
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gaQWT", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bc66a709018e63eb$export$6503ec6e8aabbaf; }, function (v) { return $bc66a709018e63eb$export$6503ec6e8aabbaf = v; });
var $bc66a709018e63eb$export$6503ec6e8aabbaf;
var $bc66a709018e63eb$export$f7ad0328861e2f03;
"use strict";
var $bc66a709018e63eb$var$mapping = new Map();
function $bc66a709018e63eb$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bc66a709018e63eb$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bc66a709018e63eb$var$resolve(id) {
    var resolved = $bc66a709018e63eb$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bc66a709018e63eb$export$6503ec6e8aabbaf = $bc66a709018e63eb$var$register;
$bc66a709018e63eb$export$f7ad0328861e2f03 = $bc66a709018e63eb$var$resolve;

});

parcelRegister("6IstV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4e3cf1fd5d79c889$export$ffb0004e005737fa; }, function (v) { return $4e3cf1fd5d79c889$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4e3cf1fd5d79c889$export$34b9dba7ce09269b; }, function (v) { return $4e3cf1fd5d79c889$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4e3cf1fd5d79c889$export$25062201e9e25d76; }, function (v) { return $4e3cf1fd5d79c889$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e3cf1fd5d79c889$export$ffb0004e005737fa;
var $4e3cf1fd5d79c889$export$34b9dba7ce09269b;
var $4e3cf1fd5d79c889$export$25062201e9e25d76;
'use strict';

var $8nGP5 = parcelRequire("8nGP5");
var $4e3cf1fd5d79c889$var$k = Symbol.for("react.element"), $4e3cf1fd5d79c889$var$l = Symbol.for("react.fragment"), $4e3cf1fd5d79c889$var$m = Object.prototype.hasOwnProperty, $4e3cf1fd5d79c889$var$n = $8nGP5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4e3cf1fd5d79c889$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4e3cf1fd5d79c889$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4e3cf1fd5d79c889$var$m.call(a, b) && !$4e3cf1fd5d79c889$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4e3cf1fd5d79c889$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4e3cf1fd5d79c889$var$n.current
    };
}
$4e3cf1fd5d79c889$export$ffb0004e005737fa = $4e3cf1fd5d79c889$var$l;
$4e3cf1fd5d79c889$export$34b9dba7ce09269b = $4e3cf1fd5d79c889$var$q;
$4e3cf1fd5d79c889$export$25062201e9e25d76 = $4e3cf1fd5d79c889$var$q;

});
parcelRegister("8nGP5", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kO00g"));

});
parcelRegister("kO00g", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $f2587acb1c26d227$export$dca3b0875bd9a954; }, function (v) { return $f2587acb1c26d227$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f2587acb1c26d227$export$16fa2f45be04daa8; }, function (v) { return $f2587acb1c26d227$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f2587acb1c26d227$export$ffb0004e005737fa; }, function (v) { return $f2587acb1c26d227$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f2587acb1c26d227$export$e2c29f18771995cb; }, function (v) { return $f2587acb1c26d227$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f2587acb1c26d227$export$221d75b3f55bb0bd; }, function (v) { return $f2587acb1c26d227$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f2587acb1c26d227$export$5f8d39834fd61797; }, function (v) { return $f2587acb1c26d227$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f2587acb1c26d227$export$74bf444e3cd11ea5; }, function (v) { return $f2587acb1c26d227$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $f2587acb1c26d227$export$ae55be85d98224ed; }, function (v) { return $f2587acb1c26d227$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f2587acb1c26d227$export$e530037191fcd5d7; }, function (v) { return $f2587acb1c26d227$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f2587acb1c26d227$export$fd42f52fd3ae1109; }, function (v) { return $f2587acb1c26d227$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f2587acb1c26d227$export$c8a8987d4410bf2d; }, function (v) { return $f2587acb1c26d227$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $f2587acb1c26d227$export$d38cd72104c1f0e9; }, function (v) { return $f2587acb1c26d227$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $f2587acb1c26d227$export$7d1e3a5e95ceca43; }, function (v) { return $f2587acb1c26d227$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f2587acb1c26d227$export$257a8862b851cb5b; }, function (v) { return $f2587acb1c26d227$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f2587acb1c26d227$export$a8257692ac88316c; }, function (v) { return $f2587acb1c26d227$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f2587acb1c26d227$export$488013bae63b21da; }, function (v) { return $f2587acb1c26d227$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f2587acb1c26d227$export$7c73462e0d25e514; }, function (v) { return $f2587acb1c26d227$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f2587acb1c26d227$export$7568632d0d33d16d; }, function (v) { return $f2587acb1c26d227$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $f2587acb1c26d227$export$88948ce120ea2619; }, function (v) { return $f2587acb1c26d227$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f2587acb1c26d227$export$35808ee640e87ca7; }, function (v) { return $f2587acb1c26d227$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f2587acb1c26d227$export$fae74005e78b1a27; }, function (v) { return $f2587acb1c26d227$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f2587acb1c26d227$export$dc8fbce3eb94dc1e; }, function (v) { return $f2587acb1c26d227$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f2587acb1c26d227$export$6a7bc4e911dc01cf; }, function (v) { return $f2587acb1c26d227$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f2587acb1c26d227$export$6d9c69b0de29b591; }, function (v) { return $f2587acb1c26d227$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $f2587acb1c26d227$export$f680877a34711e37; }, function (v) { return $f2587acb1c26d227$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f2587acb1c26d227$export$d5a552a76deda3c2; }, function (v) { return $f2587acb1c26d227$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f2587acb1c26d227$export$aaabe4eda9ed9969; }, function (v) { return $f2587acb1c26d227$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f2587acb1c26d227$export$e5c5a5f917a5871c; }, function (v) { return $f2587acb1c26d227$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f2587acb1c26d227$export$1538c33de8887b59; }, function (v) { return $f2587acb1c26d227$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $f2587acb1c26d227$export$13e3392192263954; }, function (v) { return $f2587acb1c26d227$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f2587acb1c26d227$export$b8f5890fc79d6aca; }, function (v) { return $f2587acb1c26d227$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f2587acb1c26d227$export$60241385465d0a34; }, function (v) { return $f2587acb1c26d227$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f2587acb1c26d227$export$306c0aa65ff9ec16; }, function (v) { return $f2587acb1c26d227$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f2587acb1c26d227$export$7b286972b8d8ccbf; }, function (v) { return $f2587acb1c26d227$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f2587acb1c26d227$export$83d89fbfd8236492; }, function (v) { return $f2587acb1c26d227$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f2587acb1c26d227$export$dca3b0875bd9a954;
var $f2587acb1c26d227$export$16fa2f45be04daa8;
var $f2587acb1c26d227$export$ffb0004e005737fa;
var $f2587acb1c26d227$export$e2c29f18771995cb;
var $f2587acb1c26d227$export$221d75b3f55bb0bd;
var $f2587acb1c26d227$export$5f8d39834fd61797;
var $f2587acb1c26d227$export$74bf444e3cd11ea5;
var $f2587acb1c26d227$export$ae55be85d98224ed;
var $f2587acb1c26d227$export$e530037191fcd5d7;
var $f2587acb1c26d227$export$fd42f52fd3ae1109;
var $f2587acb1c26d227$export$c8a8987d4410bf2d;
var $f2587acb1c26d227$export$d38cd72104c1f0e9;
var $f2587acb1c26d227$export$7d1e3a5e95ceca43;
var $f2587acb1c26d227$export$257a8862b851cb5b;
var $f2587acb1c26d227$export$a8257692ac88316c;
var $f2587acb1c26d227$export$488013bae63b21da;
var $f2587acb1c26d227$export$7c73462e0d25e514;
var $f2587acb1c26d227$export$7568632d0d33d16d;
var $f2587acb1c26d227$export$88948ce120ea2619;
var $f2587acb1c26d227$export$35808ee640e87ca7;
var $f2587acb1c26d227$export$fae74005e78b1a27;
var $f2587acb1c26d227$export$dc8fbce3eb94dc1e;
var $f2587acb1c26d227$export$6a7bc4e911dc01cf;
var $f2587acb1c26d227$export$6d9c69b0de29b591;
var $f2587acb1c26d227$export$f680877a34711e37;
var $f2587acb1c26d227$export$d5a552a76deda3c2;
var $f2587acb1c26d227$export$aaabe4eda9ed9969;
var $f2587acb1c26d227$export$e5c5a5f917a5871c;
var $f2587acb1c26d227$export$1538c33de8887b59;
var $f2587acb1c26d227$export$13e3392192263954;
var $f2587acb1c26d227$export$b8f5890fc79d6aca;
var $f2587acb1c26d227$export$60241385465d0a34;
var $f2587acb1c26d227$export$306c0aa65ff9ec16;
var $f2587acb1c26d227$export$7b286972b8d8ccbf;
var $f2587acb1c26d227$export$83d89fbfd8236492;
'use strict';
var $f2587acb1c26d227$var$l = Symbol.for("react.element"), $f2587acb1c26d227$var$n = Symbol.for("react.portal"), $f2587acb1c26d227$var$p = Symbol.for("react.fragment"), $f2587acb1c26d227$var$q = Symbol.for("react.strict_mode"), $f2587acb1c26d227$var$r = Symbol.for("react.profiler"), $f2587acb1c26d227$var$t = Symbol.for("react.provider"), $f2587acb1c26d227$var$u = Symbol.for("react.context"), $f2587acb1c26d227$var$v = Symbol.for("react.forward_ref"), $f2587acb1c26d227$var$w = Symbol.for("react.suspense"), $f2587acb1c26d227$var$x = Symbol.for("react.memo"), $f2587acb1c26d227$var$y = Symbol.for("react.lazy"), $f2587acb1c26d227$var$z = Symbol.iterator;
function $f2587acb1c26d227$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $f2587acb1c26d227$var$z && a[$f2587acb1c26d227$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $f2587acb1c26d227$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f2587acb1c26d227$var$C = Object.assign, $f2587acb1c26d227$var$D = {};
function $f2587acb1c26d227$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f2587acb1c26d227$var$D;
    this.updater = e || $f2587acb1c26d227$var$B;
}
$f2587acb1c26d227$var$E.prototype.isReactComponent = {};
$f2587acb1c26d227$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$f2587acb1c26d227$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $f2587acb1c26d227$var$F() {}
$f2587acb1c26d227$var$F.prototype = $f2587acb1c26d227$var$E.prototype;
function $f2587acb1c26d227$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $f2587acb1c26d227$var$D;
    this.updater = e || $f2587acb1c26d227$var$B;
}
var $f2587acb1c26d227$var$H = $f2587acb1c26d227$var$G.prototype = new $f2587acb1c26d227$var$F;
$f2587acb1c26d227$var$H.constructor = $f2587acb1c26d227$var$G;
$f2587acb1c26d227$var$C($f2587acb1c26d227$var$H, $f2587acb1c26d227$var$E.prototype);
$f2587acb1c26d227$var$H.isPureReactComponent = !0;
var $f2587acb1c26d227$var$I = Array.isArray, $f2587acb1c26d227$var$J = Object.prototype.hasOwnProperty, $f2587acb1c26d227$var$K = {
    current: null
}, $f2587acb1c26d227$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f2587acb1c26d227$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$f2587acb1c26d227$var$J.call(b, d) && !$f2587acb1c26d227$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $f2587acb1c26d227$var$K.current
    };
}
function $f2587acb1c26d227$var$N(a, b) {
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $f2587acb1c26d227$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f2587acb1c26d227$var$l;
}
function $f2587acb1c26d227$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $f2587acb1c26d227$var$P = /\/+/g;
function $f2587acb1c26d227$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $f2587acb1c26d227$var$escape("" + a.key) : b.toString(36);
}
function $f2587acb1c26d227$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $f2587acb1c26d227$var$l:
                case $f2587acb1c26d227$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $f2587acb1c26d227$var$Q(h, 0) : d, $f2587acb1c26d227$var$I(c) ? (e = "", null != a && (e = a.replace($f2587acb1c26d227$var$P, "$&/") + "/"), $f2587acb1c26d227$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($f2587acb1c26d227$var$O(c) && (c = $f2587acb1c26d227$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($f2587acb1c26d227$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($f2587acb1c26d227$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $f2587acb1c26d227$var$Q(k, g);
        h += $f2587acb1c26d227$var$R(k, b, e, f, c);
    }
    else if (f = $f2587acb1c26d227$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $f2587acb1c26d227$var$Q(k, g++), h += $f2587acb1c26d227$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $f2587acb1c26d227$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $f2587acb1c26d227$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $f2587acb1c26d227$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $f2587acb1c26d227$var$U = {
    current: null
}, $f2587acb1c26d227$var$V = {
    transition: null
}, $f2587acb1c26d227$var$W = {
    ReactCurrentDispatcher: $f2587acb1c26d227$var$U,
    ReactCurrentBatchConfig: $f2587acb1c26d227$var$V,
    ReactCurrentOwner: $f2587acb1c26d227$var$K
};
$f2587acb1c26d227$export$dca3b0875bd9a954 = {
    map: $f2587acb1c26d227$var$S,
    forEach: function(a, b, e) {
        $f2587acb1c26d227$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $f2587acb1c26d227$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $f2587acb1c26d227$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$f2587acb1c26d227$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$f2587acb1c26d227$export$16fa2f45be04daa8 = $f2587acb1c26d227$var$E;
$f2587acb1c26d227$export$ffb0004e005737fa = $f2587acb1c26d227$var$p;
$f2587acb1c26d227$export$e2c29f18771995cb = $f2587acb1c26d227$var$r;
$f2587acb1c26d227$export$221d75b3f55bb0bd = $f2587acb1c26d227$var$G;
$f2587acb1c26d227$export$5f8d39834fd61797 = $f2587acb1c26d227$var$q;
$f2587acb1c26d227$export$74bf444e3cd11ea5 = $f2587acb1c26d227$var$w;
$f2587acb1c26d227$export$ae55be85d98224ed = $f2587acb1c26d227$var$W;
$f2587acb1c26d227$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $f2587acb1c26d227$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $f2587acb1c26d227$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$f2587acb1c26d227$var$J.call(b, f) && !$f2587acb1c26d227$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $f2587acb1c26d227$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$f2587acb1c26d227$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $f2587acb1c26d227$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $f2587acb1c26d227$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$f2587acb1c26d227$export$c8a8987d4410bf2d = $f2587acb1c26d227$var$M;
$f2587acb1c26d227$export$d38cd72104c1f0e9 = function(a) {
    var b = $f2587acb1c26d227$var$M.bind(null, a);
    b.type = a;
    return b;
};
$f2587acb1c26d227$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f2587acb1c26d227$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $f2587acb1c26d227$var$v,
        render: a
    };
};
$f2587acb1c26d227$export$a8257692ac88316c = $f2587acb1c26d227$var$O;
$f2587acb1c26d227$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $f2587acb1c26d227$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $f2587acb1c26d227$var$T
    };
};
$f2587acb1c26d227$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $f2587acb1c26d227$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$f2587acb1c26d227$export$7568632d0d33d16d = function(a) {
    var b = $f2587acb1c26d227$var$V.transition;
    $f2587acb1c26d227$var$V.transition = {};
    try {
        a();
    } finally{
        $f2587acb1c26d227$var$V.transition = b;
    }
};
$f2587acb1c26d227$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$f2587acb1c26d227$export$35808ee640e87ca7 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useCallback(a, b);
};
$f2587acb1c26d227$export$fae74005e78b1a27 = function(a) {
    return $f2587acb1c26d227$var$U.current.useContext(a);
};
$f2587acb1c26d227$export$dc8fbce3eb94dc1e = function() {};
$f2587acb1c26d227$export$6a7bc4e911dc01cf = function(a) {
    return $f2587acb1c26d227$var$U.current.useDeferredValue(a);
};
$f2587acb1c26d227$export$6d9c69b0de29b591 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useEffect(a, b);
};
$f2587acb1c26d227$export$f680877a34711e37 = function() {
    return $f2587acb1c26d227$var$U.current.useId();
};
$f2587acb1c26d227$export$d5a552a76deda3c2 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useImperativeHandle(a, b, e);
};
$f2587acb1c26d227$export$aaabe4eda9ed9969 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useInsertionEffect(a, b);
};
$f2587acb1c26d227$export$e5c5a5f917a5871c = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useLayoutEffect(a, b);
};
$f2587acb1c26d227$export$1538c33de8887b59 = function(a, b) {
    return $f2587acb1c26d227$var$U.current.useMemo(a, b);
};
$f2587acb1c26d227$export$13e3392192263954 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useReducer(a, b, e);
};
$f2587acb1c26d227$export$b8f5890fc79d6aca = function(a) {
    return $f2587acb1c26d227$var$U.current.useRef(a);
};
$f2587acb1c26d227$export$60241385465d0a34 = function(a) {
    return $f2587acb1c26d227$var$U.current.useState(a);
};
$f2587acb1c26d227$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $f2587acb1c26d227$var$U.current.useSyncExternalStore(a, b, e);
};
$f2587acb1c26d227$export$7b286972b8d8ccbf = function() {
    return $f2587acb1c26d227$var$U.current.useTransition();
};
$f2587acb1c26d227$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("T5IcR", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("fCKK7", function(module, exports) {
'use strict';
function $b5fea9c20eafce38$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b5fea9c20eafce38$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b5fea9c20eafce38$var$checkDCE();

module.exports = (parcelRequire("dmm2w"));

});
parcelRegister("dmm2w", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $9b9e6d0f6347a978$export$ae55be85d98224ed; }, function (v) { return $9b9e6d0f6347a978$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $9b9e6d0f6347a978$export$d39a5bbd09211389; }, function (v) { return $9b9e6d0f6347a978$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $9b9e6d0f6347a978$export$882461b6382ed46c; }, function (v) { return $9b9e6d0f6347a978$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $9b9e6d0f6347a978$export$466bfc07425424d5; }, function (v) { return $9b9e6d0f6347a978$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9b9e6d0f6347a978$export$cd75ccfd720a3cd4; }, function (v) { return $9b9e6d0f6347a978$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $9b9e6d0f6347a978$export$fa8d919ba61d84db; }, function (v) { return $9b9e6d0f6347a978$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $9b9e6d0f6347a978$export$757ceba2d55c277e; }, function (v) { return $9b9e6d0f6347a978$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $9b9e6d0f6347a978$export$b3890eb0ae9dca99; }, function (v) { return $9b9e6d0f6347a978$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $9b9e6d0f6347a978$export$502457920280e6be; }, function (v) { return $9b9e6d0f6347a978$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9b9e6d0f6347a978$export$c78a37762a8d58e1; }, function (v) { return $9b9e6d0f6347a978$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $9b9e6d0f6347a978$export$dc54d992c10e8a18; }, function (v) { return $9b9e6d0f6347a978$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $9b9e6d0f6347a978$export$83d89fbfd8236492; }, function (v) { return $9b9e6d0f6347a978$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9b9e6d0f6347a978$export$ae55be85d98224ed;
var $9b9e6d0f6347a978$export$d39a5bbd09211389;
var $9b9e6d0f6347a978$export$882461b6382ed46c;
var $9b9e6d0f6347a978$export$466bfc07425424d5;
var $9b9e6d0f6347a978$export$cd75ccfd720a3cd4;
var $9b9e6d0f6347a978$export$fa8d919ba61d84db;
var $9b9e6d0f6347a978$export$757ceba2d55c277e;
var $9b9e6d0f6347a978$export$b3890eb0ae9dca99;
var $9b9e6d0f6347a978$export$502457920280e6be;
var $9b9e6d0f6347a978$export$c78a37762a8d58e1;
var $9b9e6d0f6347a978$export$dc54d992c10e8a18;
var $9b9e6d0f6347a978$export$83d89fbfd8236492;
'use strict';

var $8nGP5 = parcelRequire("8nGP5");

var $lC4Dh = parcelRequire("lC4Dh");
function $9b9e6d0f6347a978$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9b9e6d0f6347a978$var$da = new Set, $9b9e6d0f6347a978$var$ea = {};
function $9b9e6d0f6347a978$var$fa(a, b) {
    $9b9e6d0f6347a978$var$ha(a, b);
    $9b9e6d0f6347a978$var$ha(a + "Capture", b);
}
function $9b9e6d0f6347a978$var$ha(a, b) {
    $9b9e6d0f6347a978$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9b9e6d0f6347a978$var$da.add(b[a]);
}
var $9b9e6d0f6347a978$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9b9e6d0f6347a978$var$ja = Object.prototype.hasOwnProperty, $9b9e6d0f6347a978$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9b9e6d0f6347a978$var$la = {}, $9b9e6d0f6347a978$var$ma = {};
function $9b9e6d0f6347a978$var$oa(a) {
    if ($9b9e6d0f6347a978$var$ja.call($9b9e6d0f6347a978$var$ma, a)) return !0;
    if ($9b9e6d0f6347a978$var$ja.call($9b9e6d0f6347a978$var$la, a)) return !1;
    if ($9b9e6d0f6347a978$var$ka.test(a)) return $9b9e6d0f6347a978$var$ma[a] = !0;
    $9b9e6d0f6347a978$var$la[a] = !0;
    return !1;
}
function $9b9e6d0f6347a978$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9b9e6d0f6347a978$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9b9e6d0f6347a978$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9b9e6d0f6347a978$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9b9e6d0f6347a978$var$ra = /[\-:]([a-z])/g;
function $9b9e6d0f6347a978$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9b9e6d0f6347a978$var$ra, $9b9e6d0f6347a978$var$sa);
    $9b9e6d0f6347a978$var$z[b] = new $9b9e6d0f6347a978$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9b9e6d0f6347a978$var$z.xlinkHref = new $9b9e6d0f6347a978$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9b9e6d0f6347a978$var$z[a] = new $9b9e6d0f6347a978$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9b9e6d0f6347a978$var$ta(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$z.hasOwnProperty(b) ? $9b9e6d0f6347a978$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9b9e6d0f6347a978$var$qa(b, c, e, d) && (c = null), d || null === e ? $9b9e6d0f6347a978$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9b9e6d0f6347a978$var$ua = $8nGP5.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9b9e6d0f6347a978$var$va = Symbol.for("react.element"), $9b9e6d0f6347a978$var$wa = Symbol.for("react.portal"), $9b9e6d0f6347a978$var$ya = Symbol.for("react.fragment"), $9b9e6d0f6347a978$var$za = Symbol.for("react.strict_mode"), $9b9e6d0f6347a978$var$Aa = Symbol.for("react.profiler"), $9b9e6d0f6347a978$var$Ba = Symbol.for("react.provider"), $9b9e6d0f6347a978$var$Ca = Symbol.for("react.context"), $9b9e6d0f6347a978$var$Da = Symbol.for("react.forward_ref"), $9b9e6d0f6347a978$var$Ea = Symbol.for("react.suspense"), $9b9e6d0f6347a978$var$Fa = Symbol.for("react.suspense_list"), $9b9e6d0f6347a978$var$Ga = Symbol.for("react.memo"), $9b9e6d0f6347a978$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9b9e6d0f6347a978$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9b9e6d0f6347a978$var$Ja = Symbol.iterator;
function $9b9e6d0f6347a978$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9b9e6d0f6347a978$var$Ja && a[$9b9e6d0f6347a978$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9b9e6d0f6347a978$var$A = Object.assign, $9b9e6d0f6347a978$var$La;
function $9b9e6d0f6347a978$var$Ma(a) {
    if (void 0 === $9b9e6d0f6347a978$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9b9e6d0f6347a978$var$La = b && b[1] || "";
    }
    return "\n" + $9b9e6d0f6347a978$var$La + a;
}
var $9b9e6d0f6347a978$var$Na = !1;
function $9b9e6d0f6347a978$var$Oa(a, b) {
    if (!a || $9b9e6d0f6347a978$var$Na) return "";
    $9b9e6d0f6347a978$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9b9e6d0f6347a978$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9b9e6d0f6347a978$var$Ma(a) : "";
}
function $9b9e6d0f6347a978$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9b9e6d0f6347a978$var$Ma(a.type);
        case 16:
            return $9b9e6d0f6347a978$var$Ma("Lazy");
        case 13:
            return $9b9e6d0f6347a978$var$Ma("Suspense");
        case 19:
            return $9b9e6d0f6347a978$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9b9e6d0f6347a978$var$Oa(a.type, !1), a;
        case 11:
            return a = $9b9e6d0f6347a978$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9b9e6d0f6347a978$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9b9e6d0f6347a978$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9b9e6d0f6347a978$var$ya:
            return "Fragment";
        case $9b9e6d0f6347a978$var$wa:
            return "Portal";
        case $9b9e6d0f6347a978$var$Aa:
            return "Profiler";
        case $9b9e6d0f6347a978$var$za:
            return "StrictMode";
        case $9b9e6d0f6347a978$var$Ea:
            return "Suspense";
        case $9b9e6d0f6347a978$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9b9e6d0f6347a978$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9b9e6d0f6347a978$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9b9e6d0f6347a978$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9b9e6d0f6347a978$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9b9e6d0f6347a978$var$Qa(a.type) || "Memo";
        case $9b9e6d0f6347a978$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9b9e6d0f6347a978$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9b9e6d0f6347a978$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9b9e6d0f6347a978$var$Qa(b);
        case 8:
            return b === $9b9e6d0f6347a978$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9b9e6d0f6347a978$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9b9e6d0f6347a978$var$Ua(a) {
    var b = $9b9e6d0f6347a978$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9b9e6d0f6347a978$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9b9e6d0f6347a978$var$Ua(a));
}
function $9b9e6d0f6347a978$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9b9e6d0f6347a978$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9b9e6d0f6347a978$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9b9e6d0f6347a978$var$Ya(a, b) {
    var c = b.checked;
    return $9b9e6d0f6347a978$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9b9e6d0f6347a978$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9b9e6d0f6347a978$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9b9e6d0f6347a978$var$ab(a, b) {
    b = b.checked;
    null != b && $9b9e6d0f6347a978$var$ta(a, "checked", b, !1);
}
function $9b9e6d0f6347a978$var$bb(a, b) {
    $9b9e6d0f6347a978$var$ab(a, b);
    var c = $9b9e6d0f6347a978$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9b9e6d0f6347a978$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9b9e6d0f6347a978$var$cb(a, b.type, $9b9e6d0f6347a978$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9b9e6d0f6347a978$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9b9e6d0f6347a978$var$cb(a, b, c) {
    if ("number" !== b || $9b9e6d0f6347a978$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9b9e6d0f6347a978$var$eb = Array.isArray;
function $9b9e6d0f6347a978$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9b9e6d0f6347a978$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9b9e6d0f6347a978$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9b9e6d0f6347a978$var$p(91));
    return $9b9e6d0f6347a978$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9b9e6d0f6347a978$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9b9e6d0f6347a978$var$p(92));
            if ($9b9e6d0f6347a978$var$eb(c)) {
                if (1 < c.length) throw Error($9b9e6d0f6347a978$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9b9e6d0f6347a978$var$Sa(c)
    };
}
function $9b9e6d0f6347a978$var$ib(a, b) {
    var c = $9b9e6d0f6347a978$var$Sa(b.value), d = $9b9e6d0f6347a978$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9b9e6d0f6347a978$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9b9e6d0f6347a978$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9b9e6d0f6347a978$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9b9e6d0f6347a978$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9b9e6d0f6347a978$var$mb, $9b9e6d0f6347a978$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9b9e6d0f6347a978$var$mb = $9b9e6d0f6347a978$var$mb || document.createElement("div");
        $9b9e6d0f6347a978$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9b9e6d0f6347a978$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9b9e6d0f6347a978$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9b9e6d0f6347a978$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9b9e6d0f6347a978$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9b9e6d0f6347a978$var$pb).forEach(function(a) {
    $9b9e6d0f6347a978$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9b9e6d0f6347a978$var$pb[b] = $9b9e6d0f6347a978$var$pb[a];
    });
});
function $9b9e6d0f6347a978$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9b9e6d0f6347a978$var$pb.hasOwnProperty(a) && $9b9e6d0f6347a978$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9b9e6d0f6347a978$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9b9e6d0f6347a978$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9b9e6d0f6347a978$var$tb = $9b9e6d0f6347a978$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9b9e6d0f6347a978$var$ub(a, b) {
    if (b) {
        if ($9b9e6d0f6347a978$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9b9e6d0f6347a978$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9b9e6d0f6347a978$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9b9e6d0f6347a978$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9b9e6d0f6347a978$var$p(62));
    }
}
function $9b9e6d0f6347a978$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9b9e6d0f6347a978$var$wb = null;
function $9b9e6d0f6347a978$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9b9e6d0f6347a978$var$yb = null, $9b9e6d0f6347a978$var$zb = null, $9b9e6d0f6347a978$var$Ab = null;
function $9b9e6d0f6347a978$var$Bb(a) {
    if (a = $9b9e6d0f6347a978$var$Cb(a)) {
        if ("function" !== typeof $9b9e6d0f6347a978$var$yb) throw Error($9b9e6d0f6347a978$var$p(280));
        var b = a.stateNode;
        b && (b = $9b9e6d0f6347a978$var$Db(b), $9b9e6d0f6347a978$var$yb(a.stateNode, a.type, b));
    }
}
function $9b9e6d0f6347a978$var$Eb(a) {
    $9b9e6d0f6347a978$var$zb ? $9b9e6d0f6347a978$var$Ab ? $9b9e6d0f6347a978$var$Ab.push(a) : $9b9e6d0f6347a978$var$Ab = [
        a
    ] : $9b9e6d0f6347a978$var$zb = a;
}
function $9b9e6d0f6347a978$var$Fb() {
    if ($9b9e6d0f6347a978$var$zb) {
        var a = $9b9e6d0f6347a978$var$zb, b = $9b9e6d0f6347a978$var$Ab;
        $9b9e6d0f6347a978$var$Ab = $9b9e6d0f6347a978$var$zb = null;
        $9b9e6d0f6347a978$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9b9e6d0f6347a978$var$Bb(b[a]);
    }
}
function $9b9e6d0f6347a978$var$Gb(a, b) {
    return a(b);
}
function $9b9e6d0f6347a978$var$Hb() {}
var $9b9e6d0f6347a978$var$Ib = !1;
function $9b9e6d0f6347a978$var$Jb(a, b, c) {
    if ($9b9e6d0f6347a978$var$Ib) return a(b, c);
    $9b9e6d0f6347a978$var$Ib = !0;
    try {
        return $9b9e6d0f6347a978$var$Gb(a, b, c);
    } finally{
        if ($9b9e6d0f6347a978$var$Ib = !1, null !== $9b9e6d0f6347a978$var$zb || null !== $9b9e6d0f6347a978$var$Ab) $9b9e6d0f6347a978$var$Hb(), $9b9e6d0f6347a978$var$Fb();
    }
}
function $9b9e6d0f6347a978$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9b9e6d0f6347a978$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9b9e6d0f6347a978$var$p(231, b, typeof c));
    return c;
}
var $9b9e6d0f6347a978$var$Lb = !1;
if ($9b9e6d0f6347a978$var$ia) try {
    var $9b9e6d0f6347a978$var$Mb = {};
    Object.defineProperty($9b9e6d0f6347a978$var$Mb, "passive", {
        get: function() {
            $9b9e6d0f6347a978$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9b9e6d0f6347a978$var$Mb, $9b9e6d0f6347a978$var$Mb);
    window.removeEventListener("test", $9b9e6d0f6347a978$var$Mb, $9b9e6d0f6347a978$var$Mb);
} catch (a) {
    $9b9e6d0f6347a978$var$Lb = !1;
}
function $9b9e6d0f6347a978$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9b9e6d0f6347a978$var$Ob = !1, $9b9e6d0f6347a978$var$Pb = null, $9b9e6d0f6347a978$var$Qb = !1, $9b9e6d0f6347a978$var$Rb = null, $9b9e6d0f6347a978$var$Sb = {
    onError: function(a) {
        $9b9e6d0f6347a978$var$Ob = !0;
        $9b9e6d0f6347a978$var$Pb = a;
    }
};
function $9b9e6d0f6347a978$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9b9e6d0f6347a978$var$Ob = !1;
    $9b9e6d0f6347a978$var$Pb = null;
    $9b9e6d0f6347a978$var$Nb.apply($9b9e6d0f6347a978$var$Sb, arguments);
}
function $9b9e6d0f6347a978$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9b9e6d0f6347a978$var$Tb.apply(this, arguments);
    if ($9b9e6d0f6347a978$var$Ob) {
        if ($9b9e6d0f6347a978$var$Ob) {
            var l = $9b9e6d0f6347a978$var$Pb;
            $9b9e6d0f6347a978$var$Ob = !1;
            $9b9e6d0f6347a978$var$Pb = null;
        } else throw Error($9b9e6d0f6347a978$var$p(198));
        $9b9e6d0f6347a978$var$Qb || ($9b9e6d0f6347a978$var$Qb = !0, $9b9e6d0f6347a978$var$Rb = l);
    }
}
function $9b9e6d0f6347a978$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9b9e6d0f6347a978$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Xb(a) {
    if ($9b9e6d0f6347a978$var$Vb(a) !== a) throw Error($9b9e6d0f6347a978$var$p(188));
}
function $9b9e6d0f6347a978$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9b9e6d0f6347a978$var$Vb(a);
        if (null === b) throw Error($9b9e6d0f6347a978$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9b9e6d0f6347a978$var$Xb(e), a;
                if (f === d) return $9b9e6d0f6347a978$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9b9e6d0f6347a978$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9b9e6d0f6347a978$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9b9e6d0f6347a978$var$p(190));
    }
    if (3 !== c.tag) throw Error($9b9e6d0f6347a978$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9b9e6d0f6347a978$var$Zb(a) {
    a = $9b9e6d0f6347a978$var$Yb(a);
    return null !== a ? $9b9e6d0f6347a978$var$$b(a) : null;
}
function $9b9e6d0f6347a978$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9b9e6d0f6347a978$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$ac = $lC4Dh.unstable_scheduleCallback, $9b9e6d0f6347a978$var$bc = $lC4Dh.unstable_cancelCallback, $9b9e6d0f6347a978$var$cc = $lC4Dh.unstable_shouldYield, $9b9e6d0f6347a978$var$dc = $lC4Dh.unstable_requestPaint, $9b9e6d0f6347a978$var$B = $lC4Dh.unstable_now, $9b9e6d0f6347a978$var$ec = $lC4Dh.unstable_getCurrentPriorityLevel, $9b9e6d0f6347a978$var$fc = $lC4Dh.unstable_ImmediatePriority, $9b9e6d0f6347a978$var$gc = $lC4Dh.unstable_UserBlockingPriority, $9b9e6d0f6347a978$var$hc = $lC4Dh.unstable_NormalPriority, $9b9e6d0f6347a978$var$ic = $lC4Dh.unstable_LowPriority, $9b9e6d0f6347a978$var$jc = $lC4Dh.unstable_IdlePriority, $9b9e6d0f6347a978$var$kc = null, $9b9e6d0f6347a978$var$lc = null;
function $9b9e6d0f6347a978$var$mc(a) {
    if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onCommitFiberRoot) try {
        $9b9e6d0f6347a978$var$lc.onCommitFiberRoot($9b9e6d0f6347a978$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9b9e6d0f6347a978$var$oc = Math.clz32 ? Math.clz32 : $9b9e6d0f6347a978$var$nc, $9b9e6d0f6347a978$var$pc = Math.log, $9b9e6d0f6347a978$var$qc = Math.LN2;
function $9b9e6d0f6347a978$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9b9e6d0f6347a978$var$pc(a) / $9b9e6d0f6347a978$var$qc | 0) | 0;
}
var $9b9e6d0f6347a978$var$rc = 64, $9b9e6d0f6347a978$var$sc = 4194304;
function $9b9e6d0f6347a978$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9b9e6d0f6347a978$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9b9e6d0f6347a978$var$tc(h) : (f &= g, 0 !== f && (d = $9b9e6d0f6347a978$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9b9e6d0f6347a978$var$tc(g) : 0 !== f && (d = $9b9e6d0f6347a978$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9b9e6d0f6347a978$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9b9e6d0f6347a978$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9b9e6d0f6347a978$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9b9e6d0f6347a978$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9b9e6d0f6347a978$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9b9e6d0f6347a978$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9b9e6d0f6347a978$var$yc() {
    var a = $9b9e6d0f6347a978$var$rc;
    $9b9e6d0f6347a978$var$rc <<= 1;
    0 === ($9b9e6d0f6347a978$var$rc & 4194240) && ($9b9e6d0f6347a978$var$rc = 64);
    return a;
}
function $9b9e6d0f6347a978$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9b9e6d0f6347a978$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9b9e6d0f6347a978$var$oc(b);
    a[b] = c;
}
function $9b9e6d0f6347a978$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9b9e6d0f6347a978$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9b9e6d0f6347a978$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9b9e6d0f6347a978$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9b9e6d0f6347a978$var$C = 0;
function $9b9e6d0f6347a978$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9b9e6d0f6347a978$var$Ec, $9b9e6d0f6347a978$var$Fc, $9b9e6d0f6347a978$var$Gc, $9b9e6d0f6347a978$var$Hc, $9b9e6d0f6347a978$var$Ic, $9b9e6d0f6347a978$var$Jc = !1, $9b9e6d0f6347a978$var$Kc = [], $9b9e6d0f6347a978$var$Lc = null, $9b9e6d0f6347a978$var$Mc = null, $9b9e6d0f6347a978$var$Nc = null, $9b9e6d0f6347a978$var$Oc = new Map, $9b9e6d0f6347a978$var$Pc = new Map, $9b9e6d0f6347a978$var$Qc = [], $9b9e6d0f6347a978$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9b9e6d0f6347a978$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9b9e6d0f6347a978$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9b9e6d0f6347a978$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9b9e6d0f6347a978$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9b9e6d0f6347a978$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9b9e6d0f6347a978$var$Pc.delete(b.pointerId);
    }
}
function $9b9e6d0f6347a978$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9b9e6d0f6347a978$var$Cb(b), null !== b && $9b9e6d0f6347a978$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9b9e6d0f6347a978$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9b9e6d0f6347a978$var$Lc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9b9e6d0f6347a978$var$Mc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9b9e6d0f6347a978$var$Nc = $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9b9e6d0f6347a978$var$Oc.set(f, $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9b9e6d0f6347a978$var$Pc.set(f, $9b9e6d0f6347a978$var$Tc($9b9e6d0f6347a978$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9b9e6d0f6347a978$var$Vc(a) {
    var b = $9b9e6d0f6347a978$var$Wc(a.target);
    if (null !== b) {
        var c = $9b9e6d0f6347a978$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9b9e6d0f6347a978$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9b9e6d0f6347a978$var$Ic(a.priority, function() {
                        $9b9e6d0f6347a978$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9b9e6d0f6347a978$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9b9e6d0f6347a978$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9b9e6d0f6347a978$var$wb = d;
            c.target.dispatchEvent(d);
            $9b9e6d0f6347a978$var$wb = null;
        } else return b = $9b9e6d0f6347a978$var$Cb(c), null !== b && $9b9e6d0f6347a978$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Zc(a, b, c) {
    $9b9e6d0f6347a978$var$Xc(a) && c.delete(b);
}
function $9b9e6d0f6347a978$var$$c() {
    $9b9e6d0f6347a978$var$Jc = !1;
    null !== $9b9e6d0f6347a978$var$Lc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Lc) && ($9b9e6d0f6347a978$var$Lc = null);
    null !== $9b9e6d0f6347a978$var$Mc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Mc) && ($9b9e6d0f6347a978$var$Mc = null);
    null !== $9b9e6d0f6347a978$var$Nc && $9b9e6d0f6347a978$var$Xc($9b9e6d0f6347a978$var$Nc) && ($9b9e6d0f6347a978$var$Nc = null);
    $9b9e6d0f6347a978$var$Oc.forEach($9b9e6d0f6347a978$var$Zc);
    $9b9e6d0f6347a978$var$Pc.forEach($9b9e6d0f6347a978$var$Zc);
}
function $9b9e6d0f6347a978$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9b9e6d0f6347a978$var$Jc || ($9b9e6d0f6347a978$var$Jc = !0, $lC4Dh.unstable_scheduleCallback($lC4Dh.unstable_NormalPriority, $9b9e6d0f6347a978$var$$c)));
}
function $9b9e6d0f6347a978$var$bd(a) {
    function b(b) {
        return $9b9e6d0f6347a978$var$ad(b, a);
    }
    if (0 < $9b9e6d0f6347a978$var$Kc.length) {
        $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Kc[0], a);
        for(var c = 1; c < $9b9e6d0f6347a978$var$Kc.length; c++){
            var d = $9b9e6d0f6347a978$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9b9e6d0f6347a978$var$Lc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Lc, a);
    null !== $9b9e6d0f6347a978$var$Mc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Mc, a);
    null !== $9b9e6d0f6347a978$var$Nc && $9b9e6d0f6347a978$var$ad($9b9e6d0f6347a978$var$Nc, a);
    $9b9e6d0f6347a978$var$Oc.forEach(b);
    $9b9e6d0f6347a978$var$Pc.forEach(b);
    for(c = 0; c < $9b9e6d0f6347a978$var$Qc.length; c++)d = $9b9e6d0f6347a978$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9b9e6d0f6347a978$var$Qc.length && (c = $9b9e6d0f6347a978$var$Qc[0], null === c.blockedOn);)$9b9e6d0f6347a978$var$Vc(c), null === c.blockedOn && $9b9e6d0f6347a978$var$Qc.shift();
}
var $9b9e6d0f6347a978$var$cd = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$dd = !0;
function $9b9e6d0f6347a978$var$ed(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$C, f = $9b9e6d0f6347a978$var$cd.transition;
    $9b9e6d0f6347a978$var$cd.transition = null;
    try {
        $9b9e6d0f6347a978$var$C = 1, $9b9e6d0f6347a978$var$fd(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$C = e, $9b9e6d0f6347a978$var$cd.transition = f;
    }
}
function $9b9e6d0f6347a978$var$gd(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$C, f = $9b9e6d0f6347a978$var$cd.transition;
    $9b9e6d0f6347a978$var$cd.transition = null;
    try {
        $9b9e6d0f6347a978$var$C = 4, $9b9e6d0f6347a978$var$fd(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$C = e, $9b9e6d0f6347a978$var$cd.transition = f;
    }
}
function $9b9e6d0f6347a978$var$fd(a, b, c, d) {
    if ($9b9e6d0f6347a978$var$dd) {
        var e = $9b9e6d0f6347a978$var$Yc(a, b, c, d);
        if (null === e) $9b9e6d0f6347a978$var$hd(a, b, d, $9b9e6d0f6347a978$var$id, c), $9b9e6d0f6347a978$var$Sc(a, d);
        else if ($9b9e6d0f6347a978$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9b9e6d0f6347a978$var$Sc(a, d), b & 4 && -1 < $9b9e6d0f6347a978$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9b9e6d0f6347a978$var$Cb(e);
                null !== f && $9b9e6d0f6347a978$var$Ec(f);
                f = $9b9e6d0f6347a978$var$Yc(a, b, c, d);
                null === f && $9b9e6d0f6347a978$var$hd(a, b, d, $9b9e6d0f6347a978$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9b9e6d0f6347a978$var$hd(a, b, d, null, c);
    }
}
var $9b9e6d0f6347a978$var$id = null;
function $9b9e6d0f6347a978$var$Yc(a, b, c, d) {
    $9b9e6d0f6347a978$var$id = null;
    a = $9b9e6d0f6347a978$var$xb(d);
    a = $9b9e6d0f6347a978$var$Wc(a);
    if (null !== a) {
        if (b = $9b9e6d0f6347a978$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9b9e6d0f6347a978$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9b9e6d0f6347a978$var$id = a;
    return null;
}
function $9b9e6d0f6347a978$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9b9e6d0f6347a978$var$ec()){
                case $9b9e6d0f6347a978$var$fc:
                    return 1;
                case $9b9e6d0f6347a978$var$gc:
                    return 4;
                case $9b9e6d0f6347a978$var$hc:
                case $9b9e6d0f6347a978$var$ic:
                    return 16;
                case $9b9e6d0f6347a978$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9b9e6d0f6347a978$var$kd = null, $9b9e6d0f6347a978$var$ld = null, $9b9e6d0f6347a978$var$md = null;
function $9b9e6d0f6347a978$var$nd() {
    if ($9b9e6d0f6347a978$var$md) return $9b9e6d0f6347a978$var$md;
    var a, b = $9b9e6d0f6347a978$var$ld, c = b.length, d, e = "value" in $9b9e6d0f6347a978$var$kd ? $9b9e6d0f6347a978$var$kd.value : $9b9e6d0f6347a978$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9b9e6d0f6347a978$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9b9e6d0f6347a978$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9b9e6d0f6347a978$var$pd() {
    return !0;
}
function $9b9e6d0f6347a978$var$qd() {
    return !1;
}
function $9b9e6d0f6347a978$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9b9e6d0f6347a978$var$pd : $9b9e6d0f6347a978$var$qd;
        this.isPropagationStopped = $9b9e6d0f6347a978$var$qd;
        return this;
    }
    $9b9e6d0f6347a978$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9b9e6d0f6347a978$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9b9e6d0f6347a978$var$pd);
        },
        persist: function() {},
        isPersistent: $9b9e6d0f6347a978$var$pd
    });
    return b;
}
var $9b9e6d0f6347a978$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9b9e6d0f6347a978$var$td = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$sd), $9b9e6d0f6347a978$var$ud = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    view: 0,
    detail: 0
}), $9b9e6d0f6347a978$var$vd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$ud), $9b9e6d0f6347a978$var$wd, $9b9e6d0f6347a978$var$xd, $9b9e6d0f6347a978$var$yd, $9b9e6d0f6347a978$var$Ad = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9b9e6d0f6347a978$var$yd && ($9b9e6d0f6347a978$var$yd && "mousemove" === a.type ? ($9b9e6d0f6347a978$var$wd = a.screenX - $9b9e6d0f6347a978$var$yd.screenX, $9b9e6d0f6347a978$var$xd = a.screenY - $9b9e6d0f6347a978$var$yd.screenY) : $9b9e6d0f6347a978$var$xd = $9b9e6d0f6347a978$var$wd = 0, $9b9e6d0f6347a978$var$yd = a);
        return $9b9e6d0f6347a978$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9b9e6d0f6347a978$var$xd;
    }
}), $9b9e6d0f6347a978$var$Bd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ad), $9b9e6d0f6347a978$var$Cd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    dataTransfer: 0
}), $9b9e6d0f6347a978$var$Dd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Cd), $9b9e6d0f6347a978$var$Ed = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    relatedTarget: 0
}), $9b9e6d0f6347a978$var$Fd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ed), $9b9e6d0f6347a978$var$Gd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b9e6d0f6347a978$var$Hd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Gd), $9b9e6d0f6347a978$var$Id = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9b9e6d0f6347a978$var$Jd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Id), $9b9e6d0f6347a978$var$Kd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    data: 0
}), $9b9e6d0f6347a978$var$Ld = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Kd), $9b9e6d0f6347a978$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9b9e6d0f6347a978$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9b9e6d0f6347a978$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9b9e6d0f6347a978$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9b9e6d0f6347a978$var$Od[a]) ? !!b[a] : !1;
}
function $9b9e6d0f6347a978$var$zd() {
    return $9b9e6d0f6347a978$var$Pd;
}
var $9b9e6d0f6347a978$var$Qd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9b9e6d0f6347a978$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9b9e6d0f6347a978$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9b9e6d0f6347a978$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9b9e6d0f6347a978$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9b9e6d0f6347a978$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9b9e6d0f6347a978$var$Rd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Qd), $9b9e6d0f6347a978$var$Sd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9b9e6d0f6347a978$var$Td = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Sd), $9b9e6d0f6347a978$var$Ud = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9b9e6d0f6347a978$var$zd
}), $9b9e6d0f6347a978$var$Vd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Ud), $9b9e6d0f6347a978$var$Wd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9b9e6d0f6347a978$var$Xd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Wd), $9b9e6d0f6347a978$var$Yd = $9b9e6d0f6347a978$var$A({}, $9b9e6d0f6347a978$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9b9e6d0f6347a978$var$Zd = $9b9e6d0f6347a978$var$rd($9b9e6d0f6347a978$var$Yd), $9b9e6d0f6347a978$var$$d = [
    9,
    13,
    27,
    32
], $9b9e6d0f6347a978$var$ae = $9b9e6d0f6347a978$var$ia && "CompositionEvent" in window, $9b9e6d0f6347a978$var$be = null;
$9b9e6d0f6347a978$var$ia && "documentMode" in document && ($9b9e6d0f6347a978$var$be = document.documentMode);
var $9b9e6d0f6347a978$var$ce = $9b9e6d0f6347a978$var$ia && "TextEvent" in window && !$9b9e6d0f6347a978$var$be, $9b9e6d0f6347a978$var$de = $9b9e6d0f6347a978$var$ia && (!$9b9e6d0f6347a978$var$ae || $9b9e6d0f6347a978$var$be && 8 < $9b9e6d0f6347a978$var$be && 11 >= $9b9e6d0f6347a978$var$be), $9b9e6d0f6347a978$var$ee = String.fromCharCode(32), $9b9e6d0f6347a978$var$fe = !1;
function $9b9e6d0f6347a978$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9b9e6d0f6347a978$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9b9e6d0f6347a978$var$ie = !1;
function $9b9e6d0f6347a978$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9b9e6d0f6347a978$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9b9e6d0f6347a978$var$fe = !0;
            return $9b9e6d0f6347a978$var$ee;
        case "textInput":
            return a = b.data, a === $9b9e6d0f6347a978$var$ee && $9b9e6d0f6347a978$var$fe ? null : a;
        default:
            return null;
    }
}
function $9b9e6d0f6347a978$var$ke(a, b) {
    if ($9b9e6d0f6347a978$var$ie) return "compositionend" === a || !$9b9e6d0f6347a978$var$ae && $9b9e6d0f6347a978$var$ge(a, b) ? (a = $9b9e6d0f6347a978$var$nd(), $9b9e6d0f6347a978$var$md = $9b9e6d0f6347a978$var$ld = $9b9e6d0f6347a978$var$kd = null, $9b9e6d0f6347a978$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9b9e6d0f6347a978$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9b9e6d0f6347a978$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9b9e6d0f6347a978$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9b9e6d0f6347a978$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9b9e6d0f6347a978$var$ne(a, b, c, d) {
    $9b9e6d0f6347a978$var$Eb(d);
    b = $9b9e6d0f6347a978$var$oe(b, "onChange");
    0 < b.length && (c = new $9b9e6d0f6347a978$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9b9e6d0f6347a978$var$pe = null, $9b9e6d0f6347a978$var$qe = null;
function $9b9e6d0f6347a978$var$re(a) {
    $9b9e6d0f6347a978$var$se(a, 0);
}
function $9b9e6d0f6347a978$var$te(a) {
    var b = $9b9e6d0f6347a978$var$ue(a);
    if ($9b9e6d0f6347a978$var$Wa(b)) return a;
}
function $9b9e6d0f6347a978$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9b9e6d0f6347a978$var$we = !1;
if ($9b9e6d0f6347a978$var$ia) {
    var $9b9e6d0f6347a978$var$xe;
    if ($9b9e6d0f6347a978$var$ia) {
        var $9b9e6d0f6347a978$var$ye = "oninput" in document;
        if (!$9b9e6d0f6347a978$var$ye) {
            var $9b9e6d0f6347a978$var$ze = document.createElement("div");
            $9b9e6d0f6347a978$var$ze.setAttribute("oninput", "return;");
            $9b9e6d0f6347a978$var$ye = "function" === typeof $9b9e6d0f6347a978$var$ze.oninput;
        }
        $9b9e6d0f6347a978$var$xe = $9b9e6d0f6347a978$var$ye;
    } else $9b9e6d0f6347a978$var$xe = !1;
    $9b9e6d0f6347a978$var$we = $9b9e6d0f6347a978$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9b9e6d0f6347a978$var$Ae() {
    $9b9e6d0f6347a978$var$pe && ($9b9e6d0f6347a978$var$pe.detachEvent("onpropertychange", $9b9e6d0f6347a978$var$Be), $9b9e6d0f6347a978$var$qe = $9b9e6d0f6347a978$var$pe = null);
}
function $9b9e6d0f6347a978$var$Be(a) {
    if ("value" === a.propertyName && $9b9e6d0f6347a978$var$te($9b9e6d0f6347a978$var$qe)) {
        var b = [];
        $9b9e6d0f6347a978$var$ne(b, $9b9e6d0f6347a978$var$qe, a, $9b9e6d0f6347a978$var$xb(a));
        $9b9e6d0f6347a978$var$Jb($9b9e6d0f6347a978$var$re, b);
    }
}
function $9b9e6d0f6347a978$var$Ce(a, b, c) {
    "focusin" === a ? ($9b9e6d0f6347a978$var$Ae(), $9b9e6d0f6347a978$var$pe = b, $9b9e6d0f6347a978$var$qe = c, $9b9e6d0f6347a978$var$pe.attachEvent("onpropertychange", $9b9e6d0f6347a978$var$Be)) : "focusout" === a && $9b9e6d0f6347a978$var$Ae();
}
function $9b9e6d0f6347a978$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9b9e6d0f6347a978$var$te($9b9e6d0f6347a978$var$qe);
}
function $9b9e6d0f6347a978$var$Ee(a, b) {
    if ("click" === a) return $9b9e6d0f6347a978$var$te(b);
}
function $9b9e6d0f6347a978$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9b9e6d0f6347a978$var$te(b);
}
function $9b9e6d0f6347a978$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9b9e6d0f6347a978$var$He = "function" === typeof Object.is ? Object.is : $9b9e6d0f6347a978$var$Ge;
function $9b9e6d0f6347a978$var$Ie(a, b) {
    if ($9b9e6d0f6347a978$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9b9e6d0f6347a978$var$ja.call(b, e) || !$9b9e6d0f6347a978$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9b9e6d0f6347a978$var$Ke(a, b) {
    var c = $9b9e6d0f6347a978$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9b9e6d0f6347a978$var$Je(c);
    }
}
function $9b9e6d0f6347a978$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9b9e6d0f6347a978$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9b9e6d0f6347a978$var$Me() {
    for(var a = window, b = $9b9e6d0f6347a978$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9b9e6d0f6347a978$var$Xa(a.document);
    }
    return b;
}
function $9b9e6d0f6347a978$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9b9e6d0f6347a978$var$Oe(a) {
    var b = $9b9e6d0f6347a978$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9b9e6d0f6347a978$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9b9e6d0f6347a978$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9b9e6d0f6347a978$var$Ke(c, f);
                var g = $9b9e6d0f6347a978$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9b9e6d0f6347a978$var$Pe = $9b9e6d0f6347a978$var$ia && "documentMode" in document && 11 >= document.documentMode, $9b9e6d0f6347a978$var$Qe = null, $9b9e6d0f6347a978$var$Re = null, $9b9e6d0f6347a978$var$Se = null, $9b9e6d0f6347a978$var$Te = !1;
function $9b9e6d0f6347a978$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9b9e6d0f6347a978$var$Te || null == $9b9e6d0f6347a978$var$Qe || $9b9e6d0f6347a978$var$Qe !== $9b9e6d0f6347a978$var$Xa(d) || (d = $9b9e6d0f6347a978$var$Qe, "selectionStart" in d && $9b9e6d0f6347a978$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9b9e6d0f6347a978$var$Se && $9b9e6d0f6347a978$var$Ie($9b9e6d0f6347a978$var$Se, d) || ($9b9e6d0f6347a978$var$Se = d, d = $9b9e6d0f6347a978$var$oe($9b9e6d0f6347a978$var$Re, "onSelect"), 0 < d.length && (b = new $9b9e6d0f6347a978$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9b9e6d0f6347a978$var$Qe)));
}
function $9b9e6d0f6347a978$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9b9e6d0f6347a978$var$We = {
    animationend: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9b9e6d0f6347a978$var$Ve("Animation", "AnimationStart"),
    transitionend: $9b9e6d0f6347a978$var$Ve("Transition", "TransitionEnd")
}, $9b9e6d0f6347a978$var$Xe = {}, $9b9e6d0f6347a978$var$Ye = {};
$9b9e6d0f6347a978$var$ia && ($9b9e6d0f6347a978$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9b9e6d0f6347a978$var$We.animationend.animation, delete $9b9e6d0f6347a978$var$We.animationiteration.animation, delete $9b9e6d0f6347a978$var$We.animationstart.animation), "TransitionEvent" in window || delete $9b9e6d0f6347a978$var$We.transitionend.transition);
function $9b9e6d0f6347a978$var$Ze(a) {
    if ($9b9e6d0f6347a978$var$Xe[a]) return $9b9e6d0f6347a978$var$Xe[a];
    if (!$9b9e6d0f6347a978$var$We[a]) return a;
    var b = $9b9e6d0f6347a978$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9b9e6d0f6347a978$var$Ye) return $9b9e6d0f6347a978$var$Xe[a] = b[c];
    return a;
}
var $9b9e6d0f6347a978$var$$e = $9b9e6d0f6347a978$var$Ze("animationend"), $9b9e6d0f6347a978$var$af = $9b9e6d0f6347a978$var$Ze("animationiteration"), $9b9e6d0f6347a978$var$bf = $9b9e6d0f6347a978$var$Ze("animationstart"), $9b9e6d0f6347a978$var$cf = $9b9e6d0f6347a978$var$Ze("transitionend"), $9b9e6d0f6347a978$var$df = new Map, $9b9e6d0f6347a978$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9b9e6d0f6347a978$var$ff(a, b) {
    $9b9e6d0f6347a978$var$df.set(a, b);
    $9b9e6d0f6347a978$var$fa(b, [
        a
    ]);
}
for(var $9b9e6d0f6347a978$var$gf = 0; $9b9e6d0f6347a978$var$gf < $9b9e6d0f6347a978$var$ef.length; $9b9e6d0f6347a978$var$gf++){
    var $9b9e6d0f6347a978$var$hf = $9b9e6d0f6347a978$var$ef[$9b9e6d0f6347a978$var$gf], $9b9e6d0f6347a978$var$jf = $9b9e6d0f6347a978$var$hf.toLowerCase(), $9b9e6d0f6347a978$var$kf = $9b9e6d0f6347a978$var$hf[0].toUpperCase() + $9b9e6d0f6347a978$var$hf.slice(1);
    $9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$jf, "on" + $9b9e6d0f6347a978$var$kf);
}
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$$e, "onAnimationEnd");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$af, "onAnimationIteration");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$bf, "onAnimationStart");
$9b9e6d0f6347a978$var$ff("dblclick", "onDoubleClick");
$9b9e6d0f6347a978$var$ff("focusin", "onFocus");
$9b9e6d0f6347a978$var$ff("focusout", "onBlur");
$9b9e6d0f6347a978$var$ff($9b9e6d0f6347a978$var$cf, "onTransitionEnd");
$9b9e6d0f6347a978$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9b9e6d0f6347a978$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9b9e6d0f6347a978$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9b9e6d0f6347a978$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9b9e6d0f6347a978$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9b9e6d0f6347a978$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9b9e6d0f6347a978$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9b9e6d0f6347a978$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9b9e6d0f6347a978$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9b9e6d0f6347a978$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9b9e6d0f6347a978$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9b9e6d0f6347a978$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9b9e6d0f6347a978$var$lf));
function $9b9e6d0f6347a978$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9b9e6d0f6347a978$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9b9e6d0f6347a978$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b9e6d0f6347a978$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9b9e6d0f6347a978$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9b9e6d0f6347a978$var$Qb) throw a = $9b9e6d0f6347a978$var$Rb, $9b9e6d0f6347a978$var$Qb = !1, $9b9e6d0f6347a978$var$Rb = null, a;
}
function $9b9e6d0f6347a978$var$D(a, b) {
    var c = b[$9b9e6d0f6347a978$var$of];
    void 0 === c && (c = b[$9b9e6d0f6347a978$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9b9e6d0f6347a978$var$pf(b, a, 2, !1), c.add(d));
}
function $9b9e6d0f6347a978$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9b9e6d0f6347a978$var$pf(c, a, d, b);
}
var $9b9e6d0f6347a978$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9b9e6d0f6347a978$var$sf(a) {
    if (!a[$9b9e6d0f6347a978$var$rf]) {
        a[$9b9e6d0f6347a978$var$rf] = !0;
        $9b9e6d0f6347a978$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9b9e6d0f6347a978$var$mf.has(b) || $9b9e6d0f6347a978$var$qf(b, !1, a), $9b9e6d0f6347a978$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9b9e6d0f6347a978$var$rf] || (b[$9b9e6d0f6347a978$var$rf] = !0, $9b9e6d0f6347a978$var$qf("selectionchange", !1, b));
    }
}
function $9b9e6d0f6347a978$var$pf(a, b, c, d) {
    switch($9b9e6d0f6347a978$var$jd(b)){
        case 1:
            var e = $9b9e6d0f6347a978$var$ed;
            break;
        case 4:
            e = $9b9e6d0f6347a978$var$gd;
            break;
        default:
            e = $9b9e6d0f6347a978$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9b9e6d0f6347a978$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9b9e6d0f6347a978$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9b9e6d0f6347a978$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9b9e6d0f6347a978$var$Jb(function() {
        var d = f, e = $9b9e6d0f6347a978$var$xb(c), g = [];
        a: {
            var h = $9b9e6d0f6347a978$var$df.get(a);
            if (void 0 !== h) {
                var k = $9b9e6d0f6347a978$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9b9e6d0f6347a978$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9b9e6d0f6347a978$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9b9e6d0f6347a978$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9b9e6d0f6347a978$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9b9e6d0f6347a978$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9b9e6d0f6347a978$var$Vd;
                        break;
                    case $9b9e6d0f6347a978$var$$e:
                    case $9b9e6d0f6347a978$var$af:
                    case $9b9e6d0f6347a978$var$bf:
                        k = $9b9e6d0f6347a978$var$Hd;
                        break;
                    case $9b9e6d0f6347a978$var$cf:
                        k = $9b9e6d0f6347a978$var$Xd;
                        break;
                    case "scroll":
                        k = $9b9e6d0f6347a978$var$vd;
                        break;
                    case "wheel":
                        k = $9b9e6d0f6347a978$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9b9e6d0f6347a978$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9b9e6d0f6347a978$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9b9e6d0f6347a978$var$Kb(w, x), null != F && t.push($9b9e6d0f6347a978$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9b9e6d0f6347a978$var$wb && (n = c.relatedTarget || c.fromElement) && ($9b9e6d0f6347a978$var$Wc(n) || n[$9b9e6d0f6347a978$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9b9e6d0f6347a978$var$Wc(n) : null, null !== n && (J = $9b9e6d0f6347a978$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9b9e6d0f6347a978$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9b9e6d0f6347a978$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9b9e6d0f6347a978$var$ue(k);
                        u = null == n ? h : $9b9e6d0f6347a978$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9b9e6d0f6347a978$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9b9e6d0f6347a978$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9b9e6d0f6347a978$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9b9e6d0f6347a978$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9b9e6d0f6347a978$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9b9e6d0f6347a978$var$vf(t);
                                x = $9b9e6d0f6347a978$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9b9e6d0f6347a978$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9b9e6d0f6347a978$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9b9e6d0f6347a978$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9b9e6d0f6347a978$var$ve;
                else if ($9b9e6d0f6347a978$var$me(h)) {
                    if ($9b9e6d0f6347a978$var$we) na = $9b9e6d0f6347a978$var$Fe;
                    else {
                        na = $9b9e6d0f6347a978$var$De;
                        var xa = $9b9e6d0f6347a978$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9b9e6d0f6347a978$var$Ee);
                if (na && (na = na(a, d))) {
                    $9b9e6d0f6347a978$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9b9e6d0f6347a978$var$cb(h, "number", h.value);
            }
            xa = d ? $9b9e6d0f6347a978$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9b9e6d0f6347a978$var$me(xa) || "true" === xa.contentEditable) $9b9e6d0f6347a978$var$Qe = xa, $9b9e6d0f6347a978$var$Re = d, $9b9e6d0f6347a978$var$Se = null;
                    break;
                case "focusout":
                    $9b9e6d0f6347a978$var$Se = $9b9e6d0f6347a978$var$Re = $9b9e6d0f6347a978$var$Qe = null;
                    break;
                case "mousedown":
                    $9b9e6d0f6347a978$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9b9e6d0f6347a978$var$Te = !1;
                    $9b9e6d0f6347a978$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9b9e6d0f6347a978$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9b9e6d0f6347a978$var$Ue(g, c, e);
            }
            var $a;
            if ($9b9e6d0f6347a978$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9b9e6d0f6347a978$var$ie ? $9b9e6d0f6347a978$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9b9e6d0f6347a978$var$de && "ko" !== c.locale && ($9b9e6d0f6347a978$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9b9e6d0f6347a978$var$ie && ($a = $9b9e6d0f6347a978$var$nd()) : ($9b9e6d0f6347a978$var$kd = e, $9b9e6d0f6347a978$var$ld = "value" in $9b9e6d0f6347a978$var$kd ? $9b9e6d0f6347a978$var$kd.value : $9b9e6d0f6347a978$var$kd.textContent, $9b9e6d0f6347a978$var$ie = !0)), xa = $9b9e6d0f6347a978$var$oe(d, ba), 0 < xa.length && (ba = new $9b9e6d0f6347a978$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9b9e6d0f6347a978$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9b9e6d0f6347a978$var$ce ? $9b9e6d0f6347a978$var$je(a, c) : $9b9e6d0f6347a978$var$ke(a, c)) d = $9b9e6d0f6347a978$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9b9e6d0f6347a978$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9b9e6d0f6347a978$var$se(g, b);
    });
}
function $9b9e6d0f6347a978$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9b9e6d0f6347a978$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9b9e6d0f6347a978$var$Kb(a, c), null != f && d.unshift($9b9e6d0f6347a978$var$tf(a, f, e)), f = $9b9e6d0f6347a978$var$Kb(a, b), null != f && d.push($9b9e6d0f6347a978$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9b9e6d0f6347a978$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9b9e6d0f6347a978$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9b9e6d0f6347a978$var$Kb(c, f), null != k && g.unshift($9b9e6d0f6347a978$var$tf(c, k, h))) : e || (k = $9b9e6d0f6347a978$var$Kb(c, f), null != k && g.push($9b9e6d0f6347a978$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9b9e6d0f6347a978$var$xf = /\r\n?/g, $9b9e6d0f6347a978$var$yf = /\u0000|\uFFFD/g;
function $9b9e6d0f6347a978$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9b9e6d0f6347a978$var$xf, "\n").replace($9b9e6d0f6347a978$var$yf, "");
}
function $9b9e6d0f6347a978$var$Af(a, b, c) {
    b = $9b9e6d0f6347a978$var$zf(b);
    if ($9b9e6d0f6347a978$var$zf(a) !== b && c) throw Error($9b9e6d0f6347a978$var$p(425));
}
function $9b9e6d0f6347a978$var$Bf() {}
var $9b9e6d0f6347a978$var$Cf = null, $9b9e6d0f6347a978$var$Df = null;
function $9b9e6d0f6347a978$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9b9e6d0f6347a978$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9b9e6d0f6347a978$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9b9e6d0f6347a978$var$Hf = "function" === typeof Promise ? Promise : void 0, $9b9e6d0f6347a978$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9b9e6d0f6347a978$var$Hf ? function(a) {
    return $9b9e6d0f6347a978$var$Hf.resolve(null).then(a).catch($9b9e6d0f6347a978$var$If);
} : $9b9e6d0f6347a978$var$Ff;
function $9b9e6d0f6347a978$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9b9e6d0f6347a978$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9b9e6d0f6347a978$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9b9e6d0f6347a978$var$bd(b);
}
function $9b9e6d0f6347a978$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9b9e6d0f6347a978$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$Nf = Math.random().toString(36).slice(2), $9b9e6d0f6347a978$var$Of = "__reactFiber$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Pf = "__reactProps$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$uf = "__reactContainer$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$of = "__reactEvents$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Qf = "__reactListeners$" + $9b9e6d0f6347a978$var$Nf, $9b9e6d0f6347a978$var$Rf = "__reactHandles$" + $9b9e6d0f6347a978$var$Nf;
function $9b9e6d0f6347a978$var$Wc(a) {
    var b = a[$9b9e6d0f6347a978$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9b9e6d0f6347a978$var$uf] || c[$9b9e6d0f6347a978$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9b9e6d0f6347a978$var$Mf(a); null !== a;){
                if (c = a[$9b9e6d0f6347a978$var$Of]) return c;
                a = $9b9e6d0f6347a978$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Cb(a) {
    a = a[$9b9e6d0f6347a978$var$Of] || a[$9b9e6d0f6347a978$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9b9e6d0f6347a978$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9b9e6d0f6347a978$var$p(33));
}
function $9b9e6d0f6347a978$var$Db(a) {
    return a[$9b9e6d0f6347a978$var$Pf] || null;
}
var $9b9e6d0f6347a978$var$Sf = [], $9b9e6d0f6347a978$var$Tf = -1;
function $9b9e6d0f6347a978$var$Uf(a) {
    return {
        current: a
    };
}
function $9b9e6d0f6347a978$var$E(a) {
    0 > $9b9e6d0f6347a978$var$Tf || (a.current = $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf], $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf] = null, $9b9e6d0f6347a978$var$Tf--);
}
function $9b9e6d0f6347a978$var$G(a, b) {
    $9b9e6d0f6347a978$var$Tf++;
    $9b9e6d0f6347a978$var$Sf[$9b9e6d0f6347a978$var$Tf] = a.current;
    a.current = b;
}
var $9b9e6d0f6347a978$var$Vf = {}, $9b9e6d0f6347a978$var$H = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Vf), $9b9e6d0f6347a978$var$Wf = $9b9e6d0f6347a978$var$Uf(!1), $9b9e6d0f6347a978$var$Xf = $9b9e6d0f6347a978$var$Vf;
function $9b9e6d0f6347a978$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9b9e6d0f6347a978$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9b9e6d0f6347a978$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9b9e6d0f6347a978$var$$f() {
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
}
function $9b9e6d0f6347a978$var$ag(a, b, c) {
    if ($9b9e6d0f6347a978$var$H.current !== $9b9e6d0f6347a978$var$Vf) throw Error($9b9e6d0f6347a978$var$p(168));
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, b);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, c);
}
function $9b9e6d0f6347a978$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9b9e6d0f6347a978$var$p(108, $9b9e6d0f6347a978$var$Ra(a) || "Unknown", e));
    return $9b9e6d0f6347a978$var$A({}, c, d);
}
function $9b9e6d0f6347a978$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9b9e6d0f6347a978$var$Vf;
    $9b9e6d0f6347a978$var$Xf = $9b9e6d0f6347a978$var$H.current;
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, a);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, $9b9e6d0f6347a978$var$Wf.current);
    return !0;
}
function $9b9e6d0f6347a978$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9b9e6d0f6347a978$var$p(169));
    c ? (a = $9b9e6d0f6347a978$var$bg(a, b, $9b9e6d0f6347a978$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H), $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$H, a)) : $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Wf, c);
}
var $9b9e6d0f6347a978$var$eg = null, $9b9e6d0f6347a978$var$fg = !1, $9b9e6d0f6347a978$var$gg = !1;
function $9b9e6d0f6347a978$var$hg(a) {
    null === $9b9e6d0f6347a978$var$eg ? $9b9e6d0f6347a978$var$eg = [
        a
    ] : $9b9e6d0f6347a978$var$eg.push(a);
}
function $9b9e6d0f6347a978$var$ig(a) {
    $9b9e6d0f6347a978$var$fg = !0;
    $9b9e6d0f6347a978$var$hg(a);
}
function $9b9e6d0f6347a978$var$jg() {
    if (!$9b9e6d0f6347a978$var$gg && null !== $9b9e6d0f6347a978$var$eg) {
        $9b9e6d0f6347a978$var$gg = !0;
        var a = 0, b = $9b9e6d0f6347a978$var$C;
        try {
            var c = $9b9e6d0f6347a978$var$eg;
            for($9b9e6d0f6347a978$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9b9e6d0f6347a978$var$eg = null;
            $9b9e6d0f6347a978$var$fg = !1;
        } catch (e) {
            throw null !== $9b9e6d0f6347a978$var$eg && ($9b9e6d0f6347a978$var$eg = $9b9e6d0f6347a978$var$eg.slice(a + 1)), $9b9e6d0f6347a978$var$ac($9b9e6d0f6347a978$var$fc, $9b9e6d0f6347a978$var$jg), e;
        } finally{
            $9b9e6d0f6347a978$var$C = b, $9b9e6d0f6347a978$var$gg = !1;
        }
    }
    return null;
}
var $9b9e6d0f6347a978$var$kg = [], $9b9e6d0f6347a978$var$lg = 0, $9b9e6d0f6347a978$var$mg = null, $9b9e6d0f6347a978$var$ng = 0, $9b9e6d0f6347a978$var$og = [], $9b9e6d0f6347a978$var$pg = 0, $9b9e6d0f6347a978$var$qg = null, $9b9e6d0f6347a978$var$rg = 1, $9b9e6d0f6347a978$var$sg = "";
function $9b9e6d0f6347a978$var$tg(a, b) {
    $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg++] = $9b9e6d0f6347a978$var$ng;
    $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg++] = $9b9e6d0f6347a978$var$mg;
    $9b9e6d0f6347a978$var$mg = a;
    $9b9e6d0f6347a978$var$ng = b;
}
function $9b9e6d0f6347a978$var$ug(a, b, c) {
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$rg;
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$sg;
    $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$qg;
    $9b9e6d0f6347a978$var$qg = a;
    var d = $9b9e6d0f6347a978$var$rg;
    a = $9b9e6d0f6347a978$var$sg;
    var e = 32 - $9b9e6d0f6347a978$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9b9e6d0f6347a978$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9b9e6d0f6347a978$var$rg = 1 << 32 - $9b9e6d0f6347a978$var$oc(b) + e | c << e | d;
        $9b9e6d0f6347a978$var$sg = f + a;
    } else $9b9e6d0f6347a978$var$rg = 1 << f | c << e | d, $9b9e6d0f6347a978$var$sg = a;
}
function $9b9e6d0f6347a978$var$vg(a) {
    null !== a.return && ($9b9e6d0f6347a978$var$tg(a, 1), $9b9e6d0f6347a978$var$ug(a, 1, 0));
}
function $9b9e6d0f6347a978$var$wg(a) {
    for(; a === $9b9e6d0f6347a978$var$mg;)$9b9e6d0f6347a978$var$mg = $9b9e6d0f6347a978$var$kg[--$9b9e6d0f6347a978$var$lg], $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg] = null, $9b9e6d0f6347a978$var$ng = $9b9e6d0f6347a978$var$kg[--$9b9e6d0f6347a978$var$lg], $9b9e6d0f6347a978$var$kg[$9b9e6d0f6347a978$var$lg] = null;
    for(; a === $9b9e6d0f6347a978$var$qg;)$9b9e6d0f6347a978$var$qg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null, $9b9e6d0f6347a978$var$sg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null, $9b9e6d0f6347a978$var$rg = $9b9e6d0f6347a978$var$og[--$9b9e6d0f6347a978$var$pg], $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg] = null;
}
var $9b9e6d0f6347a978$var$xg = null, $9b9e6d0f6347a978$var$yg = null, $9b9e6d0f6347a978$var$I = !1, $9b9e6d0f6347a978$var$zg = null;
function $9b9e6d0f6347a978$var$Ag(a, b) {
    var c = $9b9e6d0f6347a978$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9b9e6d0f6347a978$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9b9e6d0f6347a978$var$qg ? {
                id: $9b9e6d0f6347a978$var$rg,
                overflow: $9b9e6d0f6347a978$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9b9e6d0f6347a978$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9b9e6d0f6347a978$var$xg = a, $9b9e6d0f6347a978$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9b9e6d0f6347a978$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9b9e6d0f6347a978$var$Eg(a) {
    if ($9b9e6d0f6347a978$var$I) {
        var b = $9b9e6d0f6347a978$var$yg;
        if (b) {
            var c = b;
            if (!$9b9e6d0f6347a978$var$Cg(a, b)) {
                if ($9b9e6d0f6347a978$var$Dg(a)) throw Error($9b9e6d0f6347a978$var$p(418));
                b = $9b9e6d0f6347a978$var$Lf(c.nextSibling);
                var d = $9b9e6d0f6347a978$var$xg;
                b && $9b9e6d0f6347a978$var$Cg(a, b) ? $9b9e6d0f6347a978$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9b9e6d0f6347a978$var$I = !1, $9b9e6d0f6347a978$var$xg = a);
            }
        } else {
            if ($9b9e6d0f6347a978$var$Dg(a)) throw Error($9b9e6d0f6347a978$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9b9e6d0f6347a978$var$I = !1;
            $9b9e6d0f6347a978$var$xg = a;
        }
    }
}
function $9b9e6d0f6347a978$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9b9e6d0f6347a978$var$xg = a;
}
function $9b9e6d0f6347a978$var$Gg(a) {
    if (a !== $9b9e6d0f6347a978$var$xg) return !1;
    if (!$9b9e6d0f6347a978$var$I) return $9b9e6d0f6347a978$var$Fg(a), $9b9e6d0f6347a978$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9b9e6d0f6347a978$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9b9e6d0f6347a978$var$yg)) {
        if ($9b9e6d0f6347a978$var$Dg(a)) throw $9b9e6d0f6347a978$var$Hg(), Error($9b9e6d0f6347a978$var$p(418));
        for(; b;)$9b9e6d0f6347a978$var$Ag(a, b), b = $9b9e6d0f6347a978$var$Lf(b.nextSibling);
    }
    $9b9e6d0f6347a978$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9b9e6d0f6347a978$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9b9e6d0f6347a978$var$yg = null;
        }
    } else $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$xg ? $9b9e6d0f6347a978$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9b9e6d0f6347a978$var$Hg() {
    for(var a = $9b9e6d0f6347a978$var$yg; a;)a = $9b9e6d0f6347a978$var$Lf(a.nextSibling);
}
function $9b9e6d0f6347a978$var$Ig() {
    $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$xg = null;
    $9b9e6d0f6347a978$var$I = !1;
}
function $9b9e6d0f6347a978$var$Jg(a) {
    null === $9b9e6d0f6347a978$var$zg ? $9b9e6d0f6347a978$var$zg = [
        a
    ] : $9b9e6d0f6347a978$var$zg.push(a);
}
var $9b9e6d0f6347a978$var$Kg = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig;
function $9b9e6d0f6347a978$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $9b9e6d0f6347a978$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $9b9e6d0f6347a978$var$Mg = $9b9e6d0f6347a978$var$Uf(null), $9b9e6d0f6347a978$var$Ng = null, $9b9e6d0f6347a978$var$Og = null, $9b9e6d0f6347a978$var$Pg = null;
function $9b9e6d0f6347a978$var$Qg() {
    $9b9e6d0f6347a978$var$Pg = $9b9e6d0f6347a978$var$Og = $9b9e6d0f6347a978$var$Ng = null;
}
function $9b9e6d0f6347a978$var$Rg(a) {
    var b = $9b9e6d0f6347a978$var$Mg.current;
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Mg);
    a._currentValue = b;
}
function $9b9e6d0f6347a978$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9b9e6d0f6347a978$var$Tg(a, b) {
    $9b9e6d0f6347a978$var$Ng = a;
    $9b9e6d0f6347a978$var$Pg = $9b9e6d0f6347a978$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9b9e6d0f6347a978$var$Ug = !0), a.firstContext = null);
}
function $9b9e6d0f6347a978$var$Vg(a) {
    var b = a._currentValue;
    if ($9b9e6d0f6347a978$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9b9e6d0f6347a978$var$Og) {
            if (null === $9b9e6d0f6347a978$var$Ng) throw Error($9b9e6d0f6347a978$var$p(308));
            $9b9e6d0f6347a978$var$Og = a;
            $9b9e6d0f6347a978$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9b9e6d0f6347a978$var$Og = $9b9e6d0f6347a978$var$Og.next = a;
    }
    return b;
}
var $9b9e6d0f6347a978$var$Wg = null;
function $9b9e6d0f6347a978$var$Xg(a) {
    null === $9b9e6d0f6347a978$var$Wg ? $9b9e6d0f6347a978$var$Wg = [
        a
    ] : $9b9e6d0f6347a978$var$Wg.push(a);
}
function $9b9e6d0f6347a978$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9b9e6d0f6347a978$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9b9e6d0f6347a978$var$Zg(a, d);
}
function $9b9e6d0f6347a978$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9b9e6d0f6347a978$var$$g = !1;
function $9b9e6d0f6347a978$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9b9e6d0f6347a978$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9b9e6d0f6347a978$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9b9e6d0f6347a978$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9b9e6d0f6347a978$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9b9e6d0f6347a978$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9b9e6d0f6347a978$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9b9e6d0f6347a978$var$Zg(a, c);
}
function $9b9e6d0f6347a978$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b9e6d0f6347a978$var$Cc(a, c);
    }
}
function $9b9e6d0f6347a978$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9b9e6d0f6347a978$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $9b9e6d0f6347a978$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9b9e6d0f6347a978$var$A({}, q, r);
                            break a;
                        case 2:
                            $9b9e6d0f6347a978$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9b9e6d0f6347a978$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9b9e6d0f6347a978$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9b9e6d0f6347a978$var$p(191, e));
            e.call(d);
        }
    }
}
var $9b9e6d0f6347a978$var$jh = (new $8nGP5.Component).refs;
function $9b9e6d0f6347a978$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9b9e6d0f6347a978$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9b9e6d0f6347a978$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9b9e6d0f6347a978$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b9e6d0f6347a978$var$L(), e = $9b9e6d0f6347a978$var$lh(a), f = $9b9e6d0f6347a978$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b9e6d0f6347a978$var$dh(a, f, e);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, e, d), $9b9e6d0f6347a978$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9b9e6d0f6347a978$var$L(), e = $9b9e6d0f6347a978$var$lh(a), f = $9b9e6d0f6347a978$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9b9e6d0f6347a978$var$dh(a, f, e);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, e, d), $9b9e6d0f6347a978$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9b9e6d0f6347a978$var$L(), d = $9b9e6d0f6347a978$var$lh(a), e = $9b9e6d0f6347a978$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9b9e6d0f6347a978$var$dh(a, e, d);
        null !== b && ($9b9e6d0f6347a978$var$mh(b, a, d, c), $9b9e6d0f6347a978$var$eh(b, a, d));
    }
};
function $9b9e6d0f6347a978$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9b9e6d0f6347a978$var$Ie(c, d) || !$9b9e6d0f6347a978$var$Ie(e, f) : !0;
}
function $9b9e6d0f6347a978$var$ph(a, b, c) {
    var d = !1, e = $9b9e6d0f6347a978$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9b9e6d0f6347a978$var$Vg(f) : (e = $9b9e6d0f6347a978$var$Zf(b) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9b9e6d0f6347a978$var$Yf(a, e) : $9b9e6d0f6347a978$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9b9e6d0f6347a978$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9b9e6d0f6347a978$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9b9e6d0f6347a978$var$nh.enqueueReplaceState(b, b.state, null);
}
function $9b9e6d0f6347a978$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $9b9e6d0f6347a978$var$jh;
    $9b9e6d0f6347a978$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9b9e6d0f6347a978$var$Vg(f) : (f = $9b9e6d0f6347a978$var$Zf(b) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, e.context = $9b9e6d0f6347a978$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9b9e6d0f6347a978$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9b9e6d0f6347a978$var$nh.enqueueReplaceState(e, e.state, null), $9b9e6d0f6347a978$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9b9e6d0f6347a978$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9b9e6d0f6347a978$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9b9e6d0f6347a978$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $9b9e6d0f6347a978$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9b9e6d0f6347a978$var$p(284));
        if (!c._owner) throw Error($9b9e6d0f6347a978$var$p(290, a));
    }
    return a;
}
function $9b9e6d0f6347a978$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9b9e6d0f6347a978$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9b9e6d0f6347a978$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $9b9e6d0f6347a978$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9b9e6d0f6347a978$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9b9e6d0f6347a978$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9b9e6d0f6347a978$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9b9e6d0f6347a978$var$Ha && $9b9e6d0f6347a978$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $9b9e6d0f6347a978$var$sh(a, b, c), d.return = a, d;
        d = $9b9e6d0f6347a978$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9b9e6d0f6347a978$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9b9e6d0f6347a978$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9b9e6d0f6347a978$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9b9e6d0f6347a978$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return c = $9b9e6d0f6347a978$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $9b9e6d0f6347a978$var$sh(a, null, b), c.return = a, c;
                case $9b9e6d0f6347a978$var$wa:
                    return b = $9b9e6d0f6347a978$var$zh(b, a.mode, c), b.return = a, b;
                case $9b9e6d0f6347a978$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9b9e6d0f6347a978$var$eb(b) || $9b9e6d0f6347a978$var$Ka(b)) return b = $9b9e6d0f6347a978$var$Ah(b, a.mode, c, null), b.return = a, b;
            $9b9e6d0f6347a978$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9b9e6d0f6347a978$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9b9e6d0f6347a978$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9b9e6d0f6347a978$var$eb(c) || $9b9e6d0f6347a978$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9b9e6d0f6347a978$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9b9e6d0f6347a978$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9b9e6d0f6347a978$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9b9e6d0f6347a978$var$eb(d) || $9b9e6d0f6347a978$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9b9e6d0f6347a978$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9b9e6d0f6347a978$var$Ka(h);
        if ("function" !== typeof l) throw Error($9b9e6d0f6347a978$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9b9e6d0f6347a978$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9b9e6d0f6347a978$var$I && $9b9e6d0f6347a978$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9b9e6d0f6347a978$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9b9e6d0f6347a978$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9b9e6d0f6347a978$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9b9e6d0f6347a978$var$Ha && $9b9e6d0f6347a978$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9b9e6d0f6347a978$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9b9e6d0f6347a978$var$ya ? (d = $9b9e6d0f6347a978$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9b9e6d0f6347a978$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $9b9e6d0f6347a978$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9b9e6d0f6347a978$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9b9e6d0f6347a978$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9b9e6d0f6347a978$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9b9e6d0f6347a978$var$eb(f)) return n(a, d, f, h);
            if ($9b9e6d0f6347a978$var$Ka(f)) return t(a, d, f, h);
            $9b9e6d0f6347a978$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9b9e6d0f6347a978$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9b9e6d0f6347a978$var$Bh = $9b9e6d0f6347a978$var$vh(!0), $9b9e6d0f6347a978$var$Ch = $9b9e6d0f6347a978$var$vh(!1), $9b9e6d0f6347a978$var$Dh = {}, $9b9e6d0f6347a978$var$Eh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh), $9b9e6d0f6347a978$var$Fh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh), $9b9e6d0f6347a978$var$Gh = $9b9e6d0f6347a978$var$Uf($9b9e6d0f6347a978$var$Dh);
function $9b9e6d0f6347a978$var$Hh(a) {
    if (a === $9b9e6d0f6347a978$var$Dh) throw Error($9b9e6d0f6347a978$var$p(174));
    return a;
}
function $9b9e6d0f6347a978$var$Ih(a, b) {
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Gh, b);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Fh, a);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, $9b9e6d0f6347a978$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9b9e6d0f6347a978$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9b9e6d0f6347a978$var$lb(b, a);
    }
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh);
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, b);
}
function $9b9e6d0f6347a978$var$Jh() {
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Fh);
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Gh);
}
function $9b9e6d0f6347a978$var$Kh(a) {
    $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
    var b = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
    var c = $9b9e6d0f6347a978$var$lb(b, a.type);
    b !== c && ($9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Fh, a), $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Eh, c));
}
function $9b9e6d0f6347a978$var$Lh(a) {
    $9b9e6d0f6347a978$var$Fh.current === a && ($9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Eh), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Fh));
}
var $9b9e6d0f6347a978$var$M = $9b9e6d0f6347a978$var$Uf(0);
function $9b9e6d0f6347a978$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9b9e6d0f6347a978$var$Nh = [];
function $9b9e6d0f6347a978$var$Oh() {
    for(var a = 0; a < $9b9e6d0f6347a978$var$Nh.length; a++)$9b9e6d0f6347a978$var$Nh[a]._workInProgressVersionPrimary = null;
    $9b9e6d0f6347a978$var$Nh.length = 0;
}
var $9b9e6d0f6347a978$var$Ph = $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher, $9b9e6d0f6347a978$var$Qh = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$Rh = 0, $9b9e6d0f6347a978$var$N = null, $9b9e6d0f6347a978$var$O = null, $9b9e6d0f6347a978$var$P = null, $9b9e6d0f6347a978$var$Sh = !1, $9b9e6d0f6347a978$var$Th = !1, $9b9e6d0f6347a978$var$Uh = 0, $9b9e6d0f6347a978$var$Vh = 0;
function $9b9e6d0f6347a978$var$Q() {
    throw Error($9b9e6d0f6347a978$var$p(321));
}
function $9b9e6d0f6347a978$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9b9e6d0f6347a978$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9b9e6d0f6347a978$var$Xh(a, b, c, d, e, f) {
    $9b9e6d0f6347a978$var$Rh = f;
    $9b9e6d0f6347a978$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9b9e6d0f6347a978$var$Ph.current = null === a || null === a.memoizedState ? $9b9e6d0f6347a978$var$Yh : $9b9e6d0f6347a978$var$Zh;
    a = c(d, e);
    if ($9b9e6d0f6347a978$var$Th) {
        f = 0;
        do {
            $9b9e6d0f6347a978$var$Th = !1;
            $9b9e6d0f6347a978$var$Uh = 0;
            if (25 <= f) throw Error($9b9e6d0f6347a978$var$p(301));
            f += 1;
            $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = null;
            b.updateQueue = null;
            $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$$h;
            a = c(d, e);
        }while ($9b9e6d0f6347a978$var$Th);
    }
    $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$ai;
    b = null !== $9b9e6d0f6347a978$var$O && null !== $9b9e6d0f6347a978$var$O.next;
    $9b9e6d0f6347a978$var$Rh = 0;
    $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = $9b9e6d0f6347a978$var$N = null;
    $9b9e6d0f6347a978$var$Sh = !1;
    if (b) throw Error($9b9e6d0f6347a978$var$p(300));
    return a;
}
function $9b9e6d0f6347a978$var$bi() {
    var a = 0 !== $9b9e6d0f6347a978$var$Uh;
    $9b9e6d0f6347a978$var$Uh = 0;
    return a;
}
function $9b9e6d0f6347a978$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState = $9b9e6d0f6347a978$var$P = a : $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$P.next = a;
    return $9b9e6d0f6347a978$var$P;
}
function $9b9e6d0f6347a978$var$di() {
    if (null === $9b9e6d0f6347a978$var$O) {
        var a = $9b9e6d0f6347a978$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9b9e6d0f6347a978$var$O.next;
    var b = null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState : $9b9e6d0f6347a978$var$P.next;
    if (null !== b) $9b9e6d0f6347a978$var$P = b, $9b9e6d0f6347a978$var$O = a;
    else {
        if (null === a) throw Error($9b9e6d0f6347a978$var$p(310));
        $9b9e6d0f6347a978$var$O = a;
        a = {
            memoizedState: $9b9e6d0f6347a978$var$O.memoizedState,
            baseState: $9b9e6d0f6347a978$var$O.baseState,
            baseQueue: $9b9e6d0f6347a978$var$O.baseQueue,
            queue: $9b9e6d0f6347a978$var$O.queue,
            next: null
        };
        null === $9b9e6d0f6347a978$var$P ? $9b9e6d0f6347a978$var$N.memoizedState = $9b9e6d0f6347a978$var$P = a : $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$P.next = a;
    }
    return $9b9e6d0f6347a978$var$P;
}
function $9b9e6d0f6347a978$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9b9e6d0f6347a978$var$fi(a) {
    var b = $9b9e6d0f6347a978$var$di(), c = b.queue;
    if (null === c) throw Error($9b9e6d0f6347a978$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9b9e6d0f6347a978$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9b9e6d0f6347a978$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9b9e6d0f6347a978$var$N.lanes |= m;
                $9b9e6d0f6347a978$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9b9e6d0f6347a978$var$He(d, b.memoizedState) || ($9b9e6d0f6347a978$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9b9e6d0f6347a978$var$N.lanes |= f, $9b9e6d0f6347a978$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9b9e6d0f6347a978$var$gi(a) {
    var b = $9b9e6d0f6347a978$var$di(), c = b.queue;
    if (null === c) throw Error($9b9e6d0f6347a978$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9b9e6d0f6347a978$var$He(f, b.memoizedState) || ($9b9e6d0f6347a978$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9b9e6d0f6347a978$var$hi() {}
function $9b9e6d0f6347a978$var$ii(a, b) {
    var c = $9b9e6d0f6347a978$var$N, d = $9b9e6d0f6347a978$var$di(), e = b(), f = !$9b9e6d0f6347a978$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9b9e6d0f6347a978$var$Ug = !0);
    d = d.queue;
    $9b9e6d0f6347a978$var$ji($9b9e6d0f6347a978$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9b9e6d0f6347a978$var$P && $9b9e6d0f6347a978$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9b9e6d0f6347a978$var$li(9, $9b9e6d0f6347a978$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $9b9e6d0f6347a978$var$R) throw Error($9b9e6d0f6347a978$var$p(349));
        0 !== ($9b9e6d0f6347a978$var$Rh & 30) || $9b9e6d0f6347a978$var$ni(c, b, e);
    }
    return e;
}
function $9b9e6d0f6347a978$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9b9e6d0f6347a978$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b9e6d0f6347a978$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9b9e6d0f6347a978$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9b9e6d0f6347a978$var$oi(b) && $9b9e6d0f6347a978$var$pi(a);
}
function $9b9e6d0f6347a978$var$ki(a, b, c) {
    return c(function() {
        $9b9e6d0f6347a978$var$oi(b) && $9b9e6d0f6347a978$var$pi(a);
    });
}
function $9b9e6d0f6347a978$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9b9e6d0f6347a978$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9b9e6d0f6347a978$var$pi(a) {
    var b = $9b9e6d0f6347a978$var$Zg(a, 1);
    null !== b && $9b9e6d0f6347a978$var$mh(b, a, 1, -1);
}
function $9b9e6d0f6347a978$var$qi(a) {
    var b = $9b9e6d0f6347a978$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9b9e6d0f6347a978$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9b9e6d0f6347a978$var$ri.bind(null, $9b9e6d0f6347a978$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9b9e6d0f6347a978$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9b9e6d0f6347a978$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9b9e6d0f6347a978$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9b9e6d0f6347a978$var$si() {
    return $9b9e6d0f6347a978$var$di().memoizedState;
}
function $9b9e6d0f6347a978$var$ti(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$ci();
    $9b9e6d0f6347a978$var$N.flags |= a;
    e.memoizedState = $9b9e6d0f6347a978$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9b9e6d0f6347a978$var$ui(a, b, c, d) {
    var e = $9b9e6d0f6347a978$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9b9e6d0f6347a978$var$O) {
        var g = $9b9e6d0f6347a978$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $9b9e6d0f6347a978$var$Wh(d, g.deps)) {
            e.memoizedState = $9b9e6d0f6347a978$var$li(b, c, f, d);
            return;
        }
    }
    $9b9e6d0f6347a978$var$N.flags |= a;
    e.memoizedState = $9b9e6d0f6347a978$var$li(1 | b, c, f, d);
}
function $9b9e6d0f6347a978$var$vi(a, b) {
    return $9b9e6d0f6347a978$var$ti(8390656, 8, a, b);
}
function $9b9e6d0f6347a978$var$ji(a, b) {
    return $9b9e6d0f6347a978$var$ui(2048, 8, a, b);
}
function $9b9e6d0f6347a978$var$wi(a, b) {
    return $9b9e6d0f6347a978$var$ui(4, 2, a, b);
}
function $9b9e6d0f6347a978$var$xi(a, b) {
    return $9b9e6d0f6347a978$var$ui(4, 4, a, b);
}
function $9b9e6d0f6347a978$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9b9e6d0f6347a978$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9b9e6d0f6347a978$var$ui(4, 4, $9b9e6d0f6347a978$var$yi.bind(null, b, a), c);
}
function $9b9e6d0f6347a978$var$Ai() {}
function $9b9e6d0f6347a978$var$Bi(a, b) {
    var c = $9b9e6d0f6347a978$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b9e6d0f6347a978$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b9e6d0f6347a978$var$Ci(a, b) {
    var c = $9b9e6d0f6347a978$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9b9e6d0f6347a978$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9b9e6d0f6347a978$var$Di(a, b, c) {
    if (0 === ($9b9e6d0f6347a978$var$Rh & 21)) return a.baseState && (a.baseState = !1, $9b9e6d0f6347a978$var$Ug = !0), a.memoizedState = c;
    $9b9e6d0f6347a978$var$He(c, b) || (c = $9b9e6d0f6347a978$var$yc(), $9b9e6d0f6347a978$var$N.lanes |= c, $9b9e6d0f6347a978$var$hh |= c, a.baseState = !0);
    return b;
}
function $9b9e6d0f6347a978$var$Ei(a, b) {
    var c = $9b9e6d0f6347a978$var$C;
    $9b9e6d0f6347a978$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9b9e6d0f6347a978$var$Qh.transition;
    $9b9e6d0f6347a978$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9b9e6d0f6347a978$var$C = c, $9b9e6d0f6347a978$var$Qh.transition = d;
    }
}
function $9b9e6d0f6347a978$var$Fi() {
    return $9b9e6d0f6347a978$var$di().memoizedState;
}
function $9b9e6d0f6347a978$var$Gi(a, b, c) {
    var d = $9b9e6d0f6347a978$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b9e6d0f6347a978$var$Hi(a)) $9b9e6d0f6347a978$var$Ii(b, c);
    else if (c = $9b9e6d0f6347a978$var$Yg(a, b, c, d), null !== c) {
        var e = $9b9e6d0f6347a978$var$L();
        $9b9e6d0f6347a978$var$mh(c, a, d, e);
        $9b9e6d0f6347a978$var$Ji(c, b, d);
    }
}
function $9b9e6d0f6347a978$var$ri(a, b, c) {
    var d = $9b9e6d0f6347a978$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9b9e6d0f6347a978$var$Hi(a)) $9b9e6d0f6347a978$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9b9e6d0f6347a978$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9b9e6d0f6347a978$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9b9e6d0f6347a978$var$Yg(a, b, e, d);
        null !== c && (e = $9b9e6d0f6347a978$var$L(), $9b9e6d0f6347a978$var$mh(c, a, d, e), $9b9e6d0f6347a978$var$Ji(c, b, d));
    }
}
function $9b9e6d0f6347a978$var$Hi(a) {
    var b = a.alternate;
    return a === $9b9e6d0f6347a978$var$N || null !== b && b === $9b9e6d0f6347a978$var$N;
}
function $9b9e6d0f6347a978$var$Ii(a, b) {
    $9b9e6d0f6347a978$var$Th = $9b9e6d0f6347a978$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9b9e6d0f6347a978$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9b9e6d0f6347a978$var$Cc(a, c);
    }
}
var $9b9e6d0f6347a978$var$ai = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Q,
    useContext: $9b9e6d0f6347a978$var$Q,
    useEffect: $9b9e6d0f6347a978$var$Q,
    useImperativeHandle: $9b9e6d0f6347a978$var$Q,
    useInsertionEffect: $9b9e6d0f6347a978$var$Q,
    useLayoutEffect: $9b9e6d0f6347a978$var$Q,
    useMemo: $9b9e6d0f6347a978$var$Q,
    useReducer: $9b9e6d0f6347a978$var$Q,
    useRef: $9b9e6d0f6347a978$var$Q,
    useState: $9b9e6d0f6347a978$var$Q,
    useDebugValue: $9b9e6d0f6347a978$var$Q,
    useDeferredValue: $9b9e6d0f6347a978$var$Q,
    useTransition: $9b9e6d0f6347a978$var$Q,
    useMutableSource: $9b9e6d0f6347a978$var$Q,
    useSyncExternalStore: $9b9e6d0f6347a978$var$Q,
    useId: $9b9e6d0f6347a978$var$Q,
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$Yh = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: function(a, b) {
        $9b9e6d0f6347a978$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9b9e6d0f6347a978$var$ti(4194308, 4, $9b9e6d0f6347a978$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9b9e6d0f6347a978$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9b9e6d0f6347a978$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9b9e6d0f6347a978$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9b9e6d0f6347a978$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9b9e6d0f6347a978$var$Gi.bind(null, $9b9e6d0f6347a978$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9b9e6d0f6347a978$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9b9e6d0f6347a978$var$qi,
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        return $9b9e6d0f6347a978$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$qi(!1), b = a[0];
        a = $9b9e6d0f6347a978$var$Ei.bind(null, a[1]);
        $9b9e6d0f6347a978$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9b9e6d0f6347a978$var$N, e = $9b9e6d0f6347a978$var$ci();
        if ($9b9e6d0f6347a978$var$I) {
            if (void 0 === c) throw Error($9b9e6d0f6347a978$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9b9e6d0f6347a978$var$R) throw Error($9b9e6d0f6347a978$var$p(349));
            0 !== ($9b9e6d0f6347a978$var$Rh & 30) || $9b9e6d0f6347a978$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9b9e6d0f6347a978$var$vi($9b9e6d0f6347a978$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9b9e6d0f6347a978$var$li(9, $9b9e6d0f6347a978$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9b9e6d0f6347a978$var$ci(), b = $9b9e6d0f6347a978$var$R.identifierPrefix;
        if ($9b9e6d0f6347a978$var$I) {
            var c = $9b9e6d0f6347a978$var$sg;
            var d = $9b9e6d0f6347a978$var$rg;
            c = (d & ~(1 << 32 - $9b9e6d0f6347a978$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9b9e6d0f6347a978$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9b9e6d0f6347a978$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$Zh = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Bi,
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$ji,
    useImperativeHandle: $9b9e6d0f6347a978$var$zi,
    useInsertionEffect: $9b9e6d0f6347a978$var$wi,
    useLayoutEffect: $9b9e6d0f6347a978$var$xi,
    useMemo: $9b9e6d0f6347a978$var$Ci,
    useReducer: $9b9e6d0f6347a978$var$fi,
    useRef: $9b9e6d0f6347a978$var$si,
    useState: function() {
        return $9b9e6d0f6347a978$var$fi($9b9e6d0f6347a978$var$ei);
    },
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        var b = $9b9e6d0f6347a978$var$di();
        return $9b9e6d0f6347a978$var$Di(b, $9b9e6d0f6347a978$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$fi($9b9e6d0f6347a978$var$ei)[0], b = $9b9e6d0f6347a978$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b9e6d0f6347a978$var$hi,
    useSyncExternalStore: $9b9e6d0f6347a978$var$ii,
    useId: $9b9e6d0f6347a978$var$Fi,
    unstable_isNewReconciler: !1
}, $9b9e6d0f6347a978$var$$h = {
    readContext: $9b9e6d0f6347a978$var$Vg,
    useCallback: $9b9e6d0f6347a978$var$Bi,
    useContext: $9b9e6d0f6347a978$var$Vg,
    useEffect: $9b9e6d0f6347a978$var$ji,
    useImperativeHandle: $9b9e6d0f6347a978$var$zi,
    useInsertionEffect: $9b9e6d0f6347a978$var$wi,
    useLayoutEffect: $9b9e6d0f6347a978$var$xi,
    useMemo: $9b9e6d0f6347a978$var$Ci,
    useReducer: $9b9e6d0f6347a978$var$gi,
    useRef: $9b9e6d0f6347a978$var$si,
    useState: function() {
        return $9b9e6d0f6347a978$var$gi($9b9e6d0f6347a978$var$ei);
    },
    useDebugValue: $9b9e6d0f6347a978$var$Ai,
    useDeferredValue: function(a) {
        var b = $9b9e6d0f6347a978$var$di();
        return null === $9b9e6d0f6347a978$var$O ? b.memoizedState = a : $9b9e6d0f6347a978$var$Di(b, $9b9e6d0f6347a978$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $9b9e6d0f6347a978$var$gi($9b9e6d0f6347a978$var$ei)[0], b = $9b9e6d0f6347a978$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9b9e6d0f6347a978$var$hi,
    useSyncExternalStore: $9b9e6d0f6347a978$var$ii,
    useId: $9b9e6d0f6347a978$var$Fi,
    unstable_isNewReconciler: !1
};
function $9b9e6d0f6347a978$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $9b9e6d0f6347a978$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9b9e6d0f6347a978$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9b9e6d0f6347a978$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9b9e6d0f6347a978$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $9b9e6d0f6347a978$var$Oi(a, b, c) {
    c = $9b9e6d0f6347a978$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9b9e6d0f6347a978$var$Pi || ($9b9e6d0f6347a978$var$Pi = !0, $9b9e6d0f6347a978$var$Qi = d);
        $9b9e6d0f6347a978$var$Mi(a, b);
    };
    return c;
}
function $9b9e6d0f6347a978$var$Ri(a, b, c) {
    c = $9b9e6d0f6347a978$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9b9e6d0f6347a978$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9b9e6d0f6347a978$var$Mi(a, b);
        "function" !== typeof d && (null === $9b9e6d0f6347a978$var$Si ? $9b9e6d0f6347a978$var$Si = new Set([
            this
        ]) : $9b9e6d0f6347a978$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9b9e6d0f6347a978$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9b9e6d0f6347a978$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9b9e6d0f6347a978$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $9b9e6d0f6347a978$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9b9e6d0f6347a978$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9b9e6d0f6347a978$var$ch(-1, 1), b.tag = 2, $9b9e6d0f6347a978$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9b9e6d0f6347a978$var$Xi = $9b9e6d0f6347a978$var$ua.ReactCurrentOwner, $9b9e6d0f6347a978$var$Ug = !1;
function $9b9e6d0f6347a978$var$Yi(a, b, c, d) {
    b.child = null === a ? $9b9e6d0f6347a978$var$Ch(b, null, c, d) : $9b9e6d0f6347a978$var$Bh(b, a.child, c, d);
}
function $9b9e6d0f6347a978$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9b9e6d0f6347a978$var$Tg(b, e);
    d = $9b9e6d0f6347a978$var$Xh(a, b, c, d, f, e);
    c = $9b9e6d0f6347a978$var$bi();
    if (null !== a && !$9b9e6d0f6347a978$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b9e6d0f6347a978$var$$i(a, b, e);
    $9b9e6d0f6347a978$var$I && c && $9b9e6d0f6347a978$var$vg(b);
    b.flags |= 1;
    $9b9e6d0f6347a978$var$Yi(a, b, d, e);
    return b.child;
}
function $9b9e6d0f6347a978$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9b9e6d0f6347a978$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9b9e6d0f6347a978$var$cj(a, b, f, d, e);
        a = $9b9e6d0f6347a978$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9b9e6d0f6347a978$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9b9e6d0f6347a978$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $9b9e6d0f6347a978$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9b9e6d0f6347a978$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9b9e6d0f6347a978$var$Ie(f, d) && a.ref === b.ref) {
            if ($9b9e6d0f6347a978$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9b9e6d0f6347a978$var$Ug = !0);
            else return b.lanes = a.lanes, $9b9e6d0f6347a978$var$$i(a, b, e);
        }
    }
    return $9b9e6d0f6347a978$var$dj(a, b, c, d, e);
}
function $9b9e6d0f6347a978$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj);
            $9b9e6d0f6347a978$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$fj, $9b9e6d0f6347a978$var$gj), $9b9e6d0f6347a978$var$gj |= d;
    $9b9e6d0f6347a978$var$Yi(a, b, e, c);
    return b.child;
}
function $9b9e6d0f6347a978$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9b9e6d0f6347a978$var$dj(a, b, c, d, e) {
    var f = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current;
    f = $9b9e6d0f6347a978$var$Yf(b, f);
    $9b9e6d0f6347a978$var$Tg(b, e);
    c = $9b9e6d0f6347a978$var$Xh(a, b, c, d, f, e);
    d = $9b9e6d0f6347a978$var$bi();
    if (null !== a && !$9b9e6d0f6347a978$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9b9e6d0f6347a978$var$$i(a, b, e);
    $9b9e6d0f6347a978$var$I && d && $9b9e6d0f6347a978$var$vg(b);
    b.flags |= 1;
    $9b9e6d0f6347a978$var$Yi(a, b, c, e);
    return b.child;
}
function $9b9e6d0f6347a978$var$ij(a, b, c, d, e) {
    if ($9b9e6d0f6347a978$var$Zf(c)) {
        var f = !0;
        $9b9e6d0f6347a978$var$cg(b);
    } else f = !1;
    $9b9e6d0f6347a978$var$Tg(b, e);
    if (null === b.stateNode) $9b9e6d0f6347a978$var$jj(a, b), $9b9e6d0f6347a978$var$ph(b, c, d), $9b9e6d0f6347a978$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9b9e6d0f6347a978$var$Vg(l) : (l = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, l = $9b9e6d0f6347a978$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9b9e6d0f6347a978$var$qh(b, g, d, l);
        $9b9e6d0f6347a978$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $9b9e6d0f6347a978$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9b9e6d0f6347a978$var$Wf.current || $9b9e6d0f6347a978$var$$g ? ("function" === typeof m && ($9b9e6d0f6347a978$var$kh(b, c, m, d), k = b.memoizedState), (h = $9b9e6d0f6347a978$var$$g || $9b9e6d0f6347a978$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9b9e6d0f6347a978$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9b9e6d0f6347a978$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9b9e6d0f6347a978$var$Vg(k) : (k = $9b9e6d0f6347a978$var$Zf(c) ? $9b9e6d0f6347a978$var$Xf : $9b9e6d0f6347a978$var$H.current, k = $9b9e6d0f6347a978$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9b9e6d0f6347a978$var$qh(b, g, d, k);
        $9b9e6d0f6347a978$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $9b9e6d0f6347a978$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9b9e6d0f6347a978$var$Wf.current || $9b9e6d0f6347a978$var$$g ? ("function" === typeof y && ($9b9e6d0f6347a978$var$kh(b, c, y, d), n = b.memoizedState), (l = $9b9e6d0f6347a978$var$$g || $9b9e6d0f6347a978$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9b9e6d0f6347a978$var$kj(a, b, c, d, f, e);
}
function $9b9e6d0f6347a978$var$kj(a, b, c, d, e, f) {
    $9b9e6d0f6347a978$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9b9e6d0f6347a978$var$dg(b, c, !1), $9b9e6d0f6347a978$var$$i(a, b, f);
    d = b.stateNode;
    $9b9e6d0f6347a978$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9b9e6d0f6347a978$var$Bh(b, a.child, null, f), b.child = $9b9e6d0f6347a978$var$Bh(b, null, h, f)) : $9b9e6d0f6347a978$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9b9e6d0f6347a978$var$dg(b, c, !0);
    return b.child;
}
function $9b9e6d0f6347a978$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9b9e6d0f6347a978$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9b9e6d0f6347a978$var$ag(a, b.context, !1);
    $9b9e6d0f6347a978$var$Ih(a, b.containerInfo);
}
function $9b9e6d0f6347a978$var$mj(a, b, c, d, e) {
    $9b9e6d0f6347a978$var$Ig();
    $9b9e6d0f6347a978$var$Jg(e);
    b.flags |= 256;
    $9b9e6d0f6347a978$var$Yi(a, b, c, d);
    return b.child;
}
var $9b9e6d0f6347a978$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9b9e6d0f6347a978$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9b9e6d0f6347a978$var$pj(a, b, c) {
    var d = b.pendingProps, e = $9b9e6d0f6347a978$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, e & 1);
    if (null === a) {
        $9b9e6d0f6347a978$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9b9e6d0f6347a978$var$qj(g, d, 0, null), a = $9b9e6d0f6347a978$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9b9e6d0f6347a978$var$oj(c), b.memoizedState = $9b9e6d0f6347a978$var$nj, a) : $9b9e6d0f6347a978$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9b9e6d0f6347a978$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9b9e6d0f6347a978$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9b9e6d0f6347a978$var$wh(h, f) : (f = $9b9e6d0f6347a978$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9b9e6d0f6347a978$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9b9e6d0f6347a978$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9b9e6d0f6347a978$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9b9e6d0f6347a978$var$rj(a, b) {
    b = $9b9e6d0f6347a978$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9b9e6d0f6347a978$var$tj(a, b, c, d) {
    null !== d && $9b9e6d0f6347a978$var$Jg(d);
    $9b9e6d0f6347a978$var$Bh(b, a.child, null, c);
    a = $9b9e6d0f6347a978$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9b9e6d0f6347a978$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9b9e6d0f6347a978$var$Li(Error($9b9e6d0f6347a978$var$p(422))), $9b9e6d0f6347a978$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9b9e6d0f6347a978$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9b9e6d0f6347a978$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9b9e6d0f6347a978$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $9b9e6d0f6347a978$var$oj(g);
        b.memoizedState = $9b9e6d0f6347a978$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9b9e6d0f6347a978$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9b9e6d0f6347a978$var$p(419));
        d = $9b9e6d0f6347a978$var$Li(f, d, void 0);
        return $9b9e6d0f6347a978$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9b9e6d0f6347a978$var$Ug || h) {
        d = $9b9e6d0f6347a978$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9b9e6d0f6347a978$var$Zg(a, e), $9b9e6d0f6347a978$var$mh(d, a, e, -1));
        }
        $9b9e6d0f6347a978$var$uj();
        d = $9b9e6d0f6347a978$var$Li(Error($9b9e6d0f6347a978$var$p(421)));
        return $9b9e6d0f6347a978$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9b9e6d0f6347a978$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(e.nextSibling);
    $9b9e6d0f6347a978$var$xg = b;
    $9b9e6d0f6347a978$var$I = !0;
    $9b9e6d0f6347a978$var$zg = null;
    null !== a && ($9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$rg, $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$sg, $9b9e6d0f6347a978$var$og[$9b9e6d0f6347a978$var$pg++] = $9b9e6d0f6347a978$var$qg, $9b9e6d0f6347a978$var$rg = a.id, $9b9e6d0f6347a978$var$sg = a.overflow, $9b9e6d0f6347a978$var$qg = b);
    b = $9b9e6d0f6347a978$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9b9e6d0f6347a978$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9b9e6d0f6347a978$var$Sg(a.return, b, c);
}
function $9b9e6d0f6347a978$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9b9e6d0f6347a978$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9b9e6d0f6347a978$var$Yi(a, b, d.children, c);
    d = $9b9e6d0f6347a978$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9b9e6d0f6347a978$var$wj(a, c, b);
            else if (19 === a.tag) $9b9e6d0f6347a978$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9b9e6d0f6347a978$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9b9e6d0f6347a978$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9b9e6d0f6347a978$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9b9e6d0f6347a978$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $9b9e6d0f6347a978$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9b9e6d0f6347a978$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9b9e6d0f6347a978$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9b9e6d0f6347a978$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9b9e6d0f6347a978$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9b9e6d0f6347a978$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9b9e6d0f6347a978$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9b9e6d0f6347a978$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $9b9e6d0f6347a978$var$lj(b);
            $9b9e6d0f6347a978$var$Ig();
            break;
        case 5:
            $9b9e6d0f6347a978$var$Kh(b);
            break;
        case 1:
            $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$cg(b);
            break;
        case 4:
            $9b9e6d0f6347a978$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9b9e6d0f6347a978$var$pj(a, b, c);
                $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1);
                a = $9b9e6d0f6347a978$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9b9e6d0f6347a978$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9b9e6d0f6347a978$var$ej(a, b, c);
    }
    return $9b9e6d0f6347a978$var$$i(a, b, c);
}
var $9b9e6d0f6347a978$var$Aj, $9b9e6d0f6347a978$var$Bj, $9b9e6d0f6347a978$var$Cj, $9b9e6d0f6347a978$var$Dj;
$9b9e6d0f6347a978$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9b9e6d0f6347a978$var$Bj = function() {};
$9b9e6d0f6347a978$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9b9e6d0f6347a978$var$Ya(a, e);
                d = $9b9e6d0f6347a978$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9b9e6d0f6347a978$var$A({}, e, {
                    value: void 0
                });
                d = $9b9e6d0f6347a978$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9b9e6d0f6347a978$var$gb(a, e);
                d = $9b9e6d0f6347a978$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9b9e6d0f6347a978$var$Bf);
        }
        $9b9e6d0f6347a978$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9b9e6d0f6347a978$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9b9e6d0f6347a978$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9b9e6d0f6347a978$var$Ej(a, b) {
    if (!$9b9e6d0f6347a978$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9b9e6d0f6347a978$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9b9e6d0f6347a978$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $9b9e6d0f6347a978$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9b9e6d0f6347a978$var$S(b), null;
        case 1:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), $9b9e6d0f6347a978$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9b9e6d0f6347a978$var$Jh();
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
            $9b9e6d0f6347a978$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9b9e6d0f6347a978$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9b9e6d0f6347a978$var$zg && ($9b9e6d0f6347a978$var$Gj($9b9e6d0f6347a978$var$zg), $9b9e6d0f6347a978$var$zg = null));
            $9b9e6d0f6347a978$var$Bj(a, b);
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 5:
            $9b9e6d0f6347a978$var$Lh(b);
            var e = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9b9e6d0f6347a978$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9b9e6d0f6347a978$var$p(166));
                    $9b9e6d0f6347a978$var$S(b);
                    return null;
                }
                a = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
                if ($9b9e6d0f6347a978$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9b9e6d0f6347a978$var$Of] = b;
                    d[$9b9e6d0f6347a978$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9b9e6d0f6347a978$var$D("cancel", d);
                            $9b9e6d0f6347a978$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9b9e6d0f6347a978$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9b9e6d0f6347a978$var$lf.length; e++)$9b9e6d0f6347a978$var$D($9b9e6d0f6347a978$var$lf[e], d);
                            break;
                        case "source":
                            $9b9e6d0f6347a978$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9b9e6d0f6347a978$var$D("error", d);
                            $9b9e6d0f6347a978$var$D("load", d);
                            break;
                        case "details":
                            $9b9e6d0f6347a978$var$D("toggle", d);
                            break;
                        case "input":
                            $9b9e6d0f6347a978$var$Za(d, f);
                            $9b9e6d0f6347a978$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9b9e6d0f6347a978$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$hb(d, f), $9b9e6d0f6347a978$var$D("invalid", d);
                    }
                    $9b9e6d0f6347a978$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9b9e6d0f6347a978$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9b9e6d0f6347a978$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9b9e6d0f6347a978$var$Va(d);
                            $9b9e6d0f6347a978$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$Va(d);
                            $9b9e6d0f6347a978$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9b9e6d0f6347a978$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9b9e6d0f6347a978$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9b9e6d0f6347a978$var$Of] = b;
                    a[$9b9e6d0f6347a978$var$Pf] = d;
                    $9b9e6d0f6347a978$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9b9e6d0f6347a978$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9b9e6d0f6347a978$var$D("cancel", a);
                                $9b9e6d0f6347a978$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9b9e6d0f6347a978$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9b9e6d0f6347a978$var$lf.length; e++)$9b9e6d0f6347a978$var$D($9b9e6d0f6347a978$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9b9e6d0f6347a978$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9b9e6d0f6347a978$var$D("error", a);
                                $9b9e6d0f6347a978$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9b9e6d0f6347a978$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9b9e6d0f6347a978$var$Za(a, d);
                                e = $9b9e6d0f6347a978$var$Ya(a, d);
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9b9e6d0f6347a978$var$A({}, d, {
                                    value: void 0
                                });
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9b9e6d0f6347a978$var$hb(a, d);
                                e = $9b9e6d0f6347a978$var$gb(a, d);
                                $9b9e6d0f6347a978$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9b9e6d0f6347a978$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9b9e6d0f6347a978$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9b9e6d0f6347a978$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9b9e6d0f6347a978$var$ob(a, k) : "number" === typeof k && $9b9e6d0f6347a978$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9b9e6d0f6347a978$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9b9e6d0f6347a978$var$D("scroll", a) : null != k && $9b9e6d0f6347a978$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9b9e6d0f6347a978$var$Va(a);
                                $9b9e6d0f6347a978$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9b9e6d0f6347a978$var$Va(a);
                                $9b9e6d0f6347a978$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9b9e6d0f6347a978$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9b9e6d0f6347a978$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9b9e6d0f6347a978$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9b9e6d0f6347a978$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9b9e6d0f6347a978$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9b9e6d0f6347a978$var$p(166));
                c = $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Gh.current);
                $9b9e6d0f6347a978$var$Hh($9b9e6d0f6347a978$var$Eh.current);
                if ($9b9e6d0f6347a978$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9b9e6d0f6347a978$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9b9e6d0f6347a978$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9b9e6d0f6347a978$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9b9e6d0f6347a978$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9b9e6d0f6347a978$var$Of] = b, b.stateNode = d;
            }
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 13:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9b9e6d0f6347a978$var$I && null !== $9b9e6d0f6347a978$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9b9e6d0f6347a978$var$Hg(), $9b9e6d0f6347a978$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9b9e6d0f6347a978$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9b9e6d0f6347a978$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9b9e6d0f6347a978$var$p(317));
                        f[$9b9e6d0f6347a978$var$Of] = b;
                    } else $9b9e6d0f6347a978$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9b9e6d0f6347a978$var$S(b);
                    f = !1;
                } else null !== $9b9e6d0f6347a978$var$zg && ($9b9e6d0f6347a978$var$Gj($9b9e6d0f6347a978$var$zg), $9b9e6d0f6347a978$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9b9e6d0f6347a978$var$M.current & 1) ? 0 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 3) : $9b9e6d0f6347a978$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 4:
            return $9b9e6d0f6347a978$var$Jh(), $9b9e6d0f6347a978$var$Bj(a, b), null === a && $9b9e6d0f6347a978$var$sf(b.stateNode.containerInfo), $9b9e6d0f6347a978$var$S(b), null;
        case 10:
            return $9b9e6d0f6347a978$var$Rg(b.type._context), $9b9e6d0f6347a978$var$S(b), null;
        case 17:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), $9b9e6d0f6347a978$var$S(b), null;
        case 19:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            f = b.memoizedState;
            if (null === f) return $9b9e6d0f6347a978$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9b9e6d0f6347a978$var$Ej(f, !1);
                else {
                    if (0 !== $9b9e6d0f6347a978$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9b9e6d0f6347a978$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9b9e6d0f6347a978$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, $9b9e6d0f6347a978$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9b9e6d0f6347a978$var$B() > $9b9e6d0f6347a978$var$Hj && (b.flags |= 128, d = !0, $9b9e6d0f6347a978$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9b9e6d0f6347a978$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9b9e6d0f6347a978$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9b9e6d0f6347a978$var$I) return $9b9e6d0f6347a978$var$S(b), null;
                    } else 2 * $9b9e6d0f6347a978$var$B() - f.renderingStartTime > $9b9e6d0f6347a978$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $9b9e6d0f6347a978$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9b9e6d0f6347a978$var$B(), b.sibling = null, c = $9b9e6d0f6347a978$var$M.current, $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$M, d ? c & 1 | 2 : c & 1), b;
            $9b9e6d0f6347a978$var$S(b);
            return null;
        case 22:
        case 23:
            return $9b9e6d0f6347a978$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9b9e6d0f6347a978$var$gj & 1073741824) && ($9b9e6d0f6347a978$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9b9e6d0f6347a978$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9b9e6d0f6347a978$var$p(156, b.tag));
}
function $9b9e6d0f6347a978$var$Jj(a, b) {
    $9b9e6d0f6347a978$var$wg(b);
    switch(b.tag){
        case 1:
            return $9b9e6d0f6347a978$var$Zf(b.type) && $9b9e6d0f6347a978$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9b9e6d0f6347a978$var$Jh(), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf), $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H), $9b9e6d0f6347a978$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9b9e6d0f6347a978$var$Lh(b), null;
        case 13:
            $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9b9e6d0f6347a978$var$p(340));
                $9b9e6d0f6347a978$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M), null;
        case 4:
            return $9b9e6d0f6347a978$var$Jh(), null;
        case 10:
            return $9b9e6d0f6347a978$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $9b9e6d0f6347a978$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9b9e6d0f6347a978$var$Kj = !1, $9b9e6d0f6347a978$var$U = !1, $9b9e6d0f6347a978$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $9b9e6d0f6347a978$var$V = null;
function $9b9e6d0f6347a978$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9b9e6d0f6347a978$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9b9e6d0f6347a978$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9b9e6d0f6347a978$var$W(a, b, d);
    }
}
var $9b9e6d0f6347a978$var$Oj = !1;
function $9b9e6d0f6347a978$var$Pj(a, b) {
    $9b9e6d0f6347a978$var$Cf = $9b9e6d0f6347a978$var$dd;
    a = $9b9e6d0f6347a978$var$Me();
    if ($9b9e6d0f6347a978$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9b9e6d0f6347a978$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9b9e6d0f6347a978$var$dd = !1;
    for($9b9e6d0f6347a978$var$V = b; null !== $9b9e6d0f6347a978$var$V;)if (b = $9b9e6d0f6347a978$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9b9e6d0f6347a978$var$V = a;
    else for(; null !== $9b9e6d0f6347a978$var$V;){
        b = $9b9e6d0f6347a978$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9b9e6d0f6347a978$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(163));
            }
        } catch (F) {
            $9b9e6d0f6347a978$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9b9e6d0f6347a978$var$V = a;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
    n = $9b9e6d0f6347a978$var$Oj;
    $9b9e6d0f6347a978$var$Oj = !1;
    return n;
}
function $9b9e6d0f6347a978$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9b9e6d0f6347a978$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9b9e6d0f6347a978$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9b9e6d0f6347a978$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9b9e6d0f6347a978$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9b9e6d0f6347a978$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9b9e6d0f6347a978$var$Of], delete b[$9b9e6d0f6347a978$var$Pf], delete b[$9b9e6d0f6347a978$var$of], delete b[$9b9e6d0f6347a978$var$Qf], delete b[$9b9e6d0f6347a978$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9b9e6d0f6347a978$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9b9e6d0f6347a978$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9b9e6d0f6347a978$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9b9e6d0f6347a978$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9b9e6d0f6347a978$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9b9e6d0f6347a978$var$Wj(a, b, c), a = a.sibling; null !== a;)$9b9e6d0f6347a978$var$Wj(a, b, c), a = a.sibling;
}
function $9b9e6d0f6347a978$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9b9e6d0f6347a978$var$Xj(a, b, c), a = a.sibling; null !== a;)$9b9e6d0f6347a978$var$Xj(a, b, c), a = a.sibling;
}
var $9b9e6d0f6347a978$var$X = null, $9b9e6d0f6347a978$var$Yj = !1;
function $9b9e6d0f6347a978$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$9b9e6d0f6347a978$var$ak(a, b, c), c = c.sibling;
}
function $9b9e6d0f6347a978$var$ak(a, b, c) {
    if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onCommitFiberUnmount) try {
        $9b9e6d0f6347a978$var$lc.onCommitFiberUnmount($9b9e6d0f6347a978$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9b9e6d0f6347a978$var$U || $9b9e6d0f6347a978$var$Mj(c, b);
        case 6:
            var d = $9b9e6d0f6347a978$var$X, e = $9b9e6d0f6347a978$var$Yj;
            $9b9e6d0f6347a978$var$X = null;
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            $9b9e6d0f6347a978$var$X = d;
            $9b9e6d0f6347a978$var$Yj = e;
            null !== $9b9e6d0f6347a978$var$X && ($9b9e6d0f6347a978$var$Yj ? (a = $9b9e6d0f6347a978$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9b9e6d0f6347a978$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9b9e6d0f6347a978$var$X && ($9b9e6d0f6347a978$var$Yj ? (a = $9b9e6d0f6347a978$var$X, c = c.stateNode, 8 === a.nodeType ? $9b9e6d0f6347a978$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9b9e6d0f6347a978$var$Kf(a, c), $9b9e6d0f6347a978$var$bd(a)) : $9b9e6d0f6347a978$var$Kf($9b9e6d0f6347a978$var$X, c.stateNode));
            break;
        case 4:
            d = $9b9e6d0f6347a978$var$X;
            e = $9b9e6d0f6347a978$var$Yj;
            $9b9e6d0f6347a978$var$X = c.stateNode.containerInfo;
            $9b9e6d0f6347a978$var$Yj = !0;
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            $9b9e6d0f6347a978$var$X = d;
            $9b9e6d0f6347a978$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9b9e6d0f6347a978$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9b9e6d0f6347a978$var$Nj(c, b, g) : 0 !== (f & 4) && $9b9e6d0f6347a978$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 1:
            if (!$9b9e6d0f6347a978$var$U && ($9b9e6d0f6347a978$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9b9e6d0f6347a978$var$W(c, b, h);
            }
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 21:
            $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9b9e6d0f6347a978$var$U = (d = $9b9e6d0f6347a978$var$U) || null !== c.memoizedState, $9b9e6d0f6347a978$var$Zj(a, b, c), $9b9e6d0f6347a978$var$U = d) : $9b9e6d0f6347a978$var$Zj(a, b, c);
            break;
        default:
            $9b9e6d0f6347a978$var$Zj(a, b, c);
    }
}
function $9b9e6d0f6347a978$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9b9e6d0f6347a978$var$Lj);
        b.forEach(function(b) {
            var d = $9b9e6d0f6347a978$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9b9e6d0f6347a978$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9b9e6d0f6347a978$var$X = h.stateNode;
                        $9b9e6d0f6347a978$var$Yj = !1;
                        break a;
                    case 3:
                        $9b9e6d0f6347a978$var$X = h.stateNode.containerInfo;
                        $9b9e6d0f6347a978$var$Yj = !0;
                        break a;
                    case 4:
                        $9b9e6d0f6347a978$var$X = h.stateNode.containerInfo;
                        $9b9e6d0f6347a978$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9b9e6d0f6347a978$var$X) throw Error($9b9e6d0f6347a978$var$p(160));
            $9b9e6d0f6347a978$var$ak(f, g, e);
            $9b9e6d0f6347a978$var$X = null;
            $9b9e6d0f6347a978$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9b9e6d0f6347a978$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9b9e6d0f6347a978$var$ek(b, a), b = b.sibling;
}
function $9b9e6d0f6347a978$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4) {
                try {
                    $9b9e6d0f6347a978$var$Qj(3, a, a.return), $9b9e6d0f6347a978$var$Rj(3, a);
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
                try {
                    $9b9e6d0f6347a978$var$Qj(5, a, a.return);
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 512 && null !== c && $9b9e6d0f6347a978$var$Mj(c, c.return);
            break;
        case 5:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 512 && null !== c && $9b9e6d0f6347a978$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9b9e6d0f6347a978$var$ob(e, "");
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9b9e6d0f6347a978$var$ab(e, f);
                    $9b9e6d0f6347a978$var$vb(h, g);
                    var l = $9b9e6d0f6347a978$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9b9e6d0f6347a978$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9b9e6d0f6347a978$var$nb(e, q) : "children" === m ? $9b9e6d0f6347a978$var$ob(e, q) : $9b9e6d0f6347a978$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9b9e6d0f6347a978$var$bb(e, f);
                            break;
                        case "textarea":
                            $9b9e6d0f6347a978$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9b9e6d0f6347a978$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9b9e6d0f6347a978$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9b9e6d0f6347a978$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9b9e6d0f6347a978$var$Pf] = f;
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9b9e6d0f6347a978$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9b9e6d0f6347a978$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9b9e6d0f6347a978$var$bd(b.containerInfo);
            } catch (t) {
                $9b9e6d0f6347a978$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            break;
        case 13:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9b9e6d0f6347a978$var$gk = $9b9e6d0f6347a978$var$B()));
            d & 4 && $9b9e6d0f6347a978$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9b9e6d0f6347a978$var$U = (l = $9b9e6d0f6347a978$var$U) || m, $9b9e6d0f6347a978$var$dk(b, a), $9b9e6d0f6347a978$var$U = l) : $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9b9e6d0f6347a978$var$V = a, m = a.child; null !== m;){
                    for(q = $9b9e6d0f6347a978$var$V = m; null !== $9b9e6d0f6347a978$var$V;){
                        r = $9b9e6d0f6347a978$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9b9e6d0f6347a978$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $9b9e6d0f6347a978$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9b9e6d0f6347a978$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9b9e6d0f6347a978$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9b9e6d0f6347a978$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9b9e6d0f6347a978$var$V = y) : $9b9e6d0f6347a978$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9b9e6d0f6347a978$var$rb("display", g));
                            } catch (t) {
                                $9b9e6d0f6347a978$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9b9e6d0f6347a978$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9b9e6d0f6347a978$var$dk(b, a);
            $9b9e6d0f6347a978$var$fk(a);
            d & 4 && $9b9e6d0f6347a978$var$bk(a);
            break;
        case 21:
            break;
        default:
            $9b9e6d0f6347a978$var$dk(b, a), $9b9e6d0f6347a978$var$fk(a);
    }
}
function $9b9e6d0f6347a978$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9b9e6d0f6347a978$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9b9e6d0f6347a978$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9b9e6d0f6347a978$var$ob(e, ""), d.flags &= -33);
                    var f = $9b9e6d0f6347a978$var$Vj(a);
                    $9b9e6d0f6347a978$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9b9e6d0f6347a978$var$Vj(a);
                    $9b9e6d0f6347a978$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(161));
            }
        } catch (k) {
            $9b9e6d0f6347a978$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9b9e6d0f6347a978$var$ik(a, b, c) {
    $9b9e6d0f6347a978$var$V = a;
    $9b9e6d0f6347a978$var$jk(a, b, c);
}
function $9b9e6d0f6347a978$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9b9e6d0f6347a978$var$V;){
        var e = $9b9e6d0f6347a978$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9b9e6d0f6347a978$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9b9e6d0f6347a978$var$U;
                h = $9b9e6d0f6347a978$var$Kj;
                var l = $9b9e6d0f6347a978$var$U;
                $9b9e6d0f6347a978$var$Kj = g;
                if (($9b9e6d0f6347a978$var$U = k) && !l) for($9b9e6d0f6347a978$var$V = e; null !== $9b9e6d0f6347a978$var$V;)g = $9b9e6d0f6347a978$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9b9e6d0f6347a978$var$kk(e) : null !== k ? (k.return = g, $9b9e6d0f6347a978$var$V = k) : $9b9e6d0f6347a978$var$kk(e);
                for(; null !== f;)$9b9e6d0f6347a978$var$V = f, $9b9e6d0f6347a978$var$jk(f, b, c), f = f.sibling;
                $9b9e6d0f6347a978$var$V = e;
                $9b9e6d0f6347a978$var$Kj = h;
                $9b9e6d0f6347a978$var$U = l;
            }
            $9b9e6d0f6347a978$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9b9e6d0f6347a978$var$V = f) : $9b9e6d0f6347a978$var$lk(a, b, c);
    }
}
function $9b9e6d0f6347a978$var$lk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9b9e6d0f6347a978$var$U || $9b9e6d0f6347a978$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9b9e6d0f6347a978$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9b9e6d0f6347a978$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9b9e6d0f6347a978$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9b9e6d0f6347a978$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9b9e6d0f6347a978$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9b9e6d0f6347a978$var$p(163));
                }
                $9b9e6d0f6347a978$var$U || b.flags & 512 && $9b9e6d0f6347a978$var$Sj(b);
            } catch (r) {
                $9b9e6d0f6347a978$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b9e6d0f6347a978$var$V = c;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
function $9b9e6d0f6347a978$var$hk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9b9e6d0f6347a978$var$V = c;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
function $9b9e6d0f6347a978$var$kk(a) {
    for(; null !== $9b9e6d0f6347a978$var$V;){
        var b = $9b9e6d0f6347a978$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Rj(4, b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9b9e6d0f6347a978$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Sj(b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9b9e6d0f6347a978$var$Sj(b);
                    } catch (k) {
                        $9b9e6d0f6347a978$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9b9e6d0f6347a978$var$W(b, b.return, k);
        }
        if (b === a) {
            $9b9e6d0f6347a978$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9b9e6d0f6347a978$var$V = h;
            break;
        }
        $9b9e6d0f6347a978$var$V = b.return;
    }
}
var $9b9e6d0f6347a978$var$mk = Math.ceil, $9b9e6d0f6347a978$var$nk = $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher, $9b9e6d0f6347a978$var$ok = $9b9e6d0f6347a978$var$ua.ReactCurrentOwner, $9b9e6d0f6347a978$var$pk = $9b9e6d0f6347a978$var$ua.ReactCurrentBatchConfig, $9b9e6d0f6347a978$var$K = 0, $9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Y = null, $9b9e6d0f6347a978$var$Z = 0, $9b9e6d0f6347a978$var$gj = 0, $9b9e6d0f6347a978$var$fj = $9b9e6d0f6347a978$var$Uf(0), $9b9e6d0f6347a978$var$T = 0, $9b9e6d0f6347a978$var$qk = null, $9b9e6d0f6347a978$var$hh = 0, $9b9e6d0f6347a978$var$rk = 0, $9b9e6d0f6347a978$var$sk = 0, $9b9e6d0f6347a978$var$tk = null, $9b9e6d0f6347a978$var$uk = null, $9b9e6d0f6347a978$var$gk = 0, $9b9e6d0f6347a978$var$Hj = Infinity, $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Pi = !1, $9b9e6d0f6347a978$var$Qi = null, $9b9e6d0f6347a978$var$Si = null, $9b9e6d0f6347a978$var$wk = !1, $9b9e6d0f6347a978$var$xk = null, $9b9e6d0f6347a978$var$yk = 0, $9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = null, $9b9e6d0f6347a978$var$Bk = -1, $9b9e6d0f6347a978$var$Ck = 0;
function $9b9e6d0f6347a978$var$L() {
    return 0 !== ($9b9e6d0f6347a978$var$K & 6) ? $9b9e6d0f6347a978$var$B() : -1 !== $9b9e6d0f6347a978$var$Bk ? $9b9e6d0f6347a978$var$Bk : $9b9e6d0f6347a978$var$Bk = $9b9e6d0f6347a978$var$B();
}
function $9b9e6d0f6347a978$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9b9e6d0f6347a978$var$K & 2) && 0 !== $9b9e6d0f6347a978$var$Z) return $9b9e6d0f6347a978$var$Z & -$9b9e6d0f6347a978$var$Z;
    if (null !== $9b9e6d0f6347a978$var$Kg.transition) return 0 === $9b9e6d0f6347a978$var$Ck && ($9b9e6d0f6347a978$var$Ck = $9b9e6d0f6347a978$var$yc()), $9b9e6d0f6347a978$var$Ck;
    a = $9b9e6d0f6347a978$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9b9e6d0f6347a978$var$jd(a.type);
    return a;
}
function $9b9e6d0f6347a978$var$mh(a, b, c, d) {
    if (50 < $9b9e6d0f6347a978$var$zk) throw $9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = null, Error($9b9e6d0f6347a978$var$p(185));
    $9b9e6d0f6347a978$var$Ac(a, c, d);
    if (0 === ($9b9e6d0f6347a978$var$K & 2) || a !== $9b9e6d0f6347a978$var$R) a === $9b9e6d0f6347a978$var$R && (0 === ($9b9e6d0f6347a978$var$K & 2) && ($9b9e6d0f6347a978$var$rk |= c), 4 === $9b9e6d0f6347a978$var$T && $9b9e6d0f6347a978$var$Dk(a, $9b9e6d0f6347a978$var$Z)), $9b9e6d0f6347a978$var$Ek(a, d), 1 === c && 0 === $9b9e6d0f6347a978$var$K && 0 === (b.mode & 1) && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$fg && $9b9e6d0f6347a978$var$jg());
}
function $9b9e6d0f6347a978$var$Ek(a, b) {
    var c = a.callbackNode;
    $9b9e6d0f6347a978$var$wc(a, b);
    var d = $9b9e6d0f6347a978$var$uc(a, a === $9b9e6d0f6347a978$var$R ? $9b9e6d0f6347a978$var$Z : 0);
    if (0 === d) null !== c && $9b9e6d0f6347a978$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9b9e6d0f6347a978$var$bc(c);
        if (1 === b) 0 === a.tag ? $9b9e6d0f6347a978$var$ig($9b9e6d0f6347a978$var$Fk.bind(null, a)) : $9b9e6d0f6347a978$var$hg($9b9e6d0f6347a978$var$Fk.bind(null, a)), $9b9e6d0f6347a978$var$Jf(function() {
            0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$jg();
        }), c = null;
        else {
            switch($9b9e6d0f6347a978$var$Dc(d)){
                case 1:
                    c = $9b9e6d0f6347a978$var$fc;
                    break;
                case 4:
                    c = $9b9e6d0f6347a978$var$gc;
                    break;
                case 16:
                    c = $9b9e6d0f6347a978$var$hc;
                    break;
                case 536870912:
                    c = $9b9e6d0f6347a978$var$jc;
                    break;
                default:
                    c = $9b9e6d0f6347a978$var$hc;
            }
            c = $9b9e6d0f6347a978$var$Gk(c, $9b9e6d0f6347a978$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9b9e6d0f6347a978$var$Hk(a, b) {
    $9b9e6d0f6347a978$var$Bk = -1;
    $9b9e6d0f6347a978$var$Ck = 0;
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    var c = a.callbackNode;
    if ($9b9e6d0f6347a978$var$Ik() && a.callbackNode !== c) return null;
    var d = $9b9e6d0f6347a978$var$uc(a, a === $9b9e6d0f6347a978$var$R ? $9b9e6d0f6347a978$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9b9e6d0f6347a978$var$Jk(a, d);
    else {
        b = d;
        var e = $9b9e6d0f6347a978$var$K;
        $9b9e6d0f6347a978$var$K |= 2;
        var f = $9b9e6d0f6347a978$var$Kk();
        if ($9b9e6d0f6347a978$var$R !== a || $9b9e6d0f6347a978$var$Z !== b) $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$Lk(a, b);
        for(;;)try {
            $9b9e6d0f6347a978$var$Mk();
            break;
        } catch (h) {
            $9b9e6d0f6347a978$var$Nk(a, h);
        }
        $9b9e6d0f6347a978$var$Qg();
        $9b9e6d0f6347a978$var$nk.current = f;
        $9b9e6d0f6347a978$var$K = e;
        null !== $9b9e6d0f6347a978$var$Y ? b = 0 : ($9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Z = 0, b = $9b9e6d0f6347a978$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9b9e6d0f6347a978$var$xc(a), 0 !== e && (d = e, b = $9b9e6d0f6347a978$var$Ok(a, e)));
        if (1 === b) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, d), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
        if (6 === b) $9b9e6d0f6347a978$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9b9e6d0f6347a978$var$Pk(e) && (b = $9b9e6d0f6347a978$var$Jk(a, d), 2 === b && (f = $9b9e6d0f6347a978$var$xc(a), 0 !== f && (d = f, b = $9b9e6d0f6347a978$var$Ok(a, f))), 1 === b)) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, d), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9b9e6d0f6347a978$var$p(345));
                case 2:
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 3:
                    $9b9e6d0f6347a978$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $9b9e6d0f6347a978$var$gk + 500 - $9b9e6d0f6347a978$var$B(), 10 < b)) {
                        if (0 !== $9b9e6d0f6347a978$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9b9e6d0f6347a978$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9b9e6d0f6347a978$var$Ff($9b9e6d0f6347a978$var$Qk.bind(null, a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk), b);
                        break;
                    }
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 4:
                    $9b9e6d0f6347a978$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9b9e6d0f6347a978$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9b9e6d0f6347a978$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9b9e6d0f6347a978$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9b9e6d0f6347a978$var$Ff($9b9e6d0f6347a978$var$Qk.bind(null, a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk), d);
                        break;
                    }
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                case 5:
                    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
                    break;
                default:
                    throw Error($9b9e6d0f6347a978$var$p(329));
            }
        }
    }
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    return a.callbackNode === c ? $9b9e6d0f6347a978$var$Hk.bind(null, a) : null;
}
function $9b9e6d0f6347a978$var$Ok(a, b) {
    var c = $9b9e6d0f6347a978$var$tk;
    a.current.memoizedState.isDehydrated && ($9b9e6d0f6347a978$var$Lk(a, b).flags |= 256);
    a = $9b9e6d0f6347a978$var$Jk(a, b);
    2 !== a && (b = $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$uk = c, null !== b && $9b9e6d0f6347a978$var$Gj(b));
    return a;
}
function $9b9e6d0f6347a978$var$Gj(a) {
    null === $9b9e6d0f6347a978$var$uk ? $9b9e6d0f6347a978$var$uk = a : $9b9e6d0f6347a978$var$uk.push.apply($9b9e6d0f6347a978$var$uk, a);
}
function $9b9e6d0f6347a978$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9b9e6d0f6347a978$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9b9e6d0f6347a978$var$Dk(a, b) {
    b &= ~$9b9e6d0f6347a978$var$sk;
    b &= ~$9b9e6d0f6347a978$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9b9e6d0f6347a978$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9b9e6d0f6347a978$var$Fk(a) {
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    $9b9e6d0f6347a978$var$Ik();
    var b = $9b9e6d0f6347a978$var$uc(a, 0);
    if (0 === (b & 1)) return $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), null;
    var c = $9b9e6d0f6347a978$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9b9e6d0f6347a978$var$xc(a);
        0 !== d && (b = d, c = $9b9e6d0f6347a978$var$Ok(a, d));
    }
    if (1 === c) throw c = $9b9e6d0f6347a978$var$qk, $9b9e6d0f6347a978$var$Lk(a, 0), $9b9e6d0f6347a978$var$Dk(a, b), $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B()), c;
    if (6 === c) throw Error($9b9e6d0f6347a978$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9b9e6d0f6347a978$var$Qk(a, $9b9e6d0f6347a978$var$uk, $9b9e6d0f6347a978$var$vk);
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    return null;
}
function $9b9e6d0f6347a978$var$Rk(a, b) {
    var c = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9b9e6d0f6347a978$var$K = c, 0 === $9b9e6d0f6347a978$var$K && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$fg && $9b9e6d0f6347a978$var$jg());
    }
}
function $9b9e6d0f6347a978$var$Sk(a) {
    null !== $9b9e6d0f6347a978$var$xk && 0 === $9b9e6d0f6347a978$var$xk.tag && 0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$Ik();
    var b = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 1;
    var c = $9b9e6d0f6347a978$var$pk.transition, d = $9b9e6d0f6347a978$var$C;
    try {
        if ($9b9e6d0f6347a978$var$pk.transition = null, $9b9e6d0f6347a978$var$C = 1, a) return a();
    } finally{
        $9b9e6d0f6347a978$var$C = d, $9b9e6d0f6347a978$var$pk.transition = c, $9b9e6d0f6347a978$var$K = b, 0 === ($9b9e6d0f6347a978$var$K & 6) && $9b9e6d0f6347a978$var$jg();
    }
}
function $9b9e6d0f6347a978$var$Ij() {
    $9b9e6d0f6347a978$var$gj = $9b9e6d0f6347a978$var$fj.current;
    $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$fj);
}
function $9b9e6d0f6347a978$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9b9e6d0f6347a978$var$Gf(c));
    if (null !== $9b9e6d0f6347a978$var$Y) for(c = $9b9e6d0f6347a978$var$Y.return; null !== c;){
        var d = c;
        $9b9e6d0f6347a978$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9b9e6d0f6347a978$var$$f();
                break;
            case 3:
                $9b9e6d0f6347a978$var$Jh();
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$Wf);
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$H);
                $9b9e6d0f6347a978$var$Oh();
                break;
            case 5:
                $9b9e6d0f6347a978$var$Lh(d);
                break;
            case 4:
                $9b9e6d0f6347a978$var$Jh();
                break;
            case 13:
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
                break;
            case 19:
                $9b9e6d0f6347a978$var$E($9b9e6d0f6347a978$var$M);
                break;
            case 10:
                $9b9e6d0f6347a978$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $9b9e6d0f6347a978$var$Ij();
        }
        c = c.return;
    }
    $9b9e6d0f6347a978$var$R = a;
    $9b9e6d0f6347a978$var$Y = a = $9b9e6d0f6347a978$var$wh(a.current, null);
    $9b9e6d0f6347a978$var$Z = $9b9e6d0f6347a978$var$gj = b;
    $9b9e6d0f6347a978$var$T = 0;
    $9b9e6d0f6347a978$var$qk = null;
    $9b9e6d0f6347a978$var$sk = $9b9e6d0f6347a978$var$rk = $9b9e6d0f6347a978$var$hh = 0;
    $9b9e6d0f6347a978$var$uk = $9b9e6d0f6347a978$var$tk = null;
    if (null !== $9b9e6d0f6347a978$var$Wg) {
        for(b = 0; b < $9b9e6d0f6347a978$var$Wg.length; b++)if (c = $9b9e6d0f6347a978$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9b9e6d0f6347a978$var$Wg = null;
    }
    return a;
}
function $9b9e6d0f6347a978$var$Nk(a, b) {
    do {
        var c = $9b9e6d0f6347a978$var$Y;
        try {
            $9b9e6d0f6347a978$var$Qg();
            $9b9e6d0f6347a978$var$Ph.current = $9b9e6d0f6347a978$var$ai;
            if ($9b9e6d0f6347a978$var$Sh) {
                for(var d = $9b9e6d0f6347a978$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9b9e6d0f6347a978$var$Sh = !1;
            }
            $9b9e6d0f6347a978$var$Rh = 0;
            $9b9e6d0f6347a978$var$P = $9b9e6d0f6347a978$var$O = $9b9e6d0f6347a978$var$N = null;
            $9b9e6d0f6347a978$var$Th = !1;
            $9b9e6d0f6347a978$var$Uh = 0;
            $9b9e6d0f6347a978$var$ok.current = null;
            if (null === c || null === c.return) {
                $9b9e6d0f6347a978$var$T = 1;
                $9b9e6d0f6347a978$var$qk = b;
                $9b9e6d0f6347a978$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9b9e6d0f6347a978$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9b9e6d0f6347a978$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9b9e6d0f6347a978$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $9b9e6d0f6347a978$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9b9e6d0f6347a978$var$Ti(f, l, b);
                            $9b9e6d0f6347a978$var$uj();
                            break a;
                        }
                        k = Error($9b9e6d0f6347a978$var$p(426));
                    }
                } else if ($9b9e6d0f6347a978$var$I && h.mode & 1) {
                    var J = $9b9e6d0f6347a978$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9b9e6d0f6347a978$var$Wi(J, g, h, f, b);
                        $9b9e6d0f6347a978$var$Jg($9b9e6d0f6347a978$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $9b9e6d0f6347a978$var$Ki(k, h);
                4 !== $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 2);
                null === $9b9e6d0f6347a978$var$tk ? $9b9e6d0f6347a978$var$tk = [
                    f
                ] : $9b9e6d0f6347a978$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9b9e6d0f6347a978$var$Oi(f, k, b);
                            $9b9e6d0f6347a978$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9b9e6d0f6347a978$var$Si || !$9b9e6d0f6347a978$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9b9e6d0f6347a978$var$Ri(f, h, b);
                                $9b9e6d0f6347a978$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9b9e6d0f6347a978$var$Tk(c);
        } catch (na) {
            b = na;
            $9b9e6d0f6347a978$var$Y === c && null !== c && ($9b9e6d0f6347a978$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9b9e6d0f6347a978$var$Kk() {
    var a = $9b9e6d0f6347a978$var$nk.current;
    $9b9e6d0f6347a978$var$nk.current = $9b9e6d0f6347a978$var$ai;
    return null === a ? $9b9e6d0f6347a978$var$ai : a;
}
function $9b9e6d0f6347a978$var$uj() {
    if (0 === $9b9e6d0f6347a978$var$T || 3 === $9b9e6d0f6347a978$var$T || 2 === $9b9e6d0f6347a978$var$T) $9b9e6d0f6347a978$var$T = 4;
    null === $9b9e6d0f6347a978$var$R || 0 === ($9b9e6d0f6347a978$var$hh & 268435455) && 0 === ($9b9e6d0f6347a978$var$rk & 268435455) || $9b9e6d0f6347a978$var$Dk($9b9e6d0f6347a978$var$R, $9b9e6d0f6347a978$var$Z);
}
function $9b9e6d0f6347a978$var$Jk(a, b) {
    var c = $9b9e6d0f6347a978$var$K;
    $9b9e6d0f6347a978$var$K |= 2;
    var d = $9b9e6d0f6347a978$var$Kk();
    if ($9b9e6d0f6347a978$var$R !== a || $9b9e6d0f6347a978$var$Z !== b) $9b9e6d0f6347a978$var$vk = null, $9b9e6d0f6347a978$var$Lk(a, b);
    for(;;)try {
        $9b9e6d0f6347a978$var$Uk();
        break;
    } catch (e) {
        $9b9e6d0f6347a978$var$Nk(a, e);
    }
    $9b9e6d0f6347a978$var$Qg();
    $9b9e6d0f6347a978$var$K = c;
    $9b9e6d0f6347a978$var$nk.current = d;
    if (null !== $9b9e6d0f6347a978$var$Y) throw Error($9b9e6d0f6347a978$var$p(261));
    $9b9e6d0f6347a978$var$R = null;
    $9b9e6d0f6347a978$var$Z = 0;
    return $9b9e6d0f6347a978$var$T;
}
function $9b9e6d0f6347a978$var$Uk() {
    for(; null !== $9b9e6d0f6347a978$var$Y;)$9b9e6d0f6347a978$var$Vk($9b9e6d0f6347a978$var$Y);
}
function $9b9e6d0f6347a978$var$Mk() {
    for(; null !== $9b9e6d0f6347a978$var$Y && !$9b9e6d0f6347a978$var$cc();)$9b9e6d0f6347a978$var$Vk($9b9e6d0f6347a978$var$Y);
}
function $9b9e6d0f6347a978$var$Vk(a) {
    var b = $9b9e6d0f6347a978$var$Wk(a.alternate, a, $9b9e6d0f6347a978$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9b9e6d0f6347a978$var$Tk(a) : $9b9e6d0f6347a978$var$Y = b;
    $9b9e6d0f6347a978$var$ok.current = null;
}
function $9b9e6d0f6347a978$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9b9e6d0f6347a978$var$Fj(c, b, $9b9e6d0f6347a978$var$gj), null !== c) {
                $9b9e6d0f6347a978$var$Y = c;
                return;
            }
        } else {
            c = $9b9e6d0f6347a978$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9b9e6d0f6347a978$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9b9e6d0f6347a978$var$T = 6;
                $9b9e6d0f6347a978$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9b9e6d0f6347a978$var$Y = b;
            return;
        }
        $9b9e6d0f6347a978$var$Y = b = a;
    }while (null !== b);
    0 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$T = 5);
}
function $9b9e6d0f6347a978$var$Qk(a, b, c) {
    var d = $9b9e6d0f6347a978$var$C, e = $9b9e6d0f6347a978$var$pk.transition;
    try {
        $9b9e6d0f6347a978$var$pk.transition = null, $9b9e6d0f6347a978$var$C = 1, $9b9e6d0f6347a978$var$Xk(a, b, c, d);
    } finally{
        $9b9e6d0f6347a978$var$pk.transition = e, $9b9e6d0f6347a978$var$C = d;
    }
    return null;
}
function $9b9e6d0f6347a978$var$Xk(a, b, c, d) {
    do $9b9e6d0f6347a978$var$Ik();
    while (null !== $9b9e6d0f6347a978$var$xk);
    if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9b9e6d0f6347a978$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9b9e6d0f6347a978$var$Bc(a, f);
    a === $9b9e6d0f6347a978$var$R && ($9b9e6d0f6347a978$var$Y = $9b9e6d0f6347a978$var$R = null, $9b9e6d0f6347a978$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9b9e6d0f6347a978$var$wk || ($9b9e6d0f6347a978$var$wk = !0, $9b9e6d0f6347a978$var$Gk($9b9e6d0f6347a978$var$hc, function() {
        $9b9e6d0f6347a978$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9b9e6d0f6347a978$var$pk.transition;
        $9b9e6d0f6347a978$var$pk.transition = null;
        var g = $9b9e6d0f6347a978$var$C;
        $9b9e6d0f6347a978$var$C = 1;
        var h = $9b9e6d0f6347a978$var$K;
        $9b9e6d0f6347a978$var$K |= 4;
        $9b9e6d0f6347a978$var$ok.current = null;
        $9b9e6d0f6347a978$var$Pj(a, c);
        $9b9e6d0f6347a978$var$ek(c, a);
        $9b9e6d0f6347a978$var$Oe($9b9e6d0f6347a978$var$Df);
        $9b9e6d0f6347a978$var$dd = !!$9b9e6d0f6347a978$var$Cf;
        $9b9e6d0f6347a978$var$Df = $9b9e6d0f6347a978$var$Cf = null;
        a.current = c;
        $9b9e6d0f6347a978$var$ik(c, a, e);
        $9b9e6d0f6347a978$var$dc();
        $9b9e6d0f6347a978$var$K = h;
        $9b9e6d0f6347a978$var$C = g;
        $9b9e6d0f6347a978$var$pk.transition = f;
    } else a.current = c;
    $9b9e6d0f6347a978$var$wk && ($9b9e6d0f6347a978$var$wk = !1, $9b9e6d0f6347a978$var$xk = a, $9b9e6d0f6347a978$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($9b9e6d0f6347a978$var$Si = null);
    $9b9e6d0f6347a978$var$mc(c.stateNode, d);
    $9b9e6d0f6347a978$var$Ek(a, $9b9e6d0f6347a978$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9b9e6d0f6347a978$var$Pi) throw $9b9e6d0f6347a978$var$Pi = !1, a = $9b9e6d0f6347a978$var$Qi, $9b9e6d0f6347a978$var$Qi = null, a;
    0 !== ($9b9e6d0f6347a978$var$yk & 1) && 0 !== a.tag && $9b9e6d0f6347a978$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9b9e6d0f6347a978$var$Ak ? $9b9e6d0f6347a978$var$zk++ : ($9b9e6d0f6347a978$var$zk = 0, $9b9e6d0f6347a978$var$Ak = a) : $9b9e6d0f6347a978$var$zk = 0;
    $9b9e6d0f6347a978$var$jg();
    return null;
}
function $9b9e6d0f6347a978$var$Ik() {
    if (null !== $9b9e6d0f6347a978$var$xk) {
        var a = $9b9e6d0f6347a978$var$Dc($9b9e6d0f6347a978$var$yk), b = $9b9e6d0f6347a978$var$pk.transition, c = $9b9e6d0f6347a978$var$C;
        try {
            $9b9e6d0f6347a978$var$pk.transition = null;
            $9b9e6d0f6347a978$var$C = 16 > a ? 16 : a;
            if (null === $9b9e6d0f6347a978$var$xk) var d = !1;
            else {
                a = $9b9e6d0f6347a978$var$xk;
                $9b9e6d0f6347a978$var$xk = null;
                $9b9e6d0f6347a978$var$yk = 0;
                if (0 !== ($9b9e6d0f6347a978$var$K & 6)) throw Error($9b9e6d0f6347a978$var$p(331));
                var e = $9b9e6d0f6347a978$var$K;
                $9b9e6d0f6347a978$var$K |= 4;
                for($9b9e6d0f6347a978$var$V = a.current; null !== $9b9e6d0f6347a978$var$V;){
                    var f = $9b9e6d0f6347a978$var$V, g = f.child;
                    if (0 !== ($9b9e6d0f6347a978$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9b9e6d0f6347a978$var$V = l; null !== $9b9e6d0f6347a978$var$V;){
                                    var m = $9b9e6d0f6347a978$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9b9e6d0f6347a978$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9b9e6d0f6347a978$var$V = q;
                                    else for(; null !== $9b9e6d0f6347a978$var$V;){
                                        m = $9b9e6d0f6347a978$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9b9e6d0f6347a978$var$Tj(m);
                                        if (m === l) {
                                            $9b9e6d0f6347a978$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9b9e6d0f6347a978$var$V = r;
                                            break;
                                        }
                                        $9b9e6d0f6347a978$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9b9e6d0f6347a978$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9b9e6d0f6347a978$var$V = g;
                    else b: for(; null !== $9b9e6d0f6347a978$var$V;){
                        f = $9b9e6d0f6347a978$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9b9e6d0f6347a978$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9b9e6d0f6347a978$var$V = x;
                            break b;
                        }
                        $9b9e6d0f6347a978$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9b9e6d0f6347a978$var$V = w; null !== $9b9e6d0f6347a978$var$V;){
                    g = $9b9e6d0f6347a978$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9b9e6d0f6347a978$var$V = u;
                    else b: for(g = w; null !== $9b9e6d0f6347a978$var$V;){
                        h = $9b9e6d0f6347a978$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9b9e6d0f6347a978$var$Rj(9, h);
                            }
                        } catch (na) {
                            $9b9e6d0f6347a978$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9b9e6d0f6347a978$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9b9e6d0f6347a978$var$V = F;
                            break b;
                        }
                        $9b9e6d0f6347a978$var$V = h.return;
                    }
                }
                $9b9e6d0f6347a978$var$K = e;
                $9b9e6d0f6347a978$var$jg();
                if ($9b9e6d0f6347a978$var$lc && "function" === typeof $9b9e6d0f6347a978$var$lc.onPostCommitFiberRoot) try {
                    $9b9e6d0f6347a978$var$lc.onPostCommitFiberRoot($9b9e6d0f6347a978$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9b9e6d0f6347a978$var$C = c, $9b9e6d0f6347a978$var$pk.transition = b;
        }
    }
    return !1;
}
function $9b9e6d0f6347a978$var$Yk(a, b, c) {
    b = $9b9e6d0f6347a978$var$Ki(c, b);
    b = $9b9e6d0f6347a978$var$Oi(a, b, 1);
    a = $9b9e6d0f6347a978$var$dh(a, b, 1);
    b = $9b9e6d0f6347a978$var$L();
    null !== a && ($9b9e6d0f6347a978$var$Ac(a, 1, b), $9b9e6d0f6347a978$var$Ek(a, b));
}
function $9b9e6d0f6347a978$var$W(a, b, c) {
    if (3 === a.tag) $9b9e6d0f6347a978$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9b9e6d0f6347a978$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9b9e6d0f6347a978$var$Si || !$9b9e6d0f6347a978$var$Si.has(d))) {
                a = $9b9e6d0f6347a978$var$Ki(c, a);
                a = $9b9e6d0f6347a978$var$Ri(b, a, 1);
                b = $9b9e6d0f6347a978$var$dh(b, a, 1);
                a = $9b9e6d0f6347a978$var$L();
                null !== b && ($9b9e6d0f6347a978$var$Ac(b, 1, a), $9b9e6d0f6347a978$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9b9e6d0f6347a978$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9b9e6d0f6347a978$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $9b9e6d0f6347a978$var$R === a && ($9b9e6d0f6347a978$var$Z & c) === c && (4 === $9b9e6d0f6347a978$var$T || 3 === $9b9e6d0f6347a978$var$T && ($9b9e6d0f6347a978$var$Z & 130023424) === $9b9e6d0f6347a978$var$Z && 500 > $9b9e6d0f6347a978$var$B() - $9b9e6d0f6347a978$var$gk ? $9b9e6d0f6347a978$var$Lk(a, 0) : $9b9e6d0f6347a978$var$sk |= c);
    $9b9e6d0f6347a978$var$Ek(a, b);
}
function $9b9e6d0f6347a978$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9b9e6d0f6347a978$var$sc, $9b9e6d0f6347a978$var$sc <<= 1, 0 === ($9b9e6d0f6347a978$var$sc & 130023424) && ($9b9e6d0f6347a978$var$sc = 4194304)));
    var c = $9b9e6d0f6347a978$var$L();
    a = $9b9e6d0f6347a978$var$Zg(a, b);
    null !== a && ($9b9e6d0f6347a978$var$Ac(a, b, c), $9b9e6d0f6347a978$var$Ek(a, c));
}
function $9b9e6d0f6347a978$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9b9e6d0f6347a978$var$Zk(a, c);
}
function $9b9e6d0f6347a978$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9b9e6d0f6347a978$var$p(314));
    }
    null !== d && d.delete(b);
    $9b9e6d0f6347a978$var$Zk(a, c);
}
var $9b9e6d0f6347a978$var$Wk;
$9b9e6d0f6347a978$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9b9e6d0f6347a978$var$Wf.current) $9b9e6d0f6347a978$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9b9e6d0f6347a978$var$Ug = !1, $9b9e6d0f6347a978$var$zj(a, b, c);
            $9b9e6d0f6347a978$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9b9e6d0f6347a978$var$Ug = !1, $9b9e6d0f6347a978$var$I && 0 !== (b.flags & 1048576) && $9b9e6d0f6347a978$var$ug(b, $9b9e6d0f6347a978$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9b9e6d0f6347a978$var$jj(a, b);
            a = b.pendingProps;
            var e = $9b9e6d0f6347a978$var$Yf(b, $9b9e6d0f6347a978$var$H.current);
            $9b9e6d0f6347a978$var$Tg(b, c);
            e = $9b9e6d0f6347a978$var$Xh(null, b, d, a, e, c);
            var f = $9b9e6d0f6347a978$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9b9e6d0f6347a978$var$Zf(d) ? (f = !0, $9b9e6d0f6347a978$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9b9e6d0f6347a978$var$ah(b), e.updater = $9b9e6d0f6347a978$var$nh, b.stateNode = e, e._reactInternals = b, $9b9e6d0f6347a978$var$rh(b, d, a, c), b = $9b9e6d0f6347a978$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $9b9e6d0f6347a978$var$I && f && $9b9e6d0f6347a978$var$vg(b), $9b9e6d0f6347a978$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9b9e6d0f6347a978$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9b9e6d0f6347a978$var$$k(d);
                a = $9b9e6d0f6347a978$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $9b9e6d0f6347a978$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9b9e6d0f6347a978$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9b9e6d0f6347a978$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9b9e6d0f6347a978$var$aj(null, b, d, $9b9e6d0f6347a978$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($9b9e6d0f6347a978$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $9b9e6d0f6347a978$var$lj(b);
                if (null === a) throw Error($9b9e6d0f6347a978$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9b9e6d0f6347a978$var$bh(a, b);
                $9b9e6d0f6347a978$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9b9e6d0f6347a978$var$Ki(Error($9b9e6d0f6347a978$var$p(423)), b);
                        b = $9b9e6d0f6347a978$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9b9e6d0f6347a978$var$Ki(Error($9b9e6d0f6347a978$var$p(424)), b);
                        b = $9b9e6d0f6347a978$var$mj(a, b, d, c, e);
                        break a;
                    } else for($9b9e6d0f6347a978$var$yg = $9b9e6d0f6347a978$var$Lf(b.stateNode.containerInfo.firstChild), $9b9e6d0f6347a978$var$xg = b, $9b9e6d0f6347a978$var$I = !0, $9b9e6d0f6347a978$var$zg = null, c = $9b9e6d0f6347a978$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9b9e6d0f6347a978$var$Ig();
                    if (d === e) {
                        b = $9b9e6d0f6347a978$var$$i(a, b, c);
                        break a;
                    }
                    $9b9e6d0f6347a978$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9b9e6d0f6347a978$var$Kh(b), null === a && $9b9e6d0f6347a978$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9b9e6d0f6347a978$var$Ef(d, e) ? g = null : null !== f && $9b9e6d0f6347a978$var$Ef(d, f) && (b.flags |= 32), $9b9e6d0f6347a978$var$hj(a, b), $9b9e6d0f6347a978$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $9b9e6d0f6347a978$var$Eg(b), null;
        case 13:
            return $9b9e6d0f6347a978$var$pj(a, b, c);
        case 4:
            return $9b9e6d0f6347a978$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9b9e6d0f6347a978$var$Bh(b, null, d, c) : $9b9e6d0f6347a978$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$Zi(a, b, d, e, c);
        case 7:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9b9e6d0f6347a978$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9b9e6d0f6347a978$var$G($9b9e6d0f6347a978$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9b9e6d0f6347a978$var$He(f.value, g)) {
                        if (f.children === e.children && !$9b9e6d0f6347a978$var$Wf.current) {
                            b = $9b9e6d0f6347a978$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9b9e6d0f6347a978$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9b9e6d0f6347a978$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9b9e6d0f6347a978$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9b9e6d0f6347a978$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9b9e6d0f6347a978$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9b9e6d0f6347a978$var$Tg(b, c), e = $9b9e6d0f6347a978$var$Vg(e), d = d(e), b.flags |= 1, $9b9e6d0f6347a978$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9b9e6d0f6347a978$var$Lg(d, b.pendingProps), e = $9b9e6d0f6347a978$var$Lg(d.type, e), $9b9e6d0f6347a978$var$aj(a, b, d, e, c);
        case 15:
            return $9b9e6d0f6347a978$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9b9e6d0f6347a978$var$Lg(d, e), $9b9e6d0f6347a978$var$jj(a, b), b.tag = 1, $9b9e6d0f6347a978$var$Zf(d) ? (a = !0, $9b9e6d0f6347a978$var$cg(b)) : a = !1, $9b9e6d0f6347a978$var$Tg(b, c), $9b9e6d0f6347a978$var$ph(b, d, e), $9b9e6d0f6347a978$var$rh(b, d, e, c), $9b9e6d0f6347a978$var$kj(null, b, d, !0, a, c);
        case 19:
            return $9b9e6d0f6347a978$var$yj(a, b, c);
        case 22:
            return $9b9e6d0f6347a978$var$ej(a, b, c);
    }
    throw Error($9b9e6d0f6347a978$var$p(156, b.tag));
};
function $9b9e6d0f6347a978$var$Gk(a, b) {
    return $9b9e6d0f6347a978$var$ac(a, b);
}
function $9b9e6d0f6347a978$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9b9e6d0f6347a978$var$Bg(a, b, c, d) {
    return new $9b9e6d0f6347a978$var$al(a, b, c, d);
}
function $9b9e6d0f6347a978$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9b9e6d0f6347a978$var$$k(a) {
    if ("function" === typeof a) return $9b9e6d0f6347a978$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9b9e6d0f6347a978$var$Da) return 11;
        if (a === $9b9e6d0f6347a978$var$Ga) return 14;
    }
    return 2;
}
function $9b9e6d0f6347a978$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $9b9e6d0f6347a978$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9b9e6d0f6347a978$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9b9e6d0f6347a978$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9b9e6d0f6347a978$var$ya:
            return $9b9e6d0f6347a978$var$Ah(c.children, e, f, b);
        case $9b9e6d0f6347a978$var$za:
            g = 8;
            e |= 8;
            break;
        case $9b9e6d0f6347a978$var$Aa:
            return a = $9b9e6d0f6347a978$var$Bg(12, c, b, e | 2), a.elementType = $9b9e6d0f6347a978$var$Aa, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Ea:
            return a = $9b9e6d0f6347a978$var$Bg(13, c, b, e), a.elementType = $9b9e6d0f6347a978$var$Ea, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Fa:
            return a = $9b9e6d0f6347a978$var$Bg(19, c, b, e), a.elementType = $9b9e6d0f6347a978$var$Fa, a.lanes = f, a;
        case $9b9e6d0f6347a978$var$Ia:
            return $9b9e6d0f6347a978$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9b9e6d0f6347a978$var$Ba:
                    g = 10;
                    break a;
                case $9b9e6d0f6347a978$var$Ca:
                    g = 9;
                    break a;
                case $9b9e6d0f6347a978$var$Da:
                    g = 11;
                    break a;
                case $9b9e6d0f6347a978$var$Ga:
                    g = 14;
                    break a;
                case $9b9e6d0f6347a978$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9b9e6d0f6347a978$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9b9e6d0f6347a978$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9b9e6d0f6347a978$var$Ah(a, b, c, d) {
    a = $9b9e6d0f6347a978$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9b9e6d0f6347a978$var$qj(a, b, c, d) {
    a = $9b9e6d0f6347a978$var$Bg(22, a, d, b);
    a.elementType = $9b9e6d0f6347a978$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9b9e6d0f6347a978$var$xh(a, b, c) {
    a = $9b9e6d0f6347a978$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9b9e6d0f6347a978$var$zh(a, b, c) {
    b = $9b9e6d0f6347a978$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9b9e6d0f6347a978$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9b9e6d0f6347a978$var$zc(0);
    this.expirationTimes = $9b9e6d0f6347a978$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9b9e6d0f6347a978$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9b9e6d0f6347a978$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $9b9e6d0f6347a978$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9b9e6d0f6347a978$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9b9e6d0f6347a978$var$ah(f);
    return a;
}
function $9b9e6d0f6347a978$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9b9e6d0f6347a978$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9b9e6d0f6347a978$var$el(a) {
    if (!a) return $9b9e6d0f6347a978$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9b9e6d0f6347a978$var$Vb(a) !== a || 1 !== a.tag) throw Error($9b9e6d0f6347a978$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9b9e6d0f6347a978$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9b9e6d0f6347a978$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9b9e6d0f6347a978$var$Zf(c)) return $9b9e6d0f6347a978$var$bg(a, c, b);
    }
    return b;
}
function $9b9e6d0f6347a978$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $9b9e6d0f6347a978$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $9b9e6d0f6347a978$var$el(null);
    c = a.current;
    d = $9b9e6d0f6347a978$var$L();
    e = $9b9e6d0f6347a978$var$lh(c);
    f = $9b9e6d0f6347a978$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9b9e6d0f6347a978$var$dh(c, f, e);
    a.current.lanes = e;
    $9b9e6d0f6347a978$var$Ac(a, e, d);
    $9b9e6d0f6347a978$var$Ek(a, d);
    return a;
}
function $9b9e6d0f6347a978$var$gl(a, b, c, d) {
    var e = b.current, f = $9b9e6d0f6347a978$var$L(), g = $9b9e6d0f6347a978$var$lh(e);
    c = $9b9e6d0f6347a978$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9b9e6d0f6347a978$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9b9e6d0f6347a978$var$dh(e, b, g);
    null !== a && ($9b9e6d0f6347a978$var$mh(a, e, g, f), $9b9e6d0f6347a978$var$eh(a, e, g));
    return g;
}
function $9b9e6d0f6347a978$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9b9e6d0f6347a978$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9b9e6d0f6347a978$var$jl(a, b) {
    $9b9e6d0f6347a978$var$il(a, b);
    (a = a.alternate) && $9b9e6d0f6347a978$var$il(a, b);
}
function $9b9e6d0f6347a978$var$kl() {
    return null;
}
var $9b9e6d0f6347a978$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9b9e6d0f6347a978$var$ml(a) {
    this._internalRoot = a;
}
$9b9e6d0f6347a978$var$nl.prototype.render = $9b9e6d0f6347a978$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9b9e6d0f6347a978$var$p(409));
    $9b9e6d0f6347a978$var$gl(a, b, null, null);
};
$9b9e6d0f6347a978$var$nl.prototype.unmount = $9b9e6d0f6347a978$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9b9e6d0f6347a978$var$Sk(function() {
            $9b9e6d0f6347a978$var$gl(null, a, null, null);
        });
        b[$9b9e6d0f6347a978$var$uf] = null;
    }
};
function $9b9e6d0f6347a978$var$nl(a) {
    this._internalRoot = a;
}
$9b9e6d0f6347a978$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9b9e6d0f6347a978$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9b9e6d0f6347a978$var$Qc.length && 0 !== b && b < $9b9e6d0f6347a978$var$Qc[c].priority; c++);
        $9b9e6d0f6347a978$var$Qc.splice(c, 0, a);
        0 === c && $9b9e6d0f6347a978$var$Vc(a);
    }
};
function $9b9e6d0f6347a978$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9b9e6d0f6347a978$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9b9e6d0f6347a978$var$ql() {}
function $9b9e6d0f6347a978$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9b9e6d0f6347a978$var$hl(g);
                f.call(a);
            };
        }
        var g = $9b9e6d0f6347a978$var$fl(b, d, a, 0, null, !1, !1, "", $9b9e6d0f6347a978$var$ql);
        a._reactRootContainer = g;
        a[$9b9e6d0f6347a978$var$uf] = g.current;
        $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9b9e6d0f6347a978$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9b9e6d0f6347a978$var$hl(k);
            h.call(a);
        };
    }
    var k = $9b9e6d0f6347a978$var$cl(a, 0, !1, null, null, !1, !1, "", $9b9e6d0f6347a978$var$ql);
    a._reactRootContainer = k;
    a[$9b9e6d0f6347a978$var$uf] = k.current;
    $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9b9e6d0f6347a978$var$Sk(function() {
        $9b9e6d0f6347a978$var$gl(b, k, c, d);
    });
    return k;
}
function $9b9e6d0f6347a978$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9b9e6d0f6347a978$var$hl(g);
                h.call(a);
            };
        }
        $9b9e6d0f6347a978$var$gl(b, g, a, e);
    } else g = $9b9e6d0f6347a978$var$rl(c, b, a, e, d);
    return $9b9e6d0f6347a978$var$hl(g);
}
$9b9e6d0f6347a978$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9b9e6d0f6347a978$var$tc(b.pendingLanes);
                0 !== c && ($9b9e6d0f6347a978$var$Cc(b, c | 1), $9b9e6d0f6347a978$var$Ek(b, $9b9e6d0f6347a978$var$B()), 0 === ($9b9e6d0f6347a978$var$K & 6) && ($9b9e6d0f6347a978$var$Hj = $9b9e6d0f6347a978$var$B() + 500, $9b9e6d0f6347a978$var$jg()));
            }
            break;
        case 13:
            $9b9e6d0f6347a978$var$Sk(function() {
                var b = $9b9e6d0f6347a978$var$Zg(a, 1);
                if (null !== b) {
                    var c = $9b9e6d0f6347a978$var$L();
                    $9b9e6d0f6347a978$var$mh(b, a, 1, c);
                }
            }), $9b9e6d0f6347a978$var$jl(a, 1);
    }
};
$9b9e6d0f6347a978$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9b9e6d0f6347a978$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $9b9e6d0f6347a978$var$L();
            $9b9e6d0f6347a978$var$mh(b, a, 134217728, c);
        }
        $9b9e6d0f6347a978$var$jl(a, 134217728);
    }
};
$9b9e6d0f6347a978$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9b9e6d0f6347a978$var$lh(a), c = $9b9e6d0f6347a978$var$Zg(a, b);
        if (null !== c) {
            var d = $9b9e6d0f6347a978$var$L();
            $9b9e6d0f6347a978$var$mh(c, a, b, d);
        }
        $9b9e6d0f6347a978$var$jl(a, b);
    }
};
$9b9e6d0f6347a978$var$Hc = function() {
    return $9b9e6d0f6347a978$var$C;
};
$9b9e6d0f6347a978$var$Ic = function(a, b) {
    var c = $9b9e6d0f6347a978$var$C;
    try {
        return $9b9e6d0f6347a978$var$C = a, b();
    } finally{
        $9b9e6d0f6347a978$var$C = c;
    }
};
$9b9e6d0f6347a978$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9b9e6d0f6347a978$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9b9e6d0f6347a978$var$Db(d);
                        if (!e) throw Error($9b9e6d0f6347a978$var$p(90));
                        $9b9e6d0f6347a978$var$Wa(d);
                        $9b9e6d0f6347a978$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9b9e6d0f6347a978$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9b9e6d0f6347a978$var$fb(a, !!c.multiple, b, !1);
    }
};
$9b9e6d0f6347a978$var$Gb = $9b9e6d0f6347a978$var$Rk;
$9b9e6d0f6347a978$var$Hb = $9b9e6d0f6347a978$var$Sk;
var $9b9e6d0f6347a978$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $9b9e6d0f6347a978$var$Cb,
        $9b9e6d0f6347a978$var$ue,
        $9b9e6d0f6347a978$var$Db,
        $9b9e6d0f6347a978$var$Eb,
        $9b9e6d0f6347a978$var$Fb,
        $9b9e6d0f6347a978$var$Rk
    ]
}, $9b9e6d0f6347a978$var$ul = {
    findFiberByHostInstance: $9b9e6d0f6347a978$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $9b9e6d0f6347a978$var$vl = {
    bundleType: $9b9e6d0f6347a978$var$ul.bundleType,
    version: $9b9e6d0f6347a978$var$ul.version,
    rendererPackageName: $9b9e6d0f6347a978$var$ul.rendererPackageName,
    rendererConfig: $9b9e6d0f6347a978$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9b9e6d0f6347a978$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9b9e6d0f6347a978$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9b9e6d0f6347a978$var$ul.findFiberByHostInstance || $9b9e6d0f6347a978$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9b9e6d0f6347a978$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9b9e6d0f6347a978$var$wl.isDisabled && $9b9e6d0f6347a978$var$wl.supportsFiber) try {
        $9b9e6d0f6347a978$var$kc = $9b9e6d0f6347a978$var$wl.inject($9b9e6d0f6347a978$var$vl), $9b9e6d0f6347a978$var$lc = $9b9e6d0f6347a978$var$wl;
    } catch (a) {}
}
$9b9e6d0f6347a978$export$ae55be85d98224ed = $9b9e6d0f6347a978$var$tl;
$9b9e6d0f6347a978$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9b9e6d0f6347a978$var$ol(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$dl(a, b, null, c);
};
$9b9e6d0f6347a978$export$882461b6382ed46c = function(a, b) {
    if (!$9b9e6d0f6347a978$var$ol(a)) throw Error($9b9e6d0f6347a978$var$p(299));
    var c = !1, d = "", e = $9b9e6d0f6347a978$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9b9e6d0f6347a978$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$9b9e6d0f6347a978$var$uf] = b.current;
    $9b9e6d0f6347a978$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9b9e6d0f6347a978$var$ml(b);
};
$9b9e6d0f6347a978$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9b9e6d0f6347a978$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9b9e6d0f6347a978$var$p(268, a));
    }
    a = $9b9e6d0f6347a978$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9b9e6d0f6347a978$export$cd75ccfd720a3cd4 = function(a) {
    return $9b9e6d0f6347a978$var$Sk(a);
};
$9b9e6d0f6347a978$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$pl(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$sl(null, a, b, !0, c);
};
$9b9e6d0f6347a978$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$ol(a)) throw Error($9b9e6d0f6347a978$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9b9e6d0f6347a978$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9b9e6d0f6347a978$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9b9e6d0f6347a978$var$uf] = b.current;
    $9b9e6d0f6347a978$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9b9e6d0f6347a978$var$nl(b);
};
$9b9e6d0f6347a978$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9b9e6d0f6347a978$var$pl(b)) throw Error($9b9e6d0f6347a978$var$p(200));
    return $9b9e6d0f6347a978$var$sl(null, a, b, !1, c);
};
$9b9e6d0f6347a978$export$502457920280e6be = function(a) {
    if (!$9b9e6d0f6347a978$var$pl(a)) throw Error($9b9e6d0f6347a978$var$p(40));
    return a._reactRootContainer ? ($9b9e6d0f6347a978$var$Sk(function() {
        $9b9e6d0f6347a978$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9b9e6d0f6347a978$var$uf] = null;
        });
    }), !0) : !1;
};
$9b9e6d0f6347a978$export$c78a37762a8d58e1 = $9b9e6d0f6347a978$var$Rk;
$9b9e6d0f6347a978$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9b9e6d0f6347a978$var$pl(c)) throw Error($9b9e6d0f6347a978$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9b9e6d0f6347a978$var$p(38));
    return $9b9e6d0f6347a978$var$sl(a, b, c, !1, d);
};
$9b9e6d0f6347a978$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("lC4Dh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dqzhg"));

});
parcelRegister("dqzhg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9c6911696f98b24c$export$c4744153514ff05d; }, function (v) { return $9c6911696f98b24c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7; }, function (v) { return $9c6911696f98b24c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9c6911696f98b24c$export$e26fe2ed2fa76875; }, function (v) { return $9c6911696f98b24c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9c6911696f98b24c$export$502329bbf4b505b1; }, function (v) { return $9c6911696f98b24c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9c6911696f98b24c$export$6e3807111c4874c4; }, function (v) { return $9c6911696f98b24c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9c6911696f98b24c$export$c27134553091fb3a; }, function (v) { return $9c6911696f98b24c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9c6911696f98b24c$export$33ee1acdc04fd2a2; }, function (v) { return $9c6911696f98b24c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9c6911696f98b24c$export$b00a404bbd5edef2; }, function (v) { return $9c6911696f98b24c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9c6911696f98b24c$export$8352ce38b91d0c62; }, function (v) { return $9c6911696f98b24c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9c6911696f98b24c$export$d66a1c1c77bd778b; }, function (v) { return $9c6911696f98b24c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9c6911696f98b24c$export$d3dfb8e4810cb555; }, function (v) { return $9c6911696f98b24c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9c6911696f98b24c$export$839f9183b0465a69; }, function (v) { return $9c6911696f98b24c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9c6911696f98b24c$export$72fdf0e06517287b; }, function (v) { return $9c6911696f98b24c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9c6911696f98b24c$export$4b844e58a3e414b4; }, function (v) { return $9c6911696f98b24c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9c6911696f98b24c$export$816d2913ae6b83b1; }, function (v) { return $9c6911696f98b24c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9c6911696f98b24c$export$61bcfe829111a1d0; }, function (v) { return $9c6911696f98b24c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9c6911696f98b24c$export$7ee8c9beb337bc3f; }, function (v) { return $9c6911696f98b24c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9c6911696f98b24c$export$b5836b71941fa3ed; }, function (v) { return $9c6911696f98b24c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9c6911696f98b24c$export$cf845f2c119da08a; }, function (v) { return $9c6911696f98b24c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c6911696f98b24c$export$c4744153514ff05d;
var $9c6911696f98b24c$export$3e506c1ccc9cc1a7;
var $9c6911696f98b24c$export$e26fe2ed2fa76875;
var $9c6911696f98b24c$export$502329bbf4b505b1;
var $9c6911696f98b24c$export$6e3807111c4874c4;
var $9c6911696f98b24c$export$c27134553091fb3a;
var $9c6911696f98b24c$export$33ee1acdc04fd2a2;
var $9c6911696f98b24c$export$b00a404bbd5edef2;
var $9c6911696f98b24c$export$8352ce38b91d0c62;
var $9c6911696f98b24c$export$d66a1c1c77bd778b;
var $9c6911696f98b24c$export$d3dfb8e4810cb555;
var $9c6911696f98b24c$export$839f9183b0465a69;
var $9c6911696f98b24c$export$72fdf0e06517287b;
var $9c6911696f98b24c$export$4b844e58a3e414b4;
var $9c6911696f98b24c$export$816d2913ae6b83b1;
var $9c6911696f98b24c$export$61bcfe829111a1d0;
var $9c6911696f98b24c$export$7ee8c9beb337bc3f;
var $9c6911696f98b24c$export$b5836b71941fa3ed;
var $9c6911696f98b24c$export$cf845f2c119da08a;
'use strict';
function $9c6911696f98b24c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9c6911696f98b24c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9c6911696f98b24c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9c6911696f98b24c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9c6911696f98b24c$var$g(C, c)) n < e && 0 > $9c6911696f98b24c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9c6911696f98b24c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9c6911696f98b24c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9c6911696f98b24c$var$l = performance;
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$l.now();
    };
} else {
    var $9c6911696f98b24c$var$p = Date, $9c6911696f98b24c$var$q = $9c6911696f98b24c$var$p.now();
    $9c6911696f98b24c$export$c4744153514ff05d = function() {
        return $9c6911696f98b24c$var$p.now() - $9c6911696f98b24c$var$q;
    };
}
var $9c6911696f98b24c$var$r = [], $9c6911696f98b24c$var$t = [], $9c6911696f98b24c$var$u = 1, $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = 3, $9c6911696f98b24c$var$z = !1, $9c6911696f98b24c$var$A = !1, $9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$D = "function" === typeof setTimeout ? setTimeout : null, $9c6911696f98b24c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9c6911696f98b24c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9c6911696f98b24c$var$G(a) {
    for(var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t); null !== b;){
        if (null === b.callback) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t);
        else if (b.startTime <= a) $9c6911696f98b24c$var$k($9c6911696f98b24c$var$t), b.sortIndex = b.expirationTime, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, b);
        else break;
        b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
    }
}
function $9c6911696f98b24c$var$H(a) {
    $9c6911696f98b24c$var$B = !1;
    $9c6911696f98b24c$var$G(a);
    if (!$9c6911696f98b24c$var$A) {
        if (null !== $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r)) $9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J);
        else {
            var b = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== b && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, b.startTime - a);
        }
    }
}
function $9c6911696f98b24c$var$J(a, b) {
    $9c6911696f98b24c$var$A = !1;
    $9c6911696f98b24c$var$B && ($9c6911696f98b24c$var$B = !1, $9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1);
    $9c6911696f98b24c$var$z = !0;
    var c = $9c6911696f98b24c$var$y;
    try {
        $9c6911696f98b24c$var$G(b);
        for($9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r); null !== $9c6911696f98b24c$var$v && (!($9c6911696f98b24c$var$v.expirationTime > b) || a && !$9c6911696f98b24c$var$M());){
            var d = $9c6911696f98b24c$var$v.callback;
            if ("function" === typeof d) {
                $9c6911696f98b24c$var$v.callback = null;
                $9c6911696f98b24c$var$y = $9c6911696f98b24c$var$v.priorityLevel;
                var e = d($9c6911696f98b24c$var$v.expirationTime <= b);
                b = $9c6911696f98b24c$export$c4744153514ff05d();
                "function" === typeof e ? $9c6911696f98b24c$var$v.callback = e : $9c6911696f98b24c$var$v === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
                $9c6911696f98b24c$var$G(b);
            } else $9c6911696f98b24c$var$k($9c6911696f98b24c$var$r);
            $9c6911696f98b24c$var$v = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
        }
        if (null !== $9c6911696f98b24c$var$v) var w = !0;
        else {
            var m = $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t);
            null !== m && $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9c6911696f98b24c$var$v = null, $9c6911696f98b24c$var$y = c, $9c6911696f98b24c$var$z = !1;
    }
}
var $9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null, $9c6911696f98b24c$var$L = -1, $9c6911696f98b24c$var$P = 5, $9c6911696f98b24c$var$Q = -1;
function $9c6911696f98b24c$var$M() {
    return $9c6911696f98b24c$export$c4744153514ff05d() - $9c6911696f98b24c$var$Q < $9c6911696f98b24c$var$P ? !1 : !0;
}
function $9c6911696f98b24c$var$R() {
    if (null !== $9c6911696f98b24c$var$O) {
        var a = $9c6911696f98b24c$export$c4744153514ff05d();
        $9c6911696f98b24c$var$Q = a;
        var b = !0;
        try {
            b = $9c6911696f98b24c$var$O(!0, a);
        } finally{
            b ? $9c6911696f98b24c$var$S() : ($9c6911696f98b24c$var$N = !1, $9c6911696f98b24c$var$O = null);
        }
    } else $9c6911696f98b24c$var$N = !1;
}
var $9c6911696f98b24c$var$S;
if ("function" === typeof $9c6911696f98b24c$var$F) $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$F($9c6911696f98b24c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9c6911696f98b24c$var$T = new MessageChannel, $9c6911696f98b24c$var$U = $9c6911696f98b24c$var$T.port2;
    $9c6911696f98b24c$var$T.port1.onmessage = $9c6911696f98b24c$var$R;
    $9c6911696f98b24c$var$S = function() {
        $9c6911696f98b24c$var$U.postMessage(null);
    };
} else $9c6911696f98b24c$var$S = function() {
    $9c6911696f98b24c$var$D($9c6911696f98b24c$var$R, 0);
};
function $9c6911696f98b24c$var$I(a) {
    $9c6911696f98b24c$var$O = a;
    $9c6911696f98b24c$var$N || ($9c6911696f98b24c$var$N = !0, $9c6911696f98b24c$var$S());
}
function $9c6911696f98b24c$var$K(a, b) {
    $9c6911696f98b24c$var$L = $9c6911696f98b24c$var$D(function() {
        a($9c6911696f98b24c$export$c4744153514ff05d());
    }, b);
}
$9c6911696f98b24c$export$3e506c1ccc9cc1a7 = 5;
$9c6911696f98b24c$export$e26fe2ed2fa76875 = 1;
$9c6911696f98b24c$export$502329bbf4b505b1 = 4;
$9c6911696f98b24c$export$6e3807111c4874c4 = 3;
$9c6911696f98b24c$export$c27134553091fb3a = null;
$9c6911696f98b24c$export$33ee1acdc04fd2a2 = 2;
$9c6911696f98b24c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9c6911696f98b24c$export$8352ce38b91d0c62 = function() {
    $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J));
};
$9c6911696f98b24c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9c6911696f98b24c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9c6911696f98b24c$export$d3dfb8e4810cb555 = function() {
    return $9c6911696f98b24c$var$y;
};
$9c6911696f98b24c$export$839f9183b0465a69 = function() {
    return $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r);
};
$9c6911696f98b24c$export$72fdf0e06517287b = function(a) {
    switch($9c6911696f98b24c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9c6911696f98b24c$var$y;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = b;
    try {
        return a();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$4b844e58a3e414b4 = function() {};
$9c6911696f98b24c$export$816d2913ae6b83b1 = function() {};
$9c6911696f98b24c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9c6911696f98b24c$var$y;
    $9c6911696f98b24c$var$y = a;
    try {
        return b();
    } finally{
        $9c6911696f98b24c$var$y = c;
    }
};
$9c6911696f98b24c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9c6911696f98b24c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9c6911696f98b24c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$t, a), null === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$r) && a === $9c6911696f98b24c$var$h($9c6911696f98b24c$var$t) && ($9c6911696f98b24c$var$B ? ($9c6911696f98b24c$var$E($9c6911696f98b24c$var$L), $9c6911696f98b24c$var$L = -1) : $9c6911696f98b24c$var$B = !0, $9c6911696f98b24c$var$K($9c6911696f98b24c$var$H, c - d))) : (a.sortIndex = e, $9c6911696f98b24c$var$f($9c6911696f98b24c$var$r, a), $9c6911696f98b24c$var$A || $9c6911696f98b24c$var$z || ($9c6911696f98b24c$var$A = !0, $9c6911696f98b24c$var$I($9c6911696f98b24c$var$J)));
    return a;
};
$9c6911696f98b24c$export$b5836b71941fa3ed = $9c6911696f98b24c$var$M;
$9c6911696f98b24c$export$cf845f2c119da08a = function(a) {
    var b = $9c6911696f98b24c$var$y;
    return function() {
        var c = $9c6911696f98b24c$var$y;
        $9c6911696f98b24c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9c6911696f98b24c$var$y = c;
        }
    };
};

});




parcelRegister("fgQ0V", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eqWSa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $djlMn = parcelRequire("djlMn");
var $02b63657f85a6045$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $02b63657f85a6045$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$02b63657f85a6045$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($02b63657f85a6045$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($02b63657f85a6045$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($02b63657f85a6045$var$isNull(x) || !$02b63657f85a6045$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $02b63657f85a6045$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $djlMn !== 'undefined' && $djlMn.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $djlMn === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($djlMn.throwDeprecation) throw new Error(msg);
            else if ($djlMn.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $02b63657f85a6045$var$debugs = {};
var $02b63657f85a6045$var$debugEnvRegex = /^$/;
var $02b63657f85a6045$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$02b63657f85a6045$var$debugs[set]) {
        if ($02b63657f85a6045$var$debugEnvRegex.test(set)) {
            var pid = $djlMn.pid;
            $02b63657f85a6045$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $02b63657f85a6045$var$debugs[set] = function() {};
    }
    return $02b63657f85a6045$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $02b63657f85a6045$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $02b63657f85a6045$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($02b63657f85a6045$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($02b63657f85a6045$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($02b63657f85a6045$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($02b63657f85a6045$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($02b63657f85a6045$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $02b63657f85a6045$var$stylizeWithColor;
    return $02b63657f85a6045$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $02b63657f85a6045$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$02b63657f85a6045$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$02b63657f85a6045$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $02b63657f85a6045$var$stylizeWithColor(str, styleType) {
    var style = $02b63657f85a6045$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $02b63657f85a6045$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $02b63657f85a6045$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $02b63657f85a6045$var$stylizeNoColor(str, styleType) {
    return str;
}
function $02b63657f85a6045$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $02b63657f85a6045$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $02b63657f85a6045$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$02b63657f85a6045$var$isString(ret)) ret = $02b63657f85a6045$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $02b63657f85a6045$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $02b63657f85a6045$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($02b63657f85a6045$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $02b63657f85a6045$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($02b63657f85a6045$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($02b63657f85a6045$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($02b63657f85a6045$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($02b63657f85a6045$var$isError(value)) return $02b63657f85a6045$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($02b63657f85a6045$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($02b63657f85a6045$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($02b63657f85a6045$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($02b63657f85a6045$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($02b63657f85a6045$var$isError(value)) base = ' ' + $02b63657f85a6045$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($02b63657f85a6045$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $02b63657f85a6045$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $02b63657f85a6045$var$reduceToSingleString(output, base, braces);
}
function $02b63657f85a6045$var$formatPrimitive(ctx, value) {
    if ($02b63657f85a6045$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($02b63657f85a6045$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($02b63657f85a6045$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($02b63657f85a6045$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($02b63657f85a6045$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $02b63657f85a6045$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $02b63657f85a6045$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($02b63657f85a6045$var$hasOwnProperty(value, String(i))) output.push($02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $02b63657f85a6045$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$02b63657f85a6045$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($02b63657f85a6045$var$isNull(recurseTimes)) str = $02b63657f85a6045$var$formatValue(ctx, desc.value, null);
            else str = $02b63657f85a6045$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($02b63657f85a6045$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $02b63657f85a6045$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3alvF"));
function $02b63657f85a6045$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $02b63657f85a6045$var$isArray;
function $02b63657f85a6045$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $02b63657f85a6045$var$isBoolean;
function $02b63657f85a6045$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $02b63657f85a6045$var$isNull;
function $02b63657f85a6045$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $02b63657f85a6045$var$isNullOrUndefined;
function $02b63657f85a6045$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $02b63657f85a6045$var$isNumber;
function $02b63657f85a6045$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $02b63657f85a6045$var$isString;
function $02b63657f85a6045$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $02b63657f85a6045$var$isSymbol;
function $02b63657f85a6045$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $02b63657f85a6045$var$isUndefined;
function $02b63657f85a6045$var$isRegExp(re) {
    return $02b63657f85a6045$var$isObject(re) && $02b63657f85a6045$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $02b63657f85a6045$var$isRegExp;
module.exports.types.isRegExp = $02b63657f85a6045$var$isRegExp;
function $02b63657f85a6045$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $02b63657f85a6045$var$isObject;
function $02b63657f85a6045$var$isDate(d) {
    return $02b63657f85a6045$var$isObject(d) && $02b63657f85a6045$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $02b63657f85a6045$var$isDate;
module.exports.types.isDate = $02b63657f85a6045$var$isDate;
function $02b63657f85a6045$var$isError(e) {
    return $02b63657f85a6045$var$isObject(e) && ($02b63657f85a6045$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $02b63657f85a6045$var$isError;
module.exports.types.isNativeError = $02b63657f85a6045$var$isError;
function $02b63657f85a6045$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $02b63657f85a6045$var$isFunction;
function $02b63657f85a6045$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $02b63657f85a6045$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("04s3C"));
function $02b63657f85a6045$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $02b63657f85a6045$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $02b63657f85a6045$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $02b63657f85a6045$var$timestamp() {
    var d = new Date();
    var time = [
        $02b63657f85a6045$var$pad(d.getHours()),
        $02b63657f85a6045$var$pad(d.getMinutes()),
        $02b63657f85a6045$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $02b63657f85a6045$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $02b63657f85a6045$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("lBpnk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$02b63657f85a6045$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $02b63657f85a6045$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $02b63657f85a6045$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($02b63657f85a6045$var$kCustomPromisifiedSymbol && original[$02b63657f85a6045$var$kCustomPromisifiedSymbol]) {
        var fn = original[$02b63657f85a6045$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $02b63657f85a6045$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($02b63657f85a6045$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $02b63657f85a6045$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $02b63657f85a6045$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $02b63657f85a6045$var$kCustomPromisifiedSymbol;
function $02b63657f85a6045$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $02b63657f85a6045$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $djlMn.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $djlMn.nextTick($02b63657f85a6045$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $02b63657f85a6045$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $02b63657f85a6045$var$callbackify;

});
parcelRegister("djlMn", function(module, exports) {
// shim for using process in browser
var $9b0df1a1bca55960$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $9b0df1a1bca55960$var$cachedSetTimeout;
var $9b0df1a1bca55960$var$cachedClearTimeout;
function $9b0df1a1bca55960$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $9b0df1a1bca55960$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $9b0df1a1bca55960$var$cachedSetTimeout = setTimeout;
        else $9b0df1a1bca55960$var$cachedSetTimeout = $9b0df1a1bca55960$var$defaultSetTimout;
    } catch (e) {
        $9b0df1a1bca55960$var$cachedSetTimeout = $9b0df1a1bca55960$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $9b0df1a1bca55960$var$cachedClearTimeout = clearTimeout;
        else $9b0df1a1bca55960$var$cachedClearTimeout = $9b0df1a1bca55960$var$defaultClearTimeout;
    } catch (e) {
        $9b0df1a1bca55960$var$cachedClearTimeout = $9b0df1a1bca55960$var$defaultClearTimeout;
    }
})();
function $9b0df1a1bca55960$var$runTimeout(fun) {
    if ($9b0df1a1bca55960$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($9b0df1a1bca55960$var$cachedSetTimeout === $9b0df1a1bca55960$var$defaultSetTimout || !$9b0df1a1bca55960$var$cachedSetTimeout) && setTimeout) {
        $9b0df1a1bca55960$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9b0df1a1bca55960$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $9b0df1a1bca55960$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $9b0df1a1bca55960$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $9b0df1a1bca55960$var$runClearTimeout(marker) {
    if ($9b0df1a1bca55960$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($9b0df1a1bca55960$var$cachedClearTimeout === $9b0df1a1bca55960$var$defaultClearTimeout || !$9b0df1a1bca55960$var$cachedClearTimeout) && clearTimeout) {
        $9b0df1a1bca55960$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $9b0df1a1bca55960$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $9b0df1a1bca55960$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $9b0df1a1bca55960$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $9b0df1a1bca55960$var$queue = [];
var $9b0df1a1bca55960$var$draining = false;
var $9b0df1a1bca55960$var$currentQueue;
var $9b0df1a1bca55960$var$queueIndex = -1;
function $9b0df1a1bca55960$var$cleanUpNextTick() {
    if (!$9b0df1a1bca55960$var$draining || !$9b0df1a1bca55960$var$currentQueue) return;
    $9b0df1a1bca55960$var$draining = false;
    if ($9b0df1a1bca55960$var$currentQueue.length) $9b0df1a1bca55960$var$queue = $9b0df1a1bca55960$var$currentQueue.concat($9b0df1a1bca55960$var$queue);
    else $9b0df1a1bca55960$var$queueIndex = -1;
    if ($9b0df1a1bca55960$var$queue.length) $9b0df1a1bca55960$var$drainQueue();
}
function $9b0df1a1bca55960$var$drainQueue() {
    if ($9b0df1a1bca55960$var$draining) return;
    var timeout = $9b0df1a1bca55960$var$runTimeout($9b0df1a1bca55960$var$cleanUpNextTick);
    $9b0df1a1bca55960$var$draining = true;
    var len = $9b0df1a1bca55960$var$queue.length;
    while(len){
        $9b0df1a1bca55960$var$currentQueue = $9b0df1a1bca55960$var$queue;
        $9b0df1a1bca55960$var$queue = [];
        while(++$9b0df1a1bca55960$var$queueIndex < len)if ($9b0df1a1bca55960$var$currentQueue) $9b0df1a1bca55960$var$currentQueue[$9b0df1a1bca55960$var$queueIndex].run();
        $9b0df1a1bca55960$var$queueIndex = -1;
        len = $9b0df1a1bca55960$var$queue.length;
    }
    $9b0df1a1bca55960$var$currentQueue = null;
    $9b0df1a1bca55960$var$draining = false;
    $9b0df1a1bca55960$var$runClearTimeout(timeout);
}
$9b0df1a1bca55960$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $9b0df1a1bca55960$var$queue.push(new $9b0df1a1bca55960$var$Item(fun, args));
    if ($9b0df1a1bca55960$var$queue.length === 1 && !$9b0df1a1bca55960$var$draining) $9b0df1a1bca55960$var$runTimeout($9b0df1a1bca55960$var$drainQueue);
};
// v8 likes predictible objects
function $9b0df1a1bca55960$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$9b0df1a1bca55960$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$9b0df1a1bca55960$var$process.title = 'browser';
$9b0df1a1bca55960$var$process.browser = true;
$9b0df1a1bca55960$var$process.env = {};
$9b0df1a1bca55960$var$process.argv = [];
$9b0df1a1bca55960$var$process.version = ''; // empty string to avoid regexp issues
$9b0df1a1bca55960$var$process.versions = {};
function $9b0df1a1bca55960$var$noop() {}
$9b0df1a1bca55960$var$process.on = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.addListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.once = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.off = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.removeListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.removeAllListeners = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.emit = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.prependListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.prependOnceListener = $9b0df1a1bca55960$var$noop;
$9b0df1a1bca55960$var$process.listeners = function(name) {
    return [];
};
$9b0df1a1bca55960$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$9b0df1a1bca55960$var$process.cwd = function() {
    return '/';
};
$9b0df1a1bca55960$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$9b0df1a1bca55960$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3alvF", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $dJCHm = parcelRequire("dJCHm");

var $jbZMF = parcelRequire("jbZMF");

var $bQ74u = parcelRequire("bQ74u");

var $d1mGn = parcelRequire("d1mGn");
function $24e2fdae4f4e3bf6$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $24e2fdae4f4e3bf6$var$BigIntSupported = typeof BigInt !== 'undefined';
var $24e2fdae4f4e3bf6$var$SymbolSupported = typeof Symbol !== 'undefined';
var $24e2fdae4f4e3bf6$var$ObjectToString = $24e2fdae4f4e3bf6$var$uncurryThis(Object.prototype.toString);
var $24e2fdae4f4e3bf6$var$numberValue = $24e2fdae4f4e3bf6$var$uncurryThis(Number.prototype.valueOf);
var $24e2fdae4f4e3bf6$var$stringValue = $24e2fdae4f4e3bf6$var$uncurryThis(String.prototype.valueOf);
var $24e2fdae4f4e3bf6$var$booleanValue = $24e2fdae4f4e3bf6$var$uncurryThis(Boolean.prototype.valueOf);
if ($24e2fdae4f4e3bf6$var$BigIntSupported) var $24e2fdae4f4e3bf6$var$bigIntValue = $24e2fdae4f4e3bf6$var$uncurryThis(BigInt.prototype.valueOf);
if ($24e2fdae4f4e3bf6$var$SymbolSupported) var $24e2fdae4f4e3bf6$var$symbolValue = $24e2fdae4f4e3bf6$var$uncurryThis(Symbol.prototype.valueOf);
function $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $dJCHm;
module.exports.isGeneratorFunction = $jbZMF;
module.exports.isTypedArray = $d1mGn;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $24e2fdae4f4e3bf6$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $24e2fdae4f4e3bf6$var$isPromise;
function $24e2fdae4f4e3bf6$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $d1mGn(value) || $24e2fdae4f4e3bf6$var$isDataView(value);
}
module.exports.isArrayBufferView = $24e2fdae4f4e3bf6$var$isArrayBufferView;
function $24e2fdae4f4e3bf6$var$isUint8Array(value) {
    return $bQ74u(value) === 'Uint8Array';
}
module.exports.isUint8Array = $24e2fdae4f4e3bf6$var$isUint8Array;
function $24e2fdae4f4e3bf6$var$isUint8ClampedArray(value) {
    return $bQ74u(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $24e2fdae4f4e3bf6$var$isUint8ClampedArray;
function $24e2fdae4f4e3bf6$var$isUint16Array(value) {
    return $bQ74u(value) === 'Uint16Array';
}
module.exports.isUint16Array = $24e2fdae4f4e3bf6$var$isUint16Array;
function $24e2fdae4f4e3bf6$var$isUint32Array(value) {
    return $bQ74u(value) === 'Uint32Array';
}
module.exports.isUint32Array = $24e2fdae4f4e3bf6$var$isUint32Array;
function $24e2fdae4f4e3bf6$var$isInt8Array(value) {
    return $bQ74u(value) === 'Int8Array';
}
module.exports.isInt8Array = $24e2fdae4f4e3bf6$var$isInt8Array;
function $24e2fdae4f4e3bf6$var$isInt16Array(value) {
    return $bQ74u(value) === 'Int16Array';
}
module.exports.isInt16Array = $24e2fdae4f4e3bf6$var$isInt16Array;
function $24e2fdae4f4e3bf6$var$isInt32Array(value) {
    return $bQ74u(value) === 'Int32Array';
}
module.exports.isInt32Array = $24e2fdae4f4e3bf6$var$isInt32Array;
function $24e2fdae4f4e3bf6$var$isFloat32Array(value) {
    return $bQ74u(value) === 'Float32Array';
}
module.exports.isFloat32Array = $24e2fdae4f4e3bf6$var$isFloat32Array;
function $24e2fdae4f4e3bf6$var$isFloat64Array(value) {
    return $bQ74u(value) === 'Float64Array';
}
module.exports.isFloat64Array = $24e2fdae4f4e3bf6$var$isFloat64Array;
function $24e2fdae4f4e3bf6$var$isBigInt64Array(value) {
    return $bQ74u(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $24e2fdae4f4e3bf6$var$isBigInt64Array;
function $24e2fdae4f4e3bf6$var$isBigUint64Array(value) {
    return $bQ74u(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $24e2fdae4f4e3bf6$var$isBigUint64Array;
function $24e2fdae4f4e3bf6$var$isMapToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Map]';
}
$24e2fdae4f4e3bf6$var$isMapToString.working = typeof Map !== 'undefined' && $24e2fdae4f4e3bf6$var$isMapToString(new Map());
function $24e2fdae4f4e3bf6$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isMapToString.working ? $24e2fdae4f4e3bf6$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $24e2fdae4f4e3bf6$var$isMap;
function $24e2fdae4f4e3bf6$var$isSetToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Set]';
}
$24e2fdae4f4e3bf6$var$isSetToString.working = typeof Set !== 'undefined' && $24e2fdae4f4e3bf6$var$isSetToString(new Set());
function $24e2fdae4f4e3bf6$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isSetToString.working ? $24e2fdae4f4e3bf6$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $24e2fdae4f4e3bf6$var$isSet;
function $24e2fdae4f4e3bf6$var$isWeakMapToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WeakMap]';
}
$24e2fdae4f4e3bf6$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $24e2fdae4f4e3bf6$var$isWeakMapToString(new WeakMap());
function $24e2fdae4f4e3bf6$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isWeakMapToString.working ? $24e2fdae4f4e3bf6$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $24e2fdae4f4e3bf6$var$isWeakMap;
function $24e2fdae4f4e3bf6$var$isWeakSetToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WeakSet]';
}
$24e2fdae4f4e3bf6$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $24e2fdae4f4e3bf6$var$isWeakSetToString(new WeakSet());
function $24e2fdae4f4e3bf6$var$isWeakSet(value) {
    return $24e2fdae4f4e3bf6$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $24e2fdae4f4e3bf6$var$isWeakSet;
function $24e2fdae4f4e3bf6$var$isArrayBufferToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$24e2fdae4f4e3bf6$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $24e2fdae4f4e3bf6$var$isArrayBufferToString(new ArrayBuffer());
function $24e2fdae4f4e3bf6$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isArrayBufferToString.working ? $24e2fdae4f4e3bf6$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $24e2fdae4f4e3bf6$var$isArrayBuffer;
function $24e2fdae4f4e3bf6$var$isDataViewToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object DataView]';
}
$24e2fdae4f4e3bf6$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $24e2fdae4f4e3bf6$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $24e2fdae4f4e3bf6$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $24e2fdae4f4e3bf6$var$isDataViewToString.working ? $24e2fdae4f4e3bf6$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $24e2fdae4f4e3bf6$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $24e2fdae4f4e3bf6$var$isSharedArrayBuffer(value) {
    if (typeof $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working === 'undefined') $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working = $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(new $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy());
    return $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString.working ? $24e2fdae4f4e3bf6$var$isSharedArrayBufferToString(value) : value instanceof $24e2fdae4f4e3bf6$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $24e2fdae4f4e3bf6$var$isSharedArrayBuffer;
function $24e2fdae4f4e3bf6$var$isAsyncFunction(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $24e2fdae4f4e3bf6$var$isAsyncFunction;
function $24e2fdae4f4e3bf6$var$isMapIterator(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $24e2fdae4f4e3bf6$var$isMapIterator;
function $24e2fdae4f4e3bf6$var$isSetIterator(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $24e2fdae4f4e3bf6$var$isSetIterator;
function $24e2fdae4f4e3bf6$var$isGeneratorObject(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $24e2fdae4f4e3bf6$var$isGeneratorObject;
function $24e2fdae4f4e3bf6$var$isWebAssemblyCompiledModule(value) {
    return $24e2fdae4f4e3bf6$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $24e2fdae4f4e3bf6$var$isWebAssemblyCompiledModule;
function $24e2fdae4f4e3bf6$var$isNumberObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$numberValue);
}
module.exports.isNumberObject = $24e2fdae4f4e3bf6$var$isNumberObject;
function $24e2fdae4f4e3bf6$var$isStringObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$stringValue);
}
module.exports.isStringObject = $24e2fdae4f4e3bf6$var$isStringObject;
function $24e2fdae4f4e3bf6$var$isBooleanObject(value) {
    return $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$booleanValue);
}
module.exports.isBooleanObject = $24e2fdae4f4e3bf6$var$isBooleanObject;
function $24e2fdae4f4e3bf6$var$isBigIntObject(value) {
    return $24e2fdae4f4e3bf6$var$BigIntSupported && $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$bigIntValue);
}
module.exports.isBigIntObject = $24e2fdae4f4e3bf6$var$isBigIntObject;
function $24e2fdae4f4e3bf6$var$isSymbolObject(value) {
    return $24e2fdae4f4e3bf6$var$SymbolSupported && $24e2fdae4f4e3bf6$var$checkBoxedPrimitive(value, $24e2fdae4f4e3bf6$var$symbolValue);
}
module.exports.isSymbolObject = $24e2fdae4f4e3bf6$var$isSymbolObject;
function $24e2fdae4f4e3bf6$var$isBoxedPrimitive(value) {
    return $24e2fdae4f4e3bf6$var$isNumberObject(value) || $24e2fdae4f4e3bf6$var$isStringObject(value) || $24e2fdae4f4e3bf6$var$isBooleanObject(value) || $24e2fdae4f4e3bf6$var$isBigIntObject(value) || $24e2fdae4f4e3bf6$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $24e2fdae4f4e3bf6$var$isBoxedPrimitive;
function $24e2fdae4f4e3bf6$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($24e2fdae4f4e3bf6$var$isArrayBuffer(value) || $24e2fdae4f4e3bf6$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $24e2fdae4f4e3bf6$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("dJCHm", function(module, exports) {
'use strict';

var $9ffd7f00e9f601d7$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $9krxM = parcelRequire("9krxM");
var $9ffd7f00e9f601d7$var$$toString = $9krxM('Object.prototype.toString');
/** @type {import('.')} */ var $9ffd7f00e9f601d7$var$isStandardArguments = function isArguments(value) {
    if ($9ffd7f00e9f601d7$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $9ffd7f00e9f601d7$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $9ffd7f00e9f601d7$var$isLegacyArguments = function isArguments(value) {
    if ($9ffd7f00e9f601d7$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $9ffd7f00e9f601d7$var$$toString(value) !== '[object Array]' && 'callee' in value && $9ffd7f00e9f601d7$var$$toString(value.callee) === '[object Function]';
};
var $9ffd7f00e9f601d7$var$supportsStandardArguments = function() {
    return $9ffd7f00e9f601d7$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$9ffd7f00e9f601d7$var$isStandardArguments.isLegacyArguments = $9ffd7f00e9f601d7$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $9ffd7f00e9f601d7$var$supportsStandardArguments ? $9ffd7f00e9f601d7$var$isStandardArguments : $9ffd7f00e9f601d7$var$isLegacyArguments;

});
parcelRegister("iK7BP", function(module, exports) {
'use strict';

var $1TyHV = parcelRequire("1TyHV");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $1TyHV() && !!Symbol.toStringTag;
};

});
parcelRegister("1TyHV", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("9krxM", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $56ErU = parcelRequire("56ErU");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $6cab58ed9df2c438$var$$indexOf = $56ErU([
    $fZZOm('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $fZZOm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $6cab58ed9df2c438$var$$indexOf(name, '.prototype.') > -1) return $56ErU(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("fZZOm", function(module, exports) {
'use strict';
var $ba5c7fefb7eb6d38$var$undefined1;

var $irzZH = parcelRequire("irzZH");

var $b3OOB = parcelRequire("b3OOB");

var $f7H97 = parcelRequire("f7H97");

var $lkkeD = parcelRequire("lkkeD");

var $70nKc = parcelRequire("70nKc");

var $kAjA9 = parcelRequire("kAjA9");

var $eVc55 = parcelRequire("eVc55");

var $bgnWJ = parcelRequire("bgnWJ");

var $lGBPc = parcelRequire("lGBPc");

var $iXUzx = parcelRequire("iXUzx");

var $b0H3C = parcelRequire("b0H3C");

var $a9u1S = parcelRequire("a9u1S");

var $iBld1 = parcelRequire("iBld1");

var $1yRPh = parcelRequire("1yRPh");

var $a0Nga = parcelRequire("a0Nga");
var $ba5c7fefb7eb6d38$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $ba5c7fefb7eb6d38$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $ba5c7fefb7eb6d38$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $59bfT = parcelRequire("59bfT");

var $91w2b = parcelRequire("91w2b");
var $ba5c7fefb7eb6d38$var$throwTypeError = function() {
    throw new $eVc55();
};
var $ba5c7fefb7eb6d38$var$ThrowTypeError = $59bfT ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $ba5c7fefb7eb6d38$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $59bfT(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $ba5c7fefb7eb6d38$var$throwTypeError;
        }
    }
}() : $ba5c7fefb7eb6d38$var$throwTypeError;

var $ba5c7fefb7eb6d38$var$hasSymbols = (parcelRequire("lm6s4"))();

var $llhfI = parcelRequire("llhfI");

var $gB04n = parcelRequire("gB04n");

var $5I8jg = parcelRequire("5I8jg");

var $jcSia = parcelRequire("jcSia");

var $iKVNo = parcelRequire("iKVNo");
var $ba5c7fefb7eb6d38$var$needsEval = {};
var $ba5c7fefb7eb6d38$var$TypedArray = typeof Uint8Array === 'undefined' || !$llhfI ? undefined : $llhfI(Uint8Array);
var $ba5c7fefb7eb6d38$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncGenerator%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncGeneratorFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%AsyncIteratorPrototype%': $ba5c7fefb7eb6d38$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $b3OOB,
    '%eval%': eval,
    '%EvalError%': $f7H97,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $ba5c7fefb7eb6d38$var$$Function,
    '%GeneratorFunction%': $ba5c7fefb7eb6d38$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI($llhfI([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$ba5c7fefb7eb6d38$var$hasSymbols || !$llhfI ? undefined : $llhfI(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $irzZH,
    '%Object.getOwnPropertyDescriptor%': $59bfT,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $lkkeD,
    '%ReferenceError%': $70nKc,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$ba5c7fefb7eb6d38$var$hasSymbols || !$llhfI ? undefined : $llhfI(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $ba5c7fefb7eb6d38$var$hasSymbols && $llhfI ? $llhfI(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $ba5c7fefb7eb6d38$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $kAjA9,
    '%ThrowTypeError%': $ba5c7fefb7eb6d38$var$ThrowTypeError,
    '%TypedArray%': $ba5c7fefb7eb6d38$var$TypedArray,
    '%TypeError%': $eVc55,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $bgnWJ,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $iKVNo,
    '%Function.prototype.apply%': $jcSia,
    '%Object.defineProperty%': $91w2b,
    '%Object.getPrototypeOf%': $gB04n,
    '%Math.abs%': $lGBPc,
    '%Math.floor%': $iXUzx,
    '%Math.max%': $b0H3C,
    '%Math.min%': $a9u1S,
    '%Math.pow%': $iBld1,
    '%Math.round%': $1yRPh,
    '%Math.sign%': $a0Nga,
    '%Reflect.getPrototypeOf%': $5I8jg
};
if ($llhfI) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $ba5c7fefb7eb6d38$var$errorProto = $llhfI($llhfI(e));
    $ba5c7fefb7eb6d38$var$INTRINSICS['%Error.prototype%'] = $ba5c7fefb7eb6d38$var$errorProto;
}
var $ba5c7fefb7eb6d38$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $ba5c7fefb7eb6d38$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $llhfI) value = $llhfI(gen.prototype);
    }
    $ba5c7fefb7eb6d38$var$INTRINSICS[name] = value;
    return value;
};
var $ba5c7fefb7eb6d38$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $cX4h3 = parcelRequire("cX4h3");

var $5AOah = parcelRequire("5AOah");
var $ba5c7fefb7eb6d38$var$$concat = $cX4h3.call($iKVNo, Array.prototype.concat);
var $ba5c7fefb7eb6d38$var$$spliceApply = $cX4h3.call($jcSia, Array.prototype.splice);
var $ba5c7fefb7eb6d38$var$$replace = $cX4h3.call($iKVNo, String.prototype.replace);
var $ba5c7fefb7eb6d38$var$$strSlice = $cX4h3.call($iKVNo, String.prototype.slice);
var $ba5c7fefb7eb6d38$var$$exec = $cX4h3.call($iKVNo, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $ba5c7fefb7eb6d38$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $ba5c7fefb7eb6d38$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $ba5c7fefb7eb6d38$var$stringToPath = function stringToPath(string) {
    var first = $ba5c7fefb7eb6d38$var$$strSlice(string, 0, 1);
    var last = $ba5c7fefb7eb6d38$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $kAjA9('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $kAjA9('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $ba5c7fefb7eb6d38$var$$replace(string, $ba5c7fefb7eb6d38$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $ba5c7fefb7eb6d38$var$$replace(subString, $ba5c7fefb7eb6d38$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $ba5c7fefb7eb6d38$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($5AOah($ba5c7fefb7eb6d38$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $ba5c7fefb7eb6d38$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($5AOah($ba5c7fefb7eb6d38$var$INTRINSICS, intrinsicName)) {
        var value = $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicName];
        if (value === $ba5c7fefb7eb6d38$var$needsEval) value = $ba5c7fefb7eb6d38$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eVc55('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $kAjA9('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eVc55('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eVc55('"allowMissing" argument must be a boolean');
    if ($ba5c7fefb7eb6d38$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $kAjA9('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $ba5c7fefb7eb6d38$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $ba5c7fefb7eb6d38$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $ba5c7fefb7eb6d38$var$$spliceApply(parts, $ba5c7fefb7eb6d38$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $ba5c7fefb7eb6d38$var$$strSlice(part, 0, 1);
        var last = $ba5c7fefb7eb6d38$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $kAjA9('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($5AOah($ba5c7fefb7eb6d38$var$INTRINSICS, intrinsicRealName)) value = $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eVc55('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($59bfT && i + 1 >= parts.length) {
                var desc = $59bfT(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $5AOah(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $ba5c7fefb7eb6d38$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("irzZH", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("b3OOB", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("f7H97", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("lkkeD", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("70nKc", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("kAjA9", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eVc55", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("bgnWJ", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lGBPc", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iXUzx", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("b0H3C", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("a9u1S", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("iBld1", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1yRPh", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("a0Nga", function(module, exports) {
'use strict';

var $e2QHU = parcelRequire("e2QHU");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($e2QHU(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("e2QHU", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("59bfT", function(module, exports) {
'use strict';

var $fHr4p = parcelRequire("fHr4p");
var $3bf686143fef81b6$require$$gOPD = $fHr4p;
if ($3bf686143fef81b6$require$$gOPD) try {
    $3bf686143fef81b6$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $3bf686143fef81b6$require$$gOPD = null;
}
module.exports = $3bf686143fef81b6$require$$gOPD;

});
parcelRegister("fHr4p", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("91w2b", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $691d0e5f67c57bad$var$$defineProperty = Object.defineProperty || false;
if ($691d0e5f67c57bad$var$$defineProperty) try {
    $691d0e5f67c57bad$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $691d0e5f67c57bad$var$$defineProperty = false;
}
module.exports = $691d0e5f67c57bad$var$$defineProperty;

});

parcelRegister("lm6s4", function(module, exports) {
'use strict';
var $f8c0a841901e2379$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $1TyHV = parcelRequire("1TyHV");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $f8c0a841901e2379$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $f8c0a841901e2379$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $1TyHV();
};

});

parcelRegister("llhfI", function(module, exports) {
'use strict';

var $5I8jg = parcelRequire("5I8jg");

var $gB04n = parcelRequire("gB04n");

var $4rbRz = parcelRequire("4rbRz");
/** @type {import('.')} */ module.exports = $5I8jg ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5I8jg(O);
} : $gB04n ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gB04n(O);
} : $4rbRz ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4rbRz(O);
} : null;

});
parcelRegister("5I8jg", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("gB04n", function(module, exports) {
'use strict';

var $irzZH = parcelRequire("irzZH");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $irzZH.getPrototypeOf || null;

});

parcelRegister("4rbRz", function(module, exports) {
'use strict';

var $56ErU = parcelRequire("56ErU");

var $59bfT = parcelRequire("59bfT");
var $33b2e2d05c543836$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $33b2e2d05c543836$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $33b2e2d05c543836$var$desc = !!$33b2e2d05c543836$var$hasProtoAccessor && $59bfT && $59bfT(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $33b2e2d05c543836$var$$Object = Object;
var $33b2e2d05c543836$var$$getPrototypeOf = $33b2e2d05c543836$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $33b2e2d05c543836$var$desc && typeof $33b2e2d05c543836$var$desc.get === 'function' ? $56ErU([
    $33b2e2d05c543836$var$desc.get
]) : typeof $33b2e2d05c543836$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $33b2e2d05c543836$var$$getPrototypeOf(value == null ? value : $33b2e2d05c543836$var$$Object(value));
} : false;

});
parcelRegister("56ErU", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $eVc55 = parcelRequire("eVc55");

var $iKVNo = parcelRequire("iKVNo");

var $hCCEd = parcelRequire("hCCEd");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eVc55('a function is required');
    return $hCCEd($cX4h3, $iKVNo, args);
};

});
parcelRegister("cX4h3", function(module, exports) {
'use strict';

var $fgaD7 = parcelRequire("fgaD7");
module.exports = Function.prototype.bind || $fgaD7;

});
parcelRegister("fgaD7", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $b1c0988399c7cbc0$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $b1c0988399c7cbc0$var$toStr = Object.prototype.toString;
var $b1c0988399c7cbc0$var$max = Math.max;
var $b1c0988399c7cbc0$var$funcType = '[object Function]';
var $b1c0988399c7cbc0$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $b1c0988399c7cbc0$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $b1c0988399c7cbc0$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $b1c0988399c7cbc0$var$toStr.apply(target) !== $b1c0988399c7cbc0$var$funcType) throw new TypeError($b1c0988399c7cbc0$var$ERROR_MESSAGE + target);
    var args = $b1c0988399c7cbc0$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $b1c0988399c7cbc0$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $b1c0988399c7cbc0$var$concatty(args, arguments));
    };
    var boundLength = $b1c0988399c7cbc0$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $b1c0988399c7cbc0$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("iKVNo", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("hCCEd", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $jcSia = parcelRequire("jcSia");

var $iKVNo = parcelRequire("iKVNo");

var $fyEu2 = parcelRequire("fyEu2");
/** @type {import('./actualApply')} */ module.exports = $fyEu2 || $cX4h3.call($iKVNo, $jcSia);

});
parcelRegister("jcSia", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fyEu2", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("5AOah", function(module, exports) {
'use strict';
var $41273a3f227f6eab$var$call = Function.prototype.call;
var $41273a3f227f6eab$var$$hasOwn = Object.prototype.hasOwnProperty;

var $cX4h3 = parcelRequire("cX4h3");
/** @type {import('.')} */ module.exports = $cX4h3.call($41273a3f227f6eab$var$call, $41273a3f227f6eab$var$$hasOwn);

});




parcelRegister("jbZMF", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $fErBy = parcelRequire("fErBy");
var $df8ef86a4f1c27fb$var$isFnRegex = $fErBy(/^\s*(?:function)?\*/);

var $df8ef86a4f1c27fb$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $llhfI = parcelRequire("llhfI");
var $df8ef86a4f1c27fb$var$toStr = $9krxM('Object.prototype.toString');
var $df8ef86a4f1c27fb$var$fnToStr = $9krxM('Function.prototype.toString');
var $df8ef86a4f1c27fb$var$getGeneratorFunc = function() {
    if (!$df8ef86a4f1c27fb$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var $df8ef86a4f1c27fb$var$GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($df8ef86a4f1c27fb$var$isFnRegex($df8ef86a4f1c27fb$var$fnToStr(fn))) return true;
    if (!$df8ef86a4f1c27fb$var$hasToStringTag) {
        var str = $df8ef86a4f1c27fb$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$llhfI) return false;
    if (typeof $df8ef86a4f1c27fb$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $df8ef86a4f1c27fb$var$getGeneratorFunc();
        $df8ef86a4f1c27fb$var$GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ $llhfI(generatorFunc) : false;
    }
    return $llhfI(fn) === $df8ef86a4f1c27fb$var$GeneratorFunction;
};

});
parcelRegister("fErBy", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $7GGSN = parcelRequire("7GGSN");
var $b6500127dff14772$var$$exec = $9krxM('RegExp.prototype.exec');

var $eVc55 = parcelRequire("eVc55");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$7GGSN(regex)) throw new $eVc55('`regex` must be a RegExp');
    return function test(s) {
        return $b6500127dff14772$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("7GGSN", function(module, exports) {
'use strict';

var $9krxM = parcelRequire("9krxM");

var $598db84e0e836efe$var$hasToStringTag = (parcelRequire("iK7BP"))();

var $5AOah = parcelRequire("5AOah");

var $59bfT = parcelRequire("59bfT");
/** @type {import('.')} */ var $598db84e0e836efe$var$fn;
if ($598db84e0e836efe$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $598db84e0e836efe$var$$exec = $9krxM('RegExp.prototype.exec');
    /** @type {object} */ var $598db84e0e836efe$var$isRegexMarker = {};
    var $598db84e0e836efe$var$throwRegexMarker = function() {
        throw $598db84e0e836efe$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $598db84e0e836efe$var$badStringifier = {
        toString: $598db84e0e836efe$var$throwRegexMarker,
        valueOf: $598db84e0e836efe$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $598db84e0e836efe$var$badStringifier[Symbol.toPrimitive] = $598db84e0e836efe$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $598db84e0e836efe$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $59bfT(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $5AOah(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $598db84e0e836efe$var$$exec(value, /** @type {unknown} */ $598db84e0e836efe$var$badStringifier);
        } catch (e) {
            return e === $598db84e0e836efe$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $598db84e0e836efe$var$$toString = $9krxM('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $598db84e0e836efe$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $598db84e0e836efe$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $598db84e0e836efe$var$$toString(value) === $598db84e0e836efe$var$regexClass;
    };
}
module.exports = $598db84e0e836efe$var$fn;

});



parcelRegister("bQ74u", function(module, exports) {
'use strict';

var $kT3R2 = parcelRequire("kT3R2");

var $1AU46 = parcelRequire("1AU46");

var $aebgU = parcelRequire("aebgU");

var $9krxM = parcelRequire("9krxM");

var $59bfT = parcelRequire("59bfT");

var $llhfI = parcelRequire("llhfI");
var $89ea0949ef56368a$var$$toString = $9krxM('Object.prototype.toString');

var $89ea0949ef56368a$var$hasToStringTag = (parcelRequire("iK7BP"))();
var $89ea0949ef56368a$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $89ea0949ef56368a$var$typedArrays = $1AU46();
var $89ea0949ef56368a$var$$slice = $9krxM('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $89ea0949ef56368a$var$$indexOf = $9krxM('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $89ea0949ef56368a$var$cache = {
    __proto__: null
};
if ($89ea0949ef56368a$var$hasToStringTag && $59bfT && $llhfI) $kT3R2($89ea0949ef56368a$var$typedArrays, function(typedArray) {
    var arr = new $89ea0949ef56368a$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $llhfI) {
        var proto = $llhfI(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $59bfT(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $llhfI(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $59bfT(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $89ea0949ef56368a$var$cache['$' + typedArray] = $aebgU(descriptor.get);
    }
});
else $kT3R2($89ea0949ef56368a$var$typedArrays, function(typedArray) {
    var arr = new $89ea0949ef56368a$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $89ea0949ef56368a$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $aebgU(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $89ea0949ef56368a$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $kT3R2(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $89ea0949ef56368a$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $89ea0949ef56368a$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $89ea0949ef56368a$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $kT3R2(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $89ea0949ef56368a$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $89ea0949ef56368a$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$89ea0949ef56368a$var$hasToStringTag) {
        /** @type {string} */ var tag = $89ea0949ef56368a$var$$slice($89ea0949ef56368a$var$$toString(value), 8, -1);
        if ($89ea0949ef56368a$var$$indexOf($89ea0949ef56368a$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $89ea0949ef56368a$var$trySlices(value);
    }
    if (!$59bfT) return null;
     // unknown engine
    return $89ea0949ef56368a$var$tryTypedArrays(value);
};

});
parcelRegister("kT3R2", function(module, exports) {
'use strict';

var $km88V = parcelRequire("km88V");
var $f34bef1ad0f2b173$var$toStr = Object.prototype.toString;
var $f34bef1ad0f2b173$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($f34bef1ad0f2b173$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $f34bef1ad0f2b173$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($f34bef1ad0f2b173$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $f34bef1ad0f2b173$var$isArray(x) {
    return $f34bef1ad0f2b173$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$km88V(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($f34bef1ad0f2b173$var$isArray(list)) $f34bef1ad0f2b173$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $f34bef1ad0f2b173$var$forEachString(list, iterator, receiver);
    else $f34bef1ad0f2b173$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("km88V", function(module, exports) {
'use strict';
var $ed1c2dc487bf6312$var$fnToStr = Function.prototype.toString;
var $ed1c2dc487bf6312$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $ed1c2dc487bf6312$var$badArrayLike;
var $ed1c2dc487bf6312$var$isCallableMarker;
if (typeof $ed1c2dc487bf6312$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $ed1c2dc487bf6312$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $ed1c2dc487bf6312$var$isCallableMarker;
        }
    });
    $ed1c2dc487bf6312$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $ed1c2dc487bf6312$var$reflectApply(function() {
        throw 42;
    }, null, $ed1c2dc487bf6312$var$badArrayLike);
} catch (_) {
    if (_ !== $ed1c2dc487bf6312$var$isCallableMarker) $ed1c2dc487bf6312$var$reflectApply = null;
}
else $ed1c2dc487bf6312$var$reflectApply = null;
var $ed1c2dc487bf6312$var$constructorRegex = /^\s*class\b/;
var $ed1c2dc487bf6312$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $ed1c2dc487bf6312$var$fnToStr.call(value);
        return $ed1c2dc487bf6312$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $ed1c2dc487bf6312$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($ed1c2dc487bf6312$var$isES6ClassFn(value)) return false;
        $ed1c2dc487bf6312$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ed1c2dc487bf6312$var$toStr = Object.prototype.toString;
var $ed1c2dc487bf6312$var$objectClass = '[object Object]';
var $ed1c2dc487bf6312$var$fnClass = '[object Function]';
var $ed1c2dc487bf6312$var$genClass = '[object GeneratorFunction]';
var $ed1c2dc487bf6312$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $ed1c2dc487bf6312$var$ddaClass2 = '[object HTML document.all class]';
var $ed1c2dc487bf6312$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $ed1c2dc487bf6312$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $ed1c2dc487bf6312$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $ed1c2dc487bf6312$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $ed1c2dc487bf6312$var$all = document.all;
    if ($ed1c2dc487bf6312$var$toStr.call($ed1c2dc487bf6312$var$all) === $ed1c2dc487bf6312$var$toStr.call(document.all)) $ed1c2dc487bf6312$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($ed1c2dc487bf6312$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $ed1c2dc487bf6312$var$toStr.call(value);
            return (str === $ed1c2dc487bf6312$var$ddaClass || str === $ed1c2dc487bf6312$var$ddaClass2 || str === $ed1c2dc487bf6312$var$ddaClass3 // opera 12.16
             || str === $ed1c2dc487bf6312$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $ed1c2dc487bf6312$var$reflectApply ? function isCallable(value) {
    if ($ed1c2dc487bf6312$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $ed1c2dc487bf6312$var$reflectApply(value, null, $ed1c2dc487bf6312$var$badArrayLike);
    } catch (e) {
        if (e !== $ed1c2dc487bf6312$var$isCallableMarker) return false;
    }
    return !$ed1c2dc487bf6312$var$isES6ClassFn(value) && $ed1c2dc487bf6312$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($ed1c2dc487bf6312$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($ed1c2dc487bf6312$var$hasToStringTag) return $ed1c2dc487bf6312$var$tryFunctionObject(value);
    if ($ed1c2dc487bf6312$var$isES6ClassFn(value)) return false;
    var strClass = $ed1c2dc487bf6312$var$toStr.call(value);
    if (strClass !== $ed1c2dc487bf6312$var$fnClass && strClass !== $ed1c2dc487bf6312$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $ed1c2dc487bf6312$var$tryFunctionObject(value);
};

});


parcelRegister("1AU46", function(module, exports) {
'use strict';

var $aOIri = parcelRequire("aOIri");
var $1294a49f681f964c$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $aOIri.length; i++)if (typeof $1294a49f681f964c$var$g[$aOIri[i]] === 'function') // @ts-expect-error
    out[out.length] = $aOIri[i];
    return out;
};

});
parcelRegister("aOIri", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("aebgU", function(module, exports) {
'use strict';

var $ec05t = parcelRequire("ec05t");

var $91w2b = parcelRequire("91w2b");

var $56ErU = parcelRequire("56ErU");

var $kdhtO = parcelRequire("kdhtO");
module.exports = function callBind(originalFunction) {
    var func = $56ErU(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $ec05t(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($91w2b) $91w2b(module.exports, 'apply', {
    value: $kdhtO
});
else module.exports.apply = $kdhtO;

});
parcelRegister("ec05t", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $2rrwJ = parcelRequire("2rrwJ");

var $a5524104db679972$var$hasDescriptors = (parcelRequire("dkM7t"))();

var $59bfT = parcelRequire("59bfT");

var $eVc55 = parcelRequire("eVc55");
var $a5524104db679972$var$$floor = $fZZOm('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eVc55('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $a5524104db679972$var$$floor(length) !== length) throw new $eVc55('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $59bfT) {
        var desc = $59bfT(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($a5524104db679972$var$hasDescriptors) $2rrwJ(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $2rrwJ(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("2rrwJ", function(module, exports) {
'use strict';

var $91w2b = parcelRequire("91w2b");

var $kAjA9 = parcelRequire("kAjA9");

var $eVc55 = parcelRequire("eVc55");

var $59bfT = parcelRequire("59bfT");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eVc55('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eVc55('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eVc55('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eVc55('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eVc55('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eVc55('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$59bfT && $59bfT(obj, property);
    if ($91w2b) $91w2b(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $kAjA9('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("dkM7t", function(module, exports) {
'use strict';

var $91w2b = parcelRequire("91w2b");
var $9b527828e9608f86$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$91w2b;
};
$9b527828e9608f86$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$91w2b) return null;
    try {
        return $91w2b([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $9b527828e9608f86$var$hasPropertyDescriptors;

});


parcelRegister("kdhtO", function(module, exports) {
'use strict';

var $cX4h3 = parcelRequire("cX4h3");

var $jcSia = parcelRequire("jcSia");

var $hCCEd = parcelRequire("hCCEd");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $hCCEd($cX4h3, $jcSia, arguments);
};

});



parcelRegister("d1mGn", function(module, exports) {
'use strict';

var $bQ74u = parcelRequire("bQ74u");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$bQ74u(value);
};

});


parcelRegister("04s3C", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("lBpnk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("gpaur", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $djlMn = parcelRequire("djlMn");
'use strict';
function $bf171e426cf417d8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bf171e426cf417d8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bf171e426cf417d8$var$_typeof(o);
}
function $bf171e426cf417d8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $bf171e426cf417d8$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $bf171e426cf417d8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf171e426cf417d8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf171e426cf417d8$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $bf171e426cf417d8$var$_toPropertyKey(arg) {
    var key = $bf171e426cf417d8$var$_toPrimitive(arg, "string");
    return $bf171e426cf417d8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bf171e426cf417d8$var$_toPrimitive(input, hint) {
    if ($bf171e426cf417d8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bf171e426cf417d8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bf171e426cf417d8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $84ZjD = parcelRequire("84ZjD");
var $bf171e426cf417d8$var$_require$codes = $84ZjD.codes, $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT = $bf171e426cf417d8$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_ARG_TYPE, $bf171e426cf417d8$var$ERR_INVALID_ARG_VALUE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_ARG_VALUE, $bf171e426cf417d8$var$ERR_INVALID_RETURN_VALUE = $bf171e426cf417d8$var$_require$codes.ERR_INVALID_RETURN_VALUE, $bf171e426cf417d8$var$ERR_MISSING_ARGS = $bf171e426cf417d8$var$_require$codes.ERR_MISSING_ARGS;

var $bZlr9 = parcelRequire("bZlr9");

var $eqWSa = parcelRequire("eqWSa");
var $bf171e426cf417d8$var$inspect = $eqWSa.inspect;

var $eqWSa = parcelRequire("eqWSa");
var $bf171e426cf417d8$require$_require$types = $eqWSa.types;
var $bf171e426cf417d8$var$isPromise = $bf171e426cf417d8$require$_require$types.isPromise, $bf171e426cf417d8$var$isRegExp = $bf171e426cf417d8$require$_require$types.isRegExp;

var $bf171e426cf417d8$var$objectAssign = (parcelRequire("lp0oE"))();

var $bf171e426cf417d8$var$objectIs = (parcelRequire("eoHrM"))();

var $bf171e426cf417d8$var$RegExpPrototypeTest = (parcelRequire("34Xrk"))('RegExp.prototype.test');
var $bf171e426cf417d8$var$errorCache = new Map();
var $bf171e426cf417d8$var$isDeepEqual;
var $bf171e426cf417d8$var$isDeepStrictEqual;
var $bf171e426cf417d8$var$parseExpressionAt;
var $bf171e426cf417d8$var$findNodeAround;
var $bf171e426cf417d8$var$decoder;

function $bf171e426cf417d8$var$lazyLoadComparison() {
    var comparison = (parcelRequire("cPQKq"));
    $bf171e426cf417d8$var$isDeepEqual = comparison.isDeepEqual;
    $bf171e426cf417d8$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $bf171e426cf417d8$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $bf171e426cf417d8$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $bf171e426cf417d8$var$escapeFn = function escapeFn(str) {
    return $bf171e426cf417d8$var$meta[str.charCodeAt(0)];
};
var $bf171e426cf417d8$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $bf171e426cf417d8$var$assert = module.exports = $bf171e426cf417d8$var$ok;
var $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $bf171e426cf417d8$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $bZlr9(obj);
}
function $bf171e426cf417d8$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($bf171e426cf417d8$var$warned === false) {
            $bf171e426cf417d8$var$warned = true;
            var warn = $djlMn.emitWarning ? $djlMn.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $bf171e426cf417d8$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $bZlr9(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$bf171e426cf417d8$var$assert.fail = $bf171e426cf417d8$var$fail;
// The AssertionError is defined in internal/error.
$bf171e426cf417d8$var$assert.AssertionError = $bZlr9;
function $bf171e426cf417d8$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $bZlr9({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $bf171e426cf417d8$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $bf171e426cf417d8$var$innerOk.apply(void 0, [
        $bf171e426cf417d8$var$ok,
        args.length
    ].concat(args));
}
$bf171e426cf417d8$var$assert.ok = $bf171e426cf417d8$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $bf171e426cf417d8$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$bf171e426cf417d8$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$bf171e426cf417d8$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if (!$bf171e426cf417d8$var$isDeepEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$bf171e426cf417d8$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if ($bf171e426cf417d8$var$isDeepEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $bf171e426cf417d8$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if (!$bf171e426cf417d8$var$isDeepStrictEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$bf171e426cf417d8$var$assert.notDeepStrictEqual = $bf171e426cf417d8$var$notDeepStrictEqual;
function $bf171e426cf417d8$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
    if ($bf171e426cf417d8$var$isDeepStrictEqual(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $bf171e426cf417d8$var$notDeepStrictEqual
    });
}
$bf171e426cf417d8$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$bf171e426cf417d8$var$objectIs(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$bf171e426cf417d8$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $bf171e426cf417d8$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($bf171e426cf417d8$var$objectIs(actual, expected)) $bf171e426cf417d8$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $bf171e426cf417d8$var$Comparison = /*#__PURE__*/ $bf171e426cf417d8$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $bf171e426cf417d8$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $bf171e426cf417d8$var$isRegExp(obj[key]) && $bf171e426cf417d8$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $bf171e426cf417d8$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$bf171e426cf417d8$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $bf171e426cf417d8$var$Comparison(actual, keys);
            var b = new $bf171e426cf417d8$var$Comparison(expected, keys, actual);
            var err = new $bZlr9({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $bf171e426cf417d8$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $bf171e426cf417d8$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($bf171e426cf417d8$var$isRegExp(expected)) return $bf171e426cf417d8$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($bf171e426cf417d8$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $bZlr9({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($bf171e426cf417d8$var$isDeepEqual === undefined) $bf171e426cf417d8$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $bf171e426cf417d8$var$isRegExp(expected[key]) && $bf171e426cf417d8$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $bf171e426cf417d8$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $bf171e426cf417d8$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL;
}
function $bf171e426cf417d8$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $bf171e426cf417d8$var$isPromise(obj) || obj !== null && $bf171e426cf417d8$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $bf171e426cf417d8$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$bf171e426cf417d8$var$checkIsPromise(resultPromise)) throw new $bf171e426cf417d8$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($bf171e426cf417d8$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $bf171e426cf417d8$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($bf171e426cf417d8$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $bf171e426cf417d8$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $bf171e426cf417d8$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $bf171e426cf417d8$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$bf171e426cf417d8$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $bf171e426cf417d8$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $bf171e426cf417d8$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $bf171e426cf417d8$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $bf171e426cf417d8$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$bf171e426cf417d8$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $bf171e426cf417d8$var$expectsError.apply(void 0, [
        throws,
        $bf171e426cf417d8$var$getActual(promiseFn)
    ].concat(args));
};
$bf171e426cf417d8$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $bf171e426cf417d8$var$waitForActual(promiseFn).then(function(result) {
        return $bf171e426cf417d8$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$bf171e426cf417d8$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $bf171e426cf417d8$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $bf171e426cf417d8$var$getActual(fn)
    ].concat(args));
};
$bf171e426cf417d8$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $bf171e426cf417d8$var$waitForActual(fn).then(function(result) {
        return $bf171e426cf417d8$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$bf171e426cf417d8$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($bf171e426cf417d8$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $bf171e426cf417d8$var$inspect(err);
        var newErr = new $bZlr9({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $bf171e426cf417d8$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$bf171e426cf417d8$var$isRegExp(regexp)) throw new $bf171e426cf417d8$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $bf171e426cf417d8$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($bf171e426cf417d8$var$_typeof(string), " (").concat($bf171e426cf417d8$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($bf171e426cf417d8$var$inspect(regexp), ". Input:\n\n").concat($bf171e426cf417d8$var$inspect(string), "\n"));
        var err = new $bZlr9({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$bf171e426cf417d8$var$assert.match = function match(string, regexp, message) {
    $bf171e426cf417d8$var$internalMatch(string, regexp, message, match, 'match');
};
$bf171e426cf417d8$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $bf171e426cf417d8$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $bf171e426cf417d8$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $bf171e426cf417d8$var$innerOk.apply(void 0, [
        $bf171e426cf417d8$var$strict,
        args.length
    ].concat(args));
}
$bf171e426cf417d8$var$assert.strict = $bf171e426cf417d8$var$objectAssign($bf171e426cf417d8$var$strict, $bf171e426cf417d8$var$assert, {
    equal: $bf171e426cf417d8$var$assert.strictEqual,
    deepEqual: $bf171e426cf417d8$var$assert.deepStrictEqual,
    notEqual: $bf171e426cf417d8$var$assert.notStrictEqual,
    notDeepEqual: $bf171e426cf417d8$var$assert.notDeepStrictEqual
});
$bf171e426cf417d8$var$assert.strict.strict = $bf171e426cf417d8$var$assert.strict;

});
parcelRegister("84ZjD", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $5e1e427abaa94f3a$export$e45cb6485273080e; }, function (v) { return $5e1e427abaa94f3a$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $5e1e427abaa94f3a$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $5e1e427abaa94f3a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5e1e427abaa94f3a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e1e427abaa94f3a$var$_typeof(o);
}
function $5e1e427abaa94f3a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5e1e427abaa94f3a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5e1e427abaa94f3a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5e1e427abaa94f3a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5e1e427abaa94f3a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5e1e427abaa94f3a$var$_toPropertyKey(arg) {
    var key = $5e1e427abaa94f3a$var$_toPrimitive(arg, "string");
    return $5e1e427abaa94f3a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5e1e427abaa94f3a$var$_toPrimitive(input, hint) {
    if ($5e1e427abaa94f3a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5e1e427abaa94f3a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5e1e427abaa94f3a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5e1e427abaa94f3a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5e1e427abaa94f3a$var$_setPrototypeOf(subClass, superClass);
}
function $5e1e427abaa94f3a$var$_setPrototypeOf(o, p) {
    $5e1e427abaa94f3a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5e1e427abaa94f3a$var$_setPrototypeOf(o, p);
}
function $5e1e427abaa94f3a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5e1e427abaa94f3a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5e1e427abaa94f3a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5e1e427abaa94f3a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5e1e427abaa94f3a$var$_possibleConstructorReturn(this, result);
    };
}
function $5e1e427abaa94f3a$var$_possibleConstructorReturn(self, call) {
    if (call && ($5e1e427abaa94f3a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5e1e427abaa94f3a$var$_assertThisInitialized(self);
}
function $5e1e427abaa94f3a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5e1e427abaa94f3a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5e1e427abaa94f3a$var$_getPrototypeOf(o) {
    $5e1e427abaa94f3a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5e1e427abaa94f3a$var$_getPrototypeOf(o);
}
var $5e1e427abaa94f3a$var$codes = {};
// Lazy loaded
var $5e1e427abaa94f3a$var$assert;
var $5e1e427abaa94f3a$var$util;
function $5e1e427abaa94f3a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $5e1e427abaa94f3a$var$_inherits(NodeError, _Base);
        var _super = $5e1e427abaa94f3a$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $5e1e427abaa94f3a$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $5e1e427abaa94f3a$var$_createClass(NodeError);
    }(Base);
    $5e1e427abaa94f3a$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $5e1e427abaa94f3a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $5e1e427abaa94f3a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $5e1e427abaa94f3a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $5e1e427abaa94f3a$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$5e1e427abaa94f3a$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($5e1e427abaa94f3a$var$assert === undefined) $5e1e427abaa94f3a$var$assert = (parcelRequire("gpaur"));
    $5e1e427abaa94f3a$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $5e1e427abaa94f3a$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($5e1e427abaa94f3a$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($5e1e427abaa94f3a$var$oneOf(expected, 'type'));
    else {
        var type = $5e1e427abaa94f3a$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($5e1e427abaa94f3a$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($5e1e427abaa94f3a$var$_typeof(actual));
    return msg;
}, TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($5e1e427abaa94f3a$var$util === undefined) $5e1e427abaa94f3a$var$util = (parcelRequire("eqWSa"));
    var inspected = $5e1e427abaa94f3a$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$5e1e427abaa94f3a$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($5e1e427abaa94f3a$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$5e1e427abaa94f3a$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($5e1e427abaa94f3a$var$assert === undefined) $5e1e427abaa94f3a$var$assert = (parcelRequire("gpaur"));
    $5e1e427abaa94f3a$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$5e1e427abaa94f3a$export$e45cb6485273080e = $5e1e427abaa94f3a$var$codes;

});

parcelRegister("bZlr9", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $djlMn = parcelRequire("djlMn");
'use strict';
function $8ba60529e2f61891$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ba60529e2f61891$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ba60529e2f61891$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8ba60529e2f61891$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ba60529e2f61891$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8ba60529e2f61891$var$_defineProperty(obj, key, value) {
    key = $8ba60529e2f61891$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8ba60529e2f61891$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ba60529e2f61891$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8ba60529e2f61891$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8ba60529e2f61891$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8ba60529e2f61891$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8ba60529e2f61891$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8ba60529e2f61891$var$_toPropertyKey(arg) {
    var key = $8ba60529e2f61891$var$_toPrimitive(arg, "string");
    return $8ba60529e2f61891$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8ba60529e2f61891$var$_toPrimitive(input, hint) {
    if ($8ba60529e2f61891$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8ba60529e2f61891$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8ba60529e2f61891$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8ba60529e2f61891$var$_setPrototypeOf(subClass, superClass);
}
function $8ba60529e2f61891$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ba60529e2f61891$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8ba60529e2f61891$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8ba60529e2f61891$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8ba60529e2f61891$var$_possibleConstructorReturn(this, result);
    };
}
function $8ba60529e2f61891$var$_possibleConstructorReturn(self, call) {
    if (call && ($8ba60529e2f61891$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8ba60529e2f61891$var$_assertThisInitialized(self);
}
function $8ba60529e2f61891$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8ba60529e2f61891$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8ba60529e2f61891$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8ba60529e2f61891$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8ba60529e2f61891$var$_construct(Class, arguments, $8ba60529e2f61891$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8ba60529e2f61891$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8ba60529e2f61891$var$_wrapNativeSuper(Class);
}
function $8ba60529e2f61891$var$_construct(Parent, args, Class) {
    if ($8ba60529e2f61891$var$_isNativeReflectConstruct()) $8ba60529e2f61891$var$_construct = Reflect.construct.bind();
    else $8ba60529e2f61891$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8ba60529e2f61891$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8ba60529e2f61891$var$_construct.apply(null, arguments);
}
function $8ba60529e2f61891$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8ba60529e2f61891$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8ba60529e2f61891$var$_setPrototypeOf(o, p) {
    $8ba60529e2f61891$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8ba60529e2f61891$var$_setPrototypeOf(o, p);
}
function $8ba60529e2f61891$var$_getPrototypeOf(o) {
    $8ba60529e2f61891$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8ba60529e2f61891$var$_getPrototypeOf(o);
}
function $8ba60529e2f61891$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8ba60529e2f61891$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8ba60529e2f61891$var$_typeof(o);
}

var $eqWSa = parcelRequire("eqWSa");
var $8ba60529e2f61891$var$inspect = $eqWSa.inspect;

var $84ZjD = parcelRequire("84ZjD");
var $8ba60529e2f61891$var$ERR_INVALID_ARG_TYPE = $84ZjD.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $8ba60529e2f61891$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $8ba60529e2f61891$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $8ba60529e2f61891$var$blue = '';
var $8ba60529e2f61891$var$green = '';
var $8ba60529e2f61891$var$red = '';
var $8ba60529e2f61891$var$white = '';
var $8ba60529e2f61891$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $8ba60529e2f61891$var$kMaxShortLength = 10;
function $8ba60529e2f61891$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $8ba60529e2f61891$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $8ba60529e2f61891$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $8ba60529e2f61891$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $8ba60529e2f61891$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $8ba60529e2f61891$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $8ba60529e2f61891$var$_typeof(actual) === 'object' && $8ba60529e2f61891$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $8ba60529e2f61891$var$kMaxShortLength) {
            if (($8ba60529e2f61891$var$_typeof(actual) !== 'object' || actual === null) && ($8ba60529e2f61891$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($8ba60529e2f61891$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $djlMn.stderr && $djlMn.stderr.isTTY ? $djlMn.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($8ba60529e2f61891$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($8ba60529e2f61891$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $8ba60529e2f61891$var$kReadableOperator[operator] + "\n".concat($8ba60529e2f61891$var$green, "+ actual").concat($8ba60529e2f61891$var$white, " ").concat($8ba60529e2f61891$var$red, "- expected").concat($8ba60529e2f61891$var$white);
    var skippedMsg = " ".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($8ba60529e2f61891$var$red, "-").concat($8ba60529e2f61891$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($8ba60529e2f61891$var$green, "+").concat($8ba60529e2f61891$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$8ba60529e2f61891$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $8ba60529e2f61891$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($8ba60529e2f61891$var$green, "+").concat($8ba60529e2f61891$var$white, " ").concat(actualLine);
                other += "\n".concat($8ba60529e2f61891$var$red, "-").concat($8ba60529e2f61891$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white).concat(other, "\n") + "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $8ba60529e2f61891$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $8ba60529e2f61891$var$_inherits(AssertionError, _Error);
    var _super = $8ba60529e2f61891$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $8ba60529e2f61891$var$_classCallCheck(this, AssertionError);
        if ($8ba60529e2f61891$var$_typeof(options) !== 'object' || options === null) throw new $8ba60529e2f61891$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($djlMn.stderr && $djlMn.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($djlMn.stderr && $djlMn.stderr.getColorDepth && $djlMn.stderr.getColorDepth() !== 1) {
                    $8ba60529e2f61891$var$blue = "\x1B[34m";
                    $8ba60529e2f61891$var$green = "\x1B[32m";
                    $8ba60529e2f61891$var$white = "\x1B[39m";
                    $8ba60529e2f61891$var$red = "\x1B[31m";
                } else {
                    $8ba60529e2f61891$var$blue = '';
                    $8ba60529e2f61891$var$green = '';
                    $8ba60529e2f61891$var$white = '';
                    $8ba60529e2f61891$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($8ba60529e2f61891$var$_typeof(actual) === 'object' && actual !== null && $8ba60529e2f61891$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $8ba60529e2f61891$var$copyError(actual);
                expected = $8ba60529e2f61891$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $8ba60529e2f61891$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $8ba60529e2f61891$var$kReadableOperator[operator];
                var res = $8ba60529e2f61891$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $8ba60529e2f61891$var$_typeof(actual) === 'object' && actual !== null) base = $8ba60529e2f61891$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($8ba60529e2f61891$var$blue, "...").concat($8ba60529e2f61891$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $8ba60529e2f61891$var$inspectValue(actual);
                var other = '';
                var knownOperators = $8ba60529e2f61891$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($8ba60529e2f61891$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($8ba60529e2f61891$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($8ba60529e2f61891$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($8ba60529e2f61891$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $8ba60529e2f61891$var$_possibleConstructorReturn(_this);
    }
    $8ba60529e2f61891$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $8ba60529e2f61891$var$inspect(this, $8ba60529e2f61891$var$_objectSpread($8ba60529e2f61891$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $8ba60529e2f61891$var$_wrapNativeSuper(Error), $8ba60529e2f61891$var$inspect.custom);
module.exports = $8ba60529e2f61891$var$AssertionError;

});

parcelRegister("lp0oE", function(module, exports) {
'use strict';

var $gibqm = parcelRequire("gibqm");
var $f94c3d8d0e8b40cb$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $f94c3d8d0e8b40cb$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $gibqm;
    if ($f94c3d8d0e8b40cb$var$lacksProperEnumerationOrder()) return $gibqm;
    if ($f94c3d8d0e8b40cb$var$assignHasPendingExceptions()) return $gibqm;
    return Object.assign;
};

});
parcelRegister("gibqm", function(module, exports) {
'use strict';

var $eYsiZ = parcelRequire("eYsiZ");

var $bdc730658ec9aab4$var$hasSymbols = (parcelRequire("1TyHV"))();

var $9krxM = parcelRequire("9krxM");

var $irzZH = parcelRequire("irzZH");
var $bdc730658ec9aab4$var$$push = $9krxM('Array.prototype.push');
var $bdc730658ec9aab4$var$$propIsEnumerable = $9krxM('Object.prototype.propertyIsEnumerable');
var $bdc730658ec9aab4$var$originalGetSymbols = $bdc730658ec9aab4$var$hasSymbols ? $irzZH.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $irzZH(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $irzZH(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $eYsiZ(from);
        var getSymbols = $bdc730658ec9aab4$var$hasSymbols && ($irzZH.getOwnPropertySymbols || $bdc730658ec9aab4$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($bdc730658ec9aab4$var$$propIsEnumerable(from, key)) $bdc730658ec9aab4$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($bdc730658ec9aab4$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("eYsiZ", function(module, exports) {
'use strict';
var $ae6ca0233735d307$var$slice = Array.prototype.slice;

var $jmQGs = parcelRequire("jmQGs");
var $ae6ca0233735d307$var$origKeys = Object.keys;

var $ae6ca0233735d307$var$keysShim = $ae6ca0233735d307$var$origKeys ? function keys(o) {
    return $ae6ca0233735d307$var$origKeys(o);
} : (parcelRequire("7I8vG"));
var $ae6ca0233735d307$var$originalKeys = Object.keys;
$ae6ca0233735d307$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($jmQGs(object)) return $ae6ca0233735d307$var$originalKeys($ae6ca0233735d307$var$slice.call(object));
            return $ae6ca0233735d307$var$originalKeys(object);
        };
    } else Object.keys = $ae6ca0233735d307$var$keysShim;
    return Object.keys || $ae6ca0233735d307$var$keysShim;
};
module.exports = $ae6ca0233735d307$var$keysShim;

});
parcelRegister("jmQGs", function(module, exports) {
'use strict';
var $e198f04eabdd4d1a$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $e198f04eabdd4d1a$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $e198f04eabdd4d1a$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("7I8vG", function(module, exports) {
'use strict';
var $59d33e6135c61ca9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $59d33e6135c61ca9$var$has = Object.prototype.hasOwnProperty;
    var $59d33e6135c61ca9$var$toStr = Object.prototype.toString;
    var $59d33e6135c61ca9$var$isArgs = (parcelRequire("jmQGs")); // eslint-disable-line global-require
    var $59d33e6135c61ca9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $59d33e6135c61ca9$var$hasDontEnumBug = !$59d33e6135c61ca9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $59d33e6135c61ca9$var$hasProtoEnumBug = $59d33e6135c61ca9$var$isEnumerable.call(function() {}, 'prototype');
    var $59d33e6135c61ca9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $59d33e6135c61ca9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $59d33e6135c61ca9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $59d33e6135c61ca9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$59d33e6135c61ca9$var$excludedKeys['$' + k] && $59d33e6135c61ca9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $59d33e6135c61ca9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $59d33e6135c61ca9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$59d33e6135c61ca9$var$hasAutomationEqualityBug) return $59d33e6135c61ca9$var$equalsConstructorPrototype(o);
        try {
            return $59d33e6135c61ca9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $59d33e6135c61ca9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $59d33e6135c61ca9$var$toStr.call(object) === '[object Function]';
        var isArguments = $59d33e6135c61ca9$var$isArgs(object);
        var isString = isObject && $59d33e6135c61ca9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $59d33e6135c61ca9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$59d33e6135c61ca9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $59d33e6135c61ca9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($59d33e6135c61ca9$var$hasDontEnumBug) {
            var skipConstructor = $59d33e6135c61ca9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $59d33e6135c61ca9$var$dontEnums.length; ++k)if (!(skipConstructor && $59d33e6135c61ca9$var$dontEnums[k] === 'constructor') && $59d33e6135c61ca9$var$has.call(object, $59d33e6135c61ca9$var$dontEnums[k])) theKeys.push($59d33e6135c61ca9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $59d33e6135c61ca9$var$keysShim;

});




parcelRegister("eoHrM", function(module, exports) {
'use strict';

var $bF0Xx = parcelRequire("bF0Xx");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $bF0Xx;
};

});
parcelRegister("bF0Xx", function(module, exports) {
'use strict';
var $87d4448ae9927229$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($87d4448ae9927229$var$numberIsNaN(a) && $87d4448ae9927229$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("34Xrk", function(module, exports) {
'use strict';

var $fZZOm = parcelRequire("fZZOm");

var $aebgU = parcelRequire("aebgU");
var $23dfda4de8857a25$var$$indexOf = $aebgU($fZZOm('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $fZZOm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $23dfda4de8857a25$var$$indexOf(name, '.prototype.') > -1) return $aebgU(intrinsic);
    return intrinsic;
};

});

parcelRegister("cPQKq", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $95832a0e0058e662$var$_slicedToArray(arr, i) {
    return $95832a0e0058e662$var$_arrayWithHoles(arr) || $95832a0e0058e662$var$_iterableToArrayLimit(arr, i) || $95832a0e0058e662$var$_unsupportedIterableToArray(arr, i) || $95832a0e0058e662$var$_nonIterableRest();
}
function $95832a0e0058e662$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $95832a0e0058e662$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $95832a0e0058e662$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $95832a0e0058e662$var$_arrayLikeToArray(o, minLen);
}
function $95832a0e0058e662$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $95832a0e0058e662$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $95832a0e0058e662$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $95832a0e0058e662$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $95832a0e0058e662$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95832a0e0058e662$var$_typeof(o);
}
var $95832a0e0058e662$var$regexFlagsSupported = /a/g.flags !== undefined;
var $95832a0e0058e662$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $95832a0e0058e662$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $95832a0e0058e662$var$objectIs = Object.is ? Object.is : (parcelRequire("1Wpr8"));
var $95832a0e0058e662$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $95832a0e0058e662$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("80C6L"));
function $95832a0e0058e662$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $95832a0e0058e662$var$hasOwnProperty = $95832a0e0058e662$var$uncurryThis(Object.prototype.hasOwnProperty);
var $95832a0e0058e662$var$propertyIsEnumerable = $95832a0e0058e662$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $95832a0e0058e662$var$objectToString = $95832a0e0058e662$var$uncurryThis(Object.prototype.toString);

var $eqWSa = parcelRequire("eqWSa");
var $95832a0e0058e662$require$_require$types = $eqWSa.types;
var $95832a0e0058e662$var$isAnyArrayBuffer = $95832a0e0058e662$require$_require$types.isAnyArrayBuffer, $95832a0e0058e662$var$isArrayBufferView = $95832a0e0058e662$require$_require$types.isArrayBufferView, $95832a0e0058e662$var$isDate = $95832a0e0058e662$require$_require$types.isDate, $95832a0e0058e662$var$isMap = $95832a0e0058e662$require$_require$types.isMap, $95832a0e0058e662$var$isRegExp = $95832a0e0058e662$require$_require$types.isRegExp, $95832a0e0058e662$var$isSet = $95832a0e0058e662$require$_require$types.isSet, $95832a0e0058e662$var$isNativeError = $95832a0e0058e662$require$_require$types.isNativeError, $95832a0e0058e662$var$isBoxedPrimitive = $95832a0e0058e662$require$_require$types.isBoxedPrimitive, $95832a0e0058e662$var$isNumberObject = $95832a0e0058e662$require$_require$types.isNumberObject, $95832a0e0058e662$var$isStringObject = $95832a0e0058e662$require$_require$types.isStringObject, $95832a0e0058e662$var$isBooleanObject = $95832a0e0058e662$require$_require$types.isBooleanObject, $95832a0e0058e662$var$isBigIntObject = $95832a0e0058e662$require$_require$types.isBigIntObject, $95832a0e0058e662$var$isSymbolObject = $95832a0e0058e662$require$_require$types.isSymbolObject, $95832a0e0058e662$var$isFloat32Array = $95832a0e0058e662$require$_require$types.isFloat32Array, $95832a0e0058e662$var$isFloat64Array = $95832a0e0058e662$require$_require$types.isFloat64Array;
function $95832a0e0058e662$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $95832a0e0058e662$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($95832a0e0058e662$var$isNonIndex).concat($95832a0e0058e662$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $95832a0e0058e662$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $95832a0e0058e662$var$ONLY_ENUMERABLE = undefined;
var $95832a0e0058e662$var$kStrict = true;
var $95832a0e0058e662$var$kLoose = false;
var $95832a0e0058e662$var$kNoIterator = 0;
var $95832a0e0058e662$var$kIsArray = 1;
var $95832a0e0058e662$var$kIsSet = 2;
var $95832a0e0058e662$var$kIsMap = 3;
// Check if they have the same source and flags
function $95832a0e0058e662$var$areSimilarRegExps(a, b) {
    return $95832a0e0058e662$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $95832a0e0058e662$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $95832a0e0058e662$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $95832a0e0058e662$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $95832a0e0058e662$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $95832a0e0058e662$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $95832a0e0058e662$var$isEqualBoxedPrimitive(val1, val2) {
    if ($95832a0e0058e662$var$isNumberObject(val1)) return $95832a0e0058e662$var$isNumberObject(val2) && $95832a0e0058e662$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($95832a0e0058e662$var$isStringObject(val1)) return $95832a0e0058e662$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($95832a0e0058e662$var$isBooleanObject(val1)) return $95832a0e0058e662$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($95832a0e0058e662$var$isBigIntObject(val1)) return $95832a0e0058e662$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $95832a0e0058e662$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $95832a0e0058e662$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $95832a0e0058e662$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($95832a0e0058e662$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $95832a0e0058e662$var$numberIsNaN(val1) && $95832a0e0058e662$var$numberIsNaN(val2);
        if ($95832a0e0058e662$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $95832a0e0058e662$var$_typeof(val1) !== 'object') {
            if (val2 === null || $95832a0e0058e662$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $95832a0e0058e662$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $95832a0e0058e662$var$objectToString(val1);
    var val2Tag = $95832a0e0058e662$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $95832a0e0058e662$var$getOwnNonIndexProperties(val1, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        var keys2 = $95832a0e0058e662$var$getOwnNonIndexProperties(val2, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$95832a0e0058e662$var$isMap(val1) && $95832a0e0058e662$var$isMap(val2) || !$95832a0e0058e662$var$isSet(val1) && $95832a0e0058e662$var$isSet(val2)) return false;
    }
    if ($95832a0e0058e662$var$isDate(val1)) {
        if (!$95832a0e0058e662$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($95832a0e0058e662$var$isRegExp(val1)) {
        if (!$95832a0e0058e662$var$isRegExp(val2) || !$95832a0e0058e662$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($95832a0e0058e662$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($95832a0e0058e662$var$isArrayBufferView(val1)) {
        if (!strict && ($95832a0e0058e662$var$isFloat32Array(val1) || $95832a0e0058e662$var$isFloat64Array(val1))) {
            if (!$95832a0e0058e662$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$95832a0e0058e662$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $95832a0e0058e662$var$getOwnNonIndexProperties(val1, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        var _keys2 = $95832a0e0058e662$var$getOwnNonIndexProperties(val2, $95832a0e0058e662$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kNoIterator, _keys);
    } else if ($95832a0e0058e662$var$isSet(val1)) {
        if (!$95832a0e0058e662$var$isSet(val2) || val1.size !== val2.size) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsSet);
    } else if ($95832a0e0058e662$var$isMap(val1)) {
        if (!$95832a0e0058e662$var$isMap(val2) || val1.size !== val2.size) return false;
        return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kIsMap);
    } else if ($95832a0e0058e662$var$isAnyArrayBuffer(val1)) {
        if (!$95832a0e0058e662$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($95832a0e0058e662$var$isBoxedPrimitive(val1) && !$95832a0e0058e662$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, $95832a0e0058e662$var$kNoIterator);
}
function $95832a0e0058e662$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $95832a0e0058e662$var$propertyIsEnumerable(val, k);
    });
}
function $95832a0e0058e662$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$95832a0e0058e662$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($95832a0e0058e662$var$propertyIsEnumerable(val1, key)) {
                    if (!$95832a0e0058e662$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($95832a0e0058e662$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $95832a0e0058e662$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $95832a0e0058e662$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $95832a0e0058e662$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $95832a0e0058e662$var$kNoIterator || iterationType === $95832a0e0058e662$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $95832a0e0058e662$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $95832a0e0058e662$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $95832a0e0058e662$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($95832a0e0058e662$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $95832a0e0058e662$var$findLooseMatchingPrimitives(prim) {
    switch($95832a0e0058e662$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($95832a0e0058e662$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $95832a0e0058e662$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $95832a0e0058e662$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $95832a0e0058e662$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $95832a0e0058e662$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$95832a0e0058e662$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $95832a0e0058e662$var$innerDeepEqual(item, curB, false, memo);
}
function $95832a0e0058e662$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $95832a0e0058e662$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($95832a0e0058e662$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$95832a0e0058e662$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $95832a0e0058e662$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($95832a0e0058e662$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$95832a0e0058e662$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$95832a0e0058e662$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $95832a0e0058e662$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $95832a0e0058e662$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($95832a0e0058e662$var$innerDeepEqual(key1, key2, strict, memo) && $95832a0e0058e662$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $95832a0e0058e662$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $95832a0e0058e662$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $95832a0e0058e662$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($95832a0e0058e662$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$95832a0e0058e662$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$95832a0e0058e662$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $95832a0e0058e662$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $95832a0e0058e662$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($95832a0e0058e662$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$95832a0e0058e662$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$95832a0e0058e662$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$95832a0e0058e662$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $95832a0e0058e662$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $95832a0e0058e662$var$kIsSet) {
        if (!$95832a0e0058e662$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $95832a0e0058e662$var$kIsMap) {
        if (!$95832a0e0058e662$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $95832a0e0058e662$var$kIsArray) for(; i < a.length; i++){
        if ($95832a0e0058e662$var$hasOwnProperty(a, i)) {
            if (!$95832a0e0058e662$var$hasOwnProperty(b, i) || !$95832a0e0058e662$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($95832a0e0058e662$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$95832a0e0058e662$var$hasOwnProperty(b, key) || !$95832a0e0058e662$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$95832a0e0058e662$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $95832a0e0058e662$var$isDeepEqual(val1, val2) {
    return $95832a0e0058e662$var$innerDeepEqual(val1, val2, $95832a0e0058e662$var$kLoose);
}
function $95832a0e0058e662$var$isDeepStrictEqual(val1, val2) {
    return $95832a0e0058e662$var$innerDeepEqual(val1, val2, $95832a0e0058e662$var$kStrict);
}
module.exports = {
    isDeepEqual: $95832a0e0058e662$var$isDeepEqual,
    isDeepStrictEqual: $95832a0e0058e662$var$isDeepStrictEqual
};

});
parcelRegister("1Wpr8", function(module, exports) {
'use strict';

var $QqlOB = parcelRequire("QqlOB");

var $aebgU = parcelRequire("aebgU");

var $bF0Xx = parcelRequire("bF0Xx");

var $eoHrM = parcelRequire("eoHrM");

var $e0pCW = parcelRequire("e0pCW");
var $169ef06e1496fb76$var$polyfill = $aebgU($eoHrM(), Object);
$QqlOB($169ef06e1496fb76$var$polyfill, {
    getPolyfill: $eoHrM,
    implementation: $bF0Xx,
    shim: $e0pCW
});
module.exports = $169ef06e1496fb76$var$polyfill;

});
parcelRegister("QqlOB", function(module, exports) {
'use strict';

var $eYsiZ = parcelRequire("eYsiZ");
var $09d94c2cd5f62246$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $09d94c2cd5f62246$var$toStr = Object.prototype.toString;
var $09d94c2cd5f62246$var$concat = Array.prototype.concat;

var $2rrwJ = parcelRequire("2rrwJ");
var $09d94c2cd5f62246$var$isFunction = function(fn) {
    return typeof fn === 'function' && $09d94c2cd5f62246$var$toStr.call(fn) === '[object Function]';
};

var $09d94c2cd5f62246$var$supportsDescriptors = (parcelRequire("dkM7t"))();
var $09d94c2cd5f62246$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$09d94c2cd5f62246$var$isFunction(predicate) || !predicate()) return;
    }
    if ($09d94c2cd5f62246$var$supportsDescriptors) $2rrwJ(object, name, value, true);
    else $2rrwJ(object, name, value);
};
var $09d94c2cd5f62246$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $eYsiZ(map);
    if ($09d94c2cd5f62246$var$hasSymbols) props = $09d94c2cd5f62246$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$09d94c2cd5f62246$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$09d94c2cd5f62246$var$defineProperties.supportsDescriptors = !!$09d94c2cd5f62246$var$supportsDescriptors;
module.exports = $09d94c2cd5f62246$var$defineProperties;

});

parcelRegister("e0pCW", function(module, exports) {
'use strict';

var $eoHrM = parcelRequire("eoHrM");

var $QqlOB = parcelRequire("QqlOB");
module.exports = function shimObjectIs() {
    var polyfill = $eoHrM();
    $QqlOB(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("80C6L", function(module, exports) {
'use strict';

var $aebgU = parcelRequire("aebgU");

var $QqlOB = parcelRequire("QqlOB");

var $fKB3l = parcelRequire("fKB3l");

var $ic5eo = parcelRequire("ic5eo");

var $dtR1B = parcelRequire("dtR1B");
var $5d4be24a5caa8855$var$polyfill = $aebgU($ic5eo(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $QqlOB($5d4be24a5caa8855$var$polyfill, {
    getPolyfill: $ic5eo,
    implementation: $fKB3l,
    shim: $dtR1B
});
module.exports = $5d4be24a5caa8855$var$polyfill;

});
parcelRegister("fKB3l", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("ic5eo", function(module, exports) {
'use strict';

var $fKB3l = parcelRequire("fKB3l");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $fKB3l;
};

});

parcelRegister("dtR1B", function(module, exports) {
'use strict';

var $QqlOB = parcelRequire("QqlOB");

var $ic5eo = parcelRequire("ic5eo");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $ic5eo();
    $QqlOB(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("fX8pL", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("8wQss", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $635a00f27fafc33c$export$306c0aa65ff9ec16; }, function (v) { return $635a00f27fafc33c$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $635a00f27fafc33c$export$306c0aa65ff9ec16;
"use strict";

var $8nGP5 = parcelRequire("8nGP5");
function $635a00f27fafc33c$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $635a00f27fafc33c$var$objectIs = "function" === typeof Object.is ? Object.is : $635a00f27fafc33c$var$is, $635a00f27fafc33c$var$useState = $8nGP5.useState, $635a00f27fafc33c$var$useEffect = $8nGP5.useEffect, $635a00f27fafc33c$var$useLayoutEffect = $8nGP5.useLayoutEffect, $635a00f27fafc33c$var$useDebugValue = $8nGP5.useDebugValue;
function $635a00f27fafc33c$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $635a00f27fafc33c$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $635a00f27fafc33c$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $635a00f27fafc33c$var$useEffect(function() {
        $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $635a00f27fafc33c$var$useDebugValue(value);
    return value;
}
function $635a00f27fafc33c$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$635a00f27fafc33c$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $635a00f27fafc33c$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $635a00f27fafc33c$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $635a00f27fafc33c$var$useSyncExternalStore$1 : $635a00f27fafc33c$var$useSyncExternalStore$2;
$635a00f27fafc33c$export$306c0aa65ff9ec16 = void 0 !== $8nGP5.useSyncExternalStore ? $8nGP5.useSyncExternalStore : $635a00f27fafc33c$var$shim;

});

parcelRegister("ajIhI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $3622a645c822ba87$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $3622a645c822ba87$export$2e2bcd8739ae039; });
function $3622a645c822ba87$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $3622a645c822ba87$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $3622a645c822ba87$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $3622a645c822ba87$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3622a645c822ba87$export$2e2bcd8739ae039 = $3622a645c822ba87$export$4f5d2d50c9deca37;

});

parcelRegister("9HWmz", function(module, exports) {
parcelRequire("9k0OT");

module.exports = (parcelRequire("aunq5")).Object.assign;

});
parcelRegister("9k0OT", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $g45SR = parcelRequire("g45SR");

$g45SR($g45SR.S + $g45SR.F, 'Object', {
    assign: (parcelRequire("4LVma"))
});

});
parcelRegister("g45SR", function(module, exports) {

var $pnVph = parcelRequire("pnVph");

var $aunq5 = parcelRequire("aunq5");

var $bMm8u = parcelRequire("bMm8u");

var $9szbs = parcelRequire("9szbs");

var $779TT = parcelRequire("779TT");
var $bb21957dbdff3874$var$PROTOTYPE = 'prototype';
var $bb21957dbdff3874$var$$export = function(type, name, source) {
    var IS_FORCED = type & $bb21957dbdff3874$var$$export.F;
    var IS_GLOBAL = type & $bb21957dbdff3874$var$$export.G;
    var IS_STATIC = type & $bb21957dbdff3874$var$$export.S;
    var IS_PROTO = type & $bb21957dbdff3874$var$$export.P;
    var IS_BIND = type & $bb21957dbdff3874$var$$export.B;
    var IS_WRAP = type & $bb21957dbdff3874$var$$export.W;
    var exports = IS_GLOBAL ? $aunq5 : $aunq5[name] || ($aunq5[name] = {});
    var expProto = exports[$bb21957dbdff3874$var$PROTOTYPE];
    var target = IS_GLOBAL ? $pnVph : IS_STATIC ? $pnVph[name] : ($pnVph[name] || {})[$bb21957dbdff3874$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $779TT(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $bMm8u(out, $pnVph) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$bb21957dbdff3874$var$PROTOTYPE] = C[$bb21957dbdff3874$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $bMm8u(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $bb21957dbdff3874$var$$export.R && expProto && !expProto[key]) $9szbs(expProto, key, out);
        }
    }
};
// type bitmap
$bb21957dbdff3874$var$$export.F = 1; // forced
$bb21957dbdff3874$var$$export.G = 2; // global
$bb21957dbdff3874$var$$export.S = 4; // static
$bb21957dbdff3874$var$$export.P = 8; // proto
$bb21957dbdff3874$var$$export.B = 16; // bind
$bb21957dbdff3874$var$$export.W = 32; // wrap
$bb21957dbdff3874$var$$export.U = 64; // safe
$bb21957dbdff3874$var$$export.R = 128; // real proto method for `library`
module.exports = $bb21957dbdff3874$var$$export;

});
parcelRegister("pnVph", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $04c4e4e76a6edd9f$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $04c4e4e76a6edd9f$var$global; // eslint-disable-line no-undef

});

parcelRegister("aunq5", function(module, exports) {
var $7a2edf6687c7bf3d$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $7a2edf6687c7bf3d$var$core; // eslint-disable-line no-undef

});

parcelRegister("bMm8u", function(module, exports) {
// optional / simple context binding

var $lRhcY = parcelRequire("lRhcY");
module.exports = function(fn, that, length) {
    $lRhcY(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("lRhcY", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("9szbs", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");

var $Gbehr = parcelRequire("Gbehr");

module.exports = (parcelRequire("iUvfY")) ? function(object, key, value) {
    return $fxtrV.f(object, key, $Gbehr(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("fxtrV", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b500c822271951d0$export$2d1720544b23b823; }, function (v) { return $b500c822271951d0$export$2d1720544b23b823 = v; });
var $b500c822271951d0$export$2d1720544b23b823;

var $gWOKW = parcelRequire("gWOKW");

var $3EiA3 = parcelRequire("3EiA3");

var $jfS6J = parcelRequire("jfS6J");
var $b500c822271951d0$var$dP = Object.defineProperty;

$b500c822271951d0$export$2d1720544b23b823 = (parcelRequire("iUvfY")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $gWOKW(O);
    P = $jfS6J(P, true);
    $gWOKW(Attributes);
    if ($3EiA3) try {
        return $b500c822271951d0$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("gWOKW", function(module, exports) {

var $c8vg0 = parcelRequire("c8vg0");
module.exports = function(it) {
    if (!$c8vg0(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("c8vg0", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("3EiA3", function(module, exports) {



module.exports = !(parcelRequire("iUvfY")) && !(parcelRequire("k9mjq"))(function() {
    return Object.defineProperty((parcelRequire("5ZV8G"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("iUvfY", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("k9mjq"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("k9mjq", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("5ZV8G", function(module, exports) {

var $c8vg0 = parcelRequire("c8vg0");

var $pnVph = parcelRequire("pnVph");
var $45def8dd436ab5ed$require$document = $pnVph.document;
// typeof document.createElement is 'object' in old IE
var $45def8dd436ab5ed$var$is = $c8vg0($45def8dd436ab5ed$require$document) && $c8vg0($45def8dd436ab5ed$require$document.createElement);
module.exports = function(it) {
    return $45def8dd436ab5ed$var$is ? $45def8dd436ab5ed$require$document.createElement(it) : {};
};

});


parcelRegister("jfS6J", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $c8vg0 = parcelRequire("c8vg0");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$c8vg0(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$c8vg0(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("Gbehr", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("779TT", function(module, exports) {
var $52e0dde1fa7b30e4$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $52e0dde1fa7b30e4$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("4LVma", function(module, exports) {
'use strict';

var $iUvfY = parcelRequire("iUvfY");

var $fmsEx = parcelRequire("fmsEx");

var $i3Fjk = parcelRequire("i3Fjk");

var $fbjf9 = parcelRequire("fbjf9");

var $f7AII = parcelRequire("f7AII");

var $awHHr = parcelRequire("awHHr");
var $37980b09787ef0c9$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$37980b09787ef0c9$var$$assign || (parcelRequire("k9mjq"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $37980b09787ef0c9$var$$assign({}, A)[S] != 7 || Object.keys($37980b09787ef0c9$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $f7AII(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $i3Fjk.f;
    var isEnum = $fbjf9.f;
    while(aLen > index){
        var S = $awHHr(arguments[index++]);
        var keys = getSymbols ? $fmsEx(S).concat(getSymbols(S)) : $fmsEx(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$iUvfY || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $37980b09787ef0c9$var$$assign;

});
parcelRegister("fmsEx", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $g7Rv3 = parcelRequire("g7Rv3");

var $eeRfl = parcelRequire("eeRfl");
module.exports = Object.keys || function keys(O) {
    return $g7Rv3(O, $eeRfl);
};

});
parcelRegister("g7Rv3", function(module, exports) {

var $779TT = parcelRequire("779TT");

var $bSzJU = parcelRequire("bSzJU");

var $bbd6ccc00206b77b$var$arrayIndexOf = (parcelRequire("gHQQ2"))(false);

var $bbd6ccc00206b77b$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $bSzJU(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $bbd6ccc00206b77b$var$IE_PROTO) $779TT(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($779TT(O, key = names[i++])) ~$bbd6ccc00206b77b$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("bSzJU", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $awHHr = parcelRequire("awHHr");

var $2GiKc = parcelRequire("2GiKc");
module.exports = function(it) {
    return $awHHr($2GiKc(it));
};

});
parcelRegister("awHHr", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $cONIx = parcelRequire("cONIx");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $cONIx(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("cONIx", function(module, exports) {
var $9550b8609f427639$var$toString = {}.toString;
module.exports = function(it) {
    return $9550b8609f427639$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("2GiKc", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("gHQQ2", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $bSzJU = parcelRequire("bSzJU");

var $42VcX = parcelRequire("42VcX");

var $btJ4J = parcelRequire("btJ4J");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $bSzJU($this);
        var length = $42VcX(O.length);
        var index = $btJ4J(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("42VcX", function(module, exports) {
// 7.1.15 ToLength

var $le8Xc = parcelRequire("le8Xc");
var $2f23b9a1f4477c52$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $2f23b9a1f4477c52$var$min($le8Xc(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("le8Xc", function(module, exports) {
// 7.1.4 ToInteger
var $f741d9d2c398843c$var$ceil = Math.ceil;
var $f741d9d2c398843c$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $f741d9d2c398843c$var$floor : $f741d9d2c398843c$var$ceil)(it);
};

});


parcelRegister("btJ4J", function(module, exports) {

var $le8Xc = parcelRequire("le8Xc");
var $85b55e281721d3ab$var$max = Math.max;
var $85b55e281721d3ab$var$min = Math.min;
module.exports = function(index, length) {
    index = $le8Xc(index);
    return index < 0 ? $85b55e281721d3ab$var$max(index + length, 0) : $85b55e281721d3ab$var$min(index, length);
};

});


parcelRegister("GgEeA", function(module, exports) {

var $07f0d64acd5a0c70$var$shared = (parcelRequire("cjBmO"))('keys');

var $59Ov2 = parcelRequire("59Ov2");
module.exports = function(key) {
    return $07f0d64acd5a0c70$var$shared[key] || ($07f0d64acd5a0c70$var$shared[key] = $59Ov2(key));
};

});
parcelRegister("cjBmO", function(module, exports) {

var $aunq5 = parcelRequire("aunq5");

var $pnVph = parcelRequire("pnVph");
var $8f743ea8506f6d26$var$SHARED = '__core-js_shared__';
var $8f743ea8506f6d26$var$store = $pnVph[$8f743ea8506f6d26$var$SHARED] || ($pnVph[$8f743ea8506f6d26$var$SHARED] = {});

(module.exports = function(key, value) {
    return $8f743ea8506f6d26$var$store[key] || ($8f743ea8506f6d26$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $aunq5.version,
    mode: (parcelRequire("9q93S")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("9q93S", function(module, exports) {
module.exports = true;

});


parcelRegister("59Ov2", function(module, exports) {
var $3c14f72a489241a1$var$id = 0;
var $3c14f72a489241a1$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$3c14f72a489241a1$var$id + $3c14f72a489241a1$var$px).toString(36));
};

});



parcelRegister("eeRfl", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("i3Fjk", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d2588d4145d20b3f$export$2d1720544b23b823; }, function (v) { return $d2588d4145d20b3f$export$2d1720544b23b823 = v; });
var $d2588d4145d20b3f$export$2d1720544b23b823;
$d2588d4145d20b3f$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("fbjf9", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $b0d6cf6dc7525790$export$2d1720544b23b823; }, function (v) { return $b0d6cf6dc7525790$export$2d1720544b23b823 = v; });
var $b0d6cf6dc7525790$export$2d1720544b23b823;
$b0d6cf6dc7525790$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("f7AII", function(module, exports) {
// 7.1.13 ToObject(argument)

var $2GiKc = parcelRequire("2GiKc");
module.exports = function(it) {
    return Object($2GiKc(it));
};

});




parcelRegister("7kC0X", function(module, exports) {
parcelRequire("cnRix");

module.exports = (parcelRequire("aunq5")).Object.getPrototypeOf;

});
parcelRegister("cnRix", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $f7AII = parcelRequire("f7AII");

var $iQWEJ = parcelRequire("iQWEJ");

(parcelRequire("7lufS"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $iQWEJ($f7AII(it));
    };
});

});
parcelRegister("iQWEJ", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $779TT = parcelRequire("779TT");

var $f7AII = parcelRequire("f7AII");

var $db9a95279c2b66e7$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
var $db9a95279c2b66e7$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $f7AII(O);
    if ($779TT(O, $db9a95279c2b66e7$var$IE_PROTO)) return O[$db9a95279c2b66e7$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $db9a95279c2b66e7$var$ObjectProto : null;
};

});

parcelRegister("7lufS", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $g45SR = parcelRequire("g45SR");

var $aunq5 = parcelRequire("aunq5");

var $k9mjq = parcelRequire("k9mjq");
module.exports = function(KEY, exec) {
    var fn = ($aunq5.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $g45SR($g45SR.S + $g45SR.F * $k9mjq(function() {
        fn(1);
    }), 'Object', exp);
};

});



parcelRegister("kRrED", function(module, exports) {
parcelRequire("kd4bk");

var $aunq5 = parcelRequire("aunq5");
var $f2fe357f25d7c4c7$require$$Object = $aunq5.Object;
module.exports = function defineProperty(it, key, desc) {
    return $f2fe357f25d7c4c7$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("kd4bk", function(module, exports) {

var $g45SR = parcelRequire("g45SR");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$g45SR($g45SR.S + $g45SR.F * !(parcelRequire("iUvfY")), 'Object', {
    defineProperty: (parcelRequire("fxtrV")).f
});

});


parcelRegister("5nWeK", function(module, exports) {
parcelRequire("4WGOw");
parcelRequire("6Lpnt");

module.exports = (parcelRequire("7ClSO")).f('iterator');

});
parcelRegister("4WGOw", function(module, exports) {
'use strict';

var $399dca20849743a1$var$$at = (parcelRequire("4MEQN"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("fOaE1"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $399dca20849743a1$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("4MEQN", function(module, exports) {

var $le8Xc = parcelRequire("le8Xc");

var $2GiKc = parcelRequire("2GiKc");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($2GiKc(that));
        var i = $le8Xc(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("fOaE1", function(module, exports) {
'use strict';

var $9q93S = parcelRequire("9q93S");

var $g45SR = parcelRequire("g45SR");

var $eM6v4 = parcelRequire("eM6v4");

var $9szbs = parcelRequire("9szbs");

var $G17rB = parcelRequire("G17rB");

var $aR3DP = parcelRequire("aR3DP");

var $fkjfL = parcelRequire("fkjfL");

var $iQWEJ = parcelRequire("iQWEJ");

var $b823c84978a89247$var$ITERATOR = (parcelRequire("fydF3"))('iterator');
var $b823c84978a89247$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $b823c84978a89247$var$FF_ITERATOR = '@@iterator';
var $b823c84978a89247$var$KEYS = 'keys';
var $b823c84978a89247$var$VALUES = 'values';
var $b823c84978a89247$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $aR3DP(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$b823c84978a89247$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $b823c84978a89247$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $b823c84978a89247$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $b823c84978a89247$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$b823c84978a89247$var$ITERATOR] || proto[$b823c84978a89247$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $iQWEJ($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $fkjfL(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$9q93S && typeof IteratorPrototype[$b823c84978a89247$var$ITERATOR] != 'function') $9szbs(IteratorPrototype, $b823c84978a89247$var$ITERATOR, $b823c84978a89247$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $b823c84978a89247$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$9q93S || FORCED) && ($b823c84978a89247$var$BUGGY || VALUES_BUG || !proto[$b823c84978a89247$var$ITERATOR])) $9szbs(proto, $b823c84978a89247$var$ITERATOR, $default);
    // Plug for library
    $G17rB[NAME] = $default;
    $G17rB[TAG] = $b823c84978a89247$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($b823c84978a89247$var$VALUES),
            keys: IS_SET ? $default : getMethod($b823c84978a89247$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $eM6v4(proto, key, methods[key]);
        } else $g45SR($g45SR.P + $g45SR.F * ($b823c84978a89247$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("eM6v4", function(module, exports) {

module.exports = (parcelRequire("9szbs"));

});

parcelRegister("G17rB", function(module, exports) {
module.exports = {};

});

parcelRegister("aR3DP", function(module, exports) {
'use strict';

var $ey75m = parcelRequire("ey75m");

var $Gbehr = parcelRequire("Gbehr");

var $fkjfL = parcelRequire("fkjfL");
var $7e71adbe8ce110e0$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("9szbs"))($7e71adbe8ce110e0$var$IteratorPrototype, (parcelRequire("fydF3"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $ey75m($7e71adbe8ce110e0$var$IteratorPrototype, {
        next: $Gbehr(1, next)
    });
    $fkjfL(Constructor, NAME + ' Iterator');
};

});
parcelRegister("ey75m", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $gWOKW = parcelRequire("gWOKW");

var $1xk0l = parcelRequire("1xk0l");

var $eeRfl = parcelRequire("eeRfl");

var $a979bcaa26f38a68$var$IE_PROTO = (parcelRequire("GgEeA"))('IE_PROTO');
var $a979bcaa26f38a68$var$Empty = function() {};
var $a979bcaa26f38a68$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $a979bcaa26f38a68$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("5ZV8G"))('iframe');
    var i = $eeRfl.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("gu9tw")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $a979bcaa26f38a68$var$createDict = iframeDocument.F;
    while(i--)delete $a979bcaa26f38a68$var$createDict[$a979bcaa26f38a68$var$PROTOTYPE][$eeRfl[i]];
    return $a979bcaa26f38a68$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $a979bcaa26f38a68$var$Empty[$a979bcaa26f38a68$var$PROTOTYPE] = $gWOKW(O);
        result = new $a979bcaa26f38a68$var$Empty();
        $a979bcaa26f38a68$var$Empty[$a979bcaa26f38a68$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$a979bcaa26f38a68$var$IE_PROTO] = O;
    } else result = $a979bcaa26f38a68$var$createDict();
    return Properties === undefined ? result : $1xk0l(result, Properties);
};

});
parcelRegister("1xk0l", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");

var $gWOKW = parcelRequire("gWOKW");

var $fmsEx = parcelRequire("fmsEx");

module.exports = (parcelRequire("iUvfY")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $gWOKW(O);
    var keys = $fmsEx(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$fxtrV.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("gu9tw", function(module, exports) {

var $pnVph = parcelRequire("pnVph");
var $c006cc3eded20735$require$document = $pnVph.document;
module.exports = $c006cc3eded20735$require$document && $c006cc3eded20735$require$document.documentElement;

});


parcelRegister("fkjfL", function(module, exports) {

var $fxtrV = parcelRequire("fxtrV");
var $b287a896fa454b10$require$def = $fxtrV.f;

var $779TT = parcelRequire("779TT");

var $b287a896fa454b10$var$TAG = (parcelRequire("fydF3"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$779TT(it = stat ? it : it.prototype, $b287a896fa454b10$var$TAG)) $b287a896fa454b10$require$def(it, $b287a896fa454b10$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("fydF3", function(module, exports) {

var $b524a0d2e0457ac4$var$store = (parcelRequire("cjBmO"))('wks');

var $59Ov2 = parcelRequire("59Ov2");

var $pnVph = parcelRequire("pnVph");
var $b524a0d2e0457ac4$require$Symbol = $pnVph.Symbol;
var $b524a0d2e0457ac4$var$USE_SYMBOL = typeof $b524a0d2e0457ac4$require$Symbol == 'function';
var $b524a0d2e0457ac4$var$$exports = module.exports = function(name) {
    return $b524a0d2e0457ac4$var$store[name] || ($b524a0d2e0457ac4$var$store[name] = $b524a0d2e0457ac4$var$USE_SYMBOL && $b524a0d2e0457ac4$require$Symbol[name] || ($b524a0d2e0457ac4$var$USE_SYMBOL ? $b524a0d2e0457ac4$require$Symbol : $59Ov2)('Symbol.' + name));
};
$b524a0d2e0457ac4$var$$exports.store = $b524a0d2e0457ac4$var$store;

});





parcelRegister("6Lpnt", function(module, exports) {
parcelRequire("9KY9L");

var $pnVph = parcelRequire("pnVph");

var $9szbs = parcelRequire("9szbs");

var $G17rB = parcelRequire("G17rB");

var $4ecad155a8c488ba$var$TO_STRING_TAG = (parcelRequire("fydF3"))('toStringTag');
var $4ecad155a8c488ba$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $4ecad155a8c488ba$var$i = 0; $4ecad155a8c488ba$var$i < $4ecad155a8c488ba$var$DOMIterables.length; $4ecad155a8c488ba$var$i++){
    var $4ecad155a8c488ba$var$NAME = $4ecad155a8c488ba$var$DOMIterables[$4ecad155a8c488ba$var$i];
    var $4ecad155a8c488ba$var$Collection = $pnVph[$4ecad155a8c488ba$var$NAME];
    var $4ecad155a8c488ba$var$proto = $4ecad155a8c488ba$var$Collection && $4ecad155a8c488ba$var$Collection.prototype;
    if ($4ecad155a8c488ba$var$proto && !$4ecad155a8c488ba$var$proto[$4ecad155a8c488ba$var$TO_STRING_TAG]) $9szbs($4ecad155a8c488ba$var$proto, $4ecad155a8c488ba$var$TO_STRING_TAG, $4ecad155a8c488ba$var$NAME);
    $G17rB[$4ecad155a8c488ba$var$NAME] = $G17rB.Array;
}

});
parcelRegister("9KY9L", function(module, exports) {
'use strict';

var $eqjq0 = parcelRequire("eqjq0");

var $jlYOp = parcelRequire("jlYOp");

var $G17rB = parcelRequire("G17rB");

var $bSzJU = parcelRequire("bSzJU");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("fOaE1"))(Array, 'Array', function(iterated, kind) {
    this._t = $bSzJU(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $jlYOp(1);
    }
    if (kind == 'keys') return $jlYOp(0, index);
    if (kind == 'values') return $jlYOp(0, O[index]);
    return $jlYOp(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$G17rB.Arguments = $G17rB.Array;
$eqjq0('keys');
$eqjq0('values');
$eqjq0('entries');

});
parcelRegister("eqjq0", function(module, exports) {
module.exports = function() {};

});

parcelRegister("jlYOp", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("7ClSO", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $58bd0e8a021ddf36$export$2d1720544b23b823; }, function (v) { return $58bd0e8a021ddf36$export$2d1720544b23b823 = v; });
var $58bd0e8a021ddf36$export$2d1720544b23b823;

$58bd0e8a021ddf36$export$2d1720544b23b823 = (parcelRequire("fydF3"));

});


parcelRegister("awRwR", function(module, exports) {
parcelRequire("cZq1X");
parcelRequire("aghnC");
parcelRequire("6owPI");
parcelRequire("grJtS");

module.exports = (parcelRequire("aunq5")).Symbol;

});
parcelRegister("cZq1X", function(module, exports) {
'use strict';

var $pnVph = parcelRequire("pnVph");

var $779TT = parcelRequire("779TT");

var $iUvfY = parcelRequire("iUvfY");

var $g45SR = parcelRequire("g45SR");

var $eM6v4 = parcelRequire("eM6v4");

var $32bVO = parcelRequire("32bVO");
var $974f5fb1f22faffb$require$META = $32bVO.KEY;

var $k9mjq = parcelRequire("k9mjq");

var $cjBmO = parcelRequire("cjBmO");

var $fkjfL = parcelRequire("fkjfL");

var $59Ov2 = parcelRequire("59Ov2");

var $fydF3 = parcelRequire("fydF3");

var $7ClSO = parcelRequire("7ClSO");

var $1BYu8 = parcelRequire("1BYu8");

var $d1OTP = parcelRequire("d1OTP");

var $ky93M = parcelRequire("ky93M");

var $gWOKW = parcelRequire("gWOKW");

var $c8vg0 = parcelRequire("c8vg0");

var $f7AII = parcelRequire("f7AII");

var $bSzJU = parcelRequire("bSzJU");

var $jfS6J = parcelRequire("jfS6J");

var $Gbehr = parcelRequire("Gbehr");

var $ey75m = parcelRequire("ey75m");

var $4YQr4 = parcelRequire("4YQr4");

var $b6FJh = parcelRequire("b6FJh");

var $i3Fjk = parcelRequire("i3Fjk");

var $fxtrV = parcelRequire("fxtrV");

var $fmsEx = parcelRequire("fmsEx");
var $974f5fb1f22faffb$var$gOPD = $b6FJh.f;
var $974f5fb1f22faffb$var$dP = $fxtrV.f;
var $974f5fb1f22faffb$var$gOPN = $4YQr4.f;
var $974f5fb1f22faffb$var$$Symbol = $pnVph.Symbol;
var $974f5fb1f22faffb$var$$JSON = $pnVph.JSON;
var $974f5fb1f22faffb$var$_stringify = $974f5fb1f22faffb$var$$JSON && $974f5fb1f22faffb$var$$JSON.stringify;
var $974f5fb1f22faffb$var$PROTOTYPE = 'prototype';
var $974f5fb1f22faffb$var$HIDDEN = $fydF3('_hidden');
var $974f5fb1f22faffb$var$TO_PRIMITIVE = $fydF3('toPrimitive');
var $974f5fb1f22faffb$var$isEnum = {}.propertyIsEnumerable;
var $974f5fb1f22faffb$var$SymbolRegistry = $cjBmO('symbol-registry');
var $974f5fb1f22faffb$var$AllSymbols = $cjBmO('symbols');
var $974f5fb1f22faffb$var$OPSymbols = $cjBmO('op-symbols');
var $974f5fb1f22faffb$var$ObjectProto = Object[$974f5fb1f22faffb$var$PROTOTYPE];
var $974f5fb1f22faffb$var$USE_NATIVE = typeof $974f5fb1f22faffb$var$$Symbol == 'function' && !!$i3Fjk.f;
var $974f5fb1f22faffb$var$QObject = $pnVph.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $974f5fb1f22faffb$var$setter = !$974f5fb1f22faffb$var$QObject || !$974f5fb1f22faffb$var$QObject[$974f5fb1f22faffb$var$PROTOTYPE] || !$974f5fb1f22faffb$var$QObject[$974f5fb1f22faffb$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $974f5fb1f22faffb$var$setSymbolDesc = $iUvfY && $k9mjq(function() {
    return $ey75m($974f5fb1f22faffb$var$dP({}, 'a', {
        get: function() {
            return $974f5fb1f22faffb$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $974f5fb1f22faffb$var$gOPD($974f5fb1f22faffb$var$ObjectProto, key);
    if (protoDesc) delete $974f5fb1f22faffb$var$ObjectProto[key];
    $974f5fb1f22faffb$var$dP(it, key, D);
    if (protoDesc && it !== $974f5fb1f22faffb$var$ObjectProto) $974f5fb1f22faffb$var$dP($974f5fb1f22faffb$var$ObjectProto, key, protoDesc);
} : $974f5fb1f22faffb$var$dP;
var $974f5fb1f22faffb$var$wrap = function(tag) {
    var sym = $974f5fb1f22faffb$var$AllSymbols[tag] = $ey75m($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $974f5fb1f22faffb$var$isSymbol = $974f5fb1f22faffb$var$USE_NATIVE && typeof $974f5fb1f22faffb$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $974f5fb1f22faffb$var$$Symbol;
};
var $974f5fb1f22faffb$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $974f5fb1f22faffb$var$ObjectProto) $974f5fb1f22faffb$var$$defineProperty($974f5fb1f22faffb$var$OPSymbols, key, D);
    $gWOKW(it);
    key = $jfS6J(key, true);
    $gWOKW(D);
    if ($779TT($974f5fb1f22faffb$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$779TT(it, $974f5fb1f22faffb$var$HIDDEN)) $974f5fb1f22faffb$var$dP(it, $974f5fb1f22faffb$var$HIDDEN, $Gbehr(1, {}));
            it[$974f5fb1f22faffb$var$HIDDEN][key] = true;
        } else {
            if ($779TT(it, $974f5fb1f22faffb$var$HIDDEN) && it[$974f5fb1f22faffb$var$HIDDEN][key]) it[$974f5fb1f22faffb$var$HIDDEN][key] = false;
            D = $ey75m(D, {
                enumerable: $Gbehr(0, false)
            });
        }
        return $974f5fb1f22faffb$var$setSymbolDesc(it, key, D);
    }
    return $974f5fb1f22faffb$var$dP(it, key, D);
};
var $974f5fb1f22faffb$var$$defineProperties = function defineProperties(it, P) {
    $gWOKW(it);
    var keys = $d1OTP(P = $bSzJU(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$974f5fb1f22faffb$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $974f5fb1f22faffb$var$$create = function create(it, P) {
    return P === undefined ? $ey75m(it) : $974f5fb1f22faffb$var$$defineProperties($ey75m(it), P);
};
var $974f5fb1f22faffb$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $974f5fb1f22faffb$var$isEnum.call(this, key = $jfS6J(key, true));
    if (this === $974f5fb1f22faffb$var$ObjectProto && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !$779TT($974f5fb1f22faffb$var$OPSymbols, key)) return false;
    return E || !$779TT(this, key) || !$779TT($974f5fb1f22faffb$var$AllSymbols, key) || $779TT(this, $974f5fb1f22faffb$var$HIDDEN) && this[$974f5fb1f22faffb$var$HIDDEN][key] ? E : true;
};
var $974f5fb1f22faffb$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $bSzJU(it);
    key = $jfS6J(key, true);
    if (it === $974f5fb1f22faffb$var$ObjectProto && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !$779TT($974f5fb1f22faffb$var$OPSymbols, key)) return;
    var D = $974f5fb1f22faffb$var$gOPD(it, key);
    if (D && $779TT($974f5fb1f22faffb$var$AllSymbols, key) && !($779TT(it, $974f5fb1f22faffb$var$HIDDEN) && it[$974f5fb1f22faffb$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $974f5fb1f22faffb$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $974f5fb1f22faffb$var$gOPN($bSzJU(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$779TT($974f5fb1f22faffb$var$AllSymbols, key = names[i++]) && key != $974f5fb1f22faffb$var$HIDDEN && key != $974f5fb1f22faffb$require$META) result.push(key);
    return result;
};
var $974f5fb1f22faffb$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $974f5fb1f22faffb$var$ObjectProto;
    var names = $974f5fb1f22faffb$var$gOPN(IS_OP ? $974f5fb1f22faffb$var$OPSymbols : $bSzJU(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($779TT($974f5fb1f22faffb$var$AllSymbols, key = names[i++]) && (IS_OP ? $779TT($974f5fb1f22faffb$var$ObjectProto, key) : true)) result.push($974f5fb1f22faffb$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$974f5fb1f22faffb$var$USE_NATIVE) {
    $974f5fb1f22faffb$var$$Symbol = function Symbol() {
        if (this instanceof $974f5fb1f22faffb$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $59Ov2(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $974f5fb1f22faffb$var$ObjectProto) $set.call($974f5fb1f22faffb$var$OPSymbols, value);
            if ($779TT(this, $974f5fb1f22faffb$var$HIDDEN) && $779TT(this[$974f5fb1f22faffb$var$HIDDEN], tag)) this[$974f5fb1f22faffb$var$HIDDEN][tag] = false;
            $974f5fb1f22faffb$var$setSymbolDesc(this, tag, $Gbehr(1, value));
        };
        if ($iUvfY && $974f5fb1f22faffb$var$setter) $974f5fb1f22faffb$var$setSymbolDesc($974f5fb1f22faffb$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $974f5fb1f22faffb$var$wrap(tag);
    };
    $eM6v4($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $b6FJh.f = $974f5fb1f22faffb$var$$getOwnPropertyDescriptor;
    $fxtrV.f = $974f5fb1f22faffb$var$$defineProperty;
    (parcelRequire("79buJ")).f = $4YQr4.f = $974f5fb1f22faffb$var$$getOwnPropertyNames;
    (parcelRequire("fbjf9")).f = $974f5fb1f22faffb$var$$propertyIsEnumerable;
    $i3Fjk.f = $974f5fb1f22faffb$var$$getOwnPropertySymbols;
    if ($iUvfY && !(parcelRequire("9q93S"))) $eM6v4($974f5fb1f22faffb$var$ObjectProto, 'propertyIsEnumerable', $974f5fb1f22faffb$var$$propertyIsEnumerable, true);
    $7ClSO.f = function(name) {
        return $974f5fb1f22faffb$var$wrap($fydF3(name));
    };
}
$g45SR($g45SR.G + $g45SR.W + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, {
    Symbol: $974f5fb1f22faffb$var$$Symbol
});
for(var $974f5fb1f22faffb$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $974f5fb1f22faffb$var$j = 0; $974f5fb1f22faffb$var$es6Symbols.length > $974f5fb1f22faffb$var$j;)$fydF3($974f5fb1f22faffb$var$es6Symbols[$974f5fb1f22faffb$var$j++]);
for(var $974f5fb1f22faffb$var$wellKnownSymbols = $fmsEx($fydF3.store), $974f5fb1f22faffb$var$k = 0; $974f5fb1f22faffb$var$wellKnownSymbols.length > $974f5fb1f22faffb$var$k;)$1BYu8($974f5fb1f22faffb$var$wellKnownSymbols[$974f5fb1f22faffb$var$k++]);
$g45SR($g45SR.S + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $779TT($974f5fb1f22faffb$var$SymbolRegistry, key += '') ? $974f5fb1f22faffb$var$SymbolRegistry[key] : $974f5fb1f22faffb$var$SymbolRegistry[key] = $974f5fb1f22faffb$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$974f5fb1f22faffb$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $974f5fb1f22faffb$var$SymbolRegistry)if ($974f5fb1f22faffb$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $974f5fb1f22faffb$var$setter = true;
    },
    useSimple: function() {
        $974f5fb1f22faffb$var$setter = false;
    }
});
$g45SR($g45SR.S + $g45SR.F * !$974f5fb1f22faffb$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $974f5fb1f22faffb$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $974f5fb1f22faffb$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $974f5fb1f22faffb$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $974f5fb1f22faffb$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $974f5fb1f22faffb$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $974f5fb1f22faffb$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $974f5fb1f22faffb$var$FAILS_ON_PRIMITIVES = $k9mjq(function() {
    $i3Fjk.f(1);
});
$g45SR($g45SR.S + $g45SR.F * $974f5fb1f22faffb$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $i3Fjk.f($f7AII(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$974f5fb1f22faffb$var$$JSON && $g45SR($g45SR.S + $g45SR.F * (!$974f5fb1f22faffb$var$USE_NATIVE || $k9mjq(function() {
    var S = $974f5fb1f22faffb$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $974f5fb1f22faffb$var$_stringify([
        S
    ]) != '[null]' || $974f5fb1f22faffb$var$_stringify({
        a: S
    }) != '{}' || $974f5fb1f22faffb$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$c8vg0(replacer) && it === undefined || $974f5fb1f22faffb$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$ky93M(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$974f5fb1f22faffb$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $974f5fb1f22faffb$var$_stringify.apply($974f5fb1f22faffb$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE][$974f5fb1f22faffb$var$TO_PRIMITIVE] || (parcelRequire("9szbs"))($974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE], $974f5fb1f22faffb$var$TO_PRIMITIVE, $974f5fb1f22faffb$var$$Symbol[$974f5fb1f22faffb$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$fkjfL($974f5fb1f22faffb$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$fkjfL(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$fkjfL($pnVph.JSON, 'JSON', true);

});
parcelRegister("32bVO", function(module, exports) {

var $235ad05d31a21508$var$META = (parcelRequire("59Ov2"))('meta');

var $c8vg0 = parcelRequire("c8vg0");

var $779TT = parcelRequire("779TT");

var $fxtrV = parcelRequire("fxtrV");
var $235ad05d31a21508$require$setDesc = $fxtrV.f;
var $235ad05d31a21508$var$id = 0;
var $235ad05d31a21508$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $235ad05d31a21508$var$FREEZE = !(parcelRequire("k9mjq"))(function() {
    return $235ad05d31a21508$var$isExtensible(Object.preventExtensions({}));
});
var $235ad05d31a21508$var$setMeta = function(it) {
    $235ad05d31a21508$require$setDesc(it, $235ad05d31a21508$var$META, {
        value: {
            i: 'O' + ++$235ad05d31a21508$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $235ad05d31a21508$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$c8vg0(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$779TT(it, $235ad05d31a21508$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$235ad05d31a21508$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $235ad05d31a21508$var$setMeta(it);
    // return object ID
    }
    return it[$235ad05d31a21508$var$META].i;
};
var $235ad05d31a21508$var$getWeak = function(it, create) {
    if (!$779TT(it, $235ad05d31a21508$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$235ad05d31a21508$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $235ad05d31a21508$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$235ad05d31a21508$var$META].w;
};
// add metadata on freeze-family methods calling
var $235ad05d31a21508$var$onFreeze = function(it) {
    if ($235ad05d31a21508$var$FREEZE && $235ad05d31a21508$var$meta.NEED && $235ad05d31a21508$var$isExtensible(it) && !$779TT(it, $235ad05d31a21508$var$META)) $235ad05d31a21508$var$setMeta(it);
    return it;
};
var $235ad05d31a21508$var$meta = module.exports = {
    KEY: $235ad05d31a21508$var$META,
    NEED: false,
    fastKey: $235ad05d31a21508$var$fastKey,
    getWeak: $235ad05d31a21508$var$getWeak,
    onFreeze: $235ad05d31a21508$var$onFreeze
};

});

parcelRegister("1BYu8", function(module, exports) {

var $pnVph = parcelRequire("pnVph");

var $aunq5 = parcelRequire("aunq5");

var $9q93S = parcelRequire("9q93S");

var $7ClSO = parcelRequire("7ClSO");

var $fxtrV = parcelRequire("fxtrV");
var $12c82a3a21e87666$require$defineProperty = $fxtrV.f;
module.exports = function(name) {
    var $Symbol = $aunq5.Symbol || ($aunq5.Symbol = $9q93S ? {} : $pnVph.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $12c82a3a21e87666$require$defineProperty($Symbol, name, {
        value: $7ClSO.f(name)
    });
};

});

parcelRegister("d1OTP", function(module, exports) {
// all enumerable object keys, includes symbols

var $fmsEx = parcelRequire("fmsEx");

var $i3Fjk = parcelRequire("i3Fjk");

var $fbjf9 = parcelRequire("fbjf9");
module.exports = function(it) {
    var result = $fmsEx(it);
    var getSymbols = $i3Fjk.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $fbjf9.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("ky93M", function(module, exports) {
// 7.2.2 IsArray(argument)

var $cONIx = parcelRequire("cONIx");
module.exports = Array.isArray || function isArray(arg) {
    return $cONIx(arg) == 'Array';
};

});

parcelRegister("4YQr4", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3a0570aae603589a$export$2d1720544b23b823; }, function (v) { return $3a0570aae603589a$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $3a0570aae603589a$export$2d1720544b23b823;

var $bSzJU = parcelRequire("bSzJU");

var $79buJ = parcelRequire("79buJ");
var $3a0570aae603589a$require$gOPN = $79buJ.f;
var $3a0570aae603589a$var$toString = {}.toString;
var $3a0570aae603589a$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $3a0570aae603589a$var$getWindowNames = function(it) {
    try {
        return $3a0570aae603589a$require$gOPN(it);
    } catch (e) {
        return $3a0570aae603589a$var$windowNames.slice();
    }
};
$3a0570aae603589a$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $3a0570aae603589a$var$windowNames && $3a0570aae603589a$var$toString.call(it) == '[object Window]' ? $3a0570aae603589a$var$getWindowNames(it) : $3a0570aae603589a$require$gOPN($bSzJU(it));
};

});
parcelRegister("79buJ", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $53424a41b87ed3aa$export$2d1720544b23b823; }, function (v) { return $53424a41b87ed3aa$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $53424a41b87ed3aa$export$2d1720544b23b823;

var $g7Rv3 = parcelRequire("g7Rv3");

var $53424a41b87ed3aa$var$hiddenKeys = (parcelRequire("eeRfl")).concat('length', 'prototype');
$53424a41b87ed3aa$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $g7Rv3(O, $53424a41b87ed3aa$var$hiddenKeys);
};

});


parcelRegister("b6FJh", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $81609fd4f300f6f5$export$2d1720544b23b823; }, function (v) { return $81609fd4f300f6f5$export$2d1720544b23b823 = v; });
var $81609fd4f300f6f5$export$2d1720544b23b823;

var $fbjf9 = parcelRequire("fbjf9");

var $Gbehr = parcelRequire("Gbehr");

var $bSzJU = parcelRequire("bSzJU");

var $jfS6J = parcelRequire("jfS6J");

var $779TT = parcelRequire("779TT");

var $3EiA3 = parcelRequire("3EiA3");
var $81609fd4f300f6f5$var$gOPD = Object.getOwnPropertyDescriptor;

$81609fd4f300f6f5$export$2d1720544b23b823 = (parcelRequire("iUvfY")) ? $81609fd4f300f6f5$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $bSzJU(O);
    P = $jfS6J(P, true);
    if ($3EiA3) try {
        return $81609fd4f300f6f5$var$gOPD(O, P);
    } catch (e) {}
    if ($779TT(O, P)) return $Gbehr(!$fbjf9.f.call(O, P), O[P]);
};

});


parcelRegister("aghnC", function(module, exports) {

});

parcelRegister("6owPI", function(module, exports) {

(parcelRequire("1BYu8"))('asyncIterator');

});

parcelRegister("grJtS", function(module, exports) {

(parcelRequire("1BYu8"))('observable');

});


parcelRegister("elpuD", function(module, exports) {
parcelRequire("h4Ncr");

module.exports = (parcelRequire("aunq5")).Object.setPrototypeOf;

});
parcelRegister("h4Ncr", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $g45SR = parcelRequire("g45SR");

$g45SR($g45SR.S, 'Object', {
    setPrototypeOf: (parcelRequire("jEtjD")).set
});

});
parcelRegister("jEtjD", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $c8vg0 = parcelRequire("c8vg0");

var $gWOKW = parcelRequire("gWOKW");
var $e4e87e3fa1b0cb0a$var$check = function(O, proto) {
    $gWOKW(O);
    if (!$c8vg0(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("bMm8u"))(Function.call, (parcelRequire("b6FJh")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $e4e87e3fa1b0cb0a$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $e4e87e3fa1b0cb0a$var$check
};

});



parcelRegister("iWNxk", function(module, exports) {
parcelRequire("ewWHt");

var $aunq5 = parcelRequire("aunq5");
var $dcb411b02d87e671$require$$Object = $aunq5.Object;
module.exports = function create(P, D) {
    return $dcb411b02d87e671$require$$Object.create(P, D);
};

});
parcelRegister("ewWHt", function(module, exports) {

var $g45SR = parcelRequire("g45SR");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$g45SR($g45SR.S, 'Object', {
    create: (parcelRequire("ey75m"))
});

});


parcelRegister("ebCsu", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a53fecd73fa4e68d$var$ReactIs, $a53fecd73fa4e68d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("3p0ZA"))();

});
parcelRegister("3p0ZA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $j82M4 = parcelRequire("j82M4");
function $27a479f8b1e67f1c$var$emptyFunction() {}
function $27a479f8b1e67f1c$var$emptyFunctionWithReset() {}
$27a479f8b1e67f1c$var$emptyFunctionWithReset.resetWarningCache = $27a479f8b1e67f1c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $j82M4) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $27a479f8b1e67f1c$var$emptyFunctionWithReset,
        resetWarningCache: $27a479f8b1e67f1c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("j82M4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $ded0ea9b72e1fb62$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $ded0ea9b72e1fb62$var$ReactPropTypesSecret;

});



parcelRegister("2DQiR", function(module, exports) {
typeof navigator !== "undefined" && function(global, factory) {
    module.exports = factory();
}(this, function() {
    'use strict';
    var svgNS = 'http://www.w3.org/2000/svg';
    var locationHref = '';
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker(flag) {
        _useWebWorker = !!flag;
    };
    var getWebWorker = function getWebWorker() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref(value) {
        locationHref = value;
    };
    var getLocationHref = function getLocationHref() {
        return locationHref;
    };
    function createTag(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type);
    }
    function extendPrototype(sources, destination) {
        var i;
        var len = sources.length;
        var sourcePrototype;
        for(i = 0; i < len; i += 1){
            sourcePrototype = sources[i].prototype;
            for(var attr in sourcePrototype)if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
        }
    }
    function getDescriptor(object, prop) {
        return Object.getOwnPropertyDescriptor(object, prop);
    }
    function createProxyFunction(prototype) {
        function ProxyFunction() {}
        ProxyFunction.prototype = prototype;
        return ProxyFunction;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController(audioFactory) {
            this.audios = [];
            this.audioFactory = audioFactory;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController.prototype = {
            addAudio: function addAudio(audio) {
                this.audios.push(audio);
            },
            pause: function pause() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].pause();
            },
            resume: function resume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].resume();
            },
            setRate: function setRate(rateValue) {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].setRate(rateValue);
            },
            createAudio: function createAudio(assetPath) {
                if (this.audioFactory) return this.audioFactory(assetPath);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play() {
                        this.isPlaying = true;
                    },
                    seek: function seek() {
                        this.isPlaying = false;
                    },
                    playing: function playing() {},
                    rate: function rate() {},
                    setVolume: function setVolume() {}
                };
            },
            setAudioFactory: function setAudioFactory(audioFactory) {
                this.audioFactory = audioFactory;
            },
            setVolume: function setVolume(value) {
                this._volume = value;
                this._updateVolume();
            },
            mute: function mute() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume() {
                return this._volume;
            },
            _updateVolume: function _updateVolume() {
                var i;
                var len = this.audios.length;
                for(i = 0; i < len; i += 1)this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray(type, len) {
            var i = 0;
            var arr = [];
            var value;
            switch(type){
                case 'int16':
                case 'uint8c':
                    value = 1;
                    break;
                default:
                    value = 1.1;
                    break;
            }
            for(i = 0; i < len; i += 1)arr.push(value);
            return arr;
        }
        function createTypedArrayFactory(type, len) {
            if (type === 'float32') return new Float32Array(len);
            if (type === 'int16') return new Int16Array(len);
            if (type === 'uint8c') return new Uint8ClampedArray(len);
            return createRegularArray(type, len);
        }
        if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') return createTypedArrayFactory;
        return createRegularArray;
    }();
    function createSizedArray(len) {
        return Array.apply(null, {
            length: len
        });
    }
    function _typeof$6(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$6 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$6(obj);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = '';
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames = [
            'abs',
            'acos',
            'acosh',
            'asin',
            'asinh',
            'atan',
            'atanh',
            'atan2',
            'ceil',
            'cbrt',
            'expm1',
            'clz32',
            'cos',
            'cosh',
            'exp',
            'floor',
            'fround',
            'hypot',
            'imul',
            'log',
            'log1p',
            'log2',
            'log10',
            'max',
            'min',
            'pow',
            'random',
            'round',
            'sign',
            'sin',
            'sinh',
            'sqrt',
            'tan',
            'tanh',
            'trunc',
            'E',
            'LN10',
            'LN2',
            'LOG10E',
            'LOG2E',
            'PI',
            'SQRT1_2',
            'SQRT2'
        ];
        var i;
        var len = propertyNames.length;
        for(i = 0; i < len; i += 1)BMMath[propertyNames[i]] = Math[propertyNames[i]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val) {
        var tOfVal = _typeof$6(val);
        if (tOfVal === 'object' && val.length) {
            var absArr = createSizedArray(val.length);
            var i;
            var len = val.length;
            for(i = 0; i < len; i += 1)absArr[i] = Math.abs(val[i]);
            return absArr;
        }
        return Math.abs(val);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag) {
        _shouldRoundValues = !!flag;
    }
    function bmRnd(value) {
        if (_shouldRoundValues) return Math.round(value);
        return value;
    }
    function styleDiv(element) {
        element.style.position = 'absolute';
        element.style.top = 0;
        element.style.left = 0;
        element.style.display = 'block';
        element.style.transformOrigin = '0 0';
        element.style.webkitTransformOrigin = '0 0';
        element.style.backfaceVisibility = 'visible';
        element.style.webkitBackfaceVisibility = 'visible';
        element.style.transformStyle = 'preserve-3d';
        element.style.webkitTransformStyle = 'preserve-3d';
        element.style.mozTransformStyle = 'preserve-3d';
    }
    function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
        this.type = type;
        this.currentTime = currentTime;
        this.totalTime = totalTime;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type, frameMultiplier) {
        this.type = type;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
        this.type = type;
        this.currentLoop = currentLoop;
        this.totalLoops = totalLoops;
        this.direction = frameMultiplier < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type, firstFrame, totalFrames) {
        this.type = type;
        this.firstFrame = firstFrame;
        this.totalFrames = totalFrames;
    }
    function BMDestroyEvent(type, target) {
        this.type = type;
        this.target = target;
    }
    function BMRenderFrameErrorEvent(nativeError, currentTime) {
        this.type = 'renderFrameError';
        this.nativeError = nativeError;
        this.currentTime = currentTime;
    }
    function BMConfigErrorEvent(nativeError) {
        this.type = 'configError';
        this.nativeError = nativeError;
    }
    function BMAnimationConfigErrorEvent(type, nativeError) {
        this.type = type;
        this.nativeError = nativeError;
    }
    var createElementID = function() {
        var _count = 0;
        return function createID() {
            _count += 1;
            return idPrefix$1 + '__lottie_element_' + _count;
        };
    }();
    function HSVtoRGB(h, s, v) {
        var r;
        var g;
        var b;
        var i;
        var f;
        var p;
        var q;
        var t;
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v;
                g = t;
                b = p;
                break;
            case 1:
                r = q;
                g = v;
                b = p;
                break;
            case 2:
                r = p;
                g = v;
                b = t;
                break;
            case 3:
                r = p;
                g = q;
                b = v;
                break;
            case 4:
                r = t;
                g = p;
                b = v;
                break;
            case 5:
                r = v;
                g = p;
                b = q;
                break;
            default:
                break;
        }
        return [
            r,
            g,
            b
        ];
    }
    function RGBtoHSV(r, g, b) {
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var h;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        switch(max){
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
            default:
                break;
        }
        return [
            h,
            s,
            v
        ];
    }
    function addSaturationToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[1] += offset;
        if (hsv[1] > 1) hsv[1] = 1;
        else if (hsv[1] <= 0) hsv[1] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addBrightnessToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[2] += offset;
        if (hsv[2] > 1) hsv[2] = 1;
        else if (hsv[2] < 0) hsv[2] = 0;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    function addHueToRGB(color, offset) {
        var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
        hsv[0] += offset / 360;
        if (hsv[0] > 1) hsv[0] -= 1;
        else if (hsv[0] < 0) hsv[0] += 1;
        return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
    }
    var rgbToHex = function() {
        var colorMap = [];
        var i;
        var hex;
        for(i = 0; i < 256; i += 1){
            hex = i.toString(16);
            colorMap[i] = hex.length === 1 ? '0' + hex : hex;
        }
        return function(r, g, b) {
            if (r < 0) r = 0;
            if (g < 0) g = 0;
            if (b < 0) b = 0;
            return '#' + colorMap[r] + colorMap[g] + colorMap[b];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled(flag) {
        subframeEnabled = !!flag;
    };
    var getSubframeEnabled = function getSubframeEnabled() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin(value) {
        expressionsPlugin = value;
    };
    var getExpressionsPlugin = function getExpressionsPlugin() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces(value) {
        expressionsInterfaces = value;
    };
    var getExpressionInterfaces = function getExpressionInterfaces() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
        defaultCurveSegments = value;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix(value) {
        idPrefix$1 = value;
    };
    var getIdPrefix = function getIdPrefix() {
        return idPrefix$1;
    };
    function createNS(type) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type);
    }
    function _typeof$5(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$5 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$5(obj);
    }
    var dataManager = function() {
        var _counterId = 1;
        var processes = [];
        var workerFn;
        var workerInstance;
        var workerProxy = {
            onmessage: function onmessage() {},
            postMessage: function postMessage(path) {
                workerFn({
                    data: path
                });
            }
        };
        var _workerSelf = {
            postMessage: function postMessage(data) {
                workerProxy.onmessage({
                    data: data
                });
            }
        };
        function createWorker(fn) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob = new Blob([
                    'var _workerSelf = self; self.onmessage = ',
                    fn.toString()
                ], {
                    type: 'text/javascript'
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url = URL.createObjectURL(blob);
                return new Worker(url);
            }
            workerFn = fn;
            return workerProxy;
        }
        function setupWorker() {
            if (!workerInstance) {
                workerInstance = createWorker(function workerStart(e) {
                    function dataFunctionManager() {
                        function completeLayers(layers, comps) {
                            var layerData;
                            var i;
                            var len = layers.length;
                            var j;
                            var jLen;
                            var k;
                            var kLen;
                            for(i = 0; i < len; i += 1){
                                layerData = layers[i];
                                if ('ks' in layerData && !layerData.completed) {
                                    layerData.completed = true;
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) convertPathsToAbsoluteValues(maskProps[j].pt.k);
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                                                if (maskProps[j].pt.k[k].e) convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData.ty === 0) {
                                        layerData.layers = findCompLayers(layerData.refId, comps);
                                        completeLayers(layerData.layers, comps);
                                    } else if (layerData.ty === 4) completeShapes(layerData.shapes);
                                    else if (layerData.ty === 5) completeText(layerData);
                                }
                            }
                        }
                        function completeChars(chars, assets) {
                            if (chars) {
                                var i = 0;
                                var len = chars.length;
                                for(i = 0; i < len; i += 1)if (chars[i].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers(chars[i].data.layers, assets);
                                }
                            }
                        }
                        function findComp(id, comps) {
                            var i = 0;
                            var len = comps.length;
                            while(i < len){
                                if (comps[i].id === id) return comps[i];
                                i += 1;
                            }
                            return null;
                        }
                        function findCompLayers(id, comps) {
                            var comp = findComp(id, comps);
                            if (comp) {
                                if (!comp.layers.__used) {
                                    comp.layers.__used = true;
                                    return comp.layers;
                                }
                                return JSON.parse(JSON.stringify(comp.layers));
                            }
                            return null;
                        }
                        function completeShapes(arr) {
                            var i;
                            var len = arr.length;
                            var j;
                            var jLen;
                            for(i = len - 1; i >= 0; i -= 1){
                                if (arr[i].ty === 'sh') {
                                    if (arr[i].ks.k.i) convertPathsToAbsoluteValues(arr[i].ks.k);
                                    else {
                                        jLen = arr[i].ks.k.length;
                                        for(j = 0; j < jLen; j += 1){
                                            if (arr[i].ks.k[j].s) convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                                            if (arr[i].ks.k[j].e) convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                                        }
                                    }
                                } else if (arr[i].ty === 'gr') completeShapes(arr[i].it);
                            }
                        }
                        function convertPathsToAbsoluteValues(path) {
                            var i;
                            var len = path.i.length;
                            for(i = 0; i < len; i += 1){
                                path.i[i][0] += path.v[i][0];
                                path.i[i][1] += path.v[i][1];
                                path.o[i][0] += path.v[i][0];
                                path.o[i][1] += path.v[i][1];
                            }
                        }
                        function checkVersion(minimum, animVersionString) {
                            var animVersion = animVersionString ? animVersionString.split('.') : [
                                100,
                                100,
                                100
                            ];
                            if (minimum[0] > animVersion[0]) return true;
                            if (animVersion[0] > minimum[0]) return false;
                            if (minimum[1] > animVersion[1]) return true;
                            if (animVersion[1] > minimum[1]) return false;
                            if (minimum[2] > animVersion[2]) return true;
                            if (animVersion[2] > minimum[2]) return false;
                            return null;
                        }
                        var checkText = function() {
                            var minimumVersion = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer(textLayer) {
                                var documentData = textLayer.t.d;
                                textLayer.t.d = {
                                    k: [
                                        {
                                            s: documentData,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars = function() {
                            var minimumVersion = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData) {
                                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                                    var i;
                                    var len = animationData.chars.length;
                                    for(i = 0; i < len; i += 1){
                                        var charData = animationData.chars[i];
                                        if (charData.data && charData.data.shapes) {
                                            completeShapes(charData.data.shapes);
                                            charData.data.ip = 0;
                                            charData.data.op = 99999;
                                            charData.data.st = 0;
                                            charData.data.sr = 1;
                                            charData.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData.chars[i].t) {
                                                charData.data.shapes.push({
                                                    ty: 'no'
                                                });
                                                charData.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: 'tr'
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties = function() {
                            var minimumVersion = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer(textLayer) {
                                var pathData = textLayer.t.p;
                                if (typeof pathData.a === 'number') pathData.a = {
                                    a: 0,
                                    k: pathData.a
                                };
                                if (typeof pathData.p === 'number') pathData.p = {
                                    a: 0,
                                    k: pathData.p
                                };
                                if (typeof pathData.r === 'number') pathData.r = {
                                    a: 0,
                                    k: pathData.r
                                };
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 5) updateTextLayer(layers[i]);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors = function() {
                            var minimumVersion = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes(shapes) {
                                var i;
                                var len = shapes.length;
                                var j;
                                var jLen;
                                for(i = 0; i < len; i += 1){
                                    if (shapes[i].ty === 'gr') iterateShapes(shapes[i].it);
                                    else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                                        if (shapes[i].c.k && shapes[i].c.k[0].i) {
                                            jLen = shapes[i].c.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (shapes[i].c.k[j].s) {
                                                    shapes[i].c.k[j].s[0] /= 255;
                                                    shapes[i].c.k[j].s[1] /= 255;
                                                    shapes[i].c.k[j].s[2] /= 255;
                                                    shapes[i].c.k[j].s[3] /= 255;
                                                }
                                                if (shapes[i].c.k[j].e) {
                                                    shapes[i].c.k[j].e[0] /= 255;
                                                    shapes[i].c.k[j].e[1] /= 255;
                                                    shapes[i].c.k[j].e[2] /= 255;
                                                    shapes[i].c.k[j].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes[i].c.k[0] /= 255;
                                            shapes[i].c.k[1] /= 255;
                                            shapes[i].c.k[2] /= 255;
                                            shapes[i].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers(layers) {
                                var i;
                                var len = layers.length;
                                for(i = 0; i < len; i += 1)if (layers[i].ty === 4) iterateShapes(layers[i].shapes);
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes = function() {
                            var minimumVersion = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes(arr) {
                                var i;
                                var len = arr.length;
                                var j;
                                var jLen;
                                for(i = len - 1; i >= 0; i -= 1){
                                    if (arr[i].ty === 'sh') {
                                        if (arr[i].ks.k.i) arr[i].ks.k.c = arr[i].closed;
                                        else {
                                            jLen = arr[i].ks.k.length;
                                            for(j = 0; j < jLen; j += 1){
                                                if (arr[i].ks.k[j].s) arr[i].ks.k[j].s[0].c = arr[i].closed;
                                                if (arr[i].ks.k[j].e) arr[i].ks.k[j].e[0].c = arr[i].closed;
                                            }
                                        }
                                    } else if (arr[i].ty === 'gr') completeClosingShapes(arr[i].it);
                                }
                            }
                            function iterateLayers(layers) {
                                var layerData;
                                var i;
                                var len = layers.length;
                                var j;
                                var jLen;
                                var k;
                                var kLen;
                                for(i = 0; i < len; i += 1){
                                    layerData = layers[i];
                                    if (layerData.hasMask) {
                                        var maskProps = layerData.masksProperties;
                                        jLen = maskProps.length;
                                        for(j = 0; j < jLen; j += 1)if (maskProps[j].pt.k.i) maskProps[j].pt.k.c = maskProps[j].cl;
                                        else {
                                            kLen = maskProps[j].pt.k.length;
                                            for(k = 0; k < kLen; k += 1){
                                                if (maskProps[j].pt.k[k].s) maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                                                if (maskProps[j].pt.k[k].e) maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                                            }
                                        }
                                    }
                                    if (layerData.ty === 4) completeClosingShapes(layerData.shapes);
                                }
                            }
                            return function(animationData) {
                                if (checkVersion(minimumVersion, animationData.v)) {
                                    iterateLayers(animationData.layers);
                                    if (animationData.assets) {
                                        var i;
                                        var len = animationData.assets.length;
                                        for(i = 0; i < len; i += 1)if (animationData.assets[i].layers) iterateLayers(animationData.assets[i].layers);
                                    }
                                }
                            };
                        }();
                        function completeData(animationData) {
                            if (animationData.__complete) return;
                            checkColors(animationData);
                            checkText(animationData);
                            checkChars(animationData);
                            checkPathProperties(animationData);
                            checkShapes(animationData);
                            completeLayers(animationData.layers, animationData.assets);
                            completeChars(animationData.chars, animationData.assets);
                            animationData.__complete = true;
                        }
                        function completeText(data) {
                            data.t.a.length === 0 && data.t.p;
                        }
                        var moduleOb = {};
                        moduleOb.completeData = completeData;
                        moduleOb.checkColors = checkColors;
                        moduleOb.checkChars = checkChars;
                        moduleOb.checkPathProperties = checkPathProperties;
                        moduleOb.checkShapes = checkShapes;
                        moduleOb.completeLayers = completeLayers;
                        return moduleOb;
                    }
                    if (!_workerSelf.dataManager) _workerSelf.dataManager = dataFunctionManager();
                    if (!_workerSelf.assetLoader) _workerSelf.assetLoader = function() {
                        function formatResponse(xhr) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader = xhr.getResponseHeader('content-type');
                            if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) return xhr.response;
                            if (xhr.response && _typeof$5(xhr.response) === 'object') return xhr.response;
                            if (xhr.response && typeof xhr.response === 'string') return JSON.parse(xhr.response);
                            if (xhr.responseText) return JSON.parse(xhr.responseText);
                            return null;
                        }
                        function loadAsset(path, fullPath, callback, errorCallback) {
                            var response;
                            var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr.responseType = 'json';
                            } catch (err) {} // eslint-disable-line no-empty
                            xhr.onreadystatechange = function() {
                                if (xhr.readyState === 4) {
                                    if (xhr.status === 200) {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } else try {
                                        response = formatResponse(xhr);
                                        callback(response);
                                    } catch (err) {
                                        if (errorCallback) errorCallback(err);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), path, true);
                            } catch (error) {
                                // Hack to workaround banner validation
                                xhr.open([
                                    'G',
                                    'E',
                                    'T'
                                ].join(''), fullPath + '/' + path, true);
                            }
                            xhr.send();
                        }
                        return {
                            load: loadAsset
                        };
                    }();
                    if (e.data.type === 'loadAnimation') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.dataManager.completeData(data);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                    else if (e.data.type === 'complete') {
                        var animation = e.data.animation;
                        _workerSelf.dataManager.completeData(animation);
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: animation,
                            status: 'success'
                        });
                    } else if (e.data.type === 'loadData') _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function(data) {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            payload: data,
                            status: 'success'
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: e.data.id,
                            status: 'error'
                        });
                    });
                });
                workerInstance.onmessage = function(event) {
                    var data = event.data;
                    var id = data.id;
                    var process = processes[id];
                    processes[id] = null;
                    if (data.status === 'success') process.onComplete(data.payload);
                    else if (process.onError) process.onError();
                };
            }
        }
        function createProcess(onComplete, onError) {
            _counterId += 1;
            var id = 'processId_' + _counterId;
            processes[id] = {
                onComplete: onComplete,
                onError: onError
            };
            return id;
        }
        function loadAnimation(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadAnimation',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function loadData(path, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'loadData',
                path: path,
                fullPath: window.location.origin + window.location.pathname,
                id: processId
            });
        }
        function completeAnimation(anim, onComplete, onError) {
            setupWorker();
            var processId = createProcess(onComplete, onError);
            workerInstance.postMessage({
                type: 'complete',
                animation: anim,
                id: processId
            });
        }
        return {
            loadAnimation: loadAnimation,
            loadData: loadData,
            completeAnimation: completeAnimation
        };
    }();
    var ImagePreloader = function() {
        var proxyImage = function() {
            var canvas = createTag('canvas');
            canvas.width = 1;
            canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = 'rgba(0,0,0,0)';
            ctx.fillRect(0, 0, 1, 1);
            return canvas;
        }();
        function imageLoaded() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath(assetData, assetsPath, originalPath) {
            var path = '';
            if (assetData.e) path = assetData.p;
            else if (assetsPath) {
                var imagePath = assetData.p;
                if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
                path = assetsPath + imagePath;
            } else {
                path = originalPath;
                path += assetData.u ? assetData.u : '';
                path += assetData.p;
            }
            return path;
        }
        function testImageLoaded(img) {
            var _count = 0;
            var intervalId = setInterval((function() {
                var box = img.getBBox();
                if (box.width || _count > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId);
                }
                _count += 1;
            }).bind(this), 50);
        }
        function createImageData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createNS('image');
            if (isSafari) this.testImageLoaded(img);
            else img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);
            if (this._elementHelper.append) this._elementHelper.append(img);
            else this._elementHelper.appendChild(img);
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createImgData(assetData) {
            var path = getAssetsPath(assetData, this.assetsPath, this.path);
            var img = createTag('img');
            img.crossOrigin = 'anonymous';
            img.addEventListener('load', this._imageLoaded, false);
            img.addEventListener('error', (function() {
                ob.img = proxyImage;
                this._imageLoaded();
            }).bind(this), false);
            img.src = path;
            var ob = {
                img: img,
                assetData: assetData
            };
            return ob;
        }
        function createFootageData(data) {
            var ob = {
                assetData: data
            };
            var path = getAssetsPath(data, this.assetsPath, this.path);
            dataManager.loadData(path, (function(footageData) {
                ob.img = footageData;
                this._footageLoaded();
            }).bind(this), (function() {
                ob.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob;
        }
        function loadAssets(assets, cb) {
            this.imagesLoadedCb = cb;
            var i;
            var len = assets.length;
            for(i = 0; i < len; i += 1)if (!assets[i].layers) {
                if (!assets[i].t || assets[i].t === 'seq') {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets[i]));
                } else if (assets[i].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets[i]));
                }
            }
        }
        function setPath(path) {
            this.path = path || '';
        }
        function setAssetsPath(path) {
            this.assetsPath = path || '';
        }
        function getAsset(assetData) {
            var i = 0;
            var len = this.images.length;
            while(i < len){
                if (this.images[i].assetData === assetData) return this.images[i].img;
                i += 1;
            }
            return null;
        }
        function destroy() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType(type, elementHelper) {
            if (type === 'svg') {
                this._elementHelper = elementHelper;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory() {
            this._imageLoaded = imageLoaded.bind(this);
            this._footageLoaded = footageLoaded.bind(this);
            this.testImageLoaded = testImageLoaded.bind(this);
            this.createFootageData = createFootageData.bind(this);
            this.assetsPath = '';
            this.path = '';
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory.prototype = {
            loadAssets: loadAssets,
            setAssetsPath: setAssetsPath,
            setPath: setPath,
            loadedImages: loadedImages,
            loadedFootages: loadedFootages,
            destroy: destroy,
            getAsset: getAsset,
            createImgData: createImgData,
            createImageData: createImageData,
            imageLoaded: imageLoaded,
            footageLoaded: footageLoaded,
            setCacheType: setCacheType
        };
        return ImagePreloaderFactory;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent(eventName, args) {
            if (this._cbs[eventName]) {
                var callbacks = this._cbs[eventName];
                for(var i = 0; i < callbacks.length; i += 1)callbacks[i](args);
            }
        },
        addEventListener: function addEventListener(eventName, callback) {
            if (!this._cbs[eventName]) this._cbs[eventName] = [];
            this._cbs[eventName].push(callback);
            return (function() {
                this.removeEventListener(eventName, callback);
            }).bind(this);
        },
        removeEventListener: function removeEventListener(eventName, callback) {
            if (!callback) this._cbs[eventName] = null;
            else if (this._cbs[eventName]) {
                var i = 0;
                var len = this._cbs[eventName].length;
                while(i < len){
                    if (this._cbs[eventName][i] === callback) {
                        this._cbs[eventName].splice(i, 1);
                        i -= 1;
                        len -= 1;
                    }
                    i += 1;
                }
                if (!this._cbs[eventName].length) this._cbs[eventName] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines(payload) {
            var lines = payload.split('\r\n');
            var keys = {};
            var line;
            var keysCount = 0;
            for(var i = 0; i < lines.length; i += 1){
                line = lines[i].split(':');
                if (line.length === 2) {
                    keys[line[0]] = line[1].trim();
                    keysCount += 1;
                }
            }
            if (keysCount === 0) throw new Error();
            return keys;
        }
        return function(_markers) {
            var markers = [];
            for(var i = 0; i < _markers.length; i += 1){
                var _marker = _markers[i];
                var markerData = {
                    time: _marker.tm,
                    duration: _marker.dr
                };
                try {
                    markerData.payload = JSON.parse(_markers[i].cm);
                } catch (_) {
                    try {
                        markerData.payload = parsePayloadLines(_markers[i].cm);
                    } catch (__) {
                        markerData.payload = {
                            name: _markers[i].cm
                        };
                    }
                }
                markers.push(markerData);
            }
            return markers;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition(comp) {
            this.compositions.push(comp);
        }
        return function() {
            function _thisProjectFunction(name) {
                var i = 0;
                var len = this.compositions.length;
                while(i < len){
                    if (this.compositions[i].data && this.compositions[i].data.nm === name) {
                        if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) this.compositions[i].prepareFrame(this.currentFrame);
                        return this.compositions[i].compInterface;
                    }
                    i += 1;
                }
                return null;
            }
            _thisProjectFunction.compositions = [];
            _thisProjectFunction.currentFrame = 0;
            _thisProjectFunction.registerComposition = registerComposition;
            return _thisProjectFunction;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer(key, value) {
        renderers[key] = value;
    };
    function getRenderer(key) {
        return renderers[key];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return 'canvas';
         // Returns any renderer that is registered
        for(var key in renderers){
            if (renderers[key]) return key;
        }
        return '';
    }
    function _typeof$4(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$4 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$4(obj);
    }
    var AnimationItem = function AnimationItem() {
        this._cbs = [];
        this.name = '';
        this.path = '';
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = '';
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params) {
        if (params.wrapper || params.container) this.wrapper = params.wrapper || params.container;
        var animType = 'svg';
        if (params.animType) animType = params.animType;
        else if (params.renderer) animType = params.renderer;
        var RendererClass = getRenderer(animType);
        this.renderer = new RendererClass(this, params.rendererSettings);
        this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType;
        if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) this.loop = true;
        else if (params.loop === false) this.loop = false;
        else this.loop = parseInt(params.loop, 10);
        this.autoplay = 'autoplay' in params ? params.autoplay : true;
        this.name = params.name ? params.name : '';
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
        this.assetsPath = params.assetsPath;
        this.initialSegment = params.initialSegment;
        if (params.audioFactory) this.audioController.setAudioFactory(params.audioFactory);
        if (params.animationData) this.setupAnimation(params.animationData);
        else if (params.path) {
            if (params.path.lastIndexOf('\\') !== -1) this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
            else this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
            this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
            dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger('data_failed');
    };
    AnimationItem.prototype.setupAnimation = function(data) {
        dataManager.completeAnimation(data, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper, animationData) {
        if (animationData) {
            if (_typeof$4(animationData) !== 'object') animationData = JSON.parse(animationData);
        }
        var params = {
            wrapper: wrapper,
            animationData: animationData
        };
        var wrapperAttributes = wrapper.attributes;
        params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
        params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
        var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
        if (loop === 'false') params.loop = false;
        else if (loop === 'true') params.loop = true;
        else if (loop !== '') params.loop = parseInt(loop, 10);
        var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
        params.autoplay = autoplay !== 'false';
        params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
        var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
         ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
        if (prerender === 'false') params.prerender = false;
        if (!params.path) this.trigger('destroy');
        else this.setParams(params);
    };
    AnimationItem.prototype.includeLayers = function(data) {
        if (data.op > this.animationData.op) {
            this.animationData.op = data.op;
            this.totalFrames = Math.floor(data.op - this.animationData.ip);
        }
        var layers = this.animationData.layers;
        var i;
        var len = layers.length;
        var newLayers = data.layers;
        var j;
        var jLen = newLayers.length;
        for(j = 0; j < jLen; j += 1){
            i = 0;
            while(i < len){
                if (layers[i].id === newLayers[j].id) {
                    layers[i] = newLayers[j];
                    break;
                }
                i += 1;
            }
        }
        if (data.chars || data.fonts) {
            this.renderer.globalData.fontManager.addChars(data.chars);
            this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
        }
        if (data.assets) {
            len = data.assets.length;
            for(i = 0; i < len; i += 1)this.animationData.assets.push(data.assets[i]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data) {
        this.animationData = data;
        var expressionsPlugin = getExpressionsPlugin();
        if (expressionsPlugin) expressionsPlugin.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments = this.animationData.segments;
        if (!segments || segments.length === 0 || !this.autoloadSegments) {
            this.trigger('data_ready');
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment = segments.shift();
        this.timeCompleted = segment.time * this.frameRate;
        var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
        this.segmentPos += 1;
        dataManager.loadData(segmentPath, this.includeLayers.bind(this), (function() {
            this.trigger('data_failed');
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments = this.animationData.segments;
        if (!segments) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger('loaded_images');
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData) {
        if (!this.renderer) return;
        try {
            this.animationData = animData;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData);
            if (!animData.assets) animData.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData.assets);
            this.markers = markerParser(animData.markers || []);
            this.trigger('config_ready');
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error) {
            this.triggerConfigError(error);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin = getExpressionsPlugin();
            if (expressionsPlugin) expressionsPlugin.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger('DOMLoaded');
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width, height) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width = typeof width === 'number' ? width : undefined;
        var _height = typeof height === 'number' ? height : undefined;
        this.renderer.updateContainerSize(_width, _height);
    };
    AnimationItem.prototype.setSubframe = function(flag) {
        this.isSubframeEnabled = !!flag;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger('enterFrame');
        this.renderFrame();
        this.trigger('drawnFrame');
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error) {
            this.triggerRenderFrameError(error);
        }
    };
    AnimationItem.prototype.play = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger('_play');
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger('_active');
            }
        }
    };
    AnimationItem.prototype.pause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger('_pause');
            this._idle = true;
            this.trigger('_idle');
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name) {
        if (name && this.name !== name) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name) {
        if (name && this.name !== name) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName) {
        var marker;
        for(var i = 0; i < this.markers.length; i += 1){
            marker = this.markers[i];
            if (marker.payload && marker.payload.name === markerName) return marker;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) this.goToAndStop(marker.time, true);
        } else if (isFrame) this.setCurrentRawFrameValue(value);
        else this.setCurrentRawFrameValue(value * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value, isFrame, name) {
        if (name && this.name !== name) return;
        var numValue = Number(value);
        if (isNaN(numValue)) {
            var marker = this.getMarkerData(value);
            if (marker) {
                if (!marker.duration) this.goToAndStop(marker.time, true);
                else this.playSegments([
                    marker.time,
                    marker.time + marker.duration
                ], true);
            }
        } else this.goToAndStop(numValue, isFrame, name);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue = this.currentRawFrame + value * this.frameModifier;
        var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
                    _isComplete = true;
                    nextValue = this.totalFrames - 1;
                }
            } else if (nextValue >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger('loopComplete');
                }
            } else this.setCurrentRawFrameValue(nextValue);
        } else if (nextValue < 0) {
            if (!this.checkSegments(nextValue % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger('loopComplete');
                } else {
                    _isComplete = true;
                    nextValue = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue);
        if (_isComplete) {
            this.setCurrentRawFrameValue(nextValue);
            this.pause();
            this.trigger('complete');
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr, offset) {
        this.playCount = 0;
        if (arr[1] < arr[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr[0] - arr[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
        } else if (arr[1] > arr[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr[1] - arr[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr[0];
            this.setCurrentRawFrameValue(0.001 + offset);
        }
        this.trigger('segmentStart');
    };
    AnimationItem.prototype.setSegment = function(init, end) {
        var pendingFrame = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init) pendingFrame = init;
            else if (this.currentRawFrame + this.firstFrame > end) pendingFrame = end - init;
        }
        this.firstFrame = init;
        this.totalFrames = end - init;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame !== -1) this.goToAndStop(pendingFrame, true);
    };
    AnimationItem.prototype.playSegments = function(arr, forceFlag) {
        if (forceFlag) this.segments.length = 0;
        if (_typeof$4(arr[0]) === 'object') {
            var i;
            var len = arr.length;
            for(i = 0; i < len; i += 1)this.segments.push(arr[i]);
        } else this.segments.push(arr);
        if (this.segments.length && forceFlag) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name) {
        if (name && this.name !== name || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger('destroy');
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value) {
        this.currentRawFrame = value;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val) {
        this.playSpeed = val;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val) {
        this.playDirection = val < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping) {
        this.loop = isLooping;
    };
    AnimationItem.prototype.setVolume = function(val, name) {
        if (name && this.name !== name) return;
        this.audioController.setVolume(val);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name) {
        if (name && this.name !== name) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData) {
        var path = '';
        if (assetData.e) path = assetData.p;
        else if (this.assetsPath) {
            var imagePath = assetData.p;
            if (imagePath.indexOf('images/') !== -1) imagePath = imagePath.split('/')[1];
            path = this.assetsPath + imagePath;
        } else {
            path = this.path;
            path += assetData.u ? assetData.u : '';
            path += assetData.p;
        }
        return path;
    };
    AnimationItem.prototype.getAssetData = function(id) {
        var i = 0;
        var len = this.assets.length;
        while(i < len){
            if (id === this.assets[i].id) return this.assets[i];
            i += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame) {
        return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path, documentData, index) {
        try {
            var element = this.renderer.getElementByPath(path);
            element.updateDocumentData(documentData, index);
        } catch (error) {}
    };
    AnimationItem.prototype.trigger = function(name) {
        if (this._cbs && this._cbs[name]) switch(name){
            case 'enterFrame':
                this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case 'drawnFrame':
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name, this.drawnFrameEvent);
                break;
            case 'loopComplete':
                this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
                break;
            case 'complete':
                this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
                break;
            case 'segmentStart':
                this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
                break;
            case 'destroy':
                this.triggerEvent(name, new BMDestroyEvent(name, this));
                break;
            default:
                this.triggerEvent(name);
        }
        if (name === 'enterFrame' && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
        if (name === 'loopComplete' && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
        if (name === 'complete' && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
        if (name === 'segmentStart' && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
        if (name === 'destroy' && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError) {
        var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError) {
        var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
        this.triggerEvent('error', error);
        if (this.onError) this.onError.call(this, error);
    };
    var animationManager = function() {
        var moduleOb = {};
        var registeredAnimations = [];
        var initTime = 0;
        var len = 0;
        var playingAnimationsNum = 0;
        var _stopped = true;
        var _isFrozen = false;
        function removeElement(ev) {
            var i = 0;
            var animItem = ev.target;
            while(i < len){
                if (registeredAnimations[i].animation === animItem) {
                    registeredAnimations.splice(i, 1);
                    i -= 1;
                    len -= 1;
                    if (!animItem.isPaused) subtractPlayingCount();
                }
                i += 1;
            }
        }
        function registerAnimation(element, animationData) {
            if (!element) return null;
            var i = 0;
            while(i < len){
                if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) return registeredAnimations[i].animation;
                i += 1;
            }
            var animItem = new AnimationItem();
            setupAnimation(animItem, element);
            animItem.setData(element, animationData);
            return animItem;
        }
        function getRegisteredAnimations() {
            var i;
            var lenAnims = registeredAnimations.length;
            var animations = [];
            for(i = 0; i < lenAnims; i += 1)animations.push(registeredAnimations[i].animation);
            return animations;
        }
        function addPlayingCount() {
            playingAnimationsNum += 1;
            activate();
        }
        function subtractPlayingCount() {
            playingAnimationsNum -= 1;
        }
        function setupAnimation(animItem, element) {
            animItem.addEventListener('destroy', removeElement);
            animItem.addEventListener('_active', addPlayingCount);
            animItem.addEventListener('_idle', subtractPlayingCount);
            registeredAnimations.push({
                elem: element,
                animation: animItem
            });
            len += 1;
        }
        function loadAnimation(params) {
            var animItem = new AnimationItem();
            setupAnimation(animItem, null);
            animItem.setParams(params);
            return animItem;
        }
        function setSpeed(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setSpeed(val, animation);
        }
        function setDirection(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setDirection(val, animation);
        }
        function play(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.play(animation);
        }
        function resume(nowTime) {
            var elapsedTime = nowTime - initTime;
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.advanceTime(elapsedTime);
            initTime = nowTime;
            if (playingAnimationsNum && !_isFrozen) window.requestAnimationFrame(resume);
            else _stopped = true;
        }
        function first(nowTime) {
            initTime = nowTime;
            window.requestAnimationFrame(resume);
        }
        function pause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.pause(animation);
        }
        function goToAndStop(value, isFrame, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
        }
        function stop(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.stop(animation);
        }
        function togglePause(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.togglePause(animation);
        }
        function destroy(animation) {
            var i;
            for(i = len - 1; i >= 0; i -= 1)registeredAnimations[i].animation.destroy(animation);
        }
        function searchAnimations(animationData, standalone, renderer) {
            var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
            var i;
            var lenAnims = animElements.length;
            for(i = 0; i < lenAnims; i += 1){
                if (renderer) animElements[i].setAttribute('data-bm-type', renderer);
                registerAnimation(animElements[i], animationData);
            }
            if (standalone && lenAnims === 0) {
                if (!renderer) renderer = 'svg';
                var body = document.getElementsByTagName('body')[0];
                body.innerText = '';
                var div = createTag('div');
                div.style.width = '100%';
                div.style.height = '100%';
                div.setAttribute('data-bm-type', renderer);
                body.appendChild(div);
                registerAnimation(div, animationData);
            }
        }
        function resize() {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.resize();
        }
        function activate() {
            if (!_isFrozen && playingAnimationsNum) {
                if (_stopped) {
                    window.requestAnimationFrame(first);
                    _stopped = false;
                }
            }
        }
        function freeze() {
            _isFrozen = true;
        }
        function unfreeze() {
            _isFrozen = false;
            activate();
        }
        function setVolume(val, animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.setVolume(val, animation);
        }
        function mute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.mute(animation);
        }
        function unmute(animation) {
            var i;
            for(i = 0; i < len; i += 1)registeredAnimations[i].animation.unmute(animation);
        }
        moduleOb.registerAnimation = registerAnimation;
        moduleOb.loadAnimation = loadAnimation;
        moduleOb.setSpeed = setSpeed;
        moduleOb.setDirection = setDirection;
        moduleOb.play = play;
        moduleOb.pause = pause;
        moduleOb.stop = stop;
        moduleOb.togglePause = togglePause;
        moduleOb.searchAnimations = searchAnimations;
        moduleOb.resize = resize; // moduleOb.start = start;
        moduleOb.goToAndStop = goToAndStop;
        moduleOb.destroy = destroy;
        moduleOb.freeze = freeze;
        moduleOb.unfreeze = unfreeze;
        moduleOb.setVolume = setVolume;
        moduleOb.mute = mute;
        moduleOb.unmute = unmute;
        moduleOb.getRegisteredAnimations = getRegisteredAnimations;
        return moduleOb;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob = {};
        ob.getBezierEasing = getBezierEasing;
        var beziers = {};
        function getBezierEasing(a, b, c, d, nm) {
            var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');
            if (beziers[str]) return beziers[str];
            var bezEasing = new BezierEasing([
                a,
                b,
                c,
                d
            ]);
            beziers[str] = bezEasing;
            return bezEasing;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS = 4;
        var NEWTON_MIN_SLOPE = 0.001;
        var SUBDIVISION_PRECISION = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS = 10;
        var kSplineTableSize = 11;
        var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
        var float32ArraySupported = typeof Float32Array === 'function';
        function A(aA1, aA2) {
            return 1.0 - 3.0 * aA2 + 3.0 * aA1;
        }
        function B(aA1, aA2) {
            return 3.0 * aA2 - 6.0 * aA1;
        }
        function C(aA1) {
            return 3.0 * aA1;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier(aT, aA1, aA2) {
            return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope(aT, aA1, aA2) {
            return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
        }
        function binarySubdivide(aX, aA, aB, mX1, mX2) {
            var currentX, currentT, i = 0;
            do {
                currentT = aA + (aB - aA) / 2.0;
                currentX = calcBezier(currentT, mX1, mX2) - aX;
                if (currentX > 0.0) aB = currentT;
                else aA = currentT;
            }while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
            return currentT;
        }
        function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
            for(var i = 0; i < NEWTON_ITERATIONS; ++i){
                var currentSlope = getSlope(aGuessT, mX1, mX2);
                if (currentSlope === 0.0) return aGuessT;
                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
                aGuessT -= currentX / currentSlope;
            }
            return aGuessT;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing(points) {
            this._p = points;
            this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing.prototype = {
            get: function get(x) {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX1 === mY1 && mX2 === mY2) return x; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x === 0) return 0;
                if (x === 1) return 1;
                return calcBezier(this._getTForX(x), mY1, mY2);
            },
            // Private part
            _precompute: function _precompute() {
                var mX1 = this._p[0], mY1 = this._p[1], mX2 = this._p[2], mY2 = this._p[3];
                this._precomputed = true;
                if (mX1 !== mY1 || mX2 !== mY2) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues() {
                var mX1 = this._p[0], mX2 = this._p[2];
                for(var i = 0; i < kSplineTableSize; ++i)this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX(aX) {
                var mX1 = this._p[0], mX2 = this._p[2], mSampleValues = this._mSampleValues;
                var intervalStart = 0.0;
                var currentSample = 1;
                var lastSample = kSplineTableSize - 1;
                for(; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample)intervalStart += kSampleStepSize;
                --currentSample; // Interpolate to provide an initial guess for t
                var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
                var guessForT = intervalStart + dist * kSampleStepSize;
                var initialSlope = getSlope(guessForT, mX1, mX2);
                if (initialSlope >= NEWTON_MIN_SLOPE) return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
                if (initialSlope === 0.0) return guessForT;
                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
            }
        };
        return ob;
    }();
    var pooling = function() {
        function _double(arr) {
            return arr.concat(createSizedArray(arr.length));
        }
        return {
            "double": _double
        };
    }();
    var poolFactory = function() {
        return function(initialLength, _create, _release) {
            var _length = 0;
            var _maxLength = initialLength;
            var pool = createSizedArray(_maxLength);
            var ob = {
                newElement: newElement,
                release: release
            };
            function newElement() {
                var element;
                if (_length) {
                    _length -= 1;
                    element = pool[_length];
                } else element = _create();
                return element;
            }
            function release(element) {
                if (_length === _maxLength) {
                    pool = pooling["double"](pool);
                    _maxLength *= 2;
                }
                if (_release) _release(element);
                pool[_length] = element;
                _length += 1;
            }
            return ob;
        };
    }();
    var bezierLengthPool = function() {
        function create() {
            return {
                addedLength: 0,
                percents: createTypedArray('float32', getDefaultCurveSegments()),
                lengths: createTypedArray('float32', getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create);
    }();
    var segmentsLengthPool = function() {
        function create() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release(element) {
            var i;
            var len = element.lengths.length;
            for(i = 0; i < len; i += 1)bezierLengthPool.release(element.lengths[i]);
            element.lengths.length = 0;
        }
        return poolFactory(8, create, release);
    }();
    function bezFunction() {
        var math = Math;
        function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
            var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
            return det1 > -0.001 && det1 < 0.001;
        }
        function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
            if (z1 === 0 && z2 === 0 && z3 === 0) return pointOnLine2D(x1, y1, x2, y2, x3, y3);
            var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
            var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
            var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
            var diffDist;
            if (dist1 > dist2) {
                if (dist1 > dist3) diffDist = dist1 - dist2 - dist3;
                else diffDist = dist3 - dist2 - dist1;
            } else if (dist3 > dist2) diffDist = dist3 - dist2 - dist1;
            else diffDist = dist2 - dist1 - dist3;
            return diffDist > -0.0001 && diffDist < 0.0001;
        }
        var getBezierLength = function() {
            return function(pt1, pt2, pt3, pt4) {
                var curveSegments = getDefaultCurveSegments();
                var k;
                var i;
                var len;
                var ptCoord;
                var perc;
                var addedLength = 0;
                var ptDistance;
                var point = [];
                var lastPoint = [];
                var lengthData = bezierLengthPool.newElement();
                len = pt3.length;
                for(k = 0; k < curveSegments; k += 1){
                    perc = k / (curveSegments - 1);
                    ptDistance = 0;
                    for(i = 0; i < len; i += 1){
                        ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
                        point[i] = ptCoord;
                        if (lastPoint[i] !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        lastPoint[i] = point[i];
                    }
                    if (ptDistance) {
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                    }
                    lengthData.percents[k] = perc;
                    lengthData.lengths[k] = addedLength;
                }
                lengthData.addedLength = addedLength;
                return lengthData;
            };
        }();
        function getSegmentsLength(shapeData) {
            var segmentsLength = segmentsLengthPool.newElement();
            var closed = shapeData.c;
            var pathV = shapeData.v;
            var pathO = shapeData.o;
            var pathI = shapeData.i;
            var i;
            var len = shapeData._length;
            var lengths = segmentsLength.lengths;
            var totalLength = 0;
            for(i = 0; i < len - 1; i += 1){
                lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
                totalLength += lengths[i].addedLength;
            }
            if (closed && len) {
                lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
                totalLength += lengths[i].addedLength;
            }
            segmentsLength.totalLength = totalLength;
            return segmentsLength;
        }
        function BezierData(length) {
            this.segmentLength = 0;
            this.points = new Array(length);
        }
        function PointData(partial, point) {
            this.partialLength = partial;
            this.point = point;
        }
        var buildBezierData = function() {
            var storedData = {};
            return function(pt1, pt2, pt3, pt4) {
                var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');
                if (!storedData[bezierName]) {
                    var curveSegments = getDefaultCurveSegments();
                    var k;
                    var i;
                    var len;
                    var ptCoord;
                    var perc;
                    var addedLength = 0;
                    var ptDistance;
                    var point;
                    var lastPoint = null;
                    if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) curveSegments = 2;
                    var bezierData = new BezierData(curveSegments);
                    len = pt3.length;
                    for(k = 0; k < curveSegments; k += 1){
                        point = createSizedArray(len);
                        perc = k / (curveSegments - 1);
                        ptDistance = 0;
                        for(i = 0; i < len; i += 1){
                            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
                            point[i] = ptCoord;
                            if (lastPoint !== null) ptDistance += bmPow(point[i] - lastPoint[i], 2);
                        }
                        ptDistance = bmSqrt(ptDistance);
                        addedLength += ptDistance;
                        bezierData.points[k] = new PointData(ptDistance, point);
                        lastPoint = point;
                    }
                    bezierData.segmentLength = addedLength;
                    storedData[bezierName] = bezierData;
                }
                return storedData[bezierName];
            };
        }();
        function getDistancePerc(perc, bezierData) {
            var percents = bezierData.percents;
            var lengths = bezierData.lengths;
            var len = percents.length;
            var initPos = bmFloor((len - 1) * perc);
            var lengthPos = perc * bezierData.addedLength;
            var lPerc = 0;
            if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) return percents[initPos];
            var dir = lengths[initPos] > lengthPos ? -1 : 1;
            var flag = true;
            while(flag){
                if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
                    lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
                    flag = false;
                } else initPos += dir;
                if (initPos < 0 || initPos >= len - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos === len - 1) return percents[initPos];
                    flag = false;
                }
            }
            return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
        }
        function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
            var t1 = getDistancePerc(percent, bezierData);
            var u1 = 1 - t1;
            var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
            var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
            return [
                ptX,
                ptY
            ];
        }
        var bezierSegmentPoints = createTypedArray('float32', 8);
        function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
            if (startPerc < 0) startPerc = 0;
            else if (startPerc > 1) startPerc = 1;
            var t0 = getDistancePerc(startPerc, bezierData);
            endPerc = endPerc > 1 ? 1 : endPerc;
            var t1 = getDistancePerc(endPerc, bezierData);
            var i;
            var len = pt1.length;
            var u0 = 1 - t0;
            var u1 = 1 - t1;
            var u0u0u0 = u0 * u0 * u0;
            var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase
            var t0t0t0 = t0 * t0 * t0; //
            var u0u0u1 = u0 * u0 * u1;
            var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase
            var t0t0t1 = t0 * t0 * t1; //
            var u0u1u1 = u0 * u1 * u1;
            var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase
            var t0t1t1 = t0 * t1 * t1; //
            var u1u1u1 = u1 * u1 * u1;
            var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase
            var t1t1t1 = t1 * t1 * t1;
            for(i = 0; i < len; i += 1){
                bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints;
        }
        return {
            getSegmentsLength: getSegmentsLength,
            getNewSegment: getNewSegment,
            getPointInSegment: getPointInSegment,
            buildBezierData: buildBezierData,
            pointOnLine2D: pointOnLine2D,
            pointOnLine3D: pointOnLine3D
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum, caching) {
        var offsetTime = this.offsetTime;
        var newValue;
        if (this.propType === 'multidimensional') newValue = createTypedArray('float32', this.pv.length);
        var iterationIndex = caching.lastIndex;
        var i = iterationIndex;
        var len = this.keyframes.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;
        while(flag){
            keyData = this.keyframes[i];
            nextKeyData = this.keyframes[i + 1];
            if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
                if (keyData.h) keyData = nextKeyData;
                iterationIndex = 0;
                break;
            }
            if (nextKeyData.t - offsetTime > frameNum) {
                iterationIndex = i;
                break;
            }
            if (i < len - 1) i += 1;
            else {
                iterationIndex = 0;
                flag = false;
            }
        }
        keyframeMetadata = this.keyframesMetadata[i] || {};
        var k;
        var kLen;
        var perc;
        var jLen;
        var j;
        var fnc;
        var nextKeyTime = nextKeyData.t - offsetTime;
        var keyTime = keyData.t - offsetTime;
        var endValue;
        if (keyData.to) {
            if (!keyframeMetadata.bezierData) keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
            var bezierData = keyframeMetadata.bezierData;
            if (frameNum >= nextKeyTime || frameNum < keyTime) {
                var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
                kLen = bezierData.points[ind].point.length;
                for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[ind].point[k];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                else {
                    fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
                    keyframeMetadata.__fnct = fnc;
                }
                perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                var distanceInLine = bezierData.segmentLength * perc;
                var segmentPerc;
                var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
                j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
                flag = true;
                jLen = bezierData.points.length;
                while(flag){
                    addedLength += bezierData.points[j].partialLength;
                    if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k];
                        break;
                    } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
                        segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
                        kLen = bezierData.points[j].point.length;
                        for(k = 0; k < kLen; k += 1)newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
                        break;
                    }
                    if (j < jLen - 1) j += 1;
                    else flag = false;
                }
                caching._lastPoint = j;
                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
                caching._lastKeyframeIndex = i;
            }
        } else {
            var outX;
            var outY;
            var inX;
            var inY;
            var keyValue;
            len = keyData.s.length;
            endValue = nextKeyData.s || keyData.e;
            if (this.sh && keyData.h !== 1) {
                if (frameNum >= nextKeyTime) {
                    newValue[0] = endValue[0];
                    newValue[1] = endValue[1];
                    newValue[2] = endValue[2];
                } else if (frameNum <= keyTime) {
                    newValue[0] = keyData.s[0];
                    newValue[1] = keyData.s[1];
                    newValue[2] = keyData.s[2];
                } else {
                    var quatStart = createQuaternion(keyData.s);
                    var quatEnd = createQuaternion(endValue);
                    var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
                    quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
                }
            } else for(i = 0; i < len; i += 1){
                if (keyData.h !== 1) {
                    if (frameNum >= nextKeyTime) perc = 1;
                    else if (frameNum < keyTime) perc = 0;
                    else {
                        if (keyData.o.x.constructor === Array) {
                            if (!keyframeMetadata.__fnct) keyframeMetadata.__fnct = [];
                            if (!keyframeMetadata.__fnct[i]) {
                                outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                                outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                                inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                                inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                                keyframeMetadata.__fnct[i] = fnc;
                            } else fnc = keyframeMetadata.__fnct[i];
                        } else if (!keyframeMetadata.__fnct) {
                            outX = keyData.o.x;
                            outY = keyData.o.y;
                            inX = keyData.i.x;
                            inY = keyData.i.y;
                            fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                            keyData.keyframeMetadata = fnc;
                        } else fnc = keyframeMetadata.__fnct;
                        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
                    }
                }
                endValue = nextKeyData.s || keyData.e;
                keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;
                if (this.propType === 'multidimensional') newValue[i] = keyValue;
                else newValue = keyValue;
            }
        }
        caching.lastIndex = iterationIndex;
        return newValue;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a, b, t) {
        var out = [];
        var ax = a[0];
        var ay = a[1];
        var az = a[2];
        var aw = a[3];
        var bx = b[0];
        var by = b[1];
        var bz = b[2];
        var bw = b[3];
        var omega;
        var cosom;
        var sinom;
        var scale0;
        var scale1;
        cosom = ax * bx + ay * by + az * bz + aw * bw;
        if (cosom < 0.0) {
            cosom = -cosom;
            bx = -bx;
            by = -by;
            bz = -bz;
            bw = -bw;
        }
        if (1.0 - cosom > 0.000001) {
            omega = Math.acos(cosom);
            sinom = Math.sin(omega);
            scale0 = Math.sin((1.0 - t) * omega) / sinom;
            scale1 = Math.sin(t * omega) / sinom;
        } else {
            scale0 = 1.0 - t;
            scale1 = t;
        }
        out[0] = scale0 * ax + scale1 * bx;
        out[1] = scale0 * ay + scale1 * by;
        out[2] = scale0 * az + scale1 * bz;
        out[3] = scale0 * aw + scale1 * bw;
        return out;
    }
    function quaternionToEuler(out, quat) {
        var qx = quat[0];
        var qy = quat[1];
        var qz = quat[2];
        var qw = quat[3];
        var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
        var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
        var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
        out[0] = heading / degToRads;
        out[1] = attitude / degToRads;
        out[2] = bank / degToRads;
    }
    function createQuaternion(values) {
        var heading = values[0] * degToRads;
        var attitude = values[1] * degToRads;
        var bank = values[2] * degToRads;
        var c1 = Math.cos(heading / 2);
        var c2 = Math.cos(attitude / 2);
        var c3 = Math.cos(bank / 2);
        var s1 = Math.sin(heading / 2);
        var s2 = Math.sin(attitude / 2);
        var s3 = Math.sin(bank / 2);
        var w = c1 * c2 * c3 - s1 * s2 * s3;
        var x = s1 * s2 * c3 + c1 * c2 * s3;
        var y = s1 * c2 * c3 + c1 * s2 * s3;
        var z = c1 * s2 * c3 - s1 * c2 * s3;
        return [
            x,
            y,
            z,
            w
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum = this.comp.renderedFrame - this.offsetTime;
        var initTime = this.keyframes[0].t - this.offsetTime;
        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
            if (this._caching.lastFrame >= frameNum) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult = this.interpolateValue(frameNum, this._caching);
            this.pv = renderResult;
        }
        this._caching.lastFrame = frameNum;
        return this.pv;
    }
    function setVValue(val) {
        var multipliedValue;
        if (this.propType === 'unidimensional') {
            multipliedValue = val * this.mult;
            if (mathAbs(this.v - multipliedValue) > 0.00001) {
                this.v = multipliedValue;
                this._mdf = true;
            }
        } else {
            var i = 0;
            var len = this.v.length;
            while(i < len){
                multipliedValue = val[i] * this.mult;
                if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
                    this.v[i] = multipliedValue;
                    this._mdf = true;
                }
                i += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = this.kf ? this.pv : this.data.k;
        for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
        this.setVValue(finalValue);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.mult = mult || 1;
        this.data = data;
        this.v = mult ? data.k * mult : data.k;
        this.pv = data.k;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        this.mult = mult || 1;
        this.data = data;
        this._mdf = false;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i;
        var len = data.k.length;
        this.v = createTypedArray('float32', len);
        this.pv = createTypedArray('float32', len);
        this.vel = createTypedArray('float32', len);
        for(i = 0; i < len; i += 1){
            this.v[i] = data.k[i] * this.mult;
            this.pv[i] = data.k[i];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem, data, mult, container) {
        this.propType = 'unidimensional';
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem, data, mult, container) {
        this.propType = 'multidimensional';
        var i;
        var len = data.k.length;
        var s;
        var e;
        var to;
        var ti;
        for(i = 0; i < len - 1; i += 1)if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
            s = data.k[i].s;
            e = data.k[i + 1].s;
            to = data.k[i].to;
            ti = data.k[i].ti;
            if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
                data.k[i].to = null;
                data.k[i].ti = null;
            }
            if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
                if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
                    data.k[i].to = null;
                    data.k[i].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data;
        this.keyframes = data.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult || 1;
        this.elem = elem;
        this.container = container;
        this.comp = elem.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen = data.k[0].s.length;
        this.v = createTypedArray('float32', arrLen);
        this.pv = createTypedArray('float32', arrLen);
        for(i = 0; i < arrLen; i += 1){
            this.v[i] = initFrame;
            this.pv[i] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray('float32', arrLen)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp(elem, data, type, mult, container) {
            if (data.sid) data = elem.globalData.slotManager.getProp(data);
            var p;
            if (!data.k.length) p = new ValueProperty(elem, data, mult, container);
            else if (typeof data.k[0] === 'number') p = new MultiDimensionalProperty(elem, data, mult, container);
            else switch(type){
                case 0:
                    p = new KeyframedValueProperty(elem, data, mult, container);
                    break;
                case 1:
                    p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
                    break;
                default:
                    break;
            }
            if (p.effectsSequence.length) container.addDynamicProperty(p);
            return p;
        }
        var ob = {
            getProp: getProp
        };
        return ob;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) {
                this.dynamicProperties.push(prop);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties() {
            this._mdf = false;
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1){
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
            this.container = container;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create() {
            return createTypedArray('float32', 2);
        }
        return poolFactory(8, create);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed, len) {
        this.c = closed;
        this.setLength(len);
        var i = 0;
        while(i < len){
            this.v[i] = pointPool.newElement();
            this.o[i] = pointPool.newElement();
            this.i[i] = pointPool.newElement();
            i += 1;
        }
    };
    ShapePath.prototype.setLength = function(len) {
        while(this._maxLength < len)this.doubleArrayLength();
        this._length = len;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
        var arr;
        this._length = Math.max(this._length, pos + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type){
            case 'v':
                arr = this.v;
                break;
            case 'i':
                arr = this.i;
                break;
            case 'o':
                arr = this.o;
                break;
            default:
                arr = [];
                break;
        }
        if (!arr[pos] || arr[pos] && !replace) arr[pos] = pointPool.newElement();
        arr[pos][0] = x;
        arr[pos][1] = y;
    };
    ShapePath.prototype.setTripleAt = function(vX, vY, oX, oY, iX, iY, pos, replace) {
        this.setXYAt(vX, vY, 'v', pos, replace);
        this.setXYAt(oX, oY, 'o', pos, replace);
        this.setXYAt(iX, iY, 'i', pos, replace);
    };
    ShapePath.prototype.reverse = function() {
        var newPath = new ShapePath();
        newPath.setPathData(this.c, this._length);
        var vertices = this.v;
        var outPoints = this.o;
        var inPoints = this.i;
        var init = 0;
        if (this.c) {
            newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
            init = 1;
        }
        var cnt = this._length - 1;
        var len = this._length;
        var i;
        for(i = init; i < len; i += 1){
            newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
            cnt -= 1;
        }
        return newPath;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create() {
            return new ShapePath();
        }
        function release(shapePath) {
            var len = shapePath._length;
            var i;
            for(i = 0; i < len; i += 1){
                pointPool.release(shapePath.v[i]);
                pointPool.release(shapePath.i[i]);
                pointPool.release(shapePath.o[i]);
                shapePath.v[i] = null;
                shapePath.i[i] = null;
                shapePath.o[i] = null;
            }
            shapePath._length = 0;
            shapePath.c = false;
        }
        function clone(shape) {
            var cloned = factory.newElement();
            var i;
            var len = shape._length === undefined ? shape.v.length : shape._length;
            cloned.setLength(len);
            cloned.c = shape.c;
            for(i = 0; i < len; i += 1)cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
            return cloned;
        }
        var factory = poolFactory(4, create, release);
        factory.clone = clone;
        return factory;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i;
        for(i = 0; i < this._length; i += 1)shapePool.release(this.shapes[i]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob = {
            newShapeCollection: newShapeCollection,
            release: release
        };
        var _length = 0;
        var _maxLength = 4;
        var pool = createSizedArray(_maxLength);
        function newShapeCollection() {
            var shapeCollection;
            if (_length) {
                _length -= 1;
                shapeCollection = pool[_length];
            } else shapeCollection = new ShapeCollection();
            return shapeCollection;
        }
        function release(shapeCollection) {
            var i;
            var len = shapeCollection._length;
            for(i = 0; i < len; i += 1)shapePool.release(shapeCollection.shapes[i]);
            shapeCollection._length = 0;
            if (_length === _maxLength) {
                pool = pooling["double"](pool);
                _maxLength *= 2;
            }
            pool[_length] = shapeCollection;
            _length += 1;
        }
        return ob;
    }();
    var ShapePropertyFactory = function() {
        var initFrame = -999999;
        function interpolateShape(frameNum, previousValue, caching) {
            var iterationIndex = caching.lastIndex;
            var keyPropS;
            var keyPropE;
            var isHold;
            var j;
            var k;
            var jLen;
            var kLen;
            var perc;
            var vertexValue;
            var kf = this.keyframes;
            if (frameNum < kf[0].t - this.offsetTime) {
                keyPropS = kf[0].s[0];
                isHold = true;
                iterationIndex = 0;
            } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
                keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold = true;
            } else {
                var i = iterationIndex;
                var len = kf.length - 1;
                var flag = true;
                var keyData;
                var nextKeyData;
                var keyframeMetadata;
                while(flag){
                    keyData = kf[i];
                    nextKeyData = kf[i + 1];
                    if (nextKeyData.t - this.offsetTime > frameNum) break;
                    if (i < len - 1) i += 1;
                    else flag = false;
                }
                keyframeMetadata = this.keyframesMetadata[i] || {};
                isHold = keyData.h === 1;
                iterationIndex = i;
                if (!isHold) {
                    if (frameNum >= nextKeyData.t - this.offsetTime) perc = 1;
                    else if (frameNum < keyData.t - this.offsetTime) perc = 0;
                    else {
                        var fnc;
                        if (keyframeMetadata.__fnct) fnc = keyframeMetadata.__fnct;
                        else {
                            fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
                            keyframeMetadata.__fnct = fnc;
                        }
                        perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
                    }
                    keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
                }
                keyPropS = keyData.s[0];
            }
            jLen = previousValue._length;
            kLen = keyPropS.i[0].length;
            caching.lastIndex = iterationIndex;
            for(j = 0; j < jLen; j += 1)for(k = 0; k < kLen; k += 1){
                vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
                previousValue.i[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
                previousValue.o[j][k] = vertexValue;
                vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
                previousValue.v[j][k] = vertexValue;
            }
        }
        function interpolateShapeCurrentTime() {
            var frameNum = this.comp.renderedFrame - this.offsetTime;
            var initTime = this.keyframes[0].t - this.offsetTime;
            var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame = this._caching.lastFrame;
            if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
                /// /
                this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum;
            return this.pv;
        }
        function resetShape() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual(shape1, shape2) {
            if (shape1._length !== shape2._length || shape1.c !== shape2.c) return false;
            var i;
            var len = shape1._length;
            for(i = 0; i < len; i += 1){
                if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) return false;
            }
            return true;
        }
        function setVValue(newPath) {
            if (!shapesEqual(this.v, newPath)) {
                this.v = shapePool.clone(newPath);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue;
            if (this.kf) finalValue = this.pv;
            else if (this.data.ks) finalValue = this.data.ks.k;
            else finalValue = this.data.pt.k;
            var i;
            var len = this.effectsSequence.length;
            for(i = 0; i < len; i += 1)finalValue = this.effectsSequence[i](finalValue);
            this.setVValue(finalValue);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.container = elem;
            this.elem = elem;
            this.data = data;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData = type === 3 ? data.pt.k : data.ks.k;
            this.v = shapePool.clone(pathData);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape;
            this.effectsSequence = [];
        }
        function addEffect(effectFunction) {
            this.effectsSequence.push(effectFunction);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty.prototype.interpolateShape = interpolateShape;
        ShapeProperty.prototype.getValue = processEffectsSequence;
        ShapeProperty.prototype.setVValue = setVValue;
        ShapeProperty.prototype.addEffect = addEffect;
        function KeyframedShapeProperty(elem, data, type) {
            this.propType = 'shape';
            this.comp = elem.comp;
            this.elem = elem;
            this.container = elem;
            this.offsetTime = elem.data.st;
            this.keyframes = type === 3 ? data.pt.k : data.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame;
            this.reset = resetShape;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime.bind(this)
            ];
        }
        KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
        KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
        KeyframedShapeProperty.prototype.setVValue = setVValue;
        KeyframedShapeProperty.prototype.addEffect = addEffect;
        var EllShapeProperty = function() {
            var cPoint = roundCorner;
            function EllShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data.d;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var s0 = this.s.v[0] / 2;
                    var s1 = this.s.v[1] / 2;
                    var _cw = this.d !== 3;
                    var _v = this.v;
                    _v.v[0][0] = p0;
                    _v.v[0][1] = p1 - s1;
                    _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.v[1][1] = p1;
                    _v.v[2][0] = p0;
                    _v.v[2][1] = p1 + s1;
                    _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.v[3][1] = p1;
                    _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.i[0][1] = p1 - s1;
                    _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.i[1][1] = p1 - s1 * cPoint;
                    _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.i[2][1] = p1 + s1;
                    _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.i[3][1] = p1 + s1 * cPoint;
                    _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
                    _v.o[0][1] = p1 - s1;
                    _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
                    _v.o[1][1] = p1 + s1 * cPoint;
                    _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
                    _v.o[2][1] = p1 + s1;
                    _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
                    _v.o[3][1] = p1 - s1 * cPoint;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory);
            return EllShapePropertyFactory;
        }();
        var StarShapeProperty = function() {
            function StarShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem;
                this.comp = elem.comp;
                this.data = data;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                if (data.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory.prototype = {
                reset: resetShape,
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath() {
                    var numPts = Math.floor(this.pt.v) * 2;
                    var angle = Math.PI * 2 / numPts;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag = true;
                    var longRad = this.or.v;
                    var shortRad = this.ir.v;
                    var longRound = this.os.v;
                    var shortRound = this.is.v;
                    var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
                    var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
                    var i;
                    var rad;
                    var roundness;
                    var perimSegment;
                    var currentAng = -Math.PI / 2;
                    currentAng += this.r.v;
                    var dir = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        rad = longFlag ? longRad : shortRad;
                        roundness = longFlag ? longRound : shortRound;
                        perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag = !longFlag;
                        currentAng += angle * dir;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath() {
                    var numPts = Math.floor(this.pt.v);
                    var angle = Math.PI * 2 / numPts;
                    var rad = this.or.v;
                    var roundness = this.os.v;
                    var perimSegment = 2 * Math.PI * rad / (numPts * 4);
                    var i;
                    var currentAng = -Math.PI * 0.5;
                    var dir = this.data.d === 3 ? -1 : 1;
                    currentAng += this.r.v;
                    this.v._length = 0;
                    for(i = 0; i < numPts; i += 1){
                        var x = rad * Math.cos(currentAng);
                        var y = rad * Math.sin(currentAng);
                        var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
                        var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
                        x += +this.p.v[0];
                        y += +this.p.v[1];
                        this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
                        currentAng += angle * dir;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory);
            return StarShapePropertyFactory;
        }();
        var RectShapeProperty = function() {
            function RectShapePropertyFactory(elem, data) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem;
                this.comp = elem.comp;
                this.frameId = -1;
                this.d = data.d;
                this.initDynamicPropertyContainer(elem);
                this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory.prototype = {
                convertRectToPath: function convertRectToPath() {
                    var p0 = this.p.v[0];
                    var p1 = this.p.v[1];
                    var v0 = this.s.v[0] / 2;
                    var v1 = this.s.v[1] / 2;
                    var round = bmMin(v0, v1, this.r.v);
                    var cPoint = round * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
                        this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
                        }
                    } else {
                        this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);
                        if (round !== 0) {
                            this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
                            this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
                            this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
                            this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
                        } else {
                            this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
                            this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
                            this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
                        }
                    }
                },
                getValue: function getValue() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory);
            return RectShapePropertyFactory;
        }();
        function getShapeProp(elem, data, type) {
            var prop;
            if (type === 3 || type === 4) {
                var dataProp = type === 3 ? data.pt : data.ks;
                var keys = dataProp.k;
                if (keys.length) prop = new KeyframedShapeProperty(elem, data, type);
                else prop = new ShapeProperty(elem, data, type);
            } else if (type === 5) prop = new RectShapeProperty(elem, data);
            else if (type === 6) prop = new EllShapeProperty(elem, data);
            else if (type === 7) prop = new StarShapeProperty(elem, data);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        }
        function getConstructorFunction() {
            return ShapeProperty;
        }
        function getKeyframedConstructorFunction() {
            return KeyframedShapeProperty;
        }
        var ob = {};
        ob.getShapeProp = getShapeProp;
        ob.getConstructorFunction = getConstructorFunction;
        ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
        return ob;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos = Math.cos;
        var _sin = Math.sin;
        var _tan = Math.tan;
        var _rnd = Math.round;
        function reset() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
        }
        function rotateY(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
        }
        function rotateZ(angle) {
            if (angle === 0) return this;
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear(sx, sy) {
            return this._t(1, sy, sx, 1, 0, 0);
        }
        function skew(ax, ay) {
            return this.shear(_tan(ax), _tan(ay));
        }
        function skewFromAxis(ax, angle) {
            var mCos = _cos(angle);
            var mSin = _sin(angle);
            return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale(sx, sy, sz) {
            if (!sz && sz !== 0) sz = 1;
            if (sx === 1 && sy === 1 && sz === 1) return this;
            return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
        }
        function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
            this.props[0] = a;
            this.props[1] = b;
            this.props[2] = c;
            this.props[3] = d;
            this.props[4] = e;
            this.props[5] = f;
            this.props[6] = g;
            this.props[7] = h;
            this.props[8] = i;
            this.props[9] = j;
            this.props[10] = k;
            this.props[11] = l;
            this.props[12] = m;
            this.props[13] = n;
            this.props[14] = o;
            this.props[15] = p;
            return this;
        }
        function translate(tx, ty, tz) {
            tz = tz || 0;
            if (tx !== 0 || ty !== 0 || tz !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
            return this;
        }
        function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
            var _p = this.props;
            if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p[12] = _p[12] * a2 + _p[15] * m2;
                _p[13] = _p[13] * f2 + _p[15] * n2;
                _p[14] = _p[14] * k2 + _p[15] * o2;
                _p[15] *= p2; // }
                this._identityCalculated = false;
                return this;
            }
            var a1 = _p[0];
            var b1 = _p[1];
            var c1 = _p[2];
            var d1 = _p[3];
            var e1 = _p[4];
            var f1 = _p[5];
            var g1 = _p[6];
            var h1 = _p[7];
            var i1 = _p[8];
            var j1 = _p[9];
            var k1 = _p[10];
            var l1 = _p[11];
            var m1 = _p[12];
            var n1 = _p[13];
            var o1 = _p[14];
            var p1 = _p[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
            _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
            _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
            _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
            _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
            _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
            _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
            _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
            _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
            _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
            _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
            _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
            _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
            _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
            _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
            _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
            this._identityCalculated = false;
            return this;
        }
        function multiply(matrix) {
            var matrixProps = matrix.props;
            return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
        }
        function isIdentity() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals(matr) {
            var i = 0;
            while(i < 16){
                if (matr.props[i] !== this.props[i]) return false;
                i += 1;
            }
            return true;
        }
        function clone(matr) {
            var i;
            for(i = 0; i < 16; i += 1)matr.props[i] = this.props[i];
            return matr;
        }
        function cloneFromProps(props) {
            var i;
            for(i = 0; i < 16; i += 1)this.props[i] = props[i];
        }
        function applyToPoint(x, y, z) {
            return {
                x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX(x, y, z) {
            return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
        }
        function applyToY(x, y, z) {
            return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
        }
        function applyToZ(x, y, z) {
            return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
        }
        function getInverseMatrix() {
            var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a = this.props[5] / determinant;
            var b = -this.props[1] / determinant;
            var c = -this.props[4] / determinant;
            var d = this.props[0] / determinant;
            var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
            var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
            var inverseMatrix = new Matrix();
            inverseMatrix.props[0] = a;
            inverseMatrix.props[1] = b;
            inverseMatrix.props[4] = c;
            inverseMatrix.props[5] = d;
            inverseMatrix.props[12] = e;
            inverseMatrix.props[13] = f;
            return inverseMatrix;
        }
        function inversePoint(pt) {
            var inverseMatrix = this.getInverseMatrix();
            return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
        }
        function inversePoints(pts) {
            var i;
            var len = pts.length;
            var retPts = [];
            for(i = 0; i < len; i += 1)retPts[i] = inversePoint(pts[i]);
            return retPts;
        }
        function applyToTriplePoints(pt1, pt2, pt3) {
            var arr = createTypedArray('float32', 6);
            if (this.isIdentity()) {
                arr[0] = pt1[0];
                arr[1] = pt1[1];
                arr[2] = pt2[0];
                arr[3] = pt2[1];
                arr[4] = pt3[0];
                arr[5] = pt3[1];
            } else {
                var p0 = this.props[0];
                var p1 = this.props[1];
                var p4 = this.props[4];
                var p5 = this.props[5];
                var p12 = this.props[12];
                var p13 = this.props[13];
                arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
                arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
                arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
                arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
                arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
                arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
            }
            return arr;
        }
        function applyToPointArray(x, y, z) {
            var arr;
            if (this.isIdentity()) arr = [
                x,
                y,
                z
            ];
            else arr = [
                x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
                x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
                x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
            ];
            return arr;
        }
        function applyToPointStringified(x, y) {
            if (this.isIdentity()) return x + ',' + y;
            var _p = this.props;
            return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
        }
        function toCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i = 0;
            var props = this.props;
            var cssValue = 'matrix3d(';
            var v = 10000;
            while(i < 16){
                cssValue += _rnd(props[i] * v) / v;
                cssValue += i === 15 ? ')' : ',';
                i += 1;
            }
            return cssValue;
        }
        function roundMatrixProperty(val) {
            var v = 10000;
            if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) return _rnd(val * v) / v;
            return val;
        }
        function to2dCSS() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props = this.props;
            var _a = roundMatrixProperty(props[0]);
            var _b = roundMatrixProperty(props[1]);
            var _c = roundMatrixProperty(props[4]);
            var _d = roundMatrixProperty(props[5]);
            var _e = roundMatrixProperty(props[12]);
            var _f = roundMatrixProperty(props[13]);
            return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
        }
        return function() {
            this.reset = reset;
            this.rotate = rotate;
            this.rotateX = rotateX;
            this.rotateY = rotateY;
            this.rotateZ = rotateZ;
            this.skew = skew;
            this.skewFromAxis = skewFromAxis;
            this.shear = shear;
            this.scale = scale;
            this.setTransform = setTransform;
            this.translate = translate;
            this.transform = transform;
            this.multiply = multiply;
            this.applyToPoint = applyToPoint;
            this.applyToX = applyToX;
            this.applyToY = applyToY;
            this.applyToZ = applyToZ;
            this.applyToPointArray = applyToPointArray;
            this.applyToTriplePoints = applyToTriplePoints;
            this.applyToPointStringified = applyToPointStringified;
            this.toCSS = toCSS;
            this.to2dCSS = to2dCSS;
            this.clone = clone;
            this.cloneFromProps = cloneFromProps;
            this.equals = equals;
            this.inversePoints = inversePoints;
            this.inversePoint = inversePoint;
            this.getInverseMatrix = getInverseMatrix;
            this._t = this.transform;
            this.isIdentity = isIdentity;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray('float32', 16);
            this.reset();
        };
    }();
    function _typeof$3(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$3 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$3(obj);
    }
    var lottie = {};
    var standalone = '__[STANDALONE]__';
    var animationData = '__[ANIMATIONDATA]__';
    var renderer = '';
    function setLocation(href) {
        setLocationHref(href);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag) {
        setSubframeEnabled(flag);
    }
    function setPrefix(prefix) {
        setIdPrefix(prefix);
    }
    function loadAnimation(params) {
        if (standalone === true) params.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params);
    }
    function setQuality(value) {
        if (typeof value === 'string') switch(value){
            case 'high':
                setDefaultCurveSegments(200);
                break;
            default:
            case 'medium':
                setDefaultCurveSegments(50);
                break;
            case 'low':
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value) && value > 1) setDefaultCurveSegments(value);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== 'undefined';
    }
    function installPlugin(type, plugin) {
        if (type === 'expressions') setExpressionsPlugin(plugin);
    }
    function getFactory(name) {
        switch(name){
            case 'propertyFactory':
                return PropertyFactory;
            case 'shapePropertyFactory':
                return ShapePropertyFactory;
            case 'matrix':
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = '5.12.2';
    function checkReady() {
        if (document.readyState === 'complete') {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable) {
        var vars = queryString.split('&');
        for(var i = 0; i < vars.length; i += 1){
            var pair = vars[i].split('=');
            if (decodeURIComponent(pair[0]) == variable) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair[1]);
        }
        return null;
    }
    var queryString = '';
    if (standalone) {
        var scripts = document.getElementsByTagName('script');
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ''
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable('renderer');
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === 'object' && true) && !(typeof define === 'function' && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob = {};
        var modifiers = {};
        ob.registerModifier = registerModifier;
        ob.getModifier = getModifier;
        function registerModifier(nm, factory) {
            if (!modifiers[nm]) modifiers[nm] = factory;
        }
        function getModifier(nm, elem, data) {
            return new modifiers[nm](elem, data);
        }
        return ob;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data.sh.container.addDynamicProperty(data.sh);
            var shapeData = {
                shape: data.sh,
                data: data,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData);
            this.addShapeToModifier(shapeData);
            if (this._isAnimated) data.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem, data) {
        this.shapes = [];
        this.elem = elem;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, data);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem, data) {
        this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData) {
        shapeData.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
        var segments = [];
        if (e <= 1) segments.push({
            s: s,
            e: e
        });
        else if (s >= 1) segments.push({
            s: s - 1,
            e: e - 1
        });
        else {
            segments.push({
                s: s,
                e: 1
            });
            segments.push({
                s: 0,
                e: e - 1
            });
        }
        var shapeSegments = [];
        var i;
        var len = segments.length;
        var segmentOb;
        for(i = 0; i < len; i += 1){
            segmentOb = segments[i];
            if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
                var shapeS;
                var shapeE;
                if (segmentOb.s * totalModifierLength <= addedLength) shapeS = 0;
                else shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
                if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) shapeE = 1;
                else shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
                shapeSegments.push([
                    shapeS,
                    shapeE
                ]);
            }
        }
        if (!shapeSegments.length) shapeSegments.push([
            0,
            0
        ]);
        return shapeSegments;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData) {
        var i;
        var len = pathsData.length;
        for(i = 0; i < len; i += 1)segmentsLengthPool.release(pathsData[i]);
        pathsData.length = 0;
        return pathsData;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame) {
        var s;
        var e;
        if (this._mdf || _isFirstFrame) {
            var o = this.o.v % 360 / 360;
            if (o < 0) o += 1;
            if (this.s.v > 1) s = 1 + o;
            else if (this.s.v < 0) s = 0 + o;
            else s = this.s.v + o;
            if (this.e.v > 1) e = 1 + o;
            else if (this.e.v < 0) e = 0 + o;
            else e = this.e.v + o;
            if (s > e) {
                var _s = s;
                s = e;
                e = _s;
            }
            s = Math.round(s * 10000) * 0.0001;
            e = Math.round(e * 10000) * 0.0001;
            this.sValue = s;
            this.eValue = e;
        } else {
            s = this.sValue;
            e = this.eValue;
        }
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var pathsData;
        var pathData;
        var totalShapeLength;
        var totalModifierLength = 0;
        if (e === s) for(i = 0; i < len; i += 1){
            this.shapes[i].localShapeCollection.releaseShapes();
            this.shapes[i].shape._mdf = true;
            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
            if (this._mdf) this.shapes[i].pathsData.length = 0;
        }
        else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
            var segments = [];
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) shapeData.shape.paths = shapeData.localShapeCollection;
                else {
                    shapePaths = shapeData.shape.paths;
                    jLen = shapePaths._length;
                    totalShapeLength = 0;
                    if (!shapeData.shape._mdf && shapeData.pathsData.length) totalShapeLength = shapeData.totalShapeLength;
                    else {
                        pathsData = this.releasePathsData(shapeData.pathsData);
                        for(j = 0; j < jLen; j += 1){
                            pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
                            pathsData.push(pathData);
                            totalShapeLength += pathData.totalLength;
                        }
                        shapeData.totalShapeLength = totalShapeLength;
                        shapeData.pathsData = pathsData;
                    }
                    totalModifierLength += totalShapeLength;
                    shapeData.shape._mdf = true;
                }
            }
            var shapeS = s;
            var shapeE = e;
            var addedLength = 0;
            var edges;
            for(i = len - 1; i >= 0; i -= 1){
                shapeData = this.shapes[i];
                if (shapeData.shape._mdf) {
                    localShapeCollection = shapeData.localShapeCollection;
                    localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len > 1) {
                        edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
                        addedLength += shapeData.totalShapeLength;
                    } else edges = [
                        [
                            shapeS,
                            shapeE
                        ]
                    ];
                    jLen = edges.length;
                    for(j = 0; j < jLen; j += 1){
                        shapeS = edges[j][0];
                        shapeE = edges[j][1];
                        segments.length = 0;
                        if (shapeE <= 1) segments.push({
                            s: shapeData.totalShapeLength * shapeS,
                            e: shapeData.totalShapeLength * shapeE
                        });
                        else if (shapeS >= 1) segments.push({
                            s: shapeData.totalShapeLength * (shapeS - 1),
                            e: shapeData.totalShapeLength * (shapeE - 1)
                        });
                        else {
                            segments.push({
                                s: shapeData.totalShapeLength * shapeS,
                                e: shapeData.totalShapeLength
                            });
                            segments.push({
                                s: 0,
                                e: shapeData.totalShapeLength * (shapeE - 1)
                            });
                        }
                        var newShapesData = this.addShapes(shapeData, segments[0]);
                        if (segments[0].s !== segments[0].e) {
                            if (segments.length > 1) {
                                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];
                                if (lastShapeInCollection.c) {
                                    var lastShape = newShapesData.pop();
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                                } else {
                                    this.addPaths(newShapesData, localShapeCollection);
                                    newShapesData = this.addShapes(shapeData, segments[1]);
                                }
                            }
                            this.addPaths(newShapesData, localShapeCollection);
                        }
                    }
                    shapeData.shape.paths = localShapeCollection;
                }
            }
        } else if (this._mdf) for(i = 0; i < len; i += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i].pathsData.length = 0;
            this.shapes[i].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
        var i;
        var len = newPaths.length;
        for(i = 0; i < len; i += 1)localShapeCollection.addShape(newPaths[i]);
    };
    TrimModifier.prototype.addSegment = function(pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
        shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
        shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
        shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points, shapePath, pos, newShape) {
        shapePath.setXYAt(points[1], points[5], 'o', pos);
        shapePath.setXYAt(points[2], points[6], 'i', pos + 1);
        if (newShape) shapePath.setXYAt(points[0], points[4], 'v', pos);
        shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath) {
        var pathsData = shapeData.pathsData;
        var shapePaths = shapeData.shape.paths.shapes;
        var i;
        var len = shapeData.shape.paths._length;
        var j;
        var jLen;
        var addedLength = 0;
        var currentLengthData;
        var segmentCount;
        var lengths;
        var segment;
        var shapes = [];
        var initPos;
        var newShape = true;
        if (!shapePath) {
            shapePath = shapePool.newElement();
            segmentCount = 0;
            initPos = 0;
        } else {
            segmentCount = shapePath._length;
            initPos = shapePath._length;
        }
        shapes.push(shapePath);
        for(i = 0; i < len; i += 1){
            lengths = pathsData[i].lengths;
            shapePath.c = shapePaths[i].c;
            jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
            for(j = 1; j < jLen; j += 1){
                currentLengthData = lengths[j - 1];
                if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
                    addedLength += currentLengthData.addedLength;
                    shapePath.c = false;
                } else if (addedLength > shapeSegment.e) {
                    shapePath.c = false;
                    break;
                } else {
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                    addedLength += currentLengthData.addedLength;
                    segmentCount += 1;
                }
            }
            if (shapePaths[i].c && lengths.length) {
                currentLengthData = lengths[j - 1];
                if (addedLength <= shapeSegment.e) {
                    var segmentLength = lengths[j - 1].addedLength;
                    if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
                        this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
                        newShape = false;
                    } else {
                        segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
                        this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape = false;
                        shapePath.c = false;
                    }
                } else shapePath.c = false;
                addedLength += currentLengthData.addedLength;
                segmentCount += 1;
            }
            if (shapePath._length) {
                shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
                shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
            }
            if (addedLength > shapeSegment.e) break;
            if (i < len - 1) {
                shapePath = shapePool.newElement();
                newShape = true;
                shapes.push(shapePath);
                segmentCount = 0;
            }
        }
        return shapes;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path, amount) {
        var percent = amount / 100;
        var centerPoint = [
            0,
            0
        ];
        var pathLength = path._length;
        var i = 0;
        for(i = 0; i < pathLength; i += 1){
            centerPoint[0] += path.v[i][0];
            centerPoint[1] += path.v[i][1];
        }
        centerPoint[0] /= pathLength;
        centerPoint[1] /= pathLength;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < pathLength; i += 1){
            vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
            vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
            oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
            oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
            iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
            iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
            clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
        }
        return clonedPath;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector = [
            0,
            0
        ];
        function applyToMatrix(mat) {
            var _mdf = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf;
            if (this.a) mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat.rotate(-this.r.v);
            else mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat.translate(this.px.v, this.py.v, -this.pz.v);
                else mat.translate(this.px.v, this.py.v, 0);
            } else mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys(forceRender) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender) {
                var frameRate;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v1;
                    var v2;
                    frameRate = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
                            v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
                            v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
                        } else {
                            v1 = this.p.pv;
                            v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v1 = [];
                        v2 = [];
                        var px = this.px;
                        var py = this.py;
                        if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
                            v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
                            v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
                            v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
                            v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
                        } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
                            v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
                            v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
                            v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
                            v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
                        } else {
                            v1 = [
                                px.pv,
                                py.pv
                            ];
                            v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
                            v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
                        }
                    } else {
                        v2 = defaultVector;
                        v1 = v2;
                    }
                    this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix() {
            this.appliedTransformations = 0;
            this.pre.reset();
            if (!this.a.effectsSequence.length) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty(prop) {
            this._addDynamicProperty(prop);
            this.elem.addDynamicProperty(prop);
            this._isDirty = true;
        }
        function TransformProperty(elem, data, container) {
            this.elem = elem;
            this.frameId = -1;
            this.propType = 'transform';
            this.data = data;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container || elem);
            if (data.p && data.p.s) {
                this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);
                if (data.p.z) this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem, data.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data.rx) {
                this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);
                if (data.or.k[0].ti) {
                    var i;
                    var len = data.or.k.length;
                    for(i = 0; i < len; i += 1){
                        data.or.k[i].to = null;
                        data.or.k[i].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem, data.r || {
                k: 0
            }, 0, degToRads, this);
            if (data.sk) {
                this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem, data.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data.o) this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty.prototype = {
            applyToMatrix: applyToMatrix,
            getValue: processKeys,
            precalculateMatrix: precalculateMatrix,
            autoOrient: autoOrient
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty);
        TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
        TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty(elem, data, container) {
            return new TransformProperty(elem, data, container);
        }
        return {
            getTransformProperty: getTransformProperty
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
        this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
        this.data = data;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv) {
        var dir = inv ? -1 : 1;
        var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
        var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
        pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
        rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        rMatrix.rotate(-transform.r.v * dir * perc);
        rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
        sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
        sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
        sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData) {
        this.elem = elem;
        this.arr = arr;
        this.pos = pos;
        this.elemsData = elemsData;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.initModifierProperties(elem, arr[pos]);
        while(pos > 0){
            pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr[pos]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._processed = false;
            if (elements[i].ty === 'gr') this.resetElements(elements[i].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements) {
        var newElements = JSON.parse(JSON.stringify(elements));
        this.resetElements(newElements);
        return newElements;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
        var i;
        var len = elements.length;
        for(i = 0; i < len; i += 1){
            elements[i]._render = renderFlag;
            if (elements[i].ty === 'gr') this.changeGroupRender(elements[i].it, renderFlag);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame) {
        var items;
        var itemsTransform;
        var i;
        var dir;
        var cont;
        var hasReloaded = false;
        if (this._mdf || _isFirstFrame) {
            var copies = Math.ceil(this.c.v);
            if (this._groups.length < copies) {
                while(this._groups.length < copies){
                    var group = {
                        it: this.cloneElements(this._elements),
                        ty: 'gr'
                    };
                    group.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: 'Transform',
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: 'tr'
                    });
                    this.arr.splice(0, 0, group);
                    this._groups.splice(0, 0, group);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded = true;
            }
            cont = 0;
            var renderFlag;
            for(i = 0; i <= this._groups.length - 1; i += 1){
                renderFlag = cont < copies;
                this._groups[i]._render = renderFlag;
                this.changeGroupRender(this._groups[i].it, renderFlag);
                if (!renderFlag) {
                    var elems = this.elemsData[i].it;
                    var transformData = elems[elems.length - 1];
                    if (transformData.transform.op.v !== 0) {
                        transformData.transform.op._mdf = true;
                        transformData.transform.op.v = 0;
                    } else transformData.transform.op._mdf = false;
                }
                cont += 1;
            }
            this._currentCopies = copies; /// /
            var offset = this.o.v;
            var offsetModulo = offset % 1;
            var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
            var pProps = this.pMatrix.props;
            var rProps = this.rMatrix.props;
            var sProps = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration = 0;
            if (offset > 0) {
                while(iteration < roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration += 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
                    iteration += offsetModulo;
                }
            } else if (offset < 0) {
                while(iteration > roundOffset){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration -= 1;
                }
                if (offsetModulo) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
                    iteration -= offsetModulo;
                }
            }
            i = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir = this.data.m === 1 ? 1 : -1;
            cont = this._currentCopies;
            var j;
            var jLen;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                jLen = itemsTransform.length;
                items[items.length - 1].transform.mProps._mdf = true;
                items[items.length - 1].transform.op._mdf = true;
                items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));
                if (iteration !== 0) {
                    if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
                    this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
                    this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j = 0; j < jLen; j += 1)itemsTransform[j] = this.matrix.props[j];
                }
                iteration += 1;
                cont -= 1;
                i += dir;
            }
        } else {
            cont = this._currentCopies;
            i = 0;
            dir = 1;
            while(cont){
                items = this.elemsData[i].it;
                itemsTransform = items[items.length - 1].transform.mProps.v.props;
                items[items.length - 1].transform.mProps._mdf = false;
                items[items.length - 1].transform.op._mdf = false;
                cont -= 1;
                i += dir;
            }
        }
        return hasReloaded;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path, round) {
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        var i;
        var len = path._length;
        var currentV;
        var currentI;
        var currentO;
        var closerV;
        var distance;
        var newPosPerc;
        var index = 0;
        var vX;
        var vY;
        var oX;
        var oY;
        var iX;
        var iY;
        for(i = 0; i < len; i += 1){
            currentV = path.v[i];
            currentO = path.o[i];
            currentI = path.i[i];
            if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
                if ((i === 0 || i === len - 1) && !path.c) {
                    clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index += 1;
                } else {
                    if (i === 0) closerV = path.v[len - 1];
                    else closerV = path.v[i - 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = iX;
                    iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
                    vY = iY;
                    oX = vX - (vX - currentV[0]) * roundCorner;
                    oY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                    if (i === len - 1) closerV = path.v[0];
                    else closerV = path.v[i + 1];
                    distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
                    newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
                    oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
                    vX = oX;
                    oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
                    vY = oY;
                    iX = vX - (vX - currentV[0]) * roundCorner;
                    iY = vY - (vY - currentV[1]) * roundCorner;
                    clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
                    index += 1;
                }
            } else {
                clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
                index += 1;
            }
        }
        return clonedPath;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var rd = this.rd.v;
        if (rd !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a, b) {
        return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
    }
    function floatZero(f) {
        return Math.abs(f) <= 0.00001;
    }
    function lerp(p0, p1, amount) {
        return p0 * (1 - amount) + p1 * amount;
    }
    function lerpPoint(p0, p1, amount) {
        return [
            lerp(p0[0], p1[0], amount),
            lerp(p0[1], p1[1], amount)
        ];
    }
    function quadRoots(a, b, c) {
        // no root
        if (a === 0) return [];
        var s = b * b - 4 * a * c; // Complex roots
        if (s < 0) return [];
        var singleRoot = -b / (2 * a); // 1 root
        if (s === 0) return [
            singleRoot
        ];
        var delta = Math.sqrt(s) / (2 * a); // 2 roots
        return [
            singleRoot - delta,
            singleRoot + delta
        ];
    }
    function polynomialCoefficients(p0, p1, p2, p3) {
        return [
            -p0 + 3 * p1 - 3 * p2 + p3,
            3 * p0 - 6 * p1 + 3 * p2,
            -3 * p0 + 3 * p1,
            p0
        ];
    }
    function singlePoint(p) {
        return new PolynomialBezier(p, p, p, p, false);
    }
    function PolynomialBezier(p0, p1, p2, p3, linearize) {
        if (linearize && pointEqual(p0, p1)) p1 = lerpPoint(p0, p3, 1 / 3);
        if (linearize && pointEqual(p2, p3)) p2 = lerpPoint(p0, p3, 2 / 3);
        var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
        var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
        this.a = [
            coeffx[0],
            coeffy[0]
        ];
        this.b = [
            coeffx[1],
            coeffy[1]
        ];
        this.c = [
            coeffx[2],
            coeffy[2]
        ];
        this.d = [
            coeffx[3],
            coeffy[3]
        ];
        this.points = [
            p0,
            p1,
            p2,
            p3
        ];
    }
    PolynomialBezier.prototype.point = function(t) {
        return [
            ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
            ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t) {
        return [
            (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
            (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[1], p[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t) {
        var p = this.derivative(t);
        return Math.atan2(p[0], p[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom)) return [];
        var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
        var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
        if (square < 0) return [];
        var root = Math.sqrt(square);
        if (floatZero(root)) {
            if (root > 0 && root < 1) return [
                tcusp
            ];
            return [];
        }
        return [
            tcusp - root,
            tcusp + root
        ].filter(function(r) {
            return r > 0 && r < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t) {
        if (t <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p10 = lerpPoint(this.points[0], this.points[1], t);
        var p11 = lerpPoint(this.points[1], this.points[2], t);
        var p12 = lerpPoint(this.points[2], this.points[3], t);
        var p20 = lerpPoint(p10, p11, t);
        var p21 = lerpPoint(p11, p12, t);
        var p3 = lerpPoint(p20, p21, t);
        return [
            new PolynomialBezier(this.points[0], p10, p20, p3, true),
            new PolynomialBezier(p3, p21, p12, this.points[3], true)
        ];
    };
    function extrema(bez, comp) {
        var min = bez.points[0][comp];
        var max = bez.points[bez.points.length - 1][comp];
        if (min > max) {
            var e = max;
            max = min;
            min = e;
        } // Derivative roots to find min/max
        var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);
        for(var i = 0; i < f.length; i += 1)if (f[i] > 0 && f[i] < 1) {
            var val = bez.point(f[i])[comp];
            if (val < min) min = val;
            else if (val > max) max = val;
        }
        return {
            min: min,
            max: max
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds = this.bounds();
        return {
            left: bounds.x.min,
            right: bounds.x.max,
            top: bounds.y.min,
            bottom: bounds.y.max,
            width: bounds.x.max - bounds.x.min,
            height: bounds.y.max - bounds.y.min,
            cx: (bounds.x.max + bounds.x.min) / 2,
            cy: (bounds.y.max + bounds.y.min) / 2
        };
    };
    function intersectData(bez, t1, t2) {
        var box = bez.boundingBox();
        return {
            cx: box.cx,
            cy: box.cy,
            width: box.width,
            height: box.height,
            bez: bez,
            t: (t1 + t2) / 2,
            t1: t1,
            t2: t2
        };
    }
    function splitData(data) {
        var split = data.bez.split(0.5);
        return [
            intersectData(split[0], data.t1, data.t),
            intersectData(split[1], data.t, data.t2)
        ];
    }
    function boxIntersect(b1, b2) {
        return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
    }
    function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
        if (!boxIntersect(d1, d2)) return;
        if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
            intersections.push([
                d1.t,
                d2.t
            ]);
            return;
        }
        var d1s = splitData(d1);
        var d2s = splitData(d2);
        intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
        intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    }
    PolynomialBezier.prototype.intersections = function(other, tolerance, maxRecursion) {
        if (tolerance === undefined) tolerance = 2;
        if (maxRecursion === undefined) maxRecursion = 7;
        var intersections = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
        return intersections;
    };
    PolynomialBezier.shapeSegment = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath, index) {
        var nextIndex = (index + 1) % shapePath.length();
        return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
    };
    function crossProduct(a, b) {
        return [
            a[1] * b[2] - a[2] * b[1],
            a[2] * b[0] - a[0] * b[2],
            a[0] * b[1] - a[1] * b[0]
        ];
    }
    function lineIntersection(start1, end1, start2, end2) {
        var v1 = [
            start1[0],
            start1[1],
            1
        ];
        var v2 = [
            end1[0],
            end1[1],
            1
        ];
        var v3 = [
            start2[0],
            start2[1],
            1
        ];
        var v4 = [
            end2[0],
            end2[1],
            1
        ];
        var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
        if (floatZero(r[2])) return null;
        return [
            r[0] / r[2],
            r[1] / r[2]
        ];
    }
    function polarOffset(p, angle, length) {
        return [
            p[0] + Math.cos(angle) * length,
            p[1] - Math.sin(angle) * length
        ];
    }
    function pointDistance(p1, p2) {
        return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
    }
    function pointEqual(p1, p2) {
        return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
        var angO = angle - Math.PI / 2;
        var angI = angle + Math.PI / 2;
        var px = point[0] + Math.cos(angle) * direction * amplitude;
        var py = point[1] - Math.sin(angle) * direction * amplitude;
        outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
    }
    function getPerpendicularVector(pt1, pt2) {
        var vector = [
            pt2[0] - pt1[0],
            pt2[1] - pt1[1]
        ];
        var rot = -Math.PI * 0.5;
        var rotatedVector = [
            Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1],
            Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]
        ];
        return rotatedVector;
    }
    function getProjectingAngle(path, cur) {
        var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
        var nextIndex = (cur + 1) % path.length();
        var prevPoint = path.v[prevIndex];
        var nextPoint = path.v[nextIndex];
        var pVector = getPerpendicularVector(prevPoint, nextPoint);
        return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
    }
    function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
        var angle = getProjectingAngle(path, cur);
        var point = path.v[cur % path._length];
        var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
        var nextPoint = path.v[(cur + 1) % path._length];
        var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
        var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
        setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
    }
    function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
        for(var i = 0; i < frequency; i += 1){
            var t = (i + 1) / (frequency + 1);
            var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
            var angle = segment.normalAngle(t);
            var point = segment.point(t);
            setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
            direction = -direction;
        }
        return direction;
    }
    ZigZagModifier.prototype.processPath = function(path, amplitude, frequency, pointType) {
        var count = path._length;
        var clonedPath = shapePool.newElement();
        clonedPath.c = path.c;
        if (!path.c) count -= 1;
        if (count === 0) return clonedPath;
        var direction = -1;
        var segment = PolynomialBezier.shapeSegment(path, 0);
        zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);
        for(var i = 0; i < count; i += 1){
            direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);
            if (i === count - 1 && !path.c) segment = null;
            else segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
            zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
        }
        return clonedPath;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amplitude = this.amplitude.v;
        var frequency = Math.max(0, Math.round(this.frequency.v));
        var pointType = this.pointsType.v;
        if (amplitude !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p1, p2, amount) {
        var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
        return [
            polarOffset(p1, angle, amount),
            polarOffset(p2, angle, amount)
        ];
    }
    function offsetSegment(segment, amount) {
        var p0;
        var p1a;
        var p1b;
        var p2b;
        var p2a;
        var p3;
        var e;
        e = linearOffset(segment.points[0], segment.points[1], amount);
        p0 = e[0];
        p1a = e[1];
        e = linearOffset(segment.points[1], segment.points[2], amount);
        p1b = e[0];
        p2b = e[1];
        e = linearOffset(segment.points[2], segment.points[3], amount);
        p2a = e[0];
        p3 = e[1];
        var p1 = lineIntersection(p0, p1a, p1b, p2b);
        if (p1 === null) p1 = p1a;
        var p2 = lineIntersection(p2a, p3, p1b, p2b);
        if (p2 === null) p2 = p2a;
        return new PolynomialBezier(p0, p1, p2, p3);
    }
    function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
        var p0 = seg1.points[3];
        var p1 = seg2.points[0]; // Bevel
        if (lineJoin === 3) return p0; // Connected, they don't need a joint
        if (pointEqual(p0, p1)) return p0; // Round
        if (lineJoin === 2) {
            var angleOut = -seg1.tangentAngle(1);
            var angleIn = -seg2.tangentAngle(0) + Math.PI;
            var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
            var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
            var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
            outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
            tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
            outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
            return p1;
        } // Miter
        var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
        var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
        var intersection = lineIntersection(t0, p0, p1, t1);
        if (intersection && pointDistance(intersection, p0) < miterLimit) {
            outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
            return intersection;
        }
        return p0;
    }
    function getIntersection(a, b) {
        var intersect = a.intersections(b);
        if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
        if (intersect.length) return intersect[0];
        return null;
    }
    function pruneSegmentIntersection(a, b) {
        var outa = a.slice();
        var outb = b.slice();
        var intersect = getIntersection(a[a.length - 1], b[0]);
        if (intersect) {
            outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
            outb[0] = b[0].split(intersect[1])[1];
        }
        if (a.length > 1 && b.length > 1) {
            intersect = getIntersection(a[0], b[b.length - 1]);
            if (intersect) return [
                [
                    a[0].split(intersect[0])[0]
                ],
                [
                    b[b.length - 1].split(intersect[1])[1]
                ]
            ];
        }
        return [
            outa,
            outb
        ];
    }
    function pruneIntersections(segments) {
        var e;
        for(var i = 1; i < segments.length; i += 1){
            e = pruneSegmentIntersection(segments[i - 1], segments[i]);
            segments[i - 1] = e[0];
            segments[i] = e[1];
        }
        if (segments.length > 1) {
            e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
            segments[segments.length - 1] = e[0];
            segments[0] = e[1];
        }
        return segments;
    }
    function offsetSegmentSplit(segment, amount) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex = segment.inflectionPoints();
        var left;
        var right;
        var split;
        var mid;
        if (flex.length === 0) return [
            offsetSegment(segment, amount)
        ];
        if (flex.length === 1 || floatEqual(flex[1], 1)) {
            split = segment.split(flex[0]);
            left = split[0];
            right = split[1];
            return [
                offsetSegment(left, amount),
                offsetSegment(right, amount)
            ];
        }
        split = segment.split(flex[0]);
        left = split[0];
        var t = (flex[1] - flex[0]) / (1 - flex[0]);
        split = split[1].split(t);
        mid = split[0];
        right = split[1];
        return [
            offsetSegment(left, amount),
            offsetSegment(mid, amount),
            offsetSegment(right, amount)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem, data) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
        this.lineJoin = data.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier, amount, lineJoin, miterLimit) {
        var outputBezier = shapePool.newElement();
        outputBezier.c = inputBezier.c;
        var count = inputBezier.length();
        if (!inputBezier.c) count -= 1;
        var i;
        var j;
        var segment;
        var multiSegments = [];
        for(i = 0; i < count; i += 1){
            segment = PolynomialBezier.shapeSegment(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        if (!inputBezier.c) for(i = count - 1; i >= 0; i -= 1){
            segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
            multiSegments.push(offsetSegmentSplit(segment, amount));
        }
        multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints
        var lastPoint = null;
        var lastSeg = null;
        for(i = 0; i < multiSegments.length; i += 1){
            var multiSegment = multiSegments[i];
            if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
            lastSeg = multiSegment[multiSegment.length - 1];
            for(j = 0; j < multiSegment.length; j += 1){
                segment = multiSegment[j];
                if (lastPoint && pointEqual(segment.points[0], lastPoint)) outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
                else outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
                outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
                lastPoint = segment.points[3];
            }
        }
        if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
        return outputBezier;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame) {
        var shapePaths;
        var i;
        var len = this.shapes.length;
        var j;
        var jLen;
        var amount = this.amount.v;
        var miterLimit = this.miterLimit.v;
        var lineJoin = this.lineJoin;
        if (amount !== 0) {
            var shapeData;
            var localShapeCollection;
            for(i = 0; i < len; i += 1){
                shapeData = this.shapes[i];
                localShapeCollection = shapeData.localShapeCollection;
                if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
                    localShapeCollection.releaseShapes();
                    shapeData.shape._mdf = true;
                    shapePaths = shapeData.shape.paths.shapes;
                    jLen = shapeData.shape.paths._length;
                    for(j = 0; j < jLen; j += 1)localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
                }
                shapeData.shape.paths = shapeData.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData) {
        var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
        var fWeight = 'normal';
        var fStyle = 'normal';
        var len = styles.length;
        var styleName;
        for(var i = 0; i < len; i += 1){
            styleName = styles[i].toLowerCase();
            switch(styleName){
                case 'italic':
                    fStyle = 'italic';
                    break;
                case 'bold':
                    fWeight = '700';
                    break;
                case 'black':
                    fWeight = '900';
                    break;
                case 'medium':
                    fWeight = '500';
                    break;
                case 'regular':
                case 'normal':
                    fWeight = '400';
                    break;
                case 'light':
                case 'thin':
                    fWeight = '200';
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle,
            weight: fontData.fWeight || fWeight
        };
    }
    var FontManager = function() {
        var maxWaitingTime = 5000;
        var emptyChar = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters = []; // Hindi characters
        combinedCharacters = combinedCharacters.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var BLACK_FLAG_CODE_POINT = 127988;
        var CANCEL_TAG_CODE_POINT = 917631;
        var A_TAG_CODE_POINT = 917601;
        var Z_TAG_CODE_POINT = 917626;
        var VARIATION_SELECTOR_16_CODE_POINT = 65039;
        var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
        var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
        var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
        var surrogateModifiers = [
            'd83cdffb',
            'd83cdffc',
            'd83cdffd',
            'd83cdffe',
            'd83cdfff'
        ];
        function trimFontOptions(font) {
            var familyArray = font.split(',');
            var i;
            var len = familyArray.length;
            var enabledFamilies = [];
            for(i = 0; i < len; i += 1)if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') enabledFamilies.push(familyArray[i]);
            return enabledFamilies.join(',');
        }
        function setUpNode(font, family) {
            var parentNode = createTag('span'); // Node is invisible to screen readers.
            parentNode.setAttribute('aria-hidden', true);
            parentNode.style.fontFamily = family;
            var node = createTag('span'); // Characters that vary significantly among different fonts
            node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen
            parentNode.style.position = 'absolute';
            parentNode.style.left = '-10000px';
            parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious
            parentNode.style.fontSize = '300px'; // Reset any font properties
            parentNode.style.fontVariant = 'normal';
            parentNode.style.fontStyle = 'normal';
            parentNode.style.fontWeight = 'normal';
            parentNode.style.letterSpacing = '0';
            parentNode.appendChild(node);
            document.body.appendChild(parentNode); // Remember width with no applied web font
            var width = node.offsetWidth;
            node.style.fontFamily = trimFontOptions(font) + ', ' + family;
            return {
                node: node,
                w: width,
                parent: parentNode
            };
        }
        function checkLoadedFonts() {
            var i;
            var len = this.fonts.length;
            var node;
            var w;
            var loadedCount = len;
            for(i = 0; i < len; i += 1){
                if (this.fonts[i].loaded) loadedCount -= 1;
                else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) this.fonts[i].loaded = true;
                else {
                    node = this.fonts[i].monoCase.node;
                    w = this.fonts[i].monoCase.w;
                    if (node.offsetWidth !== w) {
                        loadedCount -= 1;
                        this.fonts[i].loaded = true;
                    } else {
                        node = this.fonts[i].sansCase.node;
                        w = this.fonts[i].sansCase.w;
                        if (node.offsetWidth !== w) {
                            loadedCount -= 1;
                            this.fonts[i].loaded = true;
                        }
                    }
                    if (this.fonts[i].loaded) {
                        this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
                        this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
                    }
                }
            }
            if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper(fontData, def) {
            var engine = document.body && def ? 'svg' : 'canvas';
            var helper;
            var fontProps = getFontProperties(fontData);
            if (engine === 'svg') {
                var tHelper = createNS('text');
                tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper.setAttribute('font-family', fontData.fFamily);
                tHelper.setAttribute('font-style', fontProps.style);
                tHelper.setAttribute('font-weight', fontProps.weight);
                tHelper.textContent = '1';
                if (fontData.fClass) {
                    tHelper.style.fontFamily = 'inherit';
                    tHelper.setAttribute('class', fontData.fClass);
                } else tHelper.style.fontFamily = fontData.fFamily;
                def.appendChild(tHelper);
                helper = tHelper;
            } else {
                var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
                tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
                helper = tCanvasHelper;
            }
            function measure(text) {
                if (engine === 'svg') {
                    helper.textContent = text;
                    return helper.getComputedTextLength();
                }
                return helper.measureText(text).width;
            }
            return {
                measureText: measure
            };
        }
        function addFonts(fontData, defs) {
            if (!fontData) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData.list.forEach(function(data) {
                    data.helper = createHelper(data);
                    data.cache = {};
                });
                this.fonts = fontData.list;
                return;
            }
            var fontArr = fontData.list;
            var i;
            var len = fontArr.length;
            var _pendingFonts = len;
            for(i = 0; i < len; i += 1){
                var shouldLoadFont = true;
                var loadedSelector;
                var j;
                fontArr[i].loaded = false;
                fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
                fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');
                if (!fontArr[i].fPath) {
                    fontArr[i].loaded = true;
                    _pendingFonts -= 1;
                } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
                    loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');
                    if (loadedSelector.length > 0) shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var s = createTag('style');
                        s.setAttribute('f-forigin', fontArr[i].fOrigin);
                        s.setAttribute('f-origin', fontArr[i].origin);
                        s.setAttribute('f-family', fontArr[i].fFamily);
                        s.type = 'text/css';
                        s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
                        defs.appendChild(s);
                    }
                } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
                    loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var l = createTag('link');
                        l.setAttribute('f-forigin', fontArr[i].fOrigin);
                        l.setAttribute('f-origin', fontArr[i].origin);
                        l.type = 'text/css';
                        l.rel = 'stylesheet';
                        l.href = fontArr[i].fPath;
                        document.body.appendChild(l);
                    }
                } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
                    loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j = 0; j < loadedSelector.length; j += 1)if (fontArr[i].fPath === loadedSelector[j].src) // Font is already loaded
                    shouldLoadFont = false;
                    if (shouldLoadFont) {
                        var sc = createTag('link');
                        sc.setAttribute('f-forigin', fontArr[i].fOrigin);
                        sc.setAttribute('f-origin', fontArr[i].origin);
                        sc.setAttribute('rel', 'stylesheet');
                        sc.setAttribute('href', fontArr[i].fPath);
                        defs.appendChild(sc);
                    }
                }
                fontArr[i].helper = createHelper(fontArr[i], defs);
                fontArr[i].cache = {};
                this.fonts.push(fontArr[i]);
            }
            if (_pendingFonts === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars(chars) {
            if (!chars) return;
            if (!this.chars) this.chars = [];
            var i;
            var len = chars.length;
            var j;
            var jLen = this.chars.length;
            var found;
            for(i = 0; i < len; i += 1){
                j = 0;
                found = false;
                while(j < jLen){
                    if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) found = true;
                    j += 1;
                }
                if (!found) {
                    this.chars.push(chars[i]);
                    jLen += 1;
                }
            }
        }
        function getCharData(_char, style, font) {
            var i = 0;
            var len = this.chars.length;
            while(i < len){
                if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) return this.chars[i];
                i += 1;
            }
            if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
            }
            return emptyChar;
        }
        function measureText(_char2, fontName, size) {
            var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
            // to avoid collisions between equal chars
            var index = _char2;
            if (!fontData.cache[index]) {
                var tHelper = fontData.helper;
                if (_char2 === ' ') {
                    var doubleSize = tHelper.measureText('|' + _char2 + '|');
                    var singleSize = tHelper.measureText('||');
                    fontData.cache[index] = (doubleSize - singleSize) / 100;
                } else fontData.cache[index] = tHelper.measureText(_char2) / 100;
            }
            return fontData.cache[index] * size;
        }
        function getFontByName(name) {
            var i = 0;
            var len = this.fonts.length;
            while(i < len){
                if (this.fonts[i].fName === name) return this.fonts[i];
                i += 1;
            }
            return this.fonts[0];
        }
        function getCodePoint(string) {
            var codePoint = 0;
            var first = string.charCodeAt(0);
            if (first >= 0xD800 && first <= 0xDBFF) {
                var second = string.charCodeAt(1);
                if (second >= 0xDC00 && second <= 0xDFFF) codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
            }
            return codePoint;
        } // Skin tone modifiers
        function isModifier(firstCharCode, secondCharCode) {
            var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
            return surrogateModifiers.indexOf(sum) !== -1;
        }
        function isZeroWidthJoiner(charCode) {
            return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
        } // This codepoint may change the appearance of the preceding character.
        // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
        // as a colorful image as compared to a monochrome text variant.
        function isVariationSelector(charCode) {
            return charCode === VARIATION_SELECTOR_16_CODE_POINT;
        } // The regional indicator symbols are a set of 26 alphabetic Unicode
        /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
        // two-letter country codes in a way that allows optional special treatment.
        function isRegionalCode(string) {
            var codePoint = getCodePoint(string);
            if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) return true;
            return false;
        } // Some Emoji implementations represent combinations of
        // two “regional indicator” letters as a single flag symbol.
        function isFlagEmoji(string) {
            return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
        }
        function isCombinedCharacter(_char3) {
            return combinedCharacters.indexOf(_char3) !== -1;
        } // Regional flags start with a BLACK_FLAG_CODE_POINT
        // folowed by 5 chars in the TAG range
        // and end with a CANCEL_TAG_CODE_POINT
        function isRegionalFlag(text, index) {
            var codePoint = getCodePoint(text.substr(index, 2));
            if (codePoint !== BLACK_FLAG_CODE_POINT) return false;
            var count = 0;
            index += 2;
            while(count < 5){
                codePoint = getCodePoint(text.substr(index, 2));
                if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) return false;
                count += 1;
                index += 2;
            }
            return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
        }
        function setIsLoaded() {
            this.isLoaded = true;
        }
        var Font = function Font() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font.isModifier = isModifier;
        Font.isZeroWidthJoiner = isZeroWidthJoiner;
        Font.isFlagEmoji = isFlagEmoji;
        Font.isRegionalCode = isRegionalCode;
        Font.isCombinedCharacter = isCombinedCharacter;
        Font.isRegionalFlag = isRegionalFlag;
        Font.isVariationSelector = isVariationSelector;
        Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
        var fontPrototype = {
            addChars: addChars,
            addFonts: addFonts,
            getCharData: getCharData,
            getFontByName: getFontByName,
            measureText: measureText,
            checkLoadedFonts: checkLoadedFonts,
            setIsLoaded: setIsLoaded
        };
        Font.prototype = fontPrototype;
        return Font;
    }();
    function SlotManager(animationData) {
        this.animationData = animationData;
    }
    SlotManager.prototype.getProp = function(data) {
        if (this.animationData.slots && this.animationData.slots[data.sid]) return Object.assign(data, this.animationData.slots[data.sid].p);
        return data;
    };
    function slotFactory(animationData) {
        return new SlotManager(animationData);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) === -1) this.renderableComponents.push(component);
        },
        removeRenderableComponent: function removeRenderableComponent(component) {
            if (this.renderableComponents.indexOf(component) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame(num) {
            this.checkLayerLimits(num);
        },
        checkTransparency: function checkTransparency() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits(num) {
            if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable() {
            var i;
            var len = this.renderableComponents.length;
            for(i = 0; i < len; i += 1)this.renderableComponents[i].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums = {
            0: 'source-over',
            1: 'multiply',
            2: 'screen',
            3: 'overlay',
            4: 'darken',
            5: 'lighten',
            6: 'color-dodge',
            7: 'color-burn',
            8: 'hard-light',
            9: 'soft-light',
            10: 'difference',
            11: 'exclusion',
            12: 'hue',
            13: 'saturation',
            14: 'color',
            15: 'luminosity'
        };
        return function(mode) {
            return blendModeEnums[mode] || '';
        };
    }();
    function SliderEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function AngleEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function ColorEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function PointEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
    }
    function LayerIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function MaskIndexEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function CheckboxEffect(data, elem, container) {
        this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data, element) {
        var effects = data.ef || [];
        this.effectElements = [];
        var i;
        var len = effects.length;
        var effectItem;
        for(i = 0; i < len; i += 1){
            effectItem = new GroupEffect(effects[i], element);
            this.effectElements.push(effectItem);
        }
    }
    function GroupEffect(data, element) {
        this.init(data, element);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data, element) {
        this.data = data;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element);
        var i;
        var len = this.data.ef.length;
        var eff;
        var effects = this.data.ef;
        for(i = 0; i < len; i += 1){
            eff = null;
            switch(effects[i].ty){
                case 0:
                    eff = new SliderEffect(effects[i], element, this);
                    break;
                case 1:
                    eff = new AngleEffect(effects[i], element, this);
                    break;
                case 2:
                    eff = new ColorEffect(effects[i], element, this);
                    break;
                case 3:
                    eff = new PointEffect(effects[i], element, this);
                    break;
                case 4:
                case 7:
                    eff = new CheckboxEffect(effects[i], element, this);
                    break;
                case 10:
                    eff = new LayerIndexEffect(effects[i], element, this);
                    break;
                case 11:
                    eff = new MaskIndexEffect(effects[i], element, this);
                    break;
                case 5:
                    eff = new EffectsManager(effects[i], element, this);
                    break;
                // case 6:
                default:
                    eff = new NoValueEffect(effects[i], element, this);
                    break;
            }
            if (eff) this.effectElements.push(eff);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks() {
            if (!this.data.hasMask) return false;
            var i = 0;
            var len = this.data.masksProperties.length;
            while(i < len){
                if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) return true;
                i += 1;
            }
            return false;
        },
        initExpressions: function initExpressions() {
            var expressionsInterfaces = getExpressionInterfaces();
            if (!expressionsInterfaces) return;
            var LayerExpressionInterface = expressionsInterfaces('layer');
            var EffectsExpressionInterface = expressionsInterfaces('effects');
            var ShapeExpressionInterface = expressionsInterfaces('shape');
            var TextExpressionInterface = expressionsInterfaces('text');
            var CompExpressionInterface = expressionsInterfaces('comp');
            this.layerInterface = LayerExpressionInterface(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode() {
            var blendModeValue = getBlendMode(this.data.bm);
            var elem = this.baseElement || this.layerElement;
            elem.style['mix-blend-mode'] = blendModeValue;
        },
        initBaseData: function initBaseData(data, globalData, comp) {
            this.globalData = globalData;
            this.comp = comp;
            this.data = data;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties(num, isVisible) {
            var i;
            var len = this.dynamicProperties.length;
            for(i = 0; i < len; i += 1)if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
                this.dynamicProperties[i].getValue();
                if (this.dynamicProperties[i]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty(prop) {
            if (this.dynamicProperties.indexOf(prop) === -1) this.dynamicProperties.push(prop);
        }
    };
    function FootageElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.footageData = globalData.imageLoader.getAsset(this.assetData);
        this.initBaseData(data, globalData, comp);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces = getExpressionInterfaces();
        if (!expressionsInterfaces) return;
        var FootageInterface = expressionsInterfaces('footage');
        this.layerInterface = FootageInterface(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data, globalData, comp) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData.getAssetData(data.refId);
        this.initBaseData(data, globalData, comp);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num) {
        this.prepareRenderableFrame(num, true);
        this.prepareProperties(num, true);
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            this._currentTime = timeRemapped;
        } else this._currentTime = num / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume) {
            this._previousVolume = totalVolume;
            this.audio.volume(totalVolume);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue) {
        this.audio.rate(rateValue);
    };
    AudioElement.prototype.volume = function(volumeValue) {
        this._volumeMultiplier = volumeValue;
        this._previousVolume = volumeValue * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num) {
        var i;
        var len = this.layers.length;
        var data;
        this.completeLayers = true;
        for(i = len - 1; i >= 0; i -= 1){
            if (!this.elements[i]) {
                data = this.layers[i];
                if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) this.buildItem(i);
            }
            this.completeLayers = this.elements[i] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer) {
        switch(layer.ty){
            case 2:
                return this.createImage(layer);
            case 0:
                return this.createComp(layer);
            case 1:
                return this.createSolid(layer);
            case 3:
                return this.createNull(layer);
            case 4:
                return this.createShape(layer);
            case 5:
                return this.createText(layer);
            case 6:
                return this.createAudio(layer);
            case 13:
                return this.createCamera(layer);
            case 15:
                return this.createFootage(layer);
            default:
                return this.createNull(layer);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error('You\'re using a 3d camera. Try the html renderer.');
    };
    BaseRenderer.prototype.createAudio = function(data) {
        return new AudioElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data) {
        return new FootageElement(data, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)this.buildItem(i);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers) {
        this.completeLayers = false;
        var i;
        var len = newLayers.length;
        var j;
        var jLen = this.layers.length;
        for(i = 0; i < len; i += 1){
            j = 0;
            while(j < jLen){
                if (this.layers[j].id === newLayers[i].id) {
                    this.layers[j] = newLayers[i];
                    break;
                }
                j += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface) {
        this.globalData.projectInterface = pInterface;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy) {
        var elements = this.elements;
        var layers = this.layers;
        var i = 0;
        var len = layers.length;
        while(i < len){
            if (layers[i].ind == parentName) {
                // eslint-disable-line eqeqeq
                if (!elements[i] || elements[i] === true) {
                    this.buildItem(i);
                    this.addPendingElement(element);
                } else {
                    hierarchy.push(elements[i]);
                    elements[i].setAsParent();
                    if (layers[i].parent !== undefined) this.buildElementParenting(element, layers[i].parent, hierarchy);
                    else element.setHierarchy(hierarchy);
                }
            }
            i += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element) {
        this.pendingElements.push(element);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i]);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind) {
        var i;
        var len = this.elements.length;
        for(i = 0; i < len; i += 1){
            if (this.elements[i].data.ind === ind) return this.elements[i];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path) {
        var pathValue = path.shift();
        var element;
        if (typeof pathValue === 'number') element = this.elements[pathValue];
        else {
            var i;
            var len = this.elements.length;
            for(i = 0; i < len; i += 1)if (this.elements[i].data.nm === pathValue) {
                element = this.elements[i];
                break;
            }
        }
        if (path.length === 0) return element;
        return element.getElementByPath(path);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData, fontsContainer) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData);
        this.globalData.fontManager.addChars(animData.chars);
        this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData.fr;
        this.globalData.nm = animData.nm;
        this.globalData.compSize = {
            w: animData.w,
            h: animData.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: 'transformEFfect'
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform() {
            var mat = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat,
                localMat: mat,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat;
                var finalMat = this.finalTransform.mat;
                var i = 0;
                var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i < len){
                    if (this.hierarchy[i].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat = this.finalTransform.mProp.v.props;
                    finalMat.cloneFromProps(mat);
                    for(i = 0; i < len; i += 1)finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform() {
            if (this.localTransforms) {
                var i = 0;
                var len = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i < len){
                    if (this.localTransforms[i]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
                        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
                        this.finalTransform._opMdf = true;
                    }
                    i += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat);
                    for(i = 1; i < len; i += 1){
                        var lmat = this.localTransforms[i].matrix;
                        localMat.multiply(lmat);
                    }
                    localMat.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp = this.finalTransform.localOpacity;
                    for(i = 0; i < len; i += 1)localOp *= this.localTransforms[i].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms() {
            if (this.renderableEffectsManager) {
                var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i = 0;
                    var len = transformEffects.length;
                    for(i = 0; i < len; i += 1)this.localTransforms.push(transformEffects[i]);
                }
            }
        },
        globalToLocal: function globalToLocal(pt) {
            var transforms = [];
            transforms.push(this.finalTransform);
            var flag = true;
            var comp = this.comp;
            while(flag)if (comp.finalTransform) {
                if (comp.data.hasMask) transforms.splice(0, 0, comp.finalTransform);
                comp = comp.comp;
            } else flag = false;
            var i;
            var len = transforms.length;
            var ptNew;
            for(i = 0; i < len; i += 1){
                ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt = [
                    pt[0] - ptNew[0],
                    pt[1] - ptNew[1],
                    0
                ];
            }
            return pt;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data, element, globalData) {
        this.data = data;
        this.element = element;
        this.globalData = globalData;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs = this.globalData.defs;
        var i;
        var len = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len);
        this.solidPath = '';
        var path;
        var properties = this.masksProperties;
        var count = 0;
        var currentMasks = [];
        var j;
        var jLen;
        var layerId = createElementID();
        var rect;
        var expansor;
        var feMorph;
        var x;
        var maskType = 'clipPath';
        var maskRef = 'clip-path';
        for(i = 0; i < len; i += 1){
            if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
                maskType = 'mask';
                maskRef = 'mask';
            }
            if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
                rect = createNS('rect');
                rect.setAttribute('fill', '#ffffff');
                rect.setAttribute('width', this.element.comp.data.w || 0);
                rect.setAttribute('height', this.element.comp.data.h || 0);
                currentMasks.push(rect);
            } else rect = null;
            path = createNS('path');
            if (properties[i].mode === 'n') {
                // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    elem: path,
                    lastPath: ''
                };
                defs.appendChild(path);
            } else {
                count += 1;
                path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
                path.setAttribute('clip-rule', 'nonzero');
                var filterID;
                if (properties[i].x.k !== 0) {
                    maskType = 'mask';
                    maskRef = 'mask';
                    x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
                    filterID = createElementID();
                    expansor = createNS('filter');
                    expansor.setAttribute('id', filterID);
                    feMorph = createNS('feMorphology');
                    feMorph.setAttribute('operator', 'erode');
                    feMorph.setAttribute('in', 'SourceGraphic');
                    feMorph.setAttribute('radius', '0');
                    expansor.appendChild(feMorph);
                    defs.appendChild(expansor);
                    path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
                } else {
                    feMorph = null;
                    x = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i] = {
                    elem: path,
                    x: x,
                    expan: feMorph,
                    lastPath: '',
                    lastOperator: '',
                    filterId: filterID,
                    lastRadius: 0
                };
                if (properties[i].mode === 'i') {
                    jLen = currentMasks.length;
                    var g = createNS('g');
                    for(j = 0; j < jLen; j += 1)g.appendChild(currentMasks[j]);
                    var mask = createNS('mask');
                    mask.setAttribute('mask-type', 'alpha');
                    mask.setAttribute('id', layerId + '_' + count);
                    mask.appendChild(path);
                    defs.appendChild(mask);
                    g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
                    currentMasks.length = 0;
                    currentMasks.push(g);
                } else currentMasks.push(path);
                if (properties[i].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i] = {
                    elem: path,
                    lastPath: '',
                    op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
                    invRect: rect
                };
                if (!this.viewData[i].prop.k) this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
            }
        }
        this.maskElement = createNS(maskType);
        len = currentMasks.length;
        for(i = 0; i < len; i += 1)this.maskElement.appendChild(currentMasks[i]);
        if (count > 0) {
            this.maskElement.setAttribute('id', layerId);
            this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
            defs.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos) {
        return this.viewData[pos].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame) {
        var finalMat = this.element.finalTransform.mat;
        var i;
        var len = this.masksProperties.length;
        for(i = 0; i < len; i += 1){
            if (this.viewData[i].prop._mdf || isFirstFrame) this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
            if (this.viewData[i].op._mdf || isFirstFrame) this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
            if (this.masksProperties[i].mode !== 'n') {
                if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
                if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
                    var feMorph = this.storedData[i].expan;
                    if (this.storedData[i].x.v < 0) {
                        if (this.storedData[i].lastOperator !== 'erode') {
                            this.storedData[i].lastOperator = 'erode';
                            this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
                        }
                        feMorph.setAttribute('radius', -this.storedData[i].x.v);
                    } else {
                        if (this.storedData[i].lastOperator !== 'dilate') {
                            this.storedData[i].lastOperator = 'dilate';
                            this.storedData[i].elem.setAttribute('filter', null);
                        }
                        this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path = 'M0,0 ';
        path += ' h' + this.globalData.compSize.w;
        path += ' v' + this.globalData.compSize.h;
        path += ' h-' + this.globalData.compSize.w;
        path += ' v-' + this.globalData.compSize.h + ' ';
        return path;
    };
    MaskElement.prototype.drawPath = function(pathData, pathNodes, viewData) {
        var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
        var i;
        var len;
        len = pathNodes._length;
        for(i = 1; i < len; i += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes.c && len > 1) pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData.lastPath !== pathString) {
            var pathShapeValue = '';
            if (viewData.elem) {
                if (pathNodes.c) pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
                viewData.elem.setAttribute('d', pathShapeValue);
            }
            viewData.lastPath = pathString;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob = {};
        ob.createFilter = createFilter;
        ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
        function createFilter(filId, skipCoordinates) {
            var fil = createNS('filter');
            fil.setAttribute('id', filId);
            if (skipCoordinates !== true) {
                fil.setAttribute('filterUnits', 'objectBoundingBox');
                fil.setAttribute('x', '0%');
                fil.setAttribute('y', '0%');
                fil.setAttribute('width', '100%');
                fil.setAttribute('height', '100%');
            }
            return fil;
        }
        function createAlphaToLuminanceFilter() {
            var feColorMatrix = createNS('feColorMatrix');
            feColorMatrix.setAttribute('type', 'matrix');
            feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
            feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
            return feColorMatrix;
        }
        return ob;
    }();
    var featureSupport = function() {
        var ob = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob.svgLumaHidden = false;
        return ob;
    }();
    var registeredEffects$1 = {};
    var idPrefix = 'filter_result_';
    function SVGEffects(elem) {
        var i;
        var source = 'SourceGraphic';
        var len = elem.data.ef ? elem.data.ef.length : 0;
        var filId = createElementID();
        var fil = filtersFactory.createFilter(filId, true);
        var count = 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects$1[type]) {
                var Effect = registeredEffects$1[type].effect;
                filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
                source = idPrefix + count;
                if (registeredEffects$1[type].countsAsEffect) count += 1;
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (count) {
            elem.globalData.defs.appendChild(fil);
            elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    SVGEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect$1(id, effect, countsAsEffect) {
        registeredEffects$1[id] = {
            effect: effect,
            countsAsEffect: countsAsEffect
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement() {
            this.layerElement = createNS('g');
        },
        createContainerElements: function createContainerElements() {
            this.matteElement = createNS('g');
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg = createNS('g');
                gg.setAttribute('id', this.layerId);
                gg.appendChild(this.layerElement);
                layerElementParent = gg;
                this.globalData.defs.appendChild(gg);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp = createNS('clipPath');
                var pt = createNS('path');
                pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
                var clipId = createElementID();
                cp.setAttribute('id', clipId);
                cp.appendChild(pt);
                this.globalData.defs.appendChild(cp);
                if (this.checkMasks()) {
                    var cpGroup = createNS('g');
                    cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
                    cpGroup.appendChild(this.layerElement);
                    this.transformedElement = cpGroup;
                    if (layerElementParent) layerElementParent.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte(matteType) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType]) {
                var id = this.layerId + '_' + matteType;
                var filId;
                var fil;
                var useElement;
                var gg;
                if (matteType === 1 || matteType === 3) {
                    var masker = createNS('mask');
                    masker.setAttribute('id', id);
                    masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    masker.appendChild(useElement);
                    this.globalData.defs.appendChild(masker);
                    if (!featureSupport.maskType && matteType === 1) {
                        masker.setAttribute('mask-type', 'luminance');
                        filId = createElementID();
                        fil = filtersFactory.createFilter(filId);
                        this.globalData.defs.appendChild(fil);
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        gg.appendChild(useElement);
                        masker.appendChild(gg);
                        gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    }
                } else if (matteType === 2) {
                    var maskGroup = createNS('mask');
                    maskGroup.setAttribute('id', id);
                    maskGroup.setAttribute('mask-type', 'alpha');
                    var maskGrouper = createNS('g');
                    maskGroup.appendChild(maskGrouper);
                    filId = createElementID();
                    fil = filtersFactory.createFilter(filId); /// /
                    var feCTr = createNS('feComponentTransfer');
                    feCTr.setAttribute('in', 'SourceGraphic');
                    fil.appendChild(feCTr);
                    var feFunc = createNS('feFuncA');
                    feFunc.setAttribute('type', 'table');
                    feFunc.setAttribute('tableValues', '1.0 0.0');
                    feCTr.appendChild(feFunc); /// /
                    this.globalData.defs.appendChild(fil);
                    var alphaRect = createNS('rect');
                    alphaRect.setAttribute('width', this.comp.data.w);
                    alphaRect.setAttribute('height', this.comp.data.h);
                    alphaRect.setAttribute('x', '0');
                    alphaRect.setAttribute('y', '0');
                    alphaRect.setAttribute('fill', '#ffffff');
                    alphaRect.setAttribute('opacity', '0');
                    maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
                    maskGrouper.appendChild(alphaRect);
                    useElement = createNS('use');
                    useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
                    maskGrouper.appendChild(useElement);
                    if (!featureSupport.maskType) {
                        maskGroup.setAttribute('mask-type', 'luminance');
                        fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg = createNS('g');
                        maskGrouper.appendChild(alphaRect);
                        gg.appendChild(this.layerElement);
                        maskGrouper.appendChild(gg);
                    }
                    this.globalData.defs.appendChild(maskGroup);
                }
                this.matteMasks[matteType] = id;
            }
            return this.matteMasks[matteType];
        },
        setMatte: function setMatte(id) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy(hierarchy) {
            this.hierarchy = hierarchy;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype = {
            initElement: function initElement(data, globalData, comp) {
                this.initFrame();
                this.initBaseData(data, globalData, comp);
                this.initTransform(data, globalData, comp);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem = this.baseElement || this.layerElement;
                    elem.style.display = 'none';
                    this.hidden = true;
                }
            },
            show: function show() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem = this.baseElement || this.layerElement;
                        elem.style.display = 'block';
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent() {},
            prepareFrame: function prepareFrame(num) {
                this._mdf = false;
                this.prepareRenderableFrame(num);
                this.prepareProperties(num, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype)
        ], RenderableDOMElement);
    })();
    function IImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData.slotManager.getProp(this.assetData);
        this.initElement(data, globalData, comp);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS('image');
        this.innerElem.setAttribute('width', this.assetData.w + 'px');
        this.innerElem.setAttribute('height', this.assetData.h + 'px');
        this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element, position) {
        this.elem = element;
        this.pos = position;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers(data) {
            var i;
            var len = this.shapeModifiers.length;
            for(i = 0; i < len; i += 1)this.shapeModifiers[i].addShape(data);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
            var i = 0;
            var len = this.shapeModifiers.length;
            while(i < len){
                if (this.shapeModifiers[i].isAnimatedWithShape(data)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers() {
            if (!this.shapeModifiers.length) return;
            var i;
            var len = this.shapes.length;
            for(i = 0; i < len; i += 1)this.shapes[i].sh.reset();
            len = this.shapeModifiers.length;
            var shouldBreakProcess;
            for(i = len - 1; i >= 0; i -= 1){
                shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess) break;
            }
        },
        searchProcessedElement: function searchProcessedElement(elem) {
            var elements = this.processedElements;
            var i = 0;
            var len = elements.length;
            while(i < len){
                if (elements[i].elem === elem) return elements[i].pos;
                i += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement(elem, pos) {
            var elements = this.processedElements;
            var i = elements.length;
            while(i){
                i -= 1;
                if (elements[i].elem === elem) {
                    elements[i].pos = pos;
                    return;
                }
            }
            elements.push(new ProcessedElement(elem, pos));
        },
        prepareFrame: function prepareFrame(num) {
            this.prepareRenderableFrame(num);
            this.prepareProperties(num, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: 'butt',
        2: 'round',
        3: 'square'
    };
    var lineJoinEnum = {
        1: 'miter',
        2: 'round',
        3: 'bevel'
    };
    function SVGShapeData(transformers, level, shape) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers;
        this.lStr = '';
        this.sh = shape;
        this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated
        var i = 0;
        var len = transformers.length;
        while(i < len){
            if (transformers[i].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data, level) {
        this.data = data;
        this.type = data.ty;
        this.d = '';
        this.lvl = level;
        this._mdf = false;
        this.closed = data.hd === true;
        this.pElem = createNS('path');
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = '';
        this._mdf = false;
    };
    function DashProperty(elem, data, renderer, container) {
        this.elem = elem;
        this.frameId = -1;
        this.dataProps = createSizedArray(data.length);
        this.renderer = renderer;
        this.k = false;
        this.dashStr = '';
        this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
        this.dashoffset = createTypedArray('float32', 1);
        this.initDynamicPropertyContainer(container);
        var i;
        var len = data.length || 0;
        var prop;
        for(i = 0; i < len; i += 1){
            prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
            this.k = prop.k || this.k;
            this.dataProps[i] = {
                n: data[i].n,
                p: prop
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender;
        if (this._mdf) {
            var i = 0;
            var len = this.dataProps.length;
            if (this.renderer === 'svg') this.dashStr = '';
            for(i = 0; i < len; i += 1)if (this.dataProps[i].n !== 'o') {
                if (this.renderer === 'svg') this.dashStr += ' ' + this.dataProps[i].p.v;
                else this.dashArray[i] = this.dataProps[i].p.v;
            } else this.dashoffset[0] = this.dataProps[i].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem, data, container) {
        this.data = data;
        this.c = createTypedArray('uint8c', data.p * 4);
        var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
        this.o = createTypedArray('float32', cLength);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength;
        this.initDynamicPropertyContainer(container);
        this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values, points) {
        var i = 0;
        var len = this.o.length / 2;
        var diff;
        while(i < len){
            diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);
            if (diff > 0.01) return false;
            i += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i = 0;
            var len = this.data.k.k.length;
            while(i < len){
                if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) return false;
                i += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender) {
            var i;
            var len = this.data.p * 4;
            var mult;
            var val;
            for(i = 0; i < len; i += 1){
                mult = i % 4 === 0 ? 100 : 255;
                val = Math.round(this.prop.v[i] * mult);
                if (this.c[i] !== val) {
                    this.c[i] = val;
                    this._cmdf = !forceRender;
                }
            }
            if (this.o.length) {
                len = this.prop.v.length;
                for(i = this.data.p * 4; i < len; i += 1){
                    mult = i % 2 === 0 ? 100 : 1;
                    val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];
                    if (this.o[i - this.data.p * 4] !== val) {
                        this.o[i - this.data.p * 4] = val;
                        this._omdf = !forceRender;
                    }
                }
            }
            this._mdf = !forceRender;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem, data, styleOb);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem, data, styleOb) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem, data.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem, data.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem, data.g, this);
        this.style = styleOb;
        this.stops = [];
        this.setGradientData(styleOb.pElem, data);
        this.setGradientOpacity(data, styleOb);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement, data) {
        var gradientId = createElementID();
        var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
        gfill.setAttribute('id', gradientId);
        gfill.setAttribute('spreadMethod', 'pad');
        gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
        var stops = [];
        var stop;
        var j;
        var jLen;
        jLen = data.g.p * 4;
        for(j = 0; j < jLen; j += 4){
            stop = createNS('stop');
            gfill.appendChild(stop);
            stops.push(stop);
        }
        pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
        this.gf = gfill;
        this.cst = stops;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data, styleOb) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop;
            var j;
            var jLen;
            var mask = createNS('mask');
            var maskElement = createNS('path');
            mask.appendChild(maskElement);
            var opacityId = createElementID();
            var maskId = createElementID();
            mask.setAttribute('id', maskId);
            var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
            opFill.setAttribute('id', opacityId);
            opFill.setAttribute('spreadMethod', 'pad');
            opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
            jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
            var stops = this.stops;
            for(j = data.g.p * 4; j < jLen; j += 2){
                stop = createNS('stop');
                stop.setAttribute('stop-color', 'rgb(255,255,255)');
                opFill.appendChild(stop);
                stops.push(stop);
            }
            maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');
            if (data.ty === 'gs') {
                maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
                maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
                if (data.lj === 1) maskElement.setAttribute('stroke-miterlimit', data.ml);
            }
            this.of = opFill;
            this.ms = mask;
            this.ost = stops;
            this.maskId = maskId;
            styleOb.msElem = maskElement;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem, data, styleOb) {
        this.initDynamicPropertyContainer(elem);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
        this.d = new DashProperty(elem, data.d || {}, 'svg', this);
        this.initGradientData(elem, data, styleOb);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS('g');
    }
    function SVGTransformData(mProps, op, container) {
        this.transform = {
            mProps: mProps,
            op: op,
            container: container
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
        if (length === 0) return '';
        var _o = pathNodes.o;
        var _i = pathNodes.i;
        var _v = pathNodes.v;
        var i;
        var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
        for(i = 1; i < length; i += 1)shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
        if (closed && length) {
            shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
            shapeString += 'z';
        }
        return shapeString;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix = new Matrix();
        var _matrixHelper = new Matrix();
        var ob = {
            createRenderFunction: createRenderFunction
        };
        function createRenderFunction(data) {
            switch(data.ty){
                case 'fl':
                    return renderFill;
                case 'gf':
                    return renderGradient;
                case 'gs':
                    return renderGradientStroke;
                case 'st':
                    return renderStroke;
                case 'sh':
                case 'el':
                case 'rc':
                case 'sr':
                    return renderPath;
                case 'tr':
                    return renderContentTransform;
                case 'no':
                    return renderNoop;
                default:
                    return null;
            }
        }
        function renderContentTransform(styleData, itemData, isFirstFrame) {
            if (isFirstFrame || itemData.transform.op._mdf) itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
            if (isFirstFrame || itemData.transform.mProps._mdf) itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
        }
        function renderNoop() {}
        function renderPath(styleData, itemData, isFirstFrame) {
            var j;
            var jLen;
            var pathStringTransformed;
            var redraw;
            var pathNodes;
            var l;
            var lLen = itemData.styles.length;
            var lvl = itemData.lvl;
            var paths;
            var mat;
            var iterations;
            var k;
            for(l = 0; l < lLen; l += 1){
                redraw = itemData.sh._mdf || isFirstFrame;
                if (itemData.styles[l].lvl < lvl) {
                    mat = _matrixHelper.reset();
                    iterations = lvl - itemData.styles[l].lvl;
                    k = itemData.transformers.length - 1;
                    while(!redraw && iterations > 0){
                        redraw = itemData.transformers[k].mProps._mdf || redraw;
                        iterations -= 1;
                        k -= 1;
                    }
                    if (redraw) {
                        iterations = lvl - itemData.styles[l].lvl;
                        k = itemData.transformers.length - 1;
                        while(iterations > 0){
                            mat.multiply(itemData.transformers[k].mProps.v);
                            iterations -= 1;
                            k -= 1;
                        }
                    }
                } else mat = _identityMatrix;
                paths = itemData.sh.paths;
                jLen = paths._length;
                if (redraw) {
                    pathStringTransformed = '';
                    for(j = 0; j < jLen; j += 1){
                        pathNodes = paths.shapes[j];
                        if (pathNodes && pathNodes._length) pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
                    }
                    itemData.caches[l] = pathStringTransformed;
                } else pathStringTransformed = itemData.caches[l];
                itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
                itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
            }
        }
        function renderFill(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            if (itemData.c._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
        }
        function renderGradientStroke(styleData, itemData, isFirstFrame) {
            renderGradient(styleData, itemData, isFirstFrame);
            renderStroke(styleData, itemData, isFirstFrame);
        }
        function renderGradient(styleData, itemData, isFirstFrame) {
            var gfill = itemData.gf;
            var hasOpacity = itemData.g._hasOpacity;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (itemData.o._mdf || isFirstFrame) {
                var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
                itemData.style.pElem.setAttribute(attr, itemData.o.v);
            }
            if (itemData.s._mdf || isFirstFrame) {
                var attr1 = styleData.t === 1 ? 'x1' : 'cx';
                var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
                gfill.setAttribute(attr1, pt1[0]);
                gfill.setAttribute(attr2, pt1[1]);
                if (hasOpacity && !itemData.g._collapsable) {
                    itemData.of.setAttribute(attr1, pt1[0]);
                    itemData.of.setAttribute(attr2, pt1[1]);
                }
            }
            var stops;
            var i;
            var len;
            var stop;
            if (itemData.g._cmdf || isFirstFrame) {
                stops = itemData.cst;
                var cValues = itemData.g.c;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    stop.setAttribute('offset', cValues[i * 4] + '%');
                    stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
                }
            }
            if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
                var oValues = itemData.g.o;
                if (itemData.g._collapsable) stops = itemData.cst;
                else stops = itemData.ost;
                len = stops.length;
                for(i = 0; i < len; i += 1){
                    stop = stops[i];
                    if (!itemData.g._collapsable) stop.setAttribute('offset', oValues[i * 2] + '%');
                    stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
                }
            }
            if (styleData.t === 1) {
                if (itemData.e._mdf || isFirstFrame) {
                    gfill.setAttribute('x2', pt2[0]);
                    gfill.setAttribute('y2', pt2[1]);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('x2', pt2[0]);
                        itemData.of.setAttribute('y2', pt2[1]);
                    }
                }
            } else {
                var rad;
                if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
                    rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    gfill.setAttribute('r', rad);
                    if (hasOpacity && !itemData.g._collapsable) itemData.of.setAttribute('r', rad);
                }
                if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
                    if (!rad) rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                    var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                    var percent = itemData.h.v;
                    if (percent >= 1) percent = 0.99;
                    else if (percent <= -1) percent = -0.99;
                    var dist = rad * percent;
                    var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                    var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                    gfill.setAttribute('fx', x);
                    gfill.setAttribute('fy', y);
                    if (hasOpacity && !itemData.g._collapsable) {
                        itemData.of.setAttribute('fx', x);
                        itemData.of.setAttribute('fy', y);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke(styleData, itemData, isFirstFrame) {
            var styleElem = itemData.style;
            var d = itemData.d;
            if (d && (d._mdf || isFirstFrame) && d.dashStr) {
                styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
                styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
            }
            if (itemData.c && (itemData.c._mdf || isFirstFrame)) styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
            if (itemData.o._mdf || isFirstFrame) styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
            if (itemData.w._mdf || isFirstFrame) {
                styleElem.pElem.setAttribute('stroke-width', itemData.w.v);
                if (styleElem.msElem) styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
            }
        }
        return ob;
    }();
    function SVGShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i;
        var len = this.shapes.length;
        var shape;
        var j;
        var jLen = this.stylesList.length;
        var style;
        var tempShapes = [];
        var areAnimated = false;
        for(j = 0; j < jLen; j += 1){
            style = this.stylesList[j];
            areAnimated = false;
            tempShapes.length = 0;
            for(i = 0; i < len; i += 1){
                shape = this.shapes[i];
                if (shape.styles.indexOf(style) !== -1) {
                    tempShapes.push(shape);
                    areAnimated = shape._isAnimated || areAnimated;
                }
            }
            if (tempShapes.length > 1 && areAnimated) this.setShapesAsAnimated(tempShapes);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes) {
        var i;
        var len = shapes.length;
        for(i = 0; i < len; i += 1)shapes[i].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data, level) {
        // TODO: prevent drawing of hidden styles
        var elementData;
        var styleOb = new SVGStyleData(data, level);
        var pathElement = styleOb.pElem;
        if (data.ty === 'st') elementData = new SVGStrokeStyleData(this, data, styleOb);
        else if (data.ty === 'fl') elementData = new SVGFillStyleData(this, data, styleOb);
        else if (data.ty === 'gf' || data.ty === 'gs') {
            var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData = new GradientConstructor(this, data, styleOb);
            this.globalData.defs.appendChild(elementData.gf);
            if (elementData.maskId) {
                this.globalData.defs.appendChild(elementData.ms);
                this.globalData.defs.appendChild(elementData.of);
                pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
            }
        } else if (data.ty === 'no') elementData = new SVGNoStyleData(this, data, styleOb);
        if (data.ty === 'st' || data.ty === 'gs') {
            pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
            pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
            pathElement.setAttribute('fill-opacity', '0');
            if (data.lj === 1) pathElement.setAttribute('stroke-miterlimit', data.ml);
        }
        if (data.r === 2) pathElement.setAttribute('fill-rule', 'evenodd');
        if (data.ln) pathElement.setAttribute('id', data.ln);
        if (data.cl) pathElement.setAttribute('class', data.cl);
        if (data.bm) pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
        this.stylesList.push(styleOb);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createGroupElement = function(data) {
        var elementData = new ShapeGroupData();
        if (data.ln) elementData.gr.setAttribute('id', data.ln);
        if (data.cl) elementData.gr.setAttribute('class', data.cl);
        if (data.bm) elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
        return elementData;
    };
    SVGShapeElement.prototype.createTransformElement = function(data, container) {
        var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
        var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.createShapeElement = function(data, ownTransformers, level) {
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
        var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        this.addToAnimatedContents(data, elementData);
        return elementData;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data, element) {
        var i = 0;
        var len = this.animatedContents.length;
        while(i < len){
            if (this.animatedContents[i].element === element) return;
            i += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data),
            element: element,
            data: data
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData) {
        var arr = elementData.styles;
        var j;
        var jLen = this.stylesList.length;
        for(j = 0; j < jLen; j += 1)if (!this.stylesList[j].closed) arr.push(this.stylesList[j]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, container, level, transformers, render) {
        var ownTransformers = [].concat(transformers);
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var currentTransform;
        var modifier;
        var processedPos;
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._render = render;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], level);
                else itemsData[i].style.closed = false;
                if (arr[i]._render) {
                    if (itemsData[i].style.pElem.parentNode !== container) container.appendChild(itemsData[i].style.pElem);
                }
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);
                if (arr[i]._render) {
                    if (itemsData[i].gr.parentNode !== container) container.appendChild(itemsData[i].gr);
                }
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) itemsData[i] = this.createTransformElement(arr[i], container);
                currentTransform = itemsData[i].transform;
                ownTransformers.push(currentTransform);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
                this.setElementStyles(itemsData[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    render = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        len = ownStyles.length;
        for(i = 0; i < len; i += 1)ownStyles[i].closed = true;
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)this.stylesList[i].reset();
        this.renderShape();
        for(i = 0; i < len; i += 1)if (this.stylesList[i]._mdf || this._isFirstFrame) {
            if (this.stylesList[i].msElem) {
                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
            }
            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i;
        var len = this.animatedContents.length;
        var animatedContent;
        for(i = 0; i < len; i += 1){
            animatedContent = this.animatedContents[i];
            if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o, sw, sc, fc, m, p) {
        this.o = o;
        this.sw = sw;
        this.sc = sc;
        this.fc = fc;
        this.m = m;
        this.p = p;
        this._mdf = {
            o: true,
            sw: !!sw,
            sc: !!sc,
            fc: !!fc,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated = false;
        if (this.o !== o) {
            this.o = o;
            this._mdf.o = true;
            updated = true;
        }
        if (this.sw !== sw) {
            this.sw = sw;
            this._mdf.sw = true;
            updated = true;
        }
        if (this.sc !== sc) {
            this.sc = sc;
            this._mdf.sc = true;
            updated = true;
        }
        if (this.fc !== fc) {
            this.fc = fc;
            this._mdf.fc = true;
            updated = true;
        }
        if (this.m !== m) {
            this.m = m;
            this._mdf.m = true;
            updated = true;
        }
        if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
            this.p = p;
            this._mdf.p = true;
            updated = true;
        }
        return updated;
    };
    function TextProperty(elem, data) {
        this._frameId = initialDefaultFrame;
        this.pv = '';
        this.v = '';
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data.d && data.d.sid) data.d = elem.globalData.slotManager.getProp(data.d);
        this.data = data;
        this.elem = elem;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: '',
            fStyle: '',
            fWeight: '',
            fc: '',
            j: '',
            justifyOffset: '',
            l: [],
            lh: 0,
            lineWidths: [],
            ls: '',
            of: '',
            s: '',
            sc: '',
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj, data) {
        for(var s in data)if (Object.prototype.hasOwnProperty.call(data, s)) obj[s] = data[s];
        return obj;
    };
    TextProperty.prototype.setCurrentData = function(data) {
        if (!data.__complete) this.completeTextData(data);
        this.currentData = data;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction) {
        this.effectsSequence.push(effectFunction);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue = this.currentData;
        var currentIndex = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i;
        var len = this.effectsSequence.length;
        var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;
        for(i = 0; i < len; i += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex !== this.keysIndex) finalValue = this.effectsSequence[i](finalValue, finalValue.t);
        else finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
        if (currentValue !== finalValue) this.setCurrentData(finalValue);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys = this.data.d.k;
        var frameNum = this.elem.comp.renderedFrame;
        var i = 0;
        var len = textKeys.length;
        while(i <= len - 1){
            if (i === len - 1 || textKeys[i + 1].t > frameNum) break;
            i += 1;
        }
        if (this.keysIndex !== i) this.keysIndex = i;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text) {
        var charactersArray = [];
        var i = 0;
        var len = text.length;
        var charCode;
        var secondCharCode;
        var shouldCombine = false;
        var shouldCombineNext = false;
        var currentChars = '';
        while(i < len){
            shouldCombine = shouldCombineNext;
            shouldCombineNext = false;
            charCode = text.charCodeAt(i);
            currentChars = text.charAt(i);
            if (FontManager.isCombinedCharacter(charCode)) shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
            else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                if (FontManager.isRegionalFlag(text, i)) currentChars = text.substr(i, 14);
                else {
                    secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)
                    if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
                        if (FontManager.isModifier(charCode, secondCharCode)) {
                            currentChars = text.substr(i, 2);
                            shouldCombine = true;
                        } else if (FontManager.isFlagEmoji(text.substr(i, 4))) currentChars = text.substr(i, 4);
                        else currentChars = text.substr(i, 2);
                    }
                }
            } else if (charCode > 0xDBFF) {
                secondCharCode = text.charCodeAt(i + 1);
                if (FontManager.isVariationSelector(charCode)) shouldCombine = true;
            } else if (FontManager.isZeroWidthJoiner(charCode)) {
                shouldCombine = true;
                shouldCombineNext = true;
            }
            if (shouldCombine) {
                charactersArray[charactersArray.length - 1] += currentChars;
                shouldCombine = false;
            } else charactersArray.push(currentChars);
            i += currentChars.length;
        }
        return charactersArray;
    };
    TextProperty.prototype.completeTextData = function(documentData) {
        documentData.__complete = true;
        var fontManager = this.elem.globalData.fontManager;
        var data = this.data;
        var letters = [];
        var i;
        var len;
        var newLineFlag;
        var index = 0;
        var val;
        var anchorGrouping = data.m.g;
        var currentSize = 0;
        var currentPos = 0;
        var currentLine = 0;
        var lineWidths = [];
        var lineWidth = 0;
        var maxLineWidth = 0;
        var j;
        var jLen;
        var fontData = fontManager.getFontByName(documentData.f);
        var charData;
        var cLength = 0;
        var fontProps = getFontProperties(fontData);
        documentData.fWeight = fontProps.weight;
        documentData.fStyle = fontProps.style;
        documentData.finalSize = documentData.s;
        documentData.finalText = this.buildFinalText(documentData.t);
        len = documentData.finalText.length;
        documentData.finalLineHeight = documentData.lh;
        var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var charCode;
        if (documentData.sz) {
            var flag = true;
            var boxWidth = documentData.sz[0];
            var boxHeight = documentData.sz[1];
            var currentHeight;
            var finalText;
            while(flag){
                finalText = this.buildFinalText(documentData.t);
                currentHeight = 0;
                lineWidth = 0;
                len = finalText.length;
                trackingOffset = documentData.tr / 1000 * documentData.finalSize;
                var lastSpaceIndex = -1;
                for(i = 0; i < len; i += 1){
                    charCode = finalText[i].charCodeAt(0);
                    newLineFlag = false;
                    if (finalText[i] === ' ') lastSpaceIndex = i;
                    else if (charCode === 13 || charCode === 3) {
                        lineWidth = 0;
                        newLineFlag = true;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                    }
                    if (fontManager.chars) {
                        charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
                        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
                    if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
                        if (lastSpaceIndex === -1) len += 1;
                        else i = lastSpaceIndex;
                        currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
                        finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex = -1;
                        lineWidth = 0;
                    } else {
                        lineWidth += cLength;
                        lineWidth += trackingOffset;
                    }
                }
                currentHeight += fontData.ascent * documentData.finalSize / 100;
                if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
                    documentData.finalSize -= 1;
                    documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
                } else {
                    documentData.finalText = finalText;
                    len = documentData.finalText.length;
                    flag = false;
                }
            }
        }
        lineWidth = -trackingOffset;
        cLength = 0;
        var uncollapsedSpaces = 0;
        var currentChar;
        for(i = 0; i < len; i += 1){
            newLineFlag = false;
            currentChar = documentData.finalText[i];
            charCode = currentChar.charCodeAt(0);
            if (charCode === 13 || charCode === 3) {
                uncollapsedSpaces = 0;
                lineWidths.push(lineWidth);
                maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
                lineWidth = -2 * trackingOffset;
                val = '';
                newLineFlag = true;
                currentLine += 1;
            } else val = currentChar;
            if (fontManager.chars) {
                charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
                cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
             //
            if (currentChar === ' ') uncollapsedSpaces += cLength + trackingOffset;
            else {
                lineWidth += cLength + trackingOffset + uncollapsedSpaces;
                uncollapsedSpaces = 0;
            }
            letters.push({
                l: cLength,
                an: cLength,
                add: currentSize,
                n: newLineFlag,
                anIndexes: [],
                val: val,
                line: currentLine,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping == 2) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || val === ' ' || i === len - 1) {
                    if (val === '' || val === ' ') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    index += 1;
                    currentSize = 0;
                }
            } else if (anchorGrouping == 3) {
                // eslint-disable-line eqeqeq
                currentSize += cLength;
                if (val === '' || i === len - 1) {
                    if (val === '') currentSize -= cLength;
                    while(currentPos <= i){
                        letters[currentPos].an = currentSize;
                        letters[currentPos].ind = index;
                        letters[currentPos].extra = cLength;
                        currentPos += 1;
                    }
                    currentSize = 0;
                    index += 1;
                }
            } else {
                letters[index].ind = index;
                letters[index].extra = 0;
                index += 1;
            }
        }
        documentData.l = letters;
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidths.push(lineWidth);
        if (documentData.sz) {
            documentData.boxWidth = documentData.sz[0];
            documentData.justifyOffset = 0;
        } else {
            documentData.boxWidth = maxLineWidth;
            switch(documentData.j){
                case 1:
                    documentData.justifyOffset = -documentData.boxWidth;
                    break;
                case 2:
                    documentData.justifyOffset = -documentData.boxWidth / 2;
                    break;
                default:
                    documentData.justifyOffset = 0;
            }
        }
        documentData.lineWidths = lineWidths;
        var animators = data.a;
        var animatorData;
        var letterData;
        jLen = animators.length;
        var based;
        var ind;
        var indexes = [];
        for(j = 0; j < jLen; j += 1){
            animatorData = animators[j];
            if (animatorData.a.sc) documentData.strokeColorAnim = true;
            if (animatorData.a.sw) documentData.strokeWidthAnim = true;
            if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) documentData.fillColorAnim = true;
            ind = 0;
            based = animatorData.s.b;
            for(i = 0; i < len; i += 1){
                letterData = letters[i];
                letterData.anIndexes[j] = ind;
                if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData.s.rn === 1) indexes.push(ind);
                    ind += 1;
                }
            }
            data.a[j].s.totalChars = ind;
            var currentInd = -1;
            var newInd;
            if (animatorData.s.rn === 1) for(i = 0; i < len; i += 1){
                letterData = letters[i];
                if (currentInd != letterData.anIndexes[j]) {
                    // eslint-disable-line eqeqeq
                    currentInd = letterData.anIndexes[j];
                    newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
                }
                letterData.anIndexes[j] = newInd;
            }
        }
        documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
        documentData.ls = documentData.ls || 0;
        documentData.ascent = fontData.ascent * documentData.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData, index) {
        index = index === undefined ? this.keysIndex : index;
        var dData = this.copyData({}, this.data.d.k[index].s);
        dData = this.copyData(dData, newData);
        this.data.d.k[index].s = dData;
        this.recalculate(index);
        this.setCurrentData(dData);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index) {
        var dData = this.data.d.k[index].s;
        dData.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData);
    };
    TextProperty.prototype.canResizeFont = function(_canResize) {
        this.canResize = _canResize;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue) {
        this.minimumFontSize = Math.floor(_fontValue) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        function TextSelectorPropFactory(elem, data) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data;
            this.elem = elem;
            this.comp = elem.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem);
            this.s = PropertyFactory.getProp(elem, data.s || {
                k: 0
            }, 0, 0, this);
            if ('e' in data) this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem, data.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem, data.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem, data.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem, data.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory.prototype = {
            getMult: function getMult(ind) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x1 = 0;
                var y1 = 0;
                var x2 = 1;
                var y2 = 1;
                if (this.ne.v > 0) x1 = this.ne.v / 100.0;
                else y1 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x2 = 1.0 - this.xe.v / 100.0;
                else y2 = 1.0 + this.xe.v / 100.0;
                var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
                var mult = 0;
                var s = this.finalS;
                var e = this.finalE;
                var type = this.data.sh;
                if (type === 2) {
                    if (e === s) mult = ind >= e ? 1 : 0;
                    else mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 3) {
                    if (e === s) mult = ind >= e ? 0 : 1;
                    else mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                    mult = easer(mult);
                } else if (type === 4) {
                    if (e === s) mult = 0;
                    else {
                        mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
                        if (mult < 0.5) mult *= 2;
                        else mult = 1 - 2 * (mult - 0.5);
                    }
                    mult = easer(mult);
                } else if (type === 5) {
                    if (e === s) mult = 0;
                    else {
                        var tot = e - s;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind = min(max(0, ind + 0.5 - s), e - s);
                        var x = -tot / 2 + ind;
                        var a = tot / 2;
                        mult = Math.sqrt(1 - x * x / (a * a));
                    }
                    mult = easer(mult);
                } else if (type === 6) {
                    if (e === s) mult = 0;
                    else {
                        ind = min(max(0, ind + 0.5 - s), e - s);
                        mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
                    }
                    mult = easer(mult);
                } else {
                    if (ind >= floor(s)) {
                        if (ind - s < 0) mult = max(0, min(min(e, 1) - (s - ind), 1));
                        else mult = max(0, min(e - ind, 1));
                    }
                    mult = easer(mult);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness = this.sm.v * 0.01;
                    if (smoothness === 0) smoothness = 0.00000001;
                    var threshold = 0.5 - smoothness * 0.5;
                    if (mult < threshold) mult = 0;
                    else {
                        mult = (mult - threshold) / smoothness;
                        if (mult > 1) mult = 1;
                    }
                }
                return mult * this.a.v;
            },
            getValue: function getValue(newCharsFlag) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o = this.o.v / divisor;
                var s = this.s.v / divisor + o;
                var e = this.e.v / divisor + o;
                if (s > e) {
                    var _s = s;
                    s = e;
                    e = _s;
                }
                this.finalS = s;
                this.finalE = e;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory);
        function getTextSelectorProp(elem, data, arr) {
            return new TextSelectorPropFactory(elem, data, arr);
        }
        return {
            getTextSelectorProp: getTextSelectorProp
        };
    }();
    function TextAnimatorDataProperty(elem, animatorProps, container) {
        var defaultData = {
            propType: false
        };
        var getProp = PropertyFactory.getProp;
        var textAnimatorAnimatables = animatorProps.a;
        this.a = {
            r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
            rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
            ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
            sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
            sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
            s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
            a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
            o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
            p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
            sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
            sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
            fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
            fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
            fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
            fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
            t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
        this.s.t = animatorProps.s.t;
    }
    function TextAnimatorProperty(textData, renderType, elem) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData;
        this._renderType = renderType;
        this._elem = elem;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i;
        var len = this._textData.a.length;
        var animatorProps;
        var getProp = PropertyFactory.getProp;
        for(i = 0; i < len; i += 1){
            animatorProps = this._textData.a[i];
            this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
        }
        if (this._textData.p && 'm' in this._textData.p) {
            this._pathData = {
                a: getProp(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag) {
        this.lettersChangedFlag = lettersChangedFlag;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment = this._moreOptions.alignment.v;
        var animators = this._animatorsData;
        var textData = this._textData;
        var matrixHelper = this.mHelper;
        var renderType = this._renderType;
        var renderedLettersCount = this.renderedLetters.length;
        var xPos;
        var yPos;
        var i;
        var len;
        var letters = documentData.l;
        var pathInfo;
        var currentLength;
        var currentPoint;
        var segmentLength;
        var flag;
        var pointInd;
        var segmentInd;
        var prevPoint;
        var points;
        var segments;
        var partialLength;
        var totalLength;
        var perc;
        var tanAngle;
        var mask;
        if (this._hasMaskedPath) {
            mask = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths = mask.v;
                if (this._pathData.r.v) paths = paths.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo = {
                    tLength: 0,
                    segments: []
                };
                len = paths._length - 1;
                var bezierData;
                totalLength = 0;
                for(i = 0; i < len; i += 1){
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[i + 1][0] - paths.v[i + 1][0],
                        paths.i[i + 1][1] - paths.v[i + 1][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                i = len;
                if (mask.v.c) {
                    bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [
                        paths.o[i][0] - paths.v[i][0],
                        paths.o[i][1] - paths.v[i][1]
                    ], [
                        paths.i[0][0] - paths.v[0][0],
                        paths.i[0][1] - paths.v[0][1]
                    ]);
                    pathInfo.tLength += bezierData.segmentLength;
                    pathInfo.segments.push(bezierData);
                    totalLength += bezierData.segmentLength;
                }
                this._pathData.pi = pathInfo;
            }
            pathInfo = this._pathData.pi;
            currentLength = this._pathData.f.v;
            segmentInd = 0;
            pointInd = 1;
            segmentLength = 0;
            flag = true;
            segments = pathInfo.segments;
            if (currentLength < 0 && mask.v.c) {
                if (pathInfo.tLength < Math.abs(currentLength)) currentLength = -Math.abs(currentLength) % pathInfo.tLength;
                segmentInd = segments.length - 1;
                points = segments[segmentInd].points;
                pointInd = points.length - 1;
                while(currentLength < 0){
                    currentLength += points[pointInd].partialLength;
                    pointInd -= 1;
                    if (pointInd < 0) {
                        segmentInd -= 1;
                        points = segments[segmentInd].points;
                        pointInd = points.length - 1;
                    }
                }
            }
            points = segments[segmentInd].points;
            prevPoint = points[pointInd - 1];
            currentPoint = points[pointInd];
            partialLength = currentPoint.partialLength;
        }
        len = letters.length;
        xPos = 0;
        yPos = 0;
        var yOff = documentData.finalSize * 1.2 * 0.714;
        var firstLine = true;
        var animatorProps;
        var animatorSelector;
        var j;
        var jLen;
        var letterValue;
        jLen = animators.length;
        var mult;
        var ind = -1;
        var offf;
        var xPathPos;
        var yPathPos;
        var initPathPos = currentLength;
        var initSegmentInd = segmentInd;
        var initPointInd = pointInd;
        var currentLine = -1;
        var elemOpacity;
        var sc;
        var sw;
        var fc;
        var k;
        var letterSw;
        var letterSc;
        var letterFc;
        var letterM = '';
        var letterP = this.defaultPropsArray;
        var letterO; //
        if (documentData.j === 2 || documentData.j === 1) {
            var animatorJustifyOffset = 0;
            var animatorFirstCharOffset = 0;
            var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
            var lastIndex = 0;
            var isNewLine = true;
            for(i = 0; i < len; i += 1)if (letters[i].n) {
                if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
                while(lastIndex < i){
                    letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                    lastIndex += 1;
                }
                animatorJustifyOffset = 0;
                isNewLine = true;
            } else {
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        if (isNewLine && documentData.j === 2) animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
                        else animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
                    }
                }
                isNewLine = false;
            }
            if (animatorJustifyOffset) animatorJustifyOffset += animatorFirstCharOffset;
            while(lastIndex < i){
                letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
                lastIndex += 1;
            }
        } //
        for(i = 0; i < len; i += 1){
            matrixHelper.reset();
            elemOpacity = 1;
            if (letters[i].n) {
                xPos = 0;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                currentLength = initPathPos;
                firstLine = false;
                if (this._hasMaskedPath) {
                    segmentInd = initSegmentInd;
                    pointInd = initPointInd;
                    points = segments[segmentInd].points;
                    prevPoint = points[pointInd - 1];
                    currentPoint = points[pointInd];
                    partialLength = currentPoint.partialLength;
                    segmentLength = 0;
                }
                letterM = '';
                letterFc = '';
                letterSw = '';
                letterO = '';
                letterP = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine !== letters[i].line) {
                        switch(documentData.j){
                            case 1:
                                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                                break;
                            case 2:
                                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine = letters[i].line;
                    }
                    if (ind !== letters[i].ind) {
                        if (letters[ind]) currentLength += letters[ind].extra;
                        currentLength += letters[i].an / 2;
                        ind = letters[i].ind;
                    }
                    currentLength += alignment[0] * letters[i].an * 0.005;
                    var animatorOffset = 0;
                    for(j = 0; j < jLen; j += 1){
                        animatorProps = animators[j].a;
                        if (animatorProps.p.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.p.v[0] * mult[0];
                            else animatorOffset += animatorProps.p.v[0] * mult;
                        }
                        if (animatorProps.a.propType) {
                            animatorSelector = animators[j].s;
                            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                            if (mult.length) animatorOffset += animatorProps.a.v[0] * mult[0];
                            else animatorOffset += animatorProps.a.v[0] * mult;
                        }
                    }
                    flag = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
                        currentLength += this._pathData.f.v;
                    }
                    while(flag){
                        if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
                            perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
                            xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
                            yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
                            matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
                            flag = false;
                        } else if (points) {
                            segmentLength += currentPoint.partialLength;
                            pointInd += 1;
                            if (pointInd >= points.length) {
                                pointInd = 0;
                                segmentInd += 1;
                                if (!segments[segmentInd]) {
                                    if (mask.v.c) {
                                        pointInd = 0;
                                        segmentInd = 0;
                                        points = segments[segmentInd].points;
                                    } else {
                                        segmentLength -= currentPoint.partialLength;
                                        points = null;
                                    }
                                } else points = segments[segmentInd].points;
                            }
                            if (points) {
                                prevPoint = currentPoint;
                                currentPoint = points[pointInd];
                                partialLength = currentPoint.partialLength;
                            }
                        }
                    }
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0);
                } else {
                    offf = letters[i].an / 2 - letters[i].add;
                    matrixHelper.translate(-offf, 0, 0); // Grouping alignment
                    matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.t.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos !== 0 || documentData.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult.length) currentLength += animatorProps.t.v * mult[0];
                                else currentLength += animatorProps.t.v * mult;
                            } else if (mult.length) xPos += animatorProps.t.v * mult[0];
                            else xPos += animatorProps.t.v * mult;
                        }
                    }
                }
                if (documentData.strokeWidthAnim) sw = documentData.sw || 0;
                if (documentData.strokeColorAnim) {
                    if (documentData.sc) sc = [
                        documentData.sc[0],
                        documentData.sc[1],
                        documentData.sc[2]
                    ];
                    else sc = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData.fillColorAnim && documentData.fc) fc = [
                    documentData.fc[0],
                    documentData.fc[1],
                    documentData.fc[2]
                ];
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.a.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
                        else matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.s.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (mult.length) matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
                        else matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    animatorSelector = animators[j].s;
                    mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                    if (animatorProps.sk.propType) {
                        if (mult.length) matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
                        else matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
                    }
                    if (animatorProps.r.propType) {
                        if (mult.length) matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
                        else matrixHelper.rotateZ(-animatorProps.r.v * mult);
                    }
                    if (animatorProps.ry.propType) {
                        if (mult.length) matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
                        else matrixHelper.rotateY(animatorProps.ry.v * mult);
                    }
                    if (animatorProps.rx.propType) {
                        if (mult.length) matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
                        else matrixHelper.rotateX(animatorProps.rx.v * mult);
                    }
                    if (animatorProps.o.propType) {
                        if (mult.length) elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
                        else elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
                    }
                    if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
                        if (mult.length) sw += animatorProps.sw.v * mult[0];
                        else sw += animatorProps.sw.v * mult;
                    }
                    if (documentData.strokeColorAnim && animatorProps.sc.propType) {
                        for(k = 0; k < 3; k += 1)if (mult.length) sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
                        else sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
                    }
                    if (documentData.fillColorAnim && documentData.fc) {
                        if (animatorProps.fc.propType) {
                            for(k = 0; k < 3; k += 1)if (mult.length) fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                            else fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                        }
                        if (animatorProps.fh.propType) {
                            if (mult.length) fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
                            else fc = addHueToRGB(fc, animatorProps.fh.v * mult);
                        }
                        if (animatorProps.fs.propType) {
                            if (mult.length) fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
                            else fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
                        }
                        if (animatorProps.fb.propType) {
                            if (mult.length) fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
                            else fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
                        }
                    }
                }
                for(j = 0; j < jLen; j += 1){
                    animatorProps = animators[j].a;
                    if (animatorProps.p.propType) {
                        animatorSelector = animators[j].s;
                        mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult.length) matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
                            else matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                        } else if (mult.length) matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
                        else matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
                    }
                }
                if (documentData.strokeWidthAnim) letterSw = sw < 0 ? 0 : sw;
                if (documentData.strokeColorAnim) letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
                if (documentData.fillColorAnim && documentData.fc) letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
                if (this._hasMaskedPath) {
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);
                    if (this._pathData.p.v) {
                        tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
                        var rot = Math.atan(tanAngle) * 180 / Math.PI;
                        if (currentPoint.point[0] < prevPoint.point[0]) rot += 180;
                        matrixHelper.rotate(-rot * Math.PI / 180);
                    }
                    matrixHelper.translate(xPathPos, yPathPos, 0);
                    currentLength -= alignment[0] * letters[i].an * 0.005;
                    if (letters[i + 1] && ind !== letters[i + 1].ind) {
                        currentLength += letters[i].an / 2;
                        currentLength += documentData.tr * 0.001 * documentData.finalSize;
                    }
                } else {
                    matrixHelper.translate(xPos, yPos, 0);
                    if (documentData.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
                    switch(documentData.j){
                        case 1:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper.translate(0, -documentData.ls);
                    matrixHelper.translate(offf, 0, 0);
                    matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
                    xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
                }
                if (renderType === 'html') letterM = matrixHelper.toCSS();
                else if (renderType === 'svg') letterM = matrixHelper.to2dCSS();
                else letterP = [
                    matrixHelper.props[0],
                    matrixHelper.props[1],
                    matrixHelper.props[2],
                    matrixHelper.props[3],
                    matrixHelper.props[4],
                    matrixHelper.props[5],
                    matrixHelper.props[6],
                    matrixHelper.props[7],
                    matrixHelper.props[8],
                    matrixHelper.props[9],
                    matrixHelper.props[10],
                    matrixHelper.props[11],
                    matrixHelper.props[12],
                    matrixHelper.props[13],
                    matrixHelper.props[14],
                    matrixHelper.props[15]
                ];
                letterO = elemOpacity;
            }
            if (renderedLettersCount <= i) {
                letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
                this.renderedLetters.push(letterValue);
                renderedLettersCount += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue = this.renderedLetters[i];
                this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data, globalData, comp) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
        var j;
        var jLen = shapes.length;
        var pathNodes;
        var shapeStr = '';
        for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
            pathNodes = shapes[j].ks.k;
            shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
        }
        return shapeStr;
    };
    ITextElement.prototype.updateDocumentData = function(newData, index) {
        this.textProperty.updateDocumentData(newData, index);
    };
    ITextElement.prototype.canResizeFont = function(_canResize) {
        this.textProperty.canResizeFont(_canResize);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize) {
        this.textProperty.setMinimumFontSize(_fontSize);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
        if (documentData.ps) matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
        matrixHelper.translate(0, -documentData.ls, 0);
        switch(documentData.j){
            case 1:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
                break;
            case 2:
                matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper.translate(xPos, yPos, 0);
    };
    ITextElement.prototype.buildColor = function(colorData) {
        return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data, globalData, comp) {
        this.textSpans = [];
        this.renderType = 'svg';
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS('text');
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray) {
        var i = 0;
        var len = textArray.length;
        var textContents = [];
        var currentTextContent = '';
        while(i < len){
            if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
                textContents.push(currentTextContent);
                currentTextContent = '';
            } else currentTextContent += textArray[i];
            i += 1;
        }
        textContents.push(currentTextContent);
        return textContents;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data, scale) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data.shapes && data.shapes.length) {
            var shape = data.shapes[0];
            if (shape.it) {
                var shapeItem = shape.it[shape.it.length - 1];
                if (shapeItem.s) {
                    shapeItem.s.k[0] = scale;
                    shapeItem.s.k[1] = scale;
                }
            }
        }
        return data;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i;
        var len;
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);
        if (documentData.fc) this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
        else this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
        if (documentData.sc) {
            this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
            this.layerElement.setAttribute('stroke-width', documentData.sw);
        }
        this.layerElement.setAttribute('font-size', documentData.finalSize);
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (fontData.fClass) this.layerElement.setAttribute('class', fontData.fClass);
        else {
            this.layerElement.setAttribute('font-family', fontData.fFamily);
            var fWeight = documentData.fWeight;
            var fStyle = documentData.fStyle;
            this.layerElement.setAttribute('font-style', fStyle);
            this.layerElement.setAttribute('font-weight', fWeight);
        }
        this.layerElement.setAttribute('aria-label', documentData.t);
        var letters = documentData.l || [];
        var usesGlyphs = !!this.globalData.fontManager.chars;
        len = letters.length;
        var tSpan;
        var matrixHelper = this.mHelper;
        var shapeStr = '';
        var singleShape = this.data.singleShape;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        if (singleShape && !usesGlyphs && !documentData.sz) {
            var tElement = this.textContainer;
            var justify = 'start';
            switch(documentData.j){
                case 1:
                    justify = 'end';
                    break;
                case 2:
                    justify = 'middle';
                    break;
                default:
                    justify = 'start';
                    break;
            }
            tElement.setAttribute('text-anchor', justify);
            tElement.setAttribute('letter-spacing', trackingOffset);
            var textContent = this.buildTextContents(documentData.finalText);
            len = textContent.length;
            yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
            for(i = 0; i < len; i += 1){
                tSpan = this.textSpans[i].span || createNS('tspan');
                tSpan.textContent = textContent[i];
                tSpan.setAttribute('x', 0);
                tSpan.setAttribute('y', yPos);
                tSpan.style.display = 'inherit';
                tElement.appendChild(tSpan);
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i].span = tSpan;
                yPos += documentData.finalLineHeight;
            }
            this.layerElement.appendChild(tElement);
        } else {
            var cachedSpansLength = this.textSpans.length;
            var charData;
            for(i = 0; i < len; i += 1){
                if (!this.textSpans[i]) this.textSpans[i] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs || !singleShape || i === 0) {
                    tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');
                    if (cachedSpansLength <= i) {
                        tSpan.setAttribute('stroke-linecap', 'butt');
                        tSpan.setAttribute('stroke-linejoin', 'round');
                        tSpan.setAttribute('stroke-miterlimit', '4');
                        this.textSpans[i].span = tSpan;
                        if (usesGlyphs) {
                            var childSpan = createNS('g');
                            tSpan.appendChild(childSpan);
                            this.textSpans[i].childSpan = childSpan;
                        }
                        this.textSpans[i].span = tSpan;
                        this.layerElement.appendChild(tSpan);
                    }
                    tSpan.style.display = 'inherit';
                }
                matrixHelper.reset();
                if (singleShape) {
                    if (letters[i].n) {
                        xPos = -trackingOffset;
                        yPos += documentData.yOffset;
                        yPos += firstLine ? 1 : 0;
                        firstLine = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
                    xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos += trackingOffset;
                }
                if (usesGlyphs) {
                    charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                    var glyphElement; // t === 1 means the character has been replaced with an animated shaped
                    if (charData.t === 1) glyphElement = new SVGCompElement(charData.data, this.globalData, this);
                    else {
                        var data = emptyShapeData;
                        if (charData.data && charData.data.shapes) data = this.buildShapeData(charData.data, documentData.finalSize);
                        glyphElement = new SVGShapeElement(data, this.globalData, this);
                    }
                    if (this.textSpans[i].glyph) {
                        var glyph = this.textSpans[i].glyph;
                        this.textSpans[i].childSpan.removeChild(glyph.layerElement);
                        glyph.destroy();
                    }
                    this.textSpans[i].glyph = glyphElement;
                    glyphElement._debug = true;
                    glyphElement.prepareFrame(0);
                    glyphElement.renderFrame();
                    this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData.t === 1) this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
                } else {
                    if (singleShape) tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
                    tSpan.textContent = letters[i].val;
                    tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                } //
            }
            if (singleShape && tSpan) tSpan.setAttribute('d', shapeStr);
        }
        while(i < this.textSpans.length){
            this.textSpans[i].span.style.display = 'none';
            i += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox = this.layerElement.getBBox();
            this.bbox = {
                top: textBox.y,
                left: textBox.x,
                width: textBox.width,
                height: textBox.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i;
        var len = this.textSpans.length;
        var glyphElement;
        this.renderedFrame = this.comp.renderedFrame;
        for(i = 0; i < len; i += 1){
            glyphElement = this.textSpans[i].glyph;
            if (glyphElement) {
                glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i;
                var len;
                var renderedLetters = this.textAnimator.renderedLetters;
                var letters = this.textProperty.currentData.l;
                len = letters.length;
                var renderedLetter;
                var textSpan;
                var glyphElement;
                for(i = 0; i < len; i += 1)if (!letters[i].n) {
                    renderedLetter = renderedLetters[i];
                    textSpan = this.textSpans[i].span;
                    glyphElement = this.textSpans[i].glyph;
                    if (glyphElement) glyphElement.renderFrame();
                    if (renderedLetter._mdf.m) textSpan.setAttribute('transform', renderedLetter.m);
                    if (renderedLetter._mdf.o) textSpan.setAttribute('opacity', renderedLetter.o);
                    if (renderedLetter._mdf.sw) textSpan.setAttribute('stroke-width', renderedLetter.sw);
                    if (renderedLetter._mdf.sc) textSpan.setAttribute('stroke', renderedLetter.sc);
                    if (renderedLetter._mdf.fc) textSpan.setAttribute('fill', renderedLetter.fc);
                }
            }
        }
    };
    function ISolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect.setAttribute('width', this.data.sw);
        rect.setAttribute('height', this.data.sh);
        rect.setAttribute('fill', this.data.sc);
        this.layerElement.appendChild(rect);
    };
    function NullElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initFrame();
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data) {
        return new NullElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data) {
        return new SVGShapeElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data) {
        return new SVGTextLottieElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data) {
        return new IImageElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data) {
        return new ISolidElement(data, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData) {
        this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute('width', animData.w);
            this.svgElement.setAttribute('height', animData.h);
            this.svgElement.style.width = '100%';
            this.svgElement.style.height = '100%';
            this.svgElement.style.transform = 'translate3d(0,0,0)';
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute('width', this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute('height', this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute('class', this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute('id', this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
        this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs = this.globalData.defs;
        this.setupGlobalData(animData, defs);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData;
        var maskElement = createNS('clipPath');
        var rect = createNS('rect');
        rect.setAttribute('width', animData.w);
        rect.setAttribute('height', animData.h);
        rect.setAttribute('x', 0);
        rect.setAttribute('y', 0);
        var maskId = createElementID();
        maskElement.setAttribute('id', maskId);
        maskElement.appendChild(rect);
        this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
        defs.appendChild(maskElement);
        this.layers = animData.layers;
        this.elements = createSizedArray(animData.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.layerElement = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind) {
        var i = 0;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1){
            if (this.layers[i].ind === ind) return i;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        elements[pos] = true;
        var element = this.createItem(this.layers[pos]);
        elements[pos] = element;
        if (getExpressionsPlugin()) {
            if (this.layers[pos].ty === 0) this.globalData.projectInterface.registerComposition(element);
            element.initExpressions();
        }
        this.appendElementInPos(element, pos);
        if (this.layers[pos].tt) {
            var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;
            if (elementIndex === -1) return;
            if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
                this.buildItem(elementIndex);
                this.addPendingElement(element);
            } else {
                var matteElement = elements[elementIndex];
                var matteMask = matteElement.getMatte(this.layers[pos].tt);
                element.setMatte(matteMask);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
            if (element.data.tt) {
                var i = 0;
                var len = this.elements.length;
                while(i < len){
                    if (this.elements[i] === element) {
                        var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
                        var matteElement = this.elements[elementIndex];
                        var matteMask = matteElement.getMatte(this.layers[i].tt);
                        element.setMatte(matteMask);
                        break;
                    }
                    i += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num) {
        if (this.renderedFrame === num || this.destroyed) return;
        if (num === null) num = this.renderedFrame;
        else this.renderedFrame = num;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num;
        this.globalData._mdf = false;
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newElement = element.getBaseElement();
        if (!newElement) return;
        var i = 0;
        var nextElement;
        while(i < pos){
            if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) nextElement = this.elements[i].getBaseElement();
            i += 1;
        }
        if (nextElement) this.layerElement.insertBefore(newElement, nextElement);
        else this.layerElement.appendChild(newElement);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = 'none';
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = 'block';
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped = this.tm.v;
            if (timeRemapped === this.data.op) timeRemapped = this.data.op - 1;
            this.renderedFrame = timeRemapped;
        } else this.renderedFrame = num / this.data.sr;
        var i;
        var len = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) {
            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
            if (this.elements[i]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems) {
        this.elements = elems;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i;
        var len = this.layers.length;
        for(i = 0; i < len; i += 1)if (this.elements[i]) this.elements[i].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function SVGRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS('svg');
        var ariaLabel = '';
        if (config && config.title) {
            var titleElement = createNS('title');
            var titleId = createElementID();
            titleElement.setAttribute('id', titleId);
            titleElement.textContent = config.title;
            this.svgElement.appendChild(titleElement);
            ariaLabel += titleId;
        }
        if (config && config.description) {
            var descElement = createNS('desc');
            var descId = createElementID();
            descElement.setAttribute('id', descId);
            descElement.textContent = config.description;
            this.svgElement.appendChild(descElement);
            ariaLabel += ' ' + descId;
        }
        if (ariaLabel) this.svgElement.setAttribute('aria-labelledby', ariaLabel);
        var defs = createNS('defs');
        this.svgElement.appendChild(defs);
        var maskElement = createNS('g');
        this.svgElement.appendChild(maskElement);
        this.layerElement = maskElement;
        this.renderConfig = {
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            progressiveLoad: config && config.progressiveLoad || false,
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            viewBoxOnly: config && config.viewBoxOnly || false,
            viewBoxSize: config && config.viewBoxSize || false,
            className: config && config.className || '',
            id: config && config.id || '',
            focusable: config && config.focusable,
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '100%',
                height: config && config.filterSize && config.filterSize.height || '100%',
                x: config && config.filterSize && config.filterSize.x || '0%',
                y: config && config.filterSize && config.filterSize.y || '0%'
            },
            width: config && config.width,
            height: config && config.height,
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = 'svg';
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data) {
        return new SVGCompElement(data, this.globalData, this);
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence(transforms) {
            var i;
            var len = transforms.length;
            var key = '_';
            for(i = 0; i < len; i += 1)key += transforms[i].transform.key + '_';
            var sequence = this.sequences[key];
            if (!sequence) {
                sequence = {
                    transforms: [].concat(transforms),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key] = sequence;
                this.sequenceList.push(sequence);
            }
            return sequence;
        },
        processSequence: function processSequence(sequence, isFirstFrame) {
            var i = 0;
            var len = sequence.transforms.length;
            var _mdf = isFirstFrame;
            while(i < len && !isFirstFrame){
                if (sequence.transforms[i].transform.mProps._mdf) {
                    _mdf = true;
                    break;
                }
                i += 1;
            }
            if (_mdf) {
                sequence.finalTransform.reset();
                for(i = len - 1; i >= 0; i -= 1)sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
            }
            sequence._mdf = _mdf;
        },
        processSequences: function processSequences(isFirstFrame) {
            var i;
            var len = this.sequenceList.length;
            for(i = 0; i < len; i += 1)this.processSequence(this.sequenceList[i], isFirstFrame);
        },
        getNewKey: function getNewKey() {
            this.transform_key_count += 1;
            return '_' + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader() {
        var id = '__lottie_element_luma_buffer';
        var lumaBuffer = null;
        var lumaBufferCtx = null;
        var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter() {
            var _svg = createNS('svg');
            var fil = createNS('filter');
            var matrix = createNS('feColorMatrix');
            fil.setAttribute('id', id);
            matrix.setAttribute('type', 'matrix');
            matrix.setAttribute('color-interpolation-filters', 'sRGB');
            matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
            fil.appendChild(matrix);
            _svg.appendChild(fil);
            _svg.setAttribute('id', id + '_svg');
            if (featureSupport.svgLumaHidden) _svg.style.display = 'none';
            return _svg;
        }
        function loadLuma() {
            if (!lumaBuffer) {
                svg = createLumaSvgFilter();
                document.body.appendChild(svg);
                lumaBuffer = createTag('canvas');
                lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx.filter = 'url(#' + id + ')';
                lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
                lumaBufferCtx.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma(canvas) {
            if (!lumaBuffer) loadLuma();
            lumaBuffer.width = canvas.width;
            lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx.filter = 'url(#' + id + ')';
            return lumaBuffer;
        }
        return {
            load: loadLuma,
            get: getLuma
        };
    };
    function createCanvas(width, height) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width, height);
        var canvas = createTag('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem) {
        var i;
        var len = elem.data.ef ? elem.data.ef.length : 0;
        this.filters = [];
        var filterManager;
        for(i = 0; i < len; i += 1){
            filterManager = null;
            var type = elem.data.ef[i].ty;
            if (registeredEffects[type]) {
                var Effect = registeredEffects[type].effect;
                filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
            }
            if (filterManager) this.filters.push(filterManager);
        }
        if (this.filters.length) elem.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame) {
        var i;
        var len = this.filters.length;
        for(i = 0; i < len; i += 1)this.filters[i].renderFrame(_isFirstFrame);
    };
    CVEffects.prototype.getEffects = function(type) {
        var i;
        var len = this.filters.length;
        var effects = [];
        for(i = 0; i < len; i += 1)if (this.filters[i].type === type) effects.push(this.filters[i]);
        return effects;
    };
    function registerEffect(id, effect) {
        registeredEffects[id] = {
            effect: effect
        };
    }
    function CVMaskElement(data, element) {
        this.data = data;
        this.element = element;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i;
        var len = this.masksProperties.length;
        var hasMasks = false;
        for(i = 0; i < len; i += 1){
            if (this.masksProperties[i].mode !== 'n') hasMasks = true;
            this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
        }
        this.hasMasks = hasMasks;
        if (hasMasks) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform = this.element.finalTransform.mat;
        var ctx = this.element.canvasContext;
        var i;
        var len = this.masksProperties.length;
        var pt;
        var pts;
        var data;
        ctx.beginPath();
        for(i = 0; i < len; i += 1)if (this.masksProperties[i].mode !== 'n') {
            if (this.masksProperties[i].inv) {
                ctx.moveTo(0, 0);
                ctx.lineTo(this.element.globalData.compSize.w, 0);
                ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx.lineTo(0, this.element.globalData.compSize.h);
                ctx.lineTo(0, 0);
            }
            data = this.viewData[i].v;
            pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
            ctx.moveTo(pt[0], pt[1]);
            var j;
            var jLen = data._length;
            for(j = 1; j < jLen; j += 1){
                pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
                ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
            }
            pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
            ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: 'source-in',
        2: 'source-out',
        3: 'source-in',
        4: 'source-out'
    };
    CVBaseElement.prototype = {
        createElements: function createElements() {},
        initRendererElement: function initRendererElement() {},
        createContainerElements: function createContainerElements() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext = this.globalData.canvasContext;
                var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas);
                var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
                this.buffers.push(bufferCanvas2);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent() {},
        setBlendMode: function setBlendMode() {
            var globalData = this.globalData;
            if (globalData.blendMode !== this.data.bm) {
                globalData.blendMode = this.data.bm;
                var blendModeValue = getBlendMode(this.data.bm);
                globalData.canvasContext.globalCompositeOperation = blendModeValue;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas(canvasContext) {
            canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[0];
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer() {
            if (this.data.tt >= 1) {
                var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx = buffer.getContext('2d');
                this.clearCanvas(bufferCtx);
                bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
                mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx = lumaBuffer.getContext('2d');
                    lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = 'destination-over';
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = 'source-over';
            }
        },
        renderFrame: function renderFrame(forceRender) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element, data, styles, transformsManager) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty = 4;
        if (data.ty === 'rc') ty = 5;
        else if (data.ty === 'el') ty = 6;
        else if (data.ty === 'sr') ty = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
        var i;
        var len = styles.length;
        var styledShape;
        for(i = 0; i < len; i += 1)if (!styles[i].closed) {
            styledShape = {
                transforms: transformsManager.addTransformSequence(styles[i].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape);
            styles[i].elements.push(styledShape);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data, globalData, comp) {
        this.shapes = [];
        this.shapesData = data.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data, transforms) {
        var styleElem = {
            data: data,
            type: data.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms),
            transforms: [],
            elements: [],
            closed: data.hd === true
        };
        var elementData = {};
        if (data.ty === 'fl' || data.ty === 'st') {
            elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);
            if (!elementData.c.k) styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
        } else if (data.ty === 'gf' || data.ty === 'gs') {
            elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
            elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
            elementData.h = PropertyFactory.getProp(this, data.h || {
                k: 0
            }, 0, 0.01, this);
            elementData.a = PropertyFactory.getProp(this, data.a || {
                k: 0
            }, 0, degToRads, this);
            elementData.g = new GradientProperty(this, data.g, this);
        }
        elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);
        if (data.ty === 'st' || data.ty === 'gs') {
            styleElem.lc = lineCapEnum[data.lc || 2];
            styleElem.lj = lineJoinEnum[data.lj || 2];
            if (data.lj == 1) // eslint-disable-line eqeqeq
            styleElem.ml = data.ml;
            elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);
            if (!elementData.w.k) styleElem.wi = elementData.w.v;
            if (data.d) {
                var d = new DashProperty(this, data.d, 'canvas', this);
                elementData.d = d;
                if (!elementData.d.k) {
                    styleElem.da = elementData.d.dashArray;
                    styleElem["do"] = elementData.d.dashoffset[0];
                }
            }
        } else styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
        this.stylesList.push(styleElem);
        elementData.style = styleElem;
        return elementData;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData = {
            it: [],
            prevViewData: []
        };
        return elementData;
    };
    CVShapeElement.prototype.createTransformElement = function(data) {
        var elementData = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
            }
        };
        return elementData;
    };
    CVShapeElement.prototype.createShapeElement = function(data) {
        var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
        this.shapes.push(elementData);
        this.addShapeToModifiers(elementData);
        return elementData;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i;
        var len = this.itemsData.length;
        for(i = 0; i < len; i += 1)this.prevViewData[i] = this.itemsData[i];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len = this.dynamicProperties.length;
        for(i = 0; i < len; i += 1)this.dynamicProperties[i].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform) {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.push(transform);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i;
        var len = this.stylesList.length;
        for(i = 0; i < len; i += 1)if (!this.stylesList[i].closed) this.stylesList[i].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles) {
        var i;
        var len = styles.length;
        for(i = 0; i < len; i += 1)styles[i].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr, itemsData, prevViewData, shouldRender, transforms) {
        var i;
        var len = arr.length - 1;
        var j;
        var jLen;
        var ownStyles = [];
        var ownModifiers = [];
        var processedPos;
        var modifier;
        var currentTransform;
        var ownTransforms = [].concat(transforms);
        for(i = len; i >= 0; i -= 1){
            processedPos = this.searchProcessedElement(arr[i]);
            if (!processedPos) arr[i]._shouldRender = shouldRender;
            else itemsData[i] = prevViewData[processedPos - 1];
            if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
                if (!processedPos) itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
                else itemsData[i].style.closed = false;
                ownStyles.push(itemsData[i].style);
            } else if (arr[i].ty === 'gr') {
                if (!processedPos) itemsData[i] = this.createGroupElement(arr[i]);
                else {
                    jLen = itemsData[i].it.length;
                    for(j = 0; j < jLen; j += 1)itemsData[i].prevViewData[j] = itemsData[i].it[j];
                }
                this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
            } else if (arr[i].ty === 'tr') {
                if (!processedPos) {
                    currentTransform = this.createTransformElement(arr[i]);
                    itemsData[i] = currentTransform;
                }
                ownTransforms.push(itemsData[i]);
                this.addTransformToStyleList(itemsData[i]);
            } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
                if (!processedPos) itemsData[i] = this.createShapeElement(arr[i]);
            } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    modifier.init(this, arr[i]);
                    itemsData[i] = modifier;
                    this.shapeModifiers.push(modifier);
                } else {
                    modifier = itemsData[i];
                    modifier.closed = false;
                }
                ownModifiers.push(modifier);
            } else if (arr[i].ty === 'rp') {
                if (!processedPos) {
                    modifier = ShapeModifiers.getModifier(arr[i].ty);
                    itemsData[i] = modifier;
                    modifier.init(this, arr, i, itemsData);
                    this.shapeModifiers.push(modifier);
                    shouldRender = false;
                } else {
                    modifier = itemsData[i];
                    modifier.closed = true;
                }
                ownModifiers.push(modifier);
            }
            this.addProcessedElement(arr[i], i + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles);
        len = ownModifiers.length;
        for(i = 0; i < len; i += 1)ownModifiers[i].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform, groupTransform) {
        if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
            groupTransform.opacity = parentTransform.opacity;
            groupTransform.opacity *= groupTransform.op.v;
            groupTransform._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i;
        var len = this.stylesList.length;
        var j;
        var jLen;
        var k;
        var kLen;
        var elems;
        var nodes;
        var renderer = this.globalData.renderer;
        var ctx = this.globalData.canvasContext;
        var type;
        var currentStyle;
        for(i = 0; i < len; i += 1){
            currentStyle = this.stylesList[i];
            type = currentStyle.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer.save();
                elems = currentStyle.elements;
                if (type === 'st' || type === 'gs') {
                    renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;
                    renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;
                    renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;
                    renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;
                    renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
                } else renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
                renderer.ctxOpacity(currentStyle.coOp);
                if (type !== 'st' && type !== 'gs') ctx.beginPath();
                renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
                jLen = elems.length;
                for(j = 0; j < jLen; j += 1){
                    if (type === 'st' || type === 'gs') {
                        ctx.beginPath();
                        if (currentStyle.da) {
                            ctx.setLineDash(currentStyle.da);
                            ctx.lineDashOffset = currentStyle["do"];
                        }
                    }
                    nodes = elems[j].trNodes;
                    kLen = nodes.length;
                    for(k = 0; k < kLen; k += 1){
                        if (nodes[k].t === 'm') ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
                        else if (nodes[k].t === 'c') ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
                        else ctx.closePath();
                    }
                    if (type === 'st' || type === 'gs') {
                        // ctx.stroke();
                        renderer.ctxStroke();
                        if (currentStyle.da) ctx.setLineDash(this.dashResetter);
                    }
                }
                if (type !== 'st' && type !== 'gs') // ctx.fill(currentStyle.r);
                this.globalData.renderer.ctxFill(currentStyle.r);
                renderer.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform, items, data, isMain) {
        var i;
        var len = items.length - 1;
        var groupTransform;
        groupTransform = parentTransform;
        for(i = len; i >= 0; i -= 1){
            if (items[i].ty === 'tr') {
                groupTransform = data[i].transform;
                this.renderShapeTransform(parentTransform, groupTransform);
            } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') this.renderPath(items[i], data[i]);
            else if (items[i].ty === 'fl') this.renderFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'st') this.renderStroke(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gf' || items[i].ty === 'gs') this.renderGradientFill(items[i], data[i], groupTransform);
            else if (items[i].ty === 'gr') this.renderShape(groupTransform, items[i].it, data[i].it);
            else items[i].ty;
        }
        if (isMain) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape, shape) {
        if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
            var shapeNodes = styledShape.trNodes;
            var paths = shape.paths;
            var i;
            var len;
            var j;
            var jLen = paths._length;
            shapeNodes.length = 0;
            var groupTransformMat = styledShape.transforms.finalTransform;
            for(j = 0; j < jLen; j += 1){
                var pathNodes = paths.shapes[j];
                if (pathNodes && pathNodes.v) {
                    len = pathNodes._length;
                    for(i = 1; i < len; i += 1){
                        if (i === 1) shapeNodes.push({
                            t: 'm',
                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                        });
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
                        });
                    }
                    if (len === 1) shapeNodes.push({
                        t: 'm',
                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
                    });
                    if (pathNodes.c && len) {
                        shapeNodes.push({
                            t: 'c',
                            pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
                        });
                        shapeNodes.push({
                            t: 'z'
                        });
                    }
                }
            }
            styledShape.trNodes = shapeNodes;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData, itemData) {
        if (pathData.hd !== true && pathData._shouldRender) {
            var i;
            var len = itemData.styledShapes.length;
            for(i = 0; i < len; i += 1)this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var grd;
        if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
            var ctx = this.globalData.canvasContext;
            var pt1 = itemData.s.v;
            var pt2 = itemData.e.v;
            if (styleData.t === 1) grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
            else {
                var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
                var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
                var percent = itemData.h.v;
                if (percent >= 1) percent = 0.99;
                else if (percent <= -1) percent = -0.99;
                var dist = rad * percent;
                var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
                var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
                grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
            }
            var i;
            var len = styleData.g.p;
            var cValues = itemData.g.c;
            var opacity = 1;
            for(i = 0; i < len; i += 1){
                if (itemData.g._hasOpacity && itemData.g._collapsable) opacity = itemData.g.o[i * 2 + 1];
                grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
            }
            styleElem.grd = grd;
        }
        styleElem.coOp = itemData.o.v * groupTransform.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData, itemData, groupTransform) {
        var styleElem = itemData.style;
        var d = itemData.d;
        if (d && (d._mdf || this._isFirstFrame)) {
            styleElem.da = d.dashArray;
            styleElem["do"] = d.dashoffset[0];
        }
        if (itemData.c._mdf || this._isFirstFrame) styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
        if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) styleElem.coOp = itemData.o.v * groupTransform.opacity;
        if (itemData.w._mdf || this._isFirstFrame) styleElem.wi = itemData.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = 'canvas';
        this.values = {
            fill: 'rgba(0,0,0,0)',
            stroke: 'rgba(0,0,0,0)',
            sWidth: 0,
            fValue: ''
        };
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');
    CVTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var hasFill = false;
        if (documentData.fc) {
            hasFill = true;
            this.values.fill = this.buildColor(documentData.fc);
        } else this.values.fill = 'rgba(0,0,0,0)';
        this.fill = hasFill;
        var hasStroke = false;
        if (documentData.sc) {
            hasStroke = true;
            this.values.stroke = this.buildColor(documentData.sc);
            this.values.sWidth = documentData.sw;
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        var i;
        var len;
        var letters = documentData.l;
        var matrixHelper = this.mHelper;
        this.stroke = hasStroke;
        this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
        len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData;
        var shapeData;
        var k;
        var kLen;
        var shapes;
        var j;
        var jLen;
        var pathNodes;
        var commands;
        var pathArr;
        var singleShape = this.data.singleShape;
        var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
        var xPos = 0;
        var yPos = 0;
        var firstLine = true;
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
            shapeData = charData && charData.data || {};
            matrixHelper.reset();
            if (singleShape && letters[i].n) {
                xPos = -trackingOffset;
                yPos += documentData.yOffset;
                yPos += firstLine ? 1 : 0;
                firstLine = false;
            }
            shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
            jLen = shapes.length;
            matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
            if (singleShape) this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
            commands = createSizedArray(jLen - 1);
            var commandsCounter = 0;
            for(j = 0; j < jLen; j += 1)if (shapes[j].ty === 'sh') {
                kLen = shapes[j].ks.k.i.length;
                pathNodes = shapes[j].ks.k;
                pathArr = [];
                for(k = 1; k < kLen; k += 1){
                    if (k === 1) pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                    pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
                }
                pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
                commands[commandsCounter] = pathArr;
                commandsCounter += 1;
            }
            if (singleShape) {
                xPos += letters[i].l;
                xPos += trackingOffset;
            }
            if (this.textSpans[cnt]) this.textSpans[cnt].elem = commands;
            else this.textSpans[cnt] = {
                elem: commands
            };
            cnt += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx = this.canvasContext;
        ctx.font = this.values.fValue;
        this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';
        this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';
        this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i;
        var len;
        var j;
        var jLen;
        var k;
        var kLen;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var lastFill = null;
        var lastStroke = null;
        var lastStrokeW = null;
        var commands;
        var pathArr;
        var renderer = this.globalData.renderer;
        for(i = 0; i < len; i += 1)if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            if (renderedLetter) {
                renderer.save();
                renderer.ctxTransform(renderedLetter.p);
                renderer.ctxOpacity(renderedLetter.o);
            }
            if (this.fill) {
                if (renderedLetter && renderedLetter.fc) {
                    if (lastFill !== renderedLetter.fc) {
                        renderer.ctxFillStyle(renderedLetter.fc);
                        lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
                    }
                } else if (lastFill !== this.values.fill) {
                    lastFill = this.values.fill;
                    renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxFill(); // this.globalData.canvasContext.fill();
            /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter && renderedLetter.sw) {
                    if (lastStrokeW !== renderedLetter.sw) {
                        lastStrokeW = renderedLetter.sw;
                        renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
                    }
                } else if (lastStrokeW !== this.values.sWidth) {
                    lastStrokeW = this.values.sWidth;
                    renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
                }
                if (renderedLetter && renderedLetter.sc) {
                    if (lastStroke !== renderedLetter.sc) {
                        lastStroke = renderedLetter.sc;
                        renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
                    }
                } else if (lastStroke !== this.values.stroke) {
                    lastStroke = this.values.stroke;
                    renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
                }
                commands = this.textSpans[i].elem;
                jLen = commands.length;
                this.globalData.canvasContext.beginPath();
                for(j = 0; j < jLen; j += 1){
                    pathArr = commands[j];
                    kLen = pathArr.length;
                    this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
                    for(k = 2; k < kLen; k += 6)this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
                }
                this.globalData.canvasContext.closePath();
                renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
            /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.img = globalData.imageLoader.getAsset(this.assetData);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas = createTag('canvas');
            canvas.width = this.assetData.w;
            canvas.height = this.assetData.h;
            var ctx = canvas.getContext('2d');
            var imgW = this.img.width;
            var imgH = this.img.height;
            var imgRel = imgW / imgH;
            var canvasRel = this.assetData.w / this.assetData.h;
            var widthCrop;
            var heightCrop;
            var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
                heightCrop = imgH;
                widthCrop = heightCrop * canvasRel;
            } else {
                widthCrop = imgW;
                heightCrop = widthCrop / canvasRel;
            }
            ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        // var ctx = this.canvasContext;
        this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;
        this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
    };
    function CanvasRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data) {
        return new CVShapeElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data) {
        return new CVTextElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data) {
        return new CVImageElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data) {
        return new CVSolidElement(data, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props) {
        if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) return;
        this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op) {
        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
    };
    CanvasRendererBase.prototype.ctxFillStyle = function(value) {
        this.canvasContext.fillStyle = value;
    };
    CanvasRendererBase.prototype.ctxStrokeStyle = function(value) {
        this.canvasContext.strokeStyle = value;
    };
    CanvasRendererBase.prototype.ctxLineWidth = function(value) {
        this.canvasContext.lineWidth = value;
    };
    CanvasRendererBase.prototype.ctxLineCap = function(value) {
        this.canvasContext.lineCap = value;
    };
    CanvasRendererBase.prototype.ctxLineJoin = function(value) {
        this.canvasContext.lineJoin = value;
    };
    CanvasRendererBase.prototype.ctxMiterLimit = function(value) {
        this.canvasContext.miterLimit = value;
    };
    CanvasRendererBase.prototype.ctxFill = function(rule) {
        this.canvasContext.fill(rule);
    };
    CanvasRendererBase.prototype.ctxFillRect = function(x, y, w, h) {
        this.canvasContext.fillRect(x, y, w, h);
    };
    CanvasRendererBase.prototype.ctxStroke = function() {
        this.canvasContext.stroke();
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function() {
        this.canvasContext.save();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag) this.globalData.blendMode = 'source-over';
        this.contextData.restore(actionFlag);
    };
    CanvasRendererBase.prototype.configAnimation = function(animData) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag('canvas');
            var containerStyle = this.animationItem.container.style;
            containerStyle.width = '100%';
            containerStyle.height = '100%';
            var origin = '0px 0px 0px';
            containerStyle.transformOrigin = origin;
            containerStyle.mozTransformOrigin = origin;
            containerStyle.webkitTransformOrigin = origin;
            containerStyle['-webkit-transform'] = origin;
            containerStyle.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext('2d');
            if (this.renderConfig.className) this.animationItem.container.setAttribute('class', this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute('id', this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.contextData.setContext(this.canvasContext);
        this.data = animData;
        this.layers = animData.layers;
        this.transformCanvas = {
            w: animData.w,
            h: animData.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width, height) {
        this.reset();
        var elementWidth;
        var elementHeight;
        if (width) {
            elementWidth = width;
            elementHeight = height;
            this.canvasContext.canvas.width = elementWidth;
            this.canvasContext.canvas.height = elementHeight;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth = this.animationItem.wrapper.offsetWidth;
                elementHeight = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth = this.canvasContext.canvas.width;
                elementHeight = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
        }
        var elementRel;
        var animationRel;
        if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
            var par = this.renderConfig.preserveAspectRatio.split(' ');
            var fillType = par[1] || 'meet';
            var pos = par[0] || 'xMidYMid';
            var xPos = pos.substr(0, 4);
            var yPos = pos.substr(4);
            elementRel = elementWidth / elementHeight;
            animationRel = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
                this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === 'none') {
            this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num, forceRender) {
        if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) return;
        this.renderedFrame = num;
        this.globalData.frameNum = num - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
        this.globalData.projectInterface.currentFrame = num; // console.log('--------');
        // console.log('NEW: ',num);
        var i;
        var len = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num);
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].prepareFrame(num - this.layers[i].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos) {
        var elements = this.elements;
        if (elements[pos] || this.layers[pos].ty === 99) return;
        var element = this.createItem(this.layers[pos], this, this.globalData);
        elements[pos] = element;
        element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = 'none';
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = 'block';
    };
    function CanvasContext() {
        this.opacity = -1;
        this.transform = createTypedArray('float32', 16);
        this.fillStyle = '';
        this.strokeStyle = '';
        this.lineWidth = '';
        this.lineCap = '';
        this.lineJoin = '';
        this.miterLimit = '';
        this.id = Math.random();
    }
    function CVContextData() {
        this.stack = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        var i;
        var len = 15;
        for(i = 0; i < len; i += 1){
            var canvasContext = new CanvasContext();
            this.stack[i] = canvasContext;
        }
        this._length = len;
        this.nativeContext = null;
        this.transformMat = new Matrix();
        this.currentOpacity = 1; //
        this.currentFillStyle = '';
        this.appliedFillStyle = ''; //
        this.currentStrokeStyle = '';
        this.appliedStrokeStyle = ''; //
        this.currentLineWidth = '';
        this.appliedLineWidth = ''; //
        this.currentLineCap = '';
        this.appliedLineCap = ''; //
        this.currentLineJoin = '';
        this.appliedLineJoin = ''; //
        this.appliedMiterLimit = '';
        this.currentMiterLimit = '';
    }
    CVContextData.prototype.duplicate = function() {
        var newLength = this._length * 2;
        var i = 0;
        for(i = this._length; i < newLength; i += 1)this.stack[i] = new CanvasContext();
        this._length = newLength;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.stack[this.cArrPos].opacity = 1;
    };
    CVContextData.prototype.restore = function(forceRestore) {
        this.cArrPos -= 1;
        var currentContext = this.stack[this.cArrPos];
        var transform = currentContext.transform;
        var i;
        var arr = this.cTr.props;
        for(i = 0; i < 16; i += 1)arr[i] = transform[i];
        if (forceRestore) {
            this.nativeContext.restore();
            var prevStack = this.stack[this.cArrPos + 1];
            this.appliedFillStyle = prevStack.fillStyle;
            this.appliedStrokeStyle = prevStack.strokeStyle;
            this.appliedLineWidth = prevStack.lineWidth;
            this.appliedLineCap = prevStack.lineCap;
            this.appliedLineJoin = prevStack.lineJoin;
            this.appliedMiterLimit = prevStack.miterLimit;
        }
        this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);
        if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
            this.nativeContext.globalAlpha = currentContext.opacity;
            this.currentOpacity = currentContext.opacity;
        }
        this.currentFillStyle = currentContext.fillStyle;
        this.currentStrokeStyle = currentContext.strokeStyle;
        this.currentLineWidth = currentContext.lineWidth;
        this.currentLineCap = currentContext.lineCap;
        this.currentLineJoin = currentContext.lineJoin;
        this.currentMiterLimit = currentContext.miterLimit;
    };
    CVContextData.prototype.save = function(saveOnNativeFlag) {
        if (saveOnNativeFlag) this.nativeContext.save();
        var props = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var currentStack = this.stack[this.cArrPos];
        var i;
        for(i = 0; i < 16; i += 1)currentStack.transform[i] = props[i];
        this.cArrPos += 1;
        var newStack = this.stack[this.cArrPos];
        newStack.opacity = currentStack.opacity;
        newStack.fillStyle = currentStack.fillStyle;
        newStack.strokeStyle = currentStack.strokeStyle;
        newStack.lineWidth = currentStack.lineWidth;
        newStack.lineCap = currentStack.lineCap;
        newStack.lineJoin = currentStack.lineJoin;
        newStack.miterLimit = currentStack.miterLimit;
    };
    CVContextData.prototype.setOpacity = function(value) {
        this.stack[this.cArrPos].opacity = value;
    };
    CVContextData.prototype.setContext = function(value) {
        this.nativeContext = value;
    };
    CVContextData.prototype.fillStyle = function(value) {
        if (this.stack[this.cArrPos].fillStyle !== value) {
            this.currentFillStyle = value;
            this.stack[this.cArrPos].fillStyle = value;
        }
    };
    CVContextData.prototype.strokeStyle = function(value) {
        if (this.stack[this.cArrPos].strokeStyle !== value) {
            this.currentStrokeStyle = value;
            this.stack[this.cArrPos].strokeStyle = value;
        }
    };
    CVContextData.prototype.lineWidth = function(value) {
        if (this.stack[this.cArrPos].lineWidth !== value) {
            this.currentLineWidth = value;
            this.stack[this.cArrPos].lineWidth = value;
        }
    };
    CVContextData.prototype.lineCap = function(value) {
        if (this.stack[this.cArrPos].lineCap !== value) {
            this.currentLineCap = value;
            this.stack[this.cArrPos].lineCap = value;
        }
    };
    CVContextData.prototype.lineJoin = function(value) {
        if (this.stack[this.cArrPos].lineJoin !== value) {
            this.currentLineJoin = value;
            this.stack[this.cArrPos].lineJoin = value;
        }
    };
    CVContextData.prototype.miterLimit = function(value) {
        if (this.stack[this.cArrPos].miterLimit !== value) {
            this.currentMiterLimit = value;
            this.stack[this.cArrPos].miterLimit = value;
        }
    };
    CVContextData.prototype.transform = function(props) {
        this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms
        var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform
        currentTransform.cloneFromProps(this.transformMat.props);
        var trProps = currentTransform.props; // Applying the new transform to the canvas
        this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
    };
    CVContextData.prototype.opacity = function(op) {
        var currentOpacity = this.stack[this.cArrPos].opacity;
        currentOpacity *= op < 0 ? 0 : op;
        if (this.stack[this.cArrPos].opacity !== currentOpacity) {
            if (this.currentOpacity !== op) {
                this.nativeContext.globalAlpha = op;
                this.currentOpacity = op;
            }
            this.stack[this.cArrPos].opacity = currentOpacity;
        }
    };
    CVContextData.prototype.fill = function(rule) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fill(rule);
    };
    CVContextData.prototype.fillRect = function(x, y, w, h) {
        if (this.appliedFillStyle !== this.currentFillStyle) {
            this.appliedFillStyle = this.currentFillStyle;
            this.nativeContext.fillStyle = this.appliedFillStyle;
        }
        this.nativeContext.fillRect(x, y, w, h);
    };
    CVContextData.prototype.stroke = function() {
        if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
            this.appliedStrokeStyle = this.currentStrokeStyle;
            this.nativeContext.strokeStyle = this.appliedStrokeStyle;
        }
        if (this.appliedLineWidth !== this.currentLineWidth) {
            this.appliedLineWidth = this.currentLineWidth;
            this.nativeContext.lineWidth = this.appliedLineWidth;
        }
        if (this.appliedLineCap !== this.currentLineCap) {
            this.appliedLineCap = this.currentLineCap;
            this.nativeContext.lineCap = this.appliedLineCap;
        }
        if (this.appliedLineJoin !== this.currentLineJoin) {
            this.appliedLineJoin = this.currentLineJoin;
            this.nativeContext.lineJoin = this.appliedLineJoin;
        }
        if (this.appliedMiterLimit !== this.currentMiterLimit) {
            this.appliedMiterLimit = this.currentMiterLimit;
            this.nativeContext.miterLimit = this.appliedMiterLimit;
        }
        this.nativeContext.stroke();
    };
    function CVCompElement(data, globalData, comp) {
        this.completeLayers = false;
        this.layers = data.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx = this.canvasContext;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.data.w, 0);
        ctx.lineTo(this.data.w, this.data.h);
        ctx.lineTo(0, this.data.h);
        ctx.lineTo(0, 0);
        ctx.clip();
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.completeLayers || this.elements[i]) this.elements[i].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i;
        var len = this.layers.length;
        for(i = len - 1; i >= 0; i -= 1)if (this.elements[i]) this.elements[i].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function CanvasRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.renderConfig = {
            clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
            context: config && config.context || null,
            progressiveLoad: config && config.progressiveLoad || false,
            preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            contentVisibility: config && config.contentVisibility || 'visible',
            className: config && config.className || '',
            id: config && config.id || '',
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.renderConfig.dpr = config && config.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = 'canvas';
        if (this.renderConfig.clearCanvas) {
            this.ctxTransform = this.contextData.transform.bind(this.contextData);
            this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
            this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
            this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
            this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
            this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
            this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
            this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
            this.ctxFill = this.contextData.fill.bind(this.contextData);
            this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
            this.ctxStroke = this.contextData.stroke.bind(this.contextData);
            this.save = this.contextData.save.bind(this.contextData);
        }
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data) {
        return new CVCompElement(data, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode() {},
        initRendererElement: function initRendererElement() {
            this.baseElement = createTag(this.data.tg || 'div');
            if (this.data.hasMask) {
                this.svgElement = createNS('svg');
                this.layerElement = createNS('g');
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute('id', this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute('class', this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement() {
            var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue = this.finalTransform.mat.toCSS();
                transformedElementStyle.transform = matrixValue;
                transformedElementStyle.webkitTransform = matrixValue;
            }
            if (this.finalTransform._opMdf) transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects() {},
        setMatte: function setMatte() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data, globalData, comp) {
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect;
        if (this.data.hasMask) {
            rect = createNS('rect');
            rect.setAttribute('width', this.data.sw);
            rect.setAttribute('height', this.data.sh);
            rect.setAttribute('fill', this.data.sc);
            this.svgElement.setAttribute('width', this.data.sw);
            this.svgElement.setAttribute('height', this.data.sh);
        } else {
            rect = createTag('div');
            rect.style.width = this.data.sw + 'px';
            rect.style.height = this.data.sh + 'px';
            rect.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect);
    };
    function HShapeElement(data, globalData, comp) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS('g');
        this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont = this.svgElement;
        } else {
            cont = createNS('svg');
            var size = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont.setAttribute('width', size.w);
            cont.setAttribute('height', size.h);
            cont.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers, point) {
        var i;
        var len = transformers.length;
        for(i = 0; i < len; i += 1)point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
        return point;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item, boundingBox) {
        var shape = item.sh.v;
        var transformers = item.transformers;
        var i;
        var len = shape._length;
        var vPoint;
        var oPoint;
        var nextIPoint;
        var nextVPoint;
        if (len <= 1) return;
        for(i = 0; i < len - 1; i += 1){
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
        if (shape.c) {
            vPoint = this.getTransformedPoint(transformers, shape.v[i]);
            oPoint = this.getTransformedPoint(transformers, shape.o[i]);
            nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
            nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
            this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
        this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
        var bounds = this.shapeBoundingBox;
        boundingBox.x = bmMin(bounds.left, boundingBox.x);
        boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
        boundingBox.y = bmMin(bounds.top, boundingBox.y);
        boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p0, p1, p2, p3) {
        var bounds = [
            [
                p0[0],
                p3[0]
            ],
            [
                p0[1],
                p3[1]
            ]
        ];
        for(var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i){
            // eslint-disable-line no-plusplus
            b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
            a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
            c = 3 * p1[i] - 3 * p0[i];
            b |= 0; // eslint-disable-line no-bitwise
            a |= 0; // eslint-disable-line no-bitwise
            c |= 0; // eslint-disable-line no-bitwise
            if (a === 0 && b === 0) ;
            else if (a === 0) {
                t = -c / b;
                if (t > 0 && t < 1) bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
            } else {
                b2ac = b * b - 4 * c * a;
                if (b2ac >= 0) {
                    t1 = (-b + bmSqrt(b2ac)) / (2 * a);
                    if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
                    t2 = (-b - bmSqrt(b2ac)) / (2 * a);
                    if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
    };
    HShapeElement.prototype.calculateF = function(t, p0, p1, p2, p3, i) {
        return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData, boundingBox) {
        var i;
        var len = itemsData.length;
        for(i = 0; i < len; i += 1){
            if (itemsData[i] && itemsData[i].sh) this.calculateShapeBoundingBox(itemsData[i], boundingBox);
            else if (itemsData[i] && itemsData[i].it) this.calculateBoundingBox(itemsData[i].it, boundingBox);
            else if (itemsData[i] && itemsData[i].style && itemsData[i].w) this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty, boundingBox) {
        var width = 0;
        if (widthProperty.keyframes) {
            for(var i = 0; i < widthProperty.keyframes.length; i += 1){
                var kfw = widthProperty.keyframes[i].s;
                if (kfw > width) width = kfw;
            }
            width *= widthProperty.mult;
        } else width = widthProperty.v * widthProperty.mult;
        boundingBox.x -= width;
        boundingBox.xMax += width;
        boundingBox.y -= width;
        boundingBox.yMax += width;
    };
    HShapeElement.prototype.currentBoxContains = function(box) {
        return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox = this.tempBoundingBox;
            var max = 999999;
            tempBoundingBox.x = max;
            tempBoundingBox.xMax = -max;
            tempBoundingBox.y = max;
            tempBoundingBox.yMax = -max;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox);
            tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
            tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox)) return;
            var changed = false;
            if (this.currentBBox.w !== tempBoundingBox.width) {
                this.currentBBox.w = tempBoundingBox.width;
                this.shapeCont.setAttribute('width', tempBoundingBox.width);
                changed = true;
            }
            if (this.currentBBox.h !== tempBoundingBox.height) {
                this.currentBBox.h = tempBoundingBox.height;
                this.shapeCont.setAttribute('height', tempBoundingBox.height);
                changed = true;
            }
            if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
                this.currentBBox.w = tempBoundingBox.width;
                this.currentBBox.h = tempBoundingBox.height;
                this.currentBBox.x = tempBoundingBox.x;
                this.currentBBox.y = tempBoundingBox.y;
                this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                var shapeStyle = this.shapeCont.style;
                var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                shapeStyle.transform = shapeTransform;
                shapeStyle.webkitTransform = shapeTransform;
            }
        }
    };
    function HTextElement(data, globalData, comp) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = 'svg';
        this.isMasked = false;
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = 'svg';
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute('width', this.compW);
            this.svgElement.setAttribute('height', this.compH);
            var g = createNS('g');
            this.maskedElement.appendChild(g);
            this.innerElem = g;
        } else {
            this.renderType = 'html';
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
        var innerElemStyle = this.innerElem.style;
        var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
        innerElemStyle.fill = textColor;
        innerElemStyle.color = textColor;
        if (documentData.sc) {
            innerElemStyle.stroke = this.buildColor(documentData.sc);
            innerElemStyle.strokeWidth = documentData.sw + 'px';
        }
        var fontData = this.globalData.fontManager.getFontByName(documentData.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle.fontSize = documentData.finalSize + 'px';
            innerElemStyle.lineHeight = documentData.finalSize + 'px';
            if (fontData.fClass) this.innerElem.className = fontData.fClass;
            else {
                innerElemStyle.fontFamily = fontData.fFamily;
                var fWeight = documentData.fWeight;
                var fStyle = documentData.fStyle;
                innerElemStyle.fontStyle = fStyle;
                innerElemStyle.fontWeight = fWeight;
            }
        }
        var i;
        var len;
        var letters = documentData.l;
        len = letters.length;
        var tSpan;
        var tParent;
        var tCont;
        var matrixHelper = this.mHelper;
        var shapes;
        var shapeStr = '';
        var cnt = 0;
        for(i = 0; i < len; i += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt]) {
                    tSpan = createNS('path');
                    tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
                    tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
                    tSpan.setAttribute('stroke-miterlimit', '4');
                } else tSpan = this.textPaths[cnt];
                if (!this.isMasked) {
                    if (this.textSpans[cnt]) {
                        tParent = this.textSpans[cnt];
                        tCont = tParent.children[0];
                    } else {
                        tParent = createTag('div');
                        tParent.style.lineHeight = 0;
                        tCont = createNS('svg');
                        tCont.appendChild(tSpan);
                        styleDiv(tParent);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt]) {
                    tParent = this.textSpans[cnt];
                    tSpan = this.textPaths[cnt];
                } else {
                    tParent = createTag('span');
                    styleDiv(tParent);
                    tSpan = createTag('span');
                    styleDiv(tSpan);
                    tParent.appendChild(tSpan);
                }
            } else tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
                var shapeData;
                if (charData) shapeData = charData.data;
                else shapeData = null;
                matrixHelper.reset();
                if (shapeData && shapeData.shapes && shapeData.shapes.length) {
                    shapes = shapeData.shapes[0].it;
                    matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
                    shapeStr = this.createPathShape(matrixHelper, shapes);
                    tSpan.setAttribute('d', shapeStr);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent);
                    if (shapeData && shapeData.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont);
                        var boundingBox = tCont.getBBox();
                        tCont.setAttribute('width', boundingBox.width + 2);
                        tCont.setAttribute('height', boundingBox.height + 2);
                        tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
                        var tContStyle = tCont.style;
                        var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
                        tContStyle.transform = tContTranslation;
                        tContStyle.webkitTransform = tContTranslation;
                        letters[i].yOffset = boundingBox.y - 1;
                    } else {
                        tCont.setAttribute('width', 1);
                        tCont.setAttribute('height', 1);
                    }
                    tParent.appendChild(tCont);
                } else this.innerElem.appendChild(tSpan);
            } else {
                tSpan.textContent = letters[i].val;
                tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent); //
                    var tStyle = tSpan.style;
                    var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
                    tStyle.transform = tSpanTranslation;
                    tStyle.webkitTransform = tSpanTranslation;
                } else this.innerElem.appendChild(tSpan);
            } //
            if (!this.isMasked) this.textSpans[cnt] = tParent;
            else this.textSpans[cnt] = tSpan;
            this.textSpans[cnt].style.display = 'block';
            this.textPaths[cnt] = tSpan;
            cnt += 1;
        }
        while(cnt < this.textSpans.length){
            this.textSpans[cnt].style.display = 'none';
            cnt += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
                svgStyle = this.svgElement.style;
                var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
                svgStyle.transform = translation;
                svgStyle.webkitTransform = translation;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i;
        var len;
        var count = 0;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var textPath;
        for(i = 0; i < len; i += 1)if (letters[i].n) count += 1;
        else {
            textSpan = this.textSpans[i];
            textPath = this.textPaths[i];
            renderedLetter = renderedLetters[count];
            count += 1;
            if (renderedLetter._mdf.m) {
                if (!this.isMasked) {
                    textSpan.style.webkitTransform = renderedLetter.m;
                    textSpan.style.transform = renderedLetter.m;
                } else textSpan.setAttribute('transform', renderedLetter.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan.style.opacity = renderedLetter.o;
            if (renderedLetter.sw && renderedLetter._mdf.sw) textPath.setAttribute('stroke-width', renderedLetter.sw);
            if (renderedLetter.sc && renderedLetter._mdf.sc) textPath.setAttribute('stroke', renderedLetter.sc);
            if (renderedLetter.fc && renderedLetter._mdf.fc) {
                textPath.setAttribute('fill', renderedLetter.fc);
                textPath.style.color = renderedLetter.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox.width) {
                this.currentBBox.w = boundingBox.width;
                this.svgElement.setAttribute('width', boundingBox.width);
            }
            if (this.currentBBox.h !== boundingBox.height) {
                this.currentBBox.h = boundingBox.height;
                this.svgElement.setAttribute('height', boundingBox.height);
            }
            var margin = 1;
            if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
                this.currentBBox.w = boundingBox.width + margin * 2;
                this.currentBBox.h = boundingBox.height + margin * 2;
                this.currentBBox.x = boundingBox.x - margin;
                this.currentBBox.y = boundingBox.y - margin;
                this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
                svgStyle = this.svgElement.style;
                var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
                svgStyle.transform = svgTransform;
                svgStyle.webkitTransform = svgTransform;
            }
        }
    };
    function HCameraElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initHierarchy();
        var getProp = PropertyFactory.getProp;
        this.pe = getProp(this, data.pe, 0, 0, this);
        if (data.ks.p.s) {
            this.px = getProp(this, data.ks.p.x, 1, 0, this);
            this.py = getProp(this, data.ks.p.y, 1, 0, this);
            this.pz = getProp(this, data.ks.p.z, 1, 0, this);
        } else this.p = getProp(this, data.ks.p, 1, 0, this);
        if (data.ks.a) this.a = getProp(this, data.ks.a, 1, 0, this);
        if (data.ks.or.k.length && data.ks.or.k[0].to) {
            var i;
            var len = data.ks.or.k.length;
            for(i = 0; i < len; i += 1){
                data.ks.or.k[i].to = null;
                data.ks.or.k[i].ti = null;
            }
        }
        this.or = getProp(this, data.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
        this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
        this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i;
        var len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;
        for(i = 0; i < len; i += 1){
            // [perspectiveElem,container]
            comp = this.comp.threeDElements[i];
            if (comp.type === '3d') {
                perspectiveStyle = comp.perspectiveElem.style;
                containerStyle = comp.container.style;
                var perspective = this.pe.v + 'px';
                var origin = '0px 0px 0px';
                var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
                perspectiveStyle.perspective = perspective;
                perspectiveStyle.webkitPerspective = perspective;
                containerStyle.transformOrigin = origin;
                containerStyle.mozTransformOrigin = origin;
                containerStyle.webkitTransformOrigin = origin;
                perspectiveStyle.transform = matrix;
                perspectiveStyle.webkitTransform = matrix;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf = this._isFirstFrame;
        var i;
        var len;
        if (this.hierarchy) {
            len = this.hierarchy.length;
            for(i = 0; i < len; i += 1)_mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
        }
        if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len = this.hierarchy.length - 1;
                for(i = len; i >= 0; i -= 1){
                    var mTransf = this.hierarchy[i].finalTransform.mProp;
                    this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
                    this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
                    this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
                    this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
                    this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector;
                if (this.p) diffVector = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir = [
                    diffVector[0] / mag,
                    diffVector[1] / mag,
                    diffVector[2] / mag
                ];
                var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
                var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
                var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
                this.mat.rotateY(mRotationY).rotateX(-mRotationX);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
                len = this.comp.threeDElements.length;
                var comp;
                var perspectiveStyle;
                var containerStyle;
                for(i = 0; i < len; i += 1){
                    comp = this.comp.threeDElements[i];
                    if (comp.type === '3d') {
                        if (hasMatrixChanged) {
                            var matValue = this.mat.toCSS();
                            containerStyle = comp.container.style;
                            containerStyle.transform = matValue;
                            containerStyle.webkitTransform = matValue;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle = comp.perspectiveElem.style;
                            perspectiveStyle.perspective = this.pe.v + 'px';
                            perspectiveStyle.webkitPerspective = this.pe.v + 'px';
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num) {
        this.prepareProperties(num, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data, globalData, comp) {
        this.assetData = globalData.getAssetData(data.refId);
        this.initElement(data, globalData, comp);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath = this.globalData.getAssetsPath(this.assetData);
        var img = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS('image');
            this.imageElem.setAttribute('width', this.assetData.w + 'px');
            this.imageElem.setAttribute('height', this.assetData.h + 'px');
            this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute('width', this.assetData.w);
            this.baseElement.setAttribute('height', this.assetData.h);
        } else this.layerElement.appendChild(img);
        img.crossOrigin = 'anonymous';
        img.src = assetPath;
        if (this.data.ln) this.baseElement.setAttribute('id', this.data.ln);
    };
    function HybridRendererBase(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element = this.pendingElements.pop();
            element.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element, pos) {
        var newDOMElement = element.getBaseElement();
        if (!newDOMElement) return;
        var layer = this.layers[pos];
        if (!layer.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement, pos);
            else {
                var i = 0;
                var nextDOMElement;
                var nextLayer;
                var tmpDOMElement;
                while(i < pos){
                    if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
                        nextLayer = this.elements[i];
                        tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
                        nextDOMElement = tmpDOMElement || nextDOMElement;
                    }
                    i += 1;
                }
                if (nextDOMElement) {
                    if (!layer.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement, nextDOMElement);
                } else if (!layer.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement);
            }
        } else this.addTo3dContainer(newDOMElement, pos);
    };
    HybridRendererBase.prototype.createShape = function(data) {
        if (!this.supports3d) return new SVGShapeElement(data, this.globalData, this);
        return new HShapeElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data) {
        if (!this.supports3d) return new SVGTextLottieElement(data, this.globalData, this);
        return new HTextElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data) {
        this.camera = new HCameraElement(data, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data) {
        if (!this.supports3d) return new IImageElement(data, this.globalData, this);
        return new HImageElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data) {
        if (!this.supports3d) return new ISolidElement(data, this.globalData, this);
        return new HSolidElement(data, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) return this.threeDElements[i].perspectiveElem;
            i += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos, type) {
        var perspectiveElem = createTag('div');
        var style;
        var containerStyle;
        styleDiv(perspectiveElem);
        var container = createTag('div');
        styleDiv(container);
        if (type === '3d') {
            style = perspectiveElem.style;
            style.width = this.globalData.compSize.w + 'px';
            style.height = this.globalData.compSize.h + 'px';
            var center = '50% 50%';
            style.webkitTransformOrigin = center;
            style.mozTransformOrigin = center;
            style.transformOrigin = center;
            containerStyle = container.style;
            var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
            containerStyle.transform = matrix;
            containerStyle.webkitTransform = matrix;
        }
        perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData = {
            container: container,
            perspectiveElem: perspectiveElem,
            startPos: pos,
            endPos: pos,
            type: type
        };
        this.threeDElements.push(threeDContainerData);
        return threeDContainerData;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i;
        var len = this.layers.length;
        var lastThreeDContainerData;
        var currentContainer = '';
        for(i = 0; i < len; i += 1)if (this.layers[i].ddd && this.layers[i].ty !== 3) {
            if (currentContainer !== '3d') {
                currentContainer = '3d';
                lastThreeDContainerData = this.createThreeDContainer(i, '3d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        } else {
            if (currentContainer !== '2d') {
                currentContainer = '2d';
                lastThreeDContainerData = this.createThreeDContainer(i, '2d');
            }
            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
        }
        len = this.threeDElements.length;
        for(i = len - 1; i >= 0; i -= 1)this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem, pos) {
        var i = 0;
        var len = this.threeDElements.length;
        while(i < len){
            if (pos <= this.threeDElements[i].endPos) {
                var j = this.threeDElements[i].startPos;
                var nextElement;
                while(j < pos){
                    if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
                    j += 1;
                }
                if (nextElement) this.threeDElements[i].container.insertBefore(elem, nextElement);
                else this.threeDElements[i].container.appendChild(elem);
                break;
            }
            i += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData) {
        var resizerElem = createTag('div');
        var wrapper = this.animationItem.wrapper;
        var style = resizerElem.style;
        style.width = animData.w + 'px';
        style.height = animData.h + 'px';
        this.resizerElem = resizerElem;
        styleDiv(resizerElem);
        style.transformStyle = 'flat';
        style.mozTransformStyle = 'flat';
        style.webkitTransformStyle = 'flat';
        if (this.renderConfig.className) resizerElem.setAttribute('class', this.renderConfig.className);
        wrapper.appendChild(resizerElem);
        style.overflow = 'hidden';
        var svg = createNS('svg');
        svg.setAttribute('width', '1');
        svg.setAttribute('height', '1');
        styleDiv(svg);
        this.resizerElem.appendChild(svg);
        var defs = createNS('defs');
        svg.appendChild(defs);
        this.data = animData; // Mask animation
        this.setupGlobalData(animData, svg);
        this.globalData.defs = defs;
        this.layers = animData.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = '';
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i;
        var len = this.layers ? this.layers.length : 0;
        for(i = 0; i < len; i += 1)if (this.elements[i] && this.elements[i].destroy) this.elements[i].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth = this.animationItem.wrapper.offsetWidth;
        var elementHeight = this.animationItem.wrapper.offsetHeight;
        var elementRel = elementWidth / elementHeight;
        var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx;
        var sy;
        var tx;
        var ty;
        if (animationRel > elementRel) {
            sx = elementWidth / this.globalData.compSize.w;
            sy = elementWidth / this.globalData.compSize.w;
            tx = 0;
            ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
        } else {
            sx = elementHeight / this.globalData.compSize.h;
            sy = elementHeight / this.globalData.compSize.h;
            tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
            ty = 0;
        }
        var style = this.resizerElem.style;
        style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
        style.transform = style.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = 'none';
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = 'block';
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth = this.globalData.compSize.w;
            var cHeight = this.globalData.compSize.h;
            var i;
            var len = this.threeDElements.length;
            for(i = 0; i < len; i += 1){
                var style = this.threeDElements[i].perspectiveElem.style;
                style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
                style.perspective = style.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets) {
        var i;
        var len = assets.length;
        var floatingContainer = createTag('div');
        for(i = 0; i < len; i += 1)if (assets[i].xt) {
            var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
            comp.initExpressions();
            this.globalData.projectInterface.registerComposition(comp);
        }
    };
    function HCompElement(data, globalData, comp) {
        this.layers = data.layers;
        this.supports3d = !data.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data, globalData, comp);
        this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute('width', this.data.w);
            this.svgElement.setAttribute('height', this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem, pos) {
        var j = 0;
        var nextElement;
        while(j < pos){
            if (this.elements[j] && this.elements[j].getBaseElement) nextElement = this.elements[j].getBaseElement();
            j += 1;
        }
        if (nextElement) this.layerElement.insertBefore(elem, nextElement);
        else this.layerElement.appendChild(elem);
    };
    HCompElement.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    function HybridRenderer(animationItem, config) {
        this.animationItem = animationItem;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config && config.className || '',
            imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
            hideOnTransparent: !(config && config.hideOnTransparent === false),
            filterSize: {
                width: config && config.filterSize && config.filterSize.width || '400%',
                height: config && config.filterSize && config.filterSize.height || '400%',
                x: config && config.filterSize && config.filterSize.x || '-100%',
                y: config && config.filterSize && config.filterSize.y || '-100%'
            },
            runExpressions: !config || config.runExpressions === undefined || config.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = 'html';
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data) {
        if (!this.supports3d) return new SVGCompElement(data, this.globalData, this);
        return new HCompElement(data, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp) {
            function _thisLayerFunction(name) {
                var i = 0;
                var len = comp.layers.length;
                while(i < len){
                    if (comp.layers[i].nm === name || comp.layers[i].ind === name) return comp.elements[i].layerInterface;
                    i += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction, '_name', {
                value: comp.data.nm
            });
            _thisLayerFunction.layer = _thisLayerFunction;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
            _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
            _thisLayerFunction.pixelAspect = 1;
            _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
            _thisLayerFunction.displayStartTime = 0;
            _thisLayerFunction.numLayers = comp.layers.length;
            return _thisLayerFunction;
        };
    }();
    function _typeof$2(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$2 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$2(obj);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool, math) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global = this, width = 256, // each RC4 output is 0 <= x < 256
        chunks = 6, // at least six RC4 outputs for each double
        digits = 52, // there are 52 significant digits in a double
        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
        startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom(seed, options, callback) {
            var key = [];
            options = options === true ? {
                entropy: true
            } : options || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed = mixkey(flatten(options.entropy ? [
                seed,
                tostring(pool)
            ] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.
            var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng = function prng() {
                var n = arc4.g(chunks), // Start with a numerator n < 2 ^ 48
                d = startdenom, //   and denominator d = 2 ^ 48.
                x = 0; //   and no 'extra last byte'.
                while(n < significance){
                    // Fill up all significant digits by
                    n = (n + x) * width; //   shifting numerator and
                    d *= width; //   denominator and generating a
                    x = arc4.g(1); //   new least-significant-byte.
                }
                while(n >= overflow){
                    // To avoid rounding up, before adding
                    n /= 2; //   last byte, shift everything
                    d /= 2; //   right using integer math until
                    x >>>= 1; //   we have exactly the desired bits.
                }
                return (n + x) / d; // Form the number within [0, 1).
            };
            prng.int32 = function() {
                return arc4.g(4) | 0;
            };
            prng.quick = function() {
                return arc4.g(4) / 0x100000000;
            };
            prng["double"] = prng; // Mix the randomness into accumulated entropy.
            mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options.pass || callback || function(prng, seed, is_math_call, state) {
                if (state) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state.S) copy(state, arc4);
                     // Only provide the .state method if requested via options.state.
                    prng.state = function() {
                        return copy(arc4, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call) {
                    math[rngname] = prng;
                    return seed;
                } else return prng;
            })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
        }
        math['seed' + rngname] = seedrandom; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC4(key) {
            var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = []; // The empty key [] is treated as [0].
            if (!keylen) key = [
                keylen++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i < width)s[i] = i++;
            for(i = 0; i < width; i++){
                s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
                s[j] = t;
            } // The "g" method returns the next (count) outputs as one number.
            me.g = function(count) {
                // Using instance members instead of closure state nearly doubles speed.
                var t, r = 0, i = me.i, j = me.j, s = me.S;
                while(count--){
                    t = s[i = mask & i + 1];
                    r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
                }
                me.i = i;
                me.j = j;
                return r; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy(f, t) {
            t.i = f.i;
            t.j = f.j;
            t.S = f.S.slice();
            return t;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten(obj, depth) {
            var result = [], typ = _typeof$2(obj), prop;
            if (depth && typ == 'object') {
                for(prop in obj)try {
                    result.push(flatten(obj[prop], depth - 1));
                } catch (e) {}
            }
            return result.length ? result : typ == 'string' ? obj : obj + '\0';
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey(seed, key) {
            var stringseed = seed + '', smear, j = 0;
            while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
            return tostring(key);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed() {
            try {
                if (nodecrypto) return tostring(nodecrypto.randomBytes(width));
                var out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
                return tostring(out);
            } catch (e) {
                var browser = global.navigator, plugins = browser && browser.plugins;
                return [
                    +new Date(),
                    global,
                    plugins,
                    global.screen,
                    tostring(pool)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring(a) {
            return String.fromCharCode.apply(0, a);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath) {
        seedRandom([], BMMath);
    }
    var propTypes = {
        SHAPE: 'shape'
    };
    function _typeof$1(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof(obj) {
            return typeof obj;
        };
        else _typeof$1 = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof$1(obj);
    }
    var ExpressionManager = function() {
        'use strict';
        var ob = {};
        var Math1 = BMMath;
        var window1 = null;
        var document1 = null;
        var XMLHttpRequest1 = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr) {
            return arr.constructor === Array || arr.constructor === Float32Array;
        }
        function isNumerable(tOfV, v) {
            return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
        }
        function $bm_neg(a) {
            var tOfA = _typeof$1(a);
            if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') return -a;
            if ($bm_isInstanceOfArray(a)) {
                var i;
                var lenA = a.length;
                var retArr = [];
                for(i = 0; i < lenA; i += 1)retArr[i] = -a[i];
                return retArr;
            }
            if (a.propType) return a.v;
            return -a;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;
        function sum(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') return a + b;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] += b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a + b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] + b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        var add = sum;
        function sub(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
                if (tOfA === 'string') a = parseInt(a, 10);
                if (tOfB === 'string') b = parseInt(b, 10);
                return a - b;
            }
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                a = a.slice(0);
                a[0] -= b;
                return a;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                b = b.slice(0);
                b[0] = a - b[0];
                return b;
            }
            if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
                var i = 0;
                var lenA = a.length;
                var lenB = b.length;
                var retArr = [];
                while(i < lenA || i < lenB){
                    if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) retArr[i] = a[i] - b[i];
                    else retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
                    i += 1;
                }
                return retArr;
            }
            return 0;
        }
        function mul(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a * b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] * b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a * b[i];
                return arr;
            }
            return 0;
        }
        function div(a, b) {
            var tOfA = _typeof$1(a);
            var tOfB = _typeof$1(b);
            var arr;
            if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) return a / b;
            var i;
            var len;
            if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
                len = a.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a[i] / b;
                return arr;
            }
            if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
                len = b.length;
                arr = createTypedArray('float32', len);
                for(i = 0; i < len; i += 1)arr[i] = a / b[i];
                return arr;
            }
            return 0;
        }
        function mod(a, b) {
            if (typeof a === 'string') a = parseInt(a, 10);
            if (typeof b === 'string') b = parseInt(b, 10);
            return a % b;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num, min, max) {
            if (min > max) {
                var mm = max;
                max = min;
                min = mm;
            }
            return Math1.min(Math1.max(num, min), max);
        }
        function radiansToDegrees(val) {
            return val / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val) {
            return val * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr1, arr2) {
            if (typeof arr1 === 'number' || arr1 instanceof Number) {
                arr2 = arr2 || 0;
                return Math1.abs(arr1 - arr2);
            }
            if (!arr2) arr2 = helperLengthArray;
            var i;
            var len = Math1.min(arr1.length, arr2.length);
            var addedLength = 0;
            for(i = 0; i < len; i += 1)addedLength += Math1.pow(arr2[i] - arr1[i], 2);
            return Math1.sqrt(addedLength);
        }
        function normalize(vec) {
            return div(vec, length(vec));
        }
        function rgbToHsl(val) {
            var r = val[0];
            var g = val[1];
            var b = val[2];
            var max = Math1.max(r, g, b);
            var min = Math1.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max === min) {
                h = 0; // achromatic
                s = 0; // achromatic
            } else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch(max){
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                    default:
                        break;
                }
                h /= 6;
            }
            return [
                h,
                s,
                l,
                val[3]
            ];
        }
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        function hslToRgb(val) {
            var h = val[0];
            var s = val[1];
            var l = val[2];
            var r;
            var g;
            var b;
            if (s === 0) {
                r = l; // achromatic
                b = l; // achromatic
                g = l; // achromatic
            } else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return [
                r,
                g,
                b,
                val[3]
            ];
        }
        function linear(t, tMin, tMax, value1, value2) {
            if (value1 === undefined || value2 === undefined) {
                value1 = tMin;
                value2 = tMax;
                tMin = 0;
                tMax = 1;
            }
            if (tMax < tMin) {
                var _tMin = tMax;
                tMax = tMin;
                tMin = _tMin;
            }
            if (t <= tMin) return value1;
            if (t >= tMax) return value2;
            var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);
            if (!value1.length) return value1 + (value2 - value1) * perc;
            var i;
            var len = value1.length;
            var arr = createTypedArray('float32', len);
            for(i = 0; i < len; i += 1)arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
            return arr;
        }
        function random(min, max) {
            if (max === undefined) {
                if (min === undefined) {
                    min = 0;
                    max = 1;
                } else {
                    max = min;
                    min = undefined;
                }
            }
            if (max.length) {
                var i;
                var len = max.length;
                if (!min) min = createTypedArray('float32', len);
                var arr = createTypedArray('float32', len);
                var rnd = BMMath.random();
                for(i = 0; i < len; i += 1)arr[i] = min[i] + rnd * (max[i] - min[i]);
                return arr;
            }
            if (min === undefined) min = 0;
            var rndm = BMMath.random();
            return min + rndm * (max - min);
        }
        function createPath(points, inTangents, outTangents, closed) {
            var i;
            var len = points.length;
            var path = shapePool.newElement();
            path.setPathData(!!closed, len);
            var arrPlaceholder = [
                0,
                0
            ];
            var inVertexPoint;
            var outVertexPoint;
            for(i = 0; i < len; i += 1){
                inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
                outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
                path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
            }
            return path;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value) {
                return _value;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf('random') !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, 'value', {
                get: function get() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle(freq, amp) {
                var iWiggle;
                var j;
                var lenWiggle = this.pv.length ? this.pv.length : 1;
                var addedAmps = createTypedArray('float32', lenWiggle);
                freq = 5;
                var iterations = Math1.floor(time * freq);
                iWiggle = 0;
                j = 0;
                while(iWiggle < iterations){
                    // var rnd = BMMath.random();
                    for(j = 0; j < lenWiggle; j += 1)addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle += 1;
                } // var rnd2 = BMMath.random();
                var periods = time * freq;
                var perc = periods - Math1.floor(periods);
                var arr = createTypedArray('float32', lenWiggle);
                if (lenWiggle > 1) {
                    for(j = 0; j < lenWiggle; j += 1)arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr;
                }
                return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type, duration) {
                return loopIn(type, duration, true);
            }
            function loopOutDuration(type, duration) {
                return loopOut(type, duration, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem1, elem2) {
                var fVec = [
                    elem2[0] - elem1[0],
                    elem2[1] - elem1[1],
                    elem2[2] - elem1[2]
                ];
                var pitch = Math1.atan2(fVec[0], Math1.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
                var yaw = -Math1.atan2(fVec[1], fVec[2]) / degToRads;
                return [
                    yaw,
                    pitch,
                    0
                ];
            }
            function easeOut(t, tMin, tMax, val1, val2) {
                return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
            }
            function easeIn(t, tMin, tMax, val1, val2) {
                return applyEase(easeInBez, t, tMin, tMax, val1, val2);
            }
            function ease(t, tMin, tMax, val1, val2) {
                return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
            }
            function applyEase(fn, t, tMin, tMax, val1, val2) {
                if (val1 === undefined) {
                    val1 = tMin;
                    val2 = tMax;
                } else t = (t - tMin) / (tMax - tMin);
                if (t > 1) t = 1;
                else if (t < 0) t = 0;
                var mult = fn(t);
                if ($bm_isInstanceOfArray(val1)) {
                    var iKey;
                    var lenKey = val1.length;
                    var arr = createTypedArray('float32', lenKey);
                    for(iKey = 0; iKey < lenKey; iKey += 1)arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
                    return arr;
                }
                return (val2 - val1) * mult + val1;
            }
            function nearestKey(time) {
                var iKey;
                var lenKey = data.k.length;
                var index;
                var keyTime;
                if (!data.k.length || typeof data.k[0] === 'number') {
                    index = 0;
                    keyTime = 0;
                } else {
                    index = -1;
                    time *= elem.comp.globalData.frameRate;
                    if (time < data.k[0].t) {
                        index = 1;
                        keyTime = data.k[0].t;
                    } else {
                        for(iKey = 0; iKey < lenKey - 1; iKey += 1){
                            if (time === data.k[iKey].t) {
                                index = iKey + 1;
                                keyTime = data.k[iKey].t;
                                break;
                            } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                                    index = iKey + 2;
                                    keyTime = data.k[iKey + 1].t;
                                } else {
                                    index = iKey + 1;
                                    keyTime = data.k[iKey].t;
                                }
                                break;
                            }
                        }
                        if (index === -1) {
                            index = iKey + 1;
                            keyTime = data.k[iKey].t;
                        }
                    }
                }
                var obKey = {};
                obKey.index = index;
                obKey.time = keyTime / elem.comp.globalData.frameRate;
                return obKey;
            }
            function key(ind) {
                var obKey;
                var iKey;
                var lenKey;
                if (!data.k.length || typeof data.k[0] === 'number') throw new Error('The property has no keyframe at index ' + ind);
                ind -= 1;
                obKey = {
                    time: data.k[ind].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
                lenKey = arr.length;
                for(iKey = 0; iKey < lenKey; iKey += 1){
                    obKey[iKey] = arr[iKey];
                    obKey.value[iKey] = arr[iKey];
                }
                return obKey;
            }
            function framesToTime(fr, fps) {
                if (!fps) fps = elem.comp.globalData.frameRate;
                return fr / fps;
            }
            function timeToFrames(t, fps) {
                if (!t && t !== 0) t = time;
                if (!fps) fps = elem.comp.globalData.frameRate;
                return t * fps;
            }
            function seedRandom(seed) {
                BMMath.seedrandom(randSeed + seed);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substring(init);
                    return value.substring(init, end);
                }
                return '';
            }
            function substr(init, end) {
                if (typeof value === 'string') {
                    if (end === undefined) return value.substr(init);
                    return value.substr(init, end);
                }
                return '';
            }
            function posterizeTime(framesPerSecond) {
                time = framesPerSecond === 0 ? 0 : Math1.floor(time * framesPerSecond) / framesPerSecond;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math1.floor(Math1.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value) {
                // globalData.pushExpression();
                value = _value;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') return value;
                if (this.propType === 'textSelector') {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface('ADBE Transform Group');
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer('ADBE Root Vectors Group');
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window1,
            document1,
            XMLHttpRequest1,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob = {};
        ob.initExpressions = initExpressions;
        ob.resetFrame = ExpressionManager.resetFrame;
        function initExpressions(animation) {
            var stackCount = 0;
            var registers = [];
            function pushExpression() {
                stackCount += 1;
            }
            function popExpression() {
                stackCount -= 1;
                if (stackCount === 0) releaseInstances();
            }
            function registerExpressionProperty(expression) {
                if (registers.indexOf(expression) === -1) registers.push(expression);
            }
            function releaseInstances() {
                var i;
                var len = registers.length;
                for(i = 0; i < len; i += 1)registers[i].release();
                registers.length = 0;
            }
            animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
            animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
            animation.renderer.globalData.pushExpression = pushExpression;
            animation.renderer.globalData.popExpression = popExpression;
            animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
        }
        return ob;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface(mask, data) {
            this._mask = mask;
            this._data = data;
        }
        Object.defineProperty(MaskInterface.prototype, 'maskPath', {
            get: function get() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
            get: function get() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager = function MaskManager(maskManager) {
            var _masksInterfaces = createSizedArray(maskManager.viewData.length);
            var i;
            var len = maskManager.viewData.length;
            for(i = 0; i < len; i += 1)_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
            var maskFunction = function maskFunction(name) {
                i = 0;
                while(i < len){
                    if (maskManager.masksProperties[i].nm === name) return _masksInterfaces[i];
                    i += 1;
                }
                return null;
            };
            return maskFunction;
        };
        return MaskManager;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty(expressionValue, property, type) {
            Object.defineProperty(expressionValue, 'velocity', {
                get: function get() {
                    return property.getVelocityAtTime(property.comp.currentFrame);
                }
            });
            expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;
            expressionValue.key = function(pos) {
                if (!expressionValue.numKeys) return 0;
                var value = '';
                if ('s' in property.keyframes[pos - 1]) value = property.keyframes[pos - 1].s;
                else if ('e' in property.keyframes[pos - 2]) value = property.keyframes[pos - 2].e;
                else value = property.keyframes[pos - 2].s;
                var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers
                valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
                valueProp.value = type === 'unidimensional' ? value[0] : value;
                return valueProp;
            };
            expressionValue.valueAtTime = property.getValueAtTime;
            expressionValue.speedAtTime = property.getSpeedAtTime;
            expressionValue.velocityAtTime = property.getVelocityAtTime;
            expressionValue.propertyGroup = property.propertyGroup;
        }
        function UnidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultUnidimensionalValue;
            var mult = 1 / property.mult;
            var val = property.pv * mult;
            var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
            expressionValue.value = val;
            completeProperty(expressionValue, property, 'unidimensional');
            return function() {
                if (property.k) property.getValue();
                val = property.v * mult;
                if (expressionValue.value !== val) {
                    expressionValue = new Number(val); // eslint-disable-line no-new-wrappers
                    expressionValue.value = val;
                    completeProperty(expressionValue, property, 'unidimensional');
                }
                return expressionValue;
            };
        }
        function MultidimensionalPropertyInterface(property) {
            if (!property || !('pv' in property)) property = defaultMultidimensionalValue;
            var mult = 1 / property.mult;
            var len = property.data && property.data.l || property.pv.length;
            var expressionValue = createTypedArray('float32', len);
            var arrValue = createTypedArray('float32', len);
            expressionValue.value = arrValue;
            completeProperty(expressionValue, property, 'multidimensional');
            return function() {
                if (property.k) property.getValue();
                for(var i = 0; i < len; i += 1){
                    arrValue[i] = property.v[i] * mult;
                    expressionValue[i] = arrValue[i];
                }
                return expressionValue;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter() {
            return defaultUnidimensionalValue;
        }
        return function(property) {
            if (!property) return defaultGetter;
            if (property.propType === 'unidimensional') return UnidimensionalPropertyInterface(property);
            return MultidimensionalPropertyInterface(property);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform) {
            function _thisFunction(name) {
                switch(name){
                    case 'scale':
                    case 'Scale':
                    case 'ADBE Scale':
                    case 6:
                        return _thisFunction.scale;
                    case 'rotation':
                    case 'Rotation':
                    case 'ADBE Rotation':
                    case 'ADBE Rotate Z':
                    case 10:
                        return _thisFunction.rotation;
                    case 'ADBE Rotate X':
                        return _thisFunction.xRotation;
                    case 'ADBE Rotate Y':
                        return _thisFunction.yRotation;
                    case 'position':
                    case 'Position':
                    case 'ADBE Position':
                    case 2:
                        return _thisFunction.position;
                    case 'ADBE Position_0':
                        return _thisFunction.xPosition;
                    case 'ADBE Position_1':
                        return _thisFunction.yPosition;
                    case 'ADBE Position_2':
                        return _thisFunction.zPosition;
                    case 'anchorPoint':
                    case 'AnchorPoint':
                    case 'Anchor Point':
                    case 'ADBE AnchorPoint':
                    case 1:
                        return _thisFunction.anchorPoint;
                    case 'opacity':
                    case 'Opacity':
                    case 11:
                        return _thisFunction.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction, 'rotation', {
                get: ExpressionPropertyInterface(transform.r || transform.rz)
            });
            Object.defineProperty(_thisFunction, 'zRotation', {
                get: ExpressionPropertyInterface(transform.rz || transform.r)
            });
            Object.defineProperty(_thisFunction, 'xRotation', {
                get: ExpressionPropertyInterface(transform.rx)
            });
            Object.defineProperty(_thisFunction, 'yRotation', {
                get: ExpressionPropertyInterface(transform.ry)
            });
            Object.defineProperty(_thisFunction, 'scale', {
                get: ExpressionPropertyInterface(transform.s)
            });
            var _px;
            var _py;
            var _pz;
            var _transformFactory;
            if (transform.p) _transformFactory = ExpressionPropertyInterface(transform.p);
            else {
                _px = ExpressionPropertyInterface(transform.px);
                _py = ExpressionPropertyInterface(transform.py);
                if (transform.pz) _pz = ExpressionPropertyInterface(transform.pz);
            }
            Object.defineProperty(_thisFunction, 'position', {
                get: function get() {
                    if (transform.p) return _transformFactory();
                    return [
                        _px(),
                        _py(),
                        _pz ? _pz() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction, 'xPosition', {
                get: ExpressionPropertyInterface(transform.px)
            });
            Object.defineProperty(_thisFunction, 'yPosition', {
                get: ExpressionPropertyInterface(transform.py)
            });
            Object.defineProperty(_thisFunction, 'zPosition', {
                get: ExpressionPropertyInterface(transform.pz)
            });
            Object.defineProperty(_thisFunction, 'anchorPoint', {
                get: ExpressionPropertyInterface(transform.a)
            });
            Object.defineProperty(_thisFunction, 'opacity', {
                get: ExpressionPropertyInterface(transform.o)
            });
            Object.defineProperty(_thisFunction, 'skew', {
                get: ExpressionPropertyInterface(transform.sk)
            });
            Object.defineProperty(_thisFunction, 'skewAxis', {
                get: ExpressionPropertyInterface(transform.sa)
            });
            Object.defineProperty(_thisFunction, 'orientation', {
                get: ExpressionPropertyInterface(transform.or)
            });
            return _thisFunction;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix(time) {
            var toWorldMat = new Matrix();
            if (time !== undefined) {
                var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);
                propMatrix.clone(toWorldMat);
            } else {
                var transformMat = this._elem.finalTransform.mProp;
                transformMat.applyToMatrix(toWorldMat);
            }
            return toWorldMat;
        }
        function toWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.applyPoint(toWorldMat, arr);
        }
        function toWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.applyPoint(toWorldMat, arr);
        }
        function fromWorldVec(arr, time) {
            var toWorldMat = this.getMatrix(time);
            toWorldMat.props[12] = 0;
            toWorldMat.props[13] = 0;
            toWorldMat.props[14] = 0;
            return this.invertPoint(toWorldMat, arr);
        }
        function fromWorld(arr, time) {
            var toWorldMat = this.getMatrix(time);
            return this.invertPoint(toWorldMat, arr);
        }
        function applyPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
        }
        function invertPoint(matrix, arr) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
            }
            return matrix.inversePoint(arr);
        }
        function fromComp(arr) {
            var toWorldMat = new Matrix();
            toWorldMat.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i;
                var len = this._elem.hierarchy.length;
                for(i = 0; i < len; i += 1)this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
                return toWorldMat.inversePoint(arr);
            }
            return toWorldMat.inversePoint(arr);
        }
        function sampleImage() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem) {
            var transformInterface;
            function _registerMaskInterface(maskManager) {
                _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
            }
            function _registerEffectsInterface(effects) {
                _thisLayerFunction.effect = effects;
            }
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Root Vectors Group':
                    case 'Contents':
                    case 2:
                        return _thisLayerFunction.shapeInterface;
                    case 1:
                    case 6:
                    case 'Transform':
                    case 'transform':
                    case 'ADBE Transform Group':
                        return transformInterface;
                    case 4:
                    case 'ADBE Effect Parade':
                    case 'effects':
                    case 'Effects':
                        return _thisLayerFunction.effect;
                    case 'ADBE Text Properties':
                        return _thisLayerFunction.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction.getMatrix = getMatrix;
            _thisLayerFunction.invertPoint = invertPoint;
            _thisLayerFunction.applyPoint = applyPoint;
            _thisLayerFunction.toWorld = toWorld;
            _thisLayerFunction.toWorldVec = toWorldVec;
            _thisLayerFunction.fromWorld = fromWorld;
            _thisLayerFunction.fromWorldVec = fromWorldVec;
            _thisLayerFunction.toComp = toWorld;
            _thisLayerFunction.fromComp = fromComp;
            _thisLayerFunction.sampleImage = sampleImage;
            _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
            _thisLayerFunction._elem = elem;
            transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
            var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
            Object.defineProperties(_thisLayerFunction, {
                hasParent: {
                    get: function get() {
                        return elem.hierarchy.length;
                    }
                },
                parent: {
                    get: function get() {
                        return elem.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface, 'rotation'),
                scale: getDescriptor(transformInterface, 'scale'),
                position: getDescriptor(transformInterface, 'position'),
                opacity: getDescriptor(transformInterface, 'opacity'),
                anchorPoint: anchorPointDescriptor,
                anchor_point: anchorPointDescriptor,
                transform: {
                    get: function get() {
                        return transformInterface;
                    }
                },
                active: {
                    get: function get() {
                        return elem.isInRange;
                    }
                }
            });
            _thisLayerFunction.startTime = elem.data.st;
            _thisLayerFunction.index = elem.data.ind;
            _thisLayerFunction.source = elem.data.refId;
            _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
            _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
            _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
            _thisLayerFunction._name = elem.data.nm;
            _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
            _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
            return _thisLayerFunction;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction, parentPropertyGroup) {
            return function(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return parentPropertyGroup(val - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName, propertyGroup) {
            var interfaceFunction = {
                _name: propertyName
            };
            function _propertyGroup(val) {
                val = val === undefined ? 1 : val;
                if (val <= 0) return interfaceFunction;
                return propertyGroup(val - 1);
            }
            return _propertyGroup;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob = {
            createEffectsInterface: createEffectsInterface
        };
        function createEffectsInterface(elem, propertyGroup) {
            if (elem.effectsManager) {
                var effectElements = [];
                var effectsData = elem.data.ef;
                var i;
                var len = elem.effectsManager.effectElements.length;
                for(i = 0; i < len; i += 1)effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
                var effects = elem.data.ef || [];
                var groupInterface = function groupInterface(name) {
                    i = 0;
                    len = effects.length;
                    while(i < len){
                        if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) return effectElements[i];
                        i += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface, 'numProperties', {
                    get: function get() {
                        return effects.length;
                    }
                });
                return groupInterface;
            }
            return null;
        }
        function createGroupInterface(data, elements, propertyGroup, elem) {
            function groupInterface(name) {
                var effects = data.ef;
                var i = 0;
                var len = effects.length;
                while(i < len){
                    if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
                        if (effects[i].ty === 5) return effectElements[i];
                        return effectElements[i]();
                    }
                    i += 1;
                }
                throw new Error();
            }
            var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);
            var effectElements = [];
            var i;
            var len = data.ef.length;
            for(i = 0; i < len; i += 1)if (data.ef[i].ty === 5) effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
            else effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
            if (data.mn === 'ADBE Color Control') Object.defineProperty(groupInterface, 'color', {
                get: function get() {
                    return effectElements[0]();
                }
            });
            Object.defineProperties(groupInterface, {
                numProperties: {
                    get: function get() {
                        return data.np;
                    }
                },
                _name: {
                    value: data.nm
                },
                propertyGroup: {
                    value: _propertyGroup
                }
            });
            groupInterface.enabled = data.en !== 0;
            groupInterface.active = groupInterface.enabled;
            return groupInterface;
        }
        function createValueInterface(element, type, elem, propertyGroup) {
            var expressionProperty = ExpressionPropertyInterface(element.p);
            function interfaceFunction() {
                if (type === 10) return elem.comp.compInterface(element.p.v);
                return expressionProperty();
            }
            if (element.p.setGroupProperty) element.p.setGroupProperty(PropertyInterface('', propertyGroup));
            return interfaceFunction;
        }
        return ob;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory(shape, view, propertyGroup) {
            var prop = view.sh;
            function interfaceFunction(val) {
                if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) return interfaceFunction.path;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                path: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                shape: {
                    get: function get() {
                        if (prop.k) prop.getValue();
                        return prop;
                    }
                },
                _name: {
                    value: shape.nm
                },
                ix: {
                    value: shape.ix
                },
                propertyIndex: {
                    value: shape.ix
                },
                mn: {
                    value: shape.mn
                },
                propertyGroup: {
                    value: propertyGroup
                }
            });
            return interfaceFunction;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements(shapes, view, propertyGroup) {
            var arr = [];
            var i;
            var len = shapes ? shapes.length : 0;
            for(i = 0; i < len; i += 1){
                if (shapes[i].ty === 'gr') arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'fl') arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'st') arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tm') arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'tr') ;
                else if (shapes[i].ty === 'el') arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sr') arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'sh') arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rc') arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rd') arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'rp') arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
                else if (shapes[i].ty === 'gf') arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
                else arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
            }
            return arr;
        }
        function contentsInterfaceFactory(shape, view, propertyGroup) {
            var interfaces;
            var interfaceFunction = function _interfaceFunction(value) {
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) return interfaces[i];
                    i += 1;
                }
                if (typeof value === 'number') return interfaces[value - 1];
                return null;
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
            interfaceFunction.numProperties = interfaces.length;
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.transform = transformInterface;
            interfaceFunction.propertyIndex = shape.cix;
            interfaceFunction._name = shape.nm;
            return interfaceFunction;
        }
        function groupInterfaceFactory(shape, view, propertyGroup) {
            var interfaceFunction = function _interfaceFunction(value) {
                switch(value){
                    case 'ADBE Vectors Group':
                    case 'Contents':
                    case 2:
                        return interfaceFunction.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction.transform;
                }
            };
            interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
            var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
            interfaceFunction.content = content;
            interfaceFunction.transform = transformInterface;
            Object.defineProperty(interfaceFunction, '_name', {
                get: function get() {
                    return shape.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction.numProperties = shape.np;
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.nm = shape.nm;
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function fillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function gradientFillInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === 'Start Point' || val === 'start point') return interfaceFunction.startPoint;
                if (val === 'End Point' || val === 'end point') return interfaceFunction.endPoint;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                startPoint: {
                    get: ExpressionPropertyInterface(view.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                type: {
                    get: function get() {
                        return 'a';
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
            return interfaceFunction;
        }
        function defaultInterfaceFactory() {
            function interfaceFunction() {
                return null;
            }
            return interfaceFunction;
        }
        function strokeInterfaceFactory(shape, view, propertyGroup) {
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);
            function addPropertyToDashOb(i) {
                Object.defineProperty(dashOb, shape.d[i].nm, {
                    get: ExpressionPropertyInterface(view.d.dataProps[i].p)
                });
            }
            var i;
            var len = shape.d ? shape.d.length : 0;
            var dashOb = {};
            for(i = 0; i < len; i += 1){
                addPropertyToDashOb(i);
                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
            }
            function interfaceFunction(val) {
                if (val === 'Color' || val === 'color') return interfaceFunction.color;
                if (val === 'Opacity' || val === 'opacity') return interfaceFunction.opacity;
                if (val === 'Stroke Width' || val === 'stroke width') return interfaceFunction.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction, {
                color: {
                    get: ExpressionPropertyInterface(view.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view.w)
                },
                dash: {
                    get: function get() {
                        return dashOb;
                    }
                },
                _name: {
                    value: shape.nm
                },
                mn: {
                    value: shape.mn
                }
            });
            view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
            return interfaceFunction;
        }
        function trimInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(val) {
                if (val === shape.e.ix || val === 'End' || val === 'end') return interfaceFunction.end;
                if (val === shape.s.ix) return interfaceFunction.start;
                if (val === shape.o.ix) return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
            view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
            view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            interfaceFunction.propertyIndex = shape.ix;
            interfaceFunction.propertyGroup = propertyGroup;
            Object.defineProperties(interfaceFunction, {
                start: {
                    get: ExpressionPropertyInterface(view.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function transformInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.a.ix === value || value === 'Anchor Point') return interfaceFunction.anchorPoint;
                if (shape.o.ix === value || value === 'Opacity') return interfaceFunction.opacity;
                if (shape.p.ix === value || value === 'Position') return interfaceFunction.position;
                if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') return interfaceFunction.rotation;
                if (shape.s.ix === value || value === 'Scale') return interfaceFunction.scale;
                if (shape.sk && shape.sk.ix === value || value === 'Skew') return interfaceFunction.skew;
                if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') return interfaceFunction.skewAxis;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
            view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
            view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (view.transform.mProps.sk) {
                view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
                view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
            }
            view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                opacity: {
                    get: ExpressionPropertyInterface(view.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view.transform.mProps.sa)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.ty = 'tr';
            interfaceFunction.mn = shape.mn;
            interfaceFunction.propertyGroup = propertyGroup;
            return interfaceFunction;
        }
        function ellipseInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.s.ix === value) return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            interfaceFunction.propertyIndex = shape.ix;
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function starInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.rotation;
                if (shape.pt.ix === value) return interfaceFunction.points;
                if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') return interfaceFunction.outerRadius;
                if (shape.os.ix === value) return interfaceFunction.outerRoundness;
                if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) return interfaceFunction.innerRadius;
                if (shape.is && shape.is.ix === value) return interfaceFunction.innerRoundness;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
            prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
            prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            if (shape.ir) {
                prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
                prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
            }
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop.is)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function rectInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.p.ix === value) return interfaceFunction.position;
                if (shape.r.ix === value) return interfaceFunction.roundness;
                if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') return interfaceFunction.size;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
            interfaceFunction.propertyIndex = shape.ix;
            prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
            prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
            prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                position: {
                    get: ExpressionPropertyInterface(prop.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop.s)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function roundedInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.r.ix === value || value === 'Round Corners 1') return interfaceFunction.radius;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                radius: {
                    get: ExpressionPropertyInterface(prop.rd)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        function repeaterInterfaceFactory(shape, view, propertyGroup) {
            function interfaceFunction(value) {
                if (shape.c.ix === value || value === 'Copies') return interfaceFunction.copies;
                if (shape.o.ix === value || value === 'Offset') return interfaceFunction.offset;
                return null;
            }
            var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
            var prop = view;
            interfaceFunction.propertyIndex = shape.ix;
            prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
            prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
            Object.defineProperties(interfaceFunction, {
                copies: {
                    get: ExpressionPropertyInterface(prop.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop.o)
                },
                _name: {
                    value: shape.nm
                }
            });
            interfaceFunction.mn = shape.mn;
            return interfaceFunction;
        }
        return function(shapes, view, propertyGroup) {
            var interfaces;
            function _interfaceFunction(value) {
                if (typeof value === 'number') {
                    value = value === undefined ? 1 : value;
                    if (value === 0) return propertyGroup;
                    return interfaces[value - 1];
                }
                var i = 0;
                var len = interfaces.length;
                while(i < len){
                    if (interfaces[i]._name === value) return interfaces[i];
                    i += 1;
                }
                return null;
            }
            function parentGroupWrapper() {
                return propertyGroup;
            }
            _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
            interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
            _interfaceFunction.numProperties = interfaces.length;
            _interfaceFunction._name = 'Contents';
            return _interfaceFunction;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem) {
            var _sourceText;
            function _thisLayerFunction(name) {
                switch(name){
                    case 'ADBE Text Document':
                        return _thisLayerFunction.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction, 'sourceText', {
                get: function get() {
                    elem.textProperty.getValue();
                    var stringValue = elem.textProperty.currentData.t;
                    if (!_sourceText || stringValue !== _sourceText.value) {
                        _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText, 'style', {
                            get: function get() {
                                return {
                                    fillColor: elem.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText;
                }
            });
            return _thisLayerFunction;
        };
    }();
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof1(obj) {
            return typeof obj;
        };
        else _typeof = function _typeof1(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
            var currentPropertyName = '';
            var currentProperty = elem.getFootageData();
            function init() {
                currentPropertyName = '';
                currentProperty = elem.getFootageData();
                return searchProperty;
            }
            function searchProperty(value) {
                if (currentProperty[value]) {
                    currentPropertyName = value;
                    currentProperty = currentProperty[value];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                var propertyNameIndex = value.indexOf(currentPropertyName);
                if (propertyNameIndex !== -1) {
                    var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
                    currentProperty = currentProperty[index];
                    if (_typeof(currentProperty) === 'object') return searchProperty;
                    return currentProperty;
                }
                return '';
            }
            return init;
        };
        var dataInterfaceFactory = function dataInterfaceFactory(elem) {
            function interfaceFunction(value) {
                if (value === 'Outline') return interfaceFunction.outlineInterface();
                return null;
            }
            interfaceFunction._name = 'Outline';
            interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
            return interfaceFunction;
        };
        return function(elem) {
            function _interfaceFunction(value) {
                if (value === 'Data') return _interfaceFunction.dataInterface;
                return null;
            }
            _interfaceFunction._name = 'Data';
            _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
            return _interfaceFunction;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type) {
        return interfaces[type] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions(elem, data, prop) {
            if (data.x) {
                prop.k = true;
                prop.x = true;
                prop.initiateExpression = ExpressionManager.initiateExpression;
                prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
            }
        }
        function getValueAtTime(frameNum) {
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime(frameNum) {
            var delta = -0.01;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var speed = 0;
            if (v1.length) {
                var i;
                for(i = 0; i < v1.length; i += 1)speed += Math.pow(v2[i] - v1[i], 2);
                speed = Math.sqrt(speed) * 100;
            } else speed = 0;
            return speed;
        }
        function getVelocityAtTime(frameNum) {
            if (this.vel !== undefined) return this.vel;
            var delta = -0.001; // frameNum += this.elem.data.st;
            var v1 = this.getValueAtTime(frameNum);
            var v2 = this.getValueAtTime(frameNum + delta);
            var velocity;
            if (v1.length) {
                velocity = createTypedArray('float32', v1.length);
                var i;
                for(i = 0; i < v1.length; i += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity[i] = (v2[i] - v1[i]) / delta;
            } else velocity = (v2 - v1) / delta;
            return velocity;
        }
        function getStaticValueAtTime() {
            return this.pv;
        }
        function setGroupProperty(propertyGroup) {
            this.propertyGroup = propertyGroup;
        }
        return {
            searchExpressions: searchExpressions,
            getSpeedAtTime: getSpeedAtTime,
            getVelocityAtTime: getVelocityAtTime,
            getValueAtTime: getValueAtTime,
            getStaticValueAtTime: getStaticValueAtTime,
            setGroupProperty: setGroupProperty
        };
    }();
    function addPropertyDecorator() {
        function loopOut(type, duration, durationFlag) {
            if (!this.k || !this.keyframes) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var lastKeyFrame = keyframes[keyframes.length - 1].t;
            if (currentFrame <= lastKeyFrame) return this.pv;
            var cycleDuration;
            var firstKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
                else cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
                firstKeyFrame = lastKeyFrame - cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (iterations % 2 !== 0) return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = (endV[i] - initV[i]) * repeats + current[i];
                    return ret;
                }
                return (endV - initV) * repeats + current;
            } else if (type === 'continue') {
                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(lastValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret;
                }
                return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
            }
            return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn(type, duration, durationFlag) {
            if (!this.k) return this.pv;
            type = type ? type.toLowerCase() : '';
            var currentFrame = this.comp.renderedFrame;
            var keyframes = this.keyframes;
            var firstKeyFrame = keyframes[0].t;
            if (currentFrame >= firstKeyFrame) return this.pv;
            var cycleDuration;
            var lastKeyFrame;
            if (!durationFlag) {
                if (!duration || duration > keyframes.length - 1) duration = keyframes.length - 1;
                lastKeyFrame = keyframes[duration].t;
                cycleDuration = lastKeyFrame - firstKeyFrame;
            } else {
                if (!duration) cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
                else cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
                lastKeyFrame = firstKeyFrame + cycleDuration;
            }
            var i;
            var len;
            var ret;
            if (type === 'pingpong') {
                var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);
                if (iterations % 2 === 0) return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type === 'offset') {
                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
                var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;
                if (this.pv.length) {
                    ret = new Array(initV.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
                    return ret;
                }
                return current - (endV - initV) * repeats;
            } else if (type === 'continue') {
                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret = new Array(firstValue.length);
                    len = ret.length;
                    for(i = 0; i < len; i += 1)ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
                    return ret;
                }
                return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
            }
            return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth(width, samples) {
            if (!this.k) return this.pv;
            width = (width || 0.4) * 0.5;
            samples = Math.floor(samples || 5);
            if (samples <= 1) return this.pv;
            var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame = currentTime - width;
            var endFrame = currentTime + width;
            var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
            var i = 0;
            var j = 0;
            var value;
            if (this.pv.length) value = createTypedArray('float32', this.pv.length);
            else value = 0;
            var sampleValue;
            while(i < samples){
                sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);
                if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] += sampleValue[j];
                else value += sampleValue;
                i += 1;
            }
            if (this.pv.length) for(j = 0; j < this.pv.length; j += 1)value[j] /= samples;
            else value /= samples;
            return value;
        }
        function getTransformValueAtTime(time) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix = this._transformCachingAtTime.v;
            matrix.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor = this.a.getValueAtTime(time);
                matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale = this.s.getValueAtTime(time);
                matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew = this.sk.getValueAtTime(time);
                var skewAxis = this.sa.getValueAtTime(time);
                matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation = this.r.getValueAtTime(time);
                matrix.rotate(-rotation * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ = this.rz.getValueAtTime(time);
                var rotationY = this.ry.getValueAtTime(time);
                var rotationX = this.rx.getValueAtTime(time);
                var orientation = this.or.getValueAtTime(time);
                matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX = this.px.getValueAtTime(time);
                var positionY = this.py.getValueAtTime(time);
                if (this.data.p.z) {
                    var positionZ = this.pz.getValueAtTime(time);
                    matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
                } else matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
            } else {
                var position = this.p.getValueAtTime(time);
                matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
            }
            return matrix; /// /
        }
        function getTransformStaticValueAtTime() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem, data, container) {
            var prop = getTransformProperty(elem, data, container);
            if (prop.dynamicProperties.length) prop.getValueAtTime = getTransformValueAtTime.bind(prop);
            else prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop;
        };
        var propertyGetProp = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem, data, type, mult, container) {
            var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop.kf) prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
            else prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
            prop.setGroupProperty = expressionHelpers.setGroupProperty;
            prop.loopOut = loopOut;
            prop.loopIn = loopIn;
            prop.smooth = smooth;
            prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
            prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
            prop.numKeys = data.a === 1 ? data.k.length : 0;
            prop.propertyIndex = data.ix;
            var value = 0;
            if (type !== 0) value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
            prop._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value
            };
            expressionHelpers.searchExpressions(elem, data, prop);
            if (prop.k) container.addDynamicProperty(prop);
            return prop;
        };
        function getShapeValueAtTime(frameNum) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum *= this.elem.globalData.frameRate;
            frameNum -= this.offsetTime;
            if (frameNum !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum;
                this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions() {}
        ShapeExpressions.prototype = {
            vertices: function vertices(prop, time) {
                if (this.k) this.getValue();
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                var i;
                var len = shapePath._length;
                var vertices = shapePath[prop];
                var points = shapePath.v;
                var arr = createSizedArray(len);
                for(i = 0; i < len; i += 1)if (prop === 'i' || prop === 'o') arr[i] = [
                    vertices[i][0] - points[i][0],
                    vertices[i][1] - points[i][1]
                ];
                else arr[i] = [
                    vertices[i][0],
                    vertices[i][1]
                ];
                return arr;
            },
            points: function points(time) {
                return this.vertices('v', time);
            },
            inTangents: function inTangents(time) {
                return this.vertices('i', time);
            },
            outTangents: function outTangents(time) {
                return this.vertices('o', time);
            },
            isClosed: function isClosed() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath(perc, time) {
                var shapePath = this.v;
                if (time !== undefined) shapePath = this.getValueAtTime(time, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath);
                var segmentsLength = this._segmentsLength;
                var lengths = segmentsLength.lengths;
                var lengthPos = segmentsLength.totalLength * perc;
                var i = 0;
                var len = lengths.length;
                var accumulatedLength = 0;
                var pt;
                while(i < len){
                    if (accumulatedLength + lengths[i].addedLength > lengthPos) {
                        var initIndex = i;
                        var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
                        var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
                        pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
                        break;
                    } else accumulatedLength += lengths[i].addedLength;
                    i += 1;
                }
                if (!pt) pt = shapePath.c ? [
                    shapePath.v[0][0],
                    shapePath.v[0][1]
                ] : [
                    shapePath.v[shapePath._length - 1][0],
                    shapePath.v[shapePath._length - 1][1]
                ];
                return pt;
            },
            vectorOnPath: function vectorOnPath(perc, time, vectorType) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc == 1) // eslint-disable-line eqeqeq
                perc = this.v.c;
                else if (perc == 0) // eslint-disable-line eqeqeq
                perc = 0.999;
                var pt1 = this.pointOnPath(perc, time);
                var pt2 = this.pointOnPath(perc + 0.001, time);
                var xLength = pt2[0] - pt1[0];
                var yLength = pt2[1] - pt1[1];
                var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));
                if (magnitude === 0) return [
                    0,
                    0
                ];
                var unitVector = vectorType === 'tangent' ? [
                    xLength / magnitude,
                    yLength / magnitude
                ] : [
                    -yLength / magnitude,
                    xLength / magnitude
                ];
                return unitVector;
            },
            tangentOnPath: function tangentOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'tangent');
            },
            normalOnPath: function normalOnPath(perc, time) {
                return this.vectorOnPath(perc, time, 'normal');
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions
        ], ShapePropertyConstructorFunction);
        extendPrototype([
            ShapeExpressions
        ], KeyframedShapePropertyConstructorFunction);
        KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
        KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem, data, type, arr, trims) {
            var prop = propertyGetShapeProp(elem, data, type, arr, trims);
            prop.propertyIndex = data.ix;
            prop.lock = false;
            if (type === 3) expressionHelpers.searchExpressions(elem, data.pt, prop);
            else if (type === 4) expressionHelpers.searchExpressions(elem, data.ks, prop);
            if (prop.k) elem.addDynamicProperty(prop);
            return prop;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue, text) {
            var newValue = this.calculateExpression(text);
            if (currentValue.t !== newValue) {
                var newData = {};
                this.copyData(newData, currentValue);
                newData.t = newValue.toString();
                newData.__complete = false;
                return newData;
            }
            return currentValue;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed = this.searchKeyframes();
            var hasExpressions = this.searchExpressions();
            this.kf = isKeyframed || hasExpressions;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode(resultId, ins) {
            var feMerge = createNS('feMerge');
            feMerge.setAttribute('result', resultId);
            var feMergeNode;
            var i;
            for(i = 0; i < ins.length; i += 1){
                feMergeNode = createNS('feMergeNode');
                feMergeNode.setAttribute('in', ins[i]);
                feMerge.appendChild(feMergeNode);
                feMerge.appendChild(feMergeNode);
            }
            return feMerge;
        }
    };
    var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';
    function SVGTintFilter(filter, filterManager, elem, id, source) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
        this.linearFilter = feColorMatrix;
        feColorMatrix.setAttribute('result', id + '_tint_1');
        filter.appendChild(feColorMatrix);
        feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id + '_tint_2');
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
        var feMerge = this.createMergeNode(id, [
            source,
            id + '_tint_1',
            id + '_tint_2'
        ]);
        filter.appendChild(feMerge);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var colorBlack = this.filterManager.effectElements[0].p.v;
            var colorWhite = this.filterManager.effectElements[1].p.v;
            var opacity = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
            this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
        }
    };
    function SVGFillFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
        feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
        feColorMatrix.setAttribute('result', id);
        filter.appendChild(feColorMatrix);
        this.matrixFilter = feColorMatrix;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color = this.filterManager.effectElements[2].p.v;
            var opacity = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
        }
    };
    function SVGStrokeEffect(fil, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.elem = elem;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path;
        var groupPath;
        var i;
        var len;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len = this.elem.maskManager.masksProperties.length;
            i = 0;
        } else {
            i = this.filterManager.effectElements[0].p.v - 1;
            len = i + 1;
        }
        groupPath = createNS('g');
        groupPath.setAttribute('fill', 'none');
        groupPath.setAttribute('stroke-linecap', 'round');
        groupPath.setAttribute('stroke-dashoffset', 1);
        for(i; i < len; i += 1){
            path = createNS('path');
            groupPath.appendChild(path);
            this.paths.push({
                p: path,
                m: i
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask = createNS('mask');
            var id = createElementID();
            mask.setAttribute('id', id);
            mask.setAttribute('mask-type', 'alpha');
            mask.appendChild(groupPath);
            this.elem.globalData.defs.appendChild(mask);
            var g = createNS('g');
            g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
            while(elemChildren[0])g.appendChild(elemChildren[0]);
            this.elem.layerElement.appendChild(g);
            this.masker = mask;
            groupPath.setAttribute('stroke', '#fff');
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren.length)this.elem.layerElement.removeChild(elemChildren[0]);
            }
            this.elem.layerElement.appendChild(groupPath);
            this.elem.layerElement.removeAttribute('mask');
            groupPath.setAttribute('stroke', '#fff');
        }
        this.initialized = true;
        this.pathMasker = groupPath;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender) {
        if (!this.initialized) this.initialize();
        var i;
        var len = this.paths.length;
        var mask;
        var path;
        for(i = 0; i < len; i += 1)if (this.paths[i].m !== -1) {
            mask = this.elem.maskManager.viewData[this.paths[i].m];
            path = this.paths[i].p;
            if (forceRender || this.filterManager._mdf || mask.prop._mdf) path.setAttribute('d', mask.lastPath);
            if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
                var dasharrayValue;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l = path.getTotalLength();
                    dasharrayValue = '0 0 0 ' + l * s + ' ';
                    var lineLength = l * (e - s);
                    var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units = Math.floor(lineLength / segment);
                    var j;
                    for(j = 0; j < units; j += 1)dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
                    dasharrayValue += '0 ' + l * 10 + ' 0 0';
                } else dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path.setAttribute('stroke-dasharray', dasharrayValue);
            }
        }
        if (forceRender || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
        if (forceRender || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender || this.filterManager.effectElements[3].p._mdf) {
                var color = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
            }
        }
    };
    function SVGTritoneFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var feColorMatrix = createNS('feColorMatrix');
        feColorMatrix.setAttribute('type', 'matrix');
        feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
        feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
        filter.appendChild(feColorMatrix);
        var feComponentTransfer = createNS('feComponentTransfer');
        feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
        feComponentTransfer.setAttribute('result', id);
        this.matrixFilter = feComponentTransfer;
        var feFuncR = createNS('feFuncR');
        feFuncR.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncR);
        this.feFuncR = feFuncR;
        var feFuncG = createNS('feFuncG');
        feFuncG.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncG);
        this.feFuncG = feFuncG;
        var feFuncB = createNS('feFuncB');
        feFuncB.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFuncB);
        this.feFuncB = feFuncB;
        filter.appendChild(feComponentTransfer);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var color1 = this.filterManager.effectElements[0].p.v;
            var color2 = this.filterManager.effectElements[1].p.v;
            var color3 = this.filterManager.effectElements[2].p.v;
            var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
            var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
            var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
            this.feFuncR.setAttribute('tableValues', tableR);
            this.feFuncG.setAttribute('tableValues', tableG);
            this.feFuncB.setAttribute('tableValues', tableB);
        }
    };
    function SVGProLevelsFilter(filter, filterManager, elem, id) {
        this.filterManager = filterManager;
        var effectElements = this.filterManager.effectElements;
        var feComponentTransfer = createNS('feComponentTransfer'); // Red
        if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
         // Green
        if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
         // Blue
        if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
         // Alpha
        if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            filter.appendChild(feComponentTransfer);
        }
        if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
            feComponentTransfer = createNS('feComponentTransfer');
            feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
            feComponentTransfer.setAttribute('result', id);
            filter.appendChild(feComponentTransfer);
            this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
            this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
            this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
        var feFunc = createNS(type);
        feFunc.setAttribute('type', 'table');
        feComponentTransfer.appendChild(feFunc);
        return feFunc;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
        var cnt = 0;
        var segments = 256;
        var perc;
        var min = Math.min(inputBlack, inputWhite);
        var max = Math.max(inputBlack, inputWhite);
        var table = Array.call(null, {
            length: segments
        });
        var colorValue;
        var pos = 0;
        var outputDelta = outputWhite - outputBlack;
        var inputDelta = inputWhite - inputBlack;
        while(cnt <= 256){
            perc = cnt / 256;
            if (perc <= min) colorValue = inputDelta < 0 ? outputWhite : outputBlack;
            else if (perc >= max) colorValue = inputDelta < 0 ? outputBlack : outputWhite;
            else colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
            table[pos] = colorValue;
            pos += 1;
            cnt += 256 / (segments - 1);
        }
        return table.join(' ');
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            var val;
            var effectElements = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
                val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
                this.feFuncRComposed.setAttribute('tableValues', val);
                this.feFuncGComposed.setAttribute('tableValues', val);
                this.feFuncBComposed.setAttribute('tableValues', val);
            }
            if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
                val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
                this.feFuncR.setAttribute('tableValues', val);
            }
            if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
                val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
                this.feFuncG.setAttribute('tableValues', val);
            }
            if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
                val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
                this.feFuncB.setAttribute('tableValues', val);
            }
            if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
                val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
                this.feFuncA.setAttribute('tableValues', val);
            }
        }
    };
    function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
        var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
        var filterSize = filterManager.data.fs || globalFilterSize;
        filter.setAttribute('x', filterSize.x || globalFilterSize.x);
        filter.setAttribute('y', filterSize.y || globalFilterSize.y);
        filter.setAttribute('width', filterSize.width || globalFilterSize.width);
        filter.setAttribute('height', filterSize.height || globalFilterSize.height);
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('in', 'SourceAlpha');
        feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
        feGaussianBlur.setAttribute('stdDeviation', '0');
        this.feGaussianBlur = feGaussianBlur;
        filter.appendChild(feGaussianBlur);
        var feOffset = createNS('feOffset');
        feOffset.setAttribute('dx', '25');
        feOffset.setAttribute('dy', '0');
        feOffset.setAttribute('in', id + '_drop_shadow_1');
        feOffset.setAttribute('result', id + '_drop_shadow_2');
        this.feOffset = feOffset;
        filter.appendChild(feOffset);
        var feFlood = createNS('feFlood');
        feFlood.setAttribute('flood-color', '#00ff00');
        feFlood.setAttribute('flood-opacity', '1');
        feFlood.setAttribute('result', id + '_drop_shadow_3');
        this.feFlood = feFlood;
        filter.appendChild(feFlood);
        var feComposite = createNS('feComposite');
        feComposite.setAttribute('in', id + '_drop_shadow_3');
        feComposite.setAttribute('in2', id + '_drop_shadow_2');
        feComposite.setAttribute('operator', 'in');
        feComposite.setAttribute('result', id + '_drop_shadow_4');
        filter.appendChild(feComposite);
        var feMerge = this.createMergeNode(id, [
            id + '_drop_shadow_4',
            source
        ]);
        filter.appendChild(feMerge); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            if (forceRender || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
            if (forceRender || this.filterManager.effectElements[0].p._mdf) {
                var col = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
            }
            if (forceRender || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
            if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance = this.filterManager.effectElements[3].p.v;
                var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x = distance * Math.cos(angle);
                var y = distance * Math.sin(angle);
                this.feOffset.setAttribute('dx', x);
                this.feOffset.setAttribute('dy', y);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem, filterManager, elem) {
        this.initialized = false;
        this.filterManager = filterManager;
        this.filterElem = filterElem;
        this.elem = elem;
        elem.matteElement = createNS('g');
        elem.matteElement.appendChild(elem.layerElement);
        elem.matteElement.appendChild(elem.transformedElement);
        elem.baseElement = elem.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask) {
        var i = 0;
        var len = _svgMatteSymbols.length;
        while(i < len){
            if (_svgMatteSymbols[i] === mask) return _svgMatteSymbols[i];
            i += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask, symbolId) {
        var parentNode = mask.layerElement.parentNode;
        if (!parentNode) return;
        var children = parentNode.children;
        var i = 0;
        var len = children.length;
        while(i < len){
            if (children[i] === mask.layerElement) break;
            i += 1;
        }
        var nextChild;
        if (i <= len - 2) nextChild = children[i + 1];
        var useElem = createNS('use');
        useElem.setAttribute('href', '#' + symbolId);
        if (nextChild) parentNode.insertBefore(useElem, nextChild);
        else parentNode.appendChild(useElem);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
        if (!this.findSymbol(mask)) {
            var symbolId = createElementID();
            var masker = createNS('mask');
            masker.setAttribute('id', mask.layerId);
            masker.setAttribute('mask-type', 'alpha');
            _svgMatteSymbols.push(mask);
            var defs = elem.globalData.defs;
            defs.appendChild(masker);
            var symbol = createNS('symbol');
            symbol.setAttribute('id', symbolId);
            this.replaceInParent(mask, symbolId);
            symbol.appendChild(mask.layerElement);
            defs.appendChild(symbol);
            var useElem = createNS('use');
            useElem.setAttribute('href', '#' + symbolId);
            masker.appendChild(useElem);
            mask.data.hd = false;
            mask.show();
        }
        elem.setMatte(mask.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind = this.filterManager.effectElements[0].p.v;
        var elements = this.elem.comp.elements;
        var i = 0;
        var len = elements.length;
        while(i < len){
            if (elements[i] && elements[i].data.ind === ind) this.setElementAsMask(this.elem, elements[i]);
            i += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter.setAttribute('x', '-100%');
        filter.setAttribute('y', '-100%');
        filter.setAttribute('width', '300%');
        filter.setAttribute('height', '300%');
        this.filterManager = filterManager;
        var feGaussianBlur = createNS('feGaussianBlur');
        feGaussianBlur.setAttribute('result', id);
        filter.appendChild(feGaussianBlur);
        this.feGaussianBlur = feGaussianBlur;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender) {
        if (forceRender || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma = 0.3;
            var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions = this.filterManager.effectElements[1].p.v;
            var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq
            var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager) {
        this.effectsManager = effectsManager;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame || this.effectsManager._mdf) {
            var effectElements = this.effectsManager.effectElements;
            var anchor = effectElements[0].p.v;
            var position = effectElements[1].p.v;
            var isUniformScale = effectElements[2].p.v === 1;
            var scaleHeight = effectElements[3].p.v;
            var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
            var skew = effectElements[5].p.v;
            var skewAxis = effectElements[6].p.v;
            var rotation = effectElements[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
            this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
            this.matrix.rotate(-rotation * degToRads);
            this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
            this.matrix.translate(position[0], position[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements[8].p.v) {
                this.opacity = effectElements[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_, filterManager) {
        this.init(filterManager);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager) {
        this.init(effectsManager);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer('canvas', CanvasRenderer);
    registerRenderer('html', HybridRenderer);
    registerRenderer('svg', SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier('tm', TrimModifier);
    ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
    ShapeModifiers.registerModifier('rp', RepeaterModifier);
    ShapeModifiers.registerModifier('rd', RoundCornersModifier);
    ShapeModifiers.registerModifier('zz', ZigZagModifier);
    ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRegister("8tsi7", function(module, exports) {
function $62b6fa32bf2920ff$var$_extends() {
    return module.exports = $62b6fa32bf2920ff$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $62b6fa32bf2920ff$var$_extends.apply(null, arguments);
}
module.exports = $62b6fa32bf2920ff$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("68UY6", function(module, exports) {
function $478fae26ff98c896$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $478fae26ff98c896$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eFJGi", function(module, exports) {

var $2jpDk = parcelRequire("2jpDk");

var $1GoSn = parcelRequire("1GoSn");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $2jpDk.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1GoSn;
module.exports = isBuffer;

});
parcelRegister("2jpDk", function(module, exports) {

var $korbf = parcelRequire("korbf");
/** Detect free variable `self`. */ var $1af13d63009a4839$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1af13d63009a4839$var$root = $korbf || $1af13d63009a4839$var$freeSelf || Function('return this')();
module.exports = $1af13d63009a4839$var$root;

});
parcelRegister("korbf", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ed8b21fcd2e725e3$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ed8b21fcd2e725e3$var$freeGlobal;

});


parcelRegister("1GoSn", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $139d02900740a52b$var$stubFalse() {
    return false;
}
module.exports = $139d02900740a52b$var$stubFalse;

});


parcelRegister("1cz3N", function(module, exports) {

var $korbf = parcelRequire("korbf");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $korbf.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("gdOjy", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $bcf4e3a3a1d5e159$export$a7c73072b1a182ae; }, function (v) { return $bcf4e3a3a1d5e159$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bcf4e3a3a1d5e159$export$9f27bc3417b4524d; }, function (v) { return $bcf4e3a3a1d5e159$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac; }, function (v) { return $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35; }, function (v) { return $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bcf4e3a3a1d5e159$export$ffb0004e005737fa; }, function (v) { return $bcf4e3a3a1d5e159$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bcf4e3a3a1d5e159$export$b624eff549462981; }, function (v) { return $bcf4e3a3a1d5e159$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bcf4e3a3a1d5e159$export$7897aa7841a5380c; }, function (v) { return $bcf4e3a3a1d5e159$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bcf4e3a3a1d5e159$export$602eac185826482c; }, function (v) { return $bcf4e3a3a1d5e159$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bcf4e3a3a1d5e159$export$e2c29f18771995cb; }, function (v) { return $bcf4e3a3a1d5e159$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bcf4e3a3a1d5e159$export$5f8d39834fd61797; }, function (v) { return $bcf4e3a3a1d5e159$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5; }, function (v) { return $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $bcf4e3a3a1d5e159$export$998bcd577473dd93; }, function (v) { return $bcf4e3a3a1d5e159$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bcf4e3a3a1d5e159$export$92387174baf9b227; }, function (v) { return $bcf4e3a3a1d5e159$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bcf4e3a3a1d5e159$export$ec112efeb987d9c6; }, function (v) { return $bcf4e3a3a1d5e159$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bcf4e3a3a1d5e159$export$b706b080d889d2c9; }, function (v) { return $bcf4e3a3a1d5e159$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bcf4e3a3a1d5e159$export$5be5a87408f70ddc; }, function (v) { return $bcf4e3a3a1d5e159$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d; }, function (v) { return $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bcf4e3a3a1d5e159$export$455c2e768291efa6; }, function (v) { return $bcf4e3a3a1d5e159$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bcf4e3a3a1d5e159$export$9522e17588c12572; }, function (v) { return $bcf4e3a3a1d5e159$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bcf4e3a3a1d5e159$export$2110ac352bb060b9; }, function (v) { return $bcf4e3a3a1d5e159$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bcf4e3a3a1d5e159$export$56885ab8b9c456ab; }, function (v) { return $bcf4e3a3a1d5e159$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de; }, function (v) { return $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bcf4e3a3a1d5e159$export$b82d16f27459e05a; }, function (v) { return $bcf4e3a3a1d5e159$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bcf4e3a3a1d5e159$export$522c17b4f5e123e8; }, function (v) { return $bcf4e3a3a1d5e159$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6; }, function (v) { return $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $bcf4e3a3a1d5e159$export$3d6c20d97e46b957; }, function (v) { return $bcf4e3a3a1d5e159$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bcf4e3a3a1d5e159$export$9b621391a187a31a; }, function (v) { return $bcf4e3a3a1d5e159$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f; }, function (v) { return $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcf4e3a3a1d5e159$export$a7c73072b1a182ae;
var $bcf4e3a3a1d5e159$export$9f27bc3417b4524d;
var $bcf4e3a3a1d5e159$export$db77ccec0bb4ccac;
var $bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35;
var $bcf4e3a3a1d5e159$export$ffb0004e005737fa;
var $bcf4e3a3a1d5e159$export$b624eff549462981;
var $bcf4e3a3a1d5e159$export$7897aa7841a5380c;
var $bcf4e3a3a1d5e159$export$602eac185826482c;
var $bcf4e3a3a1d5e159$export$e2c29f18771995cb;
var $bcf4e3a3a1d5e159$export$5f8d39834fd61797;
var $bcf4e3a3a1d5e159$export$74bf444e3cd11ea5;
var $bcf4e3a3a1d5e159$export$998bcd577473dd93;
var $bcf4e3a3a1d5e159$export$92387174baf9b227;
var $bcf4e3a3a1d5e159$export$ec112efeb987d9c6;
var $bcf4e3a3a1d5e159$export$b706b080d889d2c9;
var $bcf4e3a3a1d5e159$export$5be5a87408f70ddc;
var $bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d;
var $bcf4e3a3a1d5e159$export$455c2e768291efa6;
var $bcf4e3a3a1d5e159$export$9522e17588c12572;
var $bcf4e3a3a1d5e159$export$2110ac352bb060b9;
var $bcf4e3a3a1d5e159$export$56885ab8b9c456ab;
var $bcf4e3a3a1d5e159$export$d927fcb6adf8f9de;
var $bcf4e3a3a1d5e159$export$b82d16f27459e05a;
var $bcf4e3a3a1d5e159$export$522c17b4f5e123e8;
var $bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6;
var $bcf4e3a3a1d5e159$export$3d6c20d97e46b957;
var $bcf4e3a3a1d5e159$export$9b621391a187a31a;
var $bcf4e3a3a1d5e159$export$f5bbd400c2f4426f;
'use strict';
var $bcf4e3a3a1d5e159$var$b = Symbol.for("react.element"), $bcf4e3a3a1d5e159$var$c = Symbol.for("react.portal"), $bcf4e3a3a1d5e159$var$d = Symbol.for("react.fragment"), $bcf4e3a3a1d5e159$var$e = Symbol.for("react.strict_mode"), $bcf4e3a3a1d5e159$var$f = Symbol.for("react.profiler"), $bcf4e3a3a1d5e159$var$g = Symbol.for("react.provider"), $bcf4e3a3a1d5e159$var$h = Symbol.for("react.context"), $bcf4e3a3a1d5e159$var$k = Symbol.for("react.server_context"), $bcf4e3a3a1d5e159$var$l = Symbol.for("react.forward_ref"), $bcf4e3a3a1d5e159$var$m = Symbol.for("react.suspense"), $bcf4e3a3a1d5e159$var$n = Symbol.for("react.suspense_list"), $bcf4e3a3a1d5e159$var$p = Symbol.for("react.memo"), $bcf4e3a3a1d5e159$var$q = Symbol.for("react.lazy"), $bcf4e3a3a1d5e159$var$t = Symbol.for("react.offscreen"), $bcf4e3a3a1d5e159$var$u;
$bcf4e3a3a1d5e159$var$u = Symbol.for("react.module.reference");
function $bcf4e3a3a1d5e159$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $bcf4e3a3a1d5e159$var$b:
                switch(a = a.type, a){
                    case $bcf4e3a3a1d5e159$var$d:
                    case $bcf4e3a3a1d5e159$var$f:
                    case $bcf4e3a3a1d5e159$var$e:
                    case $bcf4e3a3a1d5e159$var$m:
                    case $bcf4e3a3a1d5e159$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bcf4e3a3a1d5e159$var$k:
                            case $bcf4e3a3a1d5e159$var$h:
                            case $bcf4e3a3a1d5e159$var$l:
                            case $bcf4e3a3a1d5e159$var$q:
                            case $bcf4e3a3a1d5e159$var$p:
                            case $bcf4e3a3a1d5e159$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $bcf4e3a3a1d5e159$var$c:
                return r;
        }
    }
}
$bcf4e3a3a1d5e159$export$a7c73072b1a182ae = $bcf4e3a3a1d5e159$var$h;
$bcf4e3a3a1d5e159$export$9f27bc3417b4524d = $bcf4e3a3a1d5e159$var$g;
$bcf4e3a3a1d5e159$export$db77ccec0bb4ccac = $bcf4e3a3a1d5e159$var$b;
$bcf4e3a3a1d5e159$export$8392c0c9d3dcbd35 = $bcf4e3a3a1d5e159$var$l;
$bcf4e3a3a1d5e159$export$ffb0004e005737fa = $bcf4e3a3a1d5e159$var$d;
$bcf4e3a3a1d5e159$export$b624eff549462981 = $bcf4e3a3a1d5e159$var$q;
$bcf4e3a3a1d5e159$export$7897aa7841a5380c = $bcf4e3a3a1d5e159$var$p;
$bcf4e3a3a1d5e159$export$602eac185826482c = $bcf4e3a3a1d5e159$var$c;
$bcf4e3a3a1d5e159$export$e2c29f18771995cb = $bcf4e3a3a1d5e159$var$f;
$bcf4e3a3a1d5e159$export$5f8d39834fd61797 = $bcf4e3a3a1d5e159$var$e;
$bcf4e3a3a1d5e159$export$74bf444e3cd11ea5 = $bcf4e3a3a1d5e159$var$m;
$bcf4e3a3a1d5e159$export$998bcd577473dd93 = $bcf4e3a3a1d5e159$var$n;
$bcf4e3a3a1d5e159$export$92387174baf9b227 = function() {
    return !1;
};
$bcf4e3a3a1d5e159$export$ec112efeb987d9c6 = function() {
    return !1;
};
$bcf4e3a3a1d5e159$export$b706b080d889d2c9 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$h;
};
$bcf4e3a3a1d5e159$export$5be5a87408f70ddc = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$g;
};
$bcf4e3a3a1d5e159$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bcf4e3a3a1d5e159$var$b;
};
$bcf4e3a3a1d5e159$export$455c2e768291efa6 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$l;
};
$bcf4e3a3a1d5e159$export$9522e17588c12572 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$d;
};
$bcf4e3a3a1d5e159$export$2110ac352bb060b9 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$q;
};
$bcf4e3a3a1d5e159$export$56885ab8b9c456ab = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$p;
};
$bcf4e3a3a1d5e159$export$d927fcb6adf8f9de = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$c;
};
$bcf4e3a3a1d5e159$export$b82d16f27459e05a = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$f;
};
$bcf4e3a3a1d5e159$export$522c17b4f5e123e8 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$e;
};
$bcf4e3a3a1d5e159$export$1aabd8a0274ecfd6 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$m;
};
$bcf4e3a3a1d5e159$export$3d6c20d97e46b957 = function(a) {
    return $bcf4e3a3a1d5e159$var$v(a) === $bcf4e3a3a1d5e159$var$n;
};
$bcf4e3a3a1d5e159$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bcf4e3a3a1d5e159$var$d || a === $bcf4e3a3a1d5e159$var$f || a === $bcf4e3a3a1d5e159$var$e || a === $bcf4e3a3a1d5e159$var$m || a === $bcf4e3a3a1d5e159$var$n || a === $bcf4e3a3a1d5e159$var$t || "object" === typeof a && null !== a && (a.$$typeof === $bcf4e3a3a1d5e159$var$q || a.$$typeof === $bcf4e3a3a1d5e159$var$p || a.$$typeof === $bcf4e3a3a1d5e159$var$g || a.$$typeof === $bcf4e3a3a1d5e159$var$h || a.$$typeof === $bcf4e3a3a1d5e159$var$l || a.$$typeof === $bcf4e3a3a1d5e159$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$bcf4e3a3a1d5e159$export$f5bbd400c2f4426f = $bcf4e3a3a1d5e159$var$v;

});

parcelRegister("1xE3P", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("2HnWZ"));

});
parcelRegister("2HnWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $1f722cf5b9592b65$var$_tickFormat.default;
    }
});

var $1f722cf5b9592b65$var$_band = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("bvS2B")));

var $1f722cf5b9592b65$var$_identity = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("j15Sh")));

var $1f722cf5b9592b65$var$_linear = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("8cBoe")));

var $1f722cf5b9592b65$var$_log = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("cw7m0")));

var $1f722cf5b9592b65$var$_symlog = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("3DXgb")));

var $1f722cf5b9592b65$var$_ordinal = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("1gB5A")));

var $1f722cf5b9592b65$var$_pow = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("6kjWv")));

var $1f722cf5b9592b65$var$_radial = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("kwNoN")));

var $1f722cf5b9592b65$var$_quantile = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("kEBaY")));

var $1f722cf5b9592b65$var$_quantize = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("5prmo")));

var $1f722cf5b9592b65$var$_threshold = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("81sXE")));

var $1f722cf5b9592b65$var$_time = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("3lv9c")));

var $1f722cf5b9592b65$var$_utcTime = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("k0gY2")));

var $1f722cf5b9592b65$var$_sequential = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("bo5gu")));

var $1f722cf5b9592b65$var$_sequentialQuantile = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("5yyjd")));

var $1f722cf5b9592b65$var$_diverging = $1f722cf5b9592b65$var$_interopRequireWildcard((parcelRequire("8db3Z")));

var $1f722cf5b9592b65$var$_tickFormat = $1f722cf5b9592b65$var$_interopRequireDefault((parcelRequire("lIlUJ")));
function $1f722cf5b9592b65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1f722cf5b9592b65$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1f722cf5b9592b65$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1f722cf5b9592b65$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1f722cf5b9592b65$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("bvS2B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $861c825ee7e3af72$var$band;
module.exports.point = $861c825ee7e3af72$var$point;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");

var $861c825ee7e3af72$var$_ordinal = $861c825ee7e3af72$var$_interopRequireDefault((parcelRequire("1gB5A")));
function $861c825ee7e3af72$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $861c825ee7e3af72$var$band() {
    var scale = (0, $861c825ee7e3af72$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $dfXar.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $861c825ee7e3af72$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $ezRKk.initRange.apply(rescale(), arguments);
}
function $861c825ee7e3af72$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $861c825ee7e3af72$var$pointish(copy());
    };
    return scale;
}
function $861c825ee7e3af72$var$point() {
    return $861c825ee7e3af72$var$pointish($861c825ee7e3af72$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("dfXar", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $iw00b.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $6CV6g.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $6CV6g.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $iw00b.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $iw00b.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $9a6a927f65e252c9$var$_zip.default;
    }
});

var $9a6a927f65e252c9$var$_bisect = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("jZZ2P")));

var $9a6a927f65e252c9$var$_ascending = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $9a6a927f65e252c9$var$_bisector = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("efFsa")));

var $9a6a927f65e252c9$var$_count = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $9a6a927f65e252c9$var$_cross = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("id5o0")));

var $9a6a927f65e252c9$var$_cumsum = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hMTdA")));

var $9a6a927f65e252c9$var$_descending = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("be4nB")));

var $9a6a927f65e252c9$var$_deviation = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("e0UhK")));

var $9a6a927f65e252c9$var$_extent = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("3oElc")));

var $iw00b = parcelRequire("iw00b");

var $9a6a927f65e252c9$var$_group = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("lJvvG")));

var $9a6a927f65e252c9$var$_groupSort = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("4EzfP")));

var $9a6a927f65e252c9$var$_bin = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hWMrk")));

var $9a6a927f65e252c9$var$_freedmanDiaconis = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5jkYP")));

var $9a6a927f65e252c9$var$_scott = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("6h57H")));

var $9a6a927f65e252c9$var$_sturges = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5A7VI")));

var $9a6a927f65e252c9$var$_max = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("93DHJ")));

var $9a6a927f65e252c9$var$_maxIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("dpxdx")));

var $9a6a927f65e252c9$var$_mean = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gd94P")));

var $9a6a927f65e252c9$var$_median = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("b3KGp")));

var $9a6a927f65e252c9$var$_merge = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("3wDu6")));

var $9a6a927f65e252c9$var$_min = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5oxpw")));

var $9a6a927f65e252c9$var$_minIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("32tGX")));

var $9a6a927f65e252c9$var$_mode = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gnR5I")));

var $9a6a927f65e252c9$var$_nice = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("fBuXZ")));

var $9a6a927f65e252c9$var$_pairs = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("fPkBn")));

var $9a6a927f65e252c9$var$_permute = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("e5pcB")));

var $9a6a927f65e252c9$var$_quantile = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("hSQ1l")));

var $9a6a927f65e252c9$var$_quickselect = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("l37BJ")));

var $9a6a927f65e252c9$var$_range = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("8b7pK")));

var $9a6a927f65e252c9$var$_rank = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("ejl42")));

var $9a6a927f65e252c9$var$_least = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("lw8Kx")));

var $9a6a927f65e252c9$var$_leastIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("7mLIh")));

var $9a6a927f65e252c9$var$_greatest = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("5NlUE")));

var $9a6a927f65e252c9$var$_greatestIndex = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("eUrJc")));

var $9a6a927f65e252c9$var$_scan = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kbw85")));

var $9a6a927f65e252c9$var$_shuffle = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("33B7C")));

var $9a6a927f65e252c9$var$_sum = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("i2FN5")));

var $9a6a927f65e252c9$var$_ticks = $9a6a927f65e252c9$var$_interopRequireWildcard((parcelRequire("ctWaE")));

var $9a6a927f65e252c9$var$_transpose = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("evd6D")));

var $9a6a927f65e252c9$var$_variance = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kFyIt")));

var $9a6a927f65e252c9$var$_zip = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("jWis9")));

var $9a6a927f65e252c9$var$_every = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("joCtP")));

var $9a6a927f65e252c9$var$_some = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("kDNkv")));

var $9a6a927f65e252c9$var$_filter = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("h8ZUA")));

var $9a6a927f65e252c9$var$_map = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("6LTkM")));

var $9a6a927f65e252c9$var$_reduce = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("lIMEs")));

var $9a6a927f65e252c9$var$_reverse = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("hkpgI")));

var $9a6a927f65e252c9$var$_sort = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("cZZyC")));

var $9a6a927f65e252c9$var$_difference = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("2pqEM")));

var $9a6a927f65e252c9$var$_disjoint = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("h2zcH")));

var $9a6a927f65e252c9$var$_intersection = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("aAVLd")));

var $9a6a927f65e252c9$var$_subset = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("11x46")));

var $9a6a927f65e252c9$var$_superset = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("l2doT")));

var $9a6a927f65e252c9$var$_union = $9a6a927f65e252c9$var$_interopRequireDefault((parcelRequire("gsNLm")));

var $6CV6g = parcelRequire("6CV6g");
function $9a6a927f65e252c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9a6a927f65e252c9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($9a6a927f65e252c9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $9a6a927f65e252c9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $9a6a927f65e252c9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("jZZ2P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $e8f31103441a5e2f$var$_ascending = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $e8f31103441a5e2f$var$_bisector = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("efFsa")));

var $e8f31103441a5e2f$var$_number = $e8f31103441a5e2f$var$_interopRequireDefault((parcelRequire("2mZc8")));
function $e8f31103441a5e2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e8f31103441a5e2f$var$ascendingBisect = (0, $e8f31103441a5e2f$var$_bisector.default)($e8f31103441a5e2f$var$_ascending.default);
const $e8f31103441a5e2f$var$bisectRight = $e8f31103441a5e2f$var$ascendingBisect.right;
module.exports.bisectRight = $e8f31103441a5e2f$var$bisectRight;
const $e8f31103441a5e2f$var$bisectLeft = $e8f31103441a5e2f$var$ascendingBisect.left;
module.exports.bisectLeft = $e8f31103441a5e2f$var$bisectLeft;
const $e8f31103441a5e2f$var$bisectCenter = (0, $e8f31103441a5e2f$var$_bisector.default)($e8f31103441a5e2f$var$_number.default).center;
module.exports.bisectCenter = $e8f31103441a5e2f$var$bisectCenter;
var $e8f31103441a5e2f$var$_default = $e8f31103441a5e2f$var$bisectRight;
module.exports.default = $e8f31103441a5e2f$var$_default;

});
parcelRegister("2WR5G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $225a2e403c3a7b10$var$ascending;
function $225a2e403c3a7b10$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("efFsa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6029f2bb71ed739$var$bisector;

var $a6029f2bb71ed739$var$_ascending = $a6029f2bb71ed739$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $a6029f2bb71ed739$var$_descending = $a6029f2bb71ed739$var$_interopRequireDefault((parcelRequire("be4nB")));
function $a6029f2bb71ed739$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6029f2bb71ed739$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $a6029f2bb71ed739$var$_ascending.default;
        compare2 = (d, x)=>(0, $a6029f2bb71ed739$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $a6029f2bb71ed739$var$_ascending.default || f === $a6029f2bb71ed739$var$_descending.default ? f : $a6029f2bb71ed739$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $a6029f2bb71ed739$var$zero() {
    return 0;
}

});
parcelRegister("be4nB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82c4663b6dc1fe62$var$descending;
function $82c4663b6dc1fe62$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("2mZc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b9d1ad9e2381454$var$number;
module.exports.numbers = $1b9d1ad9e2381454$var$numbers;
function $1b9d1ad9e2381454$var$number(x) {
    return x === null ? NaN : +x;
}
function* $1b9d1ad9e2381454$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("jRmQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e754affe87dcf7a5$var$count;
function $e754affe87dcf7a5$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("id5o0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d41d9e7dd7cdf881$var$cross;
function $d41d9e7dd7cdf881$var$length(array) {
    return array.length | 0;
}
function $d41d9e7dd7cdf881$var$empty(length) {
    return !(length > 0);
}
function $d41d9e7dd7cdf881$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $d41d9e7dd7cdf881$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $d41d9e7dd7cdf881$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $d41d9e7dd7cdf881$var$reducer(values.pop());
    values = values.map($d41d9e7dd7cdf881$var$arrayify);
    const lengths = values.map($d41d9e7dd7cdf881$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($d41d9e7dd7cdf881$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("hMTdA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf31c08bb05fdd8c$var$cumsum;
function $cf31c08bb05fdd8c$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("e0UhK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a33cb9d6c4f61289$var$deviation;

var $a33cb9d6c4f61289$var$_variance = $a33cb9d6c4f61289$var$_interopRequireDefault((parcelRequire("kFyIt")));
function $a33cb9d6c4f61289$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a33cb9d6c4f61289$var$deviation(values, valueof) {
    const v = (0, $a33cb9d6c4f61289$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("kFyIt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f0c290f0737e21f3$var$variance;
function $f0c290f0737e21f3$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("3oElc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2792e7e121315c6e$var$extent;
function $2792e7e121315c6e$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("iw00b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $d7ab37905438cdae$var$fcumsum;
module.exports.fsum = $d7ab37905438cdae$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $d7ab37905438cdae$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $d7ab37905438cdae$var$Adder;
function $d7ab37905438cdae$var$fsum(values, valueof) {
    const adder = new $d7ab37905438cdae$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $d7ab37905438cdae$var$fcumsum(values, valueof) {
    const adder = new $d7ab37905438cdae$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("lJvvG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd263e28b3318028$var$group;
module.exports.flatGroup = $fd263e28b3318028$var$flatGroup;
module.exports.flatRollup = $fd263e28b3318028$var$flatRollup;
module.exports.groups = $fd263e28b3318028$var$groups;
module.exports.index = $fd263e28b3318028$var$index;
module.exports.indexes = $fd263e28b3318028$var$indexes;
module.exports.rollup = $fd263e28b3318028$var$rollup;
module.exports.rollups = $fd263e28b3318028$var$rollups;

var $6CV6g = parcelRequire("6CV6g");

var $fd263e28b3318028$var$_identity = $fd263e28b3318028$var$_interopRequireDefault((parcelRequire("8PKsP")));
function $fd263e28b3318028$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fd263e28b3318028$var$group(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, $fd263e28b3318028$var$_identity.default, keys);
}
function $fd263e28b3318028$var$groups(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, $fd263e28b3318028$var$_identity.default, keys);
}
function $fd263e28b3318028$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $fd263e28b3318028$var$flatGroup(values, ...keys) {
    return $fd263e28b3318028$var$flatten($fd263e28b3318028$var$groups(values, ...keys), keys);
}
function $fd263e28b3318028$var$flatRollup(values, reduce, ...keys) {
    return $fd263e28b3318028$var$flatten($fd263e28b3318028$var$rollups(values, reduce, ...keys), keys);
}
function $fd263e28b3318028$var$rollup(values, reduce, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, reduce, keys);
}
function $fd263e28b3318028$var$rollups(values, reduce, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, reduce, keys);
}
function $fd263e28b3318028$var$index(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, $fd263e28b3318028$var$_identity.default, $fd263e28b3318028$var$unique, keys);
}
function $fd263e28b3318028$var$indexes(values, ...keys) {
    return $fd263e28b3318028$var$nest(values, Array.from, $fd263e28b3318028$var$unique, keys);
}
function $fd263e28b3318028$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $fd263e28b3318028$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $6CV6g.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("6CV6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $4d3295934c897a36$var$InternMap extends Map {
    constructor(entries, key = $4d3295934c897a36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($4d3295934c897a36$var$intern_get(this, key));
    }
    has(key) {
        return super.has($4d3295934c897a36$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($4d3295934c897a36$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($4d3295934c897a36$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $4d3295934c897a36$var$InternMap;
class $4d3295934c897a36$var$InternSet extends Set {
    constructor(values, key = $4d3295934c897a36$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($4d3295934c897a36$var$intern_get(this, value));
    }
    add(value) {
        return super.add($4d3295934c897a36$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($4d3295934c897a36$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $4d3295934c897a36$var$InternSet;
function $4d3295934c897a36$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $4d3295934c897a36$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $4d3295934c897a36$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $4d3295934c897a36$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("8PKsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $66e720f0f3dbb675$var$identity;
function $66e720f0f3dbb675$var$identity(x) {
    return x;
}

});


parcelRegister("4EzfP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $36363e9a0d3b50bf$var$groupSort;

var $36363e9a0d3b50bf$var$_ascending = $36363e9a0d3b50bf$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $36363e9a0d3b50bf$var$_group = $36363e9a0d3b50bf$var$_interopRequireWildcard((parcelRequire("lJvvG")));

var $36363e9a0d3b50bf$var$_sort = $36363e9a0d3b50bf$var$_interopRequireDefault((parcelRequire("cZZyC")));
function $36363e9a0d3b50bf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36363e9a0d3b50bf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36363e9a0d3b50bf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36363e9a0d3b50bf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $36363e9a0d3b50bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $36363e9a0d3b50bf$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $36363e9a0d3b50bf$var$_sort.default)((0, $36363e9a0d3b50bf$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $36363e9a0d3b50bf$var$_ascending.default)(av, bv) || (0, $36363e9a0d3b50bf$var$_ascending.default)(ak, bk)) : (0, $36363e9a0d3b50bf$var$_sort.default)((0, $36363e9a0d3b50bf$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $36363e9a0d3b50bf$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("cZZyC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $976aee89c8a80726$var$ascendingDefined;
module.exports.compareDefined = $976aee89c8a80726$var$compareDefined;
module.exports.default = $976aee89c8a80726$var$sort;

var $976aee89c8a80726$var$_ascending = $976aee89c8a80726$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $976aee89c8a80726$var$_permute = $976aee89c8a80726$var$_interopRequireDefault((parcelRequire("e5pcB")));
function $976aee89c8a80726$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $976aee89c8a80726$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $976aee89c8a80726$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$976aee89c8a80726$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $976aee89c8a80726$var$_permute.default)(values, index);
    }
    return values.sort($976aee89c8a80726$var$compareDefined(f));
}
function $976aee89c8a80726$var$compareDefined(compare = $976aee89c8a80726$var$_ascending.default) {
    if (compare === $976aee89c8a80726$var$_ascending.default) return $976aee89c8a80726$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $976aee89c8a80726$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("e5pcB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a41514f09fa09243$var$permute;
function $a41514f09fa09243$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("hWMrk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d10d6d99ee20fb61$var$bin;

var $5OlV7 = parcelRequire("5OlV7");

var $d10d6d99ee20fb61$var$_bisect = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("jZZ2P")));

var $d10d6d99ee20fb61$var$_constant = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("038iY")));

var $d10d6d99ee20fb61$var$_extent = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("3oElc")));

var $d10d6d99ee20fb61$var$_identity = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("8PKsP")));

var $d10d6d99ee20fb61$var$_nice = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("fBuXZ")));

var $d10d6d99ee20fb61$var$_ticks = $d10d6d99ee20fb61$var$_interopRequireWildcard((parcelRequire("ctWaE")));

var $d10d6d99ee20fb61$var$_sturges = $d10d6d99ee20fb61$var$_interopRequireDefault((parcelRequire("5A7VI")));
function $d10d6d99ee20fb61$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d10d6d99ee20fb61$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d10d6d99ee20fb61$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d10d6d99ee20fb61$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d10d6d99ee20fb61$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d10d6d99ee20fb61$var$bin() {
    var value = $d10d6d99ee20fb61$var$_identity.default, domain = $d10d6d99ee20fb61$var$_extent.default, threshold = $d10d6d99ee20fb61$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $d10d6d99ee20fb61$var$_extent.default) [x0, x1] = (0, $d10d6d99ee20fb61$var$_nice.default)(x0, x1, tn);
            tz = (0, $d10d6d99ee20fb61$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $d10d6d99ee20fb61$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $d10d6d99ee20fb61$var$_extent.default) {
                    const step = (0, $d10d6d99ee20fb61$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $d10d6d99ee20fb61$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $d10d6d99ee20fb61$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $d10d6d99ee20fb61$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $d10d6d99ee20fb61$var$_constant.default)($5OlV7.slice.call(_)) : (0, $d10d6d99ee20fb61$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("5OlV7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $43b2a032763efd3e$var$array = Array.prototype;
var $43b2a032763efd3e$var$slice = $43b2a032763efd3e$var$array.slice;
module.exports.slice = $43b2a032763efd3e$var$slice;
var $43b2a032763efd3e$var$map = $43b2a032763efd3e$var$array.map;
module.exports.map = $43b2a032763efd3e$var$map;

});

parcelRegister("038iY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0096b91f09323471$var$constant;
function $0096b91f09323471$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("fBuXZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5c25505cb2d4c7c$var$nice;

var $ctWaE = parcelRequire("ctWaE");
function $b5c25505cb2d4c7c$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $ctWaE.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("ctWaE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $916550fbad5b6b79$var$ticks;
module.exports.tickIncrement = $916550fbad5b6b79$var$tickIncrement;
module.exports.tickStep = $916550fbad5b6b79$var$tickStep;
var $916550fbad5b6b79$var$e10 = Math.sqrt(50), $916550fbad5b6b79$var$e5 = Math.sqrt(10), $916550fbad5b6b79$var$e2 = Math.sqrt(2);
function $916550fbad5b6b79$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $916550fbad5b6b79$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $916550fbad5b6b79$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $916550fbad5b6b79$var$e10 ? 10 : error >= $916550fbad5b6b79$var$e5 ? 5 : error >= $916550fbad5b6b79$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $916550fbad5b6b79$var$e10 ? 10 : error >= $916550fbad5b6b79$var$e5 ? 5 : error >= $916550fbad5b6b79$var$e2 ? 2 : 1);
}
function $916550fbad5b6b79$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $916550fbad5b6b79$var$e10) step1 *= 10;
    else if (error >= $916550fbad5b6b79$var$e5) step1 *= 5;
    else if (error >= $916550fbad5b6b79$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("5A7VI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4106773f512b7812$var$thresholdSturges;

var $4106773f512b7812$var$_count = $4106773f512b7812$var$_interopRequireDefault((parcelRequire("jRmQq")));
function $4106773f512b7812$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4106773f512b7812$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $4106773f512b7812$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("5jkYP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ddf0055491303c5$var$thresholdFreedmanDiaconis;

var $3ddf0055491303c5$var$_count = $3ddf0055491303c5$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $3ddf0055491303c5$var$_quantile = $3ddf0055491303c5$var$_interopRequireDefault((parcelRequire("hSQ1l")));
function $3ddf0055491303c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3ddf0055491303c5$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $3ddf0055491303c5$var$_quantile.default)(values, 0.75) - (0, $3ddf0055491303c5$var$_quantile.default)(values, 0.25)) * Math.pow((0, $3ddf0055491303c5$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("hSQ1l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d04fd50f01c50432$var$quantile;
module.exports.quantileSorted = $d04fd50f01c50432$var$quantileSorted;

var $d04fd50f01c50432$var$_max = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("93DHJ")));

var $d04fd50f01c50432$var$_min = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("5oxpw")));

var $d04fd50f01c50432$var$_quickselect = $d04fd50f01c50432$var$_interopRequireDefault((parcelRequire("l37BJ")));

var $d04fd50f01c50432$var$_number = $d04fd50f01c50432$var$_interopRequireWildcard((parcelRequire("2mZc8")));
function $d04fd50f01c50432$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d04fd50f01c50432$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d04fd50f01c50432$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d04fd50f01c50432$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d04fd50f01c50432$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d04fd50f01c50432$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $d04fd50f01c50432$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $d04fd50f01c50432$var$_min.default)(values);
    if (p >= 1) return (0, $d04fd50f01c50432$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $d04fd50f01c50432$var$_max.default)((0, $d04fd50f01c50432$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $d04fd50f01c50432$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $d04fd50f01c50432$var$quantileSorted(values, p, valueof = $d04fd50f01c50432$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("93DHJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6983314ea78cc412$var$max;
function $6983314ea78cc412$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("5oxpw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ed91c5101d92ca4$var$min;
function $3ed91c5101d92ca4$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("l37BJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f52fc783328d31e1$var$quickselect;

var $cZZyC = parcelRequire("cZZyC");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $f52fc783328d31e1$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $cZZyC.ascendingDefined : (0, $cZZyC.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $f52fc783328d31e1$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $f52fc783328d31e1$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $f52fc783328d31e1$var$swap(array, left, right);
        while(i < j){
            $f52fc783328d31e1$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $f52fc783328d31e1$var$swap(array, left, j);
        else ++j, $f52fc783328d31e1$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $f52fc783328d31e1$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("6h57H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49184df91bb832ea$var$thresholdScott;

var $49184df91bb832ea$var$_count = $49184df91bb832ea$var$_interopRequireDefault((parcelRequire("jRmQq")));

var $49184df91bb832ea$var$_deviation = $49184df91bb832ea$var$_interopRequireDefault((parcelRequire("e0UhK")));
function $49184df91bb832ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49184df91bb832ea$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $49184df91bb832ea$var$_count.default)(values)) / (3.49 * (0, $49184df91bb832ea$var$_deviation.default)(values)));
}

});

parcelRegister("dpxdx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9c376075ebb6a51b$var$maxIndex;
function $9c376075ebb6a51b$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("gd94P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bcd4e6b596f612b9$var$mean;
function $bcd4e6b596f612b9$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("b3KGp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $80d42fd1adcb0cb1$var$median;

var $80d42fd1adcb0cb1$var$_quantile = $80d42fd1adcb0cb1$var$_interopRequireDefault((parcelRequire("hSQ1l")));
function $80d42fd1adcb0cb1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $80d42fd1adcb0cb1$var$median(values, valueof) {
    return (0, $80d42fd1adcb0cb1$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("3wDu6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2912fd0b93b9b84d$var$merge;
function* $2912fd0b93b9b84d$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $2912fd0b93b9b84d$var$merge(arrays) {
    return Array.from($2912fd0b93b9b84d$var$flatten(arrays));
}

});

parcelRegister("32tGX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $236897329b327d67$var$minIndex;
function $236897329b327d67$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("gnR5I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bed7fa1effd47853$var$mode;

var $6CV6g = parcelRequire("6CV6g");
function $bed7fa1effd47853$var$mode(values, valueof) {
    const counts = new $6CV6g.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("fPkBn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b85b998e40179317$var$pairs;
module.exports.pair = $b85b998e40179317$var$pair;
function $b85b998e40179317$var$pairs(values, pairof = $b85b998e40179317$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $b85b998e40179317$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("8b7pK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f451a1eaa8c7ebc$var$range;
function $5f451a1eaa8c7ebc$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("ejl42", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a6b32df1bcbda344$var$rank;

var $a6b32df1bcbda344$var$_ascending = $a6b32df1bcbda344$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $cZZyC = parcelRequire("cZZyC");
function $a6b32df1bcbda344$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a6b32df1bcbda344$var$rank(values, valueof = $a6b32df1bcbda344$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $a6b32df1bcbda344$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $a6b32df1bcbda344$var$_ascending.default ? (i, j)=>(0, $cZZyC.ascendingDefined)(V[i], V[j]) : (0, $cZZyC.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("lw8Kx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $040ae4a396c0cf5b$var$least;

var $040ae4a396c0cf5b$var$_ascending = $040ae4a396c0cf5b$var$_interopRequireDefault((parcelRequire("2WR5G")));
function $040ae4a396c0cf5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $040ae4a396c0cf5b$var$least(values, compare = $040ae4a396c0cf5b$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $040ae4a396c0cf5b$var$_ascending.default)(value, minValue) < 0 : (0, $040ae4a396c0cf5b$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("7mLIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $55cf9952c2173637$var$leastIndex;

var $55cf9952c2173637$var$_ascending = $55cf9952c2173637$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $55cf9952c2173637$var$_minIndex = $55cf9952c2173637$var$_interopRequireDefault((parcelRequire("32tGX")));
function $55cf9952c2173637$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $55cf9952c2173637$var$leastIndex(values, compare = $55cf9952c2173637$var$_ascending.default) {
    if (compare.length === 1) return (0, $55cf9952c2173637$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("5NlUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $438286c048d80d03$var$greatest;

var $438286c048d80d03$var$_ascending = $438286c048d80d03$var$_interopRequireDefault((parcelRequire("2WR5G")));
function $438286c048d80d03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $438286c048d80d03$var$greatest(values, compare = $438286c048d80d03$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $438286c048d80d03$var$_ascending.default)(value, maxValue) > 0 : (0, $438286c048d80d03$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("eUrJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adabcdda5af24ac5$var$greatestIndex;

var $adabcdda5af24ac5$var$_ascending = $adabcdda5af24ac5$var$_interopRequireDefault((parcelRequire("2WR5G")));

var $adabcdda5af24ac5$var$_maxIndex = $adabcdda5af24ac5$var$_interopRequireDefault((parcelRequire("dpxdx")));
function $adabcdda5af24ac5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $adabcdda5af24ac5$var$greatestIndex(values, compare = $adabcdda5af24ac5$var$_ascending.default) {
    if (compare.length === 1) return (0, $adabcdda5af24ac5$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("kbw85", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eb1dc1f02c8ad832$var$scan;

var $eb1dc1f02c8ad832$var$_leastIndex = $eb1dc1f02c8ad832$var$_interopRequireDefault((parcelRequire("7mLIh")));
function $eb1dc1f02c8ad832$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $eb1dc1f02c8ad832$var$scan(values, compare) {
    const index = (0, $eb1dc1f02c8ad832$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("33B7C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $239e728f66a8bf68$var$shuffler;
var $239e728f66a8bf68$var$_default = $239e728f66a8bf68$var$shuffler(Math.random);
module.exports.default = $239e728f66a8bf68$var$_default;
function $239e728f66a8bf68$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("i2FN5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d228d4b031310de7$var$sum;
function $d228d4b031310de7$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("evd6D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8ee208bc7507fd2$var$transpose;

var $a8ee208bc7507fd2$var$_min = $a8ee208bc7507fd2$var$_interopRequireDefault((parcelRequire("5oxpw")));
function $a8ee208bc7507fd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8ee208bc7507fd2$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $a8ee208bc7507fd2$var$_min.default)(matrix, $a8ee208bc7507fd2$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $a8ee208bc7507fd2$var$length(d) {
    return d.length;
}

});

parcelRegister("jWis9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e841bf789ed6f191$var$zip;

var $e841bf789ed6f191$var$_transpose = $e841bf789ed6f191$var$_interopRequireDefault((parcelRequire("evd6D")));
function $e841bf789ed6f191$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e841bf789ed6f191$var$zip() {
    return (0, $e841bf789ed6f191$var$_transpose.default)(arguments);
}

});

parcelRegister("joCtP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1ee1b91ef9c0b44$var$every;
function $e1ee1b91ef9c0b44$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("kDNkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f06db70a69d79f22$var$some;
function $f06db70a69d79f22$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("h8ZUA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7b33569b75866b6$var$filter;
function $c7b33569b75866b6$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("6LTkM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ee20e169d055268$var$map;
function $4ee20e169d055268$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("lIMEs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd03723cc5057acb$var$reduce;
function $fd03723cc5057acb$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("hkpgI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9d7e7bd491e47db$var$reverse;
function $c9d7e7bd491e47db$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("2pqEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c1298095047dfa5$var$difference;

var $6CV6g = parcelRequire("6CV6g");
function $1c1298095047dfa5$var$difference(values, ...others) {
    values = new $6CV6g.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("h2zcH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c67dee54f7105787$var$disjoint;

var $6CV6g = parcelRequire("6CV6g");
function $c67dee54f7105787$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $6CV6g.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("aAVLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7b6a123d63b5deee$var$intersection;

var $6CV6g = parcelRequire("6CV6g");
function $7b6a123d63b5deee$var$intersection(values, ...others) {
    values = new $6CV6g.InternSet(values);
    others = others.map($7b6a123d63b5deee$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $7b6a123d63b5deee$var$set(values) {
    return values instanceof $6CV6g.InternSet ? values : new $6CV6g.InternSet(values);
}

});

parcelRegister("11x46", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bef8879c93c737c$var$subset;

var $0bef8879c93c737c$var$_superset = $0bef8879c93c737c$var$_interopRequireDefault((parcelRequire("l2doT")));
function $0bef8879c93c737c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bef8879c93c737c$var$subset(values, other) {
    return (0, $0bef8879c93c737c$var$_superset.default)(other, values);
}

});
parcelRegister("l2doT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5042def8ce91e86$var$superset;
function $f5042def8ce91e86$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $f5042def8ce91e86$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $f5042def8ce91e86$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $f5042def8ce91e86$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("gsNLm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfc5dcb6a76b44e3$var$union;

var $6CV6g = parcelRequire("6CV6g");
function $bfc5dcb6a76b44e3$var$union(...others) {
    const set = new $6CV6g.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("ezRKk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $a9ce0670c1272f4f$var$initInterpolator;
module.exports.initRange = $a9ce0670c1272f4f$var$initRange;
function $a9ce0670c1272f4f$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $a9ce0670c1272f4f$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("1gB5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ec40e30bf0f5c00$var$ordinal;
module.exports.implicit = void 0;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
const $0ec40e30bf0f5c00$var$implicit = Symbol("implicit");
module.exports.implicit = $0ec40e30bf0f5c00$var$implicit;
function $0ec40e30bf0f5c00$var$ordinal() {
    var index = new $dfXar.InternMap(), domain = [], range = [], unknown = $0ec40e30bf0f5c00$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0ec40e30bf0f5c00$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $dfXar.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0ec40e30bf0f5c00$var$ordinal(domain, range).unknown(unknown);
    };
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("j15Sh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd82aadac38a35b1$var$identity;

var $8cBoe = parcelRequire("8cBoe");

var $dd82aadac38a35b1$var$_number = $dd82aadac38a35b1$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $dd82aadac38a35b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dd82aadac38a35b1$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $dd82aadac38a35b1$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dd82aadac38a35b1$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $dd82aadac38a35b1$var$_number.default) : [
        0,
        1
    ];
    return (0, $8cBoe.linearish)(scale);
}

});
parcelRegister("8cBoe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f8c728aee153f97$var$linear;
module.exports.linearish = $5f8c728aee153f97$var$linearish;

var $dfXar = parcelRequire("dfXar");

var $5f8c728aee153f97$var$_continuous = $5f8c728aee153f97$var$_interopRequireWildcard((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $5f8c728aee153f97$var$_tickFormat = $5f8c728aee153f97$var$_interopRequireDefault((parcelRequire("lIlUJ")));
function $5f8c728aee153f97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f8c728aee153f97$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f8c728aee153f97$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f8c728aee153f97$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f8c728aee153f97$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5f8c728aee153f97$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $dfXar.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $5f8c728aee153f97$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $dfXar.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $5f8c728aee153f97$var$linear() {
    var scale = (0, $5f8c728aee153f97$var$_continuous.default)();
    scale.copy = function() {
        return (0, $5f8c728aee153f97$var$_continuous.copy)(scale, $5f8c728aee153f97$var$linear());
    };
    $ezRKk.initRange.apply(scale, arguments);
    return $5f8c728aee153f97$var$linearish(scale);
}

});
parcelRegister("kcPbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $eb5ca1580ede39e5$var$copy;
module.exports.default = $eb5ca1580ede39e5$var$continuous;
module.exports.identity = $eb5ca1580ede39e5$var$identity;
module.exports.transformer = $eb5ca1580ede39e5$var$transformer;

var $dfXar = parcelRequire("dfXar");

var $84oZu = parcelRequire("84oZu");

var $eb5ca1580ede39e5$var$_constant = $eb5ca1580ede39e5$var$_interopRequireDefault((parcelRequire("eq00u")));

var $eb5ca1580ede39e5$var$_number = $eb5ca1580ede39e5$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $eb5ca1580ede39e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $eb5ca1580ede39e5$var$unit = [
    0,
    1
];
function $eb5ca1580ede39e5$var$identity(x) {
    return x;
}
function $eb5ca1580ede39e5$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $eb5ca1580ede39e5$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $eb5ca1580ede39e5$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $eb5ca1580ede39e5$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $eb5ca1580ede39e5$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $eb5ca1580ede39e5$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $eb5ca1580ede39e5$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $eb5ca1580ede39e5$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $dfXar.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $eb5ca1580ede39e5$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $eb5ca1580ede39e5$var$transformer() {
    var domain = $eb5ca1580ede39e5$var$unit, range = $eb5ca1580ede39e5$var$unit, interpolate = $84oZu.interpolate, transform, untransform, unknown, clamp = $eb5ca1580ede39e5$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $eb5ca1580ede39e5$var$identity) clamp = $eb5ca1580ede39e5$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $eb5ca1580ede39e5$var$polymap : $eb5ca1580ede39e5$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $84oZu.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $eb5ca1580ede39e5$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $84oZu.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $eb5ca1580ede39e5$var$identity, rescale()) : clamp !== $eb5ca1580ede39e5$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $eb5ca1580ede39e5$var$continuous() {
    return $eb5ca1580ede39e5$var$transformer()($eb5ca1580ede39e5$var$identity, $eb5ca1580ede39e5$var$identity);
}

});
parcelRegister("84oZu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $f9YjU.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $f9YjU.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $5e0215138d0a55b8$var$_quantize.default;
    }
});

var $5e0215138d0a55b8$var$_value = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("bqAXw")));

var $5e0215138d0a55b8$var$_array = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("kQcG1")));

var $5e0215138d0a55b8$var$_basis = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("a1vOh")));

var $5e0215138d0a55b8$var$_basisClosed = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("3OWQH")));

var $5e0215138d0a55b8$var$_date = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("GQCzZ")));

var $5e0215138d0a55b8$var$_discrete = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("eP0kF")));

var $5e0215138d0a55b8$var$_hue = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("lLzpp")));

var $5e0215138d0a55b8$var$_number = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $5e0215138d0a55b8$var$_numberArray = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("cws9j")));

var $5e0215138d0a55b8$var$_object = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("2xR4B")));

var $5e0215138d0a55b8$var$_round = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("9mzi1")));

var $5e0215138d0a55b8$var$_string = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("56Roz")));

var $f9YjU = parcelRequire("f9YjU");

var $5e0215138d0a55b8$var$_zoom = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("j7cx5")));

var $5e0215138d0a55b8$var$_rgb = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("fczzB")));

var $5e0215138d0a55b8$var$_hsl = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("bfWaM")));

var $5e0215138d0a55b8$var$_lab = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("dS0ed")));

var $5e0215138d0a55b8$var$_hcl = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("i3ui9")));

var $5e0215138d0a55b8$var$_cubehelix = $5e0215138d0a55b8$var$_interopRequireWildcard((parcelRequire("ichIC")));

var $5e0215138d0a55b8$var$_piecewise = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("fPqKp")));

var $5e0215138d0a55b8$var$_quantize = $5e0215138d0a55b8$var$_interopRequireDefault((parcelRequire("lxEcn")));
function $5e0215138d0a55b8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5e0215138d0a55b8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5e0215138d0a55b8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5e0215138d0a55b8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5e0215138d0a55b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("bqAXw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $851ecab306118005$var$_default;

var $eyM6K = parcelRequire("eyM6K");

var $851ecab306118005$var$_rgb = $851ecab306118005$var$_interopRequireDefault((parcelRequire("fczzB")));

var $kQcG1 = parcelRequire("kQcG1");

var $851ecab306118005$var$_date = $851ecab306118005$var$_interopRequireDefault((parcelRequire("GQCzZ")));

var $851ecab306118005$var$_number = $851ecab306118005$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $851ecab306118005$var$_object = $851ecab306118005$var$_interopRequireDefault((parcelRequire("2xR4B")));

var $851ecab306118005$var$_string = $851ecab306118005$var$_interopRequireDefault((parcelRequire("56Roz")));

var $851ecab306118005$var$_constant = $851ecab306118005$var$_interopRequireDefault((parcelRequire("8s9ZJ")));

var $851ecab306118005$var$_numberArray = $851ecab306118005$var$_interopRequireWildcard((parcelRequire("cws9j")));
function $851ecab306118005$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($851ecab306118005$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $851ecab306118005$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $851ecab306118005$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $851ecab306118005$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $851ecab306118005$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $851ecab306118005$var$_constant.default)(b) : (t === "number" ? $851ecab306118005$var$_number.default : t === "string" ? (c = (0, $eyM6K.color)(b)) ? (b = c, $851ecab306118005$var$_rgb.default) : $851ecab306118005$var$_string.default : b instanceof $eyM6K.color ? $851ecab306118005$var$_rgb.default : b instanceof Date ? $851ecab306118005$var$_date.default : (0, $851ecab306118005$var$_numberArray.isNumberArray)(b) ? $851ecab306118005$var$_numberArray.default : Array.isArray(b) ? $kQcG1.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $851ecab306118005$var$_object.default : $851ecab306118005$var$_number.default)(a, b);
}

});
parcelRegister("eyM6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $a9998ee6ec2d57cf$var$_color.rgb;
    }
});

var $a9998ee6ec2d57cf$var$_color = $a9998ee6ec2d57cf$var$_interopRequireWildcard((parcelRequire("eZZi2")));

var $a9998ee6ec2d57cf$var$_lab = $a9998ee6ec2d57cf$var$_interopRequireWildcard((parcelRequire("epdzq")));

var $a9998ee6ec2d57cf$var$_cubehelix = $a9998ee6ec2d57cf$var$_interopRequireDefault((parcelRequire("k8o4k")));
function $a9998ee6ec2d57cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a9998ee6ec2d57cf$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a9998ee6ec2d57cf$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a9998ee6ec2d57cf$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a9998ee6ec2d57cf$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("eZZi2", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("h2Uz9")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("h2Uz9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c68e80655f3c9e6c$var$_default;
module.exports.extend = $c68e80655f3c9e6c$var$extend;
function $c68e80655f3c9e6c$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $c68e80655f3c9e6c$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("epdzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $a7cded475dce49e7$var$Hcl;
module.exports.Lab = $a7cded475dce49e7$var$Lab;
module.exports.default = $a7cded475dce49e7$var$lab;
module.exports.gray = $a7cded475dce49e7$var$gray;
module.exports.hcl = $a7cded475dce49e7$var$hcl;
module.exports.lch = $a7cded475dce49e7$var$lch;

var $a7cded475dce49e7$var$_define = $a7cded475dce49e7$var$_interopRequireWildcard((parcelRequire("h2Uz9")));

var $eZZi2 = parcelRequire("eZZi2");

var $65fvp = parcelRequire("65fvp");
function $a7cded475dce49e7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a7cded475dce49e7$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a7cded475dce49e7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a7cded475dce49e7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $a7cded475dce49e7$var$K = 18, $a7cded475dce49e7$var$Xn = 0.96422, $a7cded475dce49e7$var$Yn = 1, $a7cded475dce49e7$var$Zn = 0.82521, $a7cded475dce49e7$var$t0 = 4 / 29, $a7cded475dce49e7$var$t1 = 6 / 29, $a7cded475dce49e7$var$t2 = 3 * $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1, $a7cded475dce49e7$var$t3 = $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1 * $a7cded475dce49e7$var$t1;
function $a7cded475dce49e7$var$labConvert(o) {
    if (o instanceof $a7cded475dce49e7$var$Lab) return new $a7cded475dce49e7$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $a7cded475dce49e7$var$Hcl) return $a7cded475dce49e7$var$hcl2lab(o);
    if (!(o instanceof $eZZi2.Rgb)) o = (0, $eZZi2.rgbConvert)(o);
    var r = $a7cded475dce49e7$var$rgb2lrgb(o.r), g = $a7cded475dce49e7$var$rgb2lrgb(o.g), b = $a7cded475dce49e7$var$rgb2lrgb(o.b), y = $a7cded475dce49e7$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $a7cded475dce49e7$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $a7cded475dce49e7$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $a7cded475dce49e7$var$Xn);
        z = $a7cded475dce49e7$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $a7cded475dce49e7$var$Zn);
    }
    return new $a7cded475dce49e7$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $a7cded475dce49e7$var$gray(l, opacity) {
    return new $a7cded475dce49e7$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$labConvert(l) : new $a7cded475dce49e7$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $a7cded475dce49e7$var$_define.default)($a7cded475dce49e7$var$Lab, $a7cded475dce49e7$var$lab, (0, $a7cded475dce49e7$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        return new $a7cded475dce49e7$var$Lab(this.l + $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $a7cded475dce49e7$var$Lab(this.l - $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $a7cded475dce49e7$var$Xn * $a7cded475dce49e7$var$lab2xyz(x);
        y = $a7cded475dce49e7$var$Yn * $a7cded475dce49e7$var$lab2xyz(y);
        z = $a7cded475dce49e7$var$Zn * $a7cded475dce49e7$var$lab2xyz(z);
        return new $eZZi2.Rgb($a7cded475dce49e7$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $a7cded475dce49e7$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $a7cded475dce49e7$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $a7cded475dce49e7$var$xyz2lab(t) {
    return t > $a7cded475dce49e7$var$t3 ? Math.pow(t, 1 / 3) : t / $a7cded475dce49e7$var$t2 + $a7cded475dce49e7$var$t0;
}
function $a7cded475dce49e7$var$lab2xyz(t) {
    return t > $a7cded475dce49e7$var$t1 ? t * t * t : $a7cded475dce49e7$var$t2 * (t - $a7cded475dce49e7$var$t0);
}
function $a7cded475dce49e7$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $a7cded475dce49e7$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $a7cded475dce49e7$var$hclConvert(o) {
    if (o instanceof $a7cded475dce49e7$var$Hcl) return new $a7cded475dce49e7$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $a7cded475dce49e7$var$Lab)) o = $a7cded475dce49e7$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $a7cded475dce49e7$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $65fvp.degrees;
    return new $a7cded475dce49e7$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $a7cded475dce49e7$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$hclConvert(l) : new $a7cded475dce49e7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $a7cded475dce49e7$var$hclConvert(h) : new $a7cded475dce49e7$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $a7cded475dce49e7$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $a7cded475dce49e7$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $a7cded475dce49e7$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $65fvp.radians;
    return new $a7cded475dce49e7$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $a7cded475dce49e7$var$_define.default)($a7cded475dce49e7$var$Hcl, $a7cded475dce49e7$var$hcl, (0, $a7cded475dce49e7$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        return new $a7cded475dce49e7$var$Hcl(this.h, this.c, this.l + $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $a7cded475dce49e7$var$Hcl(this.h, this.c, this.l - $a7cded475dce49e7$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $a7cded475dce49e7$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("65fvp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $46df3cc99a843bd6$var$radians = Math.PI / 180;
module.exports.radians = $46df3cc99a843bd6$var$radians;
const $46df3cc99a843bd6$var$degrees = 180 / Math.PI;
module.exports.degrees = $46df3cc99a843bd6$var$degrees;

});


parcelRegister("k8o4k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $ea8739913c38feb3$var$Cubehelix;
module.exports.default = $ea8739913c38feb3$var$cubehelix;

var $ea8739913c38feb3$var$_define = $ea8739913c38feb3$var$_interopRequireWildcard((parcelRequire("h2Uz9")));

var $eZZi2 = parcelRequire("eZZi2");

var $65fvp = parcelRequire("65fvp");
function $ea8739913c38feb3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ea8739913c38feb3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ea8739913c38feb3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ea8739913c38feb3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $ea8739913c38feb3$var$A = -0.14861, $ea8739913c38feb3$var$B = 1.78277, $ea8739913c38feb3$var$C = -0.29227, $ea8739913c38feb3$var$D = -0.90649, $ea8739913c38feb3$var$E = 1.97294, $ea8739913c38feb3$var$ED = $ea8739913c38feb3$var$E * $ea8739913c38feb3$var$D, $ea8739913c38feb3$var$EB = $ea8739913c38feb3$var$E * $ea8739913c38feb3$var$B, $ea8739913c38feb3$var$BC_DA = $ea8739913c38feb3$var$B * $ea8739913c38feb3$var$C - $ea8739913c38feb3$var$D * $ea8739913c38feb3$var$A;
function $ea8739913c38feb3$var$cubehelixConvert(o) {
    if (o instanceof $ea8739913c38feb3$var$Cubehelix) return new $ea8739913c38feb3$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $eZZi2.Rgb)) o = (0, $eZZi2.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($ea8739913c38feb3$var$BC_DA * b + $ea8739913c38feb3$var$ED * r - $ea8739913c38feb3$var$EB * g) / ($ea8739913c38feb3$var$BC_DA + $ea8739913c38feb3$var$ED - $ea8739913c38feb3$var$EB), bl = b - l, k = ($ea8739913c38feb3$var$E * (g - l) - $ea8739913c38feb3$var$C * bl) / $ea8739913c38feb3$var$D, s = Math.sqrt(k * k + bl * bl) / ($ea8739913c38feb3$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $65fvp.degrees - 120 : NaN;
    return new $ea8739913c38feb3$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $ea8739913c38feb3$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $ea8739913c38feb3$var$cubehelixConvert(h) : new $ea8739913c38feb3$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $ea8739913c38feb3$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $ea8739913c38feb3$var$_define.default)($ea8739913c38feb3$var$Cubehelix, $ea8739913c38feb3$var$cubehelix, (0, $ea8739913c38feb3$var$_define.extend)($eZZi2.Color, {
    brighter (k) {
        k = k == null ? $eZZi2.brighter : Math.pow($eZZi2.brighter, k);
        return new $ea8739913c38feb3$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $eZZi2.darker : Math.pow($eZZi2.darker, k);
        return new $ea8739913c38feb3$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $65fvp.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $eZZi2.Rgb(255 * (l + a * ($ea8739913c38feb3$var$A * cosh + $ea8739913c38feb3$var$B * sinh)), 255 * (l + a * ($ea8739913c38feb3$var$C * cosh + $ea8739913c38feb3$var$D * sinh)), 255 * (l + a * ($ea8739913c38feb3$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("fczzB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $b1139220491ac4fe$var$_basis = $b1139220491ac4fe$var$_interopRequireDefault((parcelRequire("a1vOh")));

var $b1139220491ac4fe$var$_basisClosed = $b1139220491ac4fe$var$_interopRequireDefault((parcelRequire("3OWQH")));

var $b1139220491ac4fe$var$_color = $b1139220491ac4fe$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $b1139220491ac4fe$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b1139220491ac4fe$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b1139220491ac4fe$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b1139220491ac4fe$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b1139220491ac4fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b1139220491ac4fe$var$_default = function rgbGamma(y) {
    var color = (0, $b1139220491ac4fe$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $eyM6K.rgb)(start)).r, (end = (0, $eyM6K.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $b1139220491ac4fe$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $b1139220491ac4fe$var$_default;
function $b1139220491ac4fe$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $eyM6K.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $b1139220491ac4fe$var$rgbBasis = $b1139220491ac4fe$var$rgbSpline($b1139220491ac4fe$var$_basis.default);
module.exports.rgbBasis = $b1139220491ac4fe$var$rgbBasis;
var $b1139220491ac4fe$var$rgbBasisClosed = $b1139220491ac4fe$var$rgbSpline($b1139220491ac4fe$var$_basisClosed.default);
module.exports.rgbBasisClosed = $b1139220491ac4fe$var$rgbBasisClosed;

});
parcelRegister("a1vOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $74c2ac2be00c25df$var$basis;
module.exports.default = $74c2ac2be00c25df$var$_default;
function $74c2ac2be00c25df$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $74c2ac2be00c25df$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $74c2ac2be00c25df$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("3OWQH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c83b0c4ee7a74b9$var$_default;

var $a1vOh = parcelRequire("a1vOh");
function $2c83b0c4ee7a74b9$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $a1vOh.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("hE9q1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd8d7a72f256afc3$var$nogamma;
module.exports.gamma = $cd8d7a72f256afc3$var$gamma;
module.exports.hue = $cd8d7a72f256afc3$var$hue;

var $cd8d7a72f256afc3$var$_constant = $cd8d7a72f256afc3$var$_interopRequireDefault((parcelRequire("8s9ZJ")));
function $cd8d7a72f256afc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cd8d7a72f256afc3$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $cd8d7a72f256afc3$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $cd8d7a72f256afc3$var$hue(a, b) {
    var d = b - a;
    return d ? $cd8d7a72f256afc3$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
}
function $cd8d7a72f256afc3$var$gamma(y) {
    return (y = +y) === 1 ? $cd8d7a72f256afc3$var$nogamma : function(a, b) {
        return b - a ? $cd8d7a72f256afc3$var$exponential(a, b, y) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $cd8d7a72f256afc3$var$nogamma(a, b) {
    var d = b - a;
    return d ? $cd8d7a72f256afc3$var$linear(a, d) : (0, $cd8d7a72f256afc3$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("8s9ZJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6278b0f88be90622$var$_default = (x)=>()=>x;
module.exports.default = $6278b0f88be90622$var$_default;

});



parcelRegister("kQcG1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f2c27f55a6e67554$var$_default;
module.exports.genericArray = $f2c27f55a6e67554$var$genericArray;

var $f2c27f55a6e67554$var$_value = $f2c27f55a6e67554$var$_interopRequireDefault((parcelRequire("bqAXw")));

var $f2c27f55a6e67554$var$_numberArray = $f2c27f55a6e67554$var$_interopRequireWildcard((parcelRequire("cws9j")));
function $f2c27f55a6e67554$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f2c27f55a6e67554$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f2c27f55a6e67554$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f2c27f55a6e67554$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f2c27f55a6e67554$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f2c27f55a6e67554$var$_default(a, b) {
    return ((0, $f2c27f55a6e67554$var$_numberArray.isNumberArray)(b) ? $f2c27f55a6e67554$var$_numberArray.default : $f2c27f55a6e67554$var$genericArray)(a, b);
}
function $f2c27f55a6e67554$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $f2c27f55a6e67554$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("cws9j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91de4f0a4dd67afc$var$_default;
module.exports.isNumberArray = $91de4f0a4dd67afc$var$isNumberArray;
function $91de4f0a4dd67afc$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $91de4f0a4dd67afc$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("GQCzZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $080cbdd7ac6e0c59$var$_default;
function $080cbdd7ac6e0c59$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("9n4Qi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d2a04a545812b28$var$_default;
function $6d2a04a545812b28$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("2xR4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1da7d510c8b9150b$var$_default;

var $1da7d510c8b9150b$var$_value = $1da7d510c8b9150b$var$_interopRequireDefault((parcelRequire("bqAXw")));
function $1da7d510c8b9150b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1da7d510c8b9150b$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $1da7d510c8b9150b$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("56Roz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b86ee7ff8efed04$var$_default;

var $3b86ee7ff8efed04$var$_number = $3b86ee7ff8efed04$var$_interopRequireDefault((parcelRequire("9n4Qi")));
function $3b86ee7ff8efed04$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b86ee7ff8efed04$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $3b86ee7ff8efed04$var$reB = new RegExp($3b86ee7ff8efed04$var$reA.source, "g");
function $3b86ee7ff8efed04$var$zero(b) {
    return function() {
        return b;
    };
}
function $3b86ee7ff8efed04$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $3b86ee7ff8efed04$var$_default(a, b) {
    var bi = $3b86ee7ff8efed04$var$reA.lastIndex = $3b86ee7ff8efed04$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $3b86ee7ff8efed04$var$reA.exec(a)) && (bm = $3b86ee7ff8efed04$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $3b86ee7ff8efed04$var$_number.default)(am, bm)
            });
        }
        bi = $3b86ee7ff8efed04$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $3b86ee7ff8efed04$var$one(q[0].x) : $3b86ee7ff8efed04$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("eP0kF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aca6161d8bd83d34$var$_default;
function $aca6161d8bd83d34$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("lLzpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fd897435e6af771b$var$_default;

var $hE9q1 = parcelRequire("hE9q1");
function $fd897435e6af771b$var$_default(a, b) {
    var i = (0, $hE9q1.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("9mzi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d118aef1893f91c$var$_default;
function $6d118aef1893f91c$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("f9YjU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $b0967c93565b9772$var$_number = $b0967c93565b9772$var$_interopRequireDefault((parcelRequire("9n4Qi")));

var $jx2Ik = parcelRequire("jx2Ik");
function $b0967c93565b9772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b0967c93565b9772$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $b0967c93565b9772$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $b0967c93565b9772$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $b0967c93565b9772$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $b0967c93565b9772$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $b0967c93565b9772$var$interpolateTransformCss = $b0967c93565b9772$var$interpolateTransform($jx2Ik.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $b0967c93565b9772$var$interpolateTransformCss;
var $b0967c93565b9772$var$interpolateTransformSvg = $b0967c93565b9772$var$interpolateTransform($jx2Ik.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $b0967c93565b9772$var$interpolateTransformSvg;

});
parcelRegister("jx2Ik", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $e383345a236f382d$var$parseCss;
module.exports.parseSvg = $e383345a236f382d$var$parseSvg;

var $e383345a236f382d$var$_decompose = $e383345a236f382d$var$_interopRequireWildcard((parcelRequire("31XW4")));
function $e383345a236f382d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e383345a236f382d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e383345a236f382d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e383345a236f382d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $e383345a236f382d$var$svgNode;
/* eslint-disable no-undef */ function $e383345a236f382d$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $e383345a236f382d$var$_decompose.identity : (0, $e383345a236f382d$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $e383345a236f382d$var$parseSvg(value) {
    if (value == null) return $e383345a236f382d$var$_decompose.identity;
    if (!$e383345a236f382d$var$svgNode) $e383345a236f382d$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $e383345a236f382d$var$svgNode.setAttribute("transform", value);
    if (!(value = $e383345a236f382d$var$svgNode.transform.baseVal.consolidate())) return $e383345a236f382d$var$_decompose.identity;
    value = value.matrix;
    return (0, $e383345a236f382d$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("31XW4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $234ff50cd36ed304$var$_default;
module.exports.identity = void 0;
var $234ff50cd36ed304$var$degrees = 180 / Math.PI;
var $234ff50cd36ed304$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $234ff50cd36ed304$var$identity;
function $234ff50cd36ed304$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $234ff50cd36ed304$var$degrees,
        skewX: Math.atan(skewX) * $234ff50cd36ed304$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("j7cx5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dea86482284d55a5$var$epsilon2 = 1e-12;
function $dea86482284d55a5$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $dea86482284d55a5$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $dea86482284d55a5$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $dea86482284d55a5$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $dea86482284d55a5$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $dea86482284d55a5$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $dea86482284d55a5$var$tanh(rho * s + r0) - $dea86482284d55a5$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $dea86482284d55a5$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $dea86482284d55a5$var$_default;

});

parcelRegister("bfWaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $831e3853f95e624c$var$_color = $831e3853f95e624c$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $831e3853f95e624c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($831e3853f95e624c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $831e3853f95e624c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $831e3853f95e624c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $831e3853f95e624c$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eyM6K.hsl)(start)).h, (end = (0, $eyM6K.hsl)(end)).h), s = (0, $831e3853f95e624c$var$_color.default)(start.s, end.s), l = (0, $831e3853f95e624c$var$_color.default)(start.l, end.l), opacity = (0, $831e3853f95e624c$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $831e3853f95e624c$var$_default = $831e3853f95e624c$var$hsl($831e3853f95e624c$var$_color.hue);
module.exports.default = $831e3853f95e624c$var$_default;
var $831e3853f95e624c$var$hslLong = $831e3853f95e624c$var$hsl($831e3853f95e624c$var$_color.default);
module.exports.hslLong = $831e3853f95e624c$var$hslLong;

});

parcelRegister("dS0ed", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a1907ed219b19dbe$var$lab;

var $eyM6K = parcelRequire("eyM6K");

var $a1907ed219b19dbe$var$_color = $a1907ed219b19dbe$var$_interopRequireDefault((parcelRequire("hE9q1")));
function $a1907ed219b19dbe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a1907ed219b19dbe$var$lab(start, end) {
    var l = (0, $a1907ed219b19dbe$var$_color.default)((start = (0, $eyM6K.lab)(start)).l, (end = (0, $eyM6K.lab)(end)).l), a = (0, $a1907ed219b19dbe$var$_color.default)(start.a, end.a), b = (0, $a1907ed219b19dbe$var$_color.default)(start.b, end.b), opacity = (0, $a1907ed219b19dbe$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("i3ui9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $d2500124005000b1$var$_color = $d2500124005000b1$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $d2500124005000b1$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d2500124005000b1$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d2500124005000b1$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d2500124005000b1$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d2500124005000b1$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $eyM6K.hcl)(start)).h, (end = (0, $eyM6K.hcl)(end)).h), c = (0, $d2500124005000b1$var$_color.default)(start.c, end.c), l = (0, $d2500124005000b1$var$_color.default)(start.l, end.l), opacity = (0, $d2500124005000b1$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $d2500124005000b1$var$_default = $d2500124005000b1$var$hcl($d2500124005000b1$var$_color.hue);
module.exports.default = $d2500124005000b1$var$_default;
var $d2500124005000b1$var$hclLong = $d2500124005000b1$var$hcl($d2500124005000b1$var$_color.default);
module.exports.hclLong = $d2500124005000b1$var$hclLong;

});

parcelRegister("ichIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $eyM6K = parcelRequire("eyM6K");

var $d3f7178c47a6553b$var$_color = $d3f7178c47a6553b$var$_interopRequireWildcard((parcelRequire("hE9q1")));
function $d3f7178c47a6553b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d3f7178c47a6553b$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d3f7178c47a6553b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d3f7178c47a6553b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d3f7178c47a6553b$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $eyM6K.cubehelix)(start)).h, (end = (0, $eyM6K.cubehelix)(end)).h), s = (0, $d3f7178c47a6553b$var$_color.default)(start.s, end.s), l = (0, $d3f7178c47a6553b$var$_color.default)(start.l, end.l), opacity = (0, $d3f7178c47a6553b$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $d3f7178c47a6553b$var$_default = $d3f7178c47a6553b$var$cubehelix($d3f7178c47a6553b$var$_color.hue);
module.exports.default = $d3f7178c47a6553b$var$_default;
var $d3f7178c47a6553b$var$cubehelixLong = $d3f7178c47a6553b$var$cubehelix($d3f7178c47a6553b$var$_color.default);
module.exports.cubehelixLong = $d3f7178c47a6553b$var$cubehelixLong;

});

parcelRegister("fPqKp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8605ded540cf407$var$piecewise;

var $b8605ded540cf407$var$_value = $b8605ded540cf407$var$_interopRequireDefault((parcelRequire("bqAXw")));
function $b8605ded540cf407$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b8605ded540cf407$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $b8605ded540cf407$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("lxEcn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $faebdca1a21258f6$var$_default;
function $faebdca1a21258f6$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("eq00u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7f37fc22b6a3430$var$constants;
function $a7f37fc22b6a3430$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("9pEAW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6da5f02991bd4350$var$number;
function $6da5f02991bd4350$var$number(x) {
    return +x;
}

});


parcelRegister("lIlUJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fceeb4b385ade6d6$var$tickFormat;

var $dfXar = parcelRequire("dfXar");

var $7uMWs = parcelRequire("7uMWs");
function $fceeb4b385ade6d6$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $dfXar.tickStep)(start, stop, count), precision;
    specifier = (0, $7uMWs.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $7uMWs.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $7uMWs.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $7uMWs.format)(specifier);
}

});
parcelRegister("7uMWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $57514c9906feacb9$var$_precisionRound.default;
    }
});

var $57514c9906feacb9$var$_defaultLocale = $57514c9906feacb9$var$_interopRequireWildcard((parcelRequire("f4gnY")));

var $57514c9906feacb9$var$_locale = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("basO1")));

var $57514c9906feacb9$var$_formatSpecifier = $57514c9906feacb9$var$_interopRequireWildcard((parcelRequire("4V7rf")));

var $57514c9906feacb9$var$_precisionFixed = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("l9uU9")));

var $57514c9906feacb9$var$_precisionPrefix = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("alJCX")));

var $57514c9906feacb9$var$_precisionRound = $57514c9906feacb9$var$_interopRequireDefault((parcelRequire("5Q4CM")));
function $57514c9906feacb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $57514c9906feacb9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($57514c9906feacb9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $57514c9906feacb9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $57514c9906feacb9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("f4gnY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af83f09335af1d37$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $af83f09335af1d37$var$_locale = $af83f09335af1d37$var$_interopRequireDefault((parcelRequire("basO1")));
function $af83f09335af1d37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $af83f09335af1d37$var$locale;
var $af83f09335af1d37$var$format;
module.exports.format = $af83f09335af1d37$var$format;
var $af83f09335af1d37$var$formatPrefix;
module.exports.formatPrefix = $af83f09335af1d37$var$formatPrefix;
$af83f09335af1d37$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $af83f09335af1d37$var$defaultLocale(definition) {
    $af83f09335af1d37$var$locale = (0, $af83f09335af1d37$var$_locale.default)(definition);
    module.exports.format = $af83f09335af1d37$var$format = $af83f09335af1d37$var$locale.format;
    module.exports.formatPrefix = $af83f09335af1d37$var$formatPrefix = $af83f09335af1d37$var$locale.formatPrefix;
    return $af83f09335af1d37$var$locale;
}

});
parcelRegister("basO1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8216f91b54cfbe15$var$_default;

var $8216f91b54cfbe15$var$_exponent = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("1Ql80")));

var $8216f91b54cfbe15$var$_formatGroup = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("izmDk")));

var $8216f91b54cfbe15$var$_formatNumerals = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("gjmM7")));

var $8216f91b54cfbe15$var$_formatSpecifier = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("4V7rf")));

var $8216f91b54cfbe15$var$_formatTrim = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("2dMwj")));

var $8216f91b54cfbe15$var$_formatTypes = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("jhi0g")));

var $fc1ax = parcelRequire("fc1ax");

var $8216f91b54cfbe15$var$_identity = $8216f91b54cfbe15$var$_interopRequireDefault((parcelRequire("8aR4t")));
function $8216f91b54cfbe15$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8216f91b54cfbe15$var$map = Array.prototype.map, $8216f91b54cfbe15$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $8216f91b54cfbe15$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $8216f91b54cfbe15$var$_identity.default : (0, $8216f91b54cfbe15$var$_formatGroup.default)($8216f91b54cfbe15$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $8216f91b54cfbe15$var$_identity.default : (0, $8216f91b54cfbe15$var$_formatNumerals.default)($8216f91b54cfbe15$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $8216f91b54cfbe15$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$8216f91b54cfbe15$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $8216f91b54cfbe15$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $8216f91b54cfbe15$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $8216f91b54cfbe15$var$prefixes[8 + $fc1ax.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $8216f91b54cfbe15$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $8216f91b54cfbe15$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $8216f91b54cfbe15$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("1Ql80", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $157b0960229b1f1a$var$_default;

var $3sOC5 = parcelRequire("3sOC5");
function $157b0960229b1f1a$var$_default(x) {
    return x = (0, $3sOC5.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("3sOC5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $285b3f5f938e3df5$var$_default;
module.exports.formatDecimalParts = $285b3f5f938e3df5$var$formatDecimalParts;
function $285b3f5f938e3df5$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $285b3f5f938e3df5$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("izmDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d84d0d68ca9f5790$var$_default;
function $d84d0d68ca9f5790$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("gjmM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be00165b46e31dc8$var$_default;
function $be00165b46e31dc8$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("4V7rf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $395241695799c319$var$FormatSpecifier;
module.exports.default = $395241695799c319$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $395241695799c319$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $395241695799c319$var$formatSpecifier(specifier) {
    if (!(match = $395241695799c319$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $395241695799c319$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$395241695799c319$var$formatSpecifier.prototype = $395241695799c319$var$FormatSpecifier.prototype; // instanceof
function $395241695799c319$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$395241695799c319$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("2dMwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $19e26ec3d81dc191$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $19e26ec3d81dc191$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("jhi0g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e08d91e6758090a0$var$_formatDecimal = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("3sOC5")));

var $e08d91e6758090a0$var$_formatPrefixAuto = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("fc1ax")));

var $e08d91e6758090a0$var$_formatRounded = $e08d91e6758090a0$var$_interopRequireDefault((parcelRequire("3eltF")));
function $e08d91e6758090a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e08d91e6758090a0$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $e08d91e6758090a0$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $e08d91e6758090a0$var$_formatRounded.default)(x * 100, p),
    "r": $e08d91e6758090a0$var$_formatRounded.default,
    "s": $e08d91e6758090a0$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $e08d91e6758090a0$var$_default;

});
parcelRegister("fc1ax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b0f8e2294dd2f03f$var$_default;
module.exports.prefixExponent = void 0;

var $3sOC5 = parcelRequire("3sOC5");
var $b0f8e2294dd2f03f$var$prefixExponent;
module.exports.prefixExponent = $b0f8e2294dd2f03f$var$prefixExponent;
function $b0f8e2294dd2f03f$var$_default(x, p) {
    var d = (0, $3sOC5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $b0f8e2294dd2f03f$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $3sOC5.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("3eltF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25a356e97a1d9ed6$var$_default;

var $3sOC5 = parcelRequire("3sOC5");
function $25a356e97a1d9ed6$var$_default(x, p) {
    var d = (0, $3sOC5.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("8aR4t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f386cbdb64a70ea$var$_default;
function $5f386cbdb64a70ea$var$_default(x) {
    return x;
}

});



parcelRegister("l9uU9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f662693e8de88ced$var$_default;

var $f662693e8de88ced$var$_exponent = $f662693e8de88ced$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $f662693e8de88ced$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f662693e8de88ced$var$_default(step) {
    return Math.max(0, -(0, $f662693e8de88ced$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("alJCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $788f422f57b10027$var$_default;

var $788f422f57b10027$var$_exponent = $788f422f57b10027$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $788f422f57b10027$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $788f422f57b10027$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $788f422f57b10027$var$_exponent.default)(value) / 3))) * 3 - (0, $788f422f57b10027$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("5Q4CM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44056569c9e9982f$var$_default;

var $44056569c9e9982f$var$_exponent = $44056569c9e9982f$var$_interopRequireDefault((parcelRequire("1Ql80")));
function $44056569c9e9982f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $44056569c9e9982f$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $44056569c9e9982f$var$_exponent.default)(max) - (0, $44056569c9e9982f$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("cw7m0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $91ce2d8a0eb84c4f$var$log;
module.exports.loggish = $91ce2d8a0eb84c4f$var$loggish;

var $dfXar = parcelRequire("dfXar");

var $7uMWs = parcelRequire("7uMWs");

var $91ce2d8a0eb84c4f$var$_nice = $91ce2d8a0eb84c4f$var$_interopRequireDefault((parcelRequire("etVnX")));

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $91ce2d8a0eb84c4f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91ce2d8a0eb84c4f$var$transformLog(x) {
    return Math.log(x);
}
function $91ce2d8a0eb84c4f$var$transformExp(x) {
    return Math.exp(x);
}
function $91ce2d8a0eb84c4f$var$transformLogn(x) {
    return -Math.log(-x);
}
function $91ce2d8a0eb84c4f$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $91ce2d8a0eb84c4f$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $91ce2d8a0eb84c4f$var$powp(base) {
    return base === 10 ? $91ce2d8a0eb84c4f$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $91ce2d8a0eb84c4f$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $91ce2d8a0eb84c4f$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $91ce2d8a0eb84c4f$var$loggish(transform) {
    const scale = transform($91ce2d8a0eb84c4f$var$transformLog, $91ce2d8a0eb84c4f$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $91ce2d8a0eb84c4f$var$logp(base), pows = $91ce2d8a0eb84c4f$var$powp(base);
        if (domain()[0] < 0) {
            logs = $91ce2d8a0eb84c4f$var$reflect(logs), pows = $91ce2d8a0eb84c4f$var$reflect(pows);
            transform($91ce2d8a0eb84c4f$var$transformLogn, $91ce2d8a0eb84c4f$var$transformExpn);
        } else transform($91ce2d8a0eb84c4f$var$transformLog, $91ce2d8a0eb84c4f$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $dfXar.ticks)(u, v, n);
        } else z = (0, $dfXar.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $7uMWs.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $7uMWs.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $91ce2d8a0eb84c4f$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $91ce2d8a0eb84c4f$var$log() {
    const scale = $91ce2d8a0eb84c4f$var$loggish((0, $kcPbm.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $kcPbm.copy)(scale, $91ce2d8a0eb84c4f$var$log()).base(scale.base());
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("etVnX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8b049abb6dce171$var$nice;
function $a8b049abb6dce171$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("3DXgb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a72fb69a5cbf18d$var$symlog;
module.exports.symlogish = $2a72fb69a5cbf18d$var$symlogish;

var $8cBoe = parcelRequire("8cBoe");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $2a72fb69a5cbf18d$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $2a72fb69a5cbf18d$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $2a72fb69a5cbf18d$var$symlogish(transform) {
    var c = 1, scale = transform($2a72fb69a5cbf18d$var$transformSymlog(c), $2a72fb69a5cbf18d$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($2a72fb69a5cbf18d$var$transformSymlog(c = +_), $2a72fb69a5cbf18d$var$transformSymexp(c)) : c;
    };
    return (0, $8cBoe.linearish)(scale);
}
function $2a72fb69a5cbf18d$var$symlog() {
    var scale = $2a72fb69a5cbf18d$var$symlogish((0, $kcPbm.transformer)());
    scale.copy = function() {
        return (0, $kcPbm.copy)(scale, $2a72fb69a5cbf18d$var$symlog()).constant(scale.constant());
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("6kjWv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49b414858ebc7381$var$pow;
module.exports.powish = $49b414858ebc7381$var$powish;
module.exports.sqrt = $49b414858ebc7381$var$sqrt;

var $8cBoe = parcelRequire("8cBoe");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $49b414858ebc7381$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $49b414858ebc7381$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $49b414858ebc7381$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $49b414858ebc7381$var$powish(transform) {
    var scale = transform($kcPbm.identity, $kcPbm.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($kcPbm.identity, $kcPbm.identity) : exponent === 0.5 ? transform($49b414858ebc7381$var$transformSqrt, $49b414858ebc7381$var$transformSquare) : transform($49b414858ebc7381$var$transformPow(exponent), $49b414858ebc7381$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $8cBoe.linearish)(scale);
}
function $49b414858ebc7381$var$pow() {
    var scale = $49b414858ebc7381$var$powish((0, $kcPbm.transformer)());
    scale.copy = function() {
        return (0, $kcPbm.copy)(scale, $49b414858ebc7381$var$pow()).exponent(scale.exponent());
    };
    $ezRKk.initRange.apply(scale, arguments);
    return scale;
}
function $49b414858ebc7381$var$sqrt() {
    return $49b414858ebc7381$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("kwNoN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef1d1d63bf1479b2$var$radial;

var $ef1d1d63bf1479b2$var$_continuous = $ef1d1d63bf1479b2$var$_interopRequireDefault((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $ef1d1d63bf1479b2$var$_number = $ef1d1d63bf1479b2$var$_interopRequireDefault((parcelRequire("9pEAW")));
function $ef1d1d63bf1479b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ef1d1d63bf1479b2$var$square(x) {
    return Math.sign(x) * x * x;
}
function $ef1d1d63bf1479b2$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $ef1d1d63bf1479b2$var$radial() {
    var squared = (0, $ef1d1d63bf1479b2$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $ef1d1d63bf1479b2$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($ef1d1d63bf1479b2$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $ef1d1d63bf1479b2$var$_number.default)).map($ef1d1d63bf1479b2$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ef1d1d63bf1479b2$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $ezRKk.initRange.apply(scale, arguments);
    return (0, $8cBoe.linearish)(scale);
}

});

parcelRegister("kEBaY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f094617a4f64d8ba$var$quantile;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
function $f094617a4f64d8ba$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $dfXar.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $dfXar.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dfXar.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $f094617a4f64d8ba$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("5prmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0482b6ea5d0b8f$var$quantize;

var $dfXar = parcelRequire("dfXar");

var $8cBoe = parcelRequire("8cBoe");

var $ezRKk = parcelRequire("ezRKk");
function $3f0482b6ea5d0b8f$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dfXar.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $3f0482b6ea5d0b8f$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply((0, $8cBoe.linearish)(scale), arguments);
}

});

parcelRegister("81sXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d74e1d056465429$var$threshold;

var $dfXar = parcelRequire("dfXar");

var $ezRKk = parcelRequire("ezRKk");
function $5d74e1d056465429$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $dfXar.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $5d74e1d056465429$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $ezRKk.initRange.apply(scale, arguments);
}

});

parcelRegister("3lv9c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $26fb7e7cfa923bda$var$calendar;
module.exports.default = $26fb7e7cfa923bda$var$time;

var $2iBJo = parcelRequire("2iBJo");

var $allvJ = parcelRequire("allvJ");

var $26fb7e7cfa923bda$var$_continuous = $26fb7e7cfa923bda$var$_interopRequireWildcard((parcelRequire("kcPbm")));

var $ezRKk = parcelRequire("ezRKk");

var $26fb7e7cfa923bda$var$_nice = $26fb7e7cfa923bda$var$_interopRequireDefault((parcelRequire("etVnX")));
function $26fb7e7cfa923bda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26fb7e7cfa923bda$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($26fb7e7cfa923bda$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $26fb7e7cfa923bda$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $26fb7e7cfa923bda$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $26fb7e7cfa923bda$var$date(t) {
    return new Date(t);
}
function $26fb7e7cfa923bda$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $26fb7e7cfa923bda$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $26fb7e7cfa923bda$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $26fb7e7cfa923bda$var$number)) : domain().map($26fb7e7cfa923bda$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $26fb7e7cfa923bda$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $26fb7e7cfa923bda$var$_continuous.copy)(scale, $26fb7e7cfa923bda$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $26fb7e7cfa923bda$var$time() {
    return $ezRKk.initRange.apply($26fb7e7cfa923bda$var$calendar($2iBJo.timeTicks, $2iBJo.timeTickInterval, $2iBJo.timeYear, $2iBJo.timeMonth, $2iBJo.timeWeek, $2iBJo.timeDay, $2iBJo.timeHour, $2iBJo.timeMinute, $2iBJo.timeSecond, $allvJ.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("2iBJo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $9wwjs.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $9wwjs.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $9wwjs.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $9wwjs.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $9wwjs.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $9wwjs.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $9wwjs.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $9wwjs.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $fi2S9.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $fi2S9.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $9wwjs.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $9wwjs.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $9wwjs.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $9wwjs.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $9wwjs.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $fi2S9.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $fi2S9.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $gYiWY.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $1aca87d4f197032e$var$_utcYear.utcYears;
    }
});

var $1aca87d4f197032e$var$_interval = $1aca87d4f197032e$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $1aca87d4f197032e$var$_millisecond = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("joIgc")));

var $1aca87d4f197032e$var$_second = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("emUZs")));

var $1aca87d4f197032e$var$_minute = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bWQ0C")));

var $1aca87d4f197032e$var$_hour = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("la0bP")));

var $1aca87d4f197032e$var$_day = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("8Qo8R")));

var $9wwjs = parcelRequire("9wwjs");

var $1aca87d4f197032e$var$_month = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("eQlmO")));

var $1aca87d4f197032e$var$_year = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bCw6g")));

var $1aca87d4f197032e$var$_utcMinute = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("56CHD")));

var $1aca87d4f197032e$var$_utcHour = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("4Id0V")));

var $1aca87d4f197032e$var$_utcDay = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("coaP9")));

var $gYiWY = parcelRequire("gYiWY");

var $1aca87d4f197032e$var$_utcMonth = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("15kWX")));

var $1aca87d4f197032e$var$_utcYear = $1aca87d4f197032e$var$_interopRequireWildcard((parcelRequire("bRXUB")));

var $fi2S9 = parcelRequire("fi2S9");
function $1aca87d4f197032e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1aca87d4f197032e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1aca87d4f197032e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1aca87d4f197032e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1aca87d4f197032e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("9mYsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d2511cf3662afe1$var$newInterval;
var $6d2511cf3662afe1$var$t0 = new Date(), $6d2511cf3662afe1$var$t1 = new Date();
function $6d2511cf3662afe1$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $6d2511cf3662afe1$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $6d2511cf3662afe1$var$t0.setTime(+start), $6d2511cf3662afe1$var$t1.setTime(+end);
            floori($6d2511cf3662afe1$var$t0), floori($6d2511cf3662afe1$var$t1);
            return Math.floor(count($6d2511cf3662afe1$var$t0, $6d2511cf3662afe1$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("joIgc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $e1f2975b854fe23b$var$_interval = $e1f2975b854fe23b$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $e1f2975b854fe23b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e1f2975b854fe23b$var$millisecond = (0, $e1f2975b854fe23b$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$e1f2975b854fe23b$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $e1f2975b854fe23b$var$millisecond;
    return (0, $e1f2975b854fe23b$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $e1f2975b854fe23b$var$_default = $e1f2975b854fe23b$var$millisecond;
module.exports.default = $e1f2975b854fe23b$var$_default;
var $e1f2975b854fe23b$var$milliseconds = $e1f2975b854fe23b$var$millisecond.range;
module.exports.milliseconds = $e1f2975b854fe23b$var$milliseconds;

});

parcelRegister("emUZs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $a75f53d9ffa9fbfb$var$_interval = $a75f53d9ffa9fbfb$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $a75f53d9ffa9fbfb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a75f53d9ffa9fbfb$var$second = (0, $a75f53d9ffa9fbfb$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationSecond);
}, function(start, end) {
    return (end - start) / $ffS6a.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $a75f53d9ffa9fbfb$var$_default = $a75f53d9ffa9fbfb$var$second;
module.exports.default = $a75f53d9ffa9fbfb$var$_default;
var $a75f53d9ffa9fbfb$var$seconds = $a75f53d9ffa9fbfb$var$second.range;
module.exports.seconds = $a75f53d9ffa9fbfb$var$seconds;

});
parcelRegister("ffS6a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $b1b2388a57633b6c$var$durationSecond = 1000;
module.exports.durationSecond = $b1b2388a57633b6c$var$durationSecond;
const $b1b2388a57633b6c$var$durationMinute = $b1b2388a57633b6c$var$durationSecond * 60;
module.exports.durationMinute = $b1b2388a57633b6c$var$durationMinute;
const $b1b2388a57633b6c$var$durationHour = $b1b2388a57633b6c$var$durationMinute * 60;
module.exports.durationHour = $b1b2388a57633b6c$var$durationHour;
const $b1b2388a57633b6c$var$durationDay = $b1b2388a57633b6c$var$durationHour * 24;
module.exports.durationDay = $b1b2388a57633b6c$var$durationDay;
const $b1b2388a57633b6c$var$durationWeek = $b1b2388a57633b6c$var$durationDay * 7;
module.exports.durationWeek = $b1b2388a57633b6c$var$durationWeek;
const $b1b2388a57633b6c$var$durationMonth = $b1b2388a57633b6c$var$durationDay * 30;
module.exports.durationMonth = $b1b2388a57633b6c$var$durationMonth;
const $b1b2388a57633b6c$var$durationYear = $b1b2388a57633b6c$var$durationDay * 365;
module.exports.durationYear = $b1b2388a57633b6c$var$durationYear;

});


parcelRegister("bWQ0C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $8b2d7466a451a47f$var$_interval = $8b2d7466a451a47f$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $8b2d7466a451a47f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b2d7466a451a47f$var$minute = (0, $8b2d7466a451a47f$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $ffS6a.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationMinute);
}, function(start, end) {
    return (end - start) / $ffS6a.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $8b2d7466a451a47f$var$_default = $8b2d7466a451a47f$var$minute;
module.exports.default = $8b2d7466a451a47f$var$_default;
var $8b2d7466a451a47f$var$minutes = $8b2d7466a451a47f$var$minute.range;
module.exports.minutes = $8b2d7466a451a47f$var$minutes;

});

parcelRegister("la0bP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $f67aadcffd65d77a$var$_interval = $f67aadcffd65d77a$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $f67aadcffd65d77a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $f67aadcffd65d77a$var$hour = (0, $f67aadcffd65d77a$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $ffS6a.durationSecond - date.getMinutes() * $ffS6a.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationHour);
}, function(start, end) {
    return (end - start) / $ffS6a.durationHour;
}, function(date) {
    return date.getHours();
});
var $f67aadcffd65d77a$var$_default = $f67aadcffd65d77a$var$hour;
module.exports.default = $f67aadcffd65d77a$var$_default;
var $f67aadcffd65d77a$var$hours = $f67aadcffd65d77a$var$hour.range;
module.exports.hours = $f67aadcffd65d77a$var$hours;

});

parcelRegister("8Qo8R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $6705e829935a7cb9$var$_interval = $6705e829935a7cb9$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $6705e829935a7cb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6705e829935a7cb9$var$day = (0, $6705e829935a7cb9$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $ffS6a.durationMinute) / $ffS6a.durationDay, (date)=>date.getDate() - 1);
var $6705e829935a7cb9$var$_default = $6705e829935a7cb9$var$day;
module.exports.default = $6705e829935a7cb9$var$_default;
var $6705e829935a7cb9$var$days = $6705e829935a7cb9$var$day.range;
module.exports.days = $6705e829935a7cb9$var$days;

});

parcelRegister("9wwjs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $6ef02adb24568350$var$_interval = $6ef02adb24568350$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $6ef02adb24568350$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ef02adb24568350$var$weekday(i) {
    return (0, $6ef02adb24568350$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $ffS6a.durationMinute) / $ffS6a.durationWeek;
    });
}
var $6ef02adb24568350$var$sunday = $6ef02adb24568350$var$weekday(0);
module.exports.sunday = $6ef02adb24568350$var$sunday;
var $6ef02adb24568350$var$monday = $6ef02adb24568350$var$weekday(1);
module.exports.monday = $6ef02adb24568350$var$monday;
var $6ef02adb24568350$var$tuesday = $6ef02adb24568350$var$weekday(2);
module.exports.tuesday = $6ef02adb24568350$var$tuesday;
var $6ef02adb24568350$var$wednesday = $6ef02adb24568350$var$weekday(3);
module.exports.wednesday = $6ef02adb24568350$var$wednesday;
var $6ef02adb24568350$var$thursday = $6ef02adb24568350$var$weekday(4);
module.exports.thursday = $6ef02adb24568350$var$thursday;
var $6ef02adb24568350$var$friday = $6ef02adb24568350$var$weekday(5);
module.exports.friday = $6ef02adb24568350$var$friday;
var $6ef02adb24568350$var$saturday = $6ef02adb24568350$var$weekday(6);
module.exports.saturday = $6ef02adb24568350$var$saturday;
var $6ef02adb24568350$var$sundays = $6ef02adb24568350$var$sunday.range;
module.exports.sundays = $6ef02adb24568350$var$sundays;
var $6ef02adb24568350$var$mondays = $6ef02adb24568350$var$monday.range;
module.exports.mondays = $6ef02adb24568350$var$mondays;
var $6ef02adb24568350$var$tuesdays = $6ef02adb24568350$var$tuesday.range;
module.exports.tuesdays = $6ef02adb24568350$var$tuesdays;
var $6ef02adb24568350$var$wednesdays = $6ef02adb24568350$var$wednesday.range;
module.exports.wednesdays = $6ef02adb24568350$var$wednesdays;
var $6ef02adb24568350$var$thursdays = $6ef02adb24568350$var$thursday.range;
module.exports.thursdays = $6ef02adb24568350$var$thursdays;
var $6ef02adb24568350$var$fridays = $6ef02adb24568350$var$friday.range;
module.exports.fridays = $6ef02adb24568350$var$fridays;
var $6ef02adb24568350$var$saturdays = $6ef02adb24568350$var$saturday.range;
module.exports.saturdays = $6ef02adb24568350$var$saturdays;

});

parcelRegister("eQlmO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $ace67f0a1f8c565a$var$_interval = $ace67f0a1f8c565a$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $ace67f0a1f8c565a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ace67f0a1f8c565a$var$month = (0, $ace67f0a1f8c565a$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $ace67f0a1f8c565a$var$_default = $ace67f0a1f8c565a$var$month;
module.exports.default = $ace67f0a1f8c565a$var$_default;
var $ace67f0a1f8c565a$var$months = $ace67f0a1f8c565a$var$month.range;
module.exports.months = $ace67f0a1f8c565a$var$months;

});

parcelRegister("bCw6g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $875c24b45131705a$var$_interval = $875c24b45131705a$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $875c24b45131705a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $875c24b45131705a$var$year = (0, $875c24b45131705a$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$875c24b45131705a$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $875c24b45131705a$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $875c24b45131705a$var$_default = $875c24b45131705a$var$year;
module.exports.default = $875c24b45131705a$var$_default;
var $875c24b45131705a$var$years = $875c24b45131705a$var$year.range;
module.exports.years = $875c24b45131705a$var$years;

});

parcelRegister("56CHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $3b7b88d507c18b58$var$_interval = $3b7b88d507c18b58$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $3b7b88d507c18b58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b7b88d507c18b58$var$utcMinute = (0, $3b7b88d507c18b58$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationMinute);
}, function(start, end) {
    return (end - start) / $ffS6a.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $3b7b88d507c18b58$var$_default = $3b7b88d507c18b58$var$utcMinute;
module.exports.default = $3b7b88d507c18b58$var$_default;
var $3b7b88d507c18b58$var$utcMinutes = $3b7b88d507c18b58$var$utcMinute.range;
module.exports.utcMinutes = $3b7b88d507c18b58$var$utcMinutes;

});

parcelRegister("4Id0V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $36e55dcbc0be1199$var$_interval = $36e55dcbc0be1199$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $36e55dcbc0be1199$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $36e55dcbc0be1199$var$utcHour = (0, $36e55dcbc0be1199$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $ffS6a.durationHour);
}, function(start, end) {
    return (end - start) / $ffS6a.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $36e55dcbc0be1199$var$_default = $36e55dcbc0be1199$var$utcHour;
module.exports.default = $36e55dcbc0be1199$var$_default;
var $36e55dcbc0be1199$var$utcHours = $36e55dcbc0be1199$var$utcHour.range;
module.exports.utcHours = $36e55dcbc0be1199$var$utcHours;

});

parcelRegister("coaP9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $90501f5dc5e67a5a$var$_interval = $90501f5dc5e67a5a$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $90501f5dc5e67a5a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $90501f5dc5e67a5a$var$utcDay = (0, $90501f5dc5e67a5a$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $ffS6a.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $90501f5dc5e67a5a$var$_default = $90501f5dc5e67a5a$var$utcDay;
module.exports.default = $90501f5dc5e67a5a$var$_default;
var $90501f5dc5e67a5a$var$utcDays = $90501f5dc5e67a5a$var$utcDay.range;
module.exports.utcDays = $90501f5dc5e67a5a$var$utcDays;

});

parcelRegister("gYiWY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $c5b0f30bdebda553$var$_interval = $c5b0f30bdebda553$var$_interopRequireDefault((parcelRequire("9mYsL")));

var $ffS6a = parcelRequire("ffS6a");
function $c5b0f30bdebda553$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c5b0f30bdebda553$var$utcWeekday(i) {
    return (0, $c5b0f30bdebda553$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $ffS6a.durationWeek;
    });
}
var $c5b0f30bdebda553$var$utcSunday = $c5b0f30bdebda553$var$utcWeekday(0);
module.exports.utcSunday = $c5b0f30bdebda553$var$utcSunday;
var $c5b0f30bdebda553$var$utcMonday = $c5b0f30bdebda553$var$utcWeekday(1);
module.exports.utcMonday = $c5b0f30bdebda553$var$utcMonday;
var $c5b0f30bdebda553$var$utcTuesday = $c5b0f30bdebda553$var$utcWeekday(2);
module.exports.utcTuesday = $c5b0f30bdebda553$var$utcTuesday;
var $c5b0f30bdebda553$var$utcWednesday = $c5b0f30bdebda553$var$utcWeekday(3);
module.exports.utcWednesday = $c5b0f30bdebda553$var$utcWednesday;
var $c5b0f30bdebda553$var$utcThursday = $c5b0f30bdebda553$var$utcWeekday(4);
module.exports.utcThursday = $c5b0f30bdebda553$var$utcThursday;
var $c5b0f30bdebda553$var$utcFriday = $c5b0f30bdebda553$var$utcWeekday(5);
module.exports.utcFriday = $c5b0f30bdebda553$var$utcFriday;
var $c5b0f30bdebda553$var$utcSaturday = $c5b0f30bdebda553$var$utcWeekday(6);
module.exports.utcSaturday = $c5b0f30bdebda553$var$utcSaturday;
var $c5b0f30bdebda553$var$utcSundays = $c5b0f30bdebda553$var$utcSunday.range;
module.exports.utcSundays = $c5b0f30bdebda553$var$utcSundays;
var $c5b0f30bdebda553$var$utcMondays = $c5b0f30bdebda553$var$utcMonday.range;
module.exports.utcMondays = $c5b0f30bdebda553$var$utcMondays;
var $c5b0f30bdebda553$var$utcTuesdays = $c5b0f30bdebda553$var$utcTuesday.range;
module.exports.utcTuesdays = $c5b0f30bdebda553$var$utcTuesdays;
var $c5b0f30bdebda553$var$utcWednesdays = $c5b0f30bdebda553$var$utcWednesday.range;
module.exports.utcWednesdays = $c5b0f30bdebda553$var$utcWednesdays;
var $c5b0f30bdebda553$var$utcThursdays = $c5b0f30bdebda553$var$utcThursday.range;
module.exports.utcThursdays = $c5b0f30bdebda553$var$utcThursdays;
var $c5b0f30bdebda553$var$utcFridays = $c5b0f30bdebda553$var$utcFriday.range;
module.exports.utcFridays = $c5b0f30bdebda553$var$utcFridays;
var $c5b0f30bdebda553$var$utcSaturdays = $c5b0f30bdebda553$var$utcSaturday.range;
module.exports.utcSaturdays = $c5b0f30bdebda553$var$utcSaturdays;

});

parcelRegister("15kWX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $0ca6824cb1dfe8de$var$_interval = $0ca6824cb1dfe8de$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $0ca6824cb1dfe8de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0ca6824cb1dfe8de$var$utcMonth = (0, $0ca6824cb1dfe8de$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $0ca6824cb1dfe8de$var$_default = $0ca6824cb1dfe8de$var$utcMonth;
module.exports.default = $0ca6824cb1dfe8de$var$_default;
var $0ca6824cb1dfe8de$var$utcMonths = $0ca6824cb1dfe8de$var$utcMonth.range;
module.exports.utcMonths = $0ca6824cb1dfe8de$var$utcMonths;

});

parcelRegister("bRXUB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $8a431e3bea1d160c$var$_interval = $8a431e3bea1d160c$var$_interopRequireDefault((parcelRequire("9mYsL")));
function $8a431e3bea1d160c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8a431e3bea1d160c$var$utcYear = (0, $8a431e3bea1d160c$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$8a431e3bea1d160c$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $8a431e3bea1d160c$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $8a431e3bea1d160c$var$_default = $8a431e3bea1d160c$var$utcYear;
module.exports.default = $8a431e3bea1d160c$var$_default;
var $8a431e3bea1d160c$var$utcYears = $8a431e3bea1d160c$var$utcYear.range;
module.exports.utcYears = $8a431e3bea1d160c$var$utcYears;

});

parcelRegister("fi2S9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $dfXar = parcelRequire("dfXar");

var $ffS6a = parcelRequire("ffS6a");

var $b21ac3da0cc713d1$var$_millisecond = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("joIgc")));

var $b21ac3da0cc713d1$var$_second = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("emUZs")));

var $b21ac3da0cc713d1$var$_minute = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bWQ0C")));

var $b21ac3da0cc713d1$var$_hour = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("la0bP")));

var $b21ac3da0cc713d1$var$_day = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("8Qo8R")));

var $9wwjs = parcelRequire("9wwjs");

var $b21ac3da0cc713d1$var$_month = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("eQlmO")));

var $b21ac3da0cc713d1$var$_year = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bCw6g")));

var $b21ac3da0cc713d1$var$_utcMinute = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("56CHD")));

var $b21ac3da0cc713d1$var$_utcHour = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("4Id0V")));

var $b21ac3da0cc713d1$var$_utcDay = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("coaP9")));

var $gYiWY = parcelRequire("gYiWY");

var $b21ac3da0cc713d1$var$_utcMonth = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("15kWX")));

var $b21ac3da0cc713d1$var$_utcYear = $b21ac3da0cc713d1$var$_interopRequireDefault((parcelRequire("bRXUB")));
function $b21ac3da0cc713d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b21ac3da0cc713d1$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $b21ac3da0cc713d1$var$_second.default,
            1,
            $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            5,
            5 * $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            15,
            15 * $ffS6a.durationSecond
        ],
        [
            $b21ac3da0cc713d1$var$_second.default,
            30,
            30 * $ffS6a.durationSecond
        ],
        [
            minute,
            1,
            $ffS6a.durationMinute
        ],
        [
            minute,
            5,
            5 * $ffS6a.durationMinute
        ],
        [
            minute,
            15,
            15 * $ffS6a.durationMinute
        ],
        [
            minute,
            30,
            30 * $ffS6a.durationMinute
        ],
        [
            hour,
            1,
            $ffS6a.durationHour
        ],
        [
            hour,
            3,
            3 * $ffS6a.durationHour
        ],
        [
            hour,
            6,
            6 * $ffS6a.durationHour
        ],
        [
            hour,
            12,
            12 * $ffS6a.durationHour
        ],
        [
            day,
            1,
            $ffS6a.durationDay
        ],
        [
            day,
            2,
            2 * $ffS6a.durationDay
        ],
        [
            week,
            1,
            $ffS6a.durationWeek
        ],
        [
            month,
            1,
            $ffS6a.durationMonth
        ],
        [
            month,
            3,
            3 * $ffS6a.durationMonth
        ],
        [
            year,
            1,
            $ffS6a.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $dfXar.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $dfXar.tickStep)(start / $ffS6a.durationYear, stop / $ffS6a.durationYear, count));
        if (i === 0) return $b21ac3da0cc713d1$var$_millisecond.default.every(Math.max((0, $dfXar.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$b21ac3da0cc713d1$var$utcTicks, $b21ac3da0cc713d1$var$utcTickInterval] = $b21ac3da0cc713d1$var$ticker($b21ac3da0cc713d1$var$_utcYear.default, $b21ac3da0cc713d1$var$_utcMonth.default, $gYiWY.utcSunday, $b21ac3da0cc713d1$var$_utcDay.default, $b21ac3da0cc713d1$var$_utcHour.default, $b21ac3da0cc713d1$var$_utcMinute.default);
module.exports.utcTickInterval = $b21ac3da0cc713d1$var$utcTickInterval;
module.exports.utcTicks = $b21ac3da0cc713d1$var$utcTicks;
const [$b21ac3da0cc713d1$var$timeTicks, $b21ac3da0cc713d1$var$timeTickInterval] = $b21ac3da0cc713d1$var$ticker($b21ac3da0cc713d1$var$_year.default, $b21ac3da0cc713d1$var$_month.default, $9wwjs.sunday, $b21ac3da0cc713d1$var$_day.default, $b21ac3da0cc713d1$var$_hour.default, $b21ac3da0cc713d1$var$_minute.default);
module.exports.timeTickInterval = $b21ac3da0cc713d1$var$timeTickInterval;
module.exports.timeTicks = $b21ac3da0cc713d1$var$timeTicks;

});


parcelRegister("allvJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $787c8d25ff9222f8$var$_defaultLocale.utcParse;
    }
});

var $787c8d25ff9222f8$var$_defaultLocale = $787c8d25ff9222f8$var$_interopRequireWildcard((parcelRequire("h4Kh2")));

var $787c8d25ff9222f8$var$_locale = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("4tJEG")));

var $787c8d25ff9222f8$var$_isoFormat = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("im63r")));

var $787c8d25ff9222f8$var$_isoParse = $787c8d25ff9222f8$var$_interopRequireDefault((parcelRequire("1sar7")));
function $787c8d25ff9222f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $787c8d25ff9222f8$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($787c8d25ff9222f8$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $787c8d25ff9222f8$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $787c8d25ff9222f8$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("h4Kh2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c6e6b464710df3ee$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $c6e6b464710df3ee$var$_locale = $c6e6b464710df3ee$var$_interopRequireDefault((parcelRequire("4tJEG")));
function $c6e6b464710df3ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $c6e6b464710df3ee$var$locale;
var $c6e6b464710df3ee$var$timeFormat;
module.exports.timeFormat = $c6e6b464710df3ee$var$timeFormat;
var $c6e6b464710df3ee$var$timeParse;
module.exports.timeParse = $c6e6b464710df3ee$var$timeParse;
var $c6e6b464710df3ee$var$utcFormat;
module.exports.utcFormat = $c6e6b464710df3ee$var$utcFormat;
var $c6e6b464710df3ee$var$utcParse;
module.exports.utcParse = $c6e6b464710df3ee$var$utcParse;
$c6e6b464710df3ee$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $c6e6b464710df3ee$var$defaultLocale(definition) {
    $c6e6b464710df3ee$var$locale = (0, $c6e6b464710df3ee$var$_locale.default)(definition);
    module.exports.timeFormat = $c6e6b464710df3ee$var$timeFormat = $c6e6b464710df3ee$var$locale.format;
    module.exports.timeParse = $c6e6b464710df3ee$var$timeParse = $c6e6b464710df3ee$var$locale.parse;
    module.exports.utcFormat = $c6e6b464710df3ee$var$utcFormat = $c6e6b464710df3ee$var$locale.utcFormat;
    module.exports.utcParse = $c6e6b464710df3ee$var$utcParse = $c6e6b464710df3ee$var$locale.utcParse;
    return $c6e6b464710df3ee$var$locale;
}

});
parcelRegister("4tJEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $342d490293d3c52e$var$formatLocale;

var $2iBJo = parcelRequire("2iBJo");
function $342d490293d3c52e$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $342d490293d3c52e$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $342d490293d3c52e$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $342d490293d3c52e$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $342d490293d3c52e$var$formatRe(locale_periods), periodLookup = $342d490293d3c52e$var$formatLookup(locale_periods), weekdayRe = $342d490293d3c52e$var$formatRe(locale_weekdays), weekdayLookup = $342d490293d3c52e$var$formatLookup(locale_weekdays), shortWeekdayRe = $342d490293d3c52e$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $342d490293d3c52e$var$formatLookup(locale_shortWeekdays), monthRe = $342d490293d3c52e$var$formatRe(locale_months), monthLookup = $342d490293d3c52e$var$formatLookup(locale_months), shortMonthRe = $342d490293d3c52e$var$formatRe(locale_shortMonths), shortMonthLookup = $342d490293d3c52e$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $342d490293d3c52e$var$formatDayOfMonth,
        "e": $342d490293d3c52e$var$formatDayOfMonth,
        "f": $342d490293d3c52e$var$formatMicroseconds,
        "g": $342d490293d3c52e$var$formatYearISO,
        "G": $342d490293d3c52e$var$formatFullYearISO,
        "H": $342d490293d3c52e$var$formatHour24,
        "I": $342d490293d3c52e$var$formatHour12,
        "j": $342d490293d3c52e$var$formatDayOfYear,
        "L": $342d490293d3c52e$var$formatMilliseconds,
        "m": $342d490293d3c52e$var$formatMonthNumber,
        "M": $342d490293d3c52e$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $342d490293d3c52e$var$formatUnixTimestamp,
        "s": $342d490293d3c52e$var$formatUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$formatSeconds,
        "u": $342d490293d3c52e$var$formatWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$formatWeekNumberSunday,
        "V": $342d490293d3c52e$var$formatWeekNumberISO,
        "w": $342d490293d3c52e$var$formatWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $342d490293d3c52e$var$formatYear,
        "Y": $342d490293d3c52e$var$formatFullYear,
        "Z": $342d490293d3c52e$var$formatZone,
        "%": $342d490293d3c52e$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $342d490293d3c52e$var$formatUTCDayOfMonth,
        "e": $342d490293d3c52e$var$formatUTCDayOfMonth,
        "f": $342d490293d3c52e$var$formatUTCMicroseconds,
        "g": $342d490293d3c52e$var$formatUTCYearISO,
        "G": $342d490293d3c52e$var$formatUTCFullYearISO,
        "H": $342d490293d3c52e$var$formatUTCHour24,
        "I": $342d490293d3c52e$var$formatUTCHour12,
        "j": $342d490293d3c52e$var$formatUTCDayOfYear,
        "L": $342d490293d3c52e$var$formatUTCMilliseconds,
        "m": $342d490293d3c52e$var$formatUTCMonthNumber,
        "M": $342d490293d3c52e$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $342d490293d3c52e$var$formatUnixTimestamp,
        "s": $342d490293d3c52e$var$formatUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$formatUTCSeconds,
        "u": $342d490293d3c52e$var$formatUTCWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$formatUTCWeekNumberSunday,
        "V": $342d490293d3c52e$var$formatUTCWeekNumberISO,
        "w": $342d490293d3c52e$var$formatUTCWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $342d490293d3c52e$var$formatUTCYear,
        "Y": $342d490293d3c52e$var$formatUTCFullYear,
        "Z": $342d490293d3c52e$var$formatUTCZone,
        "%": $342d490293d3c52e$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $342d490293d3c52e$var$parseDayOfMonth,
        "e": $342d490293d3c52e$var$parseDayOfMonth,
        "f": $342d490293d3c52e$var$parseMicroseconds,
        "g": $342d490293d3c52e$var$parseYear,
        "G": $342d490293d3c52e$var$parseFullYear,
        "H": $342d490293d3c52e$var$parseHour24,
        "I": $342d490293d3c52e$var$parseHour24,
        "j": $342d490293d3c52e$var$parseDayOfYear,
        "L": $342d490293d3c52e$var$parseMilliseconds,
        "m": $342d490293d3c52e$var$parseMonthNumber,
        "M": $342d490293d3c52e$var$parseMinutes,
        "p": parsePeriod,
        "q": $342d490293d3c52e$var$parseQuarter,
        "Q": $342d490293d3c52e$var$parseUnixTimestamp,
        "s": $342d490293d3c52e$var$parseUnixTimestampSeconds,
        "S": $342d490293d3c52e$var$parseSeconds,
        "u": $342d490293d3c52e$var$parseWeekdayNumberMonday,
        "U": $342d490293d3c52e$var$parseWeekNumberSunday,
        "V": $342d490293d3c52e$var$parseWeekNumberISO,
        "w": $342d490293d3c52e$var$parseWeekdayNumberSunday,
        "W": $342d490293d3c52e$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $342d490293d3c52e$var$parseYear,
        "Y": $342d490293d3c52e$var$parseFullYear,
        "Z": $342d490293d3c52e$var$parseZone,
        "%": $342d490293d3c52e$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $342d490293d3c52e$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $342d490293d3c52e$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $342d490293d3c52e$var$utcDate($342d490293d3c52e$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $2iBJo.utcMonday.ceil(week) : (0, $2iBJo.utcMonday)(week);
                    week = $2iBJo.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $342d490293d3c52e$var$localDate($342d490293d3c52e$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $2iBJo.timeMonday.ceil(week) : (0, $2iBJo.timeMonday)(week);
                    week = $2iBJo.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $342d490293d3c52e$var$utcDate($342d490293d3c52e$var$newDate(d.y, 0, 1)).getUTCDay() : $342d490293d3c52e$var$localDate($342d490293d3c52e$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $342d490293d3c52e$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $342d490293d3c52e$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $342d490293d3c52e$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $342d490293d3c52e$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $342d490293d3c52e$var$numberRe = /^\s*\d+/, // note: ignores next directive
$342d490293d3c52e$var$percentRe = /^%/, $342d490293d3c52e$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $342d490293d3c52e$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $342d490293d3c52e$var$requote(s) {
    return s.replace($342d490293d3c52e$var$requoteRe, "\\$&");
}
function $342d490293d3c52e$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($342d490293d3c52e$var$requote).join("|") + ")", "i");
}
function $342d490293d3c52e$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $342d490293d3c52e$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberSunday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberISO(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseWeekNumberMonday(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseFullYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseQuarter(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMonthNumber(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseDayOfMonth(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseDayOfYear(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseHour24(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMinutes(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseSeconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMilliseconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseMicroseconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseLiteralPercent(d, string, i) {
    var n = $342d490293d3c52e$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $342d490293d3c52e$var$parseUnixTimestamp(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $342d490293d3c52e$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $342d490293d3c52e$var$formatDayOfMonth(d, p) {
    return $342d490293d3c52e$var$pad(d.getDate(), p, 2);
}
function $342d490293d3c52e$var$formatHour24(d, p) {
    return $342d490293d3c52e$var$pad(d.getHours(), p, 2);
}
function $342d490293d3c52e$var$formatHour12(d, p) {
    return $342d490293d3c52e$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $342d490293d3c52e$var$formatDayOfYear(d, p) {
    return $342d490293d3c52e$var$pad(1 + $2iBJo.timeDay.count((0, $2iBJo.timeYear)(d), d), p, 3);
}
function $342d490293d3c52e$var$formatMilliseconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getMilliseconds(), p, 3);
}
function $342d490293d3c52e$var$formatMicroseconds(d, p) {
    return $342d490293d3c52e$var$formatMilliseconds(d, p) + "000";
}
function $342d490293d3c52e$var$formatMonthNumber(d, p) {
    return $342d490293d3c52e$var$pad(d.getMonth() + 1, p, 2);
}
function $342d490293d3c52e$var$formatMinutes(d, p) {
    return $342d490293d3c52e$var$pad(d.getMinutes(), p, 2);
}
function $342d490293d3c52e$var$formatSeconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getSeconds(), p, 2);
}
function $342d490293d3c52e$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $342d490293d3c52e$var$formatWeekNumberSunday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.timeSunday.count((0, $2iBJo.timeYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $2iBJo.timeThursday)(d) : $2iBJo.timeThursday.ceil(d);
}
function $342d490293d3c52e$var$formatWeekNumberISO(d, p) {
    d = $342d490293d3c52e$var$dISO(d);
    return $342d490293d3c52e$var$pad($2iBJo.timeThursday.count((0, $2iBJo.timeYear)(d), d) + ((0, $2iBJo.timeYear)(d).getDay() === 4), p, 2);
}
function $342d490293d3c52e$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $342d490293d3c52e$var$formatWeekNumberMonday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.timeMonday.count((0, $2iBJo.timeYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$formatYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatYearISO(d, p) {
    d = $342d490293d3c52e$var$dISO(d);
    return $342d490293d3c52e$var$pad(d.getFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatFullYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $2iBJo.timeThursday)(d) : $2iBJo.timeThursday.ceil(d);
    return $342d490293d3c52e$var$pad(d.getFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $342d490293d3c52e$var$pad(z / 60 | 0, "0", 2) + $342d490293d3c52e$var$pad(z % 60, "0", 2);
}
function $342d490293d3c52e$var$formatUTCDayOfMonth(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCDate(), p, 2);
}
function $342d490293d3c52e$var$formatUTCHour24(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCHours(), p, 2);
}
function $342d490293d3c52e$var$formatUTCHour12(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $342d490293d3c52e$var$formatUTCDayOfYear(d, p) {
    return $342d490293d3c52e$var$pad(1 + $2iBJo.utcDay.count((0, $2iBJo.utcYear)(d), d), p, 3);
}
function $342d490293d3c52e$var$formatUTCMilliseconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $342d490293d3c52e$var$formatUTCMicroseconds(d, p) {
    return $342d490293d3c52e$var$formatUTCMilliseconds(d, p) + "000";
}
function $342d490293d3c52e$var$formatUTCMonthNumber(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $342d490293d3c52e$var$formatUTCMinutes(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCMinutes(), p, 2);
}
function $342d490293d3c52e$var$formatUTCSeconds(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCSeconds(), p, 2);
}
function $342d490293d3c52e$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $342d490293d3c52e$var$formatUTCWeekNumberSunday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.utcSunday.count((0, $2iBJo.utcYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $2iBJo.utcThursday)(d) : $2iBJo.utcThursday.ceil(d);
}
function $342d490293d3c52e$var$formatUTCWeekNumberISO(d, p) {
    d = $342d490293d3c52e$var$UTCdISO(d);
    return $342d490293d3c52e$var$pad($2iBJo.utcThursday.count((0, $2iBJo.utcYear)(d), d) + ((0, $2iBJo.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $342d490293d3c52e$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $342d490293d3c52e$var$formatUTCWeekNumberMonday(d, p) {
    return $342d490293d3c52e$var$pad($2iBJo.utcMonday.count((0, $2iBJo.utcYear)(d) - 1, d), p, 2);
}
function $342d490293d3c52e$var$formatUTCYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatUTCYearISO(d, p) {
    d = $342d490293d3c52e$var$UTCdISO(d);
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $342d490293d3c52e$var$formatUTCFullYear(d, p) {
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $2iBJo.utcThursday)(d) : $2iBJo.utcThursday.ceil(d);
    return $342d490293d3c52e$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $342d490293d3c52e$var$formatUTCZone() {
    return "+0000";
}
function $342d490293d3c52e$var$formatLiteralPercent() {
    return "%";
}
function $342d490293d3c52e$var$formatUnixTimestamp(d) {
    return +d;
}
function $342d490293d3c52e$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("im63r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $h4Kh2 = parcelRequire("h4Kh2");
var $d5cefa6251d20328$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $d5cefa6251d20328$var$isoSpecifier;
function $d5cefa6251d20328$var$formatIsoNative(date) {
    return date.toISOString();
}
var $d5cefa6251d20328$var$formatIso = Date.prototype.toISOString ? $d5cefa6251d20328$var$formatIsoNative : (0, $h4Kh2.utcFormat)($d5cefa6251d20328$var$isoSpecifier);
var $d5cefa6251d20328$var$_default = $d5cefa6251d20328$var$formatIso;
module.exports.default = $d5cefa6251d20328$var$_default;

});

parcelRegister("1sar7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $im63r = parcelRequire("im63r");

var $h4Kh2 = parcelRequire("h4Kh2");
function $10f080706394d1f7$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $10f080706394d1f7$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $10f080706394d1f7$var$parseIsoNative : (0, $h4Kh2.utcParse)($im63r.isoSpecifier);
var $10f080706394d1f7$var$_default = $10f080706394d1f7$var$parseIso;
module.exports.default = $10f080706394d1f7$var$_default;

});



parcelRegister("k0gY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e900f8151d80ea00$var$utcTime;

var $2iBJo = parcelRequire("2iBJo");

var $allvJ = parcelRequire("allvJ");

var $3lv9c = parcelRequire("3lv9c");

var $ezRKk = parcelRequire("ezRKk");
function $e900f8151d80ea00$var$utcTime() {
    return $ezRKk.initRange.apply((0, $3lv9c.calendar)($2iBJo.utcTicks, $2iBJo.utcTickInterval, $2iBJo.utcYear, $2iBJo.utcMonth, $2iBJo.utcWeek, $2iBJo.utcDay, $2iBJo.utcHour, $2iBJo.utcMinute, $2iBJo.utcSecond, $allvJ.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("bo5gu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $84a6051f316b5ae4$var$copy;
module.exports.default = $84a6051f316b5ae4$var$sequential;
module.exports.sequentialLog = $84a6051f316b5ae4$var$sequentialLog;
module.exports.sequentialPow = $84a6051f316b5ae4$var$sequentialPow;
module.exports.sequentialSqrt = $84a6051f316b5ae4$var$sequentialSqrt;
module.exports.sequentialSymlog = $84a6051f316b5ae4$var$sequentialSymlog;

var $84oZu = parcelRequire("84oZu");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $cw7m0 = parcelRequire("cw7m0");

var $3DXgb = parcelRequire("3DXgb");

var $6kjWv = parcelRequire("6kjWv");
function $84a6051f316b5ae4$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $kcPbm.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($84oZu.interpolate);
    scale.rangeRound = range($84oZu.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $84a6051f316b5ae4$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $84a6051f316b5ae4$var$sequential() {
    var scale = (0, $8cBoe.linearish)($84a6051f316b5ae4$var$transformer()($kcPbm.identity));
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequential());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialLog() {
    var scale = (0, $cw7m0.loggish)($84a6051f316b5ae4$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialLog()).base(scale.base());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialSymlog() {
    var scale = (0, $3DXgb.symlogish)($84a6051f316b5ae4$var$transformer());
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialSymlog()).constant(scale.constant());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialPow() {
    var scale = (0, $6kjWv.powish)($84a6051f316b5ae4$var$transformer());
    scale.copy = function() {
        return $84a6051f316b5ae4$var$copy(scale, $84a6051f316b5ae4$var$sequentialPow()).exponent(scale.exponent());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $84a6051f316b5ae4$var$sequentialSqrt() {
    return $84a6051f316b5ae4$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("5yyjd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $40babdc73d4c4272$var$sequentialQuantile;

var $dfXar = parcelRequire("dfXar");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");
function $40babdc73d4c4272$var$sequentialQuantile() {
    var domain = [], interpolator = $kcPbm.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $dfXar.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($dfXar.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $dfXar.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $40babdc73d4c4272$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("8db3Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5fa81e918fa865b9$var$diverging;
module.exports.divergingLog = $5fa81e918fa865b9$var$divergingLog;
module.exports.divergingPow = $5fa81e918fa865b9$var$divergingPow;
module.exports.divergingSqrt = $5fa81e918fa865b9$var$divergingSqrt;
module.exports.divergingSymlog = $5fa81e918fa865b9$var$divergingSymlog;

var $84oZu = parcelRequire("84oZu");

var $kcPbm = parcelRequire("kcPbm");

var $ezRKk = parcelRequire("ezRKk");

var $8cBoe = parcelRequire("8cBoe");

var $cw7m0 = parcelRequire("cw7m0");

var $bo5gu = parcelRequire("bo5gu");

var $3DXgb = parcelRequire("3DXgb");

var $6kjWv = parcelRequire("6kjWv");
function $5fa81e918fa865b9$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $kcPbm.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $84oZu.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($84oZu.interpolate);
    scale.rangeRound = range($84oZu.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $5fa81e918fa865b9$var$diverging() {
    var scale = (0, $8cBoe.linearish)($5fa81e918fa865b9$var$transformer()($kcPbm.identity));
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$diverging());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingLog() {
    var scale = (0, $cw7m0.loggish)($5fa81e918fa865b9$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingLog()).base(scale.base());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingSymlog() {
    var scale = (0, $3DXgb.symlogish)($5fa81e918fa865b9$var$transformer());
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingSymlog()).constant(scale.constant());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingPow() {
    var scale = (0, $6kjWv.powish)($5fa81e918fa865b9$var$transformer());
    scale.copy = function() {
        return (0, $bo5gu.copy)(scale, $5fa81e918fa865b9$var$divergingPow()).exponent(scale.exponent());
    };
    return $ezRKk.initInterpolator.apply(scale, arguments);
}
function $5fa81e918fa865b9$var$divergingSqrt() {
    return $5fa81e918fa865b9$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("jR8B9", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("c7qvc"));

});
parcelRegister("c7qvc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $7pWof.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $7pWof.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $eg4Yo.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $eg4Yo.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $1a7us.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $1a7us.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $1a7us.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $1a7us.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $8d2ab249534730b9$var$_symbol.symbolsStroke;
    }
});

var $8d2ab249534730b9$var$_arc = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("hb8pW")));

var $8d2ab249534730b9$var$_area = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2mXKD")));

var $8d2ab249534730b9$var$_line = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aPa75")));

var $8d2ab249534730b9$var$_pie = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("fMagQ")));

var $8d2ab249534730b9$var$_areaRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("62Jmo")));

var $8d2ab249534730b9$var$_lineRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("gWd5A")));

var $8d2ab249534730b9$var$_pointRadial = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("i3JLJ")));

var $1a7us = parcelRequire("1a7us");

var $8d2ab249534730b9$var$_symbol = $8d2ab249534730b9$var$_interopRequireWildcard((parcelRequire("erM6A")));

var $8d2ab249534730b9$var$_asterisk = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("kGig7")));

var $8d2ab249534730b9$var$_circle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aoOCn")));

var $8d2ab249534730b9$var$_cross = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("inanL")));

var $8d2ab249534730b9$var$_diamond = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("brlrK")));

var $8d2ab249534730b9$var$_diamond2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("uApSn")));

var $8d2ab249534730b9$var$_plus = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lqFon")));

var $8d2ab249534730b9$var$_square = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lgQfD")));

var $8d2ab249534730b9$var$_square2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("hazlA")));

var $8d2ab249534730b9$var$_star = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5Q2TJ")));

var $8d2ab249534730b9$var$_triangle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5KhNy")));

var $8d2ab249534730b9$var$_triangle2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("1SPqJ")));

var $8d2ab249534730b9$var$_wye = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2Qn8y")));

var $8d2ab249534730b9$var$_x = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lbWiU")));

var $8d2ab249534730b9$var$_basisClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3Rs2W")));

var $8d2ab249534730b9$var$_basisOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("6nSQ2")));

var $8d2ab249534730b9$var$_basis = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("5Qhl2")));

var $7pWof = parcelRequire("7pWof");

var $8d2ab249534730b9$var$_bundle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3Z7fr")));

var $8d2ab249534730b9$var$_cardinalClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("2as13")));

var $8d2ab249534730b9$var$_cardinalOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jxpZF")));

var $8d2ab249534730b9$var$_cardinal = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("8eKmz")));

var $8d2ab249534730b9$var$_catmullRomClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jbHfS")));

var $8d2ab249534730b9$var$_catmullRomOpen = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("keMhD")));

var $8d2ab249534730b9$var$_catmullRom = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("lCdlx")));

var $8d2ab249534730b9$var$_linearClosed = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("aQUVY")));

var $8d2ab249534730b9$var$_linear = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("d5sso")));

var $eg4Yo = parcelRequire("eg4Yo");

var $8d2ab249534730b9$var$_natural = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("er2IE")));

var $8d2ab249534730b9$var$_step = $8d2ab249534730b9$var$_interopRequireWildcard((parcelRequire("dvzIZ")));

var $8d2ab249534730b9$var$_stack = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("31wXu")));

var $8d2ab249534730b9$var$_expand = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("jmoE1")));

var $8d2ab249534730b9$var$_diverging = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("f0DEq")));

var $8d2ab249534730b9$var$_none = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3ECyH")));

var $8d2ab249534730b9$var$_silhouette = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("9owud")));

var $8d2ab249534730b9$var$_wiggle = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("kJmkn")));

var $8d2ab249534730b9$var$_appearance = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("cMxJq")));

var $8d2ab249534730b9$var$_ascending = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("7OIkp")));

var $8d2ab249534730b9$var$_descending = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("bl2N4")));

var $8d2ab249534730b9$var$_insideOut = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("ino5x")));

var $8d2ab249534730b9$var$_none2 = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("3MXBI")));

var $8d2ab249534730b9$var$_reverse = $8d2ab249534730b9$var$_interopRequireDefault((parcelRequire("nTFR3")));
function $8d2ab249534730b9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8d2ab249534730b9$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8d2ab249534730b9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8d2ab249534730b9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8d2ab249534730b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hb8pW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c819fe4b3989a3f7$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $c819fe4b3989a3f7$var$_constant = $c819fe4b3989a3f7$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $6SVxd = parcelRequire("6SVxd");
function $c819fe4b3989a3f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c819fe4b3989a3f7$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $c819fe4b3989a3f7$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $c819fe4b3989a3f7$var$arcStartAngle(d) {
    return d.startAngle;
}
function $c819fe4b3989a3f7$var$arcEndAngle(d) {
    return d.endAngle;
}
function $c819fe4b3989a3f7$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $c819fe4b3989a3f7$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $6SVxd.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $c819fe4b3989a3f7$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $6SVxd.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $6SVxd.sqrt)((0, $6SVxd.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $c819fe4b3989a3f7$var$_default() {
    var innerRadius = $c819fe4b3989a3f7$var$arcInnerRadius, outerRadius = $c819fe4b3989a3f7$var$arcOuterRadius, cornerRadius = (0, $c819fe4b3989a3f7$var$_constant.default)(0), padRadius = null, startAngle = $c819fe4b3989a3f7$var$arcStartAngle, endAngle = $c819fe4b3989a3f7$var$arcEndAngle, padAngle = $c819fe4b3989a3f7$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $6SVxd.halfPi, a1 = endAngle.apply(this, arguments) - $6SVxd.halfPi, da = (0, $6SVxd.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $e1EIs.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $6SVxd.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $6SVxd.tau - $6SVxd.epsilon) {
            context.moveTo(r1 * (0, $6SVxd.cos)(a0), r1 * (0, $6SVxd.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $6SVxd.epsilon) {
                context.moveTo(r0 * (0, $6SVxd.cos)(a1), r0 * (0, $6SVxd.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $6SVxd.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $6SVxd.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $6SVxd.min)((0, $6SVxd.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $6SVxd.epsilon) {
                var p0 = (0, $6SVxd.asin)(rp / r0 * (0, $6SVxd.sin)(ap)), p1 = (0, $6SVxd.asin)(rp / r1 * (0, $6SVxd.sin)(ap));
                if ((da0 -= p0 * 2) > $6SVxd.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $6SVxd.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $6SVxd.cos)(a01), y01 = r1 * (0, $6SVxd.sin)(a01), x10 = r0 * (0, $6SVxd.cos)(a10), y10 = r0 * (0, $6SVxd.sin)(a10); // Apply rounded corners?
            if (rc > $6SVxd.epsilon) {
                var x11 = r1 * (0, $6SVxd.cos)(a11), y11 = r1 * (0, $6SVxd.sin)(a11), x00 = r0 * (0, $6SVxd.cos)(a00), y00 = r0 * (0, $6SVxd.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $6SVxd.pi && (oc = $c819fe4b3989a3f7$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $6SVxd.sin)((0, $6SVxd.acos)((ax * bx + ay * by) / ((0, $6SVxd.sqrt)(ax * ax + ay * ay) * (0, $6SVxd.sqrt)(bx * bx + by * by))) / 2), lc = (0, $6SVxd.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $6SVxd.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $6SVxd.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $6SVxd.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $6SVxd.epsilon) {
                t0 = $c819fe4b3989a3f7$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $c819fe4b3989a3f7$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $6SVxd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6SVxd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $6SVxd.atan2)(t1.y11, t1.x11), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $6SVxd.epsilon) || !(da0 > $6SVxd.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $6SVxd.epsilon) {
                t0 = $c819fe4b3989a3f7$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $c819fe4b3989a3f7$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $6SVxd.atan2)(t0.y01, t0.x01), (0, $6SVxd.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $6SVxd.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $6SVxd.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $6SVxd.atan2)(t1.y11, t1.x11), (0, $6SVxd.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $6SVxd.pi / 2;
        return [
            (0, $6SVxd.cos)(a) * r,
            (0, $6SVxd.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $c819fe4b3989a3f7$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("e1EIs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $a360be0c9ee1c708$var$_path.default;
    }
});

var $a360be0c9ee1c708$var$_path = $a360be0c9ee1c708$var$_interopRequireDefault((parcelRequire("a0aX6")));
function $a360be0c9ee1c708$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("a0aX6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $7482665b9d11f335$var$pi = Math.PI, $7482665b9d11f335$var$tau = 2 * $7482665b9d11f335$var$pi, $7482665b9d11f335$var$epsilon = 1e-6, $7482665b9d11f335$var$tauEpsilon = $7482665b9d11f335$var$tau - $7482665b9d11f335$var$epsilon;
function $7482665b9d11f335$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $7482665b9d11f335$var$path() {
    return new $7482665b9d11f335$var$Path();
}
$7482665b9d11f335$var$Path.prototype = $7482665b9d11f335$var$path.prototype = {
    constructor: $7482665b9d11f335$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $7482665b9d11f335$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $7482665b9d11f335$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($7482665b9d11f335$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $7482665b9d11f335$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $7482665b9d11f335$var$epsilon || Math.abs(this._y1 - y0) > $7482665b9d11f335$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $7482665b9d11f335$var$tau + $7482665b9d11f335$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $7482665b9d11f335$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $7482665b9d11f335$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $7482665b9d11f335$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $7482665b9d11f335$var$_default = $7482665b9d11f335$var$path;
module.exports.default = $7482665b9d11f335$var$_default;

});


parcelRegister("aMcNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7d8851d01781858f$var$_default;
function $7d8851d01781858f$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("6SVxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $50346a708aec5d4c$var$acos;
module.exports.asin = $50346a708aec5d4c$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $50346a708aec5d4c$var$abs = Math.abs;
module.exports.abs = $50346a708aec5d4c$var$abs;
const $50346a708aec5d4c$var$atan2 = Math.atan2;
module.exports.atan2 = $50346a708aec5d4c$var$atan2;
const $50346a708aec5d4c$var$cos = Math.cos;
module.exports.cos = $50346a708aec5d4c$var$cos;
const $50346a708aec5d4c$var$max = Math.max;
module.exports.max = $50346a708aec5d4c$var$max;
const $50346a708aec5d4c$var$min = Math.min;
module.exports.min = $50346a708aec5d4c$var$min;
const $50346a708aec5d4c$var$sin = Math.sin;
module.exports.sin = $50346a708aec5d4c$var$sin;
const $50346a708aec5d4c$var$sqrt = Math.sqrt;
module.exports.sqrt = $50346a708aec5d4c$var$sqrt;
const $50346a708aec5d4c$var$epsilon = 1e-12;
module.exports.epsilon = $50346a708aec5d4c$var$epsilon;
const $50346a708aec5d4c$var$pi = Math.PI;
module.exports.pi = $50346a708aec5d4c$var$pi;
const $50346a708aec5d4c$var$halfPi = $50346a708aec5d4c$var$pi / 2;
module.exports.halfPi = $50346a708aec5d4c$var$halfPi;
const $50346a708aec5d4c$var$tau = 2 * $50346a708aec5d4c$var$pi;
module.exports.tau = $50346a708aec5d4c$var$tau;
function $50346a708aec5d4c$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $50346a708aec5d4c$var$pi : Math.acos(x);
}
function $50346a708aec5d4c$var$asin(x) {
    return x >= 1 ? $50346a708aec5d4c$var$halfPi : x <= -1 ? -$50346a708aec5d4c$var$halfPi : Math.asin(x);
}

});


parcelRegister("2mXKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b9bfc3223355168$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $1b9bfc3223355168$var$_array = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("6svIw")));

var $1b9bfc3223355168$var$_constant = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $1b9bfc3223355168$var$_linear = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("d5sso")));

var $1b9bfc3223355168$var$_line = $1b9bfc3223355168$var$_interopRequireDefault((parcelRequire("aPa75")));

var $j6qtD = parcelRequire("j6qtD");
function $1b9bfc3223355168$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1b9bfc3223355168$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $1b9bfc3223355168$var$_constant.default)(true), context = null, curve = $1b9bfc3223355168$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $j6qtD.x : (0, $1b9bfc3223355168$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $1b9bfc3223355168$var$_constant.default)(0) : (0, $1b9bfc3223355168$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $j6qtD.y : (0, $1b9bfc3223355168$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $1b9bfc3223355168$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $1b9bfc3223355168$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $1b9bfc3223355168$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("6svIw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b3df5f65b06abb7$var$_default;
module.exports.slice = void 0;
var $4b3df5f65b06abb7$var$slice = Array.prototype.slice;
module.exports.slice = $4b3df5f65b06abb7$var$slice;
function $4b3df5f65b06abb7$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("d5sso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9871d0eed2325e7c$var$_default;
function $9871d0eed2325e7c$var$Linear(context) {
    this._context = context;
}
$9871d0eed2325e7c$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $9871d0eed2325e7c$var$_default(context) {
    return new $9871d0eed2325e7c$var$Linear(context);
}

});

parcelRegister("aPa75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e16831311f98076$var$_default;

var $e1EIs = parcelRequire("e1EIs");

var $7e16831311f98076$var$_array = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("6svIw")));

var $7e16831311f98076$var$_constant = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $7e16831311f98076$var$_linear = $7e16831311f98076$var$_interopRequireDefault((parcelRequire("d5sso")));

var $j6qtD = parcelRequire("j6qtD");
function $7e16831311f98076$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e16831311f98076$var$_default(x, y) {
    var defined = (0, $7e16831311f98076$var$_constant.default)(true), context = null, curve = $7e16831311f98076$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $j6qtD.x : (0, $7e16831311f98076$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $j6qtD.y : (0, $7e16831311f98076$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $7e16831311f98076$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $7e16831311f98076$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("j6qtD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $de831da31114a4ea$var$x;
module.exports.y = $de831da31114a4ea$var$y;
function $de831da31114a4ea$var$x(p) {
    return p[0];
}
function $de831da31114a4ea$var$y(p) {
    return p[1];
}

});



parcelRegister("fMagQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7c34e4493eeeabc$var$_default;

var $b7c34e4493eeeabc$var$_array = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("6svIw")));

var $b7c34e4493eeeabc$var$_constant = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $b7c34e4493eeeabc$var$_descending = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("9PbYZ")));

var $b7c34e4493eeeabc$var$_identity = $b7c34e4493eeeabc$var$_interopRequireDefault((parcelRequire("6DLHe")));

var $6SVxd = parcelRequire("6SVxd");
function $b7c34e4493eeeabc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b7c34e4493eeeabc$var$_default() {
    var value = $b7c34e4493eeeabc$var$_identity.default, sortValues = $b7c34e4493eeeabc$var$_descending.default, sort = null, startAngle = (0, $b7c34e4493eeeabc$var$_constant.default)(0), endAngle = (0, $b7c34e4493eeeabc$var$_constant.default)($6SVxd.tau), padAngle = (0, $b7c34e4493eeeabc$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $b7c34e4493eeeabc$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($6SVxd.tau, Math.max(-$6SVxd.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $b7c34e4493eeeabc$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("9PbYZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72722bfa77121463$var$_default;
function $72722bfa77121463$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("6DLHe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d5b620f12ffdaf0$var$_default;
function $4d5b620f12ffdaf0$var$_default(d) {
    return d;
}

});


parcelRegister("62Jmo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $46661d933a646095$var$_default;

var $46661d933a646095$var$_radial = $46661d933a646095$var$_interopRequireWildcard((parcelRequire("cxTQC")));

var $46661d933a646095$var$_area = $46661d933a646095$var$_interopRequireDefault((parcelRequire("2mXKD")));

var $gWd5A = parcelRequire("gWd5A");
function $46661d933a646095$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $46661d933a646095$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($46661d933a646095$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $46661d933a646095$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $46661d933a646095$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $46661d933a646095$var$_default() {
    var a = (0, $46661d933a646095$var$_area.default)().curve($46661d933a646095$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $gWd5A.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $gWd5A.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $gWd5A.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $gWd5A.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $46661d933a646095$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("cxTQC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $9223e34472d5d74a$var$curveRadial;

var $9223e34472d5d74a$var$_linear = $9223e34472d5d74a$var$_interopRequireDefault((parcelRequire("d5sso")));
function $9223e34472d5d74a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9223e34472d5d74a$var$curveRadialLinear = $9223e34472d5d74a$var$curveRadial($9223e34472d5d74a$var$_linear.default);
module.exports.curveRadialLinear = $9223e34472d5d74a$var$curveRadialLinear;
function $9223e34472d5d74a$var$Radial(curve) {
    this._curve = curve;
}
$9223e34472d5d74a$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $9223e34472d5d74a$var$curveRadial(curve) {
    function radial(context) {
        return new $9223e34472d5d74a$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("gWd5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c54c375a12146d14$var$_default;
module.exports.lineRadial = $c54c375a12146d14$var$lineRadial;

var $c54c375a12146d14$var$_radial = $c54c375a12146d14$var$_interopRequireWildcard((parcelRequire("cxTQC")));

var $c54c375a12146d14$var$_line = $c54c375a12146d14$var$_interopRequireDefault((parcelRequire("aPa75")));
function $c54c375a12146d14$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c54c375a12146d14$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c54c375a12146d14$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c54c375a12146d14$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c54c375a12146d14$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c54c375a12146d14$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $c54c375a12146d14$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $c54c375a12146d14$var$_default() {
    return $c54c375a12146d14$var$lineRadial((0, $c54c375a12146d14$var$_line.default)().curve($c54c375a12146d14$var$_radial.curveRadialLinear));
}

});


parcelRegister("i3JLJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d25c02916fab152d$var$_default;
function $d25c02916fab152d$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("1a7us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $0d8c8904acfd0d6a$var$link;
module.exports.linkHorizontal = $0d8c8904acfd0d6a$var$linkHorizontal;
module.exports.linkRadial = $0d8c8904acfd0d6a$var$linkRadial;
module.exports.linkVertical = $0d8c8904acfd0d6a$var$linkVertical;

var $e1EIs = parcelRequire("e1EIs");

var $6svIw = parcelRequire("6svIw");

var $0d8c8904acfd0d6a$var$_constant = $0d8c8904acfd0d6a$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $7pWof = parcelRequire("7pWof");

var $j6qtD = parcelRequire("j6qtD");
function $0d8c8904acfd0d6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0d8c8904acfd0d6a$var$linkSource(d) {
    return d.source;
}
function $0d8c8904acfd0d6a$var$linkTarget(d) {
    return d.target;
}
function $0d8c8904acfd0d6a$var$link(curve) {
    let source = $0d8c8904acfd0d6a$var$linkSource;
    let target = $0d8c8904acfd0d6a$var$linkTarget;
    let x = $j6qtD.x;
    let y = $j6qtD.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $6svIw.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $e1EIs.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $0d8c8904acfd0d6a$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $0d8c8904acfd0d6a$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $0d8c8904acfd0d6a$var$linkHorizontal() {
    return $0d8c8904acfd0d6a$var$link($7pWof.bumpX);
}
function $0d8c8904acfd0d6a$var$linkVertical() {
    return $0d8c8904acfd0d6a$var$link($7pWof.bumpY);
}
function $0d8c8904acfd0d6a$var$linkRadial() {
    const l = $0d8c8904acfd0d6a$var$link($7pWof.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("7pWof", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $5668293e7000ce9d$var$bumpRadial;
module.exports.bumpX = $5668293e7000ce9d$var$bumpX;
module.exports.bumpY = $5668293e7000ce9d$var$bumpY;

var $5668293e7000ce9d$var$_pointRadial = $5668293e7000ce9d$var$_interopRequireDefault((parcelRequire("i3JLJ")));
function $5668293e7000ce9d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $5668293e7000ce9d$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $5668293e7000ce9d$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $5668293e7000ce9d$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $5668293e7000ce9d$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $5668293e7000ce9d$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $5668293e7000ce9d$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $5668293e7000ce9d$var$bumpX(context) {
    return new $5668293e7000ce9d$var$Bump(context, true);
}
function $5668293e7000ce9d$var$bumpY(context) {
    return new $5668293e7000ce9d$var$Bump(context, false);
}
function $5668293e7000ce9d$var$bumpRadial(context) {
    return new $5668293e7000ce9d$var$BumpRadial(context);
}

});


parcelRegister("erM6A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a848e700ac23b717$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $e1EIs = parcelRequire("e1EIs");

var $a848e700ac23b717$var$_constant = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $a848e700ac23b717$var$_asterisk = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("kGig7")));

var $a848e700ac23b717$var$_circle = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("aoOCn")));

var $a848e700ac23b717$var$_cross = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("inanL")));

var $a848e700ac23b717$var$_diamond = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("brlrK")));

var $a848e700ac23b717$var$_diamond2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("uApSn")));

var $a848e700ac23b717$var$_plus = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lqFon")));

var $a848e700ac23b717$var$_square = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lgQfD")));

var $a848e700ac23b717$var$_square2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("hazlA")));

var $a848e700ac23b717$var$_star = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("5Q2TJ")));

var $a848e700ac23b717$var$_triangle = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("5KhNy")));

var $a848e700ac23b717$var$_triangle2 = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("1SPqJ")));

var $a848e700ac23b717$var$_wye = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("2Qn8y")));

var $a848e700ac23b717$var$_x = $a848e700ac23b717$var$_interopRequireDefault((parcelRequire("lbWiU")));
function $a848e700ac23b717$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $a848e700ac23b717$var$symbolsFill = [
    $a848e700ac23b717$var$_circle.default,
    $a848e700ac23b717$var$_cross.default,
    $a848e700ac23b717$var$_diamond.default,
    $a848e700ac23b717$var$_square.default,
    $a848e700ac23b717$var$_star.default,
    $a848e700ac23b717$var$_triangle.default,
    $a848e700ac23b717$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $a848e700ac23b717$var$symbolsFill;
const $a848e700ac23b717$var$symbolsStroke = [
    $a848e700ac23b717$var$_circle.default,
    $a848e700ac23b717$var$_plus.default,
    $a848e700ac23b717$var$_x.default,
    $a848e700ac23b717$var$_triangle2.default,
    $a848e700ac23b717$var$_asterisk.default,
    $a848e700ac23b717$var$_square2.default,
    $a848e700ac23b717$var$_diamond2.default
];
module.exports.symbolsStroke = $a848e700ac23b717$var$symbolsStroke;
function $a848e700ac23b717$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $a848e700ac23b717$var$_constant.default)(type || $a848e700ac23b717$var$_circle.default);
    size = typeof size === "function" ? size : (0, $a848e700ac23b717$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $e1EIs.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $a848e700ac23b717$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $a848e700ac23b717$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("kGig7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $f0e5e4b9cf05227e$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $f0e5e4b9cf05227e$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size + (0, $6SVxd.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $f0e5e4b9cf05227e$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $f0e5e4b9cf05227e$var$_default;

});

parcelRegister("aoOCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $792368f3690fafa3$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / $6SVxd.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $6SVxd.tau);
    }
};
module.exports.default = $792368f3690fafa3$var$_default;

});

parcelRegister("inanL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $d6026db0f1f69073$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $d6026db0f1f69073$var$_default;

});

parcelRegister("brlrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $8542da2adf472f40$var$tan30 = (0, $6SVxd.sqrt)(1 / 3);
const $8542da2adf472f40$var$tan30_2 = $8542da2adf472f40$var$tan30 * 2;
var $8542da2adf472f40$var$_default = {
    draw (context, size) {
        const y = (0, $6SVxd.sqrt)(size / $8542da2adf472f40$var$tan30_2);
        const x = y * $8542da2adf472f40$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $8542da2adf472f40$var$_default;

});

parcelRegister("uApSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $05bf0cfc8875f816$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $05bf0cfc8875f816$var$_default;

});

parcelRegister("lqFon", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f99c224eb9831c89$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size - (0, $6SVxd.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $f99c224eb9831c89$var$_default;

});

parcelRegister("lgQfD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f7c39f9aaff8637d$var$_default = {
    draw (context, size) {
        const w = (0, $6SVxd.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $f7c39f9aaff8637d$var$_default;

});

parcelRegister("hazlA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $c7feca11638fe8ed$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c7feca11638fe8ed$var$_default;

});

parcelRegister("5Q2TJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $44040e8b5fb88313$var$ka = 0.89081309152928522810;
const $44040e8b5fb88313$var$kr = (0, $6SVxd.sin)($6SVxd.pi / 10) / (0, $6SVxd.sin)(7 * $6SVxd.pi / 10);
const $44040e8b5fb88313$var$kx = (0, $6SVxd.sin)($6SVxd.tau / 10) * $44040e8b5fb88313$var$kr;
const $44040e8b5fb88313$var$ky = -(0, $6SVxd.cos)($6SVxd.tau / 10) * $44040e8b5fb88313$var$kr;
var $44040e8b5fb88313$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size * $44040e8b5fb88313$var$ka);
        const x = $44040e8b5fb88313$var$kx * r;
        const y = $44040e8b5fb88313$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $6SVxd.tau * i / 5;
            const c = (0, $6SVxd.cos)(a);
            const s = (0, $6SVxd.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $44040e8b5fb88313$var$_default;

});

parcelRegister("5KhNy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $42ef0dff45ed70d1$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $42ef0dff45ed70d1$var$_default = {
    draw (context, size) {
        const y = -(0, $6SVxd.sqrt)(size / ($42ef0dff45ed70d1$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$42ef0dff45ed70d1$var$sqrt3 * y, -y);
        context.lineTo($42ef0dff45ed70d1$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $42ef0dff45ed70d1$var$_default;

});

parcelRegister("1SPqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $15f2ba8f76592b22$var$sqrt3 = (0, $6SVxd.sqrt)(3);
var $15f2ba8f76592b22$var$_default = {
    draw (context, size) {
        const s = (0, $6SVxd.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $15f2ba8f76592b22$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $15f2ba8f76592b22$var$_default;

});

parcelRegister("2Qn8y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
const $212262a3cf40a3de$var$c = -0.5;
const $212262a3cf40a3de$var$s = (0, $6SVxd.sqrt)(3) / 2;
const $212262a3cf40a3de$var$k = 1 / (0, $6SVxd.sqrt)(12);
const $212262a3cf40a3de$var$a = ($212262a3cf40a3de$var$k / 2 + 1) * 3;
var $212262a3cf40a3de$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size / $212262a3cf40a3de$var$a);
        const x0 = r / 2, y0 = r * $212262a3cf40a3de$var$k;
        const x1 = x0, y1 = r * $212262a3cf40a3de$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($212262a3cf40a3de$var$c * x0 - $212262a3cf40a3de$var$s * y0, $212262a3cf40a3de$var$s * x0 + $212262a3cf40a3de$var$c * y0);
        context.lineTo($212262a3cf40a3de$var$c * x1 - $212262a3cf40a3de$var$s * y1, $212262a3cf40a3de$var$s * x1 + $212262a3cf40a3de$var$c * y1);
        context.lineTo($212262a3cf40a3de$var$c * x2 - $212262a3cf40a3de$var$s * y2, $212262a3cf40a3de$var$s * x2 + $212262a3cf40a3de$var$c * y2);
        context.lineTo($212262a3cf40a3de$var$c * x0 + $212262a3cf40a3de$var$s * y0, $212262a3cf40a3de$var$c * y0 - $212262a3cf40a3de$var$s * x0);
        context.lineTo($212262a3cf40a3de$var$c * x1 + $212262a3cf40a3de$var$s * y1, $212262a3cf40a3de$var$c * y1 - $212262a3cf40a3de$var$s * x1);
        context.lineTo($212262a3cf40a3de$var$c * x2 + $212262a3cf40a3de$var$s * y2, $212262a3cf40a3de$var$c * y2 - $212262a3cf40a3de$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $212262a3cf40a3de$var$_default;

});

parcelRegister("lbWiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6SVxd = parcelRequire("6SVxd");
var $f6d7da02fb1195bd$var$_default = {
    draw (context, size) {
        const r = (0, $6SVxd.sqrt)(size - (0, $6SVxd.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $f6d7da02fb1195bd$var$_default;

});


parcelRegister("3Rs2W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2cfc13c3e6f008f4$var$_default;

var $2cfc13c3e6f008f4$var$_noop = $2cfc13c3e6f008f4$var$_interopRequireDefault((parcelRequire("DwreA")));

var $5Qhl2 = parcelRequire("5Qhl2");
function $2cfc13c3e6f008f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2cfc13c3e6f008f4$var$BasisClosed(context) {
    this._context = context;
}
$2cfc13c3e6f008f4$var$BasisClosed.prototype = {
    areaStart: $2cfc13c3e6f008f4$var$_noop.default,
    areaEnd: $2cfc13c3e6f008f4$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $5Qhl2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2cfc13c3e6f008f4$var$_default(context) {
    return new $2cfc13c3e6f008f4$var$BasisClosed(context);
}

});
parcelRegister("DwreA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $076cce322a7018d3$var$_default;
function $076cce322a7018d3$var$_default() {}

});

parcelRegister("5Qhl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $440f421e1a553982$var$Basis;
module.exports.default = $440f421e1a553982$var$_default;
module.exports.point = $440f421e1a553982$var$point;
function $440f421e1a553982$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $440f421e1a553982$var$Basis(context) {
    this._context = context;
}
$440f421e1a553982$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $440f421e1a553982$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $440f421e1a553982$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $440f421e1a553982$var$_default(context) {
    return new $440f421e1a553982$var$Basis(context);
}

});


parcelRegister("6nSQ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a5f6dcc082043c8$var$_default;

var $5Qhl2 = parcelRequire("5Qhl2");
function $4a5f6dcc082043c8$var$BasisOpen(context) {
    this._context = context;
}
$4a5f6dcc082043c8$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $5Qhl2.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $4a5f6dcc082043c8$var$_default(context) {
    return new $4a5f6dcc082043c8$var$BasisOpen(context);
}

});

parcelRegister("3Z7fr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5Qhl2 = parcelRequire("5Qhl2");
function $2e6cb0e614239711$var$Bundle(context, beta) {
    this._basis = new $5Qhl2.Basis(context);
    this._beta = beta;
}
$2e6cb0e614239711$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $2e6cb0e614239711$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $5Qhl2.Basis(context) : new $2e6cb0e614239711$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $2e6cb0e614239711$var$_default;

});

parcelRegister("2as13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $19423f507cbf8f17$var$CardinalClosed;
module.exports.default = void 0;

var $19423f507cbf8f17$var$_noop = $19423f507cbf8f17$var$_interopRequireDefault((parcelRequire("DwreA")));

var $8eKmz = parcelRequire("8eKmz");
function $19423f507cbf8f17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $19423f507cbf8f17$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$19423f507cbf8f17$var$CardinalClosed.prototype = {
    areaStart: $19423f507cbf8f17$var$_noop.default,
    areaEnd: $19423f507cbf8f17$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $8eKmz.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $19423f507cbf8f17$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $19423f507cbf8f17$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $19423f507cbf8f17$var$_default;

});
parcelRegister("8eKmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $5ff3984554cabbc0$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $5ff3984554cabbc0$var$point;
function $5ff3984554cabbc0$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $5ff3984554cabbc0$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$5ff3984554cabbc0$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $5ff3984554cabbc0$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $5ff3984554cabbc0$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $5ff3984554cabbc0$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $5ff3984554cabbc0$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $5ff3984554cabbc0$var$_default;

});


parcelRegister("jxpZF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $e3954333b381aa52$var$CardinalOpen;
module.exports.default = void 0;

var $8eKmz = parcelRequire("8eKmz");
function $e3954333b381aa52$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e3954333b381aa52$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $8eKmz.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e3954333b381aa52$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e3954333b381aa52$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e3954333b381aa52$var$_default;

});

parcelRegister("jbHfS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2as13 = parcelRequire("2as13");

var $df8098fa74193398$var$_noop = $df8098fa74193398$var$_interopRequireDefault((parcelRequire("DwreA")));

var $lCdlx = parcelRequire("lCdlx");
function $df8098fa74193398$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $df8098fa74193398$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$df8098fa74193398$var$CatmullRomClosed.prototype = {
    areaStart: $df8098fa74193398$var$_noop.default,
    areaEnd: $df8098fa74193398$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $lCdlx.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $df8098fa74193398$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $df8098fa74193398$var$CatmullRomClosed(context, alpha) : new $2as13.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $df8098fa74193398$var$_default;

});
parcelRegister("lCdlx", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $6SVxd = parcelRequire("6SVxd");

var $8eKmz = parcelRequire("8eKmz");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $6SVxd.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $6SVxd.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $8eKmz.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("keMhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jxpZF = parcelRequire("jxpZF");

var $lCdlx = parcelRequire("lCdlx");
function $ebba9186e3b304d2$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$ebba9186e3b304d2$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $lCdlx.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $ebba9186e3b304d2$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $ebba9186e3b304d2$var$CatmullRomOpen(context, alpha) : new $jxpZF.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $ebba9186e3b304d2$var$_default;

});

parcelRegister("aQUVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e6aeca2018ea8c4$var$_default;

var $7e6aeca2018ea8c4$var$_noop = $7e6aeca2018ea8c4$var$_interopRequireDefault((parcelRequire("DwreA")));
function $7e6aeca2018ea8c4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e6aeca2018ea8c4$var$LinearClosed(context) {
    this._context = context;
}
$7e6aeca2018ea8c4$var$LinearClosed.prototype = {
    areaStart: $7e6aeca2018ea8c4$var$_noop.default,
    areaEnd: $7e6aeca2018ea8c4$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $7e6aeca2018ea8c4$var$_default(context) {
    return new $7e6aeca2018ea8c4$var$LinearClosed(context);
}

});

parcelRegister("eg4Yo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $a6166ad6ab1a0825$var$monotoneX;
module.exports.monotoneY = $a6166ad6ab1a0825$var$monotoneY;
function $a6166ad6ab1a0825$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $a6166ad6ab1a0825$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($a6166ad6ab1a0825$var$sign(s0) + $a6166ad6ab1a0825$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $a6166ad6ab1a0825$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $a6166ad6ab1a0825$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $a6166ad6ab1a0825$var$MonotoneX(context) {
    this._context = context;
}
$a6166ad6ab1a0825$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $a6166ad6ab1a0825$var$point(this, this._t0, $a6166ad6ab1a0825$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $a6166ad6ab1a0825$var$point(this, $a6166ad6ab1a0825$var$slope2(this, t1 = $a6166ad6ab1a0825$var$slope3(this, x, y)), t1);
                break;
            default:
                $a6166ad6ab1a0825$var$point(this, this._t0, t1 = $a6166ad6ab1a0825$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $a6166ad6ab1a0825$var$MonotoneY(context) {
    this._context = new $a6166ad6ab1a0825$var$ReflectContext(context);
}
($a6166ad6ab1a0825$var$MonotoneY.prototype = Object.create($a6166ad6ab1a0825$var$MonotoneX.prototype)).point = function(x, y) {
    $a6166ad6ab1a0825$var$MonotoneX.prototype.point.call(this, y, x);
};
function $a6166ad6ab1a0825$var$ReflectContext(context) {
    this._context = context;
}
$a6166ad6ab1a0825$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $a6166ad6ab1a0825$var$monotoneX(context) {
    return new $a6166ad6ab1a0825$var$MonotoneX(context);
}
function $a6166ad6ab1a0825$var$monotoneY(context) {
    return new $a6166ad6ab1a0825$var$MonotoneY(context);
}

});

parcelRegister("er2IE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a825b245f4ed65b6$var$_default;
function $a825b245f4ed65b6$var$Natural(context) {
    this._context = context;
}
$a825b245f4ed65b6$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a825b245f4ed65b6$var$controlPoints(x), py = $a825b245f4ed65b6$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a825b245f4ed65b6$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a825b245f4ed65b6$var$_default(context) {
    return new $a825b245f4ed65b6$var$Natural(context);
}

});

parcelRegister("dvzIZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9d59e1c8c88d35c8$var$_default;
module.exports.stepAfter = $9d59e1c8c88d35c8$var$stepAfter;
module.exports.stepBefore = $9d59e1c8c88d35c8$var$stepBefore;
function $9d59e1c8c88d35c8$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$9d59e1c8c88d35c8$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $9d59e1c8c88d35c8$var$_default(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 0.5);
}
function $9d59e1c8c88d35c8$var$stepBefore(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 0);
}
function $9d59e1c8c88d35c8$var$stepAfter(context) {
    return new $9d59e1c8c88d35c8$var$Step(context, 1);
}

});

parcelRegister("31wXu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $233b07f21af819cd$var$_default;

var $233b07f21af819cd$var$_array = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("6svIw")));

var $233b07f21af819cd$var$_constant = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("aMcNX")));

var $233b07f21af819cd$var$_none = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("3ECyH")));

var $233b07f21af819cd$var$_none2 = $233b07f21af819cd$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $233b07f21af819cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $233b07f21af819cd$var$stackValue(d, key) {
    return d[key];
}
function $233b07f21af819cd$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $233b07f21af819cd$var$_default() {
    var keys = (0, $233b07f21af819cd$var$_constant.default)([]), order = $233b07f21af819cd$var$_none2.default, offset = $233b07f21af819cd$var$_none.default, value = $233b07f21af819cd$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $233b07f21af819cd$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $233b07f21af819cd$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $233b07f21af819cd$var$_none2.default : typeof _ === "function" ? _ : (0, $233b07f21af819cd$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $233b07f21af819cd$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("3ECyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a93047a4f3e4882$var$_default;
function $2a93047a4f3e4882$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("3MXBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2c241795eda08ad1$var$_default;
function $2c241795eda08ad1$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("jmoE1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e183304388747979$var$_default;

var $e183304388747979$var$_none = $e183304388747979$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $e183304388747979$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e183304388747979$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $e183304388747979$var$_none.default)(series, order);
}

});

parcelRegister("f0DEq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aed59cf73c40a83a$var$_default;
function $aed59cf73c40a83a$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("9owud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6d6f8e094a80c42b$var$_default;

var $6d6f8e094a80c42b$var$_none = $6d6f8e094a80c42b$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $6d6f8e094a80c42b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6d6f8e094a80c42b$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $6d6f8e094a80c42b$var$_none.default)(series, order);
}

});

parcelRegister("kJmkn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f179546c90cfd5b8$var$_default;

var $f179546c90cfd5b8$var$_none = $f179546c90cfd5b8$var$_interopRequireDefault((parcelRequire("3ECyH")));
function $f179546c90cfd5b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f179546c90cfd5b8$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $f179546c90cfd5b8$var$_none.default)(series, order);
}

});

parcelRegister("cMxJq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $94e422235dd9ade6$var$_default;

var $94e422235dd9ade6$var$_none = $94e422235dd9ade6$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $94e422235dd9ade6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94e422235dd9ade6$var$_default(series) {
    var peaks = series.map($94e422235dd9ade6$var$peak);
    return (0, $94e422235dd9ade6$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $94e422235dd9ade6$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("7OIkp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b0f968ea3bfef64$var$_default;
module.exports.sum = $5b0f968ea3bfef64$var$sum;

var $5b0f968ea3bfef64$var$_none = $5b0f968ea3bfef64$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $5b0f968ea3bfef64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5b0f968ea3bfef64$var$_default(series) {
    var sums = series.map($5b0f968ea3bfef64$var$sum);
    return (0, $5b0f968ea3bfef64$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $5b0f968ea3bfef64$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("bl2N4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8413d1ffb7520f5d$var$_default;

var $8413d1ffb7520f5d$var$_ascending = $8413d1ffb7520f5d$var$_interopRequireDefault((parcelRequire("7OIkp")));
function $8413d1ffb7520f5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8413d1ffb7520f5d$var$_default(series) {
    return (0, $8413d1ffb7520f5d$var$_ascending.default)(series).reverse();
}

});

parcelRegister("ino5x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d60d0f7084dc1115$var$_default;

var $d60d0f7084dc1115$var$_appearance = $d60d0f7084dc1115$var$_interopRequireDefault((parcelRequire("cMxJq")));

var $7OIkp = parcelRequire("7OIkp");
function $d60d0f7084dc1115$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d60d0f7084dc1115$var$_default(series) {
    var n = series.length, i, j, sums = series.map($7OIkp.sum), order = (0, $d60d0f7084dc1115$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("nTFR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $047d55cf2e68263f$var$_default;

var $047d55cf2e68263f$var$_none = $047d55cf2e68263f$var$_interopRequireDefault((parcelRequire("3MXBI")));
function $047d55cf2e68263f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $047d55cf2e68263f$var$_default(series) {
    return (0, $047d55cf2e68263f$var$_none.default)(series).reverse();
}

});



parcelRegister("4kfzs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", function () { return $32651bbfef366712$export$4f5d2d50c9deca37; });
$parcel$export(module.exports, "default", function () { return $32651bbfef366712$export$2e2bcd8739ae039; });
function $32651bbfef366712$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $32651bbfef366712$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $32651bbfef366712$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $32651bbfef366712$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $32651bbfef366712$export$2e2bcd8739ae039 = $32651bbfef366712$export$4f5d2d50c9deca37;

});

parcelRegister("5sc3h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $3f88ea882babc0c1$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $3f88ea882babc0c1$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $3f88ea882babc0c1$var$getPrefix;
const $3f88ea882babc0c1$var$prefixes = [
    'Moz',
    'Webkit',
    'O',
    'ms'
];
function $3f88ea882babc0c1$var$getPrefix() /*: string*/ {
    var _window$document;
    let prop /*: string*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === 'undefined') return '';
    // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    const style = (_window$document = window.document) === null || _window$document === void 0 || (_window$document = _window$document.documentElement) === null || _window$document === void 0 ? void 0 : _window$document.style;
    if (!style) return '';
    if (prop in style) return '';
    for(let i = 0; i < $3f88ea882babc0c1$var$prefixes.length; i++){
        if ($3f88ea882babc0c1$var$browserPrefixToKey(prop, $3f88ea882babc0c1$var$prefixes[i]) in style) return $3f88ea882babc0c1$var$prefixes[i];
    }
    return '';
}
function $3f88ea882babc0c1$var$browserPrefixToKey(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "".concat(prefix).concat($3f88ea882babc0c1$var$kebabToTitleCase(prop)) : prop;
}
function $3f88ea882babc0c1$var$browserPrefixToStyle(prop /*: string*/ , prefix /*: string*/ ) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $3f88ea882babc0c1$var$kebabToTitleCase(str /*: string*/ ) /*: string*/ {
    let out = '';
    let shouldCapitalize = true;
    for(let i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === '-') shouldCapitalize = true;
        else out += str[i];
    }
    return out;
}
// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $3f88ea882babc0c1$var$_default = module.exports.default = $3f88ea882babc0c1$var$getPrefix();

});

parcelRegister("jlTm4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e16aeacffad49d30$var$React = $e16aeacffad49d30$var$_interopRequireWildcard((parcelRequire("8nGP5")));

var $e16aeacffad49d30$var$_propTypes = $e16aeacffad49d30$var$_interopRequireDefault((parcelRequire("ebCsu")));

var $e16aeacffad49d30$var$_reactDom = $e16aeacffad49d30$var$_interopRequireDefault((parcelRequire("fCKK7")));

var $jRSXW = parcelRequire("jRSXW");

var $bmHgZ = parcelRequire("bmHgZ");

var $e5aKa = parcelRequire("e5aKa");

var $e16aeacffad49d30$var$_log = $e16aeacffad49d30$var$_interopRequireDefault((parcelRequire("8iYqY")));
function $e16aeacffad49d30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e16aeacffad49d30$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e16aeacffad49d30$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e16aeacffad49d30$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e16aeacffad49d30$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e16aeacffad49d30$var$_defineProperty(obj, key, value) {
    key = $e16aeacffad49d30$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e16aeacffad49d30$var$_toPropertyKey(arg) {
    var key = $e16aeacffad49d30$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e16aeacffad49d30$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ // Simple abstraction for dragging events names.
const $e16aeacffad49d30$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
// Default to mouse events.
let $e16aeacffad49d30$var$dragEventFor = $e16aeacffad49d30$var$eventsFor.mouse;
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
class $e16aeacffad49d30$var$DraggableCore extends $e16aeacffad49d30$var$React.Component /*:: <DraggableCoreProps>*/  {
    constructor(){
        super(...arguments);
        $e16aeacffad49d30$var$_defineProperty(this, "dragging", false);
        // Used while dragging to determine deltas.
        $e16aeacffad49d30$var$_defineProperty(this, "lastX", NaN);
        $e16aeacffad49d30$var$_defineProperty(this, "lastY", NaN);
        $e16aeacffad49d30$var$_defineProperty(this, "touchIdentifier", null);
        $e16aeacffad49d30$var$_defineProperty(this, "mounted", false);
        $e16aeacffad49d30$var$_defineProperty(this, "handleDragStart", (e)=>{
            // Make it possible to attach event handlers on top of this one.
            this.props.onMouseDown(e);
            // Only accept left-clicks.
            if (!this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;
            // Get nodes. Be sure to grab relative document (could be iframed)
            const thisNode = this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error('<DraggableCore> not mounted on DragStart!');
            const { ownerDocument: ownerDocument } = thisNode;
            // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || this.props.handle && !(0, $jRSXW.matchesSelectorAndParentsTo)(e.target, this.props.handle, thisNode) || this.props.cancel && (0, $jRSXW.matchesSelectorAndParentsTo)(e.target, this.props.cancel, thisNode)) return;
            // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === 'touchstart') e.preventDefault();
            // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            const touchIdentifier = (0, $jRSXW.getTouchIdentifier)(e);
            this.touchIdentifier = touchIdentifier;
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $bmHgZ.getControlPosition)(e, touchIdentifier, this);
            if (position == null) return; // not possible but satisfies flow
            const { x: x, y: y } = position;
            // Create an event object with all the data parents need to make a decision here.
            const coreEvent = (0, $bmHgZ.createCoreData)(this, x, y);
            (0, $e16aeacffad49d30$var$_log.default)('DraggableCore: handleDragStart: %j', coreEvent);
            // Call event handler. If it returns explicit false, cancel.
            (0, $e16aeacffad49d30$var$_log.default)('calling', this.props.onStart);
            const shouldUpdate = this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) return;
            // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (this.props.enableUserSelectHack) (0, $jRSXW.addUserSelectStyles)(ownerDocument);
            // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            this.dragging = true;
            this.lastX = x;
            this.lastY = y;
            // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $jRSXW.addEvent)(ownerDocument, $e16aeacffad49d30$var$dragEventFor.move, this.handleDrag);
            (0, $jRSXW.addEvent)(ownerDocument, $e16aeacffad49d30$var$dragEventFor.stop, this.handleDragStop);
        });
        $e16aeacffad49d30$var$_defineProperty(this, "handleDrag", (e)=>{
            // Get the current drag point from the event. This is used as the offset.
            const position = (0, $bmHgZ.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX, deltaY = y - this.lastY;
                [deltaX, deltaY] = (0, $bmHgZ.snapToGrid)(this.props.grid, deltaX, deltaY);
                if (!deltaX && !deltaY) return; // skip useless drag
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $bmHgZ.createCoreData)(this, x, y);
            (0, $e16aeacffad49d30$var$_log.default)('DraggableCore: handleDrag: %j', coreEvent);
            // Call event handler. If it returns explicit false, trigger end.
            const shouldUpdate = this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || this.mounted === false) {
                try {
                    // $FlowIgnore
                    this.handleDragStop(new MouseEvent('mouseup'));
                } catch (err) {
                    // Old browsers
                    const event = document.createEvent('MouseEvents');
                    // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    this.handleDragStop(event);
                }
                return;
            }
            this.lastX = x;
            this.lastY = y;
        });
        $e16aeacffad49d30$var$_defineProperty(this, "handleDragStop", (e)=>{
            if (!this.dragging) return;
            const position = (0, $bmHgZ.getControlPosition)(e, this.touchIdentifier, this);
            if (position == null) return;
            let { x: x, y: y } = position;
            // Snap to grid if prop has been provided
            if (Array.isArray(this.props.grid)) {
                let deltaX = x - this.lastX || 0;
                let deltaY = y - this.lastY || 0;
                [deltaX, deltaY] = (0, $bmHgZ.snapToGrid)(this.props.grid, deltaX, deltaY);
                x = this.lastX + deltaX, y = this.lastY + deltaY;
            }
            const coreEvent = (0, $bmHgZ.createCoreData)(this, x, y);
            // Call event handler
            const shouldContinue = this.props.onStop(e, coreEvent);
            if (shouldContinue === false || this.mounted === false) return false;
            const thisNode = this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (this.props.enableUserSelectHack) (0, $jRSXW.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $e16aeacffad49d30$var$_log.default)('DraggableCore: handleDragStop: %j', coreEvent);
            // Reset the el.
            this.dragging = false;
            this.lastX = NaN;
            this.lastY = NaN;
            if (thisNode) {
                // Remove event handlers
                (0, $e16aeacffad49d30$var$_log.default)('DraggableCore: Removing handlers');
                (0, $jRSXW.removeEvent)(thisNode.ownerDocument, $e16aeacffad49d30$var$dragEventFor.move, this.handleDrag);
                (0, $jRSXW.removeEvent)(thisNode.ownerDocument, $e16aeacffad49d30$var$dragEventFor.stop, this.handleDragStop);
            }
        });
        $e16aeacffad49d30$var$_defineProperty(this, "onMouseDown", (e)=>{
            $e16aeacffad49d30$var$dragEventFor = $e16aeacffad49d30$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return this.handleDragStart(e);
        });
        $e16aeacffad49d30$var$_defineProperty(this, "onMouseUp", (e)=>{
            $e16aeacffad49d30$var$dragEventFor = $e16aeacffad49d30$var$eventsFor.mouse;
            return this.handleDragStop(e);
        });
        // Same as onMouseDown (start drag), but now consider this a touch device.
        $e16aeacffad49d30$var$_defineProperty(this, "onTouchStart", (e)=>{
            // We're on a touch device now, so change the event handlers
            $e16aeacffad49d30$var$dragEventFor = $e16aeacffad49d30$var$eventsFor.touch;
            return this.handleDragStart(e);
        });
        $e16aeacffad49d30$var$_defineProperty(this, "onTouchEnd", (e)=>{
            // We're on a touch device now, so change the event handlers
            $e16aeacffad49d30$var$dragEventFor = $e16aeacffad49d30$var$eventsFor.touch;
            return this.handleDragStop(e);
        });
    }
    componentDidMount() {
        this.mounted = true;
        // Touch handlers must be added with {passive: false} to be cancelable.
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        const thisNode = this.findDOMNode();
        if (thisNode) (0, $jRSXW.addEvent)(thisNode, $e16aeacffad49d30$var$eventsFor.touch.start, this.onTouchStart, {
            passive: false
        });
    }
    componentWillUnmount() {
        this.mounted = false;
        // Remove any leftover event handlers. Remove both touch and mouse handlers in case
        // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
        const thisNode = this.findDOMNode();
        if (thisNode) {
            const { ownerDocument: ownerDocument } = thisNode;
            (0, $jRSXW.removeEvent)(ownerDocument, $e16aeacffad49d30$var$eventsFor.mouse.move, this.handleDrag);
            (0, $jRSXW.removeEvent)(ownerDocument, $e16aeacffad49d30$var$eventsFor.touch.move, this.handleDrag);
            (0, $jRSXW.removeEvent)(ownerDocument, $e16aeacffad49d30$var$eventsFor.mouse.stop, this.handleDragStop);
            (0, $jRSXW.removeEvent)(ownerDocument, $e16aeacffad49d30$var$eventsFor.touch.stop, this.handleDragStop);
            (0, $jRSXW.removeEvent)(thisNode, $e16aeacffad49d30$var$eventsFor.touch.start, this.onTouchStart, {
                passive: false
            });
            if (this.props.enableUserSelectHack) (0, $jRSXW.removeUserSelectStyles)(ownerDocument);
        }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props, _this$props2;
        return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.nodeRef) === null || _this$props2 === void 0 ? void 0 : _this$props2.current : $e16aeacffad49d30$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: React.Element<any>*/ {
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $e16aeacffad49d30$var$React.cloneElement($e16aeacffad49d30$var$React.Children.only(this.props.children), {
            // Note: mouseMove handler is attached to document so it will still function
            // when the user drags quickly and leaves the bounds of the element.
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            // onTouchStart is added on `componentDidMount` so they can be added with
            // {passive: false}, which allows it to cancel. See
            // https://developers.google.com/web/updates/2017/01/scrolling-intervention
            onTouchEnd: this.onTouchEnd
        });
    }
}
module.exports.default = $e16aeacffad49d30$var$DraggableCore;
$e16aeacffad49d30$var$_defineProperty($e16aeacffad49d30$var$DraggableCore, "displayName", 'DraggableCore');
$e16aeacffad49d30$var$_defineProperty($e16aeacffad49d30$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $e16aeacffad49d30$var$_propTypes.default.bool,
    children: $e16aeacffad49d30$var$_propTypes.default.node.isRequired,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $e16aeacffad49d30$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $e16aeacffad49d30$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function(props /*: DraggableCoreProps*/ , propName /*: $Keys<DraggableCoreProps>*/ ) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $e16aeacffad49d30$var$_propTypes.default.arrayOf($e16aeacffad49d30$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $e16aeacffad49d30$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $e16aeacffad49d30$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $e16aeacffad49d30$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $e16aeacffad49d30$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $e16aeacffad49d30$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $e16aeacffad49d30$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $e16aeacffad49d30$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $e16aeacffad49d30$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $e5aKa.dontSetMe,
    style: $e5aKa.dontSetMe,
    transform: $e5aKa.dontSetMe
});
$e16aeacffad49d30$var$_defineProperty($e16aeacffad49d30$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function() {},
    onDrag: function() {},
    onStop: function() {},
    onMouseDown: function() {},
    scale: 1
});

});
parcelRegister("jRSXW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $e76d9a990777d27d$var$addClassName;
module.exports.addEvent = $e76d9a990777d27d$var$addEvent;
module.exports.addUserSelectStyles = $e76d9a990777d27d$var$addUserSelectStyles;
module.exports.createCSSTransform = $e76d9a990777d27d$var$createCSSTransform;
module.exports.createSVGTransform = $e76d9a990777d27d$var$createSVGTransform;
module.exports.getTouch = $e76d9a990777d27d$var$getTouch;
module.exports.getTouchIdentifier = $e76d9a990777d27d$var$getTouchIdentifier;
module.exports.getTranslation = $e76d9a990777d27d$var$getTranslation;
module.exports.innerHeight = $e76d9a990777d27d$var$innerHeight;
module.exports.innerWidth = $e76d9a990777d27d$var$innerWidth;
module.exports.matchesSelector = $e76d9a990777d27d$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $e76d9a990777d27d$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $e76d9a990777d27d$var$offsetXYFromParent;
module.exports.outerHeight = $e76d9a990777d27d$var$outerHeight;
module.exports.outerWidth = $e76d9a990777d27d$var$outerWidth;
module.exports.removeClassName = $e76d9a990777d27d$var$removeClassName;
module.exports.removeEvent = $e76d9a990777d27d$var$removeEvent;
module.exports.removeUserSelectStyles = $e76d9a990777d27d$var$removeUserSelectStyles;

var $e5aKa = parcelRequire("e5aKa");

var $e76d9a990777d27d$var$_getPrefix = $e76d9a990777d27d$var$_interopRequireWildcard((parcelRequire("5sc3h")));
function $e76d9a990777d27d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e76d9a990777d27d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e76d9a990777d27d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e76d9a990777d27d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/ let $e76d9a990777d27d$var$matchesSelectorFunc = '';
function $e76d9a990777d27d$var$matchesSelector(el /*: Node*/ , selector /*: string*/ ) /*: boolean*/ {
    if (!$e76d9a990777d27d$var$matchesSelectorFunc) $e76d9a990777d27d$var$matchesSelectorFunc = (0, $e5aKa.findInArray)([
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $e5aKa.isFunction)(el[method]);
    });
    // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $e5aKa.isFunction)(el[$e76d9a990777d27d$var$matchesSelectorFunc])) return false;
    // $FlowIgnore: Doesn't think elements are indexable
    return el[$e76d9a990777d27d$var$matchesSelectorFunc](selector);
}
// Works up the tree to the draggable itself attempting to match selector.
function $e76d9a990777d27d$var$matchesSelectorAndParentsTo(el /*: Node*/ , selector /*: string*/ , baseNode /*: Node*/ ) /*: boolean*/ {
    let node = el;
    do {
        if ($e76d9a990777d27d$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        // $FlowIgnore[incompatible-type]
        node = node.parentNode;
    }while (node);
    return false;
}
function $e76d9a990777d27d$var$addEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
}
function $e76d9a990777d27d$var$removeEvent(el /*: ?Node*/ , event /*: string*/ , handler /*: Function*/ , inputOptions /*: Object*/ ) /*: void*/ {
    if (!el) return;
    const options = {
        capture: true,
        ...inputOptions
    };
    // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent('on' + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
}
function $e76d9a990777d27d$var$outerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $e5aKa.int)(computedStyle.borderTopWidth);
    height += (0, $e5aKa.int)(computedStyle.borderBottomWidth);
    return height;
}
function $e76d9a990777d27d$var$outerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $e5aKa.int)(computedStyle.borderLeftWidth);
    width += (0, $e5aKa.int)(computedStyle.borderRightWidth);
    return width;
}
function $e76d9a990777d27d$var$innerHeight(node /*: HTMLElement*/ ) /*: number*/ {
    let height = node.clientHeight;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $e5aKa.int)(computedStyle.paddingTop);
    height -= (0, $e5aKa.int)(computedStyle.paddingBottom);
    return height;
}
function $e76d9a990777d27d$var$innerWidth(node /*: HTMLElement*/ ) /*: number*/ {
    let width = node.clientWidth;
    const computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $e5aKa.int)(computedStyle.paddingLeft);
    width -= (0, $e5aKa.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $e76d9a990777d27d$var$offsetXYFromParent(evt /*: EventWithOffset*/ , offsetParent /*: HTMLElement*/ , scale /*: number*/ ) /*: ControlPosition*/ {
    const isBody = offsetParent === offsetParent.ownerDocument.body;
    const offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    const x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    const y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $e76d9a990777d27d$var$createCSSTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: Object*/ {
    const translation = $e76d9a990777d27d$var$getTranslation(controlPos, positionOffset, 'px');
    return {
        [(0, $e76d9a990777d27d$var$_getPrefix.browserPrefixToKey)('transform', $e76d9a990777d27d$var$_getPrefix.default)]: translation
    };
}
function $e76d9a990777d27d$var$createSVGTransform(controlPos /*: ControlPosition*/ , positionOffset /*: PositionOffsetControlPosition*/ ) /*: string*/ {
    const translation = $e76d9a990777d27d$var$getTranslation(controlPos, positionOffset, '');
    return translation;
}
function $e76d9a990777d27d$var$getTranslation(_ref /*:: */ , positionOffset /*: PositionOffsetControlPosition*/ , unitSuffix /*: string*/ ) /*: string*/ {
    let { x: x, y: y } /*: ControlPosition*/  = _ref /*: ControlPosition*/ ;
    let translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        const defaultX = "".concat(typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
        const defaultY = "".concat(typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $e76d9a990777d27d$var$getTouch(e /*: MouseTouchEvent*/ , identifier /*: number*/ ) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $e5aKa.findInArray)(e.targetTouches, (t)=>identifier === t.identifier) || e.changedTouches && (0, $e5aKa.findInArray)(e.changedTouches, (t)=>identifier === t.identifier);
}
function $e76d9a990777d27d$var$getTouchIdentifier(e /*: MouseTouchEvent*/ ) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}
// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $e76d9a990777d27d$var$addUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    let styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) $e76d9a990777d27d$var$addClassName(doc.body, 'react-draggable-transparent-selection');
}
function $e76d9a990777d27d$var$removeUserSelectStyles(doc /*: ?Document*/ ) {
    if (!doc) return;
    try {
        if (doc.body) $e76d9a990777d27d$var$removeClassName(doc.body, 'react-draggable-transparent-selection');
        // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            const selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {
    // probably IE
    }
}
function $e76d9a990777d27d$var$addClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $e76d9a990777d27d$var$removeClassName(el /*: HTMLElement*/ , className /*: string*/ ) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), 'g'), '');
}

});
parcelRegister("e5aKa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $a409ddcb259e733c$var$dontSetMe;
module.exports.findInArray = $a409ddcb259e733c$var$findInArray;
module.exports.int = $a409ddcb259e733c$var$int;
module.exports.isFunction = $a409ddcb259e733c$var$isFunction;
module.exports.isNum = $a409ddcb259e733c$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $a409ddcb259e733c$var$findInArray(array /*: Array<any> | TouchList*/ , callback /*: Function*/ ) /*: any*/ {
    for(let i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $a409ddcb259e733c$var$isFunction(func /*: any*/ ) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function $a409ddcb259e733c$var$isNum(num /*: any*/ ) /*: boolean %checks*/ {
    return typeof num === 'number' && !isNaN(num);
}
function $a409ddcb259e733c$var$int(a /*: string*/ ) /*: number*/ {
    return parseInt(a, 10);
}
function $a409ddcb259e733c$var$dontSetMe(props /*: Object*/ , propName /*: string*/ , componentName /*: string*/ ) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});


parcelRegister("bmHgZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $846350e4cb4127d6$var$canDragX;
module.exports.canDragY = $846350e4cb4127d6$var$canDragY;
module.exports.createCoreData = $846350e4cb4127d6$var$createCoreData;
module.exports.createDraggableData = $846350e4cb4127d6$var$createDraggableData;
module.exports.getBoundPosition = $846350e4cb4127d6$var$getBoundPosition;
module.exports.getControlPosition = $846350e4cb4127d6$var$getControlPosition;
module.exports.snapToGrid = $846350e4cb4127d6$var$snapToGrid;

var $e5aKa = parcelRequire("e5aKa");

var $jRSXW = parcelRequire("jRSXW");
/*:: import type Draggable from '../Draggable';*/ /*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/ /*:: import type DraggableCore from '../DraggableCore';*/ function $846350e4cb4127d6$var$getBoundPosition(draggable /*: Draggable*/ , x /*: number*/ , y /*: number*/ ) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ];
    // Clone new bounds
    let { bounds: bounds } = draggable.props;
    bounds = typeof bounds === 'string' ? bounds : $846350e4cb4127d6$var$cloneBounds(bounds);
    const node = $846350e4cb4127d6$var$findDOMNode(draggable);
    if (typeof bounds === 'string') {
        const { ownerDocument: ownerDocument } = node;
        const ownerWindow = ownerDocument.defaultView;
        let boundNode;
        if (bounds === 'parent') boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        const boundNodeEl /*: HTMLElement*/  = boundNode; // for Flow, can't seem to refine correctly
        const nodeStyle = ownerWindow.getComputedStyle(node);
        const boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl);
        // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $e5aKa.int)(boundNodeStyle.paddingLeft) + (0, $e5aKa.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $e5aKa.int)(boundNodeStyle.paddingTop) + (0, $e5aKa.int)(nodeStyle.marginTop),
            right: (0, $jRSXW.innerWidth)(boundNodeEl) - (0, $jRSXW.outerWidth)(node) - node.offsetLeft + (0, $e5aKa.int)(boundNodeStyle.paddingRight) - (0, $e5aKa.int)(nodeStyle.marginRight),
            bottom: (0, $jRSXW.innerHeight)(boundNodeEl) - (0, $jRSXW.outerHeight)(node) - node.offsetTop + (0, $e5aKa.int)(boundNodeStyle.paddingBottom) - (0, $e5aKa.int)(nodeStyle.marginBottom)
        };
    }
    // Keep x and y below right and bottom limits...
    if ((0, $e5aKa.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $e5aKa.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);
    // But above left and top limits.
    if ((0, $e5aKa.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $e5aKa.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $846350e4cb4127d6$var$snapToGrid(grid /*: [number, number]*/ , pendingX /*: number*/ , pendingY /*: number*/ ) /*: [number, number]*/ {
    const x = Math.round(pendingX / grid[0]) * grid[0];
    const y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $846350e4cb4127d6$var$canDragX(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}
function $846350e4cb4127d6$var$canDragY(draggable /*: Draggable*/ ) /*: boolean*/ {
    return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}
// Get {x, y} positions from event.
function $846350e4cb4127d6$var$getControlPosition(e /*: MouseTouchEvent*/ , touchIdentifier /*: ?number*/ , draggableCore /*: DraggableCore*/ ) /*: ?ControlPosition*/ {
    const touchObj = typeof touchIdentifier === 'number' ? (0, $jRSXW.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
    const node = $846350e4cb4127d6$var$findDOMNode(draggableCore);
    // User can provide an offsetParent if desired.
    const offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $jRSXW.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
}
// Create an data object exposed by <DraggableCore>'s events
function $846350e4cb4127d6$var$createCoreData(draggable /*: DraggableCore*/ , x /*: number*/ , y /*: number*/ ) /*: DraggableData*/ {
    const isStart = !(0, $e5aKa.isNum)(draggable.lastX);
    const node = $846350e4cb4127d6$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - draggable.lastX,
        deltaY: y - draggable.lastY,
        lastX: draggable.lastX,
        lastY: draggable.lastY,
        x: x,
        y: y
    };
}
// Create an data exposed by <Draggable>'s events
function $846350e4cb4127d6$var$createDraggableData(draggable /*: Draggable*/ , coreData /*: DraggableData*/ ) /*: DraggableData*/ {
    const scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
}
// A lot faster than stringify/parse
function $846350e4cb4127d6$var$cloneBounds(bounds /*: Bounds*/ ) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $846350e4cb4127d6$var$findDOMNode(draggable /*: Draggable | DraggableCore*/ ) /*: HTMLElement*/ {
    const node = draggable.findDOMNode();
    if (!node) throw new Error('<DraggableCore>: Unmounted during event!');
    // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("8iYqY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60bee21d39bde5c8$var$log;
/*eslint no-console:0*/ function $60bee21d39bde5c8$var$log() {}

});


parcelRegister("4kwnA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3272258f0af3cbc3$export$2e2bcd8739ae039; });

var $u6I0t = parcelRequire("u6I0t");
// eslint-disable-next-line no-undef
var $3272258f0af3cbc3$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3272258f0af3cbc3$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $u6I0t.default)(function(prop) {
    return $3272258f0af3cbc3$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("u6I0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05a801ae819a91bc$export$2e2bcd8739ae039; });
function $05a801ae819a91bc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4F19u", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $364be2897847355f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $364be2897847355f$var$_composeClasses.default;
    }
});

var $364be2897847355f$var$_composeClasses = $364be2897847355f$require$_interopRequireDefault((parcelRequire("cgXH7")));

});
parcelRegister("1yHiF", function(module, exports) {
function $122a8dedaa9a5728$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $122a8dedaa9a5728$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cgXH7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8ef548c22cdb6b96$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $8ef548c22cdb6b96$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});


parcelRegister("k3QMn", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e9ad0755039c3a1c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e9ad0755039c3a1c$var$_useSlotProps.default;
    }
});

var $e9ad0755039c3a1c$var$_useSlotProps = $e9ad0755039c3a1c$require$_interopRequireDefault((parcelRequire("9cQXs")));

});
parcelRegister("9cQXs", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $6b3e506ce459d8ac$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b3e506ce459d8ac$var$_useForkRef = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("7uWLa")));

var $6b3e506ce459d8ac$var$_appendOwnerState = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("1UjvS")));

var $6b3e506ce459d8ac$var$_mergeSlotProps = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("43DfG")));

var $6b3e506ce459d8ac$var$_resolveComponentProps = $6b3e506ce459d8ac$require$_interopRequireDefault((parcelRequire("iselN")));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $6b3e506ce459d8ac$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $6b3e506ce459d8ac$var$_resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $6b3e506ce459d8ac$var$_mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $6b3e506ce459d8ac$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $6b3e506ce459d8ac$var$_appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $6b3e506ce459d8ac$var$_default = module.exports.default = $6b3e506ce459d8ac$var$useSlotProps;

});
parcelRegister("7uWLa", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5758ea304694dedd$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5758ea304694dedd$var$_useForkRef.default;
    }
});

var $5758ea304694dedd$var$_useForkRef = $5758ea304694dedd$require$_interopRequireDefault((parcelRequire("j7Q3z")));

});
parcelRegister("j7Q3z", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $dec70d1bd561b224$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dec70d1bd561b224$var$useForkRef;

var $dec70d1bd561b224$var$React = $dec70d1bd561b224$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $dec70d1bd561b224$var$useForkRef(...refs) {
    const cleanupRef = $dec70d1bd561b224$var$React.useRef(undefined);
    const refEffect = $dec70d1bd561b224$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $dec70d1bd561b224$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("1RopH", function(module, exports) {

var $1XeFJ = parcelRequire("1XeFJ");
var $15adadaf01189225$var$_typeof = $1XeFJ.default;
function $15adadaf01189225$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($15adadaf01189225$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $15adadaf01189225$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $15adadaf01189225$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $15adadaf01189225$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = $15adadaf01189225$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1XeFJ", function(module, exports) {
function $16c6aeb54381cada$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $16c6aeb54381cada$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $16c6aeb54381cada$var$_typeof(o);
}
module.exports = $16c6aeb54381cada$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("1UjvS", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $163a284c3f5d55a5$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $163a284c3f5d55a5$var$_appendOwnerState.default;
    }
});

var $163a284c3f5d55a5$var$_appendOwnerState = $163a284c3f5d55a5$require$_interopRequireDefault((parcelRequire("3B0Xs")));

});
parcelRegister("3B0Xs", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $29e5920e3cf1be8d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29e5920e3cf1be8d$var$_isHostComponent = $29e5920e3cf1be8d$require$_interopRequireDefault((parcelRequire("3c7cF")));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $29e5920e3cf1be8d$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $29e5920e3cf1be8d$var$_isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $29e5920e3cf1be8d$var$_default = module.exports.default = $29e5920e3cf1be8d$var$appendOwnerState;

});
parcelRegister("3c7cF", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $25381481a59a6d62$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25381481a59a6d62$var$_isHostComponent.default;
    }
});

var $25381481a59a6d62$var$_isHostComponent = $25381481a59a6d62$require$_interopRequireDefault((parcelRequire("aZi4K")));

});
parcelRegister("aZi4K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7ffd9f576736edcf$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7ffd9f576736edcf$var$_default = module.exports.default = $7ffd9f576736edcf$var$isHostComponent;

});




parcelRegister("43DfG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2f45e3d9fa07f54e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f45e3d9fa07f54e$var$_mergeSlotProps.default;
    }
});

var $2f45e3d9fa07f54e$var$_mergeSlotProps = $2f45e3d9fa07f54e$require$_interopRequireDefault((parcelRequire("lnM7e")));

});
parcelRegister("lnM7e", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f91111b6d20a7b45$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f91111b6d20a7b45$var$_clsx = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $f91111b6d20a7b45$var$_extractEventHandlers = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("9ds9N")));

var $f91111b6d20a7b45$var$_omitEventHandlers = $f91111b6d20a7b45$require$_interopRequireDefault((parcelRequire("4RRML")));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $f91111b6d20a7b45$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $f91111b6d20a7b45$var$_clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $f91111b6d20a7b45$var$_extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $f91111b6d20a7b45$var$_omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $f91111b6d20a7b45$var$_omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $f91111b6d20a7b45$var$_clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $f91111b6d20a7b45$var$_default = module.exports.default = $f91111b6d20a7b45$var$mergeSlotProps;

});
parcelRegister("9ds9N", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6b5b2b583a762705$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b5b2b583a762705$var$_extractEventHandlers.default;
    }
});

var $6b5b2b583a762705$var$_extractEventHandlers = $6b5b2b583a762705$require$_interopRequireDefault((parcelRequire("iTrGK")));

});
parcelRegister("iTrGK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $dc12d768c76d3df9$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $dc12d768c76d3df9$var$_default = module.exports.default = $dc12d768c76d3df9$var$extractEventHandlers;

});


parcelRegister("4RRML", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $38b5d55d2d06e1f4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $38b5d55d2d06e1f4$var$_omitEventHandlers.default;
    }
});

var $38b5d55d2d06e1f4$var$_omitEventHandlers = $38b5d55d2d06e1f4$require$_interopRequireDefault((parcelRequire("264pz")));

});
parcelRegister("264pz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $186f904e6bde06ca$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $186f904e6bde06ca$var$_default = module.exports.default = $186f904e6bde06ca$var$omitEventHandlers;

});




parcelRegister("iselN", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d6f5f9398014fd74$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d6f5f9398014fd74$var$_resolveComponentProps.default;
    }
});

var $d6f5f9398014fd74$var$_resolveComponentProps = $d6f5f9398014fd74$require$_interopRequireDefault((parcelRequire("gxVIh")));

});
parcelRegister("gxVIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $c0bc7f11c44e42cd$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $c0bc7f11c44e42cd$var$_default = module.exports.default = $c0bc7f11c44e42cd$var$resolveComponentProps;

});




parcelRegister("cCZAW", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9318d01ab38ece29$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9318d01ab38ece29$var$_formatMuiErrorMessage.default;
    }
});

var $9318d01ab38ece29$var$_formatMuiErrorMessage = $9318d01ab38ece29$require$_interopRequireDefault((parcelRequire("crgVA")));

});
parcelRegister("crgVA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90e5232a222589c1$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90e5232a222589c1$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("5TqxC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $44a6ad580101bfea$var$_default = module.exports.default = '$$material';

});

parcelRegister("2ri4z", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c6c1f3bde1b3ddd$var$adaptV4Theme;

var $czV3l = parcelRequire("czV3l");
var $fyaOi = parcelRequire("fyaOi");
function $1c6c1f3bde1b3ddd$var$adaptV4Theme(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $fyaOi.default)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $czV3l.default)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});
parcelRegister("czV3l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9285027776d9d469$export$2e2bcd8739ae039; });
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $9285027776d9d469$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $9285027776d9d469$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $9285027776d9d469$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $9285027776d9d469$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("fyaOi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5226aa9eb943df2$export$2e2bcd8739ae039; });

var $3kkiI = parcelRequire("3kkiI");
function $b5226aa9eb943df2$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $3kkiI.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("3kkiI", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $26c2fcaf135aa84a$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $26c2fcaf135aa84a$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $26c2fcaf135aa84a$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $26c2fcaf135aa84a$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $26c2fcaf135aa84a$export$6f98e8eaf0be1996; });


var $k1b5n = parcelRequire("k1b5n");

var $4Sj9k = parcelRequire("4Sj9k");

var $3InwI = parcelRequire("3InwI");

var $8t7XR = parcelRequire("8t7XR");
const $26c2fcaf135aa84a$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $26c2fcaf135aa84a$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $26c2fcaf135aa84a$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $26c2fcaf135aa84a$var$getCssProperties = (0, $8t7XR.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($26c2fcaf135aa84a$var$aliases[prop]) prop = $26c2fcaf135aa84a$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $26c2fcaf135aa84a$var$properties[a];
    const direction = $26c2fcaf135aa84a$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $26c2fcaf135aa84a$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $26c2fcaf135aa84a$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $26c2fcaf135aa84a$var$spacingKeys = [
    ...$26c2fcaf135aa84a$export$aab52a0dde05ad8a,
    ...$26c2fcaf135aa84a$export$f8397d44f03ab6ad
];
function $26c2fcaf135aa84a$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $4Sj9k.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $26c2fcaf135aa84a$export$1def6f833384e3d1(theme) {
    return $26c2fcaf135aa84a$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $26c2fcaf135aa84a$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $26c2fcaf135aa84a$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $26c2fcaf135aa84a$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $26c2fcaf135aa84a$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $26c2fcaf135aa84a$var$getCssProperties(prop);
    const styleFromPropValue = $26c2fcaf135aa84a$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $k1b5n.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $26c2fcaf135aa84a$var$style(props, keys) {
    const transformer = $26c2fcaf135aa84a$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$26c2fcaf135aa84a$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $3InwI.default), {});
}
function $26c2fcaf135aa84a$export$7ede87f9b603dd3c(props) {
    return $26c2fcaf135aa84a$var$style(props, $26c2fcaf135aa84a$export$aab52a0dde05ad8a);
}
$26c2fcaf135aa84a$export$7ede87f9b603dd3c.propTypes = {};
$26c2fcaf135aa84a$export$7ede87f9b603dd3c.filterProps = $26c2fcaf135aa84a$export$aab52a0dde05ad8a;
function $26c2fcaf135aa84a$export$6f98e8eaf0be1996(props) {
    return $26c2fcaf135aa84a$var$style(props, $26c2fcaf135aa84a$export$f8397d44f03ab6ad);
}
$26c2fcaf135aa84a$export$6f98e8eaf0be1996.propTypes = {};
$26c2fcaf135aa84a$export$6f98e8eaf0be1996.filterProps = $26c2fcaf135aa84a$export$f8397d44f03ab6ad;
function $26c2fcaf135aa84a$var$spacing(props) {
    return $26c2fcaf135aa84a$var$style(props, $26c2fcaf135aa84a$var$spacingKeys);
}
$26c2fcaf135aa84a$var$spacing.propTypes = {};
$26c2fcaf135aa84a$var$spacing.filterProps = $26c2fcaf135aa84a$var$spacingKeys;
var $26c2fcaf135aa84a$export$2e2bcd8739ae039 = $26c2fcaf135aa84a$var$spacing;

});
parcelRegister("k1b5n", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $e92c800fcc7e054a$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $e92c800fcc7e054a$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $e92c800fcc7e054a$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $e92c800fcc7e054a$export$8922c90b6e020726; });


var $cfKeZ = parcelRequire("cfKeZ");

var $3InwI = parcelRequire("3InwI");

var $iMDnO = parcelRequire("iMDnO");
const $e92c800fcc7e054a$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $e92c800fcc7e054a$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$e92c800fcc7e054a$export$68c286be0e7e55b7[key]}px)`
};
const $e92c800fcc7e054a$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $e92c800fcc7e054a$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $e92c800fcc7e054a$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $e92c800fcc7e054a$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $e92c800fcc7e054a$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $iMDnO.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $iMDnO.getContainerQuery)(theme.containerQueries ? theme : $e92c800fcc7e054a$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $e92c800fcc7e054a$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $e92c800fcc7e054a$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $e92c800fcc7e054a$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $3InwI.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $e92c800fcc7e054a$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $e92c800fcc7e054a$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $e92c800fcc7e054a$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $e92c800fcc7e054a$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(prev, next), {});
    return $e92c800fcc7e054a$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $e92c800fcc7e054a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $e92c800fcc7e054a$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $e92c800fcc7e054a$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $e92c800fcc7e054a$export$2e2bcd8739ae039 = $e92c800fcc7e054a$var$breakpoints;

});
parcelRegister("cfKeZ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $8ebac136a5bb41e3$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ebac136a5bb41e3$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8ebac136a5bb41e3$var$_deepmerge.default;
    }
});

var $8ebac136a5bb41e3$var$_deepmerge = $8ebac136a5bb41e3$require$_interopRequireWildcard((parcelRequire("kSvzm")));
Object.keys($8ebac136a5bb41e3$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8ebac136a5bb41e3$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8ebac136a5bb41e3$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8ebac136a5bb41e3$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("kSvzm", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $f33156d31a79402a$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f33156d31a79402a$var$deepmerge;
module.exports.isPlainObject = $f33156d31a79402a$var$isPlainObject;

var $f33156d31a79402a$var$React = $f33156d31a79402a$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $4G43L = parcelRequire("4G43L");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $f33156d31a79402a$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $f33156d31a79402a$var$deepClone(source) {
    if (/*#__PURE__*/ $f33156d31a79402a$var$React.isValidElement(source) || (0, $4G43L.isValidElementType)(source) || !$f33156d31a79402a$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $f33156d31a79402a$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $f33156d31a79402a$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($f33156d31a79402a$var$isPlainObject(target) && $f33156d31a79402a$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $f33156d31a79402a$var$React.isValidElement(source[key]) || (0, $4G43L.isValidElementType)(source[key])) output[key] = source[key];
        else if ($f33156d31a79402a$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $f33156d31a79402a$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $f33156d31a79402a$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $f33156d31a79402a$var$isPlainObject(source[key]) ? $f33156d31a79402a$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4G43L", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iHnq9"));

});
parcelRegister("iHnq9", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $d9ce690c28ea75f0$export$a7c73072b1a182ae; }, function (v) { return $d9ce690c28ea75f0$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $d9ce690c28ea75f0$export$9f27bc3417b4524d; }, function (v) { return $d9ce690c28ea75f0$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $d9ce690c28ea75f0$export$db77ccec0bb4ccac; }, function (v) { return $d9ce690c28ea75f0$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $d9ce690c28ea75f0$export$8392c0c9d3dcbd35; }, function (v) { return $d9ce690c28ea75f0$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d9ce690c28ea75f0$export$ffb0004e005737fa; }, function (v) { return $d9ce690c28ea75f0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $d9ce690c28ea75f0$export$b624eff549462981; }, function (v) { return $d9ce690c28ea75f0$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $d9ce690c28ea75f0$export$7897aa7841a5380c; }, function (v) { return $d9ce690c28ea75f0$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $d9ce690c28ea75f0$export$602eac185826482c; }, function (v) { return $d9ce690c28ea75f0$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $d9ce690c28ea75f0$export$e2c29f18771995cb; }, function (v) { return $d9ce690c28ea75f0$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d9ce690c28ea75f0$export$5f8d39834fd61797; }, function (v) { return $d9ce690c28ea75f0$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d9ce690c28ea75f0$export$74bf444e3cd11ea5; }, function (v) { return $d9ce690c28ea75f0$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $d9ce690c28ea75f0$export$998bcd577473dd93; }, function (v) { return $d9ce690c28ea75f0$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $d9ce690c28ea75f0$export$b706b080d889d2c9; }, function (v) { return $d9ce690c28ea75f0$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $d9ce690c28ea75f0$export$5be5a87408f70ddc; }, function (v) { return $d9ce690c28ea75f0$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $d9ce690c28ea75f0$export$45a5e7f76e0caa8d; }, function (v) { return $d9ce690c28ea75f0$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $d9ce690c28ea75f0$export$455c2e768291efa6; }, function (v) { return $d9ce690c28ea75f0$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $d9ce690c28ea75f0$export$9522e17588c12572; }, function (v) { return $d9ce690c28ea75f0$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $d9ce690c28ea75f0$export$2110ac352bb060b9; }, function (v) { return $d9ce690c28ea75f0$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $d9ce690c28ea75f0$export$56885ab8b9c456ab; }, function (v) { return $d9ce690c28ea75f0$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $d9ce690c28ea75f0$export$d927fcb6adf8f9de; }, function (v) { return $d9ce690c28ea75f0$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $d9ce690c28ea75f0$export$b82d16f27459e05a; }, function (v) { return $d9ce690c28ea75f0$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $d9ce690c28ea75f0$export$522c17b4f5e123e8; }, function (v) { return $d9ce690c28ea75f0$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $d9ce690c28ea75f0$export$1aabd8a0274ecfd6; }, function (v) { return $d9ce690c28ea75f0$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $d9ce690c28ea75f0$export$3d6c20d97e46b957; }, function (v) { return $d9ce690c28ea75f0$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $d9ce690c28ea75f0$export$9b621391a187a31a; }, function (v) { return $d9ce690c28ea75f0$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $d9ce690c28ea75f0$export$f5bbd400c2f4426f; }, function (v) { return $d9ce690c28ea75f0$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9ce690c28ea75f0$export$a7c73072b1a182ae;
var $d9ce690c28ea75f0$export$9f27bc3417b4524d;
var $d9ce690c28ea75f0$export$db77ccec0bb4ccac;
var $d9ce690c28ea75f0$export$8392c0c9d3dcbd35;
var $d9ce690c28ea75f0$export$ffb0004e005737fa;
var $d9ce690c28ea75f0$export$b624eff549462981;
var $d9ce690c28ea75f0$export$7897aa7841a5380c;
var $d9ce690c28ea75f0$export$602eac185826482c;
var $d9ce690c28ea75f0$export$e2c29f18771995cb;
var $d9ce690c28ea75f0$export$5f8d39834fd61797;
var $d9ce690c28ea75f0$export$74bf444e3cd11ea5;
var $d9ce690c28ea75f0$export$998bcd577473dd93;
var $d9ce690c28ea75f0$export$b706b080d889d2c9;
var $d9ce690c28ea75f0$export$5be5a87408f70ddc;
var $d9ce690c28ea75f0$export$45a5e7f76e0caa8d;
var $d9ce690c28ea75f0$export$455c2e768291efa6;
var $d9ce690c28ea75f0$export$9522e17588c12572;
var $d9ce690c28ea75f0$export$2110ac352bb060b9;
var $d9ce690c28ea75f0$export$56885ab8b9c456ab;
var $d9ce690c28ea75f0$export$d927fcb6adf8f9de;
var $d9ce690c28ea75f0$export$b82d16f27459e05a;
var $d9ce690c28ea75f0$export$522c17b4f5e123e8;
var $d9ce690c28ea75f0$export$1aabd8a0274ecfd6;
var $d9ce690c28ea75f0$export$3d6c20d97e46b957;
var $d9ce690c28ea75f0$export$9b621391a187a31a;
var $d9ce690c28ea75f0$export$f5bbd400c2f4426f;
"use strict";
var $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d9ce690c28ea75f0$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d9ce690c28ea75f0$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d9ce690c28ea75f0$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $d9ce690c28ea75f0$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d9ce690c28ea75f0$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE:
                    case $d9ce690c28ea75f0$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_LAZY_TYPE:
                            case $d9ce690c28ea75f0$var$REACT_MEMO_TYPE:
                                return object;
                            case $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$d9ce690c28ea75f0$export$a7c73072b1a182ae = $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE;
$d9ce690c28ea75f0$export$9f27bc3417b4524d = $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE;
$d9ce690c28ea75f0$export$db77ccec0bb4ccac = $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE;
$d9ce690c28ea75f0$export$8392c0c9d3dcbd35 = $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE;
$d9ce690c28ea75f0$export$ffb0004e005737fa = $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE;
$d9ce690c28ea75f0$export$b624eff549462981 = $d9ce690c28ea75f0$var$REACT_LAZY_TYPE;
$d9ce690c28ea75f0$export$7897aa7841a5380c = $d9ce690c28ea75f0$var$REACT_MEMO_TYPE;
$d9ce690c28ea75f0$export$602eac185826482c = $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE;
$d9ce690c28ea75f0$export$e2c29f18771995cb = $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE;
$d9ce690c28ea75f0$export$5f8d39834fd61797 = $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE;
$d9ce690c28ea75f0$export$74bf444e3cd11ea5 = $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE;
$d9ce690c28ea75f0$export$998bcd577473dd93 = $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE;
$d9ce690c28ea75f0$export$b706b080d889d2c9 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE;
};
$d9ce690c28ea75f0$export$5be5a87408f70ddc = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE;
};
$d9ce690c28ea75f0$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d9ce690c28ea75f0$var$REACT_ELEMENT_TYPE;
};
$d9ce690c28ea75f0$export$455c2e768291efa6 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE;
};
$d9ce690c28ea75f0$export$9522e17588c12572 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE;
};
$d9ce690c28ea75f0$export$2110ac352bb060b9 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_LAZY_TYPE;
};
$d9ce690c28ea75f0$export$56885ab8b9c456ab = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_MEMO_TYPE;
};
$d9ce690c28ea75f0$export$d927fcb6adf8f9de = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_PORTAL_TYPE;
};
$d9ce690c28ea75f0$export$b82d16f27459e05a = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE;
};
$d9ce690c28ea75f0$export$522c17b4f5e123e8 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE;
};
$d9ce690c28ea75f0$export$1aabd8a0274ecfd6 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE;
};
$d9ce690c28ea75f0$export$3d6c20d97e46b957 = function(object) {
    return $d9ce690c28ea75f0$var$typeOf(object) === $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE;
};
$d9ce690c28ea75f0$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $d9ce690c28ea75f0$var$REACT_FRAGMENT_TYPE || type === $d9ce690c28ea75f0$var$REACT_PROFILER_TYPE || type === $d9ce690c28ea75f0$var$REACT_STRICT_MODE_TYPE || type === $d9ce690c28ea75f0$var$REACT_SUSPENSE_TYPE || type === $d9ce690c28ea75f0$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $d9ce690c28ea75f0$var$REACT_LAZY_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_MEMO_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CONTEXT_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CONSUMER_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d9ce690c28ea75f0$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$d9ce690c28ea75f0$export$f5bbd400c2f4426f = $d9ce690c28ea75f0$var$typeOf;

});




parcelRegister("3InwI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b47bb15004445ae$export$2e2bcd8739ae039; });

var $cfKeZ = parcelRequire("cfKeZ");
function $2b47bb15004445ae$var$merge(acc, item) {
    if (!item) return acc;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $2b47bb15004445ae$export$2e2bcd8739ae039 = $2b47bb15004445ae$var$merge;

});

parcelRegister("iMDnO", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", function () { return $0387684bb2f6a822$export$456f6c1142f990db; });
$parcel$export(module.exports, "isCqShorthand", function () { return $0387684bb2f6a822$export$77c7c3e357f440e7; });
$parcel$export(module.exports, "getContainerQuery", function () { return $0387684bb2f6a822$export$10a9745dfa00d15; });
$parcel$export(module.exports, "default", function () { return $0387684bb2f6a822$export$2e2bcd8739ae039; });

function $0387684bb2f6a822$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $0387684bb2f6a822$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $0387684bb2f6a822$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $0387684bb2f6a822$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("4Sj9k", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $38cb0f45fa456b9a$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $38cb0f45fa456b9a$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $38cb0f45fa456b9a$export$2e2bcd8739ae039; });

var $eUhyY = parcelRequire("eUhyY");


var $k1b5n = parcelRequire("k1b5n");
function $38cb0f45fa456b9a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $38cb0f45fa456b9a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $38cb0f45fa456b9a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $38cb0f45fa456b9a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $38cb0f45fa456b9a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $38cb0f45fa456b9a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $38cb0f45fa456b9a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $k1b5n.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $38cb0f45fa456b9a$export$2e2bcd8739ae039 = $38cb0f45fa456b9a$var$style;

});
parcelRegister("eUhyY", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ada3eb5738fd4a73$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ada3eb5738fd4a73$var$_capitalize.default;
    }
});

var $ada3eb5738fd4a73$var$_capitalize = $ada3eb5738fd4a73$require$_interopRequireDefault((parcelRequire("hakLf")));

});
parcelRegister("hakLf", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c7f3798835790372$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7f3798835790372$var$capitalize;

var $c7f3798835790372$var$_formatMuiErrorMessage = $c7f3798835790372$require$_interopRequireDefault((parcelRequire("cCZAW")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $c7f3798835790372$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $c7f3798835790372$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});



parcelRegister("8t7XR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62a735c381fe1dc2$export$2e2bcd8739ae039; });
function $62a735c381fe1dc2$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("hxVqe", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $cc620f927411b1c2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc620f927411b1c2$var$_clamp.default;
    }
});

var $cc620f927411b1c2$var$_clamp = $cc620f927411b1c2$require$_interopRequireDefault((parcelRequire("bGq95")));

});
parcelRegister("bGq95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $0231ef103b8af312$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0231ef103b8af312$var$_default = module.exports.default = $0231ef103b8af312$var$clamp;

});


parcelRegister("36bfA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $241aa8c06e4e7e71$export$2b8d127b894957b9; }, function (v) { return $241aa8c06e4e7e71$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $241aa8c06e4e7e71$export$cea3a54a6425200c; }, function (v) { return $241aa8c06e4e7e71$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $241aa8c06e4e7e71$export$a7c73072b1a182ae; }, function (v) { return $241aa8c06e4e7e71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $241aa8c06e4e7e71$export$9f27bc3417b4524d; }, function (v) { return $241aa8c06e4e7e71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac; }, function (v) { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35; }, function (v) { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $241aa8c06e4e7e71$export$ffb0004e005737fa; }, function (v) { return $241aa8c06e4e7e71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $241aa8c06e4e7e71$export$b624eff549462981; }, function (v) { return $241aa8c06e4e7e71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $241aa8c06e4e7e71$export$7897aa7841a5380c; }, function (v) { return $241aa8c06e4e7e71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $241aa8c06e4e7e71$export$602eac185826482c; }, function (v) { return $241aa8c06e4e7e71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $241aa8c06e4e7e71$export$e2c29f18771995cb; }, function (v) { return $241aa8c06e4e7e71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $241aa8c06e4e7e71$export$5f8d39834fd61797; }, function (v) { return $241aa8c06e4e7e71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5; }, function (v) { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $241aa8c06e4e7e71$export$92387174baf9b227; }, function (v) { return $241aa8c06e4e7e71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $241aa8c06e4e7e71$export$ec112efeb987d9c6; }, function (v) { return $241aa8c06e4e7e71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $241aa8c06e4e7e71$export$b706b080d889d2c9; }, function (v) { return $241aa8c06e4e7e71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $241aa8c06e4e7e71$export$5be5a87408f70ddc; }, function (v) { return $241aa8c06e4e7e71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d; }, function (v) { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $241aa8c06e4e7e71$export$455c2e768291efa6; }, function (v) { return $241aa8c06e4e7e71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $241aa8c06e4e7e71$export$9522e17588c12572; }, function (v) { return $241aa8c06e4e7e71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $241aa8c06e4e7e71$export$2110ac352bb060b9; }, function (v) { return $241aa8c06e4e7e71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $241aa8c06e4e7e71$export$56885ab8b9c456ab; }, function (v) { return $241aa8c06e4e7e71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de; }, function (v) { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $241aa8c06e4e7e71$export$b82d16f27459e05a; }, function (v) { return $241aa8c06e4e7e71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $241aa8c06e4e7e71$export$522c17b4f5e123e8; }, function (v) { return $241aa8c06e4e7e71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6; }, function (v) { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $241aa8c06e4e7e71$export$9b621391a187a31a; }, function (v) { return $241aa8c06e4e7e71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f; }, function (v) { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $241aa8c06e4e7e71$export$2b8d127b894957b9;
var $241aa8c06e4e7e71$export$cea3a54a6425200c;
var $241aa8c06e4e7e71$export$a7c73072b1a182ae;
var $241aa8c06e4e7e71$export$9f27bc3417b4524d;
var $241aa8c06e4e7e71$export$db77ccec0bb4ccac;
var $241aa8c06e4e7e71$export$8392c0c9d3dcbd35;
var $241aa8c06e4e7e71$export$ffb0004e005737fa;
var $241aa8c06e4e7e71$export$b624eff549462981;
var $241aa8c06e4e7e71$export$7897aa7841a5380c;
var $241aa8c06e4e7e71$export$602eac185826482c;
var $241aa8c06e4e7e71$export$e2c29f18771995cb;
var $241aa8c06e4e7e71$export$5f8d39834fd61797;
var $241aa8c06e4e7e71$export$74bf444e3cd11ea5;
var $241aa8c06e4e7e71$export$92387174baf9b227;
var $241aa8c06e4e7e71$export$ec112efeb987d9c6;
var $241aa8c06e4e7e71$export$b706b080d889d2c9;
var $241aa8c06e4e7e71$export$5be5a87408f70ddc;
var $241aa8c06e4e7e71$export$45a5e7f76e0caa8d;
var $241aa8c06e4e7e71$export$455c2e768291efa6;
var $241aa8c06e4e7e71$export$9522e17588c12572;
var $241aa8c06e4e7e71$export$2110ac352bb060b9;
var $241aa8c06e4e7e71$export$56885ab8b9c456ab;
var $241aa8c06e4e7e71$export$d927fcb6adf8f9de;
var $241aa8c06e4e7e71$export$b82d16f27459e05a;
var $241aa8c06e4e7e71$export$522c17b4f5e123e8;
var $241aa8c06e4e7e71$export$1aabd8a0274ecfd6;
var $241aa8c06e4e7e71$export$9b621391a187a31a;
var $241aa8c06e4e7e71$export$f5bbd400c2f4426f;
'use strict';
var $241aa8c06e4e7e71$var$b = "function" === typeof Symbol && Symbol.for, $241aa8c06e4e7e71$var$c = $241aa8c06e4e7e71$var$b ? Symbol.for("react.element") : 60103, $241aa8c06e4e7e71$var$d = $241aa8c06e4e7e71$var$b ? Symbol.for("react.portal") : 60106, $241aa8c06e4e7e71$var$e = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fragment") : 60107, $241aa8c06e4e7e71$var$f = $241aa8c06e4e7e71$var$b ? Symbol.for("react.strict_mode") : 60108, $241aa8c06e4e7e71$var$g = $241aa8c06e4e7e71$var$b ? Symbol.for("react.profiler") : 60114, $241aa8c06e4e7e71$var$h = $241aa8c06e4e7e71$var$b ? Symbol.for("react.provider") : 60109, $241aa8c06e4e7e71$var$k = $241aa8c06e4e7e71$var$b ? Symbol.for("react.context") : 60110, $241aa8c06e4e7e71$var$l = $241aa8c06e4e7e71$var$b ? Symbol.for("react.async_mode") : 60111, $241aa8c06e4e7e71$var$m = $241aa8c06e4e7e71$var$b ? Symbol.for("react.concurrent_mode") : 60111, $241aa8c06e4e7e71$var$n = $241aa8c06e4e7e71$var$b ? Symbol.for("react.forward_ref") : 60112, $241aa8c06e4e7e71$var$p = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense") : 60113, $241aa8c06e4e7e71$var$q = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense_list") : 60120, $241aa8c06e4e7e71$var$r = $241aa8c06e4e7e71$var$b ? Symbol.for("react.memo") : 60115, $241aa8c06e4e7e71$var$t = $241aa8c06e4e7e71$var$b ? Symbol.for("react.lazy") : 60116, $241aa8c06e4e7e71$var$v = $241aa8c06e4e7e71$var$b ? Symbol.for("react.block") : 60121, $241aa8c06e4e7e71$var$w = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fundamental") : 60117, $241aa8c06e4e7e71$var$x = $241aa8c06e4e7e71$var$b ? Symbol.for("react.responder") : 60118, $241aa8c06e4e7e71$var$y = $241aa8c06e4e7e71$var$b ? Symbol.for("react.scope") : 60119;
function $241aa8c06e4e7e71$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $241aa8c06e4e7e71$var$c:
                switch(a = a.type, a){
                    case $241aa8c06e4e7e71$var$l:
                    case $241aa8c06e4e7e71$var$m:
                    case $241aa8c06e4e7e71$var$e:
                    case $241aa8c06e4e7e71$var$g:
                    case $241aa8c06e4e7e71$var$f:
                    case $241aa8c06e4e7e71$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $241aa8c06e4e7e71$var$k:
                            case $241aa8c06e4e7e71$var$n:
                            case $241aa8c06e4e7e71$var$t:
                            case $241aa8c06e4e7e71$var$r:
                            case $241aa8c06e4e7e71$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $241aa8c06e4e7e71$var$d:
                return u;
        }
    }
}
function $241aa8c06e4e7e71$var$A(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$m;
}
$241aa8c06e4e7e71$export$2b8d127b894957b9 = $241aa8c06e4e7e71$var$l;
$241aa8c06e4e7e71$export$cea3a54a6425200c = $241aa8c06e4e7e71$var$m;
$241aa8c06e4e7e71$export$a7c73072b1a182ae = $241aa8c06e4e7e71$var$k;
$241aa8c06e4e7e71$export$9f27bc3417b4524d = $241aa8c06e4e7e71$var$h;
$241aa8c06e4e7e71$export$db77ccec0bb4ccac = $241aa8c06e4e7e71$var$c;
$241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = $241aa8c06e4e7e71$var$n;
$241aa8c06e4e7e71$export$ffb0004e005737fa = $241aa8c06e4e7e71$var$e;
$241aa8c06e4e7e71$export$b624eff549462981 = $241aa8c06e4e7e71$var$t;
$241aa8c06e4e7e71$export$7897aa7841a5380c = $241aa8c06e4e7e71$var$r;
$241aa8c06e4e7e71$export$602eac185826482c = $241aa8c06e4e7e71$var$d;
$241aa8c06e4e7e71$export$e2c29f18771995cb = $241aa8c06e4e7e71$var$g;
$241aa8c06e4e7e71$export$5f8d39834fd61797 = $241aa8c06e4e7e71$var$f;
$241aa8c06e4e7e71$export$74bf444e3cd11ea5 = $241aa8c06e4e7e71$var$p;
$241aa8c06e4e7e71$export$92387174baf9b227 = function(a) {
    return $241aa8c06e4e7e71$var$A(a) || $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$l;
};
$241aa8c06e4e7e71$export$ec112efeb987d9c6 = $241aa8c06e4e7e71$var$A;
$241aa8c06e4e7e71$export$b706b080d889d2c9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$k;
};
$241aa8c06e4e7e71$export$5be5a87408f70ddc = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$h;
};
$241aa8c06e4e7e71$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $241aa8c06e4e7e71$var$c;
};
$241aa8c06e4e7e71$export$455c2e768291efa6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$n;
};
$241aa8c06e4e7e71$export$9522e17588c12572 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$e;
};
$241aa8c06e4e7e71$export$2110ac352bb060b9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$t;
};
$241aa8c06e4e7e71$export$56885ab8b9c456ab = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$r;
};
$241aa8c06e4e7e71$export$d927fcb6adf8f9de = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$d;
};
$241aa8c06e4e7e71$export$b82d16f27459e05a = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$g;
};
$241aa8c06e4e7e71$export$522c17b4f5e123e8 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$f;
};
$241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$p;
};
$241aa8c06e4e7e71$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $241aa8c06e4e7e71$var$e || a === $241aa8c06e4e7e71$var$m || a === $241aa8c06e4e7e71$var$g || a === $241aa8c06e4e7e71$var$f || a === $241aa8c06e4e7e71$var$p || a === $241aa8c06e4e7e71$var$q || "object" === typeof a && null !== a && (a.$$typeof === $241aa8c06e4e7e71$var$t || a.$$typeof === $241aa8c06e4e7e71$var$r || a.$$typeof === $241aa8c06e4e7e71$var$h || a.$$typeof === $241aa8c06e4e7e71$var$k || a.$$typeof === $241aa8c06e4e7e71$var$n || a.$$typeof === $241aa8c06e4e7e71$var$w || a.$$typeof === $241aa8c06e4e7e71$var$x || a.$$typeof === $241aa8c06e4e7e71$var$y || a.$$typeof === $241aa8c06e4e7e71$var$v);
};
$241aa8c06e4e7e71$export$f5bbd400c2f4426f = $241aa8c06e4e7e71$var$z;

});

parcelRegister("5BunL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $4147f9bebf16cd15$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $4147f9bebf16cd15$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $4147f9bebf16cd15$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $4147f9bebf16cd15$var$createBreakpoints(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $4147f9bebf16cd15$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("dleIZ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9b68a88767dffe7c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b68a88767dffe7c$var$createTheme;

var $9b68a88767dffe7c$var$_createPalette = $9b68a88767dffe7c$require$_interopRequireDefault((parcelRequire("hbeCt")));

var $9b68a88767dffe7c$var$_createThemeWithVars = $9b68a88767dffe7c$require$_interopRequireDefault((parcelRequire("brEcu")));

var $9b68a88767dffe7c$var$_createThemeNoVars = $9b68a88767dffe7c$require$_interopRequireDefault((parcelRequire("kzWxL")));
// eslint-disable-next-line consistent-return
function $9b68a88767dffe7c$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $9b68a88767dffe7c$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $9b68a88767dffe7c$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...rest } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $9b68a88767dffe7c$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $9b68a88767dffe7c$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $9b68a88767dffe7c$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $9b68a88767dffe7c$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $9b68a88767dffe7c$var$_createThemeWithVars.default)({
        ...rest,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("hbeCt", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c81ecde06497080b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dark = void 0;
module.exports.default = $c81ecde06497080b$var$createPalette;
module.exports.light = void 0;

var $c81ecde06497080b$var$_formatMuiErrorMessage = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $c81ecde06497080b$var$_deepmerge = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $lvExz = parcelRequire("lvExz");

var $c81ecde06497080b$var$_common = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("jKsPt")));

var $c81ecde06497080b$var$_grey = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("jCZrQ")));

var $c81ecde06497080b$var$_purple = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("e0VxD")));

var $c81ecde06497080b$var$_red = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("7y9Vx")));

var $c81ecde06497080b$var$_orange = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("7R7Vd")));

var $c81ecde06497080b$var$_blue = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("8Qy0j")));

var $c81ecde06497080b$var$_lightBlue = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("gZ4Hm")));

var $c81ecde06497080b$var$_green = $c81ecde06497080b$require$_interopRequireDefault((parcelRequire("9nc5r")));
function $c81ecde06497080b$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $c81ecde06497080b$var$_common.default.white,
            default: $c81ecde06497080b$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $c81ecde06497080b$var$light = module.exports.light = $c81ecde06497080b$var$getLight();
function $c81ecde06497080b$var$getDark() {
    return {
        text: {
            primary: $c81ecde06497080b$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $c81ecde06497080b$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $c81ecde06497080b$var$dark = module.exports.dark = $c81ecde06497080b$var$getDark();
function $c81ecde06497080b$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $lvExz.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $lvExz.darken)(intent.main, tonalOffsetDark);
    }
}
function $c81ecde06497080b$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_blue.default[200],
        light: $c81ecde06497080b$var$_blue.default[50],
        dark: $c81ecde06497080b$var$_blue.default[400]
    };
    return {
        main: $c81ecde06497080b$var$_blue.default[700],
        light: $c81ecde06497080b$var$_blue.default[400],
        dark: $c81ecde06497080b$var$_blue.default[800]
    };
}
function $c81ecde06497080b$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_purple.default[200],
        light: $c81ecde06497080b$var$_purple.default[50],
        dark: $c81ecde06497080b$var$_purple.default[400]
    };
    return {
        main: $c81ecde06497080b$var$_purple.default[500],
        light: $c81ecde06497080b$var$_purple.default[300],
        dark: $c81ecde06497080b$var$_purple.default[700]
    };
}
function $c81ecde06497080b$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_red.default[500],
        light: $c81ecde06497080b$var$_red.default[300],
        dark: $c81ecde06497080b$var$_red.default[700]
    };
    return {
        main: $c81ecde06497080b$var$_red.default[700],
        light: $c81ecde06497080b$var$_red.default[400],
        dark: $c81ecde06497080b$var$_red.default[800]
    };
}
function $c81ecde06497080b$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_lightBlue.default[400],
        light: $c81ecde06497080b$var$_lightBlue.default[300],
        dark: $c81ecde06497080b$var$_lightBlue.default[700]
    };
    return {
        main: $c81ecde06497080b$var$_lightBlue.default[700],
        light: $c81ecde06497080b$var$_lightBlue.default[500],
        dark: $c81ecde06497080b$var$_lightBlue.default[900]
    };
}
function $c81ecde06497080b$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_green.default[400],
        light: $c81ecde06497080b$var$_green.default[300],
        dark: $c81ecde06497080b$var$_green.default[700]
    };
    return {
        main: $c81ecde06497080b$var$_green.default[800],
        light: $c81ecde06497080b$var$_green.default[500],
        dark: $c81ecde06497080b$var$_green.default[900]
    };
}
function $c81ecde06497080b$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $c81ecde06497080b$var$_orange.default[400],
        light: $c81ecde06497080b$var$_orange.default[300],
        dark: $c81ecde06497080b$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $c81ecde06497080b$var$_orange.default[500],
        dark: $c81ecde06497080b$var$_orange.default[900]
    };
}
function $c81ecde06497080b$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, ...other } = palette;
    const primary = palette.primary || $c81ecde06497080b$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $c81ecde06497080b$var$getDefaultSecondary(mode);
    const error = palette.error || $c81ecde06497080b$var$getDefaultError(mode);
    const info = palette.info || $c81ecde06497080b$var$getDefaultInfo(mode);
    const success = palette.success || $c81ecde06497080b$var$getDefaultSuccess(mode);
    const warning = palette.warning || $c81ecde06497080b$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $lvExz.getContrastRatio)(background, $c81ecde06497080b$var$dark.text.primary) >= contrastThreshold ? $c81ecde06497080b$var$dark.text.primary : $c81ecde06497080b$var$light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $c81ecde06497080b$var$_formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $c81ecde06497080b$var$_formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $c81ecde06497080b$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $c81ecde06497080b$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $c81ecde06497080b$var$getLight();
    else if (mode === 'dark') modeHydrated = $c81ecde06497080b$var$getDark();
    const paletteOutput = (0, $c81ecde06497080b$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$c81ecde06497080b$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $c81ecde06497080b$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("lvExz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $94eiI = parcelRequire("94eiI");
Object.keys($94eiI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $94eiI[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $94eiI[key];
        }
    });
});

});
parcelRegister("94eiI", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $699f94a58ab9c3d0$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $699f94a58ab9c3d0$var$alpha;
module.exports.blend = $699f94a58ab9c3d0$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $699f94a58ab9c3d0$var$darken;
module.exports.decomposeColor = $699f94a58ab9c3d0$var$decomposeColor;
module.exports.emphasize = $699f94a58ab9c3d0$var$emphasize;
module.exports.getContrastRatio = $699f94a58ab9c3d0$var$getContrastRatio;
module.exports.getLuminance = $699f94a58ab9c3d0$var$getLuminance;
module.exports.hexToRgb = $699f94a58ab9c3d0$var$hexToRgb;
module.exports.hslToRgb = $699f94a58ab9c3d0$var$hslToRgb;
module.exports.lighten = $699f94a58ab9c3d0$var$lighten;
module.exports.private_safeAlpha = $699f94a58ab9c3d0$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $699f94a58ab9c3d0$var$private_safeDarken;
module.exports.private_safeEmphasize = $699f94a58ab9c3d0$var$private_safeEmphasize;
module.exports.private_safeLighten = $699f94a58ab9c3d0$var$private_safeLighten;
module.exports.recomposeColor = $699f94a58ab9c3d0$var$recomposeColor;
module.exports.rgbToHex = $699f94a58ab9c3d0$var$rgbToHex;

var $699f94a58ab9c3d0$var$_formatMuiErrorMessage = $699f94a58ab9c3d0$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $699f94a58ab9c3d0$var$_clamp = $699f94a58ab9c3d0$require$_interopRequireDefault((parcelRequire("hxVqe")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $699f94a58ab9c3d0$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $699f94a58ab9c3d0$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $699f94a58ab9c3d0$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $699f94a58ab9c3d0$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $699f94a58ab9c3d0$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $699f94a58ab9c3d0$var$decomposeColor($699f94a58ab9c3d0$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $699f94a58ab9c3d0$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $699f94a58ab9c3d0$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $699f94a58ab9c3d0$var$colorChannel = (color)=>{
    const decomposedColor = $699f94a58ab9c3d0$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $699f94a58ab9c3d0$var$colorChannel;
const $699f94a58ab9c3d0$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $699f94a58ab9c3d0$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $699f94a58ab9c3d0$var$private_safeColorChannel;
function $699f94a58ab9c3d0$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $699f94a58ab9c3d0$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $699f94a58ab9c3d0$var$decomposeColor(color);
    return `#${values.map((n, i)=>$699f94a58ab9c3d0$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $699f94a58ab9c3d0$var$hslToRgb(color) {
    color = $699f94a58ab9c3d0$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $699f94a58ab9c3d0$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $699f94a58ab9c3d0$var$getLuminance(color) {
    color = $699f94a58ab9c3d0$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $699f94a58ab9c3d0$var$decomposeColor($699f94a58ab9c3d0$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $699f94a58ab9c3d0$var$getContrastRatio(foreground, background) {
    const lumA = $699f94a58ab9c3d0$var$getLuminance(foreground);
    const lumB = $699f94a58ab9c3d0$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $699f94a58ab9c3d0$var$alpha(color, value) {
    color = $699f94a58ab9c3d0$var$decomposeColor(color);
    value = $699f94a58ab9c3d0$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $699f94a58ab9c3d0$var$recomposeColor(color);
}
function $699f94a58ab9c3d0$var$private_safeAlpha(color, value, warning) {
    try {
        return $699f94a58ab9c3d0$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $699f94a58ab9c3d0$var$darken(color, coefficient) {
    color = $699f94a58ab9c3d0$var$decomposeColor(color);
    coefficient = $699f94a58ab9c3d0$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $699f94a58ab9c3d0$var$recomposeColor(color);
}
function $699f94a58ab9c3d0$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $699f94a58ab9c3d0$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $699f94a58ab9c3d0$var$lighten(color, coefficient) {
    color = $699f94a58ab9c3d0$var$decomposeColor(color);
    coefficient = $699f94a58ab9c3d0$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $699f94a58ab9c3d0$var$recomposeColor(color);
}
function $699f94a58ab9c3d0$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $699f94a58ab9c3d0$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $699f94a58ab9c3d0$var$emphasize(color, coefficient = 0.15) {
    return $699f94a58ab9c3d0$var$getLuminance(color) > 0.5 ? $699f94a58ab9c3d0$var$darken(color, coefficient) : $699f94a58ab9c3d0$var$lighten(color, coefficient);
}
function $699f94a58ab9c3d0$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $699f94a58ab9c3d0$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $699f94a58ab9c3d0$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $699f94a58ab9c3d0$var$decomposeColor(background);
    const overlayColor = $699f94a58ab9c3d0$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $699f94a58ab9c3d0$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});


parcelRegister("jKsPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e608ad1952a5450f$var$common = {
    black: '#000',
    white: '#fff'
};
var $e608ad1952a5450f$var$_default = module.exports.default = $e608ad1952a5450f$var$common;

});

parcelRegister("jCZrQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e4a13b3b28bc572d$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $e4a13b3b28bc572d$var$_default = module.exports.default = $e4a13b3b28bc572d$var$grey;

});

parcelRegister("e0VxD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $a33db35306ed4657$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $a33db35306ed4657$var$_default = module.exports.default = $a33db35306ed4657$var$purple;

});

parcelRegister("7y9Vx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $57f368a9c7124642$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $57f368a9c7124642$var$_default = module.exports.default = $57f368a9c7124642$var$red;

});

parcelRegister("7R7Vd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $5b83a0c5da387942$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $5b83a0c5da387942$var$_default = module.exports.default = $5b83a0c5da387942$var$orange;

});

parcelRegister("8Qy0j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $670d8e92d99cd80c$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $670d8e92d99cd80c$var$_default = module.exports.default = $670d8e92d99cd80c$var$blue;

});

parcelRegister("gZ4Hm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $c5d5fcd7b5e8386f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c5d5fcd7b5e8386f$var$_default = module.exports.default = $c5d5fcd7b5e8386f$var$lightBlue;

});

parcelRegister("9nc5r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $6d2fa33a649fb4b6$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $6d2fa33a649fb4b6$var$_default = module.exports.default = $6d2fa33a649fb4b6$var$green;

});


parcelRegister("brEcu", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $85516648495ccc87$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $85516648495ccc87$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $85516648495ccc87$var$createThemeWithVars;

var $85516648495ccc87$var$_formatMuiErrorMessage = $85516648495ccc87$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $85516648495ccc87$var$_deepmerge = $85516648495ccc87$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $fyaOi = parcelRequire("fyaOi");
var $c626m = parcelRequire("c626m");

var $iI1Nz = parcelRequire("iI1Nz");

var $1MEOW = parcelRequire("1MEOW");

var $85516648495ccc87$var$_styleFunctionSx = $85516648495ccc87$require$_interopRequireWildcard((parcelRequire("3RwFu")));

var $lvExz = parcelRequire("lvExz");

var $85516648495ccc87$var$_createThemeNoVars = $85516648495ccc87$require$_interopRequireDefault((parcelRequire("kzWxL")));

var $85516648495ccc87$var$_createColorScheme = $85516648495ccc87$require$_interopRequireWildcard((parcelRequire("3lzSt")));

var $85516648495ccc87$var$_shouldSkipGeneratingVar = $85516648495ccc87$require$_interopRequireDefault((parcelRequire("hB1P1")));

var $85516648495ccc87$var$_createGetSelector = $85516648495ccc87$require$_interopRequireDefault((parcelRequire("df57O")));

var $9ulEf = parcelRequire("9ulEf");
function $85516648495ccc87$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $85516648495ccc87$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $85516648495ccc87$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $lvExz.hslToRgb)(color);
}
function $85516648495ccc87$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $lvExz.private_safeColorChannel)($85516648495ccc87$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $85516648495ccc87$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $85516648495ccc87$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $85516648495ccc87$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $c626m.default)(cssVarPrefix);
module.exports.createGetCssVar = $85516648495ccc87$var$createGetCssVar;
function $85516648495ccc87$var$attachColorScheme(colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $85516648495ccc87$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            }
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $85516648495ccc87$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        }
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $85516648495ccc87$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $85516648495ccc87$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $85516648495ccc87$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', shouldSkipGeneratingVar: shouldSkipGeneratingVar = $85516648495ccc87$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $85516648495ccc87$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $85516648495ccc87$var$_formatMuiErrorMessage.default)(21, defaultColorScheme));
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $85516648495ccc87$var$attachColorScheme(colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $85516648495ccc87$var$attachColorScheme(colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $85516648495ccc87$var$attachColorScheme(colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $1MEOW.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $85516648495ccc87$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $85516648495ccc87$var$setColor(palette.common, 'background', '#fff');
            $85516648495ccc87$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $85516648495ccc87$var$setColor(palette.common, 'background', '#000');
            $85516648495ccc87$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        $85516648495ccc87$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $85516648495ccc87$var$setColor(palette.Alert, 'errorColor', (0, $lvExz.private_safeDarken)(palette.error.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoColor', (0, $lvExz.private_safeDarken)(palette.info.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'successColor', (0, $lvExz.private_safeDarken)(palette.success.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningColor', (0, $lvExz.private_safeDarken)(palette.warning.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.error.main)));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.info.main)));
            $85516648495ccc87$var$setColor(palette.Alert, 'successFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.success.main)));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorStandardBg', (0, $lvExz.private_safeLighten)(palette.error.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoStandardBg', (0, $lvExz.private_safeLighten)(palette.info.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'successStandardBg', (0, $lvExz.private_safeLighten)(palette.success.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningStandardBg', (0, $lvExz.private_safeLighten)(palette.warning.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $85516648495ccc87$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $85516648495ccc87$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $85516648495ccc87$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $85516648495ccc87$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $85516648495ccc87$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $85516648495ccc87$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $85516648495ccc87$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'primaryBg', (0, $lvExz.private_safeLighten)(palette.primary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $lvExz.private_safeLighten)(palette.secondary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'errorBg', (0, $lvExz.private_safeLighten)(palette.error.main, 0.62));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'infoBg', (0, $lvExz.private_safeLighten)(palette.info.main, 0.62));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'successBg', (0, $lvExz.private_safeLighten)(palette.success.main, 0.62));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'warningBg', (0, $lvExz.private_safeLighten)(palette.warning.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $85516648495ccc87$var$setColor(palette.Slider, 'primaryTrack', (0, $lvExz.private_safeLighten)(palette.primary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Slider, 'secondaryTrack', (0, $lvExz.private_safeLighten)(palette.secondary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Slider, 'errorTrack', (0, $lvExz.private_safeLighten)(palette.error.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Slider, 'infoTrack', (0, $lvExz.private_safeLighten)(palette.info.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Slider, 'successTrack', (0, $lvExz.private_safeLighten)(palette.success.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Slider, 'warningTrack', (0, $lvExz.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, $lvExz.private_safeEmphasize)(palette.background.default, 0.8);
            $85516648495ccc87$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $85516648495ccc87$var$setColor(palette.SnackbarContent, 'color', $85516648495ccc87$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $85516648495ccc87$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $lvExz.private_safeEmphasize)(palette.background.paper, 0.15));
            $85516648495ccc87$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $85516648495ccc87$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $85516648495ccc87$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $85516648495ccc87$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $85516648495ccc87$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $lvExz.private_safeLighten)(palette.primary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $lvExz.private_safeLighten)(palette.secondary.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Switch, 'errorDisabledColor', (0, $lvExz.private_safeLighten)(palette.error.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Switch, 'infoDisabledColor', (0, $lvExz.private_safeLighten)(palette.info.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Switch, 'successDisabledColor', (0, $lvExz.private_safeLighten)(palette.success.main, 0.62));
            $85516648495ccc87$var$setColor(palette.Switch, 'warningDisabledColor', (0, $lvExz.private_safeLighten)(palette.warning.main, 0.62));
            $85516648495ccc87$var$setColor(palette.TableCell, 'border', (0, $lvExz.private_safeLighten)((0, $lvExz.private_safeAlpha)(palette.divider, 1), 0.88));
            $85516648495ccc87$var$setColor(palette.Tooltip, 'bg', (0, $lvExz.private_safeAlpha)(palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $85516648495ccc87$var$setColor(palette.Alert, 'errorColor', (0, $lvExz.private_safeLighten)(palette.error.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoColor', (0, $lvExz.private_safeLighten)(palette.info.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'successColor', (0, $lvExz.private_safeLighten)(palette.success.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningColor', (0, $lvExz.private_safeLighten)(palette.warning.light, 0.6));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $85516648495ccc87$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $85516648495ccc87$var$setColor(palette.Alert, 'successFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningFilledColor', $85516648495ccc87$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorStandardBg', (0, $lvExz.private_safeDarken)(palette.error.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoStandardBg', (0, $lvExz.private_safeDarken)(palette.info.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'successStandardBg', (0, $lvExz.private_safeDarken)(palette.success.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningStandardBg', (0, $lvExz.private_safeDarken)(palette.warning.light, 0.9));
            $85516648495ccc87$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $85516648495ccc87$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $85516648495ccc87$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $85516648495ccc87$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $85516648495ccc87$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $85516648495ccc87$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $85516648495ccc87$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $85516648495ccc87$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $85516648495ccc87$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $85516648495ccc87$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $85516648495ccc87$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $85516648495ccc87$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'primaryBg', (0, $lvExz.private_safeDarken)(palette.primary.main, 0.5));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'secondaryBg', (0, $lvExz.private_safeDarken)(palette.secondary.main, 0.5));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'errorBg', (0, $lvExz.private_safeDarken)(palette.error.main, 0.5));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'infoBg', (0, $lvExz.private_safeDarken)(palette.info.main, 0.5));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'successBg', (0, $lvExz.private_safeDarken)(palette.success.main, 0.5));
            $85516648495ccc87$var$setColor(palette.LinearProgress, 'warningBg', (0, $lvExz.private_safeDarken)(palette.warning.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $85516648495ccc87$var$setColor(palette.Slider, 'primaryTrack', (0, $lvExz.private_safeDarken)(palette.primary.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Slider, 'secondaryTrack', (0, $lvExz.private_safeDarken)(palette.secondary.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Slider, 'errorTrack', (0, $lvExz.private_safeDarken)(palette.error.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Slider, 'infoTrack', (0, $lvExz.private_safeDarken)(palette.info.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Slider, 'successTrack', (0, $lvExz.private_safeDarken)(palette.success.main, 0.5));
            $85516648495ccc87$var$setColor(palette.Slider, 'warningTrack', (0, $lvExz.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, $lvExz.private_safeEmphasize)(palette.background.default, 0.98);
            $85516648495ccc87$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $85516648495ccc87$var$setColor(palette.SnackbarContent, 'color', $85516648495ccc87$var$silent(()=>palette.getContrastText(snackbarContentBackground)));
            $85516648495ccc87$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $lvExz.private_safeEmphasize)(palette.background.paper, 0.15));
            $85516648495ccc87$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $85516648495ccc87$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $85516648495ccc87$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $85516648495ccc87$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $85516648495ccc87$var$setColor(palette.Switch, 'primaryDisabledColor', (0, $lvExz.private_safeDarken)(palette.primary.main, 0.55));
            $85516648495ccc87$var$setColor(palette.Switch, 'secondaryDisabledColor', (0, $lvExz.private_safeDarken)(palette.secondary.main, 0.55));
            $85516648495ccc87$var$setColor(palette.Switch, 'errorDisabledColor', (0, $lvExz.private_safeDarken)(palette.error.main, 0.55));
            $85516648495ccc87$var$setColor(palette.Switch, 'infoDisabledColor', (0, $lvExz.private_safeDarken)(palette.info.main, 0.55));
            $85516648495ccc87$var$setColor(palette.Switch, 'successDisabledColor', (0, $lvExz.private_safeDarken)(palette.success.main, 0.55));
            $85516648495ccc87$var$setColor(palette.Switch, 'warningDisabledColor', (0, $lvExz.private_safeDarken)(palette.warning.main, 0.55));
            $85516648495ccc87$var$setColor(palette.TableCell, 'border', (0, $lvExz.private_safeDarken)((0, $lvExz.private_safeAlpha)(palette.divider, 1), 0.68));
            $85516648495ccc87$var$setColor(palette.Tooltip, 'bg', (0, $lvExz.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $85516648495ccc87$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $85516648495ccc87$var$setColorChannel(palette.background, 'paper');
        $85516648495ccc87$var$setColorChannel(palette.common, 'background');
        $85516648495ccc87$var$setColorChannel(palette.common, 'onBackground');
        $85516648495ccc87$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $85516648495ccc87$var$setColor(palette[color], 'mainChannel', (0, $lvExz.private_safeColorChannel)($85516648495ccc87$var$toRgb(colors.main)));
                if (colors.light) $85516648495ccc87$var$setColor(palette[color], 'lightChannel', (0, $lvExz.private_safeColorChannel)($85516648495ccc87$var$toRgb(colors.light)));
                if (colors.dark) $85516648495ccc87$var$setColor(palette[color], 'darkChannel', (0, $lvExz.private_safeColorChannel)($85516648495ccc87$var$toRgb(colors.dark)));
                if (colors.contrastText) $85516648495ccc87$var$setColor(palette[color], 'contrastTextChannel', (0, $lvExz.private_safeColorChannel)($85516648495ccc87$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $85516648495ccc87$var$setColorChannel(palette[color], 'primary');
                    $85516648495ccc87$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $85516648495ccc87$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $85516648495ccc87$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $85516648495ccc87$var$_deepmerge.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $85516648495ccc87$var$_createGetSelector.default)(theme)
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $1MEOW.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $fyaOi.default)(input.spacing, (0, $iI1Nz.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $1MEOW.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$85516648495ccc87$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $85516648495ccc87$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = $9ulEf.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("c626m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ce7ace1e8505397$export$2e2bcd8739ae039; });
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $8ce7ace1e8505397$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("iI1Nz", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $d9edbb32af68bdcd$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d9edbb32af68bdcd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d9edbb32af68bdcd$var$_spacing.default;
    }
});

var $d9edbb32af68bdcd$var$_spacing = $d9edbb32af68bdcd$require$_interopRequireWildcard((parcelRequire("lbO2M")));
Object.keys($d9edbb32af68bdcd$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d9edbb32af68bdcd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d9edbb32af68bdcd$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d9edbb32af68bdcd$var$_spacing[key];
        }
    });
});

});
parcelRegister("lbO2M", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f6d171b68cba5d7a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $f6d171b68cba5d7a$var$createUnarySpacing;
module.exports.createUnaryUnit = $f6d171b68cba5d7a$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getStyleFromPropValue = $f6d171b68cba5d7a$var$getStyleFromPropValue;
module.exports.getValue = $f6d171b68cba5d7a$var$getValue;
module.exports.margin = $f6d171b68cba5d7a$var$margin;
module.exports.marginKeys = void 0;
module.exports.padding = $f6d171b68cba5d7a$var$padding;
module.exports.paddingKeys = void 0;

var $f6d171b68cba5d7a$var$_responsivePropType = $f6d171b68cba5d7a$require$_interopRequireDefault((parcelRequire("btvpa")));

var $g6OmK = parcelRequire("g6OmK");

var $dVkzc = parcelRequire("dVkzc");

var $f6d171b68cba5d7a$var$_merge = $f6d171b68cba5d7a$require$_interopRequireDefault((parcelRequire("aBbGo")));

var $f6d171b68cba5d7a$var$_memoize = $f6d171b68cba5d7a$require$_interopRequireDefault((parcelRequire("cteKR")));
const $f6d171b68cba5d7a$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $f6d171b68cba5d7a$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $f6d171b68cba5d7a$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f6d171b68cba5d7a$var$getCssProperties = (0, $f6d171b68cba5d7a$var$_memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f6d171b68cba5d7a$var$aliases[prop]) prop = $f6d171b68cba5d7a$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $f6d171b68cba5d7a$var$properties[a];
    const direction = $f6d171b68cba5d7a$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f6d171b68cba5d7a$var$marginKeys = module.exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $f6d171b68cba5d7a$var$paddingKeys = module.exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $f6d171b68cba5d7a$var$spacingKeys = [
    ...$f6d171b68cba5d7a$var$marginKeys,
    ...$f6d171b68cba5d7a$var$paddingKeys
];
function $f6d171b68cba5d7a$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $dVkzc.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $f6d171b68cba5d7a$var$createUnarySpacing(theme) {
    return $f6d171b68cba5d7a$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $f6d171b68cba5d7a$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $f6d171b68cba5d7a$var$getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f6d171b68cba5d7a$var$getValue(transformer, propValue);
            return acc;
        }, {});
}
function $f6d171b68cba5d7a$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $f6d171b68cba5d7a$var$getCssProperties(prop);
    const styleFromPropValue = $f6d171b68cba5d7a$var$getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $g6OmK.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f6d171b68cba5d7a$var$style(props, keys) {
    const transformer = $f6d171b68cba5d7a$var$createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>$f6d171b68cba5d7a$var$resolveCssProperty(props, keys, prop, transformer)).reduce($f6d171b68cba5d7a$var$_merge.default, {});
}
function $f6d171b68cba5d7a$var$margin(props) {
    return $f6d171b68cba5d7a$var$style(props, $f6d171b68cba5d7a$var$marginKeys);
}
$f6d171b68cba5d7a$var$margin.propTypes = {};
$f6d171b68cba5d7a$var$margin.filterProps = $f6d171b68cba5d7a$var$marginKeys;
function $f6d171b68cba5d7a$var$padding(props) {
    return $f6d171b68cba5d7a$var$style(props, $f6d171b68cba5d7a$var$paddingKeys);
}
$f6d171b68cba5d7a$var$padding.propTypes = {};
$f6d171b68cba5d7a$var$padding.filterProps = $f6d171b68cba5d7a$var$paddingKeys;
function $f6d171b68cba5d7a$var$spacing(props) {
    return $f6d171b68cba5d7a$var$style(props, $f6d171b68cba5d7a$var$spacingKeys);
}
$f6d171b68cba5d7a$var$spacing.propTypes = {};
$f6d171b68cba5d7a$var$spacing.filterProps = $f6d171b68cba5d7a$var$spacingKeys;
var $f6d171b68cba5d7a$var$_default = module.exports.default = $f6d171b68cba5d7a$var$spacing;

});
parcelRegister("btvpa", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $85aac3809a0e80a8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85aac3809a0e80a8$var$_responsivePropType.default;
    }
});

var $85aac3809a0e80a8$var$_responsivePropType = $85aac3809a0e80a8$require$_interopRequireDefault((parcelRequire("4j1p9")));

});
parcelRegister("4j1p9", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $322a06b6b04bc51a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $322a06b6b04bc51a$var$_propTypes = $322a06b6b04bc51a$require$_interopRequireDefault((parcelRequire("ebCsu")));
const $322a06b6b04bc51a$var$responsivePropType = {};
var $322a06b6b04bc51a$var$_default = module.exports.default = $322a06b6b04bc51a$var$responsivePropType;

});


parcelRegister("g6OmK", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $bba4467a51a40814$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bba4467a51a40814$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bba4467a51a40814$var$_breakpoints.default;
    }
});

var $bba4467a51a40814$var$_breakpoints = $bba4467a51a40814$require$_interopRequireWildcard((parcelRequire("enufT")));
Object.keys($bba4467a51a40814$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bba4467a51a40814$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bba4467a51a40814$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bba4467a51a40814$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("enufT", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a77aaebf8fa39d06$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.computeBreakpointsBase = $a77aaebf8fa39d06$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $a77aaebf8fa39d06$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $a77aaebf8fa39d06$var$handleBreakpoints;
module.exports.mergeBreakpointsInOrder = $a77aaebf8fa39d06$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $a77aaebf8fa39d06$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $a77aaebf8fa39d06$var$resolveBreakpointValues;
module.exports.values = void 0;

var $a77aaebf8fa39d06$var$_propTypes = $a77aaebf8fa39d06$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $a77aaebf8fa39d06$var$_deepmerge = $a77aaebf8fa39d06$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $a77aaebf8fa39d06$var$_merge = $a77aaebf8fa39d06$require$_interopRequireDefault((parcelRequire("aBbGo")));

var $1t22B = parcelRequire("1t22B");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const $a77aaebf8fa39d06$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $a77aaebf8fa39d06$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$a77aaebf8fa39d06$var$values[key]}px)`
};
const $a77aaebf8fa39d06$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $a77aaebf8fa39d06$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $a77aaebf8fa39d06$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $a77aaebf8fa39d06$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $a77aaebf8fa39d06$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $1t22B.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $1t22B.getContainerQuery)(theme.containerQueries ? theme : $a77aaebf8fa39d06$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $a77aaebf8fa39d06$var$values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $a77aaebf8fa39d06$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $a77aaebf8fa39d06$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $a77aaebf8fa39d06$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $a77aaebf8fa39d06$var$createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $a77aaebf8fa39d06$var$removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $a77aaebf8fa39d06$var$mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = $a77aaebf8fa39d06$var$createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $a77aaebf8fa39d06$var$_deepmerge.default)(prev, next), {});
    return $a77aaebf8fa39d06$var$removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function $a77aaebf8fa39d06$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $a77aaebf8fa39d06$var$resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $a77aaebf8fa39d06$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $a77aaebf8fa39d06$var$_default = module.exports.default = $a77aaebf8fa39d06$var$breakpoints;

});
parcelRegister("aBbGo", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $7b766c0a65064394$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7b766c0a65064394$var$_merge.default;
    }
});

var $7b766c0a65064394$var$_merge = $7b766c0a65064394$require$_interopRequireDefault((parcelRequire("35HZe")));

});
parcelRegister("35HZe", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2403f58a436872f8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2403f58a436872f8$var$_deepmerge = $2403f58a436872f8$require$_interopRequireDefault((parcelRequire("cfKeZ")));
function $2403f58a436872f8$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $2403f58a436872f8$var$_deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $2403f58a436872f8$var$_default = module.exports.default = $2403f58a436872f8$var$merge;

});


parcelRegister("1t22B", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $111a15268a0966f2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $111a15268a0966f2$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $111a15268a0966f2$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $111a15268a0966f2$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $111a15268a0966f2$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $111a15268a0966f2$var$_cssContainerQueries = $111a15268a0966f2$require$_interopRequireWildcard((parcelRequire("370g0")));

});
parcelRegister("370g0", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2442399679ea6387$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2442399679ea6387$var$cssContainerQueries;
module.exports.getContainerQuery = $2442399679ea6387$var$getContainerQuery;
module.exports.isCqShorthand = $2442399679ea6387$var$isCqShorthand;
module.exports.sortContainerQueries = $2442399679ea6387$var$sortContainerQueries;

var $2442399679ea6387$var$_formatMuiErrorMessage = $2442399679ea6387$require$_interopRequireDefault((parcelRequire("cCZAW")));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */ function $2442399679ea6387$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $2442399679ea6387$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $2442399679ea6387$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $2442399679ea6387$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});




parcelRegister("dVkzc", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $a2308d5df883cafc$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a2308d5df883cafc$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a2308d5df883cafc$var$_style.default;
    }
});

var $a2308d5df883cafc$var$_style = $a2308d5df883cafc$require$_interopRequireWildcard((parcelRequire("4KGEu")));
Object.keys($a2308d5df883cafc$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a2308d5df883cafc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a2308d5df883cafc$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a2308d5df883cafc$var$_style[key];
        }
    });
});

});
parcelRegister("4KGEu", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $375c8b22314c4f57$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getPath = $375c8b22314c4f57$var$getPath;
module.exports.getStyleValue = $375c8b22314c4f57$var$getStyleValue;

var $375c8b22314c4f57$var$_capitalize = $375c8b22314c4f57$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $375c8b22314c4f57$var$_responsivePropType = $375c8b22314c4f57$require$_interopRequireDefault((parcelRequire("btvpa")));

var $g6OmK = parcelRequire("g6OmK");
function $375c8b22314c4f57$var$getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $375c8b22314c4f57$var$getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $375c8b22314c4f57$var$getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $375c8b22314c4f57$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $375c8b22314c4f57$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $375c8b22314c4f57$var$getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $375c8b22314c4f57$var$getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $375c8b22314c4f57$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $g6OmK.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $375c8b22314c4f57$var$_default = module.exports.default = $375c8b22314c4f57$var$style;

});


parcelRegister("cteKR", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9143a378ec4ca038$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9143a378ec4ca038$var$_memoize.default;
    }
});

var $9143a378ec4ca038$var$_memoize = $9143a378ec4ca038$require$_interopRequireDefault((parcelRequire("1kTpR")));

});
parcelRegister("1kTpR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0f92a52a8ff6f3ad$var$memoize;
function $0f92a52a8ff6f3ad$var$memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});




parcelRegister("1MEOW", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $14c9f046a9e58068$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $14c9f046a9e58068$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $5nPqd.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $14c9f046a9e58068$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $14c9f046a9e58068$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $14c9f046a9e58068$var$_prepareTypographyVars.default;
    }
});

var $14c9f046a9e58068$var$_createCssVarsProvider = $14c9f046a9e58068$require$_interopRequireDefault((parcelRequire("3rA35")));

var $14c9f046a9e58068$var$_prepareCssVars = $14c9f046a9e58068$require$_interopRequireDefault((parcelRequire("eRucw")));

var $14c9f046a9e58068$var$_prepareTypographyVars = $14c9f046a9e58068$require$_interopRequireDefault((parcelRequire("jSttB")));

var $14c9f046a9e58068$var$_createCssVarsTheme = $14c9f046a9e58068$require$_interopRequireDefault((parcelRequire("doEUu")));

var $5nPqd = parcelRequire("5nPqd");

});
parcelRegister("3rA35", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $281fdb411c0cf4a9$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $281fdb411c0cf4a9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $281fdb411c0cf4a9$var$createCssVarsProvider;

var $281fdb411c0cf4a9$var$React = $281fdb411c0cf4a9$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $281fdb411c0cf4a9$var$_propTypes = $281fdb411c0cf4a9$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $i48zL = parcelRequire("i48zL");

var $1aEuo = parcelRequire("1aEuo");

var $281fdb411c0cf4a9$var$_useEnhancedEffect = $281fdb411c0cf4a9$require$_interopRequireDefault((parcelRequire("jMi8t")));

var $281fdb411c0cf4a9$var$_ThemeProvider = $281fdb411c0cf4a9$require$_interopRequireDefault((parcelRequire("lXls0")));

var $281fdb411c0cf4a9$var$_InitColorSchemeScript = $281fdb411c0cf4a9$require$_interopRequireWildcard((parcelRequire("ejtRR")));

var $281fdb411c0cf4a9$var$_useCurrentColorScheme = $281fdb411c0cf4a9$require$_interopRequireDefault((parcelRequire("jxswj")));

var $kSbwP = parcelRequire("kSbwP");
const $281fdb411c0cf4a9$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $281fdb411c0cf4a9$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $281fdb411c0cf4a9$var$_InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $281fdb411c0cf4a9$var$_InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $281fdb411c0cf4a9$var$React.createContext(undefined);
    const useColorScheme = ()=>$281fdb411c0cf4a9$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $281fdb411c0cf4a9$var$React.useRef(false);
        const upperTheme = (0, $1aEuo.default)();
        const ctx = $281fdb411c0cf4a9$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $281fdb411c0cf4a9$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $281fdb411c0cf4a9$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $281fdb411c0cf4a9$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $281fdb411c0cf4a9$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $281fdb411c0cf4a9$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $281fdb411c0cf4a9$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($281fdb411c0cf4a9$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $281fdb411c0cf4a9$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $281fdb411c0cf4a9$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $kSbwP.jsxs)($281fdb411c0cf4a9$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsx)($281fdb411c0cf4a9$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $kSbwP.jsx)($i48zL.default, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $kSbwP.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $281fdb411c0cf4a9$var$_InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("i48zL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d26f40af0100f236$export$2e2bcd8739ae039; });
parcelRequire("8nGP5");


var $bj8tp = parcelRequire("bj8tp");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $d26f40af0100f236$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $d26f40af0100f236$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($d26f40af0100f236$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bj8tp.Global), {
        styles: globalStyles
    });
}

});
parcelRegister("bj8tp", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $83b80aaa9bbccc8e$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $83b80aaa9bbccc8e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $83b80aaa9bbccc8e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jspCa")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("jspCa")).w; });

var $jspCa = parcelRequire("jspCa");

var $8nGP5 = parcelRequire("8nGP5");

var $7x006 = parcelRequire("7x006");

var $dn94N = parcelRequire("dn94N");

var $iBxqj = parcelRequire("iBxqj");
parcelRequire("6tfZw");
parcelRequire("8tsi7");
parcelRequire("eIxVf");

parcelRequire("cSUBB");
var $83b80aaa9bbccc8e$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $83b80aaa9bbccc8e$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jspCa.h).call(props, 'css')) // $FlowFixMe
    return $8nGP5.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jspCa.E);
    createElementArgArray[1] = (0, $jspCa.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $8nGP5.createElement.apply(null, createElementArgArray);
};
var $83b80aaa9bbccc8e$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $83b80aaa9bbccc8e$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jspCa.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $iBxqj.serializeStyles)([
        styles
    ], undefined, $8nGP5.useContext((0, $jspCa.T)));
    if (!(0, $jspCa.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8nGP5.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8nGP5.useRef();
    (0, $dn94N.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $dn94N.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7x006.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $83b80aaa9bbccc8e$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $iBxqj.serializeStyles)(args);
}
var $83b80aaa9bbccc8e$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $83b80aaa9bbccc8e$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $83b80aaa9bbccc8e$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $83b80aaa9bbccc8e$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7x006.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $83b80aaa9bbccc8e$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $dn94N.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7x006.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $83b80aaa9bbccc8e$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jspCa.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $iBxqj.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7x006.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $83b80aaa9bbccc8e$var$merge(cache.registered, css, $83b80aaa9bbccc8e$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8nGP5.useContext((0, $jspCa.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($83b80aaa9bbccc8e$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $83b80aaa9bbccc8e$var$isBrowser, $83b80aaa9bbccc8e$var$isTestEnv, $83b80aaa9bbccc8e$var$globalContext, $83b80aaa9bbccc8e$var$globalKey;

});
parcelRegister("jspCa", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $e2a48059f7c5542d$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $e2a48059f7c5542d$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $e2a48059f7c5542d$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $e2a48059f7c5542d$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $e2a48059f7c5542d$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $e2a48059f7c5542d$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $e2a48059f7c5542d$export$a9c23c6ac3fc3eca; });

var $8nGP5 = parcelRequire("8nGP5");

var $6tfZw = parcelRequire("6tfZw");

var $1TGTA = parcelRequire("1TGTA");

var $eIxVf = parcelRequire("eIxVf");

var $glGaj = parcelRequire("glGaj");

var $7x006 = parcelRequire("7x006");

var $iBxqj = parcelRequire("iBxqj");

var $dn94N = parcelRequire("dn94N");
var $e2a48059f7c5542d$export$23f2a1d2818174ef = true;
var $e2a48059f7c5542d$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e2a48059f7c5542d$var$EmotionCacheContext = /* #__PURE__ */ $8nGP5.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $6tfZw.default)({
    key: 'css'
}) : null);
var $e2a48059f7c5542d$export$e7094788287c5e9b = $e2a48059f7c5542d$var$EmotionCacheContext.Provider;
var $e2a48059f7c5542d$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
};
var $e2a48059f7c5542d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e2a48059f7c5542d$export$23f2a1d2818174ef) $e2a48059f7c5542d$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8nGP5.useContext)($e2a48059f7c5542d$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6tfZw.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e2a48059f7c5542d$export$971d5caa766a69d7 = /* #__PURE__ */ $8nGP5.createContext({});
var $e2a48059f7c5542d$export$3b14a55fb2447963 = function useTheme() {
    return $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
};
var $e2a48059f7c5542d$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $1TGTA.default)({}, outerTheme, theme);
};
var $e2a48059f7c5542d$var$createCacheWithTheme = /* #__PURE__ */ (0, $eIxVf.default)(function(outerTheme) {
    return (0, $eIxVf.default)(function(theme) {
        return $e2a48059f7c5542d$var$getTheme(outerTheme, theme);
    });
});
var $e2a48059f7c5542d$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e2a48059f7c5542d$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e2a48059f7c5542d$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8nGP5.createElement(Component, (0, $1TGTA.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $8nGP5.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $glGaj.default)(WithTheme, Component);
}
var $e2a48059f7c5542d$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $e2a48059f7c5542d$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e2a48059f7c5542d$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e2a48059f7c5542d$var$getLastPart(match[1]);
    return undefined;
};
var $e2a48059f7c5542d$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e2a48059f7c5542d$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e2a48059f7c5542d$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $e2a48059f7c5542d$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e2a48059f7c5542d$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e2a48059f7c5542d$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e2a48059f7c5542d$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e2a48059f7c5542d$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e2a48059f7c5542d$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e2a48059f7c5542d$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e2a48059f7c5542d$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e2a48059f7c5542d$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7x006.registerStyles)(cache, serialized, isStringTag);
    (0, $dn94N.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7x006.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e2a48059f7c5542d$var$Emotion = /* #__PURE__ */ $e2a48059f7c5542d$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e2a48059f7c5542d$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $7x006.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $iBxqj.serializeStyles)(registeredStyles, undefined, $8nGP5.useContext($e2a48059f7c5542d$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e2a48059f7c5542d$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $e2a48059f7c5542d$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($e2a48059f7c5542d$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8nGP5.createElement(WrappedComponent, newProps));
});
var $e2a48059f7c5542d$export$a9c23c6ac3fc3eca = $e2a48059f7c5542d$var$Emotion;

});
parcelRegister("6tfZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b61db10e92cce84$export$2e2bcd8739ae039; });

var $77sbF = parcelRequire("77sbF");

var $jtx5G = parcelRequire("jtx5G");

var $gbY0o = parcelRequire("gbY0o");

var $u6I0t = parcelRequire("u6I0t");
var $4b61db10e92cce84$var$isBrowser = typeof document !== 'undefined';
var $4b61db10e92cce84$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $jtx5G.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $jtx5G.token)(character)) break;
        (0, $jtx5G.next)();
    }
    return (0, $jtx5G.slice)(begin, (0, $jtx5G.position));
};
var $4b61db10e92cce84$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $jtx5G.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $jtx5G.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $4b61db10e92cce84$var$identifierWithPointTracking((0, $jtx5G.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $jtx5G.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $jtx5G.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $jtx5G.from)(character);
    }
    while (character = (0, $jtx5G.next)());
    return parsed;
};
var $4b61db10e92cce84$var$getRules = function getRules(value, points) {
    return (0, $jtx5G.dealloc)($4b61db10e92cce84$var$toRules((0, $jtx5G.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $4b61db10e92cce84$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $4b61db10e92cce84$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$4b61db10e92cce84$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $4b61db10e92cce84$var$fixedElements.set(element, true);
    var points = [];
    var rules = $4b61db10e92cce84$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $4b61db10e92cce84$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $4b61db10e92cce84$var$prefix(value, length) {
    switch((0, $jtx5G.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $jtx5G.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $jtx5G.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MOZ) + value + (0, $jtx5G.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + value + value;
        // order
        case 6165:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.replace)(value, /(\w+).+(:[^]+)/, (0, $jtx5G.WEBKIT) + 'box-$1$2' + (0, $jtx5G.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-item-' + (0, $jtx5G.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + 'flex-line-pack' + (0, $jtx5G.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $jtx5G.WEBKIT) + 'box-' + (0, $jtx5G.replace)(value, '-grow', '') + (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $jtx5G.WEBKIT) + (0, $jtx5G.replace)(value, /([^-])(transform)/g, '$1' + (0, $jtx5G.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $jtx5G.replace)((0, $jtx5G.replace)((0, $jtx5G.replace)(value, /(zoom-|grab)/, (0, $jtx5G.WEBKIT) + '$1'), /(image-set)/, (0, $jtx5G.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $jtx5G.replace)(value, /(image-set\([^]*)/, (0, $jtx5G.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $jtx5G.replace)((0, $jtx5G.replace)(value, /(.+:)(flex-)?(.*)/, (0, $jtx5G.WEBKIT) + 'box-pack:$3' + (0, $jtx5G.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $jtx5G.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $jtx5G.replace)(value, /(.+)-inline(.+)/, (0, $jtx5G.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $jtx5G.strlen)(value) - 1 - length > 6) switch((0, $jtx5G.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $jtx5G.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $jtx5G.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $jtx5G.WEBKIT) + '$2-$3' + '$1' + (0, $jtx5G.MOZ) + ((0, $jtx5G.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $jtx5G.indexof)(value, 'stretch') ? $4b61db10e92cce84$var$prefix((0, $jtx5G.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $jtx5G.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $jtx5G.charat)(value, (0, $jtx5G.strlen)(value) - 3 - (~(0, $jtx5G.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $jtx5G.replace)(value, ':', ':' + (0, $jtx5G.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $jtx5G.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $jtx5G.WEBKIT) + ((0, $jtx5G.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $jtx5G.WEBKIT) + '$2$3' + '$1' + (0, $jtx5G.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $jtx5G.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + (0, $jtx5G.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $jtx5G.WEBKIT) + value + (0, $jtx5G.MS) + value + value;
    }
    return value;
}
var $4b61db10e92cce84$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $jtx5G.DECLARATION:
                element["return"] = $4b61db10e92cce84$var$prefix(element.value, element.length);
                break;
            case 0, $jtx5G.KEYFRAMES:
                return (0, $jtx5G.serialize)([
                    (0, $jtx5G.copy)(element, {
                        value: (0, $jtx5G.replace)(element.value, '@', '@' + (0, $jtx5G.WEBKIT))
                    })
                ], callback);
            case 0, $jtx5G.RULESET:
                if (element.length) return (0, $jtx5G.combine)(element.props, function(value) {
                    switch((0, $jtx5G.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $jtx5G.serialize)([
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(read-\w+)/, ':' + (0, $jtx5G.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $jtx5G.serialize)([
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, ':' + (0, $jtx5G.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, ':' + (0, $jtx5G.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jtx5G.copy)(element, {
                                    props: [
                                        (0, $jtx5G.replace)(value, /:(plac\w+)/, (0, $jtx5G.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $4b61db10e92cce84$var$getServerStylisCache = $4b61db10e92cce84$var$isBrowser ? undefined : (0, $gbY0o.default)(function() {
    return (0, $u6I0t.default)(function() {
        return {};
    });
});
var $4b61db10e92cce84$var$defaultStylisPlugins = [
    $4b61db10e92cce84$var$prefixer
];
var $4b61db10e92cce84$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($4b61db10e92cce84$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $4b61db10e92cce84$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($4b61db10e92cce84$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $4b61db10e92cce84$var$compat,
        $4b61db10e92cce84$var$removeLabel
    ];
    if (!$4b61db10e92cce84$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $jtx5G.stringify),
            (0, $jtx5G.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $jtx5G.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $jtx5G.serialize)((0, $jtx5G.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $jtx5G.stringify)
        ];
        var _serializer = (0, $jtx5G.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $jtx5G.serialize)((0, $jtx5G.compile)(styles), _serializer);
        };
        var serverStylisCache = $4b61db10e92cce84$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $77sbF.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("77sbF", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $52ef0d398243f671$export$9d753cd7ae895cce; });
var $52ef0d398243f671$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $52ef0d398243f671$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $52ef0d398243f671$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $52ef0d398243f671$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$52ef0d398243f671$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($52ef0d398243f671$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $52ef0d398243f671$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("jtx5G", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $eea1162845e87fb8$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $eea1162845e87fb8$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $eea1162845e87fb8$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $eea1162845e87fb8$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $eea1162845e87fb8$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $eea1162845e87fb8$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $eea1162845e87fb8$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $eea1162845e87fb8$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $eea1162845e87fb8$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $eea1162845e87fb8$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $eea1162845e87fb8$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $eea1162845e87fb8$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $eea1162845e87fb8$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $eea1162845e87fb8$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $eea1162845e87fb8$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $eea1162845e87fb8$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $eea1162845e87fb8$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $eea1162845e87fb8$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $eea1162845e87fb8$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $eea1162845e87fb8$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $eea1162845e87fb8$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $eea1162845e87fb8$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $eea1162845e87fb8$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $eea1162845e87fb8$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $eea1162845e87fb8$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $eea1162845e87fb8$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $eea1162845e87fb8$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $eea1162845e87fb8$export$38bcb760f1d4871c; });
var $eea1162845e87fb8$export$71ad59f2e432cfe8 = "-ms-";
var $eea1162845e87fb8$export$2c0f367103c8d01c = "-moz-";
var $eea1162845e87fb8$export$39dfd62a25e0fe93 = "-webkit-";
var $eea1162845e87fb8$export$a29989082612d0d9 = "comm";
var $eea1162845e87fb8$export$aa3a2e812ca8570d = "rule";
var $eea1162845e87fb8$export$527d108ccf083c2b = "decl";
var $eea1162845e87fb8$export$d3d35020fa5b54f0 = "@page";
var $eea1162845e87fb8$export$500415a86c544f73 = "@media";
var $eea1162845e87fb8$export$a763edbf796b780a = "@import";
var $eea1162845e87fb8$export$2790aeb8b4e5c826 = "@charset";
var $eea1162845e87fb8$export$1cc683e23b84b133 = "@viewport";
var $eea1162845e87fb8$export$9447a5efea57e862 = "@supports";
var $eea1162845e87fb8$export$ef011b4e114b1fba = "@document";
var $eea1162845e87fb8$export$6aad947bda0f3f46 = "@namespace";
var $eea1162845e87fb8$export$b44a8529a35fcb60 = "@keyframes";
var $eea1162845e87fb8$export$2c16de31893252e6 = "@font-face";
var $eea1162845e87fb8$export$3d846dd52e150c6f = "@counter-style";
var $eea1162845e87fb8$export$22314bfbb57653fe = "@font-feature-values";
var $eea1162845e87fb8$export$d773506282b3cfe6 = "@layer";
var $eea1162845e87fb8$export$2335f513bbd82c6d = Math.abs;
var $eea1162845e87fb8$export$6788812c4e6611e6 = String.fromCharCode;
var $eea1162845e87fb8$export$e6e34fd1f2686227 = Object.assign;
function $eea1162845e87fb8$export$d6af199866bfb566(e, r) {
    return $eea1162845e87fb8$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 0)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 1)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 2)) << 2 ^ $eea1162845e87fb8$export$a9db5e087081082d(e, 3) : 0;
}
function $eea1162845e87fb8$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $eea1162845e87fb8$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $eea1162845e87fb8$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $eea1162845e87fb8$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $eea1162845e87fb8$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $eea1162845e87fb8$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $eea1162845e87fb8$export$36776f635604f274(e) {
    return e.length;
}
function $eea1162845e87fb8$export$f9084667e487ed46(e) {
    return e.length;
}
function $eea1162845e87fb8$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $eea1162845e87fb8$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $eea1162845e87fb8$export$53f1d5ea8de3d7c = 1;
var $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1;
var $eea1162845e87fb8$export$f24224f1c91d8156 = 0;
var $eea1162845e87fb8$export$5880b8b5730aff45 = 0;
var $eea1162845e87fb8$export$c0306caf338ac095 = 0;
var $eea1162845e87fb8$export$30a86d91af8ff6e6 = "";
function $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $eea1162845e87fb8$export$53f1d5ea8de3d7c,
        column: $eea1162845e87fb8$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $eea1162845e87fb8$export$784d13d8ee351f07(e, r) {
    return $eea1162845e87fb8$export$e6e34fd1f2686227($eea1162845e87fb8$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $eea1162845e87fb8$export$eba6f6f03b0a92e7() {
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$232faf9add678146() {
    $eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$5880b8b5730aff45 > 0 ? $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, --$eea1162845e87fb8$export$5880b8b5730aff45) : 0;
    if ($eea1162845e87fb8$export$4e0c71f277ca26b3--, $eea1162845e87fb8$export$c0306caf338ac095 === 10) $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$53f1d5ea8de3d7c--;
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$48cfd1e771a65c4f() {
    $eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$5880b8b5730aff45 < $eea1162845e87fb8$export$f24224f1c91d8156 ? $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, $eea1162845e87fb8$export$5880b8b5730aff45++) : 0;
    if ($eea1162845e87fb8$export$4e0c71f277ca26b3++, $eea1162845e87fb8$export$c0306caf338ac095 === 10) $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$53f1d5ea8de3d7c++;
    return $eea1162845e87fb8$export$c0306caf338ac095;
}
function $eea1162845e87fb8$export$4d3fb11e950abb9e() {
    return $eea1162845e87fb8$export$a9db5e087081082d($eea1162845e87fb8$export$30a86d91af8ff6e6, $eea1162845e87fb8$export$5880b8b5730aff45);
}
function $eea1162845e87fb8$export$e88cb2efb12ae807() {
    return $eea1162845e87fb8$export$5880b8b5730aff45;
}
function $eea1162845e87fb8$export$58adb3bec8346d0f(e, r) {
    return $eea1162845e87fb8$export$2f35ab04d2335697($eea1162845e87fb8$export$30a86d91af8ff6e6, e, r);
}
function $eea1162845e87fb8$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $eea1162845e87fb8$export$2de70f21292aac9e(e) {
    return $eea1162845e87fb8$export$53f1d5ea8de3d7c = $eea1162845e87fb8$export$4e0c71f277ca26b3 = 1, $eea1162845e87fb8$export$f24224f1c91d8156 = $eea1162845e87fb8$export$36776f635604f274($eea1162845e87fb8$export$30a86d91af8ff6e6 = e), $eea1162845e87fb8$export$5880b8b5730aff45 = 0, [];
}
function $eea1162845e87fb8$export$45918ac1574455b1(e) {
    return $eea1162845e87fb8$export$30a86d91af8ff6e6 = "", e;
}
function $eea1162845e87fb8$export$410ac95b9ec204b8(e) {
    return $eea1162845e87fb8$export$87c2784dc9fc4ab($eea1162845e87fb8$export$58adb3bec8346d0f($eea1162845e87fb8$export$5880b8b5730aff45 - 1, $eea1162845e87fb8$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $eea1162845e87fb8$export$660b2ee2d4fb4eff(e) {
    return $eea1162845e87fb8$export$45918ac1574455b1($eea1162845e87fb8$export$5f8c09e3ae6f64e1($eea1162845e87fb8$export$2de70f21292aac9e(e)));
}
function $eea1162845e87fb8$export$7af1228ff777d175(e) {
    while($eea1162845e87fb8$export$c0306caf338ac095 = $eea1162845e87fb8$export$4d3fb11e950abb9e())if ($eea1162845e87fb8$export$c0306caf338ac095 < 33) $eea1162845e87fb8$export$48cfd1e771a65c4f();
    else break;
    return $eea1162845e87fb8$export$9e1725a4cfeada27(e) > 2 || $eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $eea1162845e87fb8$export$5f8c09e3ae6f64e1(e) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())switch($eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$c0306caf338ac095)){
        case 0:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$c2ab62c7bf24634($eea1162845e87fb8$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$410ac95b9ec204b8($eea1162845e87fb8$export$c0306caf338ac095), e);
            break;
        default:
            $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$6788812c4e6611e6($eea1162845e87fb8$export$c0306caf338ac095), e);
    }
    return e;
}
function $eea1162845e87fb8$export$955ba06d119e085e(e, r) {
    while(--r && $eea1162845e87fb8$export$48cfd1e771a65c4f())if ($eea1162845e87fb8$export$c0306caf338ac095 < 48 || $eea1162845e87fb8$export$c0306caf338ac095 > 102 || $eea1162845e87fb8$export$c0306caf338ac095 > 57 && $eea1162845e87fb8$export$c0306caf338ac095 < 65 || $eea1162845e87fb8$export$c0306caf338ac095 > 70 && $eea1162845e87fb8$export$c0306caf338ac095 < 97) break;
    return $eea1162845e87fb8$export$58adb3bec8346d0f(e, $eea1162845e87fb8$export$e88cb2efb12ae807() + (r < 6 && $eea1162845e87fb8$export$4d3fb11e950abb9e() == 32 && $eea1162845e87fb8$export$48cfd1e771a65c4f() == 32));
}
function $eea1162845e87fb8$export$c889f2fcc19dbf12(e) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())switch($eea1162845e87fb8$export$c0306caf338ac095){
        case e:
            return $eea1162845e87fb8$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $eea1162845e87fb8$export$c889f2fcc19dbf12($eea1162845e87fb8$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $eea1162845e87fb8$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $eea1162845e87fb8$export$48cfd1e771a65c4f();
            break;
    }
    return $eea1162845e87fb8$export$5880b8b5730aff45;
}
function $eea1162845e87fb8$export$4254d4e2b3745c4c(e, r) {
    while($eea1162845e87fb8$export$48cfd1e771a65c4f())if (e + $eea1162845e87fb8$export$c0306caf338ac095 === 57) break;
    else if (e + $eea1162845e87fb8$export$c0306caf338ac095 === 84 && $eea1162845e87fb8$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $eea1162845e87fb8$export$58adb3bec8346d0f(r, $eea1162845e87fb8$export$5880b8b5730aff45 - 1) + "*" + $eea1162845e87fb8$export$6788812c4e6611e6(e === 47 ? e : $eea1162845e87fb8$export$48cfd1e771a65c4f());
}
function $eea1162845e87fb8$export$c2ab62c7bf24634(e) {
    while(!$eea1162845e87fb8$export$9e1725a4cfeada27($eea1162845e87fb8$export$4d3fb11e950abb9e()))$eea1162845e87fb8$export$48cfd1e771a65c4f();
    return $eea1162845e87fb8$export$58adb3bec8346d0f(e, $eea1162845e87fb8$export$5880b8b5730aff45);
}
function $eea1162845e87fb8$export$ef7acd7185315e22(e) {
    return $eea1162845e87fb8$export$45918ac1574455b1($eea1162845e87fb8$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $eea1162845e87fb8$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $eea1162845e87fb8$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $eea1162845e87fb8$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $eea1162845e87fb8$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($eea1162845e87fb8$export$f8e21b1e77979a08(j += $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $eea1162845e87fb8$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $eea1162845e87fb8$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $eea1162845e87fb8$export$955ba06d119e085e($eea1162845e87fb8$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($eea1162845e87fb8$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$4a34f930e789283c($eea1162845e87fb8$export$4254d4e2b3745c4c($eea1162845e87fb8$export$48cfd1e771a65c4f(), $eea1162845e87fb8$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $eea1162845e87fb8$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $eea1162845e87fb8$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $eea1162845e87fb8$export$36776f635604f274(j) - l) $eea1162845e87fb8$export$10d8903dec122b9d(p > 32 ? $eea1162845e87fb8$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $eea1162845e87fb8$export$f8483753829ec8f3($eea1162845e87fb8$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $eea1162845e87fb8$export$10d8903dec122b9d(y = $eea1162845e87fb8$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $eea1162845e87fb8$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $eea1162845e87fb8$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $eea1162845e87fb8$export$98e6a39c04603d36(e, y, y, n && $eea1162845e87fb8$export$10d8903dec122b9d($eea1162845e87fb8$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $eea1162845e87fb8$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $eea1162845e87fb8$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $eea1162845e87fb8$export$232faf9add678146() == 125) continue;
            }
            switch(j += $eea1162845e87fb8$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($eea1162845e87fb8$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($eea1162845e87fb8$export$4d3fb11e950abb9e() === 45) j += $eea1162845e87fb8$export$410ac95b9ec204b8($eea1162845e87fb8$export$48cfd1e771a65c4f());
                    v = $eea1162845e87fb8$export$4d3fb11e950abb9e(), o = l = $eea1162845e87fb8$export$36776f635604f274(g = j += $eea1162845e87fb8$export$c2ab62c7bf24634($eea1162845e87fb8$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $eea1162845e87fb8$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $eea1162845e87fb8$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $eea1162845e87fb8$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $eea1162845e87fb8$export$2f35ab04d2335697(e, v + 1, v = $eea1162845e87fb8$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $eea1162845e87fb8$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $eea1162845e87fb8$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, s === 0 ? $eea1162845e87fb8$export$aa3a2e812ca8570d : i, f, o, l);
}
function $eea1162845e87fb8$export$4a34f930e789283c(e, r, a) {
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, $eea1162845e87fb8$export$a29989082612d0d9, $eea1162845e87fb8$export$6788812c4e6611e6($eea1162845e87fb8$export$eba6f6f03b0a92e7()), $eea1162845e87fb8$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $eea1162845e87fb8$export$f8483753829ec8f3(e, r, a, n) {
    return $eea1162845e87fb8$export$35059013cd4a06db(e, r, a, $eea1162845e87fb8$export$527d108ccf083c2b, $eea1162845e87fb8$export$2f35ab04d2335697(e, 0, n), $eea1162845e87fb8$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $eea1162845e87fb8$export$82e9f45cca5ba907(n, c, s) {
    switch($eea1162845e87fb8$export$d6af199866bfb566(n, c)){
        case 5103:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $eea1162845e87fb8$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$2c0f367103c8d01c + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($eea1162845e87fb8$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-$1$2" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-item-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$eea1162845e87fb8$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-row-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-line-pack" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-" + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-grow", "") + $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $eea1162845e87fb8$export$39dfd62a25e0fe93 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "box-pack:$3" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $eea1162845e87fb8$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$eea1162845e87fb8$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-column-align" + $eea1162845e87fb8$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $eea1162845e87fb8$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$eea1162845e87fb8$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$eea1162845e87fb8$export$f8e21b1e77979a08(s, "span") ? $eea1162845e87fb8$export$4659b591c19bdf3d(s, /\d+/) : +$eea1162845e87fb8$export$4659b591c19bdf3d(s, /\d+/) - +$eea1162845e87fb8$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $eea1162845e87fb8$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $eea1162845e87fb8$export$71ad59f2e432cfe8 + $eea1162845e87fb8$export$77ad94ebf1c2b9ed($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($eea1162845e87fb8$export$36776f635604f274(n) - 1 - c > 6) switch($eea1162845e87fb8$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $eea1162845e87fb8$export$2c0f367103c8d01c + ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$eea1162845e87fb8$export$f8e21b1e77979a08(n, "stretch") ? $eea1162845e87fb8$export$82e9f45cca5ba907($eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $eea1162845e87fb8$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $eea1162845e87fb8$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($eea1162845e87fb8$export$a9db5e087081082d(n, c + 6) === 121) return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, ":", ":" + $eea1162845e87fb8$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($eea1162845e87fb8$export$a9db5e087081082d(n, $eea1162845e87fb8$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + ($eea1162845e87fb8$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $eea1162845e87fb8$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, ":", ":" + $eea1162845e87fb8$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $eea1162845e87fb8$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $eea1162845e87fb8$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $eea1162845e87fb8$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $eea1162845e87fb8$export$a763edbf796b780a:
        case $eea1162845e87fb8$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $eea1162845e87fb8$export$a29989082612d0d9:
            return "";
        case $eea1162845e87fb8$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $eea1162845e87fb8$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $eea1162845e87fb8$export$36776f635604f274(a = $eea1162845e87fb8$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $eea1162845e87fb8$export$5a7767152ae0305f(e) {
    var r = $eea1162845e87fb8$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $eea1162845e87fb8$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $eea1162845e87fb8$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $eea1162845e87fb8$export$527d108ccf083c2b:
                n.return = $eea1162845e87fb8$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $eea1162845e87fb8$export$b44a8529a35fcb60:
                return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                    $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                        value: $eea1162845e87fb8$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $eea1162845e87fb8$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $eea1162845e87fb8$export$aa3a2e812ca8570d:
                if (n.length) return $eea1162845e87fb8$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($eea1162845e87fb8$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $eea1162845e87fb8$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $eea1162845e87fb8$export$dfdc1655ccc5b9cb([
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $eea1162845e87fb8$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $eea1162845e87fb8$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $eea1162845e87fb8$export$784d13d8ee351f07(n, {
                                    props: [
                                        $eea1162845e87fb8$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $eea1162845e87fb8$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $eea1162845e87fb8$export$76a88f7de6507443(e) {
    switch(e.type){
        case $eea1162845e87fb8$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $eea1162845e87fb8$export$1be1fc439b849fdf($eea1162845e87fb8$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($eea1162845e87fb8$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $eea1162845e87fb8$export$2f35ab04d2335697(r, 1, $eea1162845e87fb8$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $eea1162845e87fb8$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $eea1162845e87fb8$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $eea1162845e87fb8$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("gbY0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc9c38393dd6748a$export$2e2bcd8739ae039; });
var $bc9c38393dd6748a$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("1TGTA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $161c33aa9edc3225$export$2e2bcd8739ae039; });
function $161c33aa9edc3225$export$2e2bcd8739ae039() {
    return $161c33aa9edc3225$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $161c33aa9edc3225$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("eIxVf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab6f7d074592e389$export$2e2bcd8739ae039; });
var $ab6f7d074592e389$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("glGaj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be6f50a8bcbd3d42$export$2e2bcd8739ae039; });

var $cSUBB = parcelRequire("cSUBB");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $be6f50a8bcbd3d42$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cSUBB)))(targetComponent, sourceComponent);
};

});
parcelRegister("cSUBB", function(module, exports) {
'use strict';

var $8xxle = parcelRequire("8xxle");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $96166fd72a1567f8$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $96166fd72a1567f8$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $96166fd72a1567f8$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $96166fd72a1567f8$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $96166fd72a1567f8$var$TYPE_STATICS = {};
$96166fd72a1567f8$var$TYPE_STATICS[$8xxle.ForwardRef] = $96166fd72a1567f8$var$FORWARD_REF_STATICS;
$96166fd72a1567f8$var$TYPE_STATICS[$8xxle.Memo] = $96166fd72a1567f8$var$MEMO_STATICS;
function $96166fd72a1567f8$var$getStatics(component) {
    // React v16.11 and below
    if ($8xxle.isMemo(component)) return $96166fd72a1567f8$var$MEMO_STATICS;
     // React v16.12 and above
    return $96166fd72a1567f8$var$TYPE_STATICS[component['$$typeof']] || $96166fd72a1567f8$var$REACT_STATICS;
}
var $96166fd72a1567f8$var$defineProperty = Object.defineProperty;
var $96166fd72a1567f8$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $96166fd72a1567f8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $96166fd72a1567f8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $96166fd72a1567f8$var$getPrototypeOf = Object.getPrototypeOf;
var $96166fd72a1567f8$var$objectPrototype = Object.prototype;
function $96166fd72a1567f8$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($96166fd72a1567f8$var$objectPrototype) {
            var inheritedComponent = $96166fd72a1567f8$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $96166fd72a1567f8$var$objectPrototype) $96166fd72a1567f8$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $96166fd72a1567f8$var$getOwnPropertyNames(sourceComponent);
        if ($96166fd72a1567f8$var$getOwnPropertySymbols) keys = keys.concat($96166fd72a1567f8$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $96166fd72a1567f8$var$getStatics(targetComponent);
        var sourceStatics = $96166fd72a1567f8$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$96166fd72a1567f8$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $96166fd72a1567f8$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $96166fd72a1567f8$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $96166fd72a1567f8$var$hoistNonReactStatics;

});
parcelRegister("8xxle", function(module, exports) {
'use strict';

module.exports = (parcelRequire("36bfA"));

});



parcelRegister("7x006", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $57bb9d9a345e3a49$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $57bb9d9a345e3a49$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $57bb9d9a345e3a49$export$6f077d94b33a01aa; });
var $57bb9d9a345e3a49$var$isBrowser = typeof document !== 'undefined';
function $57bb9d9a345e3a49$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $57bb9d9a345e3a49$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $57bb9d9a345e3a49$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $57bb9d9a345e3a49$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $57bb9d9a345e3a49$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$57bb9d9a345e3a49$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$57bb9d9a345e3a49$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("iBxqj", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $d8b59be3fd10785e$export$6321afa313b251b5; });

var $1av6J = parcelRequire("1av6J");

var $kZVpK = parcelRequire("kZVpK");

var $u6I0t = parcelRequire("u6I0t");
var $d8b59be3fd10785e$var$isDevelopment = false;
var $d8b59be3fd10785e$var$hyphenateRegex = /[A-Z]|^ms/g;
var $d8b59be3fd10785e$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $d8b59be3fd10785e$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $d8b59be3fd10785e$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $d8b59be3fd10785e$var$processStyleName = /* #__PURE__ */ (0, $u6I0t.default)(function(styleName) {
    return $d8b59be3fd10785e$var$isCustomProperty(styleName) ? styleName : styleName.replace($d8b59be3fd10785e$var$hyphenateRegex, '-$&').toLowerCase();
});
var $d8b59be3fd10785e$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($d8b59be3fd10785e$var$animationRegex, function(match, p1, p2) {
                $d8b59be3fd10785e$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $d8b59be3fd10785e$var$cursor
                };
                return p1;
            });
    }
    if ((0, $kZVpK.default)[key] !== 1 && !$d8b59be3fd10785e$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $d8b59be3fd10785e$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $d8b59be3fd10785e$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $d8b59be3fd10785e$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $d8b59be3fd10785e$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $d8b59be3fd10785e$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $d8b59be3fd10785e$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $d8b59be3fd10785e$var$cursor;
                var result = interpolation(mergedProps);
                $d8b59be3fd10785e$var$cursor = previousCursor;
                return $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $d8b59be3fd10785e$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($d8b59be3fd10785e$var$isProcessableValue(asString)) string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + $d8b59be3fd10785e$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $d8b59be3fd10785e$var$isDevelopment) throw new Error($d8b59be3fd10785e$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($d8b59be3fd10785e$var$isProcessableValue(value[_i])) string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + $d8b59be3fd10785e$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $d8b59be3fd10785e$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $d8b59be3fd10785e$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $d8b59be3fd10785e$var$cursor;
function $d8b59be3fd10785e$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $d8b59be3fd10785e$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $d8b59be3fd10785e$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $d8b59be3fd10785e$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $d8b59be3fd10785e$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1av6J.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $d8b59be3fd10785e$var$cursor
    };
}

});
parcelRegister("1av6J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d9edae8851266c4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0d9edae8851266c4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("kZVpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4960a7312a76ce2$export$2e2bcd8739ae039; });
var $f4960a7312a76ce2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("dn94N", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $9bc476b3b5bfc3b6$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $9bc476b3b5bfc3b6$export$811a713a7276cb9d; });

var $8nGP5 = parcelRequire("8nGP5");
var $9bc476b3b5bfc3b6$var$isBrowser = typeof document !== 'undefined';
var $9bc476b3b5bfc3b6$var$syncFallback = function syncFallback(create) {
    return create();
};
var $9bc476b3b5bfc3b6$var$useInsertionEffect = $8nGP5.useInsertionEffect ? $8nGP5.useInsertionEffect : false;
var $9bc476b3b5bfc3b6$export$db21c7ffa21794e7 = !$9bc476b3b5bfc3b6$var$isBrowser ? $9bc476b3b5bfc3b6$var$syncFallback : $9bc476b3b5bfc3b6$var$useInsertionEffect || $9bc476b3b5bfc3b6$var$syncFallback;
var $9bc476b3b5bfc3b6$export$811a713a7276cb9d = $9bc476b3b5bfc3b6$var$useInsertionEffect || $8nGP5.useLayoutEffect;

});



parcelRegister("kSbwP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6IstV"));

});


parcelRegister("1aEuo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0da621ea7d39803e$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");

var $iCGFJ = parcelRequire("iCGFJ");
function $0da621ea7d39803e$export$2e2bcd8739ae039() {
    const theme = $8nGP5.useContext((0, $iCGFJ.default));
    return theme;
}

});
parcelRegister("iCGFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8ece061c76505b2$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
'use client';
const $d8ece061c76505b2$var$ThemeContext = /*#__PURE__*/ $8nGP5.createContext(null);
var $d8ece061c76505b2$export$2e2bcd8739ae039 = $d8ece061c76505b2$var$ThemeContext;

});


parcelRegister("jMi8t", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e66091611cd09938$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e66091611cd09938$var$_useEnhancedEffect.default;
    }
});

var $e66091611cd09938$var$_useEnhancedEffect = $e66091611cd09938$require$_interopRequireDefault((parcelRequire("7pL5n")));

});
parcelRegister("7pL5n", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $565f6470f9c3e151$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $565f6470f9c3e151$var$React = $565f6470f9c3e151$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $565f6470f9c3e151$var$useEnhancedEffect = typeof window !== 'undefined' ? $565f6470f9c3e151$var$React.useLayoutEffect : $565f6470f9c3e151$var$React.useEffect;
var $565f6470f9c3e151$var$_default = module.exports.default = $565f6470f9c3e151$var$useEnhancedEffect;

});


parcelRegister("lXls0", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ffbfbf54ff895eb6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ffbfbf54ff895eb6$var$_ThemeProvider.default;
    }
});

var $ffbfbf54ff895eb6$var$_ThemeProvider = $ffbfbf54ff895eb6$require$_interopRequireDefault((parcelRequire("3YQfs")));

});
parcelRegister("3YQfs", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $2e5f812513863299$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $2e5f812513863299$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e5f812513863299$var$React = $2e5f812513863299$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $2e5f812513863299$var$_propTypes = $2e5f812513863299$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $7WGAH = parcelRequire("7WGAH");
var $1aEuo = parcelRequire("1aEuo");

var $2e5f812513863299$var$_exactProp = $2e5f812513863299$require$_interopRequireDefault((parcelRequire("fhWSG")));
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $2e5f812513863299$var$_useThemeWithoutDefault = $2e5f812513863299$require$_interopRequireDefault((parcelRequire("dfCLb")));

var $2e5f812513863299$var$_RtlProvider = $2e5f812513863299$require$_interopRequireDefault((parcelRequire("aYQZL")));

var $2e5f812513863299$var$_DefaultPropsProvider = $2e5f812513863299$require$_interopRequireDefault((parcelRequire("gmCn4")));

var $kSbwP = parcelRequire("kSbwP");
const $2e5f812513863299$var$EMPTY_THEME = {};
function $2e5f812513863299$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2e5f812513863299$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2e5f812513863299$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2e5f812513863299$var$_useThemeWithoutDefault.default)($2e5f812513863299$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $1aEuo.default)() || $2e5f812513863299$var$EMPTY_THEME;
    const engineTheme = $2e5f812513863299$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2e5f812513863299$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $kSbwP.jsx)($7WGAH.default, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($jspCa.T.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)($2e5f812513863299$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)($2e5f812513863299$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $2e5f812513863299$var$_default = module.exports.default = $2e5f812513863299$var$ThemeProvider;

});
parcelRegister("7WGAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c8efcdcf61962f4$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");



var $iCGFJ = parcelRequire("iCGFJ");

var $1aEuo = parcelRequire("1aEuo");

var $gldWy = parcelRequire("gldWy");

var $kSbwP = parcelRequire("kSbwP");
function $5c8efcdcf61962f4$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $5c8efcdcf61962f4$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $1aEuo.default)();
    const theme = $8nGP5.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $5c8efcdcf61962f4$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $gldWy.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $iCGFJ.default).Provider, {
        value: theme,
        children: children
    });
}
var $5c8efcdcf61962f4$export$2e2bcd8739ae039 = $5c8efcdcf61962f4$var$ThemeProvider;

});
parcelRegister("gldWy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be596c67f0e4c29f$export$2e2bcd8739ae039; });
const $be596c67f0e4c29f$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $be596c67f0e4c29f$export$2e2bcd8739ae039 = $be596c67f0e4c29f$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("fhWSG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b2161e1b3b547a75$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b2161e1b3b547a75$var$_exactProp.default;
    }
});

var $b2161e1b3b547a75$var$_exactProp = $b2161e1b3b547a75$require$_interopRequireDefault((parcelRequire("lX7yX")));

});
parcelRegister("lX7yX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffb4f97ec2835fce$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $ffb4f97ec2835fce$var$specialProperty = 'exact-prop: \u200b';
function $ffb4f97ec2835fce$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("dfCLb", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9a5abe03e20ea6d6$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9a5abe03e20ea6d6$var$_useThemeWithoutDefault.default;
    }
});

var $9a5abe03e20ea6d6$var$_useThemeWithoutDefault = $9a5abe03e20ea6d6$require$_interopRequireDefault((parcelRequire("9dkSf")));

});
parcelRegister("9dkSf", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $6b55851064646d89$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b55851064646d89$var$React = $6b55851064646d89$require$_interopRequireWildcard((parcelRequire("8nGP5")));
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");
function $6b55851064646d89$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $6b55851064646d89$var$useTheme(defaultTheme = null) {
    const contextTheme = $6b55851064646d89$var$React.useContext($jspCa.T);
    return !contextTheme || $6b55851064646d89$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $6b55851064646d89$var$_default = module.exports.default = $6b55851064646d89$var$useTheme;

});


parcelRegister("aYQZL", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $7fe89db9311562de$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $7fe89db9311562de$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $7fe89db9311562de$var$React = $7fe89db9311562de$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $7fe89db9311562de$var$_propTypes = $7fe89db9311562de$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $kSbwP = parcelRequire("kSbwP");
const $7fe89db9311562de$var$RtlContext = /*#__PURE__*/ $7fe89db9311562de$var$React.createContext();
function $7fe89db9311562de$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($7fe89db9311562de$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $7fe89db9311562de$var$useRtl = ()=>{
    const value = $7fe89db9311562de$var$React.useContext($7fe89db9311562de$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $7fe89db9311562de$var$useRtl;
var $7fe89db9311562de$var$_default = module.exports.default = $7fe89db9311562de$var$RtlProvider;

});

parcelRegister("gmCn4", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $be9c77212fa32356$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $be9c77212fa32356$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $be9c77212fa32356$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $be9c77212fa32356$var$_DefaultPropsProvider = $be9c77212fa32356$require$_interopRequireWildcard((parcelRequire("k2RKv")));

});
parcelRegister("k2RKv", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $e97db002cea8c630$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $e97db002cea8c630$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e97db002cea8c630$var$useDefaultProps;

var $e97db002cea8c630$var$React = $e97db002cea8c630$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $e97db002cea8c630$var$_propTypes = $e97db002cea8c630$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $e97db002cea8c630$var$_resolveProps = $e97db002cea8c630$require$_interopRequireDefault((parcelRequire("9Blzt")));

var $kSbwP = parcelRequire("kSbwP");
const $e97db002cea8c630$var$PropsContext = /*#__PURE__*/ $e97db002cea8c630$var$React.createContext(undefined);
function $e97db002cea8c630$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($e97db002cea8c630$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e97db002cea8c630$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e97db002cea8c630$var$_resolveProps.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e97db002cea8c630$var$_resolveProps.default)(config, props);
    return props;
}
function $e97db002cea8c630$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e97db002cea8c630$var$React.useContext($e97db002cea8c630$var$PropsContext);
    return $e97db002cea8c630$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e97db002cea8c630$var$_default = module.exports.default = $e97db002cea8c630$var$DefaultPropsProvider;

});
parcelRegister("9Blzt", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6fd84d5c756a0a30$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6fd84d5c756a0a30$var$_resolveProps.default;
    }
});

var $6fd84d5c756a0a30$var$_resolveProps = $6fd84d5c756a0a30$require$_interopRequireDefault((parcelRequire("314yM")));

});
parcelRegister("314yM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2325009c3d139361$var$resolveProps;
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @returns resolved props
 */ function $2325009c3d139361$var$resolveProps(defaultProps, props) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $2325009c3d139361$var$resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                }
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});






parcelRegister("ejtRR", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $a6ba02230c447d10$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.default = $a6ba02230c447d10$var$InitColorSchemeScript;

var $a6ba02230c447d10$var$React = $a6ba02230c447d10$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * Split this component for RSC import
 */ const $a6ba02230c447d10$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $a6ba02230c447d10$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $a6ba02230c447d10$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function $a6ba02230c447d10$var$InitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $a6ba02230c447d10$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $a6ba02230c447d10$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $a6ba02230c447d10$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $kSbwP.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("jxswj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $e39738e88b6271fd$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $e39738e88b6271fd$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e39738e88b6271fd$var$useCurrentColorScheme;
module.exports.getColorScheme = $e39738e88b6271fd$var$getColorScheme;
module.exports.getSystemMode = $e39738e88b6271fd$var$getSystemMode;

var $e39738e88b6271fd$var$React = $e39738e88b6271fd$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $ejtRR = parcelRequire("ejtRR");

var $e39738e88b6271fd$var$_localStorageManager = $e39738e88b6271fd$require$_interopRequireDefault((parcelRequire("GVNPC")));
function $e39738e88b6271fd$var$noop() {}
function $e39738e88b6271fd$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $e39738e88b6271fd$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $e39738e88b6271fd$var$getColorScheme(state) {
    return $e39738e88b6271fd$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $e39738e88b6271fd$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $ejtRR.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $ejtRR.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $e39738e88b6271fd$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $e39738e88b6271fd$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $e39738e88b6271fd$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $e39738e88b6271fd$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $e39738e88b6271fd$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $e39738e88b6271fd$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $e39738e88b6271fd$var$React.useState(noSsr || !isMultiSchemes);
    $e39738e88b6271fd$var$React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $e39738e88b6271fd$var$getColorScheme(state);
    const setMode = $e39738e88b6271fd$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $e39738e88b6271fd$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $e39738e88b6271fd$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $e39738e88b6271fd$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $e39738e88b6271fd$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $e39738e88b6271fd$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $e39738e88b6271fd$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $e39738e88b6271fd$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $e39738e88b6271fd$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $e39738e88b6271fd$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $e39738e88b6271fd$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("GVNPC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $0810c2c703f6bd64$var$noop() {}
const $0810c2c703f6bd64$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $0810c2c703f6bd64$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $0810c2c703f6bd64$var$_default = module.exports.default = $0810c2c703f6bd64$var$localStorageManager;

});



parcelRegister("eRucw", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ad1d7132aa652e8f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad1d7132aa652e8f$var$_deepmerge = $ad1d7132aa652e8f$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $ad1d7132aa652e8f$var$_cssVarsParser = $ad1d7132aa652e8f$require$_interopRequireDefault((parcelRequire("3T3du")));
function $ad1d7132aa652e8f$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $ad1d7132aa652e8f$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $ad1d7132aa652e8f$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $ad1d7132aa652e8f$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $ad1d7132aa652e8f$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $ad1d7132aa652e8f$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $ad1d7132aa652e8f$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $ad1d7132aa652e8f$var$_default = module.exports.default = $ad1d7132aa652e8f$var$prepareCssVars;

});
parcelRegister("3T3du", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $2d4900e8bf7756f7$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2d4900e8bf7756f7$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $2d4900e8bf7756f7$var$assignNestedKeys;
const $2d4900e8bf7756f7$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $2d4900e8bf7756f7$var$walkObjectDeep;
const $2d4900e8bf7756f7$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $2d4900e8bf7756f7$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2d4900e8bf7756f7$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $2d4900e8bf7756f7$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $2d4900e8bf7756f7$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $2d4900e8bf7756f7$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("jSttB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e789ecdec2808825$var$prepareTypographyVars;
function $e789ecdec2808825$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("doEUu", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9c0d402ac8184bb2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c0d402ac8184bb2$var$_prepareCssVars = $9c0d402ac8184bb2$require$_interopRequireDefault((parcelRequire("eRucw")));

var $5nPqd = parcelRequire("5nPqd");

var $ejtRR = parcelRequire("ejtRR");
function $9c0d402ac8184bb2$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$ejtRR.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $9c0d402ac8184bb2$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $5nPqd.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var $9c0d402ac8184bb2$var$_default = module.exports.default = $9c0d402ac8184bb2$var$createCssVarsTheme;

});
parcelRegister("5nPqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $3eb6fd0d2065f5e2$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $3eb6fd0d2065f5e2$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});



parcelRegister("3RwFu", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2cffa98b2a0247f2$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $2cffa98b2a0247f2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2cffa98b2a0247f2$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $2cffa98b2a0247f2$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $2cffa98b2a0247f2$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $2cffa98b2a0247f2$var$_defaultSxConfig.default;
    }
});

var $2cffa98b2a0247f2$var$_styleFunctionSx = $2cffa98b2a0247f2$require$_interopRequireWildcard((parcelRequire("h30nt")));

var $2cffa98b2a0247f2$var$_extendSxProp = $2cffa98b2a0247f2$require$_interopRequireDefault((parcelRequire("69zre")));

var $2cffa98b2a0247f2$var$_defaultSxConfig = $2cffa98b2a0247f2$require$_interopRequireDefault((parcelRequire("jGEJM")));

});
parcelRegister("h30nt", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c693027dc1dada95$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $c693027dc1dada95$var$unstable_createStyleFunctionSx;

var $c693027dc1dada95$var$_capitalize = $c693027dc1dada95$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $c693027dc1dada95$var$_merge = $c693027dc1dada95$require$_interopRequireDefault((parcelRequire("aBbGo")));

var $dVkzc = parcelRequire("dVkzc");

var $g6OmK = parcelRequire("g6OmK");

var $1t22B = parcelRequire("1t22B");

var $c693027dc1dada95$var$_defaultSxConfig = $c693027dc1dada95$require$_interopRequireDefault((parcelRequire("jGEJM")));
function $c693027dc1dada95$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $c693027dc1dada95$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $c693027dc1dada95$var$unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $dVkzc.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $dVkzc.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $dVkzc.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c693027dc1dada95$var$_capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $g6OmK.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? $c693027dc1dada95$var$_defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $g6OmK.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $c693027dc1dada95$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $c693027dc1dada95$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $g6OmK.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($c693027dc1dada95$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $c693027dc1dada95$var$_merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, $c693027dc1dada95$var$_merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $1t22B.sortContainerQueries)(theme, (0, $g6OmK.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $c693027dc1dada95$var$styleFunctionSx = $c693027dc1dada95$var$unstable_createStyleFunctionSx();
$c693027dc1dada95$var$styleFunctionSx.filterProps = [
    'sx'
];
var $c693027dc1dada95$var$_default = module.exports.default = $c693027dc1dada95$var$styleFunctionSx;

});
parcelRegister("jGEJM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $iI1Nz = parcelRequire("iI1Nz");

var $6t2An = parcelRequire("6t2An");

var $hFTbJ = parcelRequire("hFTbJ");

var $gaJWg = parcelRequire("gaJWg");

var $gKSGP = parcelRequire("gKSGP");
const $e5518a2a38f4598d$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $6t2An.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $6t2An.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $gaJWg.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $gaJWg.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $gaJWg.paletteTransform
    },
    // spacing
    p: {
        style: $iI1Nz.padding
    },
    pt: {
        style: $iI1Nz.padding
    },
    pr: {
        style: $iI1Nz.padding
    },
    pb: {
        style: $iI1Nz.padding
    },
    pl: {
        style: $iI1Nz.padding
    },
    px: {
        style: $iI1Nz.padding
    },
    py: {
        style: $iI1Nz.padding
    },
    padding: {
        style: $iI1Nz.padding
    },
    paddingTop: {
        style: $iI1Nz.padding
    },
    paddingRight: {
        style: $iI1Nz.padding
    },
    paddingBottom: {
        style: $iI1Nz.padding
    },
    paddingLeft: {
        style: $iI1Nz.padding
    },
    paddingX: {
        style: $iI1Nz.padding
    },
    paddingY: {
        style: $iI1Nz.padding
    },
    paddingInline: {
        style: $iI1Nz.padding
    },
    paddingInlineStart: {
        style: $iI1Nz.padding
    },
    paddingInlineEnd: {
        style: $iI1Nz.padding
    },
    paddingBlock: {
        style: $iI1Nz.padding
    },
    paddingBlockStart: {
        style: $iI1Nz.padding
    },
    paddingBlockEnd: {
        style: $iI1Nz.padding
    },
    m: {
        style: $iI1Nz.margin
    },
    mt: {
        style: $iI1Nz.margin
    },
    mr: {
        style: $iI1Nz.margin
    },
    mb: {
        style: $iI1Nz.margin
    },
    ml: {
        style: $iI1Nz.margin
    },
    mx: {
        style: $iI1Nz.margin
    },
    my: {
        style: $iI1Nz.margin
    },
    margin: {
        style: $iI1Nz.margin
    },
    marginTop: {
        style: $iI1Nz.margin
    },
    marginRight: {
        style: $iI1Nz.margin
    },
    marginBottom: {
        style: $iI1Nz.margin
    },
    marginLeft: {
        style: $iI1Nz.margin
    },
    marginX: {
        style: $iI1Nz.margin
    },
    marginY: {
        style: $iI1Nz.margin
    },
    marginInline: {
        style: $iI1Nz.margin
    },
    marginInlineStart: {
        style: $iI1Nz.margin
    },
    marginInlineEnd: {
        style: $iI1Nz.margin
    },
    marginBlock: {
        style: $iI1Nz.margin
    },
    marginBlockStart: {
        style: $iI1Nz.margin
    },
    marginBlockEnd: {
        style: $iI1Nz.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $hFTbJ.gap
    },
    rowGap: {
        style: $hFTbJ.rowGap
    },
    columnGap: {
        style: $hFTbJ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $gKSGP.sizingTransform
    },
    maxWidth: {
        style: $gKSGP.maxWidth
    },
    minWidth: {
        transform: $gKSGP.sizingTransform
    },
    height: {
        transform: $gKSGP.sizingTransform
    },
    maxHeight: {
        transform: $gKSGP.sizingTransform
    },
    minHeight: {
        transform: $gKSGP.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $e5518a2a38f4598d$var$_default = module.exports.default = $e5518a2a38f4598d$var$defaultSxConfig;

});
parcelRegister("6t2An", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $4b5774f54a350885$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4b5774f54a350885$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4b5774f54a350885$var$_borders.default;
    }
});

var $4b5774f54a350885$var$_borders = $4b5774f54a350885$require$_interopRequireWildcard((parcelRequire("38lOl")));
Object.keys($4b5774f54a350885$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4b5774f54a350885$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4b5774f54a350885$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4b5774f54a350885$var$_borders[key];
        }
    });
});

});
parcelRegister("38lOl", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $248309aa43819f18$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $248309aa43819f18$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $248309aa43819f18$var$_responsivePropType = $248309aa43819f18$require$_interopRequireDefault((parcelRequire("btvpa")));

var $248309aa43819f18$var$_style = $248309aa43819f18$require$_interopRequireDefault((parcelRequire("dVkzc")));

var $248309aa43819f18$var$_compose = $248309aa43819f18$require$_interopRequireDefault((parcelRequire("cE6of")));

var $iI1Nz = parcelRequire("iI1Nz");

var $g6OmK = parcelRequire("g6OmK");
function $248309aa43819f18$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $248309aa43819f18$var$createBorderStyle(prop, transform) {
    return (0, $248309aa43819f18$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $248309aa43819f18$var$border = module.exports.border = $248309aa43819f18$var$createBorderStyle('border', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$borderTop = module.exports.borderTop = $248309aa43819f18$var$createBorderStyle('borderTop', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$borderRight = module.exports.borderRight = $248309aa43819f18$var$createBorderStyle('borderRight', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$borderBottom = module.exports.borderBottom = $248309aa43819f18$var$createBorderStyle('borderBottom', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$borderLeft = module.exports.borderLeft = $248309aa43819f18$var$createBorderStyle('borderLeft', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$borderColor = module.exports.borderColor = $248309aa43819f18$var$createBorderStyle('borderColor');
const $248309aa43819f18$var$borderTopColor = module.exports.borderTopColor = $248309aa43819f18$var$createBorderStyle('borderTopColor');
const $248309aa43819f18$var$borderRightColor = module.exports.borderRightColor = $248309aa43819f18$var$createBorderStyle('borderRightColor');
const $248309aa43819f18$var$borderBottomColor = module.exports.borderBottomColor = $248309aa43819f18$var$createBorderStyle('borderBottomColor');
const $248309aa43819f18$var$borderLeftColor = module.exports.borderLeftColor = $248309aa43819f18$var$createBorderStyle('borderLeftColor');
const $248309aa43819f18$var$outline = module.exports.outline = $248309aa43819f18$var$createBorderStyle('outline', $248309aa43819f18$var$borderTransform);
const $248309aa43819f18$var$outlineColor = module.exports.outlineColor = $248309aa43819f18$var$createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const $248309aa43819f18$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $iI1Nz.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $iI1Nz.getValue)(transformer, propValue)
            });
        return (0, $g6OmK.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $248309aa43819f18$var$borderRadius;
$248309aa43819f18$var$borderRadius.propTypes = {};
$248309aa43819f18$var$borderRadius.filterProps = [
    'borderRadius'
];
const $248309aa43819f18$var$borders = (0, $248309aa43819f18$var$_compose.default)($248309aa43819f18$var$border, $248309aa43819f18$var$borderTop, $248309aa43819f18$var$borderRight, $248309aa43819f18$var$borderBottom, $248309aa43819f18$var$borderLeft, $248309aa43819f18$var$borderColor, $248309aa43819f18$var$borderTopColor, $248309aa43819f18$var$borderRightColor, $248309aa43819f18$var$borderBottomColor, $248309aa43819f18$var$borderLeftColor, $248309aa43819f18$var$borderRadius, $248309aa43819f18$var$outline, $248309aa43819f18$var$outlineColor);
var $248309aa43819f18$var$_default = module.exports.default = $248309aa43819f18$var$borders;

});
parcelRegister("cE6of", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $934e2d6377eb3d08$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $934e2d6377eb3d08$var$_compose.default;
    }
});

var $934e2d6377eb3d08$var$_compose = $934e2d6377eb3d08$require$_interopRequireDefault((parcelRequire("2Aji1")));

});
parcelRegister("2Aji1", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $1e1de81184fd9fbf$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e1de81184fd9fbf$var$_merge = $1e1de81184fd9fbf$require$_interopRequireDefault((parcelRequire("aBbGo")));
function $1e1de81184fd9fbf$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $1e1de81184fd9fbf$var$_merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $1e1de81184fd9fbf$var$_default = module.exports.default = $1e1de81184fd9fbf$var$compose;

});




parcelRegister("hFTbJ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $cde11339a0033373$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cde11339a0033373$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cde11339a0033373$var$_cssGrid.default;
    }
});

var $cde11339a0033373$var$_cssGrid = $cde11339a0033373$require$_interopRequireWildcard((parcelRequire("8aLdB")));
Object.keys($cde11339a0033373$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cde11339a0033373$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cde11339a0033373$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cde11339a0033373$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("8aLdB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5f33e27d83a59dae$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $5f33e27d83a59dae$var$_style = $5f33e27d83a59dae$require$_interopRequireDefault((parcelRequire("dVkzc")));

var $5f33e27d83a59dae$var$_compose = $5f33e27d83a59dae$require$_interopRequireDefault((parcelRequire("cE6of")));

var $iI1Nz = parcelRequire("iI1Nz");

var $g6OmK = parcelRequire("g6OmK");

var $5f33e27d83a59dae$var$_responsivePropType = $5f33e27d83a59dae$require$_interopRequireDefault((parcelRequire("btvpa")));
// false positive
// eslint-disable-next-line react/function-component-definition
const $5f33e27d83a59dae$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $iI1Nz.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $iI1Nz.getValue)(transformer, propValue)
            });
        return (0, $g6OmK.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $5f33e27d83a59dae$var$gap;
$5f33e27d83a59dae$var$gap.propTypes = {};
$5f33e27d83a59dae$var$gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $5f33e27d83a59dae$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $iI1Nz.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $iI1Nz.getValue)(transformer, propValue)
            });
        return (0, $g6OmK.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $5f33e27d83a59dae$var$columnGap;
$5f33e27d83a59dae$var$columnGap.propTypes = {};
$5f33e27d83a59dae$var$columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const $5f33e27d83a59dae$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $iI1Nz.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $iI1Nz.getValue)(transformer, propValue)
            });
        return (0, $g6OmK.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $5f33e27d83a59dae$var$rowGap;
$5f33e27d83a59dae$var$rowGap.propTypes = {};
$5f33e27d83a59dae$var$rowGap.filterProps = [
    'rowGap'
];
const $5f33e27d83a59dae$var$gridColumn = module.exports.gridColumn = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridColumn'
});
const $5f33e27d83a59dae$var$gridRow = module.exports.gridRow = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridRow'
});
const $5f33e27d83a59dae$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $5f33e27d83a59dae$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $5f33e27d83a59dae$var$gridAutoRows = module.exports.gridAutoRows = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridAutoRows'
});
const $5f33e27d83a59dae$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $5f33e27d83a59dae$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $5f33e27d83a59dae$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $5f33e27d83a59dae$var$gridArea = module.exports.gridArea = (0, $5f33e27d83a59dae$var$_style.default)({
    prop: 'gridArea'
});
const $5f33e27d83a59dae$var$grid = (0, $5f33e27d83a59dae$var$_compose.default)($5f33e27d83a59dae$var$gap, $5f33e27d83a59dae$var$columnGap, $5f33e27d83a59dae$var$rowGap, $5f33e27d83a59dae$var$gridColumn, $5f33e27d83a59dae$var$gridRow, $5f33e27d83a59dae$var$gridAutoFlow, $5f33e27d83a59dae$var$gridAutoColumns, $5f33e27d83a59dae$var$gridAutoRows, $5f33e27d83a59dae$var$gridTemplateColumns, $5f33e27d83a59dae$var$gridTemplateRows, $5f33e27d83a59dae$var$gridTemplateAreas, $5f33e27d83a59dae$var$gridArea);
var $5f33e27d83a59dae$var$_default = module.exports.default = $5f33e27d83a59dae$var$grid;

});


parcelRegister("gaJWg", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $bc613701108d0b60$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bc613701108d0b60$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bc613701108d0b60$var$_palette.default;
    }
});

var $bc613701108d0b60$var$_palette = $bc613701108d0b60$require$_interopRequireWildcard((parcelRequire("5HJEn")));
Object.keys($bc613701108d0b60$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($bc613701108d0b60$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $bc613701108d0b60$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $bc613701108d0b60$var$_palette[key];
        }
    });
});

});
parcelRegister("5HJEn", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $4274611720cd28b5$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $4274611720cd28b5$var$paletteTransform;

var $4274611720cd28b5$var$_style = $4274611720cd28b5$require$_interopRequireDefault((parcelRequire("dVkzc")));

var $4274611720cd28b5$var$_compose = $4274611720cd28b5$require$_interopRequireDefault((parcelRequire("cE6of")));
function $4274611720cd28b5$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $4274611720cd28b5$var$color = module.exports.color = (0, $4274611720cd28b5$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $4274611720cd28b5$var$paletteTransform
});
const $4274611720cd28b5$var$bgcolor = module.exports.bgcolor = (0, $4274611720cd28b5$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $4274611720cd28b5$var$paletteTransform
});
const $4274611720cd28b5$var$backgroundColor = module.exports.backgroundColor = (0, $4274611720cd28b5$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $4274611720cd28b5$var$paletteTransform
});
const $4274611720cd28b5$var$palette = (0, $4274611720cd28b5$var$_compose.default)($4274611720cd28b5$var$color, $4274611720cd28b5$var$bgcolor, $4274611720cd28b5$var$backgroundColor);
var $4274611720cd28b5$var$_default = module.exports.default = $4274611720cd28b5$var$palette;

});


parcelRegister("gKSGP", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $c32b5d76d49b3c63$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c32b5d76d49b3c63$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c32b5d76d49b3c63$var$_sizing.default;
    }
});

var $c32b5d76d49b3c63$var$_sizing = $c32b5d76d49b3c63$require$_interopRequireWildcard((parcelRequire("fGfjE")));
Object.keys($c32b5d76d49b3c63$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c32b5d76d49b3c63$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c32b5d76d49b3c63$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c32b5d76d49b3c63$var$_sizing[key];
        }
    });
});

});
parcelRegister("fGfjE", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b6a6a8acd071be52$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $b6a6a8acd071be52$var$sizingTransform;
module.exports.width = void 0;

var $b6a6a8acd071be52$var$_style = $b6a6a8acd071be52$require$_interopRequireDefault((parcelRequire("dVkzc")));

var $b6a6a8acd071be52$var$_compose = $b6a6a8acd071be52$require$_interopRequireDefault((parcelRequire("cE6of")));

var $g6OmK = parcelRequire("g6OmK");
function $b6a6a8acd071be52$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $b6a6a8acd071be52$var$width = module.exports.width = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'width',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $g6OmK.values[propValue];
            if (!breakpoint) return {
                maxWidth: $b6a6a8acd071be52$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $g6OmK.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $b6a6a8acd071be52$var$maxWidth;
$b6a6a8acd071be52$var$maxWidth.filterProps = [
    'maxWidth'
];
const $b6a6a8acd071be52$var$minWidth = module.exports.minWidth = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'minWidth',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$height = module.exports.height = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'height',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$maxHeight = module.exports.maxHeight = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'maxHeight',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$minHeight = module.exports.minHeight = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'minHeight',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$sizeWidth = module.exports.sizeWidth = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$sizeHeight = module.exports.sizeHeight = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $b6a6a8acd071be52$var$sizingTransform
});
const $b6a6a8acd071be52$var$boxSizing = module.exports.boxSizing = (0, $b6a6a8acd071be52$var$_style.default)({
    prop: 'boxSizing'
});
const $b6a6a8acd071be52$var$sizing = (0, $b6a6a8acd071be52$var$_compose.default)($b6a6a8acd071be52$var$width, $b6a6a8acd071be52$var$maxWidth, $b6a6a8acd071be52$var$minWidth, $b6a6a8acd071be52$var$height, $b6a6a8acd071be52$var$maxHeight, $b6a6a8acd071be52$var$minHeight, $b6a6a8acd071be52$var$boxSizing);
var $b6a6a8acd071be52$var$_default = module.exports.default = $b6a6a8acd071be52$var$sizing;

});




parcelRegister("69zre", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $47af12a22d53804b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47af12a22d53804b$var$extendSxProp;

var $cfKeZ = parcelRequire("cfKeZ");

var $47af12a22d53804b$var$_defaultSxConfig = $47af12a22d53804b$require$_interopRequireDefault((parcelRequire("jGEJM")));
const $47af12a22d53804b$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $47af12a22d53804b$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $47af12a22d53804b$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $47af12a22d53804b$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cfKeZ.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("kzWxL", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $efb47d0ded280857$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $efb47d0ded280857$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efb47d0ded280857$var$_formatMuiErrorMessage = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $efb47d0ded280857$var$_deepmerge = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $efb47d0ded280857$var$_styleFunctionSx = $efb47d0ded280857$require$_interopRequireWildcard((parcelRequire("3RwFu")));

var $efb47d0ded280857$var$_createTheme = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("dBuWz")));

var $efb47d0ded280857$var$_generateUtilityClass = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("4E9MM")));

var $efb47d0ded280857$var$_createMixins = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("cWeFn")));

var $efb47d0ded280857$var$_createPalette = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("hbeCt")));

var $efb47d0ded280857$var$_createTypography = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("ewxoJ")));

var $efb47d0ded280857$var$_shadows = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("56fqt")));

var $efb47d0ded280857$var$_createTransitions = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("6nqwa")));

var $efb47d0ded280857$var$_zIndex = $efb47d0ded280857$require$_interopRequireDefault((parcelRequire("8XP8U")));

var $9ulEf = parcelRequire("9ulEf");
function $efb47d0ded280857$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $efb47d0ded280857$var$_formatMuiErrorMessage.default)(20));
    const palette = (0, $efb47d0ded280857$var$_createPalette.default)(paletteInput);
    const systemTheme = (0, $efb47d0ded280857$var$_createTheme.default)(options);
    let muiTheme = (0, $efb47d0ded280857$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $efb47d0ded280857$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $efb47d0ded280857$var$_shadows.default.slice(),
        typography: (0, $efb47d0ded280857$var$_createTypography.default)(palette, typographyInput),
        transitions: (0, $efb47d0ded280857$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$efb47d0ded280857$var$_zIndex.default
        }
    });
    muiTheme = (0, $efb47d0ded280857$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $efb47d0ded280857$var$_deepmerge.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...$efb47d0ded280857$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $efb47d0ded280857$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $9ulEf.stringifyTheme; // for Pigment CSS integration
    return muiTheme;
}
var $efb47d0ded280857$var$_default = module.exports.default = $efb47d0ded280857$var$createThemeNoVars;

});
parcelRegister("dBuWz", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9e76bbd1650fd3c5$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9e76bbd1650fd3c5$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $9e76bbd1650fd3c5$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $9e76bbd1650fd3c5$var$_applyStyles.default;
    }
});

var $9e76bbd1650fd3c5$var$_createTheme = $9e76bbd1650fd3c5$require$_interopRequireDefault((parcelRequire("3kjKF")));

var $9e76bbd1650fd3c5$var$_createBreakpoints = $9e76bbd1650fd3c5$require$_interopRequireDefault((parcelRequire("5BunL")));

var $9e76bbd1650fd3c5$var$_applyStyles = $9e76bbd1650fd3c5$require$_interopRequireDefault((parcelRequire("4sSWG")));

});
parcelRegister("3kjKF", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $26c28fa2f761f796$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $26c28fa2f761f796$var$_deepmerge = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $26c28fa2f761f796$var$_createBreakpoints = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("5BunL")));

var $26c28fa2f761f796$var$_cssContainerQueries = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("1t22B")));

var $26c28fa2f761f796$var$_shape = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("hKcKi")));

var $26c28fa2f761f796$var$_createSpacing = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("4cXI2")));

var $26c28fa2f761f796$var$_styleFunctionSx = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("h30nt")));

var $26c28fa2f761f796$var$_defaultSxConfig = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("jGEJM")));

var $26c28fa2f761f796$var$_applyStyles = $26c28fa2f761f796$require$_interopRequireDefault((parcelRequire("4sSWG")));
function $26c28fa2f761f796$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $26c28fa2f761f796$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $26c28fa2f761f796$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $26c28fa2f761f796$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$26c28fa2f761f796$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $26c28fa2f761f796$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $26c28fa2f761f796$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $26c28fa2f761f796$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$26c28fa2f761f796$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $26c28fa2f761f796$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $26c28fa2f761f796$var$_default = module.exports.default = $26c28fa2f761f796$var$createTheme;

});
parcelRegister("hKcKi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ceb09e8dad01e389$var$shape = {
    borderRadius: 4
};
var $ceb09e8dad01e389$var$_default = module.exports.default = $ceb09e8dad01e389$var$shape;

});

parcelRegister("4cXI2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3106996b29d5ab13$var$createSpacing;

var $iI1Nz = parcelRequire("iI1Nz");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3106996b29d5ab13$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $iI1Nz.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("4sSWG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $340465f7a7b7899a$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $340465f7a7b7899a$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("4E9MM", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $36227d17408af430$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $36227d17408af430$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $36227d17408af430$var$_generateUtilityClass.default;
    }
});

var $36227d17408af430$var$_generateUtilityClass = $36227d17408af430$require$_interopRequireWildcard((parcelRequire("6c8aZ")));
Object.keys($36227d17408af430$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($36227d17408af430$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $36227d17408af430$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $36227d17408af430$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("6c8aZ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $482a34b147e5bb23$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $482a34b147e5bb23$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $482a34b147e5bb23$var$isGlobalState;

var $482a34b147e5bb23$var$_ClassNameGenerator = $482a34b147e5bb23$require$_interopRequireDefault((parcelRequire("hKcHZ")));
const $482a34b147e5bb23$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $482a34b147e5bb23$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $482a34b147e5bb23$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$482a34b147e5bb23$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $482a34b147e5bb23$var$isGlobalState(slot) {
    return $482a34b147e5bb23$var$globalStateClasses[slot] !== undefined;
}

});
parcelRegister("hKcHZ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ceb09736d060ee4f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ceb09736d060ee4f$var$_ClassNameGenerator.default;
    }
});

var $ceb09736d060ee4f$var$_ClassNameGenerator = $ceb09736d060ee4f$require$_interopRequireDefault((parcelRequire("1KCob")));

});
parcelRegister("1KCob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $1467dd9872fc2db2$var$defaultGenerator = (componentName)=>componentName;
const $1467dd9872fc2db2$var$createClassNameGenerator = ()=>{
    let generate = $1467dd9872fc2db2$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $1467dd9872fc2db2$var$defaultGenerator;
        }
    };
};
const $1467dd9872fc2db2$var$ClassNameGenerator = $1467dd9872fc2db2$var$createClassNameGenerator();
var $1467dd9872fc2db2$var$_default = module.exports.default = $1467dd9872fc2db2$var$ClassNameGenerator;

});




parcelRegister("cWeFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96b6474536dfe3a0$var$createMixins;
function $96b6474536dfe3a0$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("ewxoJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a92df5fad1ca199f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a92df5fad1ca199f$var$createTypography;

var $a92df5fad1ca199f$var$_deepmerge = $a92df5fad1ca199f$require$_interopRequireDefault((parcelRequire("cfKeZ")));
function $a92df5fad1ca199f$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a92df5fad1ca199f$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $a92df5fad1ca199f$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $a92df5fad1ca199f$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $a92df5fad1ca199f$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $a92df5fad1ca199f$var$defaultFontFamily ? {
                letterSpacing: `${$a92df5fad1ca199f$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $a92df5fad1ca199f$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $a92df5fad1ca199f$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $a92df5fad1ca199f$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("56fqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $3b697a902a860f0f$var$shadowKeyUmbraOpacity = 0.2;
const $3b697a902a860f0f$var$shadowKeyPenumbraOpacity = 0.14;
const $3b697a902a860f0f$var$shadowAmbientShadowOpacity = 0.12;
function $3b697a902a860f0f$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$3b697a902a860f0f$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$3b697a902a860f0f$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$3b697a902a860f0f$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $3b697a902a860f0f$var$shadows = [
    'none',
    $3b697a902a860f0f$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $3b697a902a860f0f$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $3b697a902a860f0f$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $3b697a902a860f0f$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $3b697a902a860f0f$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $3b697a902a860f0f$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $3b697a902a860f0f$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $3b697a902a860f0f$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $3b697a902a860f0f$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $3b697a902a860f0f$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $3b697a902a860f0f$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $3b697a902a860f0f$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $3b697a902a860f0f$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $3b697a902a860f0f$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $3b697a902a860f0f$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $3b697a902a860f0f$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $3b697a902a860f0f$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $3b697a902a860f0f$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $3b697a902a860f0f$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $3b697a902a860f0f$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $3b697a902a860f0f$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $3b697a902a860f0f$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $3b697a902a860f0f$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $3b697a902a860f0f$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $3b697a902a860f0f$var$_default = module.exports.default = $3b697a902a860f0f$var$shadows;

});

parcelRegister("6nqwa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a4975f5f7622db2$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $4a4975f5f7622db2$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $4a4975f5f7622db2$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $4a4975f5f7622db2$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $4a4975f5f7622db2$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $4a4975f5f7622db2$var$createTransitions(inputTransitions) {
    const mergedEasing = {
        ...$4a4975f5f7622db2$var$easing,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$4a4975f5f7622db2$var$duration,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $4a4975f5f7622db2$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $4a4975f5f7622db2$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $4a4975f5f7622db2$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("8XP8U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $686b814d1aaa7aa5$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $686b814d1aaa7aa5$var$_default = module.exports.default = $686b814d1aaa7aa5$var$zIndex;

});

parcelRegister("9ulEf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $6e87b54074f97842$var$stringifyTheme;

var $cfKeZ = parcelRequire("cfKeZ");
/* eslint-disable import/prefer-default-export */ function $6e87b54074f97842$var$isSerializable(val) {
    return (0, $cfKeZ.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $6e87b54074f97842$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$6e87b54074f97842$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $cfKeZ.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("3lzSt", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $26ff29cb702015d7$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26ff29cb702015d7$var$createColorScheme;
module.exports.getOpacity = $26ff29cb702015d7$var$getOpacity;
module.exports.getOverlays = $26ff29cb702015d7$var$getOverlays;

var $26ff29cb702015d7$var$_createPalette = $26ff29cb702015d7$require$_interopRequireDefault((parcelRequire("hbeCt")));

var $26ff29cb702015d7$var$_getOverlayAlpha = $26ff29cb702015d7$require$_interopRequireDefault((parcelRequire("idmqx")));
const $26ff29cb702015d7$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $26ff29cb702015d7$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $26ff29cb702015d7$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $26ff29cb702015d7$var$getOverlays(mode) {
    return mode === 'dark' ? $26ff29cb702015d7$var$defaultDarkOverlays : [];
}
function $26ff29cb702015d7$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, ...rest } = options;
    const palette = (0, $26ff29cb702015d7$var$_createPalette.default)(paletteInput);
    return {
        palette: palette,
        opacity: {
            ...$26ff29cb702015d7$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $26ff29cb702015d7$var$getOverlays(palette.mode),
        ...rest
    };
}

});
parcelRegister("idmqx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d42ad66b1f703575$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $d42ad66b1f703575$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("hB1P1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccf74e316f31bb71$var$shouldSkipGeneratingVar;
function $ccf74e316f31bb71$var$shouldSkipGeneratingVar(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("df57O", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9a40a6cf23dba154$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a40a6cf23dba154$var$_excludeVariablesFromRoot = $9a40a6cf23dba154$require$_interopRequireDefault((parcelRequire("8Q1U9")));
var $9a40a6cf23dba154$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $9a40a6cf23dba154$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $9a40a6cf23dba154$var$_default;

});
parcelRegister("8Q1U9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $66f4a84e62a4c27a$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $66f4a84e62a4c27a$var$_default = module.exports.default = $66f4a84e62a4c27a$var$excludeVariablesFromRoot;

});




parcelRegister("foFPJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b3598c20ed836ebf$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b3598c20ed836ebf$var$createMuiStrictModeTheme;

var $b3598c20ed836ebf$var$_deepmerge = $b3598c20ed836ebf$require$_interopRequireDefault((parcelRequire("cfKeZ")));

var $b3598c20ed836ebf$var$_createTheme = $b3598c20ed836ebf$require$_interopRequireDefault((parcelRequire("dleIZ")));
function $b3598c20ed836ebf$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $b3598c20ed836ebf$var$_createTheme.default)((0, $b3598c20ed836ebf$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("cYWN6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9738b14762ccd11a$var$createStyles;
let $9738b14762ccd11a$var$warnedOnce = false;
// To remove in v6
function $9738b14762ccd11a$var$createStyles(styles) {
    if (!$9738b14762ccd11a$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $9738b14762ccd11a$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("ibZiC", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d3e8cdd9017c6423$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3e8cdd9017c6423$var$responsiveFontSizes;

var $d3e8cdd9017c6423$var$_formatMuiErrorMessage = $d3e8cdd9017c6423$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $hMM1n = parcelRequire("hMM1n");
function $d3e8cdd9017c6423$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $hMM1n.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $hMM1n.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $d3e8cdd9017c6423$var$_formatMuiErrorMessage.default)(6));
        if (!(0, $hMM1n.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $hMM1n.alignProperty)({
                size: value,
                grid: (0, $hMM1n.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = {
            ...style,
            ...(0, $hMM1n.responsiveProperty)({
                cssProperty: 'fontSize',
                min: minFontSize,
                max: maxFontSize,
                unit: 'rem',
                breakpoints: breakpointValues,
                transform: transform
            })
        };
    });
    return theme;
}

});
parcelRegister("hMM1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $cf2c2b63e3ba38d8$var$alignProperty;
module.exports.convertLength = $cf2c2b63e3ba38d8$var$convertLength;
module.exports.fontGrid = $cf2c2b63e3ba38d8$var$fontGrid;
module.exports.getUnit = $cf2c2b63e3ba38d8$var$getUnit;
module.exports.isUnitless = $cf2c2b63e3ba38d8$var$isUnitless;
module.exports.responsiveProperty = $cf2c2b63e3ba38d8$var$responsiveProperty;
module.exports.toUnitless = $cf2c2b63e3ba38d8$var$toUnitless;
function $cf2c2b63e3ba38d8$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $cf2c2b63e3ba38d8$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $cf2c2b63e3ba38d8$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $cf2c2b63e3ba38d8$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $cf2c2b63e3ba38d8$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $cf2c2b63e3ba38d8$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $cf2c2b63e3ba38d8$var$toUnitless(length) * $cf2c2b63e3ba38d8$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $cf2c2b63e3ba38d8$var$toUnitless(length) * $cf2c2b63e3ba38d8$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $cf2c2b63e3ba38d8$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $cf2c2b63e3ba38d8$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $cf2c2b63e3ba38d8$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $cf2c2b63e3ba38d8$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $cf2c2b63e3ba38d8$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});


parcelRegister("iG1rK", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d98d457e126b8fcb$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $d98d457e126b8fcb$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d98d457e126b8fcb$var$useTheme;

var $d98d457e126b8fcb$var$React = $d98d457e126b8fcb$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $7fbRa = parcelRequire("7fbRa");

var $d98d457e126b8fcb$var$_defaultTheme = $d98d457e126b8fcb$require$_interopRequireDefault((parcelRequire("bBEhG")));

var $d98d457e126b8fcb$var$_identifier = $d98d457e126b8fcb$require$_interopRequireDefault((parcelRequire("5TqxC")));
function $d98d457e126b8fcb$var$useTheme() {
    const theme = (0, $7fbRa.default)($d98d457e126b8fcb$var$_defaultTheme.default);
    return theme[$d98d457e126b8fcb$var$_identifier.default] || theme;
}

});
parcelRegister("7fbRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5463218e758e350b$export$2e2bcd8739ae039; });

var $bL0S0 = parcelRequire("bL0S0");

var $1wpVQ = parcelRequire("1wpVQ");
'use client';
const $5463218e758e350b$export$35e57303dbd8a66 = (0, $bL0S0.default)();
function $5463218e758e350b$var$useTheme(defaultTheme = $5463218e758e350b$export$35e57303dbd8a66) {
    return (0, $1wpVQ.default)(defaultTheme);
}
var $5463218e758e350b$export$2e2bcd8739ae039 = $5463218e758e350b$var$useTheme;

});
parcelRegister("bL0S0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88f4c244687630ce$export$2e2bcd8739ae039; });

var $cfKeZ = parcelRequire("cfKeZ");

var $czV3l = parcelRequire("czV3l");

var $iMDnO = parcelRequire("iMDnO");

var $4gJtO = parcelRequire("4gJtO");

var $fyaOi = parcelRequire("fyaOi");

var $gqU4X = parcelRequire("gqU4X");

var $3z59k = parcelRequire("3z59k");

var $kl36y = parcelRequire("kl36y");
function $88f4c244687630ce$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $czV3l.default)(breakpointsInput);
    const spacing = (0, $fyaOi.default)(spacingInput);
    let muiTheme = (0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $4gJtO.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $iMDnO.default)(muiTheme);
    muiTheme.applyStyles = (0, $kl36y.default);
    muiTheme = args.reduce((acc, argument)=>(0, (/*@__PURE__*/$parcel$interopDefault($cfKeZ)))(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $3z59k.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $gqU4X.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $88f4c244687630ce$export$2e2bcd8739ae039 = $88f4c244687630ce$var$createTheme;

});
parcelRegister("4gJtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31bbef668aef4187$export$2e2bcd8739ae039; });
const $31bbef668aef4187$var$shape = {
    borderRadius: 4
};
var $31bbef668aef4187$export$2e2bcd8739ae039 = $31bbef668aef4187$var$shape;

});

parcelRegister("gqU4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf6a93257e78b7bc$export$2e2bcd8739ae039; });

var $eUhyY = parcelRequire("eUhyY");

var $3InwI = parcelRequire("3InwI");

var $4Sj9k = parcelRequire("4Sj9k");

var $k1b5n = parcelRequire("k1b5n");

var $iMDnO = parcelRequire("iMDnO");

var $3z59k = parcelRequire("3z59k");
function $bf6a93257e78b7bc$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $bf6a93257e78b7bc$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $bf6a93257e78b7bc$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $4Sj9k.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $4Sj9k.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $4Sj9k.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($eUhyY)))(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $k1b5n.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $3z59k.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $k1b5n.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $bf6a93257e78b7bc$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $3InwI.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $k1b5n.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($bf6a93257e78b7bc$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $3InwI.default)(css, breakpointsValues);
                        }
                    } else css = (0, $3InwI.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $iMDnO.sortContainerQueries)(theme, (0, $k1b5n.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $bf6a93257e78b7bc$var$styleFunctionSx = $bf6a93257e78b7bc$export$7d53d8bf2911e013();
$bf6a93257e78b7bc$var$styleFunctionSx.filterProps = [
    'sx'
];
var $bf6a93257e78b7bc$export$2e2bcd8739ae039 = $bf6a93257e78b7bc$var$styleFunctionSx;

});
parcelRegister("3z59k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2988a28ae3dd8587$export$2e2bcd8739ae039; });

var $3kkiI = parcelRequire("3kkiI");

var $lamX1 = parcelRequire("lamX1");

var $hA3yI = parcelRequire("hA3yI");

var $3IAMV = parcelRequire("3IAMV");

var $4dIM7 = parcelRequire("4dIM7");
const $2988a28ae3dd8587$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $lamX1.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $lamX1.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $3IAMV.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $3IAMV.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $3IAMV.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $3kkiI.padding)
    },
    pt: {
        style: (0, $3kkiI.padding)
    },
    pr: {
        style: (0, $3kkiI.padding)
    },
    pb: {
        style: (0, $3kkiI.padding)
    },
    pl: {
        style: (0, $3kkiI.padding)
    },
    px: {
        style: (0, $3kkiI.padding)
    },
    py: {
        style: (0, $3kkiI.padding)
    },
    padding: {
        style: (0, $3kkiI.padding)
    },
    paddingTop: {
        style: (0, $3kkiI.padding)
    },
    paddingRight: {
        style: (0, $3kkiI.padding)
    },
    paddingBottom: {
        style: (0, $3kkiI.padding)
    },
    paddingLeft: {
        style: (0, $3kkiI.padding)
    },
    paddingX: {
        style: (0, $3kkiI.padding)
    },
    paddingY: {
        style: (0, $3kkiI.padding)
    },
    paddingInline: {
        style: (0, $3kkiI.padding)
    },
    paddingInlineStart: {
        style: (0, $3kkiI.padding)
    },
    paddingInlineEnd: {
        style: (0, $3kkiI.padding)
    },
    paddingBlock: {
        style: (0, $3kkiI.padding)
    },
    paddingBlockStart: {
        style: (0, $3kkiI.padding)
    },
    paddingBlockEnd: {
        style: (0, $3kkiI.padding)
    },
    m: {
        style: (0, $3kkiI.margin)
    },
    mt: {
        style: (0, $3kkiI.margin)
    },
    mr: {
        style: (0, $3kkiI.margin)
    },
    mb: {
        style: (0, $3kkiI.margin)
    },
    ml: {
        style: (0, $3kkiI.margin)
    },
    mx: {
        style: (0, $3kkiI.margin)
    },
    my: {
        style: (0, $3kkiI.margin)
    },
    margin: {
        style: (0, $3kkiI.margin)
    },
    marginTop: {
        style: (0, $3kkiI.margin)
    },
    marginRight: {
        style: (0, $3kkiI.margin)
    },
    marginBottom: {
        style: (0, $3kkiI.margin)
    },
    marginLeft: {
        style: (0, $3kkiI.margin)
    },
    marginX: {
        style: (0, $3kkiI.margin)
    },
    marginY: {
        style: (0, $3kkiI.margin)
    },
    marginInline: {
        style: (0, $3kkiI.margin)
    },
    marginInlineStart: {
        style: (0, $3kkiI.margin)
    },
    marginInlineEnd: {
        style: (0, $3kkiI.margin)
    },
    marginBlock: {
        style: (0, $3kkiI.margin)
    },
    marginBlockStart: {
        style: (0, $3kkiI.margin)
    },
    marginBlockEnd: {
        style: (0, $3kkiI.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $hA3yI.gap)
    },
    rowGap: {
        style: (0, $hA3yI.rowGap)
    },
    columnGap: {
        style: (0, $hA3yI.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $4dIM7.sizingTransform)
    },
    maxWidth: {
        style: (0, $4dIM7.maxWidth)
    },
    minWidth: {
        transform: (0, $4dIM7.sizingTransform)
    },
    height: {
        transform: (0, $4dIM7.sizingTransform)
    },
    maxHeight: {
        transform: (0, $4dIM7.sizingTransform)
    },
    minHeight: {
        transform: (0, $4dIM7.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $2988a28ae3dd8587$export$2e2bcd8739ae039 = $2988a28ae3dd8587$var$defaultSxConfig;

});
parcelRegister("lamX1", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $f68c55b81a1d90e0$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $f68c55b81a1d90e0$export$7a57f79000377ca2; });


var $4Sj9k = parcelRequire("4Sj9k");

var $3mI3d = parcelRequire("3mI3d");

var $3kkiI = parcelRequire("3kkiI");

var $k1b5n = parcelRequire("k1b5n");
function $f68c55b81a1d90e0$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $f68c55b81a1d90e0$var$createBorderStyle(prop, transform) {
    return (0, $4Sj9k.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $f68c55b81a1d90e0$export$1edee58a52776cd9 = $f68c55b81a1d90e0$var$createBorderStyle('border', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$f9a7b6bd24892946 = $f68c55b81a1d90e0$var$createBorderStyle('borderTop', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$5abca33e6be905d2 = $f68c55b81a1d90e0$var$createBorderStyle('borderRight', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$e2ce9f12a980a822 = $f68c55b81a1d90e0$var$createBorderStyle('borderBottom', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$47658cca1a909427 = $f68c55b81a1d90e0$var$createBorderStyle('borderLeft', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$e7fb0694ba2404fc = $f68c55b81a1d90e0$var$createBorderStyle('borderColor');
const $f68c55b81a1d90e0$export$126a92c968acdb85 = $f68c55b81a1d90e0$var$createBorderStyle('borderTopColor');
const $f68c55b81a1d90e0$export$85cc51cb8fbb8c0e = $f68c55b81a1d90e0$var$createBorderStyle('borderRightColor');
const $f68c55b81a1d90e0$export$340b0327727f6d1a = $f68c55b81a1d90e0$var$createBorderStyle('borderBottomColor');
const $f68c55b81a1d90e0$export$60beef91a985b4bf = $f68c55b81a1d90e0$var$createBorderStyle('borderLeftColor');
const $f68c55b81a1d90e0$export$f9258c55612cbed7 = $f68c55b81a1d90e0$var$createBorderStyle('outline', $f68c55b81a1d90e0$export$34e2febe53ae29cc);
const $f68c55b81a1d90e0$export$621fe586efeb64b9 = $f68c55b81a1d90e0$var$createBorderStyle('outlineColor');
const $f68c55b81a1d90e0$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $3kkiI.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $3kkiI.getValue)(transformer, propValue)
            });
        return (0, $k1b5n.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$f68c55b81a1d90e0$export$7a57f79000377ca2.propTypes = {};
$f68c55b81a1d90e0$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $f68c55b81a1d90e0$var$borders = (0, $3mI3d.default)($f68c55b81a1d90e0$export$1edee58a52776cd9, $f68c55b81a1d90e0$export$f9a7b6bd24892946, $f68c55b81a1d90e0$export$5abca33e6be905d2, $f68c55b81a1d90e0$export$e2ce9f12a980a822, $f68c55b81a1d90e0$export$47658cca1a909427, $f68c55b81a1d90e0$export$e7fb0694ba2404fc, $f68c55b81a1d90e0$export$126a92c968acdb85, $f68c55b81a1d90e0$export$85cc51cb8fbb8c0e, $f68c55b81a1d90e0$export$340b0327727f6d1a, $f68c55b81a1d90e0$export$60beef91a985b4bf, $f68c55b81a1d90e0$export$7a57f79000377ca2, $f68c55b81a1d90e0$export$f9258c55612cbed7, $f68c55b81a1d90e0$export$621fe586efeb64b9);
var $f68c55b81a1d90e0$export$2e2bcd8739ae039 = $f68c55b81a1d90e0$var$borders;

});
parcelRegister("3mI3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273598c23d60efae$export$2e2bcd8739ae039; });

var $3InwI = parcelRequire("3InwI");
function $273598c23d60efae$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $3InwI.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $273598c23d60efae$export$2e2bcd8739ae039 = $273598c23d60efae$var$compose;

});


parcelRegister("hA3yI", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $ccc88f2a62259427$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $ccc88f2a62259427$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $ccc88f2a62259427$export$8a833ffa5f5dbeda; });

var $4Sj9k = parcelRequire("4Sj9k");

var $3mI3d = parcelRequire("3mI3d");

var $3kkiI = parcelRequire("3kkiI");

var $k1b5n = parcelRequire("k1b5n");

const $ccc88f2a62259427$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $3kkiI.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $3kkiI.getValue)(transformer, propValue)
            });
        return (0, $k1b5n.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$ccc88f2a62259427$export$5df9adcb0db95e1e.propTypes = {};
$ccc88f2a62259427$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $ccc88f2a62259427$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $3kkiI.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $3kkiI.getValue)(transformer, propValue)
            });
        return (0, $k1b5n.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$ccc88f2a62259427$export$ec60d70ff941a580.propTypes = {};
$ccc88f2a62259427$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $ccc88f2a62259427$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $3kkiI.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $3kkiI.getValue)(transformer, propValue)
            });
        return (0, $k1b5n.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$ccc88f2a62259427$export$8a833ffa5f5dbeda.propTypes = {};
$ccc88f2a62259427$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $ccc88f2a62259427$export$baf44164ca3a34e8 = (0, $4Sj9k.default)({
    prop: 'gridColumn'
});
const $ccc88f2a62259427$export$8f7213a1cd01e832 = (0, $4Sj9k.default)({
    prop: 'gridRow'
});
const $ccc88f2a62259427$export$b0e0abbc49ba668 = (0, $4Sj9k.default)({
    prop: 'gridAutoFlow'
});
const $ccc88f2a62259427$export$bcd8b929d4b4142 = (0, $4Sj9k.default)({
    prop: 'gridAutoColumns'
});
const $ccc88f2a62259427$export$e5039a674e14c828 = (0, $4Sj9k.default)({
    prop: 'gridAutoRows'
});
const $ccc88f2a62259427$export$42bd9088661ffb03 = (0, $4Sj9k.default)({
    prop: 'gridTemplateColumns'
});
const $ccc88f2a62259427$export$920682ae05b999bc = (0, $4Sj9k.default)({
    prop: 'gridTemplateRows'
});
const $ccc88f2a62259427$export$1b88fbdd482fd33a = (0, $4Sj9k.default)({
    prop: 'gridTemplateAreas'
});
const $ccc88f2a62259427$export$bdb486e40d52d26f = (0, $4Sj9k.default)({
    prop: 'gridArea'
});
const $ccc88f2a62259427$var$grid = (0, $3mI3d.default)($ccc88f2a62259427$export$5df9adcb0db95e1e, $ccc88f2a62259427$export$ec60d70ff941a580, $ccc88f2a62259427$export$8a833ffa5f5dbeda, $ccc88f2a62259427$export$baf44164ca3a34e8, $ccc88f2a62259427$export$8f7213a1cd01e832, $ccc88f2a62259427$export$b0e0abbc49ba668, $ccc88f2a62259427$export$bcd8b929d4b4142, $ccc88f2a62259427$export$e5039a674e14c828, $ccc88f2a62259427$export$42bd9088661ffb03, $ccc88f2a62259427$export$920682ae05b999bc, $ccc88f2a62259427$export$1b88fbdd482fd33a, $ccc88f2a62259427$export$bdb486e40d52d26f);
var $ccc88f2a62259427$export$2e2bcd8739ae039 = $ccc88f2a62259427$var$grid;

});

parcelRegister("3IAMV", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $2b520487e2ef4b48$export$dbaffd4420ea0ac6; });

var $4Sj9k = parcelRequire("4Sj9k");

var $3mI3d = parcelRequire("3mI3d");
function $2b520487e2ef4b48$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $2b520487e2ef4b48$export$35e9368ef982300f = (0, $4Sj9k.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $2b520487e2ef4b48$export$dbaffd4420ea0ac6
});
const $2b520487e2ef4b48$export$2506f56c10355b33 = (0, $4Sj9k.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $2b520487e2ef4b48$export$dbaffd4420ea0ac6
});
const $2b520487e2ef4b48$export$8c5a050822fd698c = (0, $4Sj9k.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $2b520487e2ef4b48$export$dbaffd4420ea0ac6
});
const $2b520487e2ef4b48$var$palette = (0, $3mI3d.default)($2b520487e2ef4b48$export$35e9368ef982300f, $2b520487e2ef4b48$export$2506f56c10355b33, $2b520487e2ef4b48$export$8c5a050822fd698c);
var $2b520487e2ef4b48$export$2e2bcd8739ae039 = $2b520487e2ef4b48$var$palette;

});

parcelRegister("4dIM7", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $312b1bbe822e9be6$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $312b1bbe822e9be6$export$488fda99655ff65a; });

var $4Sj9k = parcelRequire("4Sj9k");

var $3mI3d = parcelRequire("3mI3d");

var $k1b5n = parcelRequire("k1b5n");
function $312b1bbe822e9be6$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $312b1bbe822e9be6$export$7e3df82ee760448c = (0, $4Sj9k.default)({
    prop: 'width',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $k1b5n.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $312b1bbe822e9be6$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $k1b5n.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$312b1bbe822e9be6$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $312b1bbe822e9be6$export$ee148fbbe8357dd2 = (0, $4Sj9k.default)({
    prop: 'minWidth',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$ac607276a8fe9f0a = (0, $4Sj9k.default)({
    prop: 'height',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$dc0d8bd0b94f8570 = (0, $4Sj9k.default)({
    prop: 'maxHeight',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$a43cf604e12f3b17 = (0, $4Sj9k.default)({
    prop: 'minHeight',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$ffed9f14fb65e276 = (0, $4Sj9k.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$905076ed6620e671 = (0, $4Sj9k.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $312b1bbe822e9be6$export$8afece71750ec241
});
const $312b1bbe822e9be6$export$6ccc93f785106a58 = (0, $4Sj9k.default)({
    prop: 'boxSizing'
});
const $312b1bbe822e9be6$var$sizing = (0, $3mI3d.default)($312b1bbe822e9be6$export$7e3df82ee760448c, $312b1bbe822e9be6$export$488fda99655ff65a, $312b1bbe822e9be6$export$ee148fbbe8357dd2, $312b1bbe822e9be6$export$ac607276a8fe9f0a, $312b1bbe822e9be6$export$dc0d8bd0b94f8570, $312b1bbe822e9be6$export$a43cf604e12f3b17, $312b1bbe822e9be6$export$6ccc93f785106a58);
var $312b1bbe822e9be6$export$2e2bcd8739ae039 = $312b1bbe822e9be6$var$sizing;

});



parcelRegister("kl36y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ece82d58e1b3c0c3$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $ece82d58e1b3c0c3$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("1wpVQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11bce52c97a59416$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");
'use client';
function $11bce52c97a59416$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $11bce52c97a59416$var$useTheme(defaultTheme = null) {
    const contextTheme = $8nGP5.useContext((0, $jspCa.T));
    return !contextTheme || $11bce52c97a59416$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $11bce52c97a59416$export$2e2bcd8739ae039 = $11bce52c97a59416$var$useTheme;

});


parcelRegister("bBEhG", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $87326607025cd49a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87326607025cd49a$var$_createTheme = $87326607025cd49a$require$_interopRequireDefault((parcelRequire("dleIZ")));
const $87326607025cd49a$var$defaultTheme = (0, $87326607025cd49a$var$_createTheme.default)();
var $87326607025cd49a$var$_default = module.exports.default = $87326607025cd49a$var$defaultTheme;

});


parcelRegister("2qeyQ", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $1c394e0075b3f416$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1c394e0075b3f416$var$useThemeProps;

var $1c394e0075b3f416$var$_useThemeProps = $1c394e0075b3f416$require$_interopRequireDefault((parcelRequire("iwqzQ")));

var $1c394e0075b3f416$var$_defaultTheme = $1c394e0075b3f416$require$_interopRequireDefault((parcelRequire("bBEhG")));

var $1c394e0075b3f416$var$_identifier = $1c394e0075b3f416$require$_interopRequireDefault((parcelRequire("5TqxC")));
function $1c394e0075b3f416$var$useThemeProps({ props: props, name: name }) {
    return (0, $1c394e0075b3f416$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $1c394e0075b3f416$var$_defaultTheme.default,
        themeId: $1c394e0075b3f416$var$_identifier.default
    });
}

});
parcelRegister("iwqzQ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d7bfd4d7944c6de7$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d7bfd4d7944c6de7$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $d7bfd4d7944c6de7$var$_getThemeProps.default;
    }
});

var $d7bfd4d7944c6de7$var$_useThemeProps = $d7bfd4d7944c6de7$require$_interopRequireDefault((parcelRequire("kSJPv")));

var $d7bfd4d7944c6de7$var$_getThemeProps = $d7bfd4d7944c6de7$require$_interopRequireDefault((parcelRequire("9xXln")));

});
parcelRegister("kSJPv", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f33c669e473a525d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f33c669e473a525d$var$useThemeProps;

var $f33c669e473a525d$var$_getThemeProps = $f33c669e473a525d$require$_interopRequireDefault((parcelRequire("9xXln")));

var $f33c669e473a525d$var$_useTheme = $f33c669e473a525d$require$_interopRequireDefault((parcelRequire("akeuZ")));
function $f33c669e473a525d$var$useThemeProps({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $f33c669e473a525d$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f33c669e473a525d$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("9xXln", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6f353a901a8d97a4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f353a901a8d97a4$var$getThemeProps;

var $6f353a901a8d97a4$var$_resolveProps = $6f353a901a8d97a4$require$_interopRequireDefault((parcelRequire("9Blzt")));
function $6f353a901a8d97a4$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $6f353a901a8d97a4$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});

parcelRegister("akeuZ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $784704d06f0fadb7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $784704d06f0fadb7$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $784704d06f0fadb7$var$_useTheme.default;
    }
});

var $784704d06f0fadb7$var$_useTheme = $784704d06f0fadb7$require$_interopRequireWildcard((parcelRequire("kpTD9")));
Object.keys($784704d06f0fadb7$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($784704d06f0fadb7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $784704d06f0fadb7$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $784704d06f0fadb7$var$_useTheme[key];
        }
    });
});

});
parcelRegister("kpTD9", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $edd14b7db1c29b43$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $edd14b7db1c29b43$var$_createTheme = $edd14b7db1c29b43$require$_interopRequireDefault((parcelRequire("dBuWz")));

var $edd14b7db1c29b43$var$_useThemeWithoutDefault = $edd14b7db1c29b43$require$_interopRequireDefault((parcelRequire("dfCLb")));
const $edd14b7db1c29b43$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $edd14b7db1c29b43$var$_createTheme.default)();
function $edd14b7db1c29b43$var$useTheme(defaultTheme = $edd14b7db1c29b43$var$systemDefaultTheme) {
    return (0, $edd14b7db1c29b43$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $edd14b7db1c29b43$var$_default = module.exports.default = $edd14b7db1c29b43$var$useTheme;

});





parcelRegister("j3d8S", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $dde87ddf2e6cb9ce$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $dde87ddf2e6cb9ce$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $dde87ddf2e6cb9ce$var$_slotShouldForwardProp.default;
    }
});

var $dde87ddf2e6cb9ce$var$_createStyled = $dde87ddf2e6cb9ce$require$_interopRequireDefault((parcelRequire("cx8dF")));

var $dde87ddf2e6cb9ce$var$_defaultTheme = $dde87ddf2e6cb9ce$require$_interopRequireDefault((parcelRequire("bBEhG")));

var $dde87ddf2e6cb9ce$var$_identifier = $dde87ddf2e6cb9ce$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $dde87ddf2e6cb9ce$var$_rootShouldForwardProp = $dde87ddf2e6cb9ce$require$_interopRequireDefault((parcelRequire("6ed1m")));

var $dde87ddf2e6cb9ce$var$_slotShouldForwardProp = $dde87ddf2e6cb9ce$require$_interopRequireDefault((parcelRequire("6wCS6")));
const $dde87ddf2e6cb9ce$var$styled = (0, $dde87ddf2e6cb9ce$var$_createStyled.default)({
    themeId: $dde87ddf2e6cb9ce$var$_identifier.default,
    defaultTheme: $dde87ddf2e6cb9ce$var$_defaultTheme.default,
    rootShouldForwardProp: $dde87ddf2e6cb9ce$var$_rootShouldForwardProp.default
});
var $dde87ddf2e6cb9ce$var$_default = module.exports.default = $dde87ddf2e6cb9ce$var$styled;

});
parcelRegister("cx8dF", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $91fef150cfe102c8$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $91fef150cfe102c8$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $91fef150cfe102c8$var$_createStyled.default;
    }
});

var $91fef150cfe102c8$var$_createStyled = $91fef150cfe102c8$require$_interopRequireWildcard((parcelRequire("kV6Fz")));
Object.keys($91fef150cfe102c8$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($91fef150cfe102c8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $91fef150cfe102c8$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $91fef150cfe102c8$var$_createStyled[key];
        }
    });
});

});
parcelRegister("kV6Fz", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f3ae4df5b2b4af87$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f3ae4df5b2b4af87$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3ae4df5b2b4af87$var$createStyled;
module.exports.shouldForwardProp = $f3ae4df5b2b4af87$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $f3ae4df5b2b4af87$var$_styledEngine = $f3ae4df5b2b4af87$require$_interopRequireWildcard((parcelRequire("hmAfj")));

var $cfKeZ = parcelRequire("cfKeZ");

var $f3ae4df5b2b4af87$var$_capitalize = $f3ae4df5b2b4af87$require$_interopRequireDefault((parcelRequire("eUhyY")));

var $f3ae4df5b2b4af87$var$_getDisplayName = $f3ae4df5b2b4af87$require$_interopRequireDefault((parcelRequire("2iJqU")));

var $f3ae4df5b2b4af87$var$_createTheme = $f3ae4df5b2b4af87$require$_interopRequireDefault((parcelRequire("dBuWz")));

var $f3ae4df5b2b4af87$var$_styleFunctionSx = $f3ae4df5b2b4af87$require$_interopRequireDefault((parcelRequire("3RwFu")));

var $f3ae4df5b2b4af87$var$_preprocessStyles = $f3ae4df5b2b4af87$require$_interopRequireDefault((parcelRequire("1dpge")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $f3ae4df5b2b4af87$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $f3ae4df5b2b4af87$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $f3ae4df5b2b4af87$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $f3ae4df5b2b4af87$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $f3ae4df5b2b4af87$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $f3ae4df5b2b4af87$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $f3ae4df5b2b4af87$var$processStyle(props, style) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$f3ae4df5b2b4af87$var$processStyle(props, subStyle));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = otherStyles;
        }
        return $f3ae4df5b2b4af87$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ]);
    }
    if (resolvedStyle?.isProcessed) return resolvedStyle.style;
    return resolvedStyle;
}
function $f3ae4df5b2b4af87$var$processStyleVariants(props, variants, results = []) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(variant.style(mergedState));
        } else results.push(variant.style);
    }
    return results;
}
function $f3ae4df5b2b4af87$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $f3ae4df5b2b4af87$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $f3ae4df5b2b4af87$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $f3ae4df5b2b4af87$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $f3ae4df5b2b4af87$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $f3ae4df5b2b4af87$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $f3ae4df5b2b4af87$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $f3ae4df5b2b4af87$var$defaultOverridesResolver($f3ae4df5b2b4af87$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $f3ae4df5b2b4af87$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($f3ae4df5b2b4af87$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $f3ae4df5b2b4af87$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $f3ae4df5b2b4af87$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof style === 'function' && style.__emotion_real !== style) return function styleFunctionProcessor(props) {
                return $f3ae4df5b2b4af87$var$processStyle(props, style);
            };
            if ((0, $cfKeZ.isPlainObject)(style)) {
                const serialized = (0, $f3ae4df5b2b4af87$var$_preprocessStyles.default)(style);
                if (!serialized.variants) return serialized.style;
                return function styleObjectProcessor(props) {
                    return $f3ae4df5b2b4af87$var$processStyle(props, serialized);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $f3ae4df5b2b4af87$var$processStyle(props, styleOverrides[slotKey]);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $f3ae4df5b2b4af87$var$processStyleVariants(props, themeVariants);
            });
            if (!skipSx) expressionsTail.push($f3ae4df5b2b4af87$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $f3ae4df5b2b4af87$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $f3ae4df5b2b4af87$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $f3ae4df5b2b4af87$var$_getDisplayName.default)(tag)})`;
}
function $f3ae4df5b2b4af87$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $f3ae4df5b2b4af87$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $f3ae4df5b2b4af87$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $f3ae4df5b2b4af87$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("hmAfj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ca409b756f8e41eb$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_mutateStyles", function () { return $ca409b756f8e41eb$export$592c7226e4cb0171; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $ca409b756f8e41eb$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("jspCa")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("bj8tp")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("bj8tp")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("k9Cmz")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("i48zL")).default; });
/**
 * @mui/styled-engine v7.0.2
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $6dcdn = parcelRequire("6dcdn");

var $iBxqj = parcelRequire("iBxqj");

var $bj8tp = parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $k9Cmz = parcelRequire("k9Cmz");

var $i48zL = parcelRequire("i48zL");
'use client';
function $ca409b756f8e41eb$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $6dcdn.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $ca409b756f8e41eb$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $ca409b756f8e41eb$var$wrapper = [];
function $ca409b756f8e41eb$export$13a2d3ef13012b32(styles) {
    $ca409b756f8e41eb$var$wrapper[0] = styles;
    return (0, $iBxqj.serializeStyles)($ca409b756f8e41eb$var$wrapper);
}

});
parcelRegister("6dcdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $485d6e9869ce7485$export$2e2bcd8739ae039; });

var $02lkC = parcelRequire("02lkC");
parcelRequire("8tsi7");
parcelRequire("8nGP5");
parcelRequire("4kwnA");

parcelRequire("7x006");
parcelRequire("iBxqj");
parcelRequire("dn94N");
var $485d6e9869ce7485$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $485d6e9869ce7485$export$2e2bcd8739ae039 = (0, $02lkC.default).bind();
$485d6e9869ce7485$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $485d6e9869ce7485$export$2e2bcd8739ae039[tagName] = $485d6e9869ce7485$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("02lkC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0070bc0c2f83ac90$export$2e2bcd8739ae039; });

var $1TGTA = parcelRequire("1TGTA");

var $8nGP5 = parcelRequire("8nGP5");

var $4kwnA = parcelRequire("4kwnA");
parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $7x006 = parcelRequire("7x006");

var $iBxqj = parcelRequire("iBxqj");

var $dn94N = parcelRequire("dn94N");
var $0070bc0c2f83ac90$var$testOmitPropsOnStringTag = (0, $4kwnA.default);
var $0070bc0c2f83ac90$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $0070bc0c2f83ac90$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $0070bc0c2f83ac90$var$testOmitPropsOnStringTag : $0070bc0c2f83ac90$var$testOmitPropsOnComponent;
};
var $0070bc0c2f83ac90$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $0070bc0c2f83ac90$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $0070bc0c2f83ac90$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7x006.registerStyles)(cache, serialized, isStringTag);
    (0, $dn94N.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7x006.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $0070bc0c2f83ac90$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $0070bc0c2f83ac90$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $0070bc0c2f83ac90$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $jspCa.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8nGP5.useContext((0, $jspCa.T));
            }
            if (typeof props.className === 'string') className = (0, $7x006.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $iBxqj.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $0070bc0c2f83ac90$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($0070bc0c2f83ac90$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8nGP5.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $1TGTA.default)({}, options, nextOptions, {
                shouldForwardProp: $0070bc0c2f83ac90$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});


parcelRegister("k9Cmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eac268036d5829dd$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $jspCa = parcelRequire("jspCa");

var $6tfZw = parcelRequire("6tfZw");

var $77sbF = parcelRequire("77sbF");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $eac268036d5829dd$var$cacheMap = new Map();
const $eac268036d5829dd$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $eac268036d5829dd$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $6tfZw.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $eac268036d5829dd$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $eac268036d5829dd$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$eac268036d5829dd$var$insertionPoint) {
        $eac268036d5829dd$var$insertionPoint = document.createElement('meta');
        $eac268036d5829dd$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $eac268036d5829dd$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($eac268036d5829dd$var$insertionPoint);
    }
}
function $eac268036d5829dd$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $77sbF.StyleSheet) {
            insert(rule, options) {
                if ($eac268036d5829dd$export$5a3f4e255fc47e86.insert) return $eac268036d5829dd$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $eac268036d5829dd$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $eac268036d5829dd$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $eac268036d5829dd$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.startsWith('@layer')) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $eac268036d5829dd$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8nGP5.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if ($eac268036d5829dd$var$cacheMap.has(cacheKey)) return $eac268036d5829dd$var$cacheMap.get(cacheKey);
        const fresh = $eac268036d5829dd$var$getCache(injectFirst, enableCssLayer);
        $eac268036d5829dd$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $kSbwP.jsx)((0, $jspCa.C), {
        value: cache,
        children: children
    }) : children;
}

});


parcelRegister("2iJqU", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $1ad081476776c35f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1ad081476776c35f$var$_getDisplayName.default;
    }
});

var $1ad081476776c35f$var$_getDisplayName = $1ad081476776c35f$require$_interopRequireDefault((parcelRequire("hfpaJ")));

});
parcelRegister("hfpaJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8e75d0a6d624484$var$getDisplayName;

var $4G43L = parcelRequire("4G43L");
function $c8e75d0a6d624484$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $c8e75d0a6d624484$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $c8e75d0a6d624484$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $c8e75d0a6d624484$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $c8e75d0a6d624484$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4G43L.ForwardRef:
            return $c8e75d0a6d624484$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4G43L.Memo:
            return $c8e75d0a6d624484$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("1dpge", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e2a99964fc9b1a4$var$preprocessStyles;

var $hmAfj = parcelRequire("hmAfj");
function $0e2a99964fc9b1a4$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $hmAfj.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $hmAfj.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("6ed1m", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $488e268f0395692c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $488e268f0395692c$var$_slotShouldForwardProp = $488e268f0395692c$require$_interopRequireDefault((parcelRequire("6wCS6")));
const $488e268f0395692c$var$rootShouldForwardProp = (prop)=>(0, $488e268f0395692c$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $488e268f0395692c$var$_default = module.exports.default = $488e268f0395692c$var$rootShouldForwardProp;

});
parcelRegister("6wCS6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $4c03e25b29ffcf17$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $4c03e25b29ffcf17$var$_default = module.exports.default = $4c03e25b29ffcf17$var$slotShouldForwardProp;

});



parcelRegister("c1WwW", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8c22faf34ded1909$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $8c22faf34ded1909$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c22faf34ded1909$var$ThemeProvider;

var $8c22faf34ded1909$var$React = $8c22faf34ded1909$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8c22faf34ded1909$var$_ThemeProviderNoVars = $8c22faf34ded1909$require$_interopRequireDefault((parcelRequire("ti2jJ")));

var $ghEIe = parcelRequire("ghEIe");

var $8c22faf34ded1909$var$_identifier = $8c22faf34ded1909$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $kSbwP = parcelRequire("kSbwP");
function $8c22faf34ded1909$var$ThemeProvider({ theme: theme, ...props }) {
    if (typeof theme === 'function') return /*#__PURE__*/ (0, $kSbwP.jsx)($8c22faf34ded1909$var$_ThemeProviderNoVars.default, {
        theme: theme,
        ...props
    });
    const muiTheme = $8c22faf34ded1909$var$_identifier.default in theme ? theme[$8c22faf34ded1909$var$_identifier.default] : theme;
    if (!('colorSchemes' in muiTheme)) {
        if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
        // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
        return /*#__PURE__*/ (0, $kSbwP.jsx)($8c22faf34ded1909$var$_ThemeProviderNoVars.default, {
            theme: {
                ...theme,
                vars: null
            },
            ...props
        });
        return /*#__PURE__*/ (0, $kSbwP.jsx)($8c22faf34ded1909$var$_ThemeProviderNoVars.default, {
            theme: theme,
            ...props
        });
    }
    return /*#__PURE__*/ (0, $kSbwP.jsx)($ghEIe.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("ti2jJ", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $0580b33236f39650$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $0580b33236f39650$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0580b33236f39650$var$ThemeProviderNoVars;

var $0580b33236f39650$var$React = $0580b33236f39650$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $22gfS = parcelRequire("22gfS");

var $0580b33236f39650$var$_identifier = $0580b33236f39650$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $kSbwP = parcelRequire("kSbwP");
function $0580b33236f39650$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $0580b33236f39650$var$_identifier.default in themeInput ? themeInput[$0580b33236f39650$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $kSbwP.jsx)($22gfS.default, {
        ...props,
        themeId: scopedTheme ? $0580b33236f39650$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});
parcelRegister("22gfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17b8609514be44d2$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $7WGAH = parcelRequire("7WGAH");
var $1aEuo = parcelRequire("1aEuo");

parcelRequire("bj8tp");
var $jspCa = parcelRequire("jspCa");

var $1wpVQ = parcelRequire("1wpVQ");

var $1JnN0 = parcelRequire("1JnN0");

var $5JN1G = parcelRequire("5JN1G");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $17b8609514be44d2$var$EMPTY_THEME = {};
function $17b8609514be44d2$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8nGP5.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $17b8609514be44d2$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $1wpVQ.default)($17b8609514be44d2$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $1aEuo.default)() || $17b8609514be44d2$var$EMPTY_THEME;
    const engineTheme = $17b8609514be44d2$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $17b8609514be44d2$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $7WGAH.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $jspCa.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $1JnN0.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $5JN1G.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
var $17b8609514be44d2$export$2e2bcd8739ae039 = $17b8609514be44d2$var$ThemeProvider;

});
parcelRegister("1JnN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $142c7279f2b1cacf$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
'use client';
const $142c7279f2b1cacf$var$RtlContext = /*#__PURE__*/ $8nGP5.createContext();
function $142c7279f2b1cacf$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($142c7279f2b1cacf$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $142c7279f2b1cacf$export$b2dd014b6c321cb = ()=>{
    const value = $8nGP5.useContext($142c7279f2b1cacf$var$RtlContext);
    return value ?? false;
};
var $142c7279f2b1cacf$export$2e2bcd8739ae039 = $142c7279f2b1cacf$var$RtlProvider;

});

parcelRegister("5JN1G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42d72f4a4de5eece$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $9Blzt = parcelRequire("9Blzt");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $42d72f4a4de5eece$var$PropsContext = /*#__PURE__*/ $8nGP5.createContext(undefined);
function $42d72f4a4de5eece$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($42d72f4a4de5eece$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $42d72f4a4de5eece$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Blzt)))(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, (/*@__PURE__*/$parcel$interopDefault($9Blzt)))(config, props);
    return props;
}
function $42d72f4a4de5eece$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8nGP5.useContext($42d72f4a4de5eece$var$PropsContext);
    return $42d72f4a4de5eece$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $42d72f4a4de5eece$export$2e2bcd8739ae039 = $42d72f4a4de5eece$var$DefaultPropsProvider;

});



parcelRegister("ghEIe", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $bdadd07da6a51086$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $bdadd07da6a51086$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $bdadd07da6a51086$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $bdadd07da6a51086$var$React = $bdadd07da6a51086$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $bdadd07da6a51086$var$_styleFunctionSx = $bdadd07da6a51086$require$_interopRequireDefault((parcelRequire("3RwFu")));

var $hoEYB = parcelRequire("hoEYB");

var $bdadd07da6a51086$var$_createTheme = $bdadd07da6a51086$require$_interopRequireDefault((parcelRequire("dleIZ")));

var $bdadd07da6a51086$var$_createTypography = $bdadd07da6a51086$require$_interopRequireDefault((parcelRequire("ewxoJ")));

var $bdadd07da6a51086$var$_identifier = $bdadd07da6a51086$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $8slNs = parcelRequire("8slNs");

var $kSbwP = parcelRequire("kSbwP");
const { CssVarsProvider: $bdadd07da6a51086$var$InternalCssVarsProvider, useColorScheme: $bdadd07da6a51086$var$useColorScheme, getInitColorSchemeScript: $bdadd07da6a51086$var$deprecatedGetInitColorSchemeScript } = (0, $hoEYB.default)({
    themeId: $bdadd07da6a51086$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $bdadd07da6a51086$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $8slNs.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $8slNs.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $8slNs.defaultConfig.defaultLightColorScheme,
        dark: $8slNs.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $bdadd07da6a51086$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $bdadd07da6a51086$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $bdadd07da6a51086$var$useColorScheme;
let $bdadd07da6a51086$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $bdadd07da6a51086$var$Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($bdadd07da6a51086$var$InternalCssVarsProvider, {
        ...props
    });
}
let $bdadd07da6a51086$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $bdadd07da6a51086$var$getInitColorSchemeScript = (params)=>{
    if (!$bdadd07da6a51086$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $bdadd07da6a51086$var$warnedInitScriptOnce = true;
    }
    return $bdadd07da6a51086$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $bdadd07da6a51086$var$getInitColorSchemeScript;
const $bdadd07da6a51086$var$CssVarsProvider = module.exports.CssVarsProvider = $bdadd07da6a51086$var$InternalCssVarsProvider;

});
parcelRegister("hoEYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caa4769fc45b9cea$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");


var $i48zL = parcelRequire("i48zL");

var $1aEuo = parcelRequire("1aEuo");

var $jMi8t = parcelRequire("jMi8t");

var $22gfS = parcelRequire("22gfS");

var $jHAmf = parcelRequire("jHAmf");

var $avrCv = parcelRequire("avrCv");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $caa4769fc45b9cea$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $caa4769fc45b9cea$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $jHAmf.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $jHAmf.DEFAULT_COLOR_SCHEME_STORAGE_KEY), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $8nGP5.createContext(undefined);
    const useColorScheme = ()=>$8nGP5.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $8nGP5.useRef(false);
        const upperTheme = (0, $1aEuo.default)();
        const ctx = $8nGP5.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $8nGP5.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $8nGP5.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $avrCv.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $8nGP5.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, (/*@__PURE__*/$parcel$interopDefault($jMi8t)))(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $8nGP5.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($caa4769fc45b9cea$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $8nGP5.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $8nGP5.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $kSbwP.jsxs)($8nGP5.Fragment, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsx)((0, $22gfS.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $i48zL.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $kSbwP.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $jHAmf.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("jHAmf", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MODE_STORAGE_KEY", function () { return $e57e3c624af1a1c9$export$ff0fa3047d11164c; });
$parcel$export(module.exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", function () { return $e57e3c624af1a1c9$export$665054ea9d94dab9; });
$parcel$export(module.exports, "default", function () { return $e57e3c624af1a1c9$export$2e2bcd8739ae039; });
/**
 * Split this component for RSC import
 */ parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
const $e57e3c624af1a1c9$export$ff0fa3047d11164c = 'mode';
const $e57e3c624af1a1c9$export$665054ea9d94dab9 = 'color-scheme';
const $e57e3c624af1a1c9$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $e57e3c624af1a1c9$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $e57e3c624af1a1c9$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $e57e3c624af1a1c9$export$665054ea9d94dab9, attribute: initialAttribute = $e57e3c624af1a1c9$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^\]]+)\]/); // case [data-color-scheme=%s] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $kSbwP.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

});

parcelRegister("avrCv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a6239683dcc65f1$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");

var $jHAmf = parcelRequire("jHAmf");

var $8YJNd = parcelRequire("8YJNd");
'use client';
function $7a6239683dcc65f1$var$noop() {}
function $7a6239683dcc65f1$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $7a6239683dcc65f1$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $7a6239683dcc65f1$export$3caa7590cc1987bd(state) {
    return $7a6239683dcc65f1$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $7a6239683dcc65f1$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $jHAmf.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: colorSchemeStorageKey = (0, $jHAmf.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $8YJNd.default), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $8nGP5.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $8nGP5.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $7a6239683dcc65f1$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $8nGP5.useState(noSsr || !isMultiSchemes);
    $8nGP5.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $7a6239683dcc65f1$export$3caa7590cc1987bd(state);
    const setMode = $8nGP5.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $7a6239683dcc65f1$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $8nGP5.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $7a6239683dcc65f1$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $8nGP5.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $8nGP5.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $8nGP5.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $8nGP5.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $7a6239683dcc65f1$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $7a6239683dcc65f1$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $7a6239683dcc65f1$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("8YJNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $689772cd9cc033d1$export$2e2bcd8739ae039; });
function $689772cd9cc033d1$var$noop() {}
const $689772cd9cc033d1$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $689772cd9cc033d1$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $689772cd9cc033d1$export$2e2bcd8739ae039 = $689772cd9cc033d1$var$localStorageManager;

});



parcelRegister("8slNs", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6281d89bdee065d5$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $6281d89bdee065d5$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $6281d89bdee065d5$var$React = $6281d89bdee065d5$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $6281d89bdee065d5$var$_InitColorSchemeScript = $6281d89bdee065d5$require$_interopRequireDefault((parcelRequire("fNnUJ")));

var $kSbwP = parcelRequire("kSbwP");
const $6281d89bdee065d5$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
var $6281d89bdee065d5$var$InitColorSchemeScript = module.exports.default = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($6281d89bdee065d5$var$_InitColorSchemeScript.default, {
        ...$6281d89bdee065d5$var$defaultConfig,
        ...props
    });
};

});
parcelRegister("fNnUJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b7fdfb73b896d9c3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b7fdfb73b896d9c3$var$_InitColorSchemeScript.default;
    }
});

var $b7fdfb73b896d9c3$var$_InitColorSchemeScript = $b7fdfb73b896d9c3$require$_interopRequireDefault((parcelRequire("ejtRR")));

});




parcelRegister("5eg7s", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3ceac38102afd1e4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3ceac38102afd1e4$var$makeStyles;

var $3ceac38102afd1e4$var$_formatMuiErrorMessage = $3ceac38102afd1e4$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $3ceac38102afd1e4$var$makeStyles() {
    throw new Error((0, $3ceac38102afd1e4$var$_formatMuiErrorMessage.default)(14));
}

});

parcelRegister("e0rAD", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a326778f0d35594a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a326778f0d35594a$var$withStyles;

var $a326778f0d35594a$var$_formatMuiErrorMessage = $a326778f0d35594a$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $a326778f0d35594a$var$withStyles() {
    throw new Error((0, $a326778f0d35594a$var$_formatMuiErrorMessage.default)(15));
}

});

parcelRegister("99FyA", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $6aa530a9ea6f110b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6aa530a9ea6f110b$var$withTheme;

var $6aa530a9ea6f110b$var$_formatMuiErrorMessage = $6aa530a9ea6f110b$require$_interopRequireDefault((parcelRequire("cCZAW")));
function $6aa530a9ea6f110b$var$withTheme() {
    throw new Error((0, $6aa530a9ea6f110b$var$_formatMuiErrorMessage.default)(16));
}

});

parcelRegister("hAA2f", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $cce1c04dda22e60b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cce1c04dda22e60b$var$deprecatedExtendTheme;

var $cce1c04dda22e60b$var$_createThemeWithVars = $cce1c04dda22e60b$require$_interopRequireDefault((parcelRequire("brEcu")));
let $cce1c04dda22e60b$var$warnedOnce = false;
function $cce1c04dda22e60b$var$deprecatedExtendTheme(...args) {
    if (!$cce1c04dda22e60b$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $cce1c04dda22e60b$var$warnedOnce = true;
    }
    return (0, $cce1c04dda22e60b$var$_createThemeWithVars.default)(...args);
}

});

parcelRegister("4bI4C", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $30ca608ebce0b338$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $30ca608ebce0b338$var$_generateUtilityClasses.default;
    }
});

var $30ca608ebce0b338$var$_generateUtilityClasses = $30ca608ebce0b338$require$_interopRequireDefault((parcelRequire("gg7F3")));

});
parcelRegister("gg7F3", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $bd6415536cd8695d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd6415536cd8695d$var$generateUtilityClasses;

var $bd6415536cd8695d$var$_generateUtilityClass = $bd6415536cd8695d$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $bd6415536cd8695d$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $bd6415536cd8695d$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});


parcelRegister("htUof", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $cba0e2ff011e01c1$export$bf730a2d8bf68b42; }, function (v) { return $cba0e2ff011e01c1$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cba0e2ff011e01c1$export$bf730a2d8bf68b42;
"use strict";

var $8nGP5 = parcelRequire("8nGP5");
function $cba0e2ff011e01c1$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $cba0e2ff011e01c1$var$objectIs = "function" === typeof Object.is ? Object.is : $cba0e2ff011e01c1$var$is, $cba0e2ff011e01c1$var$useSyncExternalStore = $8nGP5.useSyncExternalStore, $cba0e2ff011e01c1$var$useRef = $8nGP5.useRef, $cba0e2ff011e01c1$var$useEffect = $8nGP5.useEffect, $cba0e2ff011e01c1$var$useMemo = $8nGP5.useMemo, $cba0e2ff011e01c1$var$useDebugValue = $8nGP5.useDebugValue;
$cba0e2ff011e01c1$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $cba0e2ff011e01c1$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $cba0e2ff011e01c1$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($cba0e2ff011e01c1$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $cba0e2ff011e01c1$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $cba0e2ff011e01c1$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $cba0e2ff011e01c1$var$useDebugValue(value);
    return value;
};

});

parcelRegister("5xdHV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $407aaad440b680e2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $407aaad440b680e2$var$_useEventCallback.default;
    }
});

var $407aaad440b680e2$var$_useEventCallback = $407aaad440b680e2$require$_interopRequireDefault((parcelRequire("f8Zxa")));

});
parcelRegister("f8Zxa", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $b06755b7f180a780$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $b06755b7f180a780$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b06755b7f180a780$var$React = $b06755b7f180a780$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $b06755b7f180a780$var$_useEnhancedEffect = $b06755b7f180a780$require$_interopRequireDefault((parcelRequire("jMi8t")));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b06755b7f180a780$var$useEventCallback(fn) {
    const ref = $b06755b7f180a780$var$React.useRef(fn);
    (0, $b06755b7f180a780$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $b06755b7f180a780$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b06755b7f180a780$var$_default = module.exports.default = $b06755b7f180a780$var$useEventCallback;

});


parcelRegister("bhDm2", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $836fcf30dfaa26de$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $836fcf30dfaa26de$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $836fcf30dfaa26de$var$React = $836fcf30dfaa26de$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $836fcf30dfaa26de$var$_propTypes = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $836fcf30dfaa26de$var$_clsx = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $836fcf30dfaa26de$var$_chainPropTypes = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("3wrUq")));

var $836fcf30dfaa26de$var$_composeClasses = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("4F19u")));

var $fS2VA = parcelRequire("fS2VA");

var $836fcf30dfaa26de$var$_memoTheme = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("jBs89")));

var $baZPJ = parcelRequire("baZPJ");

var $836fcf30dfaa26de$var$_capitalize = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("f1lQv")));

var $836fcf30dfaa26de$var$_createSimplePaletteValueFilter = $836fcf30dfaa26de$require$_interopRequireDefault((parcelRequire("fl59C")));

var $gq1Gj = parcelRequire("gq1Gj");

var $kSbwP = parcelRequire("kSbwP");
const $836fcf30dfaa26de$var$SIZE = 44;
const $836fcf30dfaa26de$var$circularRotateKeyframe = (0, $fS2VA.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $836fcf30dfaa26de$var$circularDashKeyframe = (0, $fS2VA.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $836fcf30dfaa26de$var$rotateAnimation = typeof $836fcf30dfaa26de$var$circularRotateKeyframe !== 'string' ? (0, $fS2VA.css)`
        animation: ${$836fcf30dfaa26de$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $836fcf30dfaa26de$var$dashAnimation = typeof $836fcf30dfaa26de$var$circularDashKeyframe !== 'string' ? (0, $fS2VA.css)`
        animation: ${$836fcf30dfaa26de$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $836fcf30dfaa26de$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $836fcf30dfaa26de$var$_capitalize.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $836fcf30dfaa26de$var$_capitalize.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $836fcf30dfaa26de$var$_composeClasses.default)(slots, $gq1Gj.getCircularProgressUtilityClass, classes);
};
const $836fcf30dfaa26de$var$CircularProgressRoot = (0, $fS2VA.styled)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $836fcf30dfaa26de$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $836fcf30dfaa26de$var$_memoTheme.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $836fcf30dfaa26de$var$rotateAnimation || {
                    animation: `${$836fcf30dfaa26de$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $836fcf30dfaa26de$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $836fcf30dfaa26de$var$CircularProgressSVG = (0, $fS2VA.styled)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $836fcf30dfaa26de$var$CircularProgressCircle = (0, $fS2VA.styled)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $836fcf30dfaa26de$var$_capitalize.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $836fcf30dfaa26de$var$_memoTheme.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $836fcf30dfaa26de$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$836fcf30dfaa26de$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $836fcf30dfaa26de$var$CircularProgress = /*#__PURE__*/ $836fcf30dfaa26de$var$React.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    };
    const classes = $836fcf30dfaa26de$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($836fcf30dfaa26de$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $kSbwP.jsx)($836fcf30dfaa26de$var$CircularProgressRoot, {
        className: (0, $836fcf30dfaa26de$var$_clsx.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($836fcf30dfaa26de$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$836fcf30dfaa26de$var$SIZE / 2} ${$836fcf30dfaa26de$var$SIZE / 2} ${$836fcf30dfaa26de$var$SIZE} ${$836fcf30dfaa26de$var$SIZE}`,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)($836fcf30dfaa26de$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $836fcf30dfaa26de$var$SIZE,
                cy: $836fcf30dfaa26de$var$SIZE,
                r: ($836fcf30dfaa26de$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    });
});
var $836fcf30dfaa26de$var$_default = module.exports.default = $836fcf30dfaa26de$var$CircularProgress;

});
parcelRegister("3wrUq", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $290a0271bb4a82c4$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $290a0271bb4a82c4$var$_chainPropTypes.default;
    }
});

var $290a0271bb4a82c4$var$_chainPropTypes = $290a0271bb4a82c4$require$_interopRequireDefault((parcelRequire("xH48M")));

});
parcelRegister("xH48M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $06547d2651b0686f$var$chainPropTypes;
function $06547d2651b0686f$var$chainPropTypes(propType1, propType2) {
    return ()=>null;
}

});


parcelRegister("fS2VA", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b8de2b8b5b4f3d43$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $b8de2b8b5b4f3d43$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bj8tp.css;
    }
});
module.exports.globalCss = $b8de2b8b5b4f3d43$var$globalCss;
module.exports.internal_createExtendSxProp = $b8de2b8b5b4f3d43$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bj8tp.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $b8de2b8b5b4f3d43$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $b8de2b8b5b4f3d43$var$_useTheme.default;
    }
});

var $b8de2b8b5b4f3d43$var$React = $b8de2b8b5b4f3d43$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $3RwFu = parcelRequire("3RwFu");

var $b8de2b8b5b4f3d43$var$_useTheme = $b8de2b8b5b4f3d43$require$_interopRequireDefault((parcelRequire("iG1rK")));

var $b8de2b8b5b4f3d43$var$_GlobalStyles = $b8de2b8b5b4f3d43$require$_interopRequireDefault((parcelRequire("8Meg0")));

var $kSbwP = parcelRequire("kSbwP");

var $bj8tp = parcelRequire("bj8tp");

var $b8de2b8b5b4f3d43$var$_styled = $b8de2b8b5b4f3d43$require$_interopRequireDefault((parcelRequire("j3d8S")));
function $b8de2b8b5b4f3d43$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $kSbwP.jsx)($b8de2b8b5b4f3d43$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $b8de2b8b5b4f3d43$var$internal_createExtendSxProp() {
    return $3RwFu.extendSxProp;
}

});
parcelRegister("8Meg0", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $663ddd9c387edbed$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $663ddd9c387edbed$var$_GlobalStyles.default;
    }
});

var $663ddd9c387edbed$var$_GlobalStyles = $663ddd9c387edbed$require$_interopRequireDefault((parcelRequire("lbTdK")));

});
parcelRegister("lbTdK", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f6d575b9efc24c88$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f6d575b9efc24c88$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6d575b9efc24c88$var$React = $f6d575b9efc24c88$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $f6d575b9efc24c88$var$_propTypes = $f6d575b9efc24c88$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $1s0xU = parcelRequire("1s0xU");

var $f6d575b9efc24c88$var$_defaultTheme = $f6d575b9efc24c88$require$_interopRequireDefault((parcelRequire("bBEhG")));

var $f6d575b9efc24c88$var$_identifier = $f6d575b9efc24c88$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $kSbwP = parcelRequire("kSbwP");
function $f6d575b9efc24c88$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($1s0xU.default, {
        ...props,
        defaultTheme: $f6d575b9efc24c88$var$_defaultTheme.default,
        themeId: $f6d575b9efc24c88$var$_identifier.default
    });
}
var $f6d575b9efc24c88$var$_default = module.exports.default = $f6d575b9efc24c88$var$GlobalStyles;

});
parcelRegister("1s0xU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e8d465de486315$export$2e2bcd8739ae039; });
parcelRequire("8nGP5");


var $i48zL = parcelRequire("i48zL");

var $7fbRa = parcelRequire("7fbRa");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $10e8d465de486315$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $7fbRa.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $i48zL.default), {
        styles: globalStyles
    });
}
var $10e8d465de486315$export$2e2bcd8739ae039 = $10e8d465de486315$var$GlobalStyles;

});




parcelRegister("jBs89", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9zb57 = parcelRequire("9zb57");
const $e4574b297ad16c49$var$memoTheme = $9zb57.default;
var $e4574b297ad16c49$var$_default = module.exports.default = $e4574b297ad16c49$var$memoTheme;

});
parcelRegister("9zb57", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f6ffa80563cade0$export$2e2bcd8739ae039; });

var $7NeT4 = parcelRequire("7NeT4");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $6f6ffa80563cade0$var$arg = {
    theme: undefined
};
function $6f6ffa80563cade0$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $6f6ffa80563cade0$var$arg.theme = props.theme;
            value = (0, $7NeT4.default)(styleFn($6f6ffa80563cade0$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});
parcelRegister("7NeT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ac8a85148e359c1$export$2e2bcd8739ae039; });

var $hmAfj = parcelRequire("hmAfj");
function $5ac8a85148e359c1$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $hmAfj.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $hmAfj.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("baZPJ", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $823097afbf212c0f$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823097afbf212c0f$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $823097afbf212c0f$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $823097afbf212c0f$var$_DefaultPropsProvider = $823097afbf212c0f$require$_interopRequireWildcard((parcelRequire("b11F3")));

});
parcelRegister("b11F3", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8051138ec5de66b4$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $8051138ec5de66b4$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $8051138ec5de66b4$var$useDefaultProps;

var $8051138ec5de66b4$var$React = $8051138ec5de66b4$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8051138ec5de66b4$var$_propTypes = $8051138ec5de66b4$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $8051138ec5de66b4$var$_DefaultPropsProvider = $8051138ec5de66b4$require$_interopRequireWildcard((parcelRequire("gmCn4")));

var $kSbwP = parcelRequire("kSbwP");
function $8051138ec5de66b4$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $kSbwP.jsx)($8051138ec5de66b4$var$_DefaultPropsProvider.default, {
        ...props
    });
}
var $8051138ec5de66b4$var$_default = module.exports.default = $8051138ec5de66b4$var$DefaultPropsProvider;
function $8051138ec5de66b4$var$useDefaultProps(params) {
    return (0, $8051138ec5de66b4$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});


parcelRegister("f1lQv", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $aef7e52a1ba98754$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aef7e52a1ba98754$var$_capitalize = $aef7e52a1ba98754$require$_interopRequireDefault((parcelRequire("eUhyY")));
var $aef7e52a1ba98754$var$_default = module.exports.default = $aef7e52a1ba98754$var$_capitalize.default;

});

parcelRegister("fl59C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b2acd0ab1e797bbb$var$createSimplePaletteValueFilter;
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $b2acd0ab1e797bbb$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $b2acd0ab1e797bbb$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$b2acd0ab1e797bbb$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
/**
 * Creates a filter function used to filter simple palette color options.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns ([, value]: [any, PaletteColorOptions]) => boolean
 */ function $b2acd0ab1e797bbb$var$createSimplePaletteValueFilter(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $b2acd0ab1e797bbb$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("gq1Gj", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $0315aefb9b99bdc8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCircularProgressUtilityClass = $0315aefb9b99bdc8$var$getCircularProgressUtilityClass;

var $0315aefb9b99bdc8$var$_generateUtilityClasses = $0315aefb9b99bdc8$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $0315aefb9b99bdc8$var$_generateUtilityClass = $0315aefb9b99bdc8$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $0315aefb9b99bdc8$var$getCircularProgressUtilityClass(slot) {
    return (0, $0315aefb9b99bdc8$var$_generateUtilityClass.default)('MuiCircularProgress', slot);
}
const $0315aefb9b99bdc8$var$circularProgressClasses = (0, $0315aefb9b99bdc8$var$_generateUtilityClasses.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $0315aefb9b99bdc8$var$_default = module.exports.default = $0315aefb9b99bdc8$var$circularProgressClasses;

});


parcelRegister("lalIu", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f68b6094e20a5e42$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f68b6094e20a5e42$var$_unsupportedProp.default;
    }
});

var $f68b6094e20a5e42$var$_unsupportedProp = $f68b6094e20a5e42$require$_interopRequireDefault((parcelRequire("jAmtF")));

});
parcelRegister("jAmtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e422d0adf9677a6e$var$unsupportedProp;
function $e422d0adf9677a6e$var$unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

});


parcelRegister("3uKFP", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $28b860d70d73988c$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $28b860d70d73988c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b860d70d73988c$var$React = $28b860d70d73988c$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $28b860d70d73988c$var$_clsx = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $28b860d70d73988c$var$_propTypes = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $818I0 = parcelRequire("818I0");

var $28b860d70d73988c$var$_useTimeout = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("kuuLw")));

var $28b860d70d73988c$var$_elementTypeAcceptingRef = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("5kQCz")));

var $28b860d70d73988c$var$_composeClasses = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("4F19u")));

var $fS2VA = parcelRequire("fS2VA");

var $28b860d70d73988c$var$_memoTheme = $28b860d70d73988c$require$_interopRequireDefault((parcelRequire("jBs89")));

var $baZPJ = parcelRequire("baZPJ");

var $6nqwa = parcelRequire("6nqwa");

var $83zZS = parcelRequire("83zZS");

var $ftvpK = parcelRequire("ftvpK");

var $eIMYG = parcelRequire("eIMYG");

var $kSbwP = parcelRequire("kSbwP");
const $28b860d70d73988c$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $28b860d70d73988c$var$_composeClasses.default)(slots, $eIMYG.getCollapseUtilityClass, classes);
};
const $28b860d70d73988c$var$CollapseRoot = (0, $fS2VA.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $28b860d70d73988c$var$_memoTheme.default)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $28b860d70d73988c$var$CollapseWrapper = (0, $fS2VA.styled)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $28b860d70d73988c$var$CollapseWrapperInner = (0, $fS2VA.styled)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $28b860d70d73988c$var$Collapse = /*#__PURE__*/ $28b860d70d73988c$var$React.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = $6nqwa.duration.standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = $818I0.default, ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $28b860d70d73988c$var$useUtilityClasses(ownerState);
    const theme = (0, $fS2VA.useTheme)();
    const timer = (0, $28b860d70d73988c$var$_useTimeout.default)();
    const wrapperRef = $28b860d70d73988c$var$React.useRef(null);
    const autoTransitionDuration = $28b860d70d73988c$var$React.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $28b860d70d73988c$var$React.useRef(null);
    const handleRef = (0, $ftvpK.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $83zZS.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $83zZS.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $kSbwP.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $kSbwP.jsx)($28b860d70d73988c$var$CollapseRoot, {
                as: component,
                className: (0, $28b860d70d73988c$var$_clsx.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)($28b860d70d73988c$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $kSbwP.jsx)($28b860d70d73988c$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($28b860d70d73988c$var$Collapse) $28b860d70d73988c$var$Collapse.muiSupportAuto = true;
var $28b860d70d73988c$var$_default = module.exports.default = $28b860d70d73988c$var$Collapse;

});
parcelRegister("818I0", function(module, exports) {

$parcel$export(module.exports, "ENTERING", function () { return $5d652c1a1d58da70$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $5d652c1a1d58da70$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "default", function () { return $5d652c1a1d58da70$export$2e2bcd8739ae039; });

var $8D9Xw = parcelRequire("8D9Xw");

var $79bU5 = parcelRequire("79bU5");


var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");

var $3bBJL = parcelRequire("3bBJL");


var $bTuph = parcelRequire("bTuph");

var $lU5JX = parcelRequire("lU5JX");
var $5d652c1a1d58da70$export$bb38bb9a1161268 = 'unmounted';
var $5d652c1a1d58da70$export$84cbff306f539230 = 'exited';
var $5d652c1a1d58da70$export$df38205c966be359 = 'entering';
var $5d652c1a1d58da70$export$78e9e6e3e014d60a = 'entered';
var $5d652c1a1d58da70$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $5d652c1a1d58da70$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $79bU5.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $5d652c1a1d58da70$export$84cbff306f539230;
                _this.appearStatus = $5d652c1a1d58da70$export$df38205c966be359;
            } else initialStatus = $5d652c1a1d58da70$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $5d652c1a1d58da70$export$bb38bb9a1161268;
        else initialStatus = $5d652c1a1d58da70$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $5d652c1a1d58da70$export$bb38bb9a1161268) return {
            status: $5d652c1a1d58da70$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $5d652c1a1d58da70$export$df38205c966be359 && status !== $5d652c1a1d58da70$export$78e9e6e3e014d60a) nextStatus = $5d652c1a1d58da70$export$df38205c966be359;
            } else if (status === $5d652c1a1d58da70$export$df38205c966be359 || status === $5d652c1a1d58da70$export$78e9e6e3e014d60a) nextStatus = $5d652c1a1d58da70$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $5d652c1a1d58da70$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $lU5JX.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $5d652c1a1d58da70$export$84cbff306f539230) this.setState({
            status: $5d652c1a1d58da70$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3bBJL.default).disabled) {
            this.safeSetState({
                status: $5d652c1a1d58da70$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $5d652c1a1d58da70$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $5d652c1a1d58da70$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3bBJL.default).disabled) {
            this.safeSetState({
                status: $5d652c1a1d58da70$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $5d652c1a1d58da70$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $5d652c1a1d58da70$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $5d652c1a1d58da70$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $8D9Xw.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $bTuph.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$5d652c1a1d58da70$var$Transition.contextType = (0, $bTuph.default);
$5d652c1a1d58da70$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $5d652c1a1d58da70$var$noop() {}
$5d652c1a1d58da70$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $5d652c1a1d58da70$var$noop,
    onEntering: $5d652c1a1d58da70$var$noop,
    onEntered: $5d652c1a1d58da70$var$noop,
    onExit: $5d652c1a1d58da70$var$noop,
    onExiting: $5d652c1a1d58da70$var$noop,
    onExited: $5d652c1a1d58da70$var$noop
};
$5d652c1a1d58da70$var$Transition.UNMOUNTED = $5d652c1a1d58da70$export$bb38bb9a1161268;
$5d652c1a1d58da70$var$Transition.EXITED = $5d652c1a1d58da70$export$84cbff306f539230;
$5d652c1a1d58da70$var$Transition.ENTERING = $5d652c1a1d58da70$export$df38205c966be359;
$5d652c1a1d58da70$var$Transition.ENTERED = $5d652c1a1d58da70$export$78e9e6e3e014d60a;
$5d652c1a1d58da70$var$Transition.EXITING = $5d652c1a1d58da70$export$4aacc83d4d59139f;
var $5d652c1a1d58da70$export$2e2bcd8739ae039 = $5d652c1a1d58da70$var$Transition;

});
parcelRegister("8D9Xw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6489b0e3346855d0$export$2e2bcd8739ae039; });
function $6489b0e3346855d0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("79bU5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53429b78f989eb39$export$2e2bcd8739ae039; });

var $4xcoB = parcelRequire("4xcoB");
function $53429b78f989eb39$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4xcoB.default)(t, o);
}

});
parcelRegister("4xcoB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d3dc0b25481873$export$2e2bcd8739ae039; });
function $34d3dc0b25481873$export$2e2bcd8739ae039(t, e) {
    return $34d3dc0b25481873$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $34d3dc0b25481873$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("3bBJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $251fac029a7a3a7e$export$2e2bcd8739ae039; });
var $251fac029a7a3a7e$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("bTuph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a8c6ae79818e32f$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");
var $8a8c6ae79818e32f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext(null);

});

parcelRegister("lU5JX", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $ff2347d2bac36412$export$7d26bbb1236dafd6; });
var $ff2347d2bac36412$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("kuuLw", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $eeae79608977ec34$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Timeout", {
    enumerable: true,
    get: function() {
        return $eeae79608977ec34$var$_useTimeout.Timeout;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eeae79608977ec34$var$_useTimeout.default;
    }
});

var $eeae79608977ec34$var$_useTimeout = $eeae79608977ec34$require$_interopRequireWildcard((parcelRequire("iDHdc")));

});
parcelRegister("iDHdc", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d91d638341eb78f3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = void 0;
module.exports.default = $d91d638341eb78f3$var$useTimeout;

var $d91d638341eb78f3$var$_useLazyRef = $d91d638341eb78f3$require$_interopRequireDefault((parcelRequire("587f9")));

var $d91d638341eb78f3$var$_useOnMount = $d91d638341eb78f3$require$_interopRequireDefault((parcelRequire("coHAx")));
class $d91d638341eb78f3$var$Timeout {
    static create() {
        return new $d91d638341eb78f3$var$Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
module.exports.Timeout = $d91d638341eb78f3$var$Timeout;
function $d91d638341eb78f3$var$useTimeout() {
    const timeout = (0, $d91d638341eb78f3$var$_useLazyRef.default)($d91d638341eb78f3$var$Timeout.create).current;
    (0, $d91d638341eb78f3$var$_useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("587f9", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $3bc351786e03e696$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bc351786e03e696$var$useLazyRef;

var $3bc351786e03e696$var$React = $3bc351786e03e696$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $3bc351786e03e696$var$UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function $3bc351786e03e696$var$useLazyRef(init, initArg) {
    const ref = $3bc351786e03e696$var$React.useRef($3bc351786e03e696$var$UNINITIALIZED);
    if (ref.current === $3bc351786e03e696$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("coHAx", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $906989a3cb2f6219$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $906989a3cb2f6219$var$useOnMount;

var $906989a3cb2f6219$var$React = $906989a3cb2f6219$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $906989a3cb2f6219$var$EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function $906989a3cb2f6219$var$useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $906989a3cb2f6219$var$React.useEffect(fn, $906989a3cb2f6219$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});



parcelRegister("5kQCz", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3e27a373f2ea0a29$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3e27a373f2ea0a29$var$_elementTypeAcceptingRef.default;
    }
});

var $3e27a373f2ea0a29$var$_elementTypeAcceptingRef = $3e27a373f2ea0a29$require$_interopRequireDefault((parcelRequire("aAbx9")));

});
parcelRegister("aAbx9", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $7b463683f69119c7$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b463683f69119c7$var$_propTypes = $7b463683f69119c7$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $7b463683f69119c7$var$_chainPropTypes = $7b463683f69119c7$require$_interopRequireDefault((parcelRequire("3wrUq")));
function $7b463683f69119c7$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $7b463683f69119c7$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$7b463683f69119c7$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $7b463683f69119c7$var$_default = module.exports.default = (0, $7b463683f69119c7$var$_chainPropTypes.default)($7b463683f69119c7$var$_propTypes.default.elementType, $7b463683f69119c7$var$elementTypeAcceptingRef);

});


parcelRegister("83zZS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransitionProps = $5dda86cf9a5a47fa$var$getTransitionProps;
module.exports.reflow = void 0;
const $5dda86cf9a5a47fa$var$reflow = (node)=>node.scrollTop;
module.exports.reflow = $5dda86cf9a5a47fa$var$reflow;
function $5dda86cf9a5a47fa$var$getTransitionProps(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});

parcelRegister("ftvpK", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $b441eea8987e26a2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "capitalize", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_capitalize.default;
    }
});
Object.defineProperty(module.exports, "createChainedFunction", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_createChainedFunction.default;
    }
});
Object.defineProperty(module.exports, "createSvgIcon", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_createSvgIcon.default;
    }
});
Object.defineProperty(module.exports, "debounce", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_debounce.default;
    }
});
Object.defineProperty(module.exports, "deprecatedPropType", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_deprecatedPropType.default;
    }
});
Object.defineProperty(module.exports, "isMuiElement", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_isMuiElement.default;
    }
});
Object.defineProperty(module.exports, "mergeSlotProps", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_mergeSlotProps.default;
    }
});
Object.defineProperty(module.exports, "ownerDocument", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_ownerDocument.default;
    }
});
Object.defineProperty(module.exports, "ownerWindow", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_ownerWindow.default;
    }
});
Object.defineProperty(module.exports, "requirePropFactory", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_requirePropFactory.default;
    }
});
Object.defineProperty(module.exports, "setRef", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_setRef.default;
    }
});
module.exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_useEnhancedEffect", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_useEnhancedEffect.default;
    }
});
Object.defineProperty(module.exports, "unstable_useId", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_useId.default;
    }
});
Object.defineProperty(module.exports, "unsupportedProp", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_unsupportedProp.default;
    }
});
Object.defineProperty(module.exports, "useControlled", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_useControlled.default;
    }
});
Object.defineProperty(module.exports, "useEventCallback", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_useEventCallback.default;
    }
});
Object.defineProperty(module.exports, "useForkRef", {
    enumerable: true,
    get: function() {
        return $b441eea8987e26a2$var$_useForkRef.default;
    }
});

var $8zvjb = parcelRequire("8zvjb");

var $b441eea8987e26a2$var$_capitalize = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("f1lQv")));

var $b441eea8987e26a2$var$_createChainedFunction = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("6crje")));

var $b441eea8987e26a2$var$_createSvgIcon = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("6s4Ec")));

var $b441eea8987e26a2$var$_debounce = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("6J83I")));

var $b441eea8987e26a2$var$_deprecatedPropType = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("fu1hI")));

var $b441eea8987e26a2$var$_isMuiElement = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("h5TfC")));

var $b441eea8987e26a2$var$_memoTheme = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("jBs89")));

var $b441eea8987e26a2$var$_ownerDocument = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("iCkwV")));

var $b441eea8987e26a2$var$_ownerWindow = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("kTXfr")));

var $b441eea8987e26a2$var$_requirePropFactory = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("1KSOa")));

var $b441eea8987e26a2$var$_setRef = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("1qmej")));

var $b441eea8987e26a2$var$_useEnhancedEffect = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("lHdPe")));

var $b441eea8987e26a2$var$_useId = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("ieBsi")));

var $b441eea8987e26a2$var$_unsupportedProp = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("gySrk")));

var $b441eea8987e26a2$var$_useControlled = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("dq2aN")));

var $b441eea8987e26a2$var$_useEventCallback = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("iCguj")));

var $b441eea8987e26a2$var$_useForkRef = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("bXPOA")));

var $b441eea8987e26a2$var$_mergeSlotProps = $b441eea8987e26a2$require$_interopRequireDefault((parcelRequire("7R9oI")));
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
const $b441eea8987e26a2$var$unstable_ClassNameGenerator = module.exports.unstable_ClassNameGenerator = {
    configure: (generator)=>{
        $8zvjb.default.configure(generator);
    }
};

});
parcelRegister("8zvjb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63d9e0d62239238e$export$2e2bcd8739ae039; });
const $63d9e0d62239238e$var$defaultGenerator = (componentName)=>componentName;
const $63d9e0d62239238e$var$createClassNameGenerator = ()=>{
    let generate = $63d9e0d62239238e$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $63d9e0d62239238e$var$defaultGenerator;
        }
    };
};
const $63d9e0d62239238e$var$ClassNameGenerator = $63d9e0d62239238e$var$createClassNameGenerator();
var $63d9e0d62239238e$export$2e2bcd8739ae039 = $63d9e0d62239238e$var$ClassNameGenerator;

});

parcelRegister("6crje", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $48390c1940e1d41a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $48390c1940e1d41a$var$_createChainedFunction = $48390c1940e1d41a$require$_interopRequireDefault((parcelRequire("d4blJ")));
var $48390c1940e1d41a$var$_default = module.exports.default = $48390c1940e1d41a$var$_createChainedFunction.default;

});
parcelRegister("d4blJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $983473e129da36ee$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $983473e129da36ee$var$_createChainedFunction.default;
    }
});

var $983473e129da36ee$var$_createChainedFunction = $983473e129da36ee$require$_interopRequireDefault((parcelRequire("eS7HI")));

});
parcelRegister("eS7HI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad3c15b2a71f6c1a$var$createChainedFunction;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $ad3c15b2a71f6c1a$var$createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});



parcelRegister("6s4Ec", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $4b28f67a20fd91ba$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $4b28f67a20fd91ba$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b28f67a20fd91ba$var$createSvgIcon;

var $4b28f67a20fd91ba$var$React = $4b28f67a20fd91ba$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $4b28f67a20fd91ba$var$_SvgIcon = $4b28f67a20fd91ba$require$_interopRequireDefault((parcelRequire("1fH1v")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * Private module reserved for @mui packages.
 */ function $4b28f67a20fd91ba$var$createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $kSbwP.jsx)($4b28f67a20fd91ba$var$_SvgIcon.default, {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = $4b28f67a20fd91ba$var$_SvgIcon.default.muiName;
    return /*#__PURE__*/ $4b28f67a20fd91ba$var$React.memo(/*#__PURE__*/ $4b28f67a20fd91ba$var$React.forwardRef(Component));
}

});
parcelRegister("1fH1v", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $0e9890b55332d83f$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $0e9890b55332d83f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0e9890b55332d83f$var$_exportNames = {
    svgIconClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e9890b55332d83f$var$_SvgIcon.default;
    }
});
Object.defineProperty(module.exports, "svgIconClasses", {
    enumerable: true,
    get: function() {
        return $0e9890b55332d83f$var$_svgIconClasses.default;
    }
});

var $0e9890b55332d83f$var$_SvgIcon = $0e9890b55332d83f$require$_interopRequireDefault((parcelRequire("kLHqP")));

var $0e9890b55332d83f$var$_svgIconClasses = $0e9890b55332d83f$require$_interopRequireWildcard((parcelRequire("aIJjG")));
Object.keys($0e9890b55332d83f$var$_svgIconClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0e9890b55332d83f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0e9890b55332d83f$var$_svgIconClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0e9890b55332d83f$var$_svgIconClasses[key];
        }
    });
});

});
parcelRegister("kLHqP", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $f1e9e314fb6e2201$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $f1e9e314fb6e2201$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1e9e314fb6e2201$var$React = $f1e9e314fb6e2201$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $f1e9e314fb6e2201$var$_propTypes = $f1e9e314fb6e2201$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $f1e9e314fb6e2201$var$_clsx = $f1e9e314fb6e2201$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $f1e9e314fb6e2201$var$_composeClasses = $f1e9e314fb6e2201$require$_interopRequireDefault((parcelRequire("4F19u")));

var $f1e9e314fb6e2201$var$_capitalize = $f1e9e314fb6e2201$require$_interopRequireDefault((parcelRequire("f1lQv")));

var $fS2VA = parcelRequire("fS2VA");

var $f1e9e314fb6e2201$var$_memoTheme = $f1e9e314fb6e2201$require$_interopRequireDefault((parcelRequire("jBs89")));

var $baZPJ = parcelRequire("baZPJ");

var $aIJjG = parcelRequire("aIJjG");

var $kSbwP = parcelRequire("kSbwP");
const $f1e9e314fb6e2201$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $f1e9e314fb6e2201$var$_capitalize.default)(color)}`,
            `fontSize${(0, $f1e9e314fb6e2201$var$_capitalize.default)(fontSize)}`
        ]
    };
    return (0, $f1e9e314fb6e2201$var$_composeClasses.default)(slots, $aIJjG.getSvgIconUtilityClass, classes);
};
const $f1e9e314fb6e2201$var$SvgIconRoot = (0, $fS2VA.styled)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $f1e9e314fb6e2201$var$_capitalize.default)(ownerState.color)}`],
            styles[`fontSize${(0, $f1e9e314fb6e2201$var$_capitalize.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $f1e9e314fb6e2201$var$_memoTheme.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $f1e9e314fb6e2201$var$SvgIcon = /*#__PURE__*/ $f1e9e314fb6e2201$var$React.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $f1e9e314fb6e2201$var$React.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $f1e9e314fb6e2201$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($f1e9e314fb6e2201$var$SvgIconRoot, {
        as: component,
        className: (0, $f1e9e314fb6e2201$var$_clsx.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $kSbwP.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$f1e9e314fb6e2201$var$SvgIcon.muiName = 'SvgIcon';
var $f1e9e314fb6e2201$var$_default = module.exports.default = $f1e9e314fb6e2201$var$SvgIcon;

});
parcelRegister("aIJjG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $7ce12a563a5386d0$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSvgIconUtilityClass = $7ce12a563a5386d0$var$getSvgIconUtilityClass;

var $7ce12a563a5386d0$var$_generateUtilityClasses = $7ce12a563a5386d0$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $7ce12a563a5386d0$var$_generateUtilityClass = $7ce12a563a5386d0$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $7ce12a563a5386d0$var$getSvgIconUtilityClass(slot) {
    return (0, $7ce12a563a5386d0$var$_generateUtilityClass.default)('MuiSvgIcon', slot);
}
const $7ce12a563a5386d0$var$svgIconClasses = (0, $7ce12a563a5386d0$var$_generateUtilityClasses.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $7ce12a563a5386d0$var$_default = module.exports.default = $7ce12a563a5386d0$var$svgIconClasses;

});




parcelRegister("6J83I", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $4e5d325d11002757$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4e5d325d11002757$var$_debounce = $4e5d325d11002757$require$_interopRequireDefault((parcelRequire("4aHRm")));
var $4e5d325d11002757$var$_default = module.exports.default = $4e5d325d11002757$var$_debounce.default;

});
parcelRegister("4aHRm", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $309a1e383c48f3af$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $309a1e383c48f3af$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $309a1e383c48f3af$var$_debounce.default;
    }
});

var $309a1e383c48f3af$var$_debounce = $309a1e383c48f3af$require$_interopRequireWildcard((parcelRequire("eeeqA")));
Object.keys($309a1e383c48f3af$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($309a1e383c48f3af$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $309a1e383c48f3af$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $309a1e383c48f3af$var$_debounce[key];
        }
    });
});

});
parcelRegister("eeeqA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a5bd90887596d7d8$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $a5bd90887596d7d8$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});



parcelRegister("fu1hI", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b45aa778d89cc9fc$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b45aa778d89cc9fc$var$_deprecatedPropType = $b45aa778d89cc9fc$require$_interopRequireDefault((parcelRequire("jhuth")));
var $b45aa778d89cc9fc$var$_default = module.exports.default = $b45aa778d89cc9fc$var$_deprecatedPropType.default;

});
parcelRegister("jhuth", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e0973dd0957be1be$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e0973dd0957be1be$var$_deprecatedPropType.default;
    }
});

var $e0973dd0957be1be$var$_deprecatedPropType = $e0973dd0957be1be$require$_interopRequireDefault((parcelRequire("lqC9i")));

});
parcelRegister("lqC9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9999e3e42d339a1$var$deprecatedPropType;
function $f9999e3e42d339a1$var$deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

});



parcelRegister("h5TfC", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c71dc2fb1cc81c04$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c71dc2fb1cc81c04$var$_isMuiElement = $c71dc2fb1cc81c04$require$_interopRequireDefault((parcelRequire("dhro8")));
var $c71dc2fb1cc81c04$var$_default = module.exports.default = $c71dc2fb1cc81c04$var$_isMuiElement.default;

});
parcelRegister("dhro8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9ab21ba1fd93b567$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ab21ba1fd93b567$var$_isMuiElement.default;
    }
});

var $9ab21ba1fd93b567$var$_isMuiElement = $9ab21ba1fd93b567$require$_interopRequireDefault((parcelRequire("8Vjlg")));

});
parcelRegister("8Vjlg", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $67f2a684794b2bf6$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67f2a684794b2bf6$var$isMuiElement;

var $67f2a684794b2bf6$var$React = $67f2a684794b2bf6$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $67f2a684794b2bf6$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $67f2a684794b2bf6$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});



parcelRegister("iCkwV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d8dbb36f924d38fc$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8dbb36f924d38fc$var$_ownerDocument = $d8dbb36f924d38fc$require$_interopRequireDefault((parcelRequire("cZzr8")));
var $d8dbb36f924d38fc$var$_default = module.exports.default = $d8dbb36f924d38fc$var$_ownerDocument.default;

});
parcelRegister("cZzr8", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9756ab89623dca63$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9756ab89623dca63$var$_ownerDocument.default;
    }
});

var $9756ab89623dca63$var$_ownerDocument = $9756ab89623dca63$require$_interopRequireDefault((parcelRequire("eVbdR")));

});
parcelRegister("eVbdR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adcf1821f6c6bd31$var$ownerDocument;
function $adcf1821f6c6bd31$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("kTXfr", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f376e71e2fcd348d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f376e71e2fcd348d$var$_ownerWindow = $f376e71e2fcd348d$require$_interopRequireDefault((parcelRequire("dJ518")));
var $f376e71e2fcd348d$var$_default = module.exports.default = $f376e71e2fcd348d$var$_ownerWindow.default;

});
parcelRegister("dJ518", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9fe35eabc2bed473$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9fe35eabc2bed473$var$_ownerWindow.default;
    }
});

var $9fe35eabc2bed473$var$_ownerWindow = $9fe35eabc2bed473$require$_interopRequireDefault((parcelRequire("2SfzQ")));

});
parcelRegister("2SfzQ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $217cb5335251aabf$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $217cb5335251aabf$var$ownerWindow;

var $217cb5335251aabf$var$_ownerDocument = $217cb5335251aabf$require$_interopRequireDefault((parcelRequire("cZzr8")));
function $217cb5335251aabf$var$ownerWindow(node) {
    const doc = (0, $217cb5335251aabf$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});



parcelRegister("1KSOa", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $14749a0ef1ee513f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14749a0ef1ee513f$var$_requirePropFactory = $14749a0ef1ee513f$require$_interopRequireDefault((parcelRequire("hKd8N")));
var $14749a0ef1ee513f$var$_default = module.exports.default = $14749a0ef1ee513f$var$_requirePropFactory.default;

});
parcelRegister("hKd8N", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ceb0ed089c4b7843$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ceb0ed089c4b7843$var$_requirePropFactory.default;
    }
});

var $ceb0ed089c4b7843$var$_requirePropFactory = $ceb0ed089c4b7843$require$_interopRequireDefault((parcelRequire("eUqFj")));

});
parcelRegister("eUqFj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adaaface2eaf896d$var$requirePropFactory;
function $adaaface2eaf896d$var$requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

});



parcelRegister("1qmej", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $109976853790570b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $109976853790570b$var$_setRef = $109976853790570b$require$_interopRequireDefault((parcelRequire("7W32S")));
var $109976853790570b$var$_default = module.exports.default = $109976853790570b$var$_setRef.default;

});
parcelRegister("7W32S", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5c704fec5afb7364$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5c704fec5afb7364$var$_setRef.default;
    }
});

var $5c704fec5afb7364$var$_setRef = $5c704fec5afb7364$require$_interopRequireDefault((parcelRequire("2BH8w")));

});
parcelRegister("2BH8w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1e607f7c9ff280be$var$setRef;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $1e607f7c9ff280be$var$setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("lHdPe", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $fcb8568ec05016ed$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fcb8568ec05016ed$var$_useEnhancedEffect = $fcb8568ec05016ed$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $fcb8568ec05016ed$var$_default = module.exports.default = $fcb8568ec05016ed$var$_useEnhancedEffect.default;

});

parcelRegister("ieBsi", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d46696a3c21050bd$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d46696a3c21050bd$var$_useId = $d46696a3c21050bd$require$_interopRequireDefault((parcelRequire("BEaqK")));
var $d46696a3c21050bd$var$_default = module.exports.default = $d46696a3c21050bd$var$_useId.default;

});
parcelRegister("BEaqK", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $07129d310f60d476$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $07129d310f60d476$var$_useId.default;
    }
});

var $07129d310f60d476$var$_useId = $07129d310f60d476$require$_interopRequireDefault((parcelRequire("jERCH")));

});
parcelRegister("jERCH", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $e4fb592ff0088479$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4fb592ff0088479$var$useId;

var $e4fb592ff0088479$var$React = $e4fb592ff0088479$require$_interopRequireWildcard((parcelRequire("8nGP5")));
let $e4fb592ff0088479$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $e4fb592ff0088479$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $e4fb592ff0088479$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $e4fb592ff0088479$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $e4fb592ff0088479$var$globalId += 1;
            setDefaultId(`mui-${$e4fb592ff0088479$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $e4fb592ff0088479$var$safeReact = {
    ...$e4fb592ff0088479$var$React
};
const $e4fb592ff0088479$var$maybeReactUseId = $e4fb592ff0088479$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $e4fb592ff0088479$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($e4fb592ff0088479$var$maybeReactUseId !== undefined) {
        const reactId = $e4fb592ff0088479$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $e4fb592ff0088479$var$useGlobalId(idOverride);
}

});



parcelRegister("gySrk", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c0ea0cea2c65d3e2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c0ea0cea2c65d3e2$var$_unsupportedProp = $c0ea0cea2c65d3e2$require$_interopRequireDefault((parcelRequire("lalIu")));
var $c0ea0cea2c65d3e2$var$_default = module.exports.default = $c0ea0cea2c65d3e2$var$_unsupportedProp.default;

});

parcelRegister("dq2aN", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $9c4f63a18f458334$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c4f63a18f458334$var$_useControlled = $9c4f63a18f458334$require$_interopRequireDefault((parcelRequire("fvGy1")));
var $9c4f63a18f458334$var$_default = module.exports.default = $9c4f63a18f458334$var$_useControlled.default;

});
parcelRegister("fvGy1", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $b4aac15733addaa3$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b4aac15733addaa3$var$_useControlled.default;
    }
});

var $b4aac15733addaa3$var$_useControlled = $b4aac15733addaa3$require$_interopRequireDefault((parcelRequire("bWnqg")));

});
parcelRegister("bWnqg", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $8b1747bfa7d60961$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b1747bfa7d60961$var$useControlled;

var $8b1747bfa7d60961$var$React = $8b1747bfa7d60961$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $8b1747bfa7d60961$var$useControlled({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8b1747bfa7d60961$var$React.useRef(controlled !== undefined);
    const [valueState, setValue] = $8b1747bfa7d60961$var$React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $8b1747bfa7d60961$var$React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});



parcelRegister("iCguj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d8d890c0a648dbb1$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8d890c0a648dbb1$var$_useEventCallback = $d8d890c0a648dbb1$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $d8d890c0a648dbb1$var$_default = module.exports.default = $d8d890c0a648dbb1$var$_useEventCallback.default;

});

parcelRegister("bXPOA", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8b5d65be2efe368f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b5d65be2efe368f$var$_useForkRef = $8b5d65be2efe368f$require$_interopRequireDefault((parcelRequire("7uWLa")));
var $8b5d65be2efe368f$var$_default = module.exports.default = $8b5d65be2efe368f$var$_useForkRef.default;

});

parcelRegister("7R9oI", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $5b84c5d165e5ee12$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b84c5d165e5ee12$var$mergeSlotProps;

var $5b84c5d165e5ee12$var$_clsx = $5b84c5d165e5ee12$require$_interopRequireDefault((parcelRequire("ajIhI")));
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $5b84c5d165e5ee12$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $5b84c5d165e5ee12$var$mergeSlotProps(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($5b84c5d165e5ee12$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $5b84c5d165e5ee12$var$_clsx.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $5b84c5d165e5ee12$var$_clsx.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});


parcelRegister("eIMYG", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $ab7b2abaff19d6d2$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCollapseUtilityClass = $ab7b2abaff19d6d2$var$getCollapseUtilityClass;

var $ab7b2abaff19d6d2$var$_generateUtilityClasses = $ab7b2abaff19d6d2$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $ab7b2abaff19d6d2$var$_generateUtilityClass = $ab7b2abaff19d6d2$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $ab7b2abaff19d6d2$var$getCollapseUtilityClass(slot) {
    return (0, $ab7b2abaff19d6d2$var$_generateUtilityClass.default)('MuiCollapse', slot);
}
const $ab7b2abaff19d6d2$var$collapseClasses = (0, $ab7b2abaff19d6d2$var$_generateUtilityClasses.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $ab7b2abaff19d6d2$var$_default = module.exports.default = $ab7b2abaff19d6d2$var$collapseClasses;

});


parcelRegister("iFtbQ", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $d972b2da1ff71212$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $d972b2da1ff71212$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d972b2da1ff71212$var$React = $d972b2da1ff71212$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $d972b2da1ff71212$var$_propTypes = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $d972b2da1ff71212$var$_clsx = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $d972b2da1ff71212$var$_composeClasses = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("4F19u")));

var $lvExz = parcelRequire("lvExz");

var $d972b2da1ff71212$var$_SwitchBase = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("chXFs")));

var $d972b2da1ff71212$var$_CheckBoxOutlineBlank = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("351F9")));

var $d972b2da1ff71212$var$_CheckBox = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("6LsKR")));

var $d972b2da1ff71212$var$_IndeterminateCheckBox = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("eiJ8Z")));

var $d972b2da1ff71212$var$_capitalize = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("f1lQv")));

var $d972b2da1ff71212$var$_rootShouldForwardProp = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("6ed1m")));

var $d972b2da1ff71212$var$_checkboxClasses = $d972b2da1ff71212$require$_interopRequireWildcard((parcelRequire("gvoLb")));

var $fS2VA = parcelRequire("fS2VA");

var $d972b2da1ff71212$var$_memoTheme = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("jBs89")));

var $d972b2da1ff71212$var$_createSimplePaletteValueFilter = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("fl59C")));

var $baZPJ = parcelRequire("baZPJ");

var $ftvpK = parcelRequire("ftvpK");

var $d972b2da1ff71212$var$_useSlot = $d972b2da1ff71212$require$_interopRequireDefault((parcelRequire("axU6z")));

var $kSbwP = parcelRequire("kSbwP");
const $d972b2da1ff71212$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $d972b2da1ff71212$var$_capitalize.default)(color)}`,
            `size${(0, $d972b2da1ff71212$var$_capitalize.default)(size)}`
        ]
    };
    const composedClasses = (0, $d972b2da1ff71212$var$_composeClasses.default)(slots, $d972b2da1ff71212$var$_checkboxClasses.getCheckboxUtilityClass, classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $d972b2da1ff71212$var$CheckboxRoot = (0, $fS2VA.styled)($d972b2da1ff71212$var$_SwitchBase.default, {
    shouldForwardProp: (prop)=>(0, $d972b2da1ff71212$var$_rootShouldForwardProp.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $d972b2da1ff71212$var$_capitalize.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $d972b2da1ff71212$var$_capitalize.default)(ownerState.color)}`]
        ];
    }
})((0, $d972b2da1ff71212$var$_memoTheme.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $lvExz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $d972b2da1ff71212$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $lvExz.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $d972b2da1ff71212$var$_createSimplePaletteValueFilter.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${$d972b2da1ff71212$var$_checkboxClasses.default.checked}, &.${$d972b2da1ff71212$var$_checkboxClasses.default.indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${$d972b2da1ff71212$var$_checkboxClasses.default.disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $d972b2da1ff71212$var$defaultCheckedIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($d972b2da1ff71212$var$_CheckBox.default, {});
const $d972b2da1ff71212$var$defaultIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($d972b2da1ff71212$var$_CheckBoxOutlineBlank.default, {});
const $d972b2da1ff71212$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $kSbwP.jsx)($d972b2da1ff71212$var$_IndeterminateCheckBox.default, {});
const $d972b2da1ff71212$var$Checkbox = /*#__PURE__*/ $d972b2da1ff71212$var$React.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $d972b2da1ff71212$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $d972b2da1ff71212$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $d972b2da1ff71212$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $d972b2da1ff71212$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $d972b2da1ff71212$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $d972b2da1ff71212$var$CheckboxRoot,
        className: (0, $d972b2da1ff71212$var$_clsx.default)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $d972b2da1ff71212$var$React.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $d972b2da1ff71212$var$React.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $ftvpK.mergeSlotProps)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $d972b2da1ff71212$var$_default = module.exports.default = $d972b2da1ff71212$var$Checkbox;

});
parcelRegister("chXFs", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8f255b57b9ed7a0e$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $8f255b57b9ed7a0e$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f255b57b9ed7a0e$var$React = $8f255b57b9ed7a0e$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8f255b57b9ed7a0e$var$_propTypes = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $8f255b57b9ed7a0e$var$_refType = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("e4lJB")));

var $8f255b57b9ed7a0e$var$_composeClasses = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("4F19u")));

var $8f255b57b9ed7a0e$var$_capitalize = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("f1lQv")));

var $8f255b57b9ed7a0e$var$_rootShouldForwardProp = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("6ed1m")));

var $fS2VA = parcelRequire("fS2VA");

var $8f255b57b9ed7a0e$var$_useControlled = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("dq2aN")));

var $8f255b57b9ed7a0e$var$_useFormControl = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("evoBS")));

var $8f255b57b9ed7a0e$var$_ButtonBase = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("2HveK")));

var $cHs0Y = parcelRequire("cHs0Y");

var $8f255b57b9ed7a0e$var$_useSlot = $8f255b57b9ed7a0e$require$_interopRequireDefault((parcelRequire("axU6z")));

var $kSbwP = parcelRequire("kSbwP");
const $8f255b57b9ed7a0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $8f255b57b9ed7a0e$var$_capitalize.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8f255b57b9ed7a0e$var$_composeClasses.default)(slots, $cHs0Y.getSwitchBaseUtilityClass, classes);
};
const $8f255b57b9ed7a0e$var$SwitchBaseRoot = (0, $fS2VA.styled)($8f255b57b9ed7a0e$var$_ButtonBase.default)({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $8f255b57b9ed7a0e$var$SwitchBaseInput = (0, $fS2VA.styled)('input', {
    shouldForwardProp: $8f255b57b9ed7a0e$var$_rootShouldForwardProp.default
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $8f255b57b9ed7a0e$var$SwitchBase = /*#__PURE__*/ $8f255b57b9ed7a0e$var$React.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $8f255b57b9ed7a0e$var$_useControlled.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $8f255b57b9ed7a0e$var$_useFormControl.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $8f255b57b9ed7a0e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $8f255b57b9ed7a0e$var$_useSlot.default)('root', {
        ref: ref,
        elementType: $8f255b57b9ed7a0e$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $8f255b57b9ed7a0e$var$_useSlot.default)('input', {
        ref: inputRef,
        elementType: $8f255b57b9ed7a0e$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $kSbwP.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $8f255b57b9ed7a0e$var$_default = module.exports.default = $8f255b57b9ed7a0e$var$SwitchBase;

});
parcelRegister("e4lJB", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $a3e24c6c8e984729$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e24c6c8e984729$var$_refType.default;
    }
});

var $a3e24c6c8e984729$var$_refType = $a3e24c6c8e984729$require$_interopRequireDefault((parcelRequire("h22aM")));

});
parcelRegister("h22aM", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c6644f156dd99f9d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6644f156dd99f9d$var$_propTypes = $c6644f156dd99f9d$require$_interopRequireDefault((parcelRequire("ebCsu")));
const $c6644f156dd99f9d$var$refType = $c6644f156dd99f9d$var$_propTypes.default.oneOfType([
    $c6644f156dd99f9d$var$_propTypes.default.func,
    $c6644f156dd99f9d$var$_propTypes.default.object
]);
var $c6644f156dd99f9d$var$_default = module.exports.default = $c6644f156dd99f9d$var$refType;

});


parcelRegister("evoBS", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a8f70cf8e932f1d8$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $a8f70cf8e932f1d8$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8f70cf8e932f1d8$var$useFormControl;

var $a8f70cf8e932f1d8$var$React = $a8f70cf8e932f1d8$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $a8f70cf8e932f1d8$var$_FormControlContext = $a8f70cf8e932f1d8$require$_interopRequireDefault((parcelRequire("aXy5t")));
function $a8f70cf8e932f1d8$var$useFormControl() {
    return $a8f70cf8e932f1d8$var$React.useContext($a8f70cf8e932f1d8$var$_FormControlContext.default);
}

});
parcelRegister("aXy5t", function(module, exports) {
"use strict";
'use client';

var $1RopH = parcelRequire("1RopH");
var $7fa9db121536d816$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fa9db121536d816$var$React = $7fa9db121536d816$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $7fa9db121536d816$var$FormControlContext = /*#__PURE__*/ $7fa9db121536d816$var$React.createContext(undefined);
var $7fa9db121536d816$var$_default = module.exports.default = $7fa9db121536d816$var$FormControlContext;

});


parcelRegister("2HveK", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $1f77d3e8e06f0676$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $1f77d3e8e06f0676$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1f77d3e8e06f0676$var$_exportNames = {
    buttonBaseClasses: true,
    touchRippleClasses: true
};
Object.defineProperty(module.exports, "buttonBaseClasses", {
    enumerable: true,
    get: function() {
        return $1f77d3e8e06f0676$var$_buttonBaseClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1f77d3e8e06f0676$var$_ButtonBase.default;
    }
});
Object.defineProperty(module.exports, "touchRippleClasses", {
    enumerable: true,
    get: function() {
        return $1f77d3e8e06f0676$var$_touchRippleClasses.default;
    }
});

var $1f77d3e8e06f0676$var$_ButtonBase = $1f77d3e8e06f0676$require$_interopRequireDefault((parcelRequire("fe9Sj")));

var $1f77d3e8e06f0676$var$_buttonBaseClasses = $1f77d3e8e06f0676$require$_interopRequireWildcard((parcelRequire("5fiZT")));
Object.keys($1f77d3e8e06f0676$var$_buttonBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1f77d3e8e06f0676$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1f77d3e8e06f0676$var$_buttonBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1f77d3e8e06f0676$var$_buttonBaseClasses[key];
        }
    });
});

var $1f77d3e8e06f0676$var$_touchRippleClasses = $1f77d3e8e06f0676$require$_interopRequireWildcard((parcelRequire("bqcto")));
Object.keys($1f77d3e8e06f0676$var$_touchRippleClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($1f77d3e8e06f0676$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1f77d3e8e06f0676$var$_touchRippleClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1f77d3e8e06f0676$var$_touchRippleClasses[key];
        }
    });
});

});
parcelRegister("fe9Sj", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $b15fd2c6f91b42e9$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $b15fd2c6f91b42e9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ButtonBaseRoot = void 0;

var $b15fd2c6f91b42e9$var$React = $b15fd2c6f91b42e9$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $b15fd2c6f91b42e9$var$_propTypes = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $b15fd2c6f91b42e9$var$_clsx = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $b15fd2c6f91b42e9$var$_refType = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("e4lJB")));

var $b15fd2c6f91b42e9$var$_elementTypeAcceptingRef = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("5kQCz")));

var $b15fd2c6f91b42e9$var$_composeClasses = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("4F19u")));

var $b15fd2c6f91b42e9$var$_isFocusVisible = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("jLOre")));

var $fS2VA = parcelRequire("fS2VA");

var $baZPJ = parcelRequire("baZPJ");

var $b15fd2c6f91b42e9$var$_useForkRef = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("bXPOA")));

var $b15fd2c6f91b42e9$var$_useEventCallback = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("iCguj")));

var $b15fd2c6f91b42e9$var$_useLazyRipple = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("9oeLh")));

var $b15fd2c6f91b42e9$var$_TouchRipple = $b15fd2c6f91b42e9$require$_interopRequireDefault((parcelRequire("7BFOG")));

var $b15fd2c6f91b42e9$var$_buttonBaseClasses = $b15fd2c6f91b42e9$require$_interopRequireWildcard((parcelRequire("5fiZT")));

var $kSbwP = parcelRequire("kSbwP");
const $b15fd2c6f91b42e9$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $b15fd2c6f91b42e9$var$_composeClasses.default)(slots, $b15fd2c6f91b42e9$var$_buttonBaseClasses.getButtonBaseUtilityClass, classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $b15fd2c6f91b42e9$var$ButtonBaseRoot = module.exports.ButtonBaseRoot = (0, $fS2VA.styled)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${$b15fd2c6f91b42e9$var$_buttonBaseClasses.default.disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $b15fd2c6f91b42e9$var$ButtonBase = /*#__PURE__*/ $b15fd2c6f91b42e9$var$React.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $b15fd2c6f91b42e9$var$React.useRef(null);
    const ripple = (0, $b15fd2c6f91b42e9$var$_useLazyRipple.default)();
    const handleRippleRef = (0, $b15fd2c6f91b42e9$var$_useForkRef.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $b15fd2c6f91b42e9$var$React.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $b15fd2c6f91b42e9$var$React.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $b15fd2c6f91b42e9$var$React.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $b15fd2c6f91b42e9$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $b15fd2c6f91b42e9$var$_isFocusVisible.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $b15fd2c6f91b42e9$var$_useEventCallback.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $b15fd2c6f91b42e9$var$_isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $b15fd2c6f91b42e9$var$_useEventCallback.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $b15fd2c6f91b42e9$var$_useEventCallback.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $b15fd2c6f91b42e9$var$_useForkRef.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $b15fd2c6f91b42e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $kSbwP.jsxs)($b15fd2c6f91b42e9$var$ButtonBaseRoot, {
        as: ComponentProp,
        className: (0, $b15fd2c6f91b42e9$var$_clsx.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $kSbwP.jsx)($b15fd2c6f91b42e9$var$_TouchRipple.default, {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $b15fd2c6f91b42e9$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $b15fd2c6f91b42e9$var$_useEventCallback.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $b15fd2c6f91b42e9$var$_default = module.exports.default = $b15fd2c6f91b42e9$var$ButtonBase;

});
parcelRegister("jLOre", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $e649881af75aa788$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e649881af75aa788$var$_isFocusVisible.default;
    }
});

var $e649881af75aa788$var$_isFocusVisible = $e649881af75aa788$require$_interopRequireDefault((parcelRequire("jZAvu")));

});
parcelRegister("jZAvu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8e008581ed2c035$var$isFocusVisible;
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $e8e008581ed2c035$var$isFocusVisible(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});


parcelRegister("9oeLh", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $6d61ce4705c52e3a$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d61ce4705c52e3a$var$_useLazyRipple.default;
    }
});

var $6d61ce4705c52e3a$var$_useLazyRipple = $6d61ce4705c52e3a$require$_interopRequireDefault((parcelRequire("ccVVw")));

});
parcelRegister("ccVVw", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $8e338a1046d71df6$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $8e338a1046d71df6$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LazyRipple = void 0;
module.exports.default = $8e338a1046d71df6$var$useLazyRipple;

var $8e338a1046d71df6$var$React = $8e338a1046d71df6$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8e338a1046d71df6$var$_useLazyRef = $8e338a1046d71df6$require$_interopRequireDefault((parcelRequire("3MjpJ")));
/**
 * Lazy initialization container for the Ripple instance. This improves
 * performance by delaying mounting the ripple until it's needed.
 */ class $8e338a1046d71df6$var$LazyRipple {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $8e338a1046d71df6$var$LazyRipple();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $8e338a1046d71df6$var$_useLazyRef.default)($8e338a1046d71df6$var$LazyRipple.create).current;
        const [shouldMount, setShouldMount] = $8e338a1046d71df6$var$React.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $8e338a1046d71df6$var$React.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $8e338a1046d71df6$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
module.exports.LazyRipple = $8e338a1046d71df6$var$LazyRipple;
function $8e338a1046d71df6$var$useLazyRipple() {
    return $8e338a1046d71df6$var$LazyRipple.use();
}
function $8e338a1046d71df6$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("3MjpJ", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2c04ea08bc684ff8$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2c04ea08bc684ff8$var$_useLazyRef.default;
    }
});

var $2c04ea08bc684ff8$var$_useLazyRef = $2c04ea08bc684ff8$require$_interopRequireDefault((parcelRequire("587f9")));

});



parcelRegister("7BFOG", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $589c6cff4a5dc452$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $589c6cff4a5dc452$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.TouchRippleRoot = module.exports.TouchRippleRipple = module.exports.DELAY_RIPPLE = void 0;

var $589c6cff4a5dc452$var$React = $589c6cff4a5dc452$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $589c6cff4a5dc452$var$_propTypes = $589c6cff4a5dc452$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $eM6bp = parcelRequire("eM6bp");

var $589c6cff4a5dc452$var$_clsx = $589c6cff4a5dc452$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $589c6cff4a5dc452$var$_useTimeout = $589c6cff4a5dc452$require$_interopRequireDefault((parcelRequire("kuuLw")));

var $fS2VA = parcelRequire("fS2VA");

var $baZPJ = parcelRequire("baZPJ");

var $589c6cff4a5dc452$var$_Ripple = $589c6cff4a5dc452$require$_interopRequireDefault((parcelRequire("5SiWB")));

var $589c6cff4a5dc452$var$_touchRippleClasses = $589c6cff4a5dc452$require$_interopRequireDefault((parcelRequire("bqcto")));

var $kSbwP = parcelRequire("kSbwP");
const $589c6cff4a5dc452$var$DURATION = 550;
const $589c6cff4a5dc452$var$DELAY_RIPPLE = module.exports.DELAY_RIPPLE = 80;
const $589c6cff4a5dc452$var$enterKeyframe = (0, $fS2VA.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $589c6cff4a5dc452$var$exitKeyframe = (0, $fS2VA.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $589c6cff4a5dc452$var$pulsateKeyframe = (0, $fS2VA.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $589c6cff4a5dc452$var$TouchRippleRoot = module.exports.TouchRippleRoot = (0, $fS2VA.styled)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $589c6cff4a5dc452$var$TouchRippleRipple = module.exports.TouchRippleRipple = (0, $fS2VA.styled)($589c6cff4a5dc452$var$_Ripple.default, {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${$589c6cff4a5dc452$var$_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$589c6cff4a5dc452$var$enterKeyframe};
    animation-duration: ${$589c6cff4a5dc452$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${$589c6cff4a5dc452$var$_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${$589c6cff4a5dc452$var$_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${$589c6cff4a5dc452$var$_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${$589c6cff4a5dc452$var$exitKeyframe};
    animation-duration: ${$589c6cff4a5dc452$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${$589c6cff4a5dc452$var$_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$589c6cff4a5dc452$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $589c6cff4a5dc452$var$TouchRipple = /*#__PURE__*/ $589c6cff4a5dc452$var$React.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $baZPJ.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $589c6cff4a5dc452$var$React.useState([]);
    const nextKey = $589c6cff4a5dc452$var$React.useRef(0);
    const rippleCallback = $589c6cff4a5dc452$var$React.useRef(null);
    $589c6cff4a5dc452$var$React.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $589c6cff4a5dc452$var$React.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $589c6cff4a5dc452$var$_useTimeout.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $589c6cff4a5dc452$var$React.useRef(null);
    const container = $589c6cff4a5dc452$var$React.useRef(null);
    const startCommit = $589c6cff4a5dc452$var$React.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $kSbwP.jsx)($589c6cff4a5dc452$var$TouchRippleRipple, {
                    classes: {
                        ripple: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.ripple, $589c6cff4a5dc452$var$_touchRippleClasses.default.ripple),
                        rippleVisible: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.rippleVisible, $589c6cff4a5dc452$var$_touchRippleClasses.default.rippleVisible),
                        ripplePulsate: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.ripplePulsate, $589c6cff4a5dc452$var$_touchRippleClasses.default.ripplePulsate),
                        child: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.child, $589c6cff4a5dc452$var$_touchRippleClasses.default.child),
                        childLeaving: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.childLeaving, $589c6cff4a5dc452$var$_touchRippleClasses.default.childLeaving),
                        childPulsate: (0, $589c6cff4a5dc452$var$_clsx.default)(classes.childPulsate, $589c6cff4a5dc452$var$_touchRippleClasses.default.childPulsate)
                    },
                    timeout: $589c6cff4a5dc452$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $589c6cff4a5dc452$var$React.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($589c6cff4a5dc452$var$DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $589c6cff4a5dc452$var$React.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $589c6cff4a5dc452$var$React.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $589c6cff4a5dc452$var$React.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($589c6cff4a5dc452$var$TouchRippleRoot, {
        className: (0, $589c6cff4a5dc452$var$_clsx.default)($589c6cff4a5dc452$var$_touchRippleClasses.default.root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($eM6bp.default, {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $589c6cff4a5dc452$var$_default = module.exports.default = $589c6cff4a5dc452$var$TouchRipple;

});
parcelRegister("eM6bp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1a5836cf11df1b$export$2e2bcd8739ae039; });

var $8D9Xw = parcelRequire("8D9Xw");

var $1TGTA = parcelRequire("1TGTA");

var $l5AdR = parcelRequire("l5AdR");

var $79bU5 = parcelRequire("79bU5");


var $8nGP5 = parcelRequire("8nGP5");

var $bTuph = parcelRequire("bTuph");

var $fWYEj = parcelRequire("fWYEj");
var $ac1a5836cf11df1b$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $ac1a5836cf11df1b$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $ac1a5836cf11df1b$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $79bU5.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $l5AdR.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $fWYEj.getInitialChildMapping)(nextProps, handleExited) : (0, $fWYEj.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $fWYEj.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $1TGTA.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $8D9Xw.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $ac1a5836cf11df1b$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $bTuph.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $bTuph.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$ac1a5836cf11df1b$var$TransitionGroup.propTypes = {};
$ac1a5836cf11df1b$var$TransitionGroup.defaultProps = $ac1a5836cf11df1b$var$defaultProps;
var $ac1a5836cf11df1b$export$2e2bcd8739ae039 = $ac1a5836cf11df1b$var$TransitionGroup;

});
parcelRegister("l5AdR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5a629a998bf01e6$export$2e2bcd8739ae039; });
function $f5a629a998bf01e6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("fWYEj", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $b9cb5176c433b096$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $b9cb5176c433b096$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $b9cb5176c433b096$export$36fd1af28d383ec0; });

var $8nGP5 = parcelRequire("8nGP5");
function $b9cb5176c433b096$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8nGP5.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8nGP5.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $b9cb5176c433b096$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $b9cb5176c433b096$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $b9cb5176c433b096$export$fa71e2345c31d7a2(props, onExited) {
    return $b9cb5176c433b096$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $b9cb5176c433b096$var$getProp(child, 'appear', props),
            enter: $b9cb5176c433b096$var$getProp(child, 'enter', props),
            exit: $b9cb5176c433b096$var$getProp(child, 'exit', props)
        });
    });
}
function $b9cb5176c433b096$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $b9cb5176c433b096$export$bbc8a025727ea824(nextProps.children);
    var children = $b9cb5176c433b096$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8nGP5.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8nGP5.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $b9cb5176c433b096$var$getProp(child, 'exit', nextProps),
            enter: $b9cb5176c433b096$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8nGP5.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8nGP5.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $b9cb5176c433b096$var$getProp(child, 'exit', nextProps),
            enter: $b9cb5176c433b096$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("5SiWB", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $4470b0cf684993ba$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $4470b0cf684993ba$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4470b0cf684993ba$var$React = $4470b0cf684993ba$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $4470b0cf684993ba$var$_propTypes = $4470b0cf684993ba$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $4470b0cf684993ba$var$_clsx = $4470b0cf684993ba$require$_interopRequireDefault((parcelRequire("ajIhI")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ function $4470b0cf684993ba$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $4470b0cf684993ba$var$React.useState(false);
    const rippleClassName = (0, $4470b0cf684993ba$var$_clsx.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $4470b0cf684993ba$var$_clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $4470b0cf684993ba$var$React.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("span", {
            className: childClassName
        })
    });
}
var $4470b0cf684993ba$var$_default = module.exports.default = $4470b0cf684993ba$var$Ripple;

});

parcelRegister("bqcto", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $850bcc53d14ccd55$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getTouchRippleUtilityClass = $850bcc53d14ccd55$var$getTouchRippleUtilityClass;

var $850bcc53d14ccd55$var$_generateUtilityClasses = $850bcc53d14ccd55$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $850bcc53d14ccd55$var$_generateUtilityClass = $850bcc53d14ccd55$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $850bcc53d14ccd55$var$getTouchRippleUtilityClass(slot) {
    return (0, $850bcc53d14ccd55$var$_generateUtilityClass.default)('MuiTouchRipple', slot);
}
const $850bcc53d14ccd55$var$touchRippleClasses = (0, $850bcc53d14ccd55$var$_generateUtilityClasses.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $850bcc53d14ccd55$var$_default = module.exports.default = $850bcc53d14ccd55$var$touchRippleClasses;

});


parcelRegister("5fiZT", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3d1d16ea7de8ad28$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getButtonBaseUtilityClass = $3d1d16ea7de8ad28$var$getButtonBaseUtilityClass;

var $3d1d16ea7de8ad28$var$_generateUtilityClasses = $3d1d16ea7de8ad28$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $3d1d16ea7de8ad28$var$_generateUtilityClass = $3d1d16ea7de8ad28$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $3d1d16ea7de8ad28$var$getButtonBaseUtilityClass(slot) {
    return (0, $3d1d16ea7de8ad28$var$_generateUtilityClass.default)('MuiButtonBase', slot);
}
const $3d1d16ea7de8ad28$var$buttonBaseClasses = (0, $3d1d16ea7de8ad28$var$_generateUtilityClasses.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $3d1d16ea7de8ad28$var$_default = module.exports.default = $3d1d16ea7de8ad28$var$buttonBaseClasses;

});



parcelRegister("cHs0Y", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $93ef3b54ef3627dc$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSwitchBaseUtilityClass = $93ef3b54ef3627dc$var$getSwitchBaseUtilityClass;

var $93ef3b54ef3627dc$var$_generateUtilityClasses = $93ef3b54ef3627dc$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $93ef3b54ef3627dc$var$_generateUtilityClass = $93ef3b54ef3627dc$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $93ef3b54ef3627dc$var$getSwitchBaseUtilityClass(slot) {
    return (0, $93ef3b54ef3627dc$var$_generateUtilityClass.default)('PrivateSwitchBase', slot);
}
const $93ef3b54ef3627dc$var$switchBaseClasses = (0, $93ef3b54ef3627dc$var$_generateUtilityClasses.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $93ef3b54ef3627dc$var$_default = module.exports.default = $93ef3b54ef3627dc$var$switchBaseClasses;

});

parcelRegister("axU6z", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $7ad881be0d8420af$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ad881be0d8420af$var$useSlot;

var $7ad881be0d8420af$var$_useForkRef = $7ad881be0d8420af$require$_interopRequireDefault((parcelRequire("7uWLa")));

var $7ad881be0d8420af$var$_appendOwnerState = $7ad881be0d8420af$require$_interopRequireDefault((parcelRequire("1UjvS")));

var $7ad881be0d8420af$var$_resolveComponentProps = $7ad881be0d8420af$require$_interopRequireDefault((parcelRequire("iselN")));

var $7ad881be0d8420af$var$_mergeSlotProps = $7ad881be0d8420af$require$_interopRequireDefault((parcelRequire("43DfG")));
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */ function $7ad881be0d8420af$var$useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $7ad881be0d8420af$var$_resolveComponentProps.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $7ad881be0d8420af$var$_mergeSlotProps.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $7ad881be0d8420af$var$_useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $7ad881be0d8420af$var$_appendOwnerState.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});


parcelRegister("351F9", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $23e320ed8d636610$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $23e320ed8d636610$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23e320ed8d636610$var$React = $23e320ed8d636610$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $23e320ed8d636610$var$_createSvgIcon = $23e320ed8d636610$require$_interopRequireDefault((parcelRequire("6s4Ec")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $23e320ed8d636610$var$_default = module.exports.default = (0, $23e320ed8d636610$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("6LsKR", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $4ecd6ff83a6084a7$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $4ecd6ff83a6084a7$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ecd6ff83a6084a7$var$React = $4ecd6ff83a6084a7$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $4ecd6ff83a6084a7$var$_createSvgIcon = $4ecd6ff83a6084a7$require$_interopRequireDefault((parcelRequire("6s4Ec")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $4ecd6ff83a6084a7$var$_default = module.exports.default = (0, $4ecd6ff83a6084a7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("eiJ8Z", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $a695c3c594ee25d0$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $a695c3c594ee25d0$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a695c3c594ee25d0$var$React = $a695c3c594ee25d0$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $a695c3c594ee25d0$var$_createSvgIcon = $a695c3c594ee25d0$require$_interopRequireDefault((parcelRequire("6s4Ec")));

var $kSbwP = parcelRequire("kSbwP");
/**
 * @ignore - internal component.
 */ var $a695c3c594ee25d0$var$_default = module.exports.default = (0, $a695c3c594ee25d0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("gvoLb", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c042bf69a5c9a644$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCheckboxUtilityClass = $c042bf69a5c9a644$var$getCheckboxUtilityClass;

var $c042bf69a5c9a644$var$_generateUtilityClasses = $c042bf69a5c9a644$require$_interopRequireDefault((parcelRequire("4bI4C")));

var $c042bf69a5c9a644$var$_generateUtilityClass = $c042bf69a5c9a644$require$_interopRequireDefault((parcelRequire("4E9MM")));
function $c042bf69a5c9a644$var$getCheckboxUtilityClass(slot) {
    return (0, $c042bf69a5c9a644$var$_generateUtilityClass.default)('MuiCheckbox', slot);
}
const $c042bf69a5c9a644$var$checkboxClasses = (0, $c042bf69a5c9a644$var$_generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $c042bf69a5c9a644$var$_default = module.exports.default = $c042bf69a5c9a644$var$checkboxClasses;

});


parcelRegister("akQDf", function(module, exports) {
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $7864994658d52c0e$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6iaGL = parcelRequire("6iaGL");

var $7864994658d52c0e$var$_propTypes = $7864994658d52c0e$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $7RQEl = parcelRequire("7RQEl");

var $6NVMl = parcelRequire("6NVMl");

var $7864994658d52c0e$var$_identifier = $7864994658d52c0e$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $7864994658d52c0e$var$_boxClasses = $7864994658d52c0e$require$_interopRequireDefault((parcelRequire("6RvMV")));
const $7864994658d52c0e$var$defaultTheme = (0, $6NVMl.createTheme)();
const $7864994658d52c0e$var$Box = (0, $6iaGL.default)({
    themeId: $7864994658d52c0e$var$_identifier.default,
    defaultTheme: $7864994658d52c0e$var$defaultTheme,
    defaultClassName: $7864994658d52c0e$var$_boxClasses.default.root,
    generateClassName: $7RQEl.unstable_ClassNameGenerator.generate
});
var $7864994658d52c0e$var$_default = module.exports.default = $7864994658d52c0e$var$Box;

});
parcelRegister("6iaGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $494cb71466906396$export$2e2bcd8739ae039; });

var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $hmAfj = parcelRequire("hmAfj");

var $gqU4X = parcelRequire("gqU4X");
var $b4G2q = parcelRequire("b4G2q");

var $7fbRa = parcelRequire("7fbRa");

var $kSbwP = parcelRequire("kSbwP");
'use client';
function $494cb71466906396$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $hmAfj.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $gqU4X.default));
    const Box = /*#__PURE__*/ $8nGP5.forwardRef(function Box(inProps, ref) {
        const theme = (0, $7fbRa.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $b4G2q.default)(inProps);
        return /*#__PURE__*/ (0, $kSbwP.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $ajIhI.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("b4G2q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8100ad57ed002f08$export$2e2bcd8739ae039; });

var $cfKeZ = parcelRequire("cfKeZ");

var $3z59k = parcelRequire("3z59k");
const $8100ad57ed002f08$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $3z59k.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $8100ad57ed002f08$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $8100ad57ed002f08$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cfKeZ.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("7RQEl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_ClassNameGenerator", {
    enumerable: true,
    get: function() {
        return $8zvjb.default;
    }
});

var $8zvjb = parcelRequire("8zvjb");

});

parcelRegister("6NVMl", function(module, exports) {
"use strict";

var $1RopH = parcelRequire("1RopH");
var $4f44235196c5a096$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $4f44235196c5a096$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4f44235196c5a096$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true
};
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $k9Cmz.default;
    }
});
Object.defineProperty(module.exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_identifier.default;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_adaptV4Theme.default;
    }
});
Object.defineProperty(module.exports, "alpha", {
    enumerable: true,
    get: function() {
        return $i6ViY.alpha;
    }
});
Object.defineProperty(module.exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createColorScheme.default;
    }
});
Object.defineProperty(module.exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createStyles.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createTransitions.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bj8tp.css;
    }
});
Object.defineProperty(module.exports, "darken", {
    enumerable: true,
    get: function() {
        return $i6ViY.darken;
    }
});
Object.defineProperty(module.exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $i6ViY.decomposeColor;
    }
});
Object.defineProperty(module.exports, "duration", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createTransitions.duration;
    }
});
Object.defineProperty(module.exports, "easing", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createTransitions.easing;
    }
});
Object.defineProperty(module.exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $i6ViY.emphasize;
    }
});
Object.defineProperty(module.exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_experimental_extendTheme.default;
    }
});
module.exports.experimental_sx = $4f44235196c5a096$var$experimental_sx;
Object.defineProperty(module.exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createThemeWithVars.default;
    }
});
Object.defineProperty(module.exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $i6ViY.getContrastRatio;
    }
});
Object.defineProperty(module.exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $i6ViY.getLuminance;
    }
});
Object.defineProperty(module.exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty(module.exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $i6ViY.hexToRgb;
    }
});
Object.defineProperty(module.exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $i6ViY.hslToRgb;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bj8tp.keyframes;
    }
});
Object.defineProperty(module.exports, "lighten", {
    enumerable: true,
    get: function() {
        return $i6ViY.lighten;
    }
});
Object.defineProperty(module.exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_makeStyles.default;
    }
});
Object.defineProperty(module.exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createMixins.default;
    }
});
Object.defineProperty(module.exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createTypography.default;
    }
});
Object.defineProperty(module.exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty(module.exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $i6ViY.recomposeColor;
    }
});
Object.defineProperty(module.exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty(module.exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $i6ViY.rgbToHex;
    }
});
Object.defineProperty(module.exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $gGAVD.unstable_createBreakpoints;
    }
});
Object.defineProperty(module.exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $hMM1n.getUnit;
    }
});
Object.defineProperty(module.exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $hMM1n.toUnitless;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_withStyles.default;
    }
});
Object.defineProperty(module.exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $4f44235196c5a096$var$_withTheme.default;
    }
});

var $4f44235196c5a096$var$_formatMuiErrorMessage = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("cCZAW")));

var $4f44235196c5a096$var$_identifier = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("5TqxC")));

var $4f44235196c5a096$var$_adaptV4Theme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("2ri4z")));

var $i6ViY = parcelRequire("i6ViY");
var $bj8tp = parcelRequire("bj8tp");
var $k9Cmz = parcelRequire("k9Cmz");

var $gGAVD = parcelRequire("gGAVD");

var $4f44235196c5a096$var$_createTheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("dleIZ")));

var $4f44235196c5a096$var$_createMuiStrictModeTheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("foFPJ")));

var $4f44235196c5a096$var$_createStyles = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("cYWN6")));

var $hMM1n = parcelRequire("hMM1n");

var $4f44235196c5a096$var$_responsiveFontSizes = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("ibZiC")));

var $4f44235196c5a096$var$_createTransitions = $4f44235196c5a096$require$_interopRequireWildcard((parcelRequire("6nqwa")));

var $4f44235196c5a096$var$_createColorScheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("3lzSt")));

var $4f44235196c5a096$var$_useTheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("iG1rK")));

var $4f44235196c5a096$var$_useThemeProps = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("2qeyQ")));

var $4f44235196c5a096$var$_styled = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("j3d8S")));

var $4f44235196c5a096$var$_ThemeProvider = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("c1WwW")));

var $4f44235196c5a096$var$_makeStyles = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("5eg7s")));

var $4f44235196c5a096$var$_withStyles = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("e0rAD")));

var $4f44235196c5a096$var$_withTheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("99FyA")));

var $ghEIe = parcelRequire("ghEIe");
Object.keys($ghEIe).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4f44235196c5a096$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ghEIe[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ghEIe[key];
        }
    });
});

var $4f44235196c5a096$var$_createThemeWithVars = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("brEcu")));

var $4f44235196c5a096$var$_experimental_extendTheme = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("hAA2f")));

var $4f44235196c5a096$var$_getOverlayAlpha = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("idmqx")));

var $4f44235196c5a096$var$_shouldSkipGeneratingVar = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("hB1P1")));

var $4f44235196c5a096$var$_createTypography = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("ewxoJ")));

var $4f44235196c5a096$var$_createMixins = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("cWeFn")));

var $4f44235196c5a096$var$_excludeVariablesFromRoot = $4f44235196c5a096$require$_interopRequireDefault((parcelRequire("8Q1U9")));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $4f44235196c5a096$var$experimental_sx() {
    throw new Error((0, $4f44235196c5a096$var$_formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme

});
parcelRegister("i6ViY", function(module, exports) {

$parcel$export(module.exports, "hexToRgb", function () { return $d2f53d1a705ef361$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "decomposeColor", function () { return $d2f53d1a705ef361$export$677b39864803984e; });
$parcel$export(module.exports, "recomposeColor", function () { return $d2f53d1a705ef361$export$211a73f2b8c10ce4; });
$parcel$export(module.exports, "rgbToHex", function () { return $d2f53d1a705ef361$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hslToRgb", function () { return $d2f53d1a705ef361$export$29fb7152bd3f781a; });
$parcel$export(module.exports, "getLuminance", function () { return $d2f53d1a705ef361$export$c852d90bf7403b62; });
$parcel$export(module.exports, "getContrastRatio", function () { return $d2f53d1a705ef361$export$d061e26956a60b0a; });
$parcel$export(module.exports, "alpha", function () { return $d2f53d1a705ef361$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $d2f53d1a705ef361$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $d2f53d1a705ef361$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $d2f53d1a705ef361$export$e665714f76e581fd; });

var $cCZAW = parcelRequire("cCZAW");

var $hxVqe = parcelRequire("hxVqe");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d2f53d1a705ef361$var$clampWrapper(value, min = 0, max = 1) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($hxVqe)))(value, min, max);
}
function $d2f53d1a705ef361$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d2f53d1a705ef361$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $d2f53d1a705ef361$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d2f53d1a705ef361$export$677b39864803984e($d2f53d1a705ef361$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, (/*@__PURE__*/$parcel$interopDefault($cCZAW)))(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $d2f53d1a705ef361$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $d2f53d1a705ef361$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $d2f53d1a705ef361$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $d2f53d1a705ef361$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $d2f53d1a705ef361$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $d2f53d1a705ef361$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d2f53d1a705ef361$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$d2f53d1a705ef361$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $d2f53d1a705ef361$export$29fb7152bd3f781a(color) {
    color = $d2f53d1a705ef361$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d2f53d1a705ef361$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $d2f53d1a705ef361$export$c852d90bf7403b62(color) {
    color = $d2f53d1a705ef361$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d2f53d1a705ef361$export$677b39864803984e($d2f53d1a705ef361$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $d2f53d1a705ef361$export$d061e26956a60b0a(foreground, background) {
    const lumA = $d2f53d1a705ef361$export$c852d90bf7403b62(foreground);
    const lumB = $d2f53d1a705ef361$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $d2f53d1a705ef361$export$58f0f39f63f3cf42(color, value) {
    color = $d2f53d1a705ef361$export$677b39864803984e(color);
    value = $d2f53d1a705ef361$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d2f53d1a705ef361$export$211a73f2b8c10ce4(color);
}
function $d2f53d1a705ef361$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $d2f53d1a705ef361$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $d2f53d1a705ef361$export$4b073707ff63303(color, coefficient) {
    color = $d2f53d1a705ef361$export$677b39864803984e(color);
    coefficient = $d2f53d1a705ef361$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d2f53d1a705ef361$export$211a73f2b8c10ce4(color);
}
function $d2f53d1a705ef361$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $d2f53d1a705ef361$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d2f53d1a705ef361$export$c0816ed86df316af(color, coefficient) {
    color = $d2f53d1a705ef361$export$677b39864803984e(color);
    coefficient = $d2f53d1a705ef361$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d2f53d1a705ef361$export$211a73f2b8c10ce4(color);
}
function $d2f53d1a705ef361$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $d2f53d1a705ef361$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d2f53d1a705ef361$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $d2f53d1a705ef361$export$c852d90bf7403b62(color) > 0.5 ? $d2f53d1a705ef361$export$4b073707ff63303(color, coefficient) : $d2f53d1a705ef361$export$c0816ed86df316af(color, coefficient);
}
function $d2f53d1a705ef361$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $d2f53d1a705ef361$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $d2f53d1a705ef361$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d2f53d1a705ef361$export$677b39864803984e(background);
    const overlayColor = $d2f53d1a705ef361$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d2f53d1a705ef361$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("gGAVD", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $c25d36d6aaa836b1$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $c25d36d6aaa836b1$var$_createBreakpoints.default;
    }
});

var $c25d36d6aaa836b1$var$_createBreakpoints = $c25d36d6aaa836b1$require$_interopRequireDefault((parcelRequire("5BunL")));

});


parcelRegister("6RvMV", function(module, exports) {
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $4ff059c290d85884$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ff059c290d85884$var$_generateUtilityClasses = $4ff059c290d85884$require$_interopRequireDefault((parcelRequire("4bI4C")));
const $4ff059c290d85884$var$boxClasses = (0, $4ff059c290d85884$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $4ff059c290d85884$var$_default = module.exports.default = $4ff059c290d85884$var$boxClasses;

});


var $cb03dc5f078f7cac$exports = {};

(parcelRequire("gaQWT")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"ej7d9\",\"index.389692c3.js\",\"9PF1W\",\"new_logo.d9372fce.png\",\"c6KuT\",\"bird_logo.4a767494.png\",\"7kLiz\",\"hand-edit-icon.0cb414cb.svg\",\"kFESX\",\"concentration.7d597663.svg\",\"da3Qr\",\"ebitda_performance.d2e303be.svg\",\"g073H\",\"fcf_profile.4ba5e38a.svg\",\"lKkC8\",\"market_size_and_performance.fd9c2e5e.svg\",\"9jVWK\",\"other.80576dc7.svg\",\"5fFqa\",\"overview.a1b80899.svg\",\"eNLYq\",\"revenue_performance.82890e81.svg\",\"9uQZU\",\"industry_icon.30d7df5b.svg\",\"6BHBM\",\"dragIcon.481a3c08.svg\",\"6CWZy\",\"chatgpt.2e7eab8d.svg\",\"5s7Jn\",\"sparkle.c93894f3.svg\",\"6KzTD\",\"back2.7df4d33c.svg\"]"));


var $kSbwP = parcelRequire("kSbwP");
var $de9addb89ca41b61$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $de9addb89ca41b61$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $de9addb89ca41b61$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $de9addb89ca41b61$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $de9addb89ca41b61$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $de9addb89ca41b61$var$InstrumentedPromise$1.prototype;
    return promise;
};
$de9addb89ca41b61$var$InstrumentedPromise$1.__proto__ = $de9addb89ca41b61$var$OriginalPromise;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.__proto__ = $de9addb89ca41b61$var$OriginalPromise.prototype;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $de9addb89ca41b61$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $de9addb89ca41b61$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $de9addb89ca41b61$export$cea1c58a6db52bca() {
    Promise = $de9addb89ca41b61$var$InstrumentedPromise$1;
}
function $de9addb89ca41b61$export$dfb5619354ba860() {
    if ($de9addb89ca41b61$export$baf72085f5fb4df()) $de9addb89ca41b61$export$cea1c58a6db52bca();
}
var $de9addb89ca41b61$export$2e2bcd8739ae039 = $de9addb89ca41b61$var$InstrumentedPromise$1;



var $T5IcR = parcelRequire("T5IcR");
var $d87212bfbb9d55bf$export$882461b6382ed46c;
var $d87212bfbb9d55bf$export$757ceba2d55c277e;
'use strict';

var $fCKK7 = parcelRequire("fCKK7");
var $d87212bfbb9d55bf$var$i;
$d87212bfbb9d55bf$export$882461b6382ed46c = $fCKK7.createRoot;
$d87212bfbb9d55bf$export$757ceba2d55c277e = $fCKK7.hydrateRoot;


var $66fd588cfa718c83$exports = {};
$66fd588cfa718c83$exports = JSON.parse("{\"overview\":{\"sectionName\":\"Overview\",\"section_worth\":0,\"rules\":[{\"field\":\"industry\",\"check\":\"none\"},{\"field\":\"industrySubType\",\"check\":\"none\"},{\"field\":\"company_ceo\",\"check\":\"none\"},{\"field\":\"year_founded\",\"check\":\"none\"},{\"field\":\"last_full_fiscal_year_reported\",\"check\":\"none\"}]},\"revenue_performance\":{\"sectionName\":\"Revenue Performance\",\"section_worth\":25,\"rules\":[{\"field\":\"revenue_latest\",\"check\":\"none\"},{\"field\":\"organic_cagr_N_years\",\"check\":\"range\",\"dataPick\":\"biggest_key_with_value\",\"range\":[-0.01,0.1]},{\"field\":\"projected_organic_cagr_N_years\",\"check\":\"range\",\"dataPick\":\"biggest_key_with_value\",\"range\":[-0.01,0.1]},{\"field\":\"projected_organic_cagr_N_years_minus_tam_growth\",\"check\":\"range\",\"range\":[-0.05,0.05]},{\"field\":\"gross_retention\",\"check\":\"range\",\"range\":[0,0.98]},{\"field\":\"net_retention\",\"check\":\"range\",\"range\":[0,120]},{\"field\":\"recurring_revenue_summary\",\"check\":\"boolean\"}]},\"ebitda_performance\":{\"sectionName\":\"Margins & Profitability\",\"section_worth\":25,\"rules\":[{\"field\":\"extended_selected_ebitda\",\"check\":\"none\"},{\"field\":\"adj_ebitda\",\"check\":\"greater_than\",\"threshold\":20,\"range\":[10,30]},{\"field\":\"adj_ebitda_margin\",\"check\":\"range\",\"range\":[0,0.25]},{\"field\":\"gross_profit_margin\",\"check\":\"range\",\"range\":[0.4,0.8]},{\"field\":\"adj_ebitda_margin_trend\",\"check\":\"range\",\"range\":[-0.1,0.1]},{\"field\":\"ebitda_magnatitude_adjustment\",\"check\":\"range\",\"inverse_score\":true,\"range\":[0.05,0.5]}]},\"market_size_and_performance\":{\"sectionName\":\"Market Size and Performance\",\"section_worth\":25,\"rules\":[{\"field\":\"total_addressable_market\",\"check\":\"range\",\"range\":[0,5]},{\"field\":\"historical_market_growth\",\"check\":\"range\",\"range\":[0,10]},{\"field\":\"projected_market_growth\",\"check\":\"range\",\"range\":[0,10]}]},\"fcf_profile\":{\"sectionName\":\"FCF Profile\",\"section_worth\":25,\"rules\":[{\"field\":\"nwc_as_percent_of_revenue\",\"check\":\"range\",\"range\":[-0.1,0.3],\"inverse_score\":true},{\"field\":\"free_cash_flow_conversion\",\"check\":\"range\",\"range\":[0.25,0.95]},{\"field\":\"total_capex_by_rev\",\"check\":\"range\",\"range\":[0.01,0.3],\"inverse_score\":true}]},\"concentration\":{\"sectionName\":\"Concentration\",\"section_worth\":25,\"rules\":[]},\"other\":{\"sectionName\":\"Other\",\"section_worth\":25,\"rules\":[]}}");


var $5825dfeb0ec6f258$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($5825dfeb0ec6f258$export$7debb50ef11d5e0b || ($5825dfeb0ec6f258$export$7debb50ef11d5e0b = {}));
var $5825dfeb0ec6f258$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($5825dfeb0ec6f258$export$4aa2142c225fd5c7 || ($5825dfeb0ec6f258$export$4aa2142c225fd5c7 = {}));
const $5825dfeb0ec6f258$export$5716da67bfaa244d = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $5825dfeb0ec6f258$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined;
        case "string":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $5825dfeb0ec6f258$export$5716da67bfaa244d.nan : $5825dfeb0ec6f258$export$5716da67bfaa244d.number;
        case "boolean":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean;
        case "function":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.function;
        case "bigint":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $5825dfeb0ec6f258$export$5716da67bfaa244d.array;
            if (data === null) return $5825dfeb0ec6f258$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $5825dfeb0ec6f258$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $5825dfeb0ec6f258$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $5825dfeb0ec6f258$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $5825dfeb0ec6f258$export$5716da67bfaa244d.date;
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.object;
        default:
            return $5825dfeb0ec6f258$export$5716da67bfaa244d.unknown;
    }
};
const $5825dfeb0ec6f258$export$5ba560653e4a1035 = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $5825dfeb0ec6f258$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $5825dfeb0ec6f258$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $5825dfeb0ec6f258$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $5825dfeb0ec6f258$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$5825dfeb0ec6f258$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333(issues);
    return error;
};
const $5825dfeb0ec6f258$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $5825dfeb0ec6f258$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $5825dfeb0ec6f258$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $5825dfeb0ec6f258$var$overrideErrorMap = $5825dfeb0ec6f258$export$341b0b6e0a6f5099;
function $5825dfeb0ec6f258$export$1097a8289cfd22d7(map) {
    $5825dfeb0ec6f258$var$overrideErrorMap = map;
}
function $5825dfeb0ec6f258$export$32f27c719778d4c4() {
    return $5825dfeb0ec6f258$var$overrideErrorMap;
}
const $5825dfeb0ec6f258$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $5825dfeb0ec6f258$export$1526d2e05f74572 = [];
function $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $5825dfeb0ec6f258$export$32f27c719778d4c4();
    const issue = $5825dfeb0ec6f258$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $5825dfeb0ec6f258$export$341b0b6e0a6f5099 ? undefined : $5825dfeb0ec6f258$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $5825dfeb0ec6f258$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $5825dfeb0ec6f258$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $5825dfeb0ec6f258$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $5825dfeb0ec6f258$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $5825dfeb0ec6f258$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $5825dfeb0ec6f258$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5825dfeb0ec6f258$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5825dfeb0ec6f258$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $5825dfeb0ec6f258$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($5825dfeb0ec6f258$var$errorUtil || ($5825dfeb0ec6f258$var$errorUtil = {}));
var $5825dfeb0ec6f258$var$_ZodEnum_cache, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache;
class $5825dfeb0ec6f258$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $5825dfeb0ec6f258$var$handleResult = (ctx, result)=>{
    if ($5825dfeb0ec6f258$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $5825dfeb0ec6f258$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $5825dfeb0ec6f258$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $5825dfeb0ec6f258$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$5825dfeb0ec6f258$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $5825dfeb0ec6f258$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
            schema: this,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
    optional() {
        return $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $5825dfeb0ec6f258$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $5825dfeb0ec6f258$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $5825dfeb0ec6f258$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $5825dfeb0ec6f258$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $5825dfeb0ec6f258$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            schema: this,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5825dfeb0ec6f258$export$bb19b37874861e7e({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $5825dfeb0ec6f258$export$66b0c798a395271f({
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5825dfeb0ec6f258$export$75a44ec6249ac76b({
            ...$5825dfeb0ec6f258$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $5825dfeb0ec6f258$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $5825dfeb0ec6f258$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $5825dfeb0ec6f258$var$cuid2Regex = /^[0-9a-z]+$/;
const $5825dfeb0ec6f258$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $5825dfeb0ec6f258$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $5825dfeb0ec6f258$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $5825dfeb0ec6f258$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $5825dfeb0ec6f258$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $5825dfeb0ec6f258$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $5825dfeb0ec6f258$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $5825dfeb0ec6f258$var$emojiRegex;
// faster, simpler, safer
const $5825dfeb0ec6f258$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $5825dfeb0ec6f258$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $5825dfeb0ec6f258$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $5825dfeb0ec6f258$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $5825dfeb0ec6f258$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $5825dfeb0ec6f258$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $5825dfeb0ec6f258$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $5825dfeb0ec6f258$var$dateRegex = new RegExp(`^${$5825dfeb0ec6f258$var$dateRegexSource}$`);
function $5825dfeb0ec6f258$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $5825dfeb0ec6f258$var$timeRegex(args) {
    return new RegExp(`^${$5825dfeb0ec6f258$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $5825dfeb0ec6f258$export$a4b563879add27a(args) {
    let regex = `${$5825dfeb0ec6f258$var$dateRegexSource}T${$5825dfeb0ec6f258$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $5825dfeb0ec6f258$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $5825dfeb0ec6f258$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $5825dfeb0ec6f258$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $5825dfeb0ec6f258$var$isValidJWT(jwt, alg) {
    if (!$5825dfeb0ec6f258$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $5825dfeb0ec6f258$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $5825dfeb0ec6f258$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $5825dfeb0ec6f258$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $5825dfeb0ec6f258$export$1230eb29b8d3b502 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$5825dfeb0ec6f258$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$5825dfeb0ec6f258$var$emojiRegex) $5825dfeb0ec6f258$var$emojiRegex = new RegExp($5825dfeb0ec6f258$var$_emojiRegex, "u");
                if (!$5825dfeb0ec6f258$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$5825dfeb0ec6f258$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$5825dfeb0ec6f258$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$5825dfeb0ec6f258$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$5825dfeb0ec6f258$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$5825dfeb0ec6f258$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $5825dfeb0ec6f258$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $5825dfeb0ec6f258$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $5825dfeb0ec6f258$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$5825dfeb0ec6f258$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$5825dfeb0ec6f258$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$5825dfeb0ec6f258$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$5825dfeb0ec6f258$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$5825dfeb0ec6f258$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$5825dfeb0ec6f258$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_string,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$5825dfeb0ec6f258$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $5825dfeb0ec6f258$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$5825dfeb0ec6f258$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $5825dfeb0ec6f258$export$1230eb29b8d3b502({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $5825dfeb0ec6f258$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $5825dfeb0ec6f258$export$5b070a55c0c43e09 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$5825dfeb0ec6f258$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($5825dfeb0ec6f258$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $5825dfeb0ec6f258$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$5825dfeb0ec6f258$export$5b070a55c0c43e09.create = (params)=>{
    return new $5825dfeb0ec6f258$export$5b070a55c0c43e09({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$67d741fd70ff98f4 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
            expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $5825dfeb0ec6f258$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$5825dfeb0ec6f258$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $5825dfeb0ec6f258$export$67d741fd70ff98f4({
        checks: [],
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$723d146f80596191 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$723d146f80596191.create = (params)=>{
    return new $5825dfeb0ec6f258$export$723d146f80596191({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$e974be33bdc55521 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_date
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const status = new $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $5825dfeb0ec6f258$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$5825dfeb0ec6f258$export$e974be33bdc55521.create = (params)=>{
    return new $5825dfeb0ec6f258$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDate,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$bcc3b40f6b638044 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$bcc3b40f6b638044.create = (params)=>{
    return new $5825dfeb0ec6f258$export$bcc3b40f6b638044({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodSymbol,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$4e780e961c30340d extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$4e780e961c30340d.create = (params)=>{
    return new $5825dfeb0ec6f258$export$4e780e961c30340d({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUndefined,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a96281f914484f2d extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$a96281f914484f2d.create = (params)=>{
    return new $5825dfeb0ec6f258$export$a96281f914484f2d({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNull,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$b9d1edb536b4e4eb extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $5825dfeb0ec6f258$export$b9d1edb536b4e4eb({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodAny,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$ef3b1bb1630977ae extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$ef3b1bb1630977ae.create = (params)=>{
    return new $5825dfeb0ec6f258$export$ef3b1bb1630977ae({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUnknown,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$1e576a20c3ce9fb5 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
            code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
            expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
    }
}
$5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $5825dfeb0ec6f258$export$1e576a20c3ce9fb5({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNever,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7d39f5df85f21031 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
}
$5825dfeb0ec6f258$export$7d39f5df85f21031.create = (params)=>{
    return new $5825dfeb0ec6f258$export$7d39f5df85f21031({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodVoid,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7acfc3e64785411 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big : $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $5825dfeb0ec6f258$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$5825dfeb0ec6f258$export$7acfc3e64785411.create = (schema, params)=>{
    return new $5825dfeb0ec6f258$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodArray,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
function $5825dfeb0ec6f258$var$deepPartialify(schema) {
    if (schema instanceof $5825dfeb0ec6f258$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create($5825dfeb0ec6f258$var$deepPartialify(fieldSchema));
        }
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $5825dfeb0ec6f258$export$7acfc3e64785411) return new $5825dfeb0ec6f258$export$7acfc3e64785411({
        ...schema._def,
        type: $5825dfeb0ec6f258$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8) return $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create($5825dfeb0ec6f258$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5825dfeb0ec6f258$export$aaac0b8b429cef5) return $5825dfeb0ec6f258$export$aaac0b8b429cef5.create($5825dfeb0ec6f258$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5825dfeb0ec6f258$export$e2a18bb771d8e6a3) return $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$5825dfeb0ec6f258$var$deepPartialify(item)));
    else return schema;
}
class $5825dfeb0ec6f258$export$736315c5b55efbad extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $5825dfeb0ec6f258$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $5825dfeb0ec6f258$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                        code: $5825dfeb0ec6f258$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $5825dfeb0ec6f258$var$errorUtil.errToObj;
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $5825dfeb0ec6f258$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $5825dfeb0ec6f258$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $5825dfeb0ec6f258$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $5825dfeb0ec6f258$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $5825dfeb0ec6f258$var$createZodEnum($5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$5825dfeb0ec6f258$export$736315c5b55efbad.create = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $5825dfeb0ec6f258$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create(),
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodObject,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a8b236cb5070a311 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $5825dfeb0ec6f258$export$f98dac4b251ab333(result.ctx.common.issues));
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $5825dfeb0ec6f258$export$f98dac4b251ab333(issues));
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$5825dfeb0ec6f258$export$a8b236cb5070a311.create = (types, params)=>{
    return new $5825dfeb0ec6f258$export$a8b236cb5070a311({
        options: types,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodUnion,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $5825dfeb0ec6f258$var$getDiscriminator = (type)=>{
    if (type instanceof $5825dfeb0ec6f258$export$378d0cfce37406e6) return $5825dfeb0ec6f258$var$getDiscriminator(type.schema);
    else if (type instanceof $5825dfeb0ec6f258$export$a60af00cc0ce2582) return $5825dfeb0ec6f258$var$getDiscriminator(type.innerType());
    else if (type instanceof $5825dfeb0ec6f258$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $5825dfeb0ec6f258$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $5825dfeb0ec6f258$export$bb19b37874861e7e) return $5825dfeb0ec6f258$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $5825dfeb0ec6f258$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$aa56fec1e9d629b8) return [
        undefined,
        ...$5825dfeb0ec6f258$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$aaac0b8b429cef5) return [
        null,
        ...$5825dfeb0ec6f258$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $5825dfeb0ec6f258$export$66b0c798a395271f) return $5825dfeb0ec6f258$var$getDiscriminator(type.unwrap());
    else if (type instanceof $5825dfeb0ec6f258$export$5d1f7ef05c4e493a) return $5825dfeb0ec6f258$var$getDiscriminator(type.unwrap());
    else if (type instanceof $5825dfeb0ec6f258$export$75a44ec6249ac76b) return $5825dfeb0ec6f258$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $5825dfeb0ec6f258$export$5ef2424805ac76a3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $5825dfeb0ec6f258$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $5825dfeb0ec6f258$export$5ef2424805ac76a3({
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$5825dfeb0ec6f258$var$processCreateParams(params)
        });
    }
}
function $5825dfeb0ec6f258$var$mergeValues(a, b) {
    const aType = $5825dfeb0ec6f258$export$3e9057828ebd5c7a(a);
    const bType = $5825dfeb0ec6f258$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.object && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
        const bKeys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $5825dfeb0ec6f258$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.array && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $5825dfeb0ec6f258$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $5825dfeb0ec6f258$export$5716da67bfaa244d.date && bType === $5825dfeb0ec6f258$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $5825dfeb0ec6f258$export$c02deaf0bb5203d4 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($5825dfeb0ec6f258$export$afa861e3c5730743(parsedLeft) || $5825dfeb0ec6f258$export$afa861e3c5730743(parsedRight)) return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            const merged = $5825dfeb0ec6f258$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            }
            if ($5825dfeb0ec6f258$export$910b6cdd390341b3(parsedLeft) || $5825dfeb0ec6f258$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$5825dfeb0ec6f258$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $5825dfeb0ec6f258$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodIntersection,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$e2a18bb771d8e6a3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.array) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $5825dfeb0ec6f258$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $5825dfeb0ec6f258$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a2acc09968cb4b7f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.object) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $5825dfeb0ec6f258$export$19342e026b58ebb7) return new $5825dfeb0ec6f258$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodRecord,
            ...$5825dfeb0ec6f258$var$processCreateParams(third)
        });
        return new $5825dfeb0ec6f258$export$a2acc09968cb4b7f({
            keyType: $5825dfeb0ec6f258$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodRecord,
            ...$5825dfeb0ec6f258$var$processCreateParams(second)
        });
    }
}
class $5825dfeb0ec6f258$export$163b6a2b712d9542 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.map) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$5825dfeb0ec6f258$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $5825dfeb0ec6f258$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodMap,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$977057706f816712 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.set) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $5825dfeb0ec6f258$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $5825dfeb0ec6f258$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $5825dfeb0ec6f258$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $5825dfeb0ec6f258$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$5825dfeb0ec6f258$export$977057706f816712.create = (valueType, params)=>{
    return new $5825dfeb0ec6f258$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodSet,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$d4602ba55673f53c extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.function) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $5825dfeb0ec6f258$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $5825dfeb0ec6f258$export$32f27c719778d4c4(),
                    $5825dfeb0ec6f258$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $5825dfeb0ec6f258$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $5825dfeb0ec6f258$export$32f27c719778d4c4(),
                    $5825dfeb0ec6f258$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $5825dfeb0ec6f258$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $5825dfeb0ec6f258$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $5825dfeb0ec6f258$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $5825dfeb0ec6f258$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            ...this._def,
            args: $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create(items).rest($5825dfeb0ec6f258$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $5825dfeb0ec6f258$export$d4602ba55673f53c({
            args: args ? args : $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create([]).rest($5825dfeb0ec6f258$export$ef3b1bb1630977ae.create()),
            returns: returns || $5825dfeb0ec6f258$export$ef3b1bb1630977ae.create(),
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodFunction,
            ...$5825dfeb0ec6f258$var$processCreateParams(params)
        });
    }
}
class $5825dfeb0ec6f258$export$378d0cfce37406e6 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$5825dfeb0ec6f258$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $5825dfeb0ec6f258$export$378d0cfce37406e6({
        getter: getter,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodLazy,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$7e44096782a165d3 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$5825dfeb0ec6f258$export$7e44096782a165d3.create = (value, params)=>{
    return new $5825dfeb0ec6f258$export$7e44096782a165d3({
        value: value,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodLiteral,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
function $5825dfeb0ec6f258$var$createZodEnum(values, params) {
    return new $5825dfeb0ec6f258$export$d325d1f0e1c20179({
        values: values,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEnum,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
}
class $5825dfeb0ec6f258$export$d325d1f0e1c20179 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $5825dfeb0ec6f258$var$_ZodEnum_cache.set(this, void 0);
    }
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                expected: $5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, "f")) $5825dfeb0ec6f258$var$__classPrivateFieldSet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $5825dfeb0ec6f258$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $5825dfeb0ec6f258$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
}
$5825dfeb0ec6f258$var$_ZodEnum_cache = new WeakMap();
$5825dfeb0ec6f258$export$d325d1f0e1c20179.create = $5825dfeb0ec6f258$var$createZodEnum;
class $5825dfeb0ec6f258$export$370b2e8d6d6f5c56 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        $5825dfeb0ec6f258$var$_ZodNativeEnum_cache.set(this, void 0);
    }
    _parse(input) {
        const nativeEnumValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.string && ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.number) {
            const expectedValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                expected: $5825dfeb0ec6f258$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, "f")) $5825dfeb0ec6f258$var$__classPrivateFieldSet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, new Set($5825dfeb0ec6f258$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$5825dfeb0ec6f258$var$__classPrivateFieldGet(this, $5825dfeb0ec6f258$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $5825dfeb0ec6f258$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$5825dfeb0ec6f258$var$_ZodNativeEnum_cache = new WeakMap();
$5825dfeb0ec6f258$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $5825dfeb0ec6f258$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNativeEnum,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$3f196b0127d6e50a extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$5825dfeb0ec6f258$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $5825dfeb0ec6f258$export$3f196b0127d6e50a({
        type: schema,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodPromise,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$a60af00cc0ce2582 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $5825dfeb0ec6f258$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$5825dfeb0ec6f258$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$5825dfeb0ec6f258$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $5825dfeb0ec6f258$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$5825dfeb0ec6f258$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
$5825dfeb0ec6f258$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $5825dfeb0ec6f258$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodEffects,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$aa56fec1e9d629b8 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodOptional,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$aaac0b8b429cef5 extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.null) return $5825dfeb0ec6f258$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNullable,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$bb19b37874861e7e extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $5825dfeb0ec6f258$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$bb19b37874861e7e.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$bb19b37874861e7e({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$75a44ec6249ac76b extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $5825dfeb0ec6f258$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $5825dfeb0ec6f258$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
class $5825dfeb0ec6f258$export$26ccfa0145e8511f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $5825dfeb0ec6f258$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $5825dfeb0ec6f258$export$db7caee60e5d514d(ctx, {
                code: $5825dfeb0ec6f258$export$5ba560653e4a1035.invalid_type,
                expected: $5825dfeb0ec6f258$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$5825dfeb0ec6f258$export$26ccfa0145e8511f.create = (params)=>{
    return new $5825dfeb0ec6f258$export$26ccfa0145e8511f({
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodNaN,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
const $5825dfeb0ec6f258$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $5825dfeb0ec6f258$export$66b0c798a395271f extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $5825dfeb0ec6f258$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $5825dfeb0ec6f258$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $5825dfeb0ec6f258$export$5d1f7ef05c4e493a extends $5825dfeb0ec6f258$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($5825dfeb0ec6f258$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$5825dfeb0ec6f258$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $5825dfeb0ec6f258$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $5825dfeb0ec6f258$export$558106ce543bd011.ZodReadonly,
        ...$5825dfeb0ec6f258$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $5825dfeb0ec6f258$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $5825dfeb0ec6f258$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $5825dfeb0ec6f258$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $5825dfeb0ec6f258$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create();
}
const $5825dfeb0ec6f258$export$1ee8ee30835eab8b = {
    object: $5825dfeb0ec6f258$export$736315c5b55efbad.lazycreate
};
var $5825dfeb0ec6f258$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($5825dfeb0ec6f258$export$558106ce543bd011 || ($5825dfeb0ec6f258$export$558106ce543bd011 = {}));
const $5825dfeb0ec6f258$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$5825dfeb0ec6f258$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $5825dfeb0ec6f258$export$22b082955e083ec3 = $5825dfeb0ec6f258$export$1230eb29b8d3b502.create;
const $5825dfeb0ec6f258$export$98e628dec113755e = $5825dfeb0ec6f258$export$5b070a55c0c43e09.create;
const $5825dfeb0ec6f258$export$9e06de0973666692 = $5825dfeb0ec6f258$export$26ccfa0145e8511f.create;
const $5825dfeb0ec6f258$export$a0f65b52274bcc00 = $5825dfeb0ec6f258$export$67d741fd70ff98f4.create;
const $5825dfeb0ec6f258$export$4a21f16c33752377 = $5825dfeb0ec6f258$export$723d146f80596191.create;
const $5825dfeb0ec6f258$export$324d90190a8b822a = $5825dfeb0ec6f258$export$e974be33bdc55521.create;
const $5825dfeb0ec6f258$export$8f701197936bc2a6 = $5825dfeb0ec6f258$export$bcc3b40f6b638044.create;
const $5825dfeb0ec6f258$export$1db45310990710a5 = $5825dfeb0ec6f258$export$4e780e961c30340d.create;
const $5825dfeb0ec6f258$export$7b1b591b262c240 = $5825dfeb0ec6f258$export$a96281f914484f2d.create;
const $5825dfeb0ec6f258$export$4154a199d7d90455 = $5825dfeb0ec6f258$export$b9d1edb536b4e4eb.create;
const $5825dfeb0ec6f258$export$19282c40b967aec6 = $5825dfeb0ec6f258$export$ef3b1bb1630977ae.create;
const $5825dfeb0ec6f258$export$b3e22bcfd64c1022 = $5825dfeb0ec6f258$export$1e576a20c3ce9fb5.create;
const $5825dfeb0ec6f258$export$490e536ee7389aeb = $5825dfeb0ec6f258$export$7d39f5df85f21031.create;
const $5825dfeb0ec6f258$export$2f23118c22fb2630 = $5825dfeb0ec6f258$export$7acfc3e64785411.create;
const $5825dfeb0ec6f258$export$be5493f9613cbbe = $5825dfeb0ec6f258$export$736315c5b55efbad.create;
const $5825dfeb0ec6f258$export$8fb0df5f40d0b477 = $5825dfeb0ec6f258$export$736315c5b55efbad.strictCreate;
const $5825dfeb0ec6f258$export$971dd5b0dfd021b6 = $5825dfeb0ec6f258$export$a8b236cb5070a311.create;
const $5825dfeb0ec6f258$export$4b888e40c4ee26dd = $5825dfeb0ec6f258$export$5ef2424805ac76a3.create;
const $5825dfeb0ec6f258$export$bc86dfbf7795668c = $5825dfeb0ec6f258$export$c02deaf0bb5203d4.create;
const $5825dfeb0ec6f258$export$65e3907585753458 = $5825dfeb0ec6f258$export$e2a18bb771d8e6a3.create;
const $5825dfeb0ec6f258$export$e5185e241753e543 = $5825dfeb0ec6f258$export$a2acc09968cb4b7f.create;
const $5825dfeb0ec6f258$export$871de8747c9eaa88 = $5825dfeb0ec6f258$export$163b6a2b712d9542.create;
const $5825dfeb0ec6f258$export$adaa4cf7ef1b65be = $5825dfeb0ec6f258$export$977057706f816712.create;
const $5825dfeb0ec6f258$export$44e51c8aac7c2deb = $5825dfeb0ec6f258$export$d4602ba55673f53c.create;
const $5825dfeb0ec6f258$export$488013bae63b21da = $5825dfeb0ec6f258$export$378d0cfce37406e6.create;
const $5825dfeb0ec6f258$export$c8ec6e1ec9fefcb0 = $5825dfeb0ec6f258$export$7e44096782a165d3.create;
const $5825dfeb0ec6f258$export$78a99c8d44d72635 = $5825dfeb0ec6f258$export$d325d1f0e1c20179.create;
const $5825dfeb0ec6f258$export$6fe7eca19ebe5199 = $5825dfeb0ec6f258$export$370b2e8d6d6f5c56.create;
const $5825dfeb0ec6f258$export$c957ef27a0ebfd4 = $5825dfeb0ec6f258$export$3f196b0127d6e50a.create;
const $5825dfeb0ec6f258$export$dc573d8a6576cdb3 = $5825dfeb0ec6f258$export$a60af00cc0ce2582.create;
const $5825dfeb0ec6f258$export$516e28dec6a4b6d4 = $5825dfeb0ec6f258$export$aa56fec1e9d629b8.create;
const $5825dfeb0ec6f258$export$133fc36489ac9add = $5825dfeb0ec6f258$export$aaac0b8b429cef5.create;
const $5825dfeb0ec6f258$export$fc37fe19dfda43ee = $5825dfeb0ec6f258$export$a60af00cc0ce2582.createWithPreprocess;
const $5825dfeb0ec6f258$export$43f28b24e1eb8181 = $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da.create;
const $5825dfeb0ec6f258$export$3b3d07727c5b702c = ()=>$5825dfeb0ec6f258$export$22b082955e083ec3().optional();
const $5825dfeb0ec6f258$export$eb150471a61fced6 = ()=>$5825dfeb0ec6f258$export$98e628dec113755e().optional();
const $5825dfeb0ec6f258$export$269251733cdcbbf1 = ()=>$5825dfeb0ec6f258$export$4a21f16c33752377().optional();
const $5825dfeb0ec6f258$export$8c14e57e778d3873 = {
    string: (arg)=>$5825dfeb0ec6f258$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$5825dfeb0ec6f258$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$5825dfeb0ec6f258$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$5825dfeb0ec6f258$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$5825dfeb0ec6f258$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $5825dfeb0ec6f258$export$96c94437c95d7862 = $5825dfeb0ec6f258$export$9a105a556e65c2c0;
var $5825dfeb0ec6f258$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $5825dfeb0ec6f258$export$341b0b6e0a6f5099,
    setErrorMap: $5825dfeb0ec6f258$export$1097a8289cfd22d7,
    getErrorMap: $5825dfeb0ec6f258$export$32f27c719778d4c4,
    makeIssue: $5825dfeb0ec6f258$export$244a85fde9c419ed,
    EMPTY_PATH: $5825dfeb0ec6f258$export$1526d2e05f74572,
    addIssueToContext: $5825dfeb0ec6f258$export$db7caee60e5d514d,
    ParseStatus: $5825dfeb0ec6f258$export$5b20a5c3d05c1f6f,
    INVALID: $5825dfeb0ec6f258$export$9a105a556e65c2c0,
    DIRTY: $5825dfeb0ec6f258$export$325a211da9693fcf,
    OK: $5825dfeb0ec6f258$export$c6813a8d51f77eaf,
    isAborted: $5825dfeb0ec6f258$export$afa861e3c5730743,
    isDirty: $5825dfeb0ec6f258$export$910b6cdd390341b3,
    isValid: $5825dfeb0ec6f258$export$1ea939691cdc45b8,
    isAsync: $5825dfeb0ec6f258$export$aefee5ebe1dcfd9e,
    get util () {
        return $5825dfeb0ec6f258$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $5825dfeb0ec6f258$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $5825dfeb0ec6f258$export$5716da67bfaa244d,
    getParsedType: $5825dfeb0ec6f258$export$3e9057828ebd5c7a,
    ZodType: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    datetimeRegex: $5825dfeb0ec6f258$export$a4b563879add27a,
    ZodString: $5825dfeb0ec6f258$export$1230eb29b8d3b502,
    ZodNumber: $5825dfeb0ec6f258$export$5b070a55c0c43e09,
    ZodBigInt: $5825dfeb0ec6f258$export$67d741fd70ff98f4,
    ZodBoolean: $5825dfeb0ec6f258$export$723d146f80596191,
    ZodDate: $5825dfeb0ec6f258$export$e974be33bdc55521,
    ZodSymbol: $5825dfeb0ec6f258$export$bcc3b40f6b638044,
    ZodUndefined: $5825dfeb0ec6f258$export$4e780e961c30340d,
    ZodNull: $5825dfeb0ec6f258$export$a96281f914484f2d,
    ZodAny: $5825dfeb0ec6f258$export$b9d1edb536b4e4eb,
    ZodUnknown: $5825dfeb0ec6f258$export$ef3b1bb1630977ae,
    ZodNever: $5825dfeb0ec6f258$export$1e576a20c3ce9fb5,
    ZodVoid: $5825dfeb0ec6f258$export$7d39f5df85f21031,
    ZodArray: $5825dfeb0ec6f258$export$7acfc3e64785411,
    ZodObject: $5825dfeb0ec6f258$export$736315c5b55efbad,
    ZodUnion: $5825dfeb0ec6f258$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $5825dfeb0ec6f258$export$5ef2424805ac76a3,
    ZodIntersection: $5825dfeb0ec6f258$export$c02deaf0bb5203d4,
    ZodTuple: $5825dfeb0ec6f258$export$e2a18bb771d8e6a3,
    ZodRecord: $5825dfeb0ec6f258$export$a2acc09968cb4b7f,
    ZodMap: $5825dfeb0ec6f258$export$163b6a2b712d9542,
    ZodSet: $5825dfeb0ec6f258$export$977057706f816712,
    ZodFunction: $5825dfeb0ec6f258$export$d4602ba55673f53c,
    ZodLazy: $5825dfeb0ec6f258$export$378d0cfce37406e6,
    ZodLiteral: $5825dfeb0ec6f258$export$7e44096782a165d3,
    ZodEnum: $5825dfeb0ec6f258$export$d325d1f0e1c20179,
    ZodNativeEnum: $5825dfeb0ec6f258$export$370b2e8d6d6f5c56,
    ZodPromise: $5825dfeb0ec6f258$export$3f196b0127d6e50a,
    ZodEffects: $5825dfeb0ec6f258$export$a60af00cc0ce2582,
    ZodTransformer: $5825dfeb0ec6f258$export$a60af00cc0ce2582,
    ZodOptional: $5825dfeb0ec6f258$export$aa56fec1e9d629b8,
    ZodNullable: $5825dfeb0ec6f258$export$aaac0b8b429cef5,
    ZodDefault: $5825dfeb0ec6f258$export$bb19b37874861e7e,
    ZodCatch: $5825dfeb0ec6f258$export$75a44ec6249ac76b,
    ZodNaN: $5825dfeb0ec6f258$export$26ccfa0145e8511f,
    BRAND: $5825dfeb0ec6f258$export$cf2deea74cde46b4,
    ZodBranded: $5825dfeb0ec6f258$export$66b0c798a395271f,
    ZodPipeline: $5825dfeb0ec6f258$export$a3c3ef8a0e95c6da,
    ZodReadonly: $5825dfeb0ec6f258$export$5d1f7ef05c4e493a,
    custom: $5825dfeb0ec6f258$export$4c00f665f0d4b443,
    Schema: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    ZodSchema: $5825dfeb0ec6f258$export$19342e026b58ebb7,
    late: $5825dfeb0ec6f258$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $5825dfeb0ec6f258$export$558106ce543bd011;
    },
    coerce: $5825dfeb0ec6f258$export$8c14e57e778d3873,
    any: $5825dfeb0ec6f258$export$4154a199d7d90455,
    array: $5825dfeb0ec6f258$export$2f23118c22fb2630,
    bigint: $5825dfeb0ec6f258$export$a0f65b52274bcc00,
    boolean: $5825dfeb0ec6f258$export$4a21f16c33752377,
    date: $5825dfeb0ec6f258$export$324d90190a8b822a,
    discriminatedUnion: $5825dfeb0ec6f258$export$4b888e40c4ee26dd,
    effect: $5825dfeb0ec6f258$export$dc573d8a6576cdb3,
    'enum': $5825dfeb0ec6f258$export$78a99c8d44d72635,
    'function': $5825dfeb0ec6f258$export$44e51c8aac7c2deb,
    'instanceof': $5825dfeb0ec6f258$export$3d916e7c22dbd8b5,
    intersection: $5825dfeb0ec6f258$export$bc86dfbf7795668c,
    lazy: $5825dfeb0ec6f258$export$488013bae63b21da,
    literal: $5825dfeb0ec6f258$export$c8ec6e1ec9fefcb0,
    map: $5825dfeb0ec6f258$export$871de8747c9eaa88,
    nan: $5825dfeb0ec6f258$export$9e06de0973666692,
    nativeEnum: $5825dfeb0ec6f258$export$6fe7eca19ebe5199,
    never: $5825dfeb0ec6f258$export$b3e22bcfd64c1022,
    'null': $5825dfeb0ec6f258$export$7b1b591b262c240,
    nullable: $5825dfeb0ec6f258$export$133fc36489ac9add,
    number: $5825dfeb0ec6f258$export$98e628dec113755e,
    object: $5825dfeb0ec6f258$export$be5493f9613cbbe,
    oboolean: $5825dfeb0ec6f258$export$269251733cdcbbf1,
    onumber: $5825dfeb0ec6f258$export$eb150471a61fced6,
    optional: $5825dfeb0ec6f258$export$516e28dec6a4b6d4,
    ostring: $5825dfeb0ec6f258$export$3b3d07727c5b702c,
    pipeline: $5825dfeb0ec6f258$export$43f28b24e1eb8181,
    preprocess: $5825dfeb0ec6f258$export$fc37fe19dfda43ee,
    promise: $5825dfeb0ec6f258$export$c957ef27a0ebfd4,
    record: $5825dfeb0ec6f258$export$e5185e241753e543,
    set: $5825dfeb0ec6f258$export$adaa4cf7ef1b65be,
    strictObject: $5825dfeb0ec6f258$export$8fb0df5f40d0b477,
    string: $5825dfeb0ec6f258$export$22b082955e083ec3,
    symbol: $5825dfeb0ec6f258$export$8f701197936bc2a6,
    transformer: $5825dfeb0ec6f258$export$dc573d8a6576cdb3,
    tuple: $5825dfeb0ec6f258$export$65e3907585753458,
    'undefined': $5825dfeb0ec6f258$export$1db45310990710a5,
    union: $5825dfeb0ec6f258$export$971dd5b0dfd021b6,
    unknown: $5825dfeb0ec6f258$export$19282c40b967aec6,
    'void': $5825dfeb0ec6f258$export$490e536ee7389aeb,
    NEVER: $5825dfeb0ec6f258$export$96c94437c95d7862,
    ZodIssueCode: $5825dfeb0ec6f258$export$5ba560653e4a1035,
    quotelessJson: $5825dfeb0ec6f258$export$913eddeaf297cfea,
    ZodError: $5825dfeb0ec6f258$export$f98dac4b251ab333
});



var $fgQ0V = parcelRequire("fgQ0V");

var $T5IcR = parcelRequire("T5IcR");
var $9b879bbdd76f7296$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $9b879bbdd76f7296$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $9b879bbdd76f7296$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9b879bbdd76f7296$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
const $9b879bbdd76f7296$var$RuleSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).object({
    field: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string(),
    check: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
        "greater_than",
        "range",
        "boolean",
        "none"
    ]),
    range: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).tuple([
        (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number(),
        (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number()
    ]).optional(),
    points: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number().default(1),
    dataPick: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
        "biggest_key_with_value"
    ]).optional(),
    threshold: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number().optional(),
    inverse_score: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false),
    sectionId: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string().optional(),
    disabled: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false),
    debugger: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).boolean().default(false)
}).refine((data)=>{
    if (data.check === "range" && !data.range) return false;
    if (data.check === "greater_than" && (data.threshold === undefined || data.range === undefined)) return false;
    if (data.check !== "range" && data.inverse_score) return false;
    return true;
});
const $9b879bbdd76f7296$var$SectionSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).object({
    sectionName: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).string(),
    section_worth: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).number(),
    rules: (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).array($9b879bbdd76f7296$var$RuleSchema)
});
class $9b879bbdd76f7296$export$3a327ec912fc46d0 {
    constructor(sectionId){
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sectionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fields", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "section_worth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const scoreRules = $9b879bbdd76f7296$export$5bbef306d29b8236().rules;
        this.sectionId = sectionId;
        this.section_worth = scoreRules[sectionId].section_worth;
        this.name = scoreRules[sectionId].sectionName;
        this.fields = $9b879bbdd76f7296$export$39c49a915ff7ed37.get_section_fields(sectionId);
    }
}
//type SectionTypes = "revenue_performance" | "ebitda_performance";
const $9b879bbdd76f7296$var$SectionTypeEnum = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).enum([
    "overview",
    "revenue_performance",
    "ebitda_performance",
    "market_size_and_performance",
    "fcf_profile",
    "concentration",
    "other"
]);
const $9b879bbdd76f7296$var$SectionsSchema = (0, $5825dfeb0ec6f258$export$2e2bcd8739ae039).record($9b879bbdd76f7296$var$SectionSchema).refine((data)=>{
    return Object.keys(data).every((key)=>$9b879bbdd76f7296$var$SectionTypeEnum.options.includes(key));
});
const $9b879bbdd76f7296$var$scoreRulesCopy = $9b879bbdd76f7296$var$SectionsSchema.parse((0, (/*@__PURE__*/$parcel$interopDefault($66fd588cfa718c83$exports))));
class $9b879bbdd76f7296$export$39c49a915ff7ed37 {
    constructor(dataAccess, doLog = false){
        Object.defineProperty(this, "dataAccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: dataAccess
        });
        Object.defineProperty(this, "doLog", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: doLog
        });
    }
    get_rule_weight(section, rule) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const rulesUsed = scoreRules[section].rules.filter((rule)=>this.is_rule_used_for_scoring(rule)).length;
        return rule.points / rulesUsed;
    }
    get_datapick_key_for_rule(rule) {
        if (rule.dataPick === "biggest_key_with_value") {
            const fieldValue = this.dataAccess.get_extended_value_float(rule.field);
            var keys = Object.keys(fieldValue).sort().reverse();
            if (keys.length == 0) return null;
            for(var i = 0; i < keys.length; i++){
                var keyIndex = keys[i];
                var value = fieldValue[keyIndex];
                if (value != 'N/A' && value != null) return keyIndex;
            }
        } else return null;
    }
    get_extended_float_for_scoring(score) {
        var fieldValue = this.dataAccess.get_extended_value_float(score.field);
        if (score.dataPick) {
            const keyIndex = this.get_datapick_key_for_rule(score);
            if (keyIndex == null) return 'N/A';
            return fieldValue[keyIndex];
        } else return fieldValue;
    }
    do_rule_score(score, clamp_to_01 = true) {
        if (score.debugger) debugger;
        const p = score.points;
        var fieldValue = this.get_extended_float_for_scoring(score);
        var ret = 0;
        switch(score.check){
            case "greater_than":
                ret = fieldValue > score.threshold ? p : 0;
                this.log(`Scoring -> (${score.field}) greater_than (${score.threshold}): ${fieldValue}: ${ret}/${p}`);
                break;
            case "range":
                const [low, high] = score.range;
                var norm = (fieldValue - low) / (high - low);
                if (clamp_to_01) norm = Math.min(1, Math.max(0, norm));
                if (score.inverse_score === true) {
                    this.log(`*** Inverse Scoring (${score.field}): ${norm} to: ${1 - norm} ***`);
                    norm = 1 - norm;
                }
                ret = p * norm;
                this.log(`Scoring -> (${score.field}) range[${low}, ${high}] (Value: ${fieldValue.toFixed(2)}, Norm: ${norm.toFixed(2)}): ${ret}/${p}`);
                break;
            case "boolean":
                ret = fieldValue ? p : 0;
                this.log(`Scoring -> (${score.field}) boolean: ${fieldValue}: ${ret}/${p}`);
                break;
            default:
                this.log("Scoring-> Unknown check type: " + score.check);
                ret = 0;
                break;
        }
        if (isNaN(ret)) {
            this.log("Scoring-> Error calculating score for " + score.field);
            ret = 0;
        }
        return ret;
    }
    log(msg) {
        if (!this.doLog) return;
        console.log(msg);
    }
    static get_section_name(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return scoreRules[section].sectionName;
    }
    static get_section_fields(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return scoreRules[section].rules.map((rule)=>rule.field);
    }
    is_rule_excluded_for_client(rule) {
        if (rule.disabled) return true;
        return false;
    }
    is_rule_used_for_scoring(scoreRule) {
        if (scoreRule.check === "none") return false;
        if (this.is_rule_excluded_for_client(scoreRule)) {
            this.log("Scoring-> Skipping: " + scoreRule.field + " due to client exclusion");
            return false;
        }
        var value = this.get_extended_float_for_scoring(scoreRule);
        if (value == 'N/A' || isNaN(value)) {
            this.log("Scoring-> Skipping: " + scoreRule.field + " due to N/A or NaN");
            return false;
        }
        return true;
    }
    static get_score_rule_by_fieldname(section, fieldName) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const sectionData = scoreRules[section];
        return sectionData.rules.find((rule)=>rule.field === fieldName);
    }
    is_section_used_for_scoring_by_id(section) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        return this.is_section_used_for_scoring(scoreRules[section]);
    }
    is_section_used_for_scoring(section) {
        var isUsed = false;
        for (const rule of section.rules)if (this.is_rule_used_for_scoring(rule)) {
            isUsed = true;
            break;
        }
        return isUsed;
    }
    calcSectionPercentileById(sectionId) {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        const section = scoreRules[sectionId];
        return this.calcSectionPercentile(section);
    }
    calcSectionPercentile(section) {
        var maxPointsAvailable = 0;
        var totalPoints = 0;
        section.rules.forEach((rule)=>{
            if (this.is_rule_used_for_scoring(rule)) {
                maxPointsAvailable += rule.points;
                totalPoints += this.do_rule_score(rule);
            }
        });
        this.log(`Scoring-> ${section.sectionName} Section: ${totalPoints.toFixed(2)}/${maxPointsAvailable.toFixed(2)}`);
        const percentile = totalPoints / maxPointsAvailable;
        this.log(`Scoring-> ${section.sectionName} Section Percentile: ${percentile.toFixed(2)}`);
        return percentile;
    }
    get_max_points_based_on_sections_used() {
        var maxPoints = 0;
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        for(var id in scoreRules)if (this.is_section_used_for_scoring_by_id(id)) maxPoints += scoreRules[id].section_worth;
        return maxPoints;
    }
    calcScorePercentile() {
        const scoreRules = $9b879bbdd76f7296$export$f65e0b130162f295();
        var maxAvailableSectionPoints = 0;
        var totalPointsScored = 0;
        this.log("START SCORE CALCULATION");
        for(var id in scoreRules){
            const section = scoreRules[id];
            if (this.is_section_used_for_scoring(section)) {
                maxAvailableSectionPoints += section.section_worth;
                const percentileScoreSection = this.calcSectionPercentile(section);
                this.log(`Section ${section.sectionName} scored ${percentileScoreSection}`);
                totalPointsScored += percentileScoreSection * section.section_worth;
            }
        }
        this.log("END SCORE CALCULATION");
        if (maxAvailableSectionPoints == 0) {
            this.log("Scoring-> No sections to score");
            return null;
        }
        var finalScore = totalPointsScored / maxAvailableSectionPoints;
        return finalScore;
    }
}
let $9b879bbdd76f7296$var$ScoreRulesStore = (()=>{
    var _a, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage;
    let _SCORE_FIELDS_GROUPS_decorators;
    let _SCORE_FIELDS_GROUPS_initializers = [];
    let _SCORE_FIELDS_GROUPS_extraInitializers = [];
    let _COMPARE_FIELDS_GROUPS_decorators;
    let _COMPARE_FIELDS_GROUPS_initializers = [];
    let _COMPARE_FIELDS_GROUPS_extraInitializers = [];
    return _a = class ScoreRulesStore {
        constructor(outputLog = false){
            Object.defineProperty(this, "outputLog", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: outputLog
            });
            Object.defineProperty(this, "rules", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: null
            });
            Object.defineProperty(this, "overviewGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "revenueGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ebitdaGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "marketGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "fcfGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "customerConcentration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "other", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage.set(this, $9b879bbdd76f7296$var$__runInitializers(this, _SCORE_FIELDS_GROUPS_initializers, []));
            _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage.set(this, ($9b879bbdd76f7296$var$__runInitializers(this, _SCORE_FIELDS_GROUPS_extraInitializers), $9b879bbdd76f7296$var$__runInitializers(this, _COMPARE_FIELDS_GROUPS_initializers, [])));
            $9b879bbdd76f7296$var$__runInitializers(this, _COMPARE_FIELDS_GROUPS_extraInitializers);
            this.outputLog = outputLog;
        }
        init() {
            this.rules = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep($9b879bbdd76f7296$var$scoreRulesCopy);
            for(var sectionId in this.rules){
                const section = $9b879bbdd76f7296$var$scoreRulesCopy[sectionId];
                section.rules.forEach((rule)=>{
                    rule.sectionId = sectionId;
                });
            }
            this.setupGroups();
        }
        setupGroups() {
            this.overviewGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0("overview");
            this.revenueGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0("revenue_performance");
            this.ebitdaGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0("ebitda_performance");
            this.marketGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0("market_size_and_performance");
            this.fcfGroup = new $9b879bbdd76f7296$export$3a327ec912fc46d0("fcf_profile");
            this.customerConcentration = new $9b879bbdd76f7296$export$3a327ec912fc46d0("concentration");
            this.other = new $9b879bbdd76f7296$export$3a327ec912fc46d0("other");
            this.SCORE_FIELDS_GROUPS = [
                this.revenueGroup,
                this.ebitdaGroup,
                this.marketGroup,
                this.fcfGroup,
                this.customerConcentration,
                this.other
            ];
            this.COMPARE_FIELDS_GROUPS = [
                this.overviewGroup,
                this.revenueGroup,
                this.ebitdaGroup,
                this.marketGroup,
                this.fcfGroup,
                this.customerConcentration,
                this.other
            ];
        }
        get_local_rule(sectonId, fieldName) {
            return this.rules[sectonId].rules.find((rule)=>rule.field === fieldName);
        }
        update_rules(data) {
            this.rules = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep($9b879bbdd76f7296$var$scoreRulesCopy);
            for(var sectionId in data){
                const section = data[sectionId];
                const pick = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).pick(section, [
                    "sectionName",
                    "section_worth"
                ]);
                Object.assign(this.rules[sectionId], pick);
                if (section.rules) for (var ruleUpdates of section.rules){
                    var localRule = this.get_local_rule(sectionId, ruleUpdates.field);
                    if (localRule) Object.assign(localRule, ruleUpdates);
                }
            }
            this.setupGroups();
        }
        get SCORE_FIELDS_GROUPS() {
            return $9b879bbdd76f7296$var$__classPrivateFieldGet(this, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, "f");
        }
        set SCORE_FIELDS_GROUPS(value) {
            $9b879bbdd76f7296$var$__classPrivateFieldSet(this, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage, value, "f");
        }
        get COMPARE_FIELDS_GROUPS() {
            return $9b879bbdd76f7296$var$__classPrivateFieldGet(this, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage, "f");
        }
        set COMPARE_FIELDS_GROUPS(value) {
            $9b879bbdd76f7296$var$__classPrivateFieldSet(this, _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage, value, "f");
        }
    }, _ScoreRulesStore_SCORE_FIELDS_GROUPS_accessor_storage = new WeakMap(), _ScoreRulesStore_COMPARE_FIELDS_GROUPS_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _SCORE_FIELDS_GROUPS_decorators = [
            (0, $T5IcR.observable)
        ];
        _COMPARE_FIELDS_GROUPS_decorators = [
            (0, $T5IcR.observable)
        ];
        $9b879bbdd76f7296$var$__esDecorate(_a, null, _SCORE_FIELDS_GROUPS_decorators, {
            kind: "accessor",
            name: "SCORE_FIELDS_GROUPS",
            static: false,
            private: false,
            access: {
                has: (obj)=>"SCORE_FIELDS_GROUPS" in obj,
                get: (obj)=>obj.SCORE_FIELDS_GROUPS,
                set: (obj, value)=>{
                    obj.SCORE_FIELDS_GROUPS = value;
                }
            },
            metadata: _metadata
        }, _SCORE_FIELDS_GROUPS_initializers, _SCORE_FIELDS_GROUPS_extraInitializers);
        $9b879bbdd76f7296$var$__esDecorate(_a, null, _COMPARE_FIELDS_GROUPS_decorators, {
            kind: "accessor",
            name: "COMPARE_FIELDS_GROUPS",
            static: false,
            private: false,
            access: {
                has: (obj)=>"COMPARE_FIELDS_GROUPS" in obj,
                get: (obj)=>obj.COMPARE_FIELDS_GROUPS,
                set: (obj, value)=>{
                    obj.COMPARE_FIELDS_GROUPS = value;
                }
            },
            metadata: _metadata
        }, _COMPARE_FIELDS_GROUPS_initializers, _COMPARE_FIELDS_GROUPS_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $9b879bbdd76f7296$var$scoringDataStore = new $9b879bbdd76f7296$var$ScoreRulesStore();
const $9b879bbdd76f7296$export$5bbef306d29b8236 = ()=>{
    return $9b879bbdd76f7296$var$scoringDataStore;
};
const $9b879bbdd76f7296$export$f65e0b130162f295 = ()=>{
    return $9b879bbdd76f7296$var$scoringDataStore.rules;
};
$9b879bbdd76f7296$var$scoringDataStore.init();


var $3d71a0e5fc49a3ca$exports = {};
/*global window, global*/ 
var $eqWSa = parcelRequire("eqWSa");

var $gpaur = parcelRequire("gpaur");
function $3d71a0e5fc49a3ca$var$now() {
    return new Date().getTime();
}
var $3d71a0e5fc49a3ca$var$slice = Array.prototype.slice;
var $3d71a0e5fc49a3ca$var$console;
var $3d71a0e5fc49a3ca$var$times = {};
if (typeof $parcel$global !== "undefined" && $parcel$global.console) $3d71a0e5fc49a3ca$var$console = $parcel$global.console;
else if (typeof window !== "undefined" && window.console) $3d71a0e5fc49a3ca$var$console = window.console;
else $3d71a0e5fc49a3ca$var$console = {};
var $3d71a0e5fc49a3ca$var$functions = [
    [
        $3d71a0e5fc49a3ca$var$log,
        "log"
    ],
    [
        $3d71a0e5fc49a3ca$var$info,
        "info"
    ],
    [
        $3d71a0e5fc49a3ca$var$warn,
        "warn"
    ],
    [
        $3d71a0e5fc49a3ca$var$error,
        "error"
    ],
    [
        $3d71a0e5fc49a3ca$var$time,
        "time"
    ],
    [
        $3d71a0e5fc49a3ca$var$timeEnd,
        "timeEnd"
    ],
    [
        $3d71a0e5fc49a3ca$var$trace,
        "trace"
    ],
    [
        $3d71a0e5fc49a3ca$var$dir,
        "dir"
    ],
    [
        $3d71a0e5fc49a3ca$var$consoleAssert,
        "assert"
    ]
];
for(var $3d71a0e5fc49a3ca$var$i = 0; $3d71a0e5fc49a3ca$var$i < $3d71a0e5fc49a3ca$var$functions.length; $3d71a0e5fc49a3ca$var$i++){
    var $3d71a0e5fc49a3ca$var$tuple = $3d71a0e5fc49a3ca$var$functions[$3d71a0e5fc49a3ca$var$i];
    var $3d71a0e5fc49a3ca$var$f = $3d71a0e5fc49a3ca$var$tuple[0];
    var $3d71a0e5fc49a3ca$var$name = $3d71a0e5fc49a3ca$var$tuple[1];
    if (!$3d71a0e5fc49a3ca$var$console[$3d71a0e5fc49a3ca$var$name]) $3d71a0e5fc49a3ca$var$console[$3d71a0e5fc49a3ca$var$name] = $3d71a0e5fc49a3ca$var$f;
}
$3d71a0e5fc49a3ca$exports = $3d71a0e5fc49a3ca$var$console;
function $3d71a0e5fc49a3ca$var$log() {}
function $3d71a0e5fc49a3ca$var$info() {
    $3d71a0e5fc49a3ca$var$console.log.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$warn() {
    $3d71a0e5fc49a3ca$var$console.log.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$error() {
    $3d71a0e5fc49a3ca$var$console.warn.apply($3d71a0e5fc49a3ca$var$console, arguments);
}
function $3d71a0e5fc49a3ca$var$time(label) {
    $3d71a0e5fc49a3ca$var$times[label] = $3d71a0e5fc49a3ca$var$now();
}
function $3d71a0e5fc49a3ca$var$timeEnd(label) {
    var time = $3d71a0e5fc49a3ca$var$times[label];
    if (!time) throw new Error("No such label: " + label);
    delete $3d71a0e5fc49a3ca$var$times[label];
    var duration = $3d71a0e5fc49a3ca$var$now() - time;
    $3d71a0e5fc49a3ca$var$console.log(label + ": " + duration + "ms");
}
function $3d71a0e5fc49a3ca$var$trace() {
    var err = new Error();
    err.name = "Trace";
    err.message = $eqWSa.format.apply(null, arguments);
    $3d71a0e5fc49a3ca$var$console.error(err.stack);
}
function $3d71a0e5fc49a3ca$var$dir(object) {
    $3d71a0e5fc49a3ca$var$console.log($eqWSa.inspect(object) + "\n");
}
function $3d71a0e5fc49a3ca$var$consoleAssert(expression) {
    if (!expression) {
        var arr = $3d71a0e5fc49a3ca$var$slice.call(arguments, 1);
        $gpaur.ok(false, $eqWSa.format.apply(null, arr));
    }
}


var $dfa1da4659f75e95$exports = {};
var $557b93ccd0374a02$exports = {};
$557b93ccd0374a02$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAsnokt7beqnidxzHpDU1yc3GFrzmq9yy0\",\"authDomain\":\"flightline-madison-prod.firebaseapp.com\",\"databaseURL\":\"https://flightline-madison-prod-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-madison-prod\",\"storageBucket\":\"flightline-madison-prod.firebasestorage.app\",\"messagingSenderId\":\"161215752472\",\"appId\":\"1:161215752472:web:0057d401a28dfa95ad566d\"},\"clientName\":\"25madison\",\"pdfViewerKey\":\"384fff5edfe5436e8177480ebd9667f0\",\"domains\":[\"25madison.flightlinedata.com\"]}");


var $38bc86d03fb49fee$exports = {};
$38bc86d03fb49fee$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyBQCCIPH1ZmKj_p_VlVG4DD5Y2lmyBByvs\",\"authDomain\":\"flightline-demo.firebaseapp.com\",\"projectId\":\"flightline-demo\",\"storageBucket\":\"flightline-demo.firebasestorage.app\",\"messagingSenderId\":\"377745278229\",\"appId\":\"1:377745278229:web:6a4256d4458f250513151c\"},\"clientName\":\"Demo Environment\",\"pdfViewerKey\":\"2ce4cb9a26e04ebd93556687712fe3db\",\"domains\":[\"flightline-demo.web.app\"]}");


var $c84686120c01498e$exports = {};
$c84686120c01498e$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyC8tivPreytHdsXxrppU-fnlH2fpmb8Pio\",\"authDomain\":\"flightline-demo-dev.firebaseapp.com\",\"databaseURL\":\"https://flightline-demo-dev-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-demo-dev\",\"storageBucket\":\"flightline-demo-dev.firebasestorage.app\",\"messagingSenderId\":\"321215760873\",\"appId\":\"1:321215760873:web:0785adbdf7b1f9eb85e378\"},\"clientName\":\"Demo\",\"pdfViewerKey\":\"b6e99a26b87f41d8b9b559f10c557346\",\"domains\":[\"flightline-demo-dev.web.app\"]}");


var $33b70b8fe3d0fa23$exports = {};
$33b70b8fe3d0fa23$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAG_1nlPDL1utbsxzUPZgncxCtY45SW5Ww\",\"authDomain\":\"flightline-harvest-prod.firebaseapp.com\",\"databaseURL\":\"https://flightline-harvest-prod-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-harvest-prod\",\"storageBucket\":\"flightline-harvest-prod.firebasestorage.app\",\"messagingSenderId\":\"12613364577\",\"appId\":\"1:12613364577:web:a309dd555dc824f5cdb320\"},\"clientName\":\"Harvest\",\"pdfViewerKey\":\"dfc1f220ecc745298858395864414c6a\",\"domains\":[\"harvest.flightlinedata.com\"]}");


var $00130a4904f2fceb$exports = {};
$00130a4904f2fceb$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyBlIM4LtpCaonZkHKar-QGAh1oaHAgKgEI\",\"authDomain\":\"flightline-odyssey-1823e.firebaseapp.com\",\"databaseURL\":\"https://flightline-odyssey-1823e-default-rtdb.firebaseio.com\",\"projectId\":\"flightline-odyssey-1823e\",\"storageBucket\":\"flightline-odyssey-1823e.firebasestorage.app\",\"messagingSenderId\":\"638860155\",\"appId\":\"1:638860155:web:18c31de9ef7a84fcc6dbde\"},\"clientName\":\"Odyssey\",\"pdfViewerKey\":\"677c18f9b10f46dc9a3380def61a81ab\",\"domains\":[\"flightline-odyssey-1823e.web.app\"]}");


var $4d2c22d24cb4b027$exports = {};
$4d2c22d24cb4b027$exports = JSON.parse("{\"firebase\":{\"apiKey\":\"AIzaSyAH49TGtYOjC2IA3L2QwP6BzTpUxkIdczg\",\"authDomain\":\"testing-flightline.firebaseapp.com\",\"projectId\":\"testing-flightline\",\"storageBucket\":\"testing-flightline.firebasestorage.app\",\"messagingSenderId\":\"601730080387\",\"appId\":\"1:601730080387:web:fb19d4cf586d164560c5b6\"},\"clientName\":\"Testing Environment\",\"pdfViewerKey\":\"d4b849d50ed5483c8bf51f2b390223c6\",\"domains\":[\"testing-flightline.web.app\"]}");


$dfa1da4659f75e95$exports = {
    "25madison": $557b93ccd0374a02$exports,
    "demo": $38bc86d03fb49fee$exports,
    "dev": $c84686120c01498e$exports,
    "harvest": $33b70b8fe3d0fa23$exports,
    "odyssey": $00130a4904f2fceb$exports,
    "testing": $4d2c22d24cb4b027$exports
};


class $3d79bba9fc178656$var$ConfigStore {
    constructor(){
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.config = this.getConfigByHostname();
        (0, $3d71a0e5fc49a3ca$exports.assert)(this.config, 'Config not found');
    }
    getConfig() {
        return this.getConfigByHostname();
    }
    getConfigByHostname() {
        const host = window.location.hostname;
        for(const key in $dfa1da4659f75e95$exports){
            const config = $dfa1da4659f75e95$exports[key];
            const domains = config.domains;
            if (config.domains.includes(host)) {
                console.log('Using config hostname: ', host);
                return config;
            }
        }
        return null;
    }
}
const $3d79bba9fc178656$var$configStore = new $3d79bba9fc178656$var$ConfigStore();
const $3d79bba9fc178656$export$b3611e87cd5ba6ce = ()=>{
    return $3d79bba9fc178656$var$configStore.config;
};
var $3d79bba9fc178656$export$2e2bcd8739ae039 = $3d79bba9fc178656$var$configStore;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $djlMn = parcelRequire("djlMn");
const $474ae12482b554c6$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $474ae12482b554c6$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $474ae12482b554c6$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $474ae12482b554c6$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $474ae12482b554c6$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $474ae12482b554c6$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $474ae12482b554c6$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $474ae12482b554c6$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($474ae12482b554c6$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $474ae12482b554c6$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $474ae12482b554c6$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $474ae12482b554c6$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $474ae12482b554c6$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $474ae12482b554c6$var$stringToByteArray$1(str);
    return $474ae12482b554c6$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $474ae12482b554c6$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $474ae12482b554c6$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $474ae12482b554c6$export$c62426fdd000a97e = function(str) {
    try {
        return $474ae12482b554c6$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $474ae12482b554c6$export$6c40052bed430212(value) {
    return $474ae12482b554c6$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $474ae12482b554c6$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$474ae12482b554c6$var$isValidKey(prop)) continue;
        target[prop] = $474ae12482b554c6$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $474ae12482b554c6$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $474ae12482b554c6$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $474ae12482b554c6$var$getDefaultsFromGlobal = ()=>$474ae12482b554c6$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $474ae12482b554c6$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $djlMn === 'undefined' || typeof $djlMn.env === 'undefined') return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $474ae12482b554c6$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $474ae12482b554c6$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $474ae12482b554c6$export$212bb2fc580a90a8 = ()=>{
    try {
        return $474ae12482b554c6$var$getDefaultsFromGlobal() || $474ae12482b554c6$var$getDefaultsFromEnvVariable() || $474ae12482b554c6$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $474ae12482b554c6$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $474ae12482b554c6$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $474ae12482b554c6$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $474ae12482b554c6$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $474ae12482b554c6$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $474ae12482b554c6$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $474ae12482b554c6$export$4b5284a3025a455(JSON.stringify(header)),
        $474ae12482b554c6$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $474ae12482b554c6$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $474ae12482b554c6$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($474ae12482b554c6$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $474ae12482b554c6$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $474ae12482b554c6$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $474ae12482b554c6$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $474ae12482b554c6$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $474ae12482b554c6$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $474ae12482b554c6$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $474ae12482b554c6$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $474ae12482b554c6$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $474ae12482b554c6$export$f2f6a8999f8ebd30() {
    return $474ae12482b554c6$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $474ae12482b554c6$export$7e7b1a9668aaed8() {
    const ua = $474ae12482b554c6$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $474ae12482b554c6$export$202944b2d2824246() {
    return $474ae12482b554c6$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $474ae12482b554c6$export$5d1d834fbbf8bab7() {
    return $474ae12482b554c6$export$588c7fdda06fbb0a.NODE_CLIENT === true || $474ae12482b554c6$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $474ae12482b554c6$export$95df08bae54cb4df() {
    return !$474ae12482b554c6$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $474ae12482b554c6$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $474ae12482b554c6$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $474ae12482b554c6$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $474ae12482b554c6$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $474ae12482b554c6$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $474ae12482b554c6$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $474ae12482b554c6$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $474ae12482b554c6$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $474ae12482b554c6$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $474ae12482b554c6$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $474ae12482b554c6$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $474ae12482b554c6$var$replaceTemplate(template, data) {
    return template.replace($474ae12482b554c6$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $474ae12482b554c6$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $474ae12482b554c6$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $474ae12482b554c6$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $474ae12482b554c6$export$c5a53ce6a17cf18d($474ae12482b554c6$export$c62426fdd000a97e(parts[0]) || '');
        claims = $474ae12482b554c6$export$c5a53ce6a17cf18d($474ae12482b554c6$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$5f870fcca7ae6a88 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$701c661ec91095f2 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $474ae12482b554c6$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $474ae12482b554c6$export$fc970ed23da99565 = function(token) {
    const claims = $474ae12482b554c6$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $474ae12482b554c6$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $474ae12482b554c6$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $474ae12482b554c6$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $474ae12482b554c6$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($474ae12482b554c6$var$isObject(aProp) && $474ae12482b554c6$var$isObject(bProp)) {
            if (!$474ae12482b554c6$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $474ae12482b554c6$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $474ae12482b554c6$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $474ae12482b554c6$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $474ae12482b554c6$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $474ae12482b554c6$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $474ae12482b554c6$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $474ae12482b554c6$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $474ae12482b554c6$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $474ae12482b554c6$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $474ae12482b554c6$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($474ae12482b554c6$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $474ae12482b554c6$var$noop;
        if (observer.error === undefined) observer.error = $474ae12482b554c6$var$noop;
        if (observer.complete === undefined) observer.complete = $474ae12482b554c6$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $474ae12482b554c6$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $474ae12482b554c6$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $474ae12482b554c6$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $474ae12482b554c6$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $474ae12482b554c6$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $474ae12482b554c6$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $474ae12482b554c6$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $474ae12482b554c6$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($474ae12482b554c6$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $474ae12482b554c6$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $474ae12482b554c6$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $474ae12482b554c6$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $474ae12482b554c6$export$abe4376e1bf796d6 = function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $474ae12482b554c6$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $474ae12482b554c6$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $474ae12482b554c6$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $474ae12482b554c6$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $474ae12482b554c6$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $474ae12482b554c6$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $474ae12482b554c6$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $474ae12482b554c6$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($474ae12482b554c6$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $474ae12482b554c6$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $474ae12482b554c6$var$indicator(i);
}
function $474ae12482b554c6$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $474ae12482b554c6$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $51d4719ad519d4e6$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $51d4719ad519d4e6$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($51d4719ad519d4e6$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $51d4719ad519d4e6$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $51d4719ad519d4e6$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $51d4719ad519d4e6$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $51d4719ad519d4e6$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $51d4719ad519d4e6$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $51d4719ad519d4e6$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $6cbcb85fb6f607fa$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $6cbcb85fb6f607fa$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($6cbcb85fb6f607fa$export$243e62d78d3b544d || ($6cbcb85fb6f607fa$export$243e62d78d3b544d = {}));
const $6cbcb85fb6f607fa$var$levelStringToEnum = {
    'debug': $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG,
    'verbose': $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE,
    'info': $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO,
    'warn': $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN,
    'error': $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR,
    'silent': $6cbcb85fb6f607fa$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $6cbcb85fb6f607fa$var$defaultLogLevel = $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $6cbcb85fb6f607fa$var$ConsoleMethod = {
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG]: 'log',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO]: 'info',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN]: 'warn',
    [$6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $6cbcb85fb6f607fa$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $6cbcb85fb6f607fa$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $6cbcb85fb6f607fa$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $6cbcb85fb6f607fa$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $6cbcb85fb6f607fa$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $6cbcb85fb6f607fa$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $6cbcb85fb6f607fa$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $6cbcb85fb6f607fa$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $6cbcb85fb6f607fa$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $6cbcb85fb6f607fa$export$c622e99c0ce7b1c9(level) {
    $6cbcb85fb6f607fa$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $6cbcb85fb6f607fa$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $6cbcb85fb6f607fa$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $6cbcb85fb6f607fa$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $6cbcb85fb6f607fa$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $d1e222ab0dd68be4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $d1e222ab0dd68be4$var$idbProxyableTypes;
let $d1e222ab0dd68be4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $d1e222ab0dd68be4$var$getIdbProxyableTypes() {
    return $d1e222ab0dd68be4$var$idbProxyableTypes || ($d1e222ab0dd68be4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $d1e222ab0dd68be4$var$getCursorAdvanceMethods() {
    return $d1e222ab0dd68be4$var$cursorAdvanceMethods || ($d1e222ab0dd68be4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $d1e222ab0dd68be4$var$cursorRequestMap = new WeakMap();
const $d1e222ab0dd68be4$var$transactionDoneMap = new WeakMap();
const $d1e222ab0dd68be4$var$transactionStoreNamesMap = new WeakMap();
const $d1e222ab0dd68be4$var$transformCache = new WeakMap();
const $d1e222ab0dd68be4$export$407448d2b89b1813 = new WeakMap();
function $d1e222ab0dd68be4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($d1e222ab0dd68be4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $d1e222ab0dd68be4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $d1e222ab0dd68be4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $d1e222ab0dd68be4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($d1e222ab0dd68be4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $d1e222ab0dd68be4$var$transactionDoneMap.set(tx, done);
}
let $d1e222ab0dd68be4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $d1e222ab0dd68be4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $d1e222ab0dd68be4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $d1e222ab0dd68be4$export$43caf9889c228507(callback) {
    $d1e222ab0dd68be4$var$idbProxyTraps = callback($d1e222ab0dd68be4$var$idbProxyTraps);
}
function $d1e222ab0dd68be4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($d1e222ab0dd68be4$export$3b14a55fb2447963(this), storeNames, ...args);
        $d1e222ab0dd68be4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($d1e222ab0dd68be4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($d1e222ab0dd68be4$export$3b14a55fb2447963(this), args);
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b($d1e222ab0dd68be4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $d1e222ab0dd68be4$export$efccba1c4a2ef57b(func.apply($d1e222ab0dd68be4$export$3b14a55fb2447963(this), args));
    };
}
function $d1e222ab0dd68be4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $d1e222ab0dd68be4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $d1e222ab0dd68be4$var$cacheDonePromiseForTransaction(value);
    if ($d1e222ab0dd68be4$export$23f2a1d2818174ef(value, $d1e222ab0dd68be4$var$getIdbProxyableTypes())) return new Proxy(value, $d1e222ab0dd68be4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $d1e222ab0dd68be4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $d1e222ab0dd68be4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($d1e222ab0dd68be4$var$transformCache.has(value)) return $d1e222ab0dd68be4$var$transformCache.get(value);
    const newValue = $d1e222ab0dd68be4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $d1e222ab0dd68be4$var$transformCache.set(value, newValue);
        $d1e222ab0dd68be4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $d1e222ab0dd68be4$export$3b14a55fb2447963 = (value)=>$d1e222ab0dd68be4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $a2c995df3f0fbbe6$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $a2c995df3f0fbbe6$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $d1e222ab0dd68be4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $a2c995df3f0fbbe6$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $a2c995df3f0fbbe6$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $a2c995df3f0fbbe6$var$cachedMethods = new Map();
function $a2c995df3f0fbbe6$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($a2c995df3f0fbbe6$var$cachedMethods.get(prop)) return $a2c995df3f0fbbe6$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $a2c995df3f0fbbe6$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $a2c995df3f0fbbe6$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $a2c995df3f0fbbe6$var$cachedMethods.set(prop, method);
    return method;
}
(0, $d1e222ab0dd68be4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$a2c995df3f0fbbe6$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$a2c995df3f0fbbe6$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($20ed53392b3edc61$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $20ed53392b3edc61$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $20ed53392b3edc61$var$name$q = "@firebase/app";
const $20ed53392b3edc61$var$version$1 = "0.10.13";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$logger = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/app');
const $20ed53392b3edc61$var$name$p = "@firebase/app-compat";
const $20ed53392b3edc61$var$name$o = "@firebase/analytics-compat";
const $20ed53392b3edc61$var$name$n = "@firebase/analytics";
const $20ed53392b3edc61$var$name$m = "@firebase/app-check-compat";
const $20ed53392b3edc61$var$name$l = "@firebase/app-check";
const $20ed53392b3edc61$var$name$k = "@firebase/auth";
const $20ed53392b3edc61$var$name$j = "@firebase/auth-compat";
const $20ed53392b3edc61$var$name$i = "@firebase/database";
const $20ed53392b3edc61$var$name$h = "@firebase/data-connect";
const $20ed53392b3edc61$var$name$g = "@firebase/database-compat";
const $20ed53392b3edc61$var$name$f = "@firebase/functions";
const $20ed53392b3edc61$var$name$e = "@firebase/functions-compat";
const $20ed53392b3edc61$var$name$d = "@firebase/installations";
const $20ed53392b3edc61$var$name$c = "@firebase/installations-compat";
const $20ed53392b3edc61$var$name$b = "@firebase/messaging";
const $20ed53392b3edc61$var$name$a = "@firebase/messaging-compat";
const $20ed53392b3edc61$var$name$9 = "@firebase/performance";
const $20ed53392b3edc61$var$name$8 = "@firebase/performance-compat";
const $20ed53392b3edc61$var$name$7 = "@firebase/remote-config";
const $20ed53392b3edc61$var$name$6 = "@firebase/remote-config-compat";
const $20ed53392b3edc61$var$name$5 = "@firebase/storage";
const $20ed53392b3edc61$var$name$4 = "@firebase/storage-compat";
const $20ed53392b3edc61$var$name$3 = "@firebase/firestore";
const $20ed53392b3edc61$var$name$2 = "@firebase/vertexai-preview";
const $20ed53392b3edc61$var$name$1 = "@firebase/firestore-compat";
const $20ed53392b3edc61$var$name = "firebase";
const $20ed53392b3edc61$var$version = "10.14.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $20ed53392b3edc61$export$9f30fa0c10967f7f = '[DEFAULT]';
const $20ed53392b3edc61$var$PLATFORM_LOG_STRING = {
    [$20ed53392b3edc61$var$name$q]: 'fire-core',
    [$20ed53392b3edc61$var$name$p]: 'fire-core-compat',
    [$20ed53392b3edc61$var$name$n]: 'fire-analytics',
    [$20ed53392b3edc61$var$name$o]: 'fire-analytics-compat',
    [$20ed53392b3edc61$var$name$l]: 'fire-app-check',
    [$20ed53392b3edc61$var$name$m]: 'fire-app-check-compat',
    [$20ed53392b3edc61$var$name$k]: 'fire-auth',
    [$20ed53392b3edc61$var$name$j]: 'fire-auth-compat',
    [$20ed53392b3edc61$var$name$i]: 'fire-rtdb',
    [$20ed53392b3edc61$var$name$h]: 'fire-data-connect',
    [$20ed53392b3edc61$var$name$g]: 'fire-rtdb-compat',
    [$20ed53392b3edc61$var$name$f]: 'fire-fn',
    [$20ed53392b3edc61$var$name$e]: 'fire-fn-compat',
    [$20ed53392b3edc61$var$name$d]: 'fire-iid',
    [$20ed53392b3edc61$var$name$c]: 'fire-iid-compat',
    [$20ed53392b3edc61$var$name$b]: 'fire-fcm',
    [$20ed53392b3edc61$var$name$a]: 'fire-fcm-compat',
    [$20ed53392b3edc61$var$name$9]: 'fire-perf',
    [$20ed53392b3edc61$var$name$8]: 'fire-perf-compat',
    [$20ed53392b3edc61$var$name$7]: 'fire-rc',
    [$20ed53392b3edc61$var$name$6]: 'fire-rc-compat',
    [$20ed53392b3edc61$var$name$5]: 'fire-gcs',
    [$20ed53392b3edc61$var$name$4]: 'fire-gcs-compat',
    [$20ed53392b3edc61$var$name$3]: 'fire-fst',
    [$20ed53392b3edc61$var$name$1]: 'fire-fst-compat',
    [$20ed53392b3edc61$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$20ed53392b3edc61$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $20ed53392b3edc61$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $20ed53392b3edc61$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $20ed53392b3edc61$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $20ed53392b3edc61$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $20ed53392b3edc61$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $20ed53392b3edc61$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $20ed53392b3edc61$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($20ed53392b3edc61$export$9566bce3835c0f28.has(componentName)) {
        $20ed53392b3edc61$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $20ed53392b3edc61$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $20ed53392b3edc61$export$b4e3c36c855b14b5.values())$20ed53392b3edc61$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $20ed53392b3edc61$export$fb03ad8d3d5c5f76.values())$20ed53392b3edc61$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $20ed53392b3edc61$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $20ed53392b3edc61$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $20ed53392b3edc61$export$9f30fa0c10967f7f) {
    $20ed53392b3edc61$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $20ed53392b3edc61$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $20ed53392b3edc61$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $20ed53392b3edc61$export$3685d89b9c3cdfaf() {
    $20ed53392b3edc61$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $20ed53392b3edc61$var$ERROR_FACTORY = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('app', 'Firebase', $20ed53392b3edc61$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $20ed53392b3edc61$var$FirebaseServerAppImpl extends $20ed53392b3edc61$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $20ed53392b3edc61$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $20ed53392b3edc61$export$31499a9cd224b78c = $20ed53392b3edc61$var$version;
function $20ed53392b3edc61$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $20ed53392b3edc61$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $474ae12482b554c6$export$3dfb6827a9f89756)());
    if (!options) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $20ed53392b3edc61$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $474ae12482b554c6$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $474ae12482b554c6$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $20ed53392b3edc61$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)(name);
    for (const component of $20ed53392b3edc61$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20ed53392b3edc61$var$FirebaseAppImpl(options, config, container);
    $20ed53392b3edc61$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $20ed53392b3edc61$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $474ae12482b554c6$export$4e09c449d6c407f7)() && !(0, $474ae12482b554c6$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $20ed53392b3edc61$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($20ed53392b3edc61$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $20ed53392b3edc61$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $20ed53392b3edc61$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)(nameString);
    for (const component of $20ed53392b3edc61$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $20ed53392b3edc61$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $20ed53392b3edc61$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $20ed53392b3edc61$export$f9962582c9e66d99(name = $20ed53392b3edc61$export$9f30fa0c10967f7f) {
    const app = $20ed53392b3edc61$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $20ed53392b3edc61$export$9f30fa0c10967f7f && (0, $474ae12482b554c6$export$3dfb6827a9f89756)()) return $20ed53392b3edc61$export$c55cfd413944906d();
    if (!app) throw $20ed53392b3edc61$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $20ed53392b3edc61$export$68ddedf7d44b3bdf() {
    return Array.from($20ed53392b3edc61$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $20ed53392b3edc61$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($20ed53392b3edc61$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $20ed53392b3edc61$export$b4e3c36c855b14b5.delete(name);
    } else if ($20ed53392b3edc61$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $20ed53392b3edc61$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $20ed53392b3edc61$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $20ed53392b3edc61$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $20ed53392b3edc61$var$logger.warn(warning.join(' '));
        return;
    }
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $20ed53392b3edc61$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $20ed53392b3edc61$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $6cbcb85fb6f607fa$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $20ed53392b3edc61$export$c622e99c0ce7b1c9(logLevel) {
    (0, $6cbcb85fb6f607fa$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$DB_NAME = 'firebase-heartbeat-database';
const $20ed53392b3edc61$var$DB_VERSION = 1;
const $20ed53392b3edc61$var$STORE_NAME = 'firebase-heartbeat-store';
let $20ed53392b3edc61$var$dbPromise = null;
function $20ed53392b3edc61$var$getDbPromise() {
    if (!$20ed53392b3edc61$var$dbPromise) $20ed53392b3edc61$var$dbPromise = (0, $a2c995df3f0fbbe6$export$ca0ed41b1a2af7e)($20ed53392b3edc61$var$DB_NAME, $20ed53392b3edc61$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($20ed53392b3edc61$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $20ed53392b3edc61$var$dbPromise;
}
async function $20ed53392b3edc61$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $20ed53392b3edc61$var$getDbPromise();
        const tx = db.transaction($20ed53392b3edc61$var$STORE_NAME);
        const result = await tx.objectStore($20ed53392b3edc61$var$STORE_NAME).get($20ed53392b3edc61$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) $20ed53392b3edc61$var$logger.warn(e.message);
        else {
            const idbGetError = $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20ed53392b3edc61$var$logger.warn(idbGetError.message);
        }
    }
}
async function $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $20ed53392b3edc61$var$getDbPromise();
        const tx = db.transaction($20ed53392b3edc61$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($20ed53392b3edc61$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $20ed53392b3edc61$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) $20ed53392b3edc61$var$logger.warn(e.message);
        else {
            const idbGetError = $20ed53392b3edc61$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $20ed53392b3edc61$var$logger.warn(idbGetError.message);
        }
    }
}
function $20ed53392b3edc61$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20ed53392b3edc61$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $20ed53392b3edc61$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $20ed53392b3edc61$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $20ed53392b3edc61$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $20ed53392b3edc61$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $20ed53392b3edc61$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $20ed53392b3edc61$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $20ed53392b3edc61$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $20ed53392b3edc61$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $474ae12482b554c6$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $20ed53392b3edc61$var$logger.warn(e);
            return '';
        }
    }
}
function $20ed53392b3edc61$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $20ed53392b3edc61$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $20ed53392b3edc61$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($20ed53392b3edc61$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($20ed53392b3edc61$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $20ed53392b3edc61$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $474ae12482b554c6$export$3865db50535c2055)()) return false;
        else return (0, $474ae12482b554c6$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $20ed53392b3edc61$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $20ed53392b3edc61$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $20ed53392b3edc61$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $474ae12482b554c6$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $20ed53392b3edc61$var$registerCoreComponents(variant) {
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('platform-logger', (container)=>new $20ed53392b3edc61$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $20ed53392b3edc61$export$c930050e7bb63965(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('heartbeat', (container)=>new $20ed53392b3edc61$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $20ed53392b3edc61$export$d29d5299a7137abc($20ed53392b3edc61$var$name$q, $20ed53392b3edc61$var$version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    $20ed53392b3edc61$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $20ed53392b3edc61$var$registerCoreComponents('');


var $de96275166ad8d09$var$name = "firebase";
var $de96275166ad8d09$var$version = "10.14.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $20ed53392b3edc61$export$d29d5299a7137abc)($de96275166ad8d09$var$name, $de96275166ad8d09$var$version, 'app');





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $7c9d35c24923c1be$var$extendStatics = function(d, b) {
    $7c9d35c24923c1be$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7c9d35c24923c1be$var$extendStatics(d, b);
};
function $7c9d35c24923c1be$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7c9d35c24923c1be$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7c9d35c24923c1be$export$18ce0697a983be9b = function() {
    $7c9d35c24923c1be$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7c9d35c24923c1be$export$18ce0697a983be9b.apply(this, arguments);
};
function $7c9d35c24923c1be$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7c9d35c24923c1be$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7c9d35c24923c1be$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7c9d35c24923c1be$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $7c9d35c24923c1be$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $7c9d35c24923c1be$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $7c9d35c24923c1be$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $7c9d35c24923c1be$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7c9d35c24923c1be$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7c9d35c24923c1be$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $7c9d35c24923c1be$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $7c9d35c24923c1be$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $7c9d35c24923c1be$export$45d3717a4c69092e(o, m, p);
}
function $7c9d35c24923c1be$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7c9d35c24923c1be$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7c9d35c24923c1be$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7c9d35c24923c1be$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7c9d35c24923c1be$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7c9d35c24923c1be$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $7c9d35c24923c1be$export$10c90e4f7922046c(v) {
    return this instanceof $7c9d35c24923c1be$export$10c90e4f7922046c ? (this.v = v, this) : new $7c9d35c24923c1be$export$10c90e4f7922046c(v);
}
function $7c9d35c24923c1be$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7c9d35c24923c1be$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7c9d35c24923c1be$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7c9d35c24923c1be$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $7c9d35c24923c1be$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7c9d35c24923c1be$export$19a8beecd37a4c45 === "function" ? $7c9d35c24923c1be$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7c9d35c24923c1be$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $7c9d35c24923c1be$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $7c9d35c24923c1be$var$ownKeys = function(o) {
    $7c9d35c24923c1be$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $7c9d35c24923c1be$var$ownKeys(o);
};
function $7c9d35c24923c1be$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $7c9d35c24923c1be$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $7c9d35c24923c1be$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $7c9d35c24923c1be$var$__setModuleDefault(result, mod);
    return result;
}
function $7c9d35c24923c1be$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7c9d35c24923c1be$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $7c9d35c24923c1be$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $7c9d35c24923c1be$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $7c9d35c24923c1be$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $7c9d35c24923c1be$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $7c9d35c24923c1be$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $7c9d35c24923c1be$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $7c9d35c24923c1be$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $7c9d35c24923c1be$export$2e2bcd8739ae039 = {
    __extends: $7c9d35c24923c1be$export$a8ba968b8961cb8a,
    __assign: $7c9d35c24923c1be$export$18ce0697a983be9b,
    __rest: $7c9d35c24923c1be$export$3c9a16f847548506,
    __decorate: $7c9d35c24923c1be$export$29e00dfd3077644b,
    __param: $7c9d35c24923c1be$export$d5ad3fd78186038f,
    __esDecorate: $7c9d35c24923c1be$export$3a84e1ae4e97e9b0,
    __runInitializers: $7c9d35c24923c1be$export$d831c04e792af3d,
    __propKey: $7c9d35c24923c1be$export$6a2a36740a146cb8,
    __setFunctionName: $7c9d35c24923c1be$export$d1a06452d3489bc7,
    __metadata: $7c9d35c24923c1be$export$f1db080c865becb9,
    __awaiter: $7c9d35c24923c1be$export$1050f835b63b671e,
    __generator: $7c9d35c24923c1be$export$67ebef60e6f28a6,
    __createBinding: $7c9d35c24923c1be$export$45d3717a4c69092e,
    __exportStar: $7c9d35c24923c1be$export$f33643c0debef087,
    __values: $7c9d35c24923c1be$export$19a8beecd37a4c45,
    __read: $7c9d35c24923c1be$export$8d051b38c9118094,
    __spread: $7c9d35c24923c1be$export$afc72e2116322959,
    __spreadArrays: $7c9d35c24923c1be$export$6388937ca91ccae8,
    __spreadArray: $7c9d35c24923c1be$export$1216008129fb82ed,
    __await: $7c9d35c24923c1be$export$10c90e4f7922046c,
    __asyncGenerator: $7c9d35c24923c1be$export$e427f37a30a4de9b,
    __asyncDelegator: $7c9d35c24923c1be$export$bbd80228419bb833,
    __asyncValues: $7c9d35c24923c1be$export$e3b29a3d6162315f,
    __makeTemplateObject: $7c9d35c24923c1be$export$4fb47efe1390b86f,
    __importStar: $7c9d35c24923c1be$export$c21735bcef00d192,
    __importDefault: $7c9d35c24923c1be$export$da59b14a69baef04,
    __classPrivateFieldGet: $7c9d35c24923c1be$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $7c9d35c24923c1be$export$d40a35129aaff81f,
    __classPrivateFieldIn: $7c9d35c24923c1be$export$81fdc39f203e4e04,
    __addDisposableResource: $7c9d35c24923c1be$export$88ac25d8e944e405,
    __disposeResources: $7c9d35c24923c1be$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $7c9d35c24923c1be$export$889dfb5d17574b0b
};



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $402d0a489f4b5d89$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $402d0a489f4b5d89$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $402d0a489f4b5d89$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $402d0a489f4b5d89$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $402d0a489f4b5d89$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.'
    };
}
function $402d0a489f4b5d89$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $402d0a489f4b5d89$export$2329c99376c9d0a4 = $402d0a489f4b5d89$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $402d0a489f4b5d89$export$7f8ddf7c7c20b3cd = $402d0a489f4b5d89$var$_prodErrorMap;
const $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $402d0a489f4b5d89$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $402d0a489f4b5d89$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$logClient = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/auth');
function $402d0a489f4b5d89$var$_logWarn(msg, ...args) {
    if ($402d0a489f4b5d89$var$logClient.logLevel <= (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).WARN) $402d0a489f4b5d89$var$logClient.warn(`Auth (${(0, $20ed53392b3edc61$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $402d0a489f4b5d89$var$_logError(msg, ...args) {
    if ($402d0a489f4b5d89$var$logClient.logLevel <= (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).ERROR) $402d0a489f4b5d89$var$logClient.error(`Auth (${(0, $20ed53392b3edc61$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
function $402d0a489f4b5d89$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
function $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $402d0a489f4b5d89$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $402d0a489f4b5d89$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $402d0a489f4b5d89$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $402d0a489f4b5d89$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $402d0a489f4b5d89$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $402d0a489f4b5d89$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $402d0a489f4b5d89$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $402d0a489f4b5d89$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_getCurrentUrl() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || '';
}
function $402d0a489f4b5d89$var$_isHttpOrHttps() {
    return $402d0a489f4b5d89$var$_getCurrentScheme() === 'http:' || $402d0a489f4b5d89$var$_getCurrentScheme() === 'https:';
}
function $402d0a489f4b5d89$var$_getCurrentScheme() {
    var _a;
    return typeof self !== 'undefined' && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $402d0a489f4b5d89$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($402d0a489f4b5d89$var$_isHttpOrHttps() || (0, $474ae12482b554c6$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $402d0a489f4b5d89$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $402d0a489f4b5d89$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $402d0a489f4b5d89$export$1fbe638ecf81657e(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $474ae12482b554c6$export$872f8323f01d7ae0)() || (0, $474ae12482b554c6$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$402d0a489f4b5d89$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_emulatorUrl(config, path) {
    $402d0a489f4b5d89$export$1fbe638ecf81657e(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $402d0a489f4b5d89$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $402d0a489f4b5d89$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $402d0a489f4b5d89$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $402d0a489f4b5d89$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DEFAULT_API_TIMEOUT_MS = new $402d0a489f4b5d89$var$Delay(30000, 60000);
function $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $402d0a489f4b5d89$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $474ae12482b554c6$export$ac4103b836844853)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = Object.assign({
            method: method,
            headers: headers
        }, body);
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $474ae12482b554c6$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'no-referrer';
        return $402d0a489f4b5d89$export$2ed0fc6709e59212.fetch()($402d0a489f4b5d89$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $402d0a489f4b5d89$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $402d0a489f4b5d89$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $402d0a489f4b5d89$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $402d0a489f4b5d89$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $402d0a489f4b5d89$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $402d0a489f4b5d89$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $402d0a489f4b5d89$var$_emulatorUrl(auth.config, base);
}
function $402d0a489f4b5d89$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $402d0a489f4b5d89$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $402d0a489f4b5d89$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $402d0a489f4b5d89$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $402d0a489f4b5d89$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $402d0a489f4b5d89$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $402d0a489f4b5d89$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $402d0a489f4b5d89$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$getRecaptchaParams(auth) {
    return (await $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $402d0a489f4b5d89$var$getRecaptchaConfig(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$deleteAccount(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $402d0a489f4b5d89$var$deleteLinkedAccounts(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $402d0a489f4b5d89$var$getAccountInfo(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $402d0a489f4b5d89$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $402d0a489f4b5d89$var$_parseToken(token);
    $402d0a489f4b5d89$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $402d0a489f4b5d89$var$utcTimestampToDateString($402d0a489f4b5d89$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase['sign_in_second_factor']) || null
    };
}
function $402d0a489f4b5d89$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $402d0a489f4b5d89$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $402d0a489f4b5d89$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $474ae12482b554c6$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $402d0a489f4b5d89$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $402d0a489f4b5d89$var$_logError('Caught error parsing JWT payload as JSON', e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $402d0a489f4b5d89$var$_tokenExpiresIn(token) {
    const parsedToken = $402d0a489f4b5d89$var$_parseToken(token);
    $402d0a489f4b5d89$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $474ae12482b554c6$export$dd24e9cd51226c56) && $402d0a489f4b5d89$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $402d0a489f4b5d89$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $402d0a489f4b5d89$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $402d0a489f4b5d89$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $402d0a489f4b5d89$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $402d0a489f4b5d89$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $402d0a489f4b5d89$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $402d0a489f4b5d89$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$d24c54395ce0c509(user) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $402d0a489f4b5d89$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $402d0a489f4b5d89$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$requestStsToken(auth, refreshToken) {
    const response = await $402d0a489f4b5d89$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $474ae12482b554c6$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $402d0a489f4b5d89$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        return $402d0a489f4b5d89$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $402d0a489f4b5d89$var$revokeToken(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $402d0a489f4b5d89$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $402d0a489f4b5d89$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $402d0a489f4b5d89$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $402d0a489f4b5d89$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $402d0a489f4b5d89$var$StsTokenManager();
        if (refreshToken) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $402d0a489f4b5d89$export$890c4ad488842ce7(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $402d0a489f4b5d89$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$assertStringOrUndefined(assertion, appName) {
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $402d0a489f4b5d89$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $402d0a489f4b5d89$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $402d0a489f4b5d89$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $402d0a489f4b5d89$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $402d0a489f4b5d89$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $402d0a489f4b5d89$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $402d0a489f4b5d89$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $402d0a489f4b5d89$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $402d0a489f4b5d89$var$_logoutIfInvalidated(this, $402d0a489f4b5d89$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $402d0a489f4b5d89$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $402d0a489f4b5d89$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$var$assertStringOrUndefined(displayName, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(email, auth.name);
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $402d0a489f4b5d89$var$assertStringOrUndefined(phoneNumber, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(photoURL, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(tenantId, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(createdAt, auth.name);
        $402d0a489f4b5d89$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $402d0a489f4b5d89$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $402d0a489f4b5d89$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $402d0a489f4b5d89$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $402d0a489f4b5d89$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $402d0a489f4b5d89$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $402d0a489f4b5d89$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$instanceCache = new Map();
function $402d0a489f4b5d89$export$158acd800e1ef08b(cls) {
    $402d0a489f4b5d89$export$1fbe638ecf81657e(cls instanceof Function, 'Expected a class definition');
    let instance = $402d0a489f4b5d89$var$instanceCache.get(cls);
    if (instance) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $402d0a489f4b5d89$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$402d0a489f4b5d89$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $402d0a489f4b5d89$export$3a6d5c9ae78a2c08 = $402d0a489f4b5d89$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $402d0a489f4b5d89$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $402d0a489f4b5d89$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $402d0a489f4b5d89$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $402d0a489f4b5d89$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $402d0a489f4b5d89$var$PersistenceUserManager($402d0a489f4b5d89$export$158acd800e1ef08b($402d0a489f4b5d89$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $402d0a489f4b5d89$export$158acd800e1ef08b($402d0a489f4b5d89$export$3a6d5c9ae78a2c08);
        const key = $402d0a489f4b5d89$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $402d0a489f4b5d89$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $402d0a489f4b5d89$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $402d0a489f4b5d89$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $402d0a489f4b5d89$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($402d0a489f4b5d89$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($402d0a489f4b5d89$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($402d0a489f4b5d89$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($402d0a489f4b5d89$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($402d0a489f4b5d89$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $402d0a489f4b5d89$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($402d0a489f4b5d89$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $402d0a489f4b5d89$var$_isFirefox(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $402d0a489f4b5d89$var$_isSafari(userAgent = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $402d0a489f4b5d89$var$_isChromeIOS(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $402d0a489f4b5d89$var$_isIEMobile(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $402d0a489f4b5d89$export$92108d983e8ee699(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $402d0a489f4b5d89$var$_isBlackBerry(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $402d0a489f4b5d89$var$_isWebOS(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $402d0a489f4b5d89$export$91c6e00c14e7e6fd(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $402d0a489f4b5d89$var$_isIOSStandalone(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    var _a;
    return $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $402d0a489f4b5d89$var$_isIE10() {
    return (0, $474ae12482b554c6$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $402d0a489f4b5d89$var$_isMobileBrowser(ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $402d0a489f4b5d89$export$d66dc83d8cfc8dd(ua) || $402d0a489f4b5d89$export$92108d983e8ee699(ua) || $402d0a489f4b5d89$var$_isWebOS(ua) || $402d0a489f4b5d89$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $402d0a489f4b5d89$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $402d0a489f4b5d89$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $402d0a489f4b5d89$var$_getBrowserName((0, $474ae12482b554c6$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$402d0a489f4b5d89$var$_getBrowserName((0, $474ae12482b554c6$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $20ed53392b3edc61$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $402d0a489f4b5d89$var$_getPasswordPolicy(auth, request = {}) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $402d0a489f4b5d89$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $402d0a489f4b5d89$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $402d0a489f4b5d89$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join('')) !== null && _c !== void 0 ? _c : '';
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $402d0a489f4b5d89$var$Subscription(this);
        this.idTokenSubscription = new $402d0a489f4b5d89$var$Subscription(this);
        this.beforeStateQueue = new $402d0a489f4b5d89$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $402d0a489f4b5d89$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $402d0a489f4b5d89$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $402d0a489f4b5d89$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $402d0a489f4b5d89$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $402d0a489f4b5d89$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $402d0a489f4b5d89$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $402d0a489f4b5d89$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $402d0a489f4b5d89$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $402d0a489f4b5d89$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(this.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($402d0a489f4b5d89$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $402d0a489f4b5d89$var$_getPasswordPolicy(this);
        const passwordPolicy = new $402d0a489f4b5d89$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $474ae12482b554c6$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $402d0a489f4b5d89$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $402d0a489f4b5d89$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $402d0a489f4b5d89$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $402d0a489f4b5d89$var$PersistenceUserManager.create(this, [
                $402d0a489f4b5d89$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $402d0a489f4b5d89$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $402d0a489f4b5d89$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $402d0a489f4b5d89$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $402d0a489f4b5d89$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $474ae12482b554c6$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $402d0a489f4b5d89$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $402d0a489f4b5d89$var$_setExternalJSProvider(p) {
    $402d0a489f4b5d89$var$externalJSProvider = p;
}
function $402d0a489f4b5d89$var$_loadJS(url) {
    return $402d0a489f4b5d89$var$externalJSProvider.loadJS(url);
}
function $402d0a489f4b5d89$var$_recaptchaV2ScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.recaptchaV2Script;
}
function $402d0a489f4b5d89$var$_recaptchaEnterpriseScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $402d0a489f4b5d89$var$_gapiScriptUrl() {
    return $402d0a489f4b5d89$var$externalJSProvider.gapiScript;
}
function $402d0a489f4b5d89$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $402d0a489f4b5d89$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $402d0a489f4b5d89$var$FAKE_TOKEN = 'NO_RECAPTCHA';
class $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $402d0a489f4b5d89$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $402d0a489f4b5d89$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $402d0a489f4b5d89$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($402d0a489f4b5d89$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($402d0a489f4b5d89$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $402d0a489f4b5d89$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $402d0a489f4b5d89$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $402d0a489f4b5d89$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $402d0a489f4b5d89$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $402d0a489f4b5d89$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $402d0a489f4b5d89$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $402d0a489f4b5d89$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $402d0a489f4b5d89$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const response = await $402d0a489f4b5d89$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $402d0a489f4b5d89$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $402d0a489f4b5d89$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $402d0a489f4b5d89$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $474ae12482b554c6$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $402d0a489f4b5d89$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($402d0a489f4b5d89$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $402d0a489f4b5d89$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $402d0a489f4b5d89$var$extractProtocol(url);
    const { host: host, port: port } = $402d0a489f4b5d89$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $402d0a489f4b5d89$var$emitEmulatorWarning();
}
function $402d0a489f4b5d89$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $402d0a489f4b5d89$var$extractHostAndPort(url) {
    const protocol = $402d0a489f4b5d89$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $402d0a489f4b5d89$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $402d0a489f4b5d89$var$parsePort(port)
        };
    }
}
function $402d0a489f4b5d89$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $402d0a489f4b5d89$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $402d0a489f4b5d89$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$resetPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$updateEmailPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $402d0a489f4b5d89$var$linkEmailPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $402d0a489f4b5d89$var$applyActionCode$1(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithPassword(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$sendOobCode(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$sendEmailVerification$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$sendPasswordResetEmail$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$sendSignInLinkToEmail$1(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
async function $402d0a489f4b5d89$var$verifyAndChangeEmail(auth, request) {
    return $402d0a489f4b5d89$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithEmailLink$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$signInWithEmailLinkForLinking(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $402d0a489f4b5d89$export$3a1a48c8f6ef640e extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $402d0a489f4b5d89$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $402d0a489f4b5d89$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $402d0a489f4b5d89$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $402d0a489f4b5d89$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $402d0a489f4b5d89$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $402d0a489f4b5d89$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $402d0a489f4b5d89$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $402d0a489f4b5d89$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithIdp(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $402d0a489f4b5d89$export$a07804094c3ecf2d extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $402d0a489f4b5d89$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $402d0a489f4b5d89$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $7c9d35c24923c1be$export$3c9a16f847548506)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $402d0a489f4b5d89$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $402d0a489f4b5d89$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $474ae12482b554c6$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$sendPhoneVerificationCode(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$signInWithPhoneNumber$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
async function $402d0a489f4b5d89$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $402d0a489f4b5d89$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $402d0a489f4b5d89$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $402d0a489f4b5d89$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: 'REAUTH'
    });
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, apiRequest), $402d0a489f4b5d89$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$3722cfe417b6ed86 extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $402d0a489f4b5d89$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $402d0a489f4b5d89$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $402d0a489f4b5d89$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $402d0a489f4b5d89$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $402d0a489f4b5d89$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $402d0a489f4b5d89$var$parseDeepLink(url) {
    const link = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $402d0a489f4b5d89$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $474ae12482b554c6$export$c1271ca4c8a70741)((0, $474ae12482b554c6$export$1a8408415472d8ed)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $402d0a489f4b5d89$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $402d0a489f4b5d89$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $402d0a489f4b5d89$var$parseDeepLink(link);
        try {
            return new $402d0a489f4b5d89$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $402d0a489f4b5d89$export$3b513254972cfc9c(link) {
    return $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $402d0a489f4b5d89$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $402d0a489f4b5d89$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(emailLink);
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $402d0a489f4b5d89$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $402d0a489f4b5d89$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $402d0a489f4b5d89$var$BaseOAuthProvider extends $402d0a489f4b5d89$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $402d0a489f4b5d89$export$dc98b0b04f4c7758 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $402d0a489f4b5d89$export$890c4ad488842ce7('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $402d0a489f4b5d89$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$71cec2538cb2c617 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $402d0a489f4b5d89$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $402d0a489f4b5d89$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $402d0a489f4b5d89$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$78acf4525d8a74c4 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $402d0a489f4b5d89$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $402d0a489f4b5d89$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $402d0a489f4b5d89$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $402d0a489f4b5d89$export$8743009a87fcb00f extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $402d0a489f4b5d89$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $402d0a489f4b5d89$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $402d0a489f4b5d89$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $402d0a489f4b5d89$export$f96d196f7728bb5 extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $402d0a489f4b5d89$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $402d0a489f4b5d89$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $402d0a489f4b5d89$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $402d0a489f4b5d89$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $402d0a489f4b5d89$export$71511d61b312f219 extends $402d0a489f4b5d89$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $402d0a489f4b5d89$export$890c4ad488842ce7(providerId.startsWith($402d0a489f4b5d89$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $402d0a489f4b5d89$export$f96d196f7728bb5.fromJSON(json);
        $402d0a489f4b5d89$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $402d0a489f4b5d89$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$3d8c2f653ac9d0b9 extends $402d0a489f4b5d89$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $402d0a489f4b5d89$export$a07804094c3ecf2d._fromParams({
            providerId: $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $402d0a489f4b5d89$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signUp(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $402d0a489f4b5d89$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $402d0a489f4b5d89$var$providerIdForResponse(idTokenResponse);
        const userCred = new $402d0a489f4b5d89$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $402d0a489f4b5d89$var$providerIdForResponse(response);
        return new $402d0a489f4b5d89$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $402d0a489f4b5d89$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $402d0a489f4b5d89$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $402d0a489f4b5d89$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorError extends (0, $474ae12482b554c6$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $402d0a489f4b5d89$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $402d0a489f4b5d89$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $402d0a489f4b5d89$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $402d0a489f4b5d89$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $402d0a489f4b5d89$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $402d0a489f4b5d89$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $402d0a489f4b5d89$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $402d0a489f4b5d89$var$_assertLinkedStatus(expected, user, provider) {
    await $402d0a489f4b5d89$var$_reloadWithoutSaving(user);
    const providerIds = $402d0a489f4b5d89$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $402d0a489f4b5d89$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $402d0a489f4b5d89$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $402d0a489f4b5d89$var$_parseToken(response.idToken);
        $402d0a489f4b5d89$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $402d0a489f4b5d89$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $402d0a489f4b5d89$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$3c2fa207a37baaea(auth, credential) {
    return $402d0a489f4b5d89$var$_signInWithCredential($402d0a489f4b5d89$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $402d0a489f4b5d89$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$6559d589eb85fbb6(user, credential) {
    return $402d0a489f4b5d89$var$_reauthenticate((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$signInWithCustomToken$1(auth, request) {
    return $402d0a489f4b5d89$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const response = await $402d0a489f4b5d89$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl extends $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $402d0a489f4b5d89$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl extends $402d0a489f4b5d89$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $402d0a489f4b5d89$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $402d0a489f4b5d89$var$recachePasswordPolicy(auth) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $402d0a489f4b5d89$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $402d0a489f4b5d89$var$resetPassword((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a93c5207d687da10(auth, oobCode) {
    await $402d0a489f4b5d89$var$applyActionCode$1((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const response = await $402d0a489f4b5d89$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $402d0a489f4b5d89$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $402d0a489f4b5d89$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse($402d0a489f4b5d89$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $402d0a489f4b5d89$export$c3950d9923825c02((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $402d0a489f4b5d89$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $402d0a489f4b5d89$export$555508cbc6add439(auth, email, password) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $402d0a489f4b5d89$export$3c2fa207a37baaea((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), $402d0a489f4b5d89$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $402d0a489f4b5d89$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $402d0a489f4b5d89$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $402d0a489f4b5d89$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $402d0a489f4b5d89$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $402d0a489f4b5d89$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const credential = $402d0a489f4b5d89$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $402d0a489f4b5d89$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $402d0a489f4b5d89$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $402d0a489f4b5d89$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$createAuthUri(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $402d0a489f4b5d89$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $402d0a489f4b5d89$var$_isHttpOrHttps() ? $402d0a489f4b5d89$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $402d0a489f4b5d89$var$createAuthUri((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $402d0a489f4b5d89$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $402d0a489f4b5d89$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $402d0a489f4b5d89$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$var$updateProfile$1(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(userInternal, $402d0a489f4b5d89$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $402d0a489f4b5d89$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $402d0a489f4b5d89$export$1a82df3d29112e01(user, newPassword) {
    return $402d0a489f4b5d89$var$updateEmailOrPassword((0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $402d0a489f4b5d89$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $402d0a489f4b5d89$var$_logoutIfInvalidated(user, $402d0a489f4b5d89$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $402d0a489f4b5d89$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $402d0a489f4b5d89$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $402d0a489f4b5d89$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $402d0a489f4b5d89$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $402d0a489f4b5d89$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $402d0a489f4b5d89$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $402d0a489f4b5d89$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $402d0a489f4b5d89$var$FacebookAdditionalUserInfo extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $402d0a489f4b5d89$var$GithubAdditionalUserInfo extends $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === 'string' ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $402d0a489f4b5d89$var$GoogleAdditionalUserInfo extends $402d0a489f4b5d89$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $402d0a489f4b5d89$var$TwitterAdditionalUserInfo extends $402d0a489f4b5d89$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $402d0a489f4b5d89$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $402d0a489f4b5d89$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $402d0a489f4b5d89$export$9e5f44173e64f162(auth, persistence) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$625550452a3fa3ec(auth) {
    return $402d0a489f4b5d89$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$90a7f3efeed30595(auth, password) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $402d0a489f4b5d89$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $402d0a489f4b5d89$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $402d0a489f4b5d89$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$df995fae86a55f06(auth) {
    (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ef35774e6d314e91(auth, user) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $402d0a489f4b5d89$export$e7094788287c5e9b(auth) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $402d0a489f4b5d89$export$96f57966bedc81b4(auth, token) {
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$a9c23c6ac3fc3eca(user) {
    return (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $402d0a489f4b5d89$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $402d0a489f4b5d89$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $402d0a489f4b5d89$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $402d0a489f4b5d89$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $402d0a489f4b5d89$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $402d0a489f4b5d89$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $402d0a489f4b5d89$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $402d0a489f4b5d89$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $402d0a489f4b5d89$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $402d0a489f4b5d89$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$startEnrollPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeEnrollPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$startEnrollTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeEnrollTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$withdrawMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
class $402d0a489f4b5d89$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$402d0a489f4b5d89$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $402d0a489f4b5d89$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $402d0a489f4b5d89$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $402d0a489f4b5d89$var$_logoutIfInvalidated(this.user, $402d0a489f4b5d89$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $402d0a489f4b5d89$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $402d0a489f4b5d89$export$493d36ec626b6698(user) {
    const userModular = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if (!$402d0a489f4b5d89$var$multiFactorUserCache.has(userModular)) $402d0a489f4b5d89$var$multiFactorUserCache.set(userModular, $402d0a489f4b5d89$var$MultiFactorUserImpl._fromUser(userModular));
    return $402d0a489f4b5d89$var$multiFactorUserCache.get(userModular);
}
const $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $402d0a489f4b5d89$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $402d0a489f4b5d89$var$BrowserLocalPersistence extends $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $402d0a489f4b5d89$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($402d0a489f4b5d89$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $402d0a489f4b5d89$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$402d0a489f4b5d89$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$8b22cf2602fb60ce = $402d0a489f4b5d89$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$BrowserSessionPersistence extends $402d0a489f4b5d89$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$402d0a489f4b5d89$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$407448d2b89b1813 = $402d0a489f4b5d89$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $402d0a489f4b5d89$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $402d0a489f4b5d89$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $402d0a489f4b5d89$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $402d0a489f4b5d89$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$402d0a489f4b5d89$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$export$faec65b429be379(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $402d0a489f4b5d89$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $402d0a489f4b5d89$export$faec65b429be379('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $402d0a489f4b5d89$var$_window() {
    return window;
}
function $402d0a489f4b5d89$var$_setWindowLocation(url) {
    $402d0a489f4b5d89$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$_isWorker() {
    return typeof $402d0a489f4b5d89$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $402d0a489f4b5d89$var$_window()['importScripts'] === 'function';
}
async function $402d0a489f4b5d89$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $402d0a489f4b5d89$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $402d0a489f4b5d89$var$_getWorkerGlobalScope() {
    return $402d0a489f4b5d89$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DB_NAME = 'firebaseLocalStorageDb';
const $402d0a489f4b5d89$var$DB_VERSION = 1;
const $402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $402d0a489f4b5d89$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $402d0a489f4b5d89$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $402d0a489f4b5d89$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME);
}
function $402d0a489f4b5d89$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($402d0a489f4b5d89$var$DB_NAME);
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
function $402d0a489f4b5d89$var$_openDatabase() {
    const request = indexedDB.open($402d0a489f4b5d89$var$DB_NAME, $402d0a489f4b5d89$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $402d0a489f4b5d89$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($402d0a489f4b5d89$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $402d0a489f4b5d89$var$_deleteDatabase();
                resolve(await $402d0a489f4b5d89$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $402d0a489f4b5d89$var$_putObject(db, key, value) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, true).put({
        [$402d0a489f4b5d89$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
async function $402d0a489f4b5d89$var$getObject(db, key) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, false).get(key);
    const data = await new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $402d0a489f4b5d89$var$_deleteObject(db, key) {
    const request = $402d0a489f4b5d89$var$getObjectStore(db, true).delete(key);
    return new $402d0a489f4b5d89$var$DBPromise(request).toPromise();
}
const $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS = 800;
const $402d0a489f4b5d89$var$_TRANSACTION_RETRY_COUNT = 3;
class $402d0a489f4b5d89$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $402d0a489f4b5d89$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $402d0a489f4b5d89$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $402d0a489f4b5d89$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $402d0a489f4b5d89$var$Receiver._getInstance($402d0a489f4b5d89$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $402d0a489f4b5d89$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $402d0a489f4b5d89$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $402d0a489f4b5d89$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $402d0a489f4b5d89$var$_openDatabase();
            await $402d0a489f4b5d89$var$_putObject(db, $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY, '1');
            await $402d0a489f4b5d89$var$_deleteObject(db, $402d0a489f4b5d89$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$402d0a489f4b5d89$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$402d0a489f4b5d89$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$402d0a489f4b5d89$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $402d0a489f4b5d89$var$getObjectStore(db, false).getAll();
            return new $402d0a489f4b5d89$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $402d0a489f4b5d89$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$402d0a489f4b5d89$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $402d0a489f4b5d89$export$23f2a1d2818174ef = $402d0a489f4b5d89$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$startSignInPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeSignInPhoneMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
function $402d0a489f4b5d89$var$finalizeSignInTotpMfa(auth, request) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $402d0a489f4b5d89$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$_SOLVE_TIME_MS = 500;
const $402d0a489f4b5d89$var$_EXPIRATION_TIME_MS = 60000;
const $402d0a489f4b5d89$var$_WIDGET_ID_START = 1000000000000;
class $402d0a489f4b5d89$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $402d0a489f4b5d89$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $402d0a489f4b5d89$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || '';
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $402d0a489f4b5d89$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return '';
    }
}
class $402d0a489f4b5d89$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $402d0a489f4b5d89$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $402d0a489f4b5d89$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $402d0a489f4b5d89$var$_EXPIRATION_TIME_MS);
        }, $402d0a489f4b5d89$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $402d0a489f4b5d89$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $402d0a489f4b5d89$var$_JSLOAD_CALLBACK = $402d0a489f4b5d89$var$_generateCallbackName('rcb');
const $402d0a489f4b5d89$var$NETWORK_TIMEOUT_DELAY = new $402d0a489f4b5d89$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $402d0a489f4b5d89$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $402d0a489f4b5d89$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = '') {
        $402d0a489f4b5d89$export$890c4ad488842ce7($402d0a489f4b5d89$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $402d0a489f4b5d89$var$isV2($402d0a489f4b5d89$var$_window().grecaptcha)) return Promise.resolve($402d0a489f4b5d89$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $402d0a489f4b5d89$var$_window().setTimeout(()=>{
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $402d0a489f4b5d89$var$NETWORK_TIMEOUT_DELAY.get());
            $402d0a489f4b5d89$var$_window()[$402d0a489f4b5d89$var$_JSLOAD_CALLBACK] = ()=>{
                $402d0a489f4b5d89$var$_window().clearTimeout(networkTimeout);
                delete $402d0a489f4b5d89$var$_window()[$402d0a489f4b5d89$var$_JSLOAD_CALLBACK];
                const recaptcha = $402d0a489f4b5d89$var$_window().grecaptcha;
                if (!recaptcha || !$402d0a489f4b5d89$var$isV2(recaptcha)) {
                    reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$402d0a489f4b5d89$var$_recaptchaV2ScriptUrl()}?${(0, $474ae12482b554c6$export$ac4103b836844853)({
                onload: $402d0a489f4b5d89$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $402d0a489f4b5d89$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $402d0a489f4b5d89$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $402d0a489f4b5d89$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $402d0a489f4b5d89$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $402d0a489f4b5d89$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $402d0a489f4b5d89$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $402d0a489f4b5d89$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $402d0a489f4b5d89$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $402d0a489f4b5d89$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $402d0a489f4b5d89$var$MockReCaptchaLoaderImpl() : new $402d0a489f4b5d89$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $402d0a489f4b5d89$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $402d0a489f4b5d89$export$890c4ad488842ce7($402d0a489f4b5d89$var$_isHttpOrHttps() && !$402d0a489f4b5d89$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $402d0a489f4b5d89$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $402d0a489f4b5d89$var$getRecaptchaParams(this.auth);
        $402d0a489f4b5d89$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $402d0a489f4b5d89$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $402d0a489f4b5d89$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $402d0a489f4b5d89$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(appVerifier));
    return new $402d0a489f4b5d89$var$ConfirmationResultImpl(verificationId, (cred)=>$402d0a489f4b5d89$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $402d0a489f4b5d89$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof recaptchaToken === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $402d0a489f4b5d89$export$890c4ad488842ce7(verifier.type === $402d0a489f4b5d89$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $402d0a489f4b5d89$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $402d0a489f4b5d89$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $402d0a489f4b5d89$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $402d0a489f4b5d89$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $402d0a489f4b5d89$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $402d0a489f4b5d89$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $402d0a489f4b5d89$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $402d0a489f4b5d89$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $402d0a489f4b5d89$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $402d0a489f4b5d89$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $402d0a489f4b5d89$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $402d0a489f4b5d89$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $402d0a489f4b5d89$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $402d0a489f4b5d89$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $402d0a489f4b5d89$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $402d0a489f4b5d89$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $402d0a489f4b5d89$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $402d0a489f4b5d89$export$158acd800e1ef08b(resolverOverride);
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$IdpCredential extends $402d0a489f4b5d89$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $402d0a489f4b5d89$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $402d0a489f4b5d89$var$_signIn(params) {
    return $402d0a489f4b5d89$var$_signInWithCredential(params.auth, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
function $402d0a489f4b5d89$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $402d0a489f4b5d89$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $402d0a489f4b5d89$var$_reauthenticate(user, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
async function $402d0a489f4b5d89$var$_link(params) {
    const { auth: auth, user: user } = params;
    $402d0a489f4b5d89$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $402d0a489f4b5d89$var$_link$1(user, new $402d0a489f4b5d89$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $402d0a489f4b5d89$var$_reauth;
            default:
                $402d0a489f4b5d89$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $402d0a489f4b5d89$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$var$_assertInstanceOf(auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $402d0a489f4b5d89$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $402d0a489f4b5d89$var$PopupOperation extends $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($402d0a489f4b5d89$var$PopupOperation.currentPopupAction) $402d0a489f4b5d89$var$PopupOperation.currentPopupAction.cancel();
        $402d0a489f4b5d89$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $402d0a489f4b5d89$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $402d0a489f4b5d89$export$1fbe638ecf81657e(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $402d0a489f4b5d89$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $402d0a489f4b5d89$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $402d0a489f4b5d89$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$402d0a489f4b5d89$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $402d0a489f4b5d89$var$redirectOutcomeMap = new Map();
class $402d0a489f4b5d89$var$RedirectAction extends $402d0a489f4b5d89$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $402d0a489f4b5d89$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $402d0a489f4b5d89$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $402d0a489f4b5d89$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $402d0a489f4b5d89$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $402d0a489f4b5d89$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $402d0a489f4b5d89$var$pendingRedirectKey(auth);
    const persistence = $402d0a489f4b5d89$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolver, auth) {
    return $402d0a489f4b5d89$var$resolverPersistence(resolver)._set($402d0a489f4b5d89$var$pendingRedirectKey(auth), 'true');
}
function $402d0a489f4b5d89$export$b9a6b53f9be3734() {
    $402d0a489f4b5d89$var$redirectOutcomeMap.clear();
}
function $402d0a489f4b5d89$export$a33b77bbdbb8366c(auth, result) {
    $402d0a489f4b5d89$var$redirectOutcomeMap.set(auth._key(), result);
}
function $402d0a489f4b5d89$var$resolverPersistence(resolver) {
    return $402d0a489f4b5d89$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $402d0a489f4b5d89$var$pendingRedirectKey(auth) {
    return $402d0a489f4b5d89$export$cf2f7c5792f80b46($402d0a489f4b5d89$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$2d1720544b23b823(auth, provider, resolver) {
    return $402d0a489f4b5d89$var$_signInWithRedirect(auth, provider, resolver);
}
async function $402d0a489f4b5d89$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    $402d0a489f4b5d89$var$_assertInstanceOf(auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolver);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $402d0a489f4b5d89$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $402d0a489f4b5d89$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $402d0a489f4b5d89$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $402d0a489f4b5d89$export$39b482c5e57630a8(user, provider, resolver) {
    return $402d0a489f4b5d89$var$_linkWithRedirect(user, provider, resolver);
}
async function $402d0a489f4b5d89$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(user);
    $402d0a489f4b5d89$var$_assertInstanceOf(userInternal.auth, provider, $402d0a489f4b5d89$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $402d0a489f4b5d89$var$_withDefaultResolver(userInternal.auth, resolver);
    await $402d0a489f4b5d89$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $402d0a489f4b5d89$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $402d0a489f4b5d89$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $402d0a489f4b5d89$export$35e795649ee09318(auth, resolver) {
    await $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $402d0a489f4b5d89$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $402d0a489f4b5d89$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $20ed53392b3edc61$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($402d0a489f4b5d89$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $402d0a489f4b5d89$export$a05254e7c3aeba6e(auth);
    const resolver = $402d0a489f4b5d89$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $402d0a489f4b5d89$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $402d0a489f4b5d89$var$prepareUserForRedirect(user) {
    const eventId = $402d0a489f4b5d89$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $402d0a489f4b5d89$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $402d0a489f4b5d89$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$402d0a489f4b5d89$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$402d0a489f4b5d89$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split('auth/')[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($402d0a489f4b5d89$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $402d0a489f4b5d89$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($402d0a489f4b5d89$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($402d0a489f4b5d89$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $402d0a489f4b5d89$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $402d0a489f4b5d89$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $402d0a489f4b5d89$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $402d0a489f4b5d89$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $402d0a489f4b5d89$export$3d12bd131bb975d1(auth, request = {}) {
    return $402d0a489f4b5d89$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $402d0a489f4b5d89$var$HTTP_REGEX = /^https?/;
async function $402d0a489f4b5d89$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $402d0a489f4b5d89$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($402d0a489f4b5d89$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $402d0a489f4b5d89$var$matchDomain(expected) {
    const currentUrl = $402d0a489f4b5d89$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$402d0a489f4b5d89$var$HTTP_REGEX.test(protocol)) return false;
    if ($402d0a489f4b5d89$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$NETWORK_TIMEOUT = new $402d0a489f4b5d89$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $402d0a489f4b5d89$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $402d0a489f4b5d89$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $402d0a489f4b5d89$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $402d0a489f4b5d89$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $402d0a489f4b5d89$var$resetUnloadedGapiModules();
                    reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $402d0a489f4b5d89$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $402d0a489f4b5d89$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $402d0a489f4b5d89$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $402d0a489f4b5d89$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $402d0a489f4b5d89$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $402d0a489f4b5d89$var$_loadJS(`${$402d0a489f4b5d89$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $402d0a489f4b5d89$var$cachedGApiLoader = null;
        throw error;
    });
}
let $402d0a489f4b5d89$var$cachedGApiLoader = null;
function $402d0a489f4b5d89$var$_loadGapi(auth) {
    $402d0a489f4b5d89$var$cachedGApiLoader = $402d0a489f4b5d89$var$cachedGApiLoader || $402d0a489f4b5d89$var$loadGapi(auth);
    return $402d0a489f4b5d89$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$PING_TIMEOUT = new $402d0a489f4b5d89$var$Delay(5000, 15000);
const $402d0a489f4b5d89$var$IFRAME_PATH = '__/auth/iframe';
const $402d0a489f4b5d89$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $402d0a489f4b5d89$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $402d0a489f4b5d89$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $402d0a489f4b5d89$var$getIframeUrl(auth) {
    const config = auth.config;
    $402d0a489f4b5d89$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $402d0a489f4b5d89$var$_emulatorUrl(config, $402d0a489f4b5d89$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$402d0a489f4b5d89$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $20ed53392b3edc61$export$31499a9cd224b78c)
    };
    const eid = $402d0a489f4b5d89$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $474ae12482b554c6$export$ac4103b836844853)(params).slice(1)}`;
}
async function $402d0a489f4b5d89$var$_openIframe(auth) {
    const context = await $402d0a489f4b5d89$var$_loadGapi(auth);
    const gapi1 = $402d0a489f4b5d89$var$_window().gapi;
    $402d0a489f4b5d89$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $402d0a489f4b5d89$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $402d0a489f4b5d89$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $402d0a489f4b5d89$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $402d0a489f4b5d89$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $402d0a489f4b5d89$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $402d0a489f4b5d89$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $402d0a489f4b5d89$var$DEFAULT_WIDTH = 500;
const $402d0a489f4b5d89$var$DEFAULT_HEIGHT = 600;
const $402d0a489f4b5d89$var$TARGET_BLANK = '_blank';
const $402d0a489f4b5d89$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $402d0a489f4b5d89$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $402d0a489f4b5d89$var$_open(auth, url, name, width = $402d0a489f4b5d89$var$DEFAULT_WIDTH, height = $402d0a489f4b5d89$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = Object.assign(Object.assign({}, $402d0a489f4b5d89$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $474ae12482b554c6$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $402d0a489f4b5d89$var$_isChromeIOS(ua) ? $402d0a489f4b5d89$var$TARGET_BLANK : name;
    if ($402d0a489f4b5d89$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $402d0a489f4b5d89$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($402d0a489f4b5d89$var$_isIOSStandalone(ua) && target !== '_self') {
        $402d0a489f4b5d89$var$openAsNewWindowIOS(url || '', target);
        return new $402d0a489f4b5d89$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $402d0a489f4b5d89$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $402d0a489f4b5d89$export$c03999cb2f36933f(newWin);
}
function $402d0a489f4b5d89$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $402d0a489f4b5d89$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $402d0a489f4b5d89$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $402d0a489f4b5d89$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $402d0a489f4b5d89$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $20ed53392b3edc61$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $402d0a489f4b5d89$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $474ae12482b554c6$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $402d0a489f4b5d89$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$402d0a489f4b5d89$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$402d0a489f4b5d89$var$getHandlerBase(auth)}?${(0, $474ae12482b554c6$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $402d0a489f4b5d89$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$402d0a489f4b5d89$var$WIDGET_PATH}`;
    return $402d0a489f4b5d89$var$_emulatorUrl(config, $402d0a489f4b5d89$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $402d0a489f4b5d89$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $402d0a489f4b5d89$export$407448d2b89b1813;
        this._completeRedirectFn = $402d0a489f4b5d89$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $402d0a489f4b5d89$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $402d0a489f4b5d89$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, '_initialize() not called before _openPopup()');
        const url = await $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, $402d0a489f4b5d89$var$_getCurrentUrl(), eventId);
        return $402d0a489f4b5d89$var$_open(auth, url, $402d0a489f4b5d89$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $402d0a489f4b5d89$export$28f7fcd39efa255(auth, provider, authType, $402d0a489f4b5d89$var$_getCurrentUrl(), eventId);
        $402d0a489f4b5d89$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $402d0a489f4b5d89$export$1fbe638ecf81657e(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $402d0a489f4b5d89$var$_openIframe(auth);
        const manager = new $402d0a489f4b5d89$export$24baa2b76016ce0e(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $402d0a489f4b5d89$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$402d0a489f4b5d89$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $402d0a489f4b5d89$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $402d0a489f4b5d89$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $402d0a489f4b5d89$var$_isMobileBrowser() || $402d0a489f4b5d89$var$_isSafari() || $402d0a489f4b5d89$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $402d0a489f4b5d89$export$342063e11d6c3cad = $402d0a489f4b5d89$var$BrowserPopupRedirectResolver;
class $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $402d0a489f4b5d89$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl extends $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $402d0a489f4b5d89$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $402d0a489f4b5d89$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $402d0a489f4b5d89$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $402d0a489f4b5d89$export$953cecd6e717a553.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $402d0a489f4b5d89$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $402d0a489f4b5d89$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $402d0a489f4b5d89$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl extends $402d0a489f4b5d89$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $402d0a489f4b5d89$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $402d0a489f4b5d89$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $402d0a489f4b5d89$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $402d0a489f4b5d89$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($402d0a489f4b5d89$var$_isEmptyString(accountName) || $402d0a489f4b5d89$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($402d0a489f4b5d89$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || 'unknownuser';
            if ($402d0a489f4b5d89$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $402d0a489f4b5d89$var$_isEmptyString(input) {
    return typeof input === 'undefined' || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $402d0a489f4b5d89$var$name = "@firebase/auth";
var $402d0a489f4b5d89$var$version = "1.7.9";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $402d0a489f4b5d89$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $402d0a489f4b5d89$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $402d0a489f4b5d89$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $402d0a489f4b5d89$var$registerAuth(clientPlatform) {
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $402d0a489f4b5d89$export$890c4ad488842ce7(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $402d0a489f4b5d89$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $402d0a489f4b5d89$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $402d0a489f4b5d89$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $402d0a489f4b5d89$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $402d0a489f4b5d89$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($402d0a489f4b5d89$var$name, $402d0a489f4b5d89$var$version, $402d0a489f4b5d89$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($402d0a489f4b5d89$var$name, $402d0a489f4b5d89$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $402d0a489f4b5d89$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $402d0a489f4b5d89$var$authIdTokenMaxAge = (0, $474ae12482b554c6$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $402d0a489f4b5d89$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $402d0a489f4b5d89$var$lastPostedIdToken = null;
const $402d0a489f4b5d89$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $402d0a489f4b5d89$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($402d0a489f4b5d89$var$lastPostedIdToken === idToken) return;
        $402d0a489f4b5d89$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $402d0a489f4b5d89$export$ae1af26003f05816(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)()) {
    const provider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $402d0a489f4b5d89$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $402d0a489f4b5d89$export$342063e11d6c3cad,
        persistence: [
            $402d0a489f4b5d89$export$23f2a1d2818174ef,
            $402d0a489f4b5d89$export$8b22cf2602fb60ce,
            $402d0a489f4b5d89$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $474ae12482b554c6$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $402d0a489f4b5d89$var$mintCookieFactory(authTokenSyncUrl.toString());
            $402d0a489f4b5d89$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $402d0a489f4b5d89$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $474ae12482b554c6$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $402d0a489f4b5d89$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $402d0a489f4b5d89$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName('head')) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$402d0a489f4b5d89$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $402d0a489f4b5d89$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $402d0a489f4b5d89$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$402d0a489f4b5d89$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );
















var $djlMn = parcelRequire("djlMn");
const $e0be213f695400f3$var$name = "@firebase/database";
const $e0be213f695400f3$var$version = "1.0.8";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The semver (www.semver.org) version of the SDK. */ let $e0be213f695400f3$var$SDK_VERSION = '';
/**
 * SDK_VERSION should be set before any database instance is created
 * @internal
 */ function $e0be213f695400f3$export$c9fb972242fcb3c4(version) {
    $e0be213f695400f3$var$SDK_VERSION = version;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 */ class $e0be213f695400f3$var$DOMStorageWrapper {
    /**
     * @param domStorage_ - The underlying storage object (e.g. localStorage or sessionStorage)
     */ constructor(domStorage_){
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param key - The key to save the value under
     * @param value - The value being stored, or null to remove the key.
     */ set(key, value) {
        if (value == null) this.domStorage_.removeItem(this.prefixedName_(key));
        else this.domStorage_.setItem(this.prefixedName_(key), (0, $474ae12482b554c6$export$fac44ee5b035f737)(value));
    }
    /**
     * @returns The value that was stored under this key, or null
     */ get(key) {
        const storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) return null;
        else return (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(storedVal);
    }
    remove(key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    }
    prefixedName_(name) {
        return this.prefix_ + name;
    }
    toString() {
        return this.domStorage_.toString();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 */ class $e0be213f695400f3$var$MemoryStorage {
    constructor(){
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    set(key, value) {
        if (value == null) delete this.cache_[key];
        else this.cache_[key] = value;
    }
    get(key) {
        if ((0, $474ae12482b554c6$export$2344b14b097df817)(this.cache_, key)) return this.cache_[key];
        return null;
    }
    remove(key) {
        delete this.cache_[key];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param domStorageName - Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @returns Turning off type information until a common interface is defined.
 */ const $e0be213f695400f3$var$createStoragefor = function(domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' && typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            const domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new $e0be213f695400f3$var$DOMStorageWrapper(domStorage);
        }
    } catch (e) {}
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new $e0be213f695400f3$var$MemoryStorage();
};
/** A storage object that lasts across sessions */ const $e0be213f695400f3$var$PersistentStorage = $e0be213f695400f3$var$createStoragefor('localStorage');
/** A storage object that only lasts one session */ const $e0be213f695400f3$var$SessionStorage = $e0be213f695400f3$var$createStoragefor('sessionStorage');
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$logClient = new (0, $6cbcb85fb6f607fa$export$efa9a398d6368992)('@firebase/database');
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 */ const $e0be213f695400f3$var$LUIDGenerator = function() {
    let id = 1;
    return function() {
        return id++;
    };
}();
/**
 * Sha1 hash of the input string
 * @param str - The string to hash
 * @returns {!string} The resulting hash
 */ const $e0be213f695400f3$var$sha1 = function(str) {
    const utf8Bytes = (0, $474ae12482b554c6$export$655666783217a925)(str);
    const sha1 = new (0, $474ae12482b554c6$export$c85d589bf4e25fef)();
    sha1.update(utf8Bytes);
    const sha1Bytes = sha1.digest();
    return (0, $474ae12482b554c6$export$b3b2de96497acc47).encodeByteArray(sha1Bytes);
};
const $e0be213f695400f3$var$buildLogMessage_ = function(...varArgs) {
    let message = '';
    for(let i = 0; i < varArgs.length; i++){
        const arg = varArgs[i];
        if (Array.isArray(arg) || arg && typeof arg === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        typeof arg.length === 'number') message += $e0be213f695400f3$var$buildLogMessage_.apply(null, arg);
        else if (typeof arg === 'object') message += (0, $474ae12482b554c6$export$fac44ee5b035f737)(arg);
        else message += arg;
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 */ let $e0be213f695400f3$var$logger = null;
/**
 * Flag to check for log availability on first log message
 */ let $e0be213f695400f3$var$firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param logger_ - A flag to turn on logging, or a custom logger
 * @param persistent - Whether or not to persist logging settings across refreshes
 */ const $e0be213f695400f3$var$enableLogging$1 = function(logger_, persistent) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        $e0be213f695400f3$var$logClient.logLevel = (0, $6cbcb85fb6f607fa$export$243e62d78d3b544d).VERBOSE;
        $e0be213f695400f3$var$logger = $e0be213f695400f3$var$logClient.log.bind($e0be213f695400f3$var$logClient);
        if (persistent) $e0be213f695400f3$var$SessionStorage.set('logging_enabled', true);
    } else if (typeof logger_ === 'function') $e0be213f695400f3$var$logger = logger_;
    else {
        $e0be213f695400f3$var$logger = null;
        $e0be213f695400f3$var$SessionStorage.remove('logging_enabled');
    }
};
const $e0be213f695400f3$var$log = function(...varArgs) {
    if ($e0be213f695400f3$var$firstLog_ === true) {
        $e0be213f695400f3$var$firstLog_ = false;
        if ($e0be213f695400f3$var$logger === null && $e0be213f695400f3$var$SessionStorage.get('logging_enabled') === true) $e0be213f695400f3$var$enableLogging$1(true);
    }
    if ($e0be213f695400f3$var$logger) {
        const message = $e0be213f695400f3$var$buildLogMessage_.apply(null, varArgs);
        $e0be213f695400f3$var$logger(message);
    }
};
const $e0be213f695400f3$var$logWrapper = function(prefix) {
    return function(...varArgs) {
        $e0be213f695400f3$var$log(prefix, ...varArgs);
    };
};
const $e0be213f695400f3$var$error = function(...varArgs) {
    const message = 'FIREBASE INTERNAL ERROR: ' + $e0be213f695400f3$var$buildLogMessage_(...varArgs);
    $e0be213f695400f3$var$logClient.error(message);
};
const $e0be213f695400f3$var$fatal = function(...varArgs) {
    const message = `FIREBASE FATAL ERROR: ${$e0be213f695400f3$var$buildLogMessage_(...varArgs)}`;
    $e0be213f695400f3$var$logClient.error(message);
    throw new Error(message);
};
const $e0be213f695400f3$var$warn = function(...varArgs) {
    const message = 'FIREBASE WARNING: ' + $e0be213f695400f3$var$buildLogMessage_(...varArgs);
    $e0be213f695400f3$var$logClient.warn(message);
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */ const $e0be213f695400f3$var$warnIfPageIsSecure = function() {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.protocol.indexOf('https:') !== -1) $e0be213f695400f3$var$warn("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 */ const $e0be213f695400f3$var$isInvalidJSONNumber = function(data) {
    return typeof data === 'number' && (data !== data || // NaN
    data === Number.POSITIVE_INFINITY || data === Number.NEGATIVE_INFINITY);
};
const $e0be213f695400f3$var$executeWhenDOMReady = function(fn) {
    if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)() || document.readyState === 'complete') fn();
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        let called = false;
        const wrappedFn = function() {
            if (!document.body) {
                setTimeout(wrappedFn, Math.floor(10));
                return;
            }
            if (!called) {
                called = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn, false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } else if (document.attachEvent) {
            // IE.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            document.attachEvent('onreadystatechange', ()=>{
                if (document.readyState === 'complete') wrappedFn();
            });
            // fallback to onload.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.attachEvent('onload', wrappedFn);
        // jQuery has an extra hack for IE that we could employ (based on
        // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
        // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 */ const $e0be213f695400f3$var$MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 */ const $e0be213f695400f3$var$MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 */ const $e0be213f695400f3$var$nameCompare = function(a, b) {
    if (a === b) return 0;
    else if (a === $e0be213f695400f3$var$MIN_NAME || b === $e0be213f695400f3$var$MAX_NAME) return -1;
    else if (b === $e0be213f695400f3$var$MIN_NAME || a === $e0be213f695400f3$var$MAX_NAME) return 1;
    else {
        const aAsInt = $e0be213f695400f3$var$tryParseInt(a), bAsInt = $e0be213f695400f3$var$tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
            else return -1;
        } else if (bAsInt !== null) return 1;
        else return a < b ? -1 : 1;
    }
};
/**
 * @returns {!number} comparison result.
 */ const $e0be213f695400f3$var$stringCompare = function(a, b) {
    if (a === b) return 0;
    else if (a < b) return -1;
    else return 1;
};
const $e0be213f695400f3$var$requireKey = function(key, obj) {
    if (obj && key in obj) return obj[key];
    else throw new Error('Missing required key (' + key + ') in object: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(obj));
};
const $e0be213f695400f3$var$ObjectToUniqueKey = function(obj) {
    if (typeof obj !== 'object' || obj === null) return (0, $474ae12482b554c6$export$fac44ee5b035f737)(obj);
    const keys = [];
    // eslint-disable-next-line guard-for-in
    for(const k in obj)keys.push(k);
    // Export as json, but with the keys sorted.
    keys.sort();
    let key = '{';
    for(let i = 0; i < keys.length; i++){
        if (i !== 0) key += ',';
        key += (0, $474ae12482b554c6$export$fac44ee5b035f737)(keys[i]);
        key += ':';
        key += $e0be213f695400f3$var$ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param str - The string
 * @param segsize - The maximum number of chars in the string.
 * @returns The string, split into appropriately-sized chunks
 */ const $e0be213f695400f3$var$splitStringBySize = function(str, segsize) {
    const len = str.length;
    if (len <= segsize) return [
        str
    ];
    const dataSegs = [];
    for(let c = 0; c < len; c += segsize)if (c + segsize > len) dataSegs.push(str.substring(c, len));
    else dataSegs.push(str.substring(c, c + segsize));
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param obj - The object or array to iterate over
 * @param fn - The function to apply
 */ function $e0be213f695400f3$var$each(obj, fn) {
    for(const key in obj)if (obj.hasOwnProperty(key)) fn(key, obj[key]);
}
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param v - A double
 *
 */ const $e0be213f695400f3$var$doubleToIEEE754String = function(v) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    const ebits = 11, fbits = 52;
    const bias = (1 << ebits - 1) - 1;
    let s, e, f, ln, i;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    } else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        } else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    const bits = [];
    for(i = fbits; i; i -= 1){
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for(i = ebits; i; i -= 1){
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    const str = bits.join('');
    // Return the data as a hex string. --MJL
    let hexByteString = '';
    for(i = 0; i < 64; i += 8){
        let hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1) hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 */ const $e0be213f695400f3$var$isChromeExtensionContentScript = function() {
    return !!(typeof window === 'object' && window['chrome'] && window['chrome']['extension'] && !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 */ const $e0be213f695400f3$var$isWindowsStoreApp = function() {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a JavaScript Error
 */ function $e0be213f695400f3$var$errorForServerCode(code, query) {
    let reason = 'Unknown Error';
    if (code === 'too_big') reason = "The data requested exceeds the maximum size that can be accessed with a single request.";
    else if (code === 'permission_denied') reason = "Client doesn't have permission to access the desired data.";
    else if (code === 'unavailable') reason = 'The service is unavailable';
    const error = new Error(code + ' at ' + query._path.toString() + ': ' + reason);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.code = code.toUpperCase();
    return error;
}
/**
 * Used to test for integer-looking strings
 */ const $e0be213f695400f3$var$INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
/**
 * For use in keys, the minimum possible 32-bit integer.
 */ const $e0be213f695400f3$var$INTEGER_32_MIN = -2147483648;
/**
 * For use in keys, the maximum possible 32-bit integer.
 */ const $e0be213f695400f3$var$INTEGER_32_MAX = 2147483647;
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 */ const $e0be213f695400f3$var$tryParseInt = function(str) {
    if ($e0be213f695400f3$var$INTEGER_REGEXP_.test(str)) {
        const intVal = Number(str);
        if (intVal >= $e0be213f695400f3$var$INTEGER_32_MIN && intVal <= $e0be213f695400f3$var$INTEGER_32_MAX) return intVal;
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param fn - The code to guard.
 */ const $e0be213f695400f3$var$exceptionGuard = function(fn) {
    try {
        fn();
    } catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(()=>{
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            const stack = e.stack || '';
            $e0be213f695400f3$var$warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * @returns {boolean} true if we think we're currently being crawled.
 */ const $e0be213f695400f3$var$beingCrawled = function() {
    const userAgent = typeof window === 'object' && window['navigator'] && window['navigator']['userAgent'] || '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0;
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param fn - Function to run.
 * @param time - Milliseconds to wait before running.
 * @returns The setTimeout() return value.
 */ const $e0be213f695400f3$var$setTimeoutNonBlocking = function(fn, time) {
    const timeout = setTimeout(fn, time);
    // Note: at the time of this comment, unrefTimer is under the unstable set of APIs. Run with --unstable to enable the API.
    if (typeof timeout === 'number' && // @ts-ignore Is only defined in Deno environments.
    typeof Deno !== 'undefined' && // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno['unrefTimer']) // @ts-ignore Deno and unrefTimer are only defined in Deno environments.
    Deno.unrefTimer(timeout);
    else if (typeof timeout === 'object' && timeout['unref']) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeout['unref']();
    return timeout;
};
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around AppCheck's token fetching capabilities.
 */ class $e0be213f695400f3$var$AppCheckTokenProvider {
    constructor(appName_, appCheckProvider){
        this.appName_ = appName_;
        this.appCheckProvider = appCheckProvider;
        this.appCheck = appCheckProvider === null || appCheckProvider === void 0 ? void 0 : appCheckProvider.getImmediate({
            optional: true
        });
        if (!this.appCheck) appCheckProvider === null || appCheckProvider === void 0 || appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck);
    }
    getToken(forceRefresh) {
        if (!this.appCheck) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAppCheck. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // AppCheck and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.appCheck) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.appCheck.getToken(forceRefresh);
    }
    addTokenChangeListener(listener) {
        var _a;
        (_a = this.appCheckProvider) === null || _a === void 0 || _a.get().then((appCheck)=>appCheck.addTokenListener(listener));
    }
    notifyForInvalidToken() {
        $e0be213f695400f3$var$warn(`Provided AppCheck credentials for the app named "${this.appName_}" ` + 'are invalid. This usually indicates your app was not initialized correctly.');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */ class $e0be213f695400f3$var$FirebaseAuthTokenProvider {
    constructor(appName_, firebaseOptions_, authProvider_){
        this.appName_ = appName_;
        this.firebaseOptions_ = firebaseOptions_;
        this.authProvider_ = authProvider_;
        this.auth_ = null;
        this.auth_ = authProvider_.getImmediate({
            optional: true
        });
        if (!this.auth_) authProvider_.onInit((auth)=>this.auth_ = auth);
    }
    getToken(forceRefresh) {
        if (!this.auth_) return new Promise((resolve, reject)=>{
            // Support delayed initialization of FirebaseAuth. This allows our
            // customers to initialize the RTDB SDK before initializing Firebase
            // Auth and ensures that all requests are authenticated if a token
            // becomes available before the timeout below expires.
            setTimeout(()=>{
                if (this.auth_) this.getToken(forceRefresh).then(resolve, reject);
                else resolve(null);
            }, 0);
        });
        return this.auth_.getToken(forceRefresh).catch((error)=>{
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                $e0be213f695400f3$var$log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            } else return Promise.reject(error);
        });
    }
    addTokenChangeListener(listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        if (this.auth_) this.auth_.addAuthTokenListener(listener);
        else this.authProvider_.get().then((auth)=>auth.addAuthTokenListener(listener));
    }
    removeTokenChangeListener(listener) {
        this.authProvider_.get().then((auth)=>auth.removeAuthTokenListener(listener));
    }
    notifyForInvalidToken() {
        let errorMessage = 'Provided authentication credentials for the app named "' + this.appName_ + '" are invalid. This usually indicates your app was not ' + 'initialized correctly. ';
        if ('credential' in this.firebaseOptions_) errorMessage += 'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else if ('serviceAccount' in this.firebaseOptions_) errorMessage += 'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.';
        else errorMessage += 'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.';
        $e0be213f695400f3$var$warn(errorMessage);
    }
}
/* AuthTokenProvider that supplies a constant token. Used by Admin SDK or mockUserToken with emulators. */ class $e0be213f695400f3$var$EmulatorTokenProvider {
    constructor(accessToken){
        this.accessToken = accessToken;
    }
    getToken(forceRefresh) {
        return Promise.resolve({
            accessToken: this.accessToken
        });
    }
    addTokenChangeListener(listener) {
        // Invoke the listener immediately to match the behavior in Firebase Auth
        // (see packages/auth/src/auth.js#L1807)
        listener(this.accessToken);
    }
    removeTokenChangeListener(listener) {}
    notifyForInvalidToken() {}
}
/** A string that is treated as an admin access token by the RTDB emulator. Used by Admin SDK. */ $e0be213f695400f3$var$EmulatorTokenProvider.OWNER = 'owner';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$PROTOCOL_VERSION = '5';
const $e0be213f695400f3$var$VERSION_PARAM = 'v';
const $e0be213f695400f3$var$TRANSPORT_SESSION_PARAM = 's';
const $e0be213f695400f3$var$REFERER_PARAM = 'r';
const $e0be213f695400f3$var$FORGE_REF = 'f';
// Matches console.firebase.google.com, firebase-console-*.corp.google.com and
// firebase.corp.google.com
const $e0be213f695400f3$var$FORGE_DOMAIN_RE = /(console\.firebase|firebase-console-\w+\.corp|firebase\.corp)\.google\.com/;
const $e0be213f695400f3$var$LAST_SESSION_PARAM = 'ls';
const $e0be213f695400f3$var$APPLICATION_ID_PARAM = 'p';
const $e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM = 'ac';
const $e0be213f695400f3$var$WEBSOCKET = 'websocket';
const $e0be213f695400f3$var$LONG_POLLING = 'long_polling';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that holds metadata about a Repo object
 */ class $e0be213f695400f3$var$RepoInfo {
    /**
     * @param host - Hostname portion of the url for the repo
     * @param secure - Whether or not this repo is accessed over ssl
     * @param namespace - The namespace represented by the repo
     * @param webSocketOnly - Whether to prefer websockets over all other transports (used by Nest).
     * @param nodeAdmin - Whether this instance uses Admin SDK credentials
     * @param persistenceKey - Override the default session persistence storage key
     */ constructor(host, secure, namespace, webSocketOnly, nodeAdmin = false, persistenceKey = '', includeNamespaceInQueryParams = false, isUsingEmulator = false){
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.nodeAdmin = nodeAdmin;
        this.persistenceKey = persistenceKey;
        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
        this.isUsingEmulator = isUsingEmulator;
        this._host = host.toLowerCase();
        this._domain = this._host.substr(this._host.indexOf('.') + 1);
        this.internalHost = $e0be213f695400f3$var$PersistentStorage.get('host:' + host) || this._host;
    }
    isCacheableHost() {
        return this.internalHost.substr(0, 2) === 's-';
    }
    isCustomHost() {
        return this._domain !== 'firebaseio.com' && this._domain !== 'firebaseio-demo.com';
    }
    get host() {
        return this._host;
    }
    set host(newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) $e0be213f695400f3$var$PersistentStorage.set('host:' + this._host, this.internalHost);
        }
    }
    toString() {
        let str = this.toURLString();
        if (this.persistenceKey) str += '<' + this.persistenceKey + '>';
        return str;
    }
    toURLString() {
        const protocol = this.secure ? 'https://' : 'http://';
        const query = this.includeNamespaceInQueryParams ? `?ns=${this.namespace}` : '';
        return `${protocol}${this.host}/${query}`;
    }
}
function $e0be213f695400f3$var$repoInfoNeedsQueryParam(repoInfo) {
    return repoInfo.host !== repoInfo.internalHost || repoInfo.isCustomHost() || repoInfo.includeNamespaceInQueryParams;
}
/**
 * Returns the websocket URL for this repo
 * @param repoInfo - RepoInfo object
 * @param type - of connection
 * @param params - list
 * @returns The URL for this repo
 */ function $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, type, params) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof type === 'string', 'typeof type must == string');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof params === 'object', 'typeof params must == object');
    let connURL;
    if (type === $e0be213f695400f3$var$WEBSOCKET) connURL = (repoInfo.secure ? 'wss://' : 'ws://') + repoInfo.internalHost + '/.ws?';
    else if (type === $e0be213f695400f3$var$LONG_POLLING) connURL = (repoInfo.secure ? 'https://' : 'http://') + repoInfo.internalHost + '/.lp?';
    else throw new Error('Unknown connection type: ' + type);
    if ($e0be213f695400f3$var$repoInfoNeedsQueryParam(repoInfo)) params['ns'] = repoInfo.namespace;
    const pairs = [];
    $e0be213f695400f3$var$each(params, (key, value)=>{
        pairs.push(key + '=' + value);
    });
    return connURL + pairs.join('&');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Tracks a collection of stats.
 */ class $e0be213f695400f3$var$StatsCollection {
    constructor(){
        this.counters_ = {};
    }
    incrementCounter(name, amount = 1) {
        if (!(0, $474ae12482b554c6$export$2344b14b097df817)(this.counters_, name)) this.counters_[name] = 0;
        this.counters_[name] += amount;
    }
    get() {
        return (0, $474ae12482b554c6$export$6c40052bed430212)(this.counters_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$collections = {};
const $e0be213f695400f3$var$reporters = {};
function $e0be213f695400f3$var$statsManagerGetCollection(repoInfo) {
    const hashString = repoInfo.toString();
    if (!$e0be213f695400f3$var$collections[hashString]) $e0be213f695400f3$var$collections[hashString] = new $e0be213f695400f3$var$StatsCollection();
    return $e0be213f695400f3$var$collections[hashString];
}
function $e0be213f695400f3$var$statsManagerGetOrCreateReporter(repoInfo, creatorFunction) {
    const hashString = repoInfo.toString();
    if (!$e0be213f695400f3$var$reporters[hashString]) $e0be213f695400f3$var$reporters[hashString] = creatorFunction();
    return $e0be213f695400f3$var$reporters[hashString];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 */ class $e0be213f695400f3$var$PacketReceiver {
    /**
     * @param onMessage_
     */ constructor(onMessage_){
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    closeAfter(responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    }
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     */ handleResponse(requestNum, data) {
        this.pendingResponses[requestNum] = data;
        while(this.pendingResponses[this.currentResponseNum]){
            const toProcess = this.pendingResponses[this.currentResponseNum];
            delete this.pendingResponses[this.currentResponseNum];
            for(let i = 0; i < toProcess.length; ++i)if (toProcess[i]) $e0be213f695400f3$var$exceptionGuard(()=>{
                this.onMessage_(toProcess[i]);
            });
            if (this.currentResponseNum === this.closeAfterResponse) {
                if (this.onClose) {
                    this.onClose();
                    this.onClose = null;
                }
                break;
            }
            this.currentResponseNum++;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // URL query parameters associated with longpolling
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM = 'start';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM = 'id';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM = 'pw';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_PARAM = 'd';
const $e0be213f695400f3$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
const $e0be213f695400f3$var$MAX_URL_DATA_SIZE = 1870;
const $e0be213f695400f3$var$SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
const $e0be213f695400f3$var$MAX_PAYLOAD_SIZE = $e0be213f695400f3$var$MAX_URL_DATA_SIZE - $e0be213f695400f3$var$SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 */ const $e0be213f695400f3$var$KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 */ const $e0be213f695400f3$var$LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 */ class $e0be213f695400f3$var$BrowserPollConnection {
    /**
     * @param connId An identifier for this connection, used for logging
     * @param repoInfo The info for the endpoint to send data to.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The AppCheck token for this client.
     * @param authToken The AuthToken to use for this connection.
     * @param transportSessionId Optional transportSessionid if we are
     * reconnecting for an existing transport session
     * @param lastSessionId Optional lastSessionId if the PersistentConnection has
     * already created a connection previously
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = $e0be213f695400f3$var$logWrapper(connId);
        this.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repoInfo);
        this.urlFn = (params)=>{
            // Always add the token if we have one.
            if (this.appCheckToken) params[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            return $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, $e0be213f695400f3$var$LONG_POLLING, params);
        };
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new $e0be213f695400f3$var$PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(()=>{
            this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            this.onClosed_();
            this.connectTimeoutTimer_ = null;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($e0be213f695400f3$var$LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        $e0be213f695400f3$var$executeWhenDOMReady(()=>{
            if (this.isClosed_) return;
            //Set up a callback that gets triggered once a connection is set up.
            this.scriptTagHolder = new $e0be213f695400f3$var$FirebaseIFrameScriptHolder((...args)=>{
                const [command, arg1, arg2, arg3, arg4] = args;
                this.incrementIncomingBytes_(args);
                if (!this.scriptTagHolder) return; // we closed the connection.
                if (this.connectTimeoutTimer_) {
                    clearTimeout(this.connectTimeoutTimer_);
                    this.connectTimeoutTimer_ = null;
                }
                this.everConnected_ = true;
                if (command === $e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM) {
                    this.id = arg1;
                    this.password = arg2;
                } else if (command === $e0be213f695400f3$var$FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        this.myPacketOrderer.closeAfter(arg1, ()=>{
                            this.onClosed_();
                        });
                    } else this.onClosed_();
                } else throw new Error('Unrecognized command received: ' + command);
            }, (...args)=>{
                const [pN, data] = args;
                this.incrementIncomingBytes_(args);
                this.myPacketOrderer.handleResponse(pN, data);
            }, ()=>{
                this.onClosed_();
            }, this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            const urlParams = {};
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (this.scriptTagHolder.uniqueCallbackIdentifier) urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[$e0be213f695400f3$var$VERSION_PARAM] = $e0be213f695400f3$var$PROTOCOL_VERSION;
            if (this.transportSessionId) urlParams[$e0be213f695400f3$var$TRANSPORT_SESSION_PARAM] = this.transportSessionId;
            if (this.lastSessionId) urlParams[$e0be213f695400f3$var$LAST_SESSION_PARAM] = this.lastSessionId;
            if (this.applicationId) urlParams[$e0be213f695400f3$var$APPLICATION_ID_PARAM] = this.applicationId;
            if (this.appCheckToken) urlParams[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = this.appCheckToken;
            if (typeof location !== 'undefined' && location.hostname && $e0be213f695400f3$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$e0be213f695400f3$var$REFERER_PARAM] = $e0be213f695400f3$var$FORGE_REF;
            const connectURL = this.urlFn(urlParams);
            this.log_('Connecting via long-poll to ' + connectURL);
            this.scriptTagHolder.addTag(connectURL, ()=>{
            /* do nothing */ });
        });
    }
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */ start() {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    }
    /**
     * Forces long polling to be considered as a potential transport
     */ static forceAllow() {
        $e0be213f695400f3$var$BrowserPollConnection.forceAllow_ = true;
    }
    /**
     * Forces longpolling to not be considered as a potential transport
     */ static forceDisallow() {
        $e0be213f695400f3$var$BrowserPollConnection.forceDisallow_ = true;
    }
    // Static method, use string literal so it can be accessed in a generic way
    static isAvailable() {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) return false;
        else if ($e0be213f695400f3$var$BrowserPollConnection.forceAllow_) return true;
        else // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return !$e0be213f695400f3$var$BrowserPollConnection.forceDisallow_ && typeof document !== 'undefined' && document.createElement != null && !$e0be213f695400f3$var$isChromeExtensionContentScript() && !$e0be213f695400f3$var$isWindowsStoreApp();
    }
    /**
     * No-op for polling
     */ markConnectionHealthy() {}
    /**
     * Stops polling and cleans up the iframe
     */ shutdown_() {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    }
    /**
     * Triggered when this transport is closed
     */ onClosed_() {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    }
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */ close() {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    }
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param data - The JSON data to transmit.
     */ send(data) {
        const dataStr = (0, $474ae12482b554c6$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        const base64data = (0, $474ae12482b554c6$export$e510a73ee562749)(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $e0be213f695400f3$var$splitStringBySize(base64data, $e0be213f695400f3$var$MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for(let i = 0; i < dataSegs.length; i++){
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    }
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     */ addDisconnectPingFrame(id, pw) {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) return;
        this.myDisconnFrame = document.createElement('iframe');
        const urlParams = {};
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    }
    /**
     * Used to track the bytes received by this client
     */ incrementIncomingBytes_(args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        const bytesReceived = (0, $474ae12482b554c6$export$fac44ee5b035f737)(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    }
}
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 *********************************************************************************************/ class $e0be213f695400f3$var$FirebaseIFrameScriptHolder {
    /**
     * @param commandCB - The callback to be called when control commands are received from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */ constructor(commandCB, onMessageCB, onDisconnect, urlFn){
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        this.outstandingRequests = new Set();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = $e0be213f695400f3$var$LUIDGenerator();
            window[$e0be213f695400f3$var$FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[$e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = $e0be213f695400f3$var$FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            let script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src && this.myIFrame.src.substr(0, 11) === 'javascript:') {
                const currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            const iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            } catch (e) {
                $e0be213f695400f3$var$log('frame writing exception');
                if (e.stack) $e0be213f695400f3$var$log(e.stack);
                $e0be213f695400f3$var$log(e);
            }
        } else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     */ static createIFrame_() {
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                const a = iframe.contentWindow.document;
                if (!a) // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                $e0be213f695400f3$var$log('No IE domain setting required');
            } catch (e) {
                const domain = document.domain;
                iframe.src = "javascript:void((function(){document.open();document.domain='" + domain + "';document.close();})())";
            }
        } else // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
        // never gets hit.
        throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        else if (iframe.contentWindow) iframe.doc = iframe.contentWindow.document; // Internet Explorer
        else if (iframe.document) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        iframe.doc = iframe.document; //others?
        return iframe;
    }
    /**
     * Cancel all outstanding queries and remove the frame.
     */ close() {
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting textContent seems to be the safest way to do this.
            this.myIFrame.doc.body.textContent = '';
            setTimeout(()=>{
                if (this.myIFrame !== null) {
                    document.body.removeChild(this.myIFrame);
                    this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        // Protect from being called recursively.
        const onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    }
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param id - The ID of this connection
     * @param pw - The password for this connection
     */ startLongPoll(id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while(this.newRequest_());
    }
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */ newRequest_() {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive && this.sendNewPolls && this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            const urlParams = {};
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[$e0be213f695400f3$var$FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            let theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            let curDataString = '';
            let i = 0;
            while(this.pendingSegs.length > 0){
                //first, lets see if the next segment will fit.
                const nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + $e0be213f695400f3$var$SEG_HEADER_SIZE + curDataString.length <= $e0be213f695400f3$var$MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    const theSeg = this.pendingSegs.shift();
                    curDataString = curDataString + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM + i + '=' + theSeg.seg + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET + i + '=' + theSeg.ts + '&' + $e0be213f695400f3$var$FIREBASE_LONGPOLL_DATA_PARAM + i + '=' + theSeg.d;
                    i++;
                } else break;
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        } else return false;
    }
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */ enqueueSegment(segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({
            seg: segnum,
            ts: totalsegs,
            d: data
        });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) this.newRequest_();
    }
    /**
     * Add a script tag for a regular long-poll request.
     * @param url - The URL of the script tag.
     * @param serial - The serial number of the request.
     */ addLongPollTag_(url, serial) {
        //remember that we sent this request.
        this.outstandingRequests.add(serial);
        const doNewRequest = ()=>{
            this.outstandingRequests.delete(serial);
            this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        const keepaliveTimeout = setTimeout(doNewRequest, Math.floor($e0be213f695400f3$var$KEEPALIVE_REQUEST_INTERVAL));
        const readyStateCB = ()=>{
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    }
    /**
     * Add an arbitrary script tag to the iframe.
     * @param url - The URL for the script tag source.
     * @param loadCB - A callback to be triggered once the script has loaded.
     */ addTag(url, loadCB) {
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.doNodeLongPoll(url, loadCB);
        else setTimeout(()=>{
            try {
                // if we're already closed, don't add this poll
                if (!this.sendNewPolls) return;
                const newScript = this.myIFrame.doc.createElement('script');
                newScript.type = 'text/javascript';
                newScript.async = true;
                newScript.src = url;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                newScript.onload = newScript.onreadystatechange = function() {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const rstate = newScript.readyState;
                    if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        newScript.onload = newScript.onreadystatechange = null;
                        if (newScript.parentNode) newScript.parentNode.removeChild(newScript);
                        loadCB();
                    }
                };
                newScript.onerror = ()=>{
                    $e0be213f695400f3$var$log('Long-poll script failed to load: ' + url);
                    this.sendNewPolls = false;
                    this.close();
                };
                this.myIFrame.doc.body.appendChild(newScript);
            } catch (e) {
            // TODO: we should make this error visible somehow
            }
        }, Math.floor(1));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$WEBSOCKET_MAX_FRAME_SIZE = 16384;
const $e0be213f695400f3$var$WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
let $e0be213f695400f3$var$WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') $e0be213f695400f3$var$WebSocketImpl = MozWebSocket;
else if (typeof WebSocket !== 'undefined') $e0be213f695400f3$var$WebSocketImpl = WebSocket;
/**
 * Create a new websocket connection with the given callbacks.
 */ class $e0be213f695400f3$var$WebSocketConnection {
    /**
     * @param connId identifier for this transport
     * @param repoInfo The info for the websocket endpoint.
     * @param applicationId The Firebase App ID for this project.
     * @param appCheckToken The App Check Token for this client.
     * @param authToken The Auth Token for this client.
     * @param transportSessionId Optional transportSessionId if this is connecting
     * to an existing transport session
     * @param lastSessionId Optional lastSessionId if there was a previous
     * connection
     */ constructor(connId, repoInfo, applicationId, appCheckToken, authToken, transportSessionId, lastSessionId){
        this.connId = connId;
        this.applicationId = applicationId;
        this.appCheckToken = appCheckToken;
        this.authToken = authToken;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = $e0be213f695400f3$var$logWrapper(this.connId);
        this.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repoInfo);
        this.connURL = $e0be213f695400f3$var$WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId);
        this.nodeAdmin = repoInfo.nodeAdmin;
    }
    /**
     * @param repoInfo - The info for the websocket endpoint.
     * @param transportSessionId - Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param lastSessionId - Optional lastSessionId if there was a previous connection
     * @returns connection url
     */ static connectionURL_(repoInfo, transportSessionId, lastSessionId, appCheckToken, applicationId) {
        const urlParams = {};
        urlParams[$e0be213f695400f3$var$VERSION_PARAM] = $e0be213f695400f3$var$PROTOCOL_VERSION;
        if (!(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)() && typeof location !== 'undefined' && location.hostname && $e0be213f695400f3$var$FORGE_DOMAIN_RE.test(location.hostname)) urlParams[$e0be213f695400f3$var$REFERER_PARAM] = $e0be213f695400f3$var$FORGE_REF;
        if (transportSessionId) urlParams[$e0be213f695400f3$var$TRANSPORT_SESSION_PARAM] = transportSessionId;
        if (lastSessionId) urlParams[$e0be213f695400f3$var$LAST_SESSION_PARAM] = lastSessionId;
        if (appCheckToken) urlParams[$e0be213f695400f3$var$APP_CHECK_TOKEN_PARAM] = appCheckToken;
        if (applicationId) urlParams[$e0be213f695400f3$var$APPLICATION_ID_PARAM] = applicationId;
        return $e0be213f695400f3$var$repoInfoConnectionURL(repoInfo, $e0be213f695400f3$var$WEBSOCKET, urlParams);
    }
    /**
     * @param onMessage - Callback when messages arrive
     * @param onDisconnect - Callback with connection lost.
     */ open(onMessage, onDisconnect) {
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        $e0be213f695400f3$var$PersistentStorage.set('previous_websocket_failure', true);
        try {
            let options;
            if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
                const device = this.nodeAdmin ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                options = {
                    headers: {
                        'User-Agent': `Firebase/${$e0be213f695400f3$var$PROTOCOL_VERSION}/${$e0be213f695400f3$var$SDK_VERSION}/${$djlMn.platform}/${device}`,
                        'X-Firebase-GMPID': this.applicationId || ''
                    }
                };
                // If using Node with admin creds, AppCheck-related checks are unnecessary.
                // Note that we send the credentials here even if they aren't admin credentials, which is
                // not a problem.
                // Note that this header is just used to bypass appcheck, and the token should still be sent
                // through the websocket connection once it is established.
                if (this.authToken) options.headers['Authorization'] = `Bearer ${this.authToken}`;
                if (this.appCheckToken) options.headers['X-Firebase-AppCheck'] = this.appCheckToken;
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                const env = {};
                const proxy = this.connURL.indexOf('wss://') === 0 ? env['HTTPS_PROXY'] || env['https_proxy'] : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) options['proxy'] = {
                    origin: proxy
                };
            }
            this.mySock = new $e0be213f695400f3$var$WebSocketImpl(this.connURL, [], options);
        } catch (e) {
            this.log_('Error instantiating WebSocket.');
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
            return;
        }
        this.mySock.onopen = ()=>{
            this.log_('Websocket connected.');
            this.everConnected_ = true;
        };
        this.mySock.onclose = ()=>{
            this.log_('Websocket connection was disconnected.');
            this.mySock = null;
            this.onClosed_();
        };
        this.mySock.onmessage = (m)=>{
            this.handleIncomingFrame(m);
        };
        this.mySock.onerror = (e)=>{
            this.log_('WebSocket error.  Closing connection.');
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const error = e.message || e.data;
            if (error) this.log_(error);
            this.onClosed_();
        };
    }
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */ start() {}
    static forceDisallow() {
        $e0be213f695400f3$var$WebSocketConnection.forceDisallow_ = true;
    }
    static isAvailable() {
        let isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            const oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            const oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) isOldAndroid = true;
            }
        }
        return !isOldAndroid && $e0be213f695400f3$var$WebSocketImpl !== null && !$e0be213f695400f3$var$WebSocketConnection.forceDisallow_;
    }
    /**
     * Returns true if we previously failed to connect with this transport.
     */ static previouslyFailed() {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return $e0be213f695400f3$var$PersistentStorage.isInMemoryStorage || $e0be213f695400f3$var$PersistentStorage.get('previous_websocket_failure') === true;
    }
    markConnectionHealthy() {
        $e0be213f695400f3$var$PersistentStorage.remove('previous_websocket_failure');
    }
    appendFrame_(data) {
        this.frames.push(data);
        if (this.frames.length === this.totalFrames) {
            const fullMess = this.frames.join('');
            this.frames = null;
            const jsonMess = (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    }
    /**
     * @param frameCount - The number of frames we are expecting from the server
     */ handleNewFrameCount_(frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    }
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @returns Any remaining data to be process, or null if there is none
     */ extractFrameCount_(data) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            const frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    }
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess - The frame data
     */ handleIncomingFrame(mess) {
        if (this.mySock === null) return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        const data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) // we're buffering
        this.appendFrame_(data);
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            const remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) this.appendFrame_(remainingData);
        }
    }
    /**
     * Send a message to the server
     * @param data - The JSON object to transmit
     */ send(data) {
        this.resetKeepAlive();
        const dataStr = (0, $474ae12482b554c6$export$fac44ee5b035f737)(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        const dataSegs = $e0be213f695400f3$var$splitStringBySize(dataStr, $e0be213f695400f3$var$WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) this.sendString_(String(dataSegs.length));
        //Send the actual data in segments.
        for(let i = 0; i < dataSegs.length; i++)this.sendString_(dataSegs[i]);
    }
    shutdown_() {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    }
    onClosed_() {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    }
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */ close() {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    }
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */ resetKeepAlive() {
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(()=>{
            //If there has been no websocket activity for a while, send a no-op
            if (this.mySock) this.sendString_('0');
            this.resetKeepAlive();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor($e0be213f695400f3$var$WEBSOCKET_KEEPALIVE_INTERVAL));
    }
    /**
     * Send a string over the websocket.
     *
     * @param str - String to send.
     */ sendString_(str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        } catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    }
}
/**
 * Number of response before we consider the connection "healthy."
 */ $e0be213f695400f3$var$WebSocketConnection.responsesRequiredToBeHealthy = 2;
/**
 * Time to wait for the connection te become healthy before giving up.
 */ $e0be213f695400f3$var$WebSocketConnection.healthyTimeout = 30000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 */ class $e0be213f695400f3$var$TransportManager {
    /**
     * @param repoInfo - Metadata around the namespace we're connecting to
     */ constructor(repoInfo){
        this.initTransports_(repoInfo);
    }
    static get ALL_TRANSPORTS() {
        return [
            $e0be213f695400f3$var$BrowserPollConnection,
            $e0be213f695400f3$var$WebSocketConnection
        ];
    }
    /**
     * Returns whether transport has been selected to ensure WebSocketConnection or BrowserPollConnection are not called after
     * TransportManager has already set up transports_
     */ static get IS_TRANSPORT_INITIALIZED() {
        return this.globalTransportInitialized_;
    }
    initTransports_(repoInfo) {
        const isWebSocketsAvailable = $e0be213f695400f3$var$WebSocketConnection && $e0be213f695400f3$var$WebSocketConnection['isAvailable']();
        let isSkipPollConnection = isWebSocketsAvailable && !$e0be213f695400f3$var$WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable) $e0be213f695400f3$var$warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) this.transports_ = [
            $e0be213f695400f3$var$WebSocketConnection
        ];
        else {
            const transports = this.transports_ = [];
            for (const transport of $e0be213f695400f3$var$TransportManager.ALL_TRANSPORTS)if (transport && transport['isAvailable']()) transports.push(transport);
            $e0be213f695400f3$var$TransportManager.globalTransportInitialized_ = true;
        }
    }
    /**
     * @returns The constructor for the initial transport to use
     */ initialTransport() {
        if (this.transports_.length > 0) return this.transports_[0];
        else throw new Error('No transports available');
    }
    /**
     * @returns The constructor for the next transport, or null
     */ upgradeTransport() {
        if (this.transports_.length > 1) return this.transports_[1];
        else return null;
    }
}
// Keeps track of whether the TransportManager has already chosen a transport to use
$e0be213f695400f3$var$TransportManager.globalTransportInitialized_ = false;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Abort upgrade attempt if it takes longer than 60s.
const $e0be213f695400f3$var$UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
const $e0be213f695400f3$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
const $e0be213f695400f3$var$BYTES_SENT_HEALTHY_OVERRIDE = 10240;
const $e0be213f695400f3$var$BYTES_RECEIVED_HEALTHY_OVERRIDE = 102400;
const $e0be213f695400f3$var$MESSAGE_TYPE = 't';
const $e0be213f695400f3$var$MESSAGE_DATA = 'd';
const $e0be213f695400f3$var$CONTROL_SHUTDOWN = 's';
const $e0be213f695400f3$var$CONTROL_RESET = 'r';
const $e0be213f695400f3$var$CONTROL_ERROR = 'e';
const $e0be213f695400f3$var$CONTROL_PONG = 'o';
const $e0be213f695400f3$var$SWITCH_ACK = 'a';
const $e0be213f695400f3$var$END_TRANSMISSION = 'n';
const $e0be213f695400f3$var$PING = 'p';
const $e0be213f695400f3$var$SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 */ class $e0be213f695400f3$var$Connection {
    /**
     * @param id - an id for this connection
     * @param repoInfo_ - the info for the endpoint to connect to
     * @param applicationId_ - the Firebase App ID for this project
     * @param appCheckToken_ - The App Check Token for this device.
     * @param authToken_ - The auth token for this session.
     * @param onMessage_ - the callback to be triggered when a server-push message arrives
     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param onDisconnect_ - the callback to be triggered when a connection was lost
     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */ constructor(id, repoInfo_, applicationId_, appCheckToken_, authToken_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId){
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.appCheckToken_ = appCheckToken_;
        this.authToken_ = authToken_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* RealtimeState.CONNECTING */ ;
        this.log_ = $e0be213f695400f3$var$logWrapper('c:' + this.id + ':');
        this.transportManager_ = new $e0be213f695400f3$var$TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     */ start_() {
        const conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, null, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessageReceived = this.connReceiver_(this.conn_);
        const onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */ setTimeout(()=>{
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            this.conn_ && this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        const healthyTimeoutMS = conn['healthyTimeout'] || 0;
        if (healthyTimeoutMS > 0) this.healthyTimeout_ = $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            this.healthyTimeout_ = null;
            if (!this.isHealthy_) {
                if (this.conn_ && this.conn_.bytesReceived > $e0be213f695400f3$var$BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                    this.log_('Connection exceeded healthy timeout but has received ' + this.conn_.bytesReceived + ' bytes.  Marking connection healthy.');
                    this.isHealthy_ = true;
                    this.conn_.markConnectionHealthy();
                } else if (this.conn_ && this.conn_.bytesSent > $e0be213f695400f3$var$BYTES_SENT_HEALTHY_OVERRIDE) this.log_('Connection exceeded healthy timeout but has sent ' + this.conn_.bytesSent + ' bytes.  Leaving connection alive.');
                else {
                    this.log_('Closing unhealthy connection after timeout.');
                    this.close();
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(healthyTimeoutMS));
    }
    nextTransportId_() {
        return 'c:' + this.id + ':' + this.connectionCount++;
    }
    disconnReceiver_(conn) {
        return (everConnected)=>{
            if (conn === this.conn_) this.onConnectionLost_(everConnected);
            else if (conn === this.secondaryConn_) {
                this.log_('Secondary connection lost.');
                this.onSecondaryConnectionLost_();
            } else this.log_('closing an old connection');
        };
    }
    connReceiver_(conn) {
        return (message)=>{
            if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
                if (conn === this.rx_) this.onPrimaryMessageReceived_(message);
                else if (conn === this.secondaryConn_) this.onSecondaryMessageReceived_(message);
                else this.log_('message on old connection');
            }
        };
    }
    /**
     * @param dataMsg - An arbitrary data message to be sent to the server
     */ sendRequest(dataMsg) {
        // wrap in a data message envelope and send it on
        const msg = {
            t: 'd',
            d: dataMsg
        };
        this.sendData_(msg);
    }
    tryCleanupConnection() {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
        // the server will shutdown the old connection
        }
    }
    onSecondaryControl_(controlData) {
        if ($e0be213f695400f3$var$MESSAGE_TYPE in controlData) {
            const cmd = controlData[$e0be213f695400f3$var$MESSAGE_TYPE];
            if (cmd === $e0be213f695400f3$var$SWITCH_ACK) this.upgradeIfSecondaryHealthy_();
            else if (cmd === $e0be213f695400f3$var$CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ || this.rx_ === this.secondaryConn_) this.close();
            } else if (cmd === $e0be213f695400f3$var$CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    }
    onSecondaryMessageReceived_(parsedData) {
        const layer = $e0be213f695400f3$var$requireKey('t', parsedData);
        const data = $e0be213f695400f3$var$requireKey('d', parsedData);
        if (layer === 'c') this.onSecondaryControl_(data);
        else if (layer === 'd') // got a data message, but we're still second connection. Need to buffer it up
        this.pendingDataMessages.push(data);
        else throw new Error('Unknown protocol layer: ' + layer);
    }
    upgradeIfSecondaryHealthy_() {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        } else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({
                t: 'c',
                d: {
                    t: $e0be213f695400f3$var$PING,
                    d: {}
                }
            });
        }
    }
    proceedWithUpgrade_() {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({
            t: 'c',
            d: {
                t: $e0be213f695400f3$var$SWITCH_ACK,
                d: {}
            }
        });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({
            t: 'c',
            d: {
                t: $e0be213f695400f3$var$END_TRANSMISSION,
                d: {}
            }
        });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    }
    onPrimaryMessageReceived_(parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        const layer = $e0be213f695400f3$var$requireKey('t', parsedData);
        const data = $e0be213f695400f3$var$requireKey('d', parsedData);
        if (layer === 'c') this.onControl_(data);
        else if (layer === 'd') this.onDataMessage_(data);
    }
    onDataMessage_(message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    }
    onPrimaryResponse_() {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    }
    onControl_(controlData) {
        const cmd = $e0be213f695400f3$var$requireKey($e0be213f695400f3$var$MESSAGE_TYPE, controlData);
        if ($e0be213f695400f3$var$MESSAGE_DATA in controlData) {
            const payload = controlData[$e0be213f695400f3$var$MESSAGE_DATA];
            if (cmd === $e0be213f695400f3$var$SERVER_HELLO) {
                const handshakePayload = Object.assign({}, payload);
                if (this.repoInfo_.isUsingEmulator) // Upon connecting, the emulator will pass the hostname that it's aware of, but we prefer the user's set hostname via `connectDatabaseEmulator` over what the emulator passes.
                handshakePayload.h = this.repoInfo_.host;
                this.onHandshake_(handshakePayload);
            } else if (cmd === $e0be213f695400f3$var$END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for(let i = 0; i < this.pendingDataMessages.length; ++i)this.onDataMessage_(this.pendingDataMessages[i]);
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            } else if (cmd === $e0be213f695400f3$var$CONTROL_SHUTDOWN) // This was previously the 'onKill' callback passed to the lower-level connection
            // payload in this case is the reason for the shutdown. Generally a human-readable error
            this.onConnectionShutdown_(payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_RESET) // payload in this case is the host we should contact
            this.onReset_(payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_ERROR) $e0be213f695400f3$var$error('Server Error: ' + payload);
            else if (cmd === $e0be213f695400f3$var$CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            } else $e0be213f695400f3$var$error('Unknown control packet command: ' + cmd);
        }
    }
    /**
     * @param handshake - The handshake data returned from the server
     */ onHandshake_(handshake) {
        const timestamp = handshake.ts;
        const version = handshake.v;
        const host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.host = host;
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if ($e0be213f695400f3$var$PROTOCOL_VERSION !== version) $e0be213f695400f3$var$warn('Protocol version mismatch detected');
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    }
    tryStartUpgrade_() {
        const conn = this.transportManager_.upgradeTransport();
        if (conn) this.startUpgrade_(conn);
    }
    startUpgrade_(conn) {
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        const onMessage = this.connReceiver_(this.secondaryConn_);
        const onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            if (this.secondaryConn_) {
                this.log_('Timed out trying to upgrade.');
                this.secondaryConn_.close();
            }
        }, Math.floor($e0be213f695400f3$var$UPGRADE_TIMEOUT));
    }
    onReset_(host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.host = host;
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.close();
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    }
    onConnectionEstablished_(conn, timestamp) {
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* RealtimeState.CONNECTED */ ;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        } else $e0be213f695400f3$var$setTimeoutNonBlocking(()=>{
            this.sendPingOnPrimaryIfNecessary_();
        }, Math.floor($e0be213f695400f3$var$DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
    }
    sendPingOnPrimaryIfNecessary_() {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* RealtimeState.CONNECTED */ ) {
            this.log_('sending ping on primary.');
            this.sendData_({
                t: 'c',
                d: {
                    t: $e0be213f695400f3$var$PING,
                    d: {}
                }
            });
        }
    }
    onSecondaryConnectionLost_() {
        const conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) // we are relying on this connection already in some capacity. Therefore, a failure is real
        this.close();
    }
    /**
     * @param everConnected - Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     */ onConnectionLost_(everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* RealtimeState.CONNECTING */ ) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                $e0be213f695400f3$var$PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        } else if (this.state_ === 1 /* RealtimeState.CONNECTED */ ) this.log_('Realtime connection lost.');
        this.close();
    }
    onConnectionShutdown_(reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    }
    sendData_(data) {
        if (this.state_ !== 1 /* RealtimeState.CONNECTED */ ) throw 'Connection is not connected';
        else this.tx_.send(data);
    }
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */ close() {
        if (this.state_ !== 2 /* RealtimeState.DISCONNECTED */ ) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* RealtimeState.DISCONNECTED */ ;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    }
    closeConnections_() {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */ class $e0be213f695400f3$var$ServerActions {
    put(pathString, data, onComplete, hash) {}
    merge(pathString, data, onComplete, hash) {}
    /**
     * Refreshes the auth token for the current connection.
     * @param token - The authentication token
     */ refreshAuthToken(token) {}
    /**
     * Refreshes the app check token for the current connection.
     * @param token The app check token
     */ refreshAppCheckToken(token) {}
    onDisconnectPut(pathString, data, onComplete) {}
    onDisconnectMerge(pathString, data, onComplete) {}
    onDisconnectCancel(pathString, onComplete) {}
    reportStats(stats) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */ class $e0be213f695400f3$var$EventEmitter {
    constructor(allowedEvents_){
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        (0, $474ae12482b554c6$export$a7a9523472993e97)(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     */ trigger(eventType, ...varArgs) {
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            const listeners = [
                ...this.listeners_[eventType]
            ];
            for(let i = 0; i < listeners.length; i++)listeners[i].callback.apply(listeners[i].context, varArgs);
        }
    }
    on(eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({
            callback: callback,
            context: context
        });
        const eventData = this.getInitialEvent(eventType);
        if (eventData) callback.apply(context, eventData);
    }
    off(eventType, callback, context) {
        this.validateEventType_(eventType);
        const listeners = this.listeners_[eventType] || [];
        for(let i = 0; i < listeners.length; i++)if (listeners[i].callback === callback && (!context || context === listeners[i].context)) {
            listeners.splice(i, 1);
            return;
        }
    }
    validateEventType_(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.allowedEvents_.find((et)=>{
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 */ class $e0be213f695400f3$var$OnlineMonitor extends $e0be213f695400f3$var$EventEmitter {
    constructor(){
        super([
            'online'
        ]);
        this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' && typeof window.addEventListener !== 'undefined' && !(0, $474ae12482b554c6$export$872f8323f01d7ae0)()) {
            window.addEventListener('online', ()=>{
                if (!this.online_) {
                    this.online_ = true;
                    this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', ()=>{
                if (this.online_) {
                    this.online_ = false;
                    this.trigger('online', false);
                }
            }, false);
        }
    }
    static getInstance() {
        return new $e0be213f695400f3$var$OnlineMonitor();
    }
    getInitialEvent(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventType === 'online', 'Unknown event type: ' + eventType);
        return [
            this.online_
        ];
    }
    currentlyOnline() {
        return this.online_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Maximum key depth. */ const $e0be213f695400f3$var$MAX_PATH_DEPTH = 32;
/** Maximum number of (UTF8) bytes in a Firebase path. */ const $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES = 768;
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */ class $e0be213f695400f3$var$Path {
    /**
     * @param pathOrString - Path string to parse, or another path, or the raw
     * tokens array
     */ constructor(pathOrString, pieceNum){
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            let copyTo = 0;
            for(let i = 0; i < this.pieces_.length; i++)if (this.pieces_[i].length > 0) {
                this.pieces_[copyTo] = this.pieces_[i];
                copyTo++;
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        } else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    toString() {
        let pathString = '';
        for(let i = this.pieceNum_; i < this.pieces_.length; i++)if (this.pieces_[i] !== '') pathString += '/' + this.pieces_[i];
        return pathString || '/';
    }
}
function $e0be213f695400f3$var$newEmptyPath() {
    return new $e0be213f695400f3$var$Path('');
}
function $e0be213f695400f3$var$pathGetFront(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    return path.pieces_[path.pieceNum_];
}
/**
 * @returns The number of segments in this path
 */ function $e0be213f695400f3$var$pathGetLength(path) {
    return path.pieces_.length - path.pieceNum_;
}
function $e0be213f695400f3$var$pathPopFront(path) {
    let pieceNum = path.pieceNum_;
    if (pieceNum < path.pieces_.length) pieceNum++;
    return new $e0be213f695400f3$var$Path(path.pieces_, pieceNum);
}
function $e0be213f695400f3$var$pathGetBack(path) {
    if (path.pieceNum_ < path.pieces_.length) return path.pieces_[path.pieces_.length - 1];
    return null;
}
function $e0be213f695400f3$var$pathToUrlEncodedString(path) {
    let pathString = '';
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)if (path.pieces_[i] !== '') pathString += '/' + encodeURIComponent(String(path.pieces_[i]));
    return pathString || '/';
}
/**
 * Shallow copy of the parts of the path.
 *
 */ function $e0be213f695400f3$var$pathSlice(path, begin = 0) {
    return path.pieces_.slice(path.pieceNum_ + begin);
}
function $e0be213f695400f3$var$pathParent(path) {
    if (path.pieceNum_ >= path.pieces_.length) return null;
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length - 1; i++)pieces.push(path.pieces_[i]);
    return new $e0be213f695400f3$var$Path(pieces, 0);
}
function $e0be213f695400f3$var$pathChild(path, childPathObj) {
    const pieces = [];
    for(let i = path.pieceNum_; i < path.pieces_.length; i++)pieces.push(path.pieces_[i]);
    if (childPathObj instanceof $e0be213f695400f3$var$Path) for(let i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++)pieces.push(childPathObj.pieces_[i]);
    else {
        const childPieces = childPathObj.split('/');
        for(let i = 0; i < childPieces.length; i++)if (childPieces[i].length > 0) pieces.push(childPieces[i]);
    }
    return new $e0be213f695400f3$var$Path(pieces, 0);
}
/**
 * @returns True if there are no segments in this path
 */ function $e0be213f695400f3$var$pathIsEmpty(path) {
    return path.pieceNum_ >= path.pieces_.length;
}
/**
 * @returns The path from outerPath to innerPath
 */ function $e0be213f695400f3$var$newRelativePath(outerPath, innerPath) {
    const outer = $e0be213f695400f3$var$pathGetFront(outerPath), inner = $e0be213f695400f3$var$pathGetFront(innerPath);
    if (outer === null) return innerPath;
    else if (outer === inner) return $e0be213f695400f3$var$newRelativePath($e0be213f695400f3$var$pathPopFront(outerPath), $e0be213f695400f3$var$pathPopFront(innerPath));
    else throw new Error('INTERNAL ERROR: innerPath (' + innerPath + ') is not within ' + 'outerPath (' + outerPath + ')');
}
/**
 * @returns -1, 0, 1 if left is less, equal, or greater than the right.
 */ function $e0be213f695400f3$var$pathCompare(left, right) {
    const leftKeys = $e0be213f695400f3$var$pathSlice(left, 0);
    const rightKeys = $e0be213f695400f3$var$pathSlice(right, 0);
    for(let i = 0; i < leftKeys.length && i < rightKeys.length; i++){
        const cmp = $e0be213f695400f3$var$nameCompare(leftKeys[i], rightKeys[i]);
        if (cmp !== 0) return cmp;
    }
    if (leftKeys.length === rightKeys.length) return 0;
    return leftKeys.length < rightKeys.length ? -1 : 1;
}
/**
 * @returns true if paths are the same.
 */ function $e0be213f695400f3$var$pathEquals(path, other) {
    if ($e0be213f695400f3$var$pathGetLength(path) !== $e0be213f695400f3$var$pathGetLength(other)) return false;
    for(let i = path.pieceNum_, j = other.pieceNum_; i <= path.pieces_.length; i++, j++){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
    }
    return true;
}
/**
 * @returns True if this path is a parent of (or the same as) other
 */ function $e0be213f695400f3$var$pathContains(path, other) {
    let i = path.pieceNum_;
    let j = other.pieceNum_;
    if ($e0be213f695400f3$var$pathGetLength(path) > $e0be213f695400f3$var$pathGetLength(other)) return false;
    while(i < path.pieces_.length){
        if (path.pieces_[i] !== other.pieces_[j]) return false;
        ++i;
        ++j;
    }
    return true;
}
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */ class $e0be213f695400f3$var$ValidationPath {
    /**
     * @param path - Initial Path.
     * @param errorPrefix_ - Prefix for any error messages.
     */ constructor(path, errorPrefix_){
        this.errorPrefix_ = errorPrefix_;
        this.parts_ = $e0be213f695400f3$var$pathSlice(path, 0);
        /** Initialize to number of '/' chars needed in path. */ this.byteLength_ = Math.max(1, this.parts_.length);
        for(let i = 0; i < this.parts_.length; i++)this.byteLength_ += (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(this.parts_[i]);
        $e0be213f695400f3$var$validationPathCheckValid(this);
    }
}
function $e0be213f695400f3$var$validationPathPush(validationPath, child) {
    // Count the needed '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ += 1;
    validationPath.parts_.push(child);
    validationPath.byteLength_ += (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(child);
    $e0be213f695400f3$var$validationPathCheckValid(validationPath);
}
function $e0be213f695400f3$var$validationPathPop(validationPath) {
    const last = validationPath.parts_.pop();
    validationPath.byteLength_ -= (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(last);
    // Un-count the previous '/'
    if (validationPath.parts_.length > 0) validationPath.byteLength_ -= 1;
}
function $e0be213f695400f3$var$validationPathCheckValid(validationPath) {
    if (validationPath.byteLength_ > $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES) throw new Error(validationPath.errorPrefix_ + 'has a key path longer than ' + $e0be213f695400f3$var$MAX_PATH_LENGTH_BYTES + ' bytes (' + validationPath.byteLength_ + ').');
    if (validationPath.parts_.length > $e0be213f695400f3$var$MAX_PATH_DEPTH) throw new Error(validationPath.errorPrefix_ + 'path specified exceeds the maximum depth that can be written (' + $e0be213f695400f3$var$MAX_PATH_DEPTH + ') or object contains a cycle ' + $e0be213f695400f3$var$validationPathToErrorString(validationPath));
}
/**
 * String for use in error messages - uses '.' notation for path.
 */ function $e0be213f695400f3$var$validationPathToErrorString(validationPath) {
    if (validationPath.parts_.length === 0) return '';
    return "in property '" + validationPath.parts_.join('.') + "'";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$VisibilityMonitor extends $e0be213f695400f3$var$EventEmitter {
    constructor(){
        super([
            'visible'
        ]);
        let hidden;
        let visibilityChange;
        if (typeof document !== 'undefined' && typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            } else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            } else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            } else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        this.visible_ = true;
        if (visibilityChange) document.addEventListener(visibilityChange, ()=>{
            const visible = !document[hidden];
            if (visible !== this.visible_) {
                this.visible_ = visible;
                this.trigger('visible', visible);
            }
        }, false);
    }
    static getInstance() {
        return new $e0be213f695400f3$var$VisibilityMonitor();
    }
    getInitialEvent(eventType) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [
            this.visible_
        ];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$RECONNECT_MIN_DELAY = 1000;
const $e0be213f695400f3$var$RECONNECT_MAX_DELAY_DEFAULT = 300000; // 5 minutes in milliseconds (Case: 1858)
const $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS = 30000; // 30 seconds for admin clients (likely to be a backend server)
const $e0be213f695400f3$var$RECONNECT_DELAY_MULTIPLIER = 1.3;
const $e0be213f695400f3$var$RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
const $e0be213f695400f3$var$SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
const $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */ class $e0be213f695400f3$var$PersistentConnection extends $e0be213f695400f3$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param applicationId_ - The Firebase App ID for this project
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, appCheckTokenProvider_, authOverride_){
        super();
        this.repoInfo_ = repoInfo_;
        this.applicationId_ = applicationId_;
        this.onDataUpdate_ = onDataUpdate_;
        this.onConnectStatus_ = onConnectStatus_;
        this.onServerInfoUpdate_ = onServerInfoUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        this.id = $e0be213f695400f3$var$PersistentConnection.nextPersistentConnectionId_++;
        this.log_ = $e0be213f695400f3$var$logWrapper('p:' + this.id + ':');
        this.interruptReasons_ = {};
        this.listens = new Map();
        this.outstandingPuts_ = [];
        this.outstandingGets_ = [];
        this.outstandingPutCount_ = 0;
        this.outstandingGetCount_ = 0;
        this.onDisconnectRequestQueue_ = [];
        this.connected_ = false;
        this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
        this.maxReconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_DEFAULT;
        this.securityDebugCallback_ = null;
        this.lastSessionId = null;
        this.establishConnectionTimer_ = null;
        this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        this.requestCBHash_ = {};
        this.requestNumber_ = 0;
        this.realtime_ = null;
        this.authToken_ = null;
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = false;
        this.invalidAuthTokenCount_ = 0;
        this.invalidAppCheckTokenCount_ = 0;
        this.firstConnection_ = true;
        this.lastConnectionAttemptTime_ = null;
        this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !(0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        $e0be213f695400f3$var$VisibilityMonitor.getInstance().on('visible', this.onVisible_, this);
        if (repoInfo_.host.indexOf('fblocal') === -1) $e0be213f695400f3$var$OnlineMonitor.getInstance().on('online', this.onOnline_, this);
    }
    sendRequest(action, body, onResponse) {
        const curReqNum = ++this.requestNumber_;
        const msg = {
            r: curReqNum,
            a: action,
            b: body
        };
        this.log_((0, $474ae12482b554c6$export$fac44ee5b035f737)(msg));
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) this.requestCBHash_[curReqNum] = onResponse;
    }
    get(query) {
        this.initConnection_();
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        const request = {
            p: query._path.toString(),
            q: query._queryObject
        };
        const outstandingGet = {
            action: 'g',
            request: request,
            onComplete: (message)=>{
                const payload = message['d'];
                if (message['s'] === 'ok') deferred.resolve(payload);
                else deferred.reject(payload);
            }
        };
        this.outstandingGets_.push(outstandingGet);
        this.outstandingGetCount_++;
        const index = this.outstandingGets_.length - 1;
        if (this.connected_) this.sendGet_(index);
        return deferred.promise;
    }
    listen(query, currentHashFn, tag, onComplete) {
        this.initConnection_();
        const queryId = query._queryIdentifier;
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        if (!this.listens.has(pathString)) this.listens.set(pathString, new Map());
        (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'listen() called for non-default but complete query');
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.listens.get(pathString).has(queryId), `listen() called twice for same path/queryId.`);
        const listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens.get(pathString).set(queryId, listenSpec);
        if (this.connected_) this.sendListen_(listenSpec);
    }
    sendGet_(index) {
        const get = this.outstandingGets_[index];
        this.sendRequest('g', get.request, (message)=>{
            delete this.outstandingGets_[index];
            this.outstandingGetCount_--;
            if (this.outstandingGetCount_ === 0) this.outstandingGets_ = [];
            if (get.onComplete) get.onComplete(message);
        });
    }
    sendListen_(listenSpec) {
        const query = listenSpec.query;
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query._queryObject;
            req['t'] = listenSpec.tag;
        }
        req[/*hash*/ 'h'] = listenSpec.hashFn();
        this.sendRequest(action, req, (message)=>{
            const payload = message[/*data*/ 'd'];
            const status = message[/*status*/ 's'];
            // print warnings in any case...
            $e0be213f695400f3$var$PersistentConnection.warnOnListenWarnings_(payload, query);
            const currentListenSpec = this.listens.get(pathString) && this.listens.get(pathString).get(queryId);
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                this.log_('listen response', message);
                if (status !== 'ok') this.removeListen_(pathString, queryId);
                if (listenSpec.onComplete) listenSpec.onComplete(status, payload);
            }
        });
    }
    static warnOnListenWarnings_(payload, query) {
        if (payload && typeof payload === 'object' && (0, $474ae12482b554c6$export$2344b14b097df817)(payload, 'w')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const warnings = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                const indexSpec = '".indexOn": "' + query._queryParams.getIndex().toString() + '"';
                const indexPath = query._path.toString();
                $e0be213f695400f3$var$warn(`Using an unspecified index. Your data will be downloaded and ` + `filtered on the client. Consider adding ${indexSpec} at ` + `${indexPath} to your security rules for better performance.`);
            }
        }
    }
    refreshAuthToken(token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) this.tryAuth();
        else //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
        //the credential so we dont become authenticated next time we connect.
        if (this.connected_) this.sendRequest('unauth', {}, ()=>{});
        this.reduceReconnectDelayIfAdminCredential_(token);
    }
    reduceReconnectDelayIfAdminCredential_(credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        const isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || (0, $474ae12482b554c6$export$fc970ed23da99565)(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    }
    refreshAppCheckToken(token) {
        this.appCheckToken_ = token;
        this.log_('App check token refreshed');
        if (this.appCheckToken_) this.tryAppCheck();
        else //If we're connected we want to let the server know to unauthenticate us.
        //If we're not connected, simply delete the credential so we dont become
        // authenticated next time we connect.
        if (this.connected_) this.sendRequest('unappeck', {}, ()=>{});
    }
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */ tryAuth() {
        if (this.connected_ && this.authToken_) {
            const token = this.authToken_;
            const authMethod = (0, $474ae12482b554c6$export$9565ca3d387f8aa0)(token) ? 'auth' : 'gauth';
            const requestData = {
                cred: token
            };
            if (this.authOverride_ === null) requestData['noauth'] = true;
            else if (typeof this.authOverride_ === 'object') requestData['authvar'] = this.authOverride_;
            this.sendRequest(authMethod, requestData, (res)=>{
                const status = res[/*status*/ 's'];
                const data = res[/*data*/ 'd'] || 'error';
                if (this.authToken_ === token) {
                    if (status === 'ok') this.invalidAuthTokenCount_ = 0;
                    else // Triggers reconnect and force refresh for auth token
                    this.onAuthRevoked_(status, data);
                }
            });
        }
    }
    /**
     * Attempts to authenticate with the given token. If the authentication
     * attempt fails, it's triggered like the token was revoked (the connection is
     * closed).
     */ tryAppCheck() {
        if (this.connected_ && this.appCheckToken_) this.sendRequest('appcheck', {
            'token': this.appCheckToken_
        }, (res)=>{
            const status = res[/*status*/ 's'];
            const data = res[/*data*/ 'd'] || 'error';
            if (status === 'ok') this.invalidAppCheckTokenCount_ = 0;
            else this.onAppCheckRevoked_(status, data);
        });
    }
    /**
     * @inheritDoc
     */ unlisten(query, tag) {
        const pathString = query._path.toString();
        const queryId = query._queryIdentifier;
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault() || !query._queryParams.loadsAllData(), 'unlisten() called for non-default but complete query');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) this.sendUnlisten_(pathString, queryId, query._queryObject, tag);
    }
    sendUnlisten_(pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        const req = {
            p: pathString
        };
        const action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    }
    onDisconnectPut(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('o', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'o',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectMerge(pathString, data, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('om', pathString, data, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'om',
            data: data,
            onComplete: onComplete
        });
    }
    onDisconnectCancel(pathString, onComplete) {
        this.initConnection_();
        if (this.connected_) this.sendOnDisconnect_('oc', pathString, null, onComplete);
        else this.onDisconnectRequestQueue_.push({
            pathString: pathString,
            action: 'oc',
            data: null,
            onComplete: onComplete
        });
    }
    sendOnDisconnect_(action, pathString, data, onComplete) {
        const request = {
            p: pathString,
            /*data*/ d: data
        };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, (response)=>{
            if (onComplete) setTimeout(()=>{
                onComplete(response[/*status*/ 's'], response[/* data */ 'd']);
            }, Math.floor(0));
        });
    }
    put(pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    }
    merge(pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    }
    putInternal(action, pathString, data, onComplete, hash) {
        this.initConnection_();
        const request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined) request[/*hash*/ 'h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        const index = this.outstandingPuts_.length - 1;
        if (this.connected_) this.sendPut_(index);
        else this.log_('Buffering put: ' + pathString);
    }
    sendPut_(index) {
        const action = this.outstandingPuts_[index].action;
        const request = this.outstandingPuts_[index].request;
        const onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, (message)=>{
            this.log_(action + ' response', message);
            delete this.outstandingPuts_[index];
            this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
            if (onComplete) onComplete(message[/*status*/ 's'], message[/* data */ 'd']);
        });
    }
    reportStats(stats) {
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            const request = {
                c: stats
            };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, (result)=>{
                const status = result[/*status*/ 's'];
                if (status !== 'ok') {
                    const errorReason = result[/* data */ 'd'];
                    this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    }
    onDataMessage_(message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(message));
            const reqNum = message['r'];
            const onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message[/*body*/ 'b']);
            }
        } else if ('error' in message) throw 'A server-side error has occurred: ' + message['error'];
        else if ('a' in message) // a and b are action and body, respectively
        this.onDataPush_(message['a'], message['b']);
    }
    onDataPush_(action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge*/ false, body['t']);
        else if (action === 'm') this.onDataUpdate_(body[/*path*/ 'p'], body[/*data*/ 'd'], /*isMerge=*/ true, body['t']);
        else if (action === 'c') this.onListenRevoked_(body[/*path*/ 'p'], body[/*query*/ 'q']);
        else if (action === 'ac') this.onAuthRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'apc') this.onAppCheckRevoked_(body[/*status code*/ 's'], body[/* explanation */ 'd']);
        else if (action === 'sd') this.onSecurityDebugPacket_(body);
        else $e0be213f695400f3$var$error('Unrecognized action received from server: ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(action) + '\nAre you using the latest client?');
    }
    onReady_(timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) this.sendConnectStats_();
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    }
    scheduleConnect_(timeout) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) clearTimeout(this.establishConnectionTimer_);
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(()=>{
            this.establishConnectionTimer_ = null;
            this.establishConnection_();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }, Math.floor(timeout));
    }
    initConnection_() {
        if (!this.realtime_ && this.firstConnection_) this.scheduleConnect_(0);
    }
    onVisible_(visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible && !this.visible_ && this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
        this.visible_ = visible;
    }
    onOnline_(online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        } else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) this.realtime_.close();
        }
    }
    onRealtimeDisconnect_() {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            } else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                const timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > $e0be213f695400f3$var$RECONNECT_DELAY_RESET_TIMEOUT) this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            const timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            let reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * $e0be213f695400f3$var$RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    }
    async establishConnection_() {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            const onDataMessage = this.onDataMessage_.bind(this);
            const onReady = this.onReady_.bind(this);
            const onDisconnect = this.onRealtimeDisconnect_.bind(this);
            const connId = this.id + ':' + $e0be213f695400f3$var$PersistentConnection.nextConnectionId_++;
            const lastSessionId = this.lastSessionId;
            let canceled = false;
            let connection = null;
            const closeFn = function() {
                if (connection) connection.close();
                else {
                    canceled = true;
                    onDisconnect();
                }
            };
            const sendRequestFn = function(msg) {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(connection, "sendRequest call when we're not connected not allowed.");
                connection.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn,
                sendRequest: sendRequestFn
            };
            const forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            try {
                // First fetch auth and app check token, and establish connection after
                // fetching the token was successful
                const [authToken, appCheckToken] = await Promise.all([
                    this.authTokenProvider_.getToken(forceRefresh),
                    this.appCheckTokenProvider_.getToken(forceRefresh)
                ]);
                if (!canceled) {
                    $e0be213f695400f3$var$log('getToken() completed. Creating connection.');
                    this.authToken_ = authToken && authToken.accessToken;
                    this.appCheckToken_ = appCheckToken && appCheckToken.token;
                    connection = new $e0be213f695400f3$var$Connection(connId, this.repoInfo_, this.applicationId_, this.appCheckToken_, this.authToken_, onDataMessage, onReady, onDisconnect, /* onKill= */ (reason)=>{
                        $e0be213f695400f3$var$warn(reason + ' (' + this.repoInfo_.toString() + ')');
                        this.interrupt($e0be213f695400f3$var$SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId);
                } else $e0be213f695400f3$var$log('getToken() completed but was canceled');
            } catch (error) {
                this.log_('Failed to get token: ' + error);
                if (!canceled) {
                    if (this.repoInfo_.nodeAdmin) // This may be a critical error for the Admin Node.js SDK, so log a warning.
                    // But getToken() may also just have temporarily failed, so we still want to
                    // continue retrying.
                    $e0be213f695400f3$var$warn(error);
                    closeFn();
                }
            }
        }
    }
    interrupt(reason) {
        $e0be213f695400f3$var$log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) this.realtime_.close();
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) this.onRealtimeDisconnect_();
        }
    }
    resume(reason) {
        $e0be213f695400f3$var$log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if ((0, $474ae12482b554c6$export$dd1bc94b04021eeb)(this.interruptReasons_)) {
            this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MIN_DELAY;
            if (!this.realtime_) this.scheduleConnect_(0);
        }
    }
    handleTimestamp_(timestamp) {
        const delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({
            serverTimeOffset: delta
        });
    }
    cancelSentTransactions_() {
        for(let i = 0; i < this.outstandingPuts_.length; i++){
            const put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete) put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0) this.outstandingPuts_ = [];
    }
    onListenRevoked_(pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        let queryId;
        if (!query) queryId = 'default';
        else queryId = query.map((q)=>$e0be213f695400f3$var$ObjectToUniqueKey(q)).join('$');
        const listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete) listen.onComplete('permission_denied');
    }
    removeListen_(pathString, queryId) {
        const normalizedPathString = new $e0be213f695400f3$var$Path(pathString).toString(); // normalize path.
        let listen;
        if (this.listens.has(normalizedPathString)) {
            const map = this.listens.get(normalizedPathString);
            listen = map.get(queryId);
            map.delete(queryId);
            if (map.size === 0) this.listens.delete(normalizedPathString);
        } else // all listens for this path has already been removed
        listen = undefined;
        return listen;
    }
    onAuthRevoked_(statusCode, explanation) {
        $e0be213f695400f3$var$log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = $e0be213f695400f3$var$RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    }
    onAppCheckRevoked_(statusCode, explanation) {
        $e0be213f695400f3$var$log('App check token revoked: ' + statusCode + '/' + explanation);
        this.appCheckToken_ = null;
        this.forceTokenRefresh_ = true;
        // Note: We don't close the connection as the developer may not have
        // enforcement enabled. The backend closes connections with enforcements.
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAppCheckTokenCount_++;
            if (this.invalidAppCheckTokenCount_ >= $e0be213f695400f3$var$INVALID_TOKEN_THRESHOLD) this.appCheckTokenProvider_.notifyForInvalidToken();
        }
    }
    onSecurityDebugPacket_(body) {
        if (this.securityDebugCallback_) this.securityDebugCallback_(body);
        else if ('msg' in body) console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
    }
    restoreState_() {
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        this.tryAppCheck();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        for (const queries of this.listens.values())for (const listenSpec of queries.values())this.sendListen_(listenSpec);
        for(let i = 0; i < this.outstandingPuts_.length; i++)if (this.outstandingPuts_[i]) this.sendPut_(i);
        while(this.onDisconnectRequestQueue_.length){
            const request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
        for(let i = 0; i < this.outstandingGets_.length; i++)if (this.outstandingGets_[i]) this.sendGet_(i);
    }
    /**
     * Sends client stats for first connection
     */ sendConnectStats_() {
        const stats = {};
        let clientName = 'js';
        if ((0, $474ae12482b554c6$export$5d1d834fbbf8bab7)()) {
            if (this.repoInfo_.nodeAdmin) clientName = 'admin_node';
            else clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + $e0be213f695400f3$var$SDK_VERSION.replace(/\./g, '-')] = 1;
        if ((0, $474ae12482b554c6$export$872f8323f01d7ae0)()) stats['framework.cordova'] = 1;
        else if ((0, $474ae12482b554c6$export$f7a1e23e542d38e3)()) stats['framework.reactnative'] = 1;
        this.reportStats(stats);
    }
    shouldReconnect_() {
        const online = $e0be213f695400f3$var$OnlineMonitor.getInstance().currentlyOnline();
        return (0, $474ae12482b554c6$export$dd1bc94b04021eeb)(this.interruptReasons_) && online;
    }
}
$e0be213f695400f3$var$PersistentConnection.nextPersistentConnectionId_ = 0;
/**
 * Counter for number of connections created. Mainly used for tagging in the logs
 */ $e0be213f695400f3$var$PersistentConnection.nextConnectionId_ = 0;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$NamedNode {
    constructor(name, node){
        this.name = name;
        this.node = node;
    }
    static Wrap(name, node) {
        return new $e0be213f695400f3$var$NamedNode(name, node);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Index {
    /**
     * @returns A standalone comparison function for
     * this index
     */ getCompare() {
        return this.compare.bind(this);
    }
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     *
     * @returns True if the portion of the snapshot being indexed changed between oldNode and newNode
     */ indexedValueChanged(oldNode, newNode) {
        const oldWrapped = new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, oldNode);
        const newWrapped = new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    }
    /**
     * @returns a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */ minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$__EMPTY_NODE;
class $e0be213f695400f3$var$KeyIndex extends $e0be213f695400f3$var$Index {
    static get __EMPTY_NODE() {
        return $e0be213f695400f3$var$__EMPTY_NODE;
    }
    static set __EMPTY_NODE(val) {
        $e0be213f695400f3$var$__EMPTY_NODE = val;
    }
    compare(a, b) {
        return $e0be213f695400f3$var$nameCompare(a.name, b.name);
    }
    isDefinedOn(node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('KeyIndex.isDefinedOn not expected to be called.');
    }
    indexedValueChanged(oldNode, newNode) {
        return false; // The key for a node never changes.
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, $e0be213f695400f3$var$__EMPTY_NODE);
    }
    makePost(indexValue, name) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new $e0be213f695400f3$var$NamedNode(indexValue, $e0be213f695400f3$var$__EMPTY_NODE);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.key';
    }
}
const $e0be213f695400f3$var$KEY_INDEX = new $e0be213f695400f3$var$KeyIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An iterator over an LLRBNode.
 */ class $e0be213f695400f3$var$SortedMapIterator {
    /**
     * @param node - Node to iterate.
     * @param isReverse_ - Whether or not to iterate in reverse
     */ constructor(node, startKey, comparator, isReverse_, resultGenerator_ = null){
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        this.nodeStack_ = [];
        let cmp = 1;
        while(!node.isEmpty()){
            node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_) cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) node = node.left;
                else node = node.right;
            } else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            } else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) node = node.right;
                else node = node.left;
            }
        }
    }
    getNext() {
        if (this.nodeStack_.length === 0) return null;
        let node = this.nodeStack_.pop();
        let result;
        if (this.resultGenerator_) result = this.resultGenerator_(node.key, node.value);
        else result = {
            key: node.key,
            value: node.value
        };
        if (this.isReverse_) {
            node = node.left;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.right;
            }
        } else {
            node = node.right;
            while(!node.isEmpty()){
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    }
    hasNext() {
        return this.nodeStack_.length > 0;
    }
    peek() {
        if (this.nodeStack_.length === 0) return null;
        const node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) return this.resultGenerator_(node.key, node.value);
        else return {
            key: node.key,
            value: node.value
        };
    }
}
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */ class $e0be213f695400f3$var$LLRBNode {
    /**
     * @param key - Key associated with this node.
     * @param value - Value associated with this node.
     * @param color - Whether this node is red.
     * @param left - Left child.
     * @param right - Right child.
     */ constructor(key, value, color, left, right){
        this.key = key;
        this.value = value;
        this.color = color != null ? color : $e0be213f695400f3$var$LLRBNode.RED;
        this.left = left != null ? left : $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
        this.right = right != null ? right : $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param key - New key for the node, or null.
     * @param value - New value for the node, or null.
     * @param color - New color for the node, or null.
     * @param left - New left child for the node, or null.
     * @param right - New right child for the node, or null.
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return new $e0be213f695400f3$var$LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return this.left.count() + 1 + this.right.count();
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return false;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.left.inorderTraversal(action) || !!action(this.key, this.value) || this.right.inorderTraversal(action);
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return this.right.reverseTraversal(action) || action(this.key, this.value) || this.left.reverseTraversal(action);
    }
    /**
     * @returns The minimum node in the tree.
     */ min_() {
        if (this.left.isEmpty()) return this;
        else return this.left.min_();
    }
    /**
     * @returns The maximum key in the tree.
     */ minKey() {
        return this.min_().key;
    }
    /**
     * @returns The maximum key in the tree.
     */ maxKey() {
        if (this.right.isEmpty()) return this.key;
        else return this.right.maxKey();
    }
    /**
     * @param key - Key to insert.
     * @param value - Value to insert.
     * @param comparator - Comparator.
     * @returns New tree, with the key/value added.
     */ insert(key, value, comparator) {
        let n = this;
        const cmp = comparator(key, n.key);
        if (cmp < 0) n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        else if (cmp === 0) n = n.copy(null, value, null, null, null);
        else n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        return n.fixUp_();
    }
    /**
     * @returns New tree, with the minimum key removed.
     */ removeMin_() {
        if (this.left.isEmpty()) return $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
        let n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    }
    /**
     * @param key - The key of the item to remove.
     * @param comparator - Comparator.
     * @returns New tree, with the specified item removed.
     */ remove(key, comparator) {
        let n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) n = n.moveRedLeft_();
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        } else {
            if (n.left.isRed_()) n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) n = n.moveRedRight_();
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) return $e0be213f695400f3$var$SortedMap.EMPTY_NODE;
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    }
    /**
     * @returns Whether this is a RED node.
     */ isRed_() {
        return this.color;
    }
    /**
     * @returns New tree after performing any needed rotations.
     */ fixUp_() {
        let n = this;
        if (n.right.isRed_() && !n.left.isRed_()) n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_()) n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_()) n = n.colorFlip_();
        return n;
    }
    /**
     * @returns New tree, after moveRedLeft.
     */ moveRedLeft_() {
        let n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after moveRedRight.
     */ moveRedRight_() {
        let n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    }
    /**
     * @returns New tree, after rotateLeft.
     */ rotateLeft_() {
        const nl = this.copy(null, null, $e0be213f695400f3$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    }
    /**
     * @returns New tree, after rotateRight.
     */ rotateRight_() {
        const nr = this.copy(null, null, $e0be213f695400f3$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    }
    /**
     * @returns Newt ree, after colorFlip.
     */ colorFlip_() {
        const left = this.left.copy(null, null, !this.left.color, null, null);
        const right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    }
    /**
     * For testing.
     *
     * @returns True if all is well.
     */ checkMaxDepth_() {
        const blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    }
    check_() {
        if (this.isRed_() && this.left.isRed_()) throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        if (this.right.isRed_()) throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        const blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) throw new Error('Black depths differ');
        else return blackDepth + (this.isRed_() ? 0 : 1);
    }
}
$e0be213f695400f3$var$LLRBNode.RED = true;
$e0be213f695400f3$var$LLRBNode.BLACK = false;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */ class $e0be213f695400f3$var$LLRBEmptyNode {
    /**
     * Returns a copy of the current node.
     *
     * @returns The node copy.
     */ copy(key, value, color, left, right) {
        return this;
    }
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @param comparator - Comparator.
     * @returns New tree, with item added.
     */ insert(key, value, comparator) {
        return new $e0be213f695400f3$var$LLRBNode(key, value, null);
    }
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param key - The key to remove.
     * @param comparator - Comparator.
     * @returns New tree, with item removed.
     */ remove(key, comparator) {
        return this;
    }
    /**
     * @returns The total number of nodes in the tree.
     */ count() {
        return 0;
    }
    /**
     * @returns True if the tree is empty.
     */ isEmpty() {
        return true;
    }
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ inorderTraversal(action) {
        return false;
    }
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param action - Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @returns True if traversal was aborted.
     */ reverseTraversal(action) {
        return false;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    check_() {
        return 0;
    }
    /**
     * @returns Whether this node is red.
     */ isRed_() {
        return false;
    }
}
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */ class $e0be213f695400f3$var$SortedMap {
    /**
     * @param comparator_ - Key comparator.
     * @param root_ - Optional root node for the map.
     */ constructor(comparator_, root_ = $e0be213f695400f3$var$SortedMap.EMPTY_NODE){
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param key - Key to be added.
     * @param value - Value to be added.
     * @returns New map, with item added.
     */ insert(key, value) {
        return new $e0be213f695400f3$var$SortedMap(this.comparator_, this.root_.insert(key, value, this.comparator_).copy(null, null, $e0be213f695400f3$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param key - The key to remove.
     * @returns New map, with item removed.
     */ remove(key) {
        return new $e0be213f695400f3$var$SortedMap(this.comparator_, this.root_.remove(key, this.comparator_).copy(null, null, $e0be213f695400f3$var$LLRBNode.BLACK, null, null));
    }
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param key - The key to look up.
     * @returns The value of the node with the given key, or null if the
     * key doesn't exist.
     */ get(key) {
        let cmp;
        let node = this.root_;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) return node.value;
            else if (cmp < 0) node = node.left;
            else if (cmp > 0) node = node.right;
        }
        return null;
    }
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param key - The key to find the predecessor of
     * @returns The predecessor key.
     */ getPredecessorKey(key) {
        let cmp, node = this.root_, rightParent = null;
        while(!node.isEmpty()){
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while(!node.right.isEmpty())node = node.right;
                    return node.key;
                } else if (rightParent) return rightParent.key;
                else return null; // first item.
            } else if (cmp < 0) node = node.left;
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    }
    /**
     * @returns True if the map is empty.
     */ isEmpty() {
        return this.root_.isEmpty();
    }
    /**
     * @returns The total number of nodes in the map.
     */ count() {
        return this.root_.count();
    }
    /**
     * @returns The minimum key in the map.
     */ minKey() {
        return this.root_.minKey();
    }
    /**
     * @returns The maximum key in the map.
     */ maxKey() {
        return this.root_.maxKey();
    }
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns The first truthy value returned by action, or the last falsey
     *   value returned by action
     */ inorderTraversal(action) {
        return this.root_.inorderTraversal(action);
    }
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param action - Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @returns True if the traversal was aborted.
     */ reverseTraversal(action) {
        return this.root_.reverseTraversal(action);
    }
    /**
     * Returns an iterator over the SortedMap.
     * @returns The iterator.
     */ getIterator(resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    }
    getIteratorFrom(key, resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    }
    getReverseIteratorFrom(key, resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    }
    getReverseIterator(resultGenerator) {
        return new $e0be213f695400f3$var$SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    }
}
/**
 * Always use the same empty node, to reduce memory.
 */ $e0be213f695400f3$var$SortedMap.EMPTY_NODE = new $e0be213f695400f3$var$LLRBEmptyNode();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$NAME_ONLY_COMPARATOR(left, right) {
    return $e0be213f695400f3$var$nameCompare(left.name, right.name);
}
function $e0be213f695400f3$var$NAME_COMPARATOR(left, right) {
    return $e0be213f695400f3$var$nameCompare(left, right);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$MAX_NODE$2;
function $e0be213f695400f3$var$setMaxNode$1(val) {
    $e0be213f695400f3$var$MAX_NODE$2 = val;
}
const $e0be213f695400f3$var$priorityHashText = function(priority) {
    if (typeof priority === 'number') return 'number:' + $e0be213f695400f3$var$doubleToIEEE754String(priority);
    else return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 */ const $e0be213f695400f3$var$validatePriorityNode = function(priorityNode) {
    if (priorityNode.isLeafNode()) {
        const val = priorityNode.val();
        (0, $474ae12482b554c6$export$a7a9523472993e97)(typeof val === 'string' || typeof val === 'number' || typeof val === 'object' && (0, $474ae12482b554c6$export$2344b14b097df817)(val, '.sv'), 'Priority must be a string or number.');
    } else (0, $474ae12482b554c6$export$a7a9523472993e97)(priorityNode === $e0be213f695400f3$var$MAX_NODE$2 || priorityNode.isEmpty(), 'priority of unexpected type.');
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    (0, $474ae12482b554c6$export$a7a9523472993e97)(priorityNode === $e0be213f695400f3$var$MAX_NODE$2 || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$__childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */ class $e0be213f695400f3$var$LeafNode {
    /**
     * @param value_ - The value to store in this leaf node. The object type is
     * possible in the event of a deferred value
     * @param priorityNode_ - The priority of this node.
     */ constructor(value_, priorityNode_ = $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE){
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        $e0be213f695400f3$var$validatePriorityNode(this.priorityNode_);
    }
    static set __childrenNodeConstructor(val) {
        $e0be213f695400f3$var$__childrenNodeConstructor = val;
    }
    static get __childrenNodeConstructor() {
        return $e0be213f695400f3$var$__childrenNodeConstructor;
    }
    /** @inheritDoc */ isLeafNode() {
        return true;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        return new $e0be213f695400f3$var$LeafNode(this.value_, newPriorityNode);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.priorityNode_;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    /** @inheritDoc */ getChild(path) {
        if ($e0be213f695400f3$var$pathIsEmpty(path)) return this;
        else if ($e0be213f695400f3$var$pathGetFront(path) === '.priority') return this.priorityNode_;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE;
    }
    hasChild() {
        return false;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode) {
        return null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else if (newChildNode.isEmpty() && childName !== '.priority') return this;
        else return $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else if (newChildNode.isEmpty() && front !== '.priority') return this;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(front !== '.priority' || $e0be213f695400f3$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild($e0be213f695400f3$var$pathPopFront(path), newChildNode));
        }
    }
    /** @inheritDoc */ isEmpty() {
        return false;
    }
    /** @inheritDoc */ numChildren() {
        return 0;
    }
    /** @inheritDoc */ forEachChild(index, action) {
        return false;
    }
    val(exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty()) return {
            '.value': this.getValue(),
            '.priority': this.getPriority().val()
        };
        else return this.getValue();
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.priorityNode_.isEmpty()) toHash += 'priority:' + $e0be213f695400f3$var$priorityHashText(this.priorityNode_.val()) + ':';
            const type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') toHash += $e0be213f695400f3$var$doubleToIEEE754String(this.value_);
            else toHash += this.value_;
            this.lazyHash_ = $e0be213f695400f3$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /**
     * Returns the value of the leaf node.
     * @returns The value of the node.
     */ getValue() {
        return this.value_;
    }
    compareTo(other) {
        if (other === $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor.EMPTY_NODE) return 1;
        else if (other instanceof $e0be213f695400f3$var$LeafNode.__childrenNodeConstructor) return -1;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    }
    /**
     * Comparison specifically for two leaf nodes
     */ compareToLeafNode_(otherLeaf) {
        const otherLeafType = typeof otherLeaf.value_;
        const thisLeafType = typeof this.value_;
        const otherIndex = $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        const thisIndex = $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') // Deferred value nodes are all equal, but we should also never get to this point...
            return 0;
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) return -1;
                else if (this.value_ === otherLeaf.value_) return 0;
                else return 1;
            }
        } else return thisIndex - otherIndex;
    }
    withIndex() {
        return this;
    }
    isIndexed() {
        return true;
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) {
            const otherLeaf = other;
            return this.value_ === otherLeaf.value_ && this.priorityNode_.equals(otherLeaf.priorityNode_);
        } else return false;
    }
}
/**
 * The sort order for comparing leaf nodes of different types. If two leaf nodes have
 * the same type, the comparison falls back to their value
 */ $e0be213f695400f3$var$LeafNode.VALUE_TYPE_ORDER = [
    'object',
    'boolean',
    'number',
    'string'
];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$nodeFromJSON$1;
let $e0be213f695400f3$var$MAX_NODE$1;
function $e0be213f695400f3$var$setNodeFromJSON(val) {
    $e0be213f695400f3$var$nodeFromJSON$1 = val;
}
function $e0be213f695400f3$var$setMaxNode(val) {
    $e0be213f695400f3$var$MAX_NODE$1 = val;
}
class $e0be213f695400f3$var$PriorityIndex extends $e0be213f695400f3$var$Index {
    compare(a, b) {
        const aPriority = a.node.getPriority();
        const bPriority = b.node.getPriority();
        const indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return !node.getPriority().isEmpty();
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, new $e0be213f695400f3$var$LeafNode('[PRIORITY-POST]', $e0be213f695400f3$var$MAX_NODE$1));
    }
    makePost(indexValue, name) {
        const priorityNode = $e0be213f695400f3$var$nodeFromJSON$1(indexValue);
        return new $e0be213f695400f3$var$NamedNode(name, new $e0be213f695400f3$var$LeafNode('[PRIORITY-POST]', priorityNode));
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.priority';
    }
}
const $e0be213f695400f3$var$PRIORITY_INDEX = new $e0be213f695400f3$var$PriorityIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$LOG_2 = Math.log(2);
class $e0be213f695400f3$var$Base12Num {
    constructor(length){
        const logBase2 = (num)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            parseInt(Math.log(num) / $e0be213f695400f3$var$LOG_2, 10);
        const bitMask = (bits)=>parseInt(Array(bits + 1).join('1'), 2);
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        const mask = bitMask(this.count);
        this.bits_ = length + 1 & mask;
    }
    nextBitIsOne() {
        //noinspection JSBitwiseOperatorUsage
        const result = !(this.bits_ & 0x1 << this.current_);
        this.current_--;
        return result;
    }
}
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @param childList - Unsorted list of children
 * @param cmp - The comparison method to be used
 * @param keyFn - An optional function to extract K from a node wrapper, if K's
 * type is not NamedNode
 * @param mapSortFn - An optional override for comparator used by the generated sorted map
 */ const $e0be213f695400f3$var$buildChildSet = function(childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    const buildBalancedTree = function(low, high) {
        const length = high - low;
        let namedNode;
        let key;
        if (length === 0) return null;
        else if (length === 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, $e0be213f695400f3$var$LLRBNode.BLACK, null, null);
        } else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const middle = parseInt(length / 2, 10) + low;
            const left = buildBalancedTree(low, middle);
            const right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, $e0be213f695400f3$var$LLRBNode.BLACK, left, right);
        }
    };
    const buildFrom12Array = function(base12) {
        let node = null;
        let root = null;
        let index = childList.length;
        const buildPennant = function(chunkSize, color) {
            const low = index - chunkSize;
            const high = index;
            index -= chunkSize;
            const childTree = buildBalancedTree(low + 1, high);
            const namedNode = childList[low];
            const key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new $e0be213f695400f3$var$LLRBNode(key, namedNode.node, color, null, childTree));
        };
        const attachPennant = function(pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            } else {
                root = pennant;
                node = pennant;
            }
        };
        for(let i = 0; i < base12.count; ++i){
            const isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            const chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.BLACK);
            else {
                // current == 2
                buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.BLACK);
                buildPennant(chunkSize, $e0be213f695400f3$var$LLRBNode.RED);
            }
        }
        return root;
    };
    const base12 = new $e0be213f695400f3$var$Base12Num(childList.length);
    const root = buildFrom12Array(base12);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new $e0be213f695400f3$var$SortedMap(mapSortFn || cmp, root);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$_defaultIndexMap;
const $e0be213f695400f3$var$fallbackObject = {};
class $e0be213f695400f3$var$IndexMap {
    constructor(indexes_, indexSet_){
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    /**
     * The default IndexMap for nodes without a priority
     */ static get Default() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$fallbackObject && $e0be213f695400f3$var$PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
        $e0be213f695400f3$var$_defaultIndexMap = $e0be213f695400f3$var$_defaultIndexMap || new $e0be213f695400f3$var$IndexMap({
            '.priority': $e0be213f695400f3$var$fallbackObject
        }, {
            '.priority': $e0be213f695400f3$var$PRIORITY_INDEX
        });
        return $e0be213f695400f3$var$_defaultIndexMap;
    }
    get(indexKey) {
        const sortedMap = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.indexes_, indexKey);
        if (!sortedMap) throw new Error('No index defined for ' + indexKey);
        if (sortedMap instanceof $e0be213f695400f3$var$SortedMap) return sortedMap;
        else // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
        // regular child map
        return null;
    }
    hasIndex(indexDefinition) {
        return (0, $474ae12482b554c6$export$2344b14b097df817)(this.indexSet_, indexDefinition.toString());
    }
    addIndex(indexDefinition, existingChildren) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(indexDefinition !== $e0be213f695400f3$var$KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        const childList = [];
        let sawIndexedValue = false;
        const iter = existingChildren.getIterator($e0be213f695400f3$var$NamedNode.Wrap);
        let next = iter.getNext();
        while(next){
            sawIndexedValue = sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        let newIndex;
        if (sawIndexedValue) newIndex = $e0be213f695400f3$var$buildChildSet(childList, indexDefinition.getCompare());
        else newIndex = $e0be213f695400f3$var$fallbackObject;
        const indexName = indexDefinition.toString();
        const newIndexSet = Object.assign({}, this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        const newIndexes = Object.assign({}, this.indexes_);
        newIndexes[indexName] = newIndex;
        return new $e0be213f695400f3$var$IndexMap(newIndexes, newIndexSet);
    }
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     */ addToIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $474ae12482b554c6$export$871de8747c9eaa88)(this.indexes_, (indexedChildren, indexName)=>{
            const index = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.indexSet_, indexName);
            (0, $474ae12482b554c6$export$a7a9523472993e97)(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === $e0be213f695400f3$var$fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    const childList = [];
                    const iter = existingChildren.getIterator($e0be213f695400f3$var$NamedNode.Wrap);
                    let next = iter.getNext();
                    while(next){
                        if (next.name !== namedNode.name) childList.push(next);
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return $e0be213f695400f3$var$buildChildSet(childList, index.getCompare());
                } else // No change, this remains a fallback
                return $e0be213f695400f3$var$fallbackObject;
            } else {
                const existingSnap = existingChildren.get(namedNode.name);
                let newChildren = indexedChildren;
                if (existingSnap) newChildren = newChildren.remove(new $e0be213f695400f3$var$NamedNode(namedNode.name, existingSnap));
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new $e0be213f695400f3$var$IndexMap(newIndexes, this.indexSet_);
    }
    /**
     * Create a new IndexMap instance with the given value removed
     */ removeFromIndexes(namedNode, existingChildren) {
        const newIndexes = (0, $474ae12482b554c6$export$871de8747c9eaa88)(this.indexes_, (indexedChildren)=>{
            if (indexedChildren === $e0be213f695400f3$var$fallbackObject) // This is the fallback. Just return it, nothing to do in this case
            return indexedChildren;
            else {
                const existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) return indexedChildren.remove(new $e0be213f695400f3$var$NamedNode(namedNode.name, existingSnap));
                else // No record of this child
                return indexedChildren;
            }
        });
        return new $e0be213f695400f3$var$IndexMap(newIndexes, this.indexSet_);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO: For memory savings, don't store priorityNode_ if it's empty.
let $e0be213f695400f3$var$EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 */ class $e0be213f695400f3$var$ChildrenNode {
    /**
     * @param children_ - List of children of this node..
     * @param priorityNode_ - The priority of this node (as a snapshot node).
     */ constructor(children_, priorityNode_, indexMap_){
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */ if (this.priorityNode_) $e0be213f695400f3$var$validatePriorityNode(this.priorityNode_);
        if (this.children_.isEmpty()) (0, $474ae12482b554c6$export$a7a9523472993e97)(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
    }
    static get EMPTY_NODE() {
        return $e0be213f695400f3$var$EMPTY_NODE || ($e0be213f695400f3$var$EMPTY_NODE = new $e0be213f695400f3$var$ChildrenNode(new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$NAME_COMPARATOR), null, $e0be213f695400f3$var$IndexMap.Default));
    }
    /** @inheritDoc */ isLeafNode() {
        return false;
    }
    /** @inheritDoc */ getPriority() {
        return this.priorityNode_ || $e0be213f695400f3$var$EMPTY_NODE;
    }
    /** @inheritDoc */ updatePriority(newPriorityNode) {
        if (this.children_.isEmpty()) // Don't allow priorities on empty nodes
        return this;
        else return new $e0be213f695400f3$var$ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
    }
    /** @inheritDoc */ getImmediateChild(childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') return this.getPriority();
        else {
            const child = this.children_.get(childName);
            return child === null ? $e0be213f695400f3$var$EMPTY_NODE : child;
        }
    }
    /** @inheritDoc */ getChild(path) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return this;
        return this.getImmediateChild(front).getChild($e0be213f695400f3$var$pathPopFront(path));
    }
    /** @inheritDoc */ hasChild(childName) {
        return this.children_.get(childName) !== null;
    }
    /** @inheritDoc */ updateImmediateChild(childName, newChildNode) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') return this.updatePriority(newChildNode);
        else {
            const namedNode = new $e0be213f695400f3$var$NamedNode(childName, newChildNode);
            let newChildren, newIndexMap;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            } else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            const newPriority = newChildren.isEmpty() ? $e0be213f695400f3$var$EMPTY_NODE : this.priorityNode_;
            return new $e0be213f695400f3$var$ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    }
    /** @inheritDoc */ updateChild(path, newChildNode) {
        const front = $e0be213f695400f3$var$pathGetFront(path);
        if (front === null) return newChildNode;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(path) !== '.priority' || $e0be213f695400f3$var$pathGetLength(path) === 1, '.priority must be the last token in a path');
            const newImmediateChild = this.getImmediateChild(front).updateChild($e0be213f695400f3$var$pathPopFront(path), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    }
    /** @inheritDoc */ isEmpty() {
        return this.children_.isEmpty();
    }
    /** @inheritDoc */ numChildren() {
        return this.children_.count();
    }
    /** @inheritDoc */ val(exportFormat) {
        if (this.isEmpty()) return null;
        const obj = {};
        let numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && $e0be213f695400f3$var$ChildrenNode.INTEGER_REGEXP_.test(key)) maxKey = Math.max(maxKey, Number(key));
            else allIntegerKeys = false;
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            const array = [];
            // eslint-disable-next-line guard-for-in
            for(const key in obj)array[key] = obj[key];
            return array;
        } else {
            if (exportFormat && !this.getPriority().isEmpty()) obj['.priority'] = this.getPriority().val();
            return obj;
        }
    }
    /** @inheritDoc */ hash() {
        if (this.lazyHash_ === null) {
            let toHash = '';
            if (!this.getPriority().isEmpty()) toHash += 'priority:' + $e0be213f695400f3$var$priorityHashText(this.getPriority().val()) + ':';
            this.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                const childHash = childNode.hash();
                if (childHash !== '') toHash += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash === '' ? '' : $e0be213f695400f3$var$sha1(toHash);
        }
        return this.lazyHash_;
    }
    /** @inheritDoc */ getPredecessorChildName(childName, childNode, index) {
        const idx = this.resolveIndex_(index);
        if (idx) {
            const predecessor = idx.getPredecessorKey(new $e0be213f695400f3$var$NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        } else return this.children_.getPredecessorKey(childName);
    }
    getFirstChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const minKey = idx.minKey();
            return minKey && minKey.name;
        } else return this.children_.minKey();
    }
    getFirstChild(indexDefinition) {
        const minKey = this.getFirstChildName(indexDefinition);
        if (minKey) return new $e0be213f695400f3$var$NamedNode(minKey, this.children_.get(minKey));
        else return null;
    }
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     */ getLastChildName(indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            const maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        } else return this.children_.maxKey();
    }
    getLastChild(indexDefinition) {
        const maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) return new $e0be213f695400f3$var$NamedNode(maxKey, this.children_.get(maxKey));
        else return null;
    }
    forEachChild(index, action) {
        const idx = this.resolveIndex_(index);
        if (idx) return idx.inorderTraversal((wrappedNode)=>{
            return action(wrappedNode.name, wrappedNode.node);
        });
        else return this.children_.inorderTraversal(action);
    }
    getIterator(indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    }
    getIteratorFrom(startPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getIteratorFrom(startPost, (key)=>key);
        else {
            const iterator = this.children_.getIteratorFrom(startPost.name, $e0be213f695400f3$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, startPost) < 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    getReverseIterator(indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    }
    getReverseIteratorFrom(endPost, indexDefinition) {
        const idx = this.resolveIndex_(indexDefinition);
        if (idx) return idx.getReverseIteratorFrom(endPost, (key)=>{
            return key;
        });
        else {
            const iterator = this.children_.getReverseIteratorFrom(endPost.name, $e0be213f695400f3$var$NamedNode.Wrap);
            let next = iterator.peek();
            while(next != null && indexDefinition.compare(next, endPost) > 0){
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    }
    compareTo(other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) return 0;
            else return -1;
        } else if (other.isLeafNode() || other.isEmpty()) return 1;
        else if (other === $e0be213f695400f3$var$MAX_NODE) return -1;
        else // Must be another node with children.
        return 0;
    }
    withIndex(indexDefinition) {
        if (indexDefinition === $e0be213f695400f3$var$KEY_INDEX || this.indexMap_.hasIndex(indexDefinition)) return this;
        else {
            const newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new $e0be213f695400f3$var$ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    }
    isIndexed(index) {
        return index === $e0be213f695400f3$var$KEY_INDEX || this.indexMap_.hasIndex(index);
    }
    equals(other) {
        if (other === this) return true;
        else if (other.isLeafNode()) return false;
        else {
            const otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) return false;
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                const thisIter = this.getIterator($e0be213f695400f3$var$PRIORITY_INDEX);
                const otherIter = otherChildrenNode.getIterator($e0be213f695400f3$var$PRIORITY_INDEX);
                let thisCurrent = thisIter.getNext();
                let otherCurrent = otherIter.getNext();
                while(thisCurrent && otherCurrent){
                    if (thisCurrent.name !== otherCurrent.name || !thisCurrent.node.equals(otherCurrent.node)) return false;
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            } else return false;
        }
    }
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     */ resolveIndex_(indexDefinition) {
        if (indexDefinition === $e0be213f695400f3$var$KEY_INDEX) return null;
        else return this.indexMap_.get(indexDefinition.toString());
    }
}
$e0be213f695400f3$var$ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
class $e0be213f695400f3$var$MaxNode extends $e0be213f695400f3$var$ChildrenNode {
    constructor(){
        super(new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$NAME_COMPARATOR), $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, $e0be213f695400f3$var$IndexMap.Default);
    }
    compareTo(other) {
        if (other === this) return 0;
        else return 1;
    }
    equals(other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    }
    getPriority() {
        return this;
    }
    getImmediateChild(childName) {
        return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    }
    isEmpty() {
        return false;
    }
}
/**
 * Marker that will sort higher than any other snapshot.
 */ const $e0be213f695400f3$var$MAX_NODE = new $e0be213f695400f3$var$MaxNode();
Object.defineProperties($e0be213f695400f3$var$NamedNode, {
    MIN: {
        value: new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MIN_NAME, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, $e0be213f695400f3$var$MAX_NODE)
    }
});
/**
 * Reference Extensions
 */ $e0be213f695400f3$var$KeyIndex.__EMPTY_NODE = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
$e0be213f695400f3$var$LeafNode.__childrenNodeConstructor = $e0be213f695400f3$var$ChildrenNode;
$e0be213f695400f3$var$setMaxNode$1($e0be213f695400f3$var$MAX_NODE);
$e0be213f695400f3$var$setMaxNode($e0be213f695400f3$var$MAX_NODE);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param json - JSON to create a node for.
 * @param priority - Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 */ function $e0be213f695400f3$var$nodeFromJSON(json, priority = null) {
    if (json === null) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    if (typeof json === 'object' && '.priority' in json) priority = json['.priority'];
    (0, $474ae12482b554c6$export$a7a9523472993e97)(priority === null || typeof priority === 'string' || typeof priority === 'number' || typeof priority === 'object' && '.sv' in priority, 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) json = json['.value'];
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        const jsonLeaf = json;
        return new $e0be213f695400f3$var$LeafNode(jsonLeaf, $e0be213f695400f3$var$nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && $e0be213f695400f3$var$USE_HINZE) {
        const children = [];
        let childrenHavePriority = false;
        const hinzeJsonObj = json;
        $e0be213f695400f3$var$each(hinzeJsonObj, (key, child)=>{
            if (key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                const childNode = $e0be213f695400f3$var$nodeFromJSON(child);
                if (!childNode.isEmpty()) {
                    childrenHavePriority = childrenHavePriority || !childNode.getPriority().isEmpty();
                    children.push(new $e0be213f695400f3$var$NamedNode(key, childNode));
                }
            }
        });
        if (children.length === 0) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        const childSet = $e0be213f695400f3$var$buildChildSet(children, $e0be213f695400f3$var$NAME_ONLY_COMPARATOR, (namedNode)=>namedNode.name, $e0be213f695400f3$var$NAME_COMPARATOR);
        if (childrenHavePriority) {
            const sortedChildSet = $e0be213f695400f3$var$buildChildSet(children, $e0be213f695400f3$var$PRIORITY_INDEX.getCompare());
            return new $e0be213f695400f3$var$ChildrenNode(childSet, $e0be213f695400f3$var$nodeFromJSON(priority), new $e0be213f695400f3$var$IndexMap({
                '.priority': sortedChildSet
            }, {
                '.priority': $e0be213f695400f3$var$PRIORITY_INDEX
            }));
        } else return new $e0be213f695400f3$var$ChildrenNode(childSet, $e0be213f695400f3$var$nodeFromJSON(priority), $e0be213f695400f3$var$IndexMap.Default);
    } else {
        let node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        $e0be213f695400f3$var$each(json, (key, childData)=>{
            if ((0, $474ae12482b554c6$export$2344b14b097df817)(json, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    const childNode = $e0be213f695400f3$var$nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty()) node = node.updateImmediateChild(key, childNode);
                }
            }
        });
        return node.updatePriority($e0be213f695400f3$var$nodeFromJSON(priority));
    }
}
$e0be213f695400f3$var$setNodeFromJSON($e0be213f695400f3$var$nodeFromJSON);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$PathIndex extends $e0be213f695400f3$var$Index {
    constructor(indexPath_){
        super();
        this.indexPath_ = indexPath_;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$pathIsEmpty(indexPath_) && $e0be213f695400f3$var$pathGetFront(indexPath_) !== '.priority', "Can't create PathIndex with empty path or .priority key");
    }
    extractChild(snap) {
        return snap.getChild(this.indexPath_);
    }
    isDefinedOn(node) {
        return !node.getChild(this.indexPath_).isEmpty();
    }
    compare(a, b) {
        const aChild = this.extractChild(a.node);
        const bChild = this.extractChild(b.node);
        const indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    makePost(indexValue, name) {
        const valueNode = $e0be213f695400f3$var$nodeFromJSON(indexValue);
        const node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new $e0be213f695400f3$var$NamedNode(name, node);
    }
    maxPost() {
        const node = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, $e0be213f695400f3$var$MAX_NODE);
        return new $e0be213f695400f3$var$NamedNode($e0be213f695400f3$var$MAX_NAME, node);
    }
    toString() {
        return $e0be213f695400f3$var$pathSlice(this.indexPath_, 0).join('/');
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ValueIndex extends $e0be213f695400f3$var$Index {
    compare(a, b) {
        const indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) return $e0be213f695400f3$var$nameCompare(a.name, b.name);
        else return indexCmp;
    }
    isDefinedOn(node) {
        return true;
    }
    indexedValueChanged(oldNode, newNode) {
        return !oldNode.equals(newNode);
    }
    minPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MIN;
    }
    maxPost() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $e0be213f695400f3$var$NamedNode.MAX;
    }
    makePost(indexValue, name) {
        const valueNode = $e0be213f695400f3$var$nodeFromJSON(indexValue);
        return new $e0be213f695400f3$var$NamedNode(name, valueNode);
    }
    /**
     * @returns String representation for inclusion in a query spec
     */ toString() {
        return '.value';
    }
}
const $e0be213f695400f3$var$VALUE_INDEX = new $e0be213f695400f3$var$ValueIndex();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$changeValue(snapshotNode) {
    return {
        type: "value" /* ChangeType.VALUE */ ,
        snapshotNode: snapshotNode
    };
}
function $e0be213f695400f3$var$changeChildAdded(childName, snapshotNode) {
    return {
        type: "child_added" /* ChangeType.CHILD_ADDED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $e0be213f695400f3$var$changeChildRemoved(childName, snapshotNode) {
    return {
        type: "child_removed" /* ChangeType.CHILD_REMOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
function $e0be213f695400f3$var$changeChildChanged(childName, snapshotNode, oldSnap) {
    return {
        type: "child_changed" /* ChangeType.CHILD_CHANGED */ ,
        snapshotNode: snapshotNode,
        childName: childName,
        oldSnap: oldSnap
    };
}
function $e0be213f695400f3$var$changeChildMoved(childName, snapshotNode) {
    return {
        type: "child_moved" /* ChangeType.CHILD_MOVED */ ,
        snapshotNode: snapshotNode,
        childName: childName
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 */ class $e0be213f695400f3$var$IndexedFilter {
    constructor(index_){
        this.index_ = index_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        const oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() === newChild.isEmpty()) // Nothing changed.
            // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
            //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
            return snap;
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(key, oldChild));
                else (0, $474ae12482b554c6$export$a7a9523472993e97)(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
            } else if (oldChild.isEmpty()) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(key, newChild));
            else optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(key, newChild, oldChild));
        }
        if (snap.isLeafNode() && newChild.isEmpty()) return snap;
        else // Make sure the node is indexed
        return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) oldSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                if (!newSnap.hasChild(key)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(key, childNode));
            });
            if (!newSnap.isLeafNode()) newSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
                if (oldSnap.hasChild(key)) {
                    const oldChild = oldSnap.getImmediateChild(key);
                    if (!oldChild.equals(childNode)) optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(key, childNode, oldChild));
                } else optChangeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(key, childNode));
            });
        }
        return newSnap.withIndex(this.index_);
    }
    updatePriority(oldSnap, newPriority) {
        if (oldSnap.isEmpty()) return $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        else return oldSnap.updatePriority(newPriority);
    }
    filtersNodes() {
        return false;
    }
    getIndexedFilter() {
        return this;
    }
    getIndex() {
        return this.index_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 */ class $e0be213f695400f3$var$RangedFilter {
    constructor(params){
        this.indexedFilter_ = new $e0be213f695400f3$var$IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = $e0be213f695400f3$var$RangedFilter.getStartPost_(params);
        this.endPost_ = $e0be213f695400f3$var$RangedFilter.getEndPost_(params);
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    getStartPost() {
        return this.startPost_;
    }
    getEndPost() {
        return this.endPost_;
    }
    matches(node) {
        const isWithinStart = this.startIsInclusive_ ? this.index_.compare(this.getStartPost(), node) <= 0 : this.index_.compare(this.getStartPost(), node) < 0;
        const isWithinEnd = this.endIsInclusive_ ? this.index_.compare(node, this.getEndPost()) <= 0 : this.index_.compare(node, this.getEndPost()) < 0;
        return isWithinStart && isWithinEnd;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new $e0be213f695400f3$var$NamedNode(key, newChild))) newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) // Make sure we have a children node with the correct index, not a leaf node;
        newSnap = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        let filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
        const self = this;
        newSnap.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            if (!self.matches(new $e0be213f695400f3$var$NamedNode(key, childNode))) filtered = filtered.updateImmediateChild(key, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.indexedFilter_;
    }
    getIndex() {
        return this.index_;
    }
    static getStartPost_(params) {
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        } else return params.getIndex().minPost();
    }
    static getEndPost_(params) {
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        } else return params.getIndex().maxPost();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 */ class $e0be213f695400f3$var$LimitedFilter {
    constructor(params){
        this.withinDirectionalStart = (node)=>this.reverse_ ? this.withinEndPost(node) : this.withinStartPost(node);
        this.withinDirectionalEnd = (node)=>this.reverse_ ? this.withinStartPost(node) : this.withinEndPost(node);
        this.withinStartPost = (node)=>{
            const compareRes = this.index_.compare(this.rangedFilter_.getStartPost(), node);
            return this.startIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.withinEndPost = (node)=>{
            const compareRes = this.index_.compare(node, this.rangedFilter_.getEndPost());
            return this.endIsInclusive_ ? compareRes <= 0 : compareRes < 0;
        };
        this.rangedFilter_ = new $e0be213f695400f3$var$RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
        this.startIsInclusive_ = !params.startAfterSet_;
        this.endIsInclusive_ = !params.endBeforeSet_;
    }
    updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new $e0be213f695400f3$var$NamedNode(key, newChild))) newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        if (snap.getImmediateChild(key).equals(newChild)) // No change
        return snap;
        else if (snap.numChildren() < this.limit_) return this.rangedFilter_.getIndexedFilter().updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        else return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
    }
    updateFullNode(oldSnap, newSnap, optChangeAccumulator) {
        let filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) // Make sure we have a children node with the correct index, not a leaf node;
        filtered = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        else if (this.limit_ * 2 < newSnap.numChildren() && newSnap.isIndexed(this.index_)) {
            // Easier to build up a snapshot, since what we're given has more than twice the elements we want
            filtered = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE.withIndex(this.index_);
            // anchor to the startPost, endPost, or last element as appropriate
            let iterator;
            if (this.reverse_) iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
            else iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
            let count = 0;
            while(iterator.hasNext() && count < this.limit_){
                const next = iterator.getNext();
                if (!this.withinDirectionalStart(next)) continue;
                else if (!this.withinDirectionalEnd(next)) break;
                else {
                    filtered = filtered.updateImmediateChild(next.name, next.node);
                    count++;
                }
            }
        } else {
            // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
            filtered = newSnap.withIndex(this.index_);
            // Don't support priorities on queries
            filtered = filtered.updatePriority($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            let iterator;
            if (this.reverse_) iterator = filtered.getReverseIterator(this.index_);
            else iterator = filtered.getIterator(this.index_);
            let count = 0;
            while(iterator.hasNext()){
                const next = iterator.getNext();
                const inRange = count < this.limit_ && this.withinDirectionalStart(next) && this.withinDirectionalEnd(next);
                if (inRange) count++;
                else filtered = filtered.updateImmediateChild(next.name, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            }
        }
        return this.rangedFilter_.getIndexedFilter().updateFullNode(oldSnap, filtered, optChangeAccumulator);
    }
    updatePriority(oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    }
    filtersNodes() {
        return true;
    }
    getIndexedFilter() {
        return this.rangedFilter_.getIndexedFilter();
    }
    getIndex() {
        return this.index_;
    }
    fullLimitUpdateChild_(snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        let cmp;
        if (this.reverse_) {
            const indexCmp = this.index_.getCompare();
            cmp = (a, b)=>indexCmp(b, a);
        } else cmp = this.index_.getCompare();
        const oldEventCache = snap;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(oldEventCache.numChildren() === this.limit_, '');
        const newChildNamedNode = new $e0be213f695400f3$var$NamedNode(childKey, childSnap);
        const windowBoundary = this.reverse_ ? oldEventCache.getFirstChild(this.index_) : oldEventCache.getLastChild(this.index_);
        const inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            const oldChildSnap = oldEventCache.getImmediateChild(childKey);
            let nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while(nextChild != null && (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name)))// There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
            // been applied to the limited filter yet. Ignore this next child which will be updated later in
            // the limited filter...
            nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            const compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            const remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildChanged(childKey, childSnap, oldChildSnap));
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            } else {
                if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(childKey, oldChildSnap));
                const newEventCache = oldEventCache.updateImmediateChild(childKey, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
                const nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(nextChild.name, nextChild.node));
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                } else return newEventCache;
            }
        } else if (childSnap.isEmpty()) // we're deleting a node, but it was not in the window, so ignore it
        return snap;
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildRemoved(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange($e0be213f695400f3$var$changeChildAdded(childKey, childSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap).updateImmediateChild(windowBoundary.name, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE);
            } else return snap;
        } else return snap;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 *
 * @internal
 */ class $e0be213f695400f3$export$7ba287e361c94330 {
    constructor(){
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.startAfterSet_ = false; // can only be true if startSet_ is true
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.endBeforeSet_ = false; // can only be true if endSet_ is true
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = $e0be213f695400f3$var$PRIORITY_INDEX;
    }
    hasStart() {
        return this.startSet_;
    }
    /**
     * @returns True if it would return from left.
     */ isViewFromLeft() {
        if (this.viewFrom_ === '') // limit(), rather than limitToFirst or limitToLast was called.
        // This means that only one of startSet_ and endSet_ is true. Use them
        // to calculate which side of the view to anchor to. If neither is set,
        // anchor to the end.
        return this.startSet_;
        else return this.viewFrom_ === "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    }
    /**
     * Only valid to call if hasStart() returns true
     */ getIndexStartValue() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    }
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     */ getIndexStartName() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) return this.indexStartName_;
        else return $e0be213f695400f3$var$MIN_NAME;
    }
    hasEnd() {
        return this.endSet_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     */ getIndexEndValue() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    }
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     */ getIndexEndName() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) return this.indexEndName_;
        else return $e0be213f695400f3$var$MAX_NAME;
    }
    hasLimit() {
        return this.limitSet_;
    }
    /**
     * @returns True if a limit has been set and it has been explicitly anchored
     */ hasAnchoredLimit() {
        return this.limitSet_ && this.viewFrom_ !== '';
    }
    /**
     * Only valid to call if hasLimit() returns true
     */ getLimit() {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    }
    getIndex() {
        return this.index_;
    }
    loadsAllData() {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    }
    isDefault() {
        return this.loadsAllData() && this.index_ === $e0be213f695400f3$var$PRIORITY_INDEX;
    }
    copy() {
        const copy = new $e0be213f695400f3$export$7ba287e361c94330();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.startAfterSet_ = this.startAfterSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.endBeforeSet_ = this.endBeforeSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    }
}
function $e0be213f695400f3$var$queryParamsGetNodeFilter(queryParams) {
    if (queryParams.loadsAllData()) return new $e0be213f695400f3$var$IndexedFilter(queryParams.getIndex());
    else if (queryParams.hasLimit()) return new $e0be213f695400f3$var$LimitedFilter(queryParams);
    else return new $e0be213f695400f3$var$RangedFilter(queryParams);
}
function $e0be213f695400f3$var$queryParamsLimitToFirst(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
    return newParams;
}
function $e0be213f695400f3$var$queryParamsLimitToLast(queryParams, newLimit) {
    const newParams = queryParams.copy();
    newParams.limitSet_ = true;
    newParams.limit_ = newLimit;
    newParams.viewFrom_ = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
    return newParams;
}
function $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.startSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexStartValue_ = indexValue;
    if (key != null) {
        newParams.startNameSet_ = true;
        newParams.indexStartName_ = key;
    } else {
        newParams.startNameSet_ = false;
        newParams.indexStartName_ = '';
    }
    return newParams;
}
function $e0be213f695400f3$var$queryParamsStartAfter(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX || !!key) params = $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, key);
    else params = $e0be213f695400f3$var$queryParamsStartAt(queryParams, indexValue, $e0be213f695400f3$var$MAX_NAME);
    params.startAfterSet_ = true;
    return params;
}
function $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, key) {
    const newParams = queryParams.copy();
    newParams.endSet_ = true;
    if (indexValue === undefined) indexValue = null;
    newParams.indexEndValue_ = indexValue;
    if (key !== undefined) {
        newParams.endNameSet_ = true;
        newParams.indexEndName_ = key;
    } else {
        newParams.endNameSet_ = false;
        newParams.indexEndName_ = '';
    }
    return newParams;
}
function $e0be213f695400f3$var$queryParamsEndBefore(queryParams, indexValue, key) {
    let params;
    if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX || !!key) params = $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, key);
    else params = $e0be213f695400f3$var$queryParamsEndAt(queryParams, indexValue, $e0be213f695400f3$var$MIN_NAME);
    params.endBeforeSet_ = true;
    return params;
}
function $e0be213f695400f3$var$queryParamsOrderBy(queryParams, index) {
    const newParams = queryParams.copy();
    newParams.index_ = index;
    return newParams;
}
/**
 * Returns a set of REST query string parameters representing this query.
 *
 * @returns query string parameters
 */ function $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(queryParams) {
    const qs = {};
    if (queryParams.isDefault()) return qs;
    let orderBy;
    if (queryParams.index_ === $e0be213f695400f3$var$PRIORITY_INDEX) orderBy = "$priority" /* REST_QUERY_CONSTANTS.PRIORITY_INDEX */ ;
    else if (queryParams.index_ === $e0be213f695400f3$var$VALUE_INDEX) orderBy = "$value" /* REST_QUERY_CONSTANTS.VALUE_INDEX */ ;
    else if (queryParams.index_ === $e0be213f695400f3$var$KEY_INDEX) orderBy = "$key" /* REST_QUERY_CONSTANTS.KEY_INDEX */ ;
    else {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(queryParams.index_ instanceof $e0be213f695400f3$var$PathIndex, 'Unrecognized index type!');
        orderBy = queryParams.index_.toString();
    }
    qs["orderBy" /* REST_QUERY_CONSTANTS.ORDER_BY */ ] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(orderBy);
    if (queryParams.startSet_) {
        const startParam = queryParams.startAfterSet_ ? "startAfter" /* REST_QUERY_CONSTANTS.START_AFTER */  : "startAt" /* REST_QUERY_CONSTANTS.START_AT */ ;
        qs[startParam] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexStartValue_);
        if (queryParams.startNameSet_) qs[startParam] += ',' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexStartName_);
    }
    if (queryParams.endSet_) {
        const endParam = queryParams.endBeforeSet_ ? "endBefore" /* REST_QUERY_CONSTANTS.END_BEFORE */  : "endAt" /* REST_QUERY_CONSTANTS.END_AT */ ;
        qs[endParam] = (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexEndValue_);
        if (queryParams.endNameSet_) qs[endParam] += ',' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(queryParams.indexEndName_);
    }
    if (queryParams.limitSet_) {
        if (queryParams.isViewFromLeft()) qs["limitToFirst" /* REST_QUERY_CONSTANTS.LIMIT_TO_FIRST */ ] = queryParams.limit_;
        else qs["limitToLast" /* REST_QUERY_CONSTANTS.LIMIT_TO_LAST */ ] = queryParams.limit_;
    }
    return qs;
}
function $e0be213f695400f3$var$queryParamsGetQueryObject(queryParams) {
    const obj = {};
    if (queryParams.startSet_) {
        obj["sp" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE */ ] = queryParams.indexStartValue_;
        if (queryParams.startNameSet_) obj["sn" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME */ ] = queryParams.indexStartName_;
        obj["sin" /* WIRE_PROTOCOL_CONSTANTS.INDEX_START_IS_INCLUSIVE */ ] = !queryParams.startAfterSet_;
    }
    if (queryParams.endSet_) {
        obj["ep" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE */ ] = queryParams.indexEndValue_;
        if (queryParams.endNameSet_) obj["en" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME */ ] = queryParams.indexEndName_;
        obj["ein" /* WIRE_PROTOCOL_CONSTANTS.INDEX_END_IS_INCLUSIVE */ ] = !queryParams.endBeforeSet_;
    }
    if (queryParams.limitSet_) {
        obj["l" /* WIRE_PROTOCOL_CONSTANTS.LIMIT */ ] = queryParams.limit_;
        let viewFrom = queryParams.viewFrom_;
        if (viewFrom === '') {
            if (queryParams.isViewFromLeft()) viewFrom = "l" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT */ ;
            else viewFrom = "r" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT */ ;
        }
        obj["vf" /* WIRE_PROTOCOL_CONSTANTS.VIEW_FROM */ ] = viewFrom;
    }
    // For now, priority index is the default, so we only specify if it's some other index
    if (queryParams.index_ !== $e0be213f695400f3$var$PRIORITY_INDEX) obj["i" /* WIRE_PROTOCOL_CONSTANTS.INDEX */ ] = queryParams.index_.toString();
    return obj;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */ class $e0be213f695400f3$var$ReadonlyRestClient extends $e0be213f695400f3$var$ServerActions {
    /**
     * @param repoInfo_ - Data about the namespace we are connecting to
     * @param onDataUpdate_ - A callback for new data from the server
     */ constructor(repoInfo_, onDataUpdate_, authTokenProvider_, appCheckTokenProvider_){
        super();
        this.repoInfo_ = repoInfo_;
        this.onDataUpdate_ = onDataUpdate_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckTokenProvider_ = appCheckTokenProvider_;
        /** @private {function(...[*])} */ this.log_ = $e0be213f695400f3$var$logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         */ this.listens_ = {};
    }
    reportStats(stats) {
        throw new Error('Method not implemented.');
    }
    static getListenId_(query, tag) {
        if (tag !== undefined) return 'tag$' + tag;
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(query._queryParams.isDefault(), "should have a tag if it's not a default query.");
            return query._path.toString();
        }
    }
    /** @inheritDoc */ listen(query, currentHashFn, tag, onComplete) {
        const pathString = query._path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query._queryIdentifier);
        // Mark this listener so we can tell if it's removed.
        const listenId = $e0be213f695400f3$var$ReadonlyRestClient.getListenId_(query, tag);
        const thisListen = {};
        this.listens_[listenId] = thisListen;
        const queryStringParameters = $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(query._queryParams);
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            if ((0, $474ae12482b554c6$export$e51ae4db7b428f67)(this.listens_, listenId) === thisListen) {
                let status;
                if (!error) status = 'ok';
                else if (error === 401) status = 'permission_denied';
                else status = 'rest_error:' + error;
                onComplete(status, null);
            }
        });
    }
    /** @inheritDoc */ unlisten(query, tag) {
        const listenId = $e0be213f695400f3$var$ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    }
    get(query) {
        const queryStringParameters = $e0be213f695400f3$var$queryParamsToRestQueryStringParameters(query._queryParams);
        const pathString = query._path.toString();
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        this.restRequest_(pathString + '.json', queryStringParameters, (error, result)=>{
            let data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                this.onDataUpdate_(pathString, data, /*isMerge=*/ false, /*tag=*/ null);
                deferred.resolve(data);
            } else deferred.reject(new Error(data));
        });
        return deferred.promise;
    }
    /** @inheritDoc */ refreshAuthToken(token) {
    // no-op since we just always call getToken.
    }
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     */ restRequest_(pathString, queryStringParameters = {}, callback) {
        queryStringParameters['format'] = 'export';
        return Promise.all([
            this.authTokenProvider_.getToken(/*forceRefresh=*/ false),
            this.appCheckTokenProvider_.getToken(/*forceRefresh=*/ false)
        ]).then(([authToken, appCheckToken])=>{
            if (authToken && authToken.accessToken) queryStringParameters['auth'] = authToken.accessToken;
            if (appCheckToken && appCheckToken.token) queryStringParameters['ac'] = appCheckToken.token;
            const url = (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host + pathString + '?' + 'ns=' + this.repoInfo_.namespace + (0, $474ae12482b554c6$export$ac4103b836844853)(queryStringParameters);
            this.log_('Sending REST request for ' + url);
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = ()=>{
                if (callback && xhr.readyState === 4) {
                    this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    let res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = (0, $474ae12482b554c6$export$c5a53ce6a17cf18d)(xhr.responseText);
                        } catch (e) {
                            $e0be213f695400f3$var$warn('Failed to parse JSON response for ' + url + ': ' + xhr.responseText);
                        }
                        callback(null, res);
                    } else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) $e0be213f695400f3$var$warn('Got unsuccessful REST response for ' + url + ' Status: ' + xhr.status);
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 */ class $e0be213f695400f3$var$SnapshotHolder {
    constructor(){
        this.rootNode_ = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    }
    getNode(path) {
        return this.rootNode_.getChild(path);
    }
    updateSnapshot(path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newSparseSnapshotTree() {
    return {
        value: null,
        children: new Map()
    };
}
/**
 * Stores the given node at the specified path. If there is already a node
 * at a shallower path, it merges the new data into that snapshot node.
 *
 * @param path - Path to look up snapshot for.
 * @param data - The new data, or null.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeRemember(sparseSnapshotTree, path, data) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = data;
        sparseSnapshotTree.children.clear();
    } else if (sparseSnapshotTree.value !== null) sparseSnapshotTree.value = sparseSnapshotTree.value.updateChild(path, data);
    else {
        const childKey = $e0be213f695400f3$var$pathGetFront(path);
        if (!sparseSnapshotTree.children.has(childKey)) sparseSnapshotTree.children.set(childKey, $e0be213f695400f3$var$newSparseSnapshotTree());
        const child = sparseSnapshotTree.children.get(childKey);
        path = $e0be213f695400f3$var$pathPopFront(path);
        $e0be213f695400f3$var$sparseSnapshotTreeRemember(child, path, data);
    }
}
/**
 * Purge the data at path from the cache.
 *
 * @param path - Path to look up snapshot for.
 * @returns True if this node should now be removed.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) {
        sparseSnapshotTree.value = null;
        sparseSnapshotTree.children.clear();
        return true;
    } else {
        if (sparseSnapshotTree.value !== null) {
            if (sparseSnapshotTree.value.isLeafNode()) // We're trying to forget a node that doesn't exist
            return false;
            else {
                const value = sparseSnapshotTree.value;
                sparseSnapshotTree.value = null;
                value.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, tree)=>{
                    $e0be213f695400f3$var$sparseSnapshotTreeRemember(sparseSnapshotTree, new $e0be213f695400f3$var$Path(key), tree);
                });
                return $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree, path);
            }
        } else if (sparseSnapshotTree.children.size > 0) {
            const childKey = $e0be213f695400f3$var$pathGetFront(path);
            path = $e0be213f695400f3$var$pathPopFront(path);
            if (sparseSnapshotTree.children.has(childKey)) {
                const safeToRemove = $e0be213f695400f3$var$sparseSnapshotTreeForget(sparseSnapshotTree.children.get(childKey), path);
                if (safeToRemove) sparseSnapshotTree.children.delete(childKey);
            }
            return sparseSnapshotTree.children.size === 0;
        } else return true;
    }
}
/**
 * Recursively iterates through all of the stored tree and calls the
 * callback on each one.
 *
 * @param prefixPath - Path to look up node for.
 * @param func - The function to invoke for each tree.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(sparseSnapshotTree, prefixPath, func) {
    if (sparseSnapshotTree.value !== null) func(prefixPath, sparseSnapshotTree.value);
    else $e0be213f695400f3$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, (key, tree)=>{
        const path = new $e0be213f695400f3$var$Path(prefixPath.toString() + '/' + key);
        $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(tree, path, func);
    });
}
/**
 * Iterates through each immediate child and triggers the callback.
 * Only seems to be used in tests.
 *
 * @param func - The function to invoke for each child.
 */ function $e0be213f695400f3$var$sparseSnapshotTreeForEachChild(sparseSnapshotTree, func) {
    sparseSnapshotTree.children.forEach((tree, key)=>{
        func(key, tree);
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ - The collection to "listen" to.
 */ class $e0be213f695400f3$var$StatsListener {
    constructor(collection_){
        this.collection_ = collection_;
        this.last_ = null;
    }
    get() {
        const newStats = this.collection_.get();
        const delta = Object.assign({}, newStats);
        if (this.last_) $e0be213f695400f3$var$each(this.last_, (stat, value)=>{
            delta[stat] = delta[stat] - value;
        });
        this.last_ = newStats;
        return delta;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
const $e0be213f695400f3$var$FIRST_STATS_MIN_TIME = 10000;
const $e0be213f695400f3$var$FIRST_STATS_MAX_TIME = 30000;
// We'll continue to report stats on average every 5 minutes.
const $e0be213f695400f3$var$REPORT_STATS_INTERVAL = 300000;
class $e0be213f695400f3$var$StatsReporter {
    constructor(collection, server_){
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new $e0be213f695400f3$var$StatsListener(collection);
        const timeout = $e0be213f695400f3$var$FIRST_STATS_MIN_TIME + ($e0be213f695400f3$var$FIRST_STATS_MAX_TIME - $e0be213f695400f3$var$FIRST_STATS_MIN_TIME) * Math.random();
        $e0be213f695400f3$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    reportStats_() {
        const stats = this.statsListener_.get();
        const reportedStats = {};
        let haveStatsToReport = false;
        $e0be213f695400f3$var$each(stats, (stat, value)=>{
            if (value > 0 && (0, $474ae12482b554c6$export$2344b14b097df817)(this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) this.server_.reportStats(reportedStats);
        // queue our next run.
        $e0be213f695400f3$var$setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * $e0be213f695400f3$var$REPORT_STATS_INTERVAL));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *
 * @enum
 */ var $e0be213f695400f3$var$OperationType;
(function(OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})($e0be213f695400f3$var$OperationType || ($e0be213f695400f3$var$OperationType = {}));
function $e0be213f695400f3$var$newOperationSourceUser() {
    return {
        fromUser: true,
        fromServer: false,
        queryId: null,
        tagged: false
    };
}
function $e0be213f695400f3$var$newOperationSourceServer() {
    return {
        fromUser: false,
        fromServer: true,
        queryId: null,
        tagged: false
    };
}
function $e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId) {
    return {
        fromUser: false,
        fromServer: true,
        queryId: queryId,
        tagged: true
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$AckUserWrite {
    /**
     * @param affectedTree - A tree containing true for each affected path. Affected paths can't overlap.
     */ constructor(/** @inheritDoc */ path, /** @inheritDoc */ affectedTree, /** @inheritDoc */ revert){
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.ACK_USER_WRITE;
        /** @inheritDoc */ this.source = $e0be213f695400f3$var$newOperationSourceUser();
    }
    operationForChild(childName) {
        if (!$e0be213f695400f3$var$pathIsEmpty(this.path)) {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(this.path) === childName, 'operationForChild called for unrelated child.');
            return new $e0be213f695400f3$var$AckUserWrite($e0be213f695400f3$var$pathPopFront(this.path), this.affectedTree, this.revert);
        } else if (this.affectedTree.value != null) {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        } else {
            const childTree = this.affectedTree.subtree(new $e0be213f695400f3$var$Path(childName));
            return new $e0be213f695400f3$var$AckUserWrite($e0be213f695400f3$var$newEmptyPath(), childTree, this.revert);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ListenComplete {
    constructor(source, path){
        this.source = source;
        this.path = path;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.LISTEN_COMPLETE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) return new $e0be213f695400f3$var$ListenComplete(this.source, $e0be213f695400f3$var$newEmptyPath());
        else return new $e0be213f695400f3$var$ListenComplete(this.source, $e0be213f695400f3$var$pathPopFront(this.path));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Overwrite {
    constructor(source, path, snap){
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.OVERWRITE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$newEmptyPath(), this.snap.getImmediateChild(childName));
        else return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$pathPopFront(this.path), this.snap);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$Merge {
    constructor(/** @inheritDoc */ source, /** @inheritDoc */ path, /** @inheritDoc */ children){
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */ this.type = $e0be213f695400f3$var$OperationType.MERGE;
    }
    operationForChild(childName) {
        if ($e0be213f695400f3$var$pathIsEmpty(this.path)) {
            const childTree = this.children.subtree(new $e0be213f695400f3$var$Path(childName));
            if (childTree.isEmpty()) // This child is unaffected
            return null;
            else if (childTree.value) // We have a snapshot for the child in question.  This becomes an overwrite of the child.
            return new $e0be213f695400f3$var$Overwrite(this.source, $e0be213f695400f3$var$newEmptyPath(), childTree.value);
            else // This is a merge at a deeper level
            return new $e0be213f695400f3$var$Merge(this.source, $e0be213f695400f3$var$newEmptyPath(), childTree);
        } else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetFront(this.path) === childName, "Can't get a merge for a child not on the path of the operation");
            return new $e0be213f695400f3$var$Merge(this.source, $e0be213f695400f3$var$pathPopFront(this.path), this.children);
        }
    }
    toString() {
        return 'Operation(' + this.path + ': ' + this.source.toString() + ' merge: ' + this.children.toString() + ')';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */ class $e0be213f695400f3$var$CacheNode {
    constructor(node_, fullyInitialized_, filtered_){
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     */ isFullyInitialized() {
        return this.fullyInitialized_;
    }
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     */ isFiltered() {
        return this.filtered_;
    }
    isCompleteForPath(path) {
        if ($e0be213f695400f3$var$pathIsEmpty(path)) return this.isFullyInitialized() && !this.filtered_;
        const childKey = $e0be213f695400f3$var$pathGetFront(path);
        return this.isCompleteForChild(childKey);
    }
    isCompleteForChild(key) {
        return this.isFullyInitialized() && !this.filtered_ || this.node_.hasChild(key);
    }
    getNode() {
        return this.node_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 */ class $e0be213f695400f3$var$EventGenerator {
    constructor(query_){
        this.query_ = query_;
        this.index_ = this.query_._queryParams.getIndex();
    }
}
/**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 *  - child_moved events will be synthesized at this time for any child_changed events that affect
 *    our index.
 *  - prevName will be calculated based on the index ordering.
 */ function $e0be213f695400f3$var$eventGeneratorGenerateEventsForChanges(eventGenerator, changes, eventCache, eventRegistrations) {
    const events = [];
    const moves = [];
    changes.forEach((change)=>{
        if (change.type === "child_changed" /* ChangeType.CHILD_CHANGED */  && eventGenerator.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) moves.push($e0be213f695400f3$var$changeChildMoved(change.childName, change.snapshotNode));
    });
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_removed" /* ChangeType.CHILD_REMOVED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_added" /* ChangeType.CHILD_ADDED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_moved" /* ChangeType.CHILD_MOVED */ , moves, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "child_changed" /* ChangeType.CHILD_CHANGED */ , changes, eventRegistrations, eventCache);
    $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, "value" /* ChangeType.VALUE */ , changes, eventRegistrations, eventCache);
    return events;
}
/**
 * Given changes of a single change type, generate the corresponding events.
 */ function $e0be213f695400f3$var$eventGeneratorGenerateEventsForType(eventGenerator, events, eventType, changes, registrations, eventCache) {
    const filteredChanges = changes.filter((change)=>change.type === eventType);
    filteredChanges.sort((a, b)=>$e0be213f695400f3$var$eventGeneratorCompareChanges(eventGenerator, a, b));
    filteredChanges.forEach((change)=>{
        const materializedChange = $e0be213f695400f3$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache);
        registrations.forEach((registration)=>{
            if (registration.respondsTo(change.type)) events.push(registration.createEvent(materializedChange, eventGenerator.query_));
        });
    });
}
function $e0be213f695400f3$var$eventGeneratorMaterializeSingleChange(eventGenerator, change, eventCache) {
    if (change.type === 'value' || change.type === 'child_removed') return change;
    else {
        change.prevName = eventCache.getPredecessorChildName(change.childName, change.snapshotNode, eventGenerator.index_);
        return change;
    }
}
function $e0be213f695400f3$var$eventGeneratorCompareChanges(eventGenerator, a, b) {
    if (a.childName == null || b.childName == null) throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Should only compare child_ events.');
    const aWrapped = new $e0be213f695400f3$var$NamedNode(a.childName, a.snapshotNode);
    const bWrapped = new $e0be213f695400f3$var$NamedNode(b.childName, b.snapshotNode);
    return eventGenerator.index_.compare(aWrapped, bWrapped);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newViewCache(eventCache, serverCache) {
    return {
        eventCache: eventCache,
        serverCache: serverCache
    };
}
function $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, eventSnap, complete, filtered) {
    return $e0be213f695400f3$var$newViewCache(new $e0be213f695400f3$var$CacheNode(eventSnap, complete, filtered), viewCache.serverCache);
}
function $e0be213f695400f3$var$viewCacheUpdateServerSnap(viewCache, serverSnap, complete, filtered) {
    return $e0be213f695400f3$var$newViewCache(viewCache.eventCache, new $e0be213f695400f3$var$CacheNode(serverSnap, complete, filtered));
}
function $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(viewCache) {
    return viewCache.eventCache.isFullyInitialized() ? viewCache.eventCache.getNode() : null;
}
function $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache) {
    return viewCache.serverCache.isFullyInitialized() ? viewCache.serverCache.getNode() : null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 */ const $e0be213f695400f3$var$EmptyChildren = ()=>{
    if (!$e0be213f695400f3$var$emptyChildrenSingleton) $e0be213f695400f3$var$emptyChildrenSingleton = new $e0be213f695400f3$var$SortedMap($e0be213f695400f3$var$stringCompare);
    return $e0be213f695400f3$var$emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */ class $e0be213f695400f3$var$ImmutableTree {
    constructor(value, children = $e0be213f695400f3$var$EmptyChildren()){
        this.value = value;
        this.children = children;
    }
    static fromObject(obj) {
        let tree = new $e0be213f695400f3$var$ImmutableTree(null);
        $e0be213f695400f3$var$each(obj, (childPath, childSnap)=>{
            tree = tree.set(new $e0be213f695400f3$var$Path(childPath), childSnap);
        });
        return tree;
    }
    /**
     * True if the value is empty and there are no children
     */ isEmpty() {
        return this.value === null && this.children.isEmpty();
    }
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of `{path: value:}`
     * objects on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param relativePath - The remainder of the path
     * @param predicate - The predicate to satisfy to return a node
     */ findRootMostMatchingPathAndValue(relativePath, predicate) {
        if (this.value != null && predicate(this.value)) return {
            path: $e0be213f695400f3$var$newEmptyPath(),
            value: this.value
        };
        else {
            if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return null;
            else {
                const front = $e0be213f695400f3$var$pathGetFront(relativePath);
                const child = this.children.get(front);
                if (child !== null) {
                    const childExistingPathAndValue = child.findRootMostMatchingPathAndValue($e0be213f695400f3$var$pathPopFront(relativePath), predicate);
                    if (childExistingPathAndValue != null) {
                        const fullPath = $e0be213f695400f3$var$pathChild(new $e0be213f695400f3$var$Path(front), childExistingPathAndValue.path);
                        return {
                            path: fullPath,
                            value: childExistingPathAndValue.value
                        };
                    } else return null;
                } else return null;
            }
        }
    }
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     */ findRootMostValueAndPath(relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, ()=>true);
    }
    /**
     * @returns The subtree at the given path
     */ subtree(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return this;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const childTree = this.children.get(front);
            if (childTree !== null) return childTree.subtree($e0be213f695400f3$var$pathPopFront(relativePath));
            else return new $e0be213f695400f3$var$ImmutableTree(null);
        }
    }
    /**
     * Sets a value at the specified path.
     *
     * @param relativePath - Path to set value at.
     * @param toSet - Value to set.
     * @returns Resulting tree.
     */ set(relativePath, toSet) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return new $e0be213f695400f3$var$ImmutableTree(toSet, this.children);
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $e0be213f695400f3$var$ImmutableTree(null);
            const newChild = child.set($e0be213f695400f3$var$pathPopFront(relativePath), toSet);
            const newChildren = this.children.insert(front, newChild);
            return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Removes the value at the specified path.
     *
     * @param relativePath - Path to value to remove.
     * @returns Resulting tree.
     */ remove(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) {
            if (this.children.isEmpty()) return new $e0be213f695400f3$var$ImmutableTree(null);
            else return new $e0be213f695400f3$var$ImmutableTree(null, this.children);
        } else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) {
                const newChild = child.remove($e0be213f695400f3$var$pathPopFront(relativePath));
                let newChildren;
                if (newChild.isEmpty()) newChildren = this.children.remove(front);
                else newChildren = this.children.insert(front, newChild);
                if (this.value === null && newChildren.isEmpty()) return new $e0be213f695400f3$var$ImmutableTree(null);
                else return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
            } else return this;
        }
    }
    /**
     * Gets a value from the tree.
     *
     * @param relativePath - Path to get value for.
     * @returns Value at path, or null.
     */ get(relativePath) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return this.value;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front);
            if (child) return child.get($e0be213f695400f3$var$pathPopFront(relativePath));
            else return null;
        }
    }
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param relativePath - Path to replace subtree for.
     * @param newTree - New tree.
     * @returns Resulting tree.
     */ setTree(relativePath, newTree) {
        if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) return newTree;
        else {
            const front = $e0be213f695400f3$var$pathGetFront(relativePath);
            const child = this.children.get(front) || new $e0be213f695400f3$var$ImmutableTree(null);
            const newChild = child.setTree($e0be213f695400f3$var$pathPopFront(relativePath), newTree);
            let newChildren;
            if (newChild.isEmpty()) newChildren = this.children.remove(front);
            else newChildren = this.children.insert(front, newChild);
            return new $e0be213f695400f3$var$ImmutableTree(this.value, newChildren);
        }
    }
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     */ fold(fn) {
        return this.fold_($e0be213f695400f3$var$newEmptyPath(), fn);
    }
    /**
     * Recursive helper for public-facing fold() method
     */ fold_(pathSoFar, fn) {
        const accum = {};
        this.children.inorderTraversal((childKey, childTree)=>{
            accum[childKey] = childTree.fold_($e0be213f695400f3$var$pathChild(pathSoFar, childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    }
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     */ findOnPath(path, f) {
        return this.findOnPath_(path, $e0be213f695400f3$var$newEmptyPath(), f);
    }
    findOnPath_(pathToFollow, pathSoFar, f) {
        const result = this.value ? f(pathSoFar, this.value) : false;
        if (result) return result;
        else {
            if ($e0be213f695400f3$var$pathIsEmpty(pathToFollow)) return null;
            else {
                const front = $e0be213f695400f3$var$pathGetFront(pathToFollow);
                const nextChild = this.children.get(front);
                if (nextChild) return nextChild.findOnPath_($e0be213f695400f3$var$pathPopFront(pathToFollow), $e0be213f695400f3$var$pathChild(pathSoFar, front), f);
                else return null;
            }
        }
    }
    foreachOnPath(path, f) {
        return this.foreachOnPath_(path, $e0be213f695400f3$var$newEmptyPath(), f);
    }
    foreachOnPath_(pathToFollow, currentRelativePath, f) {
        if ($e0be213f695400f3$var$pathIsEmpty(pathToFollow)) return this;
        else {
            if (this.value) f(currentRelativePath, this.value);
            const front = $e0be213f695400f3$var$pathGetFront(pathToFollow);
            const nextChild = this.children.get(front);
            if (nextChild) return nextChild.foreachOnPath_($e0be213f695400f3$var$pathPopFront(pathToFollow), $e0be213f695400f3$var$pathChild(currentRelativePath, front), f);
            else return new $e0be213f695400f3$var$ImmutableTree(null);
        }
    }
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param f - A function to be called with the path from the root of the tree to
     * a node, and the value at that node. Called in depth-first order.
     */ foreach(f) {
        this.foreach_($e0be213f695400f3$var$newEmptyPath(), f);
    }
    foreach_(currentRelativePath, f) {
        this.children.inorderTraversal((childName, childTree)=>{
            childTree.foreach_($e0be213f695400f3$var$pathChild(currentRelativePath, childName), f);
        });
        if (this.value) f(currentRelativePath, this.value);
    }
    foreachChild(f) {
        this.children.inorderTraversal((childName, childTree)=>{
            if (childTree.value) f(childName, childTree.value);
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 */ class $e0be213f695400f3$var$CompoundWrite {
    constructor(writeTree_){
        this.writeTree_ = writeTree_;
    }
    static empty() {
        return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(null));
    }
}
function $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, path, node) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(node));
    else {
        const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            const rootMostPath = rootmost.path;
            let value = rootmost.value;
            const relativePath = $e0be213f695400f3$var$newRelativePath(rootMostPath, path);
            value = value.updateChild(relativePath, node);
            return new $e0be213f695400f3$var$CompoundWrite(compoundWrite.writeTree_.set(rootMostPath, value));
        } else {
            const subtree = new $e0be213f695400f3$var$ImmutableTree(node);
            const newWriteTree = compoundWrite.writeTree_.setTree(path, subtree);
            return new $e0be213f695400f3$var$CompoundWrite(newWriteTree);
        }
    }
}
function $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, path, updates) {
    let newWrite = compoundWrite;
    $e0be213f695400f3$var$each(updates, (childKey, node)=>{
        newWrite = $e0be213f695400f3$var$compoundWriteAddWrite(newWrite, $e0be213f695400f3$var$pathChild(path, childKey), node);
    });
    return newWrite;
}
/**
 * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param compoundWrite - The CompoundWrite to remove.
 * @param path - The path at which a write and all deeper writes should be removed
 * @returns The new CompoundWrite with the removed path
 */ function $e0be213f695400f3$var$compoundWriteRemoveWrite(compoundWrite, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return $e0be213f695400f3$var$CompoundWrite.empty();
    else {
        const newWriteTree = compoundWrite.writeTree_.setTree(path, new $e0be213f695400f3$var$ImmutableTree(null));
        return new $e0be213f695400f3$var$CompoundWrite(newWriteTree);
    }
}
/**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param compoundWrite - The CompoundWrite to check.
 * @param path - The path to check for
 * @returns Whether there is a complete write at that path
 */ function $e0be213f695400f3$var$compoundWriteHasCompleteWrite(compoundWrite, path) {
    return $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path) != null;
}
/**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param compoundWrite - The CompoundWrite to get the node from.
 * @param path - The path to get a complete write
 * @returns The node if complete at that path, or null otherwise.
 */ function $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path) {
    const rootmost = compoundWrite.writeTree_.findRootMostValueAndPath(path);
    if (rootmost != null) return compoundWrite.writeTree_.get(rootmost.path).getChild($e0be213f695400f3$var$newRelativePath(rootmost.path, path));
    else return null;
}
/**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @param compoundWrite - The CompoundWrite to get children from.
 * @returns A list of all complete children.
 */ function $e0be213f695400f3$var$compoundWriteGetCompleteChildren(compoundWrite) {
    const children = [];
    const node = compoundWrite.writeTree_.value;
    if (node != null) // If it's a leaf node, it has no children; so nothing to do.
    {
        if (!node.isLeafNode()) node.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            children.push(new $e0be213f695400f3$var$NamedNode(childName, childNode));
        });
    } else compoundWrite.writeTree_.children.inorderTraversal((childName, childTree)=>{
        if (childTree.value != null) children.push(new $e0be213f695400f3$var$NamedNode(childName, childTree.value));
    });
    return children;
}
function $e0be213f695400f3$var$compoundWriteChildCompoundWrite(compoundWrite, path) {
    if ($e0be213f695400f3$var$pathIsEmpty(path)) return compoundWrite;
    else {
        const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(compoundWrite, path);
        if (shadowingNode != null) return new $e0be213f695400f3$var$CompoundWrite(new $e0be213f695400f3$var$ImmutableTree(shadowingNode));
        else return new $e0be213f695400f3$var$CompoundWrite(compoundWrite.writeTree_.subtree(path));
    }
}
/**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @returns Whether this CompoundWrite is empty
 */ function $e0be213f695400f3$var$compoundWriteIsEmpty(compoundWrite) {
    return compoundWrite.writeTree_.isEmpty();
}
/**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param node - The node to apply this CompoundWrite to
 * @returns The node with all writes applied
 */ function $e0be213f695400f3$var$compoundWriteApply(compoundWrite, node) {
    return $e0be213f695400f3$var$applySubtreeWrite($e0be213f695400f3$var$newEmptyPath(), compoundWrite.writeTree_, node);
}
function $e0be213f695400f3$var$applySubtreeWrite(relativePath, writeTree, node) {
    if (writeTree.value != null) // Since there a write is always a leaf, we're done here
    return node.updateChild(relativePath, writeTree.value);
    else {
        let priorityWrite = null;
        writeTree.children.inorderTraversal((childKey, childTree)=>{
            if (childKey === '.priority') {
                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                // to apply priorities to empty nodes that are later filled
                (0, $474ae12482b554c6$export$a7a9523472993e97)(childTree.value !== null, 'Priority writes must always be leaf nodes');
                priorityWrite = childTree.value;
            } else node = $e0be213f695400f3$var$applySubtreeWrite($e0be213f695400f3$var$pathChild(relativePath, childKey), childTree, node);
        });
        // If there was a priority write, we only apply it if the node is not empty
        if (!node.getChild(relativePath).isEmpty() && priorityWrite !== null) node = node.updateChild($e0be213f695400f3$var$pathChild(relativePath, '.priority'), priorityWrite);
        return node;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 */ function $e0be213f695400f3$var$writeTreeChildWrites(writeTree, path) {
    return $e0be213f695400f3$var$newWriteTreeRef(path, writeTree);
}
/**
 * Record a new overwrite from user code.
 *
 * @param visible - This is set to false by some transactions. It should be excluded from event caches
 */ function $e0be213f695400f3$var$writeTreeAddOverwrite(writeTree, path, snap, writeId, visible) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older write on top of newer ones');
    if (visible === undefined) visible = true;
    writeTree.allWrites.push({
        path: path,
        snap: snap,
        writeId: writeId,
        visible: visible
    });
    if (visible) writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteAddWrite(writeTree.visibleWrites, path, snap);
    writeTree.lastWriteId = writeId;
}
/**
 * Record a new merge from user code.
 */ function $e0be213f695400f3$var$writeTreeAddMerge(writeTree, path, changedChildren, writeId) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(writeId > writeTree.lastWriteId, 'Stacking an older merge on top of newer ones');
    writeTree.allWrites.push({
        path: path,
        children: changedChildren,
        writeId: writeId,
        visible: true
    });
    writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteAddWrites(writeTree.visibleWrites, path, changedChildren);
    writeTree.lastWriteId = writeId;
}
function $e0be213f695400f3$var$writeTreeGetWrite(writeTree, writeId) {
    for(let i = 0; i < writeTree.allWrites.length; i++){
        const record = writeTree.allWrites[i];
        if (record.writeId === writeId) return record;
    }
    return null;
}
/**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @returns true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */ function $e0be213f695400f3$var$writeTreeRemoveWrite(writeTree, writeId) {
    // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
    // out of order.
    //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
    //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
    const idx = writeTree.allWrites.findIndex((s)=>{
        return s.writeId === writeId;
    });
    (0, $474ae12482b554c6$export$a7a9523472993e97)(idx >= 0, 'removeWrite called with nonexistent writeId.');
    const writeToRemove = writeTree.allWrites[idx];
    writeTree.allWrites.splice(idx, 1);
    let removedWriteWasVisible = writeToRemove.visible;
    let removedWriteOverlapsWithOtherWrites = false;
    let i = writeTree.allWrites.length - 1;
    while(removedWriteWasVisible && i >= 0){
        const currentWrite = writeTree.allWrites[i];
        if (currentWrite.visible) {
            if (i >= idx && $e0be213f695400f3$var$writeTreeRecordContainsPath_(currentWrite, writeToRemove.path)) // The removed write was completely shadowed by a subsequent write.
            removedWriteWasVisible = false;
            else if ($e0be213f695400f3$var$pathContains(writeToRemove.path, currentWrite.path)) // Either we're covering some writes or they're covering part of us (depending on which came first).
            removedWriteOverlapsWithOtherWrites = true;
        }
        i--;
    }
    if (!removedWriteWasVisible) return false;
    else if (removedWriteOverlapsWithOtherWrites) {
        // There's some shadowing going on. Just rebuild the visible writes from scratch.
        $e0be213f695400f3$var$writeTreeResetTree_(writeTree);
        return true;
    } else {
        // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
        if (writeToRemove.snap) writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteRemoveWrite(writeTree.visibleWrites, writeToRemove.path);
        else {
            const children = writeToRemove.children;
            $e0be213f695400f3$var$each(children, (childName)=>{
                writeTree.visibleWrites = $e0be213f695400f3$var$compoundWriteRemoveWrite(writeTree.visibleWrites, $e0be213f695400f3$var$pathChild(writeToRemove.path, childName));
            });
        }
        return true;
    }
}
function $e0be213f695400f3$var$writeTreeRecordContainsPath_(writeRecord, path) {
    if (writeRecord.snap) return $e0be213f695400f3$var$pathContains(writeRecord.path, path);
    else {
        for(const childName in writeRecord.children){
            if (writeRecord.children.hasOwnProperty(childName) && $e0be213f695400f3$var$pathContains($e0be213f695400f3$var$pathChild(writeRecord.path, childName), path)) return true;
        }
        return false;
    }
}
/**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 */ function $e0be213f695400f3$var$writeTreeResetTree_(writeTree) {
    writeTree.visibleWrites = $e0be213f695400f3$var$writeTreeLayerTree_(writeTree.allWrites, $e0be213f695400f3$var$writeTreeDefaultFilter_, $e0be213f695400f3$var$newEmptyPath());
    if (writeTree.allWrites.length > 0) writeTree.lastWriteId = writeTree.allWrites[writeTree.allWrites.length - 1].writeId;
    else writeTree.lastWriteId = -1;
}
/**
 * The default filter used when constructing the tree. Keep everything that's visible.
 */ function $e0be213f695400f3$var$writeTreeDefaultFilter_(write) {
    return write.visible;
}
/**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 */ function $e0be213f695400f3$var$writeTreeLayerTree_(writes, filter, treeRoot) {
    let compoundWrite = $e0be213f695400f3$var$CompoundWrite.empty();
    for(let i = 0; i < writes.length; ++i){
        const write = writes[i];
        // Theory, a later set will either:
        // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
        // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
        if (filter(write)) {
            const writePath = write.path;
            let relativePath;
            if (write.snap) {
                if ($e0be213f695400f3$var$pathContains(treeRoot, writePath)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, relativePath, write.snap);
                } else if ($e0be213f695400f3$var$pathContains(writePath, treeRoot)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(writePath, treeRoot);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), write.snap.getChild(relativePath));
                }
            } else if (write.children) {
                if ($e0be213f695400f3$var$pathContains(treeRoot, writePath)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(treeRoot, writePath);
                    compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, relativePath, write.children);
                } else if ($e0be213f695400f3$var$pathContains(writePath, treeRoot)) {
                    relativePath = $e0be213f695400f3$var$newRelativePath(writePath, treeRoot);
                    if ($e0be213f695400f3$var$pathIsEmpty(relativePath)) compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrites(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), write.children);
                    else {
                        const child = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(write.children, $e0be213f695400f3$var$pathGetFront(relativePath));
                        if (child) {
                            // There exists a child in this node that matches the root path
                            const deepNode = child.getChild($e0be213f695400f3$var$pathPopFront(relativePath));
                            compoundWrite = $e0be213f695400f3$var$compoundWriteAddWrite(compoundWrite, $e0be213f695400f3$var$newEmptyPath(), deepNode);
                        }
                    }
                }
            } else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('WriteRecord should have .snap or .children');
        }
    }
    return compoundWrite;
}
/**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param writeIdsToExclude - An optional set to be excluded
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTree, treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    if (!writeIdsToExclude && !includeHiddenWrites) {
        const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
        if (shadowingNode != null) return shadowingNode;
        else {
            const subMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
            if ($e0be213f695400f3$var$compoundWriteIsEmpty(subMerge)) return completeServerCache;
            else if (completeServerCache == null && !$e0be213f695400f3$var$compoundWriteHasCompleteWrite(subMerge, $e0be213f695400f3$var$newEmptyPath())) // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
            return null;
            else {
                const layeredCache = completeServerCache || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                return $e0be213f695400f3$var$compoundWriteApply(subMerge, layeredCache);
            }
        }
    } else {
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        if (!includeHiddenWrites && $e0be213f695400f3$var$compoundWriteIsEmpty(merge)) return completeServerCache;
        else {
            // If the server cache is null, and we don't have a complete cache, we need to return null
            if (!includeHiddenWrites && completeServerCache == null && !$e0be213f695400f3$var$compoundWriteHasCompleteWrite(merge, $e0be213f695400f3$var$newEmptyPath())) return null;
            else {
                const filter = function(write) {
                    return (write.visible || includeHiddenWrites) && (!writeIdsToExclude || !~writeIdsToExclude.indexOf(write.writeId)) && ($e0be213f695400f3$var$pathContains(write.path, treePath) || $e0be213f695400f3$var$pathContains(treePath, write.path));
                };
                const mergeAtPath = $e0be213f695400f3$var$writeTreeLayerTree_(writeTree.allWrites, filter, treePath);
                const layeredCache = completeServerCache || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                return $e0be213f695400f3$var$compoundWriteApply(mergeAtPath, layeredCache);
            }
        }
    }
}
/**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteEventChildren(writeTree, treePath, completeServerChildren) {
    let completeChildren = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
    const topLevelSet = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, treePath);
    if (topLevelSet) {
        if (!topLevelSet.isLeafNode()) // we're shadowing everything. Return the children.
        topLevelSet.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childSnap)=>{
            completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
        });
        return completeChildren;
    } else if (completeServerChildren) {
        // Layer any children we have on top of this
        // We know we don't have a top-level set, so just enumerate existing children
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        completeServerChildren.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            const node = $e0be213f695400f3$var$compoundWriteApply($e0be213f695400f3$var$compoundWriteChildCompoundWrite(merge, new $e0be213f695400f3$var$Path(childName)), childNode);
            completeChildren = completeChildren.updateImmediateChild(childName, node);
        });
        // Add any complete children we have from the set
        $e0be213f695400f3$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    } else {
        // We don't have anything to layer on top of. Layer on any children we have
        // Note that we can return an empty snap if we have a defined delete
        const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
        $e0be213f695400f3$var$compoundWriteGetCompleteChildren(merge).forEach((namedNode)=>{
            completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
        });
        return completeChildren;
    }
}
/**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 */ function $e0be213f695400f3$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTree, treePath, childPath, existingEventSnap, existingServerSnap) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
    const path = $e0be213f695400f3$var$pathChild(treePath, childPath);
    if ($e0be213f695400f3$var$compoundWriteHasCompleteWrite(writeTree.visibleWrites, path)) // At this point we can probably guarantee that we're in case 2, meaning no events
    // May need to check visibility while doing the findRootMostValueAndPath call
    return null;
    else {
        // No complete shadowing. We're either partially shadowing or not shadowing at all.
        const childMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
        if ($e0be213f695400f3$var$compoundWriteIsEmpty(childMerge)) // We're not shadowing at all. Case 1
        return existingServerSnap.getChild(childPath);
        else // This could be more efficient if the serverNode + updates doesn't change the eventSnap
        // However this is tricky to find out, since user updates don't necessary change the server
        // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
        // adds nodes, but doesn't change any existing writes. It is therefore not enough to
        // only check if the updates change the serverNode.
        // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
        return $e0be213f695400f3$var$compoundWriteApply(childMerge, existingServerSnap.getChild(childPath));
    }
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $e0be213f695400f3$var$writeTreeCalcCompleteChild(writeTree, treePath, childKey, existingServerSnap) {
    const path = $e0be213f695400f3$var$pathChild(treePath, childKey);
    const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
    if (shadowingNode != null) return shadowingNode;
    else {
        if (existingServerSnap.isCompleteForChild(childKey)) {
            const childMerge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, path);
            return $e0be213f695400f3$var$compoundWriteApply(childMerge, existingServerSnap.getNode().getImmediateChild(childKey));
        } else return null;
    }
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 */ function $e0be213f695400f3$var$writeTreeShadowingWrite(writeTree, path) {
    return $e0be213f695400f3$var$compoundWriteGetCompleteNode(writeTree.visibleWrites, path);
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 */ function $e0be213f695400f3$var$writeTreeCalcIndexedSlice(writeTree, treePath, completeServerData, startPost, count, reverse, index) {
    let toIterate;
    const merge = $e0be213f695400f3$var$compoundWriteChildCompoundWrite(writeTree.visibleWrites, treePath);
    const shadowingNode = $e0be213f695400f3$var$compoundWriteGetCompleteNode(merge, $e0be213f695400f3$var$newEmptyPath());
    if (shadowingNode != null) toIterate = shadowingNode;
    else if (completeServerData != null) toIterate = $e0be213f695400f3$var$compoundWriteApply(merge, completeServerData);
    else // no children to iterate on
    return [];
    toIterate = toIterate.withIndex(index);
    if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
        const nodes = [];
        const cmp = index.getCompare();
        const iter = reverse ? toIterate.getReverseIteratorFrom(startPost, index) : toIterate.getIteratorFrom(startPost, index);
        let next = iter.getNext();
        while(next && nodes.length < count){
            if (cmp(next, startPost) !== 0) nodes.push(next);
            next = iter.getNext();
        }
        return nodes;
    } else return [];
}
function $e0be213f695400f3$var$newWriteTree() {
    return {
        visibleWrites: $e0be213f695400f3$var$CompoundWrite.empty(),
        allWrites: [],
        lastWriteId: -1
    };
}
/**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param writeIdsToExclude - Optional writes to exclude.
 * @param includeHiddenWrites - Defaults to false, whether or not to layer on writes with visible set to false
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writeTreeRef, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites);
}
/**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writeTreeRef, completeServerChildren) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventChildren(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerChildren);
}
/**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 *
 */ function $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writeTreeRef, path, existingEventSnap, existingServerSnap) {
    return $e0be213f695400f3$var$writeTreeCalcEventCacheAfterServerOverwrite(writeTreeRef.writeTree, writeTreeRef.treePath, path, existingEventSnap, existingServerSnap);
}
/**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 */ function $e0be213f695400f3$var$writeTreeRefShadowingWrite(writeTreeRef, path) {
    return $e0be213f695400f3$var$writeTreeShadowingWrite(writeTreeRef.writeTree, $e0be213f695400f3$var$pathChild(writeTreeRef.treePath, path));
}
/**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 */ function $e0be213f695400f3$var$writeTreeRefCalcIndexedSlice(writeTreeRef, completeServerData, startPost, count, reverse, index) {
    return $e0be213f695400f3$var$writeTreeCalcIndexedSlice(writeTreeRef.writeTree, writeTreeRef.treePath, completeServerData, startPost, count, reverse, index);
}
/**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 */ function $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writeTreeRef, childKey, existingServerCache) {
    return $e0be213f695400f3$var$writeTreeCalcCompleteChild(writeTreeRef.writeTree, writeTreeRef.treePath, childKey, existingServerCache);
}
/**
 * Return a WriteTreeRef for a child.
 */ function $e0be213f695400f3$var$writeTreeRefChild(writeTreeRef, childName) {
    return $e0be213f695400f3$var$newWriteTreeRef($e0be213f695400f3$var$pathChild(writeTreeRef.treePath, childName), writeTreeRef.writeTree);
}
function $e0be213f695400f3$var$newWriteTreeRef(path, writeTree) {
    return {
        treePath: path,
        writeTree: writeTree
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ChildChangeAccumulator {
    constructor(){
        this.changeMap = new Map();
    }
    trackChildChange(change) {
        const type = change.type;
        const childKey = change.childName;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(type === "child_added" /* ChangeType.CHILD_ADDED */  || type === "child_changed" /* ChangeType.CHILD_CHANGED */  || type === "child_removed" /* ChangeType.CHILD_REMOVED */ , 'Only child changes supported for tracking');
        (0, $474ae12482b554c6$export$a7a9523472993e97)(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        const oldChange = this.changeMap.get(childKey);
        if (oldChange) {
            const oldType = oldChange.type;
            if (type === "child_added" /* ChangeType.CHILD_ADDED */  && oldType === "child_removed" /* ChangeType.CHILD_REMOVED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildChanged(childKey, change.snapshotNode, oldChange.snapshotNode));
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.delete(childKey);
            else if (type === "child_removed" /* ChangeType.CHILD_REMOVED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildRemoved(childKey, oldChange.oldSnap));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_added" /* ChangeType.CHILD_ADDED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildAdded(childKey, change.snapshotNode));
            else if (type === "child_changed" /* ChangeType.CHILD_CHANGED */  && oldType === "child_changed" /* ChangeType.CHILD_CHANGED */ ) this.changeMap.set(childKey, $e0be213f695400f3$var$changeChildChanged(childKey, change.snapshotNode, oldChange.oldSnap));
            else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Illegal combination of changes: ' + change + ' occurred after ' + oldChange);
        } else this.changeMap.set(childKey, change);
    }
    getChanges() {
        return Array.from(this.changeMap.values());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An implementation of CompleteChildSource that never returns any additional children
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $e0be213f695400f3$var$NoCompleteChildSource_ {
    getCompleteChild(childKey) {
        return null;
    }
    getChildAfterChild(index, child, reverse) {
        return null;
    }
}
/**
 * Singleton instance.
 */ const $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE = new $e0be213f695400f3$var$NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 */ class $e0be213f695400f3$var$WriteTreeCompleteChildSource {
    constructor(writes_, viewCache_, optCompleteServerCache_ = null){
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    getCompleteChild(childKey) {
        const node = this.viewCache_.eventCache;
        if (node.isCompleteForChild(childKey)) return node.getNode().getImmediateChild(childKey);
        else {
            const serverNode = this.optCompleteServerCache_ != null ? new $e0be213f695400f3$var$CacheNode(this.optCompleteServerCache_, true, false) : this.viewCache_.serverCache;
            return $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(this.writes_, childKey, serverNode);
        }
    }
    getChildAfterChild(index, child, reverse) {
        const completeServerData = this.optCompleteServerCache_ != null ? this.optCompleteServerCache_ : $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(this.viewCache_);
        const nodes = $e0be213f695400f3$var$writeTreeRefCalcIndexedSlice(this.writes_, completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) return null;
        else return nodes[0];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$newViewProcessor(filter) {
    return {
        filter: filter
    };
}
function $e0be213f695400f3$var$viewProcessorAssertIndexed(viewProcessor, viewCache) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.eventCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Event snap not indexed');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.serverCache.getNode().isIndexed(viewProcessor.filter.getIndex()), 'Server snap not indexed');
}
function $e0be213f695400f3$var$viewProcessorApplyOperation(viewProcessor, oldViewCache, operation, writesCache, completeCache) {
    const accumulator = new $e0be213f695400f3$var$ChildChangeAccumulator();
    let newViewCache, filterServerNode;
    if (operation.type === $e0be213f695400f3$var$OperationType.OVERWRITE) {
        const overwrite = operation;
        if (overwrite.source.fromUser) newViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(overwrite.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered  and the
            // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
            // again
            filterServerNode = overwrite.source.tagged || oldViewCache.serverCache.isFiltered() && !$e0be213f695400f3$var$pathIsEmpty(overwrite.path);
            newViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $e0be213f695400f3$var$OperationType.MERGE) {
        const merge = operation;
        if (merge.source.fromUser) newViewCache = $e0be213f695400f3$var$viewProcessorApplyUserMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
        else {
            (0, $474ae12482b554c6$export$a7a9523472993e97)(merge.source.fromServer, 'Unknown source.');
            // We filter the node if it's a tagged update or the node has been previously filtered
            filterServerNode = merge.source.tagged || oldViewCache.serverCache.isFiltered();
            newViewCache = $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
        }
    } else if (operation.type === $e0be213f695400f3$var$OperationType.ACK_USER_WRITE) {
        const ackUserWrite = operation;
        if (!ackUserWrite.revert) newViewCache = $e0be213f695400f3$var$viewProcessorAckUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
        else newViewCache = $e0be213f695400f3$var$viewProcessorRevertUserWrite(viewProcessor, oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
    } else if (operation.type === $e0be213f695400f3$var$OperationType.LISTEN_COMPLETE) newViewCache = $e0be213f695400f3$var$viewProcessorListenComplete(viewProcessor, oldViewCache, operation.path, writesCache, accumulator);
    else throw (0, $474ae12482b554c6$export$a39cad550e7ab28a)('Unknown operation type: ' + operation.type);
    const changes = accumulator.getChanges();
    $e0be213f695400f3$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, changes);
    return {
        viewCache: newViewCache,
        changes: changes
    };
}
function $e0be213f695400f3$var$viewProcessorMaybeAddValueEvent(oldViewCache, newViewCache, accumulator) {
    const eventSnap = newViewCache.eventCache;
    if (eventSnap.isFullyInitialized()) {
        const isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
        const oldCompleteSnap = $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(oldViewCache);
        if (accumulator.length > 0 || !oldViewCache.eventCache.isFullyInitialized() || isLeafOrEmpty && !eventSnap.getNode().equals(oldCompleteSnap) || !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) accumulator.push($e0be213f695400f3$var$changeValue($e0be213f695400f3$var$viewCacheGetCompleteEventSnap(newViewCache)));
    }
}
function $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, viewCache, changePath, writesCache, source, accumulator) {
    const oldEventSnap = viewCache.eventCache;
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, changePath) != null) // we have a shadowing write, ignore changes
    return viewCache;
    else {
        let newEventCache, serverNode;
        if ($e0be213f695400f3$var$pathIsEmpty(changePath)) {
            // TODO: figure out how this plays with "sliding ack windows"
            (0, $474ae12482b554c6$export$a7a9523472993e97)(viewCache.serverCache.isFullyInitialized(), 'If change path is empty, we must have complete server data');
            if (viewCache.serverCache.isFiltered()) {
                // We need to special case this, because we need to only apply writes to complete children, or
                // we might end up raising events for incomplete children. If the server data is filtered deep
                // writes cannot be guaranteed to be complete
                const serverCache = $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache);
                const completeChildren = serverCache instanceof $e0be213f695400f3$var$ChildrenNode ? serverCache : $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
                const completeEventChildren = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, completeChildren);
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeEventChildren, accumulator);
            } else {
                const completeNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
                newEventCache = viewProcessor.filter.updateFullNode(viewCache.eventCache.getNode(), completeNode, accumulator);
            }
        } else {
            const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
            if (childKey === '.priority') {
                (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$pathGetLength(changePath) === 1, "Can't have a priority with additional path components");
                const oldEventNode = oldEventSnap.getNode();
                serverNode = viewCache.serverCache.getNode();
                // we might have overwrites for this priority
                const updatedPriority = $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventNode, serverNode);
                if (updatedPriority != null) newEventCache = viewProcessor.filter.updatePriority(oldEventNode, updatedPriority);
                else // priority didn't change, keep old node
                newEventCache = oldEventSnap.getNode();
            } else {
                const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
                // update child
                let newEventChild;
                if (oldEventSnap.isCompleteForChild(childKey)) {
                    serverNode = viewCache.serverCache.getNode();
                    const eventChildUpdate = $e0be213f695400f3$var$writeTreeRefCalcEventCacheAfterServerOverwrite(writesCache, changePath, oldEventSnap.getNode(), serverNode);
                    if (eventChildUpdate != null) newEventChild = oldEventSnap.getNode().getImmediateChild(childKey).updateChild(childChangePath, eventChildUpdate);
                    else // Nothing changed, just keep the old child
                    newEventChild = oldEventSnap.getNode().getImmediateChild(childKey);
                } else newEventChild = $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
                if (newEventChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                else // no complete child available or no change
                newEventCache = oldEventSnap.getNode();
            }
        }
        return $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, newEventCache, oldEventSnap.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(changePath), viewProcessor.filter.filtersNodes());
    }
}
function $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
    const oldServerSnap = oldViewCache.serverCache;
    let newServerCache;
    const serverFilter = filterServerNode ? viewProcessor.filter : viewProcessor.filter.getIndexedFilter();
    if ($e0be213f695400f3$var$pathIsEmpty(changePath)) newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
    else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
        // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
        const newServerNode = oldServerSnap.getNode().updateChild(changePath, changedSnap);
        newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
    } else {
        const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
        if (!oldServerSnap.isCompleteForPath(changePath) && $e0be213f695400f3$var$pathGetLength(changePath) > 1) // We don't update incomplete nodes with updates intended for other listeners
        return oldViewCache;
        const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
        const childNode = oldServerSnap.getNode().getImmediateChild(childKey);
        const newChildNode = childNode.updateChild(childChangePath, changedSnap);
        if (childKey === '.priority') newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
        else newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE, null);
    }
    const newViewCache = $e0be213f695400f3$var$viewCacheUpdateServerSnap(oldViewCache, newServerCache, oldServerSnap.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(changePath), serverFilter.filtersNodes());
    const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
    return $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, changePath, writesCache, source, accumulator);
}
function $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
    const oldEventSnap = oldViewCache.eventCache;
    let newViewCache, newEventCache;
    const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
    if ($e0be213f695400f3$var$pathIsEmpty(changePath)) {
        newEventCache = viewProcessor.filter.updateFullNode(oldViewCache.eventCache.getNode(), changedSnap, accumulator);
        newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, true, viewProcessor.filter.filtersNodes());
    } else {
        const childKey = $e0be213f695400f3$var$pathGetFront(changePath);
        if (childKey === '.priority') {
            newEventCache = viewProcessor.filter.updatePriority(oldViewCache.eventCache.getNode(), changedSnap);
            newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
        } else {
            const childChangePath = $e0be213f695400f3$var$pathPopFront(changePath);
            const oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
            let newChild;
            if ($e0be213f695400f3$var$pathIsEmpty(childChangePath)) // Child overwrite, we can replace the child
            newChild = changedSnap;
            else {
                const childNode = source.getCompleteChild(childKey);
                if (childNode != null) {
                    if ($e0be213f695400f3$var$pathGetBack(childChangePath) === '.priority' && childNode.getChild($e0be213f695400f3$var$pathParent(childChangePath)).isEmpty()) // This is a priority update on an empty node. If this node exists on the server, the
                    // server will send down the priority in the update, so ignore for now
                    newChild = childNode;
                    else newChild = childNode.updateChild(childChangePath, changedSnap);
                } else // There is no complete child node available
                newChild = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            }
            if (!oldChild.equals(newChild)) {
                const newEventSnap = viewProcessor.filter.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                newViewCache = $e0be213f695400f3$var$viewCacheUpdateEventSnap(oldViewCache, newEventSnap, oldEventSnap.isFullyInitialized(), viewProcessor.filter.filtersNodes());
            } else newViewCache = oldViewCache;
        }
    }
    return newViewCache;
}
function $e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, childKey) {
    return viewCache.eventCache.isCompleteForChild(childKey);
}
function $e0be213f695400f3$var$viewProcessorApplyUserMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $e0be213f695400f3$var$pathChild(path, relativePath);
        if ($e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, $e0be213f695400f3$var$pathGetFront(writePath))) curViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    changedChildren.foreach((relativePath, childNode)=>{
        const writePath = $e0be213f695400f3$var$pathChild(path, relativePath);
        if (!$e0be213f695400f3$var$viewProcessorCacheHasChild(viewCache, $e0be213f695400f3$var$pathGetFront(writePath))) curViewCache = $e0be213f695400f3$var$viewProcessorApplyUserOverwrite(viewProcessor, curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
    });
    return curViewCache;
}
function $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, node, merge) {
    merge.foreach((relativePath, childNode)=>{
        node = node.updateChild(relativePath, childNode);
    });
    return node;
}
function $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
    // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
    // wait for the complete data update coming soon.
    if (viewCache.serverCache.getNode().isEmpty() && !viewCache.serverCache.isFullyInitialized()) return viewCache;
    // HACK: In the case of a limit query, there may be some changes that bump things out of the
    // window leaving room for new items.  It's important we process these changes first, so we
    // iterate the changes twice, first processing any that affect items currently in view.
    // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
    // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
    // not the other.
    let curViewCache = viewCache;
    let viewMergeTree;
    if ($e0be213f695400f3$var$pathIsEmpty(path)) viewMergeTree = changedChildren;
    else viewMergeTree = new $e0be213f695400f3$var$ImmutableTree(null).setTree(path, changedChildren);
    const serverNode = viewCache.serverCache.getNode();
    viewMergeTree.children.inorderTraversal((childKey, childTree)=>{
        if (serverNode.hasChild(childKey)) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, serverChild, childTree);
            curViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $e0be213f695400f3$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    viewMergeTree.children.inorderTraversal((childKey, childMergeTree)=>{
        const isUnknownDeepMerge = !viewCache.serverCache.isCompleteForChild(childKey) && childMergeTree.value === null;
        if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
            const serverChild = viewCache.serverCache.getNode().getImmediateChild(childKey);
            const newChild = $e0be213f695400f3$var$viewProcessorApplyMerge(viewProcessor, serverChild, childMergeTree);
            curViewCache = $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, curViewCache, new $e0be213f695400f3$var$Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
        }
    });
    return curViewCache;
}
function $e0be213f695400f3$var$viewProcessorAckUserWrite(viewProcessor, viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, ackPath) != null) return viewCache;
    // Only filter server node if it is currently filtered
    const filterServerNode = viewCache.serverCache.isFiltered();
    // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
    // now that it won't be shadowed.
    const serverCache = viewCache.serverCache;
    if (affectedTree.value != null) {
        // This is an overwrite.
        if ($e0be213f695400f3$var$pathIsEmpty(ackPath) && serverCache.isFullyInitialized() || serverCache.isCompleteForPath(ackPath)) return $e0be213f695400f3$var$viewProcessorApplyServerOverwrite(viewProcessor, viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
        else if ($e0be213f695400f3$var$pathIsEmpty(ackPath)) {
            // This is a goofy edge case where we are acking data at this location but don't have full data.  We
            // should just re-apply whatever we have in our cache as a merge.
            let changedChildren = new $e0be213f695400f3$var$ImmutableTree(null);
            serverCache.getNode().forEachChild($e0be213f695400f3$var$KEY_INDEX, (name, node)=>{
                changedChildren = changedChildren.set(new $e0be213f695400f3$var$Path(name), node);
            });
            return $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
        } else return viewCache;
    } else {
        // This is a merge.
        let changedChildren = new $e0be213f695400f3$var$ImmutableTree(null);
        affectedTree.foreach((mergePath, value)=>{
            const serverCachePath = $e0be213f695400f3$var$pathChild(ackPath, mergePath);
            if (serverCache.isCompleteForPath(serverCachePath)) changedChildren = changedChildren.set(mergePath, serverCache.getNode().getChild(serverCachePath));
        });
        return $e0be213f695400f3$var$viewProcessorApplyServerMerge(viewProcessor, viewCache, ackPath, changedChildren, writesCache, completeCache, filterServerNode, accumulator);
    }
}
function $e0be213f695400f3$var$viewProcessorListenComplete(viewProcessor, viewCache, path, writesCache, accumulator) {
    const oldServerNode = viewCache.serverCache;
    const newViewCache = $e0be213f695400f3$var$viewCacheUpdateServerSnap(viewCache, oldServerNode.getNode(), oldServerNode.isFullyInitialized() || $e0be213f695400f3$var$pathIsEmpty(path), oldServerNode.isFiltered());
    return $e0be213f695400f3$var$viewProcessorGenerateEventCacheAfterServerEvent(viewProcessor, newViewCache, path, writesCache, $e0be213f695400f3$var$NO_COMPLETE_CHILD_SOURCE, accumulator);
}
function $e0be213f695400f3$var$viewProcessorRevertUserWrite(viewProcessor, viewCache, path, writesCache, completeServerCache, accumulator) {
    let complete;
    if ($e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, path) != null) return viewCache;
    else {
        const source = new $e0be213f695400f3$var$WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
        const oldEventCache = viewCache.eventCache.getNode();
        let newEventCache;
        if ($e0be213f695400f3$var$pathIsEmpty(path) || $e0be213f695400f3$var$pathGetFront(path) === '.priority') {
            let newNode;
            if (viewCache.serverCache.isFullyInitialized()) newNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
            else {
                const serverChildren = viewCache.serverCache.getNode();
                (0, $474ae12482b554c6$export$a7a9523472993e97)(serverChildren instanceof $e0be213f695400f3$var$ChildrenNode, 'serverChildren would be complete if leaf node');
                newNode = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverChildren);
            }
            newNode;
            newEventCache = viewProcessor.filter.updateFullNode(oldEventCache, newNode, accumulator);
        } else {
            const childKey = $e0be213f695400f3$var$pathGetFront(path);
            let newChild = $e0be213f695400f3$var$writeTreeRefCalcCompleteChild(writesCache, childKey, viewCache.serverCache);
            if (newChild == null && viewCache.serverCache.isCompleteForChild(childKey)) newChild = oldEventCache.getImmediateChild(childKey);
            if (newChild != null) newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, newChild, $e0be213f695400f3$var$pathPopFront(path), source, accumulator);
            else if (viewCache.eventCache.getNode().hasChild(childKey)) // No complete child available, delete the existing one, if any
            newEventCache = viewProcessor.filter.updateChild(oldEventCache, childKey, $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, $e0be213f695400f3$var$pathPopFront(path), source, accumulator);
            else newEventCache = oldEventCache;
            if (newEventCache.isEmpty() && viewCache.serverCache.isFullyInitialized()) {
                // We might have reverted all child writes. Maybe the old event was a leaf node
                complete = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(viewCache));
                if (complete.isLeafNode()) newEventCache = viewProcessor.filter.updateFullNode(newEventCache, complete, accumulator);
            }
        }
        complete = viewCache.serverCache.isFullyInitialized() || $e0be213f695400f3$var$writeTreeRefShadowingWrite(writesCache, $e0be213f695400f3$var$newEmptyPath()) != null;
        return $e0be213f695400f3$var$viewCacheUpdateEventSnap(viewCache, newEventCache, complete, viewProcessor.filter.filtersNodes());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 */ class $e0be213f695400f3$var$View {
    constructor(query_, initialViewCache){
        this.query_ = query_;
        this.eventRegistrations_ = [];
        const params = this.query_._queryParams;
        const indexFilter = new $e0be213f695400f3$var$IndexedFilter(params.getIndex());
        const filter = $e0be213f695400f3$var$queryParamsGetNodeFilter(params);
        this.processor_ = $e0be213f695400f3$var$newViewProcessor(filter);
        const initialServerCache = initialViewCache.serverCache;
        const initialEventCache = initialViewCache.eventCache;
        // Don't filter server node with other filter than index, wait for tagged listen
        const serverSnap = indexFilter.updateFullNode($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        const eventSnap = filter.updateFullNode($e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        const newServerCache = new $e0be213f695400f3$var$CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        const newEventCache = new $e0be213f695400f3$var$CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        this.viewCache_ = $e0be213f695400f3$var$newViewCache(newEventCache, newServerCache);
        this.eventGenerator_ = new $e0be213f695400f3$var$EventGenerator(this.query_);
    }
    get query() {
        return this.query_;
    }
}
function $e0be213f695400f3$var$viewGetServerCache(view) {
    return view.viewCache_.serverCache.getNode();
}
function $e0be213f695400f3$var$viewGetCompleteNode(view) {
    return $e0be213f695400f3$var$viewCacheGetCompleteEventSnap(view.viewCache_);
}
function $e0be213f695400f3$var$viewGetCompleteServerCache(view, path) {
    const cache = $e0be213f695400f3$var$viewCacheGetCompleteServerSnap(view.viewCache_);
    if (cache) {
        // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
        // we need to see if it contains the child we're interested in.
        if (view.query._queryParams.loadsAllData() || !$e0be213f695400f3$var$pathIsEmpty(path) && !cache.getImmediateChild($e0be213f695400f3$var$pathGetFront(path)).isEmpty()) return cache.getChild(path);
    }
    return null;
}
function $e0be213f695400f3$var$viewIsEmpty(view) {
    return view.eventRegistrations_.length === 0;
}
function $e0be213f695400f3$var$viewAddEventRegistration(view, eventRegistration) {
    view.eventRegistrations_.push(eventRegistration);
}
/**
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns Cancel events, if cancelError was provided.
 */ function $e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError) {
    const cancelEvents = [];
    if (cancelError) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(eventRegistration == null, 'A cancel should cancel all event registrations.');
        const path = view.query._path;
        view.eventRegistrations_.forEach((registration)=>{
            const maybeEvent = registration.createCancelEvent(cancelError, path);
            if (maybeEvent) cancelEvents.push(maybeEvent);
        });
    }
    if (eventRegistration) {
        let remaining = [];
        for(let i = 0; i < view.eventRegistrations_.length; ++i){
            const existing = view.eventRegistrations_[i];
            if (!existing.matches(eventRegistration)) remaining.push(existing);
            else if (eventRegistration.hasAnyCallback()) {
                // We're removing just this one
                remaining = remaining.concat(view.eventRegistrations_.slice(i + 1));
                break;
            }
        }
        view.eventRegistrations_ = remaining;
    } else view.eventRegistrations_ = [];
    return cancelEvents;
}
/**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 */ function $e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, completeServerCache) {
    if (operation.type === $e0be213f695400f3$var$OperationType.MERGE && operation.source.queryId !== null) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$viewCacheGetCompleteServerSnap(view.viewCache_), 'We should always have a full cache before handling merges');
        (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$viewCacheGetCompleteEventSnap(view.viewCache_), 'Missing event cache, even though we have a server cache');
    }
    const oldViewCache = view.viewCache_;
    const result = $e0be213f695400f3$var$viewProcessorApplyOperation(view.processor_, oldViewCache, operation, writesCache, completeServerCache);
    $e0be213f695400f3$var$viewProcessorAssertIndexed(view.processor_, result.viewCache);
    (0, $474ae12482b554c6$export$a7a9523472993e97)(result.viewCache.serverCache.isFullyInitialized() || !oldViewCache.serverCache.isFullyInitialized(), 'Once a server snap is complete, it should never go back');
    view.viewCache_ = result.viewCache;
    return $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, result.changes, result.viewCache.eventCache.getNode(), null);
}
function $e0be213f695400f3$var$viewGetInitialEvents(view, registration) {
    const eventSnap = view.viewCache_.eventCache;
    const initialChanges = [];
    if (!eventSnap.getNode().isLeafNode()) {
        const eventNode = eventSnap.getNode();
        eventNode.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (key, childNode)=>{
            initialChanges.push($e0be213f695400f3$var$changeChildAdded(key, childNode));
        });
    }
    if (eventSnap.isFullyInitialized()) initialChanges.push($e0be213f695400f3$var$changeValue(eventSnap.getNode()));
    return $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, initialChanges, eventSnap.getNode(), registration);
}
function $e0be213f695400f3$var$viewGenerateEventsForChanges_(view, changes, eventCache, eventRegistration) {
    const registrations = eventRegistration ? [
        eventRegistration
    ] : view.eventRegistrations_;
    return $e0be213f695400f3$var$eventGeneratorGenerateEventsForChanges(view.eventGenerator_, changes, eventCache, registrations);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$referenceConstructor$1;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */ class $e0be213f695400f3$var$SyncPoint {
    constructor(){
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         */ this.views = new Map();
    }
}
function $e0be213f695400f3$var$syncPointSetReferenceConstructor(val) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$referenceConstructor$1, '__referenceConstructor has already been defined');
    $e0be213f695400f3$var$referenceConstructor$1 = val;
}
function $e0be213f695400f3$var$syncPointGetReferenceConstructor() {
    (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$referenceConstructor$1, 'Reference.ts has not been loaded');
    return $e0be213f695400f3$var$referenceConstructor$1;
}
function $e0be213f695400f3$var$syncPointIsEmpty(syncPoint) {
    return syncPoint.views.size === 0;
}
function $e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, optCompleteServerCache) {
    const queryId = operation.source.queryId;
    if (queryId !== null) {
        const view = syncPoint.views.get(queryId);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(view != null, 'SyncTree gave us an op for an invalid query.');
        return $e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache);
    } else {
        let events = [];
        for (const view of syncPoint.views.values())events = events.concat($e0be213f695400f3$var$viewApplyOperation(view, operation, writesCache, optCompleteServerCache));
        return events;
    }
}
/**
 * Get a view for the specified query.
 *
 * @param query - The query to return a view for
 * @param writesCache
 * @param serverCache
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete) {
    const queryId = query._queryIdentifier;
    const view = syncPoint.views.get(queryId);
    if (!view) {
        // TODO: make writesCache take flag for complete server node
        let eventCache = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventCache(writesCache, serverCacheComplete ? serverCache : null);
        let eventCacheComplete = false;
        if (eventCache) eventCacheComplete = true;
        else if (serverCache instanceof $e0be213f695400f3$var$ChildrenNode) {
            eventCache = $e0be213f695400f3$var$writeTreeRefCalcCompleteEventChildren(writesCache, serverCache);
            eventCacheComplete = false;
        } else {
            eventCache = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            eventCacheComplete = false;
        }
        const viewCache = $e0be213f695400f3$var$newViewCache(new $e0be213f695400f3$var$CacheNode(eventCache, eventCacheComplete, false), new $e0be213f695400f3$var$CacheNode(serverCache, serverCacheComplete, false));
        return new $e0be213f695400f3$var$View(query, viewCache);
    }
    return view;
}
/**
 * Add an event callback for the specified query.
 *
 * @param query
 * @param eventRegistration
 * @param writesCache
 * @param serverCache - Complete server cache, if we have it.
 * @param serverCacheComplete
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
    const view = $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCache, serverCacheComplete);
    if (!syncPoint.views.has(query._queryIdentifier)) syncPoint.views.set(query._queryIdentifier, view);
    // This is guaranteed to exist now, we just created anything that was missing
    $e0be213f695400f3$var$viewAddEventRegistration(view, eventRegistration);
    return $e0be213f695400f3$var$viewGetInitialEvents(view, eventRegistration);
}
/**
 * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
 *
 * If query is the default query, we'll check all views for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
 *
 * @param eventRegistration - If null, remove all callbacks.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @returns removed queries and any cancel events
 */ function $e0be213f695400f3$var$syncPointRemoveEventRegistration(syncPoint, query, eventRegistration, cancelError) {
    const queryId = query._queryIdentifier;
    const removed = [];
    let cancelEvents = [];
    const hadCompleteView = $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint);
    if (queryId === 'default') // When you do ref.off(...), we search all views for the registration to remove.
    for (const [viewQueryId, view] of syncPoint.views.entries()){
        cancelEvents = cancelEvents.concat($e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
        if ($e0be213f695400f3$var$viewIsEmpty(view)) {
            syncPoint.views.delete(viewQueryId);
            // We'll deal with complete views later.
            if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
        }
    }
    else {
        // remove the callback from the specific view.
        const view = syncPoint.views.get(queryId);
        if (view) {
            cancelEvents = cancelEvents.concat($e0be213f695400f3$var$viewRemoveEventRegistration(view, eventRegistration, cancelError));
            if ($e0be213f695400f3$var$viewIsEmpty(view)) {
                syncPoint.views.delete(queryId);
                // We'll deal with complete views later.
                if (!view.query._queryParams.loadsAllData()) removed.push(view.query);
            }
        }
    }
    if (hadCompleteView && !$e0be213f695400f3$var$syncPointHasCompleteView(syncPoint)) // We removed our last complete view.
    removed.push(new ($e0be213f695400f3$var$syncPointGetReferenceConstructor())(query._repo, query._path));
    return {
        removed: removed,
        events: cancelEvents
    };
}
function $e0be213f695400f3$var$syncPointGetQueryViews(syncPoint) {
    const result = [];
    for (const view of syncPoint.views.values())if (!view.query._queryParams.loadsAllData()) result.push(view);
    return result;
}
/**
 * @param path - The path to the desired complete snapshot
 * @returns A complete cache, if it exists
 */ function $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, path) {
    let serverCache = null;
    for (const view of syncPoint.views.values())serverCache = serverCache || $e0be213f695400f3$var$viewGetCompleteServerCache(view, path);
    return serverCache;
}
function $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query) {
    const params = query._queryParams;
    if (params.loadsAllData()) return $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint);
    else {
        const queryId = query._queryIdentifier;
        return syncPoint.views.get(queryId);
    }
}
function $e0be213f695400f3$var$syncPointViewExistsForQuery(syncPoint, query) {
    return $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query) != null;
}
function $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint) {
    return $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint) != null;
}
function $e0be213f695400f3$var$syncPointGetCompleteView(syncPoint) {
    for (const view of syncPoint.views.values()){
        if (view.query._queryParams.loadsAllData()) return view;
    }
    return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e0be213f695400f3$var$referenceConstructor;
function $e0be213f695400f3$var$syncTreeSetReferenceConstructor(val) {
    (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$referenceConstructor, '__referenceConstructor has already been defined');
    $e0be213f695400f3$var$referenceConstructor = val;
}
function $e0be213f695400f3$var$syncTreeGetReferenceConstructor() {
    (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$referenceConstructor, 'Reference.ts has not been loaded');
    return $e0be213f695400f3$var$referenceConstructor;
}
/**
 * Static tracker for next query tag.
 */ let $e0be213f695400f3$var$syncTreeNextQueryTag_ = 1;
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 */ class $e0be213f695400f3$var$SyncTree {
    /**
     * @param listenProvider_ - Used by SyncTree to start / stop listening
     *   to server data.
     */ constructor(listenProvider_){
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         */ this.syncPointTree_ = new $e0be213f695400f3$var$ImmutableTree(null);
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         */ this.pendingWriteTree_ = $e0be213f695400f3$var$newWriteTree();
        this.tagToQueryMap = new Map();
        this.queryToTagMap = new Map();
    }
}
/**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyUserOverwrite(syncTree, path, newData, writeId, visible) {
    // Record pending write.
    $e0be213f695400f3$var$writeTreeAddOverwrite(syncTree.pendingWriteTree_, path, newData, writeId, visible);
    if (!visible) return [];
    else return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceUser(), path, newData));
}
/**
 * Apply the data from a user-generated update() call
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyUserMerge(syncTree, path, changedChildren, writeId) {
    // Record pending merge.
    $e0be213f695400f3$var$writeTreeAddMerge(syncTree.pendingWriteTree_, path, changedChildren, writeId);
    const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceUser(), path, changeTree));
}
/**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param revert - True if the given write failed and needs to be reverted
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeAckUserWrite(syncTree, writeId, revert = false) {
    const write = $e0be213f695400f3$var$writeTreeGetWrite(syncTree.pendingWriteTree_, writeId);
    const needToReevaluate = $e0be213f695400f3$var$writeTreeRemoveWrite(syncTree.pendingWriteTree_, writeId);
    if (!needToReevaluate) return [];
    else {
        let affectedTree = new $e0be213f695400f3$var$ImmutableTree(null);
        if (write.snap != null) // overwrite
        affectedTree = affectedTree.set($e0be213f695400f3$var$newEmptyPath(), true);
        else $e0be213f695400f3$var$each(write.children, (pathString)=>{
            affectedTree = affectedTree.set(new $e0be213f695400f3$var$Path(pathString), true);
        });
        return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$AckUserWrite(write.path, affectedTree, revert));
    }
}
/**
 * Apply new server data for the specified path..
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyServerOverwrite(syncTree, path, newData) {
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceServer(), path, newData));
}
/**
 * Apply new server data to be merged in at the specified path.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyServerMerge(syncTree, path, changedChildren) {
    const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceServer(), path, changeTree));
}
/**
 * Apply a listen complete for a query
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyListenComplete(syncTree, path) {
    return $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, new $e0be213f695400f3$var$ListenComplete($e0be213f695400f3$var$newOperationSourceServer(), path));
}
/**
 * Apply a listen complete for a tagged query
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedListenComplete(syncTree, path, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const op = new $e0be213f695400f3$var$ListenComplete($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param eventRegistration - If null, all callbacks are removed.
 * @param cancelError - If a cancelError is provided, appropriate cancel events will be returned.
 * @param skipListenerDedup - When performing a `get()`, we don't add any new listeners, so no
 *  deduping needs to take place. This flag allows toggling of that behavior
 * @returns Cancel events, if cancelError was provided.
 */ function $e0be213f695400f3$var$syncTreeRemoveEventRegistration(syncTree, query, eventRegistration, cancelError, skipListenerDedup = false) {
    // Find the syncPoint first. Then deal with whether or not it has matching listeners
    const path = query._path;
    const maybeSyncPoint = syncTree.syncPointTree_.get(path);
    let cancelEvents = [];
    // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
    // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
    // not loadsAllData().
    if (maybeSyncPoint && (query._queryIdentifier === 'default' || $e0be213f695400f3$var$syncPointViewExistsForQuery(maybeSyncPoint, query))) {
        const removedAndEvents = $e0be213f695400f3$var$syncPointRemoveEventRegistration(maybeSyncPoint, query, eventRegistration, cancelError);
        if ($e0be213f695400f3$var$syncPointIsEmpty(maybeSyncPoint)) syncTree.syncPointTree_ = syncTree.syncPointTree_.remove(path);
        const removed = removedAndEvents.removed;
        cancelEvents = removedAndEvents.events;
        if (!skipListenerDedup) {
            /**
             * We may have just removed one of many listeners and can short-circuit this whole process
             * We may also not have removed a default listener, in which case all of the descendant listeners should already be
             * properly set up.
             */ // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            const removingDefault = -1 !== removed.findIndex((query)=>{
                return query._queryParams.loadsAllData();
            });
            const covered = syncTree.syncPointTree_.findOnPath(path, (relativePath, parentSyncPoint)=>$e0be213f695400f3$var$syncPointHasCompleteView(parentSyncPoint));
            if (removingDefault && !covered) {
                const subtree = syncTree.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    const newViews = $e0be213f695400f3$var$syncTreeCollectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for(let i = 0; i < newViews.length; ++i){
                        const view = newViews[i], newQuery = view.query;
                        const listener = $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view);
                        syncTree.listenProvider_.startListening($e0be213f695400f3$var$syncTreeQueryForListening_(newQuery), $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, newQuery), listener.hashFn, listener.onComplete);
                    }
                }
            // Otherwise there's nothing below us, so nothing we need to start listening on
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    const defaultTag = null;
                    syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(query), defaultTag);
                } else removed.forEach((queryToRemove)=>{
                    const tagToRemove = syncTree.queryToTagMap.get($e0be213f695400f3$var$syncTreeMakeQueryKey_(queryToRemove));
                    syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(queryToRemove), tagToRemove);
                });
            }
        }
        // Now, clear all of the tags we're tracking for the removed listens
        $e0be213f695400f3$var$syncTreeRemoveTags_(syncTree, removed);
    }
    return cancelEvents;
}
/**
 * Apply new server data for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(syncTree, path, snap, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey != null) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const op = new $e0be213f695400f3$var$Overwrite($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath, snap);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // Query must have been removed already
    return [];
}
/**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedQueryMerge(syncTree, path, changedChildren, tag) {
    const queryKey = $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag);
    if (queryKey) {
        const r = $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey);
        const queryPath = r.path, queryId = r.queryId;
        const relativePath = $e0be213f695400f3$var$newRelativePath(queryPath, path);
        const changeTree = $e0be213f695400f3$var$ImmutableTree.fromObject(changedChildren);
        const op = new $e0be213f695400f3$var$Merge($e0be213f695400f3$var$newOperationSourceServerTaggedQuery(queryId), relativePath, changeTree);
        return $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, op);
    } else // We've already removed the query. No big deal, ignore the update
    return [];
}
/**
 * Add an event callback for the specified query.
 *
 * @returns Events to raise.
 */ function $e0be213f695400f3$var$syncTreeAddEventRegistration(syncTree, query, eventRegistration, skipSetupListener = false) {
    const path = query._path;
    let serverCache = null;
    let foundAncestorDefaultView = false;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(sp, relativePath);
        foundAncestorDefaultView = foundAncestorDefaultView || $e0be213f695400f3$var$syncPointHasCompleteView(sp);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $e0be213f695400f3$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else {
        foundAncestorDefaultView = foundAncestorDefaultView || $e0be213f695400f3$var$syncPointHasCompleteView(syncPoint);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    }
    let serverCacheComplete;
    if (serverCache != null) serverCacheComplete = true;
    else {
        serverCacheComplete = false;
        serverCache = $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
        const subtree = syncTree.syncPointTree_.subtree(path);
        subtree.foreachChild((childName, childSyncPoint)=>{
            const completeCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(childSyncPoint, $e0be213f695400f3$var$newEmptyPath());
            if (completeCache) serverCache = serverCache.updateImmediateChild(childName, completeCache);
        });
    }
    const viewAlreadyExists = $e0be213f695400f3$var$syncPointViewExistsForQuery(syncPoint, query);
    if (!viewAlreadyExists && !query._queryParams.loadsAllData()) {
        // We need to track a tag for this query
        const queryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(query);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(!syncTree.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
        const tag = $e0be213f695400f3$var$syncTreeGetNextQueryTag_();
        syncTree.queryToTagMap.set(queryKey, tag);
        syncTree.tagToQueryMap.set(tag, queryKey);
    }
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, path);
    let events = $e0be213f695400f3$var$syncPointAddEventRegistration(syncPoint, query, eventRegistration, writesCache, serverCache, serverCacheComplete);
    if (!viewAlreadyExists && !foundAncestorDefaultView && !skipSetupListener) {
        const view = $e0be213f695400f3$var$syncPointViewForQuery(syncPoint, query);
        events = events.concat($e0be213f695400f3$var$syncTreeSetupListener_(syncTree, query, view));
    }
    return events;
}
/**
 * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
 * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
 * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
 *     <incremented total> as the write is applied locally and then acknowledged at the server.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 *
 * @param path - The path to the data we want
 * @param writeIdsToExclude - A specific set to be excluded
 */ function $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(syncTree, path, writeIdsToExclude) {
    const includeHiddenSets = true;
    const writeTree = syncTree.pendingWriteTree_;
    const serverCache = syncTree.syncPointTree_.findOnPath(path, (pathSoFar, syncPoint)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathSoFar, path);
        const serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, relativePath);
        if (serverCache) return serverCache;
    });
    return $e0be213f695400f3$var$writeTreeCalcCompleteEventCache(writeTree, path, serverCache, writeIdsToExclude, includeHiddenSets);
}
function $e0be213f695400f3$var$syncTreeGetServerValue(syncTree, query) {
    const path = query._path;
    let serverCache = null;
    // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
    // Consider optimizing this once there's a better understanding of what actual behavior will be.
    syncTree.syncPointTree_.foreachOnPath(path, (pathToSyncPoint, sp)=>{
        const relativePath = $e0be213f695400f3$var$newRelativePath(pathToSyncPoint, path);
        serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(sp, relativePath);
    });
    let syncPoint = syncTree.syncPointTree_.get(path);
    if (!syncPoint) {
        syncPoint = new $e0be213f695400f3$var$SyncPoint();
        syncTree.syncPointTree_ = syncTree.syncPointTree_.set(path, syncPoint);
    } else serverCache = serverCache || $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    const serverCacheComplete = serverCache != null;
    const serverCacheNode = serverCacheComplete ? new $e0be213f695400f3$var$CacheNode(serverCache, true, false) : null;
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, query._path);
    const view = $e0be213f695400f3$var$syncPointGetView(syncPoint, query, writesCache, serverCacheComplete ? serverCacheNode.getNode() : $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE, serverCacheComplete);
    return $e0be213f695400f3$var$viewGetCompleteNode(view);
}
/**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 *
 * - We call applyOperation() on each SyncPoint passing three things:
 *   1. A version of the Operation that has been made relative to the SyncPoint location.
 *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 *   3. A snapshot Node with cached server data, if we have it.
 *
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 */ function $e0be213f695400f3$var$syncTreeApplyOperationToSyncPoints_(syncTree, operation) {
    return $e0be213f695400f3$var$syncTreeApplyOperationHelper_(operation, syncTree.syncPointTree_, /*serverCache=*/ null, $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, $e0be213f695400f3$var$newEmptyPath()));
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $e0be213f695400f3$var$syncTreeApplyOperationHelper_(operation, syncPointTree, serverCache, writesCache) {
    if ($e0be213f695400f3$var$pathIsEmpty(operation.path)) return $e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
    else {
        const syncPoint = syncPointTree.get($e0be213f695400f3$var$newEmptyPath());
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
        let events = [];
        const childName = $e0be213f695400f3$var$pathGetFront(operation.path);
        const childOperation = operation.operationForChild(childName);
        const childTree = syncPointTree.children.get(childName);
        if (childTree && childOperation) {
            const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
            const childWritesCache = $e0be213f695400f3$var$writeTreeRefChild(writesCache, childName);
            events = events.concat($e0be213f695400f3$var$syncTreeApplyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
        }
        if (syncPoint) events = events.concat($e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
        return events;
    }
}
/**
 * Recursive helper for applyOperationToSyncPoints_
 */ function $e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache) {
    const syncPoint = syncPointTree.get($e0be213f695400f3$var$newEmptyPath());
    // If we don't have cached server data, see if we can get it from this SyncPoint.
    if (serverCache == null && syncPoint != null) serverCache = $e0be213f695400f3$var$syncPointGetCompleteServerCache(syncPoint, $e0be213f695400f3$var$newEmptyPath());
    let events = [];
    syncPointTree.children.inorderTraversal((childName, childTree)=>{
        const childServerCache = serverCache ? serverCache.getImmediateChild(childName) : null;
        const childWritesCache = $e0be213f695400f3$var$writeTreeRefChild(writesCache, childName);
        const childOperation = operation.operationForChild(childName);
        if (childOperation) events = events.concat($e0be213f695400f3$var$syncTreeApplyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
    });
    if (syncPoint) events = events.concat($e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, serverCache));
    return events;
}
function $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view) {
    const query = view.query;
    const tag = $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query);
    return {
        hashFn: ()=>{
            const cache = $e0be213f695400f3$var$viewGetServerCache(view) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            return cache.hash();
        },
        onComplete: (status)=>{
            if (status === 'ok') {
                if (tag) return $e0be213f695400f3$var$syncTreeApplyTaggedListenComplete(syncTree, query._path, tag);
                else return $e0be213f695400f3$var$syncTreeApplyListenComplete(syncTree, query._path);
            } else {
                // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                const error = $e0be213f695400f3$var$errorForServerCode(status, query);
                return $e0be213f695400f3$var$syncTreeRemoveEventRegistration(syncTree, query, /*eventRegistration*/ null, error);
            }
        }
    };
}
/**
 * Return the tag associated with the given query.
 */ function $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query) {
    const queryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(query);
    return syncTree.queryToTagMap.get(queryKey);
}
/**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 */ function $e0be213f695400f3$var$syncTreeMakeQueryKey_(query) {
    return query._path.toString() + '$' + query._queryIdentifier;
}
/**
 * Return the query associated with the given tag, if we have one
 */ function $e0be213f695400f3$var$syncTreeQueryKeyForTag_(syncTree, tag) {
    return syncTree.tagToQueryMap.get(tag);
}
/**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 */ function $e0be213f695400f3$var$syncTreeParseQueryKey_(queryKey) {
    const splitIndex = queryKey.indexOf('$');
    (0, $474ae12482b554c6$export$a7a9523472993e97)(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
    return {
        queryId: queryKey.substr(splitIndex + 1),
        path: new $e0be213f695400f3$var$Path(queryKey.substr(0, splitIndex))
    };
}
/**
 * A helper method to apply tagged operations
 */ function $e0be213f695400f3$var$syncTreeApplyTaggedOperation_(syncTree, queryPath, operation) {
    const syncPoint = syncTree.syncPointTree_.get(queryPath);
    (0, $474ae12482b554c6$export$a7a9523472993e97)(syncPoint, "Missing sync point for query tag that we're tracking");
    const writesCache = $e0be213f695400f3$var$writeTreeChildWrites(syncTree.pendingWriteTree_, queryPath);
    return $e0be213f695400f3$var$syncPointApplyOperation(syncPoint, operation, writesCache, null);
}
/**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 */ function $e0be213f695400f3$var$syncTreeCollectDistinctViewsForSubTree_(subtree) {
    return subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
        if (maybeChildSyncPoint && $e0be213f695400f3$var$syncPointHasCompleteView(maybeChildSyncPoint)) {
            const completeView = $e0be213f695400f3$var$syncPointGetCompleteView(maybeChildSyncPoint);
            return [
                completeView
            ];
        } else {
            // No complete view here, flatten any deeper listens into an array
            let views = [];
            if (maybeChildSyncPoint) views = $e0be213f695400f3$var$syncPointGetQueryViews(maybeChildSyncPoint);
            $e0be213f695400f3$var$each(childMap, (_key, childViews)=>{
                views = views.concat(childViews);
            });
            return views;
        }
    });
}
/**
 * Normalizes a query to a query we send the server for listening
 *
 * @returns The normalized query
 */ function $e0be213f695400f3$var$syncTreeQueryForListening_(query) {
    if (query._queryParams.loadsAllData() && !query._queryParams.isDefault()) // We treat queries that load all data as default queries
    // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
    // from Query
    return new ($e0be213f695400f3$var$syncTreeGetReferenceConstructor())(query._repo, query._path);
    else return query;
}
function $e0be213f695400f3$var$syncTreeRemoveTags_(syncTree, queries) {
    for(let j = 0; j < queries.length; ++j){
        const removedQuery = queries[j];
        if (!removedQuery._queryParams.loadsAllData()) {
            // We should have a tag for this
            const removedQueryKey = $e0be213f695400f3$var$syncTreeMakeQueryKey_(removedQuery);
            const removedQueryTag = syncTree.queryToTagMap.get(removedQueryKey);
            syncTree.queryToTagMap.delete(removedQueryKey);
            syncTree.tagToQueryMap.delete(removedQueryTag);
        }
    }
}
/**
 * Static accessor for query tags.
 */ function $e0be213f695400f3$var$syncTreeGetNextQueryTag_() {
    return $e0be213f695400f3$var$syncTreeNextQueryTag_++;
}
/**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @returns This method can return events to support synchronous data sources
 */ function $e0be213f695400f3$var$syncTreeSetupListener_(syncTree, query, view) {
    const path = query._path;
    const tag = $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, query);
    const listener = $e0be213f695400f3$var$syncTreeCreateListenerForView_(syncTree, view);
    const events = syncTree.listenProvider_.startListening($e0be213f695400f3$var$syncTreeQueryForListening_(query), tag, listener.hashFn, listener.onComplete);
    const subtree = syncTree.syncPointTree_.subtree(path);
    // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
    // may need to shadow other listens as well.
    if (tag) (0, $474ae12482b554c6$export$a7a9523472993e97)(!$e0be213f695400f3$var$syncPointHasCompleteView(subtree.value), "If we're adding a query, it shouldn't be shadowed");
    else {
        // Shadow everything at or below this location, this is a default listener.
        const queriesToStop = subtree.fold((relativePath, maybeChildSyncPoint, childMap)=>{
            if (!$e0be213f695400f3$var$pathIsEmpty(relativePath) && maybeChildSyncPoint && $e0be213f695400f3$var$syncPointHasCompleteView(maybeChildSyncPoint)) return [
                $e0be213f695400f3$var$syncPointGetCompleteView(maybeChildSyncPoint).query
            ];
            else {
                // No default listener here, flatten any deeper queries into an array
                let queries = [];
                if (maybeChildSyncPoint) queries = queries.concat($e0be213f695400f3$var$syncPointGetQueryViews(maybeChildSyncPoint).map((view)=>view.query));
                $e0be213f695400f3$var$each(childMap, (_key, childQueries)=>{
                    queries = queries.concat(childQueries);
                });
                return queries;
            }
        });
        for(let i = 0; i < queriesToStop.length; ++i){
            const queryToStop = queriesToStop[i];
            syncTree.listenProvider_.stopListening($e0be213f695400f3$var$syncTreeQueryForListening_(queryToStop), $e0be213f695400f3$var$syncTreeTagForQuery(syncTree, queryToStop));
        }
    }
    return events;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $e0be213f695400f3$var$ExistingValueProvider {
    constructor(node_){
        this.node_ = node_;
    }
    getImmediateChild(childName) {
        const child = this.node_.getImmediateChild(childName);
        return new $e0be213f695400f3$var$ExistingValueProvider(child);
    }
    node() {
        return this.node_;
    }
}
class $e0be213f695400f3$var$DeferredValueProvider {
    constructor(syncTree, path){
        this.syncTree_ = syncTree;
        this.path_ = path;
    }
    getImmediateChild(childName) {
        const childPath = $e0be213f695400f3$var$pathChild(this.path_, childName);
        return new $e0be213f695400f3$var$DeferredValueProvider(this.syncTree_, childPath);
    }
    node() {
        return $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(this.syncTree_, this.path_);
    }
}
/**
 * Generate placeholders for deferred values.
 */ const $e0be213f695400f3$var$generateWithValues = function(values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 */ const $e0be213f695400f3$var$resolveDeferredLeafValue = function(value, existingVal, serverValues) {
    if (!value || typeof value !== 'object') return value;
    (0, $474ae12482b554c6$export$a7a9523472993e97)('.sv' in value, 'Unexpected leaf node or priority contents');
    if (typeof value['.sv'] === 'string') return $e0be213f695400f3$var$resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
    else if (typeof value['.sv'] === 'object') return $e0be213f695400f3$var$resolveComplexDeferredValue(value['.sv'], existingVal);
    else (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
};
const $e0be213f695400f3$var$resolveScalarDeferredValue = function(op, existing, serverValues) {
    switch(op){
        case 'timestamp':
            return serverValues['timestamp'];
        default:
            (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + op);
    }
};
const $e0be213f695400f3$var$resolveComplexDeferredValue = function(op, existing, unused) {
    if (!op.hasOwnProperty('increment')) (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
    const delta = op['increment'];
    if (typeof delta !== 'number') (0, $474ae12482b554c6$export$a7a9523472993e97)(false, 'Unexpected increment value: ' + delta);
    const existingNode = existing.node();
    (0, $474ae12482b554c6$export$a7a9523472993e97)(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
    // Incrementing a non-number sets the value to the incremented amount
    if (!existingNode.isLeafNode()) return delta;
    const leaf = existingNode;
    const existingVal = leaf.getValue();
    if (typeof existingVal !== 'number') return delta;
    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
    return existingVal + delta;
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param path - path to which write is relative
 * @param node - new data written at path
 * @param syncTree - current data
 */ const $e0be213f695400f3$var$resolveDeferredValueTree = function(path, node, syncTree, serverValues) {
    return $e0be213f695400f3$var$resolveDeferredValue(node, new $e0be213f695400f3$var$DeferredValueProvider(syncTree, path), serverValues);
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 */ const $e0be213f695400f3$var$resolveDeferredValueSnapshot = function(node, existing, serverValues) {
    return $e0be213f695400f3$var$resolveDeferredValue(node, new $e0be213f695400f3$var$ExistingValueProvider(existing), serverValues);
};
function $e0be213f695400f3$var$resolveDeferredValue(node, existingVal, serverValues) {
    const rawPri = node.getPriority().val();
    const priority = $e0be213f695400f3$var$resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
    let newNode;
    if (node.isLeafNode()) {
        const leafNode = node;
        const value = $e0be213f695400f3$var$resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
        if (value !== leafNode.getValue() || priority !== leafNode.getPriority().val()) return new $e0be213f695400f3$var$LeafNode(value, $e0be213f695400f3$var$nodeFromJSON(priority));
        else return node;
    } else {
        const childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) newNode = newNode.updatePriority(new $e0be213f695400f3$var$LeafNode(priority));
        childrenNode.forEachChild($e0be213f695400f3$var$PRIORITY_INDEX, (childName, childNode)=>{
            const newChildNode = $e0be213f695400f3$var$resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
            if (newChildNode !== childNode) newNode = newNode.updateImmediateChild(childName, newChildNode);
        });
        return newNode;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */ class $e0be213f695400f3$var$Tree {
    /**
     * @param name - Optional name of the node.
     * @param parent - Optional parent node.
     * @param node - Optional node to wrap.
     */ constructor(name = '', parent = null, node = {
        children: {},
        childCount: 0
    }){
        this.name = name;
        this.parent = parent;
        this.node = node;
    }
}
/**
 * Returns a sub-Tree for the given path.
 *
 * @param pathObj - Path to look up.
 * @returns Tree for path.
 */ function $e0be213f695400f3$var$treeSubTree(tree, pathObj) {
    // TODO: Require pathObj to be Path?
    let path = pathObj instanceof $e0be213f695400f3$var$Path ? pathObj : new $e0be213f695400f3$var$Path(pathObj);
    let child = tree, next = $e0be213f695400f3$var$pathGetFront(path);
    while(next !== null){
        const childNode = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(child.node.children, next) || {
            children: {},
            childCount: 0
        };
        child = new $e0be213f695400f3$var$Tree(next, child, childNode);
        path = $e0be213f695400f3$var$pathPopFront(path);
        next = $e0be213f695400f3$var$pathGetFront(path);
    }
    return child;
}
/**
 * Returns the data associated with this tree node.
 *
 * @returns The data or null if no data exists.
 */ function $e0be213f695400f3$var$treeGetValue(tree) {
    return tree.node.value;
}
/**
 * Sets data to this tree node.
 *
 * @param value - Value to set.
 */ function $e0be213f695400f3$var$treeSetValue(tree, value) {
    tree.node.value = value;
    $e0be213f695400f3$var$treeUpdateParents(tree);
}
/**
 * @returns Whether the tree has any children.
 */ function $e0be213f695400f3$var$treeHasChildren(tree) {
    return tree.node.childCount > 0;
}
/**
 * @returns Whether the tree is empty (no value or children).
 */ function $e0be213f695400f3$var$treeIsEmpty(tree) {
    return $e0be213f695400f3$var$treeGetValue(tree) === undefined && !$e0be213f695400f3$var$treeHasChildren(tree);
}
/**
 * Calls action for each child of this tree node.
 *
 * @param action - Action to be called for each child.
 */ function $e0be213f695400f3$var$treeForEachChild(tree, action) {
    $e0be213f695400f3$var$each(tree.node.children, (child, childTree)=>{
        action(new $e0be213f695400f3$var$Tree(child, tree, childTree));
    });
}
/**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param action - Action to be called for each child.
 * @param includeSelf - Whether to call action on this node as well. Defaults to
 *   false.
 * @param childrenFirst - Whether to call action on children before calling it on
 *   parent.
 */ function $e0be213f695400f3$var$treeForEachDescendant(tree, action, includeSelf, childrenFirst) {
    if (includeSelf && !childrenFirst) action(tree);
    $e0be213f695400f3$var$treeForEachChild(tree, (child)=>{
        $e0be213f695400f3$var$treeForEachDescendant(child, action, true, childrenFirst);
    });
    if (includeSelf && childrenFirst) action(tree);
}
/**
 * Calls action on each ancestor node.
 *
 * @param action - Action to be called on each parent; return
 *   true to abort.
 * @param includeSelf - Whether to call action on this node as well.
 * @returns true if the action callback returned true.
 */ function $e0be213f695400f3$var$treeForEachAncestor(tree, action, includeSelf) {
    let node = includeSelf ? tree : tree.parent;
    while(node !== null){
        if (action(node)) return true;
        node = node.parent;
    }
    return false;
}
/**
 * @returns The path of this tree node, as a Path.
 */ function $e0be213f695400f3$var$treeGetPath(tree) {
    return new $e0be213f695400f3$var$Path(tree.parent === null ? tree.name : $e0be213f695400f3$var$treeGetPath(tree.parent) + '/' + tree.name);
}
/**
 * Adds or removes this child from its parent based on whether it's empty or not.
 */ function $e0be213f695400f3$var$treeUpdateParents(tree) {
    if (tree.parent !== null) $e0be213f695400f3$var$treeUpdateChild(tree.parent, tree.name, tree);
}
/**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param childName - The name of the child to update.
 * @param child - The child to update.
 */ function $e0be213f695400f3$var$treeUpdateChild(tree, childName, child) {
    const childEmpty = $e0be213f695400f3$var$treeIsEmpty(child);
    const childExists = (0, $474ae12482b554c6$export$2344b14b097df817)(tree.node.children, childName);
    if (childEmpty && childExists) {
        delete tree.node.children[childName];
        tree.node.childCount--;
        $e0be213f695400f3$var$treeUpdateParents(tree);
    } else if (!childEmpty && !childExists) {
        tree.node.children[childName] = child.node;
        tree.node.childCount++;
        $e0be213f695400f3$var$treeUpdateParents(tree);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * True for invalid Firebase keys
 */ const $e0be213f695400f3$var$INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 */ const $e0be213f695400f3$var$INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 */ const $e0be213f695400f3$var$MAX_LEAF_SIZE_ = 10485760;
const $e0be213f695400f3$var$isValidKey = function(key) {
    return typeof key === 'string' && key.length !== 0 && !$e0be213f695400f3$var$INVALID_KEY_REGEX_.test(key);
};
const $e0be213f695400f3$var$isValidPathString = function(pathString) {
    return typeof pathString === 'string' && pathString.length !== 0 && !$e0be213f695400f3$var$INVALID_PATH_REGEX_.test(pathString);
};
const $e0be213f695400f3$var$isValidRootPathString = function(pathString) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    return $e0be213f695400f3$var$isValidPathString(pathString);
};
const $e0be213f695400f3$var$isValidPriority = function(priority) {
    return priority === null || typeof priority === 'string' || typeof priority === 'number' && !$e0be213f695400f3$var$isInvalidJSONNumber(priority) || priority && typeof priority === 'object' && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0, $474ae12482b554c6$export$2344b14b097df817)(priority, '.sv');
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 */ const $e0be213f695400f3$var$validateFirebaseDataArg = function(fnName, value, path, optional) {
    if (optional && value === undefined) return;
    $e0be213f695400f3$var$validateFirebaseData((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'value'), value, path);
};
/**
 * Validate a data object client-side before sending to server.
 */ const $e0be213f695400f3$var$validateFirebaseData = function(errorPrefix, data, path_) {
    const path = path_ instanceof $e0be213f695400f3$var$Path ? new $e0be213f695400f3$var$ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) throw new Error(errorPrefix + 'contains undefined ' + $e0be213f695400f3$var$validationPathToErrorString(path));
    if (typeof data === 'function') throw new Error(errorPrefix + 'contains a function ' + $e0be213f695400f3$var$validationPathToErrorString(path) + ' with contents = ' + data.toString());
    if ($e0be213f695400f3$var$isInvalidJSONNumber(data)) throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + $e0be213f695400f3$var$validationPathToErrorString(path));
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' && data.length > $e0be213f695400f3$var$MAX_LEAF_SIZE_ / 3 && (0, $474ae12482b554c6$export$9536dc0a75b20bf9)(data) > $e0be213f695400f3$var$MAX_LEAF_SIZE_) throw new Error(errorPrefix + 'contains a string greater than ' + $e0be213f695400f3$var$MAX_LEAF_SIZE_ + ' utf8 bytes ' + $e0be213f695400f3$var$validationPathToErrorString(path) + " ('" + data.substring(0, 50) + "...')");
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        let hasDotValue = false;
        let hasActualChild = false;
        $e0be213f695400f3$var$each(data, (key, value)=>{
            if (key === '.value') hasDotValue = true;
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild = true;
                if (!$e0be213f695400f3$var$isValidKey(key)) throw new Error(errorPrefix + ' contains an invalid key (' + key + ') ' + $e0be213f695400f3$var$validationPathToErrorString(path) + '.  Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
            $e0be213f695400f3$var$validationPathPush(path, key);
            $e0be213f695400f3$var$validateFirebaseData(errorPrefix, value, path);
            $e0be213f695400f3$var$validationPathPop(path);
        });
        if (hasDotValue && hasActualChild) throw new Error(errorPrefix + ' contains ".value" child ' + $e0be213f695400f3$var$validationPathToErrorString(path) + ' in addition to actual children.');
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 */ const $e0be213f695400f3$var$validateFirebaseMergePaths = function(errorPrefix, mergePaths) {
    let i, curPath;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        const keys = $e0be213f695400f3$var$pathSlice(curPath);
        for(let j = 0; j < keys.length; j++){
            if (keys[j] === '.priority' && j === keys.length - 1) ;
            else if (!$e0be213f695400f3$var$isValidKey(keys[j])) throw new Error(errorPrefix + 'contains an invalid key (' + keys[j] + ') in path ' + curPath.toString() + '. Keys must be non-empty strings ' + 'and can\'t contain ".", "#", "$", "/", "[", or "]"');
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort($e0be213f695400f3$var$pathCompare);
    let prevPath = null;
    for(i = 0; i < mergePaths.length; i++){
        curPath = mergePaths[i];
        if (prevPath !== null && $e0be213f695400f3$var$pathContains(prevPath, curPath)) throw new Error(errorPrefix + 'contains a path ' + prevPath.toString() + ' that is ancestor of another path ' + curPath.toString());
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 */ const $e0be213f695400f3$var$validateFirebaseMergeDataArg = function(fnName, data, path, optional) {
    if (optional && data === undefined) return;
    const errorPrefix$1 = (0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'values');
    if (!(data && typeof data === 'object') || Array.isArray(data)) throw new Error(errorPrefix$1 + ' must be an object containing the children to replace.');
    const mergePaths = [];
    $e0be213f695400f3$var$each(data, (key, value)=>{
        const curPath = new $e0be213f695400f3$var$Path(key);
        $e0be213f695400f3$var$validateFirebaseData(errorPrefix$1, value, $e0be213f695400f3$var$pathChild(path, curPath));
        if ($e0be213f695400f3$var$pathGetBack(curPath) === '.priority') {
            if (!$e0be213f695400f3$var$isValidPriority(value)) throw new Error(errorPrefix$1 + "contains an invalid value for '" + curPath.toString() + "', which must be a valid " + 'Firebase priority (a string, finite number, server value, or null).');
        }
        mergePaths.push(curPath);
    });
    $e0be213f695400f3$var$validateFirebaseMergePaths(errorPrefix$1, mergePaths);
};
const $e0be213f695400f3$var$validatePriority = function(fnName, priority, optional) {
    if (optional && priority === undefined) return;
    if ($e0be213f695400f3$var$isInvalidJSONNumber(priority)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'priority') + 'is ' + priority.toString() + ', but must be a valid Firebase priority (a string, finite number, ' + 'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!$e0be213f695400f3$var$isValidPriority(priority)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'priority') + 'must be a valid Firebase priority ' + '(a string, finite number, server value, or null).');
};
const $e0be213f695400f3$var$validateKey = function(fnName, argumentName, key, optional) {
    if (optional && key === undefined) return;
    if (!$e0be213f695400f3$var$isValidKey(key)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid key = "' + key + '".  Firebase keys must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
/**
 * @internal
 */ const $e0be213f695400f3$export$8637b026ace8abb1 = function(fnName, argumentName, pathString, optional) {
    if (optional && pathString === undefined) return;
    if (!$e0be213f695400f3$var$isValidPathString(pathString)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, argumentName) + 'was an invalid path = "' + pathString + '". Paths must be non-empty strings and ' + 'can\'t contain ".", "#", "$", "[", or "]"');
};
const $e0be213f695400f3$var$validateRootPathString = function(fnName, argumentName, pathString, optional) {
    if (pathString) // Allow '/.info/' at the beginning.
    pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    $e0be213f695400f3$export$8637b026ace8abb1(fnName, argumentName, pathString, optional);
};
/**
 * @internal
 */ const $e0be213f695400f3$export$8d83036122ae444e = function(fnName, path) {
    if ($e0be213f695400f3$var$pathGetFront(path) === '.info') throw new Error(fnName + " failed = Can't modify data under /.info/");
};
const $e0be213f695400f3$var$validateUrl = function(fnName, parsedUrl) {
    // TODO = Validate server better.
    const pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') || parsedUrl.repoInfo.host.length === 0 || !$e0be213f695400f3$var$isValidKey(parsedUrl.repoInfo.namespace) && parsedUrl.repoInfo.host.split(':')[0] !== 'localhost' || pathString.length !== 0 && !$e0be213f695400f3$var$isValidRootPathString(pathString)) throw new Error((0, $474ae12482b554c6$export$adea4917e02d93dc)(fnName, 'url') + 'must be a valid firebase URL and ' + 'the path can\'t contain ".", "#", "$", "[", or "]".');
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 */ class $e0be213f695400f3$var$EventQueue {
    constructor(){
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         */ this.recursionDepth_ = 0;
    }
}
/**
 * @param eventDataList - The new events to queue.
 */ function $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList) {
    // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
    let currList = null;
    for(let i = 0; i < eventDataList.length; i++){
        const data = eventDataList[i];
        const path = data.getPath();
        if (currList !== null && !$e0be213f695400f3$var$pathEquals(path, currList.path)) {
            eventQueue.eventLists_.push(currList);
            currList = null;
        }
        if (currList === null) currList = {
            events: [],
            path: path
        };
        currList.events.push(data);
    }
    if (currList) eventQueue.eventLists_.push(currList);
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param path - The path to raise events for.
 * @param eventDataList - The new events to raise.
 */ function $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(eventQueue, path, eventDataList) {
    $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$e0be213f695400f3$var$pathEquals(eventPath, path));
}
/**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param changedPath - The path to raise events for.
 * @param eventDataList - The events to raise
 */ function $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(eventQueue, changedPath, eventDataList) {
    $e0be213f695400f3$var$eventQueueQueueEvents(eventQueue, eventDataList);
    $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, (eventPath)=>$e0be213f695400f3$var$pathContains(eventPath, changedPath) || $e0be213f695400f3$var$pathContains(changedPath, eventPath));
}
function $e0be213f695400f3$var$eventQueueRaiseQueuedEventsMatchingPredicate(eventQueue, predicate) {
    eventQueue.recursionDepth_++;
    let sentAll = true;
    for(let i = 0; i < eventQueue.eventLists_.length; i++){
        const eventList = eventQueue.eventLists_[i];
        if (eventList) {
            const eventPath = eventList.path;
            if (predicate(eventPath)) {
                $e0be213f695400f3$var$eventListRaise(eventQueue.eventLists_[i]);
                eventQueue.eventLists_[i] = null;
            } else sentAll = false;
        }
    }
    if (sentAll) eventQueue.eventLists_ = [];
    eventQueue.recursionDepth_--;
}
/**
 * Iterates through the list and raises each event
 */ function $e0be213f695400f3$var$eventListRaise(eventList) {
    for(let i = 0; i < eventList.events.length; i++){
        const eventData = eventList.events[i];
        if (eventData !== null) {
            eventList.events[i] = null;
            const eventFn = eventData.getEventRunner();
            if ($e0be213f695400f3$var$logger) $e0be213f695400f3$var$log('event: ' + eventData.toString());
            $e0be213f695400f3$var$exceptionGuard(eventFn);
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$INTERRUPT_REASON = 'repo_interrupt';
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other
 * things this ensure that if there's ever a bug causing a mismatch between
 * client / server hashes for some data, we won't retry indefinitely.
 */ const $e0be213f695400f3$var$MAX_TRANSACTION_RETRIES = 25;
/**
 * A connection to a single data repository.
 */ class $e0be213f695400f3$var$Repo {
    constructor(repoInfo_, forceRestClient_, authTokenProvider_, appCheckProvider_){
        this.repoInfo_ = repoInfo_;
        this.forceRestClient_ = forceRestClient_;
        this.authTokenProvider_ = authTokenProvider_;
        this.appCheckProvider_ = appCheckProvider_;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new $e0be213f695400f3$var$EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        /** A list of data pieces and paths to be set when this client disconnects. */ this.onDisconnect_ = $e0be213f695400f3$var$newSparseSnapshotTree();
        /** Stores queues of outstanding transactions for Firebase locations. */ this.transactionQueueTree_ = new $e0be213f695400f3$var$Tree();
        // TODO: This should be @private but it's used by test_access.js and internal.js
        this.persistentConnection_ = null;
        // This key is intentionally not updated if RepoInfo is later changed or replaced
        this.key = this.repoInfo_.toURLString();
    }
    /**
     * @returns The URL corresponding to the root of this Firebase.
     */ toString() {
        return (this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host;
    }
}
function $e0be213f695400f3$var$repoStart(repo, appId, authOverride) {
    repo.stats_ = $e0be213f695400f3$var$statsManagerGetCollection(repo.repoInfo_);
    if (repo.forceRestClient_ || $e0be213f695400f3$var$beingCrawled()) {
        repo.server_ = new $e0be213f695400f3$var$ReadonlyRestClient(repo.repoInfo_, (pathString, data, isMerge, tag)=>{
            $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, repo.authTokenProvider_, repo.appCheckProvider_);
        // Minor hack: Fire onConnect immediately, since there's no actual connection.
        setTimeout(()=>$e0be213f695400f3$var$repoOnConnectStatus(repo, /* connectStatus= */ true), 0);
    } else {
        // Validate authOverride
        if (typeof authOverride !== 'undefined' && authOverride !== null) {
            if (typeof authOverride !== 'object') throw new Error('Only objects are supported for option databaseAuthVariableOverride');
            try {
                (0, $474ae12482b554c6$export$fac44ee5b035f737)(authOverride);
            } catch (e) {
                throw new Error('Invalid authOverride provided: ' + e);
            }
        }
        repo.persistentConnection_ = new $e0be213f695400f3$var$PersistentConnection(repo.repoInfo_, appId, (pathString, data, isMerge, tag)=>{
            $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag);
        }, (connectStatus)=>{
            $e0be213f695400f3$var$repoOnConnectStatus(repo, connectStatus);
        }, (updates)=>{
            $e0be213f695400f3$var$repoOnServerInfoUpdate(repo, updates);
        }, repo.authTokenProvider_, repo.appCheckProvider_, authOverride);
        repo.server_ = repo.persistentConnection_;
    }
    repo.authTokenProvider_.addTokenChangeListener((token)=>{
        repo.server_.refreshAuthToken(token);
    });
    repo.appCheckProvider_.addTokenChangeListener((result)=>{
        repo.server_.refreshAppCheckToken(result.token);
    });
    // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
    // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
    repo.statsReporter_ = $e0be213f695400f3$var$statsManagerGetOrCreateReporter(repo.repoInfo_, ()=>new $e0be213f695400f3$var$StatsReporter(repo.stats_, repo.server_));
    // Used for .info.
    repo.infoData_ = new $e0be213f695400f3$var$SnapshotHolder();
    repo.infoSyncTree_ = new $e0be213f695400f3$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            let infoEvents = [];
            const node = repo.infoData_.getNode(query._path);
            // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
            // on initial data...
            if (!node.isEmpty()) {
                infoEvents = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, query._path, node);
                setTimeout(()=>{
                    onComplete('ok');
                }, 0);
            }
            return infoEvents;
        },
        stopListening: ()=>{}
    });
    $e0be213f695400f3$var$repoUpdateInfo(repo, 'connected', false);
    repo.serverSyncTree_ = new $e0be213f695400f3$var$SyncTree({
        startListening: (query, tag, currentHashFn, onComplete)=>{
            repo.server_.listen(query, currentHashFn, tag, (status, data)=>{
                const events = onComplete(status, data);
                $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
            });
            // No synchronous events for network-backed sync trees
            return [];
        },
        stopListening: (query, tag)=>{
            repo.server_.unlisten(query, tag);
        }
    });
}
/**
 * @returns The time in milliseconds, taking the server offset into account if we have one.
 */ function $e0be213f695400f3$var$repoServerTime(repo) {
    const offsetNode = repo.infoData_.getNode(new $e0be213f695400f3$var$Path('.info/serverTimeOffset'));
    const offset = offsetNode.val() || 0;
    return new Date().getTime() + offset;
}
/**
 * Generate ServerValues using some variables from the repo object.
 */ function $e0be213f695400f3$var$repoGenerateServerValues(repo) {
    return $e0be213f695400f3$var$generateWithValues({
        timestamp: $e0be213f695400f3$var$repoServerTime(repo)
    });
}
/**
 * Called by realtime when we get new messages from the server.
 */ function $e0be213f695400f3$var$repoOnDataUpdate(repo, pathString, data, isMerge, tag) {
    // For testing.
    repo.dataUpdateCount++;
    const path = new $e0be213f695400f3$var$Path(pathString);
    data = repo.interceptServerDataCallback_ ? repo.interceptServerDataCallback_(pathString, data) : data;
    let events = [];
    if (tag) {
        if (isMerge) {
            const taggedChildren = (0, $474ae12482b554c6$export$871de8747c9eaa88)(data, (raw)=>$e0be213f695400f3$var$nodeFromJSON(raw));
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryMerge(repo.serverSyncTree_, path, taggedChildren, tag);
        } else {
            const taggedSnap = $e0be213f695400f3$var$nodeFromJSON(data);
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, path, taggedSnap, tag);
        }
    } else if (isMerge) {
        const changedChildren = (0, $474ae12482b554c6$export$871de8747c9eaa88)(data, (raw)=>$e0be213f695400f3$var$nodeFromJSON(raw));
        events = $e0be213f695400f3$var$syncTreeApplyServerMerge(repo.serverSyncTree_, path, changedChildren);
    } else {
        const snap = $e0be213f695400f3$var$nodeFromJSON(data);
        events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap);
    }
    let affectedPath = path;
    if (events.length > 0) // Since we have a listener outstanding for each transaction, receiving any events
    // is a proxy for some change having occurred.
    affectedPath = $e0be213f695400f3$var$repoRerunTransactions(repo, path);
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, events);
}
function $e0be213f695400f3$var$repoOnConnectStatus(repo, connectStatus) {
    $e0be213f695400f3$var$repoUpdateInfo(repo, 'connected', connectStatus);
    if (connectStatus === false) $e0be213f695400f3$var$repoRunOnDisconnectEvents(repo);
}
function $e0be213f695400f3$var$repoOnServerInfoUpdate(repo, updates) {
    $e0be213f695400f3$var$each(updates, (key, value)=>{
        $e0be213f695400f3$var$repoUpdateInfo(repo, key, value);
    });
}
function $e0be213f695400f3$var$repoUpdateInfo(repo, pathString, value) {
    const path = new $e0be213f695400f3$var$Path('/.info/' + pathString);
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value);
    repo.infoData_.updateSnapshot(path, newNode);
    const events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.infoSyncTree_, path, newNode);
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
}
function $e0be213f695400f3$var$repoGetNextWriteId(repo) {
    return repo.nextWriteId_++;
}
/**
 * The purpose of `getValue` is to return the latest known value
 * satisfying `query`.
 *
 * This method will first check for in-memory cached values
 * belonging to active listeners. If they are found, such values
 * are considered to be the most up-to-date.
 *
 * If the client is not connected, this method will wait until the
 *  repo has established a connection and then request the value for `query`.
 * If the client is not able to retrieve the query result for another reason,
 * it reports an error.
 *
 * @param query - The query to surface a value for.
 */ function $e0be213f695400f3$var$repoGetValue(repo, query, eventRegistration) {
    // Only active queries are cached. There is no persisted cache.
    const cached = $e0be213f695400f3$var$syncTreeGetServerValue(repo.serverSyncTree_, query);
    if (cached != null) return Promise.resolve(cached);
    return repo.server_.get(query).then((payload)=>{
        const node = $e0be213f695400f3$var$nodeFromJSON(payload).withIndex(query._queryParams.getIndex());
        /**
         * Below we simulate the actions of an `onlyOnce` `onValue()` event where:
         * Add an event registration,
         * Update data at the path,
         * Raise any events,
         * Cleanup the SyncTree
         */ $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration, true);
        let events;
        if (query._queryParams.loadsAllData()) events = $e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, query._path, node);
        else {
            const tag = $e0be213f695400f3$var$syncTreeTagForQuery(repo.serverSyncTree_, query);
            events = $e0be213f695400f3$var$syncTreeApplyTaggedQueryOverwrite(repo.serverSyncTree_, query._path, node, tag);
        }
        /*
         * We need to raise events in the scenario where `get()` is called at a parent path, and
         * while the `get()` is pending, `onValue` is called at a child location. While get() is waiting
         * for the data, `onValue` will register a new event. Then, get() will come back, and update the syncTree
         * and its corresponding serverCache, including the child location where `onValue` is called. Then,
         * `onValue` will receive the event from the server, but look at the syncTree and see that the data received
         * from the server is already at the SyncPoint, and so the `onValue` callback will never get fired.
         * Calling `eventQueueRaiseEventsForChangedPath()` is the correct way to propagate the events and
         * ensure the corresponding child events will get fired.
         */ $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, query._path, events);
        $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration, null, true);
        return node;
    }, (err)=>{
        $e0be213f695400f3$var$repoLog(repo, 'get for query ' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(query) + ' failed: ' + err);
        return Promise.reject(new Error(err));
    });
}
function $e0be213f695400f3$var$repoSetWithPriority(repo, path, newVal, newPriority, onComplete) {
    $e0be213f695400f3$var$repoLog(repo, 'set', {
        path: path.toString(),
        value: newVal,
        priority: newPriority
    });
    // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
    // (b) store unresolved paths on JSON parse
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const newNodeUnresolved = $e0be213f695400f3$var$nodeFromJSON(newVal, newPriority);
    const existing = $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path);
    const newNode = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
    const writeId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
    const events = $e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, writeId, true);
    $e0be213f695400f3$var$eventQueueQueueEvents(repo.eventQueue_, events);
    repo.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), (status, errorReason)=>{
        const success = status === 'ok';
        if (!success) $e0be213f695400f3$var$warn('set at ' + path + ' failed: ' + status);
        const clearEvents = $e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, clearEvents);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
    const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, path);
    $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
    // We queued the events above, so just flush the queue here
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, []);
}
function $e0be213f695400f3$var$repoUpdate(repo, path, childrenToMerge, onComplete) {
    $e0be213f695400f3$var$repoLog(repo, 'update', {
        path: path.toString(),
        value: childrenToMerge
    });
    // Start with our existing data and merge each child into it.
    let empty = true;
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const changedChildren = {};
    $e0be213f695400f3$var$each(childrenToMerge, (changedKey, changedValue)=>{
        empty = false;
        changedChildren[changedKey] = $e0be213f695400f3$var$resolveDeferredValueTree($e0be213f695400f3$var$pathChild(path, changedKey), $e0be213f695400f3$var$nodeFromJSON(changedValue), repo.serverSyncTree_, serverValues);
    });
    if (!empty) {
        const writeId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
        const events = $e0be213f695400f3$var$syncTreeApplyUserMerge(repo.serverSyncTree_, path, changedChildren, writeId);
        $e0be213f695400f3$var$eventQueueQueueEvents(repo.eventQueue_, events);
        repo.server_.merge(path.toString(), childrenToMerge, (status, errorReason)=>{
            const success = status === 'ok';
            if (!success) $e0be213f695400f3$var$warn('update at ' + path + ' failed: ' + status);
            const clearEvents = $e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, writeId, !success);
            const affectedPath = clearEvents.length > 0 ? $e0be213f695400f3$var$repoRerunTransactions(repo, path) : path;
            $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, affectedPath, clearEvents);
            $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
        });
        $e0be213f695400f3$var$each(childrenToMerge, (changedPath)=>{
            const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, $e0be213f695400f3$var$pathChild(path, changedPath));
            $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
        });
        // We queued the events above, so just flush the queue here
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, []);
    } else {
        $e0be213f695400f3$var$log("update() called with empty data.  Don't do anything.");
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
    }
}
/**
 * Applies all of the changes stored up in the onDisconnect_ tree.
 */ function $e0be213f695400f3$var$repoRunOnDisconnectEvents(repo) {
    $e0be213f695400f3$var$repoLog(repo, 'onDisconnectEvents');
    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
    const resolvedOnDisconnectTree = $e0be213f695400f3$var$newSparseSnapshotTree();
    $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(repo.onDisconnect_, $e0be213f695400f3$var$newEmptyPath(), (path, node)=>{
        const resolved = $e0be213f695400f3$var$resolveDeferredValueTree(path, node, repo.serverSyncTree_, serverValues);
        $e0be213f695400f3$var$sparseSnapshotTreeRemember(resolvedOnDisconnectTree, path, resolved);
    });
    let events = [];
    $e0be213f695400f3$var$sparseSnapshotTreeForEachTree(resolvedOnDisconnectTree, $e0be213f695400f3$var$newEmptyPath(), (path, snap)=>{
        events = events.concat($e0be213f695400f3$var$syncTreeApplyServerOverwrite(repo.serverSyncTree_, path, snap));
        const affectedPath = $e0be213f695400f3$var$repoAbortTransactions(repo, path);
        $e0be213f695400f3$var$repoRerunTransactions(repo, affectedPath);
    });
    repo.onDisconnect_ = $e0be213f695400f3$var$newSparseSnapshotTree();
    $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $e0be213f695400f3$var$newEmptyPath(), events);
}
function $e0be213f695400f3$var$repoOnDisconnectCancel(repo, path, onComplete) {
    repo.server_.onDisconnectCancel(path.toString(), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeForget(repo.onDisconnect_, path);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectSet(repo, path, value, onComplete) {
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectSetWithPriority(repo, path, value, priority, onComplete) {
    const newNode = $e0be213f695400f3$var$nodeFromJSON(value, priority);
    repo.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, path, newNode);
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoOnDisconnectUpdate(repo, path, childrenToMerge, onComplete) {
    if ((0, $474ae12482b554c6$export$dd1bc94b04021eeb)(childrenToMerge)) {
        $e0be213f695400f3$var$log("onDisconnect().update() called with empty data.  Don't do anything.");
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, 'ok', undefined);
        return;
    }
    repo.server_.onDisconnectMerge(path.toString(), childrenToMerge, (status, errorReason)=>{
        if (status === 'ok') $e0be213f695400f3$var$each(childrenToMerge, (childName, childNode)=>{
            const newChildNode = $e0be213f695400f3$var$nodeFromJSON(childNode);
            $e0be213f695400f3$var$sparseSnapshotTreeRemember(repo.onDisconnect_, $e0be213f695400f3$var$pathChild(path, childName), newChildNode);
        });
        $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, onComplete, status, errorReason);
    });
}
function $e0be213f695400f3$var$repoAddEventCallbackForQuery(repo, query, eventRegistration) {
    let events;
    if ($e0be213f695400f3$var$pathGetFront(query._path) === '.info') events = $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $e0be213f695400f3$var$syncTreeAddEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(repo, query, eventRegistration) {
    // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
    // a little bit by handling the return values anyways.
    let events;
    if ($e0be213f695400f3$var$pathGetFront(query._path) === '.info') events = $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.infoSyncTree_, query, eventRegistration);
    else events = $e0be213f695400f3$var$syncTreeRemoveEventRegistration(repo.serverSyncTree_, query, eventRegistration);
    $e0be213f695400f3$var$eventQueueRaiseEventsAtPath(repo.eventQueue_, query._path, events);
}
function $e0be213f695400f3$var$repoInterrupt(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.interrupt($e0be213f695400f3$var$INTERRUPT_REASON);
}
function $e0be213f695400f3$var$repoResume(repo) {
    if (repo.persistentConnection_) repo.persistentConnection_.resume($e0be213f695400f3$var$INTERRUPT_REASON);
}
function $e0be213f695400f3$var$repoLog(repo, ...varArgs) {
    let prefix = '';
    if (repo.persistentConnection_) prefix = repo.persistentConnection_.id + ':';
    $e0be213f695400f3$var$log(prefix, ...varArgs);
}
function $e0be213f695400f3$var$repoCallOnCompleteCallback(repo, callback, status, errorReason) {
    if (callback) $e0be213f695400f3$var$exceptionGuard(()=>{
        if (status === 'ok') callback(null);
        else {
            const code = (status || 'error').toUpperCase();
            let message = code;
            if (errorReason) message += ': ' + errorReason;
            const error = new Error(message);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.code = code;
            callback(error);
        }
    });
}
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and
 * sends it to the server if possible.
 *
 * @param path - Path at which to do transaction.
 * @param transactionUpdate - Update callback.
 * @param onComplete - Completion callback.
 * @param unwatcher - Function that will be called when the transaction no longer
 * need data updates for `path`.
 * @param applyLocally - Whether or not to make intermediate results visible
 */ function $e0be213f695400f3$var$repoStartTransaction(repo, path, transactionUpdate, onComplete, unwatcher, applyLocally) {
    $e0be213f695400f3$var$repoLog(repo, 'transaction on ' + path);
    // Initialize transaction.
    const transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out
        // which one goes first.
        order: $e0be213f695400f3$var$LUIDGenerator(),
        applyLocally: // Whether to raise local events for this transaction.
        applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        unwatcher: // Function to call to clean up our .on() listener.
        unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    const currentState = $e0be213f695400f3$var$repoGetLatestState(repo, path, undefined);
    transaction.currentInputSnapshot = currentState;
    const newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) transaction.onComplete(null, false, transaction.currentInputSnapshot);
    } else {
        $e0be213f695400f3$var$validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = 0 /* TransactionStatus.RUN */ ;
        const queueNode = $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path);
        const nodeQueue = $e0be213f695400f3$var$treeGetValue(queueNode) || [];
        nodeQueue.push(transaction);
        $e0be213f695400f3$var$treeSetValue(queueNode, nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our
        // transaction state, since the user could start new transactions from the
        // event callbacks.
        let priorityForNode;
        if (typeof newVal === 'object' && newVal !== null && (0, $474ae12482b554c6$export$2344b14b097df817)(newVal, '.priority')) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            priorityForNode = (0, $474ae12482b554c6$export$e51ae4db7b428f67)(newVal, '.priority');
            (0, $474ae12482b554c6$export$a7a9523472993e97)($e0be213f695400f3$var$isValidPriority(priorityForNode), "Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.");
        } else {
            const currentNode = $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
        const newNodeUnresolved = $e0be213f695400f3$var$nodeFromJSON(newVal, priorityForNode);
        const newNode = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
        const events = $e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, path, newNode, transaction.currentWriteId, transaction.applyLocally);
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
    }
}
/**
 * @param excludeSets - A specific set to exclude
 */ function $e0be213f695400f3$var$repoGetLatestState(repo, path, excludeSets) {
    return $e0be213f695400f3$var$syncTreeCalcCompleteEventCache(repo.serverSyncTree_, path, excludeSets) || $e0be213f695400f3$var$ChildrenNode.EMPTY_NODE;
}
/**
 * Sends any already-run transactions that aren't waiting for outstanding
 * transactions to complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively
 * with a particular transactionQueueTree node to recurse through the tree.
 *
 * @param node - transactionQueueTree node to start at.
 */ function $e0be213f695400f3$var$repoSendReadyTransactions(repo, node = repo.transactionQueueTree_) {
    // Before recursing, make sure any completed transactions are removed.
    if (!node) $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, node);
    if ($e0be213f695400f3$var$treeGetValue(node)) {
        const queue = $e0be213f695400f3$var$repoBuildTransactionQueue(repo, node);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(queue.length > 0, 'Sending zero length transaction queue');
        const allRun = queue.every((transaction)=>transaction.status === 0 /* TransactionStatus.RUN */ );
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) $e0be213f695400f3$var$repoSendTransactionQueue(repo, $e0be213f695400f3$var$treeGetPath(node), queue);
    } else if ($e0be213f695400f3$var$treeHasChildren(node)) $e0be213f695400f3$var$treeForEachChild(node, (childNode)=>{
        $e0be213f695400f3$var$repoSendReadyTransactions(repo, childNode);
    });
}
/**
 * Given a list of run transactions, send them to the server and then handle
 * the result (success or failure).
 *
 * @param path - The location of the queue.
 * @param queue - Queue of transactions under the specified location.
 */ function $e0be213f695400f3$var$repoSendTransactionQueue(repo, path, queue) {
    // Mark transactions as sent and increment retry count!
    const setsToIgnore = queue.map((txn)=>{
        return txn.currentWriteId;
    });
    const latestState = $e0be213f695400f3$var$repoGetLatestState(repo, path, setsToIgnore);
    let snapToSend = latestState;
    const latestHash = latestState.hash();
    for(let i = 0; i < queue.length; i++){
        const txn = queue[i];
        (0, $474ae12482b554c6$export$a7a9523472993e97)(txn.status === 0 /* TransactionStatus.RUN */ , 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = 1 /* TransactionStatus.SENT */ ;
        txn.retryCount++;
        const relativePath = $e0be213f695400f3$var$newRelativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */ , txn.currentOutputSnapshotRaw);
    }
    const dataToSend = snapToSend.val(true);
    const pathToSend = path;
    // Send the put.
    repo.server_.put(pathToSend.toString(), dataToSend, (status)=>{
        $e0be213f695400f3$var$repoLog(repo, 'transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        let events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our
            // transaction state, since the callback could trigger more
            // transactions or sets.
            const callbacks = [];
            for(let i = 0; i < queue.length; i++){
                queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId));
                if (queue[i].onComplete) // We never unset the output snapshot, and given that this
                // transaction is complete, it should be set
                callbacks.push(()=>queue[i].onComplete(null, true, queue[i].currentOutputSnapshotResolved));
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path));
            // There may be pending transactions that we can now send.
            $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
            $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
            // Finally, trigger onComplete callbacks.
            for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
        } else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for(let i = 0; i < queue.length; i++)if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                else queue[i].status = 0 /* TransactionStatus.RUN */ ;
            } else {
                $e0be213f695400f3$var$warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for(let i = 0; i < queue.length; i++){
                    queue[i].status = 4 /* TransactionStatus.NEEDS_ABORT */ ;
                    queue[i].abortReason = status;
                }
            }
            $e0be213f695400f3$var$repoRerunTransactions(repo, path);
        }
    }, latestHash);
}
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This
 * is the path at which events need to be raised for.
 *
 * @param changedPath - The path in mergedData that changed.
 * @returns The rootmost path that was affected by rerunning transactions.
 */ function $e0be213f695400f3$var$repoRerunTransactions(repo, changedPath) {
    const rootMostTransactionNode = $e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, changedPath);
    const path = $e0be213f695400f3$var$treeGetPath(rootMostTransactionNode);
    const queue = $e0be213f695400f3$var$repoBuildTransactionQueue(repo, rootMostTransactionNode);
    $e0be213f695400f3$var$repoRerunTransactionQueue(repo, queue, path);
    return path;
}
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted
 * transactions and whatnot).
 *
 * @param queue - The queue of transactions to run.
 * @param path - The path the queue is for.
 */ function $e0be213f695400f3$var$repoRerunTransactionQueue(repo, queue, path) {
    if (queue.length === 0) return; // Nothing to do!
    // Queue up the callbacks and fire them after cleaning up all of our
    // transaction state, since the callback could trigger more transactions or
    // sets.
    const callbacks = [];
    let events = [];
    // Ignore all of the sets we're going to re-run.
    const txnsToRerun = queue.filter((q)=>{
        return q.status === 0 /* TransactionStatus.RUN */ ;
    });
    const setsToIgnore = txnsToRerun.map((q)=>{
        return q.currentWriteId;
    });
    for(let i = 0; i < queue.length; i++){
        const transaction = queue[i];
        const relativePath = $e0be213f695400f3$var$newRelativePath(path, transaction.path);
        let abortTransaction = false, abortReason;
        (0, $474ae12482b554c6$export$a7a9523472993e97)(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === 4 /* TransactionStatus.NEEDS_ABORT */ ) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
        } else if (transaction.status === 0 /* TransactionStatus.RUN */ ) {
            if (transaction.retryCount >= $e0be213f695400f3$var$MAX_TRANSACTION_RETRIES) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
            } else {
                // This code reruns a transaction
                const currentNode = $e0be213f695400f3$var$repoGetLatestState(repo, transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                const newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    $e0be213f695400f3$var$validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    let newDataNode = $e0be213f695400f3$var$nodeFromJSON(newData);
                    const hasExplicitPriority = typeof newData === 'object' && newData != null && (0, $474ae12482b554c6$export$2344b14b097df817)(newData, '.priority');
                    if (!hasExplicitPriority) // Keep the old priority if there wasn't a priority explicitly specified.
                    newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    const oldWriteId = transaction.currentWriteId;
                    const serverValues = $e0be213f695400f3$var$repoGenerateServerValues(repo);
                    const newNodeResolved = $e0be213f695400f3$var$resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = $e0be213f695400f3$var$repoGetNextWriteId(repo);
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat($e0be213f695400f3$var$syncTreeApplyUserOverwrite(repo.serverSyncTree_, transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, oldWriteId, true));
                } else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, transaction.currentWriteId, true));
                }
            }
        }
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = 2 /* TransactionStatus.COMPLETED */ ;
            // Removing a listener can trigger pruning which can muck with
            // mergedData/visibleData (as it prunes data). So defer the unwatcher
            // until we're done.
            (function(unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') callbacks.push(()=>queue[i].onComplete(null, false, queue[i].currentInputSnapshot));
                else callbacks.push(()=>queue[i].onComplete(new Error(abortReason), false, null));
            }
        }
    }
    // Clean up completed transactions.
    $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, repo.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
    // Try to send the transaction result to the server.
    $e0be213f695400f3$var$repoSendReadyTransactions(repo, repo.transactionQueueTree_);
}
/**
 * Returns the rootmost ancestor node of the specified path that has a pending
 * transaction on it, or just returns the node for the given path if there are
 * no pending transactions on any ancestor.
 *
 * @param path - The location to start at.
 * @returns The rootmost node with a transaction.
 */ function $e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, path) {
    let front;
    // Start at the root and walk deeper into the tree towards path until we
    // find a node with pending transactions.
    let transactionNode = repo.transactionQueueTree_;
    front = $e0be213f695400f3$var$pathGetFront(path);
    while(front !== null && $e0be213f695400f3$var$treeGetValue(transactionNode) === undefined){
        transactionNode = $e0be213f695400f3$var$treeSubTree(transactionNode, front);
        path = $e0be213f695400f3$var$pathPopFront(path);
        front = $e0be213f695400f3$var$pathGetFront(path);
    }
    return transactionNode;
}
/**
 * Builds the queue of all transactions at or below the specified
 * transactionNode.
 *
 * @param transactionNode
 * @returns The generated queue.
 */ function $e0be213f695400f3$var$repoBuildTransactionQueue(repo, transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    const transactionQueue = [];
    $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort((a, b)=>a.order - b.order);
    return transactionQueue;
}
function $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, node, queue) {
    const nodeQueue = $e0be213f695400f3$var$treeGetValue(node);
    if (nodeQueue) for(let i = 0; i < nodeQueue.length; i++)queue.push(nodeQueue[i]);
    $e0be213f695400f3$var$treeForEachChild(node, (child)=>{
        $e0be213f695400f3$var$repoAggregateTransactionQueuesForNode(repo, child, queue);
    });
}
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 */ function $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, node) {
    const queue = $e0be213f695400f3$var$treeGetValue(node);
    if (queue) {
        let to = 0;
        for(let from = 0; from < queue.length; from++)if (queue[from].status !== 2 /* TransactionStatus.COMPLETED */ ) {
            queue[to] = queue[from];
            to++;
        }
        queue.length = to;
        $e0be213f695400f3$var$treeSetValue(node, queue.length > 0 ? queue : undefined);
    }
    $e0be213f695400f3$var$treeForEachChild(node, (childNode)=>{
        $e0be213f695400f3$var$repoPruneCompletedTransactionsBelowNode(repo, childNode);
    });
}
/**
 * Aborts all transactions on ancestors or descendants of the specified path.
 * Called when doing a set() or update() since we consider them incompatible
 * with transactions.
 *
 * @param path - Path for which we want to abort related transactions.
 */ function $e0be213f695400f3$var$repoAbortTransactions(repo, path) {
    const affectedPath = $e0be213f695400f3$var$treeGetPath($e0be213f695400f3$var$repoGetAncestorTransactionNode(repo, path));
    const transactionNode = $e0be213f695400f3$var$treeSubTree(repo.transactionQueueTree_, path);
    $e0be213f695400f3$var$treeForEachAncestor(transactionNode, (node)=>{
        $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node);
    });
    $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, transactionNode);
    $e0be213f695400f3$var$treeForEachDescendant(transactionNode, (node)=>{
        $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node);
    });
    return affectedPath;
}
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param node - Node to abort transactions for.
 */ function $e0be213f695400f3$var$repoAbortTransactionsOnNode(repo, node) {
    const queue = $e0be213f695400f3$var$treeGetValue(node);
    if (queue) {
        // Queue up the callbacks and fire them after cleaning up all of our
        // transaction state, since the callback could trigger more transactions
        // or sets.
        const callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for
        // abort, while the unsent ones can be immediately aborted and removed.
        let events = [];
        let lastSent = -1;
        for(let i = 0; i < queue.length; i++){
            if (queue[i].status === 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ) ;
            else if (queue[i].status === 1 /* TransactionStatus.SENT */ ) {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = 3 /* TransactionStatus.SENT_NEEDS_ABORT */ ;
                queue[i].abortReason = 'set';
            } else {
                (0, $474ae12482b554c6$export$a7a9523472993e97)(queue[i].status === 0 /* TransactionStatus.RUN */ , 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat($e0be213f695400f3$var$syncTreeAckUserWrite(repo.serverSyncTree_, queue[i].currentWriteId, true));
                if (queue[i].onComplete) callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, null));
            }
        }
        if (lastSent === -1) // We're not waiting for any sent transactions.  We can clear the queue.
        $e0be213f695400f3$var$treeSetValue(node, undefined);
        else // Remove the transactions we aborted.
        queue.length = lastSent + 1;
        // Now fire the callbacks.
        $e0be213f695400f3$var$eventQueueRaiseEventsForChangedPath(repo.eventQueue_, $e0be213f695400f3$var$treeGetPath(node), events);
        for(let i = 0; i < callbacks.length; i++)$e0be213f695400f3$var$exceptionGuard(callbacks[i]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$decodePath(pathString) {
    let pathStringDecoded = '';
    const pieces = pathString.split('/');
    for(let i = 0; i < pieces.length; i++)if (pieces[i].length > 0) {
        let piece = pieces[i];
        try {
            piece = decodeURIComponent(piece.replace(/\+/g, ' '));
        } catch (e) {}
        pathStringDecoded += '/' + piece;
    }
    return pathStringDecoded;
}
/**
 * @returns key value hash
 */ function $e0be213f695400f3$var$decodeQuery(queryString) {
    const results = {};
    if (queryString.charAt(0) === '?') queryString = queryString.substring(1);
    for (const segment of queryString.split('&')){
        if (segment.length === 0) continue;
        const kv = segment.split('=');
        if (kv.length === 2) results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        else $e0be213f695400f3$var$warn(`Invalid query segment '${segment}' in query '${queryString}'`);
    }
    return results;
}
const $e0be213f695400f3$var$parseRepoInfo = function(dataURL, nodeAdmin) {
    const parsedUrl = $e0be213f695400f3$var$parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
    if (parsedUrl.domain === 'firebase.com') $e0be213f695400f3$var$fatal(parsedUrl.host + ' is no longer supported. ' + 'Please use <YOUR FIREBASE>.firebaseio.com instead');
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace === 'undefined') && parsedUrl.domain !== 'localhost') $e0be213f695400f3$var$fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    if (!parsedUrl.secure) $e0be213f695400f3$var$warnIfPageIsSecure();
    const webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new $e0be213f695400f3$var$RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, nodeAdmin, /*persistenceKey=*/ '', /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
        path: new $e0be213f695400f3$var$Path(parsedUrl.pathString)
    };
};
const $e0be213f695400f3$var$parseDatabaseURL = function(dataURL) {
    // Default to empty strings in the event of a malformed string.
    let host = '', domain = '', subdomain = '', pathString = '', namespace = '';
    // Always default to SSL, unless otherwise specified.
    let secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        let colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        let slashInd = dataURL.indexOf('/');
        if (slashInd === -1) slashInd = dataURL.length;
        let questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) questionMarkInd = dataURL.length;
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) // For pathString, questionMarkInd will always come after slashInd
        pathString = $e0be213f695400f3$var$decodePath(dataURL.substring(slashInd, questionMarkInd));
        const queryParams = $e0be213f695400f3$var$decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        } else colonInd = host.length;
        const hostWithoutPort = host.slice(0, colonInd);
        if (hostWithoutPort.toLowerCase() === 'localhost') domain = 'localhost';
        else if (hostWithoutPort.split('.').length <= 2) domain = hostWithoutPort;
        else {
            // Interpret the subdomain of a 3 or more component URL as the namespace name.
            const dotInd = host.indexOf('.');
            subdomain = host.substring(0, dotInd).toLowerCase();
            domain = host.substring(dotInd + 1);
            // Normalize namespaces to lowercase to share storage / connection.
            namespace = subdomain;
        }
        // Always treat the value of the `ns` as the namespace name if it is present.
        if ('ns' in queryParams) namespace = queryParams['ns'];
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString,
        namespace: namespace
    };
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Modeled after base64 web-safe chars, but ordered by ASCII.
const $e0be213f695400f3$var$PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */ const $e0be213f695400f3$var$nextPushId = function() {
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    let lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    const lastRandChars = [];
    return function(now) {
        const duplicateTime = now === lastPushTime;
        lastPushTime = now;
        let i;
        const timeStampChars = new Array(8);
        for(i = 7; i >= 0; i--){
            timeStampChars[i] = $e0be213f695400f3$var$PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        (0, $474ae12482b554c6$export$a7a9523472993e97)(now === 0, 'Cannot push at time == 0');
        let id = timeStampChars.join('');
        if (!duplicateTime) for(i = 0; i < 12; i++)lastRandChars[i] = Math.floor(Math.random() * 64);
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for(i = 11; i >= 0 && lastRandChars[i] === 63; i--)lastRandChars[i] = 0;
            lastRandChars[i]++;
        }
        for(i = 0; i < 12; i++)id += $e0be213f695400f3$var$PUSH_CHARS.charAt(lastRandChars[i]);
        (0, $474ae12482b554c6$export$a7a9523472993e97)(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encapsulates the data needed to raise an event
 */ class $e0be213f695400f3$var$DataEvent {
    /**
     * @param eventType - One of: value, child_added, child_changed, child_moved, child_removed
     * @param eventRegistration - The function to call to with the event data. User provided
     * @param snapshot - The data backing the event
     * @param prevName - Optional, the name of the previous child for child_* events.
     */ constructor(eventType, eventRegistration, snapshot, prevName){
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    getPath() {
        const ref = this.snapshot.ref;
        if (this.eventType === 'value') return ref._path;
        else return ref.parent._path;
    }
    getEventType() {
        return this.eventType;
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.getPath().toString() + ':' + this.eventType + ':' + (0, $474ae12482b554c6$export$fac44ee5b035f737)(this.snapshot.exportVal());
    }
}
class $e0be213f695400f3$var$CancelEvent {
    constructor(eventRegistration, error, path){
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    getPath() {
        return this.path;
    }
    getEventType() {
        return 'cancel';
    }
    getEventRunner() {
        return this.eventRegistration.getEventRunner(this);
    }
    toString() {
        return this.path.toString() + ':cancel';
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A wrapper class that converts events from the database@exp SDK to the legacy
 * Database SDK. Events are not converted directly as event registration relies
 * on reference comparison of the original user callback (see `matches()`) and
 * relies on equality of the legacy SDK's `context` object.
 */ class $e0be213f695400f3$var$CallbackContext {
    constructor(snapshotCallback, cancelCallback){
        this.snapshotCallback = snapshotCallback;
        this.cancelCallback = cancelCallback;
    }
    onValue(expDataSnapshot, previousChildName) {
        this.snapshotCallback.call(null, expDataSnapshot, previousChildName);
    }
    onCancel(error) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(this.hasCancelCallback, 'Raising a cancel event on a listener with no cancel callback');
        return this.cancelCallback.call(null, error);
    }
    get hasCancelCallback() {
        return !!this.cancelCallback;
    }
    matches(other) {
        return this.snapshotCallback === other.snapshotCallback || this.snapshotCallback.userCallback !== undefined && this.snapshotCallback.userCallback === other.snapshotCallback.userCallback && this.snapshotCallback.context === other.snapshotCallback.context;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The `onDisconnect` class allows you to write or clear data when your client
 * disconnects from the Database server. These updates occur whether your
 * client disconnects cleanly or not, so you can rely on them to clean up data
 * even if a connection is dropped or a client crashes.
 *
 * The `onDisconnect` class is most commonly used to manage presence in
 * applications where it is useful to detect how many clients are connected and
 * when other clients disconnect. See
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information.
 *
 * To avoid problems when a connection is dropped before the requests can be
 * transferred to the Database server, these functions should be called before
 * writing any data.
 *
 * Note that `onDisconnect` operations are only triggered once. If you want an
 * operation to occur each time a disconnect occurs, you'll need to re-establish
 * the `onDisconnect` operations each time you reconnect.
 */ class $e0be213f695400f3$export$95b7818b4ee6c2af {
    /** @hideconstructor */ constructor(_repo, _path){
        this._repo = _repo;
        this._path = _path;
    }
    /**
     * Cancels all previously queued `onDisconnect()` set or update events for this
     * location and all children.
     *
     * If a write has been queued for this location via a `set()` or `update()` at a
     * parent location, the write at this location will be canceled, though writes
     * to sibling locations will still occur.
     *
     * @returns Resolves when synchronization to the server is complete.
     */ cancel() {
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectCancel(this._repo, this._path, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is deleted when the client is disconnected
     * (due to closing the browser, navigating to a new page, or network issues).
     *
     * @returns Resolves when synchronization to the server is complete.
     */ remove() {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.remove', this._path);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSet(this._repo, this._path, null, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value when the
     * client is disconnected (due to closing the browser, navigating to a new page,
     * or network issues).
     *
     * `set()` is especially useful for implementing "presence" systems, where a
     * value should be changed or cleared when a user disconnects so that they
     * appear "offline" to other users. See
     * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
     * for more information.
     *
     * Note that `onDisconnect` operations are only triggered once. If you want an
     * operation to occur each time a disconnect occurs, you'll need to re-establish
     * the `onDisconnect` operations each time.
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ set(value) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.set', this._path);
        $e0be213f695400f3$var$validateFirebaseDataArg('OnDisconnect.set', value, this._path, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSet(this._repo, this._path, value, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Ensures the data at this location is set to the specified value and priority
     * when the client is disconnected (due to closing the browser, navigating to a
     * new page, or network issues).
     *
     * @param value - The value to be written to this location on disconnect (can
     * be an object, array, string, number, boolean, or null).
     * @param priority - The priority to be written (string, number, or null).
     * @returns Resolves when synchronization to the Database is complete.
     */ setWithPriority(value, priority) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.setWithPriority', this._path);
        $e0be213f695400f3$var$validateFirebaseDataArg('OnDisconnect.setWithPriority', value, this._path, false);
        $e0be213f695400f3$var$validatePriority('OnDisconnect.setWithPriority', priority, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectSetWithPriority(this._repo, this._path, value, priority, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
    /**
     * Writes multiple values at this location when the client is disconnected (due
     * to closing the browser, navigating to a new page, or network issues).
     *
     * The `values` argument contains multiple property-value pairs that will be
     * written to the Database together. Each child property can either be a simple
     * property (for example, "name") or a relative path (for example, "name/first")
     * from the current location to the data to update.
     *
     * As opposed to the `set()` method, `update()` can be use to selectively update
     * only the referenced properties at the current location (instead of replacing
     * all the child properties at the current location).
     *
     * @param values - Object containing multiple values.
     * @returns Resolves when synchronization to the Database is complete.
     */ update(values) {
        $e0be213f695400f3$export$8d83036122ae444e('OnDisconnect.update', this._path);
        $e0be213f695400f3$var$validateFirebaseMergeDataArg('OnDisconnect.update', values, this._path, false);
        const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
        $e0be213f695400f3$var$repoOnDisconnectUpdate(this._repo, this._path, values, deferred.wrapCallback(()=>{}));
        return deferred.promise;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $e0be213f695400f3$export$e79c8d837d2220a8 {
    /**
     * @hideconstructor
     */ constructor(_repo, _path, _queryParams, _orderByCalled){
        this._repo = _repo;
        this._path = _path;
        this._queryParams = _queryParams;
        this._orderByCalled = _orderByCalled;
    }
    get key() {
        if ($e0be213f695400f3$var$pathIsEmpty(this._path)) return null;
        else return $e0be213f695400f3$var$pathGetBack(this._path);
    }
    get ref() {
        return new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, this._path);
    }
    get _queryIdentifier() {
        const obj = $e0be213f695400f3$var$queryParamsGetQueryObject(this._queryParams);
        const id = $e0be213f695400f3$var$ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    }
    /**
     * An object representation of the query parameters used by this Query.
     */ get _queryObject() {
        return $e0be213f695400f3$var$queryParamsGetQueryObject(this._queryParams);
    }
    isEqual(other) {
        other = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(other);
        if (!(other instanceof $e0be213f695400f3$export$e79c8d837d2220a8)) return false;
        const sameRepo = this._repo === other._repo;
        const samePath = $e0be213f695400f3$var$pathEquals(this._path, other._path);
        const sameQueryIdentifier = this._queryIdentifier === other._queryIdentifier;
        return sameRepo && samePath && sameQueryIdentifier;
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return this._repo.toString() + $e0be213f695400f3$var$pathToUrlEncodedString(this._path);
    }
}
/**
 * Validates that no other order by call has been made
 */ function $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, fnName) {
    if (query._orderByCalled === true) throw new Error(fnName + ": You can't combine multiple orderBy calls.");
}
/**
 * Validates start/end values for queries.
 */ function $e0be213f695400f3$var$validateQueryEndpoints(params) {
    let startNode = null;
    let endNode = null;
    if (params.hasStart()) startNode = params.getIndexStartValue();
    if (params.hasEnd()) endNode = params.getIndexEndValue();
    if (params.getIndex() === $e0be213f695400f3$var$KEY_INDEX) {
        const tooManyArgsError = "Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().";
        const wrongArgTypeError = "Query: When ordering by key, the argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() must be a string.";
        if (params.hasStart()) {
            const startName = params.getIndexStartName();
            if (startName !== $e0be213f695400f3$var$MIN_NAME) throw new Error(tooManyArgsError);
            else if (typeof startNode !== 'string') throw new Error(wrongArgTypeError);
        }
        if (params.hasEnd()) {
            const endName = params.getIndexEndName();
            if (endName !== $e0be213f695400f3$var$MAX_NAME) throw new Error(tooManyArgsError);
            else if (typeof endNode !== 'string') throw new Error(wrongArgTypeError);
        }
    } else if (params.getIndex() === $e0be213f695400f3$var$PRIORITY_INDEX) {
        if (startNode != null && !$e0be213f695400f3$var$isValidPriority(startNode) || endNode != null && !$e0be213f695400f3$var$isValidPriority(endNode)) throw new Error("Query: When ordering by priority, the first argument passed to startAt(), startAfter() endAt(), endBefore(), or equalTo() must be a valid priority value (null, a number, or a string).");
    } else {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(params.getIndex() instanceof $e0be213f695400f3$var$PathIndex || params.getIndex() === $e0be213f695400f3$var$VALUE_INDEX, 'unknown index type.');
        if (startNode != null && typeof startNode === 'object' || endNode != null && typeof endNode === 'object') throw new Error("Query: First argument passed to startAt(), startAfter(), endAt(), endBefore(), or equalTo() cannot be an object.");
    }
}
/**
 * Validates that limit* has been called with the correct combination of parameters
 */ function $e0be213f695400f3$var$validateLimit(params) {
    if (params.hasStart() && params.hasEnd() && params.hasLimit() && !params.hasAnchoredLimit()) throw new Error("Query: Can't combine startAt(), startAfter(), endAt(), endBefore(), and limit(). Use limitToFirst() or limitToLast() instead.");
}
/**
 * @internal
 */ class $e0be213f695400f3$export$35c3a5e7c9d1033c extends $e0be213f695400f3$export$e79c8d837d2220a8 {
    /** @hideconstructor */ constructor(repo, path){
        super(repo, path, new $e0be213f695400f3$export$7ba287e361c94330(), false);
    }
    get parent() {
        const parentPath = $e0be213f695400f3$var$pathParent(this._path);
        return parentPath === null ? null : new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, parentPath);
    }
    get root() {
        let ref = this;
        while(ref.parent !== null)ref = ref.parent;
        return ref;
    }
}
/**
 * A `DataSnapshot` contains data from a Database location.
 *
 * Any time you read data from the Database, you receive the data as a
 * `DataSnapshot`. A `DataSnapshot` is passed to the event callbacks you attach
 * with `on()` or `once()`. You can extract the contents of the snapshot as a
 * JavaScript object by calling the `val()` method. Alternatively, you can
 * traverse into the snapshot by calling `child()` to return child snapshots
 * (which you could then call `val()` on).
 *
 * A `DataSnapshot` is an efficiently generated, immutable copy of the data at
 * a Database location. It cannot be modified and will never change (to modify
 * data, you always call the `set()` method on a `Reference` directly).
 */ class $e0be213f695400f3$export$80b98bcbc246c942 {
    /**
     * @param _node - A SnapshotNode to wrap.
     * @param ref - The location this snapshot came from.
     * @param _index - The iteration order for this snapshot
     * @hideconstructor
     */ constructor(_node, /**
     * The location of this DataSnapshot.
     */ ref, _index){
        this._node = _node;
        this.ref = ref;
        this._index = _index;
    }
    /**
     * Gets the priority value of the data in this `DataSnapshot`.
     *
     * Applications need not use priority but can order collections by
     * ordinary properties (see
     * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data |Sorting and filtering data}
     * ).
     */ get priority() {
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this._node.getPriority().val();
    }
    /**
     * The key (last part of the path) of the location of this `DataSnapshot`.
     *
     * The last token in a Database location is considered its key. For example,
     * "ada" is the key for the /users/ada/ node. Accessing the key on any
     * `DataSnapshot` will return the key for the location that generated it.
     * However, accessing the key on the root URL of a Database will return
     * `null`.
     */ get key() {
        return this.ref.key;
    }
    /** Returns the number of child properties of this `DataSnapshot`. */ get size() {
        return this._node.numChildren();
    }
    /**
     * Gets another `DataSnapshot` for the location at the specified relative path.
     *
     * Passing a relative path to the `child()` method of a DataSnapshot returns
     * another `DataSnapshot` for the location at the specified relative path. The
     * relative path can either be a simple child name (for example, "ada") or a
     * deeper, slash-separated path (for example, "ada/name/first"). If the child
     * location has no data, an empty `DataSnapshot` (that is, a `DataSnapshot`
     * whose value is `null`) is returned.
     *
     * @param path - A relative path to the location of child data.
     */ child(path) {
        const childPath = new $e0be213f695400f3$var$Path(path);
        const childRef = $e0be213f695400f3$export$f9574b70e1d95d9d(this.ref, path);
        return new $e0be213f695400f3$export$80b98bcbc246c942(this._node.getChild(childPath), childRef, $e0be213f695400f3$var$PRIORITY_INDEX);
    }
    /**
     * Returns true if this `DataSnapshot` contains any data. It is slightly more
     * efficient than using `snapshot.val() !== null`.
     */ exists() {
        return !this._node.isEmpty();
    }
    /**
     * Exports the entire contents of the DataSnapshot as a JavaScript object.
     *
     * The `exportVal()` method is similar to `val()`, except priority information
     * is included (if available), making it suitable for backing up your data.
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportVal() {
        return this._node.val(true);
    }
    /**
     * Enumerates the top-level children in the `IteratedDataSnapshot`.
     *
     * Because of the way JavaScript objects work, the ordering of data in the
     * JavaScript object returned by `val()` is not guaranteed to match the
     * ordering on the server nor the ordering of `onChildAdded()` events. That is
     * where `forEach()` comes in handy. It guarantees the children of a
     * `DataSnapshot` will be iterated in their query order.
     *
     * If no explicit `orderBy*()` method is used, results are returned
     * ordered by key (unless priorities are used, in which case, results are
     * returned by priority).
     *
     * @param action - A function that will be called for each child DataSnapshot.
     * The callback can return true to cancel further enumeration.
     * @returns true if enumeration was canceled due to your callback returning
     * true.
     */ forEach(action) {
        if (this._node.isLeafNode()) return false;
        const childrenNode = this._node;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this._index, (key, node)=>{
            return action(new $e0be213f695400f3$export$80b98bcbc246c942(node, $e0be213f695400f3$export$f9574b70e1d95d9d(this.ref, key), $e0be213f695400f3$var$PRIORITY_INDEX));
        });
    }
    /**
     * Returns true if the specified child path has (non-null) data.
     *
     * @param path - A relative path to the location of a potential child.
     * @returns `true` if data exists at the specified child path; else
     *  `false`.
     */ hasChild(path) {
        const childPath = new $e0be213f695400f3$var$Path(path);
        return !this._node.getChild(childPath).isEmpty();
    }
    /**
     * Returns whether or not the `DataSnapshot` has any non-`null` child
     * properties.
     *
     * You can use `hasChildren()` to determine if a `DataSnapshot` has any
     * children. If it does, you can enumerate them using `forEach()`. If it
     * doesn't, then either this snapshot contains a primitive value (which can be
     * retrieved with `val()`) or it is empty (in which case, `val()` will return
     * `null`).
     *
     * @returns true if this snapshot has any children; else false.
     */ hasChildren() {
        if (this._node.isLeafNode()) return false;
        else return !this._node.isEmpty();
    }
    /**
     * Returns a JSON-serializable representation of this object.
     */ toJSON() {
        return this.exportVal();
    }
    /**
     * Extracts a JavaScript value from a `DataSnapshot`.
     *
     * Depending on the data in a `DataSnapshot`, the `val()` method may return a
     * scalar type (string, number, or boolean), an array, or an object. It may
     * also return null, indicating that the `DataSnapshot` is empty (contains no
     * data).
     *
     * @returns The DataSnapshot's contents as a JavaScript value (Object,
     *   Array, string, number, boolean, or `null`).
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    val() {
        return this._node.val();
    }
}
/**
 *
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided path. If no path is provided, the `Reference`
 * will point to the root of the Database.
 *
 * @param db - The database instance to obtain a reference for.
 * @param path - Optional path representing the location the returned
 *   `Reference` will point. If not provided, the returned `Reference` will
 *   point to the root of the Database.
 * @returns If a path is provided, a `Reference`
 *   pointing to the provided path. Otherwise, a `Reference` pointing to the
 *   root of the Database.
 */ function $e0be213f695400f3$export$eff4d24c3ff7876e(db, path) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('ref');
    return path !== undefined ? $e0be213f695400f3$export$f9574b70e1d95d9d(db._root, path) : db._root;
}
/**
 * Returns a `Reference` representing the location in the Database
 * corresponding to the provided Firebase URL.
 *
 * An exception is thrown if the URL is not a valid Firebase Database URL or it
 * has a different domain than the current `Database` instance.
 *
 * Note that all query parameters (`orderBy`, `limitToLast`, etc.) are ignored
 * and are not applied to the returned `Reference`.
 *
 * @param db - The database instance to obtain a reference for.
 * @param url - The Firebase URL at which the returned `Reference` will
 *   point.
 * @returns A `Reference` pointing to the provided
 *   Firebase URL.
 */ function $e0be213f695400f3$export$291fc3c05735451(db, url) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('refFromURL');
    const parsedURL = $e0be213f695400f3$var$parseRepoInfo(url, db._repo.repoInfo_.nodeAdmin);
    $e0be213f695400f3$var$validateUrl('refFromURL', parsedURL);
    const repoInfo = parsedURL.repoInfo;
    if (!db._repo.repoInfo_.isCustomHost() && repoInfo.host !== db._repo.repoInfo_.host) $e0be213f695400f3$var$fatal("refFromURL: Host name does not match the current database: (found " + repoInfo.host + ' but expected ' + db._repo.repoInfo_.host + ')');
    return $e0be213f695400f3$export$eff4d24c3ff7876e(db, parsedURL.path.toString());
}
/**
 * Gets a `Reference` for the location at the specified relative path.
 *
 * The relative path can either be a simple child name (for example, "ada") or
 * a deeper slash-separated path (for example, "ada/name/first").
 *
 * @param parent - The parent location.
 * @param path - A relative path from this location to the desired child
 *   location.
 * @returns The specified child location.
 */ function $e0be213f695400f3$export$f9574b70e1d95d9d(parent, path) {
    parent = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(parent);
    if ($e0be213f695400f3$var$pathGetFront(parent._path) === null) $e0be213f695400f3$var$validateRootPathString('child', 'path', path, false);
    else $e0be213f695400f3$export$8637b026ace8abb1('child', 'path', path, false);
    return new $e0be213f695400f3$export$35c3a5e7c9d1033c(parent._repo, $e0be213f695400f3$var$pathChild(parent._path, path));
}
/**
 * Returns an `OnDisconnect` object - see
 * {@link https://firebase.google.com/docs/database/web/offline-capabilities | Enabling Offline Capabilities in JavaScript}
 * for more information on how to use it.
 *
 * @param ref - The reference to add OnDisconnect triggers for.
 */ function $e0be213f695400f3$export$b61bdcd0bdb4f86a(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return new $e0be213f695400f3$export$95b7818b4ee6c2af(ref._repo, ref._path);
}
/**
 * Generates a new child location using a unique key and returns its
 * `Reference`.
 *
 * This is the most common pattern for adding data to a collection of items.
 *
 * If you provide a value to `push()`, the value is written to the
 * generated location. If you don't pass a value, nothing is written to the
 * database and the child remains empty (but you can use the `Reference`
 * elsewhere).
 *
 * The unique keys generated by `push()` are ordered by the current time, so the
 * resulting list of items is chronologically sorted. The keys are also
 * designed to be unguessable (they contain 72 random bits of entropy).
 *
 * See {@link https://firebase.google.com/docs/database/web/lists-of-data#append_to_a_list_of_data | Append to a list of data}.
 * See {@link https://firebase.googleblog.com/2015/02/the-2120-ways-to-ensure-unique_68.html | The 2^120 Ways to Ensure Unique Identifiers}.
 *
 * @param parent - The parent location.
 * @param value - Optional value to be written at the generated location.
 * @returns Combined `Promise` and `Reference`; resolves when write is complete,
 * but can be used immediately as the `Reference` to the child location.
 */ function $e0be213f695400f3$export$4cbf152802aa238(parent, value) {
    parent = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(parent);
    $e0be213f695400f3$export$8d83036122ae444e('push', parent._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('push', value, parent._path, true);
    const now = $e0be213f695400f3$var$repoServerTime(parent._repo);
    const name = $e0be213f695400f3$var$nextPushId(now);
    // push() returns a ThennableReference whose promise is fulfilled with a
    // regular Reference. We use child() to create handles to two different
    // references. The first is turned into a ThennableReference below by adding
    // then() and catch() methods and is used as the return value of push(). The
    // second remains a regular Reference and is used as the fulfilled value of
    // the first ThennableReference.
    const thenablePushRef = $e0be213f695400f3$export$f9574b70e1d95d9d(parent, name);
    const pushRef = $e0be213f695400f3$export$f9574b70e1d95d9d(parent, name);
    let promise;
    if (value != null) promise = $e0be213f695400f3$export$adaa4cf7ef1b65be(pushRef, value).then(()=>pushRef);
    else promise = Promise.resolve(pushRef);
    thenablePushRef.then = promise.then.bind(promise);
    thenablePushRef.catch = promise.then.bind(promise, undefined);
    return thenablePushRef;
}
/**
 * Removes the data at this Database location.
 *
 * Any data at child locations will also be deleted.
 *
 * The effect of the remove will be visible immediately and the corresponding
 * event 'value' will be triggered. Synchronization of the remove to the
 * Firebase servers will also be started, and the returned Promise will resolve
 * when complete. If provided, the onComplete callback will be called
 * asynchronously after synchronization has finished.
 *
 * @param ref - The location to remove.
 * @returns Resolves when remove on server is complete.
 */ function $e0be213f695400f3$export$cd7f480d6b8286c3(ref) {
    $e0be213f695400f3$export$8d83036122ae444e('remove', ref._path);
    return $e0be213f695400f3$export$adaa4cf7ef1b65be(ref, null);
}
/**
 * Writes data to this Database location.
 *
 * This will overwrite any data at this location and all child locations.
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ("value", "child_added", etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * Passing `null` for the new value is equivalent to calling `remove()`; namely,
 * all data at this location and all child locations will be deleted.
 *
 * `set()` will remove any priority stored at this location, so if priority is
 * meant to be preserved, you need to use `setWithPriority()` instead.
 *
 * Note that modifying data with `set()` will cancel any pending transactions
 * at that location, so extreme care should be taken if mixing `set()` and
 * `transaction()` to modify the same data.
 *
 * A single `set()` will generate a single "value" event at the location where
 * the `set()` was performed.
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$adaa4cf7ef1b65be(ref, value) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('set', ref._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('set', value, ref._path, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, ref._path, value, /*priority=*/ null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Sets a priority for the data at this Database location.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$313bf5dbe7a1196e(ref, priority) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('setPriority', ref._path);
    $e0be213f695400f3$var$validatePriority('setPriority', priority, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, $e0be213f695400f3$var$pathChild(ref._path, '.priority'), priority, null, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes data the Database location. Like `set()` but also specifies the
 * priority for that data.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sorting_and_filtering_data | Sorting and filtering data}
 * ).
 *
 * @param ref - The location to write to.
 * @param value - The value to be written (string, number, boolean, object,
 *   array, or null).
 * @param priority - The priority to be written (string, number, or null).
 * @returns Resolves when write to server is complete.
 */ function $e0be213f695400f3$export$1fa5d5bf488088f3(ref, value, priority) {
    $e0be213f695400f3$export$8d83036122ae444e('setWithPriority', ref._path);
    $e0be213f695400f3$var$validateFirebaseDataArg('setWithPriority', value, ref._path, false);
    $e0be213f695400f3$var$validatePriority('setWithPriority', priority, false);
    if (ref.key === '.length' || ref.key === '.keys') throw 'setWithPriority failed: ' + ref.key + ' is a read-only object.';
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoSetWithPriority(ref._repo, ref._path, value, priority, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Writes multiple values to the Database at once.
 *
 * The `values` argument contains multiple property-value pairs that will be
 * written to the Database together. Each child property can either be a simple
 * property (for example, "name") or a relative path (for example,
 * "name/first") from the current location to the data to update.
 *
 * As opposed to the `set()` method, `update()` can be use to selectively update
 * only the referenced properties at the current location (instead of replacing
 * all the child properties at the current location).
 *
 * The effect of the write will be visible immediately, and the corresponding
 * events ('value', 'child_added', etc.) will be triggered. Synchronization of
 * the data to the Firebase servers will also be started, and the returned
 * Promise will resolve when complete. If provided, the `onComplete` callback
 * will be called asynchronously after synchronization has finished.
 *
 * A single `update()` will generate a single "value" event at the location
 * where the `update()` was performed, regardless of how many children were
 * modified.
 *
 * Note that modifying data with `update()` will cancel any pending
 * transactions at that location, so extreme care should be taken if mixing
 * `update()` and `transaction()` to modify the same data.
 *
 * Passing `null` to `update()` will remove the data at this location.
 *
 * See
 * {@link https://firebase.googleblog.com/2015/09/introducing-multi-location-updates-and_86.html | Introducing multi-location updates and more}.
 *
 * @param ref - The location to write to.
 * @param values - Object containing multiple values.
 * @returns Resolves when update on server is complete.
 */ function $e0be213f695400f3$export$722fbec263ad908a(ref, values) {
    $e0be213f695400f3$var$validateFirebaseMergeDataArg('update', values, ref._path, false);
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    $e0be213f695400f3$var$repoUpdate(ref._repo, ref._path, values, deferred.wrapCallback(()=>{}));
    return deferred.promise;
}
/**
 * Gets the most up-to-date result for this query.
 *
 * @param query - The query to run.
 * @returns A `Promise` which resolves to the resulting DataSnapshot if a value is
 * available, or rejects if the client is unable to return a value (e.g., if the
 * server is unreachable and there is nothing cached).
 */ function $e0be213f695400f3$export$3988ae62b71be9a3(query) {
    query = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(query);
    const callbackContext = new $e0be213f695400f3$var$CallbackContext(()=>{});
    const container = new $e0be213f695400f3$var$ValueEventRegistration(callbackContext);
    return $e0be213f695400f3$var$repoGetValue(query._repo, query, container).then((node)=>{
        return new $e0be213f695400f3$export$80b98bcbc246c942(node, new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), query._queryParams.getIndex());
    });
}
/**
 * Represents registration for 'value' events.
 */ class $e0be213f695400f3$var$ValueEventRegistration {
    constructor(callbackContext){
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        return eventType === 'value';
    }
    createEvent(change, query) {
        const index = query._queryParams.getIndex();
        return new $e0be213f695400f3$var$DataEvent('value', this, new $e0be213f695400f3$export$80b98bcbc246c942(change.snapshotNode, new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), index));
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, null);
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $e0be213f695400f3$var$CancelEvent(this, error, path);
        else return null;
    }
    matches(other) {
        if (!(other instanceof $e0be213f695400f3$var$ValueEventRegistration)) return false;
        else if (!other.callbackContext || !this.callbackContext) // If no callback specified, we consider it to match any callback.
        return true;
        else return other.callbackContext.matches(this.callbackContext);
    }
    hasAnyCallback() {
        return this.callbackContext !== null;
    }
}
/**
 * Represents the registration of a child_x event.
 */ class $e0be213f695400f3$var$ChildEventRegistration {
    constructor(eventType, callbackContext){
        this.eventType = eventType;
        this.callbackContext = callbackContext;
    }
    respondsTo(eventType) {
        let eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck = eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return this.eventType === eventToCheck;
    }
    createCancelEvent(error, path) {
        if (this.callbackContext.hasCancelCallback) return new $e0be213f695400f3$var$CancelEvent(this, error, path);
        else return null;
    }
    createEvent(change, query) {
        (0, $474ae12482b554c6$export$a7a9523472993e97)(change.childName != null, 'Child events should have a childName.');
        const childRef = $e0be213f695400f3$export$f9574b70e1d95d9d(new $e0be213f695400f3$export$35c3a5e7c9d1033c(query._repo, query._path), change.childName);
        const index = query._queryParams.getIndex();
        return new $e0be213f695400f3$var$DataEvent(change.type, this, new $e0be213f695400f3$export$80b98bcbc246c942(change.snapshotNode, childRef, index), change.prevName);
    }
    getEventRunner(eventData) {
        if (eventData.getEventType() === 'cancel') return ()=>this.callbackContext.onCancel(eventData.error);
        else return ()=>this.callbackContext.onValue(eventData.snapshot, eventData.prevName);
    }
    matches(other) {
        if (other instanceof $e0be213f695400f3$var$ChildEventRegistration) return this.eventType === other.eventType && (!this.callbackContext || !other.callbackContext || this.callbackContext.matches(other.callbackContext));
        return false;
    }
    hasAnyCallback() {
        return !!this.callbackContext;
    }
}
function $e0be213f695400f3$var$addEventListener(query, eventType, callback, cancelCallbackOrListenOptions, options) {
    let cancelCallback;
    if (typeof cancelCallbackOrListenOptions === 'object') {
        cancelCallback = undefined;
        options = cancelCallbackOrListenOptions;
    }
    if (typeof cancelCallbackOrListenOptions === 'function') cancelCallback = cancelCallbackOrListenOptions;
    if (options && options.onlyOnce) {
        const userCallback = callback;
        const onceCallback = (dataSnapshot, previousChildName)=>{
            $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
            userCallback(dataSnapshot, previousChildName);
        };
        onceCallback.userCallback = callback.userCallback;
        onceCallback.context = callback.context;
        callback = onceCallback;
    }
    const callbackContext = new $e0be213f695400f3$var$CallbackContext(callback, cancelCallback || undefined);
    const container = eventType === 'value' ? new $e0be213f695400f3$var$ValueEventRegistration(callbackContext) : new $e0be213f695400f3$var$ChildEventRegistration(eventType, callbackContext);
    $e0be213f695400f3$var$repoAddEventCallbackForQuery(query._repo, query, container);
    return ()=>$e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
function $e0be213f695400f3$export$ad30f661f41f4d90(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'value', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$fdc3e67b2775c753(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_added', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$a3fdf31223dcb03(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_changed', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$1b001b15904d2a7f(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_moved', callback, cancelCallbackOrListenOptions, options);
}
function $e0be213f695400f3$export$8362b530316d1aba(query, callback, cancelCallbackOrListenOptions, options) {
    return $e0be213f695400f3$var$addEventListener(query, 'child_removed', callback, cancelCallbackOrListenOptions, options);
}
/**
 * Detaches a callback previously attached with the corresponding `on*()` (`onValue`, `onChildAdded`) listener.
 * Note: This is not the recommended way to remove a listener. Instead, please use the returned callback function from
 * the respective `on*` callbacks.
 *
 * Detach a callback previously attached with `on*()`. Calling `off()` on a parent listener
 * will not automatically remove listeners registered on child nodes, `off()`
 * must also be called on any child listeners to remove the callback.
 *
 * If a callback is not specified, all callbacks for the specified eventType
 * will be removed. Similarly, if no eventType is specified, all callbacks
 * for the `Reference` will be removed.
 *
 * Individual listeners can also be removed by invoking their unsubscribe
 * callbacks.
 *
 * @param query - The query that the listener was registered with.
 * @param eventType - One of the following strings: "value", "child_added",
 * "child_changed", "child_removed", or "child_moved." If omitted, all callbacks
 * for the `Reference` will be removed.
 * @param callback - The callback function that was passed to `on()` or
 * `undefined` to remove all callbacks.
 */ function $e0be213f695400f3$export$8c8705df4a2dcec9(query, eventType, callback) {
    let container = null;
    const expCallback = callback ? new $e0be213f695400f3$var$CallbackContext(callback) : null;
    if (eventType === 'value') container = new $e0be213f695400f3$var$ValueEventRegistration(expCallback);
    else if (eventType) container = new $e0be213f695400f3$var$ChildEventRegistration(eventType, expCallback);
    $e0be213f695400f3$var$repoRemoveEventCallbackForQuery(query._repo, query, container);
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Database query. `QueryConstraint`s are created by invoking {@link endAt},
 * {@link endBefore}, {@link startAt}, {@link startAfter}, {@link
 * limitToFirst}, {@link limitToLast}, {@link orderByChild},
 * {@link orderByChild}, {@link orderByKey} , {@link orderByPriority} ,
 * {@link orderByValue}  or {@link equalTo} and
 * can then be passed to {@link query} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $e0be213f695400f3$export$b0e86f2c7431df4e {
}
class $e0be213f695400f3$var$QueryEndAtConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endAt';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('endAt', this._value, query._path, true);
        const newParams = $e0be213f695400f3$var$queryParamsEndAt(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endAt: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name less than or equal
 * to the specified key.
 *
 * You can read more about `endAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to end at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end at, among the children with the previously
 * specified priority. This argument is only allowed if ordering by child,
 * value, or priority.
 */ function $e0be213f695400f3$export$28ec54a8428bdb3f(value, key) {
    $e0be213f695400f3$var$validateKey('endAt', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEndAtConstraint(value, key);
}
class $e0be213f695400f3$var$QueryEndBeforeConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'endBefore';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('endBefore', this._value, query._path, false);
        const newParams = $e0be213f695400f3$var$queryParamsEndBefore(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasEnd()) throw new Error("endBefore: Starting point was already set (by another call to endAt, endBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified ending point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The ending point is exclusive. If only a value is provided, children
 * with a value less than the specified value will be included in the query.
 * If a key is specified, then children must have a value less than or equal
 * to the specified value and a key name less than the specified key.
 *
 * @param value - The value to end before. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to end before, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $e0be213f695400f3$export$57203950645b8b11(value, key) {
    $e0be213f695400f3$var$validateKey('endBefore', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEndBeforeConstraint(value, key);
}
class $e0be213f695400f3$var$QueryStartAtConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAt';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('startAt', this._value, query._path, true);
        const newParams = $e0be213f695400f3$var$queryParamsStartAt(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAt: Starting point was already set (by another call to startAt, startBefore or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is inclusive, so children with exactly the specified value
 * will be included in the query. The optional key argument can be used to
 * further limit the range of the query. If it is specified, then children that
 * have exactly the specified value must also have a key name greater than or
 * equal to the specified key.
 *
 * You can read more about `startAt()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to start at. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $e0be213f695400f3$export$859941c5fc8eba6b(value = null, key) {
    $e0be213f695400f3$var$validateKey('startAt', 'key', key, true);
    return new $e0be213f695400f3$var$QueryStartAtConstraint(value, key);
}
class $e0be213f695400f3$var$QueryStartAfterConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'startAfter';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('startAfter', this._value, query._path, false);
        const newParams = $e0be213f695400f3$var$queryParamsStartAfter(query._queryParams, this._value, this._key);
        $e0be213f695400f3$var$validateLimit(newParams);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        if (query._queryParams.hasStart()) throw new Error("startAfter: Starting point was already set (by another call to startAt, startAfter, or equalTo).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, query._orderByCalled);
    }
}
/**
 * Creates a `QueryConstraint` with the specified starting point (exclusive).
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The starting point is exclusive. If only a value is provided, children
 * with a value greater than the specified value will be included in the query.
 * If a key is specified, then children must have a value greater than or equal
 * to the specified value and a a key name greater than the specified key.
 *
 * @param value - The value to start after. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start after. This argument is only allowed if
 * ordering by child, value, or priority.
 */ function $e0be213f695400f3$export$dd8dee5f7b804673(value, key) {
    $e0be213f695400f3$var$validateKey('startAfter', 'key', key, true);
    return new $e0be213f695400f3$var$QueryStartAfterConstraint(value, key);
}
class $e0be213f695400f3$var$QueryLimitToFirstConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToFirst';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToFirst: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, $e0be213f695400f3$var$queryParamsLimitToFirst(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that if limited to the first specific number
 * of children.
 *
 * The `limitToFirst()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the first 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToFirst()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $e0be213f695400f3$export$9d02e839f813b99d(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToFirst: First argument must be a positive integer.');
    return new $e0be213f695400f3$var$QueryLimitToFirstConstraint(limit);
}
class $e0be213f695400f3$var$QueryLimitToLastConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_limit){
        super();
        this._limit = _limit;
        this.type = 'limitToLast';
    }
    _apply(query) {
        if (query._queryParams.hasLimit()) throw new Error("limitToLast: Limit was already set (by another call to limitToFirst or limitToLast).");
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, $e0be213f695400f3$var$queryParamsLimitToLast(query._queryParams, this._limit), query._orderByCalled);
    }
}
/**
 * Creates a new `QueryConstraint` that is limited to return only the last
 * specified number of children.
 *
 * The `limitToLast()` method is used to set a maximum number of children to be
 * synced for a given callback. If we set a limit of 100, we will initially only
 * receive up to 100 `child_added` events. If we have fewer than 100 messages
 * stored in our Database, a `child_added` event will fire for each message.
 * However, if we have over 100 messages, we will only receive a `child_added`
 * event for the last 100 ordered messages. As items change, we will receive
 * `child_removed` events for each item that drops out of the active list so
 * that the total number stays at 100.
 *
 * You can read more about `limitToLast()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param limit - The maximum number of nodes to include in this query.
 */ function $e0be213f695400f3$export$f823b3589f69d3b8(limit) {
    if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) throw new Error('limitToLast: First argument must be a positive integer.');
    return new $e0be213f695400f3$var$QueryLimitToLastConstraint(limit);
}
class $e0be213f695400f3$var$QueryOrderByChildConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_path){
        super();
        this._path = _path;
        this.type = 'orderByChild';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByChild');
        const parsedPath = new $e0be213f695400f3$var$Path(this._path);
        if ($e0be213f695400f3$var$pathIsEmpty(parsedPath)) throw new Error('orderByChild: cannot pass in empty path. Use orderByValue() instead.');
        const index = new $e0be213f695400f3$var$PathIndex(parsedPath);
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, index);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the specified child key.
 *
 * Queries can only order by one key at a time. Calling `orderByChild()`
 * multiple times on the same query is an error.
 *
 * Firebase queries allow you to order your data by any child key on the fly.
 * However, if you know in advance what your indexes will be, you can define
 * them via the .indexOn rule in your Security Rules for better performance. See
 * the{@link https://firebase.google.com/docs/database/security/indexing-data}
 * rule for more information.
 *
 * You can read more about `orderByChild()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 *
 * @param path - The path to order by.
 */ function $e0be213f695400f3$export$5162bd9025f8e144(path) {
    if (path === '$key') throw new Error('orderByChild: "$key" is invalid.  Use orderByKey() instead.');
    else if (path === '$priority') throw new Error('orderByChild: "$priority" is invalid.  Use orderByPriority() instead.');
    else if (path === '$value') throw new Error('orderByChild: "$value" is invalid.  Use orderByValue() instead.');
    $e0be213f695400f3$export$8637b026ace8abb1('orderByChild', 'path', path, false);
    return new $e0be213f695400f3$var$QueryOrderByChildConstraint(path);
}
class $e0be213f695400f3$var$QueryOrderByKeyConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByKey';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByKey');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$KEY_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by the key.
 *
 * Sorts the results of a query by their (ascending) key values.
 *
 * You can read more about `orderByKey()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $e0be213f695400f3$export$d5ab8b3bbd8afbf8() {
    return new $e0be213f695400f3$var$QueryOrderByKeyConstraint();
}
class $e0be213f695400f3$var$QueryOrderByPriorityConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByPriority';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByPriority');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$PRIORITY_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by priority.
 *
 * Applications need not use priority but can order collections by
 * ordinary properties (see
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}
 * for alternatives to priority.
 */ function $e0be213f695400f3$export$19e8ae5500cf2e55() {
    return new $e0be213f695400f3$var$QueryOrderByPriorityConstraint();
}
class $e0be213f695400f3$var$QueryOrderByValueConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(){
        super(...arguments);
        this.type = 'orderByValue';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateNoPreviousOrderByCall(query, 'orderByValue');
        const newParams = $e0be213f695400f3$var$queryParamsOrderBy(query._queryParams, $e0be213f695400f3$var$VALUE_INDEX);
        $e0be213f695400f3$var$validateQueryEndpoints(newParams);
        return new $e0be213f695400f3$export$e79c8d837d2220a8(query._repo, query._path, newParams, /*orderByCalled=*/ true);
    }
}
/**
 * Creates a new `QueryConstraint` that orders by value.
 *
 * If the children of a query are all scalar values (string, number, or
 * boolean), you can order the results by their (ascending) values.
 *
 * You can read more about `orderByValue()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#sort_data | Sort data}.
 */ function $e0be213f695400f3$export$7f2f62793c39d0c0() {
    return new $e0be213f695400f3$var$QueryOrderByValueConstraint();
}
class $e0be213f695400f3$var$QueryEqualToValueConstraint extends $e0be213f695400f3$export$b0e86f2c7431df4e {
    constructor(_value, _key){
        super();
        this._value = _value;
        this._key = _key;
        this.type = 'equalTo';
    }
    _apply(query) {
        $e0be213f695400f3$var$validateFirebaseDataArg('equalTo', this._value, query._path, false);
        if (query._queryParams.hasStart()) throw new Error("equalTo: Starting point was already set (by another call to startAt/startAfter or equalTo).");
        if (query._queryParams.hasEnd()) throw new Error("equalTo: Ending point was already set (by another call to endAt/endBefore or equalTo).");
        return new $e0be213f695400f3$var$QueryEndAtConstraint(this._value, this._key)._apply(new $e0be213f695400f3$var$QueryStartAtConstraint(this._value, this._key)._apply(query));
    }
}
/**
 * Creates a `QueryConstraint` that includes children that match the specified
 * value.
 *
 * Using `startAt()`, `startAfter()`, `endBefore()`, `endAt()` and `equalTo()`
 * allows you to choose arbitrary starting and ending points for your queries.
 *
 * The optional key argument can be used to further limit the range of the
 * query. If it is specified, then children that have exactly the specified
 * value must also have exactly the specified key as their key name. This can be
 * used to filter result sets with many matches for the same value.
 *
 * You can read more about `equalTo()` in
 * {@link https://firebase.google.com/docs/database/web/lists-of-data#filtering_data | Filtering data}.
 *
 * @param value - The value to match for. The argument type depends on which
 * `orderBy*()` function was used in this query. Specify a value that matches
 * the `orderBy*()` type. When used in combination with `orderByKey()`, the
 * value must be a string.
 * @param key - The child key to start at, among the children with the
 * previously specified priority. This argument is only allowed if ordering by
 * child, value, or priority.
 */ function $e0be213f695400f3$export$bdcdec1f91f16dff(value, key) {
    $e0be213f695400f3$var$validateKey('equalTo', 'key', key, true);
    return new $e0be213f695400f3$var$QueryEqualToValueConstraint(value, key);
}
/**
 * Creates a new immutable instance of `Query` that is extended to also include
 * additional query constraints.
 *
 * @param query - The Query instance to use as a base for the new constraints.
 * @param queryConstraints - The list of `QueryConstraint`s to apply.
 * @throws if any of the provided query constraints cannot be combined with the
 * existing or new constraints.
 */ function $e0be213f695400f3$export$2fa187e846a241c4(query1, ...queryConstraints) {
    let queryImpl = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(query1);
    for (const constraint of queryConstraints)queryImpl = constraint._apply(queryImpl);
    return queryImpl;
}
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */ $e0be213f695400f3$var$syncPointSetReferenceConstructor($e0be213f695400f3$export$35c3a5e7c9d1033c);
$e0be213f695400f3$var$syncTreeSetReferenceConstructor($e0be213f695400f3$export$35c3a5e7c9d1033c);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This variable is also defined in the firebase Node.js Admin SDK. Before
 * modifying this definition, consult the definition in:
 *
 * https://github.com/firebase/firebase-admin-node
 *
 * and make sure the two are consistent.
 */ const $e0be213f695400f3$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
/**
 * Creates and caches `Repo` instances.
 */ const $e0be213f695400f3$var$repos = {};
/**
 * If true, any new `Repo` will be created to use `ReadonlyRestClient` (for testing purposes).
 */ let $e0be213f695400f3$var$useRestClient = false;
/**
 * Update an existing `Repo` in place to point to a new host/port.
 */ function $e0be213f695400f3$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider) {
    repo.repoInfo_ = new $e0be213f695400f3$var$RepoInfo(`${host}:${port}`, /* secure= */ false, repo.repoInfo_.namespace, repo.repoInfo_.webSocketOnly, repo.repoInfo_.nodeAdmin, repo.repoInfo_.persistenceKey, repo.repoInfo_.includeNamespaceInQueryParams, /*isUsingEmulator=*/ true);
    if (tokenProvider) repo.authTokenProvider_ = tokenProvider;
}
/**
 * This function should only ever be called to CREATE a new database instance.
 * @internal
 */ function $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin) {
    let dbUrl = url || app.options.databaseURL;
    if (dbUrl === undefined) {
        if (!app.options.projectId) $e0be213f695400f3$var$fatal("Can't determine Firebase Database URL. Be sure to include  a Project ID when calling firebase.initializeApp().");
        $e0be213f695400f3$var$log('Using default host for project ', app.options.projectId);
        dbUrl = `${app.options.projectId}-default-rtdb.firebaseio.com`;
    }
    let parsedUrl = $e0be213f695400f3$var$parseRepoInfo(dbUrl, nodeAdmin);
    let repoInfo = parsedUrl.repoInfo;
    let isEmulator;
    let dbEmulatorHost = undefined;
    if (typeof $djlMn !== 'undefined' && $djlMn.env) dbEmulatorHost = $djlMn.env[$e0be213f695400f3$var$FIREBASE_DATABASE_EMULATOR_HOST_VAR];
    if (dbEmulatorHost) {
        isEmulator = true;
        dbUrl = `http://${dbEmulatorHost}?ns=${repoInfo.namespace}`;
        parsedUrl = $e0be213f695400f3$var$parseRepoInfo(dbUrl, nodeAdmin);
        repoInfo = parsedUrl.repoInfo;
    } else isEmulator = !parsedUrl.repoInfo.secure;
    const authTokenProvider = nodeAdmin && isEmulator ? new $e0be213f695400f3$var$EmulatorTokenProvider($e0be213f695400f3$var$EmulatorTokenProvider.OWNER) : new $e0be213f695400f3$var$FirebaseAuthTokenProvider(app.name, app.options, authProvider);
    $e0be213f695400f3$var$validateUrl('Invalid Firebase Database URL', parsedUrl);
    if (!$e0be213f695400f3$var$pathIsEmpty(parsedUrl.path)) $e0be213f695400f3$var$fatal("Database URL must point to the root of a Firebase Database (not including a child path).");
    const repo = $e0be213f695400f3$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, new $e0be213f695400f3$var$AppCheckTokenProvider(app.name, appCheckProvider));
    return new $e0be213f695400f3$export$6feb5ea51a7b0b47(repo, app);
}
/**
 * Remove the repo and make sure it is disconnected.
 *
 */ function $e0be213f695400f3$var$repoManagerDeleteRepo(repo, appName) {
    const appRepos = $e0be213f695400f3$var$repos[appName];
    // This should never happen...
    if (!appRepos || appRepos[repo.key] !== repo) $e0be213f695400f3$var$fatal(`Database ${appName}(${repo.repoInfo_}) has already been deleted.`);
    $e0be213f695400f3$var$repoInterrupt(repo);
    delete appRepos[repo.key];
}
/**
 * Ensures a repo doesn't already exist and then creates one using the
 * provided app.
 *
 * @param repoInfo - The metadata about the Repo
 * @returns The Repo object for the specified server / repoName.
 */ function $e0be213f695400f3$var$repoManagerCreateRepo(repoInfo, app, authTokenProvider, appCheckProvider) {
    let appRepos = $e0be213f695400f3$var$repos[app.name];
    if (!appRepos) {
        appRepos = {};
        $e0be213f695400f3$var$repos[app.name] = appRepos;
    }
    let repo = appRepos[repoInfo.toURLString()];
    if (repo) $e0be213f695400f3$var$fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
    repo = new $e0be213f695400f3$var$Repo(repoInfo, $e0be213f695400f3$var$useRestClient, authTokenProvider, appCheckProvider);
    appRepos[repoInfo.toURLString()] = repo;
    return repo;
}
/**
 * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
 */ function $e0be213f695400f3$var$repoManagerForceRestClient(forceRestClient) {
    $e0be213f695400f3$var$useRestClient = forceRestClient;
}
/**
 * Class representing a Firebase Realtime Database.
 */ class $e0be213f695400f3$export$6feb5ea51a7b0b47 {
    /** @hideconstructor */ constructor(_repoInternal, /** The {@link @firebase/app#FirebaseApp} associated with this Realtime Database instance. */ app){
        this._repoInternal = _repoInternal;
        this.app = app;
        /** Represents a `Database` instance. */ this['type'] = 'database';
        /** Track if the instance has been used (root or repo accessed) */ this._instanceStarted = false;
    }
    get _repo() {
        if (!this._instanceStarted) {
            $e0be213f695400f3$var$repoStart(this._repoInternal, this.app.options.appId, this.app.options['databaseAuthVariableOverride']);
            this._instanceStarted = true;
        }
        return this._repoInternal;
    }
    get _root() {
        if (!this._rootInternal) this._rootInternal = new $e0be213f695400f3$export$35c3a5e7c9d1033c(this._repo, $e0be213f695400f3$var$newEmptyPath());
        return this._rootInternal;
    }
    _delete() {
        if (this._rootInternal !== null) {
            $e0be213f695400f3$var$repoManagerDeleteRepo(this._repo, this.app.name);
            this._repoInternal = null;
            this._rootInternal = null;
        }
        return Promise.resolve();
    }
    _checkNotDeleted(apiName) {
        if (this._rootInternal === null) $e0be213f695400f3$var$fatal('Cannot call ' + apiName + ' on a deleted database.');
    }
}
function $e0be213f695400f3$var$checkTransportInit() {
    if ($e0be213f695400f3$var$TransportManager.IS_TRANSPORT_INITIALIZED) $e0be213f695400f3$var$warn('Transport has already been initialized. Please call this function before calling ref or setting up a listener');
}
/**
 * Force the use of websockets instead of longPolling.
 */ function $e0be213f695400f3$export$752b38c15a5377b6() {
    $e0be213f695400f3$var$checkTransportInit();
    $e0be213f695400f3$var$BrowserPollConnection.forceDisallow();
}
/**
 * Force the use of longPolling instead of websockets. This will be ignored if websocket protocol is used in databaseURL.
 */ function $e0be213f695400f3$export$387cff57f2608869() {
    $e0be213f695400f3$var$checkTransportInit();
    $e0be213f695400f3$var$WebSocketConnection.forceDisallow();
    $e0be213f695400f3$var$BrowserPollConnection.forceAllow();
}
/**
 * Returns the instance of the Realtime Database SDK that is associated with the provided
 * {@link @firebase/app#FirebaseApp}. Initializes a new instance with default settings if
 * no instance exists or if the existing instance uses a custom database URL.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} instance that the returned Realtime
 * Database instance is associated with.
 * @param url - The URL of the Realtime Database instance to connect to. If not
 * provided, the SDK connects to the default instance of the Firebase App.
 * @returns The `Database` instance of the provided app.
 */ function $e0be213f695400f3$export$d0dd861204d0bf72(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)(), url) {
    const db = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, 'database').getImmediate({
        identifier: url
    });
    if (!db._instanceStarted) {
        const emulator = (0, $474ae12482b554c6$export$a3febcf1f14a3a0c)('database');
        if (emulator) $e0be213f695400f3$export$87f3cfc4a2e3958d(db, ...emulator);
    }
    return db;
}
/**
 * Modify the provided instance to communicate with the Realtime Database
 * emulator.
 *
 * <p>Note: This method must be called before performing any other operation.
 *
 * @param db - The instance to modify.
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 8080)
 * @param options.mockUserToken - the mock auth token to use for unit testing Security Rules
 */ function $e0be213f695400f3$export$87f3cfc4a2e3958d(db, host, port, options = {}) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('useEmulator');
    if (db._instanceStarted) $e0be213f695400f3$var$fatal('Cannot call useEmulator() after instance has already been initialized.');
    const repo = db._repoInternal;
    let tokenProvider = undefined;
    if (repo.repoInfo_.nodeAdmin) {
        if (options.mockUserToken) $e0be213f695400f3$var$fatal('mockUserToken is not supported by the Admin SDK. For client access with mock users, please use the "firebase" package instead of "firebase-admin".');
        tokenProvider = new $e0be213f695400f3$var$EmulatorTokenProvider($e0be213f695400f3$var$EmulatorTokenProvider.OWNER);
    } else if (options.mockUserToken) {
        const token = typeof options.mockUserToken === 'string' ? options.mockUserToken : (0, $474ae12482b554c6$export$367bf224123348f1)(options.mockUserToken, db.app.options.projectId);
        tokenProvider = new $e0be213f695400f3$var$EmulatorTokenProvider(token);
    }
    // Modify the repo to apply emulator settings
    $e0be213f695400f3$var$repoManagerApplyEmulatorSettings(repo, host, port, tokenProvider);
}
/**
 * Disconnects from the server (all Database operations will be completed
 * offline).
 *
 * The client automatically maintains a persistent connection to the Database
 * server, which will remain active indefinitely and reconnect when
 * disconnected. However, the `goOffline()` and `goOnline()` methods may be used
 * to control the client connection in cases where a persistent connection is
 * undesirable.
 *
 * While offline, the client will no longer receive data updates from the
 * Database. However, all Database operations performed locally will continue to
 * immediately fire events, allowing your application to continue behaving
 * normally. Additionally, each operation performed locally will automatically
 * be queued and retried upon reconnection to the Database server.
 *
 * To reconnect to the Database and begin receiving remote events, see
 * `goOnline()`.
 *
 * @param db - The instance to disconnect.
 */ function $e0be213f695400f3$export$bee838355d017f0a(db) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOffline');
    $e0be213f695400f3$var$repoInterrupt(db._repo);
}
/**
 * Reconnects to the server and synchronizes the offline Database state
 * with the server state.
 *
 * This method should be used after disabling the active connection with
 * `goOffline()`. Once reconnected, the client will transmit the proper data
 * and fire the appropriate events so that your client "catches up"
 * automatically.
 *
 * @param db - The instance to reconnect.
 */ function $e0be213f695400f3$export$e0eecaabee32dd(db) {
    db = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(db);
    db._checkNotDeleted('goOnline');
    $e0be213f695400f3$var$repoResume(db._repo);
}
function $e0be213f695400f3$export$4e1d237eb9e560af(logger, persistent) {
    $e0be213f695400f3$var$enableLogging$1(logger, persistent);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $e0be213f695400f3$var$registerDatabase(variant) {
    $e0be213f695400f3$export$c9fb972242fcb3c4((0, $20ed53392b3edc61$export$31499a9cd224b78c));
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('database', (container, { instanceIdentifier: url })=>{
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider('auth-internal');
        const appCheckProvider = container.getProvider('app-check-internal');
        return $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url);
    }, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($e0be213f695400f3$var$name, $e0be213f695400f3$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($e0be213f695400f3$var$name, $e0be213f695400f3$var$version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0be213f695400f3$var$SERVER_TIMESTAMP = {
    '.sv': 'timestamp'
};
/**
 * Returns a placeholder value for auto-populating the current timestamp (time
 * since the Unix epoch, in milliseconds) as determined by the Firebase
 * servers.
 */ function $e0be213f695400f3$export$3ff8e7e00c3264b7() {
    return $e0be213f695400f3$var$SERVER_TIMESTAMP;
}
/**
 * Returns a placeholder value that can be used to atomically increment the
 * current database value by the provided delta.
 *
 * @param delta - the amount to modify the current value atomically.
 * @returns A placeholder value for modifying data atomically server-side.
 */ function $e0be213f695400f3$export$a2647aa13413c947(delta) {
    return {
        '.sv': {
            'increment': delta
        }
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A type for the resolve value of {@link runTransaction}.
 */ class $e0be213f695400f3$export$7a6f238067628c6b {
    /** @hideconstructor */ constructor(/** Whether the transaction was successfully committed. */ committed, /** The resulting data snapshot. */ snapshot){
        this.committed = committed;
        this.snapshot = snapshot;
    }
    /** Returns a JSON-serializable representation of this object. */ toJSON() {
        return {
            committed: this.committed,
            snapshot: this.snapshot.toJSON()
        };
    }
}
/**
 * Atomically modifies the data at this location.
 *
 * Atomically modify the data at this location. Unlike a normal `set()`, which
 * just overwrites the data regardless of its previous value, `runTransaction()` is
 * used to modify the existing value to a new value, ensuring there are no
 * conflicts with other clients writing to the same location at the same time.
 *
 * To accomplish this, you pass `runTransaction()` an update function which is
 * used to transform the current value into a new value. If another client
 * writes to the location before your new value is successfully written, your
 * update function will be called again with the new current value, and the
 * write will be retried. This will happen repeatedly until your write succeeds
 * without conflict or you abort the transaction by not returning a value from
 * your update function.
 *
 * Note: Modifying data with `set()` will cancel any pending transactions at
 * that location, so extreme care should be taken if mixing `set()` and
 * `runTransaction()` to update the same data.
 *
 * Note: When using transactions with Security and Firebase Rules in place, be
 * aware that a client needs `.read` access in addition to `.write` access in
 * order to perform a transaction. This is because the client-side nature of
 * transactions requires the client to read the data in order to transactionally
 * update it.
 *
 * @param ref - The location to atomically modify.
 * @param transactionUpdate - A developer-supplied function which will be passed
 * the current data stored at this location (as a JavaScript object). The
 * function should return the new value it would like written (as a JavaScript
 * object). If `undefined` is returned (i.e. you return with no arguments) the
 * transaction will be aborted and the data at this location will not be
 * modified.
 * @param options - An options object to configure transactions.
 * @returns A `Promise` that can optionally be used instead of the `onComplete`
 * callback to handle success and failure.
 */ function $e0be213f695400f3$export$3c54e006bf9c93b7(ref, // eslint-disable-next-line @typescript-eslint/no-explicit-any
transactionUpdate, options) {
    var _a;
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    $e0be213f695400f3$export$8d83036122ae444e('Reference.transaction', ref._path);
    if (ref.key === '.length' || ref.key === '.keys') throw 'Reference.transaction failed: ' + ref.key + ' is a read-only object.';
    const applyLocally = (_a = options === null || options === void 0 ? void 0 : options.applyLocally) !== null && _a !== void 0 ? _a : true;
    const deferred = new (0, $474ae12482b554c6$export$85f6557964517f1a)();
    const promiseComplete = (error, committed, node)=>{
        let dataSnapshot = null;
        if (error) deferred.reject(error);
        else {
            dataSnapshot = new $e0be213f695400f3$export$80b98bcbc246c942(node, new $e0be213f695400f3$export$35c3a5e7c9d1033c(ref._repo, ref._path), $e0be213f695400f3$var$PRIORITY_INDEX);
            deferred.resolve(new $e0be213f695400f3$export$7a6f238067628c6b(committed, dataSnapshot));
        }
    };
    // Add a watch to make sure we get server updates.
    const unwatcher = $e0be213f695400f3$export$ad30f661f41f4d90(ref, ()=>{});
    $e0be213f695400f3$var$repoStartTransaction(ref._repo, ref._path, transactionUpdate, promiseComplete, unwatcher, applyLocally);
    return deferred.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $e0be213f695400f3$var$PersistentConnection;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$e0be213f695400f3$var$PersistentConnection.prototype.simpleListen = function(pathString, onComplete) {
    this.sendRequest('q', {
        p: pathString
    }, onComplete);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$e0be213f695400f3$var$PersistentConnection.prototype.echo = function(data, onEcho) {
    this.sendRequest('echo', {
        d: data
    }, onEcho);
};
// RealTimeConnection properties that we use in tests.
$e0be213f695400f3$var$Connection;
/**
 * @internal
 */ const $e0be213f695400f3$export$3f9782a4529ff160 = function(newHash) {
    const oldPut = $e0be213f695400f3$var$PersistentConnection.prototype.put;
    $e0be213f695400f3$var$PersistentConnection.prototype.put = function(pathString, data, onComplete, hash) {
        if (hash !== undefined) hash = newHash();
        oldPut.call(this, pathString, data, onComplete, hash);
    };
    return function() {
        $e0be213f695400f3$var$PersistentConnection.prototype.put = oldPut;
    };
};
$e0be213f695400f3$var$RepoInfo;
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 * @internal
 */ const $e0be213f695400f3$export$868c9f20a76f0839 = function(forceRestClient) {
    $e0be213f695400f3$var$repoManagerForceRestClient(forceRestClient);
};
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Used by console to create a database based on the app,
 * passed database URL and a custom auth implementation.
 * @internal
 * @param app - A valid FirebaseApp-like object
 * @param url - A valid Firebase databaseURL
 * @param version - custom version e.g. firebase-admin version
 * @param customAppCheckImpl - custom app check implementation
 * @param customAuthImpl - custom auth implementation
 */ function $e0be213f695400f3$export$8efb8ed30f837963({ app: app, url: url, version: version, customAuthImpl: customAuthImpl, customAppCheckImpl: customAppCheckImpl, nodeAdmin: nodeAdmin = false }) {
    $e0be213f695400f3$export$c9fb972242fcb3c4(version);
    /**
     * ComponentContainer('database-standalone') is just a placeholder that doesn't perform
     * any actual function.
     */ const componentContainer = new (0, $51d4719ad519d4e6$export$436a80eea5d5c0c5)('database-standalone');
    const authProvider = new (0, $51d4719ad519d4e6$export$2881499e37b75b9a)('auth-internal', componentContainer);
    let appCheckProvider;
    if (customAppCheckImpl) {
        appCheckProvider = new (0, $51d4719ad519d4e6$export$2881499e37b75b9a)('app-check-internal', componentContainer);
        appCheckProvider.setComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('app-check-internal', ()=>customAppCheckImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    }
    authProvider.setComponent(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)('auth-internal', ()=>customAuthImpl, "PRIVATE" /* ComponentType.PRIVATE */ ));
    return $e0be213f695400f3$export$a248c1d2ea757674(app, authProvider, appCheckProvider, url, nodeAdmin);
}
/**
 * Firebase Realtime Database
 *
 * @packageDocumentation
 */ $e0be213f695400f3$var$registerDatabase();




//Get yearly value
//get Value
//default values
//Sources
// Break FieldsSchema into sub-structs based on categories
const $809f7f123ac5d4fa$export$90649b5dc12c94b1 = {
    net_revenue_per_year: {
        t: '$',
        yearly: true,
        field: 'revenue'
    },
    gross_profit_per_year: {
        t: '$',
        yearly: true,
        field: 'gross_profit'
    },
    fixed_asset_acquisitions_revenue_per_year: {
        t: '$',
        yearly: true,
        field: 'acquisition_rev'
    },
    recurring_revenue_percent_per_year: {
        t: '$',
        yearly: true,
        field: 'recurring_revenue_percent'
    },
    gross_retention_lost_only_per_year: {
        t: '$',
        yearly: true,
        field: 'gross_retention_lost_only'
    },
    net_retention_yearly: {
        t: '$',
        yearly: true,
        field: 'net_retention_percent'
    },
    ebitda_cashflow_yearly: {
        t: '$',
        yearly: true,
        field: 'ebitda_cashflow'
    }
};
const $809f7f123ac5d4fa$export$3b47d575189433bc = {
    ebitda_per_year: {
        t: '$',
        yearly: true,
        field: 'ebitda'
    },
    adjusted_ebitda_per_year: {
        t: '$',
        yearly: true,
        field: 'adjusted_ebitda'
    }
};
const $809f7f123ac5d4fa$export$239fac331b09df39 = {
    capitalized_software_override: {
        t: '$',
        yearly: true,
        field: 'capitalized_software_override'
    },
    capitalized_software: {
        display: 'Capitalized Software',
        t: '$',
        yearly: true,
        field: 'capitalized_software'
    },
    capitalized_application_development: {
        display: 'Capitalized Application Development',
        t: '$',
        yearly: true,
        field: 'capitalized_application_development'
    },
    capitalized_rnd: {
        display: 'Capitalized R&D',
        t: '$',
        yearly: true,
        field: 'capitalized_rnd'
    }
};
const $809f7f123ac5d4fa$export$1fdd607427d5a745 = {
    capex_per_year: {
        t: '$',
        yearly: true,
        field: 'capex'
    },
    maintenance_capex_per_year: {
        t: '$',
        yearly: true,
        field: 'maintenance_capex'
    },
    growth_capex_per_year: {
        t: '$',
        yearly: true,
        field: 'growth_capex'
    },
    total_current_assets_yearly: {
        t: '$',
        yearly: true,
        field: 'total_current_assets'
    },
    total_current_liabilities_yearly: {
        t: '$',
        yearly: true,
        field: 'total_current_liabilities'
    },
    historical_market_size: {
        t: '%',
        yearly: true,
        field: 'historic_market_size'
    },
    projected_market_size: {
        t: '%',
        yearly: true,
        field: 'projected_market_size'
    },
    list_years_actualized_revenue: {
        t: 'array'
    },
    list_years_projected_revenue: {
        t: 'array'
    },
    recurring_revenue_summary: {
        t: 'bool'
    },
    company_name: {
        t: 'str'
    },
    company_overview: {
        t: 'str'
    },
    company_main_market: {
        t: 'str'
    },
    company_ceo: {
        t: 'str'
    },
    hq_location: {
        t: 'str'
    },
    year_founded: {
        t: 'year'
    },
    industry: {
        t: 'str'
    },
    industrySubType: {
        t: 'str'
    },
    subscription_revenue: {
        t: 'bool'
    },
    recurring_revenue_stream: {
        t: 'bool'
    },
    contractual_revenue: {
        t: 'bool'
    },
    total_addressable_market: {
        t: '$'
    },
    market_share: {
        t: '%'
    },
    historical_market_growth: {
        t: '%'
    },
    projected_market_growth: {
        t: '%'
    },
    last_full_fiscal_year_reported: {
        t: 'int'
    }
};
const $809f7f123ac5d4fa$export$be4faee424ea3a71 = Object.assign(Object.assign(Object.assign(Object.assign({}, $809f7f123ac5d4fa$export$90649b5dc12c94b1), $809f7f123ac5d4fa$export$3b47d575189433bc), $809f7f123ac5d4fa$export$239fac331b09df39), $809f7f123ac5d4fa$export$1fdd607427d5a745);
const $809f7f123ac5d4fa$export$3266a7a951967395 = {
    extended_selected_ebitda: {
        t: 'str',
        display: 'EBITDA Used for Comparison'
    },
    organic_cagr_N_years: {
        t: '%',
        display: 'Year(s) Historical Organic Revenue CAGR',
        dynDisplayPrefix: '$DATA_PICK_KEY-'
    },
    organic_cagr_4_years: {
        t: '%',
        display: '4-Year Historical Organic Revenue CAGR'
    },
    organic_cagr_3_years: {
        t: '%',
        display: '3-Year Historical Organic Revenue CAGR'
    },
    projected_organic_cagr_N_years: {
        t: '%',
        display: 'Year(s) Projected Organic Revenue CAGR',
        dynDisplayPrefix: '$DATA_PICK_KEY-'
    },
    projected_organic_cagr_3_years: {
        t: '%',
        display: '3-Year Projected Organic Revenue CAGR'
    },
    projected_organic_cagr_4_years: {
        t: '%',
        display: '4-Year Projected Organic Revenue CAGR'
    },
    projected_organic_cagr_N_years_minus_tam_growth: {
        t: '%',
        display: 'Relative Growth Rate (Company Growth less Market Growth)'
    },
    adj_ebitda_margin: {
        t: '%',
        display: 'Adjusted EBITDA Margin',
        dynDisplay: '%SELECTED_EBITDA% Margin'
    },
    adj_ebitda_margin_trend: {
        t: '%',
        display: 'Adjusted Ebitda Margin versus Two Years Ago',
        dynDisplay: '%SELECTED_EBITDA% Margin versus Two Years Ago'
    },
    adj_ebitda: {
        t: '$',
        display: 'Adjusted Ebitda',
        dynDisplay: '%SELECTED_EBITDA%'
    },
    gross_retention: {
        t: '%',
        display: 'Gross Retention Rate'
    },
    net_retention: {
        t: '%',
        display: 'Net Retention Rate',
        scale: 100
    },
    ebitda_magnatitude_adjustment: {
        t: '%',
        display: '% of Adjusted EBITDA from Adjustments'
    },
    fcf_conversion_ebitda: {
        t: '%',
        display: ''
    },
    nwc_as_percent_of_revenue: {
        t: '%',
        display: 'New Working Capital, as a % of Revenue'
    },
    free_cash_flow_conversion: {
        t: '%',
        display: 'Free Cash Flow Conversion'
    },
    total_capex_by_rev: {
        t: '%',
        display: 'CapEx, as a % of Revenue'
    },
    total_addressable_market: {
        t: '$',
        display: 'Total Addressable Market Size'
    },
    historical_market_growth: {
        t: '%',
        display: 'Historical Market Growth Rate',
        scale: 100
    },
    projected_market_growth: {
        t: '%',
        display: 'Projected Market Growth Rate',
        scale: 100
    },
    recurring_revenue_summary: {
        t: 'bool',
        display: 'Contractual Revenue'
    },
    gross_profit_margin: {
        t: '%',
        display: 'Gross Profit Margin'
    },
    gross_profit: {
        t: '$',
        display: 'Gross Profit'
    },
    industry: {
        t: 'str',
        display: 'Industry'
    },
    industrySubType: {
        t: 'str',
        display: 'Sub-Industry'
    },
    company_ceo: {
        t: 'str',
        display: 'CEO'
    },
    hq_location: {
        t: 'str',
        display: 'HQ Location'
    },
    year_founded: {
        t: 'str',
        display: 'Founded'
    },
    last_full_fiscal_year_reported: {
        t: 'str',
        display: 'Actuals As Of'
    },
    revenue_latest: {
        t: '$',
        display: 'Revenue'
    }
};


const $7fbd760f3c05e83d$export$c47d79b712795940 = (s)=>{
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;
        return parseInt(s.toString().match(/(-)?\d+[\.,\d+]*/)[0].replace(',', ''));
    } catch (e) {
        return 0;
    }
};
const $7fbd760f3c05e83d$export$c0080068ec287465 = (s)=>{
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;
        return parseFloat(s.toString().match(/(-)?\d+[\.,\d+]*/)[0].replace(',', ''));
    } catch (e) {
        return 0;
    }
};
const $7fbd760f3c05e83d$export$4ba1d6600e2a2892 = (s)=>{
    try {
        if (!s) return false;
        if (s == 'N/A') return false;
        return !isNaN(parseFloat(s.match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};
const $7fbd760f3c05e83d$export$357fc28f6427af8b = (s)=>{
    try {
        if (!s) return false;
        if (s == 'N/A') return false;
        return !isNaN(parseInt(s.toString().match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};
function $7fbd760f3c05e83d$var$isString(s) {
    return typeof s === 'string' || s instanceof String;
}
const $7fbd760f3c05e83d$var$EMPTY_RETURN = '-';
const $7fbd760f3c05e83d$export$48d3f001ea9fddb0 = (s, sizeConversion = 'auto')=>{
    function formatNumberCommas(num) {
        return num.toFixed(1).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }
    if (!s || s == 'N/A' || s == 'NaN') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    if ($7fbd760f3c05e83d$var$isString(s)) {
        var str = s;
        if (str == '' || str == 'N/A' || str == 'NaN') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
        if ($7fbd760f3c05e83d$export$4ba1d6600e2a2892(str)) {
            var num = $7fbd760f3c05e83d$export$c0080068ec287465(str);
            var absNum = Math.abs(num);
            var letterToAdd = '';
            //Values expected in MILLIONS
            if (sizeConversion === 'auto') {
                if (absNum > 1000) {
                    letterToAdd = 'B';
                    num = num / 1000;
                } else if (absNum < 1) {
                    num = num * 1000;
                    letterToAdd = 'K';
                }
            }
            var numDisplay = formatNumberCommas(Math.abs(num)) + letterToAdd;
            if (num >= 0) return '$' + numDisplay;
            else return '-$' + numDisplay;
        } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
};
const $7fbd760f3c05e83d$export$e440a706af0c0216 = (s, multiplyBy = 100)=>{
    if (!s) return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    if ($7fbd760f3c05e83d$var$isString(s)) {
        var str = s;
        if (str == '' || str == 'N/A') return $7fbd760f3c05e83d$var$EMPTY_RETURN;
        if ($7fbd760f3c05e83d$export$4ba1d6600e2a2892(str)) {
            var num = $7fbd760f3c05e83d$export$c0080068ec287465(str);
            var r = (num * multiplyBy).toFixed(1) + '%';
            return r;
        } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
    } else return $7fbd760f3c05e83d$var$EMPTY_RETURN;
};


const $d8669940f261b2b4$export$c69afbbecb48616d = (input)=>{
    var ret = input.toString().match(/[0-9]+/g);
    if (ret == null) return [];
    return ret.map((x)=>parseInt(x));
};



var $gpaur = parcelRequire("gpaur");

var $fgQ0V = parcelRequire("fgQ0V");

class $2934a4a4389d65dc$export$d9b13a70c820f8b9 {
    constructor(reportOriginal, overrides, reportId){
        Object.defineProperty(this, "overrides", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: overrides
        });
        Object.defineProperty(this, "reportId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: reportId
        });
        Object.defineProperty(this, "report", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_scoreCache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.report = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(reportOriginal);
        if (!this.report) return null;
        var over_rides = overrides;
        for(var fieldName in over_rides){
            const value = over_rides[fieldName];
            //typeof a == 'object' && Array.isArray(a)\
            //Connect to field type in schmea to know sub field
            const fieldsSchema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
            if (typeof value == 'object') {
                if (!Array.isArray(value)) {
                    var set = value;
                    if (!Array.isArray(this.report[fieldName])) this.report[fieldName] = [];
                    const keys = Object.keys(set);
                    keys.forEach((year)=>{
                        const yearValue = set[year];
                        // if (fieldName.indexOf(".") > 0) {
                        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
                        //     const fieldsSchema = DATA_SECTIONS[section];
                        // }
                        if (!fieldsSchema.hasOwnProperty(fieldName)) {
                            console.log(`Field ${fieldName} not found in schema`);
                            return;
                        }
                        // assert(
                        //     fieldsSchema.hasOwnProperty(fieldName),
                        //     `Field ${fieldName} not found in schema`
                        // );
                        const subFieldName = fieldsSchema[fieldName].field;
                        const e = this.report[fieldName].find((arrYear)=>{
                            return parseInt(arrYear.year) == parseInt(year);
                        });
                        const entry = {
                            year: parseInt(year),
                            [subFieldName]: yearValue
                        };
                        if (!e) this.report[fieldName].push(entry);
                        else e[subFieldName] = yearValue;
                    });
                }
            } else {
                const fieldMeta = fieldsSchema[fieldName];
                if (fieldMeta && fieldMeta.t == 'array') {
                    var unpack = value.split(',');
                    var toInt = unpack.map((v)=>(0, $7fbd760f3c05e83d$export$c47d79b712795940)(v));
                    this.report[fieldName] = toInt;
                } else this.report[fieldName] = value;
            }
        }
    }
    isValueEditedByRowCol(row, col) {
        const schema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
        const edits = this.overrides;
        const fieldName = row.field.source;
        // if (fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0] as DataSectionKey;
        //     var subField = parts[1] as DataFieldsKey<DataSectionKey>;
        //     const sectionDefinition = DATA_SECTIONS[sectionName];
        //     const field = sectionDefinition[subField];
        //     const editKey = `${sectionName}.${subField}`;
        //     if (field.yearly) {
        //         if (!edits.hasOwnProperty(editKey)) {
        //             return false;
        //         }
        //         if (!edits[editKey].hasOwnProperty(col.column.source.toString())) {
        //             return false;
        //         }
        //         return true;
        //     } else {
        //         return edits && edits.hasOwnProperty(editKey);
        //     }
        // }
        const f = schema[row.field.source];
        if (f.yearly) {
            if (!edits.hasOwnProperty(row.field.source)) return false;
            if (!edits[row.field.source].hasOwnProperty(col.column.source.toString())) return false;
            return true;
        } else //value
        return edits && edits.hasOwnProperty(row.field.source);
    }
    isValueEditedAtAll(fieldName) {
        const edits = this.overrides;
        return edits && edits.hasOwnProperty(fieldName);
    }
    get activeReport() {
        return this.report;
    }
    get customers() {
        const v = this.value('top_customers');
        if (v == 'N/A') return null;
        return v;
    }
    get selectedEbitdaType() {
        var availEbitda = [];
        for (const ebitdaType of $2934a4a4389d65dc$export$d9b13a70c820f8b9.EBITDA_TYPES)if (this.report[ebitdaType]) availEbitda.push(ebitdaType);
        if (availEbitda.length == 0) return 'ebitda_per_year';
        const getTotal = (key)=>{
            return this.report[key].length;
        };
        const options = availEbitda.slice(0, 2);
        if (options.length > 1) {
            const totalBest = getTotal(options[0]);
            const totalSecond = getTotal(options[1]);
            if (totalBest >= totalSecond - 2) //Still pick #1 if its only 2 less than #2
            return options[0];
            else return options[1];
        } else return options[0];
    }
    value(fieldName) {
        let data = this.report;
        if (!data) return 'N/A';
        if (data.hasOwnProperty(fieldName)) {
            var field = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
            var val = data[fieldName];
            if (field && field.t == 'bool') {
                if (typeof val === 'string') return val === 'true' ? true : false;
            }
            return data[fieldName];
        }
        return 'N/A';
    }
    actualYear() {
        var _a, _b;
        const actualizedYears = (_a = this.report['list_years_actualized_revenue']) !== null && _a !== void 0 ? _a : [];
        if (actualizedYears.length == 0) ((_b = this.report['net_revenue_per_year']) !== null && _b !== void 0 ? _b : []).forEach((item)=>{
            actualizedYears.push(parseInt(item.year));
        });
        return Math.max(...actualizedYears);
    }
    valueByYearDivideByRevenue(fieldName, year, yearOffset = 0) {
        let data = this.report;
        if (!data) return 'N/A';
        try {
            const fieldValue = this.valueByYear(fieldName, year, yearOffset);
            const revenue = this.valueByYear('net_revenue_per_year', year, yearOffset);
            return fieldValue / revenue;
        } catch (_a) {
            return 'N/A';
        }
    }
    getIsYearActualized(year) {
        var _a;
        const actualizedYears = (_a = this.value('list_years_actualized_revenue')) !== null && _a !== void 0 ? _a : [];
        const minActualizedYear = Math.min(...actualizedYears);
        const isActualized = actualizedYears.includes(year) || year <= minActualizedYear;
        return isActualized;
    }
    getReportYearRange() {
        var minYear = -1;
        var maxYear = -1;
        const fields = [
            'net_revenue_per_year',
            'ebitda_per_year'
        ];
        var data = this.activeReport;
        fields.forEach((field)=>{
            const list = data[field];
            if (!list || Array.isArray(list) === false) return;
            const years = list.map((item)=>parseInt(item.year));
            const min = Math.min(...years);
            const max = Math.max(...years);
            if (minYear == -1 || min < minYear) minYear = min;
            if (maxYear == -1 || max > maxYear) maxYear = max;
        });
        return {
            from: minYear,
            to: maxYear
        };
    }
    valueByYear(fieldName, year, yearOffset = 0) {
        // if (fieldName.indexOf(".") > 0) {
        //     const { section, field } = this.getSectionFieldFromSource(fieldName);
        //     return this.valueBySection({ section, field, year: year + yearOffset });
        // }
        let data = this.report;
        if (!data) return 'N/A';
        const fieldInfo = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
        (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(fieldInfo, `Field ${fieldName} not found in schema`);
        (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(fieldInfo.hasOwnProperty('field'), `Field ${fieldName} does not have 'field' property`);
        const valueField = fieldInfo['field'];
        const yearSource = year + yearOffset;
        const dataRow = data[fieldName];
        if (!dataRow || !Array.isArray(dataRow)) return 'N/A';
        const r = dataRow.find((d)=>parseInt(d.year) === yearSource);
        if (r == undefined) return 'N/A';
        if (r.hasOwnProperty(valueField)) return r[valueField];
        else return 'N/A';
    }
    // BY SECTION CODE TO USE SOMETIME
    // getSectionFieldFromSource(fieldName: string) {
    //     const parts = fieldName.split('.');
    //     assert(parts.length == 2, `Invalid field name ${fieldName}`);
    //     const section = parts[0] as DataSectionKey;
    //     const field = parts[1] as DataFieldsKey<DataSectionKey>;
    //     return { section, field };
    // }
    // schemaBySection(request: SectionFieldRequest): FieldInfo {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     return sectionDefinition[request.field];
    // }
    // labelBySection(request: SectionFieldRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const field = sectionDefinition[request.field];
    //     return field.display;
    // }
    // sourcesBySection(request: SectionFieldRequest): number[] {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];
    //     if (!data) {
    //         return [];
    //     }
    //     const field = sectionDefinition[request.field];
    //     const sourcesField = request.field + '_sources';
    //     const sourcesValue = data[sourcesField];
    //     var sources = [];
    //     if (sourcesValue) {
    //         sources = get_numbers(sourcesValue.toString());
    //     }
    //     return sources;
    // }
    // valueBySection(request: SectionValueByYearRequest) {
    //     const sectionDefinition = DATA_SECTIONS[request.section];
    //     const data = this.report[request.section];
    //     const field = sectionDefinition[request.field];
    //     const ret = (val) => {
    //         return val;
    //     }
    //     const retNA = () => {
    //         return "N/A";
    //     }
    //     if (!data) {
    //         return retNA();
    //     }
    //     if (field.yearly && !request.year) {
    //         console.log(`Field ${request.field} is yearly, but year is not provided`);
    //         return retNA();
    //     }
    //     if (field.yearly) {
    //         const year = request.year;
    //         const fieldList = data[request.field];
    //         if (!fieldList) {
    //             return retNA();
    //         }
    //         const yearData = fieldList.find((d: any) => parseInt(d.year) === year);
    //         if (yearData) {
    //             const val = yearData[request.field]; //always same key
    //             if (val == undefined) {
    //                 return retNA();
    //             }
    //             return ret(val);
    //         }
    //     } else {
    //         const fieldValue = data[request.field];
    //         if (fieldValue == undefined) {
    //             return retNA();
    //         }
    //         return ret(fieldValue);
    //     }
    // }
    organicCagr(howManYears) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const before = q.valueByYear('net_revenue_per_year', lastYear, -howManYears);
            if (current == 'N/A' || before == 'N/A') return 'N/A';
            return Math.pow(current / before, 1 / howManYears) - 1;
        } catch (_a) {
            return 'N/A';
        }
    }
    ebitdaMargin(year) {
        const ebitda = this.valueByYear('ebitda_per_year', year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') return 'N/A';
        return ebitda / revenue;
    }
    selectedEbitda(year) {
        const selectedEbitdaType = this.selectedEbitdaType;
        return this.valueByYear(selectedEbitdaType, year);
    }
    selectedEbitdaMargin(year) {
        const ebidtaType = this.selectedEbitdaType;
        const ebitda = this.selectedEbitda(year);
        const revenue = this.valueByYear('net_revenue_per_year', year);
        if (ebitda === 'N/A' || revenue === 'N/A') return 'N/A';
        return ebitda / revenue;
    }
    //Merge the two
    projectedCagr(howManYears) {
        try {
            const q = this;
            const lastYear = q.actualYear();
            const current = q.valueByYear('net_revenue_per_year', lastYear);
            const projected = q.valueByYear('net_revenue_per_year', lastYear, howManYears);
            if (current == 'N/A' || projected == 'N/A') return 'N/A';
            return Math.pow(projected / current, 1 / howManYears) - 1;
        } catch (e) {
            return 'N/A';
        }
    }
    fcf_conversion_ebitda(year) {
        const ebitda = this.selectedEbitda(year);
        const capex = this.valueByYear('capex_per_year', year);
        if (ebitda === 'N/A' || capex === 'N/A') return 'N/A';
        return (ebitda - capex) / ebitda;
    }
    formatExtendedValueDisplay(input) {
        var _a;
        var display = input;
        const matches = display.match(/%[A-Z0-9_]+%/g) || [];
        const stripped = matches.map((m)=>m.slice(1, -1));
        for (const match of stripped)switch(match){
            case 'SELECTED_EBITDA':
                const selected = this.selectedEbitdaType;
                const schemaLookupName = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[selected]['display']) !== null && _a !== void 0 ? _a : 'Adjusted EBITDA';
                display = display.replace(`%${match}%`, schemaLookupName);
                break;
        }
        return display;
    }
    get_extended_value_float(fieldName) {
        var val = this.get_extended_value_float_internal(fieldName);
        if ((0, $fgQ0V.isString)(val)) val = val.replace('%', '');
        //Hack
        if (fieldName == 'recurring_revenue_summary' || fieldName == 'organic_cagr_N_years' || fieldName == 'projected_organic_cagr_N_years' || fieldName == 'extended_selected_ebitda') return val;
        if (val === 'N/A' || isNaN(val) || val === '' || val === 'NaN') return 'N/A';
        return (0, $7fbd760f3c05e83d$export$c0080068ec287465)(val);
    }
    get_extended_value_float_internal(fieldName) {
        var _a;
        switch(fieldName){
            case 'extended_selected_ebitda':
                const selected = this.selectedEbitdaType;
                const schemaLookupName = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[selected]['display']) !== null && _a !== void 0 ? _a : 'Adjusted EBITDA';
                return schemaLookupName;
            case 'organic_cagr_N_years':
                var ret = {};
                for(var years = 5; years >= 3; years--)ret[years] = this.organicCagr(years);
                return ret;
            case 'projected_organic_cagr_N_years':
                var ret = {};
                for(var years = 5; years >= 3; years--)ret[years] = this.projectedCagr(years);
                return ret;
            case 'organic_cagr_4_years':
                return this.organicCagr(4);
            case 'organic_cagr_3_years':
                return this.organicCagr(3);
            case 'projected_organic_cagr_3_years':
                return this.projectedCagr(3);
            case 'projected_organic_cagr_4_years':
                return this.projectedCagr(4);
            case 'projected_organic_cagr_N_years_minus_tam_growth':
                var projected = null;
                for(var years = 5; years >= 3; years--){
                    projected = this.projectedCagr(years);
                    if (projected !== 'N/A') break;
                }
                var market_growth = this.value('projected_market_growth');
                if (projected === 'N/A' || market_growth === 'N/A') return 'N/A';
                //Market growth is 1-100, not 0-1
                return projected - (0, $7fbd760f3c05e83d$export$c0080068ec287465)(market_growth) / 100.0;
            case 'adj_ebitda_margin':
                return this.selectedEbitdaMargin(this.actualYear());
            case 'adj_ebitda_margin_trend':
                const ebitdaNow = this.selectedEbitdaMargin(this.actualYear());
                const ebitda2YearsAgo = this.selectedEbitdaMargin(this.actualYear() - 2);
                if (ebitdaNow === 'N/A' || ebitda2YearsAgo === 'N/A') return 'N/A';
                return ebitdaNow - ebitda2YearsAgo;
            case 'adj_ebitda':
                return this.selectedEbitda(this.actualYear());
            case 'gross_retention':
                const gross = this.valueByYear('gross_retention_lost_only_per_year', this.actualYear());
                if (gross === 'N/A') return 'N/A';
                return gross / 100;
            case 'net_retention':
                return this.valueByYear('net_retention_yearly', this.actualYear());
            case 'revenue_latest':
                return this.valueByYear('net_revenue_per_year', this.actualYear());
            case 'ebitda_magnatitude_adjustment':
                const ebitda = this.valueByYear('ebitda_per_year', this.actualYear());
                const adj_ebitda = this.selectedEbitda(this.actualYear());
                return (adj_ebitda - ebitda) / adj_ebitda;
            case 'fcf_conversion_ebitda':
                return this.fcf_conversion_ebitda(this.actualYear());
            case 'nwc_as_percent_of_revenue':
                const currentAssets = this.valueByYear('total_current_assets_yearly', this.actualYear());
                const currentLiabilities = this.valueByYear('total_current_liabilities_yearly', this.actualYear());
                const revenue = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (currentAssets === 'N/A' || currentLiabilities === 'N/A' || revenue === 'N/A') return 'N/A';
                return (currentAssets - currentLiabilities) / revenue;
            case 'free_cash_flow_conversion':
                const ebitdaCashFlow = this.valueByYear('ebitda_per_year', this.actualYear());
                const maintenance_capex = this.valueByYear('maintenance_capex_per_year', this.actualYear());
                if (ebitdaCashFlow === 'N/A' || maintenance_capex === 'N/A') return 'N/A';
                return (ebitdaCashFlow - maintenance_capex) / ebitdaCashFlow;
            case 'total_capex_by_rev':
                const capex = this.valueByYear('capex_per_year', this.actualYear());
                const revenueCapex = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (capex === 'N/A' || revenueCapex === 'N/A') return 'N/A';
                return capex / revenueCapex;
            case 'gross_profit_margin':
                const grossProfit = this.valueByYear('gross_profit_per_year', this.actualYear());
                const revenueGross = this.valueByYear('net_revenue_per_year', this.actualYear());
                if (grossProfit === 'N/A' || revenueGross === 'N/A') return 'N/A';
                return grossProfit / revenueGross;
            case 'gross_profit':
                return this.valueByYear('gross_profit_per_year', this.actualYear());
            case 'total_addressable_market':
            case 'historical_market_growth':
            case 'projected_market_growth':
            case 'recurring_revenue_summary':
                return this.value(fieldName);
            default:
                return null;
        }
    }
    scoreBySection(sectionName) {
        const scoreUtil = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(this);
        if (scoreUtil.is_section_used_for_scoring_by_id(sectionName)) return scoreUtil.calcSectionPercentileById(sectionName);
        else return null;
    }
    score() {
        if (this._scoreCache != null) return this._scoreCache;
        const scoreUtil = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(this);
        const score = scoreUtil.calcScorePercentile();
        if (score == null) this._scoreCache = -1;
        else this._scoreCache = Math.round(score * 100);
        return this._scoreCache;
    }
    sourcesByField(fieldName, fieldDisplay) {
        // if (fieldName && fieldName.indexOf(".") > 0) {
        //     const parts = fieldName.split(".");
        //     var sectionName = parts[0];
        //     var fieldName = parts[1];
        //     return this.sourcesBySection({ section: sectionName as any, field: fieldName as any });
        // }
        let fields = [
            fieldName
        ];
        if (fieldDisplay == "\u2060Capitalized Development Costs") {
            if (this.value('capitalized_software_override_page_source') != 'N/A') fields = [
                'capitalized_software_override'
            ];
            else fields = [
                'capitalized_software',
                'capitalized_application_development',
                'capitalized_rnd'
            ];
        }
        const conv_source_to_num_array = (sourcesValue)=>{
            var pages = (0, $d8669940f261b2b4$export$c69afbbecb48616d)(sourcesValue.toString());
            return pages;
        };
        var sources = [];
        fields.forEach((fieldEntry)=>{
            let val = this.value(fieldEntry + '_page_source');
            sources = sources.concat(conv_source_to_num_array(val));
        });
        return sources;
    }
    anyValue(fieldName) {
        var _a;
        const field = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName];
        if ((_a = field['yearly']) !== null && _a !== void 0 ? _a : false) {
            const data = this.report[fieldName];
            if (!data) return false;
            return Object.keys(data).length > 0;
        } else return this.report.hasOwnProperty(fieldName);
    }
    sources(field, column) {
        let l = this.sourcesByField(field.source, field.display);
        l = l.sort((a, b)=>a - b);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).uniq(l);
    }
    get pdfViewUrl() {
        return this.value('pdfViewUrl');
    }
    get companyName() {
        return this.value('company_name');
    }
}
//Order of selected ebitda top is most 'adjusted'
Object.defineProperty($2934a4a4389d65dc$export$d9b13a70c820f8b9, "EBITDA_TYPES", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        'adjusted_ebitda_per_year',
        'ebitda_per_year'
    ]
});



var $fgQ0V = parcelRequire("fgQ0V");

var $T5IcR = parcelRequire("T5IcR");

var $fX8pL = parcelRequire("fX8pL");

var $8nGP5 = parcelRequire("8nGP5");


var $8df13b3de5b3c0c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $8df13b3de5b3c0c6$export$79c5294a8f16ac4d {
    constructor(reportId){
        Object.defineProperty(this, "reportId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: reportId
        });
        Object.defineProperty(this, "query", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    init(query) {
        return $8df13b3de5b3c0c6$var$__awaiter(this, void 0, void 0, function*() {
            this.query = query;
        });
    }
    sendMessage(question) {
        return $8df13b3de5b3c0c6$var$__awaiter(this, void 0, void 0, function*() {
            const query = this.query;
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            storeUI.chatWaitingForResponse = true;
            try {
                fb.chatbot_add_message(this.reportId, question, true);
                storeUI.chatWaitingForResponse = false;
            } catch (e) {
                storeUI.chatWaitingForResponse = false;
            }
        });
    }
}
Object.defineProperty($8df13b3de5b3c0c6$export$79c5294a8f16ac4d, "accessTokenAPI", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: null
}); //This can be static


var $8f024b03d9af7c67$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8f024b03d9af7c67$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8f024b03d9af7c67$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $8f024b03d9af7c67$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
function $8f024b03d9af7c67$var$isString(s) {
    return typeof s === 'string' || s instanceof String;
}
let $8f024b03d9af7c67$var$Store = (()=>{
    var _a, _Store_selectedReportId_accessor_storage, _Store_reportDataDB_accessor_storage, _Store_settings_accessor_storage, _Store_reportDataOverridesDB_accessor_storage, _Store_reportsDataAccessCache_accessor_storage, _Store_users_accessor_storage, _Store_userId_accessor_storage, _Store_jobs_accessor_storage, _Store_systemStatus_accessor_storage, _Store_activeJob_accessor_storage, _Store_areOveridesLoaded_accessor_storage, _Store_areScoreRulesLoaded_accessor_storage, _Store_allProjectFiles_accessor_storage, _Store_firmInfo_accessor_storage, _Store_isChatLoaded_accessor_storage, _Store_chatData_accessor_storage, _Store_ragDB_accessor_storage, _Store_isRagDbLoaded_accessor_storage, _Store_lastReportLoaded_accessor_storage;
    let _instanceExtraInitializers = [];
    let _selectedReportId_decorators;
    let _selectedReportId_initializers = [];
    let _selectedReportId_extraInitializers = [];
    let _reportDataDB_decorators;
    let _reportDataDB_initializers = [];
    let _reportDataDB_extraInitializers = [];
    let _settings_decorators;
    let _settings_initializers = [];
    let _settings_extraInitializers = [];
    let _get_scoringOverideRules_decorators;
    let _get_isAdmin_decorators;
    let _get_showExportButton_decorators;
    let _get_showRerunReport_decorators;
    let _get_showDeleteButton_decorators;
    let _reportDataOverridesDB_decorators;
    let _reportDataOverridesDB_initializers = [];
    let _reportDataOverridesDB_extraInitializers = [];
    let _reportsDataAccessCache_decorators;
    let _reportsDataAccessCache_initializers = [];
    let _reportsDataAccessCache_extraInitializers = [];
    let _users_decorators;
    let _users_initializers = [];
    let _users_extraInitializers = [];
    let _userId_decorators;
    let _userId_initializers = [];
    let _userId_extraInitializers = [];
    let _jobs_decorators;
    let _jobs_initializers = [];
    let _jobs_extraInitializers = [];
    let _systemStatus_decorators;
    let _systemStatus_initializers = [];
    let _systemStatus_extraInitializers = [];
    let _activeJob_decorators;
    let _activeJob_initializers = [];
    let _activeJob_extraInitializers = [];
    let _areOveridesLoaded_decorators;
    let _areOveridesLoaded_initializers = [];
    let _areOveridesLoaded_extraInitializers = [];
    let _areScoreRulesLoaded_decorators;
    let _areScoreRulesLoaded_initializers = [];
    let _areScoreRulesLoaded_extraInitializers = [];
    let _allProjectFiles_decorators;
    let _allProjectFiles_initializers = [];
    let _allProjectFiles_extraInitializers = [];
    let _firmInfo_decorators;
    let _firmInfo_initializers = [];
    let _firmInfo_extraInitializers = [];
    let _isChatLoaded_decorators;
    let _isChatLoaded_initializers = [];
    let _isChatLoaded_extraInitializers = [];
    let _chatData_decorators;
    let _chatData_initializers = [];
    let _chatData_extraInitializers = [];
    let _ragDB_decorators;
    let _ragDB_initializers = [];
    let _ragDB_extraInitializers = [];
    let _isRagDbLoaded_decorators;
    let _isRagDbLoaded_initializers = [];
    let _isRagDbLoaded_extraInitializers = [];
    let _lastReportLoaded_decorators;
    let _lastReportLoaded_initializers = [];
    let _lastReportLoaded_extraInitializers = [];
    let _get_activeReportOriginal_decorators;
    let _get_isLoaded_decorators;
    let _get_projectFiles_decorators;
    let _get_reportChatHistory_decorators;
    let _get_reportOverride_decorators;
    let _get_query_decorators;
    let _get_ragAPI_decorators;
    let _get_company_name_decorators;
    let _get_ticker_decorators;
    let _get_reportCreationDate_decorators;
    let _get_errorMessageTicker_decorators;
    let _get_reportFiscalYear_decorators;
    let _get_companyOverview_decorators;
    return _a = class Store {
        constructor(){
            _Store_selectedReportId_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _instanceExtraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _selectedReportId_initializers, '')));
            _Store_reportDataDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _selectedReportId_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportDataDB_initializers, null)));
            _Store_settings_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportDataDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _settings_initializers, {})));
            _Store_reportDataOverridesDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _settings_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportDataOverridesDB_initializers, {})));
            _Store_reportsDataAccessCache_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportDataOverridesDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _reportsDataAccessCache_initializers, {})));
            _Store_users_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _reportsDataAccessCache_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _users_initializers, {})));
            _Store_userId_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _users_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _userId_initializers, void 0)));
            _Store_jobs_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _userId_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _jobs_initializers, {})));
            _Store_systemStatus_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _jobs_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _systemStatus_initializers, {})));
            _Store_activeJob_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _systemStatus_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _activeJob_initializers, null)));
            _Store_areOveridesLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _activeJob_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areOveridesLoaded_initializers, false)));
            _Store_areScoreRulesLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areOveridesLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _areScoreRulesLoaded_initializers, false)));
            _Store_allProjectFiles_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _areScoreRulesLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _allProjectFiles_initializers, {})));
            _Store_firmInfo_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _allProjectFiles_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _firmInfo_initializers, {})));
            _Store_isChatLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _firmInfo_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isChatLoaded_initializers, false)));
            _Store_chatData_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isChatLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _chatData_initializers, {})));
            _Store_ragDB_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _chatData_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _ragDB_initializers, {})));
            _Store_isRagDbLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _ragDB_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isRagDbLoaded_initializers, false)));
            _Store_lastReportLoaded_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isRagDbLoaded_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _lastReportLoaded_initializers, '')));
            $8f024b03d9af7c67$var$__runInitializers(this, _lastReportLoaded_extraInitializers);
        }
        get selectedReportId() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_selectedReportId_accessor_storage, "f");
        }
        set selectedReportId(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_selectedReportId_accessor_storage, value, "f");
        }
        get reportDataDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportDataDB_accessor_storage, "f");
        }
        set reportDataDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportDataDB_accessor_storage, value, "f");
        }
        get settings() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_settings_accessor_storage, "f");
        }
        set settings(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_settings_accessor_storage, value, "f");
        }
        get scoringOverideRules() {
            var _b;
            if (!this.settings) return {};
            return (_b = this.settings.scoringOverideRules) !== null && _b !== void 0 ? _b : {};
        }
        get isAdmin() {
            var _b, _c;
            if (!this.users) return false;
            return (_c = (_b = this.users[this.userId]) === null || _b === void 0 ? void 0 : _b.isAdmin) !== null && _c !== void 0 ? _c : false;
        }
        get showExportButton() {
            if (!this.isAdmin) return false;
            return true;
        }
        get showRerunReport() {
            if (!this.isAdmin) return false;
            return true;
        }
        get showDeleteButton() {
            if (!this.isAdmin) return false;
            return true;
        }
        get reportDataOverridesDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportDataOverridesDB_accessor_storage, "f");
        }
        set reportDataOverridesDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportDataOverridesDB_accessor_storage, value, "f");
        }
        get reportsDataAccessCache() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_reportsDataAccessCache_accessor_storage, "f");
        }
        set reportsDataAccessCache(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_reportsDataAccessCache_accessor_storage, value, "f");
        }
        get users() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_users_accessor_storage, "f");
        }
        set users(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_users_accessor_storage, value, "f");
        }
        get userId() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_userId_accessor_storage, "f");
        }
        set userId(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_userId_accessor_storage, value, "f");
        }
        get jobs() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_jobs_accessor_storage, "f");
        }
        set jobs(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_jobs_accessor_storage, value, "f");
        }
        get systemStatus() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_systemStatus_accessor_storage, "f");
        }
        set systemStatus(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_systemStatus_accessor_storage, value, "f");
        }
        get activeJob() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_activeJob_accessor_storage, "f");
        }
        set activeJob(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_activeJob_accessor_storage, value, "f");
        }
        get areOveridesLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areOveridesLoaded_accessor_storage, "f");
        }
        set areOveridesLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areOveridesLoaded_accessor_storage, value, "f");
        }
        get areScoreRulesLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_areScoreRulesLoaded_accessor_storage, "f");
        }
        set areScoreRulesLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_areScoreRulesLoaded_accessor_storage, value, "f");
        }
        get allProjectFiles() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_allProjectFiles_accessor_storage, "f");
        }
        set allProjectFiles(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_allProjectFiles_accessor_storage, value, "f");
        }
        get firmInfo() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_firmInfo_accessor_storage, "f");
        }
        set firmInfo(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_firmInfo_accessor_storage, value, "f");
        }
        get isChatLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_isChatLoaded_accessor_storage, "f");
        }
        set isChatLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_isChatLoaded_accessor_storage, value, "f");
        }
        get chatData() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_chatData_accessor_storage, "f");
        }
        set chatData(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_chatData_accessor_storage, value, "f");
        }
        get ragDB() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_ragDB_accessor_storage, "f");
        }
        set ragDB(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_ragDB_accessor_storage, value, "f");
        }
        get isRagDbLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_isRagDbLoaded_accessor_storage, "f");
        }
        set isRagDbLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_isRagDbLoaded_accessor_storage, value, "f");
        }
        get lastReportLoaded() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _Store_lastReportLoaded_accessor_storage, "f");
        }
        set lastReportLoaded(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _Store_lastReportLoaded_accessor_storage, value, "f");
        }
        get activeReportOriginal() {
            const ticker = this.selectedReportId;
            if (!this.reportDataDB) return null;
            if (this.reportDataDB.hasOwnProperty(ticker)) {
                if (this.reportDataDB[ticker].status == 'processing') return null;
                return (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).cloneDeep(this.reportDataDB[ticker]);
            }
            return null;
        }
        get isLoaded() {
            return this.reportDataDB != null && this.areOveridesLoaded && this.areScoreRulesLoaded;
        }
        get projectFiles() {
            var _b;
            return (_b = this.allProjectFiles[this.selectedReportId]) !== null && _b !== void 0 ? _b : {
                files: {}
            };
        }
        get reportChatHistory() {
            var _b;
            return (_b = this.chatData[this.selectedReportId]) !== null && _b !== void 0 ? _b : [
                {
                    isMe: false,
                    message: 'Hello! How can I help you today?',
                    date: new Date(),
                    processed: true
                }
            ];
        }
        get reportOverride() {
            const ticker = this.selectedReportId;
            var over_rides = {};
            if (this.reportDataOverridesDB && this.reportDataOverridesDB.hasOwnProperty(ticker)) over_rides = this.reportDataOverridesDB[ticker];
            return over_rides;
        }
        get query() {
            if (!this.activeReportOriginal) return null;
            if (!this.areOveridesLoaded || !this.isRagDbLoaded || !this.isChatLoaded) return null;
            return new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(this.activeReportOriginal, this.reportOverride, this.selectedReportId);
        }
        get ragAPI() {
            if (!this.activeReportOriginal) return null;
            return new (0, $8df13b3de5b3c0c6$export$79c5294a8f16ac4d)(this.selectedReportId);
        }
        resetDataAccessCache() {
            this.reportsDataAccessCache = {};
        }
        createDataAccess(reportId) {
            if (this.reportsDataAccessCache[reportId]) return this.reportsDataAccessCache[reportId];
            //console.log('Creating data access for: ', reportId);
            const deal = this.reportDataDB[reportId]; //Fix over rides ?
            if (!deal || deal['status'] != 'completed') {
                console.log('No data found for: ', reportId);
                return null;
            }
            const override = this.reportDataOverridesDB[reportId];
            this.reportsDataAccessCache[reportId] = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(deal, override, reportId);
            return this.reportsDataAccessCache[reportId];
        }
        get company_name() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('company_name');
        }
        get ticker() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('ticker');
        }
        get reportCreationDate() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('created'))) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fX8pL))).unix((_c = this.query) === null || _c === void 0 ? void 0 : _c.value('created')).format('YYYY-MM-D');
        }
        get errorMessageTicker() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('error'))) return null;
            return (_c = this.query) === null || _c === void 0 ? void 0 : _c.value('error');
        }
        get reportFiscalYear() {
            var _b, _c;
            if (!((_b = this.query) === null || _b === void 0 ? void 0 : _b.value('report_fiscal_year'))) return null;
            return (_c = this.query) === null || _c === void 0 ? void 0 : _c.value('report_fiscal_year');
        }
        get companyOverview() {
            var _b;
            return (_b = this.query) === null || _b === void 0 ? void 0 : _b.value('company_overview');
        }
    }, _Store_selectedReportId_accessor_storage = new WeakMap(), _Store_reportDataDB_accessor_storage = new WeakMap(), _Store_settings_accessor_storage = new WeakMap(), _Store_reportDataOverridesDB_accessor_storage = new WeakMap(), _Store_reportsDataAccessCache_accessor_storage = new WeakMap(), _Store_users_accessor_storage = new WeakMap(), _Store_userId_accessor_storage = new WeakMap(), _Store_jobs_accessor_storage = new WeakMap(), _Store_systemStatus_accessor_storage = new WeakMap(), _Store_activeJob_accessor_storage = new WeakMap(), _Store_areOveridesLoaded_accessor_storage = new WeakMap(), _Store_areScoreRulesLoaded_accessor_storage = new WeakMap(), _Store_allProjectFiles_accessor_storage = new WeakMap(), _Store_firmInfo_accessor_storage = new WeakMap(), _Store_isChatLoaded_accessor_storage = new WeakMap(), _Store_chatData_accessor_storage = new WeakMap(), _Store_ragDB_accessor_storage = new WeakMap(), _Store_isRagDbLoaded_accessor_storage = new WeakMap(), _Store_lastReportLoaded_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _selectedReportId_decorators = [
            (0, $T5IcR.observable)
        ];
        _reportDataDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _settings_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_scoringOverideRules_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_isAdmin_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showExportButton_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showRerunReport_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_showDeleteButton_decorators = [
            (0, $T5IcR.computed)
        ];
        _reportDataOverridesDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _reportsDataAccessCache_decorators = [
            (0, $T5IcR.observable)
        ];
        _users_decorators = [
            (0, $T5IcR.observable)
        ];
        _userId_decorators = [
            (0, $T5IcR.observable)
        ];
        _jobs_decorators = [
            (0, $T5IcR.observable)
        ];
        _systemStatus_decorators = [
            (0, $T5IcR.observable)
        ];
        _activeJob_decorators = [
            (0, $T5IcR.observable)
        ];
        _areOveridesLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _areScoreRulesLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _allProjectFiles_decorators = [
            (0, $T5IcR.observable)
        ];
        _firmInfo_decorators = [
            (0, $T5IcR.observable)
        ];
        _isChatLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _chatData_decorators = [
            (0, $T5IcR.observable)
        ];
        _ragDB_decorators = [
            (0, $T5IcR.observable)
        ];
        _isRagDbLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _lastReportLoaded_decorators = [
            (0, $T5IcR.observable)
        ];
        _get_activeReportOriginal_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_isLoaded_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_projectFiles_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportChatHistory_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportOverride_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_query_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_ragAPI_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_company_name_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_ticker_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportCreationDate_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_errorMessageTicker_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_reportFiscalYear_decorators = [
            (0, $T5IcR.computed)
        ];
        _get_companyOverview_decorators = [
            (0, $T5IcR.computed)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _selectedReportId_decorators, {
            kind: "accessor",
            name: "selectedReportId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"selectedReportId" in obj,
                get: (obj)=>obj.selectedReportId,
                set: (obj, value)=>{
                    obj.selectedReportId = value;
                }
            },
            metadata: _metadata
        }, _selectedReportId_initializers, _selectedReportId_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportDataDB_decorators, {
            kind: "accessor",
            name: "reportDataDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportDataDB" in obj,
                get: (obj)=>obj.reportDataDB,
                set: (obj, value)=>{
                    obj.reportDataDB = value;
                }
            },
            metadata: _metadata
        }, _reportDataDB_initializers, _reportDataDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _settings_decorators, {
            kind: "accessor",
            name: "settings",
            static: false,
            private: false,
            access: {
                has: (obj)=>"settings" in obj,
                get: (obj)=>obj.settings,
                set: (obj, value)=>{
                    obj.settings = value;
                }
            },
            metadata: _metadata
        }, _settings_initializers, _settings_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_scoringOverideRules_decorators, {
            kind: "getter",
            name: "scoringOverideRules",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scoringOverideRules" in obj,
                get: (obj)=>obj.scoringOverideRules
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isAdmin_decorators, {
            kind: "getter",
            name: "isAdmin",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isAdmin" in obj,
                get: (obj)=>obj.isAdmin
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showExportButton_decorators, {
            kind: "getter",
            name: "showExportButton",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showExportButton" in obj,
                get: (obj)=>obj.showExportButton
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showRerunReport_decorators, {
            kind: "getter",
            name: "showRerunReport",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showRerunReport" in obj,
                get: (obj)=>obj.showRerunReport
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_showDeleteButton_decorators, {
            kind: "getter",
            name: "showDeleteButton",
            static: false,
            private: false,
            access: {
                has: (obj)=>"showDeleteButton" in obj,
                get: (obj)=>obj.showDeleteButton
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportDataOverridesDB_decorators, {
            kind: "accessor",
            name: "reportDataOverridesDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportDataOverridesDB" in obj,
                get: (obj)=>obj.reportDataOverridesDB,
                set: (obj, value)=>{
                    obj.reportDataOverridesDB = value;
                }
            },
            metadata: _metadata
        }, _reportDataOverridesDB_initializers, _reportDataOverridesDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _reportsDataAccessCache_decorators, {
            kind: "accessor",
            name: "reportsDataAccessCache",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportsDataAccessCache" in obj,
                get: (obj)=>obj.reportsDataAccessCache,
                set: (obj, value)=>{
                    obj.reportsDataAccessCache = value;
                }
            },
            metadata: _metadata
        }, _reportsDataAccessCache_initializers, _reportsDataAccessCache_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _users_decorators, {
            kind: "accessor",
            name: "users",
            static: false,
            private: false,
            access: {
                has: (obj)=>"users" in obj,
                get: (obj)=>obj.users,
                set: (obj, value)=>{
                    obj.users = value;
                }
            },
            metadata: _metadata
        }, _users_initializers, _users_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _userId_decorators, {
            kind: "accessor",
            name: "userId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"userId" in obj,
                get: (obj)=>obj.userId,
                set: (obj, value)=>{
                    obj.userId = value;
                }
            },
            metadata: _metadata
        }, _userId_initializers, _userId_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _jobs_decorators, {
            kind: "accessor",
            name: "jobs",
            static: false,
            private: false,
            access: {
                has: (obj)=>"jobs" in obj,
                get: (obj)=>obj.jobs,
                set: (obj, value)=>{
                    obj.jobs = value;
                }
            },
            metadata: _metadata
        }, _jobs_initializers, _jobs_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _systemStatus_decorators, {
            kind: "accessor",
            name: "systemStatus",
            static: false,
            private: false,
            access: {
                has: (obj)=>"systemStatus" in obj,
                get: (obj)=>obj.systemStatus,
                set: (obj, value)=>{
                    obj.systemStatus = value;
                }
            },
            metadata: _metadata
        }, _systemStatus_initializers, _systemStatus_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _activeJob_decorators, {
            kind: "accessor",
            name: "activeJob",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activeJob" in obj,
                get: (obj)=>obj.activeJob,
                set: (obj, value)=>{
                    obj.activeJob = value;
                }
            },
            metadata: _metadata
        }, _activeJob_initializers, _activeJob_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areOveridesLoaded_decorators, {
            kind: "accessor",
            name: "areOveridesLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areOveridesLoaded" in obj,
                get: (obj)=>obj.areOveridesLoaded,
                set: (obj, value)=>{
                    obj.areOveridesLoaded = value;
                }
            },
            metadata: _metadata
        }, _areOveridesLoaded_initializers, _areOveridesLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _areScoreRulesLoaded_decorators, {
            kind: "accessor",
            name: "areScoreRulesLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"areScoreRulesLoaded" in obj,
                get: (obj)=>obj.areScoreRulesLoaded,
                set: (obj, value)=>{
                    obj.areScoreRulesLoaded = value;
                }
            },
            metadata: _metadata
        }, _areScoreRulesLoaded_initializers, _areScoreRulesLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _allProjectFiles_decorators, {
            kind: "accessor",
            name: "allProjectFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allProjectFiles" in obj,
                get: (obj)=>obj.allProjectFiles,
                set: (obj, value)=>{
                    obj.allProjectFiles = value;
                }
            },
            metadata: _metadata
        }, _allProjectFiles_initializers, _allProjectFiles_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _firmInfo_decorators, {
            kind: "accessor",
            name: "firmInfo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"firmInfo" in obj,
                get: (obj)=>obj.firmInfo,
                set: (obj, value)=>{
                    obj.firmInfo = value;
                }
            },
            metadata: _metadata
        }, _firmInfo_initializers, _firmInfo_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isChatLoaded_decorators, {
            kind: "accessor",
            name: "isChatLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isChatLoaded" in obj,
                get: (obj)=>obj.isChatLoaded,
                set: (obj, value)=>{
                    obj.isChatLoaded = value;
                }
            },
            metadata: _metadata
        }, _isChatLoaded_initializers, _isChatLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _chatData_decorators, {
            kind: "accessor",
            name: "chatData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"chatData" in obj,
                get: (obj)=>obj.chatData,
                set: (obj, value)=>{
                    obj.chatData = value;
                }
            },
            metadata: _metadata
        }, _chatData_initializers, _chatData_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _ragDB_decorators, {
            kind: "accessor",
            name: "ragDB",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ragDB" in obj,
                get: (obj)=>obj.ragDB,
                set: (obj, value)=>{
                    obj.ragDB = value;
                }
            },
            metadata: _metadata
        }, _ragDB_initializers, _ragDB_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isRagDbLoaded_decorators, {
            kind: "accessor",
            name: "isRagDbLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isRagDbLoaded" in obj,
                get: (obj)=>obj.isRagDbLoaded,
                set: (obj, value)=>{
                    obj.isRagDbLoaded = value;
                }
            },
            metadata: _metadata
        }, _isRagDbLoaded_initializers, _isRagDbLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _lastReportLoaded_decorators, {
            kind: "accessor",
            name: "lastReportLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"lastReportLoaded" in obj,
                get: (obj)=>obj.lastReportLoaded,
                set: (obj, value)=>{
                    obj.lastReportLoaded = value;
                }
            },
            metadata: _metadata
        }, _lastReportLoaded_initializers, _lastReportLoaded_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_activeReportOriginal_decorators, {
            kind: "getter",
            name: "activeReportOriginal",
            static: false,
            private: false,
            access: {
                has: (obj)=>"activeReportOriginal" in obj,
                get: (obj)=>obj.activeReportOriginal
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_isLoaded_decorators, {
            kind: "getter",
            name: "isLoaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isLoaded" in obj,
                get: (obj)=>obj.isLoaded
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_projectFiles_decorators, {
            kind: "getter",
            name: "projectFiles",
            static: false,
            private: false,
            access: {
                has: (obj)=>"projectFiles" in obj,
                get: (obj)=>obj.projectFiles
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportChatHistory_decorators, {
            kind: "getter",
            name: "reportChatHistory",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportChatHistory" in obj,
                get: (obj)=>obj.reportChatHistory
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportOverride_decorators, {
            kind: "getter",
            name: "reportOverride",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportOverride" in obj,
                get: (obj)=>obj.reportOverride
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_query_decorators, {
            kind: "getter",
            name: "query",
            static: false,
            private: false,
            access: {
                has: (obj)=>"query" in obj,
                get: (obj)=>obj.query
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_ragAPI_decorators, {
            kind: "getter",
            name: "ragAPI",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ragAPI" in obj,
                get: (obj)=>obj.ragAPI
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_company_name_decorators, {
            kind: "getter",
            name: "company_name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"company_name" in obj,
                get: (obj)=>obj.company_name
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_ticker_decorators, {
            kind: "getter",
            name: "ticker",
            static: false,
            private: false,
            access: {
                has: (obj)=>"ticker" in obj,
                get: (obj)=>obj.ticker
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportCreationDate_decorators, {
            kind: "getter",
            name: "reportCreationDate",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportCreationDate" in obj,
                get: (obj)=>obj.reportCreationDate
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_errorMessageTicker_decorators, {
            kind: "getter",
            name: "errorMessageTicker",
            static: false,
            private: false,
            access: {
                has: (obj)=>"errorMessageTicker" in obj,
                get: (obj)=>obj.errorMessageTicker
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_reportFiscalYear_decorators, {
            kind: "getter",
            name: "reportFiscalYear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reportFiscalYear" in obj,
                get: (obj)=>obj.reportFiscalYear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _get_companyOverview_decorators, {
            kind: "getter",
            name: "companyOverview",
            static: false,
            private: false,
            access: {
                has: (obj)=>"companyOverview" in obj,
                get: (obj)=>obj.companyOverview
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8f024b03d9af7c67$export$74848b9d4d66d1d3;
(function(UIDealDetailsTabs) {
    UIDealDetailsTabs["DASHBOARD"] = "DASHBOARD";
    UIDealDetailsTabs["DETAILS"] = "DETAILS";
    UIDealDetailsTabs["COMPARE"] = "COMPARE";
    UIDealDetailsTabs["SCORE_BREAKDOWN"] = "SUMMARY";
    UIDealDetailsTabs["CHAT"] = "CHAT";
})($8f024b03d9af7c67$export$74848b9d4d66d1d3 || ($8f024b03d9af7c67$export$74848b9d4d66d1d3 = {}));
let $8f024b03d9af7c67$export$5a825fdb72e99846 = (()=>{
    var _a, _StoreUI_detailsViewYearsToShow_accessor_storage, _StoreUI_pdfRequest_accessor_storage, _StoreUI_disableLoading_accessor_storage, _StoreUI_scrolling_accessor_storage, _StoreUI_currentSplitRatioDetailView_accessor_storage, _StoreUI_modal_accessor_storage, _StoreUI_dealPageNameSearch_accessor_storage, _StoreUI_dealPageIndustrySearch_accessor_storage, _StoreUI_dealPageScoreSearch_accessor_storage, _StoreUI_pageTitle_accessor_storage, _StoreUI_dealViewTab_accessor_storage, _StoreUI_chatWaitingForResponse_accessor_storage, _StoreUI_isKeyControlKeyDown_accessor_storage, _StoreUI_isKeyTabDown_accessor_storage, _StoreUI_isKeyShiftKeyDown_accessor_storage, _StoreUI_isKeyEscapeDown_accessor_storage;
    let _detailsViewYearsToShow_decorators;
    let _detailsViewYearsToShow_initializers = [];
    let _detailsViewYearsToShow_extraInitializers = [];
    let _pdfRequest_decorators;
    let _pdfRequest_initializers = [];
    let _pdfRequest_extraInitializers = [];
    let _disableLoading_decorators;
    let _disableLoading_initializers = [];
    let _disableLoading_extraInitializers = [];
    let _scrolling_decorators;
    let _scrolling_initializers = [];
    let _scrolling_extraInitializers = [];
    let _currentSplitRatioDetailView_decorators;
    let _currentSplitRatioDetailView_initializers = [];
    let _currentSplitRatioDetailView_extraInitializers = [];
    let _modal_decorators;
    let _modal_initializers = [];
    let _modal_extraInitializers = [];
    let _dealPageNameSearch_decorators;
    let _dealPageNameSearch_initializers = [];
    let _dealPageNameSearch_extraInitializers = [];
    let _dealPageIndustrySearch_decorators;
    let _dealPageIndustrySearch_initializers = [];
    let _dealPageIndustrySearch_extraInitializers = [];
    let _dealPageScoreSearch_decorators;
    let _dealPageScoreSearch_initializers = [];
    let _dealPageScoreSearch_extraInitializers = [];
    let _pageTitle_decorators;
    let _pageTitle_initializers = [];
    let _pageTitle_extraInitializers = [];
    let _dealViewTab_decorators;
    let _dealViewTab_initializers = [];
    let _dealViewTab_extraInitializers = [];
    let _chatWaitingForResponse_decorators;
    let _chatWaitingForResponse_initializers = [];
    let _chatWaitingForResponse_extraInitializers = [];
    let _isKeyControlKeyDown_decorators;
    let _isKeyControlKeyDown_initializers = [];
    let _isKeyControlKeyDown_extraInitializers = [];
    let _isKeyTabDown_decorators;
    let _isKeyTabDown_initializers = [];
    let _isKeyTabDown_extraInitializers = [];
    let _isKeyShiftKeyDown_decorators;
    let _isKeyShiftKeyDown_initializers = [];
    let _isKeyShiftKeyDown_extraInitializers = [];
    let _isKeyEscapeDown_decorators;
    let _isKeyEscapeDown_initializers = [];
    let _isKeyEscapeDown_extraInitializers = [];
    return _a = class StoreUI {
        get isDev() {
            return false;
        }
        resetViewerRequests() {
            this.pdfRequest = {
                page: -1,
                highlightTexts: []
            };
        }
        resetDealView() {
            this.dealViewTab = $8f024b03d9af7c67$export$74848b9d4d66d1d3.DASHBOARD;
            if (this.isDev) this.dealViewTab = $8f024b03d9af7c67$export$74848b9d4d66d1d3.DETAILS;
            this.resetViewerRequests();
        }
        resetHome() {
            this.dealPageNameSearch = '';
            this.dealPageIndustrySearch = [];
            this.dealPageScoreSearch = [];
        }
        onKeyUpReset() {
            this.isKeyControlKeyDown = false;
            this.scrolling = 'NONE';
            this.isKeyTabDown = false;
            this.isKeyShiftKeyDown = false;
            this.isKeyEscapeDown = false;
        }
        requestPdfImagePage(page) {
            this.resetViewerRequests();
            setTimeout(()=>{
                this.pdfRequest = {
                    page: page,
                    highlightTexts: []
                };
            }, 10);
        }
        constructor(){
            _StoreUI_detailsViewYearsToShow_accessor_storage.set(this, $8f024b03d9af7c67$var$__runInitializers(this, _detailsViewYearsToShow_initializers, 6));
            _StoreUI_pdfRequest_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _detailsViewYearsToShow_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _pdfRequest_initializers, void 0)));
            _StoreUI_disableLoading_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _pdfRequest_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _disableLoading_initializers, false)));
            _StoreUI_scrolling_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _disableLoading_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _scrolling_initializers, 'NONE')));
            _StoreUI_currentSplitRatioDetailView_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _scrolling_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _currentSplitRatioDetailView_initializers, 50)));
            _StoreUI_modal_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _currentSplitRatioDetailView_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _modal_initializers, null)));
            _StoreUI_dealPageNameSearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _modal_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageNameSearch_initializers, '')));
            _StoreUI_dealPageIndustrySearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageNameSearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageIndustrySearch_initializers, [])));
            _StoreUI_dealPageScoreSearch_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageIndustrySearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealPageScoreSearch_initializers, [])));
            _StoreUI_pageTitle_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealPageScoreSearch_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _pageTitle_initializers, '')));
            _StoreUI_dealViewTab_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _pageTitle_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _dealViewTab_initializers, void 0)));
            _StoreUI_chatWaitingForResponse_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _dealViewTab_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _chatWaitingForResponse_initializers, false)));
            _StoreUI_isKeyControlKeyDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _chatWaitingForResponse_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyControlKeyDown_initializers, false)));
            _StoreUI_isKeyTabDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyControlKeyDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyTabDown_initializers, false)));
            _StoreUI_isKeyShiftKeyDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyTabDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyShiftKeyDown_initializers, false)));
            _StoreUI_isKeyEscapeDown_accessor_storage.set(this, ($8f024b03d9af7c67$var$__runInitializers(this, _isKeyShiftKeyDown_extraInitializers), $8f024b03d9af7c67$var$__runInitializers(this, _isKeyEscapeDown_initializers, false)));
            $8f024b03d9af7c67$var$__runInitializers(this, _isKeyEscapeDown_extraInitializers);
            this.resetDealView();
        }
        get detailsViewYearsToShow() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_detailsViewYearsToShow_accessor_storage, "f");
        }
        set detailsViewYearsToShow(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_detailsViewYearsToShow_accessor_storage, value, "f");
        }
        get pdfRequest() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_pdfRequest_accessor_storage, "f");
        }
        set pdfRequest(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_pdfRequest_accessor_storage, value, "f");
        }
        get disableLoading() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_disableLoading_accessor_storage, "f");
        }
        set disableLoading(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_disableLoading_accessor_storage, value, "f");
        }
        get scrolling() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_scrolling_accessor_storage, "f");
        }
        set scrolling(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_scrolling_accessor_storage, value, "f");
        }
        get currentSplitRatioDetailView() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_currentSplitRatioDetailView_accessor_storage, "f");
        }
        set currentSplitRatioDetailView(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_currentSplitRatioDetailView_accessor_storage, value, "f");
        }
        get modal() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_modal_accessor_storage, "f");
        }
        set modal(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_modal_accessor_storage, value, "f");
        }
        get dealPageNameSearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageNameSearch_accessor_storage, "f");
        }
        set dealPageNameSearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageNameSearch_accessor_storage, value, "f");
        }
        get dealPageIndustrySearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageIndustrySearch_accessor_storage, "f");
        }
        set dealPageIndustrySearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageIndustrySearch_accessor_storage, value, "f");
        }
        get dealPageScoreSearch() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealPageScoreSearch_accessor_storage, "f");
        }
        set dealPageScoreSearch(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealPageScoreSearch_accessor_storage, value, "f");
        }
        get pageTitle() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_pageTitle_accessor_storage, "f");
        }
        set pageTitle(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_pageTitle_accessor_storage, value, "f");
        }
        get dealViewTab() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_dealViewTab_accessor_storage, "f");
        }
        set dealViewTab(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_dealViewTab_accessor_storage, value, "f");
        }
        get chatWaitingForResponse() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_chatWaitingForResponse_accessor_storage, "f");
        }
        set chatWaitingForResponse(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_chatWaitingForResponse_accessor_storage, value, "f");
        }
        get isKeyControlKeyDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyControlKeyDown_accessor_storage, "f");
        }
        set isKeyControlKeyDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyControlKeyDown_accessor_storage, value, "f");
        }
        get isKeyTabDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyTabDown_accessor_storage, "f");
        }
        set isKeyTabDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyTabDown_accessor_storage, value, "f");
        }
        get isKeyShiftKeyDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyShiftKeyDown_accessor_storage, "f");
        }
        set isKeyShiftKeyDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyShiftKeyDown_accessor_storage, value, "f");
        }
        get isKeyEscapeDown() {
            return $8f024b03d9af7c67$var$__classPrivateFieldGet(this, _StoreUI_isKeyEscapeDown_accessor_storage, "f");
        }
        set isKeyEscapeDown(value) {
            $8f024b03d9af7c67$var$__classPrivateFieldSet(this, _StoreUI_isKeyEscapeDown_accessor_storage, value, "f");
        }
    }, _StoreUI_detailsViewYearsToShow_accessor_storage = new WeakMap(), _StoreUI_pdfRequest_accessor_storage = new WeakMap(), _StoreUI_disableLoading_accessor_storage = new WeakMap(), _StoreUI_scrolling_accessor_storage = new WeakMap(), _StoreUI_currentSplitRatioDetailView_accessor_storage = new WeakMap(), _StoreUI_modal_accessor_storage = new WeakMap(), _StoreUI_dealPageNameSearch_accessor_storage = new WeakMap(), _StoreUI_dealPageIndustrySearch_accessor_storage = new WeakMap(), _StoreUI_dealPageScoreSearch_accessor_storage = new WeakMap(), _StoreUI_pageTitle_accessor_storage = new WeakMap(), _StoreUI_dealViewTab_accessor_storage = new WeakMap(), _StoreUI_chatWaitingForResponse_accessor_storage = new WeakMap(), _StoreUI_isKeyControlKeyDown_accessor_storage = new WeakMap(), _StoreUI_isKeyTabDown_accessor_storage = new WeakMap(), _StoreUI_isKeyShiftKeyDown_accessor_storage = new WeakMap(), _StoreUI_isKeyEscapeDown_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _detailsViewYearsToShow_decorators = [
            (0, $T5IcR.observable)
        ];
        _pdfRequest_decorators = [
            (0, $T5IcR.observable)
        ];
        _disableLoading_decorators = [
            (0, $T5IcR.observable)
        ];
        _scrolling_decorators = [
            (0, $T5IcR.observable)
        ];
        _currentSplitRatioDetailView_decorators = [
            (0, $T5IcR.observable)
        ];
        _modal_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageNameSearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageIndustrySearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealPageScoreSearch_decorators = [
            (0, $T5IcR.observable)
        ];
        _pageTitle_decorators = [
            (0, $T5IcR.observable)
        ];
        _dealViewTab_decorators = [
            (0, $T5IcR.observable)
        ];
        _chatWaitingForResponse_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyControlKeyDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyTabDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyShiftKeyDown_decorators = [
            (0, $T5IcR.observable)
        ];
        _isKeyEscapeDown_decorators = [
            (0, $T5IcR.observable)
        ];
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _detailsViewYearsToShow_decorators, {
            kind: "accessor",
            name: "detailsViewYearsToShow",
            static: false,
            private: false,
            access: {
                has: (obj)=>"detailsViewYearsToShow" in obj,
                get: (obj)=>obj.detailsViewYearsToShow,
                set: (obj, value)=>{
                    obj.detailsViewYearsToShow = value;
                }
            },
            metadata: _metadata
        }, _detailsViewYearsToShow_initializers, _detailsViewYearsToShow_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _pdfRequest_decorators, {
            kind: "accessor",
            name: "pdfRequest",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pdfRequest" in obj,
                get: (obj)=>obj.pdfRequest,
                set: (obj, value)=>{
                    obj.pdfRequest = value;
                }
            },
            metadata: _metadata
        }, _pdfRequest_initializers, _pdfRequest_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _disableLoading_decorators, {
            kind: "accessor",
            name: "disableLoading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"disableLoading" in obj,
                get: (obj)=>obj.disableLoading,
                set: (obj, value)=>{
                    obj.disableLoading = value;
                }
            },
            metadata: _metadata
        }, _disableLoading_initializers, _disableLoading_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _scrolling_decorators, {
            kind: "accessor",
            name: "scrolling",
            static: false,
            private: false,
            access: {
                has: (obj)=>"scrolling" in obj,
                get: (obj)=>obj.scrolling,
                set: (obj, value)=>{
                    obj.scrolling = value;
                }
            },
            metadata: _metadata
        }, _scrolling_initializers, _scrolling_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _currentSplitRatioDetailView_decorators, {
            kind: "accessor",
            name: "currentSplitRatioDetailView",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentSplitRatioDetailView" in obj,
                get: (obj)=>obj.currentSplitRatioDetailView,
                set: (obj, value)=>{
                    obj.currentSplitRatioDetailView = value;
                }
            },
            metadata: _metadata
        }, _currentSplitRatioDetailView_initializers, _currentSplitRatioDetailView_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _modal_decorators, {
            kind: "accessor",
            name: "modal",
            static: false,
            private: false,
            access: {
                has: (obj)=>"modal" in obj,
                get: (obj)=>obj.modal,
                set: (obj, value)=>{
                    obj.modal = value;
                }
            },
            metadata: _metadata
        }, _modal_initializers, _modal_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageNameSearch_decorators, {
            kind: "accessor",
            name: "dealPageNameSearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageNameSearch" in obj,
                get: (obj)=>obj.dealPageNameSearch,
                set: (obj, value)=>{
                    obj.dealPageNameSearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageNameSearch_initializers, _dealPageNameSearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageIndustrySearch_decorators, {
            kind: "accessor",
            name: "dealPageIndustrySearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageIndustrySearch" in obj,
                get: (obj)=>obj.dealPageIndustrySearch,
                set: (obj, value)=>{
                    obj.dealPageIndustrySearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageIndustrySearch_initializers, _dealPageIndustrySearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealPageScoreSearch_decorators, {
            kind: "accessor",
            name: "dealPageScoreSearch",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealPageScoreSearch" in obj,
                get: (obj)=>obj.dealPageScoreSearch,
                set: (obj, value)=>{
                    obj.dealPageScoreSearch = value;
                }
            },
            metadata: _metadata
        }, _dealPageScoreSearch_initializers, _dealPageScoreSearch_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _pageTitle_decorators, {
            kind: "accessor",
            name: "pageTitle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageTitle" in obj,
                get: (obj)=>obj.pageTitle,
                set: (obj, value)=>{
                    obj.pageTitle = value;
                }
            },
            metadata: _metadata
        }, _pageTitle_initializers, _pageTitle_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _dealViewTab_decorators, {
            kind: "accessor",
            name: "dealViewTab",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealViewTab" in obj,
                get: (obj)=>obj.dealViewTab,
                set: (obj, value)=>{
                    obj.dealViewTab = value;
                }
            },
            metadata: _metadata
        }, _dealViewTab_initializers, _dealViewTab_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _chatWaitingForResponse_decorators, {
            kind: "accessor",
            name: "chatWaitingForResponse",
            static: false,
            private: false,
            access: {
                has: (obj)=>"chatWaitingForResponse" in obj,
                get: (obj)=>obj.chatWaitingForResponse,
                set: (obj, value)=>{
                    obj.chatWaitingForResponse = value;
                }
            },
            metadata: _metadata
        }, _chatWaitingForResponse_initializers, _chatWaitingForResponse_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyControlKeyDown_decorators, {
            kind: "accessor",
            name: "isKeyControlKeyDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyControlKeyDown" in obj,
                get: (obj)=>obj.isKeyControlKeyDown,
                set: (obj, value)=>{
                    obj.isKeyControlKeyDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyControlKeyDown_initializers, _isKeyControlKeyDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyTabDown_decorators, {
            kind: "accessor",
            name: "isKeyTabDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyTabDown" in obj,
                get: (obj)=>obj.isKeyTabDown,
                set: (obj, value)=>{
                    obj.isKeyTabDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyTabDown_initializers, _isKeyTabDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyShiftKeyDown_decorators, {
            kind: "accessor",
            name: "isKeyShiftKeyDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyShiftKeyDown" in obj,
                get: (obj)=>obj.isKeyShiftKeyDown,
                set: (obj, value)=>{
                    obj.isKeyShiftKeyDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyShiftKeyDown_initializers, _isKeyShiftKeyDown_extraInitializers);
        $8f024b03d9af7c67$var$__esDecorate(_a, null, _isKeyEscapeDown_decorators, {
            kind: "accessor",
            name: "isKeyEscapeDown",
            static: false,
            private: false,
            access: {
                has: (obj)=>"isKeyEscapeDown" in obj,
                get: (obj)=>obj.isKeyEscapeDown,
                set: (obj, value)=>{
                    obj.isKeyEscapeDown = value;
                }
            },
            metadata: _metadata
        }, _isKeyEscapeDown_initializers, _isKeyEscapeDown_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $8f024b03d9af7c67$var$store = new $8f024b03d9af7c67$var$Store();
const $8f024b03d9af7c67$var$storeUI = new $8f024b03d9af7c67$export$5a825fdb72e99846();
const $8f024b03d9af7c67$export$6ccbb43953eebf8 = ()=>$8f024b03d9af7c67$var$store;
const $8f024b03d9af7c67$export$d842a17955610ca9 = ()=>$8f024b03d9af7c67$var$storeUI;
const $8f024b03d9af7c67$export$d2d3ee67e04f6bd9 = (pageTitle)=>{
    (0, $8nGP5.useEffect)(()=>{
        $8f024b03d9af7c67$var$storeUI.pageTitle = pageTitle;
    }, [
        pageTitle
    ]);
};


const $b2432f43c421c848$var$PATH_RAG = '/Service_RAG';
const $b2432f43c421c848$var$PATH_CHAT = '/Service_Chat';
const $b2432f43c421c848$var$PATH_RAG_REMOTE_ACTION = 'Service_RAG_RemoteAction';
const $b2432f43c421c848$var$PATH_DB_SERVICE_FILES = '/Service_Files';
function $b2432f43c421c848$var$sanitizeName(name) {
    const validChars = new Set('-_()ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    return [
        ...name
    ].filter((c)=>validChars.has(c)).join('');
}
function $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, fileName) {
    const noExt = fileName.replace(/\.[^/.]+$/, '');
    const entryName = $b2432f43c421c848$var$sanitizeName(noExt);
    return `${$b2432f43c421c848$var$PATH_DB_SERVICE_FILES}/${reportId}/files/${entryName}`;
}
class $b2432f43c421c848$var$FirebaseAdapater {
    constructor(){
        Object.defineProperty(this, "app", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "db", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    getConfig() {
        return (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)().firebase;
    }
    init() {
        const firebaseConfig = this.getConfig();
        console.log('Initializing Firebase');
        console.log(firebaseConfig);
        console.log('Is Developer: ', (0, $8f024b03d9af7c67$export$d842a17955610ca9)().isDev);
        this.app = (0, $20ed53392b3edc61$export$c55cfd413944906d)(firebaseConfig);
        this.db = (0, $e0be213f695400f3$export$d0dd861204d0bf72)(this.app);
        var auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)(this.app);
        (0, $402d0a489f4b5d89$export$4a5767248b18ef41)(auth, (user)=>{
            if (user) {
                console.log('Logged in!');
                this.userId = user.uid;
                this.user = user;
                const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                store.userId = user.uid;
                //TODO: Clean this up a bit
                this.store_audit_entry('APP_LOAD');
                var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/cim_results');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.resetDataAccessCache();
                    store.reportDataDB = val || {};
                });
                var r_overrides = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/cim_results_overrides');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_overrides, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.resetDataAccessCache();
                    store.reportDataOverridesDB = val || {};
                    store.areOveridesLoaded = true;
                });
                var r_firminfo = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/firm_info');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_firminfo, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.firmInfo = val || {};
                });
                var r_project_files = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_DB_SERVICE_FILES);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_project_files, (data)=>{
                    const val = data.val();
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    for(var reportId in val){
                        const files = val[reportId].files;
                        if (files) for(var key in files)files[key].saveKey = key;
                    }
                    store.allProjectFiles = val || {};
                });
                var r_rag = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_RAG);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_rag, (data)=>{
                    var val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    // for (var key in val) {
                    //     val[key]['originalDocId'] = key;
                    // }
                    store.ragDB = val || {};
                    store.isRagDbLoaded = true;
                });
                var r_settings = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/settings');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_settings, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.settings = val || {};
                });
                var r_scoreoverride = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/score_override');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r_scoreoverride, (data)=>{
                    const val = data.val();
                    //console.log(JSON.stringify(val));
                    const ruleStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
                    ruleStore.update_rules(val || {});
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.areScoreRulesLoaded = true;
                });
                var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/jobs');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(r, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.jobs = data.val();
                });
                var chatsRef = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_CHAT);
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(chatsRef, (data)=>{
                    var _a;
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.chatData = (_a = data.val()) !== null && _a !== void 0 ? _a : {};
                    store.isChatLoaded = true;
                });
                var activeJobs = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/activeJob');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(activeJobs, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.activeJob = data.val();
                });
                var users = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/users');
                (0, $e0be213f695400f3$export$ad30f661f41f4d90)(users, (data)=>{
                    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
                    store.users = data.val();
                });
            // var onlineStatus = ref(this.db, '/system_status');
            // onValue(onlineStatus, data => {
            //     store.systemStatus = data.val();
            // });
            } else if (location.href.indexOf('login') < 0) location.href = '/login';
        });
    }
    deleteReport(reportId) {
        this.store_audit_entry('DELETE_DEAL', {
            reportId: reportId
        });
        var r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `/cim_results/${reportId}`);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    store_override(reportId, overidePath, value) {
        const path = `cim_results_overrides/${reportId}/${overidePath}`;
        const switchDot = path.replace('.', '___');
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, switchDot);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, value);
        this.store_audit_entry('EDIT_FIELD', {
            reportId: reportId,
            field: overidePath,
            value: value
        });
    }
    remove_override(reportId, overidePath) {
        const path = `cim_results_overrides/${reportId}/${overidePath}`;
        const switchDot = path.replace('.', '___');
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, switchDot);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
        this.store_audit_entry('EDIT_FIELD', {
            reportId: reportId,
            field: overidePath,
            value: 'DELETED'
        });
    }
    store_audit_entry(type, extraData = {}) {
        if (!this.userId) {
            setTimeout(()=>{
                this.store_audit_entry(type, extraData);
            }, 1000);
            return;
        }
        const userId = this.userId;
        const userEmail = this.user.email;
        const path = `audit_log`;
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            type: type,
            userId: userId,
            userEmail: userEmail,
            extraData: extraData,
            date: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
    }
    addDummyProjectFile(reportId, fileName) {
        const path = $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, fileName);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            filename: fileName
        });
    }
    deleteProjectFile(reportId, filename) {
        const path = $b2432f43c421c848$var$dbBuildProjectFilePath(reportId, filename);
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, path);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    triggerScanRagFiles() {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, $b2432f43c421c848$var$PATH_RAG_REMOTE_ACTION);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, {
            action: 'import',
            started: false
        });
    }
    clearJobQueue() {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, '/jobs');
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
    setJobStatus(jobId, status) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `/jobs/${jobId}`);
        (0, $e0be213f695400f3$export$722fbec263ad908a)(r, {
            status: status
        });
    }
    add_job(fileName, password, originalJobId, clearCache, priority) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `/jobs`);
        const data = {
            fileName: fileName,
            user: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.email,
            userId: (0, $402d0a489f4b5d89$export$ae1af26003f05816)().currentUser.uid,
            priority: priority || 0,
            status: 'pending',
            createdAt: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        };
        if (password) data['pdfPassword'] = password;
        if (originalJobId) data['originalJobId'] = originalJobId;
        if (clearCache) data['clearCache'] = true;
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, data);
    }
    chatbot_add_message(reportId, message, isMe) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_CHAT}/${reportId}`);
        (0, $e0be213f695400f3$export$4cbf152802aa238)(r, {
            message: message,
            isMe: isMe,
            processed: false,
            date: (0, $e0be213f695400f3$export$3ff8e7e00c3264b7)()
        });
    }
    clear_chat(reportId) {
        const r = (0, $e0be213f695400f3$export$eff4d24c3ff7876e)(this.db, `${$b2432f43c421c848$var$PATH_CHAT}/${reportId}`);
        (0, $e0be213f695400f3$export$adaa4cf7ef1b65be)(r, null);
    }
}
const $b2432f43c421c848$var$mFirebaseService = new $b2432f43c421c848$var$FirebaseAdapater();
function $b2432f43c421c848$export$7a667d08ed65fa47() {
    return $b2432f43c421c848$var$mFirebaseService;
}



var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");


var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");

var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
if (!(0, $8nGP5.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $T5IcR.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $fCKK7 = parcelRequire("fCKK7");


var $fCKK7 = parcelRequire("fCKK7");

var $T5IcR = parcelRequire("T5IcR");
function $06788226e6cf4706$export$fb2daceae6f5097a(callback) {
    callback();
}
function $06788226e6cf4706$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $06788226e6cf4706$export$fb2daceae6f5097a;
    (0, $T5IcR.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $06788226e6cf4706$export$13ce1459b9a04b51 = function() {
    return true;
};


var $7b2e385845e89a2a$var$deprecatedMessages = [];
function $7b2e385845e89a2a$export$be38475be17599d(msg) {
    if (!$7b2e385845e89a2a$var$deprecatedMessages.includes(msg)) {
        $7b2e385845e89a2a$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");

var $T5IcR = parcelRequire("T5IcR");
function $aea7a9b7e34d5f28$export$ef795f1f307682c7(v) {
    return (0, $T5IcR.getDependencyTree)(v);
}


var $43e377faaed97490$var$globalIsUsingStaticRendering = false;
function $43e377faaed97490$export$5d52eaa7c0f24c9e(enable) {
    $43e377faaed97490$var$globalIsUsingStaticRendering = enable;
}
function $43e377faaed97490$export$55979271896d643e() {
    return $43e377faaed97490$var$globalIsUsingStaticRendering;
}


var $33be30eca2999b1c$export$e901ba0ffe10ba41 = 10000;
var $33be30eca2999b1c$export$1ae22ce5a82f26b6 = 10000;
var $33be30eca2999b1c$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $33be30eca2999b1c$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $33be30eca2999b1c$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $33be30eca2999b1c$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $33be30eca2999b1c$export$b7a00d372cedeedd;


var $c9256b9a503783e3$export$10e8a12fbfd8583c = new (0, $33be30eca2999b1c$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $3c02d2fff4e333b2$exports = {};
'use strict';

$3c02d2fff4e333b2$exports = (parcelRequire("8wQss"));


function $3189ea0013ac6397$var$createReaction(adm) {
    adm.reaction = new (0, $T5IcR.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $3189ea0013ac6397$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $43e377faaed97490$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $c9256b9a503783e3$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $3189ea0013ac6397$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $3189ea0013ac6397$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $c9256b9a503783e3$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useDebugValue(adm.reaction, (0, $aea7a9b7e34d5f28$export$ef795f1f307682c7));
    (0, $3c02d2fff4e333b2$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $8nGP5 = parcelRequire("8nGP5");


var $377af52de255c3c1$var$_a, $377af52de255c3c1$var$_b;
var $377af52de255c3c1$var$warnObserverOptionsDeprecated = true;
var $377af52de255c3c1$var$warnLegacyContextTypes = true;
var $377af52de255c3c1$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $377af52de255c3c1$var$isFunctionNameConfigurable = ($377af52de255c3c1$var$_b = ($377af52de255c3c1$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $377af52de255c3c1$var$_a === void 0 ? void 0 : $377af52de255c3c1$var$_a.configurable) !== null && $377af52de255c3c1$var$_b !== void 0 ? $377af52de255c3c1$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $377af52de255c3c1$var$ReactForwardRefSymbol = $377af52de255c3c1$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $8nGP5.forwardRef) === "function" && (0, $8nGP5.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $377af52de255c3c1$var$ReactMemoSymbol = $377af52de255c3c1$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $8nGP5.memo) === "function" && (0, $8nGP5.memo)(function(props) {
    return null;
})["$$typeof"];
function $377af52de255c3c1$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($377af52de255c3c1$var$ReactMemoSymbol && baseComponent["$$typeof"] === $377af52de255c3c1$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $43e377faaed97490$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($377af52de255c3c1$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $377af52de255c3c1$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $3189ea0013ac6397$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($377af52de255c3c1$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $8nGP5.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $8nGP5.memo)(observerComponent);
    $377af52de255c3c1$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $377af52de255c3c1$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $377af52de255c3c1$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$377af52de255c3c1$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $ce623943d2e82d7e$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $3189ea0013ac6397$export$b9c7ecd090a87b14)(component);
}
$ce623943d2e82d7e$export$c1cbdee04e18ea8b.displayName = "Observer";
function $ce623943d2e82d7e$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
function $e2530c04d3a343b1$export$aa207039f277c5f(initializer, annotations) {
    return (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");



var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
function $62061af237ca870a$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $T5IcR.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $19c24c5a7fc6d99e$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $62061af237ca870a$export$e0ded3646391939c)(current);
    return (0, $8nGP5.useState)(function() {
        return (0, $T5IcR.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $58a752ab88cc94e3$var$_a;
(0, $06788226e6cf4706$export$294943bbc3c74f4f)((0, $fCKK7.unstable_batchedUpdates));
var $58a752ab88cc94e3$export$469d51fb8d268227 = ($58a752ab88cc94e3$var$_a = (0, $c9256b9a503783e3$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $58a752ab88cc94e3$var$_a !== void 0 ? $58a752ab88cc94e3$var$_a : function() {};
function $58a752ab88cc94e3$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $3189ea0013ac6397$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $58a752ab88cc94e3$export$7613124ee4202834(enable) {
    (0, $43e377faaed97490$export$5d52eaa7c0f24c9e)(enable);
}


function $d8a76c81a2e66478$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($d8a76c81a2e66478$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$d8a76c81a2e66478$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $d8a76c81a2e66478$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $d8a76c81a2e66478$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $d8a76c81a2e66478$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$d8a76c81a2e66478$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $d8a76c81a2e66478$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $d8a76c81a2e66478$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $d8a76c81a2e66478$var$getMixins(target, methodName) {
    var mixins = target[$d8a76c81a2e66478$var$mobxMixins] = target[$d8a76c81a2e66478$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $d8a76c81a2e66478$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $d8a76c81a2e66478$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $d8a76c81a2e66478$var$wrapper.call.apply($d8a76c81a2e66478$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $d8a76c81a2e66478$var$patch(target, methodName, mixinMethod) {
    var mixins = $d8a76c81a2e66478$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$d8a76c81a2e66478$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $d8a76c81a2e66478$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $d8a76c81a2e66478$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $d8a76c81a2e66478$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$d8a76c81a2e66478$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $d8a76c81a2e66478$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $d8a76c81a2e66478$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $d8a76c81a2e66478$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $d8a76c81a2e66478$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $d8a76c81a2e66478$var$observablePropDescriptors;
function $d8a76c81a2e66478$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$d8a76c81a2e66478$var$administrationSymbol]) != null ? _component$administra : component[$d8a76c81a2e66478$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $d8a76c81a2e66478$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $d8a76c81a2e66478$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$d8a76c81a2e66478$var$isMobXReactObserverSymbol]) {
        var displayName = $d8a76c81a2e66478$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$d8a76c81a2e66478$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $8nGP5.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $d8a76c81a2e66478$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $d8a76c81a2e66478$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $d8a76c81a2e66478$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $43e377faaed97490$export$55979271896d643e)() ? originalRender : $d8a76c81a2e66478$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $d8a76c81a2e66478$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $c9256b9a503783e3$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $d8a76c81a2e66478$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $43e377faaed97490$export$55979271896d643e)()) return;
        var admin = $d8a76c81a2e66478$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $d8a76c81a2e66478$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $d8a76c81a2e66478$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $d8a76c81a2e66478$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $d8a76c81a2e66478$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $c9256b9a503783e3$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $T5IcR._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $d8a76c81a2e66478$var$createReaction(admin) {
    return new (0, $T5IcR.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $d8a76c81a2e66478$var$observerSCU(nextProps, nextState) {
    if ((0, $43e377faaed97490$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$d8a76c81a2e66478$var$shallowEqual(this.props, nextProps);
}
function $d8a76c81a2e66478$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $d8a76c81a2e66478$var$getAdministration(this);
            var derivation = (0, $T5IcR._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $d8a76c81a2e66478$var$getAdministration(this)[key] = value;
        }
    };
}
function $d8a76c81a2e66478$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $8nGP5.Component), component) || Object.prototype.isPrototypeOf.call((0, $8nGP5.PureComponent), component)) // Class component
    return $d8a76c81a2e66478$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $377af52de255c3c1$export$b6ae1bc530f4c149)(component);
}
function $d8a76c81a2e66478$var$_extends() {
    return $d8a76c81a2e66478$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d8a76c81a2e66478$var$_extends.apply(null, arguments);
}
function $d8a76c81a2e66478$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $d8a76c81a2e66478$var$_excluded = [
    "children"
];
var $d8a76c81a2e66478$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext({});
function $d8a76c81a2e66478$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $d8a76c81a2e66478$var$_objectWithoutPropertiesLoose(props, $d8a76c81a2e66478$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useContext($d8a76c81a2e66478$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef($d8a76c81a2e66478$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($d8a76c81a2e66478$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$d8a76c81a2e66478$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $d8a76c81a2e66478$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
        var newProps = $d8a76c81a2e66478$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useContext($d8a76c81a2e66478$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $d8a76c81a2e66478$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $d8a76c81a2e66478$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $d8a76c81a2e66478$var$getInjectName(component, injectNames);
    return Injector;
}
function $d8a76c81a2e66478$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $d8a76c81a2e66478$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $d8a76c81a2e66478$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $d8a76c81a2e66478$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $d8a76c81a2e66478$var$createStoreInjector($d8a76c81a2e66478$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $d8a76c81a2e66478$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).version.split(".")[0]);
var $d8a76c81a2e66478$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $d8a76c81a2e66478$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $d8a76c81a2e66478$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $d8a76c81a2e66478$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$d8a76c81a2e66478$var$protoStoreKey] || [], this[$d8a76c81a2e66478$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $d8a76c81a2e66478$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $d8a76c81a2e66478$export$4e749cb731da87a9(target, fn);
    });
    if (!$d8a76c81a2e66478$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($d8a76c81a2e66478$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $d8a76c81a2e66478$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$d8a76c81a2e66478$var$protoStoreKey] || !!target[$d8a76c81a2e66478$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$d8a76c81a2e66478$var$protoStoreKey] || (target[$d8a76c81a2e66478$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$d8a76c81a2e66478$var$instStoreKey] || (target[$d8a76c81a2e66478$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $d8a76c81a2e66478$var$patch(target, "componentWillUnmount", $d8a76c81a2e66478$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $d8a76c81a2e66478$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $T5IcR.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $d8a76c81a2e66478$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $d8a76c81a2e66478$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($d8a76c81a2e66478$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $d8a76c81a2e66478$var$getPreciseType(propValue) {
    var propType = $d8a76c81a2e66478$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $d8a76c81a2e66478$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $T5IcR.untracked)(function() {
            if (allowNativeType) {
                if ($d8a76c81a2e66478$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $T5IcR.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $T5IcR.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $T5IcR.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $d8a76c81a2e66478$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $d8a76c81a2e66478$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $d8a76c81a2e66478$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $T5IcR.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $d8a76c81a2e66478$var$observableArray = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(false, "Array");
var $d8a76c81a2e66478$var$observableArrayOf = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableArrayOfTypeChecker.bind(null, false);
var $d8a76c81a2e66478$var$observableMap = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(false, "Map");
var $d8a76c81a2e66478$var$observableObject = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(false, "Object");
var $d8a76c81a2e66478$var$arrayOrObservableArray = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(true, "Array");
var $d8a76c81a2e66478$var$arrayOrObservableArrayOf = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableArrayOfTypeChecker.bind(null, true);
var $d8a76c81a2e66478$var$objectOrObservableObject = /*#__PURE__*/ $d8a76c81a2e66478$var$createObservableTypeCheckerCreator(true, "Object");
var $d8a76c81a2e66478$export$e0c95a451cd220b7 = {
    observableArray: $d8a76c81a2e66478$var$observableArray,
    observableArrayOf: $d8a76c81a2e66478$var$observableArrayOf,
    observableMap: $d8a76c81a2e66478$var$observableMap,
    observableObject: $d8a76c81a2e66478$var$observableObject,
    arrayOrObservableArray: $d8a76c81a2e66478$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $d8a76c81a2e66478$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $d8a76c81a2e66478$var$objectOrObservableObject
};
if (!(0, $8nGP5.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $T5IcR.observable)) throw new Error("mobx-react requires mobx to be available");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");
"use client";
function $c1e5789890d2fb2f$var$Mt(t) {
    if (!t || typeof document == "undefined") return;
    let o = document.head || document.getElementsByTagName("head")[0], e = document.createElement("style");
    e.type = "text/css", o.firstChild ? o.insertBefore(e, o.firstChild) : o.appendChild(e), e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
$c1e5789890d2fb2f$var$Mt(`:root{--toastify-color-light: #fff;--toastify-color-dark: #121212;--toastify-color-info: #3498db;--toastify-color-success: #07bc0c;--toastify-color-warning: #f1c40f;--toastify-color-error: hsl(6, 78%, 57%);--toastify-color-transparent: rgba(255, 255, 255, .7);--toastify-icon-color-info: var(--toastify-color-info);--toastify-icon-color-success: var(--toastify-color-success);--toastify-icon-color-warning: var(--toastify-color-warning);--toastify-icon-color-error: var(--toastify-color-error);--toastify-container-width: fit-content;--toastify-toast-width: 320px;--toastify-toast-offset: 16px;--toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));--toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));--toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));--toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));--toastify-toast-background: #fff;--toastify-toast-padding: 14px;--toastify-toast-min-height: 64px;--toastify-toast-max-height: 800px;--toastify-toast-bd-radius: 6px;--toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, .1);--toastify-font-family: sans-serif;--toastify-z-index: 9999;--toastify-text-color-light: #757575;--toastify-text-color-dark: #fff;--toastify-text-color-info: #fff;--toastify-text-color-success: #fff;--toastify-text-color-warning: #fff;--toastify-text-color-error: #fff;--toastify-spinner-color: #616161;--toastify-spinner-color-empty-area: #e0e0e0;--toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);--toastify-color-progress-dark: #bb86fc;--toastify-color-progress-info: var(--toastify-color-info);--toastify-color-progress-success: var(--toastify-color-success);--toastify-color-progress-warning: var(--toastify-color-warning);--toastify-color-progress-error: var(--toastify-color-error);--toastify-color-progress-bgo: .2}.Toastify__toast-container{z-index:var(--toastify-z-index);-webkit-transform:translate3d(0,0,var(--toastify-z-index));position:fixed;width:var(--toastify-container-width);box-sizing:border-box;color:#fff;display:flex;flex-direction:column}.Toastify__toast-container--top-left{top:var(--toastify-toast-top);left:var(--toastify-toast-left)}.Toastify__toast-container--top-center{top:var(--toastify-toast-top);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--top-right{top:var(--toastify-toast-top);right:var(--toastify-toast-right);align-items:end}.Toastify__toast-container--bottom-left{bottom:var(--toastify-toast-bottom);left:var(--toastify-toast-left)}.Toastify__toast-container--bottom-center{bottom:var(--toastify-toast-bottom);left:50%;transform:translate(-50%);align-items:center}.Toastify__toast-container--bottom-right{bottom:var(--toastify-toast-bottom);right:var(--toastify-toast-right);align-items:end}.Toastify__toast{--y: 0;position:relative;touch-action:none;width:var(--toastify-toast-width);min-height:var(--toastify-toast-min-height);box-sizing:border-box;margin-bottom:1rem;padding:var(--toastify-toast-padding);border-radius:var(--toastify-toast-bd-radius);box-shadow:var(--toastify-toast-shadow);max-height:var(--toastify-toast-max-height);font-family:var(--toastify-font-family);z-index:0;display:flex;flex:1 auto;align-items:center;word-break:break-word}@media only screen and (max-width: 480px){.Toastify__toast-container{width:100vw;left:env(safe-area-inset-left);margin:0}.Toastify__toast-container--top-left,.Toastify__toast-container--top-center,.Toastify__toast-container--top-right{top:env(safe-area-inset-top);transform:translate(0)}.Toastify__toast-container--bottom-left,.Toastify__toast-container--bottom-center,.Toastify__toast-container--bottom-right{bottom:env(safe-area-inset-bottom);transform:translate(0)}.Toastify__toast-container--rtl{right:env(safe-area-inset-right);left:initial}.Toastify__toast{--toastify-toast-width: 100%;margin-bottom:0;border-radius:0}}.Toastify__toast-container[data-stacked=true]{width:var(--toastify-toast-width)}.Toastify__toast--stacked{position:absolute;width:100%;transform:translate3d(0,var(--y),0) scale(var(--s));transition:transform .3s}.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,.Toastify__toast--stacked[data-collapsed] .Toastify__close-button{transition:opacity .1s}.Toastify__toast--stacked[data-collapsed=false]{overflow:visible}.Toastify__toast--stacked[data-collapsed=true]:not(:last-child)>*{opacity:0}.Toastify__toast--stacked:after{content:"";position:absolute;left:0;right:0;height:calc(var(--g) * 1px);bottom:100%}.Toastify__toast--stacked[data-pos=top]{top:0}.Toastify__toast--stacked[data-pos=bot]{bottom:0}.Toastify__toast--stacked[data-pos=bot].Toastify__toast--stacked:before{transform-origin:top}.Toastify__toast--stacked[data-pos=top].Toastify__toast--stacked:before{transform-origin:bottom}.Toastify__toast--stacked:before{content:"";position:absolute;left:0;right:0;bottom:0;height:100%;transform:scaleY(3);z-index:-1}.Toastify__toast--rtl{direction:rtl}.Toastify__toast--close-on-click{cursor:pointer}.Toastify__toast-icon{margin-inline-end:10px;width:22px;flex-shrink:0;display:flex}.Toastify--animate{animation-fill-mode:both;animation-duration:.5s}.Toastify--animate-icon{animation-fill-mode:both;animation-duration:.3s}.Toastify__toast-theme--dark{background:var(--toastify-color-dark);color:var(--toastify-text-color-dark)}.Toastify__toast-theme--light,.Toastify__toast-theme--colored.Toastify__toast--default{background:var(--toastify-color-light);color:var(--toastify-text-color-light)}.Toastify__toast-theme--colored.Toastify__toast--info{color:var(--toastify-text-color-info);background:var(--toastify-color-info)}.Toastify__toast-theme--colored.Toastify__toast--success{color:var(--toastify-text-color-success);background:var(--toastify-color-success)}.Toastify__toast-theme--colored.Toastify__toast--warning{color:var(--toastify-text-color-warning);background:var(--toastify-color-warning)}.Toastify__toast-theme--colored.Toastify__toast--error{color:var(--toastify-text-color-error);background:var(--toastify-color-error)}.Toastify__progress-bar-theme--light{background:var(--toastify-color-progress-light)}.Toastify__progress-bar-theme--dark{background:var(--toastify-color-progress-dark)}.Toastify__progress-bar--info{background:var(--toastify-color-progress-info)}.Toastify__progress-bar--success{background:var(--toastify-color-progress-success)}.Toastify__progress-bar--warning{background:var(--toastify-color-progress-warning)}.Toastify__progress-bar--error{background:var(--toastify-color-progress-error)}.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error{background:var(--toastify-color-transparent)}.Toastify__close-button{color:#fff;position:absolute;top:6px;right:6px;background:transparent;outline:none;border:none;padding:0;cursor:pointer;opacity:.7;transition:.3s ease;z-index:1}.Toastify__toast--rtl .Toastify__close-button{left:6px;right:unset}.Toastify__close-button--light{color:#000;opacity:.3}.Toastify__close-button>svg{fill:currentColor;height:16px;width:14px}.Toastify__close-button:hover,.Toastify__close-button:focus{opacity:1}@keyframes Toastify__trackProgress{0%{transform:scaleX(1)}to{transform:scaleX(0)}}.Toastify__progress-bar{position:absolute;bottom:0;left:0;width:100%;height:100%;z-index:1;opacity:.7;transform-origin:left}.Toastify__progress-bar--animated{animation:Toastify__trackProgress linear 1 forwards}.Toastify__progress-bar--controlled{transition:transform .2s}.Toastify__progress-bar--rtl{right:0;left:initial;transform-origin:right;border-bottom-left-radius:initial}.Toastify__progress-bar--wrp{position:absolute;overflow:hidden;bottom:0;left:0;width:100%;height:5px;border-bottom-left-radius:var(--toastify-toast-bd-radius);border-bottom-right-radius:var(--toastify-toast-bd-radius)}.Toastify__progress-bar--wrp[data-hidden=true]{opacity:0}.Toastify__progress-bar--bg{opacity:var(--toastify-color-progress-bgo);width:100%;height:100%}.Toastify__spinner{width:20px;height:20px;box-sizing:border-box;border:2px solid;border-radius:100%;border-color:var(--toastify-spinner-color-empty-area);border-right-color:var(--toastify-spinner-color);animation:Toastify__spin .65s linear infinite}@keyframes Toastify__bounceInRight{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutRight{20%{opacity:1;transform:translate3d(-20px,var(--y),0)}to{opacity:0;transform:translate3d(2000px,var(--y),0)}}@keyframes Toastify__bounceInLeft{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}@keyframes Toastify__bounceOutLeft{20%{opacity:1;transform:translate3d(20px,var(--y),0)}to{opacity:0;transform:translate3d(-2000px,var(--y),0)}}@keyframes Toastify__bounceInUp{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}@keyframes Toastify__bounceOutUp{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}@keyframes Toastify__bounceInDown{0%,60%,75%,90%,to{animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}@keyframes Toastify__bounceOutDown{20%{transform:translate3d(0,calc(var(--y) - 10px),0)}40%,45%{opacity:1;transform:translate3d(0,calc(var(--y) + 20px),0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.Toastify__bounce-enter--top-left,.Toastify__bounce-enter--bottom-left{animation-name:Toastify__bounceInLeft}.Toastify__bounce-enter--top-right,.Toastify__bounce-enter--bottom-right{animation-name:Toastify__bounceInRight}.Toastify__bounce-enter--top-center{animation-name:Toastify__bounceInDown}.Toastify__bounce-enter--bottom-center{animation-name:Toastify__bounceInUp}.Toastify__bounce-exit--top-left,.Toastify__bounce-exit--bottom-left{animation-name:Toastify__bounceOutLeft}.Toastify__bounce-exit--top-right,.Toastify__bounce-exit--bottom-right{animation-name:Toastify__bounceOutRight}.Toastify__bounce-exit--top-center{animation-name:Toastify__bounceOutUp}.Toastify__bounce-exit--bottom-center{animation-name:Toastify__bounceOutDown}@keyframes Toastify__zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes Toastify__zoomOut{0%{opacity:1}50%{opacity:0;transform:translate3d(0,var(--y),0) scale3d(.3,.3,.3)}to{opacity:0}}.Toastify__zoom-enter{animation-name:Toastify__zoomIn}.Toastify__zoom-exit{animation-name:Toastify__zoomOut}@keyframes Toastify__flipIn{0%{transform:perspective(400px) rotateX(90deg);animation-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);animation-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}@keyframes Toastify__flipOut{0%{transform:translate3d(0,var(--y),0) perspective(400px)}30%{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(-20deg);opacity:1}to{transform:translate3d(0,var(--y),0) perspective(400px) rotateX(90deg);opacity:0}}.Toastify__flip-enter{animation-name:Toastify__flipIn}.Toastify__flip-exit{animation-name:Toastify__flipOut}@keyframes Toastify__slideInRight{0%{transform:translate3d(110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInLeft{0%{transform:translate3d(-110%,0,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInUp{0%{transform:translate3d(0,110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideInDown{0%{transform:translate3d(0,-110%,0);visibility:visible}to{transform:translate3d(0,var(--y),0)}}@keyframes Toastify__slideOutRight{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(110%,var(--y),0)}}@keyframes Toastify__slideOutLeft{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(-110%,var(--y),0)}}@keyframes Toastify__slideOutDown{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,500px,0)}}@keyframes Toastify__slideOutUp{0%{transform:translate3d(0,var(--y),0)}to{visibility:hidden;transform:translate3d(0,-500px,0)}}.Toastify__slide-enter--top-left,.Toastify__slide-enter--bottom-left{animation-name:Toastify__slideInLeft}.Toastify__slide-enter--top-right,.Toastify__slide-enter--bottom-right{animation-name:Toastify__slideInRight}.Toastify__slide-enter--top-center{animation-name:Toastify__slideInDown}.Toastify__slide-enter--bottom-center{animation-name:Toastify__slideInUp}.Toastify__slide-exit--top-left,.Toastify__slide-exit--bottom-left{animation-name:Toastify__slideOutLeft;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-right,.Toastify__slide-exit--bottom-right{animation-name:Toastify__slideOutRight;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--top-center{animation-name:Toastify__slideOutUp;animation-timing-function:ease-in;animation-duration:.3s}.Toastify__slide-exit--bottom-center{animation-name:Toastify__slideOutDown;animation-timing-function:ease-in;animation-duration:.3s}@keyframes Toastify__spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}
`);
var $c1e5789890d2fb2f$var$L = (t)=>typeof t == "number" && !isNaN(t), $c1e5789890d2fb2f$var$N = (t)=>typeof t == "string", $c1e5789890d2fb2f$var$P = (t)=>typeof t == "function", $c1e5789890d2fb2f$var$mt = (t)=>$c1e5789890d2fb2f$var$N(t) || $c1e5789890d2fb2f$var$L(t), $c1e5789890d2fb2f$var$B = (t)=>$c1e5789890d2fb2f$var$N(t) || $c1e5789890d2fb2f$var$P(t) ? t : null, $c1e5789890d2fb2f$var$pt = (t, o)=>t === !1 || $c1e5789890d2fb2f$var$L(t) && t > 0 ? t : o, $c1e5789890d2fb2f$var$z = (t)=>(0, $8nGP5.isValidElement)(t) || $c1e5789890d2fb2f$var$N(t) || $c1e5789890d2fb2f$var$P(t) || $c1e5789890d2fb2f$var$L(t);
function $c1e5789890d2fb2f$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = r + "px", s.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(o, e);
        });
    });
}
function $c1e5789890d2fb2f$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: s = 300 }) {
    return function({ children: a, position: d, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${d}` : t, S = e ? `${o}--${d}` : o, E = (0, $8nGP5.useRef)(0);
        return (0, $8nGP5.useLayoutEffect)(()=>{
            let f = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), f.removeEventListener("animationend", b), f.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && f.classList.remove(...p));
            };
            (()=>{
                f.classList.add(...p), f.addEventListener("animationend", b), f.addEventListener("animationcancel", b);
            })();
        }, []), (0, $8nGP5.useEffect)(()=>{
            let f = g.current, p = ()=>{
                f.removeEventListener("animationend", p), r ? $c1e5789890d2fb2f$export$184cca501f1aed7f(f, T, s) : T();
            };
            v || (c ? p() : (()=>{
                E.current = 1, f.className += ` ${S}`, f.addEventListener("animationend", p);
            })());
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, a);
    };
}
function $c1e5789890d2fb2f$var$J(t, o) {
    return {
        content: $c1e5789890d2fb2f$var$tt(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $c1e5789890d2fb2f$var$tt(t, o, e = !1) {
    return (0, $8nGP5.isValidElement)(t) && !$c1e5789890d2fb2f$var$N(t.type) ? (0, $8nGP5.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $c1e5789890d2fb2f$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $c1e5789890d2fb2f$var$yt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $c1e5789890d2fb2f$var$gt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: s, className: l, controlledProgress: a, progress: d, rtl: c, isIn: T, theme: g }) {
    let v = s || a && d === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    a && (x.transform = `scaleX(${d})`);
    let C = (0, $ajIhI.default)("Toastify__progress-bar", a ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $c1e5789890d2fb2f$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $ajIhI.default)(C, l), E = {
        [a && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: a && d < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        className: S,
        style: x,
        ...E
    }));
}
var $c1e5789890d2fb2f$var$Xt = 1, $c1e5789890d2fb2f$var$at = ()=>`${$c1e5789890d2fb2f$var$Xt++}`;
function $c1e5789890d2fb2f$var$_t(t, o, e) {
    let r = 1, s = 0, l = [], a = [], d = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        a = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        (u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1;
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, f = ()=>{
        s -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($c1e5789890d2fb2f$var$J(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: d,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: f,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, M = h == null;
            M && s++;
            let A = {
                ...d,
                style: d.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([D, Y])=>Y != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $c1e5789890d2fb2f$var$B(n.className || d.toastClassName),
                progressClassName: $c1e5789890d2fb2f$var$B(n.progressClassName || d.progressClassName),
                autoClose: n.isLoading ? !1 : $c1e5789890d2fb2f$var$pt(n.autoClose, d.autoClose),
                closeToast (D) {
                    c.get(u).removalReason = D, E(u);
                },
                deleteToast () {
                    let D = c.get(u);
                    if (D != null) {
                        if (e($c1e5789890d2fb2f$var$J(D, "removed")), c.delete(u), s--, s < 0 && (s = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = d.closeButton, n.closeButton === !1 || $c1e5789890d2fb2f$var$z(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $c1e5789890d2fb2f$var$z(d.closeButton) ? d.closeButton : !0);
            let R = {
                content: i,
                props: A,
                staleId: _
            };
            d.limit && d.limit > 0 && s > d.limit && M ? l.push(R) : $c1e5789890d2fb2f$var$L(k) ? setTimeout(()=>{
                p(R);
            }, k) : p(R);
        },
        setProps (i) {
            d = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>a
    };
}
var $c1e5789890d2fb2f$var$I = new Map, $c1e5789890d2fb2f$var$F = [], $c1e5789890d2fb2f$var$st = new Set, $c1e5789890d2fb2f$var$Vt = (t)=>$c1e5789890d2fb2f$var$st.forEach((o)=>o(t)), $c1e5789890d2fb2f$var$bt = ()=>$c1e5789890d2fb2f$var$I.size > 0;
function $c1e5789890d2fb2f$var$Qt() {
    $c1e5789890d2fb2f$var$F.forEach((t)=>$c1e5789890d2fb2f$var$nt(t.content, t.options)), $c1e5789890d2fb2f$var$F = [];
}
var $c1e5789890d2fb2f$var$vt = (t, { containerId: o })=>{
    var e;
    return (e = $c1e5789890d2fb2f$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $c1e5789890d2fb2f$var$X(t, o) {
    var r;
    if (o) return !!((r = $c1e5789890d2fb2f$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $c1e5789890d2fb2f$var$I.forEach((s)=>{
        s.isToastActive(t) && (e = !0);
    }), e;
}
function $c1e5789890d2fb2f$var$ht(t) {
    if (!$c1e5789890d2fb2f$var$bt()) {
        $c1e5789890d2fb2f$var$F = $c1e5789890d2fb2f$var$F.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $c1e5789890d2fb2f$var$mt(t)) $c1e5789890d2fb2f$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $c1e5789890d2fb2f$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $c1e5789890d2fb2f$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $c1e5789890d2fb2f$var$Ct = (t = {})=>{
    $c1e5789890d2fb2f$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $c1e5789890d2fb2f$var$nt(t, o) {
    $c1e5789890d2fb2f$var$z(t) && ($c1e5789890d2fb2f$var$bt() || $c1e5789890d2fb2f$var$F.push({
        content: t,
        options: o
    }), $c1e5789890d2fb2f$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $c1e5789890d2fb2f$var$xt(t) {
    var o;
    (o = $c1e5789890d2fb2f$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $c1e5789890d2fb2f$var$rt(t, o) {
    $c1e5789890d2fb2f$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $c1e5789890d2fb2f$var$Et(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $c1e5789890d2fb2f$var$_t(o, t, $c1e5789890d2fb2f$var$Vt);
            $c1e5789890d2fb2f$var$I.set(o, r);
            let s = r.observe(e);
            return $c1e5789890d2fb2f$var$Qt(), ()=>{
                s(), $c1e5789890d2fb2f$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $c1e5789890d2fb2f$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $c1e5789890d2fb2f$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $c1e5789890d2fb2f$var$Pt(t) {
    return $c1e5789890d2fb2f$var$st.add(t), ()=>{
        $c1e5789890d2fb2f$var$st.delete(t);
    };
}
function $c1e5789890d2fb2f$var$Wt(t) {
    return t && ($c1e5789890d2fb2f$var$N(t.toastId) || $c1e5789890d2fb2f$var$L(t.toastId)) ? t.toastId : $c1e5789890d2fb2f$var$at();
}
function $c1e5789890d2fb2f$var$U(t, o) {
    return $c1e5789890d2fb2f$var$nt(t, o), o.toastId;
}
function $c1e5789890d2fb2f$var$V(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $c1e5789890d2fb2f$var$Wt(o)
    };
}
function $c1e5789890d2fb2f$var$Q(t) {
    return (o, e)=>$c1e5789890d2fb2f$var$U(o, $c1e5789890d2fb2f$var$V(t, e));
}
function $c1e5789890d2fb2f$export$b410431fab84fa58(t, o) {
    return $c1e5789890d2fb2f$var$U(t, $c1e5789890d2fb2f$var$V("default", o));
}
$c1e5789890d2fb2f$export$b410431fab84fa58.loading = (t, o)=>$c1e5789890d2fb2f$var$U(t, $c1e5789890d2fb2f$var$V("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $c1e5789890d2fb2f$var$Gt(t, { pending: o, error: e, success: r }, s) {
    let l;
    o && (l = $c1e5789890d2fb2f$var$N(o) ? $c1e5789890d2fb2f$export$b410431fab84fa58.loading(o, s) : $c1e5789890d2fb2f$export$b410431fab84fa58.loading(o.render, {
        ...s,
        ...o
    }));
    let a = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, d = (T, g, v)=>{
        if (g == null) {
            $c1e5789890d2fb2f$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...a,
            ...s,
            data: v
        }, C = $c1e5789890d2fb2f$var$N(g) ? {
            render: g
        } : g;
        return l ? $c1e5789890d2fb2f$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $c1e5789890d2fb2f$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $c1e5789890d2fb2f$var$P(t) ? t() : t;
    return c.then((T)=>d("success", r, T)).catch((T)=>d("error", e, T)), c;
}
$c1e5789890d2fb2f$export$b410431fab84fa58.promise = $c1e5789890d2fb2f$var$Gt;
$c1e5789890d2fb2f$export$b410431fab84fa58.success = $c1e5789890d2fb2f$var$Q("success");
$c1e5789890d2fb2f$export$b410431fab84fa58.info = $c1e5789890d2fb2f$var$Q("info");
$c1e5789890d2fb2f$export$b410431fab84fa58.error = $c1e5789890d2fb2f$var$Q("error");
$c1e5789890d2fb2f$export$b410431fab84fa58.warning = $c1e5789890d2fb2f$var$Q("warning");
$c1e5789890d2fb2f$export$b410431fab84fa58.warn = $c1e5789890d2fb2f$export$b410431fab84fa58.warning;
$c1e5789890d2fb2f$export$b410431fab84fa58.dark = (t, o)=>$c1e5789890d2fb2f$var$U(t, $c1e5789890d2fb2f$var$V("default", {
        theme: "dark",
        ...o
    }));
function $c1e5789890d2fb2f$var$qt(t) {
    $c1e5789890d2fb2f$var$ht(t);
}
$c1e5789890d2fb2f$export$b410431fab84fa58.dismiss = $c1e5789890d2fb2f$var$qt;
$c1e5789890d2fb2f$export$b410431fab84fa58.clearWaitingQueue = $c1e5789890d2fb2f$var$Ct;
$c1e5789890d2fb2f$export$b410431fab84fa58.isActive = $c1e5789890d2fb2f$var$X;
$c1e5789890d2fb2f$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $c1e5789890d2fb2f$var$vt(t, o);
    if (e) {
        let { props: r, content: s } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $c1e5789890d2fb2f$var$at()
        };
        l.toastId !== t && (l.staleId = t);
        let a = l.render || s;
        delete l.render, $c1e5789890d2fb2f$var$U(a, l);
    }
};
$c1e5789890d2fb2f$export$b410431fab84fa58.done = (t)=>{
    $c1e5789890d2fb2f$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$c1e5789890d2fb2f$export$b410431fab84fa58.onChange = $c1e5789890d2fb2f$var$Pt;
$c1e5789890d2fb2f$export$b410431fab84fa58.play = (t)=>$c1e5789890d2fb2f$var$rt(!0, t);
$c1e5789890d2fb2f$export$b410431fab84fa58.pause = (t)=>$c1e5789890d2fb2f$var$rt(!1, t);
function $c1e5789890d2fb2f$var$It(t) {
    var a;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $8nGP5.useRef)($c1e5789890d2fb2f$var$Et(t)).current;
    r(t);
    let s = (a = (0, $8nGP5.useSyncExternalStore)(o, e, e)) == null ? void 0 : a.slice();
    function l(d) {
        if (!s) return [];
        let c = new Map;
        return t.newestOnTop && s.reverse(), s.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>d(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $c1e5789890d2fb2f$var$X,
        count: s == null ? void 0 : s.length
    };
}
function $c1e5789890d2fb2f$var$At(t) {
    let [o, e] = (0, $8nGP5.useState)(!1), [r, s] = (0, $8nGP5.useState)(!1), l = (0, $8nGP5.useRef)(null), a = (0, $8nGP5.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: d, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $c1e5789890d2fb2f$var$xt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $8nGP5.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", f), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", f), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            a.canCloseOnClick = !0, a.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (a.start = m.clientX, a.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (a.start = m.clientY, a.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: M, right: A } = l.current.getBoundingClientRect();
        m.nativeEvent.type !== "touchend" && t.pauseOnHover && m.clientX >= M && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : f();
    }
    function f() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        a.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (a.canDrag && _) {
            a.didMove = !0, o && p(), t.draggableDirection === "x" ? a.delta = m.clientX - a.start : a.delta = m.clientY - a.start, a.start !== m.clientX && (a.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${a.delta}px, var(--y)` : `0, calc(${a.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(a.delta / a.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (a.canDrag && a.didMove && m) {
            if (a.canDrag = !1, Math.abs(a.delta) > a.removalDistance) {
                s(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return d && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = f)), v && (h.onClick = (m)=>{
        g && g(m), a.canCloseOnClick && T(!0);
    }), {
        playToast: f,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $c1e5789890d2fb2f$var$Ot = typeof window != "undefined" ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);
var $c1e5789890d2fb2f$var$G = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $c1e5789890d2fb2f$var$ao(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $c1e5789890d2fb2f$var$so(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $c1e5789890d2fb2f$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $c1e5789890d2fb2f$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$G, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $c1e5789890d2fb2f$var$io() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $c1e5789890d2fb2f$export$4f13f83fd8bb1dac = {
    info: $c1e5789890d2fb2f$var$so,
    warning: $c1e5789890d2fb2f$var$ao,
    success: $c1e5789890d2fb2f$var$no,
    error: $c1e5789890d2fb2f$var$ro,
    spinner: $c1e5789890d2fb2f$var$io
}, $c1e5789890d2fb2f$var$lo = (t)=>t in $c1e5789890d2fb2f$export$4f13f83fd8bb1dac;
function $c1e5789890d2fb2f$var$Nt({ theme: t, type: o, isLoading: e, icon: r }) {
    let s = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($c1e5789890d2fb2f$var$P(r) ? s = r({
        ...l,
        isLoading: e
    }) : (0, $8nGP5.isValidElement)(r) ? s = (0, $8nGP5.cloneElement)(r, l) : e ? s = $c1e5789890d2fb2f$export$4f13f83fd8bb1dac.spinner() : $c1e5789890d2fb2f$var$lo(o) && (s = $c1e5789890d2fb2f$export$4f13f83fd8bb1dac[o](l))), s;
}
var $c1e5789890d2fb2f$var$wt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: s, playToast: l } = $c1e5789890d2fb2f$var$At(t), { closeButton: a, children: d, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: f, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: M, theme: A, ariaLabel: R } = t, D = (0, $ajIhI.default)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: M
    }), Y = $c1e5789890d2fb2f$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: D
    }) : (0, $ajIhI.default)(D, E), ft = $c1e5789890d2fb2f$var$Nt(t), dt = !!n || !c, j = {
        closeToast: x,
        type: g,
        theme: A
    }, H = null;
    return a === !1 || ($c1e5789890d2fb2f$var$P(a) ? H = a(j) : (0, $8nGP5.isValidElement)(a) ? H = (0, $8nGP5.cloneElement)(a, j) : H = $c1e5789890d2fb2f$var$yt(j)), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: Y,
        ...s,
        style: f,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": R
        }
    }, ft != null && (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: (0, $ajIhI.default)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, ft), $c1e5789890d2fb2f$var$tt(d, t, !o), H, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$gt, {
        ...b && !dt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: dt,
        progress: n || 0
    })));
};
var $c1e5789890d2fb2f$var$K = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $c1e5789890d2fb2f$export$d20e79fdc3899e95 = $c1e5789890d2fb2f$export$3ff7dc44d332d222($c1e5789890d2fb2f$var$K("bounce", !0)), $c1e5789890d2fb2f$export$d8dc01b5c85a37b9 = $c1e5789890d2fb2f$export$3ff7dc44d332d222($c1e5789890d2fb2f$var$K("slide", !0)), $c1e5789890d2fb2f$export$65cfd44a2050f99 = $c1e5789890d2fb2f$export$3ff7dc44d332d222($c1e5789890d2fb2f$var$K("zoom")), $c1e5789890d2fb2f$export$4d2fae537bd90431 = $c1e5789890d2fb2f$export$3ff7dc44d332d222($c1e5789890d2fb2f$var$K("flip"));
var $c1e5789890d2fb2f$var$_o = {
    position: "top-right",
    transition: $c1e5789890d2fb2f$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $c1e5789890d2fb2f$export$f2815235e76a62b9(t) {
    let o = {
        ...$c1e5789890d2fb2f$var$_o,
        ...t
    }, e = t.stacked, [r, s] = (0, $8nGP5.useState)(!0), l = (0, $8nGP5.useRef)(null), { getToastToRender: a, isToastActive: d, count: c } = $c1e5789890d2fb2f$var$It(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(f) {
        let p = (0, $ajIhI.default)("Toastify__toast-container", `Toastify__toast-container--${f}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $c1e5789890d2fb2f$var$P(T) ? T({
            position: f,
            rtl: v,
            defaultClassName: p
        }) : (0, $ajIhI.default)(p, $c1e5789890d2fb2f$var$B(T));
    }
    function E() {
        e && (s(!0), $c1e5789890d2fb2f$export$b410431fab84fa58.play());
    }
    return $c1e5789890d2fb2f$var$Ot(()=>{
        var f;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (f = o.position) == null ? void 0 : f.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m);
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${1 - (r ? u : 0)}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $8nGP5.useEffect)(()=>{
        function f(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b.querySelector('[tabIndex="0"]')) == null || i.focus(), s(!1), $c1e5789890d2fb2f$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (s(!0), $c1e5789890d2fb2f$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", f), ()=>{
            document.removeEventListener("keydown", f);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (s(!1), $c1e5789890d2fb2f$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, a((f, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
            tabIndex: -1,
            className: S(f),
            "data-stacked": e,
            style: b,
            key: `c-${f}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c1e5789890d2fb2f$var$wt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: d(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}


const $96c137ca70850e28$export$7a45779be0c29756 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const activeJobToaster = (0, $8nGP5.useRef)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    (0, $8nGP5.useEffect)(()=>{
        if (store.activeJob && store.activeJob.status == 'processing') {
            if (activeJobToaster.current == null) activeJobToaster.current = (0, $c1e5789890d2fb2f$export$b410431fab84fa58).info(`Analysis \r\n ${store.activeJob.task}`, {
                progress: 0,
                autoClose: false,
                closeButton: false
            });
            const progress = Math.min(store.activeJob.progress || 0, 0.99);
            (0, $c1e5789890d2fb2f$export$b410431fab84fa58).update(activeJobToaster.current, {
                render: (0, $kSbwP.jsxs)("span", {
                    style: {
                        marginLeft: 'auto'
                    },
                    children: [
                        store.activeJob.task,
                        ' ',
                        (0, $kSbwP.jsxs)("b", {
                            children: [
                                (progress * 100).toFixed(0),
                                "%"
                            ]
                        })
                    ]
                }),
                progress: progress
            });
        } else if (activeJobToaster.current) {
            (0, $c1e5789890d2fb2f$export$b410431fab84fa58).dismiss(activeJobToaster.current);
            activeJobToaster.current = null;
        }
    }, [
        store.activeJob
    ]);
    return null;
});




/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f4bbcf51f4268bcb$var$_extends() {
    $f4bbcf51f4268bcb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4bbcf51f4268bcb$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f4bbcf51f4268bcb$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f4bbcf51f4268bcb$export$e19cd5f9376f8cee || ($f4bbcf51f4268bcb$export$e19cd5f9376f8cee = {}));
const $f4bbcf51f4268bcb$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f4bbcf51f4268bcb$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f4bbcf51f4268bcb$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f4bbcf51f4268bcb$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f4bbcf51f4268bcb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
    }
    return $f4bbcf51f4268bcb$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f4bbcf51f4268bcb$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f4bbcf51f4268bcb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f4bbcf51f4268bcb$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f4bbcf51f4268bcb$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f4bbcf51f4268bcb$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f4bbcf51f4268bcb$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f4bbcf51f4268bcb$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f4bbcf51f4268bcb$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f4bbcf51f4268bcb$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f4bbcf51f4268bcb$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f4bbcf51f4268bcb$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f4bbcf51f4268bcb$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f4bbcf51f4268bcb$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        let location = $f4bbcf51f4268bcb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f4bbcf51f4268bcb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        let location = $f4bbcf51f4268bcb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f4bbcf51f4268bcb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f4bbcf51f4268bcb$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f4bbcf51f4268bcb$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f4bbcf51f4268bcb$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f4bbcf51f4268bcb$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f4bbcf51f4268bcb$var$ResultType || ($f4bbcf51f4268bcb$var$ResultType = {}));
const $f4bbcf51f4268bcb$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f4bbcf51f4268bcb$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($f4bbcf51f4268bcb$var$isIndexRoute(route)) {
            let indexRoute = $f4bbcf51f4268bcb$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f4bbcf51f4268bcb$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $f4bbcf51f4268bcb$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $f4bbcf51f4268bcb$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $f4bbcf51f4268bcb$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f4bbcf51f4268bcb$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f4bbcf51f4268bcb$var$flattenRoutes(routes);
    $f4bbcf51f4268bcb$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f4bbcf51f4268bcb$export$30d21fd6d7295f52(pathname);
        matches = $f4bbcf51f4268bcb$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $f4bbcf51f4268bcb$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f4bbcf51f4268bcb$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f4bbcf51f4268bcb$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $f4bbcf51f4268bcb$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f4bbcf51f4268bcb$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f4bbcf51f4268bcb$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f4bbcf51f4268bcb$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f4bbcf51f4268bcb$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f4bbcf51f4268bcb$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f4bbcf51f4268bcb$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f4bbcf51f4268bcb$var$paramRe = /^:[\w-]+$/;
const $f4bbcf51f4268bcb$var$dynamicSegmentValue = 3;
const $f4bbcf51f4268bcb$var$indexRouteValue = 2;
const $f4bbcf51f4268bcb$var$emptySegmentValue = 1;
const $f4bbcf51f4268bcb$var$staticSegmentValue = 10;
const $f4bbcf51f4268bcb$var$splatPenalty = -2;
const $f4bbcf51f4268bcb$var$isSplat = (s)=>s === "*";
function $f4bbcf51f4268bcb$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f4bbcf51f4268bcb$var$isSplat)) initialScore += $f4bbcf51f4268bcb$var$splatPenalty;
    if (index) initialScore += $f4bbcf51f4268bcb$var$indexRouteValue;
    return segments.filter((s)=>!$f4bbcf51f4268bcb$var$isSplat(s)).reduce((score, segment)=>score + ($f4bbcf51f4268bcb$var$paramRe.test(segment) ? $f4bbcf51f4268bcb$var$dynamicSegmentValue : segment === "" ? $f4bbcf51f4268bcb$var$emptySegmentValue : $f4bbcf51f4268bcb$var$staticSegmentValue), initialScore);
}
function $f4bbcf51f4268bcb$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f4bbcf51f4268bcb$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f4bbcf51f4268bcb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f4bbcf51f4268bcb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f4bbcf51f4268bcb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f4bbcf51f4268bcb$export$a5c6d149b50c1d86($f4bbcf51f4268bcb$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f4bbcf51f4268bcb$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $f4bbcf51f4268bcb$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $f4bbcf51f4268bcb$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f4bbcf51f4268bcb$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f4bbcf51f4268bcb$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f4bbcf51f4268bcb$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f4bbcf51f4268bcb$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $f4bbcf51f4268bcb$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f4bbcf51f4268bcb$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f4bbcf51f4268bcb$var$normalizeSearch(search),
        hash: $f4bbcf51f4268bcb$var$normalizeHash(hash)
    };
}
function $f4bbcf51f4268bcb$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f4bbcf51f4268bcb$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f4bbcf51f4268bcb$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f4bbcf51f4268bcb$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f4bbcf51f4268bcb$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f4bbcf51f4268bcb$var$_extends({}, toArg);
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f4bbcf51f4268bcb$var$getInvalidPathError("?", "pathname", "search", to));
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f4bbcf51f4268bcb$var$getInvalidPathError("#", "pathname", "hash", to));
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f4bbcf51f4268bcb$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f4bbcf51f4268bcb$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f4bbcf51f4268bcb$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f4bbcf51f4268bcb$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f4bbcf51f4268bcb$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f4bbcf51f4268bcb$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f4bbcf51f4268bcb$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $f4bbcf51f4268bcb$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f4bbcf51f4268bcb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f4bbcf51f4268bcb$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $f4bbcf51f4268bcb$export$4051a07651545597(data, init) {
    return new $f4bbcf51f4268bcb$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a extends Error {
}
class $f4bbcf51f4268bcb$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f4bbcf51f4268bcb$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $f4bbcf51f4268bcb$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f4bbcf51f4268bcb$var$unwrapTrackedPromise(value) {
    if (!$f4bbcf51f4268bcb$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $f4bbcf51f4268bcb$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f4bbcf51f4268bcb$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f4bbcf51f4268bcb$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f4bbcf51f4268bcb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f4bbcf51f4268bcb$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f4bbcf51f4268bcb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f4bbcf51f4268bcb$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f4bbcf51f4268bcb$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f4bbcf51f4268bcb$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f4bbcf51f4268bcb$var$validMutationMethods = new Set($f4bbcf51f4268bcb$var$validMutationMethodsArr);
const $f4bbcf51f4268bcb$var$validRequestMethodsArr = [
    "get",
    ...$f4bbcf51f4268bcb$var$validMutationMethodsArr
];
const $f4bbcf51f4268bcb$var$validRequestMethods = new Set($f4bbcf51f4268bcb$var$validRequestMethodsArr);
const $f4bbcf51f4268bcb$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f4bbcf51f4268bcb$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f4bbcf51f4268bcb$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f4bbcf51f4268bcb$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f4bbcf51f4268bcb$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f4bbcf51f4268bcb$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f4bbcf51f4268bcb$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $f4bbcf51f4268bcb$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $f4bbcf51f4268bcb$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $f4bbcf51f4268bcb$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f4bbcf51f4268bcb$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f4bbcf51f4268bcb$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f4bbcf51f4268bcb$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f4bbcf51f4268bcb$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f4bbcf51f4268bcb$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f4bbcf51f4268bcb$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f4bbcf51f4268bcb$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f4bbcf51f4268bcb$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f4bbcf51f4268bcb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f4bbcf51f4268bcb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f4bbcf51f4268bcb$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f4bbcf51f4268bcb$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $f4bbcf51f4268bcb$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f4bbcf51f4268bcb$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $f4bbcf51f4268bcb$var$findNearestBoundary(matches).route.id,
            {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $f4bbcf51f4268bcb$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($f4bbcf51f4268bcb$var$isErrorResult(result) && $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $f4bbcf51f4268bcb$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f4bbcf51f4268bcb$var$_extends({
            matches: updatedMatches || matches
        }, $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f4bbcf51f4268bcb$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f4bbcf51f4268bcb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $f4bbcf51f4268bcb$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $f4bbcf51f4268bcb$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $f4bbcf51f4268bcb$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $f4bbcf51f4268bcb$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f4bbcf51f4268bcb$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($f4bbcf51f4268bcb$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $f4bbcf51f4268bcb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f4bbcf51f4268bcb$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f4bbcf51f4268bcb$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f4bbcf51f4268bcb$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $f4bbcf51f4268bcb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $f4bbcf51f4268bcb$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f4bbcf51f4268bcb$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f4bbcf51f4268bcb$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f4bbcf51f4268bcb$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f4bbcf51f4268bcb$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $f4bbcf51f4268bcb$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f4bbcf51f4268bcb$var$isRedirectResult(actionResult) || $f4bbcf51f4268bcb$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f4bbcf51f4268bcb$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f4bbcf51f4268bcb$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f4bbcf51f4268bcb$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f4bbcf51f4268bcb$var$isDeferredResult(actionResult)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f4bbcf51f4268bcb$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f4bbcf51f4268bcb$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f4bbcf51f4268bcb$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $f4bbcf51f4268bcb$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f4bbcf51f4268bcb$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $f4bbcf51f4268bcb$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) result = await $f4bbcf51f4268bcb$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!$f4bbcf51f4268bcb$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f4bbcf51f4268bcb$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $f4bbcf51f4268bcb$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $f4bbcf51f4268bcb$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f4bbcf51f4268bcb$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Replace : $f4bbcf51f4268bcb$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f4bbcf51f4268bcb$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $f4bbcf51f4268bcb$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f4bbcf51f4268bcb$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f4bbcf51f4268bcb$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $f4bbcf51f4268bcb$var$ResultType.redirect,
                response: $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $f4bbcf51f4268bcb$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $f4bbcf51f4268bcb$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $f4bbcf51f4268bcb$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $f4bbcf51f4268bcb$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f4bbcf51f4268bcb$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f4bbcf51f4268bcb$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f4bbcf51f4268bcb$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f4bbcf51f4268bcb$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $f4bbcf51f4268bcb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f4bbcf51f4268bcb$export$4d0306f8f6a4585b = Symbol("deferred");
function $f4bbcf51f4268bcb$export$3336b097a6fbc59a(routes, opts) {
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f4bbcf51f4268bcb$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f4bbcf51f4268bcb$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f4bbcf51f4268bcb$var$createLocation("", $f4bbcf51f4268bcb$export$fe53371bee54353d(url), null, "default");
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f4bbcf51f4268bcb$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f4bbcf51f4268bcb$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($f4bbcf51f4268bcb$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f4bbcf51f4268bcb$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f4bbcf51f4268bcb$var$createLocation("", $f4bbcf51f4268bcb$export$fe53371bee54353d(url), null, "default");
        let matches = $f4bbcf51f4268bcb$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f4bbcf51f4268bcb$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f4bbcf51f4268bcb$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f4bbcf51f4268bcb$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($f4bbcf51f4268bcb$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f4bbcf51f4268bcb$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f4bbcf51f4268bcb$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f4bbcf51f4268bcb$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $f4bbcf51f4268bcb$var$isResponse(result) ? result : $f4bbcf51f4268bcb$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($f4bbcf51f4268bcb$var$isDataStrategyResult(e) && $f4bbcf51f4268bcb$var$isResponse(e.result)) {
                if (e.type === $f4bbcf51f4268bcb$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f4bbcf51f4268bcb$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            let error = $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f4bbcf51f4268bcb$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $f4bbcf51f4268bcb$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $f4bbcf51f4268bcb$var$_extends({}, context, {
                statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $f4bbcf51f4268bcb$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $f4bbcf51f4268bcb$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f4bbcf51f4268bcb$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategy || $f4bbcf51f4268bcb$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($f4bbcf51f4268bcb$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f4bbcf51f4268bcb$export$fec11da027c70692(routes, context, error) {
    let newContext = $f4bbcf51f4268bcb$var$_extends({}, context, {
        statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f4bbcf51f4268bcb$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f4bbcf51f4268bcb$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f4bbcf51f4268bcb$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f4bbcf51f4268bcb$export$cae722b0cc860f13(to ? to : ".", $f4bbcf51f4268bcb$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f4bbcf51f4268bcb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $f4bbcf51f4268bcb$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f4bbcf51f4268bcb$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f4bbcf51f4268bcb$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f4bbcf51f4268bcb$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f4bbcf51f4268bcb$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f4bbcf51f4268bcb$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f4bbcf51f4268bcb$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f4bbcf51f4268bcb$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f4bbcf51f4268bcb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f4bbcf51f4268bcb$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f4bbcf51f4268bcb$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f4bbcf51f4268bcb$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $f4bbcf51f4268bcb$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $f4bbcf51f4268bcb$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($f4bbcf51f4268bcb$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f4bbcf51f4268bcb$var$shouldRevalidateLoader(match, $f4bbcf51f4268bcb$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f4bbcf51f4268bcb$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f4bbcf51f4268bcb$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f4bbcf51f4268bcb$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f4bbcf51f4268bcb$var$shouldRevalidateLoader(fetcherMatch, $f4bbcf51f4268bcb$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f4bbcf51f4268bcb$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $f4bbcf51f4268bcb$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f4bbcf51f4268bcb$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f4bbcf51f4268bcb$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $f4bbcf51f4268bcb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$f4bbcf51f4268bcb$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $f4bbcf51f4268bcb$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $f4bbcf51f4268bcb$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$f4bbcf51f4268bcb$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f4bbcf51f4268bcb$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f4bbcf51f4268bcb$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$f4bbcf51f4268bcb$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f4bbcf51f4268bcb$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $f4bbcf51f4268bcb$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $f4bbcf51f4268bcb$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $f4bbcf51f4268bcb$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $f4bbcf51f4268bcb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $f4bbcf51f4268bcb$var$ResultType.data,
                result: undefined
            });
        };
        return $f4bbcf51f4268bcb$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $f4bbcf51f4268bcb$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f4bbcf51f4268bcb$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f4bbcf51f4268bcb$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f4bbcf51f4268bcb$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $f4bbcf51f4268bcb$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($f4bbcf51f4268bcb$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: e
            };
        }
        if (type === $f4bbcf51f4268bcb$var$ResultType.error) return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: new $f4bbcf51f4268bcb$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $f4bbcf51f4268bcb$var$ResultType.error) {
        if ($f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $f4bbcf51f4268bcb$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $f4bbcf51f4268bcb$var$ResultType.error,
                error: new $f4bbcf51f4268bcb$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: result,
            statusCode: $f4bbcf51f4268bcb$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($f4bbcf51f4268bcb$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $f4bbcf51f4268bcb$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $f4bbcf51f4268bcb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $f4bbcf51f4268bcb$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $f4bbcf51f4268bcb$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $f4bbcf51f4268bcb$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($f4bbcf51f4268bcb$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $f4bbcf51f4268bcb$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f4bbcf51f4268bcb$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f4bbcf51f4268bcb$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f4bbcf51f4268bcb$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f4bbcf51f4268bcb$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f4bbcf51f4268bcb$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(!$f4bbcf51f4268bcb$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f4bbcf51f4268bcb$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f4bbcf51f4268bcb$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f4bbcf51f4268bcb$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($f4bbcf51f4268bcb$var$isErrorResult(result)) {
            let boundaryMatch = $f4bbcf51f4268bcb$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f4bbcf51f4268bcb$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f4bbcf51f4268bcb$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f4bbcf51f4268bcb$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f4bbcf51f4268bcb$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f4bbcf51f4268bcb$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $f4bbcf51f4268bcb$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $f4bbcf51f4268bcb$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f4bbcf51f4268bcb$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f4bbcf51f4268bcb$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f4bbcf51f4268bcb$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $f4bbcf51f4268bcb$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f4bbcf51f4268bcb$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($f4bbcf51f4268bcb$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $f4bbcf51f4268bcb$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(path) : path;
    return $f4bbcf51f4268bcb$export$fe53371bee54353d($f4bbcf51f4268bcb$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f4bbcf51f4268bcb$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f4bbcf51f4268bcb$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $f4bbcf51f4268bcb$var$ResultType.data || result.type === $f4bbcf51f4268bcb$var$ResultType.error);
}
function $f4bbcf51f4268bcb$var$isRedirectDataStrategyResultResult(result) {
    return $f4bbcf51f4268bcb$var$isResponse(result.result) && $f4bbcf51f4268bcb$var$redirectStatusCodes.has(result.result.status);
}
function $f4bbcf51f4268bcb$var$isDeferredResult(result) {
    return result.type === $f4bbcf51f4268bcb$var$ResultType.deferred;
}
function $f4bbcf51f4268bcb$var$isErrorResult(result) {
    return result.type === $f4bbcf51f4268bcb$var$ResultType.error;
}
function $f4bbcf51f4268bcb$var$isRedirectResult(result) {
    return (result && result.type) === $f4bbcf51f4268bcb$var$ResultType.redirect;
}
function $f4bbcf51f4268bcb$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $f4bbcf51f4268bcb$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f4bbcf51f4268bcb$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f4bbcf51f4268bcb$var$isRedirectResponse(result) {
    if (!$f4bbcf51f4268bcb$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f4bbcf51f4268bcb$var$isValidMethod(method) {
    return $f4bbcf51f4268bcb$var$validRequestMethods.has(method.toLowerCase());
}
function $f4bbcf51f4268bcb$var$isMutationMethod(method) {
    return $f4bbcf51f4268bcb$var$validMutationMethods.has(method.toLowerCase());
}
async function $f4bbcf51f4268bcb$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f4bbcf51f4268bcb$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $f4bbcf51f4268bcb$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $f4bbcf51f4268bcb$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($f4bbcf51f4268bcb$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $f4bbcf51f4268bcb$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $f4bbcf51f4268bcb$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $f4bbcf51f4268bcb$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f4bbcf51f4268bcb$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f4bbcf51f4268bcb$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f4bbcf51f4268bcb$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f4bbcf51f4268bcb$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f4bbcf51f4268bcb$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f4bbcf51f4268bcb$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f4bbcf51f4268bcb$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f4bbcf51f4268bcb$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f4bbcf51f4268bcb$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f4bbcf51f4268bcb$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f4bbcf51f4268bcb$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f4bbcf51f4268bcb$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f4bbcf51f4268bcb$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f4bbcf51f4268bcb$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f4bbcf51f4268bcb$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f4bbcf51f4268bcb$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f4bbcf51f4268bcb$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8nGP5 = parcelRequire("8nGP5");

function $48e5d1fb97c993cc$var$_extends() {
    $48e5d1fb97c993cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48e5d1fb97c993cc$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $48e5d1fb97c993cc$export$3add0d5dce533e2e = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$145dfa71566a64dc = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$var$AwaitContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $48e5d1fb97c993cc$export$26749e8557646306 = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$c7914228fb69b0f5 = /*#__PURE__*/ $8nGP5.createContext(null);
const $48e5d1fb97c993cc$export$9072aa6dd1f93057 = /*#__PURE__*/ $8nGP5.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $48e5d1fb97c993cc$var$RouteErrorContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $48e5d1fb97c993cc$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $48e5d1fb97c993cc$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $48e5d1fb97c993cc$export$9c954a9d03d32f4a() {
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $48e5d1fb97c993cc$export$45d76561a5302f2b() {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $48e5d1fb97c993cc$export$1b3f31771c5d07c() {
    return $8nGP5.useContext($48e5d1fb97c993cc$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $48e5d1fb97c993cc$export$6c330e8992e8a295(pattern) {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    return $8nGP5.useMemo(()=>(0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(pattern, (0, $f4bbcf51f4268bcb$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $48e5d1fb97c993cc$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8nGP5.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $48e5d1fb97c993cc$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $48e5d1fb97c993cc$var$useNavigateStable() : $48e5d1fb97c993cc$var$useNavigateUnstable();
}
function $48e5d1fb97c993cc$var$useNavigateUnstable() {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let dataRouterContext = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8nGP5.useRef(false);
    $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8nGP5.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $48e5d1fb97c993cc$var$OutletContext = /*#__PURE__*/ $8nGP5.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $48e5d1fb97c993cc$export$4138103a3ae699cc() {
    return $8nGP5.useContext($48e5d1fb97c993cc$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $48e5d1fb97c993cc$export$a3be3530d8e40d0b(context) {
    let outlet = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $48e5d1fb97c993cc$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $48e5d1fb97c993cc$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8nGP5.useMemo(()=>(0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $48e5d1fb97c993cc$export$5d3fca4a98652595(routes, locationArg) {
    return $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: parentMatches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f4bbcf51f4268bcb$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $f4bbcf51f4268bcb$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $48e5d1fb97c993cc$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $48e5d1fb97c993cc$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f4bbcf51f4268bcb$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $48e5d1fb97c993cc$var$DefaultErrorComponent() {
    let error = $48e5d1fb97c993cc$export$ed527bf60f6e05f2();
    let message = (0, $f4bbcf51f4268bcb$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8nGP5.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8nGP5.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $48e5d1fb97c993cc$var$defaultErrorElement = /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$DefaultErrorComponent, null);
class $48e5d1fb97c993cc$var$RenderErrorBoundary extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $48e5d1fb97c993cc$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $48e5d1fb97c993cc$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $48e5d1fb97c993cc$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $48e5d1fb97c993cc$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8nGP5.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $48e5d1fb97c993cc$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($48e5d1fb97c993cc$var$DataRouterHook || {});
var $48e5d1fb97c993cc$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($48e5d1fb97c993cc$var$DataRouterStateHook || {});
function $48e5d1fb97c993cc$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $48e5d1fb97c993cc$var$useDataRouterContext(hookName) {
    let ctx = $8nGP5.useContext($48e5d1fb97c993cc$export$3add0d5dce533e2e);
    !ctx && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return ctx;
}
function $48e5d1fb97c993cc$var$useDataRouterState(hookName) {
    let state = $8nGP5.useContext($48e5d1fb97c993cc$export$145dfa71566a64dc);
    !state && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return state;
}
function $48e5d1fb97c993cc$var$useRouteContext(hookName) {
    let route = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    !route && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $48e5d1fb97c993cc$var$useCurrentRouteId(hookName) {
    let route = $48e5d1fb97c993cc$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $48e5d1fb97c993cc$export$5fc8298006ad9e58() {
    return $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $48e5d1fb97c993cc$export$d0fd4b7106de2769() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $48e5d1fb97c993cc$export$600dc272ed516c15() {
    let dataRouterContext = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseRevalidator);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRevalidator);
    return $8nGP5.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $48e5d1fb97c993cc$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseMatches);
    return $8nGP5.useMemo(()=>matches.map((m)=>(0, $f4bbcf51f4268bcb$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $48e5d1fb97c993cc$export$1448a5050d252c4d() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $48e5d1fb97c993cc$export$fd5d37484eab868d(routeId) {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $48e5d1fb97c993cc$export$fdc00f3f26066d5e() {
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseActionData);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $48e5d1fb97c993cc$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8nGP5.useContext($48e5d1fb97c993cc$var$RouteErrorContext);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteError);
    let routeId = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $48e5d1fb97c993cc$export$78a72ddb39bdd145() {
    let value = $8nGP5.useContext($48e5d1fb97c993cc$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $48e5d1fb97c993cc$export$17f53340677d5831() {
    let value = $8nGP5.useContext($48e5d1fb97c993cc$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $48e5d1fb97c993cc$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $48e5d1fb97c993cc$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseBlocker);
    let state = $48e5d1fb97c993cc$var$useDataRouterState($48e5d1fb97c993cc$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8nGP5.useState("");
    let blockerFunction = $8nGP5.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $48e5d1fb97c993cc$var$_extends({}, currentLocation, {
                pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $48e5d1fb97c993cc$var$_extends({}, nextLocation, {
                pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8nGP5.useEffect(()=>{
        let key = String(++$48e5d1fb97c993cc$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8nGP5.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f4bbcf51f4268bcb$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $48e5d1fb97c993cc$var$useNavigateStable() {
    let { router: router } = $48e5d1fb97c993cc$var$useDataRouterContext($48e5d1fb97c993cc$var$DataRouterHook.UseNavigateStable);
    let id = $48e5d1fb97c993cc$var$useCurrentRouteId($48e5d1fb97c993cc$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8nGP5.useRef(false);
    $48e5d1fb97c993cc$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8nGP5.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $48e5d1fb97c993cc$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $48e5d1fb97c993cc$var$alreadyWarned$1 = {};
function $48e5d1fb97c993cc$var$warningOnce(key, cond, message) {
    if (!cond && !$48e5d1fb97c993cc$var$alreadyWarned$1[key]) $48e5d1fb97c993cc$var$alreadyWarned$1[key] = true;
}
const $48e5d1fb97c993cc$var$alreadyWarned = {};
function $48e5d1fb97c993cc$var$warnOnce(key, message) {}
const $48e5d1fb97c993cc$var$logDeprecation = (flag, msg, link)=>$48e5d1fb97c993cc$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $48e5d1fb97c993cc$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $48e5d1fb97c993cc$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $48e5d1fb97c993cc$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $48e5d1fb97c993cc$var$START_TRANSITION = "startTransition";
const $48e5d1fb97c993cc$var$startTransitionImpl = $8nGP5[$48e5d1fb97c993cc$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $48e5d1fb97c993cc$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8nGP5.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        if (v7_startTransition && $48e5d1fb97c993cc$var$startTransitionImpl) $48e5d1fb97c993cc$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8nGP5.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8nGP5.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8nGP5.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8nGP5.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8nGP5.useEffect(()=>$48e5d1fb97c993cc$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $48e5d1fb97c993cc$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $48e5d1fb97c993cc$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $48e5d1fb97c993cc$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $48e5d1fb97c993cc$var$startTransitionImpl ? $48e5d1fb97c993cc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>$48e5d1fb97c993cc$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $48e5d1fb97c993cc$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $8nGP5.useContext($48e5d1fb97c993cc$export$26749e8557646306);
    let { matches: matches } = $8nGP5.useContext($48e5d1fb97c993cc$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $48e5d1fb97c993cc$export$45d76561a5302f2b();
    let navigate = $48e5d1fb97c993cc$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f4bbcf51f4268bcb$export$cae722b0cc860f13)(to, (0, $f4bbcf51f4268bcb$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8nGP5.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $48e5d1fb97c993cc$export$910ae8079b2c2852(props) {
    return $48e5d1fb97c993cc$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $48e5d1fb97c993cc$export$e7b0ac011bb776c6(_props) {
    (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $48e5d1fb97c993cc$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f4bbcf51f4268bcb$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$48e5d1fb97c993cc$export$9c954a9d03d32f4a() && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8nGP5.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $48e5d1fb97c993cc$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f4bbcf51f4268bcb$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8nGP5.useMemo(()=>{
        let trailingPathname = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $48e5d1fb97c993cc$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $48e5d1fb97c993cc$export$5d3fca4a98652595($48e5d1fb97c993cc$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $48e5d1fb97c993cc$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$ResolveAwait, null, children));
}
var $48e5d1fb97c993cc$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($48e5d1fb97c993cc$var$AwaitRenderStatus || {});
const $48e5d1fb97c993cc$var$neverSettledPromise = new Promise(()=>{});
class $48e5d1fb97c993cc$var$AwaitErrorBoundary extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $48e5d1fb97c993cc$var$AwaitRenderStatus.error : "_data" in promise ? $48e5d1fb97c993cc$var$AwaitRenderStatus.success : $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $48e5d1fb97c993cc$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error && promise._error instanceof (0, $f4bbcf51f4268bcb$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $48e5d1fb97c993cc$var$neverSettledPromise;
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $48e5d1fb97c993cc$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8nGP5.createElement($48e5d1fb97c993cc$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $48e5d1fb97c993cc$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $48e5d1fb97c993cc$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $48e5d1fb97c993cc$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8nGP5.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8nGP5.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8nGP5.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $48e5d1fb97c993cc$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $48e5d1fb97c993cc$export$e7b0ac011bb776c6) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $48e5d1fb97c993cc$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $48e5d1fb97c993cc$export$daf73786167a7f72(matches) {
    return $48e5d1fb97c993cc$var$_renderMatches(matches);
}
function $48e5d1fb97c993cc$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8nGP5.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8nGP5.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8nGP5.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $48e5d1fb97c993cc$export$f30f7e456d254e83(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $48e5d1fb97c993cc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $48e5d1fb97c993cc$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $0f551f4a4f916cc1$var$_extends() {
    $0f551f4a4f916cc1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f551f4a4f916cc1$var$_extends.apply(this, arguments);
}
function $0f551f4a4f916cc1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0f551f4a4f916cc1$var$defaultMethod = "get";
const $0f551f4a4f916cc1$var$defaultEncType = "application/x-www-form-urlencoded";
function $0f551f4a4f916cc1$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0f551f4a4f916cc1$var$isButtonElement(object) {
    return $0f551f4a4f916cc1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0f551f4a4f916cc1$var$isFormElement(object) {
    return $0f551f4a4f916cc1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0f551f4a4f916cc1$var$isInputElement(object) {
    return $0f551f4a4f916cc1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0f551f4a4f916cc1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0f551f4a4f916cc1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0f551f4a4f916cc1$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0f551f4a4f916cc1$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0f551f4a4f916cc1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0f551f4a4f916cc1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0f551f4a4f916cc1$var$_formDataSupportsSubmitter = null;
function $0f551f4a4f916cc1$var$isFormDataSubmitterSupported() {
    if ($0f551f4a4f916cc1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0f551f4a4f916cc1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0f551f4a4f916cc1$var$_formDataSupportsSubmitter = true;
    }
    return $0f551f4a4f916cc1$var$_formDataSupportsSubmitter;
}
const $0f551f4a4f916cc1$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0f551f4a4f916cc1$var$getFormEncType(encType) {
    if (encType != null && !$0f551f4a4f916cc1$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0f551f4a4f916cc1$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0f551f4a4f916cc1$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0f551f4a4f916cc1$var$defaultMethod;
        encType = $0f551f4a4f916cc1$var$getFormEncType(target.getAttribute("enctype")) || $0f551f4a4f916cc1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0f551f4a4f916cc1$var$isButtonElement(target) || $0f551f4a4f916cc1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0f551f4a4f916cc1$var$defaultMethod;
        encType = $0f551f4a4f916cc1$var$getFormEncType(target.getAttribute("formenctype")) || $0f551f4a4f916cc1$var$getFormEncType(form.getAttribute("enctype")) || $0f551f4a4f916cc1$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0f551f4a4f916cc1$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0f551f4a4f916cc1$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0f551f4a4f916cc1$var$defaultMethod;
        action = null;
        encType = $0f551f4a4f916cc1$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0f551f4a4f916cc1$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $0f551f4a4f916cc1$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $0f551f4a4f916cc1$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0f551f4a4f916cc1$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0f551f4a4f916cc1$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0f551f4a4f916cc1$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0f551f4a4f916cc1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0f551f4a4f916cc1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $48e5d1fb97c993cc$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0f551f4a4f916cc1$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f4bbcf51f4268bcb$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0f551f4a4f916cc1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f4bbcf51f4268bcb$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0f551f4a4f916cc1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $48e5d1fb97c993cc$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0f551f4a4f916cc1$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0f551f4a4f916cc1$var$_extends({}, state, {
        errors: $0f551f4a4f916cc1$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0f551f4a4f916cc1$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f4bbcf51f4268bcb$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0f551f4a4f916cc1$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8nGP5.createContext({
    isTransitioning: false
});
const $0f551f4a4f916cc1$export$148fd98d095596d4 = /*#__PURE__*/ $8nGP5.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0f551f4a4f916cc1$var$START_TRANSITION = "startTransition";
const $0f551f4a4f916cc1$var$startTransitionImpl = $8nGP5[$0f551f4a4f916cc1$var$START_TRANSITION];
const $0f551f4a4f916cc1$var$FLUSH_SYNC = "flushSync";
const $0f551f4a4f916cc1$var$flushSyncImpl = $fCKK7[$0f551f4a4f916cc1$var$FLUSH_SYNC];
const $0f551f4a4f916cc1$var$USE_ID = "useId";
const $0f551f4a4f916cc1$var$useIdImpl = $8nGP5[$0f551f4a4f916cc1$var$USE_ID];
function $0f551f4a4f916cc1$var$startTransitionSafe(cb) {
    if ($0f551f4a4f916cc1$var$startTransitionImpl) $0f551f4a4f916cc1$var$startTransitionImpl(cb);
    else cb();
}
function $0f551f4a4f916cc1$var$flushSyncSafe(cb) {
    if ($0f551f4a4f916cc1$var$flushSyncImpl) $0f551f4a4f916cc1$var$flushSyncImpl(cb);
    else cb();
}
class $0f551f4a4f916cc1$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0f551f4a4f916cc1$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8nGP5.useState(router.state);
    let [pendingState, setPendingState] = $8nGP5.useState();
    let [vtContext, setVtContext] = $8nGP5.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8nGP5.useState();
    let [transition, setTransition] = $8nGP5.useState();
    let [interruption, setInterruption] = $8nGP5.useState();
    let fetcherData = $8nGP5.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8nGP5.useCallback((cb)=>{
        if (v7_startTransition) $0f551f4a4f916cc1$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8nGP5.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0f551f4a4f916cc1$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0f551f4a4f916cc1$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0f551f4a4f916cc1$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0f551f4a4f916cc1$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0f551f4a4f916cc1$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8nGP5.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8nGP5.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0f551f4a4f916cc1$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8nGP5.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8nGP5.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8nGP5.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8nGP5.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8nGP5.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8nGP5.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8nGP5.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8nGP5.createElement($8nGP5.Fragment, null, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8nGP5.createElement($0f551f4a4f916cc1$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8nGP5.createElement($0f551f4a4f916cc1$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8nGP5.createElement($0f551f4a4f916cc1$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0f551f4a4f916cc1$var$MemoizedDataRoutes = /*#__PURE__*/ $8nGP5.memo($0f551f4a4f916cc1$var$DataRoutes);
function $0f551f4a4f916cc1$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $48e5d1fb97c993cc$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0f551f4a4f916cc1$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $0f551f4a4f916cc1$var$startTransitionImpl ? $0f551f4a4f916cc1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0f551f4a4f916cc1$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8nGP5.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f4bbcf51f4268bcb$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $0f551f4a4f916cc1$var$startTransitionImpl ? $0f551f4a4f916cc1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0f551f4a4f916cc1$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8nGP5.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8nGP5.useCallback((newState)=>{
        v7_startTransition && $0f551f4a4f916cc1$var$startTransitionImpl ? $0f551f4a4f916cc1$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8nGP5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8nGP5.useEffect(()=>(0, $48e5d1fb97c993cc$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $8nGP5.createElement((0, $48e5d1fb97c993cc$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0f551f4a4f916cc1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0f551f4a4f916cc1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0f551f4a4f916cc1$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8nGP5.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $0f551f4a4f916cc1$var$_objectWithoutPropertiesLoose(_ref7, $0f551f4a4f916cc1$var$_excluded);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0f551f4a4f916cc1$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0f551f4a4f916cc1$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $48e5d1fb97c993cc$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0f551f4a4f916cc1$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8nGP5.createElement("a", $0f551f4a4f916cc1$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0f551f4a4f916cc1$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8nGP5.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $0f551f4a4f916cc1$var$_objectWithoutPropertiesLoose(_ref8, $0f551f4a4f916cc1$var$_excluded2);
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let routerState = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0f551f4a4f916cc1$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8nGP5.createElement($0f551f4a4f916cc1$export$a6c7ac8248d6e38a, $0f551f4a4f916cc1$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0f551f4a4f916cc1$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8nGP5.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0f551f4a4f916cc1$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $0f551f4a4f916cc1$var$_objectWithoutPropertiesLoose(_ref9, $0f551f4a4f916cc1$var$_excluded3);
    let submit = $0f551f4a4f916cc1$export$47c85c6e3a081d3();
    let formAction = $0f551f4a4f916cc1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8nGP5.createElement("form", $0f551f4a4f916cc1$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0f551f4a4f916cc1$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0f551f4a4f916cc1$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0f551f4a4f916cc1$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0f551f4a4f916cc1$var$DataRouterHook || ($0f551f4a4f916cc1$var$DataRouterHook = {}));
var $0f551f4a4f916cc1$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0f551f4a4f916cc1$var$DataRouterStateHook || ($0f551f4a4f916cc1$var$DataRouterStateHook = {}));
// Internal hooks
function $0f551f4a4f916cc1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $0f551f4a4f916cc1$var$useDataRouterContext(hookName) {
    let ctx = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$3add0d5dce533e2e));
    !ctx && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0f551f4a4f916cc1$var$useDataRouterState(hookName) {
    let state = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$145dfa71566a64dc));
    !state && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0f551f4a4f916cc1$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8nGP5.useCallback((event)=>{
        if ($0f551f4a4f916cc1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(location) === (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0f551f4a4f916cc1$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8nGP5.useRef($0f551f4a4f916cc1$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8nGP5.useRef(false);
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let searchParams = $8nGP5.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0f551f4a4f916cc1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    let setSearchParams = $8nGP5.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0f551f4a4f916cc1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0f551f4a4f916cc1$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0f551f4a4f916cc1$var$fetcherId = 0;
let $0f551f4a4f916cc1$var$getUniqueFetcherId = ()=>"__" + String(++$0f551f4a4f916cc1$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0f551f4a4f916cc1$export$47c85c6e3a081d3() {
    let { router: router } = $0f551f4a4f916cc1$var$useDataRouterContext($0f551f4a4f916cc1$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let currentRouteId = (0, $48e5d1fb97c993cc$export$5fc8298006ad9e58)();
    return $8nGP5.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0f551f4a4f916cc1$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0f551f4a4f916cc1$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0f551f4a4f916cc1$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0f551f4a4f916cc1$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let routeContext = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$9072aa6dd1f93057));
    !routeContext && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0f551f4a4f916cc1$var$_extends({}, (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f4bbcf51f4268bcb$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f4bbcf51f4268bcb$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0f551f4a4f916cc1$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0f551f4a4f916cc1$var$useDataRouterContext($0f551f4a4f916cc1$var$DataRouterHook.UseFetcher);
    let state = $0f551f4a4f916cc1$var$useDataRouterState($0f551f4a4f916cc1$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8nGP5.useContext($0f551f4a4f916cc1$export$148fd98d095596d4);
    let route = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    !route && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0f551f4a4f916cc1$var$useIdImpl ? $0f551f4a4f916cc1$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8nGP5.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0f551f4a4f916cc1$var$getUniqueFetcherId());
    // Registration/cleanup
    $8nGP5.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8nGP5.useCallback((href, opts)=>{
        !routeId && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0f551f4a4f916cc1$export$47c85c6e3a081d3();
    let submit = $8nGP5.useCallback((target, opts)=>{
        submitImpl(target, $0f551f4a4f916cc1$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8nGP5.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8nGP5.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8nGP5.createElement($0f551f4a4f916cc1$export$a7fed597f4b8afd8, $0f551f4a4f916cc1$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f4bbcf51f4268bcb$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8nGP5.useMemo(()=>$0f551f4a4f916cc1$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0f551f4a4f916cc1$export$fa996778a3a31087() {
    let state = $0f551f4a4f916cc1$var$useDataRouterState($0f551f4a4f916cc1$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0f551f4a4f916cc1$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0f551f4a4f916cc1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0f551f4a4f916cc1$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0f551f4a4f916cc1$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0f551f4a4f916cc1$var$useDataRouterContext($0f551f4a4f916cc1$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0f551f4a4f916cc1$var$useDataRouterState($0f551f4a4f916cc1$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8nGP5.useContext((0, $48e5d1fb97c993cc$export$26749e8557646306));
    let location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    let matches = (0, $48e5d1fb97c993cc$export$2378eb7f5ff86053)();
    let navigation = (0, $48e5d1fb97c993cc$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8nGP5.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0f551f4a4f916cc1$var$usePageHide($8nGP5.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0f551f4a4f916cc1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0f551f4a4f916cc1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0f551f4a4f916cc1$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0f551f4a4f916cc1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0f551f4a4f916cc1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0f551f4a4f916cc1$var$_extends({}, location, {
                    pathname: (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0f551f4a4f916cc1$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8nGP5.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0f551f4a4f916cc1$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8nGP5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0f551f4a4f916cc1$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8nGP5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0f551f4a4f916cc1$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $48e5d1fb97c993cc$export$b273b3273281a049)(when);
    $8nGP5.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8nGP5.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0f551f4a4f916cc1$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8nGP5.useContext($0f551f4a4f916cc1$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f4bbcf51f4268bcb$export$3e9cee6b33872309)(false);
    let { basename: basename } = $0f551f4a4f916cc1$var$useDataRouterContext($0f551f4a4f916cc1$var$DataRouterHook.useViewTransitionState);
    let path = (0, $48e5d1fb97c993cc$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f4bbcf51f4268bcb$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f4bbcf51f4268bcb$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
const $a5cfab634e3a04d6$export$f51f4c4ede09e011 = (props)=>{
    const ref = (0, $8nGP5.useRef)();
    const id = props.id || '';
    const fillCell = props.fillCell || false;
    const direction = props.direction || 'row';
    const justify = props.justify || 'start';
    const wrap = props.wrap || 'nowrap';
    const alignItems = props.alignItems || 'stretch';
    const className = props.className || '';
    const inline = props.inline || false;
    const flexType = inline ? 'd-inline-flex' : 'd-flex';
    const classes = `${flexType} flex-${direction} justify-content-${justify} flex-${wrap} align-items-${alignItems} ${className} ${fillCell ? 'h-100 w-100' : ''}`;
    return (0, $kSbwP.jsx)("div", {
        id: id,
        className: classes,
        style: props.style,
        onClick: ()=>{
            if (props.onClick) props.onClick();
        },
        children: props.children
    });
};





var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");




class $02fdab2e48ca7872$export$28a0d76af7a168a {
    constructor(nav){
        Object.defineProperty(this, "nav", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: nav
        });
    }
    openLink(url) {
        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        if (ui.isKeyControlKeyDown) window.open(url, '_blank');
        else this.nav(url);
    }
    toReport(tickerId) {
        this.openLink(`/${tickerId}`);
    }
    back() {
        this.nav(-1);
    }
    home() {
        this.openLink('/');
    }
    knowledgeBase() {
        this.openLink('/knowledge');
    }
}
function $02fdab2e48ca7872$export$726c44d912e0140f() {
    const nav = (0, $48e5d1fb97c993cc$export$9770f232ac06a008)();
    return new $02fdab2e48ca7872$export$28a0d76af7a168a(nav);
}



var $87d9bcd99e124788$export$e8c9778bf415dd08;
var $87d9bcd99e124788$export$3dc9c18d68dcbf9a;
var $87d9bcd99e124788$export$becc9140d0e846f8;
var $87d9bcd99e124788$export$fb184b623420d9be;
$87d9bcd99e124788$export$e8c9778bf415dd08 = `vb520q_divider`;
$87d9bcd99e124788$export$3dc9c18d68dcbf9a = `vb520q_filenameText`;
$87d9bcd99e124788$export$becc9140d0e846f8 = `vb520q_thumb`;
$87d9bcd99e124788$export$fb184b623420d9be = `vb520q_title`;


var $8879a5b024ca9d42$exports = {};
$8879a5b024ca9d42$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


var $4c21b0df46793000$exports = {};
'use strict';
Object.defineProperty($4c21b0df46793000$exports, "__esModule", {
    value: true
});
var $b19883bf6c50b518$exports = {};

$parcel$defineInteropFlag($b19883bf6c50b518$exports);

$parcel$export($b19883bf6c50b518$exports, "__esModule", function () { return $b19883bf6c50b518$export$1e511d4a378977f5; }, function (v) { return $b19883bf6c50b518$export$1e511d4a378977f5 = v; });
$parcel$export($b19883bf6c50b518$exports, "default", function () { return $b19883bf6c50b518$export$2e2bcd8739ae039; }, function (v) { return $b19883bf6c50b518$export$2e2bcd8739ae039 = v; });
var $b19883bf6c50b518$export$1e511d4a378977f5;
var $b19883bf6c50b518$export$2e2bcd8739ae039;
"use strict";
$b19883bf6c50b518$export$1e511d4a378977f5 = true;
var $0107668699af6117$exports = {};

$0107668699af6117$exports = {
    "default": (parcelRequire("9HWmz")),
    __esModule: true
};


var $b19883bf6c50b518$var$_assign2 = $b19883bf6c50b518$var$_interopRequireDefault($0107668699af6117$exports);
function $b19883bf6c50b518$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b19883bf6c50b518$export$2e2bcd8739ae039 = $b19883bf6c50b518$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};


var $4c21b0df46793000$var$_extends3 = $4c21b0df46793000$var$_interopRequireDefault($b19883bf6c50b518$exports);
var $d1803123caaf0bdf$exports = {};

$d1803123caaf0bdf$exports = {
    "default": (parcelRequire("7kC0X")),
    __esModule: true
};


var $4c21b0df46793000$var$_getPrototypeOf2 = $4c21b0df46793000$var$_interopRequireDefault($d1803123caaf0bdf$exports);
var $8fbe2cbc4e7ce8ca$exports = {};

$parcel$defineInteropFlag($8fbe2cbc4e7ce8ca$exports);

$parcel$export($8fbe2cbc4e7ce8ca$exports, "__esModule", function () { return $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5; }, function (v) { return $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5 = v; });
$parcel$export($8fbe2cbc4e7ce8ca$exports, "default", function () { return $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039; }, function (v) { return $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039 = v; });
var $8fbe2cbc4e7ce8ca$export$1e511d4a378977f5;
var $8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039;
"use strict";
$8fbe2cbc4e7ce8ca$export$1e511d4a378977f5 = true;
$8fbe2cbc4e7ce8ca$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};


var $4c21b0df46793000$var$_classCallCheck3 = $4c21b0df46793000$var$_interopRequireDefault($8fbe2cbc4e7ce8ca$exports);
var $0b67a7dd7b08a285$exports = {};

$parcel$defineInteropFlag($0b67a7dd7b08a285$exports);

$parcel$export($0b67a7dd7b08a285$exports, "__esModule", function () { return $0b67a7dd7b08a285$export$1e511d4a378977f5; }, function (v) { return $0b67a7dd7b08a285$export$1e511d4a378977f5 = v; });
$parcel$export($0b67a7dd7b08a285$exports, "default", function () { return $0b67a7dd7b08a285$export$2e2bcd8739ae039; }, function (v) { return $0b67a7dd7b08a285$export$2e2bcd8739ae039 = v; });
var $0b67a7dd7b08a285$export$1e511d4a378977f5;
var $0b67a7dd7b08a285$export$2e2bcd8739ae039;
"use strict";
$0b67a7dd7b08a285$export$1e511d4a378977f5 = true;
var $ca42b4fdaa8cc95e$exports = {};

$ca42b4fdaa8cc95e$exports = {
    "default": (parcelRequire("kRrED")),
    __esModule: true
};


var $0b67a7dd7b08a285$var$_defineProperty2 = $0b67a7dd7b08a285$var$_interopRequireDefault($ca42b4fdaa8cc95e$exports);
function $0b67a7dd7b08a285$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$0b67a7dd7b08a285$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $0b67a7dd7b08a285$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();


var $4c21b0df46793000$var$_createClass3 = $4c21b0df46793000$var$_interopRequireDefault($0b67a7dd7b08a285$exports);
var $f44505b454109184$exports = {};

$parcel$defineInteropFlag($f44505b454109184$exports);

$parcel$export($f44505b454109184$exports, "__esModule", function () { return $f44505b454109184$export$1e511d4a378977f5; }, function (v) { return $f44505b454109184$export$1e511d4a378977f5 = v; });
$parcel$export($f44505b454109184$exports, "default", function () { return $f44505b454109184$export$2e2bcd8739ae039; }, function (v) { return $f44505b454109184$export$2e2bcd8739ae039 = v; });
var $f44505b454109184$export$1e511d4a378977f5;
var $f44505b454109184$export$2e2bcd8739ae039;
"use strict";
$f44505b454109184$export$1e511d4a378977f5 = true;
var $9e3b7384f5c31771$exports = {};

$parcel$defineInteropFlag($9e3b7384f5c31771$exports);

$parcel$export($9e3b7384f5c31771$exports, "__esModule", function () { return $9e3b7384f5c31771$export$1e511d4a378977f5; }, function (v) { return $9e3b7384f5c31771$export$1e511d4a378977f5 = v; });
$parcel$export($9e3b7384f5c31771$exports, "default", function () { return $9e3b7384f5c31771$export$2e2bcd8739ae039; }, function (v) { return $9e3b7384f5c31771$export$2e2bcd8739ae039 = v; });
var $9e3b7384f5c31771$export$1e511d4a378977f5;
var $9e3b7384f5c31771$export$2e2bcd8739ae039;
"use strict";
$9e3b7384f5c31771$export$1e511d4a378977f5 = true;
var $458c58f186e9b17f$exports = {};

$458c58f186e9b17f$exports = {
    "default": (parcelRequire("5nWeK")),
    __esModule: true
};


var $9e3b7384f5c31771$var$_iterator2 = $9e3b7384f5c31771$var$_interopRequireDefault($458c58f186e9b17f$exports);
var $68dfa0da1d64505a$exports = {};

$68dfa0da1d64505a$exports = {
    "default": (parcelRequire("awRwR")),
    __esModule: true
};


var $9e3b7384f5c31771$var$_symbol2 = $9e3b7384f5c31771$var$_interopRequireDefault($68dfa0da1d64505a$exports);
var $9e3b7384f5c31771$var$_typeof = typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && typeof $9e3b7384f5c31771$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && obj.constructor === $9e3b7384f5c31771$var$_symbol2.default && obj !== $9e3b7384f5c31771$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $9e3b7384f5c31771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9e3b7384f5c31771$export$2e2bcd8739ae039 = typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && $9e3b7384f5c31771$var$_typeof($9e3b7384f5c31771$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $9e3b7384f5c31771$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $9e3b7384f5c31771$var$_symbol2.default === "function" && obj.constructor === $9e3b7384f5c31771$var$_symbol2.default && obj !== $9e3b7384f5c31771$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $9e3b7384f5c31771$var$_typeof(obj);
};


var $f44505b454109184$var$_typeof3 = $f44505b454109184$var$_interopRequireDefault($9e3b7384f5c31771$exports);
function $f44505b454109184$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$f44505b454109184$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $f44505b454109184$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};


var $4c21b0df46793000$var$_possibleConstructorReturn3 = $4c21b0df46793000$var$_interopRequireDefault($f44505b454109184$exports);
var $c62b3f33f191c239$exports = {};

$parcel$defineInteropFlag($c62b3f33f191c239$exports);

$parcel$export($c62b3f33f191c239$exports, "__esModule", function () { return $c62b3f33f191c239$export$1e511d4a378977f5; }, function (v) { return $c62b3f33f191c239$export$1e511d4a378977f5 = v; });
$parcel$export($c62b3f33f191c239$exports, "default", function () { return $c62b3f33f191c239$export$2e2bcd8739ae039; }, function (v) { return $c62b3f33f191c239$export$2e2bcd8739ae039 = v; });
var $c62b3f33f191c239$export$1e511d4a378977f5;
var $c62b3f33f191c239$export$2e2bcd8739ae039;
"use strict";
$c62b3f33f191c239$export$1e511d4a378977f5 = true;
var $41bfbf96173944bd$exports = {};

$41bfbf96173944bd$exports = {
    "default": (parcelRequire("elpuD")),
    __esModule: true
};


var $c62b3f33f191c239$var$_setPrototypeOf2 = $c62b3f33f191c239$var$_interopRequireDefault($41bfbf96173944bd$exports);
var $8aaf46f087fe6360$exports = {};

$8aaf46f087fe6360$exports = {
    "default": (parcelRequire("iWNxk")),
    __esModule: true
};


var $c62b3f33f191c239$var$_create2 = $c62b3f33f191c239$var$_interopRequireDefault($8aaf46f087fe6360$exports);

var $c62b3f33f191c239$var$_typeof3 = $c62b3f33f191c239$var$_interopRequireDefault($9e3b7384f5c31771$exports);
function $c62b3f33f191c239$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$c62b3f33f191c239$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c62b3f33f191c239$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $c62b3f33f191c239$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c62b3f33f191c239$var$_setPrototypeOf2.default ? (0, $c62b3f33f191c239$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};


var $4c21b0df46793000$var$_inherits3 = $4c21b0df46793000$var$_interopRequireDefault($c62b3f33f191c239$exports);

var $8nGP5 = parcelRequire("8nGP5");
var $4c21b0df46793000$var$_react2 = $4c21b0df46793000$var$_interopRequireDefault($8nGP5);

var $ebCsu = parcelRequire("ebCsu");
var $4c21b0df46793000$var$_propTypes2 = $4c21b0df46793000$var$_interopRequireDefault($ebCsu);

var $2DQiR = parcelRequire("2DQiR");
var $4c21b0df46793000$var$_lottieWeb2 = $4c21b0df46793000$var$_interopRequireDefault($2DQiR);
function $4c21b0df46793000$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4c21b0df46793000$var$Lottie = function(_React$Component) {
    (0, $4c21b0df46793000$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $4c21b0df46793000$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $4c21b0df46793000$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $4c21b0df46793000$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $4c21b0df46793000$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $4c21b0df46793000$var$_createClass3.default)(Lottie, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: 'svg',
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $4c21b0df46793000$var$_extends3.default)({}, this.options, options);
                this.anim = $4c21b0df46793000$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
                this.setSpeed();
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $4c21b0df46793000$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $4c21b0df46793000$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: 'setSpeed',
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: 'setDirection',
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: 'playSegments',
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: 'registerEvents',
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'deRegisterEvents',
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === 'number') size = initial + 'px';
                    else size = initial || '100%';
                    return size;
                };
                var lottieStyles = (0, $4c21b0df46793000$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: 'hidden',
                    margin: '0 auto',
                    outline: 'none'
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $4c21b0df46793000$var$_react2.default.createElement('div', {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    'aria-label': ariaLabel,
                    tabIndex: '0'
                }));
            }
        }
    ]);
    return Lottie;
}($4c21b0df46793000$var$_react2.default.Component);
$4c21b0df46793000$exports.default = $4c21b0df46793000$var$Lottie;
$4c21b0df46793000$var$Lottie.propTypes = {
    eventListeners: $4c21b0df46793000$var$_propTypes2.default.arrayOf($4c21b0df46793000$var$_propTypes2.default.object),
    options: $4c21b0df46793000$var$_propTypes2.default.object.isRequired,
    height: $4c21b0df46793000$var$_propTypes2.default.oneOfType([
        $4c21b0df46793000$var$_propTypes2.default.string,
        $4c21b0df46793000$var$_propTypes2.default.number
    ]),
    width: $4c21b0df46793000$var$_propTypes2.default.oneOfType([
        $4c21b0df46793000$var$_propTypes2.default.string,
        $4c21b0df46793000$var$_propTypes2.default.number
    ]),
    isStopped: $4c21b0df46793000$var$_propTypes2.default.bool,
    isPaused: $4c21b0df46793000$var$_propTypes2.default.bool,
    speed: $4c21b0df46793000$var$_propTypes2.default.number,
    segments: $4c21b0df46793000$var$_propTypes2.default.arrayOf($4c21b0df46793000$var$_propTypes2.default.number),
    direction: $4c21b0df46793000$var$_propTypes2.default.number,
    ariaRole: $4c21b0df46793000$var$_propTypes2.default.string,
    ariaLabel: $4c21b0df46793000$var$_propTypes2.default.string,
    isClickToPauseDisabled: $4c21b0df46793000$var$_propTypes2.default.bool,
    title: $4c21b0df46793000$var$_propTypes2.default.string,
    style: $4c21b0df46793000$var$_propTypes2.default.object
};
$4c21b0df46793000$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: ''
};


const $a3827455c2ec81f0$export$7750bf75c5a3c423 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    var _a, _b, _c, _d;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($8879a5b024ca9d42$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    const jobs = store.jobs;
    if (((_a = store.activeJob) === null || _a === void 0 ? void 0 : _a.jobId) == p.jobId) return (0, $kSbwP.jsx)("div", {
        className: $87d9bcd99e124788$export$becc9140d0e846f8,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            justify: "between",
            alignItems: "center",
            direction: "column",
            fillCell: true,
            style: {
                padding: '10px 0px'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $87d9bcd99e124788$export$3dc9c18d68dcbf9a,
                    children: (_b = store.activeJob) === null || _b === void 0 ? void 0 : _b.fileName
                }),
                (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                    options: defaultOptionsLottie,
                    height: 300,
                    width: 300
                })
            ]
        })
    });
    else {
        const queueString = 'In Queue';
        return (0, $kSbwP.jsx)("div", {
            className: $87d9bcd99e124788$export$becc9140d0e846f8,
            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                justify: "between",
                alignItems: "center",
                direction: "column",
                fillCell: true,
                style: {
                    padding: '10px 0px'
                },
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $87d9bcd99e124788$export$fb184b623420d9be,
                        children: [
                            queueString,
                            ' ',
                            ((_c = store.jobs[p.jobId]) === null || _c === void 0 ? void 0 : _c.pdfPassword) !== undefined && (0, $kSbwP.jsx)("i", {
                                className: "bi bi-asterisk",
                                style: {
                                    fontSize: 25
                                }
                            })
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $87d9bcd99e124788$export$3dc9c18d68dcbf9a,
                        children: (_d = store.jobs[p.jobId]) === null || _d === void 0 ? void 0 : _d.fileName
                    })
                ]
            })
        });
    }
});


var $def1233c7c6126ed$export$34e0f9847d4c02dd;
$def1233c7c6126ed$export$34e0f9847d4c02dd = `zbMiIq_container`;



var $kSbwP = parcelRequire("kSbwP");

var $46a03b660b5bd4f2$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, $46a03b660b5bd4f2$exports) {
        classNames.default = classNames;
        $46a03b660b5bd4f2$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $8nGP5 = parcelRequire("8nGP5");
// Components

var $8tsi7 = parcelRequire("8tsi7");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");
var $95134dd252a1c141$exports = {};
var $84e62c9181c3ad9d$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $84e62c9181c3ad9d$var$_typeof = $1XeFJ.default;
var $e9fef0b183b3ed16$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $e9fef0b183b3ed16$var$_typeof = $1XeFJ.default;
function $e9fef0b183b3ed16$var$toPrimitive(t, r) {
    if ("object" != $e9fef0b183b3ed16$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e9fef0b183b3ed16$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$e9fef0b183b3ed16$exports = $e9fef0b183b3ed16$var$toPrimitive, $e9fef0b183b3ed16$exports.__esModule = true, $e9fef0b183b3ed16$exports["default"] = $e9fef0b183b3ed16$exports;


function $84e62c9181c3ad9d$var$toPropertyKey(t) {
    var i = $e9fef0b183b3ed16$exports(t, "string");
    return "symbol" == $84e62c9181c3ad9d$var$_typeof(i) ? i : i + "";
}
$84e62c9181c3ad9d$exports = $84e62c9181c3ad9d$var$toPropertyKey, $84e62c9181c3ad9d$exports.__esModule = true, $84e62c9181c3ad9d$exports["default"] = $84e62c9181c3ad9d$exports;


function $95134dd252a1c141$var$_defineProperty(e, r, t) {
    return (r = $84e62c9181c3ad9d$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$95134dd252a1c141$exports = $95134dd252a1c141$var$_defineProperty, $95134dd252a1c141$exports.__esModule = true, $95134dd252a1c141$exports["default"] = $95134dd252a1c141$exports;


var $087fe1b2c8dfed8f$exports = {};

var $68UY6 = parcelRequire("68UY6");
function $087fe1b2c8dfed8f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $68UY6(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$087fe1b2c8dfed8f$exports = $087fe1b2c8dfed8f$var$_objectWithoutProperties, $087fe1b2c8dfed8f$exports.__esModule = true, $087fe1b2c8dfed8f$exports["default"] = $087fe1b2c8dfed8f$exports;


var $6fe20d3196595522$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $6fe20d3196595522$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $6fe20d3196595522$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6fe20d3196595522$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $6fe20d3196595522$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6fe20d3196595522$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6fe20d3196595522$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6fe20d3196595522$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6fe20d3196595522$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $6fe20d3196595522$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $6fe20d3196595522$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6fe20d3196595522$var$root = $6fe20d3196595522$var$freeGlobal || $6fe20d3196595522$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $6fe20d3196595522$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6fe20d3196595522$var$objectToString = $6fe20d3196595522$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6fe20d3196595522$var$nativeMax = Math.max, $6fe20d3196595522$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6fe20d3196595522$var$now = function() {
    return $6fe20d3196595522$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $6fe20d3196595522$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($6fe20d3196595522$var$FUNC_ERROR_TEXT);
    wait = $6fe20d3196595522$var$toNumber(wait) || 0;
    if ($6fe20d3196595522$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $6fe20d3196595522$var$nativeMax($6fe20d3196595522$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $6fe20d3196595522$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6fe20d3196595522$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6fe20d3196595522$var$now());
    }
    function debounced() {
        var time = $6fe20d3196595522$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6fe20d3196595522$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6fe20d3196595522$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6fe20d3196595522$var$isSymbol(value) {
    return typeof value == 'symbol' || $6fe20d3196595522$var$isObjectLike(value) && $6fe20d3196595522$var$objectToString.call(value) == $6fe20d3196595522$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6fe20d3196595522$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6fe20d3196595522$var$isSymbol(value)) return $6fe20d3196595522$var$NAN;
    if ($6fe20d3196595522$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6fe20d3196595522$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($6fe20d3196595522$var$reTrim, '');
    var isBinary = $6fe20d3196595522$var$reIsBinary.test(value);
    return isBinary || $6fe20d3196595522$var$reIsOctal.test(value) ? $6fe20d3196595522$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6fe20d3196595522$var$reIsBadHex.test(value) ? $6fe20d3196595522$var$NAN : +value;
}
$6fe20d3196595522$exports = $6fe20d3196595522$var$debounce;



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $178a7eb43675e020$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $8nGP5.useReducer)((state)=>!state, false);
    return dispatch;
}



var $8nGP5 = parcelRequire("8nGP5");
function $2d88d745050e62ad$export$2e2bcd8739ae039(value) {
    const ref = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}




var $ebCsu = parcelRequire("ebCsu");
var $5e8ba3c9c2c5ca78$export$54df5a921294d7ab = [
    'justify',
    'left',
    'right'
];
var $5e8ba3c9c2c5ca78$export$365087e449b345ed = 'label';
var $5e8ba3c9c2c5ca78$export$57732b6846a8df7c = [
    'lg',
    'sm'
];


var $250d2e1099d426ec$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $250d2e1099d426ec$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$250d2e1099d426ec$exports = $250d2e1099d426ec$var$invariant;



function $818312df3dbb7671$export$2e2bcd8739ae039(labelKey) {
    return typeof labelKey === 'string' ? labelKey : (0, $5e8ba3c9c2c5ca78$export$365087e449b345ed);
}


/**
 * Check if an object has the given property in a type-safe way.
 */ function $8fc2d9bda1008216$export$2e2bcd8739ae039(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}


var $11373711587d158e$var$idCounter = 0;
function $11373711587d158e$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $11373711587d158e$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $11373711587d158e$export$8793edee2d425525() {}
function $11373711587d158e$export$357523c63a2253b9(obj, keys) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var result = {};
    keys.forEach(function(key) {
        result[key] = obj[key];
    });
    return result;
}
function $11373711587d158e$export$8b15d37bc3f197d4(prefix) {
    $11373711587d158e$var$idCounter += 1;
    return (prefix == null ? '' : String(prefix)) + $11373711587d158e$var$idCounter;
}


/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */ function $6668b6b2d47a8092$var$getOptionLabel(option, labelKey) {
    // Handle internally created options first.
    if (!(0, $11373711587d158e$export$844ec244b1367d54)(option) && ((0, $8fc2d9bda1008216$export$2e2bcd8739ae039)(option, 'paginationOption') || (0, $8fc2d9bda1008216$export$2e2bcd8739ae039)(option, 'customOption'))) return option[(0, $818312df3dbb7671$export$2e2bcd8739ae039)(labelKey)];
    var optionLabel;
    if ((0, $11373711587d158e$export$f6e2535fb5126e54)(labelKey)) optionLabel = labelKey(option);
    else if ((0, $11373711587d158e$export$844ec244b1367d54)(option)) optionLabel = option;
    else // `option` is an object and `labelKey` is a string.
    optionLabel = option[labelKey];
    !(0, $11373711587d158e$export$844ec244b1367d54)(optionLabel) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    return optionLabel;
}
var $6668b6b2d47a8092$export$2e2bcd8739ae039 = $6668b6b2d47a8092$var$getOptionLabel;



function $1d5aef206a95a5de$var$addCustomOption(results, props) {
    var allowNew = props.allowNew, labelKey = props.labelKey, text = props.text;
    if (!allowNew || !text.trim()) return false;
    // If the consumer has provided a callback, use that to determine whether or
    // not to add the custom option.
    if ((0, $11373711587d158e$export$f6e2535fb5126e54)(allowNew)) return allowNew(results, props);
    // By default, don't add the custom option if there is an exact text match
    // with an existing option.
    return !results.some(function(o) {
        return (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(o, labelKey) === text;
    });
}
var $1d5aef206a95a5de$export$2e2bcd8739ae039 = $1d5aef206a95a5de$var$addCustomOption;


var $60aa457c0b214a25$exports = {};
'use strict';
// do not edit .js files directly - edit src/index.jst
$60aa457c0b214a25$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



function $61a1fe5993bb42a6$export$2e2bcd8739ae039(option, key) {
    if ((0, $11373711587d158e$export$844ec244b1367d54)(option)) return undefined;
    return option[key];
}



// prettier-ignore
var $a724b9178702be8c$var$map = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'OE',
        letters: "\x8C\u0152"
    },
    {
        base: 'oe',
        letters: "\x9C\u0153"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
].reduce(function(acc, _ref) {
    var base = _ref.base, letters = _ref.letters;
    letters.split('').forEach(function(letter) {
        acc[letter] = base;
    });
    return acc;
}, {});
// Combining marks
var $a724b9178702be8c$var$latin = "\u0300-\u036F";
var $a724b9178702be8c$var$japanese = "\u3099\u309A";
function $a724b9178702be8c$export$2e2bcd8739ae039(str) {
    return str.normalize('NFD')// Remove combining diacritics
    .replace(new RegExp("[".concat($a724b9178702be8c$var$latin).concat($a724b9178702be8c$var$japanese, "]"), 'g'), '')/* eslint-disable-next-line no-control-regex */ .replace(/[^\u0000-\u007E]/g, function(a) {
        return $a724b9178702be8c$var$map[a] || a;
    });
}


var $ced47db6f467fbae$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ced47db6f467fbae$var$__DEV__ = false;
var $ced47db6f467fbae$var$warning = function() {};
if ($ced47db6f467fbae$var$__DEV__) {
    var $ced47db6f467fbae$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ced47db6f467fbae$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ced47db6f467fbae$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ced47db6f467fbae$exports = $ced47db6f467fbae$var$warning;


var $b7e31a327d03e94b$var$warned = {};
function $b7e31a327d03e94b$export$2e2bcd8739ae039(falseToWarn, message) {
    // Only issue deprecation warnings once.
    if (!falseToWarn && message.indexOf('deprecated') !== -1) {
        if ($b7e31a327d03e94b$var$warned[message]) return;
        $b7e31a327d03e94b$var$warned[message] = true;
    }
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports))).apply(void 0, [
        falseToWarn,
        "[react-bootstrap-typeahead] ".concat(message)
    ].concat(args));
}
function $b7e31a327d03e94b$export$60eef1277fe463e4() {
    $b7e31a327d03e94b$var$warned = {};
}


function $c5e48693defe599e$var$isMatch(input, string, props) {
    var searchStr = input;
    var str = string;
    if (!props.caseSensitive) {
        searchStr = searchStr.toLowerCase();
        str = str.toLowerCase();
    }
    if (props.ignoreDiacritics) {
        searchStr = (0, $a724b9178702be8c$export$2e2bcd8739ae039)(searchStr);
        str = (0, $a724b9178702be8c$export$2e2bcd8739ae039)(str);
    }
    return str.indexOf(searchStr) !== -1;
}
function $c5e48693defe599e$export$2e2bcd8739ae039(option, props) {
    var filterBy = props.filterBy, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    // Don't show selected options in the menu for the multi-select case.
    if (multiple && selected.some(function(o) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(o, option);
    })) return false;
    if ((0, $11373711587d158e$export$f6e2535fb5126e54)(labelKey)) return $c5e48693defe599e$var$isMatch(text, labelKey(option), props);
    var fields = filterBy.slice();
    if ((0, $11373711587d158e$export$844ec244b1367d54)(labelKey)) // Add the `labelKey` field to the list of fields if it isn't already there.
    {
        if (fields.indexOf(labelKey) === -1) fields.unshift(labelKey);
    }
    if ((0, $11373711587d158e$export$844ec244b1367d54)(option)) {
        (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');
        return $c5e48693defe599e$var$isMatch(text, option, props);
    }
    return fields.some(function(field) {
        var value = (0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, field);
        if (!(0, $11373711587d158e$export$844ec244b1367d54)(value)) {
            (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(false, "Fields passed to `filterBy` should have string values. Value will be converted to a string; results may be unexpected.");
            value = String(value);
        }
        return $c5e48693defe599e$var$isMatch(text, value, props);
    });
}


/**
 * Check if an input type is selectable, based on WHATWG spec.
 *
 * See:
 *  - https://stackoverflow.com/questions/21177489/selectionstart-selectionend-on-input-type-number-no-longer-allowed-in-chrome/24175357
 *  - https://html.spec.whatwg.org/multipage/input.html#do-not-apply
 */ function $28e09257a3fd8d03$export$2e2bcd8739ae039(inputNode) {
    return inputNode.selectionStart != null;
}


function $ed18b1e84ef65594$export$2e2bcd8739ae039(e, selectHint) {
    var shouldSelectHint = false;
    if (e.key === 'ArrowRight') // For selectable input types ("text", "search"), only select the hint if
    // it's at the end of the input value. For non-selectable types ("email",
    // "number"), always select the hint.
    shouldSelectHint = (0, $28e09257a3fd8d03$export$2e2bcd8739ae039)(e.currentTarget) ? e.currentTarget.selectionStart === e.currentTarget.value.length : true;
    if (e.key === 'Tab') {
        // Prevent input from blurring on TAB.
        e.preventDefault();
        shouldSelectHint = true;
    }
    return selectHint ? selectHint(shouldSelectHint, e) : shouldSelectHint;
}


// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6198e38015028611$export$2e2bcd8739ae039(Component) {
    return Component.displayName || Component.name || 'Component';
}




var $63528407dbac2a37$var$CASE_INSENSITIVE = 'i';
var $63528407dbac2a37$var$COMBINING_MARKS = /[\u0300-\u036F]/;
function $63528407dbac2a37$export$691f87e685a5fa78(str) {
    !(typeof str === 'string') && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    // Escape characters with special meaning either inside or outside character
    // sets. Use a simple backslash escape when it’s always valid, and a \unnnn
    // escape when the simpler form would be disallowed by Unicode patterns’
    // stricter grammar.
    return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
function $63528407dbac2a37$export$2e2bcd8739ae039(subject, str) {
    var search = new RegExp($63528407dbac2a37$export$691f87e685a5fa78((0, $a724b9178702be8c$export$2e2bcd8739ae039)(str)), $63528407dbac2a37$var$CASE_INSENSITIVE);
    var matches = search.exec((0, $a724b9178702be8c$export$2e2bcd8739ae039)(subject));
    if (!matches) return null;
    var start = matches.index;
    var matchLength = matches[0].length;
    // Account for combining marks, which changes the indices.
    if ($63528407dbac2a37$var$COMBINING_MARKS.test(subject)) {
        // Starting at the beginning of the subject string, check for the number of
        // combining marks and increment the start index whenever one is found.
        for(var ii = 0; ii <= start; ii++)if ($63528407dbac2a37$var$COMBINING_MARKS.test(subject[ii])) start += 1;
        // Similarly, increment the length of the match string if it contains a
        // combining mark.
        for(var _ii = start; _ii <= start + matchLength; _ii++)if ($63528407dbac2a37$var$COMBINING_MARKS.test(subject[_ii])) matchLength += 1;
    }
    return {
        end: start + matchLength,
        start: start
    };
}





function $a1711cda6d7da6d6$var$getHintText(_ref) {
    var activeIndex = _ref.activeIndex, initialItem = _ref.initialItem, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, labelKey = _ref.labelKey, multiple = _ref.multiple, selected = _ref.selected, text = _ref.text;
    // Don't display a hint under the following conditions:
    if (// No text entered.
    !text || // The input is not focused.
    !isFocused || // The menu is hidden.
    !isMenuShown || // No item in the menu.
    !initialItem || // The initial item is a custom option.
    !(0, $11373711587d158e$export$844ec244b1367d54)(initialItem) && (0, $8fc2d9bda1008216$export$2e2bcd8739ae039)(initialItem, 'customOption') || // The initial item is disabled
    !(0, $11373711587d158e$export$844ec244b1367d54)(initialItem) && initialItem.disabled || // One of the menu items is active.
    activeIndex > -1 || // There's already a selection in single-select mode.
    !!selected.length && !multiple) return '';
    var initialItemStr = (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(initialItem, labelKey);
    var bounds = (0, $63528407dbac2a37$export$2e2bcd8739ae039)(initialItemStr.toLowerCase(), text.toLowerCase());
    if (!(bounds && bounds.start === 0)) return '';
    // Text matching is case- and accent-insensitive, so to display the hint
    // correctly, splice the input string with the hint string.
    return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}
var $a1711cda6d7da6d6$export$2e2bcd8739ae039 = $a1711cda6d7da6d6$var$getHintText;





function $5425939472d679db$export$2e2bcd8739ae039() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var position = arguments.length > 1 ? arguments[1] : undefined;
    return "".concat(id, "-item-").concat(position);
}



var $e8fe15ba48f4ce2a$var$_excluded = [
    "activeIndex",
    "id",
    "isFocused",
    "isMenuShown",
    "multiple",
    "onClick",
    "onFocus",
    "placeholder"
];
function $e8fe15ba48f4ce2a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e8fe15ba48f4ce2a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e8fe15ba48f4ce2a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e8fe15ba48f4ce2a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e8fe15ba48f4ce2a$var$getInputProps = function getInputProps(_ref) {
    var activeIndex = _ref.activeIndex, id = _ref.id, isFocused = _ref.isFocused, isMenuShown = _ref.isMenuShown, multiple = _ref.multiple, onClick = _ref.onClick, onFocus = _ref.onFocus, placeholder = _ref.placeholder, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $e8fe15ba48f4ce2a$var$_excluded);
    return function() {
        var _cx;
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var className = (0, $8fc2d9bda1008216$export$2e2bcd8739ae039)(inputProps, 'className') ? String(inputProps.className) : undefined;
        return $e8fe15ba48f4ce2a$var$_objectSpread($e8fe15ba48f4ce2a$var$_objectSpread($e8fe15ba48f4ce2a$var$_objectSpread($e8fe15ba48f4ce2a$var$_objectSpread({
            // These props can be overridden by values in `inputProps`.
            autoComplete: 'off',
            placeholder: placeholder,
            type: 'text'
        }, inputProps), props), {}, {
            'aria-activedescendant': activeIndex >= 0 ? (0, $5425939472d679db$export$2e2bcd8739ae039)(id, activeIndex) : undefined,
            'aria-autocomplete': 'both',
            'aria-expanded': isMenuShown,
            'aria-haspopup': 'listbox',
            'aria-multiselectable': multiple || undefined,
            'aria-owns': isMenuShown ? id : undefined,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))((_cx = {}, (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_cx, className || '', !multiple), (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_cx, "focus", isFocused), _cx))
        }, multiple && {
            inputClassName: className
        }), {}, {
            onClick: onClick,
            onFocus: onFocus,
            role: 'combobox'
        });
    };
};
var $e8fe15ba48f4ce2a$export$2e2bcd8739ae039 = $e8fe15ba48f4ce2a$var$getInputProps;



function $22b87da6e9dce42c$var$getInputText(props) {
    var activeItem = props.activeItem, labelKey = props.labelKey, multiple = props.multiple, selected = props.selected, text = props.text;
    if (activeItem) // Display the input value if the pagination item is active.
    return (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(activeItem, labelKey);
    if (!multiple && selected.length && selected[0]) return (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(selected[0], labelKey);
    return text;
}
var $22b87da6e9dce42c$export$2e2bcd8739ae039 = $22b87da6e9dce42c$var$getInputText;



function $f7964357ed06cb9c$var$getIsOnlyResult(props) {
    var allowNew = props.allowNew, highlightOnlyResult = props.highlightOnlyResult, results = props.results;
    if (!highlightOnlyResult || allowNew) return false;
    return results.length === 1 && !(0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(results[0], 'disabled');
}
var $f7964357ed06cb9c$export$2e2bcd8739ae039 = $f7964357ed06cb9c$var$getIsOnlyResult;







/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */ function $486a6d4e4a177cb8$var$getTruncatedOptions(options, maxResults) {
    if (!maxResults || maxResults >= options.length) return options;
    return options.slice(0, maxResults);
}
var $486a6d4e4a177cb8$export$2e2bcd8739ae039 = $486a6d4e4a177cb8$var$getTruncatedOptions;



function $87c46f28122be0aa$export$30acd1b3e7561a3(index, items) {
    var option = items[index];
    return !!option && !!(0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, 'disabled');
}
function $87c46f28122be0aa$export$3b2e82793fda938f(currentIndex, key, items) {
    var newIndex = currentIndex;
    while($87c46f28122be0aa$export$30acd1b3e7561a3(newIndex, items))newIndex += key === 'ArrowUp' ? -1 : 1;
    return newIndex;
}
function $87c46f28122be0aa$export$2e2bcd8739ae039(currentIndex, key, items) {
    var newIndex = currentIndex;
    // Increment or decrement index based on user keystroke.
    newIndex += key === 'ArrowUp' ? -1 : 1;
    // Skip over any disabled options.
    newIndex = $87c46f28122be0aa$export$3b2e82793fda938f(newIndex, key, items);
    // If we've reached the end, go back to the beginning or vice-versa.
    if (newIndex === items.length) newIndex = -1;
    else if (newIndex === -2) {
        newIndex = items.length - 1;
        // Skip over any disabled options.
        newIndex = $87c46f28122be0aa$export$3b2e82793fda938f(newIndex, key, items);
    }
    return newIndex;
}




function $0a9074bba0bfd84d$export$2e2bcd8739ae039(_ref) {
    var open = _ref.open, minLength = _ref.minLength, showMenu = _ref.showMenu, text = _ref.text;
    // If menu visibility is controlled via props, that value takes precedence.
    if (open || open === false) return open;
    if (text.length < minLength) return false;
    return showMenu;
}



/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */ function $b6a46aad601ce360$export$2e2bcd8739ae039(e) {
    e.preventDefault();
}





function $5df0515af306a98d$export$650961c52e438122(size) {
    return size === 'lg';
}
function $5df0515af306a98d$export$93100e6f8d8c0365(size) {
    return size === 'sm';
}


var $3ee1870d9ae8f65e$var$_excluded = [
    "className",
    "isInvalid",
    "isValid",
    "size"
];
function $3ee1870d9ae8f65e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3ee1870d9ae8f65e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3ee1870d9ae8f65e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3ee1870d9ae8f65e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3ee1870d9ae8f65e$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, isInvalid = _ref.isInvalid, isValid = _ref.isValid, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $3ee1870d9ae8f65e$var$_excluded);
    return $3ee1870d9ae8f65e$var$_objectSpread($3ee1870d9ae8f65e$var$_objectSpread({}, props), {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('form-control', 'rbt-input', {
            'form-control-lg': (0, $5df0515af306a98d$export$650961c52e438122)(size),
            'form-control-sm': (0, $5df0515af306a98d$export$93100e6f8d8c0365)(size),
            'is-invalid': isInvalid,
            'is-valid': isValid
        }, className)
    });
}





function $2a03374cfcc5dc09$export$2e2bcd8739ae039(prevSelected, selected) {
    var uncontrolledToControlled = !prevSelected && selected;
    var controlledToUncontrolled = prevSelected && !selected;
    var from, to, precedent;
    if (uncontrolledToControlled) {
        from = 'uncontrolled';
        to = 'controlled';
        precedent = 'an';
    } else {
        from = 'controlled';
        to = 'uncontrolled';
        precedent = 'a';
    }
    var message = "You are changing ".concat(precedent, " ").concat(from, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from, " to ").concat(to, " (or vice versa). ") + 'Decide between using a controlled or uncontrolled element for the ' + 'lifetime of the component.';
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!(uncontrolledToControlled || controlledToUncontrolled), message);
}





var $845dede6ba74432c$var$INPUT_PROPS_BLACKLIST = [
    {
        alt: 'onBlur',
        prop: 'onBlur'
    },
    {
        alt: 'onInputChange',
        prop: 'onChange'
    },
    {
        alt: 'onFocus',
        prop: 'onFocus'
    },
    {
        alt: 'onKeyDown',
        prop: 'onKeyDown'
    }
];
var $845dede6ba74432c$export$9ae6167e9ee9e6d0 = (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf((0, $5e8ba3c9c2c5ca78$export$57732b6846a8df7c));
function $845dede6ba74432c$export$1c8c72d28a0627d2(validator, callback) {
    return function(props, propName, componentName) {
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({}, propName, validator), props, 'prop', componentName);
        (0, $11373711587d158e$export$f6e2535fb5126e54)(callback) && callback(props, propName, componentName);
    };
}
function $845dede6ba74432c$export$8a831d0ae116fbcd(props) {
    var caseSensitive = props.caseSensitive, filterBy = props.filterBy;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}
function $845dede6ba74432c$export$cdd73fc4100a6ef4(validator, reason) {
    return function(props, propName, componentName) {
        if (props[propName] != null) (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(false, "The `".concat(propName, "` prop is deprecated. ").concat(reason));
        return (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).checkPropTypes((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({}, propName, validator), props, 'prop', componentName);
    };
}
function $845dede6ba74432c$export$5534cbfe725ae92a(props) {
    var defaultInputValue = props.defaultInputValue, defaultSelected = props.defaultSelected, multiple = props.multiple, selected = props.selected;
    var name = defaultSelected.length ? 'defaultSelected' : 'selected';
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function $845dede6ba74432c$export$79f4757fa6baab77(props) {
    var defaultSelected = props.defaultSelected, multiple = props.multiple;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(multiple || defaultSelected.length <= 1, "You are passing multiple options to the `defaultSelected` prop of a Typeahead in single-select mode. The selections will be truncated to a single selection.");
}
function $845dede6ba74432c$export$f8e54140ea7ea3a8(_ref) {
    var allowNew = _ref.allowNew, highlightOnlyResult = _ref.highlightOnlyResult;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}
function $845dede6ba74432c$export$9b9aee2bc2e2973d(props) {
    var filterBy = props.filterBy, ignoreDiacritics = props.ignoreDiacritics;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}
function $845dede6ba74432c$export$82c0eddbd071e45f(_ref2) {
    var inputProps = _ref2.inputProps;
    if (!(inputProps && Object.prototype.toString.call(inputProps) === '[object Object]')) return;
    // Blacklisted properties.
    $845dede6ba74432c$var$INPUT_PROPS_BLACKLIST.forEach(function(_ref3) {
        var alt = _ref3.alt, prop = _ref3.prop;
        var msg = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
        (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg));
    });
}
function $845dede6ba74432c$export$50bb8c440cf2a42c(props, propName, componentName) {
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + 'accessible for users of assistive technologies such as screen readers.');
}
function $845dede6ba74432c$export$8ae4524d34467ed5(_ref4) {
    var allowNew = _ref4.allowNew, labelKey = _ref4.labelKey;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!((0, $11373711587d158e$export$f6e2535fb5126e54)(labelKey) && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}
var $845dede6ba74432c$export$7de5fae3688fa523 = (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
]);
function $845dede6ba74432c$export$1f1343c4475956f4(_ref5) {
    var multiple = _ref5.multiple, onChange = _ref5.onChange, selected = _ref5.selected;
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(multiple || !selected || selected.length <= 1, "You are passing multiple options to the `selected` prop of a Typeahead in single-select mode. This may lead to unexpected behaviors or errors.");
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(!selected || selected && (0, $11373711587d158e$export$f6e2535fb5126e54)(onChange), "You provided a `selected` prop without an `onChange` handler. If you want the typeahead to be uncontrolled, use `defaultSelected`. Otherwise, set `onChange`.");
}



var $e5c873bd330d4b52$var$_excluded = [
    "allowNew",
    "delay",
    "emptyLabel",
    "isLoading",
    "minLength",
    "onInputChange",
    "onSearch",
    "options",
    "promptText",
    "searchText",
    "useCache"
];
function $e5c873bd330d4b52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5c873bd330d4b52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5c873bd330d4b52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5c873bd330d4b52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e5c873bd330d4b52$var$propTypes = {
    /**
   * Delay, in milliseconds, before performing search.
   */ delay: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Whether or not a request is currently pending. Necessary for the
   * container to know when new results are available.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool.isRequired,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Callback to perform when the search is executed.
   */ onSearch: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func.isRequired,
    /**
   * Options to be passed to the typeahead. Will typically be the query
   * results, but can also be initial default options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $845dede6ba74432c$export$7de5fae3688fa523)),
    /**
   * Message displayed in the menu when there is no user input.
   */ promptText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Message displayed in the menu while the request is pending.
   */ searchText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Whether or not the component should cache query results.
   */ useCache: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool
};
function $e5c873bd330d4b52$export$cdf1dc76b55502e3(props) {
    var allowNew = props.allowNew, _props$delay = props.delay, delay = _props$delay === void 0 ? 200 : _props$delay, emptyLabel = props.emptyLabel, isLoading = props.isLoading, _props$minLength = props.minLength, minLength = _props$minLength === void 0 ? 2 : _props$minLength, onInputChange = props.onInputChange, onSearch = props.onSearch, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$promptText = props.promptText, promptText = _props$promptText === void 0 ? 'Type to search...' : _props$promptText, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? 'Searching...' : _props$searchText, _props$useCache = props.useCache, useCache = _props$useCache === void 0 ? true : _props$useCache, otherProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(props, $e5c873bd330d4b52$var$_excluded);
    var cacheRef = (0, $8nGP5.useRef)({});
    var handleSearchDebouncedRef = (0, $8nGP5.useRef)(null);
    var queryRef = (0, $8nGP5.useRef)(props.defaultInputValue || '');
    var forceUpdate = (0, $178a7eb43675e020$export$2e2bcd8739ae039)();
    var prevProps = (0, $2d88d745050e62ad$export$2e2bcd8739ae039)(props);
    var handleSearch = (0, $8nGP5.useCallback)(function(query) {
        queryRef.current = query;
        if (!query || minLength && query.length < minLength) return;
        // Use cached results, if applicable.
        if (useCache && cacheRef.current[query]) {
            // Re-render the component with the cached results.
            forceUpdate();
            return;
        }
        // Perform the search.
        onSearch(query);
    }, [
        forceUpdate,
        minLength,
        onSearch,
        useCache
    ]);
    // Set the debounced search function.
    (0, $8nGP5.useEffect)(function() {
        handleSearchDebouncedRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($6fe20d3196595522$exports)))(handleSearch, delay);
        return function() {
            handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
        };
    }, [
        delay,
        handleSearch
    ]);
    (0, $8nGP5.useEffect)(function() {
        // Ensure that we've gone from a loading to a completed state. Otherwise
        // an empty response could get cached if the component updates during the
        // request (eg: if the parent re-renders for some reason).
        if (!isLoading && prevProps && prevProps.isLoading && useCache) cacheRef.current[queryRef.current] = options;
    });
    var getEmptyLabel = function getEmptyLabel() {
        if (!queryRef.current.length) return promptText;
        if (isLoading) return searchText;
        return emptyLabel;
    };
    var handleInputChange = (0, $8nGP5.useCallback)(function(query, e) {
        onInputChange && onInputChange(query, e);
        handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
    }, [
        onInputChange
    ]);
    var cachedQuery = cacheRef.current[queryRef.current];
    return $e5c873bd330d4b52$var$_objectSpread($e5c873bd330d4b52$var$_objectSpread({}, otherProps), {}, {
        // Disable custom selections during a search if `allowNew` isn't a function.
        allowNew: (0, $11373711587d158e$export$f6e2535fb5126e54)(allowNew) ? allowNew : allowNew && !isLoading,
        emptyLabel: getEmptyLabel(),
        isLoading: isLoading,
        minLength: minLength,
        onInputChange: handleInputChange,
        options: useCache && cachedQuery ? cachedQuery : options
    });
}
function $e5c873bd330d4b52$export$3523553ee0bc32a8(Component) {
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(false, "Warning: `withAsync` is deprecated and will be removed in the next major version. Use `useAsync` instead.");
    var AsyncTypeahead = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $e5c873bd330d4b52$export$cdf1dc76b55502e3(props), {
            ref: ref
        }));
    });
    AsyncTypeahead.displayName = "withAsync(".concat((0, $6198e38015028611$export$2e2bcd8739ae039)(Component), ")");
    // @ts-ignore
    AsyncTypeahead.propTypes = $e5c873bd330d4b52$var$propTypes;
    return AsyncTypeahead;
}


var $face66a2b537e00d$exports = {};
function $face66a2b537e00d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$face66a2b537e00d$exports = $face66a2b537e00d$var$_classCallCheck, $face66a2b537e00d$exports.__esModule = true, $face66a2b537e00d$exports["default"] = $face66a2b537e00d$exports;


var $2bd15c24945ea86e$exports = {};

function $2bd15c24945ea86e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $84e62c9181c3ad9d$exports(o.key), o);
    }
}
function $2bd15c24945ea86e$var$_createClass(e, r, t) {
    return r && $2bd15c24945ea86e$var$_defineProperties(e.prototype, r), t && $2bd15c24945ea86e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$2bd15c24945ea86e$exports = $2bd15c24945ea86e$var$_createClass, $2bd15c24945ea86e$exports.__esModule = true, $2bd15c24945ea86e$exports["default"] = $2bd15c24945ea86e$exports;


var $91b09f50e96287f6$exports = {};
function $91b09f50e96287f6$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$91b09f50e96287f6$exports = $91b09f50e96287f6$var$_assertThisInitialized, $91b09f50e96287f6$exports.__esModule = true, $91b09f50e96287f6$exports["default"] = $91b09f50e96287f6$exports;


var $0e1045ebe29aee70$exports = {};
var $01054b8d8aa533aa$exports = {};
function $01054b8d8aa533aa$var$_setPrototypeOf(t, e) {
    return $01054b8d8aa533aa$exports = $01054b8d8aa533aa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $01054b8d8aa533aa$exports.__esModule = true, $01054b8d8aa533aa$exports["default"] = $01054b8d8aa533aa$exports, $01054b8d8aa533aa$var$_setPrototypeOf(t, e);
}
$01054b8d8aa533aa$exports = $01054b8d8aa533aa$var$_setPrototypeOf, $01054b8d8aa533aa$exports.__esModule = true, $01054b8d8aa533aa$exports["default"] = $01054b8d8aa533aa$exports;


function $0e1045ebe29aee70$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $01054b8d8aa533aa$exports(t, e);
}
$0e1045ebe29aee70$exports = $0e1045ebe29aee70$var$_inherits, $0e1045ebe29aee70$exports.__esModule = true, $0e1045ebe29aee70$exports["default"] = $0e1045ebe29aee70$exports;


var $2443e6812aa08435$exports = {};

var $1XeFJ = parcelRequire("1XeFJ");
var $2443e6812aa08435$var$_typeof = $1XeFJ.default;

function $2443e6812aa08435$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $2443e6812aa08435$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $91b09f50e96287f6$exports(t);
}
$2443e6812aa08435$exports = $2443e6812aa08435$var$_possibleConstructorReturn, $2443e6812aa08435$exports.__esModule = true, $2443e6812aa08435$exports["default"] = $2443e6812aa08435$exports;


var $c922f707fc099e1f$exports = {};
function $c922f707fc099e1f$var$_getPrototypeOf(t) {
    return $c922f707fc099e1f$exports = $c922f707fc099e1f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $c922f707fc099e1f$exports.__esModule = true, $c922f707fc099e1f$exports["default"] = $c922f707fc099e1f$exports, $c922f707fc099e1f$var$_getPrototypeOf(t);
}
$c922f707fc099e1f$exports = $c922f707fc099e1f$var$_getPrototypeOf, $c922f707fc099e1f$exports.__esModule = true, $c922f707fc099e1f$exports["default"] = $c922f707fc099e1f$exports;




var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");










var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $fb80432f8fddfb4b$export$2fba198b5b2e37fa = {
    activeIndex: -1,
    hintText: '',
    id: '',
    initialItem: null,
    inputNode: null,
    isOnlyResult: false,
    onActiveItemChange: (0, $11373711587d158e$export$8793edee2d425525),
    onAdd: (0, $11373711587d158e$export$8793edee2d425525),
    onInitialItemChange: (0, $11373711587d158e$export$8793edee2d425525),
    onMenuItemClick: (0, $11373711587d158e$export$8793edee2d425525),
    setItem: (0, $11373711587d158e$export$8793edee2d425525)
};
var $fb80432f8fddfb4b$export$b86a312c9066f850 = /*#__PURE__*/ (0, $8nGP5.createContext)($fb80432f8fddfb4b$export$2fba198b5b2e37fa);
var $fb80432f8fddfb4b$export$20418b9b18662c6c = function useTypeaheadContext() {
    return (0, $8nGP5.useContext)($fb80432f8fddfb4b$export$b86a312c9066f850);
};



function $c8a24c97b4820d89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c8a24c97b4820d89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c8a24c97b4820d89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c8a24c97b4820d89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c8a24c97b4820d89$var$inputPropKeys = [
    'activeIndex',
    'disabled',
    'id',
    'inputRef',
    'isFocused',
    'isMenuShown',
    'multiple',
    'onBlur',
    'onChange',
    'onClick',
    'onFocus',
    'onKeyDown',
    'placeholder'
];
var $c8a24c97b4820d89$var$propKeys = [
    'activeIndex',
    'hideMenu',
    'isMenuShown',
    'labelKey',
    'onClear',
    'onHide',
    'onRemove',
    'results',
    'selected',
    'text',
    'toggleMenu'
];
var $c8a24c97b4820d89$var$contextKeys = [
    'activeIndex',
    'id',
    'initialItem',
    'inputNode',
    'onActiveItemChange',
    'onAdd',
    'onInitialItemChange',
    'onMenuItemClick',
    'setItem'
];
var $c8a24c97b4820d89$var$TypeaheadManager = function TypeaheadManager(props) {
    var allowNew = props.allowNew, children = props.children, initialItem = props.initialItem, isMenuShown = props.isMenuShown, onAdd = props.onAdd, onInitialItemChange = props.onInitialItemChange, onKeyDown = props.onKeyDown, onMenuToggle = props.onMenuToggle, results = props.results, selectHint = props.selectHint;
    var hintText = (0, $a1711cda6d7da6d6$export$2e2bcd8739ae039)(props);
    (0, $8nGP5.useEffect)(function() {
        // Clear the initial item when there are no results.
        if (!(allowNew || results.length)) onInitialItemChange();
    });
    var isInitialRender = (0, $8nGP5.useRef)(true);
    (0, $8nGP5.useEffect)(function() {
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        onMenuToggle(isMenuShown);
    }, [
        isMenuShown,
        onMenuToggle
    ]);
    var handleKeyDown = function handleKeyDown(e) {
        onKeyDown(e);
        if (!initialItem) return;
        var addOnlyResult = e.key === 'Enter' && (0, $f7964357ed06cb9c$export$2e2bcd8739ae039)(props);
        var shouldSelectHint = hintText && (0, $ed18b1e84ef65594$export$2e2bcd8739ae039)(e, selectHint);
        if (addOnlyResult || shouldSelectHint) onAdd(initialItem);
    };
    var childProps = $c8a24c97b4820d89$var$_objectSpread($c8a24c97b4820d89$var$_objectSpread({}, (0, $11373711587d158e$export$357523c63a2253b9)(props, $c8a24c97b4820d89$var$propKeys)), {}, {
        getInputProps: (0, $e8fe15ba48f4ce2a$export$2e2bcd8739ae039)($c8a24c97b4820d89$var$_objectSpread($c8a24c97b4820d89$var$_objectSpread({}, (0, $11373711587d158e$export$357523c63a2253b9)(props, $c8a24c97b4820d89$var$inputPropKeys)), {}, {
            onKeyDown: handleKeyDown,
            value: (0, $22b87da6e9dce42c$export$2e2bcd8739ae039)(props)
        }))
    });
    var contextValue = $c8a24c97b4820d89$var$_objectSpread($c8a24c97b4820d89$var$_objectSpread({}, (0, $11373711587d158e$export$357523c63a2253b9)(props, $c8a24c97b4820d89$var$contextKeys)), {}, {
        hintText: hintText,
        isOnlyResult: (0, $f7964357ed06cb9c$export$2e2bcd8739ae039)(props)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $fb80432f8fddfb4b$export$b86a312c9066f850).Provider, {
        value: contextValue
    }, (0, $11373711587d158e$export$f6e2535fb5126e54)(children) ? children(childProps) : children);
};
var $c8a24c97b4820d89$export$2e2bcd8739ae039 = $c8a24c97b4820d89$var$TypeaheadManager;




function $6c443eac0bd4ff3e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6c443eac0bd4ff3e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6c443eac0bd4ff3e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6c443eac0bd4ff3e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6c443eac0bd4ff3e$export$53ac33307b5acee9(props) {
    var defaultInputValue = props.defaultInputValue, defaultOpen = props.defaultOpen, defaultSelected = props.defaultSelected, maxResults = props.maxResults, multiple = props.multiple;
    var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
    var text = defaultInputValue;
    if (!multiple && selected.length) {
        // Set the text if an initial selection is passed in.
        text = (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(selected[0], props.labelKey);
        if (selected.length > 1) // Limit to 1 selection in single-select mode.
        selected = selected.slice(0, 1);
    }
    return {
        activeIndex: -1,
        activeItem: undefined,
        initialItem: undefined,
        isFocused: false,
        selected: selected,
        showMenu: defaultOpen,
        shownResults: maxResults,
        text: text
    };
}
function $6c443eac0bd4ff3e$export$df98f41f85652e52(state, props) {
    return $6c443eac0bd4ff3e$var$_objectSpread($6c443eac0bd4ff3e$var$_objectSpread({}, $6c443eac0bd4ff3e$export$53ac33307b5acee9(props)), {}, {
        isFocused: state.isFocused,
        selected: [],
        text: ''
    });
}
function $6c443eac0bd4ff3e$export$81b416d1310f34c8(state) {
    return $6c443eac0bd4ff3e$var$_objectSpread($6c443eac0bd4ff3e$var$_objectSpread({}, state), {}, {
        isFocused: true,
        showMenu: true
    });
}
function $6c443eac0bd4ff3e$export$cdf0b0ed532145ff(state, props) {
    var _getInitialState = $6c443eac0bd4ff3e$export$53ac33307b5acee9(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, initialItem = _getInitialState.initialItem, shownResults = _getInitialState.shownResults;
    return $6c443eac0bd4ff3e$var$_objectSpread($6c443eac0bd4ff3e$var$_objectSpread({}, state), {}, {
        activeIndex: activeIndex,
        activeItem: activeItem,
        initialItem: initialItem,
        showMenu: false,
        shownResults: shownResults
    });
}
function $6c443eac0bd4ff3e$export$ac262bcf0e49db26(state, props) {
    return state.showMenu ? $6c443eac0bd4ff3e$export$cdf0b0ed532145ff(state, props) : $6c443eac0bd4ff3e$var$_objectSpread($6c443eac0bd4ff3e$var$_objectSpread({}, state), {}, {
        showMenu: true
    });
}





var $df5385684d4138fc$var$_excluded = [
    "onChange"
];
function $df5385684d4138fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df5385684d4138fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df5385684d4138fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df5385684d4138fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $df5385684d4138fc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $df5385684d4138fc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2443e6812aa08435$exports)))(this, result);
    };
}
function $df5385684d4138fc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $df5385684d4138fc$var$propTypes = {
    /**
   * Allows the creation of new selections on the fly. Note that any new items
   * will be added to the list of selections, but not the list of original
   * options unless handled as such by `Typeahead`'s parent.
   *
   * If a function is specified, it will be used to determine whether a custom
   * option should be included. The return value should be true or false.
   */ allowNew: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    /**
   * Autofocus the input when the component initially mounts.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Whether or not filtering should be case-sensitive.
   */ caseSensitive: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $845dede6ba74432c$export$8a831d0ae116fbcd)),
    /**
   * The initial value displayed in the text input.
   */ defaultInputValue: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string, (0, $845dede6ba74432c$export$5534cbfe725ae92a)),
    /**
   * Whether or not the menu is displayed upon initial render.
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Specify any pre-selected options. Use only if you want the component to
   * be uncontrolled.
   */ defaultSelected: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $845dede6ba74432c$export$7de5fae3688fa523)), (0, $845dede6ba74432c$export$79f4757fa6baab77)),
    /**
   * Either an array of fields in `option` to search, or a custom filtering
   * callback.
   */ filterBy: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired),
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    /**
   * Highlights the menu item if there is only one result and allows selecting
   * that item by hitting enter. Does not work with `allowNew`.
   */ highlightOnlyResult: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $845dede6ba74432c$export$f8e54140ea7ea3a8)),
    /**
   * An html id attribute, required for assistive technologies such as screen
   * readers.
   */ id: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]), (0, $845dede6ba74432c$export$50bb8c440cf2a42c)),
    /**
   * Whether the filter should ignore accents and other diacritical marks.
   */ ignoreDiacritics: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool, (0, $845dede6ba74432c$export$9b9aee2bc2e2973d)),
    /**
   * Specify the option key to use for display or a function returning the
   * display string. By default, the selector will use the `label` key.
   */ labelKey: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]), (0, $845dede6ba74432c$export$8ae4524d34467ed5)),
    /**
   * Maximum number of results to display by default. Mostly done for
   * performance reasons so as not to render too many DOM nodes in the case of
   * large data sets.
   */ maxResults: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Number of input characters that must be entered before showing results.
   */ minLength: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    /**
   * Whether or not multiple selections are allowed.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Invoked when the input is blurred. Receives an event.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked whenever items are added or removed. Receives an array of the
   * selected options.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the input is focused. Receives an event.
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the input value changes. Receives the string value of the
   * input.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when a key is pressed. Receives an event.
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when menu visibility changes.
   */ onMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Invoked when the pagination menu item is clicked. Receives an event.
   */ onPaginate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Whether or not the menu should be displayed. `undefined` allows the
   * component to control visibility, while `true` and `false` show and hide
   * the menu, respectively.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Full set of options, including pre-selected options. Must either be an
   * array of objects (recommended) or strings.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $845dede6ba74432c$export$7de5fae3688fa523)).isRequired,
    /**
   * Give user the ability to display additional results if the number of
   * results exceeds `maxResults`.
   */ paginate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * The selected option(s) displayed in the input. Use this prop if you want
   * to control the component via its parent.
   */ selected: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, $845dede6ba74432c$export$7de5fae3688fa523)), (0, $845dede6ba74432c$export$1f1343c4475956f4))
};
var $df5385684d4138fc$var$defaultProps = {
    allowNew: false,
    autoFocus: false,
    caseSensitive: false,
    defaultInputValue: '',
    defaultOpen: false,
    defaultSelected: [],
    filterBy: [],
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    labelKey: (0, $5e8ba3c9c2c5ca78$export$365087e449b345ed),
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: (0, $11373711587d158e$export$8793edee2d425525),
    onFocus: (0, $11373711587d158e$export$8793edee2d425525),
    onInputChange: (0, $11373711587d158e$export$8793edee2d425525),
    onKeyDown: (0, $11373711587d158e$export$8793edee2d425525),
    onMenuToggle: (0, $11373711587d158e$export$8793edee2d425525),
    onPaginate: (0, $11373711587d158e$export$8793edee2d425525),
    paginate: true
};
/**
 * Manually trigger the input's change event.
 * https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js/46012210#46012210
 */ function $df5385684d4138fc$var$triggerInputChange(input, value) {
    var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    inputValue && inputValue.set && inputValue.set.call(input, value);
    var e = new Event('input', {
        bubbles: true
    });
    input.dispatchEvent(e);
}
var $df5385684d4138fc$var$Typeahead = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($0e1045ebe29aee70$exports)))(Typeahead, _React$Component);
    var _super = $df5385684d4138fc$var$_createSuper(Typeahead);
    function Typeahead() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($face66a2b537e00d$exports)))(this, Typeahead);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "state", (0, $6c443eac0bd4ff3e$export$53ac33307b5acee9)(_this.props));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "inputNode", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "isMenuShown", false);
        // Keeps track of actual items displayed in the menu, after sorting,
        // truncating, grouping, etc.
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "items", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "blur", function() {
            _this.inputNode && _this.inputNode.blur();
            _this.hideMenu();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "clear", function() {
            _this.setState((0, $6c443eac0bd4ff3e$export$df98f41f85652e52));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "focus", function() {
            _this.inputNode && _this.inputNode.focus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "getInput", function() {
            return _this.inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "inputRef", function(inputNode) {
            _this.inputNode = inputNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "setItem", function(item, position) {
            _this.items[position] = item;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "hideMenu", function() {
            _this.setState((0, $6c443eac0bd4ff3e$export$cdf0b0ed532145ff));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "toggleMenu", function() {
            _this.setState((0, $6c443eac0bd4ff3e$export$ac262bcf0e49db26));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleActiveIndexChange", function(activeIndex) {
            _this.setState(function(state) {
                return {
                    activeIndex: activeIndex,
                    activeItem: activeIndex >= 0 ? state.activeItem : undefined
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleActiveItemChange", function(activeItem) {
            // Don't update the active item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(activeItem, _this.state.activeItem)) _this.setState({
                activeItem: activeItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleBlur", function(e) {
            e.persist();
            _this.setState({
                isFocused: false
            }, function() {
                return _this.props.onBlur(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleChange", function(selected) {
            _this.props.onChange && _this.props.onChange(selected);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleClear", function() {
            _this.inputNode && $df5385684d4138fc$var$triggerInputChange(_this.inputNode, '');
            _this.setState((0, $6c443eac0bd4ff3e$export$df98f41f85652e52), function() {
                // Change handler is automatically triggered for single selections but
                // not multi-selections.
                if (_this.props.multiple) _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleClick", function(e) {
            var _this$props$inputProp;
            e.persist();
            var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
            _this.setState((0, $6c443eac0bd4ff3e$export$81b416d1310f34c8), function() {
                return (0, $11373711587d158e$export$f6e2535fb5126e54)(onClick) && onClick(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleFocus", function(e) {
            e.persist();
            _this.setState((0, $6c443eac0bd4ff3e$export$81b416d1310f34c8), function() {
                return _this.props.onFocus(e);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleInitialItemChange", function(initialItem) {
            // Don't update the initial item if it hasn't changed.
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(initialItem, _this.state.initialItem)) _this.setState({
                initialItem: initialItem
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleInputChange", function(e) {
            e.persist();
            var text = e.currentTarget.value;
            var _this$props = _this.props, multiple = _this$props.multiple, onInputChange = _this$props.onInputChange;
            // Clear selections when the input value changes in single-select mode.
            var shouldClearSelections = _this.state.selected.length && !multiple;
            _this.setState(function(state, props) {
                var _getInitialState = (0, $6c443eac0bd4ff3e$export$53ac33307b5acee9)(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, shownResults = _getInitialState.shownResults;
                return {
                    activeIndex: activeIndex,
                    activeItem: activeItem,
                    selected: shouldClearSelections ? [] : state.selected,
                    showMenu: true,
                    shownResults: shownResults,
                    text: text
                };
            }, function() {
                onInputChange(text, e);
                shouldClearSelections && _this._handleChange([]);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleKeyDown", function(e) {
            var activeItem = _this.state.activeItem;
            // Skip most actions when the menu is hidden.
            if (!_this.isMenuShown) {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') _this.setState({
                    showMenu: true
                });
                _this.props.onKeyDown(e);
                return;
            }
            switch(e.key){
                case 'ArrowUp':
                case 'ArrowDown':
                    // Prevent input cursor from going to the beginning when pressing up.
                    e.preventDefault();
                    _this._handleActiveIndexChange((0, $87c46f28122be0aa$export$2e2bcd8739ae039)(_this.state.activeIndex, e.key, _this.items));
                    break;
                case 'Enter':
                    // Prevent form submission while menu is open.
                    e.preventDefault();
                    activeItem && _this._handleMenuItemSelect(activeItem, e);
                    break;
                case 'Escape':
                case 'Tab':
                    // ESC simply hides the menu. TAB will blur the input and move focus to
                    // the next item; hide the menu so it doesn't gain focus.
                    _this.hideMenu();
                    break;
                default:
                    break;
            }
            _this.props.onKeyDown(e);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleMenuItemSelect", function(option, e) {
            if ((0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, 'paginationOption')) _this._handlePaginate(e);
            else _this._handleSelectionAdd(option);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handlePaginate", function(e) {
            e.persist();
            _this.setState(function(state, props) {
                return {
                    shownResults: state.shownResults + props.maxResults
                };
            }, function() {
                return _this.props.onPaginate(e, _this.state.shownResults);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleSelectionAdd", function(option) {
            var _this$props2 = _this.props, multiple = _this$props2.multiple, labelKey = _this$props2.labelKey;
            var selected;
            var selection = option;
            var text;
            // Add a unique id to the custom selection. Avoid doing this in `render` so
            // the id doesn't increment every time.
            if (!(0, $11373711587d158e$export$844ec244b1367d54)(selection) && selection.customOption) selection = $df5385684d4138fc$var$_objectSpread($df5385684d4138fc$var$_objectSpread({}, selection), {}, {
                id: (0, $11373711587d158e$export$8b15d37bc3f197d4)('new-id-')
            });
            if (multiple) {
                // If multiple selections are allowed, add the new selection to the
                // existing selections.
                selected = _this.state.selected.concat(selection);
                text = '';
            } else {
                // If only a single selection is allowed, replace the existing selection
                // with the new one.
                selected = [
                    selection
                ];
                text = (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(selection, labelKey);
            }
            _this.setState(function(state, props) {
                return $df5385684d4138fc$var$_objectSpread($df5385684d4138fc$var$_objectSpread({}, (0, $6c443eac0bd4ff3e$export$cdf0b0ed532145ff)(state, props)), {}, {
                    initialItem: selection,
                    selected: selected,
                    text: text
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_handleSelectionRemove", function(selection) {
            var selected = _this.state.selected.filter(function(option) {
                return !(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(option, selection);
            });
            // Make sure the input stays focused after the item is removed.
            _this.focus();
            _this.setState(function(state, props) {
                return $df5385684d4138fc$var$_objectSpread($df5385684d4138fc$var$_objectSpread({}, (0, $6c443eac0bd4ff3e$export$cdf0b0ed532145ff)(state, props)), {}, {
                    selected: selected
                });
            }, function() {
                return _this._handleChange(selected);
            });
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2bd15c24945ea86e$exports)))(Typeahead, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.autoFocus && this.focus();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props3 = this.props, labelKey = _this$props3.labelKey, multiple = _this$props3.multiple, selected = _this$props3.selected;
                (0, $2a03374cfcc5dc09$export$2e2bcd8739ae039)(selected, prevProps.selected);
                // Sync selections in state with those in props.
                if (selected && !(0, (/*@__PURE__*/$parcel$interopDefault($60aa457c0b214a25$exports)))(selected, prevState.selected)) {
                    this.setState({
                        selected: selected
                    });
                    if (!multiple) this.setState({
                        text: selected.length ? (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(selected[0], labelKey) : ''
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, onChange = _this$props4.onChange, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_this$props4, $df5385684d4138fc$var$_excluded);
                var mergedPropsAndState = $df5385684d4138fc$var$_objectSpread($df5385684d4138fc$var$_objectSpread({}, props), this.state);
                var filterBy = mergedPropsAndState.filterBy, labelKey = mergedPropsAndState.labelKey, options = mergedPropsAndState.options, paginate = mergedPropsAndState.paginate, shownResults = mergedPropsAndState.shownResults, text = mergedPropsAndState.text;
                this.isMenuShown = (0, $0a9074bba0bfd84d$export$2e2bcd8739ae039)(mergedPropsAndState);
                this.items = []; // Reset items on re-render.
                var results = [];
                if (this.isMenuShown) {
                    var cb = (0, $11373711587d158e$export$f6e2535fb5126e54)(filterBy) ? filterBy : (0, $c5e48693defe599e$export$2e2bcd8739ae039);
                    results = options.filter(function(option) {
                        return cb(option, mergedPropsAndState);
                    });
                    // This must come before results are truncated.
                    var shouldPaginate = paginate && results.length > shownResults;
                    // Truncate results if necessary.
                    results = (0, $486a6d4e4a177cb8$export$2e2bcd8739ae039)(results, shownResults);
                    // Add the custom option if necessary.
                    if ((0, $1d5aef206a95a5de$export$2e2bcd8739ae039)(results, mergedPropsAndState)) results.push((0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))({
                        customOption: true
                    }, (0, $818312df3dbb7671$export$2e2bcd8739ae039)(labelKey), text));
                    // Add the pagination item if necessary.
                    if (shouldPaginate) {
                        var _results$push2;
                        results.push((_results$push2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_results$push2, (0, $818312df3dbb7671$export$2e2bcd8739ae039)(labelKey), ''), (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(_results$push2, "paginationOption", true), _results$push2));
                    }
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c8a24c97b4820d89$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, mergedPropsAndState, {
                    hideMenu: this.hideMenu,
                    inputNode: this.inputNode,
                    inputRef: this.inputRef,
                    isMenuShown: this.isMenuShown,
                    onActiveItemChange: this._handleActiveItemChange,
                    onAdd: this._handleSelectionAdd,
                    onBlur: this._handleBlur,
                    onChange: this._handleInputChange,
                    onClear: this._handleClear,
                    onClick: this._handleClick,
                    onFocus: this._handleFocus,
                    onHide: this.hideMenu,
                    onInitialItemChange: this._handleInitialItemChange,
                    onKeyDown: this._handleKeyDown,
                    onMenuItemClick: this._handleMenuItemSelect,
                    onRemove: this._handleSelectionRemove,
                    results: results,
                    setItem: this.setItem,
                    toggleMenu: this.toggleMenu
                }));
            }
        }
    ]);
    return Typeahead;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($df5385684d4138fc$var$Typeahead, "propTypes", $df5385684d4138fc$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($df5385684d4138fc$var$Typeahead, "defaultProps", $df5385684d4138fc$var$defaultProps);
var $df5385684d4138fc$export$2e2bcd8739ae039 = $df5385684d4138fc$var$Typeahead;



var $8tsi7 = parcelRequire("8tsi7");



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $f7e88d5fe2c758c9$var$_excluded = [
    "className",
    "label",
    "onClick",
    "onKeyDown",
    "size"
];
var $f7e88d5fe2c758c9$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    size: (0, $845dede6ba74432c$export$9ae6167e9ee9e6d0)
};
/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */ var $f7e88d5fe2c758c9$var$ClearButton = function ClearButton(_ref) {
    var className = _ref.className, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Clear' : _ref$label, _onClick = _ref.onClick, _onKeyDown = _ref.onKeyDown, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $f7e88d5fe2c758c9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('close', 'btn-close', 'rbt-close', {
            'rbt-close-lg': (0, $5df0515af306a98d$export$650961c52e438122)(size),
            'rbt-close-sm': (0, $5df0515af306a98d$export$93100e6f8d8c0365)(size)
        }, className),
        onClick: function onClick(e) {
            e.stopPropagation();
            _onClick && _onClick(e);
        },
        onKeyDown: function onKeyDown(e) {
            // Prevent browser from navigating back.
            if (e.key === 'Backspace') e.preventDefault();
            _onKeyDown && _onKeyDown(e);
        },
        type: "button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        "aria-hidden": "true",
        className: "rbt-close-content"
    }, "\xD7"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$f7e88d5fe2c758c9$var$ClearButton.propTypes = $f7e88d5fe2c758c9$var$propTypes;
var $f7e88d5fe2c758c9$export$2e2bcd8739ae039 = $f7e88d5fe2c758c9$var$ClearButton;





var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");
var $ae237702e28c108f$var$propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
};
var $ae237702e28c108f$var$Loader = function Loader(_ref) {
    var _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loading...' : _ref$label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-loader spinner-border spinner-border-sm",
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        className: "sr-only visually-hidden"
    }, label));
};
$ae237702e28c108f$var$Loader.propTypes = $ae237702e28c108f$var$propTypes;
var $ae237702e28c108f$export$2e2bcd8739ae039 = $ae237702e28c108f$var$Loader;






var $ebCsu = parcelRequire("ebCsu");
var $a74fbf0c8354a097$exports = {};
var $f0b3d55530c9f11c$exports = {};
function $f0b3d55530c9f11c$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$f0b3d55530c9f11c$exports = $f0b3d55530c9f11c$var$_arrayWithHoles, $f0b3d55530c9f11c$exports.__esModule = true, $f0b3d55530c9f11c$exports["default"] = $f0b3d55530c9f11c$exports;


var $9a8c171e66b36989$exports = {};
function $9a8c171e66b36989$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$9a8c171e66b36989$exports = $9a8c171e66b36989$var$_iterableToArrayLimit, $9a8c171e66b36989$exports.__esModule = true, $9a8c171e66b36989$exports["default"] = $9a8c171e66b36989$exports;


var $47e6fce6f3313410$exports = {};
var $7e7cf0ecf06c2d08$exports = {};
function $7e7cf0ecf06c2d08$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$7e7cf0ecf06c2d08$exports = $7e7cf0ecf06c2d08$var$_arrayLikeToArray, $7e7cf0ecf06c2d08$exports.__esModule = true, $7e7cf0ecf06c2d08$exports["default"] = $7e7cf0ecf06c2d08$exports;


function $47e6fce6f3313410$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7e7cf0ecf06c2d08$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7e7cf0ecf06c2d08$exports(r, a) : void 0;
    }
}
$47e6fce6f3313410$exports = $47e6fce6f3313410$var$_unsupportedIterableToArray, $47e6fce6f3313410$exports.__esModule = true, $47e6fce6f3313410$exports["default"] = $47e6fce6f3313410$exports;


var $a8af1fc8a581bdd4$exports = {};
function $a8af1fc8a581bdd4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a8af1fc8a581bdd4$exports = $a8af1fc8a581bdd4$var$_nonIterableRest, $a8af1fc8a581bdd4$exports.__esModule = true, $a8af1fc8a581bdd4$exports["default"] = $a8af1fc8a581bdd4$exports;


function $a74fbf0c8354a097$var$_slicedToArray(r, e) {
    return $f0b3d55530c9f11c$exports(r) || $9a8c171e66b36989$exports(r, e) || $47e6fce6f3313410$exports(r, e) || $a8af1fc8a581bdd4$exports();
}
$a74fbf0c8354a097$exports = $a74fbf0c8354a097$var$_slicedToArray, $a74fbf0c8354a097$exports.__esModule = true, $a74fbf0c8354a097$exports["default"] = $a74fbf0c8354a097$exports;


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $96ee0238679183f5$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $96ee0238679183f5$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $96ee0238679183f5$export$803cd8101b6c182b = /*#__PURE__*/ $96ee0238679183f5$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $96ee0238679183f5$export$27b07d8a310ed8b5[0], side + "-" + $96ee0238679183f5$export$27b07d8a310ed8b5[1]), []);
const $96ee0238679183f5$export$96ec731ed4dcb222 = Math.min;
const $96ee0238679183f5$export$8960430cfd85939f = Math.max;
const $96ee0238679183f5$export$2077e0241d6afd3c = Math.round;
const $96ee0238679183f5$export$a3fe094919f356fd = Math.floor;
const $96ee0238679183f5$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $96ee0238679183f5$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $96ee0238679183f5$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $96ee0238679183f5$export$7d15b64cf5a3a4c4(start, value, end) {
    return $96ee0238679183f5$export$8960430cfd85939f(start, $96ee0238679183f5$export$96ec731ed4dcb222(value, end));
}
function $96ee0238679183f5$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $96ee0238679183f5$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $96ee0238679183f5$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $96ee0238679183f5$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $96ee0238679183f5$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $96ee0238679183f5$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($96ee0238679183f5$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $96ee0238679183f5$export$2b57e0052a6d6d4c(placement) {
    return $96ee0238679183f5$export$8a000a963141ac32($96ee0238679183f5$export$f28e8f882010718a(placement));
}
function $96ee0238679183f5$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $96ee0238679183f5$export$f0989780f32bfcda(placement);
    const alignmentAxis = $96ee0238679183f5$export$2b57e0052a6d6d4c(placement);
    const length = $96ee0238679183f5$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $96ee0238679183f5$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $96ee0238679183f5$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $96ee0238679183f5$export$496432a3699e50b1(placement) {
    const oppositePlacement = $96ee0238679183f5$export$9c5e28bad23365fa(placement);
    return [
        $96ee0238679183f5$export$2b182c584985588b(placement),
        oppositePlacement,
        $96ee0238679183f5$export$2b182c584985588b(oppositePlacement)
    ];
}
function $96ee0238679183f5$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$96ee0238679183f5$var$oppositeAlignmentMap[alignment]);
}
function $96ee0238679183f5$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $96ee0238679183f5$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $96ee0238679183f5$export$f0989780f32bfcda(placement);
    let list = $96ee0238679183f5$var$getSideList($96ee0238679183f5$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($96ee0238679183f5$export$2b182c584985588b));
    }
    return list;
}
function $96ee0238679183f5$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$96ee0238679183f5$var$oppositeSideMap[side]);
}
function $96ee0238679183f5$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $96ee0238679183f5$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $96ee0238679183f5$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $96ee0238679183f5$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $477f7879101cfdb4$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $96ee0238679183f5$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $96ee0238679183f5$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $96ee0238679183f5$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $477f7879101cfdb4$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $477f7879101cfdb4$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $477f7879101cfdb4$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $477f7879101cfdb4$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $477f7879101cfdb4$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $96ee0238679183f5$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $96ee0238679183f5$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $477f7879101cfdb4$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $96ee0238679183f5$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $477f7879101cfdb4$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $96ee0238679183f5$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $96ee0238679183f5$export$803cd8101b6c182b) ? $477f7879101cfdb4$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $96ee0238679183f5$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $96ee0238679183f5$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $96ee0238679183f5$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $477f7879101cfdb4$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $96ee0238679183f5$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $96ee0238679183f5$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $96ee0238679183f5$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $96ee0238679183f5$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $477f7879101cfdb4$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $477f7879101cfdb4$var$isAnySideFullyClipped(overflow) {
    return (0, $96ee0238679183f5$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $477f7879101cfdb4$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $477f7879101cfdb4$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $477f7879101cfdb4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $477f7879101cfdb4$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $477f7879101cfdb4$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $477f7879101cfdb4$var$getBoundingRect(rects) {
    const minX = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $96ee0238679183f5$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $96ee0238679183f5$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $477f7879101cfdb4$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $96ee0238679183f5$export$ee05aea0aeecbad4)($477f7879101cfdb4$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $477f7879101cfdb4$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $477f7879101cfdb4$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $96ee0238679183f5$export$ee05aea0aeecbad4)($477f7879101cfdb4$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $96ee0238679183f5$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $96ee0238679183f5$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $477f7879101cfdb4$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $477f7879101cfdb4$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $477f7879101cfdb4$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $477f7879101cfdb4$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)((0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $96ee0238679183f5$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $96ee0238679183f5$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $477f7879101cfdb4$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $96ee0238679183f5$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $477f7879101cfdb4$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $96ee0238679183f5$export$fef61f332f2c0afc)(options, state);
            const overflow = await $477f7879101cfdb4$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $96ee0238679183f5$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $96ee0238679183f5$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $96ee0238679183f5$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $96ee0238679183f5$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $1dc0cfe62243c1a1$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $1dc0cfe62243c1a1$export$651544f548703224(node) {
    if ($1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1dc0cfe62243c1a1$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1dc0cfe62243c1a1$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1dc0cfe62243c1a1$export$8ee0fc9ee280b4ee(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).Node;
}
function $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).Element;
}
function $1dc0cfe62243c1a1$export$1b3bfaa9684536aa(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1dc0cfe62243c1a1$export$af51f0f06c0f328a(value) {
    if (!$1dc0cfe62243c1a1$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1dc0cfe62243c1a1$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1dc0cfe62243c1a1$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1dc0cfe62243c1a1$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1dc0cfe62243c1a1$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1dc0cfe62243c1a1$export$651544f548703224(element));
}
function $1dc0cfe62243c1a1$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1dc0cfe62243c1a1$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $1dc0cfe62243c1a1$export$78551043582a6a98();
    const css = $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(elementOrCss) ? $1dc0cfe62243c1a1$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1dc0cfe62243c1a1$export$940d8225183e1404(element) {
    let currentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(element);
    while($1dc0cfe62243c1a1$export$1b3bfaa9684536aa(currentNode) && !$1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(currentNode)){
        if ($1dc0cfe62243c1a1$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($1dc0cfe62243c1a1$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1dc0cfe62243c1a1$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1dc0cfe62243c1a1$export$651544f548703224(node));
}
function $1dc0cfe62243c1a1$export$3735103072e4a80(element) {
    return $1dc0cfe62243c1a1$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1dc0cfe62243c1a1$export$dc8fc79fa2800137(element) {
    if ($1dc0cfe62243c1a1$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1dc0cfe62243c1a1$export$4e12058fc4d51d56(node) {
    if ($1dc0cfe62243c1a1$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1dc0cfe62243c1a1$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1dc0cfe62243c1a1$export$e495491855dc5418(node);
    return $1dc0cfe62243c1a1$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(node) {
    const parentNode = $1dc0cfe62243c1a1$export$4e12058fc4d51d56(node);
    if ($1dc0cfe62243c1a1$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1dc0cfe62243c1a1$export$1b3bfaa9684536aa(parentNode) && $1dc0cfe62243c1a1$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(parentNode);
}
function $1dc0cfe62243c1a1$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1dc0cfe62243c1a1$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1dc0cfe62243c1a1$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $1dc0cfe62243c1a1$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $1dc0cfe62243c1a1$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $1dc0cfe62243c1a1$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $1dc0cfe62243c1a1$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $1dc0cfe62243c1a1$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $322acf408b6b8401$var$getCssDimensions(element) {
    const css = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $96ee0238679183f5$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $96ee0238679183f5$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $322acf408b6b8401$var$unwrapElement(element) {
    return !(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $322acf408b6b8401$var$getScale(element) {
    const domElement = $322acf408b6b8401$var$unwrapElement(element);
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(domElement)) return (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $322acf408b6b8401$var$getCssDimensions(domElement);
    let x = ($ ? (0, $96ee0238679183f5$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $96ee0238679183f5$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $322acf408b6b8401$var$noOffsets = /*#__PURE__*/ (0, $96ee0238679183f5$export$a397704b5e280835)(0);
function $322acf408b6b8401$var$getVisualOffsets(element) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    if (!(0, $1dc0cfe62243c1a1$export$78551043582a6a98)() || !win.visualViewport) return $322acf408b6b8401$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $322acf408b6b8401$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $322acf408b6b8401$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $322acf408b6b8401$var$unwrapElement(element);
    let scale = (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(offsetParent)) scale = $322acf408b6b8401$var$getScale(offsetParent);
        } else scale = $322acf408b6b8401$var$getScale(element);
    }
    const visualOffsets = $322acf408b6b8401$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $322acf408b6b8401$var$getVisualOffsets(domElement) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $1dc0cfe62243c1a1$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $322acf408b6b8401$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $1dc0cfe62243c1a1$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $96ee0238679183f5$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $322acf408b6b8401$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $322acf408b6b8401$var$getBoundingClientRect((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $322acf408b6b8401$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const offsets = (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1dc0cfe62243c1a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $322acf408b6b8401$var$getBoundingClientRect(offsetParent);
            scale = $322acf408b6b8401$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll, true) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $322acf408b6b8401$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $322acf408b6b8401$var$getDocumentRect(element) {
    const html = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    const scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $96ee0238679183f5$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $96ee0238679183f5$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $322acf408b6b8401$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1dc0cfe62243c1a1$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $96ee0238679183f5$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$getViewportRect(element, strategy) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    const html = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1dc0cfe62243c1a1$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $322acf408b6b8401$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $322acf408b6b8401$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element) ? $322acf408b6b8401$var$getScale(element) : (0, $96ee0238679183f5$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $322acf408b6b8401$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $322acf408b6b8401$var$getDocumentRect((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element));
    else if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $322acf408b6b8401$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $322acf408b6b8401$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $96ee0238679183f5$export$ee05aea0aeecbad4)(rect);
}
function $322acf408b6b8401$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(parentNode) || (0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(parentNode).position === 'fixed' || $322acf408b6b8401$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $322acf408b6b8401$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(el) && (0, $1dc0cfe62243c1a1$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(currentNode) && !(0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $1dc0cfe62243c1a1$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $322acf408b6b8401$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $322acf408b6b8401$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(element) ? [] : $322acf408b6b8401$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $96ee0238679183f5$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $96ee0238679183f5$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $96ee0238679183f5$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $322acf408b6b8401$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $322acf408b6b8401$var$getDimensions(element) {
    const { width: width, height: height } = $322acf408b6b8401$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $322acf408b6b8401$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $322acf408b6b8401$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1dc0cfe62243c1a1$export$651544f548703224)(offsetParent) !== 'body' || (0, $1dc0cfe62243c1a1$export$989e911fa9af580a)(documentElement)) scroll = (0, $1dc0cfe62243c1a1$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $322acf408b6b8401$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $322acf408b6b8401$var$getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $322acf408b6b8401$var$getHTMLOffset(documentElement, scroll) : (0, $96ee0238679183f5$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $322acf408b6b8401$var$isStaticPositioned(element) {
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'static';
}
function $322acf408b6b8401$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element) || (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $322acf408b6b8401$var$getOffsetParent(element, polyfill) {
    const win = (0, $1dc0cfe62243c1a1$export$38b2d434cce3ea22)(element);
    if ((0, $1dc0cfe62243c1a1$export$89e651af02346cd4)(element)) return win;
    if (!(0, $1dc0cfe62243c1a1$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$322acf408b6b8401$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1dc0cfe62243c1a1$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $322acf408b6b8401$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1dc0cfe62243c1a1$export$71535ffaa902797f)(offsetParent) && $322acf408b6b8401$var$isStaticPositioned(offsetParent))offsetParent = $322acf408b6b8401$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1dc0cfe62243c1a1$export$d1162fb0b6d4cd51)(offsetParent) && $322acf408b6b8401$var$isStaticPositioned(offsetParent) && !(0, $1dc0cfe62243c1a1$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $1dc0cfe62243c1a1$export$940d8225183e1404)(element) || win;
}
const $322acf408b6b8401$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $322acf408b6b8401$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $322acf408b6b8401$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $322acf408b6b8401$var$isRTL(element) {
    return (0, $1dc0cfe62243c1a1$export$3735103072e4a80)(element).direction === 'rtl';
}
const $322acf408b6b8401$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $322acf408b6b8401$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1dc0cfe62243c1a1$export$e495491855dc5418,
    getClippingRect: $322acf408b6b8401$var$getClippingRect,
    getOffsetParent: $322acf408b6b8401$var$getOffsetParent,
    getElementRects: $322acf408b6b8401$var$getElementRects,
    getClientRects: $322acf408b6b8401$var$getClientRects,
    getDimensions: $322acf408b6b8401$var$getDimensions,
    getScale: $322acf408b6b8401$var$getScale,
    isElement: $1dc0cfe62243c1a1$export$45a5e7f76e0caa8d,
    isRTL: $322acf408b6b8401$var$isRTL
};
function $322acf408b6b8401$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $322acf408b6b8401$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1dc0cfe62243c1a1$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $96ee0238679183f5$export$a3fe094919f356fd)(top);
        const insetRight = (0, $96ee0238679183f5$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $96ee0238679183f5$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $96ee0238679183f5$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $96ee0238679183f5$export$8960430cfd85939f)(0, (0, $96ee0238679183f5$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$322acf408b6b8401$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $322acf408b6b8401$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $322acf408b6b8401$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $1dc0cfe62243c1a1$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $322acf408b6b8401$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $322acf408b6b8401$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $322acf408b6b8401$var$getBoundingClientRect(reference);
        if (prevRefRect && !$322acf408b6b8401$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $322acf408b6b8401$export$37b6bde19b108ecc = (0, $477f7879101cfdb4$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $322acf408b6b8401$export$cc800923e997bb8 = (0, $477f7879101cfdb4$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $322acf408b6b8401$export$91fb6ecbd551914 = (0, $477f7879101cfdb4$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $322acf408b6b8401$export$fba63a578e423eb = (0, $477f7879101cfdb4$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $322acf408b6b8401$export$8a83211c878a3f1f = (0, $477f7879101cfdb4$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $322acf408b6b8401$export$346677f925de839c = (0, $477f7879101cfdb4$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $322acf408b6b8401$export$fe8985bb6374093c = (0, $477f7879101cfdb4$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $322acf408b6b8401$export$f2120bbfa5450bd2 = (0, $477f7879101cfdb4$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $322acf408b6b8401$export$18c8ad048e32c7d5 = (0, $477f7879101cfdb4$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $322acf408b6b8401$export$7bf07e38f3dc4b69 = (0, $477f7879101cfdb4$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $322acf408b6b8401$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $322acf408b6b8401$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $477f7879101cfdb4$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
var $1910b6912baf0339$var$index = typeof document !== 'undefined' ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $1910b6912baf0339$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$1910b6912baf0339$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$1910b6912baf0339$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $1910b6912baf0339$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $1910b6912baf0339$var$roundByDPR(element, value) {
    const dpr = $1910b6912baf0339$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $1910b6912baf0339$var$useLatestRef(value) {
    const ref = $8nGP5.useRef(value);
    $1910b6912baf0339$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $1910b6912baf0339$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $8nGP5.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $8nGP5.useState(middleware);
    if (!$1910b6912baf0339$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $8nGP5.useState(null);
    const [_floating, _setFloating] = $8nGP5.useState(null);
    const setReference = $8nGP5.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $8nGP5.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $8nGP5.useRef(null);
    const floatingRef = $8nGP5.useRef(null);
    const dataRef = $8nGP5.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $1910b6912baf0339$var$useLatestRef(whileElementsMounted);
    const platformRef = $1910b6912baf0339$var$useLatestRef(platform);
    const openRef = $1910b6912baf0339$var$useLatestRef(open);
    const update = $8nGP5.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $322acf408b6b8401$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$1910b6912baf0339$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $fCKK7.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $1910b6912baf0339$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $8nGP5.useRef(false);
    $1910b6912baf0339$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $1910b6912baf0339$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $8nGP5.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $8nGP5.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $8nGP5.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $1910b6912baf0339$var$roundByDPR(elements.floating, data.x);
        const y = $1910b6912baf0339$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$1910b6912baf0339$var$getDPR(elements.floating) >= 1.5 && {
                willChange: 'transform'
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $8nGP5.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1910b6912baf0339$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $1910b6912baf0339$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $1910b6912baf0339$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $1910b6912baf0339$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $1910b6912baf0339$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $1910b6912baf0339$export$346677f925de839c = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $1910b6912baf0339$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $1910b6912baf0339$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $1910b6912baf0339$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $322acf408b6b8401$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $1910b6912baf0339$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$1910b6912baf0339$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });



var $8nGP5 = parcelRequire("8nGP5");
function $c01e3de1776076ec$export$e2eb4c264cf71a83(props) {
    var middleware = [];
    if (props.flip) middleware.push((0, $1910b6912baf0339$export$8a83211c878a3f1f)());
    if (props.align !== 'right' && props.align !== 'left') middleware.push((0, $1910b6912baf0339$export$346677f925de839c)({
        apply: function apply(_ref) {
            var rects = _ref.rects, elements = _ref.elements;
            Object.assign(elements.floating.style, {
                width: "".concat(rects.reference.width, "px")
            });
        }
    }));
    return middleware;
}
function $c01e3de1776076ec$export$a9fe23cfa43a7b55(props) {
    var x = props.align === 'right' ? 'end' : 'start';
    var y = props.dropup ? 'top' : 'bottom';
    return "".concat(y, "-").concat(x);
}
function $c01e3de1776076ec$export$ea8f71083e90600f(referenceElement, options) {
    var _useState = (0, $8nGP5.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a74fbf0c8354a097$exports)))(_useState, 2), floatingElement = _useState2[0], attachRef = _useState2[1];
    var _useFloating = (0, $1910b6912baf0339$export$4e02a5c1d08bac65)({
        elements: {
            floating: floatingElement,
            reference: referenceElement
        },
        middleware: $c01e3de1776076ec$export$e2eb4c264cf71a83(options),
        placement: $c01e3de1776076ec$export$a9fe23cfa43a7b55(options),
        strategy: options.positionFixed ? 'fixed' : 'absolute',
        whileElementsMounted: (0, $322acf408b6b8401$export$deee3a793edee05f)
    }), floatingStyles = _useFloating.floatingStyles;
    return {
        innerRef: attachRef,
        style: floatingStyles
    };
}
var $c01e3de1776076ec$export$2e2bcd8739ae039 = $c01e3de1776076ec$export$ea8f71083e90600f;




var $65f3a06f40fea863$var$_excluded = [
    "referenceElement",
    "isMenuShown"
];
// `Element` is not defined during server-side rendering, so shim it here.
/* istanbul ignore next */ var $65f3a06f40fea863$var$SafeElement = typeof Element === 'undefined' ? (0, $11373711587d158e$export$8793edee2d425525) : Element;
var $65f3a06f40fea863$var$propTypes = {
    /**
   * Specify menu alignment. The default value is `justify`, which makes the
   * menu as wide as the input and truncates long values. Specifying `left`
   * or `right` will align the menu to that side and the width will be
   * determined by the length of menu item values.
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf((0, $5e8ba3c9c2c5ca78$export$54df5a921294d7ab)),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func.isRequired,
    /**
   * Specify whether the menu should appear above the input.
   */ dropup: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Whether or not to automatically adjust the position of the menu when it
   * reaches the viewport boundaries.
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    isMenuShown: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    // @ts-ignore
    referenceElement: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).instanceOf($65f3a06f40fea863$var$SafeElement)
};
var $65f3a06f40fea863$var$Overlay = function Overlay(_ref) {
    var referenceElement = _ref.referenceElement, isMenuShown = _ref.isMenuShown, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $65f3a06f40fea863$var$_excluded);
    var overlayProps = (0, $c01e3de1776076ec$export$2e2bcd8739ae039)(referenceElement, props);
    if (!isMenuShown) return null;
    return props.children(overlayProps);
};
$65f3a06f40fea863$var$Overlay.propTypes = $65f3a06f40fea863$var$propTypes;
var $65f3a06f40fea863$export$2e2bcd8739ae039 = $65f3a06f40fea863$var$Overlay;







var $8nGP5 = parcelRequire("8nGP5");
/* eslint-disable no-return-assign */ var $53e6d5b016eb161e$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $39288ac6dc5c98da$export$63fefd044b2bc624 = false;
var $39288ac6dc5c98da$export$a614c6b395900f69 = false;
try {
    var $39288ac6dc5c98da$var$options = {
        get passive () {
            return $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $39288ac6dc5c98da$export$a614c6b395900f69 = $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
        window.addEventListener('test', $39288ac6dc5c98da$var$options, $39288ac6dc5c98da$var$options);
        window.removeEventListener('test', $39288ac6dc5c98da$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $39288ac6dc5c98da$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$39288ac6dc5c98da$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$39288ac6dc5c98da$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $39288ac6dc5c98da$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $39288ac6dc5c98da$export$2e2bcd8739ae039 = $39288ac6dc5c98da$var$addEventListener;


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $bf50d51abf54f84c$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $bf50d51abf54f84c$export$2e2bcd8739ae039 = $bf50d51abf54f84c$var$removeEventListener;


function $c19f71e61aa90e5d$var$listen(node, eventName, handler, options) {
    (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $c19f71e61aa90e5d$export$2e2bcd8739ae039 = $c19f71e61aa90e5d$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $0ddd9f7131150c10$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $9e2b25d42636a35a$var$useCommittedRef(value) {
    const ref = (0, $8nGP5.useRef)(value);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $9e2b25d42636a35a$export$2e2bcd8739ae039 = $9e2b25d42636a35a$var$useCommittedRef;


function $000fcb6676031dc3$export$2e2bcd8739ae039(fn) {
    const ref = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    return (0, $8nGP5.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $321b0569c1d3b241$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $8nGP5 = parcelRequire("8nGP5");


const $f34e6b7358d1b365$var$noop = ()=>{};
function $f34e6b7358d1b365$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $f34e6b7358d1b365$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $f34e6b7358d1b365$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $f34e6b7358d1b365$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $f34e6b7358d1b365$var$useClickOutside(ref, onClickOutside = $f34e6b7358d1b365$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $8nGP5.useRef)(false);
    const waitingForTrigger = (0, $8nGP5.useRef)(false);
    const handleMouseCapture = (0, $8nGP5.useCallback)((e)=>{
        const currentTarget = $f34e6b7358d1b365$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $f34e6b7358d1b365$var$isModifiedEvent(e) || !$f34e6b7358d1b365$var$isLeftClickEvent(e) || !!(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $f34e6b7358d1b365$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $8nGP5.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)($f34e6b7358d1b365$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($f34e6b7358d1b365$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, $f34e6b7358d1b365$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(el, 'mousemove', $f34e6b7358d1b365$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $f34e6b7358d1b365$export$2e2bcd8739ae039 = $f34e6b7358d1b365$var$useClickOutside;



var $8nGP5 = parcelRequire("8nGP5");
function $0ca6f01aced8e29e$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $0ca6f01aced8e29e$export$13e065f3a74cfe36() {
    const parts = $8nGP5.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $0ca6f01aced8e29e$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $0ca6f01aced8e29e$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


const $304d4b83213e4a79$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $304d4b83213e4a79$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $304d4b83213e4a79$var$noop;
    (0, $f34e6b7358d1b365$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if ((0, $0ca6f01aced8e29e$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $8nGP5.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)((0, $f34e6b7358d1b365$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $304d4b83213e4a79$export$2e2bcd8739ae039 = $304d4b83213e4a79$var$useRootClose;


function $505f3e67dc638a90$var$useRootClose(onRootClose, options) {
    var ref = (0, $8nGP5.useRef)(null);
    (0, $304d4b83213e4a79$export$2e2bcd8739ae039)(ref, onRootClose, options);
    return ref;
}
var $505f3e67dc638a90$export$2e2bcd8739ae039 = $505f3e67dc638a90$var$useRootClose;


var $dd667b2581d6ac2c$var$_excluded = [
    "children",
    "onRootClose"
];
function $dd667b2581d6ac2c$var$RootClose(_ref) {
    var children = _ref.children, onRootClose = _ref.onRootClose, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $dd667b2581d6ac2c$var$_excluded);
    var rootRef = (0, $505f3e67dc638a90$export$2e2bcd8739ae039)(onRootClose, props);
    return children(rootRef);
}
var $dd667b2581d6ac2c$export$2e2bcd8739ae039 = $dd667b2581d6ac2c$var$RootClose;







var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");


var $8tsi7 = parcelRequire("8tsi7");




var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");



var $b7c50f5d7f42b349$var$_excluded = [
    "onBlur",
    "onClick",
    "onFocus",
    "onRemove",
    "option"
];
function $b7c50f5d7f42b349$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b7c50f5d7f42b349$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b7c50f5d7f42b349$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b7c50f5d7f42b349$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b7c50f5d7f42b349$var$propTypes = {
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onRemove: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    option: (0, $845dede6ba74432c$export$7de5fae3688fa523).isRequired
};
function $b7c50f5d7f42b349$export$31dcd79391e423fe(_ref) {
    var onBlur = _ref.onBlur, onClick = _ref.onClick, onFocus = _ref.onFocus, onRemove = _ref.onRemove, option = _ref.option, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $b7c50f5d7f42b349$var$_excluded);
    var _useState = (0, $8nGP5.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($a74fbf0c8354a097$exports)))(_useState, 2), active = _useState2[0], setActive = _useState2[1];
    var handleBlur = function handleBlur(e) {
        setActive(false);
        onBlur && onBlur(e);
    };
    var handleClick = function handleClick(e) {
        setActive(true);
        onClick && onClick(e);
    };
    var handleFocus = function handleFocus(e) {
        setActive(true);
        onFocus && onFocus(e);
    };
    var handleRemove = function handleRemove() {
        onRemove && onRemove(option);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Backspace' && active) {
            // Prevent browser from going back.
            e.preventDefault();
            handleRemove();
        }
    };
    var attachRef = (0, $505f3e67dc638a90$export$2e2bcd8739ae039)(handleBlur, $b7c50f5d7f42b349$var$_objectSpread($b7c50f5d7f42b349$var$_objectSpread({}, props), {}, {
        disabled: !active
    }));
    return {
        active: active,
        onBlur: handleBlur,
        onClick: handleClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onRemove: (0, $11373711587d158e$export$f6e2535fb5126e54)(onRemove) ? handleRemove : undefined,
        ref: attachRef
    };
}
function $b7c50f5d7f42b349$export$f6f0dceccdb6a70d(Component) {
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(false, "Warning: `withToken` is deprecated and will be removed in the next major version. Use `useToken` instead.");
    var displayName = "withToken(".concat((0, $6198e38015028611$export$2e2bcd8739ae039)(Component), ")");
    var WrappedToken = function WrappedToken(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $b7c50f5d7f42b349$export$31dcd79391e423fe(props)));
    };
    WrappedToken.displayName = displayName;
    WrappedToken.propTypes = $b7c50f5d7f42b349$var$propTypes;
    return WrappedToken;
}



var $1102a155c2474c03$var$_excluded = [
    "active",
    "children",
    "className",
    "onRemove",
    "tabIndex"
], $1102a155c2474c03$var$_excluded2 = [
    "children",
    "option",
    "readOnly"
], $1102a155c2474c03$var$_excluded3 = [
    "ref"
];
function $1102a155c2474c03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1102a155c2474c03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1102a155c2474c03$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1102a155c2474c03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1102a155c2474c03$var$InteractiveToken = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, onRemove = _ref.onRemove, tabIndex = _ref.tabIndex, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $1102a155c2474c03$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-token', 'rbt-token-removeable', {
            'rbt-token-active': !!active
        }, className),
        ref: ref,
        tabIndex: tabIndex || 0
    }), children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $f7e88d5fe2c758c9$export$2e2bcd8739ae039), {
        className: "rbt-token-remove-button",
        label: "Remove",
        onClick: onRemove,
        tabIndex: -1
    }));
});
var $1102a155c2474c03$var$StaticToken = function StaticToken(_ref2) {
    var children = _ref2.children, className = _ref2.className, disabled = _ref2.disabled, href = _ref2.href;
    var classnames = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-token', {
        'rbt-token-disabled': disabled
    }, className);
    if (href && !disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("a", {
        className: classnames,
        href: href
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: classnames
    }, children);
};
/**
 * Individual token component, generally displayed within the
 * `TypeaheadInputMulti` component, but can also be rendered on its own.
 */ var $1102a155c2474c03$var$Token = function Token(_ref3) {
    var children = _ref3.children, option = _ref3.option, readOnly = _ref3.readOnly, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref3, $1102a155c2474c03$var$_excluded2);
    var _useToken = (0, $b7c50f5d7f42b349$export$31dcd79391e423fe)($1102a155c2474c03$var$_objectSpread($1102a155c2474c03$var$_objectSpread({}, props), {}, {
        option: option
    })), ref = _useToken.ref, tokenProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_useToken, $1102a155c2474c03$var$_excluded3);
    var child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-token-label"
    }, children);
    return !props.disabled && !readOnly && (0, $11373711587d158e$export$f6e2535fb5126e54)(tokenProps.onRemove) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($1102a155c2474c03$var$InteractiveToken, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, tokenProps, {
        ref: ref
    }), child) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($1102a155c2474c03$var$StaticToken, props, child);
};
var $1102a155c2474c03$export$2e2bcd8739ae039 = $1102a155c2474c03$var$Token;



var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function $46beecaf067db253$var$interpolateStyle(styles, attr) {
    var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    // Title-case the sub-attribute.
    if (subattr) /* eslint-disable-next-line no-param-reassign */ subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
    return [
        'Top',
        'Right',
        'Bottom',
        'Left'
    ].map(function(dir) {
        return styles["".concat(attr).concat(dir).concat(subattr)];
    }).join(' ');
}
function $46beecaf067db253$var$copyStyles(inputNode, hintNode) {
    var inputStyle = window.getComputedStyle(inputNode);
    /* eslint-disable no-param-reassign */ hintNode.style.borderStyle = $46beecaf067db253$var$interpolateStyle(inputStyle, 'border', 'style');
    hintNode.style.borderWidth = $46beecaf067db253$var$interpolateStyle(inputStyle, 'border', 'width');
    hintNode.style.fontSize = inputStyle.fontSize;
    hintNode.style.fontWeight = inputStyle.fontWeight;
    hintNode.style.height = inputStyle.height;
    hintNode.style.lineHeight = inputStyle.lineHeight;
    hintNode.style.margin = $46beecaf067db253$var$interpolateStyle(inputStyle, 'margin');
    hintNode.style.padding = $46beecaf067db253$var$interpolateStyle(inputStyle, 'padding');
/* eslint-enable no-param-reassign */ }
var $46beecaf067db253$export$efccc994a079cdc8 = function useHint() {
    var _useTypeaheadContext = (0, $fb80432f8fddfb4b$export$20418b9b18662c6c)(), hintText = _useTypeaheadContext.hintText, inputNode = _useTypeaheadContext.inputNode;
    var hintRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(function() {
        // Scroll hint input when the text input is scrolling.
        var handleInputScroll = function handleInputScroll() {
            if (hintRef.current && inputNode) hintRef.current.scrollLeft = inputNode.scrollLeft;
        };
        inputNode === null || inputNode === void 0 || inputNode.addEventListener('scroll', handleInputScroll);
        return function() {
            inputNode === null || inputNode === void 0 || inputNode.removeEventListener('scroll', handleInputScroll);
        };
    }, [
        inputNode
    ]);
    (0, $8nGP5.useEffect)(function() {
        if (inputNode && hintRef.current) $46beecaf067db253$var$copyStyles(inputNode, hintRef.current);
    });
    return {
        hintRef: hintRef,
        hintText: hintText
    };
};
var $46beecaf067db253$var$Hint = function Hint(_ref) {
    var children = _ref.children, className = _ref.className;
    var _useHint = $46beecaf067db253$export$efccc994a079cdc8(), hintRef = _useHint.hintRef, hintText = _useHint.hintText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: className,
        style: {
            display: 'flex',
            flex: 1,
            height: '100%',
            position: 'relative'
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("input", {
        "aria-hidden": true,
        className: "rbt-input-hint",
        ref: hintRef,
        readOnly: true,
        style: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.54)',
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            width: '100%'
        },
        tabIndex: -1,
        value: hintText
    }));
};
var $46beecaf067db253$export$2e2bcd8739ae039 = $46beecaf067db253$var$Hint;





var $8tsi7 = parcelRequire("8tsi7");


var $8nGP5 = parcelRequire("8nGP5");
var $c9537a0f8ded5fd0$var$Input = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-input-main', props.className),
        ref: ref
    }));
});
var $c9537a0f8ded5fd0$export$2e2bcd8739ae039 = $c9537a0f8ded5fd0$var$Input;





var $d525d66c49c2942f$var$_excluded = [
    "children",
    "className",
    "inputClassName",
    "inputRef",
    "referenceElementRef",
    "selected"
];
function $d525d66c49c2942f$var$TypeaheadInputMulti(props) {
    var wrapperRef = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    var inputElem = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useRef(null);
    var _propsWithBsClassName = (0, $3ee1870d9ae8f65e$export$2e2bcd8739ae039)(props), children = _propsWithBsClassName.children, className = _propsWithBsClassName.className, inputClassName = _propsWithBsClassName.inputClassName, inputRef = _propsWithBsClassName.inputRef, referenceElementRef = _propsWithBsClassName.referenceElementRef, selected = _propsWithBsClassName.selected, rest = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_propsWithBsClassName, $d525d66c49c2942f$var$_excluded);
    function getInputRef(input) {
        inputElem.current = input;
        props.inputRef(input);
    }
    /**
   * Forward click or focus events on the container element to the input.
   */ function handleContainerClickOrFocus(e) {
        // Don't focus the input if it's disabled.
        if (props.disabled) {
            e.currentTarget.blur();
            return;
        }
        var inputNode = inputElem.current;
        if (!inputNode || // Ignore if the clicked element is a child of the container, ie: a token
        // or the input itself.
        e.currentTarget.contains(e.target) && e.currentTarget !== e.target) return;
        if ((0, $28e09257a3fd8d03$export$2e2bcd8739ae039)(inputNode)) // Move cursor to the end if the user clicks outside the actual input.
        inputNode.selectionStart = inputNode.value.length;
        inputNode.focus();
    }
    function handleKeyDown(e) {
        if (e.key === 'Backspace' && selected.length && !props.value) {
            var _wrapperRef$current;
            // Prevent browser from going back.
            e.preventDefault();
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
            if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
                var lastToken = wrapperChildren[wrapperChildren.length - 2];
                lastToken === null || lastToken === void 0 || lastToken.focus();
            }
        }
        props.onKeyDown && props.onKeyDown(e);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-input-multi', {
            disabled: props.disabled
        }, className),
        onClick: handleContainerClickOrFocus,
        onFocus: handleContainerClickOrFocus,
        ref: referenceElementRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "rbt-input-wrapper",
        ref: wrapperRef
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $46beecaf067db253$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c9537a0f8ded5fd0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, rest, {
        className: inputClassName,
        onKeyDown: handleKeyDown,
        ref: getInputRef,
        style: {
            backgroundColor: 'transparent',
            border: 0,
            boxShadow: 'none',
            cursor: 'inherit',
            outline: 'none',
            padding: 0,
            width: '100%',
            zIndex: 1
        }
    })))));
}
var $d525d66c49c2942f$export$2e2bcd8739ae039 = $d525d66c49c2942f$var$TypeaheadInputMulti;





var $8tsi7 = parcelRequire("8tsi7");


var $8nGP5 = parcelRequire("8nGP5");



var $25d50401b8bff022$var$_excluded = [
    "inputRef",
    "referenceElementRef"
];
var $25d50401b8bff022$var$TypeaheadInputSingle = function TypeaheadInputSingle(_ref) {
    var inputRef = _ref.inputRef, referenceElementRef = _ref.referenceElementRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $25d50401b8bff022$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $46beecaf067db253$export$2e2bcd8739ae039), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c9537a0f8ded5fd0$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, (0, $3ee1870d9ae8f65e$export$2e2bcd8739ae039)(props), {
        ref: function ref(node) {
            inputRef(node);
            referenceElementRef(node);
        }
    })));
};
var $25d50401b8bff022$export$2e2bcd8739ae039 = $25d50401b8bff022$var$TypeaheadInputSingle;





var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $31dcb54c1b7d7b0e$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired,
    highlightClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string.isRequired
};
/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */ var $31dcb54c1b7d7b0e$var$Highlighter = function Highlighter(_ref) {
    var children = _ref.children, _ref$highlightClassNa = _ref.highlightClassName, highlightClassName = _ref$highlightClassNa === void 0 ? 'rbt-highlight-text' : _ref$highlightClassNa, search = _ref.search;
    if (!search || !children) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, children);
    var matchCount = 0;
    var remaining = children;
    var highlighterChildren = [];
    while(remaining){
        var bounds = (0, $63528407dbac2a37$export$2e2bcd8739ae039)(remaining, search);
        // No match anywhere in the remaining string, stop.
        if (!bounds) {
            highlighterChildren.push(remaining);
            break;
        }
        // Capture the string that leads up to a match.
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) highlighterChildren.push(nonMatch);
        // Capture the matching string.
        var match = remaining.slice(bounds.start, bounds.end);
        highlighterChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("mark", {
            className: highlightClassName,
            key: matchCount
        }, match));
        matchCount += 1;
        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, highlighterChildren);
};
$31dcb54c1b7d7b0e$var$Highlighter.propTypes = $31dcb54c1b7d7b0e$var$propTypes;
var $31dcb54c1b7d7b0e$export$2e2bcd8739ae039 = $31dcb54c1b7d7b0e$var$Highlighter;







var $8tsi7 = parcelRequire("8tsi7");


var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");



var $8nGP5 = parcelRequire("8nGP5");

var $8tsi7 = parcelRequire("8tsi7");



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");
const $103c83a501eb320c$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $103c83a501eb320c$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $103c83a501eb320c$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $103c83a501eb320c$var$e(o.overflowY, n) || $103c83a501eb320c$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $103c83a501eb320c$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $103c83a501eb320c$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $103c83a501eb320c$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$103c83a501eb320c$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $103c83a501eb320c$var$t(W) && p(W);){
        if (W = $103c83a501eb320c$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $103c83a501eb320c$var$n(W) && !$103c83a501eb320c$var$n(document.documentElement) || null != W && $103c83a501eb320c$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$103c83a501eb320c$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $103c83a501eb320c$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $103c83a501eb320c$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $103c83a501eb320c$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $103c83a501eb320c$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $e403ef96e408edf5$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $e403ef96e408edf5$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $103c83a501eb320c$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $103c83a501eb320c$export$3b12cb22b12b954b)(e, $e403ef96e408edf5$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}





var $08658b67e42dde9b$var$_excluded = [
    "label",
    "onClick",
    "option",
    "position"
];
function $08658b67e42dde9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $08658b67e42dde9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $08658b67e42dde9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $08658b67e42dde9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $08658b67e42dde9b$var$propTypes = {
    option: (0, $845dede6ba74432c$export$7de5fae3688fa523).isRequired,
    position: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number
};
function $08658b67e42dde9b$export$9842ce616dcc8723(_ref) {
    var label = _ref.label, onClick = _ref.onClick, option = _ref.option, position = _ref.position, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $08658b67e42dde9b$var$_excluded);
    var _useTypeaheadContext = (0, $fb80432f8fddfb4b$export$20418b9b18662c6c)(), activeIndex = _useTypeaheadContext.activeIndex, id = _useTypeaheadContext.id, isOnlyResult = _useTypeaheadContext.isOnlyResult, onActiveItemChange = _useTypeaheadContext.onActiveItemChange, onInitialItemChange = _useTypeaheadContext.onInitialItemChange, onMenuItemClick = _useTypeaheadContext.onMenuItemClick, setItem = _useTypeaheadContext.setItem;
    var itemRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(function() {
        if (position === 0) onInitialItemChange(option);
    });
    (0, $8nGP5.useEffect)(function() {
        if (position === activeIndex) {
            onActiveItemChange(option);
            // Automatically scroll the menu as the user keys through it.
            var node = itemRef.current;
            node && (0, $e403ef96e408edf5$export$2e2bcd8739ae039)(node, {
                boundary: node.parentNode,
                scrollMode: 'if-needed'
            });
        }
    }, [
        activeIndex,
        onActiveItemChange,
        option,
        position
    ]);
    var handleClick = (0, $8nGP5.useCallback)(function(e) {
        onMenuItemClick(option, e);
        onClick && onClick(e);
    }, [
        onClick,
        onMenuItemClick,
        option
    ]);
    var active = isOnlyResult || activeIndex === position;
    // Update the item's position in the item stack.
    setItem(option, position);
    return $08658b67e42dde9b$var$_objectSpread($08658b67e42dde9b$var$_objectSpread({}, props), {}, {
        active: active,
        'aria-label': label,
        'aria-selected': active,
        id: (0, $5425939472d679db$export$2e2bcd8739ae039)(id, position),
        onClick: handleClick,
        onMouseDown: (0, $b6a46aad601ce360$export$2e2bcd8739ae039),
        ref: itemRef,
        role: 'option'
    });
}
function $08658b67e42dde9b$export$a3a500069effb440(Component) {
    (0, $b7e31a327d03e94b$export$2e2bcd8739ae039)(false, "Warning: `withItem` is deprecated and will be removed in the next major version. Use `useItem` instead.");
    var WrappedMenuItem = function WrappedMenuItem(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, $08658b67e42dde9b$export$9842ce616dcc8723(props)));
    };
    WrappedMenuItem.displayName = "withItem(".concat((0, $6198e38015028611$export$2e2bcd8739ae039)(Component), ")");
    WrappedMenuItem.propTypes = $08658b67e42dde9b$var$propTypes;
    return WrappedMenuItem;
}


var $e75615a1aadb7ad8$var$_excluded = [
    "active",
    "children",
    "className",
    "disabled",
    "onClick"
];
var $e75615a1aadb7ad8$export$2ddca9041350239b = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var active = _ref.active, children = _ref.children, className = _ref.className, disabled = _ref.disabled, _onClick = _ref.onClick, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $e75615a1aadb7ad8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("a", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('dropdown-item', {
            active: active,
            disabled: disabled
        }, className),
        href: props.href || '#',
        onClick: function onClick(e) {
            e.preventDefault();
            !disabled && _onClick && _onClick(e);
        },
        ref: ref
    }), children);
});
function $e75615a1aadb7ad8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e75615a1aadb7ad8$export$2ddca9041350239b, (0, $08658b67e42dde9b$export$9842ce616dcc8723)(props));
}






var $a393443ef5a34139$var$_excluded = [
    "emptyLabel",
    "innerRef",
    "maxHeight",
    "style"
];
function $a393443ef5a34139$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a393443ef5a34139$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a393443ef5a34139$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a393443ef5a34139$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a393443ef5a34139$var$MenuDivider = function MenuDivider() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        className: "dropdown-divider",
        role: "separator"
    });
};
var $a393443ef5a34139$var$MenuHeader = function MenuHeader(props) {
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        className: "dropdown-header",
        role: "heading"
    })));
};
var $a393443ef5a34139$var$propTypes = {
    'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /**
   * Message to display in the menu if there are no valid results.
   */ emptyLabel: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Needed for accessibility.
   */ id: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]), (0, $845dede6ba74432c$export$50bb8c440cf2a42c)),
    /**
   * Maximum height of the dropdown menu.
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
};
/**
 * Menu component that handles empty state when passed a set of results.
 */ var $a393443ef5a34139$var$Menu = function Menu(_ref) {
    var _ref$emptyLabel = _ref.emptyLabel, emptyLabel = _ref$emptyLabel === void 0 ? 'No matches found.' : _ref$emptyLabel, innerRef = _ref.innerRef, _ref$maxHeight = _ref.maxHeight, maxHeight = _ref$maxHeight === void 0 ? '300px' : _ref$maxHeight, style = _ref.style, props = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(_ref, $a393443ef5a34139$var$_excluded);
    var children = (0, $8nGP5.Children).count(props.children) === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $e75615a1aadb7ad8$export$2ddca9041350239b), {
        disabled: true,
        role: "option"
    }, emptyLabel) : props.children;
    return /*#__PURE__*/ /* eslint-disable jsx-a11y/interactive-supports-focus */ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        "aria-label": props['aria-label'] || 'menu-options',
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-menu', 'dropdown-menu', 'show', props.className),
        onMouseDown: // Prevent input from blurring when clicking on the menu scrollbar.
        (0, $b6a46aad601ce360$export$2e2bcd8739ae039),
        ref: innerRef,
        role: "listbox",
        style: $a393443ef5a34139$var$_objectSpread($a393443ef5a34139$var$_objectSpread({}, style), {}, {
            display: 'block',
            maxHeight: maxHeight,
            overflow: 'auto'
        })
    }), children);
};
$a393443ef5a34139$var$Menu.propTypes = $a393443ef5a34139$var$propTypes;
$a393443ef5a34139$var$Menu.Divider = $a393443ef5a34139$var$MenuDivider;
$a393443ef5a34139$var$Menu.Header = $a393443ef5a34139$var$MenuHeader;
var $a393443ef5a34139$export$2e2bcd8739ae039 = $a393443ef5a34139$var$Menu;






var $7806f54416f540b7$var$_excluded = [
    "labelKey",
    "newSelectionPrefix",
    "options",
    "paginationText",
    "renderMenuItemChildren",
    "text"
];
var $7806f54416f540b7$var$propTypes = {
    /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */ newSelectionPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Prompt displayed when large data sets are paginated.
   */ paginationText: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
    /**
   * Provides a hook for customized rendering of menu item contents.
   */ renderMenuItemChildren: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
};
function $7806f54416f540b7$var$renderMenuItemChildrenFn(option, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $31dcb54c1b7d7b0e$export$2e2bcd8739ae039), {
        search: props.text
    }, (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(option, props.labelKey));
}
var $7806f54416f540b7$var$TypeaheadMenu = function TypeaheadMenu(props) {
    var labelKey = props.labelKey, _props$newSelectionPr = props.newSelectionPrefix, newSelectionPrefix = _props$newSelectionPr === void 0 ? 'New selection: ' : _props$newSelectionPr, options = props.options, _props$paginationText = props.paginationText, paginationText = _props$paginationText === void 0 ? 'Display additional results...' : _props$paginationText, _props$renderMenuItem = props.renderMenuItemChildren, renderMenuItemChildren = _props$renderMenuItem === void 0 ? $7806f54416f540b7$var$renderMenuItemChildrenFn : _props$renderMenuItem, text = props.text, menuProps = (0, (/*@__PURE__*/$parcel$interopDefault($087fe1b2c8dfed8f$exports)))(props, $7806f54416f540b7$var$_excluded);
    var renderMenuItem = function renderMenuItem(option, position) {
        var label = (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(option, labelKey);
        var menuItemProps = {
            disabled: !!(0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, 'disabled'),
            label: label,
            option: option,
            position: position
        };
        if ((0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, 'customOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $e75615a1aadb7ad8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            className: "rbt-menu-custom-option",
            key: position,
            label: label
        }), newSelectionPrefix, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $31dcb54c1b7d7b0e$export$2e2bcd8739ae039), {
            search: text
        }, label));
        if ((0, $61a1fe5993bb42a6$export$2e2bcd8739ae039)(option, 'paginationOption')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, {
            key: "pagination-option-divider"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $a393443ef5a34139$export$2e2bcd8739ae039).Divider, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $e75615a1aadb7ad8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            className: "rbt-menu-pagination-option",
            label: // TODO: Fix how (aria-)labels are passed to `MenuItem`.
            // `paginationText` can be a ReactNode.
            (0, $11373711587d158e$export$844ec244b1367d54)(paginationText) ? paginationText : ''
        }), paginationText));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $e75615a1aadb7ad8$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuItemProps, {
            key: position
        }), renderMenuItemChildren(option, props, position));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $a393443ef5a34139$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuProps, {
        key: // Force a re-render if the text changes to ensure that menu
        // positioning updates correctly.
        text
    }), options.map(renderMenuItem));
};
$7806f54416f540b7$var$TypeaheadMenu.propTypes = $7806f54416f540b7$var$propTypes;
var $7806f54416f540b7$export$2e2bcd8739ae039 = $7806f54416f540b7$var$TypeaheadMenu;






function $64acedd27c21146a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64acedd27c21146a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64acedd27c21146a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64acedd27c21146a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64acedd27c21146a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $64acedd27c21146a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($c922f707fc099e1f$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2443e6812aa08435$exports)))(this, result);
    };
}
function $64acedd27c21146a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $64acedd27c21146a$var$propTypes = {
    /**
   * Displays a button to clear the input when there are selections.
   */ clearButton: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Props to be applied directly to the input. `onBlur`, `onChange`,
   * `onFocus`, and `onKeyDown` are ignored.
   */ inputProps: (0, $845dede6ba74432c$export$1c8c72d28a0627d2)((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object, (0, $845dede6ba74432c$export$82c0eddbd071e45f)),
    /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */ isInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Indicate whether an asynchronous data fetch is happening.
   */ isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */ isValid: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Callback for custom input rendering.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Callback for custom menu rendering.
   */ renderMenu: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Callback for custom menu rendering.
   */ renderToken: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    /**
   * Specifies the size of the input.
   */ size: (0, $845dede6ba74432c$export$9ae6167e9ee9e6d0)
};
var $64acedd27c21146a$var$defaultProps = {
    isLoading: false
};
var $64acedd27c21146a$var$defaultRenderMenu = function defaultRenderMenu(results, menuProps, props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $7806f54416f540b7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, menuProps, {
        labelKey: props.labelKey,
        options: results,
        text: props.text
    }));
};
var $64acedd27c21146a$var$defaultRenderToken = function defaultRenderToken(option, props, idx) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1102a155c2474c03$export$2e2bcd8739ae039), {
        disabled: props.disabled,
        key: idx,
        onRemove: props.onRemove,
        option: option,
        tabIndex: props.tabIndex
    }, (0, $6668b6b2d47a8092$export$2e2bcd8739ae039)(option, props.labelKey));
};
var $64acedd27c21146a$var$overlayPropKeys = [
    'align',
    'dropup',
    'flip',
    'positionFixed'
];
function $64acedd27c21146a$var$getOverlayProps(props) {
    return (0, $11373711587d158e$export$357523c63a2253b9)(props, $64acedd27c21146a$var$overlayPropKeys);
}
var $64acedd27c21146a$var$TypeaheadComponent = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($0e1045ebe29aee70$exports)))(TypeaheadComponent, _React$Component);
    var _super = $64acedd27c21146a$var$_createSuper(TypeaheadComponent);
    function TypeaheadComponent() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($face66a2b537e00d$exports)))(this, TypeaheadComponent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_referenceElement", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "referenceElementRef", function(referenceElement) {
            _this._referenceElement = referenceElement;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderInput", function(inputProps, props) {
            var _this$props = _this.props, isInvalid = _this$props.isInvalid, isValid = _this$props.isValid, multiple = _this$props.multiple, renderInput = _this$props.renderInput, renderToken = _this$props.renderToken, size = _this$props.size;
            if ((0, $11373711587d158e$export$f6e2535fb5126e54)(renderInput)) return renderInput(inputProps, props);
            var commonProps = $64acedd27c21146a$var$_objectSpread($64acedd27c21146a$var$_objectSpread({}, inputProps), {}, {
                isInvalid: isInvalid,
                isValid: isValid,
                size: size
            });
            if (!multiple) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $25d50401b8bff022$export$2e2bcd8739ae039), commonProps);
            var labelKey = props.labelKey, onRemove = props.onRemove, selected = props.selected;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $d525d66c49c2942f$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, commonProps, {
                placeholder: selected.length ? '' : inputProps.placeholder,
                selected: selected
            }), selected.map(function(option, idx) {
                return (renderToken || $64acedd27c21146a$var$defaultRenderToken)(option, $64acedd27c21146a$var$_objectSpread($64acedd27c21146a$var$_objectSpread({}, commonProps), {}, {
                    labelKey: labelKey,
                    onRemove: onRemove
                }), idx);
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderMenu", function(results, menuProps, props) {
            var _this$props2 = _this.props, emptyLabel = _this$props2.emptyLabel, id = _this$props2.id, maxHeight = _this$props2.maxHeight, newSelectionPrefix = _this$props2.newSelectionPrefix, paginationText = _this$props2.paginationText, renderMenu = _this$props2.renderMenu, renderMenuItemChildren = _this$props2.renderMenuItemChildren;
            return (renderMenu || $64acedd27c21146a$var$defaultRenderMenu)(results, $64acedd27c21146a$var$_objectSpread($64acedd27c21146a$var$_objectSpread({}, menuProps), {}, {
                emptyLabel: emptyLabel,
                id: id,
                maxHeight: maxHeight,
                newSelectionPrefix: newSelectionPrefix,
                paginationText: paginationText,
                renderMenuItemChildren: renderMenuItemChildren
            }), props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($91b09f50e96287f6$exports)))(_this), "_renderAux", function(_ref) {
            var onClear = _ref.onClear, selected = _ref.selected;
            var _this$props3 = _this.props, clearButton = _this$props3.clearButton, disabled = _this$props3.disabled, isLoading = _this$props3.isLoading, size = _this$props3.size;
            var content;
            if (isLoading) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ae237702e28c108f$export$2e2bcd8739ae039), null);
            else if (clearButton && !disabled && selected.length) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $f7e88d5fe2c758c9$export$2e2bcd8739ae039), {
                onClick: onClear,
                onMouseDown: (0, $b6a46aad601ce360$export$2e2bcd8739ae039),
                size: size
            });
            return content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt-aux', {
                    'rbt-aux-lg': (0, $5df0515af306a98d$export$650961c52e438122)(size)
                })
            }, content) : null;
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($2bd15c24945ea86e$exports)))(TypeaheadComponent, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, instanceRef = _this$props4.instanceRef, open = _this$props4.open, options = _this$props4.options, style = _this$props4.style;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $df5385684d4138fc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, this.props, {
                    options: options,
                    ref: instanceRef
                }), function(props) {
                    var hideMenu = props.hideMenu, isMenuShown = props.isMenuShown, results = props.results;
                    var auxContent = _this2._renderAux(props);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $dd667b2581d6ac2c$export$2e2bcd8739ae039), {
                        disabled: open || !isMenuShown,
                        onRootClose: hideMenu
                    }, function(ref) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('rbt', {
                                'has-aux': !!auxContent,
                                'is-invalid': _this2.props.isInvalid,
                                'is-valid': _this2.props.isValid
                            }, className),
                            ref: ref,
                            style: $64acedd27c21146a$var$_objectSpread($64acedd27c21146a$var$_objectSpread({}, style), {}, {
                                outline: 'none',
                                position: 'relative'
                            }),
                            tabIndex: -1
                        }, _this2._renderInput($64acedd27c21146a$var$_objectSpread($64acedd27c21146a$var$_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
                            referenceElementRef: _this2.referenceElementRef
                        }), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $65f3a06f40fea863$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, $64acedd27c21146a$var$getOverlayProps(_this2.props), {
                            isMenuShown: isMenuShown,
                            referenceElement: _this2._referenceElement
                        }), function(menuProps) {
                            return _this2._renderMenu(results, menuProps, props);
                        }), auxContent, (0, $11373711587d158e$export$f6e2535fb5126e54)(children) ? children(props) : children);
                    });
                });
            }
        }
    ]);
    return TypeaheadComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($64acedd27c21146a$var$TypeaheadComponent, "propTypes", $64acedd27c21146a$var$propTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($95134dd252a1c141$exports)))($64acedd27c21146a$var$TypeaheadComponent, "defaultProps", $64acedd27c21146a$var$defaultProps);
var $64acedd27c21146a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($64acedd27c21146a$var$TypeaheadComponent, (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, props, {
        instanceRef: ref
    }));
});




var $75621fa37394c8b1$var$AsyncTypeahead = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $64acedd27c21146a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($8tsi7)))({}, (0, $e5c873bd330d4b52$export$cdf1dc76b55502e3)(props), {
        ref: ref
    }));
});
var $75621fa37394c8b1$export$2e2bcd8739ae039 = $75621fa37394c8b1$var$AsyncTypeahead;

























var $80541c05916033ee$exports = {};
$80541c05916033ee$exports = JSON.parse("[{\"name\":\"Consumer/Retail\",\"id\":1,\"subtypes\":[{\"name\":\"Apparel\",\"id\":1},{\"name\":\"Beauty and Personal Care Products\",\"id\":2},{\"name\":\"Convenience Stores\",\"id\":3},{\"name\":\"Food and Beverage\",\"id\":4},{\"name\":\"Department Stores\",\"id\":5},{\"name\":\"Pet Food and Services\",\"id\":6},{\"name\":\"Restaurants\",\"id\":7},{\"name\":\"Specialty and Hardline Retailers\",\"id\":8},{\"name\":\"Supermarkets\",\"id\":9},{\"name\":\"Other Consumer/Retail\",\"id\":10}]},{\"name\":\"Financial Institutions\",\"id\":2,\"subtypes\":[{\"name\":\"Banks\",\"id\":11},{\"name\":\"Insurance Companies\",\"id\":12},{\"name\":\"Asset Management Firms\",\"id\":13},{\"name\":\"Financial Technology Companies\",\"id\":14},{\"name\":\"Specialty Finance Institutions\",\"id\":15},{\"name\":\"Other Financial Institutions\",\"id\":16}]},{\"name\":\"Healthcare\",\"id\":3,\"subtypes\":[{\"name\":\"Biotechnology\",\"id\":17},{\"name\":\"Diagnostics/Life Sciences\",\"id\":18},{\"name\":\"Healthcare Information Technology\",\"id\":19},{\"name\":\"Healthcare Services\",\"id\":20},{\"name\":\"Medical Devices\",\"id\":21},{\"name\":\"Pharmaceuticals\",\"id\":22},{\"name\":\"Other Healthcare\",\"id\":23}]},{\"name\":\"Industrials\",\"id\":4,\"subtypes\":[{\"name\":\"Aerospace and Defense\",\"id\":24},{\"name\":\"Automotive\",\"id\":25},{\"name\":\"Building and Construction\",\"id\":26},{\"name\":\"Business Services\",\"id\":27},{\"name\":\"Capital Goods\",\"id\":28},{\"name\":\"Diversified Industrials\",\"id\":29},{\"name\":\"Industrial Technology\",\"id\":30},{\"name\":\"Paper\",\"id\":31},{\"name\":\"Forest Products And Packaging\",\"id\":32},{\"name\":\"Transportation And Logistics\",\"id\":33},{\"name\":\"Other Industrials\",\"id\":34}]},{\"name\":\"Natural Resources\",\"id\":5,\"subtypes\":[{\"name\":\"Energy\",\"id\":35},{\"name\":\"Power\",\"id\":36},{\"name\":\"Infrastructure\",\"id\":37},{\"name\":\"Chemicals\",\"id\":38},{\"name\":\"Metals and Mining\",\"id\":39},{\"name\":\"Other Natural Resources\",\"id\":40}]},{\"name\":\"Public Sector and Infrastructure\",\"id\":6,\"subtypes\":[{\"name\":\"State and Local Governments\",\"id\":41},{\"name\":\"Not-For-Profit Healthcare Systems\",\"id\":42},{\"name\":\"Higher Education Institutions\",\"id\":43},{\"name\":\"Public Power Utilities\",\"id\":44},{\"name\":\"Surface Transportation and Mass Transit Agencies\",\"id\":45},{\"name\":\"Airports and Seaports\",\"id\":46},{\"name\":\"Sports Franchises\",\"id\":47},{\"name\":\"Other Public Sector and Infrastructure\",\"id\":48}]},{\"name\":\"Real Estate\",\"id\":7,\"subtypes\":[{\"name\":\"Real Estate Investment Trusts (REITs)\",\"id\":49},{\"name\":\"Hotels and Resorts\",\"id\":50},{\"name\":\"Retailers and Public Sector Entities\",\"id\":51},{\"name\":\"Retail Properties\",\"id\":52},{\"name\":\"Golf Courses\",\"id\":53},{\"name\":\"Shopping Centers\",\"id\":54},{\"name\":\"Office Buildings\",\"id\":55},{\"name\":\"Industrial Properties\",\"id\":56},{\"name\":\"Multifamily Properties\",\"id\":57},{\"name\":\"Development Projects\",\"id\":58},{\"name\":\"Other Real Estate\",\"id\":59}]},{\"name\":\"Technology, Media, and Telecommunications\",\"id\":8,\"subtypes\":[{\"name\":\"Software\",\"id\":60},{\"name\":\"Internet\",\"id\":61},{\"name\":\"Semiconductors\",\"id\":62},{\"name\":\"Hardware\",\"id\":63},{\"name\":\"Communications Technology\",\"id\":64},{\"name\":\"Information Services\",\"id\":65},{\"name\":\"Education Technology\",\"id\":66},{\"name\":\"Media\",\"id\":67},{\"name\":\"Telecom\",\"id\":68},{\"name\":\"Gaming Companies\",\"id\":69},{\"name\":\"Other Technology, Media, and Telecommunications\",\"id\":70}]},{\"name\":\"Business Services\",\"id\":9,\"subtypes\":[{\"name\":\"Property Maintenance Services\",\"id\":71}]}]");



var $3e1bb84537f03bf0$export$40a9eeef55665a40;
var $3e1bb84537f03bf0$export$93b7586d956c930e;
var $3e1bb84537f03bf0$export$38e42c68cf43b5d4;
var $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5;
var $3e1bb84537f03bf0$export$f843afa9e9b53052;
var $3e1bb84537f03bf0$export$ae78d338ad66ff90;
var $3e1bb84537f03bf0$export$a72e403537378b74;
var $3e1bb84537f03bf0$export$d76128d007d19019;
var $3e1bb84537f03bf0$export$f2ea4ab276c3e3fa;
var $3e1bb84537f03bf0$export$d90250155de6d7e7;
var $3e1bb84537f03bf0$export$b8972b998723d602;
var $3e1bb84537f03bf0$export$fb184b623420d9be;
$3e1bb84537f03bf0$export$40a9eeef55665a40 = `JH1BnG_defaultPadding`;
$3e1bb84537f03bf0$export$93b7586d956c930e = `JH1BnG_dropShadow`;
$3e1bb84537f03bf0$export$38e42c68cf43b5d4 = `JH1BnG_header`;
$3e1bb84537f03bf0$export$37c8efd0a1d7c4c5 = `JH1BnG_industrySearch`;
$3e1bb84537f03bf0$export$f843afa9e9b53052 = `JH1BnG_panelImage`;
$3e1bb84537f03bf0$export$ae78d338ad66ff90 = `JH1BnG_scaleInOut`;
$3e1bb84537f03bf0$export$a72e403537378b74 = `JH1BnG_scoreSearch`;
$3e1bb84537f03bf0$export$d76128d007d19019 = `JH1BnG_search`;
$3e1bb84537f03bf0$export$f2ea4ab276c3e3fa = `JH1BnG_searchBar`;
$3e1bb84537f03bf0$export$d90250155de6d7e7 = `JH1BnG_selected`;
$3e1bb84537f03bf0$export$b8972b998723d602 = `JH1BnG_shadow`;
$3e1bb84537f03bf0$export$fb184b623420d9be = `JH1BnG_title`;



var $fgQ0V = parcelRequire("fgQ0V");

var $8nGP5 = parcelRequire("8nGP5");

const $3e7d8e12b3f432b0$export$4ec57c364807b0e9 = (page, fn)=>{
    const location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    (0, $8nGP5.useEffect)(()=>{
        if (location.pathname == '/' && page == 'DB_PAGE') fn();
        else if (location.pathname == '/login' && page == 'LOGIN_PAGE') fn();
        else //DEAL_VIEW
        fn();
    }, [
        location
    ]);
};


var $959d475eae63db88$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $959d475eae63db88$export$552e6df88a6b2171 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8f024b03d9af7c67$export$d2d3ee67e04f6bd9)('Deal Database');
    const [multiSelectionsIndustry, setMultiSelectionsIndustry] = (0, $8nGP5.useState)([]);
    const [scoreSelection, setScoreSelection] = (0, $8nGP5.useState)([]);
    const [textSearch, setTextSearch] = (0, $8nGP5.useState)(ui.dealPageNameSearch);
    const setTextSearchDebounce = (0, $fgQ0V.debounce)((text)=>{
        ui.dealPageNameSearch = text;
    }, 300);
    (0, $3e7d8e12b3f432b0$export$4ec57c364807b0e9)('DB_PAGE', ()=>{
        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        ui.resetHome();
        setMultiSelectionsIndustry([]);
        setScoreSelection([]);
        setTextSearch('');
    });
    const updateScoreSeletion = (selected)=>{
        setScoreSelection(selected);
    };
    const updateSelectionIndustry = (selected)=>{
        var updated = [];
        selected.forEach((selection)=>{
            if (!updated.find((item)=>item.value == selection.value)) updated.push({
                label: selection.label,
                value: selection.value
            });
        });
        setMultiSelectionsIndustry(updated);
    };
    (0, $8nGP5.useEffect)(()=>{
        const filter = [];
        multiSelectionsIndustry.forEach((selection)=>{
            const [type, value] = selection.value.split(':');
            filter.push({
                type: type == 'CAT' ? 'category' : 'sub_category',
                value: value
            });
        });
        ui.dealPageIndustrySearch = filter;
        ui.dealPageScoreSearch = scoreSelection.map((selection)=>selection.value);
    }, [
        multiSelectionsIndustry,
        scoreSelection
    ]);
    if (!store.isLoaded) return null;
    function filterBy(option, ticker) {
        return option.label.toLowerCase().indexOf(ticker.text.toLowerCase()) > -1;
    }
    function filterByReturnAll(option, ticker) {
        return true;
    }
    const braileSpacing = "\u2800  ";
    var options_score = [
        {
            label: 'All',
            value: 'All'
        },
        {
            label: 'Strong',
            value: 'Strong'
        },
        {
            label: 'Medium',
            value: 'Medium'
        },
        {
            label: 'Weak',
            value: 'Weak'
        }
    ];
    var options = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($80541c05916033ee$exports))).forEach((industry)=>{
        var name = industry.name;
        options.push({
            label: name,
            value: 'CAT:' + name,
            industry: name,
            type: 'category'
        });
        industry.subtypes.forEach((sub_industry)=>{
            options.push({
                label: braileSpacing + sub_industry.name,
                value: 'SUB:' + sub_industry.name,
                industry: name,
                type: 'subcategory'
            });
        });
    });
    function groupBy(list, keyGetter) {
        const map = {};
        list.forEach((item)=>{
            const key = keyGetter(item);
            if (!map.hasOwnProperty(key)) map[key] = [];
            map[key].push(item);
        });
        return map;
    }
    var typeahead_props = {};
    typeahead_props['renderMenu'] = (results, _a, state)=>{
        var { newSelectionPrefix: newSelectionPrefix, paginationText: paginationText, renderMenuItemChildren: renderMenuItemChildren } = _a, menuProps = $959d475eae63db88$var$__rest(_a, [
            "newSelectionPrefix",
            "paginationText",
            "renderMenuItemChildren"
        ]);
        let index = 0;
        const list = groupBy(results, (a)=>a.industry);
        const items = Object.keys(list).sort().map((region)=>{
            var subitems = list[region];
            var header = (0, $kSbwP.jsx)((0, $a393443ef5a34139$export$2e2bcd8739ae039).Header, {
                children: region
            });
            if (subitems[0].label == region) //kind of hackish
            header = null;
            return (0, $kSbwP.jsxs)((0, $8nGP5.Fragment), {
                children: [
                    index !== 0 && (0, $kSbwP.jsx)((0, $a393443ef5a34139$export$2e2bcd8739ae039).Divider, {}),
                    header,
                    subitems.map((i)=>{
                        var isSelected = multiSelectionsIndustry.find((a)=>a.value == i.value);
                        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
                            [$3e1bb84537f03bf0$export$d90250155de6d7e7]: isSelected
                        });
                        const item = //<a aria-label="Consumer/Retail" aria-selected="false" id="industry-search-item-0" role="option" class="dropdown-item" href="#">Consumer/Retail</a>
                        (0, $kSbwP.jsx)((0, $e75615a1aadb7ad8$export$2e2bcd8739ae039), {
                            option: i,
                            position: index,
                            className: cls,
                            children: (0, $kSbwP.jsx)((0, $31dcb54c1b7d7b0e$export$2e2bcd8739ae039), {
                                search: state.text,
                                children: i.label
                            })
                        }, index);
                        index += 1;
                        return item;
                    })
                ]
            }, region);
        });
        return (0, $kSbwP.jsx)((0, $a393443ef5a34139$export$2e2bcd8739ae039), Object.assign({}, menuProps, {
            children: items
        }));
    };
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: $3e1bb84537f03bf0$export$38e42c68cf43b5d4,
        justify: "start",
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "row",
            className: $3e1bb84537f03bf0$export$f2ea4ab276c3e3fa,
            children: [
                (0, $kSbwP.jsx)("input", {
                    type: "text",
                    className: $3e1bb84537f03bf0$export$d76128d007d19019,
                    value: textSearch,
                    onInput: (e)=>{
                        setTextSearch(e.currentTarget.value);
                        setTextSearchDebounce(e.currentTarget.value);
                    },
                    placeholder: "Filter by name"
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5,
                    children: (0, $kSbwP.jsx)((0, $64acedd27c21146a$export$2e2bcd8739ae039), Object.assign({}, typeahead_props, {
                        id: "industry-search",
                        className: $3e1bb84537f03bf0$export$37c8efd0a1d7c4c5,
                        filterBy: filterBy,
                        options: options,
                        placeholder: "Filter by Industry",
                        onChange: updateSelectionIndustry,
                        selected: multiSelectionsIndustry,
                        multiple: true
                    }))
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $3e1bb84537f03bf0$export$a72e403537378b74,
                    children: (0, $kSbwP.jsx)((0, $64acedd27c21146a$export$2e2bcd8739ae039), {
                        id: "score-search",
                        filterBy: filterByReturnAll,
                        className: $3e1bb84537f03bf0$export$a72e403537378b74,
                        options: options_score,
                        placeholder: "Filter by Score",
                        onChange: updateScoreSeletion,
                        selected: scoreSelection
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");


var $6843beb2b4fdf546$export$1ca1ec8b29a4ce27;
var $6843beb2b4fdf546$export$b1e2ee34456f92d3;
var $6843beb2b4fdf546$export$6b75a9690b36aa74;
var $6843beb2b4fdf546$export$6f093cfa640b7166;
$6843beb2b4fdf546$export$1ca1ec8b29a4ce27 = `KZ9tcG_icon`;
$6843beb2b4fdf546$export$b1e2ee34456f92d3 = `KZ9tcG_numberScore`;
$6843beb2b4fdf546$export$6b75a9690b36aa74 = `KZ9tcG_scoreBox`;
$6843beb2b4fdf546$export$6f093cfa640b7166 = `KZ9tcG_text`;



const $33ac36ca38f3f8d0$export$5fb755babf77fa30 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    var icon = 'bi bi-check';
    var text = 'Strong';
    var color = '#00A171';
    if (p.score == null) debugger;
    var score = parseInt(p.score.toString());
    //temp hack
    //score = 90;
    //temp hack
    var scoreDisplay = score.toString();
    if (score > 85) ;
    else if (p.score == -1) {
        icon = 'bi bi-exclamation';
        text = 'Error';
        color = '#3E0000';
        scoreDisplay = 'N/A';
    } else if (score > 55) {
        //Medium
        icon = 'bi bi-dash';
        text = 'Med';
        color = '#FF9F00';
    } else {
        icon = 'bi bi-x';
        text = 'Weak';
        color = '#DD2222';
    }
    var iconCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('bi', icon, $6843beb2b4fdf546$export$1ca1ec8b29a4ce27);
    //scoreDisplay = 'TBD'
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: $6843beb2b4fdf546$export$6b75a9690b36aa74 + ' ' + p.className,
        style: {
            backgroundColor: color
        },
        justify: "between",
        children: [
            (0, $kSbwP.jsx)("i", {
                className: iconCls
            }),
            (0, $kSbwP.jsx)("div", {
                className: $6843beb2b4fdf546$export$6f093cfa640b7166,
                children: text
            }),
            (0, $kSbwP.jsx)("div", {
                className: $6843beb2b4fdf546$export$b1e2ee34456f92d3,
                children: scoreDisplay
            })
        ]
    });
//<div>{p.score}</div>;
});







var $1a071b47cc920250$export$e8c9778bf415dd08;
var $1a071b47cc920250$export$9cc28892e1853afe;
var $1a071b47cc920250$export$e7b177dbdcaed6bd;
var $1a071b47cc920250$export$3a3c5c2f733d37e3;
var $1a071b47cc920250$export$d9696ccac9d85db1;
var $1a071b47cc920250$export$8b09bce1e89c2f21;
var $1a071b47cc920250$export$7a2e7b3d8095518a;
var $1a071b47cc920250$export$d049a13fc4149044;
var $1a071b47cc920250$export$f3cbcc6ad82435d7;
var $1a071b47cc920250$export$e55b6242cf16bbb8;
var $1a071b47cc920250$export$becc9140d0e846f8;
var $1a071b47cc920250$export$fb184b623420d9be;
$1a071b47cc920250$export$e8c9778bf415dd08 = `_4we_0W_divider`;
$1a071b47cc920250$export$9cc28892e1853afe = `_4we_0W_fieldContainer`;
$1a071b47cc920250$export$e7b177dbdcaed6bd = `_4we_0W_fieldTitle`;
$1a071b47cc920250$export$3a3c5c2f733d37e3 = `_4we_0W_fieldValue`;
$1a071b47cc920250$export$d9696ccac9d85db1 = `_4we_0W_imageThumbLoading`;
$1a071b47cc920250$export$8b09bce1e89c2f21 = `_4we_0W_imageThumbnail`;
$1a071b47cc920250$export$7a2e7b3d8095518a = `_4we_0W_imageThumbnailContainer`;
$1a071b47cc920250$export$d049a13fc4149044 = `_4we_0W_industry`;
$1a071b47cc920250$export$f3cbcc6ad82435d7 = `_4we_0W_overview`;
$1a071b47cc920250$export$e55b6242cf16bbb8 = `_4we_0W_score`;
$1a071b47cc920250$export$becc9140d0e846f8 = `_4we_0W_thumb`;
$1a071b47cc920250$export$fb184b623420d9be = `_4we_0W_title`;



var $8nGP5 = parcelRequire("8nGP5");

var $63ebe9e92d041dc9$exports = {};
$63ebe9e92d041dc9$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $9e54bdf16921cff4$export$fe8b4069b38236f9 = ()=>{
    return (0, $kSbwP.jsx)("div", {
        className: $1a071b47cc920250$export$becc9140d0e846f8,
        style: {
            visibility: 'hidden'
        }
    });
};
const $9e54bdf16921cff4$export$ec96aade4c78ed16 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const [isImgLoaded, setIsImgLoaded] = (0, $8nGP5.useState)(0);
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($63ebe9e92d041dc9$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    const query = store.createDataAccess(p.name);
    const companyName = query.companyName;
    const year = query.actualYear();
    const rev = query.valueByYear('net_revenue_per_year', year);
    const ebitda = query.selectedEbitda(year);
    const companyDesc = query.value('company_overview_short');
    const industry = query.value('industry');
    const sub_industry = query.value('industrySubType');
    const thumb = query.value('thumb');
    const metaFields = [
        {
            label: 'Revenue ($M)',
            value: (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(rev.toString())
        },
        {
            label: 'Adj. EBITDA ($M)',
            value: (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(ebitda.toString())
        },
        {
            label: 'CEO',
            value: query.value('company_ceo')
        },
        {
            label: 'Founded',
            value: query.value('year_founded')
        }
    ];
    return (0, $kSbwP.jsx)("div", {
        className: $1a071b47cc920250$export$becc9140d0e846f8,
        onClick: ()=>{
            navUtils.toReport(p.name);
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$fb184b623420d9be,
                    children: companyName
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$d049a13fc4149044,
                    children: industry
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $1a071b47cc920250$export$e8c9778bf415dd08
                }),
                (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                    score: query.score(),
                    className: $1a071b47cc920250$export$e55b6242cf16bbb8
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "between",
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $1a071b47cc920250$export$f3cbcc6ad82435d7,
                            children: companyDesc
                        }),
                        (0, $kSbwP.jsxs)("div", {
                            className: $1a071b47cc920250$export$7a2e7b3d8095518a,
                            children: [
                                isImgLoaded == 0 && (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$d9696ccac9d85db1,
                                    children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                                        options: defaultOptionsLottie,
                                        height: 150,
                                        width: 200
                                    })
                                }),
                                (0, $kSbwP.jsx)("img", {
                                    src: thumb,
                                    className: $1a071b47cc920250$export$8b09bce1e89c2f21,
                                    style: {
                                        opacity: isImgLoaded
                                    },
                                    onLoad: ()=>setIsImgLoaded(1)
                                })
                            ]
                        })
                    ]
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    style: {
                        position: 'absolute',
                        bottom: '30px',
                        width: '100%',
                        padding: '0 20px 0 0px',
                        maxHeight: '50px'
                    },
                    justify: "between",
                    children: metaFields.map((field, index)=>{
                        return (0, $kSbwP.jsxs)("div", {
                            className: $1a071b47cc920250$export$9cc28892e1853afe,
                            children: [
                                (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$e7b177dbdcaed6bd,
                                    children: field.label
                                }),
                                (0, $kSbwP.jsx)("div", {
                                    className: $1a071b47cc920250$export$3a3c5c2f733d37e3,
                                    children: field.value
                                })
                            ]
                        }, field.label);
                    })
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");




var $71285a979481ea35$export$b7e3ae3d7c15e42e;
var $71285a979481ea35$export$becc9140d0e846f8;
var $71285a979481ea35$export$fb184b623420d9be;
var $71285a979481ea35$export$c6e11f163cc2dc47;
var $71285a979481ea35$export$eccddd504975e05d;
var $71285a979481ea35$export$743fdfb094991ec6;
$71285a979481ea35$export$b7e3ae3d7c15e42e = `_9ntroq_input`;
$71285a979481ea35$export$becc9140d0e846f8 = `_9ntroq_thumb`;
$71285a979481ea35$export$fb184b623420d9be = `_9ntroq_title`;
$71285a979481ea35$export$c6e11f163cc2dc47 = `_9ntroq_trashIcon`;
$71285a979481ea35$export$eccddd504975e05d = `_9ntroq_unlock`;
$71285a979481ea35$export$743fdfb094991ec6 = `_9ntroq_unlockIcon`;



var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
const $a4ab631a1be079fe$var$_excluded = [
    "as",
    "disabled"
];
function $a4ab631a1be079fe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a4ab631a1be079fe$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $a4ab631a1be079fe$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $a4ab631a1be079fe$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $a4ab631a1be079fe$var$Button = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $a4ab631a1be079fe$var$_objectWithoutPropertiesLoose(_ref, $a4ab631a1be079fe$var$_excluded);
    const [buttonProps, { tagName: Component }] = $a4ab631a1be079fe$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$a4ab631a1be079fe$var$Button.displayName = 'Button';
var $a4ab631a1be079fe$export$2e2bcd8739ae039 = $a4ab631a1be079fe$var$Button;



var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
"use client";
const $8b96a2995cbd6328$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $8b96a2995cbd6328$export$ff817e17bad2e091 = 'xs';
const $8b96a2995cbd6328$var$ThemeContext = /*#__PURE__*/ $8nGP5.createContext({
    prefixes: {},
    breakpoints: $8b96a2995cbd6328$export$666ad80b5007f835,
    minBreakpoint: $8b96a2995cbd6328$export$ff817e17bad2e091
});
const { Consumer: $8b96a2995cbd6328$export$b631efc24e9d5e2f, Provider: $8b96a2995cbd6328$var$Provider } = $8b96a2995cbd6328$var$ThemeContext;
function $8b96a2995cbd6328$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $8b96a2995cbd6328$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $8b96a2995cbd6328$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $8nGP5.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($8b96a2995cbd6328$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $8b96a2995cbd6328$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $8nGP5.useContext)($8b96a2995cbd6328$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $8b96a2995cbd6328$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $8nGP5.useContext)($8b96a2995cbd6328$var$ThemeContext);
    return breakpoints;
}
function $8b96a2995cbd6328$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $8nGP5.useContext)($8b96a2995cbd6328$var$ThemeContext);
    return minBreakpoint;
}
function $8b96a2995cbd6328$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $8nGP5.useContext)($8b96a2995cbd6328$var$ThemeContext);
    return dir === 'rtl';
}
function $8b96a2995cbd6328$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $8nGP5.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $8b96a2995cbd6328$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $8b96a2995cbd6328$export$2e2bcd8739ae039 = $8b96a2995cbd6328$var$ThemeProvider;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $bffaf950c90188d4$var$Button = /*#__PURE__*/ $8nGP5.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $a4ab631a1be079fe$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$bffaf950c90188d4$var$Button.displayName = 'Button';
var $bffaf950c90188d4$export$2e2bcd8739ae039 = $bffaf950c90188d4$var$Button;



var $ebCsu = parcelRequire("ebCsu");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");

var $kSbwP = parcelRequire("kSbwP");
const $7f7fcc3c332df642$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).elementType
};
const $7f7fcc3c332df642$var$Feedback = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$7f7fcc3c332df642$var$Feedback.displayName = 'Feedback';
$7f7fcc3c332df642$var$Feedback.propTypes = $7f7fcc3c332df642$var$propTypes;
var $7f7fcc3c332df642$export$2e2bcd8739ae039 = $7f7fcc3c332df642$var$Feedback;




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
// TODO
const $d08bc134063905b4$var$FormContext = /*#__PURE__*/ $8nGP5.createContext({});
var $d08bc134063905b4$export$2e2bcd8739ae039 = $d08bc134063905b4$var$FormContext;




var $kSbwP = parcelRequire("kSbwP");
"use client";
const $bfd4a68de6707a64$var$FormCheckInput = /*#__PURE__*/ $8nGP5.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$bfd4a68de6707a64$var$FormCheckInput.displayName = 'FormCheckInput';
var $bfd4a68de6707a64$export$2e2bcd8739ae039 = $bfd4a68de6707a64$var$FormCheckInput;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $6fb7f211d50a31ba$var$FormCheckLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix)
    });
});
$6fb7f211d50a31ba$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $6fb7f211d50a31ba$export$2e2bcd8739ae039 = $6fb7f211d50a31ba$var$FormCheckLabel;





var $8nGP5 = parcelRequire("8nGP5");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $311c500c8155d408$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $8nGP5.Children.map(children, (child)=>/*#__PURE__*/ $8nGP5.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $311c500c8155d408$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $8nGP5.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $8nGP5.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $311c500c8155d408$export$500fd6099226ffae(children, type) {
    return $8nGP5.Children.toArray(children).some((child)=>/*#__PURE__*/ $8nGP5.isValidElement(child) && child.type === type);
}



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $e6ff999e734518ab$var$FormCheck = /*#__PURE__*/ $8nGP5.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    const innerFormContext = (0, $8nGP5.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $311c500c8155d408$export$500fd6099226ffae)(children, (0, $6fb7f211d50a31ba$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bfd4a68de6707a64$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $d08bc134063905b4$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $6fb7f211d50a31ba$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $kSbwP.jsx)((0, $7f7fcc3c332df642$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$e6ff999e734518ab$var$FormCheck.displayName = 'FormCheck';
var $e6ff999e734518ab$export$2e2bcd8739ae039 = Object.assign($e6ff999e734518ab$var$FormCheck, {
    Input: (0, $bfd4a68de6707a64$export$2e2bcd8739ae039),
    Label: (0, $6fb7f211d50a31ba$export$2e2bcd8739ae039)
});




var $8nGP5 = parcelRequire("8nGP5");





var $kSbwP = parcelRequire("kSbwP");
"use client";
const $571fa994d7ba6d79$var$FormControl = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$571fa994d7ba6d79$var$FormControl.displayName = 'FormControl';
var $571fa994d7ba6d79$export$2e2bcd8739ae039 = Object.assign($571fa994d7ba6d79$var$FormControl, {
    Feedback: $7f7fcc3c332df642$export$2e2bcd8739ae039
});



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $fd1d86ab29492cf1$var$FormFloating = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$fd1d86ab29492cf1$var$FormFloating.displayName = 'FormFloating';
var $fd1d86ab29492cf1$export$2e2bcd8739ae039 = $fd1d86ab29492cf1$var$FormFloating;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
const $ddee6851e3e21a61$var$FormGroup = /*#__PURE__*/ $8nGP5.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $8nGP5.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $d08bc134063905b4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$ddee6851e3e21a61$var$FormGroup.displayName = 'FormGroup';
var $ddee6851e3e21a61$export$2e2bcd8739ae039 = $ddee6851e3e21a61$var$FormGroup;




var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
function $9d386835d571a6a9$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $8b96a2995cbd6328$export$8970c8db816a5863)();
    const minBreakpoint = (0, $8b96a2995cbd6328$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $9d386835d571a6a9$var$Col = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $9d386835d571a6a9$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, !spans.length && bsPrefix)
    });
});
$9d386835d571a6a9$var$Col.displayName = 'Col';
var $9d386835d571a6a9$export$2e2bcd8739ae039 = $9d386835d571a6a9$var$Col;





var $kSbwP = parcelRequire("kSbwP");
"use client";
const $372495baddf93e65$var$FormLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control
    (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    }));
});
$372495baddf93e65$var$FormLabel.displayName = 'FormLabel';
var $372495baddf93e65$export$2e2bcd8739ae039 = $372495baddf93e65$var$FormLabel;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $fd24c3f119e8027f$var$FormRange = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$fd24c3f119e8027f$var$FormRange.displayName = 'FormRange';
var $fd24c3f119e8027f$export$2e2bcd8739ae039 = $fd24c3f119e8027f$var$FormRange;




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $a2baa839f055c8e9$var$FormSelect = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $8nGP5.useContext)((0, $d08bc134063905b4$export$2e2bcd8739ae039));
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $kSbwP.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$a2baa839f055c8e9$var$FormSelect.displayName = 'FormSelect';
var $a2baa839f055c8e9$export$2e2bcd8739ae039 = $a2baa839f055c8e9$var$FormSelect;




var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $c711779bf660baf1$var$FormText = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$c711779bf660baf1$var$FormText.displayName = 'FormText';
var $c711779bf660baf1$export$2e2bcd8739ae039 = $c711779bf660baf1$var$FormText;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
const $f018fbd724a83723$var$Switch = /*#__PURE__*/ $8nGP5.forwardRef((props, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $e6ff999e734518ab$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$f018fbd724a83723$var$Switch.displayName = 'Switch';
var $f018fbd724a83723$export$2e2bcd8739ae039 = Object.assign($f018fbd724a83723$var$Switch, {
    Input: (0, $e6ff999e734518ab$export$2e2bcd8739ae039).Input,
    Label: (0, $e6ff999e734518ab$export$2e2bcd8739ae039).Label
});




var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $9873276d619ab914$var$FloatingLabel = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $ddee6851e3e21a61$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $kSbwP.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$9873276d619ab914$var$FloatingLabel.displayName = 'FloatingLabel';
var $9873276d619ab914$export$2e2bcd8739ae039 = $9873276d619ab914$var$FloatingLabel;



var $kSbwP = parcelRequire("kSbwP");
const $5bf7899a63084c1b$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).elementType
};
const $5bf7899a63084c1b$var$Form = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, validated && 'was-validated')
    }));
$5bf7899a63084c1b$var$Form.displayName = 'Form';
$5bf7899a63084c1b$var$Form.propTypes = $5bf7899a63084c1b$var$propTypes;
var $5bf7899a63084c1b$export$2e2bcd8739ae039 = Object.assign($5bf7899a63084c1b$var$Form, {
    Group: (0, $ddee6851e3e21a61$export$2e2bcd8739ae039),
    Control: (0, $571fa994d7ba6d79$export$2e2bcd8739ae039),
    Floating: (0, $fd1d86ab29492cf1$export$2e2bcd8739ae039),
    Check: (0, $e6ff999e734518ab$export$2e2bcd8739ae039),
    Switch: $f018fbd724a83723$export$2e2bcd8739ae039,
    Label: (0, $372495baddf93e65$export$2e2bcd8739ae039),
    Text: (0, $c711779bf660baf1$export$2e2bcd8739ae039),
    Range: (0, $fd24c3f119e8027f$export$2e2bcd8739ae039),
    Select: (0, $a2baa839f055c8e9$export$2e2bcd8739ae039),
    FloatingLabel: $9873276d619ab914$export$2e2bcd8739ae039
});



var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $2c5d3c4d97a014ef$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$2c5d3c4d97a014ef$var$context.displayName = 'InputGroupContext';
var $2c5d3c4d97a014ef$export$2e2bcd8739ae039 = $2c5d3c4d97a014ef$var$context;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $76ab8685a29931e8$var$InputGroupText = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$76ab8685a29931e8$var$InputGroupText.displayName = 'InputGroupText';
var $76ab8685a29931e8$export$2e2bcd8739ae039 = $76ab8685a29931e8$var$InputGroupText;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $5d327268a5763dca$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $76ab8685a29931e8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bfd4a68de6707a64$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $5d327268a5763dca$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $76ab8685a29931e8$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $bfd4a68de6707a64$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $5d327268a5763dca$var$InputGroup = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $8nGP5.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $2c5d3c4d97a014ef$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$5d327268a5763dca$var$InputGroup.displayName = 'InputGroup';
var $5d327268a5763dca$export$2e2bcd8739ae039 = Object.assign($5d327268a5763dca$var$InputGroup, {
    Text: (0, $76ab8685a29931e8$export$2e2bcd8739ae039),
    Radio: $5d327268a5763dca$var$InputGroupRadio,
    Checkbox: $5d327268a5763dca$var$InputGroupCheckbox
});


const $5f2582552430e6bc$export$57d7964eb05a4d4e = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const pdfPasswordRef = (0, $8nGP5.useRef)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const deal = store.reportDataDB[p.jobId];
    if (!deal) return null;
    return (0, $kSbwP.jsx)("div", {
        className: $71285a979481ea35$export$becc9140d0e846f8,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            justify: "between",
            alignItems: "center",
            direction: "column",
            fillCell: true,
            style: {
                padding: '10px 0px'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $71285a979481ea35$export$fb184b623420d9be,
                    children: deal.errorText
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $71285a979481ea35$export$fb184b623420d9be,
                    style: {
                        fontSize: '30px'
                    },
                    children: deal === null || deal === void 0 ? void 0 : deal.pdf
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    style: {
                        maxHeight: '40px',
                        padding: '0px 10px'
                    },
                    children: [
                        (0, $kSbwP.jsxs)((0, $5d327268a5763dca$export$2e2bcd8739ae039), {
                            children: [
                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Control, {
                                    className: $71285a979481ea35$export$b7e3ae3d7c15e42e,
                                    placeholder: "PDF Unlock password?",
                                    "aria-label": "PDF Unlock password?",
                                    ref: pdfPasswordRef
                                }),
                                (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                    className: $71285a979481ea35$export$eccddd504975e05d,
                                    onClick: ()=>{
                                        var _a;
                                        const pass = pdfPasswordRef.current.value;
                                        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                                        const pdf = (_a = store.reportDataDB[p.jobId]) === null || _a === void 0 ? void 0 : _a.pdf;
                                        fb.add_job(pdf, pass, p.jobId);
                                    },
                                    children: (0, $kSbwP.jsx)("i", {
                                        className: 'bi bi-unlock ' + $71285a979481ea35$export$743fdfb094991ec6
                                    })
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("i", {
                            className: 'bi bi-trash ' + $71285a979481ea35$export$c6e11f163cc2dc47,
                            onClick: ()=>{
                                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                                const yesNo = confirm('Are you sure you want to delete this report?');
                                if (yesNo) fb.deleteReport(p.jobId);
                            }
                        })
                    ]
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
const $e6c16966fa3d22d4$export$f2b96e571871cea1 = (scrollRef, uiStore, scrollSpeed = 100)=>{
    const scrollInterval = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        const clearTimer = ()=>{
            if (scrollInterval.current) {
                clearInterval(scrollInterval.current);
                scrollInterval.current = null;
            }
        };
        clearTimer();
        if (scrollRef) {
            if (uiStore.scrolling == 'UP') scrollInterval.current = setInterval(()=>{
                if (scrollRef) scrollRef.scrollBy(0, -scrollSpeed);
            }, 50);
            else if (uiStore.scrolling == 'DOWN') scrollInterval.current = setInterval(()=>{
                if (scrollRef) scrollRef.scrollBy(0, scrollSpeed);
            }, 50);
            return ()=>{
                clearTimer();
            };
        }
    }, [
        scrollRef,
        uiStore.scrolling
    ]);
};




var $8nGP5 = parcelRequire("8nGP5");

var $fCKK7 = parcelRequire("fCKK7");
function $cc4347c94e2e0bfc$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = opts.initialDeps ?? [];
    let result;
    function memoizedFunction() {
        var _a, _b, _c, _d;
        let depTime;
        if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
        result = fn(...newDeps);
        if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
            const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
            const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
            const resultFpsPercentage = resultEndTime / 16;
            const pad = (str, num)=>{
                str = String(str);
                while(str.length < num)str = " " + str;
                return str;
            };
            console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
        }
        (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
        return result;
    }
    memoizedFunction.updateDeps = (newDeps)=>{
        deps = newDeps;
    };
    return memoizedFunction;
}
function $cc4347c94e2e0bfc$export$9a1adf421b69c6a(value, msg) {
    if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
    else return value;
}
const $cc4347c94e2e0bfc$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
const $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
    let timeoutId;
    return function(...args) {
        targetWindow.clearTimeout(timeoutId);
        timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
    };
};


const $4d01f19e09510362$export$76974b428a49f15b = (index)=>index;
const $4d01f19e09510362$export$7eb7cb13fd21e5e1 = (range)=>{
    const start = Math.max(range.startIndex - range.overscan, 0);
    const end = Math.min(range.endIndex + range.overscan, range.count - 1);
    const arr = [];
    for(let i = start; i <= end; i++)arr.push(i);
    return arr;
};
const $4d01f19e09510362$export$5a50ff2cde8c3802 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    const handler = (rect)=>{
        const { width: width, height: height } = rect;
        cb({
            width: Math.round(width),
            height: Math.round(height)
        });
    };
    handler(element.getBoundingClientRect());
    if (!targetWindow.ResizeObserver) return ()=>{};
    const observer = new targetWindow.ResizeObserver((entries)=>{
        const run = ()=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler(element.getBoundingClientRect());
        };
        instance.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
    });
    observer.observe(element, {
        box: "border-box"
    });
    return ()=>{
        observer.unobserve(element);
    };
};
const $4d01f19e09510362$var$addEventListenerOptions = {
    passive: true
};
const $4d01f19e09510362$export$e911b82c7a99311 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const handler = ()=>{
        cb({
            width: element.innerWidth,
            height: element.innerHeight
        });
    };
    handler();
    element.addEventListener("resize", handler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("resize", handler);
    };
};
const $4d01f19e09510362$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
const $4d01f19e09510362$export$fbc040aee017375a = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend ? ()=>void 0 : (0, $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            const { horizontal: horizontal, isRtl: isRtl } = instance.options;
            offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $4d01f19e09510362$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $4d01f19e09510362$export$518998f8c5d09287 = (instance, cb)=>{
    const element = instance.scrollElement;
    if (!element) return;
    const targetWindow = instance.targetWindow;
    if (!targetWindow) return;
    let offset = 0;
    const fallback = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend ? ()=>void 0 : (0, $cc4347c94e2e0bfc$export$61fc7d43ac8f84b0)(targetWindow, ()=>{
        cb(offset, false);
    }, instance.options.isScrollingResetDelay);
    const createHandler = (isScrolling)=>()=>{
            offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
            fallback();
            cb(offset, isScrolling);
        };
    const handler = createHandler(true);
    const endHandler = createHandler(false);
    endHandler();
    element.addEventListener("scroll", handler, $4d01f19e09510362$var$addEventListenerOptions);
    const registerScrollendEvent = instance.options.useScrollendEvent && $4d01f19e09510362$var$supportsScrollend;
    if (registerScrollendEvent) element.addEventListener("scrollend", endHandler, $4d01f19e09510362$var$addEventListenerOptions);
    return ()=>{
        element.removeEventListener("scroll", handler);
        if (registerScrollendEvent) element.removeEventListener("scrollend", endHandler);
    };
};
const $4d01f19e09510362$export$6aa9c23c0f5932af = (element, entry, instance)=>{
    if (entry == null ? void 0 : entry.borderBoxSize) {
        const box = entry.borderBoxSize[0];
        if (box) {
            const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
            return size;
        }
    }
    return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
const $4d01f19e09510362$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
const $4d01f19e09510362$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
    var _a, _b;
    const toOffset = offset + adjustments;
    (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
        [instance.options.horizontal ? "left" : "top"]: toOffset,
        behavior: behavior
    });
};
class $4d01f19e09510362$export$89be5a243e59c4b2 {
    constructor(opts){
        this.unsubs = [];
        this.scrollElement = null;
        this.targetWindow = null;
        this.isScrolling = false;
        this.scrollToIndexTimeoutId = null;
        this.measurementsCache = [];
        this.itemSizeCache = /* @__PURE__ */ new Map();
        this.pendingMeasuredCacheIndexes = [];
        this.scrollRect = null;
        this.scrollOffset = null;
        this.scrollDirection = null;
        this.scrollAdjustments = 0;
        this.elementsCache = /* @__PURE__ */ new Map();
        this.observer = /* @__PURE__ */ (()=>{
            let _ro = null;
            const get = ()=>{
                if (_ro) return _ro;
                if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        const run = ()=>{
                            this._measureElement(entry.target, entry);
                        };
                        this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(run) : run();
                    });
                });
            };
            return {
                disconnect: ()=>{
                    var _a;
                    (_a = get()) == null || _a.disconnect();
                    _ro = null;
                },
                observe: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.observe(target, {
                        box: "border-box"
                    });
                },
                unobserve: (target)=>{
                    var _a;
                    return (_a = get()) == null ? void 0 : _a.unobserve(target);
                }
            };
        })();
        this.range = null;
        this.setOptions = (opts2)=>{
            Object.entries(opts2).forEach(([key, value])=>{
                if (typeof value === "undefined") delete opts2[key];
            });
            this.options = {
                debug: false,
                initialOffset: 0,
                overscan: 1,
                paddingStart: 0,
                paddingEnd: 0,
                scrollPaddingStart: 0,
                scrollPaddingEnd: 0,
                horizontal: false,
                getItemKey: $4d01f19e09510362$export$76974b428a49f15b,
                rangeExtractor: $4d01f19e09510362$export$7eb7cb13fd21e5e1,
                onChange: ()=>{},
                measureElement: $4d01f19e09510362$export$6aa9c23c0f5932af,
                initialRect: {
                    width: 0,
                    height: 0
                },
                scrollMargin: 0,
                gap: 0,
                indexAttribute: "data-index",
                initialMeasurementsCache: [],
                lanes: 1,
                isScrollingResetDelay: 150,
                enabled: true,
                isRtl: false,
                useScrollendEvent: false,
                useAnimationFrameWithResizeObserver: false,
                ...opts2
            };
        };
        this.notify = (sync)=>{
            var _a, _b;
            (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
        };
        this.maybeNotify = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>{
            this.calculateRange();
            return [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ];
        }, (isScrolling)=>{
            this.notify(isScrolling);
        }, {
            key: false,
            debug: ()=>this.options.debug,
            initialDeps: [
                this.isScrolling,
                this.range ? this.range.startIndex : null,
                this.range ? this.range.endIndex : null
            ]
        });
        this.cleanup = ()=>{
            this.unsubs.filter(Boolean).forEach((d)=>d());
            this.unsubs = [];
            this.observer.disconnect();
            this.scrollElement = null;
            this.targetWindow = null;
        };
        this._didMount = ()=>{
            return ()=>{
                this.cleanup();
            };
        };
        this._willUpdate = ()=>{
            var _a;
            const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
            if (this.scrollElement !== scrollElement) {
                this.cleanup();
                if (!scrollElement) {
                    this.maybeNotify();
                    return;
                }
                this.scrollElement = scrollElement;
                if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                this.elementsCache.forEach((cached)=>{
                    this.observer.observe(cached);
                });
                this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: void 0,
                    behavior: void 0
                });
                this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                    this.scrollRect = rect;
                    this.maybeNotify();
                }));
                this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                    this.scrollAdjustments = 0;
                    this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                    this.scrollOffset = offset;
                    this.isScrolling = isScrolling;
                    this.maybeNotify();
                }));
            }
        };
        this.getSize = ()=>{
            if (!this.options.enabled) {
                this.scrollRect = null;
                return 0;
            }
            this.scrollRect = this.scrollRect ?? this.options.initialRect;
            return this.scrollRect[this.options.horizontal ? "width" : "height"];
        };
        this.getScrollOffset = ()=>{
            if (!this.options.enabled) {
                this.scrollOffset = null;
                return 0;
            }
            this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
            return this.scrollOffset;
        };
        this.getFurthestMeasurement = (measurements, index)=>{
            const furthestMeasurementsFound = /* @__PURE__ */ new Map();
            const furthestMeasurements = /* @__PURE__ */ new Map();
            for(let m = index - 1; m >= 0; m--){
                const measurement = measurements[m];
                if (furthestMeasurementsFound.has(measurement.lane)) continue;
                const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                if (furthestMeasurementsFound.size === this.options.lanes) break;
            }
            return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                if (a.end === b.end) return a.index - b.index;
                return a.end - b.end;
            })[0] : void 0;
        };
        this.getMeasurementOptions = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.options.count,
                this.options.paddingStart,
                this.options.scrollMargin,
                this.options.getItemKey,
                this.options.enabled
            ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
            this.pendingMeasuredCacheIndexes = [];
            return {
                count: count,
                paddingStart: paddingStart,
                scrollMargin: scrollMargin,
                getItemKey: getItemKey,
                enabled: enabled
            };
        }, {
            key: false
        });
        this.getMeasurements = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getMeasurementOptions(),
                this.itemSizeCache
            ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
            if (!enabled) {
                this.measurementsCache = [];
                this.itemSizeCache.clear();
                return [];
            }
            if (this.measurementsCache.length === 0) {
                this.measurementsCache = this.options.initialMeasurementsCache;
                this.measurementsCache.forEach((item)=>{
                    this.itemSizeCache.set(item.key, item.size);
                });
            }
            const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
            this.pendingMeasuredCacheIndexes = [];
            const measurements = this.measurementsCache.slice(0, min);
            for(let i = min; i < count; i++){
                const key = getItemKey(i);
                const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                const measuredSize = itemSizeCache.get(key);
                const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                const end = start + size;
                const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                measurements[i] = {
                    index: i,
                    start: start,
                    size: size,
                    end: end,
                    key: key,
                    lane: lane
                };
            }
            this.measurementsCache = measurements;
            return measurements;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.calculateRange = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getMeasurements(),
                this.getSize(),
                this.getScrollOffset(),
                this.options.lanes
            ], (measurements, outerSize, scrollOffset, lanes)=>{
            return this.range = measurements.length > 0 && outerSize > 0 ? $4d01f19e09510362$var$calculateRange({
                measurements: measurements,
                outerSize: outerSize,
                scrollOffset: scrollOffset,
                lanes: lanes
            }) : null;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualIndexes = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>{
            let startIndex = null;
            let endIndex = null;
            const range = this.calculateRange();
            if (range) {
                startIndex = range.startIndex;
                endIndex = range.endIndex;
            }
            this.maybeNotify.updateDeps([
                this.isScrolling,
                startIndex,
                endIndex
            ]);
            return [
                this.options.rangeExtractor,
                this.options.overscan,
                this.options.count,
                startIndex,
                endIndex
            ];
        }, (rangeExtractor, overscan, count, startIndex, endIndex)=>{
            return startIndex === null || endIndex === null ? [] : rangeExtractor({
                startIndex: startIndex,
                endIndex: endIndex,
                overscan: overscan,
                count: count
            });
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.indexFromElement = (node)=>{
            const attributeName = this.options.indexAttribute;
            const indexStr = node.getAttribute(attributeName);
            if (!indexStr) {
                console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                return -1;
            }
            return parseInt(indexStr, 10);
        };
        this._measureElement = (node, entry)=>{
            const index = this.indexFromElement(node);
            const item = this.measurementsCache[index];
            if (!item) return;
            const key = item.key;
            const prevNode = this.elementsCache.get(key);
            if (prevNode !== node) {
                if (prevNode) this.observer.unobserve(prevNode);
                this.observer.observe(node);
                this.elementsCache.set(key, node);
            }
            if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
        };
        this.resizeItem = (index, size)=>{
            const item = this.measurementsCache[index];
            if (!item) return;
            const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
            const delta = size - itemSize;
            if (delta !== 0) {
                if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                    adjustments: this.scrollAdjustments += delta,
                    behavior: void 0
                });
                this.pendingMeasuredCacheIndexes.push(item.index);
                this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                this.notify(false);
            }
        };
        this.measureElement = (node)=>{
            if (!node) {
                this.elementsCache.forEach((cached, key)=>{
                    if (!cached.isConnected) {
                        this.observer.unobserve(cached);
                        this.elementsCache.delete(key);
                    }
                });
                return;
            }
            this._measureElement(node, void 0);
        };
        this.getVirtualItems = (0, $cc4347c94e2e0bfc$export$7c73462e0d25e514)(()=>[
                this.getVirtualIndexes(),
                this.getMeasurements()
            ], (indexes, measurements)=>{
            const virtualItems = [];
            for(let k = 0, len = indexes.length; k < len; k++){
                const i = indexes[k];
                const measurement = measurements[i];
                virtualItems.push(measurement);
            }
            return virtualItems;
        }, {
            key: false,
            debug: ()=>this.options.debug
        });
        this.getVirtualItemForOffset = (offset)=>{
            const measurements = this.getMeasurements();
            if (measurements.length === 0) return void 0;
            return (0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(measurements[$4d01f19e09510362$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(measurements[index]).start, offset)]);
        };
        this.getOffsetForAlignment = (toOffset, align, itemSize = 0)=>{
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") align = toOffset >= scrollOffset + size ? "end" : "start";
            if (align === "center") toOffset += (itemSize - size) / 2;
            else if (align === "end") toOffset -= size;
            const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
            const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
            const maxOffset = scrollSize - size;
            return Math.max(Math.min(maxOffset, toOffset), 0);
        };
        this.getOffsetForIndex = (index, align = "auto")=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            const item = this.measurementsCache[index];
            if (!item) return void 0;
            const size = this.getSize();
            const scrollOffset = this.getScrollOffset();
            if (align === "auto") {
                if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                else return [
                    scrollOffset,
                    align
                ];
            }
            const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
            return [
                this.getOffsetForAlignment(toOffset, align, item.size),
                align
            ];
        };
        this.isDynamicMode = ()=>this.elementsCache.size > 0;
        this.cancelScrollToIndex = ()=>{
            if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                this.scrollToIndexTimeoutId = null;
            }
        };
        this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
            index = Math.max(0, Math.min(index, this.options.count - 1));
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
            if (!offsetAndAlign) return;
            const [offset, align] = offsetAndAlign;
            this._scrollToOffset(offset, {
                adjustments: void 0,
                behavior: behavior
            });
            if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                this.scrollToIndexTimeoutId = null;
                const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                if (elementInDOM) {
                    const [latestOffset] = (0, $cc4347c94e2e0bfc$export$9a1adf421b69c6a)(this.getOffsetForIndex(index, align));
                    if (!(0, $cc4347c94e2e0bfc$export$8a4f1dcc58a69dbd)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                } else this.scrollToIndex(index, {
                    align: align,
                    behavior: behavior
                });
            });
        };
        this.scrollBy = (delta, { behavior: behavior } = {})=>{
            this.cancelScrollToIndex();
            if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
            this._scrollToOffset(this.getScrollOffset() + delta, {
                adjustments: void 0,
                behavior: behavior
            });
        };
        this.getTotalSize = ()=>{
            var _a;
            const measurements = this.getMeasurements();
            let end;
            if (measurements.length === 0) end = this.options.paddingStart;
            else if (this.options.lanes === 1) end = ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0;
            else {
                const endByLane = Array(this.options.lanes).fill(null);
                let endIndex = measurements.length - 1;
                while(endIndex >= 0 && endByLane.some((val)=>val === null)){
                    const item = measurements[endIndex];
                    if (endByLane[item.lane] === null) endByLane[item.lane] = item.end;
                    endIndex--;
                }
                end = Math.max(...endByLane.filter((val)=>val !== null));
            }
            return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
        };
        this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
            this.options.scrollToFn(offset, {
                behavior: behavior,
                adjustments: adjustments
            }, this);
        };
        this.measure = ()=>{
            this.itemSizeCache = /* @__PURE__ */ new Map();
            this.notify(false);
        };
        this.setOptions(opts);
    }
}
const $4d01f19e09510362$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
    while(low <= high){
        const middle = (low + high) / 2 | 0;
        const currentValue = getCurrentValue(middle);
        if (currentValue < value) low = middle + 1;
        else if (currentValue > value) high = middle - 1;
        else return middle;
    }
    if (low > 0) return low - 1;
    else return 0;
};
function $4d01f19e09510362$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset, lanes: lanes }) {
    const lastIndex = measurements.length - 1;
    const getOffset = (index)=>measurements[index].start;
    if (measurements.length <= lanes) return {
        startIndex: 0,
        endIndex: lastIndex
    };
    let startIndex = $4d01f19e09510362$var$findNearestBinarySearch(0, lastIndex, getOffset, scrollOffset);
    let endIndex = startIndex;
    if (lanes === 1) while(endIndex < lastIndex && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
    else if (lanes > 1) {
        const endPerLane = Array(lanes).fill(0);
        while(endIndex < lastIndex && endPerLane.some((pos)=>pos < scrollOffset + outerSize)){
            const item = measurements[endIndex];
            endPerLane[item.lane] = item.end;
            endIndex++;
        }
        const startPerLane = Array(lanes).fill(scrollOffset + outerSize);
        while(startIndex >= 0 && startPerLane.some((pos)=>pos >= scrollOffset)){
            const item = measurements[startIndex];
            startPerLane[item.lane] = item.start;
            startIndex--;
        }
        startIndex = Math.max(0, startIndex - startIndex % lanes);
        endIndex = Math.min(lastIndex, endIndex + (lanes - 1 - endIndex % lanes));
    }
    return {
        startIndex: startIndex,
        endIndex: endIndex
    };
}


const $4491e497d1ac4c45$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $8nGP5.useLayoutEffect : $8nGP5.useEffect;
function $4491e497d1ac4c45$var$useVirtualizerBase(options) {
    const rerender = $8nGP5.useReducer(()=>({}), {})[1];
    const resolvedOptions = {
        ...options,
        onChange: (instance2, sync)=>{
            var _a;
            if (sync) (0, $fCKK7.flushSync)(rerender);
            else rerender();
            (_a = options.onChange) == null || _a.call(options, instance2, sync);
        }
    };
    const [instance] = $8nGP5.useState(()=>new (0, $4d01f19e09510362$export$89be5a243e59c4b2)(resolvedOptions));
    instance.setOptions(resolvedOptions);
    $4491e497d1ac4c45$var$useIsomorphicLayoutEffect(()=>{
        return instance._didMount();
    }, []);
    $4491e497d1ac4c45$var$useIsomorphicLayoutEffect(()=>{
        return instance._willUpdate();
    });
    return instance;
}
function $4491e497d1ac4c45$export$dd6d526d88b5a137(options) {
    return $4491e497d1ac4c45$var$useVirtualizerBase({
        observeElementRect: $4d01f19e09510362$export$5a50ff2cde8c3802,
        observeElementOffset: $4d01f19e09510362$export$fbc040aee017375a,
        scrollToFn: (0, $4d01f19e09510362$export$1cdb988e5ab69fe7),
        ...options
    });
}
function $4491e497d1ac4c45$export$645722dcac657cb9(options) {
    return $4491e497d1ac4c45$var$useVirtualizerBase({
        getScrollElement: ()=>typeof document !== "undefined" ? window : null,
        observeElementRect: (0, $4d01f19e09510362$export$e911b82c7a99311),
        observeElementOffset: (0, $4d01f19e09510362$export$518998f8c5d09287),
        scrollToFn: (0, $4d01f19e09510362$export$2162c5b3eeedd27),
        initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
        ...options
    });
}




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $3a0100122386f550$var$g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function $3a0100122386f550$export$2e2bcd8739ae039({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, $8nGP5.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, $8nGP5.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, $8nGP5.useRef)(!1);
    (0, $8nGP5.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, $8nGP5.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !$3a0100122386f550$var$D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? $3a0100122386f550$var$g(r, f) : r,
            d ? $3a0100122386f550$var$g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = $3a0100122386f550$var$E(r), b());
    };
    return $3a0100122386f550$var$X(s, !!t), $3a0100122386f550$var$W(m), (0, $8nGP5.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, $8nGP5.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function $3a0100122386f550$var$W(n) {
    (0, $8nGP5.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function $3a0100122386f550$var$X(n, t) {
    (0, $8nGP5.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function $3a0100122386f550$var$E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...$3a0100122386f550$var$E(n.parentElement)
    ];
}
const $3a0100122386f550$var$k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], $3a0100122386f550$var$D = (n, t)=>$3a0100122386f550$var$k.every((o)=>n[o] === t[o]);




const $9a6a933c7ac9e24c$export$1eab25c49fe72a2f = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const thumbMinSize = 660;
    const parentRef = (0, $8nGP5.useRef)(null);
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [resizeRef, bounds] = (0, $3a0100122386f550$export$2e2bcd8739ae039)();
    const [elementsPerLine, setElementsPerLine] = (0, $8nGP5.useState)(3);
    const deals = [
        ...props.deals
    ];
    const [totalRows, setTotalRows] = (0, $8nGP5.useState)(props.deals.length / elementsPerLine); //Good guess
    const rowVirtualizer = (0, $4491e497d1ac4c45$export$dd6d526d88b5a137)({
        count: totalRows,
        getScrollElement: ()=>parentRef.current,
        estimateSize: (i)=>415,
        overscan: 2
    });
    (0, $e6c16966fa3d22d4$export$f2b96e571871cea1)(parentRef.current, uiStore);
    const totalRowsNeeded = Math.ceil(deals.length / elementsPerLine);
    if (totalRows !== totalRowsNeeded) setTotalRows(totalRowsNeeded);
    if (bounds.width > 0) {
        const expectedElemsPerLine = Math.max(Math.floor(bounds.width / thumbMinSize), 1);
        if (expectedElemsPerLine !== elementsPerLine) setElementsPerLine(expectedElemsPerLine);
    }
    const fillLine = deals.length % elementsPerLine;
    if (elementsPerLine > 1) for(let i = 0; i < elementsPerLine - fillLine; i++)deals.push((0, $kSbwP.jsx)((0, $9e54bdf16921cff4$export$fe8b4069b38236f9), {}, 'empty_' + i.toString()));
    return (0, $kSbwP.jsxs)("div", {
        style: {
            height: 'calc(100vh - 250px)',
            width: 'calc(100% + 20px)'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                ref: resizeRef,
                style: {
                    width: '100%',
                    height: '1px',
                    position: 'absolute'
                }
            }),
            (0, $kSbwP.jsx)("div", {
                ref: parentRef,
                style: {
                    height: `100%`,
                    width: `100%`,
                    overflow: 'auto',
                    scrollbarColor: ' #eaecf0',
                    scrollbarWidth: 'thin'
                },
                children: (0, $kSbwP.jsx)("div", {
                    style: {
                        height: `${rowVirtualizer.getTotalSize()}px`,
                        width: '100%',
                        position: 'relative'
                    },
                    children: rowVirtualizer.getVirtualItems().map((virtualRow)=>{
                        const dealsElements = [];
                        for(var i = 0; i < elementsPerLine; i++)dealsElements.push(deals[virtualRow.index * elementsPerLine + i]);
                        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                            style: {
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: `400px`,
                                transform: `translateY(${virtualRow.start}px)`
                            },
                            children: dealsElements
                        }, virtualRow.index);
                    })
                })
            })
        ]
    });
});


const $a283eceebd9e41ec$export$632b367007f30628 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8nGP5.useEffect)(()=>{
        uiStore.dealPageIndustrySearch = [];
        uiStore.dealPageNameSearch = '';
    }, []);
    const dealKeys = Object.keys(store.reportDataDB);
    //Show completed reports
    var filtered = dealKeys.filter((deal)=>{
        var e = store.reportDataDB[deal];
        var status = e.status;
        if (status != 'completed') return false;
        var dataAccess = store.createDataAccess(deal);
        const companyName = dataAccess.companyName;
        const matchCompanyName = companyName.toLowerCase().includes(uiStore.dealPageNameSearch.toLowerCase()) || uiStore.dealPageNameSearch == '';
        const filter = uiStore.dealPageIndustrySearch;
        var industry = dataAccess.value('industry');
        var sub_industry = dataAccess.value('industrySubType');
        var matchIndustry = false;
        if (filter.length == 0) matchIndustry = true;
        else filter.forEach((filterItem)=>{
            if (filterItem.type == 'category') {
                if (filterItem.value == industry) matchIndustry = true;
            } else if (filterItem.type == 'sub_category') {
                if (filterItem.value == sub_industry) matchIndustry = true;
            }
        });
        const filterScore = uiStore.dealPageScoreSearch;
        var matchScore = true;
        if (filterScore.length > 0) {
            var type = filterScore[0];
            const score = dataAccess.score();
            if (type == 'All') matchScore = true;
            else if (type == 'Strong') matchScore = score > 85;
            else if (type == 'Medium') matchScore = score > 60 && score <= 85;
            else if (type == 'Weak') matchScore = score <= 60;
        }
        // if (matchCompanyName && matchIndustry && matchScore) {
        //     console.log('Match');
        // }
        return matchCompanyName && matchIndustry && matchScore;
    });
    //sort by creation than name
    filtered = filtered.sort((a, b)=>{
        const ep1 = store.reportDataDB[a].report_creation_epoch || 0;
        const ep2 = store.reportDataDB[b].report_creation_epoch || 0;
        if (ep1 === ep2) {
            const aName = store.reportDataDB[a].company_name;
            const bName = store.reportDataDB[b].company_name;
            return aName.localeCompare(bName);
        } else return ep2 - ep1;
    });
    //Add pending jobs to view
    const pendingJobs = [];
    if (uiStore.dealPageNameSearch.length == 0) for(const key in store.jobs){
        var e = store.jobs[key];
        if (e.status == 'pending') pendingJobs.push(key);
    }
    const queuedFilesInJobs = [];
    for(var jobId in store.jobs){
        var job = store.jobs[jobId];
        if (job.status == 'pending') queuedFilesInJobs.push(job.fileName.toLowerCase());
    }
    var activeJob = store.activeJob;
    if (store.activeJob) {
        const job = store.activeJob;
        if (job.status == 'processing') {
            const fileName = activeJob.fileName.toLowerCase();
            queuedFilesInJobs.push(fileName);
        }
    }
    const pdfLocked = [];
    //Switch to sorting the view by the final IDs
    for(const key in store.reportDataDB){
        var e = store.reportDataDB[key];
        var file = e['pdf'];
        if (e.status == 'failed' && e['error'] == 'pdf_password' && !queuedFilesInJobs.includes(file.toLowerCase())) pdfLocked.push(key);
    }
    if (pendingJobs.length > 0) pendingJobs.forEach((jobId, index)=>{
        if (!filtered.includes(jobId)) {
            if (index < 4) filtered.unshift(jobId);
            else filtered.push(jobId);
        }
    });
    if (pdfLocked.length > 0) pdfLocked.forEach((jobId)=>{
        if (!filtered.includes(jobId)) filtered.unshift(jobId);
    });
    if (store.activeJob && store.activeJob.status === 'processing' && !filtered.includes(store.activeJob.jobId)) {
        const jobs = store.jobs;
        for(const key in jobs);
        filtered.unshift(store.activeJob.jobId);
    }
    let deals = filtered.map((deal)=>{
        if (pdfLocked.includes(deal) && !pendingJobs.includes(deal)) return (0, $kSbwP.jsx)((0, $5f2582552430e6bc$export$57d7964eb05a4d4e), {
            jobId: deal
        }, deal);
        else if (store.activeJob && store.activeJob.status === 'processing' && deal === store.activeJob.jobId || pendingJobs.includes(deal)) return (0, $kSbwP.jsx)((0, $a3827455c2ec81f0$export$7750bf75c5a3c423), {
            jobId: deal
        }, deal);
        return (0, $kSbwP.jsx)((0, $9e54bdf16921cff4$export$ec96aade4c78ed16), {
            name: deal
        }, deal);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            className: $def1233c7c6126ed$export$34e0f9847d4c02dd,
            justify: "start",
            children: [
                (0, $kSbwP.jsx)((0, $959d475eae63db88$export$552e6df88a6b2171), {}),
                (0, $kSbwP.jsx)((0, $9a6a933c7ac9e24c$export$1eab25c49fe72a2f), {
                    deals: deals
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");









var $kSbwP = parcelRequire("kSbwP");



var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $9540cd6ba7792ada$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $9540cd6ba7792ada$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $9540cd6ba7792ada$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $9540cd6ba7792ada$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $9540cd6ba7792ada$export$697502632950e9d3 extends (0, $474ae12482b554c6$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($9540cd6ba7792ada$var$prependCode(code), `Firebase Storage: ${message} (${$9540cd6ba7792ada$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $9540cd6ba7792ada$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $9540cd6ba7792ada$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $9540cd6ba7792ada$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($9540cd6ba7792ada$export$54592d666d6ce114 || ($9540cd6ba7792ada$export$54592d666d6ce114 = {}));
function $9540cd6ba7792ada$var$prependCode(code) {
    return 'storage/' + code;
}
function $9540cd6ba7792ada$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNKNOWN, message);
}
function $9540cd6ba7792ada$var$objectNotFound(path) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $9540cd6ba7792ada$var$quotaExceeded(bucket) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $9540cd6ba7792ada$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $9540cd6ba7792ada$var$unauthorizedApp() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $9540cd6ba7792ada$var$unauthorized(path) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $9540cd6ba7792ada$var$retryLimitExceeded() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $9540cd6ba7792ada$var$canceled() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $9540cd6ba7792ada$var$invalidUrl(url) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $9540cd6ba7792ada$var$invalidDefaultBucket(bucket) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $9540cd6ba7792ada$var$noDefaultBucket() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $9540cd6ba7792ada$var$cannotSliceBlob() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $9540cd6ba7792ada$var$serverFileWrongSize() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $9540cd6ba7792ada$var$noDownloadURL() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $9540cd6ba7792ada$var$missingPolyFill(polyFill) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$8f74d9881d1936fd(message) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $9540cd6ba7792ada$var$appDeleted() {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $9540cd6ba7792ada$export$61f54cdc36500ad(name) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $9540cd6ba7792ada$var$invalidFormat(format, message) {
    return new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $9540cd6ba7792ada$var$internalError(message) {
    throw new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $9540cd6ba7792ada$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $9540cd6ba7792ada$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $9540cd6ba7792ada$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $9540cd6ba7792ada$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $9540cd6ba7792ada$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $9540cd6ba7792ada$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $9540cd6ba7792ada$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $9540cd6ba7792ada$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $9540cd6ba7792ada$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $9540cd6ba7792ada$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $9540cd6ba7792ada$var$isFunction(p) {
    return typeof p === 'function';
}
function $9540cd6ba7792ada$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $9540cd6ba7792ada$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $9540cd6ba7792ada$var$isNativeBlob(p) {
    return $9540cd6ba7792ada$var$isNativeBlobDefined() && p instanceof Blob;
}
function $9540cd6ba7792ada$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $9540cd6ba7792ada$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $9540cd6ba7792ada$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $9540cd6ba7792ada$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $9540cd6ba7792ada$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $9540cd6ba7792ada$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($9540cd6ba7792ada$var$ErrorCode || ($9540cd6ba7792ada$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $9540cd6ba7792ada$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $9540cd6ba7792ada$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $9540cd6ba7792ada$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $9540cd6ba7792ada$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $9540cd6ba7792ada$var$ErrorCode.ABORT;
                    backoffCallback(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $9540cd6ba7792ada$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($9540cd6ba7792ada$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $9540cd6ba7792ada$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $9540cd6ba7792ada$var$appDeleted() : $9540cd6ba7792ada$var$canceled();
                    reject(err);
                } else {
                    const err = $9540cd6ba7792ada$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $9540cd6ba7792ada$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $9540cd6ba7792ada$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $9540cd6ba7792ada$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $9540cd6ba7792ada$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $9540cd6ba7792ada$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $9540cd6ba7792ada$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion !== null && firebaseVersion !== void 0 ? firebaseVersion : 'AppManager');
}
function $9540cd6ba7792ada$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $9540cd6ba7792ada$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $9540cd6ba7792ada$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true) {
    const queryPart = $9540cd6ba7792ada$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $9540cd6ba7792ada$var$addGmpidHeader_(headers, appId);
    $9540cd6ba7792ada$var$addAuthHeader_(headers, authToken);
    $9540cd6ba7792ada$var$addVersionHeader_(headers, firebaseVersion);
    $9540cd6ba7792ada$var$addAppCheckHeader_(headers, appCheckToken);
    return new $9540cd6ba7792ada$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $9540cd6ba7792ada$var$getBlob$1(...args) {
    const BlobBuilder1 = $9540cd6ba7792ada$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($9540cd6ba7792ada$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $9540cd6ba7792ada$export$697502632950e9d3($9540cd6ba7792ada$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $9540cd6ba7792ada$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $9540cd6ba7792ada$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $9540cd6ba7792ada$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $9540cd6ba7792ada$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $9540cd6ba7792ada$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$utf8Bytes_(stringData));
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64:
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64URL:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$base64Bytes_(format, stringData));
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL:
            return new $9540cd6ba7792ada$var$StringData($9540cd6ba7792ada$var$dataURLBytes_(stringData), $9540cd6ba7792ada$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $9540cd6ba7792ada$var$unknown();
}
function $9540cd6ba7792ada$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $9540cd6ba7792ada$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $9540cd6ba7792ada$var$invalidFormat($9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $9540cd6ba7792ada$var$utf8Bytes_(decoded);
}
function $9540cd6ba7792ada$var$base64Bytes_(format, value) {
    switch(format){
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $9540cd6ba7792ada$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $9540cd6ba7792ada$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $9540cd6ba7792ada$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $9540cd6ba7792ada$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $9540cd6ba7792ada$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $9540cd6ba7792ada$var$invalidFormat($9540cd6ba7792ada$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $9540cd6ba7792ada$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $9540cd6ba7792ada$var$dataURLBytes_(dataUrl) {
    const parts = new $9540cd6ba7792ada$var$DataURLParts(dataUrl);
    if (parts.base64) return $9540cd6ba7792ada$var$base64Bytes_($9540cd6ba7792ada$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $9540cd6ba7792ada$var$percentEncodedBytes_(parts.rest);
}
function $9540cd6ba7792ada$var$dataURLContentType_(dataUrl) {
    const parts = new $9540cd6ba7792ada$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $9540cd6ba7792ada$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $9540cd6ba7792ada$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($9540cd6ba7792ada$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($9540cd6ba7792ada$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $9540cd6ba7792ada$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($9540cd6ba7792ada$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $9540cd6ba7792ada$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7($9540cd6ba7792ada$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($9540cd6ba7792ada$var$isString(val)) return $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0($9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $9540cd6ba7792ada$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $9540cd6ba7792ada$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($9540cd6ba7792ada$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $9540cd6ba7792ada$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $9540cd6ba7792ada$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $9540cd6ba7792ada$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$noXform_(metadata, value) {
    return value;
}
class $9540cd6ba7792ada$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $9540cd6ba7792ada$var$noXform_;
    }
}
let $9540cd6ba7792ada$var$mappings_ = null;
function $9540cd6ba7792ada$var$xformPath(fullPath) {
    if (!$9540cd6ba7792ada$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $9540cd6ba7792ada$var$lastComponent(fullPath);
}
function $9540cd6ba7792ada$var$getMappings() {
    if ($9540cd6ba7792ada$var$mappings_) return $9540cd6ba7792ada$var$mappings_;
    const mappings = [];
    mappings.push(new $9540cd6ba7792ada$var$Mapping('bucket'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('generation'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('metageneration'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $9540cd6ba7792ada$var$xformPath(fullPath);
    }
    const nameMapping = new $9540cd6ba7792ada$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $9540cd6ba7792ada$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $9540cd6ba7792ada$var$Mapping('timeCreated'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('updated'));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('md5Hash', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('cacheControl', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentDisposition', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentEncoding', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentLanguage', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('contentType', null, true));
    mappings.push(new $9540cd6ba7792ada$var$Mapping('metadata', 'customMetadata', true));
    $9540cd6ba7792ada$var$mappings_ = mappings;
    return $9540cd6ba7792ada$var$mappings_;
}
function $9540cd6ba7792ada$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $9540cd6ba7792ada$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $9540cd6ba7792ada$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $9540cd6ba7792ada$var$addRef(metadata, service);
    return metadata;
}
function $9540cd6ba7792ada$var$fromResourceString(service, resourceString, mappings) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $9540cd6ba7792ada$var$fromResource(service, resource, mappings);
}
function $9540cd6ba7792ada$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$9540cd6ba7792ada$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $9540cd6ba7792ada$var$makeUrl(urlPart, host, protocol);
        const queryString = $9540cd6ba7792ada$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $9540cd6ba7792ada$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9540cd6ba7792ada$var$PREFIXES_KEY = 'prefixes';
const $9540cd6ba7792ada$var$ITEMS_KEY = 'items';
function $9540cd6ba7792ada$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$9540cd6ba7792ada$var$PREFIXES_KEY]) for (const path of resource[$9540cd6ba7792ada$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $9540cd6ba7792ada$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$9540cd6ba7792ada$var$ITEMS_KEY]) for (const item of resource[$9540cd6ba7792ada$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $9540cd6ba7792ada$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $9540cd6ba7792ada$var$fromResponseString(service, bucket, resourceString) {
    const obj = $9540cd6ba7792ada$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $9540cd6ba7792ada$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $9540cd6ba7792ada$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $9540cd6ba7792ada$var$handlerCheck(cndn) {
    if (!cndn) throw $9540cd6ba7792ada$var$unknown();
}
function $9540cd6ba7792ada$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $9540cd6ba7792ada$var$fromResourceString(service, text, mappings);
        $9540cd6ba7792ada$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $9540cd6ba7792ada$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $9540cd6ba7792ada$var$fromResponseString(service, bucket, text);
        $9540cd6ba7792ada$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $9540cd6ba7792ada$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $9540cd6ba7792ada$var$fromResourceString(service, text, mappings);
        $9540cd6ba7792ada$var$handlerCheck(metadata !== null);
        return $9540cd6ba7792ada$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $9540cd6ba7792ada$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $9540cd6ba7792ada$var$unauthorizedApp();
            else newErr = $9540cd6ba7792ada$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $9540cd6ba7792ada$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $9540cd6ba7792ada$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $9540cd6ba7792ada$var$objectErrorHandler(location) {
    const shared = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $9540cd6ba7792ada$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $9540cd6ba7792ada$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $9540cd6ba7792ada$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $9540cd6ba7792ada$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $9540cd6ba7792ada$var$objectErrorHandler(location);
    return requestInfo;
}
function $9540cd6ba7792ada$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $9540cd6ba7792ada$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $9540cd6ba7792ada$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $9540cd6ba7792ada$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $9540cd6ba7792ada$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $9540cd6ba7792ada$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, $9540cd6ba7792ada$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $9540cd6ba7792ada$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $9540cd6ba7792ada$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $9540cd6ba7792ada$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $9540cd6ba7792ada$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $9540cd6ba7792ada$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $9540cd6ba7792ada$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $9540cd6ba7792ada$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $9540cd6ba7792ada$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $9540cd6ba7792ada$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $9540cd6ba7792ada$var$handlerCheck(false);
        }
        $9540cd6ba7792ada$var$handlerCheck($9540cd6ba7792ada$var$isString(url));
        return url;
    }
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $9540cd6ba7792ada$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $9540cd6ba7792ada$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $9540cd6ba7792ada$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $9540cd6ba7792ada$var$handlerCheck(false);
        const size = Number(sizeString);
        $9540cd6ba7792ada$var$handlerCheck(!isNaN(size));
        return new $9540cd6ba7792ada$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $9540cd6ba7792ada$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $9540cd6ba7792ada$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $9540cd6ba7792ada$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $9540cd6ba7792ada$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $9540cd6ba7792ada$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $9540cd6ba7792ada$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $9540cd6ba7792ada$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $9540cd6ba7792ada$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $9540cd6ba7792ada$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $9540cd6ba7792ada$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $9540cd6ba7792ada$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $9540cd6ba7792ada$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $9540cd6ba7792ada$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $9540cd6ba7792ada$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error !== null && error !== void 0 ? error : undefined;
            this.complete = complete !== null && complete !== void 0 ? complete : undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9540cd6ba7792ada$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $9540cd6ba7792ada$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $9540cd6ba7792ada$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $9540cd6ba7792ada$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, body, headers) {
        if (this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .send() more than once');
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $9540cd6ba7792ada$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $9540cd6ba7792ada$var$XhrTextConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $9540cd6ba7792ada$var$newTextConnection() {
    return $9540cd6ba7792ada$var$textFactoryOverride ? $9540cd6ba7792ada$var$textFactoryOverride() : new $9540cd6ba7792ada$var$XhrTextConnection();
}
class $9540cd6ba7792ada$var$XhrBytesConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $9540cd6ba7792ada$var$newBytesConnection() {
    return new $9540cd6ba7792ada$var$XhrBytesConnection();
}
class $9540cd6ba7792ada$var$XhrBlobConnection extends $9540cd6ba7792ada$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $9540cd6ba7792ada$var$newBlobConnection() {
    return new $9540cd6ba7792ada$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $9540cd6ba7792ada$export$86a2a9b92406a048 {
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $9540cd6ba7792ada$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($9540cd6ba7792ada$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $9540cd6ba7792ada$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $9540cd6ba7792ada$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($9540cd6ba7792ada$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $9540cd6ba7792ada$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $9540cd6ba7792ada$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $9540cd6ba7792ada$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $9540cd6ba7792ada$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $9540cd6ba7792ada$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $9540cd6ba7792ada$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $9540cd6ba7792ada$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state)){
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS:
                    $9540cd6ba7792ada$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED:
                case $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $9540cd6ba7792ada$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $9540cd6ba7792ada$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.RUNNING:
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $9540cd6ba7792ada$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $9540cd6ba7792ada$var$async(observer.complete.bind(observer))();
                break;
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.CANCELED:
            case $9540cd6ba7792ada$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $9540cd6ba7792ada$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $9540cd6ba7792ada$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $9540cd6ba7792ada$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $9540cd6ba7792ada$export$adb98fff6714334) this._location = location;
        else this._location = $9540cd6ba7792ada$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $9540cd6ba7792ada$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $9540cd6ba7792ada$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $9540cd6ba7792ada$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $9540cd6ba7792ada$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $9540cd6ba7792ada$export$adb98fff6714334(this._location.bucket, newPath);
        return new $9540cd6ba7792ada$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $9540cd6ba7792ada$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $9540cd6ba7792ada$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $9540cd6ba7792ada$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $9540cd6ba7792ada$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $9540cd6ba7792ada$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $9540cd6ba7792ada$var$multipartUpload(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings(), new $9540cd6ba7792ada$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $9540cd6ba7792ada$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $9540cd6ba7792ada$export$86a2a9b92406a048(ref, new $9540cd6ba7792ada$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$var$uploadString$1(ref, value, format = $9540cd6ba7792ada$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $9540cd6ba7792ada$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = Object.assign({}, metadata);
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $9540cd6ba7792ada$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $9540cd6ba7792ada$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $9540cd6ba7792ada$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $9540cd6ba7792ada$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $9540cd6ba7792ada$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $9540cd6ba7792ada$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $9540cd6ba7792ada$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $9540cd6ba7792ada$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $9540cd6ba7792ada$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $9540cd6ba7792ada$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $9540cd6ba7792ada$var$getMetadata$2(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $9540cd6ba7792ada$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $9540cd6ba7792ada$var$updateMetadata$2(ref.storage, ref._location, metadata, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $9540cd6ba7792ada$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $9540cd6ba7792ada$var$getDownloadUrl(ref.storage, ref._location, $9540cd6ba7792ada$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection).then((url)=>{
        if (url === null) throw $9540cd6ba7792ada$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $9540cd6ba7792ada$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $9540cd6ba7792ada$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $9540cd6ba7792ada$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $9540cd6ba7792ada$var$_getChild$1(ref, childPath) {
    const newPath = $9540cd6ba7792ada$var$child(ref._location.path, childPath);
    const location = new $9540cd6ba7792ada$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $9540cd6ba7792ada$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $9540cd6ba7792ada$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $9540cd6ba7792ada$var$refFromURL(service, url) {
    return new $9540cd6ba7792ada$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $9540cd6ba7792ada$var$refFromPath(ref, path) {
    if (ref instanceof $9540cd6ba7792ada$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $9540cd6ba7792ada$var$noDefaultBucket();
        const reference = new $9540cd6ba7792ada$var$Reference(service, service._bucket);
        if (path != null) return $9540cd6ba7792ada$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $9540cd6ba7792ada$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $9540cd6ba7792ada$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $9540cd6ba7792ada$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $9540cd6ba7792ada$var$FirebaseStorageImpl) return $9540cd6ba7792ada$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $9540cd6ba7792ada$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $9540cd6ba7792ada$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $9540cd6ba7792ada$var$extractBucket(host, config) {
    const bucketString = config === null || config === void 0 ? void 0 : config[$9540cd6ba7792ada$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $9540cd6ba7792ada$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    storage._protocol = 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $474ae12482b554c6$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $9540cd6ba7792ada$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $9540cd6ba7792ada$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $9540cd6ba7792ada$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $9540cd6ba7792ada$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $9540cd6ba7792ada$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $9540cd6ba7792ada$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $9540cd6ba7792ada$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $9540cd6ba7792ada$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $9540cd6ba7792ada$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $9540cd6ba7792ada$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $9540cd6ba7792ada$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $9540cd6ba7792ada$var$FailRequest($9540cd6ba7792ada$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $9540cd6ba7792ada$var$name = "@firebase/storage";
const $9540cd6ba7792ada$var$version = "0.13.2";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $9540cd6ba7792ada$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $9540cd6ba7792ada$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $9540cd6ba7792ada$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $9540cd6ba7792ada$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $9540cd6ba7792ada$export$8548546c0aa631e6(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $9540cd6ba7792ada$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $9540cd6ba7792ada$export$8837f4fc672e936d(ref, options) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $9540cd6ba7792ada$export$6a265a7d315dec03(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $9540cd6ba7792ada$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $9540cd6ba7792ada$export$39c5ed4ec960eade(ref) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$deleteObject$1(ref);
}
function $9540cd6ba7792ada$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(serviceOrRef);
    return $9540cd6ba7792ada$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $9540cd6ba7792ada$export$9acd24c0fce96a85(ref, childPath) {
    return $9540cd6ba7792ada$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $9540cd6ba7792ada$export$fbd9b57a66480737(app = (0, $20ed53392b3edc61$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $20ed53392b3edc61$export$fa0d6da0f5838f50)(app, $9540cd6ba7792ada$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $474ae12482b554c6$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $9540cd6ba7792ada$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $9540cd6ba7792ada$export$9850e656f954b889(storage, host, port, options = {}) {
    $9540cd6ba7792ada$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $9540cd6ba7792ada$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $474ae12482b554c6$export$4befe9b5fa509a1b)(ref);
    return $9540cd6ba7792ada$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $9540cd6ba7792ada$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $9540cd6ba7792ada$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $9540cd6ba7792ada$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $20ed53392b3edc61$export$31499a9cd224b78c));
}
function $9540cd6ba7792ada$var$registerStorage() {
    (0, $20ed53392b3edc61$export$c930050e7bb63965)(new (0, $51d4719ad519d4e6$export$16fa2f45be04daa8)($9540cd6ba7792ada$var$STORAGE_TYPE, $9540cd6ba7792ada$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($9540cd6ba7792ada$var$name, $9540cd6ba7792ada$var$version, '');
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $20ed53392b3edc61$export$d29d5299a7137abc)($9540cd6ba7792ada$var$name, $9540cd6ba7792ada$var$version, 'esm2017');
}
$9540cd6ba7792ada$var$registerStorage();





var $fa12c9399a1a76ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/pdfs';
const $fa12c9399a1a76ec$var$STORAGE_PATH_RAG = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/rag';
const $fa12c9399a1a76ec$var$STORAGE_KNOWLEDGE_PATH = 'gs://' + (0, $b2432f43c421c848$export$7a667d08ed65fa47)().getConfig().storageBucket + '/knowledge';
class $fa12c9399a1a76ec$var$StorageAdapater {
    check_if_report_exists(fileName) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const docRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${fileName}`);
            try {
                yield (0, $9540cd6ba7792ada$export$c8bf645a0c2a7d9f)(docRef);
                return true;
            } catch (error) {
                return false;
            }
        });
    }
    buildStorageFolderPath(storageTarget, fileName) {
        switch(storageTarget.type){
            case 'cim':
                return `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${fileName}`;
            case 'rag':
                return `${$fa12c9399a1a76ec$var$STORAGE_PATH_RAG}/${storageTarget.reportId}/${fileName}`;
            case 'knowledge_base':
                return `${$fa12c9399a1a76ec$var$STORAGE_KNOWLEDGE_PATH}/${storageTarget.folder}/${fileName}`;
            default:
                throw new Error('Invalid storage target type');
        }
    }
    uploadFileToStorage(storageTarget, file, onProgress) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const userId = fb.userId;
            const userEmail = fb.user.email;
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            //const filePath = `${STORAGE_PATH_RAG}/${dealId}/${file.name}`;
            const filePath = this.buildStorageFolderPath(storageTarget, file.name);
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, filePath);
            const upload_task = (0, $9540cd6ba7792ada$export$3895d39eb7ac9b25)(storageRef, file);
            upload_task.on('state_changed', (snapshot)=>{
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                if (onProgress) onProgress(progress);
            }, (error)=>{
                return null;
            }, ()=>{});
            const metadata = {
                customMetadata: {
                    userId: userId,
                    userEmail: userEmail
                }
            };
            var snapshot = yield upload_task;
            yield (0, $9540cd6ba7792ada$export$f64791b2d30456a0)(storageRef, metadata);
            fb.triggerScanRagFiles();
            return filePath;
        });
    }
    deleteFileFromStorage(storageTarget, fileName) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const filePath = this.buildStorageFolderPath(storageTarget, fileName);
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, filePath);
            try {
                yield (0, $9540cd6ba7792ada$export$39c5ed4ec960eade)(storageRef);
            } catch (error) {
                return false;
            }
            return true;
        });
    }
    uploadReportPdf(file, onProgress) {
        return $fa12c9399a1a76ec$var$__awaiter(this, void 0, void 0, function*() {
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const userId = fb.userId;
            const userEmail = fb.user.email;
            const storage = (0, $9540cd6ba7792ada$export$fbd9b57a66480737)();
            const storageRef = (0, $9540cd6ba7792ada$export$eff4d24c3ff7876e)(storage, `${$fa12c9399a1a76ec$var$STORAGE_PATH_REPORTS}/${file.name}`);
            const upload_task = (0, $9540cd6ba7792ada$export$3895d39eb7ac9b25)(storageRef, file);
            upload_task.on('state_changed', (snapshot)=>{
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                const progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                if (onProgress) onProgress(progress);
            }, (error)=>{
                return false;
            }, ()=>{});
            const metadata = {
                customMetadata: {
                    userId: userId,
                    userEmail: userEmail
                }
            };
            var snapshot = yield upload_task;
            yield (0, $9540cd6ba7792ada$export$f64791b2d30456a0)(storageRef, metadata);
            return true;
        });
    }
}
const $fa12c9399a1a76ec$var$mStorageService = new $fa12c9399a1a76ec$var$StorageAdapater();
function $fa12c9399a1a76ec$export$39e0a5bed87a3667() {
    return $fa12c9399a1a76ec$var$mStorageService;
}




var $1bc40f4eb65039a9$export$40a9eeef55665a40;
var $1bc40f4eb65039a9$export$93b7586d956c930e;
var $1bc40f4eb65039a9$export$f843afa9e9b53052;
var $1bc40f4eb65039a9$export$ae78d338ad66ff90;
var $1bc40f4eb65039a9$export$b8972b998723d602;
var $1bc40f4eb65039a9$export$2778853eeaa53fa7;
$1bc40f4eb65039a9$export$40a9eeef55665a40 = `tEP1QG_defaultPadding`;
$1bc40f4eb65039a9$export$93b7586d956c930e = `tEP1QG_dropShadow`;
$1bc40f4eb65039a9$export$f843afa9e9b53052 = `tEP1QG_panelImage`;
$1bc40f4eb65039a9$export$ae78d338ad66ff90 = `tEP1QG_scaleInOut`;
$1bc40f4eb65039a9$export$ae78d338ad66ff90;
$1bc40f4eb65039a9$export$b8972b998723d602 = `tEP1QG_shadow`;
$1bc40f4eb65039a9$export$2778853eeaa53fa7 = `tEP1QG_taskPageDropZone`;



var $d39d5626a2a26fe7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ee62ca6949990202$export$2e2bcd8739ae039 = $ee62ca6949990202$var$extend;
/*
  var obj = {a: 3, b: 5};
  extend(obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 4, b: 5, c: 8}

  var obj = {a: 3, b: 5};
  extend({}, obj, {a: 4, c: 8}); // {a: 4, b: 5, c: 8}
  obj; // {a: 3, b: 5}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3, 4]}

  var arr = [1, 2, 3];
  var obj = {a: 3, b: 5};
  extend(true, obj, {c: arr}); // {a: 3, b: 5, c: [1, 2, 3]}
  arr.push(4);
  obj; // {a: 3, b: 5, c: [1, 2, 3]}

  extend({a: 4, b: 5}); // {a: 4, b: 5}
  extend({a: 4, b: 5}, 3); {a: 4, b: 5}
  extend({a: 4, b: 5}, true); {a: 4, b: 5}
  extend('hello', {a: 4, b: 5}); // throws
  extend(3, {a: 4, b: 5}); // throws
*/ function $ee62ca6949990202$var$extend() {
    var args = [].slice.call(arguments);
    var deep = false;
    if (typeof args[0] == 'boolean') deep = args.shift();
    var result = args[0];
    if ($ee62ca6949990202$var$isUnextendable(result)) throw new Error('extendee must be an object');
    var extenders = args.slice(1);
    var len = extenders.length;
    for(var i = 0; i < len; i++){
        var extender = extenders[i];
        for(var key in extender)if (Object.prototype.hasOwnProperty.call(extender, key)) {
            var value = extender[key];
            if (deep && $ee62ca6949990202$var$isCloneable(value)) {
                var base = Array.isArray(value) ? [] : {};
                result[key] = $ee62ca6949990202$var$extend(true, Object.prototype.hasOwnProperty.call(result, key) && !$ee62ca6949990202$var$isUnextendable(result[key]) ? result[key] : base, value);
            } else result[key] = value;
        }
    }
    return result;
}
function $ee62ca6949990202$var$isCloneable(obj) {
    return Array.isArray(obj) || ({}).toString.call(obj) == '[object Object]';
}
function $ee62ca6949990202$var$isUnextendable(val) {
    return !val || typeof val != 'object' && typeof val != 'function';
}


function $540cd3dd02161f28$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
class $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    // Add an event listener for given event
    on(event, fn) {
        this._callbacks = this._callbacks || {};
        // Create namespace for this event
        if (!this._callbacks[event]) this._callbacks[event] = [];
        this._callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        this._callbacks = this._callbacks || {};
        let callbacks = this._callbacks[event];
        if (callbacks) for (let callback of callbacks)callback.apply(this, args);
        // trigger a corresponding DOM event
        if (this.element) this.element.dispatchEvent(this.makeEvent("dropzone:" + event, {
            args: args
        }));
        return this;
    }
    makeEvent(eventName, detail) {
        let params = {
            bubbles: true,
            cancelable: true,
            detail: detail
        };
        if (typeof window.CustomEvent === "function") return new CustomEvent(eventName, params);
        else {
            // IE 11 support
            // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
            var evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
    }
    // Remove event listener for given event. If fn is not provided, all event
    // listeners for that event will be removed. If neither is provided, all
    // event listeners will be removed.
    off(event, fn) {
        if (!this._callbacks || arguments.length === 0) {
            this._callbacks = {};
            return this;
        }
        // specific event
        let callbacks = this._callbacks[event];
        if (!callbacks) return this;
        // remove all handlers
        if (arguments.length === 1) {
            delete this._callbacks[event];
            return this;
        }
        // remove specific handler
        for(let i = 0; i < callbacks.length; i++){
            let callback = callbacks[i];
            if (callback === fn) {
                callbacks.splice(i, 1);
                break;
            }
        }
        return this;
    }
}
var $540cd3dd02161f28$var$$fd6031f88dce2e32$exports = {};
$540cd3dd02161f28$var$$fd6031f88dce2e32$exports = "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail=\"\"></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size=\"\"></span></div>\n    <div class=\"dz-filename\"><span data-dz-name=\"\"></span></div>\n  </div>\n  <div class=\"dz-progress\">\n    <span class=\"dz-upload\" data-dz-uploadprogress=\"\"></span>\n  </div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage=\"\"></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M10.2071 29.7929L14.2929 25.7071C14.6834 25.3166 15.3166 25.3166 15.7071 25.7071L21.2929 31.2929C21.6834 31.6834 22.3166 31.6834 22.7071 31.2929L38.2929 15.7071C38.6834 15.3166 39.3166 15.3166 39.7071 15.7071L43.7929 19.7929C44.1834 20.1834 44.1834 20.8166 43.7929 21.2071L22.7071 42.2929C22.3166 42.6834 21.6834 42.6834 21.2929 42.2929L10.2071 31.2071C9.81658 30.8166 9.81658 30.1834 10.2071 29.7929Z\"></path>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54\" height=\"54\" viewBox=\"0 0 54 54\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M26.2929 20.2929L19.2071 13.2071C18.8166 12.8166 18.1834 12.8166 17.7929 13.2071L13.2071 17.7929C12.8166 18.1834 12.8166 18.8166 13.2071 19.2071L20.2929 26.2929C20.6834 26.6834 20.6834 27.3166 20.2929 27.7071L13.2071 34.7929C12.8166 35.1834 12.8166 35.8166 13.2071 36.2071L17.7929 40.7929C18.1834 41.1834 18.8166 41.1834 19.2071 40.7929L26.2929 33.7071C26.6834 33.3166 27.3166 33.3166 27.7071 33.7071L34.7929 40.7929C35.1834 41.1834 35.8166 41.1834 36.2071 40.7929L40.7929 36.2071C41.1834 35.8166 41.1834 35.1834 40.7929 34.7929L33.7071 27.7071C33.3166 27.3166 33.3166 26.6834 33.7071 26.2929L40.7929 19.2071C41.1834 18.8166 41.1834 18.1834 40.7929 17.7929L36.2071 13.2071C35.8166 12.8166 35.1834 12.8166 34.7929 13.2071L27.7071 20.2929C27.3166 20.6834 26.6834 20.6834 26.2929 20.2929Z\"></path>\n    </svg>\n  </div>\n</div>\n";
let $540cd3dd02161f28$var$$4ca367182776f80b$var$defaultOptions = {
    /**
   * Has to be specified on elements other than form (or when the form doesn't
   * have an `action` attribute).
   *
   * You can also provide a function that will be called with `files` and
   * `dataBlocks`  and must return the url as string.
   */ url: null,
    /**
   * Can be changed to `"put"` if necessary. You can also provide a function
   * that will be called with `files` and must return the method (since `v3.12.0`).
   */ method: "post",
    /**
   * Will be set on the XHRequest.
   */ withCredentials: false,
    /**
   * The timeout for the XHR requests in milliseconds (since `v4.4.0`).
   * If set to null or 0, no timeout is going to be set.
   */ timeout: null,
    /**
   * How many file uploads to process in parallel (See the
   * Enqueuing file uploads documentation section for more info)
   */ parallelUploads: 2,
    /**
   * Whether to send multiple files in one request. If
   * this it set to true, then the fallback file input element will
   * have the `multiple` attribute as well. This option will
   * also trigger additional events (like `processingmultiple`). See the events
   * documentation section for more information.
   */ uploadMultiple: false,
    /**
   * Whether you want files to be uploaded in chunks to your server. This can't be
   * used in combination with `uploadMultiple`.
   *
   * See [chunksUploaded](#config-chunksUploaded) for the callback to finalise an upload.
   */ chunking: false,
    /**
   * If `chunking` is enabled, this defines whether **every** file should be chunked,
   * even if the file size is below chunkSize. This means, that the additional chunk
   * form data will be submitted and the `chunksUploaded` callback will be invoked.
   */ forceChunking: false,
    /**
   * If `chunking` is `true`, then this defines the chunk size in bytes.
   */ chunkSize: 2097152,
    /**
   * If `true`, the individual chunks of a file are being uploaded simultaneously.
   */ parallelChunkUploads: false,
    /**
   * Whether a chunk should be retried if it fails.
   */ retryChunks: false,
    /**
   * If `retryChunks` is true, how many times should it be retried.
   */ retryChunksLimit: 3,
    /**
   * The maximum filesize (in MiB) that is allowed to be uploaded.
   */ maxFilesize: 256,
    /**
   * The name of the file param that gets transferred.
   * **NOTE**: If you have the option  `uploadMultiple` set to `true`, then
   * Dropzone will append `[]` to the name.
   */ paramName: "file",
    /**
   * Whether thumbnails for images should be generated
   */ createImageThumbnails: true,
    /**
   * In MB. When the filename exceeds this limit, the thumbnail will not be generated.
   */ maxThumbnailFilesize: 10,
    /**
   * If `null`, the ratio of the image will be used to calculate it.
   */ thumbnailWidth: 120,
    /**
   * The same as `thumbnailWidth`. If both are null, images will not be resized.
   */ thumbnailHeight: 120,
    /**
   * How the images should be scaled down in case both, `thumbnailWidth` and `thumbnailHeight` are provided.
   * Can be either `contain` or `crop`.
   */ thumbnailMethod: "crop",
    /**
   * If set, images will be resized to these dimensions before being **uploaded**.
   * If only one, `resizeWidth` **or** `resizeHeight` is provided, the original aspect
   * ratio of the file will be preserved.
   *
   * The `options.transformFile` function uses these options, so if the `transformFile` function
   * is overridden, these options don't do anything.
   */ resizeWidth: null,
    /**
   * See `resizeWidth`.
   */ resizeHeight: null,
    /**
   * The mime type of the resized image (before it gets uploaded to the server).
   * If `null` the original mime type will be used. To force jpeg, for example, use `image/jpeg`.
   * See `resizeWidth` for more information.
   */ resizeMimeType: null,
    /**
   * The quality of the resized images. See `resizeWidth`.
   */ resizeQuality: 0.8,
    /**
   * How the images should be scaled down in case both, `resizeWidth` and `resizeHeight` are provided.
   * Can be either `contain` or `crop`.
   */ resizeMethod: "contain",
    /**
   * The base that is used to calculate the **displayed** filesize. You can
   * change this to 1024 if you would rather display kibibytes, mebibytes,
   * etc... 1024 is technically incorrect, because `1024 bytes` are `1 kibibyte`
   * not `1 kilobyte`. You can change this to `1024` if you don't care about
   * validity.
   */ filesizeBase: 1000,
    /**
   * If not `null` defines how many files this Dropzone handles. If it exceeds,
   * the event `maxfilesexceeded` will be called. The dropzone element gets the
   * class `dz-max-files-reached` accordingly so you can provide visual
   * feedback.
   */ maxFiles: null,
    /**
   * An optional object to send additional headers to the server. Eg:
   * `{ "My-Awesome-Header": "header value" }`
   */ headers: null,
    /**
   * Should the default headers be set or not?
   * Accept: application/json <- for requesting json response
   * Cache-Control: no-cache <- Request shouldnt be cached
   * X-Requested-With: XMLHttpRequest <- We sent the request via XMLHttpRequest
   */ defaultHeaders: true,
    /**
   * If `true`, the dropzone element itself will be clickable, if `false`
   * nothing will be clickable.
   *
   * You can also pass an HTML element, a CSS selector (for multiple elements)
   * or an array of those. In that case, all of those elements will trigger an
   * upload when clicked.
   */ clickable: true,
    /**
   * Whether hidden files in directories should be ignored.
   */ ignoreHiddenFiles: true,
    /**
   * The default implementation of `accept` checks the file's mime type or
   * extension against this list. This is a comma separated list of mime
   * types or file extensions.
   *
   * Eg.: `image/*,application/pdf,.psd`
   *
   * If the Dropzone is `clickable` this option will also be used as
   * [`accept`](https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept)
   * parameter on the hidden file input as well.
   */ acceptedFiles: null,
    /**
   * **Deprecated!**
   * Use acceptedFiles instead.
   */ acceptedMimeTypes: null,
    /**
   * If false, files will be added to the queue but the queue will not be
   * processed automatically.
   * This can be useful if you need some additional user input before sending
   * files (or if you want want all files sent at once).
   * If you're ready to send the file simply call `myDropzone.processQueue()`.
   *
   * See the [enqueuing file uploads](#enqueuing-file-uploads) documentation
   * section for more information.
   */ autoProcessQueue: true,
    /**
   * If false, files added to the dropzone will not be queued by default.
   * You'll have to call `enqueueFile(file)` manually.
   */ autoQueue: true,
    /**
   * If `true`, this will add a link to every file preview to remove or cancel (if
   * already uploading) the file. The `dictCancelUpload`, `dictCancelUploadConfirmation`
   * and `dictRemoveFile` options are used for the wording.
   */ addRemoveLinks: false,
    /**
   * Defines where to display the file previews – if `null` the
   * Dropzone element itself is used. Can be a plain `HTMLElement` or a CSS
   * selector. The element should have the `dropzone-previews` class so
   * the previews are displayed properly.
   */ previewsContainer: null,
    /**
   * Set this to `true` if you don't want previews to be shown.
   */ disablePreviews: false,
    /**
   * This is the element the hidden input field (which is used when clicking on the
   * dropzone to trigger file selection) will be appended to. This might
   * be important in case you use frameworks to switch the content of your page.
   *
   * Can be a selector string, or an element directly.
   */ hiddenInputContainer: "body",
    /**
   * If null, no capture type will be specified
   * If camera, mobile devices will skip the file selection and choose camera
   * If microphone, mobile devices will skip the file selection and choose the microphone
   * If camcorder, mobile devices will skip the file selection and choose the camera in video mode
   * On apple devices multiple must be set to false.  AcceptedFiles may need to
   * be set to an appropriate mime type (e.g. "image/*", "audio/*", or "video/*").
   */ capture: null,
    /**
   * **Deprecated**. Use `renameFile` instead.
   */ renameFilename: null,
    /**
   * A function that is invoked before the file is uploaded to the server and renames the file.
   * This function gets the `File` as argument and can use the `file.name`. The actual name of the
   * file that gets used during the upload can be accessed through `file.upload.filename`.
   */ renameFile: null,
    /**
   * If `true` the fallback will be forced. This is very useful to test your server
   * implementations first and make sure that everything works as
   * expected without dropzone if you experience problems, and to test
   * how your fallbacks will look.
   */ forceFallback: false,
    /**
   * The text used before any files are dropped.
   */ dictDefaultMessage: "Drop files here to upload",
    /**
   * The text that replaces the default message text it the browser is not supported.
   */ dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
    /**
   * The text that will be added before the fallback form.
   * If you provide a  fallback element yourself, or if this option is `null` this will
   * be ignored.
   */ dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
    /**
   * If the filesize is too big.
   * `{{filesize}}` and `{{maxFilesize}}` will be replaced with the respective configuration values.
   */ dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    /**
   * If the file doesn't match the file type.
   */ dictInvalidFileType: "You can't upload files of this type.",
    /**
   * If the server response was invalid.
   * `{{statusCode}}` will be replaced with the servers status code.
   */ dictResponseError: "Server responded with {{statusCode}} code.",
    /**
   * If `addRemoveLinks` is true, the text to be used for the cancel upload link.
   */ dictCancelUpload: "Cancel upload",
    /**
   * The text that is displayed if an upload was manually canceled
   */ dictUploadCanceled: "Upload canceled.",
    /**
   * If `addRemoveLinks` is true, the text to be used for confirmation when cancelling upload.
   */ dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
    /**
   * If `addRemoveLinks` is true, the text to be used to remove a file.
   */ dictRemoveFile: "Remove file",
    /**
   * If this is not null, then the user will be prompted before removing a file.
   */ dictRemoveFileConfirmation: null,
    /**
   * Displayed if `maxFiles` is st and exceeded.
   * The string `{{maxFiles}}` will be replaced by the configuration value.
   */ dictMaxFilesExceeded: "You can not upload any more files.",
    /**
   * Allows you to translate the different units. Starting with `tb` for terabytes and going down to
   * `b` for bytes.
   */ dictFileSizeUnits: {
        tb: "TB",
        gb: "GB",
        mb: "MB",
        kb: "KB",
        b: "b"
    },
    /**
   * Called when dropzone initialized
   * You can add event listeners here
   */ init () {},
    /**
   * Can be an **object** of additional parameters to transfer to the server, **or** a `Function`
   * that gets invoked with the `files`, `xhr` and, if it's a chunked upload, `chunk` arguments. In case
   * of a function, this needs to return a map.
   *
   * The default implementation does nothing for normal uploads, but adds relevant information for
   * chunked uploads.
   *
   * This is the same as adding hidden input fields in the form element.
   */ params (files, xhr, chunk) {
        if (chunk) return {
            dzuuid: chunk.file.upload.uuid,
            dzchunkindex: chunk.index,
            dztotalfilesize: chunk.file.size,
            dzchunksize: this.options.chunkSize,
            dztotalchunkcount: chunk.file.upload.totalChunkCount,
            dzchunkbyteoffset: chunk.index * this.options.chunkSize
        };
    },
    /**
   * A function that gets a [file](https://developer.mozilla.org/en-US/docs/DOM/File)
   * and a `done` function as parameters.
   *
   * If the done function is invoked without arguments, the file is "accepted" and will
   * be processed. If you pass an error message, the file is rejected, and the error
   * message will be displayed.
   * This function will not be called if the file is too big or doesn't match the mime types.
   */ accept (file, done) {
        return done();
    },
    /**
   * The callback that will be invoked when all chunks have been uploaded for a file.
   * It gets the file for which the chunks have been uploaded as the first parameter,
   * and the `done` function as second. `done()` needs to be invoked when everything
   * needed to finish the upload process is done.
   */ chunksUploaded: function(file, done) {
        done();
    },
    /**
   * Sends the file as binary blob in body instead of form data.
   * If this is set, the `params` option will be ignored.
   * It's an error to set this to `true` along with `uploadMultiple` since
   * multiple files cannot be in a single binary body.
   */ binaryBody: false,
    /**
   * Gets called when the browser is not supported.
   * The default implementation shows the fallback input field and adds
   * a text.
   */ fallback () {
        // This code should pass in IE7... :(
        let messageElement;
        this.element.className = `${this.element.className} dz-browser-not-supported`;
        for (let child of this.element.getElementsByTagName("div"))if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message"; // Removes the 'dz-default' class
            break;
        }
        if (!messageElement) {
            messageElement = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement('<div class="dz-message"><span></span></div>');
            this.element.appendChild(messageElement);
        }
        let span = messageElement.getElementsByTagName("span")[0];
        if (span) {
            if (span.textContent != null) span.textContent = this.options.dictFallbackMessage;
            else if (span.innerText != null) span.innerText = this.options.dictFallbackMessage;
        }
        return this.element.appendChild(this.getFallbackForm());
    },
    /**
   * Gets called to calculate the thumbnail dimensions.
   *
   * It gets `file`, `width` and `height` (both may be `null`) as parameters and must return an object containing:
   *
   *  - `srcWidth` & `srcHeight` (required)
   *  - `trgWidth` & `trgHeight` (required)
   *  - `srcX` & `srcY` (optional, default `0`)
   *  - `trgX` & `trgY` (optional, default `0`)
   *
   * Those values are going to be used by `ctx.drawImage()`.
   */ resize (file, width, height, resizeMethod) {
        let info = {
            srcX: 0,
            srcY: 0,
            srcWidth: file.width,
            srcHeight: file.height
        };
        let srcRatio = file.width / file.height;
        // Automatically calculate dimensions if not specified
        if (width == null && height == null) {
            width = info.srcWidth;
            height = info.srcHeight;
        } else if (width == null) width = height * srcRatio;
        else if (height == null) height = width / srcRatio;
        // Make sure images aren't upscaled
        width = Math.min(width, info.srcWidth);
        height = Math.min(height, info.srcHeight);
        let trgRatio = width / height;
        if (info.srcWidth > width || info.srcHeight > height) {
            // Image is bigger and needs rescaling
            if (resizeMethod === "crop") {
                if (srcRatio > trgRatio) {
                    info.srcHeight = file.height;
                    info.srcWidth = info.srcHeight * trgRatio;
                } else {
                    info.srcWidth = file.width;
                    info.srcHeight = info.srcWidth / trgRatio;
                }
            } else if (resizeMethod === "contain") {
                // Method 'contain'
                if (srcRatio > trgRatio) height = width / srcRatio;
                else width = height * srcRatio;
            } else throw new Error(`Unknown resizeMethod '${resizeMethod}'`);
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        info.trgWidth = width;
        info.trgHeight = height;
        return info;
    },
    /**
   * Can be used to transform the file (for example, resize an image if necessary).
   *
   * The default implementation uses `resizeWidth` and `resizeHeight` (if provided) and resizes
   * images according to those dimensions.
   *
   * Gets the `file` as the first parameter, and a `done()` function as the second, that needs
   * to be invoked with the file when the transformation is done.
   */ transformFile (file, done) {
        if ((this.options.resizeWidth || this.options.resizeHeight) && file.type.match(/image.*/)) return this.resizeImage(file, this.options.resizeWidth, this.options.resizeHeight, this.options.resizeMethod, done);
        else return done(file);
    },
    /**
   * A string that contains the template used for each dropped
   * file. Change it to fulfill your needs but make sure to properly
   * provide all elements.
   *
   * If you want to use an actual HTML element instead of providing a String
   * as a config option, you could create a div with the id `tpl`,
   * put the template inside it and provide the element like this:
   *
   *     document
   *       .querySelector('#tpl')
   *       .innerHTML
   *
   */ previewTemplate: /*@__PURE__*/ $540cd3dd02161f28$var$$parcel$interopDefault($540cd3dd02161f28$var$$fd6031f88dce2e32$exports),
    /*
   Those functions register themselves to the events on init and handle all
   the user interface specific stuff. Overwriting them won't break the upload
   but can break the way it's displayed.
   You can overwrite them if you don't like the default behavior. If you just
   want to add an additional event handler, register it on the dropzone object
   and don't overwrite those options.
   */ // Those are self explanatory and simply concern the DragnDrop.
    drop (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragstart (e) {},
    dragend (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    dragenter (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragover (e) {
        return this.element.classList.add("dz-drag-hover");
    },
    dragleave (e) {
        return this.element.classList.remove("dz-drag-hover");
    },
    paste (e) {},
    // Called whenever there are no files left in the dropzone anymore, and the
    // dropzone should be displayed as if in the initial state.
    reset () {
        return this.element.classList.remove("dz-started");
    },
    // Called when a file is added to the queue
    // Receives `file`
    addedfile (file) {
        if (this.element === this.previewsContainer) this.element.classList.add("dz-started");
        if (this.previewsContainer && !this.options.disablePreviews) {
            file.previewElement = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(this.options.previewTemplate.trim());
            file.previewTemplate = file.previewElement; // Backwards compatibility
            this.previewsContainer.appendChild(file.previewElement);
            for (var node of file.previewElement.querySelectorAll("[data-dz-name]"))node.textContent = file.name;
            for (node of file.previewElement.querySelectorAll("[data-dz-size]"))node.innerHTML = this.filesize(file.size);
            if (this.options.addRemoveLinks) {
                file._removeLink = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<a class="dz-remove" href="javascript:undefined;" data-dz-remove>${this.options.dictRemoveFile}</a>`);
                file.previewElement.appendChild(file._removeLink);
            }
            let removeFileEvent = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) return $540cd3dd02161f28$export$2e2bcd8739ae039.confirm(this.options.dictCancelUploadConfirmation, ()=>this.removeFile(file));
                else {
                    if (this.options.dictRemoveFileConfirmation) return $540cd3dd02161f28$export$2e2bcd8739ae039.confirm(this.options.dictRemoveFileConfirmation, ()=>this.removeFile(file));
                    else return this.removeFile(file);
                }
            };
            for (let removeLink of file.previewElement.querySelectorAll("[data-dz-remove]"))removeLink.addEventListener("click", removeFileEvent);
        }
    },
    // Called whenever a file is removed.
    removedfile (file) {
        if (file.previewElement != null && file.previewElement.parentNode != null) file.previewElement.parentNode.removeChild(file.previewElement);
        return this._updateMaxFilesReachedClass();
    },
    // Called when a thumbnail has been generated
    // Receives `file` and `dataUrl`
    thumbnail (file, dataUrl) {
        if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            for (let thumbnailElement of file.previewElement.querySelectorAll("[data-dz-thumbnail]")){
                thumbnailElement.alt = file.name;
                thumbnailElement.src = dataUrl;
            }
            return setTimeout(()=>file.previewElement.classList.add("dz-image-preview"), 1);
        }
    },
    // Called whenever an error occurs
    // Receives `file` and `message`
    error (file, message) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-error");
            if (typeof message !== "string" && message.error) message = message.error;
            for (let node of file.previewElement.querySelectorAll("[data-dz-errormessage]"))node.textContent = message;
        }
    },
    errormultiple () {},
    // Called when a file gets processed. Since there is a cue, not all added
    // files are processed immediately.
    // Receives `file`
    processing (file) {
        if (file.previewElement) {
            file.previewElement.classList.add("dz-processing");
            if (file._removeLink) return file._removeLink.innerHTML = this.options.dictCancelUpload;
        }
    },
    processingmultiple () {},
    // Called whenever the upload progress gets updated.
    // Receives `file`, `progress` (percentage 0-100) and `bytesSent`.
    // To get the total number of bytes of the file, use `file.size`
    uploadprogress (file, progress, bytesSent) {
        if (file.previewElement) for (let node of file.previewElement.querySelectorAll("[data-dz-uploadprogress]"))node.nodeName === "PROGRESS" ? node.value = progress : node.style.width = `${progress}%`;
    },
    // Called whenever the total upload progress gets updated.
    // Called with totalUploadProgress (0-100), totalBytes and totalBytesSent
    totaluploadprogress () {},
    // Called just before the file is sent. Gets the `xhr` object as second
    // parameter, so you can modify it (for example to add a CSRF token) and a
    // `formData` object to add additional information.
    sending () {},
    sendingmultiple () {},
    // When the complete upload is finished and successful
    // Receives `file`
    success (file) {
        if (file.previewElement) return file.previewElement.classList.add("dz-success");
    },
    successmultiple () {},
    // When the upload is canceled.
    canceled (file) {
        return this.emit("error", file, this.options.dictUploadCanceled);
    },
    canceledmultiple () {},
    // When the upload is finished, either with success or an error.
    // Receives `file`
    complete (file) {
        if (file._removeLink) file._removeLink.innerHTML = this.options.dictRemoveFile;
        if (file.previewElement) return file.previewElement.classList.add("dz-complete");
    },
    completemultiple () {},
    maxfilesexceeded () {},
    maxfilesreached () {},
    queuecomplete () {},
    addedfiles () {}
};
var $540cd3dd02161f28$var$$4ca367182776f80b$export$2e2bcd8739ae039 = $540cd3dd02161f28$var$$4ca367182776f80b$var$defaultOptions;
class $540cd3dd02161f28$export$2e2bcd8739ae039 extends $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039 {
    static initClass() {
        // Exposing the emitter class, mainly for tests
        this.prototype.Emitter = $540cd3dd02161f28$var$$4040acfd8584338d$export$2e2bcd8739ae039;
        /*
     This is a list of all available events you can register on a dropzone object.

     You can register an event handler like this:

     dropzone.on("dragEnter", function() { });

     */ this.prototype.events = [
            "drop",
            "dragstart",
            "dragend",
            "dragenter",
            "dragover",
            "dragleave",
            "addedfile",
            "addedfiles",
            "removedfile",
            "thumbnail",
            "error",
            "errormultiple",
            "processing",
            "processingmultiple",
            "uploadprogress",
            "totaluploadprogress",
            "sending",
            "sendingmultiple",
            "success",
            "successmultiple",
            "canceled",
            "canceledmultiple",
            "complete",
            "completemultiple",
            "reset",
            "maxfilesexceeded",
            "maxfilesreached",
            "queuecomplete"
        ];
        this.prototype._thumbnailQueue = [];
        this.prototype._processingThumbnail = false;
    }
    // Returns all files that have been accepted
    getAcceptedFiles() {
        return this.files.filter((file)=>file.accepted).map((file)=>file);
    }
    // Returns all files that have been rejected
    // Not sure when that's going to be useful, but added for completeness.
    getRejectedFiles() {
        return this.files.filter((file)=>!file.accepted).map((file)=>file);
    }
    getFilesWithStatus(status) {
        return this.files.filter((file)=>file.status === status).map((file)=>file);
    }
    // Returns all files that are in the queue
    getQueuedFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED);
    }
    getUploadingFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING);
    }
    getAddedFiles() {
        return this.getFilesWithStatus($540cd3dd02161f28$export$2e2bcd8739ae039.ADDED);
    }
    // Files that are either queued or uploading
    getActiveFiles() {
        return this.files.filter((file)=>file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING || file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED).map((file)=>file);
    }
    // The function that gets called when Dropzone is initialized. You
    // can (and should) setup event listeners inside this function.
    init() {
        // In case it isn't set already
        if (this.element.tagName === "form") this.element.setAttribute("enctype", "multipart/form-data");
        if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) this.element.appendChild($540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<div class="dz-default dz-message"><button class="dz-button" type="button">${this.options.dictDefaultMessage}</button></div>`));
        if (this.clickableElements.length) {
            let setupHiddenFileInput = ()=>{
                if (this.hiddenFileInput) this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
                this.hiddenFileInput = document.createElement("input");
                this.hiddenFileInput.setAttribute("type", "file");
                if (this.options.maxFiles === null || this.options.maxFiles > 1) this.hiddenFileInput.setAttribute("multiple", "multiple");
                this.hiddenFileInput.className = "dz-hidden-input";
                if (this.options.acceptedFiles !== null) this.hiddenFileInput.setAttribute("accept", this.options.acceptedFiles);
                if (this.options.capture !== null) this.hiddenFileInput.setAttribute("capture", this.options.capture);
                // Making sure that no one can "tab" into this field.
                this.hiddenFileInput.setAttribute("tabindex", "-1");
                // Not setting `display="none"` because some browsers don't accept clicks
                // on elements that aren't displayed.
                this.hiddenFileInput.style.visibility = "hidden";
                this.hiddenFileInput.style.position = "absolute";
                this.hiddenFileInput.style.top = "0";
                this.hiddenFileInput.style.left = "0";
                this.hiddenFileInput.style.height = "0";
                this.hiddenFileInput.style.width = "0";
                $540cd3dd02161f28$export$2e2bcd8739ae039.getElement(this.options.hiddenInputContainer, "hiddenInputContainer").appendChild(this.hiddenFileInput);
                this.hiddenFileInput.addEventListener("change", ()=>{
                    let { files: files } = this.hiddenFileInput;
                    if (files.length) for (let file of files)this.addFile(file);
                    this.emit("addedfiles", files);
                    setupHiddenFileInput();
                });
            };
            setupHiddenFileInput();
        }
        this.URL = window.URL !== null ? window.URL : window.webkitURL;
        // Setup all event listeners on the Dropzone object itself.
        // They're not in @setupEventListeners() because they shouldn't be removed
        // again when the dropzone gets disabled.
        for (let eventName of this.events)this.on(eventName, this.options[eventName]);
        this.on("uploadprogress", ()=>this.updateTotalUploadProgress());
        this.on("removedfile", ()=>this.updateTotalUploadProgress());
        this.on("canceled", (file)=>this.emit("complete", file));
        // Emit a `queuecomplete` event if all files finished uploading.
        this.on("complete", (file)=>{
            if (this.getAddedFiles().length === 0 && this.getUploadingFiles().length === 0 && this.getQueuedFiles().length === 0) return setTimeout(()=>this.emit("queuecomplete"), 0);
        });
        const containsFiles = function(e) {
            if (e.dataTransfer.types) // IE, we need to iterate like this instead of
            // using e.dataTransfer.types.some()
            for(var i = 0; i < e.dataTransfer.types.length; i++){
                if (e.dataTransfer.types[i] === "Files") return true;
            }
            return false;
        };
        let noPropagation = function(e) {
            // If there are no files, we don't want to stop
            // propagation so we don't interfere with other
            // drag and drop behaviour.
            if (!containsFiles(e)) return;
            e.stopPropagation();
            if (e.preventDefault) return e.preventDefault();
            else return e.returnValue = false;
        };
        // Create the listeners
        this.listeners = [
            {
                element: this.element,
                events: {
                    dragstart: (e)=>{
                        return this.emit("dragstart", e);
                    },
                    dragenter: (e)=>{
                        noPropagation(e);
                        return this.emit("dragenter", e);
                    },
                    dragover: (e)=>{
                        // Makes it possible to drag files from chrome's download bar
                        // http://stackoverflow.com/questions/19526430/drag-and-drop-file-uploads-from-chrome-downloads-bar
                        // Try is required to prevent bug in Internet Explorer 11 (SCRIPT65535 exception)
                        let efct;
                        try {
                            efct = e.dataTransfer.effectAllowed;
                        } catch (error) {}
                        e.dataTransfer.dropEffect = "move" === efct || "linkMove" === efct ? "move" : "copy";
                        noPropagation(e);
                        return this.emit("dragover", e);
                    },
                    dragleave: (e)=>{
                        return this.emit("dragleave", e);
                    },
                    drop: (e)=>{
                        noPropagation(e);
                        return this.drop(e);
                    },
                    dragend: (e)=>{
                        return this.emit("dragend", e);
                    }
                }
            }
        ];
        this.clickableElements.forEach((clickableElement)=>{
            return this.listeners.push({
                element: clickableElement,
                events: {
                    click: (evt)=>{
                        // Only the actual dropzone or the message element should trigger file selection
                        if (clickableElement !== this.element || evt.target === this.element || $540cd3dd02161f28$export$2e2bcd8739ae039.elementInside(evt.target, this.element.querySelector(".dz-message"))) this.hiddenFileInput.click(); // Forward the click
                        return true;
                    }
                }
            });
        });
        this.enable();
        return this.options.init.call(this);
    }
    // Not fully tested yet
    destroy() {
        this.disable();
        this.removeAllFiles(true);
        if (this.hiddenFileInput != null ? this.hiddenFileInput.parentNode : undefined) {
            this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
            this.hiddenFileInput = null;
        }
        delete this.element.dropzone;
        return $540cd3dd02161f28$export$2e2bcd8739ae039.instances.splice($540cd3dd02161f28$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
    updateTotalUploadProgress() {
        let totalUploadProgress;
        let totalBytesSent = 0;
        let totalBytes = 0;
        let activeFiles = this.getActiveFiles();
        if (activeFiles.length) {
            for (let file of this.getActiveFiles()){
                totalBytesSent += file.upload.bytesSent;
                totalBytes += file.upload.total;
            }
            totalUploadProgress = 100 * totalBytesSent / totalBytes;
        } else totalUploadProgress = 100;
        return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    }
    // @options.paramName can be a function taking one parameter rather than a string.
    // A parameter name for a file is obtained simply by calling this with an index number.
    _getParamName(n) {
        if (typeof this.options.paramName === "function") return this.options.paramName(n);
        else return `${this.options.paramName}${this.options.uploadMultiple ? `[${n}]` : ""}`;
    }
    // If @options.renameFile is a function,
    // the function will be used to rename the file.name before appending it to the formData
    _renameFile(file) {
        if (typeof this.options.renameFile !== "function") return file.name;
        return this.options.renameFile(file);
    }
    // Returns a form that can be used as fallback if the browser does not support DragnDrop
    //
    // If the dropzone is already a form, only the input field and button are returned. Otherwise a complete form element is provided.
    // This code has to pass in IE7 :(
    getFallbackForm() {
        let existingFallback, form;
        if (existingFallback = this.getExistingFallback()) return existingFallback;
        let fieldsString = '<div class="dz-fallback">';
        if (this.options.dictFallbackText) fieldsString += `<p>${this.options.dictFallbackText}</p>`;
        fieldsString += `<input type="file" name="${this._getParamName(0)}" ${this.options.uploadMultiple ? 'multiple="multiple"' : undefined} /><input type="submit" value="Upload!"></div>`;
        let fields = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(fieldsString);
        if (this.element.tagName !== "FORM") {
            form = $540cd3dd02161f28$export$2e2bcd8739ae039.createElement(`<form action="${this.options.url}" enctype="multipart/form-data" method="${this.options.method}"></form>`);
            form.appendChild(fields);
        } else {
            // Make sure that the enctype and method attributes are set properly
            this.element.setAttribute("enctype", "multipart/form-data");
            this.element.setAttribute("method", this.options.method);
        }
        return form != null ? form : fields;
    }
    // Returns the fallback elements if they exist already
    //
    // This code has to pass in IE7 :(
    getExistingFallback() {
        let getFallback = function(elements) {
            for (let el of elements){
                if (/(^| )fallback($| )/.test(el.className)) return el;
            }
        };
        for (let tagName of [
            "div",
            "form"
        ]){
            var fallback;
            if (fallback = getFallback(this.element.getElementsByTagName(tagName))) return fallback;
        }
    }
    // Activates all listeners stored in @listeners
    setupEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.addEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Deactivates all listeners stored in @listeners
    removeEventListeners() {
        return this.listeners.map((elementListeners)=>(()=>{
                let result = [];
                for(let event in elementListeners.events){
                    let listener = elementListeners.events[event];
                    result.push(elementListeners.element.removeEventListener(event, listener, false));
                }
                return result;
            })());
    }
    // Removes all event listeners and cancels all files in the queue or being processed.
    disable() {
        this.clickableElements.forEach((element)=>element.classList.remove("dz-clickable"));
        this.removeEventListeners();
        this.disabled = true;
        return this.files.map((file)=>this.cancelUpload(file));
    }
    enable() {
        delete this.disabled;
        this.clickableElements.forEach((element)=>element.classList.add("dz-clickable"));
        return this.setupEventListeners();
    }
    // Returns a nicely formatted filesize
    filesize(size) {
        let selectedSize = 0;
        let selectedUnit = "b";
        if (size > 0) {
            let units = [
                "tb",
                "gb",
                "mb",
                "kb",
                "b"
            ];
            for(let i = 0; i < units.length; i++){
                let unit = units[i];
                let cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
                if (size >= cutoff) {
                    selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
                    selectedUnit = unit;
                    break;
                }
            }
            selectedSize = Math.round(10 * selectedSize) / 10; // Cutting of digits
        }
        return `<strong>${selectedSize}</strong> ${this.options.dictFileSizeUnits[selectedUnit]}`;
    }
    // Adds or removes the `dz-max-files-reached` class from the form.
    _updateMaxFilesReachedClass() {
        if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            if (this.getAcceptedFiles().length === this.options.maxFiles) this.emit("maxfilesreached", this.files);
            return this.element.classList.add("dz-max-files-reached");
        } else return this.element.classList.remove("dz-max-files-reached");
    }
    drop(e) {
        if (!e.dataTransfer) return;
        this.emit("drop", e);
        // Convert the FileList to an Array
        // This is necessary for IE11
        let files = [];
        for(let i = 0; i < e.dataTransfer.files.length; i++)files[i] = e.dataTransfer.files[i];
        // Even if it's a folder, files.length will contain the folders.
        if (files.length) {
            let { items: items } = e.dataTransfer;
            if (items && items.length && items[0].webkitGetAsEntry != null) this._addFilesFromItems(items);
            else this.handleFiles(files);
        }
        this.emit("addedfiles", files);
    }
    paste(e) {
        if ($540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guard__(e != null ? e.clipboardData : undefined, (x)=>x.items) == null) return;
        this.emit("paste", e);
        let { items: items } = e.clipboardData;
        if (items.length) return this._addFilesFromItems(items);
    }
    handleFiles(files) {
        for (let file of files)this.addFile(file);
    }
    // When a folder is dropped (or files are pasted), items must be handled
    // instead of files.
    _addFilesFromItems(items) {
        return (()=>{
            let result = [];
            for (let item of items){
                var entry;
                if (item.webkitGetAsEntry != null && (entry = item.webkitGetAsEntry())) {
                    if (entry.isFile) result.push(this.addFile(item.getAsFile()));
                    else if (entry.isDirectory) result.push(this._addFilesFromDirectory(entry, entry.name));
                    else result.push(undefined);
                } else if (item.getAsFile != null) {
                    if (item.kind == null || item.kind === "file") result.push(this.addFile(item.getAsFile()));
                    else result.push(undefined);
                } else result.push(undefined);
            }
            return result;
        })();
    }
    // Goes through the directory, and adds each file it finds recursively
    _addFilesFromDirectory(directory, path) {
        let dirReader = directory.createReader();
        let errorHandler = (error)=>$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guardMethod__(console, "log", (o)=>o.log(error));
        var readEntries = ()=>{
            return dirReader.readEntries((entries)=>{
                if (entries.length > 0) {
                    for (let entry of entries){
                        if (entry.isFile) entry.file((file)=>{
                            if (this.options.ignoreHiddenFiles && file.name.substring(0, 1) === ".") return;
                            file.fullPath = `${path}/${file.name}`;
                            return this.addFile(file);
                        });
                        else if (entry.isDirectory) this._addFilesFromDirectory(entry, `${path}/${entry.name}`);
                    }
                    // Recursively call readEntries() again, since browser only handle
                    // the first 100 entries.
                    // See: https://developer.mozilla.org/en-US/docs/Web/API/DirectoryReader#readEntries
                    readEntries();
                }
                return null;
            }, errorHandler);
        };
        return readEntries();
    }
    // If `done()` is called without argument the file is accepted
    // If you call it with an error message, the file is rejected
    // (This allows for asynchronous validation)
    //
    // This function checks the filesize, and if the file.type passes the
    // `acceptedFiles` check.
    accept(file, done) {
        if (this.options.maxFilesize && file.size > this.options.maxFilesize * 1048576) done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
        else if (!$540cd3dd02161f28$export$2e2bcd8739ae039.isValidFile(file, this.options.acceptedFiles)) done(this.options.dictInvalidFileType);
        else if (this.options.maxFiles != null && this.getAcceptedFiles().length >= this.options.maxFiles) {
            done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
            this.emit("maxfilesexceeded", file);
        } else this.options.accept.call(this, file, done);
    }
    addFile(file) {
        file.upload = {
            uuid: $540cd3dd02161f28$export$2e2bcd8739ae039.uuidv4(),
            progress: 0,
            // Setting the total upload size to file.size for the beginning
            // It's actual different than the size to be transmitted.
            total: file.size,
            bytesSent: 0,
            filename: this._renameFile(file)
        };
        this.files.push(file);
        file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED;
        this.emit("addedfile", file);
        this._enqueueThumbnail(file);
        this.accept(file, (error)=>{
            if (error) {
                file.accepted = false;
                this._errorProcessing([
                    file
                ], error); // Will set the file.status
            } else {
                file.accepted = true;
                if (this.options.autoQueue) this.enqueueFile(file);
            // Will set .accepted = true
            }
            this._updateMaxFilesReachedClass();
        });
    }
    // Wrapper for enqueueFile
    enqueueFiles(files) {
        for (let file of files)this.enqueueFile(file);
        return null;
    }
    enqueueFile(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED && file.accepted === true) {
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED;
            if (this.options.autoProcessQueue) return setTimeout(()=>this.processQueue(), 0); // Deferring the call
        } else throw new Error("This file can't be queued because it has already been processed or was rejected.");
    }
    _enqueueThumbnail(file) {
        if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1048576) {
            this._thumbnailQueue.push(file);
            return setTimeout(()=>this._processThumbnailQueue(), 0); // Deferring the call
        }
    }
    _processThumbnailQueue() {
        if (this._processingThumbnail || this._thumbnailQueue.length === 0) return;
        this._processingThumbnail = true;
        let file = this._thumbnailQueue.shift();
        return this.createThumbnail(file, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, true, (dataUrl)=>{
            this.emit("thumbnail", file, dataUrl);
            this._processingThumbnail = false;
            return this._processThumbnailQueue();
        });
    }
    // Can be called by the user to remove a file
    removeFile(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) this.cancelUpload(file);
        this.files = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$without(this.files, file);
        this.emit("removedfile", file);
        if (this.files.length === 0) return this.emit("reset");
    }
    // Removes all files that aren't currently processed from the list
    removeAllFiles(cancelIfNecessary) {
        // Create a copy of files since removeFile() changes the @files array.
        if (cancelIfNecessary == null) cancelIfNecessary = false;
        for (let file of this.files.slice())if (file.status !== $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING || cancelIfNecessary) this.removeFile(file);
        return null;
    }
    // Resizes an image before it gets sent to the server. This function is the default behavior of
    // `options.transformFile` if `resizeWidth` or `resizeHeight` are set. The callback is invoked with
    // the resized blob.
    resizeImage(file, width, height, resizeMethod, callback) {
        return this.createThumbnail(file, width, height, resizeMethod, true, (dataUrl, canvas)=>{
            if (canvas == null) return callback(file);
            else {
                let { resizeMimeType: resizeMimeType } = this.options;
                if (resizeMimeType == null) resizeMimeType = file.type;
                let resizedDataURL = canvas.toDataURL(resizeMimeType, this.options.resizeQuality);
                if (resizeMimeType === "image/jpeg" || resizeMimeType === "image/jpg") resizedDataURL = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore.restore(file.dataURL, resizedDataURL);
                return callback($540cd3dd02161f28$export$2e2bcd8739ae039.dataURItoBlob(resizedDataURL));
            }
        });
    }
    createThumbnail(file, width, height, resizeMethod, fixOrientation, callback) {
        let fileReader = new FileReader();
        fileReader.onload = ()=>{
            file.dataURL = fileReader.result;
            // Don't bother creating a thumbnail for SVG images since they're vector
            if (file.type === "image/svg+xml") {
                if (callback != null) callback(fileReader.result);
                return;
            }
            this.createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback);
        };
        fileReader.readAsDataURL(file);
    }
    // `mockFile` needs to have these attributes:
    //
    //     { name: 'name', size: 12345, imageUrl: '' }
    //
    // `callback` will be invoked when the image has been downloaded and displayed.
    // `crossOrigin` will be added to the `img` tag when accessing the file.
    displayExistingFile(mockFile, imageUrl, callback, crossOrigin, resizeThumbnail = true) {
        this.emit("addedfile", mockFile);
        this.emit("complete", mockFile);
        if (!resizeThumbnail) {
            this.emit("thumbnail", mockFile, imageUrl);
            if (callback) callback();
        } else {
            let onDone = (thumbnail)=>{
                this.emit("thumbnail", mockFile, thumbnail);
                if (callback) callback();
            };
            mockFile.dataURL = imageUrl;
            this.createThumbnailFromUrl(mockFile, this.options.thumbnailWidth, this.options.thumbnailHeight, this.options.thumbnailMethod, this.options.fixOrientation, onDone, crossOrigin);
        }
    }
    createThumbnailFromUrl(file, width, height, resizeMethod, fixOrientation, callback, crossOrigin) {
        // Not using `new Image` here because of a bug in latest Chrome versions.
        // See https://github.com/enyo/dropzone/pull/226
        let img = document.createElement("img");
        if (crossOrigin) img.crossOrigin = crossOrigin;
        // fixOrientation is not needed anymore with browsers handling imageOrientation
        fixOrientation = getComputedStyle(document.body)["imageOrientation"] == "from-image" ? false : fixOrientation;
        img.onload = ()=>{
            let loadExif = (callback)=>callback(1);
            if (typeof EXIF !== "undefined" && EXIF !== null && fixOrientation) loadExif = (callback)=>EXIF.getData(img, function() {
                    return callback(EXIF.getTag(this, "Orientation"));
                });
            return loadExif((orientation)=>{
                file.width = img.width;
                file.height = img.height;
                let resizeInfo = this.options.resize.call(this, file, width, height, resizeMethod);
                let canvas = document.createElement("canvas");
                let ctx = canvas.getContext("2d");
                canvas.width = resizeInfo.trgWidth;
                canvas.height = resizeInfo.trgHeight;
                if (orientation > 4) {
                    canvas.width = resizeInfo.trgHeight;
                    canvas.height = resizeInfo.trgWidth;
                }
                switch(orientation){
                    case 2:
                        // horizontal flip
                        ctx.translate(canvas.width, 0);
                        ctx.scale(-1, 1);
                        break;
                    case 3:
                        // 180° rotate left
                        ctx.translate(canvas.width, canvas.height);
                        ctx.rotate(Math.PI);
                        break;
                    case 4:
                        // vertical flip
                        ctx.translate(0, canvas.height);
                        ctx.scale(1, -1);
                        break;
                    case 5:
                        // vertical flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.scale(1, -1);
                        break;
                    case 6:
                        // 90° rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(0, -canvas.width);
                        break;
                    case 7:
                        // horizontal flip + 90 rotate right
                        ctx.rotate(0.5 * Math.PI);
                        ctx.translate(canvas.height, -canvas.width);
                        ctx.scale(-1, 1);
                        break;
                    case 8:
                        // 90° rotate left
                        ctx.rotate(-0.5 * Math.PI);
                        ctx.translate(-canvas.height, 0);
                        break;
                }
                // This is a bugfix for iOS' scaling bug.
                $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$drawImageIOSFix(ctx, img, resizeInfo.srcX != null ? resizeInfo.srcX : 0, resizeInfo.srcY != null ? resizeInfo.srcY : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, resizeInfo.trgX != null ? resizeInfo.trgX : 0, resizeInfo.trgY != null ? resizeInfo.trgY : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
                let thumbnail = canvas.toDataURL("image/png");
                if (callback != null) return callback(thumbnail, canvas);
            });
        };
        if (callback != null) img.onerror = callback;
        return img.src = file.dataURL;
    }
    // Goes through the queue and processes files if there aren't too many already.
    processQueue() {
        let { parallelUploads: parallelUploads } = this.options;
        let processingLength = this.getUploadingFiles().length;
        let i = processingLength;
        // There are already at least as many files uploading than should be
        if (processingLength >= parallelUploads) return;
        let queuedFiles = this.getQueuedFiles();
        if (!(queuedFiles.length > 0)) return;
        if (this.options.uploadMultiple) return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
        else while(i < parallelUploads){
            if (!queuedFiles.length) return;
            // Nothing left to process
            this.processFile(queuedFiles.shift());
            i++;
        }
    }
    // Wrapper for `processFiles`
    processFile(file) {
        return this.processFiles([
            file
        ]);
    }
    // Loads the file, then calls finishedLoading()
    processFiles(files) {
        for (let file of files){
            file.processing = true; // Backwards compatibility
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING;
            this.emit("processing", file);
        }
        if (this.options.uploadMultiple) this.emit("processingmultiple", files);
        return this.uploadFiles(files);
    }
    _getFilesWithXhr(xhr) {
        let files;
        return files = this.files.filter((file)=>file.xhr === xhr).map((file)=>file);
    }
    // Cancels the file upload and sets the status to CANCELED
    // **if** the file is actually being uploaded.
    // If it's still in the queue, the file is being removed from it and the status
    // set to CANCELED.
    cancelUpload(file) {
        if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING) {
            let groupedFiles = this._getFilesWithXhr(file.xhr);
            for (let groupedFile of groupedFiles)groupedFile.status = $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED;
            if (typeof file.xhr !== "undefined") file.xhr.abort();
            for (let groupedFile1 of groupedFiles)this.emit("canceled", groupedFile1);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", groupedFiles);
        } else if (file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.ADDED || file.status === $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED) {
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED;
            this.emit("canceled", file);
            if (this.options.uploadMultiple) this.emit("canceledmultiple", [
                file
            ]);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    resolveOption(option, ...args) {
        if (typeof option === "function") return option.apply(this, args);
        return option;
    }
    uploadFile(file) {
        return this.uploadFiles([
            file
        ]);
    }
    uploadFiles(files) {
        this._transformFiles(files, (transformedFiles)=>{
            if (this.options.chunking) {
                // Chunking is not allowed to be used with `uploadMultiple` so we know
                // that there is only __one__file.
                let transformedFile = transformedFiles[0];
                files[0].upload.chunked = this.options.chunking && (this.options.forceChunking || transformedFile.size > this.options.chunkSize);
                files[0].upload.totalChunkCount = Math.ceil(transformedFile.size / this.options.chunkSize);
            }
            if (files[0].upload.chunked) {
                // This file should be sent in chunks!
                // If the chunking option is set, we **know** that there can only be **one** file, since
                // uploadMultiple is not allowed with this option.
                let file = files[0];
                let transformedFile = transformedFiles[0];
                let startedChunkCount = 0;
                file.upload.chunks = [];
                let handleNextChunk = ()=>{
                    let chunkIndex = 0;
                    // Find the next item in file.upload.chunks that is not defined yet.
                    while(file.upload.chunks[chunkIndex] !== undefined)chunkIndex++;
                    // This means, that all chunks have already been started.
                    if (chunkIndex >= file.upload.totalChunkCount) return;
                    startedChunkCount++;
                    let start = chunkIndex * this.options.chunkSize;
                    let end = Math.min(start + this.options.chunkSize, transformedFile.size);
                    let dataBlock = {
                        name: this._getParamName(0),
                        data: transformedFile.webkitSlice ? transformedFile.webkitSlice(start, end) : transformedFile.slice(start, end),
                        filename: file.upload.filename,
                        chunkIndex: chunkIndex
                    };
                    file.upload.chunks[chunkIndex] = {
                        file: file,
                        index: chunkIndex,
                        dataBlock: dataBlock,
                        status: $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING,
                        progress: 0,
                        retries: 0
                    };
                    this._uploadData(files, [
                        dataBlock
                    ]);
                };
                file.upload.finishedChunkUpload = (chunk, response)=>{
                    let allFinished = true;
                    chunk.status = $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS;
                    // Clear the data from the chunk
                    chunk.dataBlock = null;
                    chunk.response = chunk.xhr.responseText;
                    chunk.responseHeaders = chunk.xhr.getAllResponseHeaders();
                    // Leaving this reference to xhr will cause memory leaks.
                    chunk.xhr = null;
                    for(let i = 0; i < file.upload.totalChunkCount; i++){
                        if (file.upload.chunks[i] === undefined) return handleNextChunk();
                        if (file.upload.chunks[i].status !== $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS) allFinished = false;
                    }
                    if (allFinished) this.options.chunksUploaded(file, ()=>{
                        this._finished(files, response, null);
                    });
                };
                if (this.options.parallelChunkUploads) for(let i = 0; i < file.upload.totalChunkCount; i++)handleNextChunk();
                else handleNextChunk();
            } else {
                let dataBlocks = [];
                for(let i = 0; i < files.length; i++)dataBlocks[i] = {
                    name: this._getParamName(i),
                    data: transformedFiles[i],
                    filename: files[i].upload.filename
                };
                this._uploadData(files, dataBlocks);
            }
        });
    }
    /// Returns the right chunk for given file and xhr
    _getChunk(file, xhr) {
        for(let i = 0; i < file.upload.totalChunkCount; i++){
            if (file.upload.chunks[i] !== undefined && file.upload.chunks[i].xhr === xhr) return file.upload.chunks[i];
        }
    }
    // This function actually uploads the file(s) to the server.
    //
    //  If dataBlocks contains the actual data to upload (meaning, that this could
    // either be transformed files, or individual chunks for chunked upload) then
    // they will be used for the actual data to upload.
    _uploadData(files, dataBlocks) {
        let xhr = new XMLHttpRequest();
        // Put the xhr object in the file objects to be able to reference it later.
        for (let file of files)file.xhr = xhr;
        if (files[0].upload.chunked) // later, and found with _getChunk.
        files[0].upload.chunks[dataBlocks[0].chunkIndex].xhr = xhr;
        let method = this.resolveOption(this.options.method, files, dataBlocks);
        let url = this.resolveOption(this.options.url, files, dataBlocks);
        xhr.open(method, url, true);
        // Setting the timeout after open because of IE11 issue: https://gitlab.com/meno/dropzone/issues/8
        let timeout = this.resolveOption(this.options.timeout, files);
        if (timeout) xhr.timeout = this.resolveOption(this.options.timeout, files);
        // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
        xhr.withCredentials = !!this.options.withCredentials;
        xhr.onload = (e)=>{
            this._finishedUploading(files, xhr, e);
        };
        xhr.ontimeout = ()=>{
            this._handleUploadError(files, xhr, `Request timedout after ${this.options.timeout / 1000} seconds`);
        };
        xhr.onerror = ()=>{
            this._handleUploadError(files, xhr);
        };
        // Some browsers do not have the .upload property
        let progressObj = xhr.upload != null ? xhr.upload : xhr;
        progressObj.onprogress = (e)=>this._updateFilesUploadProgress(files, xhr, e);
        let headers = this.options.defaultHeaders ? {
            Accept: "application/json",
            "Cache-Control": "no-cache",
            "X-Requested-With": "XMLHttpRequest"
        } : {};
        if (this.options.binaryBody) headers["Content-Type"] = files[0].type;
        if (this.options.headers) (0, $ee62ca6949990202$export$2e2bcd8739ae039)(headers, this.options.headers);
        for(let headerName in headers){
            let headerValue = headers[headerName];
            if (headerValue) xhr.setRequestHeader(headerName, headerValue);
        }
        if (this.options.binaryBody) {
            // Since the file is going to be sent as binary body, it doesn't make
            // any sense to generate `FormData` for it.
            for (let file of files)this.emit("sending", file, xhr);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr);
            this.submitRequest(xhr, null, files);
        } else {
            let formData = new FormData();
            // Adding all @options parameters
            if (this.options.params) {
                let additionalParams = this.options.params;
                if (typeof additionalParams === "function") additionalParams = additionalParams.call(this, files, xhr, files[0].upload.chunked ? this._getChunk(files[0], xhr) : null);
                for(let key in additionalParams){
                    let value = additionalParams[key];
                    if (Array.isArray(value)) // so lets iterate over it to attach each value
                    // individually.
                    for(let i = 0; i < value.length; i++)formData.append(key, value[i]);
                    else formData.append(key, value);
                }
            }
            // Let the user add additional data if necessary
            for (let file of files)this.emit("sending", file, xhr, formData);
            if (this.options.uploadMultiple) this.emit("sendingmultiple", files, xhr, formData);
            this._addFormElementData(formData);
            // Finally add the files
            // Has to be last because some servers (eg: S3) expect the file to be the last parameter
            for(let i = 0; i < dataBlocks.length; i++){
                let dataBlock = dataBlocks[i];
                formData.append(dataBlock.name, dataBlock.data, dataBlock.filename);
            }
            this.submitRequest(xhr, formData, files);
        }
    }
    // Transforms all files with this.options.transformFile and invokes done with the transformed files when done.
    _transformFiles(files, done) {
        let transformedFiles = [];
        // Clumsy way of handling asynchronous calls, until I get to add a proper Future library.
        let doneCounter = 0;
        for(let i = 0; i < files.length; i++)this.options.transformFile.call(this, files[i], (transformedFile)=>{
            transformedFiles[i] = transformedFile;
            if (++doneCounter === files.length) done(transformedFiles);
        });
    }
    // Takes care of adding other input elements of the form to the AJAX request
    _addFormElementData(formData) {
        // Take care of other input elements
        if (this.element.tagName === "FORM") for (let input of this.element.querySelectorAll("input, textarea, select, button")){
            let inputName = input.getAttribute("name");
            let inputType = input.getAttribute("type");
            if (inputType) inputType = inputType.toLowerCase();
            // If the input doesn't have a name, we can't use it.
            if (typeof inputName === "undefined" || inputName === null) continue;
            if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
                // Possibly multiple values
                for (let option of input.options)if (option.selected) formData.append(inputName, option.value);
            } else if (!inputType || inputType !== "checkbox" && inputType !== "radio" || input.checked) formData.append(inputName, input.value);
        }
    }
    // Invoked when there is new progress information about given files.
    // If e is not provided, it is assumed that the upload is finished.
    _updateFilesUploadProgress(files, xhr, e) {
        if (!files[0].upload.chunked) for (let file of files){
            if (file.upload.total && file.upload.bytesSent && file.upload.bytesSent == file.upload.total) continue;
            if (e) {
                file.upload.progress = 100 * e.loaded / e.total;
                file.upload.total = e.total;
                file.upload.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                file.upload.progress = 100;
                file.upload.bytesSent = file.upload.total;
            }
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
        else {
            // Handle chunked file uploads
            // Chunked upload is not compatible with uploading multiple files in one
            // request, so we know there's only one file.
            let file = files[0];
            // Since this is a chunked upload, we need to update the appropriate chunk
            // progress.
            let chunk = this._getChunk(file, xhr);
            if (e) {
                chunk.progress = 100 * e.loaded / e.total;
                chunk.total = e.total;
                chunk.bytesSent = e.loaded;
            } else {
                // No event, so we're at 100%
                chunk.progress = 100;
                chunk.bytesSent = chunk.total;
            }
            // Now tally the *file* upload progress from its individual chunks
            file.upload.progress = 0;
            file.upload.total = 0;
            file.upload.bytesSent = 0;
            for(let i = 0; i < file.upload.totalChunkCount; i++)if (file.upload.chunks[i] && typeof file.upload.chunks[i].progress !== "undefined") {
                file.upload.progress += file.upload.chunks[i].progress;
                file.upload.total += file.upload.chunks[i].total;
                file.upload.bytesSent += file.upload.chunks[i].bytesSent;
            }
            // Since the process is a percentage, we need to divide by the amount of
            // chunks we've used.
            file.upload.progress = file.upload.progress / file.upload.totalChunkCount;
            this.emit("uploadprogress", file, file.upload.progress, file.upload.bytesSent);
        }
    }
    _finishedUploading(files, xhr, e) {
        let response;
        if (files[0].status === $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED) return;
        if (xhr.readyState !== 4) return;
        if (xhr.responseType !== "arraybuffer" && xhr.responseType !== "blob") {
            response = xhr.responseText;
            if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) try {
                response = JSON.parse(response);
            } catch (error) {
                e = error;
                response = "Invalid JSON response from server.";
            }
        }
        this._updateFilesUploadProgress(files, xhr);
        if (!(200 <= xhr.status && xhr.status < 300)) this._handleUploadError(files, xhr, response);
        else if (files[0].upload.chunked) files[0].upload.finishedChunkUpload(this._getChunk(files[0], xhr), response);
        else this._finished(files, response, e);
    }
    _handleUploadError(files, xhr, response) {
        if (files[0].status === $540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED) return;
        if (files[0].upload.chunked && this.options.retryChunks) {
            let chunk = this._getChunk(files[0], xhr);
            if (chunk.retries++ < this.options.retryChunksLimit) {
                this._uploadData(files, [
                    chunk.dataBlock
                ]);
                return;
            } else console.warn("Retried this chunk too often. Giving up.");
        }
        this._errorProcessing(files, response || this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr);
    }
    submitRequest(xhr, formData, files) {
        if (xhr.readyState != 1) {
            console.warn("Cannot send this request because the XMLHttpRequest.readyState is not OPENED.");
            return;
        }
        if (this.options.binaryBody) {
            if (files[0].upload.chunked) {
                const chunk = this._getChunk(files[0], xhr);
                xhr.send(chunk.dataBlock.data);
            } else xhr.send(files[0]);
        } else xhr.send(formData);
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _finished(files, responseText, e) {
        for (let file of files){
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS;
            this.emit("success", file, responseText, e);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("successmultiple", files, responseText, e);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    // Called internally when processing is finished.
    // Individual callbacks have to be called in the appropriate sections.
    _errorProcessing(files, message, xhr) {
        for (let file of files){
            file.status = $540cd3dd02161f28$export$2e2bcd8739ae039.ERROR;
            this.emit("error", file, message, xhr);
            this.emit("complete", file);
        }
        if (this.options.uploadMultiple) {
            this.emit("errormultiple", files, message, xhr);
            this.emit("completemultiple", files);
        }
        if (this.options.autoProcessQueue) return this.processQueue();
    }
    static uuidv4() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            let r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    constructor(el, options){
        super();
        let fallback, left;
        this.element = el;
        this.clickableElements = [];
        this.listeners = [];
        this.files = []; // All files
        if (typeof this.element === "string") this.element = document.querySelector(this.element);
        // Not checking if instance of HTMLElement or Element since IE9 is extremely weird.
        if (!this.element || this.element.nodeType == null) throw new Error("Invalid dropzone element.");
        if (this.element.dropzone) throw new Error("Dropzone already attached.");
        // Now add this dropzone to the instances.
        $540cd3dd02161f28$export$2e2bcd8739ae039.instances.push(this);
        // Put the dropzone inside the element itself.
        this.element.dropzone = this;
        let elementOptions = (left = $540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement(this.element)) != null ? left : {};
        this.options = (0, $ee62ca6949990202$export$2e2bcd8739ae039)(true, {}, $540cd3dd02161f28$var$$4ca367182776f80b$export$2e2bcd8739ae039, elementOptions, options != null ? options : {});
        this.options.previewTemplate = this.options.previewTemplate.replace(/\n*/g, "");
        // If the browser failed, just call the fallback and leave
        if (this.options.forceFallback || !$540cd3dd02161f28$export$2e2bcd8739ae039.isBrowserSupported()) return this.options.fallback.call(this);
        // @options.url = @element.getAttribute "action" unless @options.url?
        if (this.options.url == null) this.options.url = this.element.getAttribute("action");
        if (!this.options.url) throw new Error("No URL provided.");
        if (this.options.acceptedFiles && this.options.acceptedMimeTypes) throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
        if (this.options.uploadMultiple && this.options.chunking) throw new Error("You cannot set both: uploadMultiple and chunking.");
        if (this.options.binaryBody && this.options.uploadMultiple) throw new Error("You cannot set both: binaryBody and uploadMultiple.");
        // Backwards compatibility
        if (this.options.acceptedMimeTypes) {
            this.options.acceptedFiles = this.options.acceptedMimeTypes;
            delete this.options.acceptedMimeTypes;
        }
        // Backwards compatibility
        if (this.options.renameFilename != null) this.options.renameFile = (file)=>this.options.renameFilename.call(this, file.name, file);
        if (typeof this.options.method === "string") this.options.method = this.options.method.toUpperCase();
        if ((fallback = this.getExistingFallback()) && fallback.parentNode) fallback.parentNode.removeChild(fallback);
        // Display previews in the previewsContainer element or the Dropzone element unless explicitly set to false
        if (this.options.previewsContainer !== false) {
            if (this.options.previewsContainer) this.previewsContainer = $540cd3dd02161f28$export$2e2bcd8739ae039.getElement(this.options.previewsContainer, "previewsContainer");
            else this.previewsContainer = this.element;
        }
        if (this.options.clickable) {
            if (this.options.clickable === true) this.clickableElements = [
                this.element
            ];
            else this.clickableElements = $540cd3dd02161f28$export$2e2bcd8739ae039.getElements(this.options.clickable, "clickable");
        }
        this.init();
    }
}
$540cd3dd02161f28$export$2e2bcd8739ae039.initClass();
// This is a map of options for your different dropzones. Add configurations
// to this object for your different dropzone elemens.
//
// Example:
//
//     Dropzone.options.myDropzoneElementId = { maxFilesize: 1 };
//
// And in html:
//
//     <form action="/upload" id="my-dropzone-element-id" class="dropzone"></form>
$540cd3dd02161f28$export$2e2bcd8739ae039.options = {};
// Returns the options for an element or undefined if none available.
$540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement = function(element) {
    // Get the `Dropzone.options.elementId` for this element if it exists
    if (element.getAttribute("id")) return $540cd3dd02161f28$export$2e2bcd8739ae039.options[$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$camelize(element.getAttribute("id"))];
    else return undefined;
};
// Holds a list of all dropzone instances
$540cd3dd02161f28$export$2e2bcd8739ae039.instances = [];
// Returns the dropzone for given element if any
$540cd3dd02161f28$export$2e2bcd8739ae039.forElement = function(element) {
    if (typeof element === "string") element = document.querySelector(element);
    if ((element != null ? element.dropzone : undefined) == null) throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    return element.dropzone;
};
// Looks for all .dropzone elements and creates a dropzone for them
$540cd3dd02161f28$export$2e2bcd8739ae039.discover = function() {
    let dropzones;
    if (document.querySelectorAll) dropzones = document.querySelectorAll(".dropzone");
    else {
        dropzones = [];
        // IE :(
        let checkElements = (elements)=>(()=>{
                let result = [];
                for (let el of elements)if (/(^| )dropzone($| )/.test(el.className)) result.push(dropzones.push(el));
                else result.push(undefined);
                return result;
            })();
        checkElements(document.getElementsByTagName("div"));
        checkElements(document.getElementsByTagName("form"));
    }
    return (()=>{
        let result = [];
        for (let dropzone of dropzones)if ($540cd3dd02161f28$export$2e2bcd8739ae039.optionsForElement(dropzone) !== false) result.push(new $540cd3dd02161f28$export$2e2bcd8739ae039(dropzone));
        else result.push(undefined);
        return result;
    })();
};
// Some browsers support drag and drog functionality, but not correctly.
//
// So I created a blocklist of userAgents. Yes, yes. Browser sniffing, I know.
// But what to do when browsers *theoretically* support an API, but crash
// when using it.
//
// This is a list of regular expressions tested against navigator.userAgent
//
// ** It should only be used on browser that *do* support the API, but
// incorrectly **
$540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers = [
    // The mac os and windows phone version of opera 12 seems to have a problem with the File drag'n'drop API.
    /opera.*(Macintosh|Windows Phone).*version\/12/i
];
// Checks if the browser is supported
$540cd3dd02161f28$export$2e2bcd8739ae039.isBrowserSupported = function() {
    let capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
        if (!("classList" in document.createElement("a"))) capableBrowser = false;
        else {
            if ($540cd3dd02161f28$export$2e2bcd8739ae039.blacklistedBrowsers !== undefined) // configuration.
            $540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers = $540cd3dd02161f28$export$2e2bcd8739ae039.blacklistedBrowsers;
            // The browser supports the API, but may be blocked.
            for (let regex of $540cd3dd02161f28$export$2e2bcd8739ae039.blockedBrowsers)if (regex.test(navigator.userAgent)) {
                capableBrowser = false;
                continue;
            }
        }
    } else capableBrowser = false;
    return capableBrowser;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.dataURItoBlob = function(dataURI) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(",")[1]);
    // separate out the mime component
    let mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);
    let ia = new Uint8Array(ab);
    for(let i = 0, end = byteString.length, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--)ia[i] = byteString.charCodeAt(i);
    // write the ArrayBuffer to a blob
    return new Blob([
        ab
    ], {
        type: mimeString
    });
};
// Returns an array without the rejected item
const $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$without = (list, rejectedItem)=>list.filter((item)=>item !== rejectedItem).map((item)=>item);
// abc-def_ghi -> abcDefGhi
const $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$camelize = (str)=>str.replace(/[\-_](\w)/g, (match)=>match.charAt(1).toUpperCase());
// Creates an element from string
$540cd3dd02161f28$export$2e2bcd8739ae039.createElement = function(string) {
    let div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
};
// Tests if given element is inside (or simply is) the container
$540cd3dd02161f28$export$2e2bcd8739ae039.elementInside = function(element, container) {
    if (element === container) return true;
    // Coffeescript doesn't support do/while loops
    while(element = element.parentNode){
        if (element === container) return true;
    }
    return false;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.getElement = function(el, name) {
    let element;
    if (typeof el === "string") element = document.querySelector(el);
    else if (el.nodeType != null) element = el;
    if (element == null) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector or a plain HTML element.`);
    return element;
};
$540cd3dd02161f28$export$2e2bcd8739ae039.getElements = function(els, name) {
    let el, elements;
    if (els instanceof Array) {
        elements = [];
        try {
            for (el of els)elements.push(this.getElement(el, name));
        } catch (e) {
            elements = null;
        }
    } else if (typeof els === "string") {
        elements = [];
        for (el of document.querySelectorAll(els))elements.push(el);
    } else if (els.nodeType != null) elements = [
        els
    ];
    if (elements == null || !elements.length) throw new Error(`Invalid \`${name}\` option provided. Please provide a CSS selector, a plain HTML element or a list of those.`);
    return elements;
};
// Asks the user the question and calls accepted or rejected accordingly
//
// The default implementation just uses `window.confirm` and then calls the
// appropriate callback.
$540cd3dd02161f28$export$2e2bcd8739ae039.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) return accepted();
    else if (rejected != null) return rejected();
};
// Validates the mime type like this:
//
// https://developer.mozilla.org/en-US/docs/HTML/Element/input#attr-accept
$540cd3dd02161f28$export$2e2bcd8739ae039.isValidFile = function(file, acceptedFiles) {
    if (!acceptedFiles) return true;
    // If there are no accepted mime types, it's OK
    acceptedFiles = acceptedFiles.split(",");
    let mimeType = file.type;
    let baseMimeType = mimeType.replace(/\/.*$/, "");
    for (let validType of acceptedFiles){
        validType = validType.trim();
        if (validType.charAt(0) === ".") {
            if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) return true;
        } else if (/\/\*$/.test(validType)) {
            // This is something like a image/* mime type
            if (baseMimeType === validType.replace(/\/.*$/, "")) return true;
        } else {
            if (mimeType === validType) return true;
        }
    }
    return false;
};
// Augment jQuery
if (typeof jQuery !== "undefined" && jQuery !== null) jQuery.fn.dropzone = function(options) {
    return this.each(function() {
        return new $540cd3dd02161f28$export$2e2bcd8739ae039(this, options);
    });
};
// Dropzone file status codes
$540cd3dd02161f28$export$2e2bcd8739ae039.ADDED = "added";
$540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED = "queued";
// For backwards compatibility. Now, if a file is accepted, it's either queued
// or uploading.
$540cd3dd02161f28$export$2e2bcd8739ae039.ACCEPTED = $540cd3dd02161f28$export$2e2bcd8739ae039.QUEUED;
$540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING = "uploading";
$540cd3dd02161f28$export$2e2bcd8739ae039.PROCESSING = $540cd3dd02161f28$export$2e2bcd8739ae039.UPLOADING; // alias
$540cd3dd02161f28$export$2e2bcd8739ae039.CANCELED = "canceled";
$540cd3dd02161f28$export$2e2bcd8739ae039.ERROR = "error";
$540cd3dd02161f28$export$2e2bcd8739ae039.SUCCESS = "success";
/*

 Bugfix for iOS 6 and 7
 Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
 based on the work of https://github.com/stomita/ios-imagefile-megapixel

 */ // Detecting vertical squash in loaded image.
// Fixes a bug which squash image vertically while drawing into canvas for some images.
// This is a bug in iOS6 devices. This function from https://github.com/stomita/ios-imagefile-megapixel
let $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$detectVerticalSquash = function(img) {
    let iw = img.naturalWidth;
    let ih = img.naturalHeight;
    let canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    let { data: data } = ctx.getImageData(1, 0, 1, ih);
    // search image edge pixel position in case it is squashed vertically.
    let sy = 0;
    let ey = ih;
    let py = ih;
    while(py > sy){
        let alpha = data[(py - 1) * 4 + 3];
        if (alpha === 0) ey = py;
        else sy = py;
        py = ey + sy >> 1;
    }
    let ratio = py / ih;
    if (ratio === 0) return 1;
    else return ratio;
};
// A replacement for context.drawImage
// (args are for source and destination).
var $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    let vertSquashRatio = $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
};
// Based on MinifyJpeg
// Source: http://www.perry.cz/files/ExifRestorer.js
// http://elicon.blog57.fc2.com/blog-entry-206.html
class $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore {
    static initClass() {
        this.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    }
    static encode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        while(true){
            chr1 = input[i++];
            chr2 = input[i++];
            chr3 = input[i++];
            enc1 = chr1 >> 2;
            enc2 = (chr1 & 3) << 4 | chr2 >> 4;
            enc3 = (chr2 & 15) << 2 | chr3 >> 6;
            enc4 = chr3 & 63;
            if (isNaN(chr2)) enc3 = enc4 = 64;
            else if (isNaN(chr3)) enc4 = 64;
            output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return output;
    }
    static restore(origFileBase64, resizedFileBase64) {
        if (!origFileBase64.match("data:image/jpeg;base64,")) return resizedFileBase64;
        let rawImage = this.decode64(origFileBase64.replace("data:image/jpeg;base64,", ""));
        let segments = this.slice2Segments(rawImage);
        let image = this.exifManipulation(resizedFileBase64, segments);
        return `data:image/jpeg;base64,${this.encode64(image)}`;
    }
    static exifManipulation(resizedFileBase64, segments) {
        let exifArray = this.getExifArray(segments);
        let newImageArray = this.insertExif(resizedFileBase64, exifArray);
        let aBuffer = new Uint8Array(newImageArray);
        return aBuffer;
    }
    static getExifArray(segments) {
        let seg = undefined;
        let x = 0;
        while(x < segments.length){
            seg = segments[x];
            if (seg[0] === 255 & seg[1] === 225) return seg;
            x++;
        }
        return [];
    }
    static insertExif(resizedFileBase64, exifArray) {
        let imageData = resizedFileBase64.replace("data:image/jpeg;base64,", "");
        let buf = this.decode64(imageData);
        let separatePoint = buf.indexOf(255, 3);
        let mae = buf.slice(0, separatePoint);
        let ato = buf.slice(separatePoint);
        let array = mae;
        array = array.concat(exifArray);
        array = array.concat(ato);
        return array;
    }
    static slice2Segments(rawImageArray) {
        let head = 0;
        let segments = [];
        while(true){
            var length;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) break;
            if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) head += 2;
            else {
                length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3];
                let endPoint = head + length + 2;
                let seg = rawImageArray.slice(head, endPoint);
                segments.push(seg);
                head = endPoint;
            }
            if (head > rawImageArray.length) break;
        }
        return segments;
    }
    static decode64(input) {
        let output = "";
        let chr1 = undefined;
        let chr2 = undefined;
        let chr3 = "";
        let enc1 = undefined;
        let enc2 = undefined;
        let enc3 = undefined;
        let enc4 = "";
        let i = 0;
        let buf = [];
        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        let base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(input)) console.warn("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding.");
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
        while(true){
            enc1 = this.KEY_STR.indexOf(input.charAt(i++));
            enc2 = this.KEY_STR.indexOf(input.charAt(i++));
            enc3 = this.KEY_STR.indexOf(input.charAt(i++));
            enc4 = this.KEY_STR.indexOf(input.charAt(i++));
            chr1 = enc1 << 2 | enc2 >> 4;
            chr2 = (enc2 & 15) << 4 | enc3 >> 2;
            chr3 = (enc3 & 3) << 6 | enc4;
            buf.push(chr1);
            if (enc3 !== 64) buf.push(chr2);
            if (enc4 !== 64) buf.push(chr3);
            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";
            if (!(i < input.length)) break;
        }
        return buf;
    }
}
$540cd3dd02161f28$var$$3ed269f2f0fb224b$var$ExifRestore.initClass();
/*
 * contentloaded.js
 *
 * Author: Diego Perini (diego.perini at gmail.com)
 * Summary: cross-browser wrapper for DOMContentLoaded
 * Updated: 20101020
 * License: MIT
 * Version: 1.2
 *
 * URL:
 * http://javascript.nwbox.com/ContentLoaded/
 * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
 */ // @win window reference
// @fn function reference
let $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$contentLoaded = function(win, fn) {
    let done = false;
    let top = true;
    let doc = win.document;
    let root = doc.documentElement;
    let add = doc.addEventListener ? "addEventListener" : "attachEvent";
    let rem = doc.addEventListener ? "removeEventListener" : "detachEvent";
    let pre = doc.addEventListener ? "" : "on";
    var init = function(e) {
        if (e.type === "readystatechange" && doc.readyState !== "complete") return;
        (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
        if (!done && (done = true)) return fn.call(win, e.type || e);
    };
    var poll = function() {
        try {
            root.doScroll("left");
        } catch (e) {
            setTimeout(poll, 50);
            return;
        }
        return init("poll");
    };
    if (doc.readyState !== "complete") {
        if (doc.createEventObject && root.doScroll) {
            try {
                top = !win.frameElement;
            } catch (error) {}
            if (top) poll();
        }
        doc[add](pre + "DOMContentLoaded", init, false);
        doc[add](pre + "readystatechange", init, false);
        return win[add](pre + "load", init, false);
    }
};
function $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guard__(value, transform) {
    return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
function $540cd3dd02161f28$var$$3ed269f2f0fb224b$var$__guardMethod__(obj, methodName, transform) {
    if (typeof obj !== "undefined" && obj !== null && typeof obj[methodName] === "function") return transform(obj, methodName);
    else return undefined;
}


var $d39d5626a2a26fe7$require$Dropzone = $540cd3dd02161f28$export$2e2bcd8739ae039;
const $d39d5626a2a26fe7$export$6b45509f74bc6382 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const dropzoneRef = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        let myDropzone = new $d39d5626a2a26fe7$require$Dropzone(dropzoneRef.current, {
            dictDefaultMessage: '',
            maxFilesize: 20,
            url: '/',
            addRemoveLinks: false,
            method: 'put',
            chunking: true,
            forceChunking: true,
            autoQueue: false,
            autoProcessQueue: false,
            disablePreviews: true
        });
        myDropzone.on('addedfile', function(file) {
            return $d39d5626a2a26fe7$var$__awaiter(this, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                const name = file.name;
                if (!name.toLowerCase().endsWith('.pdf')) {
                    (0, $c1e5789890d2fb2f$export$b410431fab84fa58).error('Please upload a PDF file');
                    myDropzone.removeFile(file);
                    return;
                }
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                const fileExists = false;
                if (!fileExists) {
                    const message = props.toasterMessage.replace('%name%', name);
                    var toasterId = (0, $c1e5789890d2fb2f$export$b410431fab84fa58).info(message, {
                        progress: 0,
                        autoClose: false
                    });
                    //alert('Uploading file');
                    const success = yield storage.uploadFileToStorage(props.storageTarget, file, (progress)=>{
                        //file.upload.progress = progress;
                        (0, $c1e5789890d2fb2f$export$b410431fab84fa58).update(toasterId, {
                            progress: progress / 100
                        });
                    });
                    if (success) {
                        //alert('Upload done!');
                        if (props.onUpload) props.onUpload(name);
                        (0, $c1e5789890d2fb2f$export$b410431fab84fa58).done(toasterId);
                    } else (0, $c1e5789890d2fb2f$export$b410431fab84fa58).info('Trouble uploading the file..');
                }
            });
        });
        return ()=>{
            while(myDropzone.files.length > 0)myDropzone.removeFile(myDropzone.files[0]);
            myDropzone.destroy();
        };
    }, [
        dropzoneRef,
        props
    ]);
    const clsToUse = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($1bc40f4eb65039a9$export$2778853eeaa53fa7, props.className);
    return(//Click is handled by drop-zone
    (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
        ref: dropzoneRef,
        className: clsToUse,
        variant: "light",
        children: props.display
    }));
});


var $3c05c8c560a8b6b4$export$40a9eeef55665a40;
var $3c05c8c560a8b6b4$export$93b7586d956c930e;
var $3c05c8c560a8b6b4$export$e4f6ce96d55d099a;
var $3c05c8c560a8b6b4$export$f843afa9e9b53052;
var $3c05c8c560a8b6b4$export$ae78d338ad66ff90;
var $3c05c8c560a8b6b4$export$b8972b998723d602;
$3c05c8c560a8b6b4$export$40a9eeef55665a40 = `YUBJYq_defaultPadding`;
$3c05c8c560a8b6b4$export$93b7586d956c930e = `YUBJYq_dropShadow`;
$3c05c8c560a8b6b4$export$e4f6ce96d55d099a = `YUBJYq_newDealButton`;
$3c05c8c560a8b6b4$export$f843afa9e9b53052 = `YUBJYq_panelImage`;
$3c05c8c560a8b6b4$export$ae78d338ad66ff90 = `YUBJYq_scaleInOut`;
$3c05c8c560a8b6b4$export$b8972b998723d602 = `YUBJYq_shadow`;


const $cb260e4106feb219$export$3dd2d6bc8d332dfb = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    return (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
        display: "New Deal",
        storageTarget: {
            type: 'cim'
        },
        toasterMessage: "Uploading Deal: %name%",
        className: $3c05c8c560a8b6b4$export$e4f6ce96d55d099a,
        onUpload: (fileName)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.store_audit_entry('UPLOAD_CIM', {
                fileName: fileName
            });
            fb.add_job(fileName);
        }
    });
});


var $705b9354ee184fb4$export$dac02eec6ee70897;
var $705b9354ee184fb4$export$34e0f9847d4c02dd;
var $705b9354ee184fb4$export$40a9eeef55665a40;
var $705b9354ee184fb4$export$93b7586d956c930e;
var $705b9354ee184fb4$export$faed4863136ce212;
var $705b9354ee184fb4$export$e4f6ce96d55d099a;
var $705b9354ee184fb4$export$f843afa9e9b53052;
var $705b9354ee184fb4$export$3304639b795b6ae;
var $705b9354ee184fb4$export$ae78d338ad66ff90;
var $705b9354ee184fb4$export$155b316d1d1ff341;
var $705b9354ee184fb4$export$b8972b998723d602;
var $705b9354ee184fb4$export$fb184b623420d9be;
$705b9354ee184fb4$export$dac02eec6ee70897 = `_sVDwa_clientName`;
$705b9354ee184fb4$export$34e0f9847d4c02dd = `_sVDwa_container`;
$705b9354ee184fb4$export$40a9eeef55665a40 = `_sVDwa_defaultPadding`;
$705b9354ee184fb4$export$93b7586d956c930e = `_sVDwa_dropShadow`;
$705b9354ee184fb4$export$faed4863136ce212 = `_sVDwa_headerRow`;
$705b9354ee184fb4$export$e4f6ce96d55d099a = `_sVDwa_newDealButton`;
$705b9354ee184fb4$export$f843afa9e9b53052 = `_sVDwa_panelImage`;
$705b9354ee184fb4$export$3304639b795b6ae = `_sVDwa_plusIcon`;
$705b9354ee184fb4$export$ae78d338ad66ff90 = `_sVDwa_scaleInOut`;
$705b9354ee184fb4$export$155b316d1d1ff341 = `_sVDwa_scorePosition`;
$705b9354ee184fb4$export$b8972b998723d602 = `_sVDwa_shadow`;
$705b9354ee184fb4$export$fb184b623420d9be = `_sVDwa_title`;



var $kSbwP = parcelRequire("kSbwP");
var $c13c7138f721db72$exports = {};
$c13c7138f721db72$exports = new URL("new_logo.d9372fce.png", import.meta.url).toString();


var $5abc52d34966ec2e$exports = {};
$5abc52d34966ec2e$exports = new URL("bird_logo.4a767494.png", import.meta.url).toString();


const $bc783706f3494468$export$e6ff31bff12b7ff4 = (props)=>{
    const width = props.width || 160;
    return (0, $kSbwP.jsx)("img", {
        style: {
            cursor: 'pointer',
            objectFit: 'contain'
        },
        className: props.className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c13c7138f721db72$exports))),
        width: width,
        onClick: ()=>{
            if (props.onClick) props.onClick();
        }
    });
};
const $bc783706f3494468$export$7707107edd1bbb83 = ()=>{
    return (0, $kSbwP.jsx)("img", {
        style: {
            objectFit: 'contain'
        },
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5abc52d34966ec2e$exports))),
        width: 50
    });
};


const $77d5878715146af4$export$8b251419efc915eb = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    var _a;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const q = store.query;
    const useShadow = (_a = p.showShadow) !== null && _a !== void 0 ? _a : true;
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($705b9354ee184fb4$export$34e0f9847d4c02dd, {
        [$705b9354ee184fb4$export$b8972b998723d602]: useShadow
    });
    const config = (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)();
    const clientName = config.clientName;
    const firmURL = store.firmInfo.logoURL;
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: cls,
        justify: "center",
        children: [
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                style: {
                    paddingBottom: '5px'
                },
                children: [
                    (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {
                        onClick: ()=>{
                            navUtils.home();
                        }
                    }),
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            width: '30px'
                        }
                    }),
                    p.showDealDbLink && (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                        variant: "light",
                        onClick: ()=>{
                            navUtils.home();
                        },
                        children: "Deal Database"
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $705b9354ee184fb4$export$dac02eec6ee70897,
                        children: (0, $kSbwP.jsx)("img", {
                            height: 40,
                            width: 180,
                            src: firmURL,
                            style: {
                                objectFit: 'contain',
                                objectPosition: 'right'
                            }
                        })
                    })
                ]
            }),
            (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                alignItems: "center",
                className: $705b9354ee184fb4$export$faed4863136ce212,
                justify: "between",
                style: {
                    gap: '10px'
                },
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $705b9354ee184fb4$export$fb184b623420d9be,
                        children: storeUI.pageTitle
                    }),
                    p.showScore && q && (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                        score: q.score(),
                        className: $705b9354ee184fb4$export$155b316d1d1ff341
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: "flex-grow-1"
                    }),
                    store.isAdmin && (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                        variant: "light",
                        style: {
                            height: '45px'
                        },
                        onClick: ()=>{
                            navUtils.knowledgeBase();
                        },
                        children: "Knowledge Base"
                    }),
                    p.showNewDeal && (0, $kSbwP.jsx)((0, $cb260e4106feb219$export$3dd2d6bc8d332dfb), {})
                ]
            })
        ]
    });
});






var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");








var $kSbwP = parcelRequire("kSbwP");


var $7a2e80ea91ff7781$export$a7db06668cad9adb;
var $7a2e80ea91ff7781$export$40a9eeef55665a40;
var $7a2e80ea91ff7781$export$93b7586d956c930e;
var $7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2;
var $7a2e80ea91ff7781$export$21f42ab9b6679f44;
var $7a2e80ea91ff7781$export$f843afa9e9b53052;
var $7a2e80ea91ff7781$export$4585e12f251bfc64;
var $7a2e80ea91ff7781$export$ae78d338ad66ff90;
var $7a2e80ea91ff7781$export$b8972b998723d602;
var $7a2e80ea91ff7781$export$fb184b623420d9be;
$7a2e80ea91ff7781$export$a7db06668cad9adb = `_63TkoG_content`;
$7a2e80ea91ff7781$export$40a9eeef55665a40 = `_63TkoG_defaultPadding`;
$7a2e80ea91ff7781$export$93b7586d956c930e = `_63TkoG_dropShadow`;
$7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2 = `_63TkoG_fillCell`;
$7a2e80ea91ff7781$export$21f42ab9b6679f44 = `_63TkoG_panel`;
$7a2e80ea91ff7781$export$f843afa9e9b53052 = `_63TkoG_panelImage`;
$7a2e80ea91ff7781$export$4585e12f251bfc64 = `_63TkoG_panel_shadow`;
$7a2e80ea91ff7781$export$ae78d338ad66ff90 = `_63TkoG_scaleInOut`;
$7a2e80ea91ff7781$export$b8972b998723d602 = `_63TkoG_shadow`;
$7a2e80ea91ff7781$export$fb184b623420d9be = `_63TkoG_title`;



const $a7f903e2fee2d8e0$export$2ddb90ad54e5f587 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const className = props.className || '';
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($7a2e80ea91ff7781$export$21f42ab9b6679f44, {
        [$7a2e80ea91ff7781$export$4585e12f251bfc64]: props.shadow
    }, className, {
        [$7a2e80ea91ff7781$export$4c9cc8a8bb2b3fc2]: props.fillCell == true
    });
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: cls,
        direction: "column",
        children: props.children
    });
});


const $c852cf41bf4911ee$export$e7b94983f4222b90 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const location = (0, $48e5d1fb97c993cc$export$45d76561a5302f2b)();
    const isRoot = location.pathname === '/';
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const getCompanyData = (reportId)=>{
        const q = store.createDataAccess(reportId);
        const year = q.actualYear();
        const company_overview = q.value('company_overview');
        const company_overview_short = q.value('company_overview_short');
        const industry = q.value('industry');
        const subIndustry = q.value('industrySubType');
        const ebitda = q.valueByYear('ebitda_per_year', year);
        const ebitdaMargin = q.valueByYearDivideByRevenue('ebitda_per_year', year);
        const netRevenue = q.valueByYear('net_revenue_per_year', year);
        const grossProfit = q.valueByYear('gross_profit_per_year', year);
        const ebitdaMargin2YearsAgo = q.valueByYearDivideByRevenue('ebitda_per_year', year, -2);
        //const adjustedEbidta = q.valueByYear('adjusted_ebitda_per_year', year);
        const totalCapexByRev = q.valueByYearDivideByRevenue('capex_per_year', year);
        const gross_retention = q.valueByYearDivideByRevenue('gross_retention_lost_only_per_year', year);
        const netRet = q.valueByYear('net_retention_yearly', year);
        const capexPerYear = q.valueByYear('capex_per_year', year);
        const maintenanceCapexPerYear = q.valueByYear('maintenance_capex_per_year', year);
        const ebitdaCashflow = q.valueByYear('ebitda_cashflow_yearly', year);
        const totalAssets = q.valueByYear('total_current_assets_yearly', year);
        const totalLiabilities = q.valueByYear('total_current_liabilities_yearly', year);
        const tam = q.value('total_addressable_market');
        const historicalMarketGrowth = q.value('historical_market_growth');
        const projectedMarketGrowth = q.value('projected_market_growth');
        const contractualRevenue = q.value('recurring_revenue_summary');
        const rows = [];
        const data = {};
        const addValue = (name, value)=>{
            data[name] = value;
        //rows.push(`${name},${value}`);
        };
        addValue('company_name', q.value('company_name'));
        addValue('company_overview', company_overview);
        addValue('company_overview_short', company_overview_short);
        addValue('industry', industry);
        addValue('sub_industry', subIndustry);
        addValue('net_revenue', netRevenue);
        addValue('gross_profit', grossProfit);
        addValue('organic_cagr_2_years', q.organicCagr(2));
        addValue('projected_organic_cagr_2_years', q.projectedCagr(2));
        addValue('organic_cagr_3_years', q.organicCagr(3));
        addValue('projected_organic_cagr_3_years', q.projectedCagr(3));
        addValue('organic_cagr_4_years', q.organicCagr(4));
        addValue('projected_organic_cagr_4_years', q.projectedCagr(4));
        addValue('organic_cagr_5_years', q.organicCagr(5));
        addValue('projected_organic_cagr_5_years', q.projectedCagr(5));
        addValue('ebitda', ebitda);
        addValue('ebitda_margin', ebitdaMargin);
        addValue('ebitda_margin_2_years_ago', ebitdaMargin2YearsAgo);
        //addValue('adjusted_ebitda', adjustedEbidta);
        addValue('total_capex_by_rev', totalCapexByRev);
        addValue('gross_retention', gross_retention);
        addValue('net_retention', netRet);
        addValue('capex_per_year', capexPerYear);
        addValue('maintenance_capex_per_year', maintenanceCapexPerYear);
        addValue('free_cash_flow', ebitdaCashflow);
        addValue('total_assets', totalAssets);
        addValue('total_liabilities', totalLiabilities);
        addValue('tam', tam);
        addValue('historical_market_growth', historicalMarketGrowth);
        addValue('projected_market_growth', projectedMarketGrowth);
        addValue('contractual_revenue', contractualRevenue);
        return data;
    };
    function jsonToTransposedCSV(jsonData) {
        const companyIds = Object.keys(jsonData);
        const fieldSet = new Set();
        // Collect all unique fields
        companyIds.forEach((id)=>{
            Object.keys(jsonData[id]).forEach((field)=>fieldSet.add(field));
        });
        companyIds.sort();
        const fields = Array.from(fieldSet);
        // CSV Header
        let csv = `Field||${companyIds.join('||')}\n`;
        // Add rows for each field
        fields.forEach((field)=>{
            const row = [
                field
            ];
            companyIds.forEach((id)=>{
                row.push(jsonData[id][field] !== undefined ? jsonData[id][field] : '');
            });
            csv += row.join('||') + '\r\n';
        });
        return csv;
    }
    const genAllCompaniesData = ()=>{
        const companies = Object.keys(store.reportDataDB);
        const data = {};
        companies.sort();
        companies.forEach((company, i)=>{
            data[company] = getCompanyData(company);
        });
        var csv = jsonToTransposedCSV(data);
        navigator.clipboard.writeText(csv);
    };
    const getCurrentReportFilename = ()=>{
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        return store.query.value('pdf');
    };
    const getCurrentReport = ()=>{
        return store.selectedReportId;
    };
    const getAllFileame = ()=>{
        return '**ALL REPORTS**';
    };
    const getLastJobName = ()=>{
        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
        const sorted = Object.entries(store.jobs).sort((a, b)=>b[0].localeCompare(a[0]));
        const pdfFile = sorted[0][1]['fileName'];
        return pdfFile;
    };
    if (!store.isAdmin && !storeUI.isDev) return null;
    const makeReRunButtons = (typeRerun, getFileName)=>{
        const extraSure = '*** FULL-RERUN: DOUBLE-CHECK: Are you sure?';
        const processRerun = (type, pdfFile, clearCache)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            if (type == 'ALL') {
                var areYouSure2 = window.confirm(extraSure);
                if (!areYouSure2) return;
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                var reports = store.reportDataDB;
                var redoList = [];
                for(var reportId in reports){
                    var data = reports[reportId];
                    if (data['status'] == 'completed') redoList.push(data['pdf']);
                }
                redoList.forEach((pdfFile)=>{
                    fb.add_job(pdfFile, null, null, clearCache);
                });
            } else fb.add_job(pdfFile, null, null, clearCache);
            nav.home();
        };
        const variant = typeRerun === 'ALL' ? 'danger' : 'light';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: typeRerun
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** RERUN:  ${typeRerun}: File: ${getFileName()} - Are you sure?`;
                                    var cacheStr = '\nUSING SAME CACHE';
                                    var areYouSure = window.confirm(buildMessage + cacheStr);
                                    if (!areYouSure) return;
                                    processRerun(typeRerun, getFileName(), false);
                                },
                                children: "Reuse"
                            }),
                            (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** RERUN:  ${typeRerun}: File: ${getFileName()} - Are you sure?`;
                                    var cacheStr = '**** CLEARING CACHE ****';
                                    var areYouSure = window.confirm(buildMessage + cacheStr);
                                    if (!areYouSure) return;
                                    processRerun(typeRerun, getFileName(), true);
                                },
                                children: "Clear"
                            })
                        ]
                    })
                ]
            })
        });
    };
    const makeDeleteButton = (getReportName)=>{
        const processDelete = (reportId)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.deleteReport(reportId);
            nav.home();
        };
        const variant = 'danger';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "CURRENT"
                    }),
                    (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '2px'
                        },
                        children: (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                            variant: variant,
                            onClick: ()=>{
                                const buildMessage = `*** DELETE: Report: ${getReportName()} - Are you sure?`;
                                var areYouSure = window.confirm(buildMessage);
                                if (!areYouSure) return;
                                processDelete(getReportName());
                            },
                            children: "Delete"
                        })
                    })
                ]
            })
        });
    };
    const makePauseResumeJobs = ()=>{
        const setStatusToJobs = (fromStatus, toStatus)=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            const jobs = store.jobs;
            const jobIds = Object.keys(jobs);
            jobIds.forEach((jobId)=>{
                const job = jobs[jobId];
                if (job['status'] == fromStatus) fb.setJobStatus(jobId, toStatus);
            });
        };
        const variant = 'danger';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px',
                minWidth: '160px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "PAUSE/RESUME"
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        style: {
                            gap: '10px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** This will PAUSE jobs that are in the QUEUE?`;
                                    var areYouSure = window.confirm(buildMessage);
                                    if (!areYouSure) return;
                                    setStatusToJobs('pending', 'paused');
                                },
                                children: "Pause"
                            }),
                            (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                variant: variant,
                                onClick: ()=>{
                                    const buildMessage = `*** This will RESUME jobs that were previously PAUSED?`;
                                    var areYouSure = window.confirm(buildMessage);
                                    if (!areYouSure) return;
                                    setStatusToJobs('paused', 'pending');
                                },
                                children: "Resume"
                            })
                        ]
                    })
                ]
            })
        });
    };
    const makeClearJobQueue = ()=>{
        const processClearJobQueue = ()=>{
            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
            fb.clearJobQueue();
            nav.home();
        };
        const variant = 'warning';
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            style: {
                gap: '10px',
                minWidth: '100px'
            },
            children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                shadow: true,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            backgroundColor: 'lightgray',
                            borderRadius: '10px 10px 0px 0px',
                            padding: '5px'
                        },
                        children: "JOB QUEUE"
                    }),
                    (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                        variant: variant,
                        onClick: ()=>{
                            const buildMessage = `*** Clearing Job Queue - Are you sure?`;
                            var areYouSure = window.confirm(buildMessage);
                            if (!areYouSure) return;
                            processClearJobQueue();
                        },
                        children: "CLEAR"
                    })
                ]
            })
        });
    };
    const makeStats = ()=>{
        var _a;
        var totalReports = 0;
        var totalQueued = 0;
        if (!store.reportDataDB) return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {});
        for(var reportId in store.reportDataDB){
            const report = store.reportDataDB[reportId];
            if (report['status'] == 'completed') totalReports++;
        }
        for(var jobId in (_a = store.jobs) !== null && _a !== void 0 ? _a : {}){
            const job = store.jobs[jobId];
            if (job['status'] == 'pending') totalQueued++;
        }
        return (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            shadow: true,
            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                style: {
                    gap: '2px',
                    width: '150px',
                    height: '69px',
                    backgroundColor: 'white',
                    borderRadius: '10px'
                },
                direction: "column",
                alignItems: "center",
                justify: "around",
                children: [
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '18px'
                        },
                        children: (0, $kSbwP.jsxs)("b", {
                            children: [
                                "Reports: ",
                                totalReports
                            ]
                        })
                    }),
                    (0, $kSbwP.jsx)("div", {
                        style: {
                            fontSize: '18px'
                        },
                        children: (0, $kSbwP.jsxs)("b", {
                            children: [
                                "Queue: ",
                                totalQueued
                            ]
                        })
                    })
                ]
            })
        });
    };
    return (0, $kSbwP.jsx)("div", {
        style: {
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '500px',
            height: '100px',
            zIndex: 50000
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            alignItems: "end",
            fillCell: true,
            style: {
                gap: '20px'
            },
            children: [
                makeReRunButtons('LAST JOB', getLastJobName),
                !isRoot && makeReRunButtons('CURRENT', getCurrentReportFilename),
                !isRoot && makeDeleteButton(getCurrentReport),
                makeReRunButtons('ALL', getAllFileame),
                makeStats(),
                makeClearJobQueue(),
                makePauseResumeJobs(),
                (0, $kSbwP.jsx)("input", {
                    type: "button",
                    value: "Export",
                    onClick: ()=>{
                        genAllCompaniesData();
                    }
                })
            ]
        })
    });
});


const $e640bef1966ab6d6$var$DealDBPage = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    (0, $8nGP5.useEffect)(()=>{
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('VIEW_PAGE_DB', {
            page: 'DealDBPage'
        });
    }, []);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: "d-flex justify-content-center",
            style: {
                height: '100%'
            },
            children: [
                (0, $kSbwP.jsx)((0, $c852cf41bf4911ee$export$e7b94983f4222b90), {}),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    className: "h-100 w-100",
                    children: [
                        (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                            disableTicker: true,
                            showNewDeal: true
                        }),
                        (0, $kSbwP.jsx)((0, $a283eceebd9e41ec$export$632b367007f30628), {})
                    ]
                })
            ]
        })
    });
});
var $e640bef1966ab6d6$export$2e2bcd8739ae039 = $e640bef1966ab6d6$var$DealDBPage;



var $kSbwP = parcelRequire("kSbwP");



var $kSbwP = parcelRequire("kSbwP");





const $1ac83566e6b5504b$export$ce7cfd4f28e6833 = (postfix)=>{
    return (data)=>{
        return (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(data.toString()) + postfix;
    };
};
const $1ac83566e6b5504b$export$40333d0facc9092d = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$48d3f001ea9fddb0)(data.toString());
};
const $1ac83566e6b5504b$export$32e6b1ae352e94d6 = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString());
};
const $1ac83566e6b5504b$export$23be700726d3a499 = (data)=>{
    if (!data && data !== 0) data = '';
    return (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString(), 1);
};
const $1ac83566e6b5504b$export$91991769c57c29a = (data)=>{
    if (!data) data = '';
    return data.toString();
};
const $1ac83566e6b5504b$export$8c8c9051f21dcdc2 = (data)=>{
    return data;
};



var $kSbwP = parcelRequire("kSbwP");
var $05cd79ec61a0a305$export$d13f5cc425f7d974;
var $05cd79ec61a0a305$export$40a9eeef55665a40;
var $05cd79ec61a0a305$export$8fe35dc8637e3206;
var $05cd79ec61a0a305$export$93b7586d956c930e;
var $05cd79ec61a0a305$export$9218fcc08fed1387;
var $05cd79ec61a0a305$export$4f9756682a863729;
var $05cd79ec61a0a305$export$736b6cf572925334;
var $05cd79ec61a0a305$export$f843afa9e9b53052;
var $05cd79ec61a0a305$export$417d8c6682ca6007;
var $05cd79ec61a0a305$export$a62276682e66b561;
var $05cd79ec61a0a305$export$91ebb600d7a82645;
var $05cd79ec61a0a305$export$ae78d338ad66ff90;
var $05cd79ec61a0a305$export$b8972b998723d602;
var $05cd79ec61a0a305$export$e63129c0d9da4beb;
$05cd79ec61a0a305$export$d13f5cc425f7d974 = `_8RP5ba_columnHeader`;
$05cd79ec61a0a305$export$40a9eeef55665a40 = `_8RP5ba_defaultPadding`;
$05cd79ec61a0a305$export$8fe35dc8637e3206 = `_8RP5ba_dollar`;
$05cd79ec61a0a305$export$93b7586d956c930e = `_8RP5ba_dropShadow`;
$05cd79ec61a0a305$export$9218fcc08fed1387 = `_8RP5ba_editHandIcon`;
$05cd79ec61a0a305$export$4f9756682a863729 = `_8RP5ba_editable`;
$05cd79ec61a0a305$export$736b6cf572925334 = `_8RP5ba_modified_data`;
$05cd79ec61a0a305$export$f843afa9e9b53052 = `_8RP5ba_panelImage`;
$05cd79ec61a0a305$export$417d8c6682ca6007 = `_8RP5ba_rowLabel`;
$05cd79ec61a0a305$export$a62276682e66b561 = `_8RP5ba_rowValue`;
$05cd79ec61a0a305$export$91ebb600d7a82645 = `_8RP5ba_rowValueBoolean`;
$05cd79ec61a0a305$export$ae78d338ad66ff90 = `_8RP5ba_scaleInOut`;
$05cd79ec61a0a305$export$b8972b998723d602 = `_8RP5ba_shadow`;
$05cd79ec61a0a305$export$e63129c0d9da4beb = `_8RP5ba_source_page_entry`;



class $d121fd2a7a5df6ff$export$3d23a8262daf519 {
    static label(field) {
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "start",
            className: $05cd79ec61a0a305$export$417d8c6682ca6007,
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "title",
                    children: field.display
                }),
                field.description && (0, $kSbwP.jsx)("div", {
                    className: "desc",
                    children: field.description
                })
            ]
        });
    }
    static percent_label(field) {
        return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "start",
            className: $05cd79ec61a0a305$export$417d8c6682ca6007,
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: "title",
                    children: (0, $kSbwP.jsx)("i", {
                        children: field.display
                    })
                }),
                field.description && (0, $kSbwP.jsx)("div", {
                    className: "desc",
                    children: field.description
                })
            ]
        });
    }
}



var $kSbwP = parcelRequire("kSbwP");




var $cd924d034215795d$exports = {};
$cd924d034215795d$exports = new URL("hand-edit-icon.0cb414cb.svg", import.meta.url).toString();





var $kSbwP = parcelRequire("kSbwP");
const $8421c2e6c1303cf8$export$1f54913ccc4368b1 = (props)=>{
    const align = props.alignItems || 'center';
    const justify = props.justifyContent || 'center';
    const cls = props.className || '';
    const style = props.style || {};
    return (0, $kSbwP.jsx)("div", {
        className: cls,
        style: Object.assign({
            display: 'flex',
            position: 'relative',
            alignItems: align,
            justifyContent: justify
        }, style),
        onClick: ()=>{
            props.onClick && props.onClick();
        },
        onDoubleClick: ()=>{
            props.onDoubleClick && props.onDoubleClick();
        },
        children: props.children
    });
};


let $7d2817d1c3724d77$var$removeClassTimeout = null;
class $7d2817d1c3724d77$export$2fae71e1297dd07b {
    static sources(row, col, data) {
        //Pencil edit icon
        const pencilEditIcon = (0, $kSbwP.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cd924d034215795d$exports))),
            alt: "edit",
            className: $05cd79ec61a0a305$export$e63129c0d9da4beb + ' ' + $05cd79ec61a0a305$export$9218fcc08fed1387,
            onClick: ()=>{
                function removeRule() {
                    const stylesheet = document.styleSheets[0];
                    for(let i = 0; i < stylesheet.cssRules.length; i++)if (stylesheet.cssRules[i].selectorText === '.modified_js_tweaked') {
                        stylesheet.deleteRule(i);
                        break; // Stop after deleting
                    }
                }
                removeRule();
                setTimeout(()=>{
                    const stylesheet = document.styleSheets[0];
                    stylesheet.insertRule('.modified_js_tweaked {     animation: colorEditedFieldsAnimation 1s 1; animation-timing-function: ease-in-out; }', stylesheet.cssRules.length);
                }, 10);
                if ($7d2817d1c3724d77$var$removeClassTimeout) clearTimeout($7d2817d1c3724d77$var$removeClassTimeout);
                $7d2817d1c3724d77$var$removeClassTimeout = setTimeout(()=>{
                    removeRule();
                }, 10000);
            }
        }, "hand_icon");
        if (row.dontShowSources) data = [];
        const items = [];
        if (!Array.isArray(data)) data = [];
        if (row.editable) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedAtAll(row.field.source) || q.isValueEditedAtAll(row.field.source + '_page_source')) items.push(pencilEditIcon);
        }
        data.map((page, index)=>{
            items.push((0, $kSbwP.jsx)("div", {
                className: $05cd79ec61a0a305$export$e63129c0d9da4beb,
                onClick: ()=>{
                    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                    uiStore.requestPdfImagePage(page);
                },
                children: (0, $kSbwP.jsx)((0, $8421c2e6c1303cf8$export$1f54913ccc4368b1), {
                    children: page
                })
            }, page));
        });
        var isModified = false;
        if (row.editable) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedAtAll(row.field.source + '_page_source')) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified
        });
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "start",
            alignItems: "center",
            className: containerClasses,
            style: {
                minWidth: 100
            },
            wrap: "wrap",
            children: items
        });
    }
    static button(display, onClick, data = null, isEnabled = true) {
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            'fade-in': isEnabled
        });
        return (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
            variant: "light",
            onClick: ()=>onClick(data),
            style: {
                width: '70px',
                opacity: 0
            },
            className: cls,
            disabled: !isEnabled,
            children: display
        });
    }
    static percent(row, col, data) {
        var isModified = false;
        if (row.editable) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedByRowCol(row, col)) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified
        });
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561, {
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified
        });
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "center",
            alignItems: "center",
            className: containerClasses,
            children: (0, $kSbwP.jsx)("div", {
                className: valueClasses,
                children: (0, $kSbwP.jsx)("i", {
                    children: data.toString()
                })
            })
        });
    }
    static score(row, col, data) {
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            justify: 'center',
            children: (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                score: data
            })
        });
    }
    static dollar(row, col, data) {
        return $7d2817d1c3724d77$export$2fae71e1297dd07b.value(row, col, data /* , style.dollar */ );
    }
    static value(row, col, data, className) {
        var isModified = false;
        if (row.editable) {
            var q = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
            if (q.isValueEditedByRowCol(row, col)) isModified = true;
        }
        const containerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))({
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable,
            [$05cd79ec61a0a305$export$736b6cf572925334]: isModified,
            ['modified_js_tweaked']: isModified,
            [className || '']: className !== undefined
        });
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561, {
            [$05cd79ec61a0a305$export$4f9756682a863729]: row.editable
        });
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            className: containerClasses,
            children: (0, $kSbwP.jsx)("div", {
                className: valueClasses,
                children: data.toString()
            })
        });
    }
    static custom(render) {
        const valueClasses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($05cd79ec61a0a305$export$a62276682e66b561);
        return (row, col, data)=>{
            return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                fillCell: true,
                alignItems: "center",
                className: valueClasses,
                children: render(row, col, data)
            });
        };
    }
    static icon(row, col, data) {
        return (0, $kSbwP.jsx)("div", {
            children: " PDF "
        });
    }
    static booleanCentered(row, col, data, centerIcon = false) {
        return $7d2817d1c3724d77$export$2fae71e1297dd07b.boolean(row, col, data, true);
    }
    static boolean(row, col, data, centerIcon = false) {
        const yes = (0, $kSbwP.jsx)("i", {
            className: "bi bi-check"
        });
        const no = (0, $kSbwP.jsx)("i", {
            className: "bi bi-x"
        });
        const unsure = (0, $kSbwP.jsx)("i", {
            className: "bi bi-question"
        });
        const icon = data === true || data === 1 ? yes : data === false ? no : unsure;
        return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            alignItems: "center",
            justify: centerIcon ? 'center' : 'start',
            children: (0, $kSbwP.jsx)("div", {
                className: $05cd79ec61a0a305$export$91ebb600d7a82645,
                children: icon
            })
        });
    }
}



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");

var $cbaa28af8904e717$export$23e48554307a3492;
var $cbaa28af8904e717$export$9579a76b7b70a45f;
$cbaa28af8904e717$export$23e48554307a3492 = `fejckW_editIndustry`;
$cbaa28af8904e717$export$9579a76b7b70a45f = `fejckW_typeahead-industry-edit`;




const $68d2907db623a0aa$var$TextBoxEditor = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    return (0, $kSbwP.jsx)("input", {
        autoFocus: true,
        type: "text",
        value: p.val.editCellValue,
        style: {
            width: '100%'
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter') {
                const newValue = e.target.value;
                p.val.editCellValue = newValue;
                p.onEdit(newValue, true);
            }
        },
        onInput: (e)=>{
            const newValue = e.target.value;
            p.val.editCellValue = newValue;
        }
    });
});
const $68d2907db623a0aa$var$IndustryEditor = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const options = (0, (/*@__PURE__*/$parcel$interopDefault($80541c05916033ee$exports))).map((industry)=>{
        var name = industry.name;
        return {
            label: name,
            value: name,
            industry: name
        };
    });
    return (0, $kSbwP.jsx)((0, $64acedd27c21146a$export$2e2bcd8739ae039), {
        className: $cbaa28af8904e717$export$23e48554307a3492,
        dropup: true,
        id: "typeahead-industry-edit",
        labelKey: "label",
        positionFixed: true,
        onChange: (selected)=>{
            if (selected.length > 0) p.onEdit(selected[0]['value'], true);
        },
        options: options,
        placeholder: p.val.editCellValue,
        open: true
    });
});
const $68d2907db623a0aa$var$SubIndustryEditor = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const industryValue = p.val.dealData['industry'];
    const subIndustry = (0, (/*@__PURE__*/$parcel$interopDefault($80541c05916033ee$exports))).find((industry)=>industry.name == industryValue).subtypes;
    const options = subIndustry.map((industry)=>{
        var name = industry.name;
        return {
            label: name,
            value: name,
            industry: name
        };
    });
    return (0, $kSbwP.jsx)((0, $64acedd27c21146a$export$2e2bcd8739ae039), {
        className: $cbaa28af8904e717$export$23e48554307a3492,
        dropup: true,
        id: "typeahead-industry-edit",
        labelKey: "label",
        positionFixed: true,
        onChange: (selected)=>{
            if (selected.length > 0) p.onEdit(selected[0]['value'], true);
        },
        options: options,
        placeholder: p.val.editCellValue,
        open: true
    });
});
class $68d2907db623a0aa$export$44b5115104b4b812 {
}
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "textbox", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$TextBoxEditor, Object.assign({}, api));
    }
});
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "industry", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$IndustryEditor, Object.assign({}, api));
    }
});
Object.defineProperty($68d2907db623a0aa$export$44b5115104b4b812, "subIndustry", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (api)=>{
        return (0, $kSbwP.jsx)($68d2907db623a0aa$var$SubIndustryEditor, Object.assign({}, api));
    }
});




var $T5IcR = parcelRequire("T5IcR");

var $8nGP5 = parcelRequire("8nGP5");
var $0a90de210c8d2546$exports = {};

$parcel$export($0a90de210c8d2546$exports, "defaultPadding", function () { return $0a90de210c8d2546$export$40a9eeef55665a40; }, function (v) { return $0a90de210c8d2546$export$40a9eeef55665a40 = v; });
$parcel$export($0a90de210c8d2546$exports, "disable_round_edges", function () { return $0a90de210c8d2546$export$486b53607e7afa2e; }, function (v) { return $0a90de210c8d2546$export$486b53607e7afa2e = v; });
$parcel$export($0a90de210c8d2546$exports, "dropShadow", function () { return $0a90de210c8d2546$export$93b7586d956c930e; }, function (v) { return $0a90de210c8d2546$export$93b7586d956c930e = v; });
$parcel$export($0a90de210c8d2546$exports, "gridContainer", function () { return $0a90de210c8d2546$export$711e2b273dbb00ac; }, function (v) { return $0a90de210c8d2546$export$711e2b273dbb00ac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_1", function () { return $0a90de210c8d2546$export$e894550936196378; }, function (v) { return $0a90de210c8d2546$export$e894550936196378 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_10", function () { return $0a90de210c8d2546$export$76d0c5c9f1bcd33; }, function (v) { return $0a90de210c8d2546$export$76d0c5c9f1bcd33 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_11", function () { return $0a90de210c8d2546$export$9e6e44a433024d6d; }, function (v) { return $0a90de210c8d2546$export$9e6e44a433024d6d = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_12", function () { return $0a90de210c8d2546$export$69b0a233bc8d9471; }, function (v) { return $0a90de210c8d2546$export$69b0a233bc8d9471 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_13", function () { return $0a90de210c8d2546$export$b0b08b4cb457fb4b; }, function (v) { return $0a90de210c8d2546$export$b0b08b4cb457fb4b = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_14", function () { return $0a90de210c8d2546$export$8b7a67e609fa7876; }, function (v) { return $0a90de210c8d2546$export$8b7a67e609fa7876 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_15", function () { return $0a90de210c8d2546$export$8f32fb792fd5de35; }, function (v) { return $0a90de210c8d2546$export$8f32fb792fd5de35 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_16", function () { return $0a90de210c8d2546$export$1a6f885bbce36133; }, function (v) { return $0a90de210c8d2546$export$1a6f885bbce36133 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_17", function () { return $0a90de210c8d2546$export$ad03ba2e139bc2ee; }, function (v) { return $0a90de210c8d2546$export$ad03ba2e139bc2ee = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_18", function () { return $0a90de210c8d2546$export$3eecb192f21c7b5c; }, function (v) { return $0a90de210c8d2546$export$3eecb192f21c7b5c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_19", function () { return $0a90de210c8d2546$export$29b2c50d1c249b17; }, function (v) { return $0a90de210c8d2546$export$29b2c50d1c249b17 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_2", function () { return $0a90de210c8d2546$export$8662788fffc45d3d; }, function (v) { return $0a90de210c8d2546$export$8662788fffc45d3d = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_20", function () { return $0a90de210c8d2546$export$7321992e2bb5e119; }, function (v) { return $0a90de210c8d2546$export$7321992e2bb5e119 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_3", function () { return $0a90de210c8d2546$export$cf04fc74071f77de; }, function (v) { return $0a90de210c8d2546$export$cf04fc74071f77de = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_4", function () { return $0a90de210c8d2546$export$5196ecb7b39dfed7; }, function (v) { return $0a90de210c8d2546$export$5196ecb7b39dfed7 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_5", function () { return $0a90de210c8d2546$export$41b3ffe2771e76cf; }, function (v) { return $0a90de210c8d2546$export$41b3ffe2771e76cf = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_6", function () { return $0a90de210c8d2546$export$7e320dd60220241b; }, function (v) { return $0a90de210c8d2546$export$7e320dd60220241b = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_7", function () { return $0a90de210c8d2546$export$c6e650e8135abfab; }, function (v) { return $0a90de210c8d2546$export$c6e650e8135abfab = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_8", function () { return $0a90de210c8d2546$export$4175ce7efd6e9ec1; }, function (v) { return $0a90de210c8d2546$export$4175ce7efd6e9ec1 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_9", function () { return $0a90de210c8d2546$export$57c61f2397272657; }, function (v) { return $0a90de210c8d2546$export$57c61f2397272657 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_end", function () { return $0a90de210c8d2546$export$e85318e035c52c7c; }, function (v) { return $0a90de210c8d2546$export$e85318e035c52c7c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_col_start", function () { return $0a90de210c8d2546$export$ff6a8ffa07d93f02; }, function (v) { return $0a90de210c8d2546$export$ff6a8ffa07d93f02 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_item", function () { return $0a90de210c8d2546$export$c358ddc4badb7c84; }, function (v) { return $0a90de210c8d2546$export$c358ddc4badb7c84 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_1", function () { return $0a90de210c8d2546$export$73071494e5833cb; }, function (v) { return $0a90de210c8d2546$export$73071494e5833cb = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_10", function () { return $0a90de210c8d2546$export$f87cbfa5083ffea1; }, function (v) { return $0a90de210c8d2546$export$f87cbfa5083ffea1 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_11", function () { return $0a90de210c8d2546$export$b8a875b3bf2b6497; }, function (v) { return $0a90de210c8d2546$export$b8a875b3bf2b6497 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_12", function () { return $0a90de210c8d2546$export$aae58836b4de9cac; }, function (v) { return $0a90de210c8d2546$export$aae58836b4de9cac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_13", function () { return $0a90de210c8d2546$export$57b78e3d40e397e4; }, function (v) { return $0a90de210c8d2546$export$57b78e3d40e397e4 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_14", function () { return $0a90de210c8d2546$export$bff6ba74fefffa10; }, function (v) { return $0a90de210c8d2546$export$bff6ba74fefffa10 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_15", function () { return $0a90de210c8d2546$export$8c72aec5d3e76045; }, function (v) { return $0a90de210c8d2546$export$8c72aec5d3e76045 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_16", function () { return $0a90de210c8d2546$export$7b344b17e6ef98ac; }, function (v) { return $0a90de210c8d2546$export$7b344b17e6ef98ac = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_17", function () { return $0a90de210c8d2546$export$39347543b3ff02df; }, function (v) { return $0a90de210c8d2546$export$39347543b3ff02df = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_18", function () { return $0a90de210c8d2546$export$df6733bcdadf6242; }, function (v) { return $0a90de210c8d2546$export$df6733bcdadf6242 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_19", function () { return $0a90de210c8d2546$export$992d889614beca52; }, function (v) { return $0a90de210c8d2546$export$992d889614beca52 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_2", function () { return $0a90de210c8d2546$export$2a10cd6da3d1bdae; }, function (v) { return $0a90de210c8d2546$export$2a10cd6da3d1bdae = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_20", function () { return $0a90de210c8d2546$export$b2e47302835cde6c; }, function (v) { return $0a90de210c8d2546$export$b2e47302835cde6c = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_3", function () { return $0a90de210c8d2546$export$8a5c95d5a153e064; }, function (v) { return $0a90de210c8d2546$export$8a5c95d5a153e064 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_4", function () { return $0a90de210c8d2546$export$88648ed041c8c49e; }, function (v) { return $0a90de210c8d2546$export$88648ed041c8c49e = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_5", function () { return $0a90de210c8d2546$export$405e84483889de82; }, function (v) { return $0a90de210c8d2546$export$405e84483889de82 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_6", function () { return $0a90de210c8d2546$export$442feee28a216471; }, function (v) { return $0a90de210c8d2546$export$442feee28a216471 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_7", function () { return $0a90de210c8d2546$export$d0e7718a69538409; }, function (v) { return $0a90de210c8d2546$export$d0e7718a69538409 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_8", function () { return $0a90de210c8d2546$export$edd4044cdf20e596; }, function (v) { return $0a90de210c8d2546$export$edd4044cdf20e596 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_9", function () { return $0a90de210c8d2546$export$efd9ca471bfe7c58; }, function (v) { return $0a90de210c8d2546$export$efd9ca471bfe7c58 = v; });
$parcel$export($0a90de210c8d2546$exports, "grid_row_last", function () { return $0a90de210c8d2546$export$3d53354eb0909d0f; }, function (v) { return $0a90de210c8d2546$export$3d53354eb0909d0f = v; });
$parcel$export($0a90de210c8d2546$exports, "headerRow", function () { return $0a90de210c8d2546$export$faed4863136ce212; }, function (v) { return $0a90de210c8d2546$export$faed4863136ce212 = v; });
$parcel$export($0a90de210c8d2546$exports, "panelImage", function () { return $0a90de210c8d2546$export$f843afa9e9b53052; }, function (v) { return $0a90de210c8d2546$export$f843afa9e9b53052 = v; });
$parcel$export($0a90de210c8d2546$exports, "scaleInOut", function () { return $0a90de210c8d2546$export$ae78d338ad66ff90; }, function (v) { return $0a90de210c8d2546$export$ae78d338ad66ff90 = v; });
$parcel$export($0a90de210c8d2546$exports, "shadow", function () { return $0a90de210c8d2546$export$b8972b998723d602; }, function (v) { return $0a90de210c8d2546$export$b8972b998723d602 = v; });
var $0a90de210c8d2546$export$40a9eeef55665a40;
var $0a90de210c8d2546$export$486b53607e7afa2e;
var $0a90de210c8d2546$export$93b7586d956c930e;
var $0a90de210c8d2546$export$711e2b273dbb00ac;
var $0a90de210c8d2546$export$e894550936196378;
var $0a90de210c8d2546$export$76d0c5c9f1bcd33;
var $0a90de210c8d2546$export$9e6e44a433024d6d;
var $0a90de210c8d2546$export$69b0a233bc8d9471;
var $0a90de210c8d2546$export$b0b08b4cb457fb4b;
var $0a90de210c8d2546$export$8b7a67e609fa7876;
var $0a90de210c8d2546$export$8f32fb792fd5de35;
var $0a90de210c8d2546$export$1a6f885bbce36133;
var $0a90de210c8d2546$export$ad03ba2e139bc2ee;
var $0a90de210c8d2546$export$3eecb192f21c7b5c;
var $0a90de210c8d2546$export$29b2c50d1c249b17;
var $0a90de210c8d2546$export$8662788fffc45d3d;
var $0a90de210c8d2546$export$7321992e2bb5e119;
var $0a90de210c8d2546$export$cf04fc74071f77de;
var $0a90de210c8d2546$export$5196ecb7b39dfed7;
var $0a90de210c8d2546$export$41b3ffe2771e76cf;
var $0a90de210c8d2546$export$7e320dd60220241b;
var $0a90de210c8d2546$export$c6e650e8135abfab;
var $0a90de210c8d2546$export$4175ce7efd6e9ec1;
var $0a90de210c8d2546$export$57c61f2397272657;
var $0a90de210c8d2546$export$e85318e035c52c7c;
var $0a90de210c8d2546$export$ff6a8ffa07d93f02;
var $0a90de210c8d2546$export$c358ddc4badb7c84;
var $0a90de210c8d2546$export$73071494e5833cb;
var $0a90de210c8d2546$export$f87cbfa5083ffea1;
var $0a90de210c8d2546$export$b8a875b3bf2b6497;
var $0a90de210c8d2546$export$aae58836b4de9cac;
var $0a90de210c8d2546$export$57b78e3d40e397e4;
var $0a90de210c8d2546$export$bff6ba74fefffa10;
var $0a90de210c8d2546$export$8c72aec5d3e76045;
var $0a90de210c8d2546$export$7b344b17e6ef98ac;
var $0a90de210c8d2546$export$39347543b3ff02df;
var $0a90de210c8d2546$export$df6733bcdadf6242;
var $0a90de210c8d2546$export$992d889614beca52;
var $0a90de210c8d2546$export$2a10cd6da3d1bdae;
var $0a90de210c8d2546$export$b2e47302835cde6c;
var $0a90de210c8d2546$export$8a5c95d5a153e064;
var $0a90de210c8d2546$export$88648ed041c8c49e;
var $0a90de210c8d2546$export$405e84483889de82;
var $0a90de210c8d2546$export$442feee28a216471;
var $0a90de210c8d2546$export$d0e7718a69538409;
var $0a90de210c8d2546$export$edd4044cdf20e596;
var $0a90de210c8d2546$export$efd9ca471bfe7c58;
var $0a90de210c8d2546$export$3d53354eb0909d0f;
var $0a90de210c8d2546$export$faed4863136ce212;
var $0a90de210c8d2546$export$f843afa9e9b53052;
var $0a90de210c8d2546$export$ae78d338ad66ff90;
var $0a90de210c8d2546$export$b8972b998723d602;
$0a90de210c8d2546$export$40a9eeef55665a40 = `SEVMuW_defaultPadding`;
$0a90de210c8d2546$export$486b53607e7afa2e = `SEVMuW_disable_round_edges`;
$0a90de210c8d2546$export$93b7586d956c930e = `SEVMuW_dropShadow`;
$0a90de210c8d2546$export$711e2b273dbb00ac = `SEVMuW_gridContainer`;
$0a90de210c8d2546$export$e894550936196378 = `SEVMuW_grid_col_1`;
$0a90de210c8d2546$export$76d0c5c9f1bcd33 = `SEVMuW_grid_col_10`;
$0a90de210c8d2546$export$9e6e44a433024d6d = `SEVMuW_grid_col_11`;
$0a90de210c8d2546$export$69b0a233bc8d9471 = `SEVMuW_grid_col_12`;
$0a90de210c8d2546$export$b0b08b4cb457fb4b = `SEVMuW_grid_col_13`;
$0a90de210c8d2546$export$8b7a67e609fa7876 = `SEVMuW_grid_col_14`;
$0a90de210c8d2546$export$8f32fb792fd5de35 = `SEVMuW_grid_col_15`;
$0a90de210c8d2546$export$1a6f885bbce36133 = `SEVMuW_grid_col_16`;
$0a90de210c8d2546$export$ad03ba2e139bc2ee = `SEVMuW_grid_col_17`;
$0a90de210c8d2546$export$3eecb192f21c7b5c = `SEVMuW_grid_col_18`;
$0a90de210c8d2546$export$29b2c50d1c249b17 = `SEVMuW_grid_col_19`;
$0a90de210c8d2546$export$8662788fffc45d3d = `SEVMuW_grid_col_2`;
$0a90de210c8d2546$export$7321992e2bb5e119 = `SEVMuW_grid_col_20`;
$0a90de210c8d2546$export$cf04fc74071f77de = `SEVMuW_grid_col_3`;
$0a90de210c8d2546$export$5196ecb7b39dfed7 = `SEVMuW_grid_col_4`;
$0a90de210c8d2546$export$41b3ffe2771e76cf = `SEVMuW_grid_col_5`;
$0a90de210c8d2546$export$7e320dd60220241b = `SEVMuW_grid_col_6`;
$0a90de210c8d2546$export$c6e650e8135abfab = `SEVMuW_grid_col_7`;
$0a90de210c8d2546$export$4175ce7efd6e9ec1 = `SEVMuW_grid_col_8`;
$0a90de210c8d2546$export$57c61f2397272657 = `SEVMuW_grid_col_9`;
$0a90de210c8d2546$export$e85318e035c52c7c = `SEVMuW_grid_col_end`;
$0a90de210c8d2546$export$ff6a8ffa07d93f02 = `SEVMuW_grid_col_start`;
$0a90de210c8d2546$export$c358ddc4badb7c84 = `SEVMuW_grid_item`;
$0a90de210c8d2546$export$73071494e5833cb = `SEVMuW_grid_row_1`;
$0a90de210c8d2546$export$f87cbfa5083ffea1 = `SEVMuW_grid_row_10`;
$0a90de210c8d2546$export$b8a875b3bf2b6497 = `SEVMuW_grid_row_11`;
$0a90de210c8d2546$export$aae58836b4de9cac = `SEVMuW_grid_row_12`;
$0a90de210c8d2546$export$57b78e3d40e397e4 = `SEVMuW_grid_row_13`;
$0a90de210c8d2546$export$bff6ba74fefffa10 = `SEVMuW_grid_row_14`;
$0a90de210c8d2546$export$8c72aec5d3e76045 = `SEVMuW_grid_row_15`;
$0a90de210c8d2546$export$7b344b17e6ef98ac = `SEVMuW_grid_row_16`;
$0a90de210c8d2546$export$39347543b3ff02df = `SEVMuW_grid_row_17`;
$0a90de210c8d2546$export$df6733bcdadf6242 = `SEVMuW_grid_row_18`;
$0a90de210c8d2546$export$992d889614beca52 = `SEVMuW_grid_row_19`;
$0a90de210c8d2546$export$2a10cd6da3d1bdae = `SEVMuW_grid_row_2`;
$0a90de210c8d2546$export$b2e47302835cde6c = `SEVMuW_grid_row_20`;
$0a90de210c8d2546$export$8a5c95d5a153e064 = `SEVMuW_grid_row_3`;
$0a90de210c8d2546$export$88648ed041c8c49e = `SEVMuW_grid_row_4`;
$0a90de210c8d2546$export$405e84483889de82 = `SEVMuW_grid_row_5`;
$0a90de210c8d2546$export$442feee28a216471 = `SEVMuW_grid_row_6`;
$0a90de210c8d2546$export$d0e7718a69538409 = `SEVMuW_grid_row_7`;
$0a90de210c8d2546$export$edd4044cdf20e596 = `SEVMuW_grid_row_8`;
$0a90de210c8d2546$export$efd9ca471bfe7c58 = `SEVMuW_grid_row_9`;
$0a90de210c8d2546$export$3d53354eb0909d0f = `SEVMuW_grid_row_last`;
$0a90de210c8d2546$export$faed4863136ce212 = `SEVMuW_headerRow`;
$0a90de210c8d2546$export$f843afa9e9b53052 = `SEVMuW_panelImage`;
$0a90de210c8d2546$export$ae78d338ad66ff90 = `SEVMuW_scaleInOut`;
$0a90de210c8d2546$export$b8972b998723d602 = `SEVMuW_shadow`;



var $58be81631dcdd257$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $58be81631dcdd257$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $58be81631dcdd257$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $58be81631dcdd257$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $58be81631dcdd257$export$db6c4f5cbda21d5d = (()=>{
    var _a, _EditTableStore_dealData_accessor_storage, _EditTableStore_editCellValue_accessor_storage, _EditTableStore_editCellId_accessor_storage;
    let _dealData_decorators;
    let _dealData_initializers = [];
    let _dealData_extraInitializers = [];
    let _editCellValue_decorators;
    let _editCellValue_initializers = [];
    let _editCellValue_extraInitializers = [];
    let _editCellId_decorators;
    let _editCellId_initializers = [];
    let _editCellId_extraInitializers = [];
    return _a = class EditTableStore {
        get dealData() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_dealData_accessor_storage, "f");
        }
        set dealData(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_dealData_accessor_storage, value, "f");
        }
        get editCellValue() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_editCellValue_accessor_storage, "f");
        }
        set editCellValue(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_editCellValue_accessor_storage, value, "f");
        }
        get editCellId() {
            return $58be81631dcdd257$var$__classPrivateFieldGet(this, _EditTableStore_editCellId_accessor_storage, "f");
        }
        set editCellId(value) {
            $58be81631dcdd257$var$__classPrivateFieldSet(this, _EditTableStore_editCellId_accessor_storage, value, "f");
        }
        constructor(){
            _EditTableStore_dealData_accessor_storage.set(this, $58be81631dcdd257$var$__runInitializers(this, _dealData_initializers, null));
            _EditTableStore_editCellValue_accessor_storage.set(this, ($58be81631dcdd257$var$__runInitializers(this, _dealData_extraInitializers), $58be81631dcdd257$var$__runInitializers(this, _editCellValue_initializers, null)));
            _EditTableStore_editCellId_accessor_storage.set(this, ($58be81631dcdd257$var$__runInitializers(this, _editCellValue_extraInitializers), $58be81631dcdd257$var$__runInitializers(this, _editCellId_initializers, null)));
            $58be81631dcdd257$var$__runInitializers(this, _editCellId_extraInitializers);
        }
    }, _EditTableStore_dealData_accessor_storage = new WeakMap(), _EditTableStore_editCellValue_accessor_storage = new WeakMap(), _EditTableStore_editCellId_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _dealData_decorators = [
            (0, $T5IcR.observable)
        ];
        _editCellValue_decorators = [
            (0, $T5IcR.observable)
        ];
        _editCellId_decorators = [
            (0, $T5IcR.observable)
        ];
        $58be81631dcdd257$var$__esDecorate(_a, null, _dealData_decorators, {
            kind: "accessor",
            name: "dealData",
            static: false,
            private: false,
            access: {
                has: (obj)=>"dealData" in obj,
                get: (obj)=>obj.dealData,
                set: (obj, value)=>{
                    obj.dealData = value;
                }
            },
            metadata: _metadata
        }, _dealData_initializers, _dealData_extraInitializers);
        $58be81631dcdd257$var$__esDecorate(_a, null, _editCellValue_decorators, {
            kind: "accessor",
            name: "editCellValue",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editCellValue" in obj,
                get: (obj)=>obj.editCellValue,
                set: (obj, value)=>{
                    obj.editCellValue = value;
                }
            },
            metadata: _metadata
        }, _editCellValue_initializers, _editCellValue_extraInitializers);
        $58be81631dcdd257$var$__esDecorate(_a, null, _editCellId_decorators, {
            kind: "accessor",
            name: "editCellId",
            static: false,
            private: false,
            access: {
                has: (obj)=>"editCellId" in obj,
                get: (obj)=>obj.editCellId,
                set: (obj, value)=>{
                    obj.editCellId = value;
                }
            },
            metadata: _metadata
        }, _editCellId_initializers, _editCellId_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $58be81631dcdd257$export$5dd4673b7f9fa87b = (props)=>{
    const [editValueStore] = (0, $8nGP5.useState)(new $58be81631dcdd257$export$db6c4f5cbda21d5d());
    const [editCellRefresh, setEditCellRefreshUI] = (0, $8nGP5.useState)(null);
    const skipHeadeRow = props.noHeaderRow === true;
    const skipRowLabel = props.skipLabelInRow === true;
    function onKeyDown(e) {
        if (editValueStore.editCellId == null) return;
        if (e.key === 'Tab' || e.key == 'ArrowUp' || e.key == 'ArrowDown') {
            e.preventDefault();
            saveCurrentEdit();
            const columnsInRow = props.columns.length;
            const editCellId = editValueStore.editCellId;
            var nextColumnIndex = editCellId.colIndex;
            var nextRowIndex = editCellId.rowIndex;
            if (e.shiftKey) {
                nextColumnIndex -= 1;
                if (nextColumnIndex < 0) nextColumnIndex = 0;
            } else if (e.key == 'ArrowUp') for(let i = 0; i < rows.length; i++){
                nextRowIndex -= 1;
                if (nextRowIndex <= -1) return;
                if (props.rows[nextRowIndex].editable) break;
            }
            else if (e.key == 'ArrowDown') for(let i = 0; i < rows.length; i++){
                nextRowIndex += 1;
                if (nextRowIndex >= props.rows.length) return;
                if (props.rows[nextRowIndex].editable) break;
            }
            else if (e.key == 'Tab') {
                nextColumnIndex += 1;
                if (nextColumnIndex >= columnsInRow) nextColumnIndex -= 1;
            } else if (e.key == 'Enter') setCellEditMode(null);
            var newRow = props.rows[nextRowIndex];
            var newCol = props.columns[nextColumnIndex];
            setCellEditMode({
                row: newRow,
                col: newCol,
                rowIndex: nextRowIndex,
                colIndex: nextColumnIndex
            });
        } else if (e.key === 'Escape') setCellEditMode(null);
        else if (e.key === 'Delete') {
            const editCellId = editValueStore.editCellId;
            props.onEditField(editCellId.row, editCellId.col, null);
            setCellEditMode(null);
        }
    }
    (0, $8nGP5.useEffect)(()=>{
        document.addEventListener('keydown', onKeyDown);
        return ()=>{
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [
        editValueStore.editCellId,
        editValueStore.editCellValue
    ]);
    const setCellEditMode = (cellId)=>{
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        editValueStore.editCellId = cellId;
        setEditCellRefreshUI(editValueStore.editCellId);
        if (cellId == null) {
            setValueForEditCell('SHOULD_NOT_SEE');
            return;
        }
        editValueStore.dealData = (0, $T5IcR.toJS)(store.query.activeReport);
        const valFn = cellId.col.overrideValue || cellId.row.value;
        let newEditValue = valFn(cellId.row.field, cellId.col.column);
        setValueForEditCell(newEditValue);
    };
    const saveCurrentEdit = ()=>{
        const val = editValueStore.editCellValue;
        const editCellId = editValueStore.editCellId;
        if (props.onEditField) props.onEditField(editCellId.row, editCellId.col, val);
    };
    const setValueForEditCell = (value)=>{
        if (value.toString() == 'NaN' || value.toString() == 'N\\A' || value.toString() == 'N/A') value = '';
        editValueStore.editCellValue = value;
    };
    const disableRoundEdges = props.disable_round_edges === true;
    const elementsToGridRow = (row, rowData, elements, classesToAdd = [], rowPosition = 'none')=>{
        return elements.map((el, index)=>{
            var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($0a90de210c8d2546$exports.grid_item, $0a90de210c8d2546$exports[`grid_row_${row}`], $0a90de210c8d2546$exports[`grid_col_${index + 1}`], `grid_row_${row}`, `grid_col_${index + 1}`, {
                even_row: row % 2 === 0
            }, {
                odd_row: row % 2 === 1
            }, ...classesToAdd, {
                [$0a90de210c8d2546$exports.grid_col_start]: index === 0
            }, {
                [$0a90de210c8d2546$exports.grid_col_end]: index === elements.length - 1
            }, {
                [$0a90de210c8d2546$exports.grid_row_first]: rowPosition === 'start'
            }, {
                [$0a90de210c8d2546$exports.grid_row_last]: rowPosition === 'end'
            }, {
                [$0a90de210c8d2546$exports.disable_round_edges]: disableRoundEdges
            });
            return (0, $kSbwP.jsx)("div", {
                className: cls,
                onClick: ()=>{
                    if (rowData && rowData.onClick && !rowData.editable) rowData.onClick(rowData);
                },
                children: el
            }, 'Row_' + row + '_' + index);
        });
    };
    const rows = [];
    if (!skipHeadeRow) {
        const headerLabels = [
            (0, $kSbwP.jsx)("div", {
                children: props.topLeftCellText
            }),
            ...props.columns.map((col)=>{
                const el = col.header ? col.header(col) : (0, $kSbwP.jsx)("div", {
                    children: col.column.display
                });
                return (0, $kSbwP.jsx)("div", {
                    children: el
                }, col.column.source);
            })
        ];
        rows.push(elementsToGridRow(1, null, headerLabels, [
            $0a90de210c8d2546$exports.headerRow
        ]));
    }
    props.rows.forEach((row, rowIndex)=>{
        if (row.skipRow) return;
        const newRow = [];
        if (!skipRowLabel) newRow.push(row.label ? row.label(row.field) : row.field.display);
        props.columns.forEach((col, colIndex)=>{
            var _a, _b;
            const isRowEditable = row.editable;
            const columnsInRow = props.columns.length;
            const cellId = {
                row: row,
                col: col,
                rowIndex: rowIndex,
                colIndex: colIndex
            };
            const editCellId = editValueStore.editCellId;
            const editMode = editCellId && editCellId.rowIndex == rowIndex && editCellId.colIndex == colIndex;
            let val = '-';
            let val_noformatting = '-';
            const valFn = col.overrideValue || row.value;
            try {
                val = valFn(row.field, col.column);
                val_noformatting = val;
                if (!editMode) {
                    if (col.overrideFormatting) val = col.overrideFormatting(val);
                    else if (row.formatter && col.dontUseRowFormatting !== true) val = row.formatter(val);
                }
            } catch (e) {
                console.log('Error in PanelTable', e);
                val = '-';
            }
            const createEl = col.element || row.element;
            const createEditor = col.editor || row.editor || (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox;
            const onEditApi = (value, save)=>{
                setValueForEditCell(value);
                if (save) {
                    saveCurrentEdit();
                    setCellEditMode(null);
                }
            };
            const editApi = {
                row: row,
                col: col,
                val: editValueStore,
                onEdit: onEditApi
            };
            const justifyContent = ((_a = col === null || col === void 0 ? void 0 : col.style) === null || _a === void 0 ? void 0 : _a.justifyContent) || 'center';
            const alignItems = ((_b = col === null || col === void 0 ? void 0 : col.style) === null || _b === void 0 ? void 0 : _b.alignItems) || 'start';
            const newEl = (0, $kSbwP.jsx)((0, $8421c2e6c1303cf8$export$1f54913ccc4368b1), {
                justifyContent: justifyContent,
                alignItems: alignItems,
                style: {
                    width: '100%',
                    height: '100%'
                },
                onDoubleClick: ()=>{
                    if (props.onEditField && row.editable) setCellEditMode({
                        row: row,
                        col: col,
                        rowIndex: rowIndex,
                        colIndex: colIndex
                    });
                },
                children: editMode ? createEditor(editApi) : createEl(row, col, val)
            }, colIndex);
            newRow.push(newEl);
        });
        const rowPosition = rowIndex === 0 ? 'start' : rowIndex === props.rows.length - 1 ? 'end' : 'none';
        rows.push(elementsToGridRow(rows.length + 1, row, newRow, [], rowPosition));
    });
    // props.columns.forEach((col, index) => {
    //     const v = col.value(col.field, col.column, props.data);
    //     const row = dataToRow(
    //         index + 2,
    //         data.map((d: any) => d.value)
    //     );
    //     rows.push(row);
    // });
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($0a90de210c8d2546$exports.gridContainer, props.className);
    return (0, $kSbwP.jsx)("div", {
        className: cls,
        children: rows
    });
};



class $7403a76d892238e8$export$8b849e0e30783f61 {
}
Object.defineProperty($7403a76d892238e8$export$8b849e0e30783f61, "findCompaniesToCompare", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (reportId, maxReturn = 2)=>{
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        const q = store.createDataAccess(reportId);
        if (q == null) return [];
        if (reportId == 'AOMInfusions(ProjectAugusta)CIMCemEsendal') return [
            'VitalCare(ProjectShelby)CIPCemEsendal',
            'InfusionAssociates(ProjectSpartan)CIMCemEsendal'
        ];
        const companies = Object.keys(store.reportDataDB).filter((reportId)=>store.reportDataDB[reportId].status == 'completed');
        const fullMatch = [];
        const partialMatch = [];
        const noMatch = [];
        const industry = q.value('industry');
        const subIndustry = q.value('industrySubType');
        companies.forEach((reportId)=>{
            const compA = store.createDataAccess(reportId);
            const otherIndustry = compA.value('industry');
            const otherSub = compA.value('industrySubType');
            if (store.selectedReportId == reportId) return;
            if (industry == otherIndustry && subIndustry == otherSub) fullMatch.push(reportId);
            else if (industry == otherIndustry) partialMatch.push(reportId);
            else noMatch.push(reportId);
        });
        var allCompanies = fullMatch.concat(partialMatch).concat(noMatch);
        return allCompanies.slice(0, maxReturn);
    }
});



class $7e550ef9293629bd$export$2044ca5e7e8cae3 {
    constructor(industry, subIndustry){
        Object.defineProperty(this, "industry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: industry
        });
        Object.defineProperty(this, "subIndustry", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: subIndustry
        });
        Object.defineProperty(this, "companies", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
        const allDeals = Object.keys(store.reportDataDB);
        allDeals.forEach((deal)=>{
            const q = store.createDataAccess(deal);
            if (q) {
                const industry = q.value('industry');
                const subIndustry = q.value('industrySubType');
                if (industry === this.industry && subIndustry === this.subIndustry) this.companies.push(q);
            }
        });
    }
    value(fieldName) {
        if (fieldName == 'company_name') return this.industry;
        if (fieldName == 'industry') return this.industry;
        if (fieldName == 'industrySubType') return this.subIndustry;
        return 'N/A';
    }
    scoreBySection(section) {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach((company)=>{
            const val = company.scoreBySection(section);
            if (val != null) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });
        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }
    score() {
        var valuesUsed = 0;
        var valuesTotalAccumlated = 0;
        this.companies.forEach((company)=>{
            const val = company.score();
            if (val != -1) {
                valuesUsed++;
                valuesTotalAccumlated += val;
            }
        });
        return valuesUsed > 0 ? (valuesTotalAccumlated / valuesUsed).toFixed(2) : -1;
    }
    returnYearsAverageCagr(cagr) {
        var ret = {};
        for(var year = 3; year <= 5; year++){
            var valuesUsed = [];
            this.companies.forEach((company)=>{
                const val = cagr == 'organic' ? company.organicCagr(year) : company.projectedCagr(year);
                if (val != 'N/A' && !isNaN(val)) valuesUsed.push(val);
            });
            ret[year] = this.trimmedAverage(valuesUsed);
        }
        return ret;
    }
    trimmedAverage(values) {
        if (values.length == 0) return "N/A";
        if (values.length < 4) return values.reduce((acc, val)=>acc + val, 0) / values.length;
        const sorted = [
            ...values
        ].sort((a, b)=>a - b);
        const count = sorted.length;
        const lower = Math.floor(count * 0.25);
        const upper = Math.ceil(count * 0.75);
        const middle = sorted.slice(lower, upper); // middle 50%
        const sum = middle.reduce((acc, val)=>acc + val, 0);
        return sum / middle.length;
    }
    get_extended_value_float(fieldName) {
        if (fieldName == 'recurring_revenue_summary') return 'N/A';
        if (fieldName == 'organic_cagr_N_years' || fieldName == 'projected_organic_cagr_N_years') {
            const cagrType = fieldName == 'organic_cagr_N_years' ? 'organic' : 'projected';
            return this.returnYearsAverageCagr(cagrType);
        }
        var valuesUsed = [];
        this.companies.forEach((company)=>{
            const val = company.get_extended_value_float(fieldName);
            if (val != 'N/A' && !isNaN(val)) valuesUsed.push(val);
        });
        return this.trimmedAverage(valuesUsed);
    }
}








var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");
var $1b1a012ab27d0a02$exports = {};
$1b1a012ab27d0a02$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");



const $3025be2fbc4fcb83$export$9626faa1e0fab265 = (props)=>{
    const [isLoaded, setIsLoaded] = (0, $8nGP5.useState)(false);
    const defaultOptionsLottie = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1b1a012ab27d0a02$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            !isLoaded && (0, $kSbwP.jsx)("div", {
                className: props.className,
                children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                    options: defaultOptionsLottie
                })
            }),
            (0, $kSbwP.jsx)("img", {
                src: props.src,
                alt: "placeholder",
                className: props.className,
                onLoad: ()=>{
                    setIsLoaded(true);
                }
            })
        ]
    });
};



var $kSbwP = parcelRequire("kSbwP");

var $d75ef6ac4f58ae92$export$40a9eeef55665a40;
var $d75ef6ac4f58ae92$export$93b7586d956c930e;
var $d75ef6ac4f58ae92$export$f843afa9e9b53052;
var $d75ef6ac4f58ae92$export$296fb8e7af4c4a4d;
var $d75ef6ac4f58ae92$export$ae78d338ad66ff90;
var $d75ef6ac4f58ae92$export$b8972b998723d602;
$d75ef6ac4f58ae92$export$40a9eeef55665a40 = `_Czy6G_defaultPadding`;
$d75ef6ac4f58ae92$export$93b7586d956c930e = `_Czy6G_dropShadow`;
$d75ef6ac4f58ae92$export$f843afa9e9b53052 = `_Czy6G_panelImage`;
$d75ef6ac4f58ae92$export$296fb8e7af4c4a4d = `_Czy6G_panelRowTitle`;
$d75ef6ac4f58ae92$export$ae78d338ad66ff90 = `_Czy6G_scaleInOut`;
$d75ef6ac4f58ae92$export$b8972b998723d602 = `_Czy6G_shadow`;



const $308b83e7da0f0dd7$export$86de09faaa70680d = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(props.containerClassName);
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($d75ef6ac4f58ae92$export$296fb8e7af4c4a4d, props.className);
    return (0, $kSbwP.jsxs)((0, $8421c2e6c1303cf8$export$1f54913ccc4368b1), {
        className: container,
        children: [
            props.children ? props.children : '',
            (0, $kSbwP.jsx)("div", {
                className: cls,
                children: props.title
            })
        ]
    });
};



var $kSbwP = parcelRequire("kSbwP");

var $f874c4f8ee17651e$export$fad3c8302a7540c6;
$f874c4f8ee17651e$export$fad3c8302a7540c6 = `YM63lW_scrollContainer`;



var $8nGP5 = parcelRequire("8nGP5");





const $1cd5198602b08238$export$9159ebcaf8f42267 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    var _a;
    const scrollRef = (0, $8nGP5.useRef)(null);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($f874c4f8ee17651e$export$fad3c8302a7540c6, props.className);
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [resizeRef, bounds] = (0, $3a0100122386f550$export$2e2bcd8739ae039)();
    const enableHideScrollUntilMouseOver = props.enableHideScrollUntilMouseOver === true;
    const disableKeyboardScroll = props.disableKeyboardScroll === true;
    const [firstLoadScroll, setFirstLoadScroll] = (0, $8nGP5.useState)(false);
    (0, $e6c16966fa3d22d4$export$f2b96e571871cea1)(scrollRef.current, uiStore, disableKeyboardScroll ? 0 : 100);
    (0, $8nGP5.useEffect)(()=>{
        if (enableHideScrollUntilMouseOver) scrollRef.current.style.scrollbarColor = 'transparent transparent';
    }, [
        scrollRef.current
    ]);
    if (props.onLoadScrollToEnd) {
        if (!firstLoadScroll && ((_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > 0) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
            setFirstLoadScroll(true);
        }
    }
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        style: {
            position: 'relative'
        },
        children: [
            (0, $kSbwP.jsx)("div", {
                ref: resizeRef,
                style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                }
            }),
            (0, $kSbwP.jsx)("div", {
                className: classes,
                style: Object.assign({
                    position: 'absolute',
                    width: bounds.width,
                    height: bounds.height
                }, props.style),
                id: props.id,
                ref: scrollRef,
                onMouseLeave: ()=>{
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor = 'transparent transparent';
                },
                onMouseEnter: ()=>{
                    if (!enableHideScrollUntilMouseOver) return;
                    scrollRef.current.style.scrollbarColor = '#eaecf0 transparent';
                },
                children: props.children
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");
var $454bde0f68041a40$exports = {};
var $7c3ec5a697c1e683$exports = {};
$7c3ec5a697c1e683$exports = new URL("concentration.7d597663.svg", import.meta.url).toString();


var $a8e7b42e52bb1529$exports = {};
$a8e7b42e52bb1529$exports = new URL("ebitda_performance.d2e303be.svg", import.meta.url).toString();


var $a07ca7f865e39e0a$exports = {};
$a07ca7f865e39e0a$exports = new URL("fcf_profile.4ba5e38a.svg", import.meta.url).toString();


var $992f3cc16bc9db1a$exports = {};
$992f3cc16bc9db1a$exports = new URL("market_size_and_performance.fd9c2e5e.svg", import.meta.url).toString();


var $5771c6bd39c874b5$exports = {};
$5771c6bd39c874b5$exports = new URL("other.80576dc7.svg", import.meta.url).toString();


var $07f55281b15491a7$exports = {};
$07f55281b15491a7$exports = new URL("overview.a1b80899.svg", import.meta.url).toString();


var $f31503c2d53b37a4$exports = {};
$f31503c2d53b37a4$exports = new URL("revenue_performance.82890e81.svg", import.meta.url).toString();


$454bde0f68041a40$exports = {
    "concentration": $7c3ec5a697c1e683$exports,
    "ebitda_performance": $a8e7b42e52bb1529$exports,
    "fcf_profile": $a07ca7f865e39e0a$exports,
    "market_size_and_performance": $992f3cc16bc9db1a$exports,
    "other": $5771c6bd39c874b5$exports,
    "overview": $07f55281b15491a7$exports,
    "revenue_performance": $f31503c2d53b37a4$exports
};


const $3d82e178f5213798$export$ef2b607153f69518 = (section)=>{
    if (!$454bde0f68041a40$exports[section]) return null;
    return $454bde0f68041a40$exports[section];
};
const $3d82e178f5213798$export$ab8815222a429372 = (p)=>{
    return (0, $kSbwP.jsx)("div", {
        className: p.className,
        children: (0, $kSbwP.jsx)("img", {
            src: $454bde0f68041a40$exports[p.section]
        })
    });
};



var $e8cfe043fdb0cc46$export$a38dc554151ff661;
var $e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e;
var $e8cfe043fdb0cc46$export$5c219a65934d4b9c;
var $e8cfe043fdb0cc46$export$a9201b0f321cc198;
var $e8cfe043fdb0cc46$export$e730f6987ad4283b;
var $e8cfe043fdb0cc46$export$41fc6278a3c14d73;
var $e8cfe043fdb0cc46$export$6633e83f4afff9ea;
var $e8cfe043fdb0cc46$export$637f169d296cfe12;
var $e8cfe043fdb0cc46$export$524c9eca7362778b;
var $e8cfe043fdb0cc46$export$64b67e74237b10b9;
var $e8cfe043fdb0cc46$export$daaf31466ad29ead;
var $e8cfe043fdb0cc46$export$9ba80d992c64273b;
var $e8cfe043fdb0cc46$export$4087c73cbd989252;
$e8cfe043fdb0cc46$export$a38dc554151ff661 = `yzAg9a_companyHeaderElement`;
$e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e = `yzAg9a_companyLogo`;
$e8cfe043fdb0cc46$export$5c219a65934d4b9c = `yzAg9a_companyNameLabel`;
$e8cfe043fdb0cc46$export$a9201b0f321cc198 = `yzAg9a_dealCategoryScore`;
$e8cfe043fdb0cc46$export$e730f6987ad4283b = `yzAg9a_dealThumbScore`;
$e8cfe043fdb0cc46$export$41fc6278a3c14d73 = `yzAg9a_noDataAvail`;
$e8cfe043fdb0cc46$export$6633e83f4afff9ea = `yzAg9a_panelTableCompanies`;
$e8cfe043fdb0cc46$export$637f169d296cfe12 = `yzAg9a_panelTableStyle`;
$e8cfe043fdb0cc46$export$524c9eca7362778b = `yzAg9a_panelTableStyleRelativeContainer`;
$e8cfe043fdb0cc46$export$64b67e74237b10b9 = `yzAg9a_panelTableStyleScoreLine`;
$e8cfe043fdb0cc46$export$daaf31466ad29ead = `yzAg9a_panelTitle`;
$e8cfe043fdb0cc46$export$9ba80d992c64273b = `yzAg9a_panelTitleText`;
$e8cfe043fdb0cc46$export$4087c73cbd989252 = `yzAg9a_sectionIcon`;


var $23a7952c7535a456$exports = {};
$23a7952c7535a456$exports = new URL("industry_icon.30d7df5b.svg", import.meta.url).toString();




var $fgQ0V = parcelRequire("fgQ0V");

var $8nGP5 = parcelRequire("8nGP5");
const $5a1995dee7b5d277$export$a928f7cf0495745d = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const INDUSTRY_AVG_ID = 'INDUSTRY_AVERAGE';
    const SECTIONS_SHOW_NOT_SCORED = [
        'overview'
    ];
    if (store.selectedReportId == '' || store.query == null) return null;
    const q = store.query;
    const companies = [
        store.selectedReportId,
        ...(0, $7403a76d892238e8$export$8b849e0e30783f61).findCompaniesToCompare(store.selectedReportId),
        INDUSTRY_AVG_ID
    ];
    const dataAccess = {
        string: (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)
    };
    const aggAccess = new (0, $7e550ef9293629bd$export$2044ca5e7e8cae3)(q.value('industry'), q.value('industrySubType'));
    companies.forEach((company)=>{
        if (company == INDUSTRY_AVG_ID) return;
        const query = store.createDataAccess(company);
        dataAccess[company] = query;
    });
    const getElement = (fieldName, rule)=>{
        const cagrPercentElement = (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).custom((row, col, data)=>{
            var typed = data;
            var keys = Object.keys(typed).sort();
            var children = [];
            for(let i = 0; i < keys.length; i++){
                const yearIndex = keys[i];
                const value = typed[yearIndex];
                if (value != null) {
                    var valDisplay = value == 'N/A' ? 'N/A' : (0, $7fbd760f3c05e83d$export$e440a706af0c0216)(value.toString());
                    children.push((0, $kSbwP.jsxs)((0, $8nGP5.Fragment), {
                        children: [
                            (0, $kSbwP.jsx)("div", {
                                children: valDisplay
                            }),
                            (0, $kSbwP.jsxs)("div", {
                                children: [
                                    "(",
                                    yearIndex,
                                    " years) "
                                ]
                            }, yearIndex),
                            (0, $kSbwP.jsx)("div", {
                                className: "w-100"
                            })
                        ]
                    }, yearIndex));
                }
            }
            return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "row",
                justify: "center",
                fillCell: true,
                wrap: "wrap",
                style: {
                    gap: '5px'
                },
                children: children
            });
        });
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        const rules = (0, $9b879bbdd76f7296$export$f65e0b130162f295)();
        if (e.t == 'bool') return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).booleanCentered;
        else if (e.t == '%') {
            if (rule.dataPick != null) return cagrPercentElement;
            return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent;
        } else return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value;
    };
    const getLabel = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label;
        else return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label;
    };
    const formatPercentWithYear = (data)=>{
        if (!data && data !== 0) data = '';
        if ((0, $fgQ0V.isString)(data)) return data;
        const v = data;
        return `${(0, $7fbd760f3c05e83d$export$e440a706af0c0216)(v.value.toString())} (${v.years} years)`;
    };
    const getFormatter = (fieldName, rule)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') {
            if (rule.dataPick != null) return 0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2;
            if (e.scale == 100) return 0, $1ac83566e6b5504b$export$23be700726d3a499;
            return 0, $1ac83566e6b5504b$export$32e6b1ae352e94d6;
        } else if (e.t == 'bool' || e.t == 'str') return null;
        else return 0, $1ac83566e6b5504b$export$40333d0facc9092d;
    };
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    const fieldsGroup = scoreStore.COMPARE_FIELDS_GROUPS;
    const genColumn = (reportId, disableHeaderLogo)=>{
        return {
            column: {
                source: reportId,
                display: null
            },
            header: (col)=>{
                if (disableHeaderLogo) return null;
                const q = getQ(col.column.source);
                const name = q.value('company_name');
                var logoURL = null;
                if (col.column.source == INDUSTRY_AVG_ID) logoURL = (0, (/*@__PURE__*/$parcel$interopDefault($23a7952c7535a456$exports)));
                else logoURL = q.value('logoURL');
                return (0, $kSbwP.jsx)("a", {
                    href: `${reportId}`,
                    style: {
                        textDecoration: 'none',
                        cursor: 'pointer'
                    },
                    className: "companyNameLabel",
                    onClick: (e)=>{
                        e.preventDefault();
                        if (reportId == INDUSTRY_AVG_ID) return;
                        navUtils.toReport(reportId);
                    },
                    children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        className: $e8cfe043fdb0cc46$export$a38dc554151ff661,
                        direction: "column",
                        alignItems: "center",
                        justify: "between",
                        children: [
                            (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                                score: q.score(),
                                className: $e8cfe043fdb0cc46$export$e730f6987ad4283b
                            }),
                            (0, $kSbwP.jsx)("div", {
                                className: $e8cfe043fdb0cc46$export$5c219a65934d4b9c,
                                children: name
                            }),
                            logoURL && (0, $kSbwP.jsx)((0, $3025be2fbc4fcb83$export$9626faa1e0fab265), {
                                src: logoURL,
                                className: $e8cfe043fdb0cc46$export$42e4a6ed1eb5a52e
                            })
                        ]
                    })
                });
            }
        };
    };
    const columns = companies.map((reportId)=>{
        return genColumn(reportId);
    });
    const getQ = (reportId)=>{
        if (reportId == INDUSTRY_AVG_ID) return aggAccess;
        return dataAccess[reportId];
    };
    const fieldsToRows = (group)=>{
        const fields = group.fields;
        const rules = (0, $9b879bbdd76f7296$export$f65e0b130162f295)();
        return fields.map((fieldName)=>{
            const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
            const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(group.sectionId, fieldName);
            (0, $3d71a0e5fc49a3ca$exports.assert)(e != null, `Field ${fieldName} not found in fieldsNameLookup`);
            return {
                field: {
                    source: null,
                    display: e.display
                },
                value: (_field, column)=>{
                    // if (
                    //     fieldName ==
                    //     'projected_organic_cagr_3_years_minus_tam_growth'
                    // ) {
                    //     debugger;
                    // }
                    const q = getQ(column.source);
                    if (e.t == 'str') {
                        if (fieldName.indexOf('extended_') == 0) return q.get_extended_value_float(fieldName);
                        return q.value(fieldName);
                    }
                    return q.get_extended_value_float(fieldName);
                },
                label: getLabel(fieldName),
                formatter: getFormatter(fieldName, rule),
                element: getElement(fieldName, rule)
            };
        });
    };
    const groupTables = fieldsGroup.map((group, i)=>{
        const sectionScoreRow = {
            field: {
                source: null,
                display: ''
            },
            value: (_field, column)=>{
                const q = getQ(column.source);
                var ret = q.scoreBySection(group.sectionId);
                if (ret == -1) return '-';
                return ret;
            },
            formatter: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6),
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (row, col, data)=>{
                const score = data == '-' ? -1 : data;
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    fillCell: true,
                    alignItems: "center",
                    justify: "center",
                    children: (0, $kSbwP.jsx)((0, $33ac36ca38f3f8d0$export$5fb755babf77fa30), {
                        score: score
                    })
                });
            }
        };
        const groupRows = [
            ...fieldsToRows(group)
        ];
        var shouldShow = companies.some((reportId)=>{
            if (reportId == INDUSTRY_AVG_ID) return false;
            if (SECTIONS_SHOW_NOT_SCORED.includes(group.sectionId)) return true;
            var scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(getQ(reportId));
            if (scoreUtils.is_section_used_for_scoring_by_id(group.sectionId)) return true;
            return false;
        });
        const titlePanel = (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
            title: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
            className: $e8cfe043fdb0cc46$export$9ba80d992c64273b,
            containerClassName: $e8cfe043fdb0cc46$export$daaf31466ad29ead,
            children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                section: group.sectionId,
                className: $e8cfe043fdb0cc46$export$4087c73cbd989252
            })
        }, 'title_' + group.sectionId);
        if (!shouldShow) return (0, $kSbwP.jsxs)("div", {
            children: [
                titlePanel,
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: (0, $kSbwP.jsx)("div", {
                        className: $e8cfe043fdb0cc46$export$41fc6278a3c14d73,
                        children: "No Data Available"
                    })
                })
            ]
        }, 'group_nodata_' + i);
        return (0, $kSbwP.jsxs)("div", {
            children: [
                titlePanel,
                !SECTIONS_SHOW_NOT_SCORED.includes(group.sectionId) && (0, $kSbwP.jsx)("div", {
                    className: $e8cfe043fdb0cc46$export$524c9eca7362778b,
                    children: (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                        columns: columns,
                        rows: [
                            sectionScoreRow
                        ],
                        disable_round_edges: true,
                        className: $e8cfe043fdb0cc46$export$64b67e74237b10b9,
                        noHeaderRow: true
                    })
                }),
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: groupRows,
                    disable_round_edges: true,
                    className: $e8cfe043fdb0cc46$export$637f169d296cfe12,
                    noHeaderRow: true
                })
            ]
        }, 'group_report_' + i);
    });
    const headersTableStyle = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e8cfe043fdb0cc46$export$637f169d296cfe12, $e8cfe043fdb0cc46$export$6633e83f4afff9ea);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: [],
                    disable_round_edges: true,
                    className: headersTableStyle
                }),
                (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                    children: [
                        groupTables,
                        (0, $kSbwP.jsx)("div", {
                            style: {
                                width: '100%',
                                height: '100px'
                            }
                        })
                    ]
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $kSbwP = parcelRequire("kSbwP");


var $b1ab14b7ed695c47$export$40a9eeef55665a40;
var $b1ab14b7ed695c47$export$93b7586d956c930e;
var $b1ab14b7ed695c47$export$38e42c68cf43b5d4;
var $b1ab14b7ed695c47$export$f843afa9e9b53052;
var $b1ab14b7ed695c47$export$ae78d338ad66ff90;
var $b1ab14b7ed695c47$export$a3a773c2b0a58e0d;
var $b1ab14b7ed695c47$export$b8972b998723d602;
var $b1ab14b7ed695c47$export$fb184b623420d9be;
$b1ab14b7ed695c47$export$40a9eeef55665a40 = `USuRvW_defaultPadding`;
$b1ab14b7ed695c47$export$93b7586d956c930e = `USuRvW_dropShadow`;
$b1ab14b7ed695c47$export$38e42c68cf43b5d4 = `USuRvW_header`;
$b1ab14b7ed695c47$export$f843afa9e9b53052 = `USuRvW_panelImage`;
$b1ab14b7ed695c47$export$ae78d338ad66ff90 = `USuRvW_scaleInOut`;
$b1ab14b7ed695c47$export$a3a773c2b0a58e0d = `USuRvW_seperatorFields`;
$b1ab14b7ed695c47$export$b8972b998723d602 = `USuRvW_shadow`;
$b1ab14b7ed695c47$export$fb184b623420d9be = `USuRvW_title`;




var $kSbwP = parcelRequire("kSbwP");

var $85f5da2e80edabb8$export$34e0f9847d4c02dd;
var $85f5da2e80edabb8$export$fb184b623420d9be;
var $85f5da2e80edabb8$export$2ab9a8f9f1186f14;
$85f5da2e80edabb8$export$34e0f9847d4c02dd = `pezUqG_container`;
$85f5da2e80edabb8$export$fb184b623420d9be = `pezUqG_title`;
$85f5da2e80edabb8$export$2ab9a8f9f1186f14 = `pezUqG_value`;



const $ccf4ab5e114879a2$export$9c5e83992d724a63 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        alignItems: "center",
        className: $85f5da2e80edabb8$export$34e0f9847d4c02dd,
        children: [
            (0, $kSbwP.jsxs)("div", {
                className: $85f5da2e80edabb8$export$fb184b623420d9be,
                children: [
                    " ",
                    p.label,
                    " "
                ]
            }),
            (0, $kSbwP.jsx)("div", {
                className: $85f5da2e80edabb8$export$2ab9a8f9f1186f14,
                children: p.value
            })
        ]
    });
});


const $f20b217cc7daff5d$export$f20f69a59ceebf9d = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    if (!query) return null;
    const error = store.errorMessageTicker;
    const metaFields = [
        {
            label: 'Founded:',
            value: query.value('year_founded')
        },
        {
            label: 'CEO',
            value: query.value('company_ceo')
        },
        {
            label: 'HQ',
            value: query.value('hq_location')
        },
        {
            label: 'Industry',
            value: query.value('industry')
        },
        {
            label: 'Sub-industry',
            value: query.value('industrySubType')
        }
    ];
    const values = [];
    metaFields.forEach((field, index)=>{
        values.push((0, $kSbwP.jsx)((0, $ccf4ab5e114879a2$export$9c5e83992d724a63), {
            label: field.label,
            value: field.value
        }, field.label));
        if (index < metaFields.length - 1) values.push((0, $kSbwP.jsx)("div", {
            className: $b1ab14b7ed695c47$export$a3a773c2b0a58e0d,
            children: (0, $kSbwP.jsx)("i", {
                className: "bi bi-dot"
            })
        }, 'sep_' + field.label));
    });
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        className: $b1ab14b7ed695c47$export$38e42c68cf43b5d4,
        children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            justify: "around",
            children: values
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");

var $118dc35c9da0a546$export$40a9eeef55665a40;
var $118dc35c9da0a546$export$51987bb50e1f6752;
var $118dc35c9da0a546$export$93b7586d956c930e;
var $118dc35c9da0a546$export$f843afa9e9b53052;
var $118dc35c9da0a546$export$ae78d338ad66ff90;
var $118dc35c9da0a546$export$b8972b998723d602;
var $118dc35c9da0a546$export$fb184b623420d9be;
$118dc35c9da0a546$export$40a9eeef55665a40 = `ZOZyKW_defaultPadding`;
$118dc35c9da0a546$export$51987bb50e1f6752 = `ZOZyKW_desc`;
$118dc35c9da0a546$export$93b7586d956c930e = `ZOZyKW_dropShadow`;
$118dc35c9da0a546$export$f843afa9e9b53052 = `ZOZyKW_panelImage`;
$118dc35c9da0a546$export$ae78d338ad66ff90 = `ZOZyKW_scaleInOut`;
$118dc35c9da0a546$export$b8972b998723d602 = `ZOZyKW_shadow`;
$118dc35c9da0a546$export$fb184b623420d9be = `ZOZyKW_title`;




const $908ff996248f52cc$export$d30a5f17ebdee8f = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            (0, $kSbwP.jsx)("div", {
                className: $118dc35c9da0a546$export$fb184b623420d9be,
                children: "Business Overview"
            }),
            (0, $kSbwP.jsx)("div", {
                className: $118dc35c9da0a546$export$51987bb50e1f6752,
                children: store.companyOverview
            })
        ]
    });
});




var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");
var $a22fa58636ba4c67$exports = {};
(function(global, factory) {
    factory($a22fa58636ba4c67$exports);
})($a22fa58636ba4c67$exports, function(exports1) {
    'use strict';
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    var PREACT_VNODE = '__v';
    var PREACT_OWNER = '__o';
    var REACT_OWNER = '_owner';
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.entries();
        var aResult;
        var bResult;
        var index = 0;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                var aEntry = aResult.value;
                var bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ var areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        var size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        var matchedIndices = new Array(size);
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    var ARGUMENTS_TAG = '[object Arguments]';
    var BOOLEAN_TAG = '[object Boolean]';
    var DATE_TAG = '[object Date]';
    var ERROR_TAG = '[object Error]';
    var MAP_TAG = '[object Map]';
    var NUMBER_TAG = '[object Number]';
    var OBJECT_TAG = '[object Object]';
    var REG_EXP_TAG = '[object RegExp]';
    var SET_TAG = '[object Set]';
    var STRING_TAG = '[object String]';
    var URL_TAG = '[object URL]';
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === 'function' && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            var type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $2f99252fdabe2e67$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $2f99252fdabe2e67$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $2f99252fdabe2e67$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $e103405a148ee9f6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e103405a148ee9f6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e103405a148ee9f6$var$_typeof(o);
}
function $e103405a148ee9f6$var$_toArray(arr) {
    return $e103405a148ee9f6$var$_arrayWithHoles(arr) || $e103405a148ee9f6$var$_iterableToArray(arr) || $e103405a148ee9f6$var$_unsupportedIterableToArray(arr) || $e103405a148ee9f6$var$_nonIterableRest();
}
function $e103405a148ee9f6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e103405a148ee9f6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e103405a148ee9f6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e103405a148ee9f6$var$_arrayLikeToArray(o, minLen);
}
function $e103405a148ee9f6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e103405a148ee9f6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e103405a148ee9f6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e103405a148ee9f6$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $e103405a148ee9f6$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $2f99252fdabe2e67$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $2f99252fdabe2e67$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($e103405a148ee9f6$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $9ac15f2cfbe23c11$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ac15f2cfbe23c11$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ac15f2cfbe23c11$var$_typeof(o);
}
function $9ac15f2cfbe23c11$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ac15f2cfbe23c11$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ac15f2cfbe23c11$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ac15f2cfbe23c11$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ac15f2cfbe23c11$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ac15f2cfbe23c11$var$_defineProperty(obj, key, value) {
    key = $9ac15f2cfbe23c11$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ac15f2cfbe23c11$var$_toPropertyKey(arg) {
    var key = $9ac15f2cfbe23c11$var$_toPrimitive(arg, "string");
    return $9ac15f2cfbe23c11$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9ac15f2cfbe23c11$var$_toPrimitive(input, hint) {
    if ($9ac15f2cfbe23c11$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9ac15f2cfbe23c11$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9ac15f2cfbe23c11$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $9ac15f2cfbe23c11$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $9ac15f2cfbe23c11$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $9ac15f2cfbe23c11$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $9ac15f2cfbe23c11$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $9ac15f2cfbe23c11$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $9ac15f2cfbe23c11$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $9ac15f2cfbe23c11$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $9ac15f2cfbe23c11$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $9ac15f2cfbe23c11$var$_objectSpread($9ac15f2cfbe23c11$var$_objectSpread({}, res), {}, $9ac15f2cfbe23c11$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $9ac15f2cfbe23c11$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($9ac15f2cfbe23c11$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $9ac15f2cfbe23c11$var$isDev = false;
var $9ac15f2cfbe23c11$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($9ac15f2cfbe23c11$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $8a063fd321a353f2$var$_slicedToArray(arr, i) {
    return $8a063fd321a353f2$var$_arrayWithHoles(arr) || $8a063fd321a353f2$var$_iterableToArrayLimit(arr, i) || $8a063fd321a353f2$var$_unsupportedIterableToArray(arr, i) || $8a063fd321a353f2$var$_nonIterableRest();
}
function $8a063fd321a353f2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8a063fd321a353f2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8a063fd321a353f2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8a063fd321a353f2$var$_toConsumableArray(arr) {
    return $8a063fd321a353f2$var$_arrayWithoutHoles(arr) || $8a063fd321a353f2$var$_iterableToArray(arr) || $8a063fd321a353f2$var$_unsupportedIterableToArray(arr) || $8a063fd321a353f2$var$_nonIterableSpread();
}
function $8a063fd321a353f2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8a063fd321a353f2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8a063fd321a353f2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8a063fd321a353f2$var$_arrayLikeToArray(o, minLen);
}
function $8a063fd321a353f2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8a063fd321a353f2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8a063fd321a353f2$var$_arrayLikeToArray(arr);
}
function $8a063fd321a353f2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $8a063fd321a353f2$var$ACCURACY = 1e-4;
var $8a063fd321a353f2$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $8a063fd321a353f2$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $8a063fd321a353f2$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $8a063fd321a353f2$var$cubicBezierFactor(c1, c2);
        return $8a063fd321a353f2$var$multyTime(params, t);
    };
};
var $8a063fd321a353f2$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $8a063fd321a353f2$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($8a063fd321a353f2$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $8a063fd321a353f2$var$multyTime(newParams, t);
    };
};
var $8a063fd321a353f2$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $8a063fd321a353f2$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $9ac15f2cfbe23c11$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $9ac15f2cfbe23c11$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $8a063fd321a353f2$var$cubicBezier(x1, x2);
    var curveY = $8a063fd321a353f2$var$cubicBezier(y1, y2);
    var derCurveX = $8a063fd321a353f2$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $8a063fd321a353f2$var$ACCURACY || derVal < $8a063fd321a353f2$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $8a063fd321a353f2$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $8a063fd321a353f2$var$ACCURACY && Math.abs(newV) < $8a063fd321a353f2$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $8a063fd321a353f2$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $8a063fd321a353f2$export$56c51296f72f0592(easing);
        case 'spring':
            return $8a063fd321a353f2$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $8a063fd321a353f2$export$56c51296f72f0592(easing);
            (0, $9ac15f2cfbe23c11$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $9ac15f2cfbe23c11$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $d635bc303b4f8fc4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d635bc303b4f8fc4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d635bc303b4f8fc4$var$_typeof(o);
}
function $d635bc303b4f8fc4$var$_toConsumableArray(arr) {
    return $d635bc303b4f8fc4$var$_arrayWithoutHoles(arr) || $d635bc303b4f8fc4$var$_iterableToArray(arr) || $d635bc303b4f8fc4$var$_unsupportedIterableToArray(arr) || $d635bc303b4f8fc4$var$_nonIterableSpread();
}
function $d635bc303b4f8fc4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d635bc303b4f8fc4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $d635bc303b4f8fc4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d635bc303b4f8fc4$var$_arrayLikeToArray(arr);
}
function $d635bc303b4f8fc4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d635bc303b4f8fc4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d635bc303b4f8fc4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d635bc303b4f8fc4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d635bc303b4f8fc4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d635bc303b4f8fc4$var$_defineProperty(obj, key, value) {
    key = $d635bc303b4f8fc4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d635bc303b4f8fc4$var$_toPropertyKey(arg) {
    var key = $d635bc303b4f8fc4$var$_toPrimitive(arg, "string");
    return $d635bc303b4f8fc4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d635bc303b4f8fc4$var$_toPrimitive(input, hint) {
    if ($d635bc303b4f8fc4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d635bc303b4f8fc4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d635bc303b4f8fc4$var$_slicedToArray(arr, i) {
    return $d635bc303b4f8fc4$var$_arrayWithHoles(arr) || $d635bc303b4f8fc4$var$_iterableToArrayLimit(arr, i) || $d635bc303b4f8fc4$var$_unsupportedIterableToArray(arr, i) || $d635bc303b4f8fc4$var$_nonIterableRest();
}
function $d635bc303b4f8fc4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d635bc303b4f8fc4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d635bc303b4f8fc4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d635bc303b4f8fc4$var$_arrayLikeToArray(o, minLen);
}
function $d635bc303b4f8fc4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d635bc303b4f8fc4$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d635bc303b4f8fc4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d635bc303b4f8fc4$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $d635bc303b4f8fc4$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $d635bc303b4f8fc4$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $9ac15f2cfbe23c11$export$d6051a0f7a227332)(function(key, val) {
        if ($d635bc303b4f8fc4$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $d635bc303b4f8fc4$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $9ac15f2cfbe23c11$export$d6051a0f7a227332)(function(key, val) {
        if ($d635bc303b4f8fc4$var$needContinue(val)) return $d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, val), {}, {
            velocity: $d635bc303b4f8fc4$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $d635bc303b4f8fc4$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$d635bc303b4f8fc4$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $9ac15f2cfbe23c11$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, res), {}, $d635bc303b4f8fc4$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, res), {}, $d635bc303b4f8fc4$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $9ac15f2cfbe23c11$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($d635bc303b4f8fc4$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $d635bc303b4f8fc4$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $9ac15f2cfbe23c11$export$d6051a0f7a227332)(function(key, val) {
            return $d635bc303b4f8fc4$var$alpha.apply(void 0, $d635bc303b4f8fc4$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $9ac15f2cfbe23c11$export$d6051a0f7a227332)(function(key, val) {
                return $d635bc303b4f8fc4$var$alpha.apply(void 0, $d635bc303b4f8fc4$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread($d635bc303b4f8fc4$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $1287f7c6ac9a28ab$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1287f7c6ac9a28ab$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1287f7c6ac9a28ab$var$_typeof(o);
}
var $1287f7c6ac9a28ab$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $1287f7c6ac9a28ab$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1287f7c6ac9a28ab$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1287f7c6ac9a28ab$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1287f7c6ac9a28ab$var$_toConsumableArray(arr) {
    return $1287f7c6ac9a28ab$var$_arrayWithoutHoles(arr) || $1287f7c6ac9a28ab$var$_iterableToArray(arr) || $1287f7c6ac9a28ab$var$_unsupportedIterableToArray(arr) || $1287f7c6ac9a28ab$var$_nonIterableSpread();
}
function $1287f7c6ac9a28ab$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1287f7c6ac9a28ab$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1287f7c6ac9a28ab$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1287f7c6ac9a28ab$var$_arrayLikeToArray(o, minLen);
}
function $1287f7c6ac9a28ab$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1287f7c6ac9a28ab$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1287f7c6ac9a28ab$var$_arrayLikeToArray(arr);
}
function $1287f7c6ac9a28ab$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1287f7c6ac9a28ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1287f7c6ac9a28ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1287f7c6ac9a28ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1287f7c6ac9a28ab$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1287f7c6ac9a28ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1287f7c6ac9a28ab$var$_defineProperty(obj, key, value) {
    key = $1287f7c6ac9a28ab$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1287f7c6ac9a28ab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1287f7c6ac9a28ab$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1287f7c6ac9a28ab$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1287f7c6ac9a28ab$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1287f7c6ac9a28ab$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1287f7c6ac9a28ab$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1287f7c6ac9a28ab$var$_toPropertyKey(arg) {
    var key = $1287f7c6ac9a28ab$var$_toPrimitive(arg, "string");
    return $1287f7c6ac9a28ab$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1287f7c6ac9a28ab$var$_toPrimitive(input, hint) {
    if ($1287f7c6ac9a28ab$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1287f7c6ac9a28ab$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1287f7c6ac9a28ab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1287f7c6ac9a28ab$var$_setPrototypeOf(subClass, superClass);
}
function $1287f7c6ac9a28ab$var$_setPrototypeOf(o, p) {
    $1287f7c6ac9a28ab$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1287f7c6ac9a28ab$var$_setPrototypeOf(o, p);
}
function $1287f7c6ac9a28ab$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1287f7c6ac9a28ab$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1287f7c6ac9a28ab$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1287f7c6ac9a28ab$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1287f7c6ac9a28ab$var$_possibleConstructorReturn(this, result);
    };
}
function $1287f7c6ac9a28ab$var$_possibleConstructorReturn(self, call) {
    if (call && ($1287f7c6ac9a28ab$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1287f7c6ac9a28ab$var$_assertThisInitialized(self);
}
function $1287f7c6ac9a28ab$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1287f7c6ac9a28ab$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1287f7c6ac9a28ab$var$_getPrototypeOf(o) {
    $1287f7c6ac9a28ab$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1287f7c6ac9a28ab$var$_getPrototypeOf(o);
}
var $1287f7c6ac9a28ab$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $1287f7c6ac9a28ab$var$_inherits(Animate, _PureComponent);
    var _super = $1287f7c6ac9a28ab$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $1287f7c6ac9a28ab$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($1287f7c6ac9a28ab$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($1287f7c6ac9a28ab$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $1287f7c6ac9a28ab$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $1287f7c6ac9a28ab$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $1287f7c6ac9a28ab$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $1287f7c6ac9a28ab$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $1287f7c6ac9a28ab$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $a22fa58636ba4c67$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $1287f7c6ac9a28ab$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $d635bc303b4f8fc4$export$2e2bcd8739ae039)(from, to, (0, $8a063fd321a353f2$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($1287f7c6ac9a28ab$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $9ac15f2cfbe23c11$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($1287f7c6ac9a28ab$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $9ac15f2cfbe23c11$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($1287f7c6ac9a28ab$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $e103405a148ee9f6$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $1287f7c6ac9a28ab$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $9ac15f2cfbe23c11$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $1287f7c6ac9a28ab$var$_objectWithoutProperties(_this$props4, $1287f7c6ac9a28ab$var$_excluded);
                var count = (0, $8nGP5.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $8nGP5.cloneElement)(container, $1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread({}, others), {}, {
                        style: $1287f7c6ac9a28ab$var$_objectSpread($1287f7c6ac9a28ab$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $8nGP5.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", null, (0, $8nGP5.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $8nGP5.PureComponent));
$1287f7c6ac9a28ab$var$Animate.displayName = 'Animate';
$1287f7c6ac9a28ab$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$1287f7c6ac9a28ab$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).func
};
var $1287f7c6ac9a28ab$export$2e2bcd8739ae039 = $1287f7c6ac9a28ab$var$Animate;




var $ac29565f779d4b91$export$2e2bcd8739ae039 = (0, $1287f7c6ac9a28ab$export$2e2bcd8739ae039);


var $5443d49d3d139f56$exports = {};
var $319a4f523286b934$exports = {};
var $e4e3f2df1701baeb$exports = {};
var $7cbdce1218977e91$exports = {};
var $7f2c7dd9742642e0$exports = {};
var $6fa627bcecd5990f$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $6fa627bcecd5990f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$6fa627bcecd5990f$exports = $6fa627bcecd5990f$var$listCacheClear;


var $8beda91139d9f496$exports = {};
var $db5286ddcd601607$exports = {};
var $59abe4f1dde57d22$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $59abe4f1dde57d22$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$59abe4f1dde57d22$exports = $59abe4f1dde57d22$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $db5286ddcd601607$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($59abe4f1dde57d22$exports(array[length][0], key)) return length;
    }
    return -1;
}
$db5286ddcd601607$exports = $db5286ddcd601607$var$assocIndexOf;


/** Used for built-in method references. */ var $8beda91139d9f496$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8beda91139d9f496$var$splice = $8beda91139d9f496$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8beda91139d9f496$var$listCacheDelete(key) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8beda91139d9f496$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8beda91139d9f496$exports = $8beda91139d9f496$var$listCacheDelete;


var $088f70052d566114$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $088f70052d566114$var$listCacheGet(key) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$088f70052d566114$exports = $088f70052d566114$var$listCacheGet;


var $f36f76e6af54e920$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f36f76e6af54e920$var$listCacheHas(key) {
    return $db5286ddcd601607$exports(this.__data__, key) > -1;
}
$f36f76e6af54e920$exports = $f36f76e6af54e920$var$listCacheHas;


var $03912848439cf58e$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $03912848439cf58e$var$listCacheSet(key, value) {
    var data = this.__data__, index = $db5286ddcd601607$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$03912848439cf58e$exports = $03912848439cf58e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7f2c7dd9742642e0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$7f2c7dd9742642e0$var$ListCache.prototype.clear = $6fa627bcecd5990f$exports;
$7f2c7dd9742642e0$var$ListCache.prototype['delete'] = $8beda91139d9f496$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.get = $088f70052d566114$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.has = $f36f76e6af54e920$exports;
$7f2c7dd9742642e0$var$ListCache.prototype.set = $03912848439cf58e$exports;
$7f2c7dd9742642e0$exports = $7f2c7dd9742642e0$var$ListCache;


var $38b3a72f4503a8d5$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $38b3a72f4503a8d5$var$stackClear() {
    this.__data__ = new $7f2c7dd9742642e0$exports;
    this.size = 0;
}
$38b3a72f4503a8d5$exports = $38b3a72f4503a8d5$var$stackClear;


var $999145c3bcdba4dc$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $999145c3bcdba4dc$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$999145c3bcdba4dc$exports = $999145c3bcdba4dc$var$stackDelete;


var $3f716e9ece3a4a7e$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f716e9ece3a4a7e$var$stackGet(key) {
    return this.__data__.get(key);
}
$3f716e9ece3a4a7e$exports = $3f716e9ece3a4a7e$var$stackGet;


var $0a9325c0fff3448a$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0a9325c0fff3448a$var$stackHas(key) {
    return this.__data__.has(key);
}
$0a9325c0fff3448a$exports = $0a9325c0fff3448a$var$stackHas;


var $ffa18809d5034c03$exports = {};

var $1ac484c0eeaed10e$exports = {};
var $7f56803878bcc7da$exports = {};
var $05341c6db84a2b16$exports = {};
var $4c7b1825f8a16f64$exports = {};
var $22b8ec638f42dca7$exports = {};
var $d932e958496f67e8$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Built-in value references. */ var $d932e958496f67e8$var$Symbol = $2jpDk.Symbol;
$d932e958496f67e8$exports = $d932e958496f67e8$var$Symbol;


var $711d9afa20a40c30$exports = {};

/** Used for built-in method references. */ var $711d9afa20a40c30$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $711d9afa20a40c30$var$hasOwnProperty = $711d9afa20a40c30$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $711d9afa20a40c30$var$nativeObjectToString = $711d9afa20a40c30$var$objectProto.toString;
/** Built-in value references. */ var $711d9afa20a40c30$var$symToStringTag = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $711d9afa20a40c30$var$getRawTag(value) {
    var isOwn = $711d9afa20a40c30$var$hasOwnProperty.call(value, $711d9afa20a40c30$var$symToStringTag), tag = value[$711d9afa20a40c30$var$symToStringTag];
    try {
        value[$711d9afa20a40c30$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $711d9afa20a40c30$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$711d9afa20a40c30$var$symToStringTag] = tag;
        else delete value[$711d9afa20a40c30$var$symToStringTag];
    }
    return result;
}
$711d9afa20a40c30$exports = $711d9afa20a40c30$var$getRawTag;


var $31dce5817c35017e$exports = {};
/** Used for built-in method references. */ var $31dce5817c35017e$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $31dce5817c35017e$var$nativeObjectToString = $31dce5817c35017e$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $31dce5817c35017e$var$objectToString(value) {
    return $31dce5817c35017e$var$nativeObjectToString.call(value);
}
$31dce5817c35017e$exports = $31dce5817c35017e$var$objectToString;


/** `Object#toString` result references. */ var $22b8ec638f42dca7$var$nullTag = '[object Null]', $22b8ec638f42dca7$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $22b8ec638f42dca7$var$symToStringTag = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $22b8ec638f42dca7$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $22b8ec638f42dca7$var$undefinedTag : $22b8ec638f42dca7$var$nullTag;
    return $22b8ec638f42dca7$var$symToStringTag && $22b8ec638f42dca7$var$symToStringTag in Object(value) ? $711d9afa20a40c30$exports(value) : $31dce5817c35017e$exports(value);
}
$22b8ec638f42dca7$exports = $22b8ec638f42dca7$var$baseGetTag;


var $4679825e1cdd07bc$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4679825e1cdd07bc$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$4679825e1cdd07bc$exports = $4679825e1cdd07bc$var$isObject;


/** `Object#toString` result references. */ var $4c7b1825f8a16f64$var$asyncTag = '[object AsyncFunction]', $4c7b1825f8a16f64$var$funcTag = '[object Function]', $4c7b1825f8a16f64$var$genTag = '[object GeneratorFunction]', $4c7b1825f8a16f64$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4c7b1825f8a16f64$var$isFunction(value) {
    if (!$4679825e1cdd07bc$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $22b8ec638f42dca7$exports(value);
    return tag == $4c7b1825f8a16f64$var$funcTag || tag == $4c7b1825f8a16f64$var$genTag || tag == $4c7b1825f8a16f64$var$asyncTag || tag == $4c7b1825f8a16f64$var$proxyTag;
}
$4c7b1825f8a16f64$exports = $4c7b1825f8a16f64$var$isFunction;


var $17080069c0442cfb$exports = {};
var $c2de6c6f88aa051a$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Used to detect overreaching core-js shims. */ var $c2de6c6f88aa051a$var$coreJsData = $2jpDk["__core-js_shared__"];
$c2de6c6f88aa051a$exports = $c2de6c6f88aa051a$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $17080069c0442cfb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($c2de6c6f88aa051a$exports && $c2de6c6f88aa051a$exports.keys && $c2de6c6f88aa051a$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $17080069c0442cfb$var$isMasked(func) {
    return !!$17080069c0442cfb$var$maskSrcKey && $17080069c0442cfb$var$maskSrcKey in func;
}
$17080069c0442cfb$exports = $17080069c0442cfb$var$isMasked;



var $c926545e85a233a2$exports = {};
/** Used for built-in method references. */ var $c926545e85a233a2$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $c926545e85a233a2$var$funcToString = $c926545e85a233a2$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $c926545e85a233a2$var$toSource(func) {
    if (func != null) {
        try {
            return $c926545e85a233a2$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$c926545e85a233a2$exports = $c926545e85a233a2$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $05341c6db84a2b16$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $05341c6db84a2b16$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $05341c6db84a2b16$var$funcProto = Function.prototype, $05341c6db84a2b16$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $05341c6db84a2b16$var$funcToString = $05341c6db84a2b16$var$funcProto.toString;
/** Used to check objects for own properties. */ var $05341c6db84a2b16$var$hasOwnProperty = $05341c6db84a2b16$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $05341c6db84a2b16$var$reIsNative = RegExp('^' + $05341c6db84a2b16$var$funcToString.call($05341c6db84a2b16$var$hasOwnProperty).replace($05341c6db84a2b16$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $05341c6db84a2b16$var$baseIsNative(value) {
    if (!$4679825e1cdd07bc$exports(value) || $17080069c0442cfb$exports(value)) return false;
    var pattern = $4c7b1825f8a16f64$exports(value) ? $05341c6db84a2b16$var$reIsNative : $05341c6db84a2b16$var$reIsHostCtor;
    return pattern.test($c926545e85a233a2$exports(value));
}
$05341c6db84a2b16$exports = $05341c6db84a2b16$var$baseIsNative;


var $9dad768a39cb1f08$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9dad768a39cb1f08$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$9dad768a39cb1f08$exports = $9dad768a39cb1f08$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7f56803878bcc7da$var$getNative(object, key) {
    var value = $9dad768a39cb1f08$exports(object, key);
    return $05341c6db84a2b16$exports(value) ? value : undefined;
}
$7f56803878bcc7da$exports = $7f56803878bcc7da$var$getNative;



var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $1ac484c0eeaed10e$var$Map = $7f56803878bcc7da$exports($2jpDk, 'Map');
$1ac484c0eeaed10e$exports = $1ac484c0eeaed10e$var$Map;


var $d4e6758f087be491$exports = {};
var $e8d7f6bb0d6ba14b$exports = {};
var $43ccfad3c27b8c09$exports = {};
var $d0716826acc0b84b$exports = {};
var $d518273df11762cd$exports = {};

/* Built-in method references that are verified to be native. */ var $d518273df11762cd$var$nativeCreate = $7f56803878bcc7da$exports(Object, 'create');
$d518273df11762cd$exports = $d518273df11762cd$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $d0716826acc0b84b$var$hashClear() {
    this.__data__ = $d518273df11762cd$exports ? $d518273df11762cd$exports(null) : {};
    this.size = 0;
}
$d0716826acc0b84b$exports = $d0716826acc0b84b$var$hashClear;


var $08b793673aa88d6c$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $08b793673aa88d6c$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$08b793673aa88d6c$exports = $08b793673aa88d6c$var$hashDelete;


var $6160f2c3d9bd32b2$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $6160f2c3d9bd32b2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $6160f2c3d9bd32b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6160f2c3d9bd32b2$var$hasOwnProperty = $6160f2c3d9bd32b2$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6160f2c3d9bd32b2$var$hashGet(key) {
    var data = this.__data__;
    if ($d518273df11762cd$exports) {
        var result = data[key];
        return result === $6160f2c3d9bd32b2$var$HASH_UNDEFINED ? undefined : result;
    }
    return $6160f2c3d9bd32b2$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$6160f2c3d9bd32b2$exports = $6160f2c3d9bd32b2$var$hashGet;


var $e803f96216f1da01$exports = {};

/** Used for built-in method references. */ var $e803f96216f1da01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e803f96216f1da01$var$hasOwnProperty = $e803f96216f1da01$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e803f96216f1da01$var$hashHas(key) {
    var data = this.__data__;
    return $d518273df11762cd$exports ? data[key] !== undefined : $e803f96216f1da01$var$hasOwnProperty.call(data, key);
}
$e803f96216f1da01$exports = $e803f96216f1da01$var$hashHas;


var $9be87881822841c9$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $9be87881822841c9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $9be87881822841c9$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $d518273df11762cd$exports && value === undefined ? $9be87881822841c9$var$HASH_UNDEFINED : value;
    return this;
}
$9be87881822841c9$exports = $9be87881822841c9$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $43ccfad3c27b8c09$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$43ccfad3c27b8c09$var$Hash.prototype.clear = $d0716826acc0b84b$exports;
$43ccfad3c27b8c09$var$Hash.prototype['delete'] = $08b793673aa88d6c$exports;
$43ccfad3c27b8c09$var$Hash.prototype.get = $6160f2c3d9bd32b2$exports;
$43ccfad3c27b8c09$var$Hash.prototype.has = $e803f96216f1da01$exports;
$43ccfad3c27b8c09$var$Hash.prototype.set = $9be87881822841c9$exports;
$43ccfad3c27b8c09$exports = $43ccfad3c27b8c09$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $e8d7f6bb0d6ba14b$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $43ccfad3c27b8c09$exports,
        'map': new ($1ac484c0eeaed10e$exports || $7f2c7dd9742642e0$exports),
        'string': new $43ccfad3c27b8c09$exports
    };
}
$e8d7f6bb0d6ba14b$exports = $e8d7f6bb0d6ba14b$var$mapCacheClear;


var $4fdb5da172003e14$exports = {};
var $eb8cd57dcb58d4c9$exports = {};
var $d9e8d4659e1cdef6$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $d9e8d4659e1cdef6$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$d9e8d4659e1cdef6$exports = $d9e8d4659e1cdef6$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $eb8cd57dcb58d4c9$var$getMapData(map, key) {
    var data = map.__data__;
    return $d9e8d4659e1cdef6$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$eb8cd57dcb58d4c9$exports = $eb8cd57dcb58d4c9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4fdb5da172003e14$var$mapCacheDelete(key) {
    var result = $eb8cd57dcb58d4c9$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$4fdb5da172003e14$exports = $4fdb5da172003e14$var$mapCacheDelete;


var $dc6af98db77117e4$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $dc6af98db77117e4$var$mapCacheGet(key) {
    return $eb8cd57dcb58d4c9$exports(this, key).get(key);
}
$dc6af98db77117e4$exports = $dc6af98db77117e4$var$mapCacheGet;


var $6650c8b92c02e0d6$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6650c8b92c02e0d6$var$mapCacheHas(key) {
    return $eb8cd57dcb58d4c9$exports(this, key).has(key);
}
$6650c8b92c02e0d6$exports = $6650c8b92c02e0d6$var$mapCacheHas;


var $c42519bfc0806ebf$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c42519bfc0806ebf$var$mapCacheSet(key, value) {
    var data = $eb8cd57dcb58d4c9$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$c42519bfc0806ebf$exports = $c42519bfc0806ebf$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d4e6758f087be491$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$d4e6758f087be491$var$MapCache.prototype.clear = $e8d7f6bb0d6ba14b$exports;
$d4e6758f087be491$var$MapCache.prototype['delete'] = $4fdb5da172003e14$exports;
$d4e6758f087be491$var$MapCache.prototype.get = $dc6af98db77117e4$exports;
$d4e6758f087be491$var$MapCache.prototype.has = $6650c8b92c02e0d6$exports;
$d4e6758f087be491$var$MapCache.prototype.set = $c42519bfc0806ebf$exports;
$d4e6758f087be491$exports = $d4e6758f087be491$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $ffa18809d5034c03$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $ffa18809d5034c03$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $7f2c7dd9742642e0$exports) {
        var pairs = data.__data__;
        if (!$1ac484c0eeaed10e$exports || pairs.length < $ffa18809d5034c03$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $d4e6758f087be491$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$ffa18809d5034c03$exports = $ffa18809d5034c03$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7cbdce1218977e91$var$Stack(entries) {
    var data = this.__data__ = new $7f2c7dd9742642e0$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$7cbdce1218977e91$var$Stack.prototype.clear = $38b3a72f4503a8d5$exports;
$7cbdce1218977e91$var$Stack.prototype['delete'] = $999145c3bcdba4dc$exports;
$7cbdce1218977e91$var$Stack.prototype.get = $3f716e9ece3a4a7e$exports;
$7cbdce1218977e91$var$Stack.prototype.has = $0a9325c0fff3448a$exports;
$7cbdce1218977e91$var$Stack.prototype.set = $ffa18809d5034c03$exports;
$7cbdce1218977e91$exports = $7cbdce1218977e91$var$Stack;


var $1ce4e306faa356cb$exports = {};
var $d2c49809ad6e170e$exports = {};

var $dce0bf715e67581f$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $dce0bf715e67581f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dce0bf715e67581f$var$setCacheAdd(value) {
    this.__data__.set(value, $dce0bf715e67581f$var$HASH_UNDEFINED);
    return this;
}
$dce0bf715e67581f$exports = $dce0bf715e67581f$var$setCacheAdd;


var $f0fae38dced8c043$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f0fae38dced8c043$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f0fae38dced8c043$exports = $f0fae38dced8c043$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d2c49809ad6e170e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $d4e6758f087be491$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d2c49809ad6e170e$var$SetCache.prototype.add = $d2c49809ad6e170e$var$SetCache.prototype.push = $dce0bf715e67581f$exports;
$d2c49809ad6e170e$var$SetCache.prototype.has = $f0fae38dced8c043$exports;
$d2c49809ad6e170e$exports = $d2c49809ad6e170e$var$SetCache;


var $63744a28e8fd4c84$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $63744a28e8fd4c84$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$63744a28e8fd4c84$exports = $63744a28e8fd4c84$var$arraySome;


var $e5e703715ca3ea7c$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e5e703715ca3ea7c$var$cacheHas(cache, key) {
    return cache.has(key);
}
$e5e703715ca3ea7c$exports = $e5e703715ca3ea7c$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $1ce4e306faa356cb$var$COMPARE_PARTIAL_FLAG = 1, $1ce4e306faa356cb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1ce4e306faa356cb$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1ce4e306faa356cb$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1ce4e306faa356cb$var$COMPARE_UNORDERED_FLAG ? new $d2c49809ad6e170e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$63744a28e8fd4c84$exports(other, function(othValue, othIndex) {
                if (!$e5e703715ca3ea7c$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$1ce4e306faa356cb$exports = $1ce4e306faa356cb$var$equalArrays;


var $d4e9211b344c9a7a$exports = {};

var $09f8dc425a8b200b$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/** Built-in value references. */ var $09f8dc425a8b200b$var$Uint8Array = $2jpDk.Uint8Array;
$09f8dc425a8b200b$exports = $09f8dc425a8b200b$var$Uint8Array;




var $02e2a23514891b9e$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $02e2a23514891b9e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$02e2a23514891b9e$exports = $02e2a23514891b9e$var$mapToArray;


var $1360f177952adc80$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $1360f177952adc80$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$1360f177952adc80$exports = $1360f177952adc80$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d4e9211b344c9a7a$var$COMPARE_PARTIAL_FLAG = 1, $d4e9211b344c9a7a$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d4e9211b344c9a7a$var$boolTag = '[object Boolean]', $d4e9211b344c9a7a$var$dateTag = '[object Date]', $d4e9211b344c9a7a$var$errorTag = '[object Error]', $d4e9211b344c9a7a$var$mapTag = '[object Map]', $d4e9211b344c9a7a$var$numberTag = '[object Number]', $d4e9211b344c9a7a$var$regexpTag = '[object RegExp]', $d4e9211b344c9a7a$var$setTag = '[object Set]', $d4e9211b344c9a7a$var$stringTag = '[object String]', $d4e9211b344c9a7a$var$symbolTag = '[object Symbol]';
var $d4e9211b344c9a7a$var$arrayBufferTag = '[object ArrayBuffer]', $d4e9211b344c9a7a$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $d4e9211b344c9a7a$var$symbolProto = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.prototype : undefined, $d4e9211b344c9a7a$var$symbolValueOf = $d4e9211b344c9a7a$var$symbolProto ? $d4e9211b344c9a7a$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d4e9211b344c9a7a$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d4e9211b344c9a7a$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d4e9211b344c9a7a$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $09f8dc425a8b200b$exports(object), new $09f8dc425a8b200b$exports(other))) return false;
            return true;
        case $d4e9211b344c9a7a$var$boolTag:
        case $d4e9211b344c9a7a$var$dateTag:
        case $d4e9211b344c9a7a$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $59abe4f1dde57d22$exports(+object, +other);
        case $d4e9211b344c9a7a$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d4e9211b344c9a7a$var$regexpTag:
        case $d4e9211b344c9a7a$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $d4e9211b344c9a7a$var$mapTag:
            var convert = $02e2a23514891b9e$exports;
        case $d4e9211b344c9a7a$var$setTag:
            var isPartial = bitmask & $d4e9211b344c9a7a$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1360f177952adc80$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d4e9211b344c9a7a$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1ce4e306faa356cb$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $d4e9211b344c9a7a$var$symbolTag:
            if ($d4e9211b344c9a7a$var$symbolValueOf) return $d4e9211b344c9a7a$var$symbolValueOf.call(object) == $d4e9211b344c9a7a$var$symbolValueOf.call(other);
    }
    return false;
}
$d4e9211b344c9a7a$exports = $d4e9211b344c9a7a$var$equalByTag;


var $2224c020433640a0$exports = {};
var $8d7541fd0e463dc6$exports = {};
var $c63543f5c9e1db85$exports = {};
var $93eb1ba0371cd30c$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $93eb1ba0371cd30c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$93eb1ba0371cd30c$exports = $93eb1ba0371cd30c$var$arrayPush;


var $46116793eaa02c32$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $46116793eaa02c32$var$isArray = Array.isArray;
$46116793eaa02c32$exports = $46116793eaa02c32$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c63543f5c9e1db85$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $46116793eaa02c32$exports(object) ? result : $93eb1ba0371cd30c$exports(result, symbolsFunc(object));
}
$c63543f5c9e1db85$exports = $c63543f5c9e1db85$var$baseGetAllKeys;


var $2e702b29c03226bb$exports = {};
var $03b49cc04a9e0bf9$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $03b49cc04a9e0bf9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$03b49cc04a9e0bf9$exports = $03b49cc04a9e0bf9$var$arrayFilter;


var $f5556dcf7a4bbfe6$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $f5556dcf7a4bbfe6$var$stubArray() {
    return [];
}
$f5556dcf7a4bbfe6$exports = $f5556dcf7a4bbfe6$var$stubArray;


/** Used for built-in method references. */ var $2e702b29c03226bb$var$objectProto = Object.prototype;
/** Built-in value references. */ var $2e702b29c03226bb$var$propertyIsEnumerable = $2e702b29c03226bb$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2e702b29c03226bb$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $2e702b29c03226bb$var$getSymbols = !$2e702b29c03226bb$var$nativeGetSymbols ? $f5556dcf7a4bbfe6$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $03b49cc04a9e0bf9$exports($2e702b29c03226bb$var$nativeGetSymbols(object), function(symbol) {
        return $2e702b29c03226bb$var$propertyIsEnumerable.call(object, symbol);
    });
};
$2e702b29c03226bb$exports = $2e702b29c03226bb$var$getSymbols;


var $2e84fcf9f20ac983$exports = {};
var $82c78902af9d196b$exports = {};
var $5a1e00bc5b141560$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $5a1e00bc5b141560$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$5a1e00bc5b141560$exports = $5a1e00bc5b141560$var$baseTimes;


var $831a7343de17c81b$exports = {};
var $00ae986c6dc32c3a$exports = {};

var $9405d96f7f034703$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9405d96f7f034703$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$9405d96f7f034703$exports = $9405d96f7f034703$var$isObjectLike;


/** `Object#toString` result references. */ var $00ae986c6dc32c3a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $00ae986c6dc32c3a$var$baseIsArguments(value) {
    return $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $00ae986c6dc32c3a$var$argsTag;
}
$00ae986c6dc32c3a$exports = $00ae986c6dc32c3a$var$baseIsArguments;



/** Used for built-in method references. */ var $831a7343de17c81b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $831a7343de17c81b$var$hasOwnProperty = $831a7343de17c81b$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $831a7343de17c81b$var$propertyIsEnumerable = $831a7343de17c81b$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $831a7343de17c81b$var$isArguments = $00ae986c6dc32c3a$exports(function() {
    return arguments;
}()) ? $00ae986c6dc32c3a$exports : function(value) {
    return $9405d96f7f034703$exports(value) && $831a7343de17c81b$var$hasOwnProperty.call(value, 'callee') && !$831a7343de17c81b$var$propertyIsEnumerable.call(value, 'callee');
};
$831a7343de17c81b$exports = $831a7343de17c81b$var$isArguments;




var $eFJGi = parcelRequire("eFJGi");
var $ea7b709b198a2835$exports = {};
/** Used as references for various `Number` constants. */ var $ea7b709b198a2835$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ea7b709b198a2835$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ea7b709b198a2835$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ea7b709b198a2835$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ea7b709b198a2835$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ea7b709b198a2835$exports = $ea7b709b198a2835$var$isIndex;


var $d92395e90f0b7eed$exports = {};
var $c6b3bec86156229a$exports = {};

var $5b55e27769eb229f$exports = {};
/** Used as references for various `Number` constants. */ var $5b55e27769eb229f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $5b55e27769eb229f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $5b55e27769eb229f$var$MAX_SAFE_INTEGER;
}
$5b55e27769eb229f$exports = $5b55e27769eb229f$var$isLength;



/** `Object#toString` result references. */ var $c6b3bec86156229a$var$argsTag = '[object Arguments]', $c6b3bec86156229a$var$arrayTag = '[object Array]', $c6b3bec86156229a$var$boolTag = '[object Boolean]', $c6b3bec86156229a$var$dateTag = '[object Date]', $c6b3bec86156229a$var$errorTag = '[object Error]', $c6b3bec86156229a$var$funcTag = '[object Function]', $c6b3bec86156229a$var$mapTag = '[object Map]', $c6b3bec86156229a$var$numberTag = '[object Number]', $c6b3bec86156229a$var$objectTag = '[object Object]', $c6b3bec86156229a$var$regexpTag = '[object RegExp]', $c6b3bec86156229a$var$setTag = '[object Set]', $c6b3bec86156229a$var$stringTag = '[object String]', $c6b3bec86156229a$var$weakMapTag = '[object WeakMap]';
var $c6b3bec86156229a$var$arrayBufferTag = '[object ArrayBuffer]', $c6b3bec86156229a$var$dataViewTag = '[object DataView]', $c6b3bec86156229a$var$float32Tag = '[object Float32Array]', $c6b3bec86156229a$var$float64Tag = '[object Float64Array]', $c6b3bec86156229a$var$int8Tag = '[object Int8Array]', $c6b3bec86156229a$var$int16Tag = '[object Int16Array]', $c6b3bec86156229a$var$int32Tag = '[object Int32Array]', $c6b3bec86156229a$var$uint8Tag = '[object Uint8Array]', $c6b3bec86156229a$var$uint8ClampedTag = '[object Uint8ClampedArray]', $c6b3bec86156229a$var$uint16Tag = '[object Uint16Array]', $c6b3bec86156229a$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $c6b3bec86156229a$var$typedArrayTags = {};
$c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$float32Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$float64Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int8Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int16Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$int32Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint8Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint8ClampedTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint16Tag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$uint32Tag] = true;
$c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$argsTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$arrayTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$arrayBufferTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$boolTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$dataViewTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$dateTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$errorTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$funcTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$mapTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$numberTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$objectTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$regexpTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$setTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$stringTag] = $c6b3bec86156229a$var$typedArrayTags[$c6b3bec86156229a$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $c6b3bec86156229a$var$baseIsTypedArray(value) {
    return $9405d96f7f034703$exports(value) && $5b55e27769eb229f$exports(value.length) && !!$c6b3bec86156229a$var$typedArrayTags[$22b8ec638f42dca7$exports(value)];
}
$c6b3bec86156229a$exports = $c6b3bec86156229a$var$baseIsTypedArray;


var $6c87d2ec7a5b64db$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $6c87d2ec7a5b64db$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$6c87d2ec7a5b64db$exports = $6c87d2ec7a5b64db$var$baseUnary;



var $1cz3N = parcelRequire("1cz3N");
/* Node.js helper references. */ var $d92395e90f0b7eed$var$nodeIsTypedArray = $1cz3N && $1cz3N.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $d92395e90f0b7eed$var$isTypedArray = $d92395e90f0b7eed$var$nodeIsTypedArray ? $6c87d2ec7a5b64db$exports($d92395e90f0b7eed$var$nodeIsTypedArray) : $c6b3bec86156229a$exports;
$d92395e90f0b7eed$exports = $d92395e90f0b7eed$var$isTypedArray;


/** Used for built-in method references. */ var $82c78902af9d196b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $82c78902af9d196b$var$hasOwnProperty = $82c78902af9d196b$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $82c78902af9d196b$var$arrayLikeKeys(value, inherited) {
    var isArr = $46116793eaa02c32$exports(value), isArg = !isArr && $831a7343de17c81b$exports(value), isBuff = !isArr && !isArg && $eFJGi(value), isType = !isArr && !isArg && !isBuff && $d92395e90f0b7eed$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $5a1e00bc5b141560$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $82c78902af9d196b$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ea7b709b198a2835$exports(key, length)))) result.push(key);
    return result;
}
$82c78902af9d196b$exports = $82c78902af9d196b$var$arrayLikeKeys;


var $70343d667ca5cf12$exports = {};
var $ede3dc0e3cba8cac$exports = {};
/** Used for built-in method references. */ var $ede3dc0e3cba8cac$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ede3dc0e3cba8cac$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $ede3dc0e3cba8cac$var$objectProto;
    return value === proto;
}
$ede3dc0e3cba8cac$exports = $ede3dc0e3cba8cac$var$isPrototype;


var $64b4ff58317e9ed8$exports = {};
var $e5cfd6ab9c22776f$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e5cfd6ab9c22776f$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$e5cfd6ab9c22776f$exports = $e5cfd6ab9c22776f$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $64b4ff58317e9ed8$var$nativeKeys = $e5cfd6ab9c22776f$exports(Object.keys, Object);
$64b4ff58317e9ed8$exports = $64b4ff58317e9ed8$var$nativeKeys;


/** Used for built-in method references. */ var $70343d667ca5cf12$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $70343d667ca5cf12$var$hasOwnProperty = $70343d667ca5cf12$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $70343d667ca5cf12$var$baseKeys(object) {
    if (!$ede3dc0e3cba8cac$exports(object)) return $64b4ff58317e9ed8$exports(object);
    var result = [];
    for(var key in Object(object))if ($70343d667ca5cf12$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$70343d667ca5cf12$exports = $70343d667ca5cf12$var$baseKeys;


var $70a87f3bd796a6cd$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $70a87f3bd796a6cd$var$isArrayLike(value) {
    return value != null && $5b55e27769eb229f$exports(value.length) && !$4c7b1825f8a16f64$exports(value);
}
$70a87f3bd796a6cd$exports = $70a87f3bd796a6cd$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $2e84fcf9f20ac983$var$keys(object) {
    return $70a87f3bd796a6cd$exports(object) ? $82c78902af9d196b$exports(object) : $70343d667ca5cf12$exports(object);
}
$2e84fcf9f20ac983$exports = $2e84fcf9f20ac983$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8d7541fd0e463dc6$var$getAllKeys(object) {
    return $c63543f5c9e1db85$exports(object, $2e84fcf9f20ac983$exports, $2e702b29c03226bb$exports);
}
$8d7541fd0e463dc6$exports = $8d7541fd0e463dc6$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $2224c020433640a0$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $2224c020433640a0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2224c020433640a0$var$hasOwnProperty = $2224c020433640a0$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2224c020433640a0$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2224c020433640a0$var$COMPARE_PARTIAL_FLAG, objProps = $8d7541fd0e463dc6$exports(object), objLength = objProps.length, othProps = $8d7541fd0e463dc6$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $2224c020433640a0$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$2224c020433640a0$exports = $2224c020433640a0$var$equalObjects;


var $397ffb1740602045$exports = {};
var $3a8fec3239256c13$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $3a8fec3239256c13$var$DataView = $7f56803878bcc7da$exports($2jpDk, 'DataView');
$3a8fec3239256c13$exports = $3a8fec3239256c13$var$DataView;



var $ba1a06f8a2e0f960$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $ba1a06f8a2e0f960$var$Promise = $7f56803878bcc7da$exports($2jpDk, 'Promise');
$ba1a06f8a2e0f960$exports = $ba1a06f8a2e0f960$var$Promise;


var $4c1a03e269fbabc9$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $4c1a03e269fbabc9$var$Set = $7f56803878bcc7da$exports($2jpDk, 'Set');
$4c1a03e269fbabc9$exports = $4c1a03e269fbabc9$var$Set;


var $8b7614145d10ca77$exports = {};


var $2jpDk = parcelRequire("2jpDk");
/* Built-in method references that are verified to be native. */ var $8b7614145d10ca77$var$WeakMap = $7f56803878bcc7da$exports($2jpDk, 'WeakMap');
$8b7614145d10ca77$exports = $8b7614145d10ca77$var$WeakMap;




/** `Object#toString` result references. */ var $397ffb1740602045$var$mapTag = '[object Map]', $397ffb1740602045$var$objectTag = '[object Object]', $397ffb1740602045$var$promiseTag = '[object Promise]', $397ffb1740602045$var$setTag = '[object Set]', $397ffb1740602045$var$weakMapTag = '[object WeakMap]';
var $397ffb1740602045$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $397ffb1740602045$var$dataViewCtorString = $c926545e85a233a2$exports($3a8fec3239256c13$exports), $397ffb1740602045$var$mapCtorString = $c926545e85a233a2$exports($1ac484c0eeaed10e$exports), $397ffb1740602045$var$promiseCtorString = $c926545e85a233a2$exports($ba1a06f8a2e0f960$exports), $397ffb1740602045$var$setCtorString = $c926545e85a233a2$exports($4c1a03e269fbabc9$exports), $397ffb1740602045$var$weakMapCtorString = $c926545e85a233a2$exports($8b7614145d10ca77$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $397ffb1740602045$var$getTag = $22b8ec638f42dca7$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3a8fec3239256c13$exports && $397ffb1740602045$var$getTag(new $3a8fec3239256c13$exports(new ArrayBuffer(1))) != $397ffb1740602045$var$dataViewTag || $1ac484c0eeaed10e$exports && $397ffb1740602045$var$getTag(new $1ac484c0eeaed10e$exports) != $397ffb1740602045$var$mapTag || $ba1a06f8a2e0f960$exports && $397ffb1740602045$var$getTag($ba1a06f8a2e0f960$exports.resolve()) != $397ffb1740602045$var$promiseTag || $4c1a03e269fbabc9$exports && $397ffb1740602045$var$getTag(new $4c1a03e269fbabc9$exports) != $397ffb1740602045$var$setTag || $8b7614145d10ca77$exports && $397ffb1740602045$var$getTag(new $8b7614145d10ca77$exports) != $397ffb1740602045$var$weakMapTag) $397ffb1740602045$var$getTag = function(value) {
    var result = $22b8ec638f42dca7$exports(value), Ctor = result == $397ffb1740602045$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $c926545e85a233a2$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $397ffb1740602045$var$dataViewCtorString:
            return $397ffb1740602045$var$dataViewTag;
        case $397ffb1740602045$var$mapCtorString:
            return $397ffb1740602045$var$mapTag;
        case $397ffb1740602045$var$promiseCtorString:
            return $397ffb1740602045$var$promiseTag;
        case $397ffb1740602045$var$setCtorString:
            return $397ffb1740602045$var$setTag;
        case $397ffb1740602045$var$weakMapCtorString:
            return $397ffb1740602045$var$weakMapTag;
    }
    return result;
};
$397ffb1740602045$exports = $397ffb1740602045$var$getTag;




var $eFJGi = parcelRequire("eFJGi");

/** Used to compose bitmasks for value comparisons. */ var $e4e3f2df1701baeb$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e4e3f2df1701baeb$var$argsTag = '[object Arguments]', $e4e3f2df1701baeb$var$arrayTag = '[object Array]', $e4e3f2df1701baeb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e4e3f2df1701baeb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4e3f2df1701baeb$var$hasOwnProperty = $e4e3f2df1701baeb$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e4e3f2df1701baeb$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $46116793eaa02c32$exports(object), othIsArr = $46116793eaa02c32$exports(other), objTag = objIsArr ? $e4e3f2df1701baeb$var$arrayTag : $397ffb1740602045$exports(object), othTag = othIsArr ? $e4e3f2df1701baeb$var$arrayTag : $397ffb1740602045$exports(other);
    objTag = objTag == $e4e3f2df1701baeb$var$argsTag ? $e4e3f2df1701baeb$var$objectTag : objTag;
    othTag = othTag == $e4e3f2df1701baeb$var$argsTag ? $e4e3f2df1701baeb$var$objectTag : othTag;
    var objIsObj = objTag == $e4e3f2df1701baeb$var$objectTag, othIsObj = othTag == $e4e3f2df1701baeb$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $eFJGi(object)) {
        if (!$eFJGi(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $7cbdce1218977e91$exports);
        return objIsArr || $d92395e90f0b7eed$exports(object) ? $1ce4e306faa356cb$exports(object, other, bitmask, customizer, equalFunc, stack) : $d4e9211b344c9a7a$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e4e3f2df1701baeb$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e4e3f2df1701baeb$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e4e3f2df1701baeb$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $7cbdce1218977e91$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $7cbdce1218977e91$exports);
    return $2224c020433640a0$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e4e3f2df1701baeb$exports = $e4e3f2df1701baeb$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $319a4f523286b934$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$9405d96f7f034703$exports(value) && !$9405d96f7f034703$exports(other)) return value !== value && other !== other;
    return $e4e3f2df1701baeb$exports(value, other, bitmask, customizer, $319a4f523286b934$var$baseIsEqual, stack);
}
$319a4f523286b934$exports = $319a4f523286b934$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $5443d49d3d139f56$var$isEqual(value, other) {
    return $319a4f523286b934$exports(value, other);
}
$5443d49d3d139f56$exports = $5443d49d3d139f56$var$isEqual;


var $19a6b838e2f2c525$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $19a6b838e2f2c525$var$isNil(value) {
    return value == null;
}
$19a6b838e2f2c525$exports = $19a6b838e2f2c525$var$isNil;



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");
var $cb1822b0eadf52f8$exports = {};
var $1378bbdee3372fdb$exports = {};
var $c3e51feb30e3ace0$exports = {};

var $6b74c0782c00dd69$exports = {};

var $8fab81ce33077160$exports = {};


/** `Object#toString` result references. */ var $8fab81ce33077160$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8fab81ce33077160$var$isSymbol(value) {
    return typeof value == 'symbol' || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $8fab81ce33077160$var$symbolTag;
}
$8fab81ce33077160$exports = $8fab81ce33077160$var$isSymbol;


/** Used to match property names within property paths. */ var $6b74c0782c00dd69$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $6b74c0782c00dd69$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $6b74c0782c00dd69$var$isKey(value, object) {
    if ($46116793eaa02c32$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $8fab81ce33077160$exports(value)) return true;
    return $6b74c0782c00dd69$var$reIsPlainProp.test(value) || !$6b74c0782c00dd69$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$6b74c0782c00dd69$exports = $6b74c0782c00dd69$var$isKey;


var $9d65ec3c6b614ffd$exports = {};
var $e0bc53e005c763a4$exports = {};
var $c273302ab84aa29a$exports = {};

/** Error message constants. */ var $c273302ab84aa29a$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c273302ab84aa29a$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c273302ab84aa29a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c273302ab84aa29a$var$memoize.Cache || $d4e6758f087be491$exports);
    return memoized;
}
// Expose `MapCache`.
$c273302ab84aa29a$var$memoize.Cache = $d4e6758f087be491$exports;
$c273302ab84aa29a$exports = $c273302ab84aa29a$var$memoize;


/** Used as the maximum memoize cache size. */ var $e0bc53e005c763a4$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e0bc53e005c763a4$var$memoizeCapped(func) {
    var result = $c273302ab84aa29a$exports(func, function(key) {
        if (cache.size === $e0bc53e005c763a4$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$e0bc53e005c763a4$exports = $e0bc53e005c763a4$var$memoizeCapped;


/** Used to match property names within property paths. */ var $9d65ec3c6b614ffd$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $9d65ec3c6b614ffd$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $9d65ec3c6b614ffd$var$stringToPath = $e0bc53e005c763a4$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($9d65ec3c6b614ffd$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($9d65ec3c6b614ffd$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$9d65ec3c6b614ffd$exports = $9d65ec3c6b614ffd$var$stringToPath;


var $2854456ba4e51b7a$exports = {};
var $f98b1794ede2b410$exports = {};

var $9fd738eaa74f3638$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9fd738eaa74f3638$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$9fd738eaa74f3638$exports = $9fd738eaa74f3638$var$arrayMap;




/** Used as references for various `Number` constants. */ var $f98b1794ede2b410$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f98b1794ede2b410$var$symbolProto = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.prototype : undefined, $f98b1794ede2b410$var$symbolToString = $f98b1794ede2b410$var$symbolProto ? $f98b1794ede2b410$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f98b1794ede2b410$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($46116793eaa02c32$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $9fd738eaa74f3638$exports(value, $f98b1794ede2b410$var$baseToString) + '';
    if ($8fab81ce33077160$exports(value)) return $f98b1794ede2b410$var$symbolToString ? $f98b1794ede2b410$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f98b1794ede2b410$var$INFINITY ? '-0' : result;
}
$f98b1794ede2b410$exports = $f98b1794ede2b410$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $2854456ba4e51b7a$var$toString(value) {
    return value == null ? '' : $f98b1794ede2b410$exports(value);
}
$2854456ba4e51b7a$exports = $2854456ba4e51b7a$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $c3e51feb30e3ace0$var$castPath(value, object) {
    if ($46116793eaa02c32$exports(value)) return value;
    return $6b74c0782c00dd69$exports(value, object) ? [
        value
    ] : $9d65ec3c6b614ffd$exports($2854456ba4e51b7a$exports(value));
}
$c3e51feb30e3ace0$exports = $c3e51feb30e3ace0$var$castPath;


var $696bce860a809156$exports = {};

/** Used as references for various `Number` constants. */ var $696bce860a809156$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $696bce860a809156$var$toKey(value) {
    if (typeof value == 'string' || $8fab81ce33077160$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$696bce860a809156$var$INFINITY ? '-0' : result;
}
$696bce860a809156$exports = $696bce860a809156$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $1378bbdee3372fdb$var$baseGet(object, path) {
    path = $c3e51feb30e3ace0$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$696bce860a809156$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$1378bbdee3372fdb$exports = $1378bbdee3372fdb$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $cb1822b0eadf52f8$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $1378bbdee3372fdb$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$cb1822b0eadf52f8$exports = $cb1822b0eadf52f8$var$get;



var $187d420db4e9f7fe$exports = {};



/** `Object#toString` result references. */ var $187d420db4e9f7fe$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $187d420db4e9f7fe$var$isString(value) {
    return typeof value == 'string' || !$46116793eaa02c32$exports(value) && $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $187d420db4e9f7fe$var$stringTag;
}
$187d420db4e9f7fe$exports = $187d420db4e9f7fe$var$isString;





var $8nGP5 = parcelRequire("8nGP5");
var $a21b66e3b05a06f0$exports = {};
'use strict';

$a21b66e3b05a06f0$exports = (parcelRequire("gdOjy"));



var $5fa94942c48bac63$exports = {};
var $5bcb1a33d8b181b4$exports = {};


/** `Object#toString` result references. */ var $5bcb1a33d8b181b4$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $5bcb1a33d8b181b4$var$isNumber(value) {
    return typeof value == 'number' || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $5bcb1a33d8b181b4$var$numberTag;
}
$5bcb1a33d8b181b4$exports = $5bcb1a33d8b181b4$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $5fa94942c48bac63$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $5bcb1a33d8b181b4$exports(value) && value != +value;
}
$5fa94942c48bac63$exports = $5fa94942c48bac63$var$isNaN;




var $3d08f6c3b4eab1e3$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $3d08f6c3b4eab1e3$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $3d08f6c3b4eab1e3$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5bcb1a33d8b181b4$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(value);
};
var $3d08f6c3b4eab1e3$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $3d08f6c3b4eab1e3$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(value);
};
var $3d08f6c3b4eab1e3$var$idCounter = 0;
var $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$3d08f6c3b4eab1e3$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $3d08f6c3b4eab1e3$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$3d08f6c3b4eab1e3$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(percent)) return defaultValue;
    var value;
    if ($3d08f6c3b4eab1e3$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $3d08f6c3b4eab1e3$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $3d08f6c3b4eab1e3$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $3d08f6c3b4eab1e3$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($3d08f6c3b4eab1e3$export$7e4aa119212bc614(numberA) && $3d08f6c3b4eab1e3$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $3d08f6c3b4eab1e3$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $3d08f6c3b4eab1e3$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $3d08f6c3b4eab1e3$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($3d08f6c3b4eab1e3$export$7e4aa119212bc614(a) && $3d08f6c3b4eab1e3$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};


function $0e7c207b469fdda3$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $8nGP5 = parcelRequire("8nGP5");

function $f1d44a0cc6cff721$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f1d44a0cc6cff721$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f1d44a0cc6cff721$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $f1d44a0cc6cff721$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $f1d44a0cc6cff721$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $f1d44a0cc6cff721$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $f1d44a0cc6cff721$export$2b22758266a6fa48 = {
    svg: $f1d44a0cc6cff721$var$SVGContainerPropKeys,
    polygon: $f1d44a0cc6cff721$var$PolyElementKeys,
    polyline: $f1d44a0cc6cff721$var$PolyElementKeys
};
var $f1d44a0cc6cff721$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($f1d44a0cc6cff721$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $f1d44a0cc6cff721$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $f1d44a0cc6cff721$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(props) || $f1d44a0cc6cff721$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($f1d44a0cc6cff721$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $f1d44a0cc6cff721$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $8b99c43c69c5c37b$var$_excluded = [
    "children"
], $8b99c43c69c5c37b$var$_excluded2 = [
    "children"
];
function $8b99c43c69c5c37b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8b99c43c69c5c37b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8b99c43c69c5c37b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8b99c43c69c5c37b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b99c43c69c5c37b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b99c43c69c5c37b$var$_typeof(o);
}
var $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $8b99c43c69c5c37b$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $8b99c43c69c5c37b$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $8b99c43c69c5c37b$export$59a4d7d024cf1025 = [
    'none'
];
var $8b99c43c69c5c37b$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $8b99c43c69c5c37b$var$lastChildren = null;
var $8b99c43c69c5c37b$var$lastResult = null;
var $8b99c43c69c5c37b$export$45b10814cc054894 = function toArray(children) {
    if (children === $8b99c43c69c5c37b$var$lastChildren && Array.isArray($8b99c43c69c5c37b$var$lastResult)) return $8b99c43c69c5c37b$var$lastResult;
    var result = [];
    (0, $8nGP5.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(child)) return;
        if ((0, $a21b66e3b05a06f0$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $8b99c43c69c5c37b$var$lastResult = result;
    $8b99c43c69c5c37b$var$lastChildren = children;
    return result;
};
function $8b99c43c69c5c37b$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $8b99c43c69c5c37b$export$be63e0664592e141(t);
    });
    else types = [
        $8b99c43c69c5c37b$export$be63e0664592e141(type)
    ];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $8b99c43c69c5c37b$export$64c61536a2b72e0f(children, type) {
    var result = $8b99c43c69c5c37b$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $8b99c43c69c5c37b$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $8b99c43c69c5c37b$export$be63e0664592e141(t);
    });
    else types = [
        $8b99c43c69c5c37b$export$be63e0664592e141(type)
    ];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $8b99c43c69c5c37b$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $8b99c43c69c5c37b$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $8b99c43c69c5c37b$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(child.type) && $8b99c43c69c5c37b$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $8b99c43c69c5c37b$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $8b99c43c69c5c37b$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $8b99c43c69c5c37b$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $f1d44a0cc6cff721$export$2b22758266a6fa48) === null || (0, $f1d44a0cc6cff721$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $f1d44a0cc6cff721$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $f1d44a0cc6cff721$export$190f430946f96110).includes(key)) || includeEvents && (0, $f1d44a0cc6cff721$export$f30789245f2c4d11).includes(key);
};
var $8b99c43c69c5c37b$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(entry) {
        if ($8b99c43c69c5c37b$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $8b99c43c69c5c37b$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($8b99c43c69c5c37b$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $8b99c43c69c5c37b$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $8nGP5.Children).count(nextChildren);
    if (count !== (0, $8nGP5.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $8b99c43c69c5c37b$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$8b99c43c69c5c37b$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $8b99c43c69c5c37b$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $8b99c43c69c5c37b$var$_objectWithoutProperties(_ref, $8b99c43c69c5c37b$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $8b99c43c69c5c37b$var$_objectWithoutProperties(_ref2, $8b99c43c69c5c37b$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextProps, prevProps) && $8b99c43c69c5c37b$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $8b99c43c69c5c37b$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $8b99c43c69c5c37b$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($8b99c43c69c5c37b$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $8b99c43c69c5c37b$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $8b99c43c69c5c37b$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP[type]) return $8b99c43c69c5c37b$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $8b99c43c69c5c37b$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $8b99c43c69c5c37b$export$45b10814cc054894(children).indexOf(child);
};


var $9147c7844befd856$var$_excluded = [
    "children",
    "className"
];
function $9147c7844befd856$var$_extends() {
    $9147c7844befd856$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9147c7844befd856$var$_extends.apply(this, arguments);
}
function $9147c7844befd856$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9147c7844befd856$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9147c7844befd856$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9147c7844befd856$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $9147c7844befd856$var$_objectWithoutProperties(props, $9147c7844befd856$var$_excluded);
    var layerClass = (0, $ajIhI.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", $9147c7844befd856$var$_extends({
        className: layerClass
    }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $8nGP5 = parcelRequire("8nGP5");
var $0c84d2c5e90079cb$var$isProduction = true;
var $0c84d2c5e90079cb$var$prefix = 'Invariant failed';
function $0c84d2c5e90079cb$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0c84d2c5e90079cb$var$isProduction) throw new Error($0c84d2c5e90079cb$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0c84d2c5e90079cb$var$prefix, ": ").concat(provided) : $0c84d2c5e90079cb$var$prefix;
    throw new Error(value);
}




var $d0e02a4abf979d13$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $d0e02a4abf979d13$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d0e02a4abf979d13$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d0e02a4abf979d13$var$_typeof(o);
}
function $d0e02a4abf979d13$var$_extends() {
    $d0e02a4abf979d13$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d0e02a4abf979d13$var$_extends.apply(this, arguments);
}
function $d0e02a4abf979d13$var$_slicedToArray(arr, i) {
    return $d0e02a4abf979d13$var$_arrayWithHoles(arr) || $d0e02a4abf979d13$var$_iterableToArrayLimit(arr, i) || $d0e02a4abf979d13$var$_unsupportedIterableToArray(arr, i) || $d0e02a4abf979d13$var$_nonIterableRest();
}
function $d0e02a4abf979d13$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d0e02a4abf979d13$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d0e02a4abf979d13$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d0e02a4abf979d13$var$_arrayLikeToArray(o, minLen);
}
function $d0e02a4abf979d13$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d0e02a4abf979d13$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d0e02a4abf979d13$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d0e02a4abf979d13$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d0e02a4abf979d13$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d0e02a4abf979d13$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d0e02a4abf979d13$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0e02a4abf979d13$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d0e02a4abf979d13$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d0e02a4abf979d13$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0e02a4abf979d13$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0e02a4abf979d13$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d0e02a4abf979d13$var$_callSuper(t, o, e) {
    return o = $d0e02a4abf979d13$var$_getPrototypeOf(o), $d0e02a4abf979d13$var$_possibleConstructorReturn(t, $d0e02a4abf979d13$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $d0e02a4abf979d13$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $d0e02a4abf979d13$var$_possibleConstructorReturn(self, call) {
    if (call && ($d0e02a4abf979d13$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $d0e02a4abf979d13$var$_assertThisInitialized(self);
}
function $d0e02a4abf979d13$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d0e02a4abf979d13$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d0e02a4abf979d13$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d0e02a4abf979d13$var$_getPrototypeOf(o) {
    $d0e02a4abf979d13$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d0e02a4abf979d13$var$_getPrototypeOf(o);
}
function $d0e02a4abf979d13$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $d0e02a4abf979d13$var$_setPrototypeOf(subClass, superClass);
}
function $d0e02a4abf979d13$var$_setPrototypeOf(o, p) {
    $d0e02a4abf979d13$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0e02a4abf979d13$var$_setPrototypeOf(o, p);
}
function $d0e02a4abf979d13$var$_defineProperty(obj, key, value) {
    key = $d0e02a4abf979d13$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d0e02a4abf979d13$var$_toPropertyKey(t) {
    var i = $d0e02a4abf979d13$var$_toPrimitive(t, "string");
    return "symbol" == $d0e02a4abf979d13$var$_typeof(i) ? i : i + "";
}
function $d0e02a4abf979d13$var$_toPrimitive(t, r) {
    if ("object" != $d0e02a4abf979d13$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d0e02a4abf979d13$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d0e02a4abf979d13$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $d0e02a4abf979d13$var$_classCallCheck(this, ErrorBar);
        return $d0e02a4abf979d13$var$_callSuper(this, ErrorBar, arguments);
    }
    $d0e02a4abf979d13$var$_inherits(ErrorBar, _React$Component);
    return $d0e02a4abf979d13$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $d0e02a4abf979d13$var$_objectWithoutProperties(_this$props, $d0e02a4abf979d13$var$_excluded);
                var svgProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $d0e02a4abf979d13$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $d0e02a4abf979d13$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $d0e02a4abf979d13$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$d0e02a4abf979d13$var$_defineProperty($d0e02a4abf979d13$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$d0e02a4abf979d13$var$_defineProperty($d0e02a4abf979d13$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');


/**
 * @fileOverview Cross
 */ var $94307f62a0d95f57$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$94307f62a0d95f57$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $8nGP5 = parcelRequire("8nGP5");



var $ef7c13d61ecebd89$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $ef7c13d61ecebd89$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$ef7c13d61ecebd89$exports = $ef7c13d61ecebd89$var$last;



var $8nGP5 = parcelRequire("8nGP5");




var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");

var $863769adbc4b0799$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $863769adbc4b0799$export$98f03c5d19621d70 = {
    isSsr: $863769adbc4b0799$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $863769adbc4b0799$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $863769adbc4b0799$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $863769adbc4b0799$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $afcbff65789b5460$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $afcbff65789b5460$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $afcbff65789b5460$var$_typeof(o);
}
function $afcbff65789b5460$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $afcbff65789b5460$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $afcbff65789b5460$var$ownKeys(Object(t), !0).forEach(function(r) {
            $afcbff65789b5460$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $afcbff65789b5460$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $afcbff65789b5460$var$_defineProperty(obj, key, value) {
    key = $afcbff65789b5460$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $afcbff65789b5460$var$_toPropertyKey(t) {
    var i = $afcbff65789b5460$var$_toPrimitive(t, "string");
    return "symbol" == $afcbff65789b5460$var$_typeof(i) ? i : i + "";
}
function $afcbff65789b5460$var$_toPrimitive(t, r) {
    if ("object" != $afcbff65789b5460$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $afcbff65789b5460$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $afcbff65789b5460$var$_toConsumableArray(arr) {
    return $afcbff65789b5460$var$_arrayWithoutHoles(arr) || $afcbff65789b5460$var$_iterableToArray(arr) || $afcbff65789b5460$var$_unsupportedIterableToArray(arr) || $afcbff65789b5460$var$_nonIterableSpread();
}
function $afcbff65789b5460$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $afcbff65789b5460$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $afcbff65789b5460$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $afcbff65789b5460$var$_arrayLikeToArray(o, minLen);
}
function $afcbff65789b5460$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $afcbff65789b5460$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $afcbff65789b5460$var$_arrayLikeToArray(arr);
}
function $afcbff65789b5460$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $afcbff65789b5460$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $afcbff65789b5460$var$MAX_CACHE_NUM = 2000;
var $afcbff65789b5460$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $afcbff65789b5460$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $afcbff65789b5460$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $afcbff65789b5460$var$autoCompleteStyle(name, value) {
    if ($afcbff65789b5460$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $afcbff65789b5460$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($afcbff65789b5460$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($afcbff65789b5460$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $afcbff65789b5460$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($afcbff65789b5460$var$camelToMiddleLine(s), ":").concat($afcbff65789b5460$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $afcbff65789b5460$var$removeInvalidKeys(obj) {
    var copyObj = $afcbff65789b5460$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $afcbff65789b5460$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $afcbff65789b5460$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($afcbff65789b5460$var$stringCache.widthCache[cacheKey]) return $afcbff65789b5460$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($afcbff65789b5460$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $afcbff65789b5460$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $afcbff65789b5460$var$_objectSpread($afcbff65789b5460$var$_objectSpread({}, $afcbff65789b5460$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $afcbff65789b5460$var$stringCache.widthCache[cacheKey] = result;
        if (++$afcbff65789b5460$var$stringCache.cacheCount > $afcbff65789b5460$var$MAX_CACHE_NUM) {
            $afcbff65789b5460$var$stringCache.cacheCount = 0;
            $afcbff65789b5460$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $afcbff65789b5460$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $0c5a8338a63fb7e5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c5a8338a63fb7e5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c5a8338a63fb7e5$var$_typeof(o);
}
function $0c5a8338a63fb7e5$var$_slicedToArray(arr, i) {
    return $0c5a8338a63fb7e5$var$_arrayWithHoles(arr) || $0c5a8338a63fb7e5$var$_iterableToArrayLimit(arr, i) || $0c5a8338a63fb7e5$var$_unsupportedIterableToArray(arr, i) || $0c5a8338a63fb7e5$var$_nonIterableRest();
}
function $0c5a8338a63fb7e5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0c5a8338a63fb7e5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0c5a8338a63fb7e5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0c5a8338a63fb7e5$var$_arrayLikeToArray(o, minLen);
}
function $0c5a8338a63fb7e5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0c5a8338a63fb7e5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0c5a8338a63fb7e5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0c5a8338a63fb7e5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0c5a8338a63fb7e5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0c5a8338a63fb7e5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0c5a8338a63fb7e5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0c5a8338a63fb7e5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0c5a8338a63fb7e5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0c5a8338a63fb7e5$var$_toPropertyKey(t) {
    var i = $0c5a8338a63fb7e5$var$_toPrimitive(t, "string");
    return "symbol" == $0c5a8338a63fb7e5$var$_typeof(i) ? i : i + "";
}
function $0c5a8338a63fb7e5$var$_toPrimitive(t, r) {
    if ("object" != $0c5a8338a63fb7e5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0c5a8338a63fb7e5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $0c5a8338a63fb7e5$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $0c5a8338a63fb7e5$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $0c5a8338a63fb7e5$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $0c5a8338a63fb7e5$var$FIXED_CSS_LENGTH_UNITS = Object.keys($0c5a8338a63fb7e5$var$CONVERSION_RATES);
var $0c5a8338a63fb7e5$var$STR_NAN = 'NaN';
function $0c5a8338a63fb7e5$var$convertToPx(value, unit) {
    return value * $0c5a8338a63fb7e5$var$CONVERSION_RATES[unit];
}
var $0c5a8338a63fb7e5$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $0c5a8338a63fb7e5$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$0c5a8338a63fb7e5$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($0c5a8338a63fb7e5$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $0c5a8338a63fb7e5$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $0c5a8338a63fb7e5$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $0c5a8338a63fb7e5$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $0c5a8338a63fb7e5$var$calculateArithmetic(expr) {
    if (expr.includes($0c5a8338a63fb7e5$var$STR_NAN)) return $0c5a8338a63fb7e5$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $0c5a8338a63fb7e5$var$STR_NAN;
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $0c5a8338a63fb7e5$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $0c5a8338a63fb7e5$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $0c5a8338a63fb7e5$var$STR_NAN;
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $0c5a8338a63fb7e5$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $0c5a8338a63fb7e5$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $0c5a8338a63fb7e5$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $0c5a8338a63fb7e5$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($0c5a8338a63fb7e5$var$PARENTHESES_REGEX, $0c5a8338a63fb7e5$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $0c5a8338a63fb7e5$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $0c5a8338a63fb7e5$var$calculateParentheses(newExpr);
    newExpr = $0c5a8338a63fb7e5$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $0c5a8338a63fb7e5$export$c891f73c9c6d00c9(expression) {
    try {
        return $0c5a8338a63fb7e5$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $0c5a8338a63fb7e5$var$STR_NAN;
    }
}
function $0c5a8338a63fb7e5$export$254eac204f89fd7d(expression) {
    var result = $0c5a8338a63fb7e5$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $0c5a8338a63fb7e5$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $844463820b79d851$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $844463820b79d851$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $844463820b79d851$var$_extends() {
    $844463820b79d851$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $844463820b79d851$var$_extends.apply(this, arguments);
}
function $844463820b79d851$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $844463820b79d851$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $844463820b79d851$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $844463820b79d851$var$_slicedToArray(arr, i) {
    return $844463820b79d851$var$_arrayWithHoles(arr) || $844463820b79d851$var$_iterableToArrayLimit(arr, i) || $844463820b79d851$var$_unsupportedIterableToArray(arr, i) || $844463820b79d851$var$_nonIterableRest();
}
function $844463820b79d851$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $844463820b79d851$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $844463820b79d851$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $844463820b79d851$var$_arrayLikeToArray(o, minLen);
}
function $844463820b79d851$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $844463820b79d851$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $844463820b79d851$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $844463820b79d851$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $844463820b79d851$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($844463820b79d851$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $afcbff65789b5460$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $afcbff65789b5460$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $844463820b79d851$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $844463820b79d851$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $844463820b79d851$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $844463820b79d851$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $844463820b79d851$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children) ? children.toString().split($844463820b79d851$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $844463820b79d851$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $844463820b79d851$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $844463820b79d851$var$getWordsWithoutCalculate(children);
        return $844463820b79d851$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $844463820b79d851$var$getWordsWithoutCalculate(children);
};
var $844463820b79d851$var$DEFAULT_FILL = '#808080';
var $844463820b79d851$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $844463820b79d851$var$DEFAULT_FILL : _ref5$fill, props = $844463820b79d851$var$_objectWithoutProperties(_ref5, $844463820b79d851$var$_excluded);
    var wordsByLines = (0, $8nGP5.useMemo)(function() {
        return $844463820b79d851$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $844463820b79d851$var$_objectWithoutProperties(props, $844463820b79d851$var$_excluded2);
    if (!(0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(propsX) || !(0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $0c5a8338a63fb7e5$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("text", $844463820b79d851$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $ajIhI.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $844463820b79d851$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $8nGP5 = parcelRequire("8nGP5");


var $5389c27663bb3a0e$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$5389c27663bb3a0e$exports = (parcelRequire("1xE3P"));


var $4efdaf596664c2fb$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$4efdaf596664c2fb$exports = (parcelRequire("jR8B9"));


var $16a263dc7ad650d9$exports = {};
var $a5f8c8545678430c$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $a5f8c8545678430c$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8fab81ce33077160$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$a5f8c8545678430c$exports = $a5f8c8545678430c$var$baseExtremum;


var $697c572969d07084$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $697c572969d07084$var$baseGt(value, other) {
    return value > other;
}
$697c572969d07084$exports = $697c572969d07084$var$baseGt;


var $5cab5b412769001e$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $5cab5b412769001e$var$identity(value) {
    return value;
}
$5cab5b412769001e$exports = $5cab5b412769001e$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $16a263dc7ad650d9$var$max(array) {
    return array && array.length ? $a5f8c8545678430c$exports(array, $5cab5b412769001e$exports, $697c572969d07084$exports) : undefined;
}
$16a263dc7ad650d9$exports = $16a263dc7ad650d9$var$max;


var $68f8d6cfd642a3d7$exports = {};

var $82ee23cbf0c7be99$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $82ee23cbf0c7be99$var$baseLt(value, other) {
    return value < other;
}
$82ee23cbf0c7be99$exports = $82ee23cbf0c7be99$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $68f8d6cfd642a3d7$var$min(array) {
    return array && array.length ? $a5f8c8545678430c$exports(array, $5cab5b412769001e$exports, $82ee23cbf0c7be99$exports) : undefined;
}
$68f8d6cfd642a3d7$exports = $68f8d6cfd642a3d7$var$min;






var $ce626f03865ef5d1$exports = {};
var $dcd699742a532aa9$exports = {};

var $1db7dd8c21ff64f4$exports = {};



/** Built-in value references. */ var $1db7dd8c21ff64f4$var$spreadableSymbol = $d932e958496f67e8$exports ? $d932e958496f67e8$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $1db7dd8c21ff64f4$var$isFlattenable(value) {
    return $46116793eaa02c32$exports(value) || $831a7343de17c81b$exports(value) || !!($1db7dd8c21ff64f4$var$spreadableSymbol && value && value[$1db7dd8c21ff64f4$var$spreadableSymbol]);
}
$1db7dd8c21ff64f4$exports = $1db7dd8c21ff64f4$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $dcd699742a532aa9$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $1db7dd8c21ff64f4$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $dcd699742a532aa9$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $93eb1ba0371cd30c$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$dcd699742a532aa9$exports = $dcd699742a532aa9$var$baseFlatten;


var $19c32bf6b9804e62$exports = {};

var $6aa52744a9ab51b8$exports = {};
var $7391754aeef62814$exports = {};
var $b05f87b265eaa1b9$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $b05f87b265eaa1b9$var$COMPARE_PARTIAL_FLAG = 1, $b05f87b265eaa1b9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $b05f87b265eaa1b9$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $7cbdce1218977e91$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $319a4f523286b934$exports(srcValue, objValue, $b05f87b265eaa1b9$var$COMPARE_PARTIAL_FLAG | $b05f87b265eaa1b9$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$b05f87b265eaa1b9$exports = $b05f87b265eaa1b9$var$baseIsMatch;


var $e974065d649a8bdc$exports = {};
var $4cdcaa293be7a027$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $4cdcaa293be7a027$var$isStrictComparable(value) {
    return value === value && !$4679825e1cdd07bc$exports(value);
}
$4cdcaa293be7a027$exports = $4cdcaa293be7a027$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $e974065d649a8bdc$var$getMatchData(object) {
    var result = $2e84fcf9f20ac983$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $4cdcaa293be7a027$exports(value)
        ];
    }
    return result;
}
$e974065d649a8bdc$exports = $e974065d649a8bdc$var$getMatchData;


var $bfd06d716f20e505$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $bfd06d716f20e505$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$bfd06d716f20e505$exports = $bfd06d716f20e505$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $7391754aeef62814$var$baseMatches(source) {
    var matchData = $e974065d649a8bdc$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $bfd06d716f20e505$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $b05f87b265eaa1b9$exports(object, source, matchData);
    };
}
$7391754aeef62814$exports = $7391754aeef62814$var$baseMatches;


var $506ddeba8a5cf470$exports = {};


var $eb43c4c7d5c912d2$exports = {};
var $ed3d94793c08c9a8$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ed3d94793c08c9a8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ed3d94793c08c9a8$exports = $ed3d94793c08c9a8$var$baseHasIn;


var $55cbad4ee8bb0cfb$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $55cbad4ee8bb0cfb$var$hasPath(object, path, hasFunc) {
    path = $c3e51feb30e3ace0$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $696bce860a809156$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5b55e27769eb229f$exports(length) && $ea7b709b198a2835$exports(key, length) && ($46116793eaa02c32$exports(object) || $831a7343de17c81b$exports(object));
}
$55cbad4ee8bb0cfb$exports = $55cbad4ee8bb0cfb$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $eb43c4c7d5c912d2$var$hasIn(object, path) {
    return object != null && $55cbad4ee8bb0cfb$exports(object, path, $ed3d94793c08c9a8$exports);
}
$eb43c4c7d5c912d2$exports = $eb43c4c7d5c912d2$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $506ddeba8a5cf470$var$COMPARE_PARTIAL_FLAG = 1, $506ddeba8a5cf470$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $506ddeba8a5cf470$var$baseMatchesProperty(path, srcValue) {
    if ($6b74c0782c00dd69$exports(path) && $4cdcaa293be7a027$exports(srcValue)) return $bfd06d716f20e505$exports($696bce860a809156$exports(path), srcValue);
    return function(object) {
        var objValue = $cb1822b0eadf52f8$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $eb43c4c7d5c912d2$exports(object, path) : $319a4f523286b934$exports(srcValue, objValue, $506ddeba8a5cf470$var$COMPARE_PARTIAL_FLAG | $506ddeba8a5cf470$var$COMPARE_UNORDERED_FLAG);
    };
}
$506ddeba8a5cf470$exports = $506ddeba8a5cf470$var$baseMatchesProperty;




var $166d88ea8445df76$exports = {};
var $4ee6ae10e8830287$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4ee6ae10e8830287$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$4ee6ae10e8830287$exports = $4ee6ae10e8830287$var$baseProperty;


var $871249e1c0a017db$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $871249e1c0a017db$var$basePropertyDeep(path) {
    return function(object) {
        return $1378bbdee3372fdb$exports(object, path);
    };
}
$871249e1c0a017db$exports = $871249e1c0a017db$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $166d88ea8445df76$var$property(path) {
    return $6b74c0782c00dd69$exports(path) ? $4ee6ae10e8830287$exports($696bce860a809156$exports(path)) : $871249e1c0a017db$exports(path);
}
$166d88ea8445df76$exports = $166d88ea8445df76$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $6aa52744a9ab51b8$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $5cab5b412769001e$exports;
    if (typeof value == 'object') return $46116793eaa02c32$exports(value) ? $506ddeba8a5cf470$exports(value[0], value[1]) : $7391754aeef62814$exports(value);
    return $166d88ea8445df76$exports(value);
}
$6aa52744a9ab51b8$exports = $6aa52744a9ab51b8$var$baseIteratee;


var $bd274b9519243073$exports = {};
var $f1008ccff5feed7a$exports = {};
var $34c69bd8a346e2bb$exports = {};
var $e517e993f90f8988$exports = {};
var $d9fabc146d8d5ada$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d9fabc146d8d5ada$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$d9fabc146d8d5ada$exports = $d9fabc146d8d5ada$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e517e993f90f8988$var$baseFor = $d9fabc146d8d5ada$exports();
$e517e993f90f8988$exports = $e517e993f90f8988$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34c69bd8a346e2bb$var$baseForOwn(object, iteratee) {
    return object && $e517e993f90f8988$exports(object, iteratee, $2e84fcf9f20ac983$exports);
}
$34c69bd8a346e2bb$exports = $34c69bd8a346e2bb$var$baseForOwn;


var $d5d90ceb4314d0a2$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d5d90ceb4314d0a2$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$70a87f3bd796a6cd$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$d5d90ceb4314d0a2$exports = $d5d90ceb4314d0a2$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $f1008ccff5feed7a$var$baseEach = $d5d90ceb4314d0a2$exports($34c69bd8a346e2bb$exports);
$f1008ccff5feed7a$exports = $f1008ccff5feed7a$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $bd274b9519243073$var$baseMap(collection, iteratee) {
    var index = -1, result = $70a87f3bd796a6cd$exports(collection) ? Array(collection.length) : [];
    $f1008ccff5feed7a$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$bd274b9519243073$exports = $bd274b9519243073$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $19c32bf6b9804e62$var$map(collection, iteratee) {
    var func = $46116793eaa02c32$exports(collection) ? $9fd738eaa74f3638$exports : $bd274b9519243073$exports;
    return func(collection, $6aa52744a9ab51b8$exports(iteratee, 3));
}
$19c32bf6b9804e62$exports = $19c32bf6b9804e62$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $ce626f03865ef5d1$var$flatMap(collection, iteratee) {
    return $dcd699742a532aa9$exports($19c32bf6b9804e62$exports(collection, iteratee), 1);
}
$ce626f03865ef5d1$exports = $ce626f03865ef5d1$var$flatMap;



var $dba9b32de817c336$exports = {};
var $4ee66e75fa6423f9$exports = {};
var $52811d56a7e00a58$exports = {};
var $191e618a80d2ac3e$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $191e618a80d2ac3e$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$191e618a80d2ac3e$exports = $191e618a80d2ac3e$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $52811d56a7e00a58$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $191e618a80d2ac3e$exports(array, start, end);
}
$52811d56a7e00a58$exports = $52811d56a7e00a58$var$castSlice;


var $08c6de7647e49cf0$exports = {};
/** Used to compose unicode character classes. */ var $08c6de7647e49cf0$var$rsAstralRange = '\\ud800-\\udfff', $08c6de7647e49cf0$var$rsComboMarksRange = '\\u0300-\\u036f', $08c6de7647e49cf0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $08c6de7647e49cf0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $08c6de7647e49cf0$var$rsComboRange = $08c6de7647e49cf0$var$rsComboMarksRange + $08c6de7647e49cf0$var$reComboHalfMarksRange + $08c6de7647e49cf0$var$rsComboSymbolsRange, $08c6de7647e49cf0$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $08c6de7647e49cf0$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $08c6de7647e49cf0$var$reHasUnicode = RegExp('[' + $08c6de7647e49cf0$var$rsZWJ + $08c6de7647e49cf0$var$rsAstralRange + $08c6de7647e49cf0$var$rsComboRange + $08c6de7647e49cf0$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $08c6de7647e49cf0$var$hasUnicode(string) {
    return $08c6de7647e49cf0$var$reHasUnicode.test(string);
}
$08c6de7647e49cf0$exports = $08c6de7647e49cf0$var$hasUnicode;


var $e44dd93306bd922d$exports = {};
var $7be5b911880c1538$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7be5b911880c1538$var$asciiToArray(string) {
    return string.split('');
}
$7be5b911880c1538$exports = $7be5b911880c1538$var$asciiToArray;



var $993c3276db17f461$exports = {};
/** Used to compose unicode character classes. */ var $993c3276db17f461$var$rsAstralRange = '\\ud800-\\udfff', $993c3276db17f461$var$rsComboMarksRange = '\\u0300-\\u036f', $993c3276db17f461$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $993c3276db17f461$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $993c3276db17f461$var$rsComboRange = $993c3276db17f461$var$rsComboMarksRange + $993c3276db17f461$var$reComboHalfMarksRange + $993c3276db17f461$var$rsComboSymbolsRange, $993c3276db17f461$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $993c3276db17f461$var$rsAstral = '[' + $993c3276db17f461$var$rsAstralRange + ']', $993c3276db17f461$var$rsCombo = '[' + $993c3276db17f461$var$rsComboRange + ']', $993c3276db17f461$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $993c3276db17f461$var$rsModifier = '(?:' + $993c3276db17f461$var$rsCombo + '|' + $993c3276db17f461$var$rsFitz + ')', $993c3276db17f461$var$rsNonAstral = '[^' + $993c3276db17f461$var$rsAstralRange + ']', $993c3276db17f461$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $993c3276db17f461$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $993c3276db17f461$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $993c3276db17f461$var$reOptMod = $993c3276db17f461$var$rsModifier + '?', $993c3276db17f461$var$rsOptVar = '[' + $993c3276db17f461$var$rsVarRange + ']?', $993c3276db17f461$var$rsOptJoin = '(?:' + $993c3276db17f461$var$rsZWJ + '(?:' + [
    $993c3276db17f461$var$rsNonAstral,
    $993c3276db17f461$var$rsRegional,
    $993c3276db17f461$var$rsSurrPair
].join('|') + ')' + $993c3276db17f461$var$rsOptVar + $993c3276db17f461$var$reOptMod + ')*', $993c3276db17f461$var$rsSeq = $993c3276db17f461$var$rsOptVar + $993c3276db17f461$var$reOptMod + $993c3276db17f461$var$rsOptJoin, $993c3276db17f461$var$rsSymbol = '(?:' + [
    $993c3276db17f461$var$rsNonAstral + $993c3276db17f461$var$rsCombo + '?',
    $993c3276db17f461$var$rsCombo,
    $993c3276db17f461$var$rsRegional,
    $993c3276db17f461$var$rsSurrPair,
    $993c3276db17f461$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $993c3276db17f461$var$reUnicode = RegExp($993c3276db17f461$var$rsFitz + '(?=' + $993c3276db17f461$var$rsFitz + ')|' + $993c3276db17f461$var$rsSymbol + $993c3276db17f461$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $993c3276db17f461$var$unicodeToArray(string) {
    return string.match($993c3276db17f461$var$reUnicode) || [];
}
$993c3276db17f461$exports = $993c3276db17f461$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $e44dd93306bd922d$var$stringToArray(string) {
    return $08c6de7647e49cf0$exports(string) ? $993c3276db17f461$exports(string) : $7be5b911880c1538$exports(string);
}
$e44dd93306bd922d$exports = $e44dd93306bd922d$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $4ee66e75fa6423f9$var$createCaseFirst(methodName) {
    return function(string) {
        string = $2854456ba4e51b7a$exports(string);
        var strSymbols = $08c6de7647e49cf0$exports(string) ? $e44dd93306bd922d$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $52811d56a7e00a58$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$4ee66e75fa6423f9$exports = $4ee66e75fa6423f9$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $dba9b32de817c336$var$upperFirst = $4ee66e75fa6423f9$exports('toUpperCase');
$dba9b32de817c336$exports = $dba9b32de817c336$var$upperFirst;



var $0082dfda2c4d7cdc$exports = {};

var $abf6d9273e7929f9$exports = {};




var $3af2638337ba382f$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $3af2638337ba382f$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$3af2638337ba382f$exports = $3af2638337ba382f$var$baseSortBy;



var $602519c54e4e091b$exports = {};
var $0251941a81a84b5d$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $0251941a81a84b5d$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $8fab81ce33077160$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $8fab81ce33077160$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$0251941a81a84b5d$exports = $0251941a81a84b5d$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $602519c54e4e091b$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $0251941a81a84b5d$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$602519c54e4e091b$exports = $602519c54e4e091b$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $abf6d9273e7929f9$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $9fd738eaa74f3638$exports(iteratees, function(iteratee) {
        if ($46116793eaa02c32$exports(iteratee)) return function(value) {
            return $1378bbdee3372fdb$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $5cab5b412769001e$exports
    ];
    var index = -1;
    iteratees = $9fd738eaa74f3638$exports(iteratees, $6c87d2ec7a5b64db$exports($6aa52744a9ab51b8$exports));
    var result = $bd274b9519243073$exports(collection, function(value, key, collection) {
        var criteria = $9fd738eaa74f3638$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $3af2638337ba382f$exports(result, function(object, other) {
        return $602519c54e4e091b$exports(object, other, orders);
    });
}
$abf6d9273e7929f9$exports = $abf6d9273e7929f9$var$baseOrderBy;


var $61c73e9686c610a8$exports = {};

var $c82c120815c1c8ae$exports = {};
var $658c040200873e47$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $658c040200873e47$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$658c040200873e47$exports = $658c040200873e47$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c82c120815c1c8ae$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c82c120815c1c8ae$var$overRest(func, start, transform) {
    start = $c82c120815c1c8ae$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c82c120815c1c8ae$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $658c040200873e47$exports(func, this, otherArgs);
    };
}
$c82c120815c1c8ae$exports = $c82c120815c1c8ae$var$overRest;


var $21a1f32b1e81f677$exports = {};
var $9a46bbf5bbe44fa4$exports = {};
var $2c613fe635aa8c20$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2c613fe635aa8c20$var$constant(value) {
    return function() {
        return value;
    };
}
$2c613fe635aa8c20$exports = $2c613fe635aa8c20$var$constant;


var $aa9927229ed34ba4$exports = {};

var $aa9927229ed34ba4$var$defineProperty = function() {
    try {
        var func = $7f56803878bcc7da$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$aa9927229ed34ba4$exports = $aa9927229ed34ba4$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9a46bbf5bbe44fa4$var$baseSetToString = !$aa9927229ed34ba4$exports ? $5cab5b412769001e$exports : function(func, string) {
    return $aa9927229ed34ba4$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $2c613fe635aa8c20$exports(string),
        'writable': true
    });
};
$9a46bbf5bbe44fa4$exports = $9a46bbf5bbe44fa4$var$baseSetToString;


var $9c556a97cef624ca$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $9c556a97cef624ca$var$HOT_COUNT = 800, $9c556a97cef624ca$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $9c556a97cef624ca$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $9c556a97cef624ca$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $9c556a97cef624ca$var$nativeNow(), remaining = $9c556a97cef624ca$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $9c556a97cef624ca$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$9c556a97cef624ca$exports = $9c556a97cef624ca$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $21a1f32b1e81f677$var$setToString = $9c556a97cef624ca$exports($9a46bbf5bbe44fa4$exports);
$21a1f32b1e81f677$exports = $21a1f32b1e81f677$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $61c73e9686c610a8$var$baseRest(func, start) {
    return $21a1f32b1e81f677$exports($c82c120815c1c8ae$exports(func, start, $5cab5b412769001e$exports), func + '');
}
$61c73e9686c610a8$exports = $61c73e9686c610a8$var$baseRest;


var $b4e75ea659f79f53$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b4e75ea659f79f53$var$isIterateeCall(value, index, object) {
    if (!$4679825e1cdd07bc$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $70a87f3bd796a6cd$exports(object) && $ea7b709b198a2835$exports(index, object.length) : type == 'string' && index in object) return $59abe4f1dde57d22$exports(object[index], value);
    return false;
}
$b4e75ea659f79f53$exports = $b4e75ea659f79f53$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $0082dfda2c4d7cdc$var$sortBy = $61c73e9686c610a8$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b4e75ea659f79f53$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b4e75ea659f79f53$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $abf6d9273e7929f9$exports(collection, $dcd699742a532aa9$exports(iteratees, 1), []);
});
$0082dfda2c4d7cdc$exports = $0082dfda2c4d7cdc$var$sortBy;


var $bce74eef350a6fa0$exports = {};
(function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $bce74eef350a6fa0$exports) $bce74eef350a6fa0$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($bce74eef350a6fa0$exports);


function $a06b64c01280796f$var$_toConsumableArray(arr) {
    return $a06b64c01280796f$var$_arrayWithoutHoles(arr) || $a06b64c01280796f$var$_iterableToArray(arr) || $a06b64c01280796f$var$_unsupportedIterableToArray(arr) || $a06b64c01280796f$var$_nonIterableSpread();
}
function $a06b64c01280796f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a06b64c01280796f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a06b64c01280796f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a06b64c01280796f$var$_arrayLikeToArray(o, minLen);
}
function $a06b64c01280796f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $a06b64c01280796f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a06b64c01280796f$var$_arrayLikeToArray(arr);
}
function $a06b64c01280796f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $a06b64c01280796f$var$identity = function identity(i) {
    return i;
};
var $a06b64c01280796f$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $a06b64c01280796f$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $a06b64c01280796f$export$ca73b6d700d0505;
};
var $a06b64c01280796f$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $a06b64c01280796f$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $a06b64c01280796f$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $a06b64c01280796f$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $a06b64c01280796f$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $a06b64c01280796f$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $a06b64c01280796f$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $a06b64c01280796f$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $a06b64c01280796f$export$c3095a23b368d1f2 = function curry(fn) {
    return $a06b64c01280796f$var$curryN(fn.length, fn);
};
var $a06b64c01280796f$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $a06b64c01280796f$export$871de8747c9eaa88 = $a06b64c01280796f$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $a06b64c01280796f$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $a06b64c01280796f$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $a06b64c01280796f$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $a06b64c01280796f$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $112b038b80f65489$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $112b038b80f65489$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $112b038b80f65489$var$interpolateNumber = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $112b038b80f65489$var$uninterpolateNumber = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $112b038b80f65489$var$uninterpolateTruncation = (0, $a06b64c01280796f$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $112b038b80f65489$export$2e2bcd8739ae039 = {
    rangeStep: $112b038b80f65489$var$rangeStep,
    getDigitCount: $112b038b80f65489$var$getDigitCount,
    interpolateNumber: $112b038b80f65489$var$interpolateNumber,
    uninterpolateNumber: $112b038b80f65489$var$uninterpolateNumber,
    uninterpolateTruncation: $112b038b80f65489$var$uninterpolateTruncation
};


function $c8245f9d62e1c71a$var$_toConsumableArray(arr) {
    return $c8245f9d62e1c71a$var$_arrayWithoutHoles(arr) || $c8245f9d62e1c71a$var$_iterableToArray(arr) || $c8245f9d62e1c71a$var$_unsupportedIterableToArray(arr) || $c8245f9d62e1c71a$var$_nonIterableSpread();
}
function $c8245f9d62e1c71a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8245f9d62e1c71a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c8245f9d62e1c71a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c8245f9d62e1c71a$var$_arrayLikeToArray(arr);
}
function $c8245f9d62e1c71a$var$_slicedToArray(arr, i) {
    return $c8245f9d62e1c71a$var$_arrayWithHoles(arr) || $c8245f9d62e1c71a$var$_iterableToArrayLimit(arr, i) || $c8245f9d62e1c71a$var$_unsupportedIterableToArray(arr, i) || $c8245f9d62e1c71a$var$_nonIterableRest();
}
function $c8245f9d62e1c71a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c8245f9d62e1c71a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c8245f9d62e1c71a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c8245f9d62e1c71a$var$_arrayLikeToArray(o, minLen);
}
function $c8245f9d62e1c71a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c8245f9d62e1c71a$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c8245f9d62e1c71a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $c8245f9d62e1c71a$var$getValidInterval(_ref) {
    var _ref2 = $c8245f9d62e1c71a$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $c8245f9d62e1c71a$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0);
    var digitCount = (0, $112b038b80f65489$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $c8245f9d62e1c71a$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(10).pow((0, $112b038b80f65489$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $a06b64c01280796f$export$f672e0b6f7222cd7)((0, $a06b64c01280796f$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $a06b64c01280796f$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $c8245f9d62e1c71a$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $c8245f9d62e1c71a$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $c8245f9d62e1c71a$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $a06b64c01280796f$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $a06b64c01280796f$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $c8245f9d62e1c71a$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $c8245f9d62e1c71a$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $112b038b80f65489$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getTickValuesFn(_ref5) {
    var _ref6 = $c8245f9d62e1c71a$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $c8245f9d62e1c71a$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $a06b64c01280796f$export$f672e0b6f7222cd7)((0, $a06b64c01280796f$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(n).mul(step)).toNumber();
    }), (0, $a06b64c01280796f$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $c8245f9d62e1c71a$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $c8245f9d62e1c71a$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $c8245f9d62e1c71a$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $c8245f9d62e1c71a$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $c8245f9d62e1c71a$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($c8245f9d62e1c71a$var$_toConsumableArray((0, $112b038b80f65489$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($bce74eef350a6fa0$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $a06b64c01280796f$export$66c1ae025e96b4bc)(values) : values;
}
var $c8245f9d62e1c71a$export$b84e75ccbfe6a612 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getNiceTickValuesFn);
var $c8245f9d62e1c71a$export$4cc7a216492b1f53 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getTickValuesFn);
var $c8245f9d62e1c71a$export$e9d28da780436e98 = (0, $a06b64c01280796f$export$fc10aeed3a532e2a)($c8245f9d62e1c71a$var$getTickValuesFixedDomainFn);








var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");
/* eslint no-console: 0 */ var $7371dc891b6c1818$var$isDev = false;
var $7371dc891b6c1818$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($7371dc891b6c1818$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $ed0c2f2ddc9d58cd$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $ed0c2f2ddc9d58cd$var$_extends() {
    $ed0c2f2ddc9d58cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed0c2f2ddc9d58cd$var$_extends.apply(this, arguments);
}
function $ed0c2f2ddc9d58cd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed0c2f2ddc9d58cd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed0c2f2ddc9d58cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ed0c2f2ddc9d58cd$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $ed0c2f2ddc9d58cd$var$_objectWithoutProperties(props, $ed0c2f2ddc9d58cd$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $ajIhI.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("svg", $ed0c2f2ddc9d58cd$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("desc", null, desc), children);
}



var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");

function $1a06a1b516e783f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1a06a1b516e783f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1a06a1b516e783f8$var$_typeof(o);
}
var $1a06a1b516e783f8$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $1a06a1b516e783f8$var$_extends() {
    $1a06a1b516e783f8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a06a1b516e783f8$var$_extends.apply(this, arguments);
}
function $1a06a1b516e783f8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a06a1b516e783f8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a06a1b516e783f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1a06a1b516e783f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a06a1b516e783f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1a06a1b516e783f8$var$_defineProperty(obj, key, value) {
    key = $1a06a1b516e783f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1a06a1b516e783f8$var$_toPropertyKey(t) {
    var i = $1a06a1b516e783f8$var$_toPrimitive(t, "string");
    return "symbol" == $1a06a1b516e783f8$var$_typeof(i) ? i : i + "";
}
function $1a06a1b516e783f8$var$_toPrimitive(t, r) {
    if ("object" != $1a06a1b516e783f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1a06a1b516e783f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1a06a1b516e783f8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1a06a1b516e783f8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1a06a1b516e783f8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1a06a1b516e783f8$var$symbolFactories = {
    symbolCircle: (0, $4efdaf596664c2fb$exports.symbolCircle),
    symbolCross: (0, $4efdaf596664c2fb$exports.symbolCross),
    symbolDiamond: (0, $4efdaf596664c2fb$exports.symbolDiamond),
    symbolSquare: (0, $4efdaf596664c2fb$exports.symbolSquare),
    symbolStar: (0, $4efdaf596664c2fb$exports.symbolStar),
    symbolTriangle: (0, $4efdaf596664c2fb$exports.symbolTriangle),
    symbolWye: (0, $4efdaf596664c2fb$exports.symbolWye)
};
var $1a06a1b516e783f8$var$RADIAN = Math.PI / 180;
var $1a06a1b516e783f8$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(type));
    return $1a06a1b516e783f8$var$symbolFactories[name] || (0, $4efdaf596664c2fb$exports.symbolCircle);
};
var $1a06a1b516e783f8$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $1a06a1b516e783f8$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $1a06a1b516e783f8$var$registerSymbol = function registerSymbol(key, factory) {
    $1a06a1b516e783f8$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(key))] = factory;
};
var $1a06a1b516e783f8$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $1a06a1b516e783f8$var$_objectWithoutProperties(_ref, $1a06a1b516e783f8$var$_excluded);
    var props = $1a06a1b516e783f8$var$_objectSpread($1a06a1b516e783f8$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $1a06a1b516e783f8$var$getSymbolFactory(type);
        var symbol = (0, $4efdaf596664c2fb$exports.symbol)().type(symbolFactory).size($1a06a1b516e783f8$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $1a06a1b516e783f8$var$_extends({}, filteredProps, {
        className: (0, $ajIhI.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$1a06a1b516e783f8$export$fa456266707bf4e4.registerSymbol = $1a06a1b516e783f8$var$registerSymbol;



function $9367d502c40c9dd9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9367d502c40c9dd9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9367d502c40c9dd9$var$_typeof(o);
}
function $9367d502c40c9dd9$var$_extends() {
    $9367d502c40c9dd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9367d502c40c9dd9$var$_extends.apply(this, arguments);
}
function $9367d502c40c9dd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9367d502c40c9dd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9367d502c40c9dd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9367d502c40c9dd9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9367d502c40c9dd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9367d502c40c9dd9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9367d502c40c9dd9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $9367d502c40c9dd9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $9367d502c40c9dd9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9367d502c40c9dd9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9367d502c40c9dd9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $9367d502c40c9dd9$var$_callSuper(t, o, e) {
    return o = $9367d502c40c9dd9$var$_getPrototypeOf(o), $9367d502c40c9dd9$var$_possibleConstructorReturn(t, $9367d502c40c9dd9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $9367d502c40c9dd9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $9367d502c40c9dd9$var$_possibleConstructorReturn(self, call) {
    if (call && ($9367d502c40c9dd9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $9367d502c40c9dd9$var$_assertThisInitialized(self);
}
function $9367d502c40c9dd9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9367d502c40c9dd9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($9367d502c40c9dd9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $9367d502c40c9dd9$var$_getPrototypeOf(o) {
    $9367d502c40c9dd9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9367d502c40c9dd9$var$_getPrototypeOf(o);
}
function $9367d502c40c9dd9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $9367d502c40c9dd9$var$_setPrototypeOf(subClass, superClass);
}
function $9367d502c40c9dd9$var$_setPrototypeOf(o, p) {
    $9367d502c40c9dd9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9367d502c40c9dd9$var$_setPrototypeOf(o, p);
}
function $9367d502c40c9dd9$var$_defineProperty(obj, key, value) {
    key = $9367d502c40c9dd9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9367d502c40c9dd9$var$_toPropertyKey(t) {
    var i = $9367d502c40c9dd9$var$_toPrimitive(t, "string");
    return "symbol" == $9367d502c40c9dd9$var$_typeof(i) ? i : i + "";
}
function $9367d502c40c9dd9$var$_toPrimitive(t, r) {
    if ("object" != $9367d502c40c9dd9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9367d502c40c9dd9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9367d502c40c9dd9$var$SIZE = 32;
var $9367d502c40c9dd9$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $9367d502c40c9dd9$var$_classCallCheck(this, DefaultLegendContent);
        return $9367d502c40c9dd9$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $9367d502c40c9dd9$var$_inherits(DefaultLegendContent, _PureComponent);
    return $9367d502c40c9dd9$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $9367d502c40c9dd9$var$SIZE / 2;
                var sixthSize = $9367d502c40c9dd9$var$SIZE / 6;
                var thirdSize = $9367d502c40c9dd9$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $9367d502c40c9dd9$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($9367d502c40c9dd9$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($9367d502c40c9dd9$var$SIZE / 8, "h").concat($9367d502c40c9dd9$var$SIZE, "v").concat($9367d502c40c9dd9$var$SIZE * 3 / 4, "h").concat(-$9367d502c40c9dd9$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(data.legendIcon)) {
                    var iconProps = $9367d502c40c9dd9$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $9367d502c40c9dd9$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $9367d502c40c9dd9$var$SIZE,
                    height: $9367d502c40c9dd9$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $ajIhI.default)($9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(entry.value) ? entry.value : null;
                    (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("li", $9367d502c40c9dd9$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$export$99f8d96ed0cededa, "displayName", 'Legend');
$9367d502c40c9dd9$var$_defineProperty($9367d502c40c9dd9$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $40ad740a6014714b$exports = {};

var $a06e18c8dbcabb91$exports = {};

var $3bc11f46233f5100$exports = {};
var $9b098515d7eeae5d$exports = {};
var $ecf86b262255e231$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ecf86b262255e231$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$ecf86b262255e231$exports = $ecf86b262255e231$var$baseFindIndex;


var $f70a71a1b152b764$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $f70a71a1b152b764$var$baseIsNaN(value) {
    return value !== value;
}
$f70a71a1b152b764$exports = $f70a71a1b152b764$var$baseIsNaN;


var $70917896206e833e$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $70917896206e833e$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$70917896206e833e$exports = $70917896206e833e$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $9b098515d7eeae5d$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $70917896206e833e$exports(array, value, fromIndex) : $ecf86b262255e231$exports(array, $f70a71a1b152b764$exports, fromIndex);
}
$9b098515d7eeae5d$exports = $9b098515d7eeae5d$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $3bc11f46233f5100$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $9b098515d7eeae5d$exports(array, value, 0) > -1;
}
$3bc11f46233f5100$exports = $3bc11f46233f5100$var$arrayIncludes;


var $557571bb1a129035$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $557571bb1a129035$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$557571bb1a129035$exports = $557571bb1a129035$var$arrayIncludesWith;



var $0e7b9f08e7c4736f$exports = {};

var $77935f72c4f64c88$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $77935f72c4f64c88$var$noop() {
// No operation performed.
}
$77935f72c4f64c88$exports = $77935f72c4f64c88$var$noop;



/** Used as references for various `Number` constants. */ var $0e7b9f08e7c4736f$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $0e7b9f08e7c4736f$var$createSet = !($4c1a03e269fbabc9$exports && 1 / $1360f177952adc80$exports(new $4c1a03e269fbabc9$exports([
    ,
    -0
]))[1] == $0e7b9f08e7c4736f$var$INFINITY) ? $77935f72c4f64c88$exports : function(values) {
    return new $4c1a03e269fbabc9$exports(values);
};
$0e7b9f08e7c4736f$exports = $0e7b9f08e7c4736f$var$createSet;



/** Used as the size to enable large array optimizations. */ var $a06e18c8dbcabb91$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $a06e18c8dbcabb91$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $3bc11f46233f5100$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $557571bb1a129035$exports;
    } else if (length >= $a06e18c8dbcabb91$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $0e7b9f08e7c4736f$exports(array);
        if (set) return $1360f177952adc80$exports(set);
        isCommon = false;
        includes = $e5e703715ca3ea7c$exports;
        seen = new $d2c49809ad6e170e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$a06e18c8dbcabb91$exports = $a06e18c8dbcabb91$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $40ad740a6014714b$var$uniqBy(array, iteratee) {
    return array && array.length ? $a06e18c8dbcabb91$exports(array, $6aa52744a9ab51b8$exports(iteratee, 2)) : [];
}
$40ad740a6014714b$exports = $40ad740a6014714b$var$uniqBy;



function $45b995e155031399$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($40ad740a6014714b$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($40ad740a6014714b$exports)))(payload, option);
    return payload;
}


function $06340f5273236c74$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $06340f5273236c74$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $06340f5273236c74$var$_typeof(o);
}
var $06340f5273236c74$var$_excluded = [
    "ref"
];
function $06340f5273236c74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06340f5273236c74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06340f5273236c74$var$ownKeys(Object(t), !0).forEach(function(r) {
            $06340f5273236c74$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06340f5273236c74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $06340f5273236c74$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06340f5273236c74$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $06340f5273236c74$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $06340f5273236c74$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $06340f5273236c74$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $06340f5273236c74$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $06340f5273236c74$var$_callSuper(t, o, e) {
    return o = $06340f5273236c74$var$_getPrototypeOf(o), $06340f5273236c74$var$_possibleConstructorReturn(t, $06340f5273236c74$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $06340f5273236c74$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $06340f5273236c74$var$_possibleConstructorReturn(self, call) {
    if (call && ($06340f5273236c74$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $06340f5273236c74$var$_assertThisInitialized(self);
}
function $06340f5273236c74$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $06340f5273236c74$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($06340f5273236c74$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $06340f5273236c74$var$_getPrototypeOf(o) {
    $06340f5273236c74$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $06340f5273236c74$var$_getPrototypeOf(o);
}
function $06340f5273236c74$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $06340f5273236c74$var$_setPrototypeOf(subClass, superClass);
}
function $06340f5273236c74$var$_setPrototypeOf(o, p) {
    $06340f5273236c74$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $06340f5273236c74$var$_setPrototypeOf(o, p);
}
function $06340f5273236c74$var$_defineProperty(obj, key, value) {
    key = $06340f5273236c74$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $06340f5273236c74$var$_toPropertyKey(t) {
    var i = $06340f5273236c74$var$_toPrimitive(t, "string");
    return "symbol" == $06340f5273236c74$var$_typeof(i) ? i : i + "";
}
function $06340f5273236c74$var$_toPrimitive(t, r) {
    if ("object" != $06340f5273236c74$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $06340f5273236c74$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $06340f5273236c74$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $06340f5273236c74$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $06340f5273236c74$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $06340f5273236c74$var$defaultUniqBy(entry) {
    return entry.value;
}
function $06340f5273236c74$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(content, props);
    var ref = props.ref, otherProps = $06340f5273236c74$var$_objectWithoutProperties(props, $06340f5273236c74$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9367d502c40c9dd9$export$99f8d96ed0cededa), otherProps);
}
var $06340f5273236c74$var$EPS = 1;
var $06340f5273236c74$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $06340f5273236c74$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $06340f5273236c74$var$_callSuper(this, Legend, [].concat(args));
        $06340f5273236c74$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $06340f5273236c74$var$_inherits(Legend, _PureComponent);
    return $06340f5273236c74$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $06340f5273236c74$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $06340f5273236c74$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $06340f5273236c74$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $06340f5273236c74$var$renderContent(content, $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $45b995e155031399$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $06340f5273236c74$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $06340f5273236c74$var$_objectSpread($06340f5273236c74$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$06340f5273236c74$var$_defineProperty($06340f5273236c74$export$ed247974535929c7, "displayName", 'Legend');
$06340f5273236c74$var$_defineProperty($06340f5273236c74$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $3c595a89abddaa2c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3c595a89abddaa2c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c595a89abddaa2c$var$_typeof(o);
}
function $3c595a89abddaa2c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3c595a89abddaa2c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3c595a89abddaa2c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3c595a89abddaa2c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3c595a89abddaa2c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3c595a89abddaa2c$var$_defineProperty(obj, key, value) {
    key = $3c595a89abddaa2c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c595a89abddaa2c$var$_toPropertyKey(t) {
    var i = $3c595a89abddaa2c$var$_toPrimitive(t, "string");
    return "symbol" == $3c595a89abddaa2c$var$_typeof(i) ? i : i + "";
}
function $3c595a89abddaa2c$var$_toPrimitive(t, r) {
    if ("object" != $3c595a89abddaa2c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3c595a89abddaa2c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3c595a89abddaa2c$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $06340f5273236c74$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $06340f5273236c74$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $cc31aced37ecb634$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread($3c595a89abddaa2c$var$_objectSpread({}, legendProps), (0, $06340f5273236c74$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $cc31aced37ecb634$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cc31aced37ecb634$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cc31aced37ecb634$var$_typeof(o);
}
function $cc31aced37ecb634$var$_toConsumableArray(arr) {
    return $cc31aced37ecb634$var$_arrayWithoutHoles(arr) || $cc31aced37ecb634$var$_iterableToArray(arr) || $cc31aced37ecb634$var$_unsupportedIterableToArray(arr) || $cc31aced37ecb634$var$_nonIterableSpread();
}
function $cc31aced37ecb634$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cc31aced37ecb634$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cc31aced37ecb634$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cc31aced37ecb634$var$_arrayLikeToArray(o, minLen);
}
function $cc31aced37ecb634$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cc31aced37ecb634$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cc31aced37ecb634$var$_arrayLikeToArray(arr);
}
function $cc31aced37ecb634$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cc31aced37ecb634$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cc31aced37ecb634$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cc31aced37ecb634$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cc31aced37ecb634$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cc31aced37ecb634$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cc31aced37ecb634$var$_defineProperty(obj, key, value) {
    key = $cc31aced37ecb634$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc31aced37ecb634$var$_toPropertyKey(t) {
    var i = $cc31aced37ecb634$var$_toPrimitive(t, "string");
    return "symbol" == $cc31aced37ecb634$var$_typeof(i) ? i : i + "";
}
function $cc31aced37ecb634$var$_toPrimitive(t, r) {
    if ("object" != $cc31aced37ecb634$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cc31aced37ecb634$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cc31aced37ecb634$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey)) return defaultValue;
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $cc31aced37ecb634$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($ce626f03865ef5d1$exports)))(data, function(entry) {
        return $cc31aced37ecb634$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $cc31aced37ecb634$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(cur - before) !== (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(after - cur) === (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $cc31aced37ecb634$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $cc31aced37ecb634$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(barSize) ? undefined : (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $cc31aced37ecb634$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($cc31aced37ecb634$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($cc31aced37ecb634$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $cc31aced37ecb634$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $3c595a89abddaa2c$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(offset[align])) return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, offset), {}, $cc31aced37ecb634$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(offset[verticalAlign])) return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, offset), {}, $cc31aced37ecb634$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $cc31aced37ecb634$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $cc31aced37ecb634$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $cc31aced37ecb634$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $cc31aced37ecb634$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $cc31aced37ecb634$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $cc31aced37ecb634$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $cc31aced37ecb634$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $cc31aced37ecb634$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $cc31aced37ecb634$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $cc31aced37ecb634$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $cc31aced37ecb634$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $cc31aced37ecb634$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $cc31aced37ecb634$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $cc31aced37ecb634$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $cc31aced37ecb634$var$handlerWeakMap = new WeakMap();
var $cc31aced37ecb634$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$cc31aced37ecb634$var$handlerWeakMap.has(defaultHandler)) $cc31aced37ecb634$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $cc31aced37ecb634$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $cc31aced37ecb634$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $5389c27663bb3a0e$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $5389c27663bb3a0e$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $5389c27663bb3a0e$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $5389c27663bb3a0e$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $5389c27663bb3a0e$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($187d420db4e9f7fe$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(scale));
        return {
            scale: ($5389c27663bb3a0e$exports[name] || $5389c27663bb3a0e$exports.scalePoint)(),
            realScaleType: $5389c27663bb3a0e$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $5389c27663bb3a0e$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $cc31aced37ecb634$var$EPS = 1e-4;
var $cc31aced37ecb634$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $cc31aced37ecb634$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $cc31aced37ecb634$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $cc31aced37ecb634$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $cc31aced37ecb634$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domain[0]) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $cc31aced37ecb634$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $cc31aced37ecb634$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $cc31aced37ecb634$var$STACK_OFFSET_MAP = {
    sign: $cc31aced37ecb634$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $4efdaf596664c2fb$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $4efdaf596664c2fb$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $4efdaf596664c2fb$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $4efdaf596664c2fb$exports.stackOffsetWiggle),
    positive: $cc31aced37ecb634$export$9f2c6ead70935022
};
var $cc31aced37ecb634$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $cc31aced37ecb634$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $4efdaf596664c2fb$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$cc31aced37ecb634$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $4efdaf596664c2fb$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $cc31aced37ecb634$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, result), {}, $cc31aced37ecb634$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, res), {}, $cc31aced37ecb634$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $cc31aced37ecb634$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, result), {}, $cc31aced37ecb634$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $cc31aced37ecb634$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $c8245f9d62e1c71a$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $c8245f9d62e1c71a$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $cc31aced37ecb634$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $cc31aced37ecb634$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? axis.scale(value) : null;
}
var $cc31aced37ecb634$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $cc31aced37ecb634$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $cc31aced37ecb634$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $cc31aced37ecb634$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $cc31aced37ecb634$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($68f8d6cfd642a3d7$exports)))(entry.concat([
                result[0]
            ]).filter((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(entry.concat([
                result[1]
            ]).filter((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $cc31aced37ecb634$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $cc31aced37ecb634$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $cc31aced37ecb634$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cc31aced37ecb634$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $cc31aced37ecb634$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($cc31aced37ecb634$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$cc31aced37ecb634$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($cc31aced37ecb634$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$cc31aced37ecb634$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $cc31aced37ecb634$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $cc31aced37ecb634$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $cc31aced37ecb634$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $cc31aced37ecb634$var$_objectSpread($cc31aced37ecb634$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $cc31aced37ecb634$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $cc31aced37ecb634$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $e229728826610b73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e229728826610b73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e229728826610b73$var$_typeof(o);
}
function $e229728826610b73$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e229728826610b73$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e229728826610b73$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e229728826610b73$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e229728826610b73$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e229728826610b73$var$_defineProperty(obj, key, value) {
    key = $e229728826610b73$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e229728826610b73$var$_toPropertyKey(t) {
    var i = $e229728826610b73$var$_toPrimitive(t, "string");
    return "symbol" == $e229728826610b73$var$_typeof(i) ? i : i + "";
}
function $e229728826610b73$var$_toPrimitive(t, r) {
    if ("object" != $e229728826610b73$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e229728826610b73$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e229728826610b73$var$_slicedToArray(arr, i) {
    return $e229728826610b73$var$_arrayWithHoles(arr) || $e229728826610b73$var$_iterableToArrayLimit(arr, i) || $e229728826610b73$var$_unsupportedIterableToArray(arr, i) || $e229728826610b73$var$_nonIterableRest();
}
function $e229728826610b73$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e229728826610b73$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e229728826610b73$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e229728826610b73$var$_arrayLikeToArray(o, minLen);
}
function $e229728826610b73$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e229728826610b73$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e229728826610b73$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $e229728826610b73$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $e229728826610b73$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $e229728826610b73$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $e229728826610b73$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$e229728826610b73$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$e229728826610b73$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $e229728826610b73$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $e229728826610b73$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $e229728826610b73$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $e229728826610b73$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $cc31aced37ecb634$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $cc31aced37ecb634$export$9d80152e23bae434)(scale);
        var ticks = (0, $cc31aced37ecb634$export$ac086aaa4358d590)(scale, $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, result), {}, $e229728826610b73$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $e229728826610b73$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $e229728826610b73$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $e229728826610b73$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $e229728826610b73$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $e229728826610b73$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $e229728826610b73$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $e229728826610b73$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $e229728826610b73$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $e229728826610b73$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $e229728826610b73$var$_objectSpread($e229728826610b73$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $e229728826610b73$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $e229728826610b73$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $8nGP5.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $91b8fcd34b00a8a9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $91b8fcd34b00a8a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $91b8fcd34b00a8a9$var$_typeof(o);
}
var $91b8fcd34b00a8a9$var$_excluded = [
    "offset"
];
function $91b8fcd34b00a8a9$var$_toConsumableArray(arr) {
    return $91b8fcd34b00a8a9$var$_arrayWithoutHoles(arr) || $91b8fcd34b00a8a9$var$_iterableToArray(arr) || $91b8fcd34b00a8a9$var$_unsupportedIterableToArray(arr) || $91b8fcd34b00a8a9$var$_nonIterableSpread();
}
function $91b8fcd34b00a8a9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91b8fcd34b00a8a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $91b8fcd34b00a8a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $91b8fcd34b00a8a9$var$_arrayLikeToArray(o, minLen);
}
function $91b8fcd34b00a8a9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $91b8fcd34b00a8a9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $91b8fcd34b00a8a9$var$_arrayLikeToArray(arr);
}
function $91b8fcd34b00a8a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $91b8fcd34b00a8a9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $91b8fcd34b00a8a9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $91b8fcd34b00a8a9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $91b8fcd34b00a8a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91b8fcd34b00a8a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91b8fcd34b00a8a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $91b8fcd34b00a8a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91b8fcd34b00a8a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91b8fcd34b00a8a9$var$_defineProperty(obj, key, value) {
    key = $91b8fcd34b00a8a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91b8fcd34b00a8a9$var$_toPropertyKey(t) {
    var i = $91b8fcd34b00a8a9$var$_toPrimitive(t, "string");
    return "symbol" == $91b8fcd34b00a8a9$var$_typeof(i) ? i : i + "";
}
function $91b8fcd34b00a8a9$var$_toPrimitive(t, r) {
    if ("object" != $91b8fcd34b00a8a9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $91b8fcd34b00a8a9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $91b8fcd34b00a8a9$var$_extends() {
    $91b8fcd34b00a8a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $91b8fcd34b00a8a9$var$_extends.apply(this, arguments);
}
var $91b8fcd34b00a8a9$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(formatter)) return formatter(label);
    return label;
};
var $91b8fcd34b00a8a9$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $91b8fcd34b00a8a9$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $91b8fcd34b00a8a9$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(labelProps.id) ? (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("text", $91b8fcd34b00a8a9$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $ajIhI.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $91b8fcd34b00a8a9$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $91b8fcd34b00a8a9$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $91b8fcd34b00a8a9$var$_objectSpread($91b8fcd34b00a8a9$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(position) && ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position.x) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(position.x)) && ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position.y) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(position.y))) return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $91b8fcd34b00a8a9$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $91b8fcd34b00a8a9$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(viewBox.cx);
};
function $91b8fcd34b00a8a9$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $91b8fcd34b00a8a9$var$_objectWithoutProperties(_ref4, $91b8fcd34b00a8a9$var$_excluded);
    var props = $91b8fcd34b00a8a9$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(children) && !/*#__PURE__*/ (0, $8nGP5.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(content)) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(content)) {
        label = /*#__PURE__*/ (0, $8nGP5.createElement)(content, props);
        if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(label)) return label;
    } else label = $91b8fcd34b00a8a9$var$getLabel(props);
    var isPolarLabel = $91b8fcd34b00a8a9$var$isPolar(viewBox);
    var attrs = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $91b8fcd34b00a8a9$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $91b8fcd34b00a8a9$var$getAttrsOfPolarLabel(props) : $91b8fcd34b00a8a9$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $91b8fcd34b00a8a9$var$_extends({
        className: (0, $ajIhI.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.displayName = 'Label';
var $91b8fcd34b00a8a9$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height)) {
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(top) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(cx) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $91b8fcd34b00a8a9$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(label)) {
        if (label.type === $91b8fcd34b00a8a9$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($91b8fcd34b00a8a9$export$b04be29aa201d4f5, $91b8fcd34b00a8a9$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $91b8fcd34b00a8a9$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $91b8fcd34b00a8a9$var$parseViewBox(parentProps);
    var explicitChildren = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $91b8fcd34b00a8a9$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($91b8fcd34b00a8a9$var$_toConsumableArray(explicitChildren));
};
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.parseViewBox = $91b8fcd34b00a8a9$var$parseViewBox;
$91b8fcd34b00a8a9$export$b04be29aa201d4f5.renderCallByParent = $91b8fcd34b00a8a9$var$renderCallByParent;





function $e476a06be597057a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e476a06be597057a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e476a06be597057a$var$_typeof(o);
}
var $e476a06be597057a$var$_excluded = [
    "valueAccessor"
], $e476a06be597057a$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $e476a06be597057a$var$_toConsumableArray(arr) {
    return $e476a06be597057a$var$_arrayWithoutHoles(arr) || $e476a06be597057a$var$_iterableToArray(arr) || $e476a06be597057a$var$_unsupportedIterableToArray(arr) || $e476a06be597057a$var$_nonIterableSpread();
}
function $e476a06be597057a$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e476a06be597057a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e476a06be597057a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e476a06be597057a$var$_arrayLikeToArray(o, minLen);
}
function $e476a06be597057a$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e476a06be597057a$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e476a06be597057a$var$_arrayLikeToArray(arr);
}
function $e476a06be597057a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e476a06be597057a$var$_extends() {
    $e476a06be597057a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e476a06be597057a$var$_extends.apply(this, arguments);
}
function $e476a06be597057a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e476a06be597057a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e476a06be597057a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e476a06be597057a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e476a06be597057a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e476a06be597057a$var$_defineProperty(obj, key, value) {
    key = $e476a06be597057a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e476a06be597057a$var$_toPropertyKey(t) {
    var i = $e476a06be597057a$var$_toPrimitive(t, "string");
    return "symbol" == $e476a06be597057a$var$_typeof(i) ? i : i + "";
}
function $e476a06be597057a$var$_toPrimitive(t, r) {
    if ("object" != $e476a06be597057a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e476a06be597057a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e476a06be597057a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e476a06be597057a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e476a06be597057a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e476a06be597057a$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($ef7c13d61ecebd89$exports)))(entry.value) : entry.value;
};
function $e476a06be597057a$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $e476a06be597057a$var$defaultAccessor : _ref$valueAccessor, restProps = $e476a06be597057a$var$_objectWithoutProperties(_ref, $e476a06be597057a$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $e476a06be597057a$var$_objectWithoutProperties(restProps, $e476a06be597057a$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5), $e476a06be597057a$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(clockWise) ? entry : $e476a06be597057a$var$_objectSpread($e476a06be597057a$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$e476a06be597057a$export$835fcf23ab7bf88.displayName = 'LabelList';
function $e476a06be597057a$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4679825e1cdd07bc$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($e476a06be597057a$export$835fcf23ab7bf88, $e476a06be597057a$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $e476a06be597057a$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, $e476a06be597057a$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $e476a06be597057a$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($e476a06be597057a$var$_toConsumableArray(explicitChildren));
}
$e476a06be597057a$export$835fcf23ab7bf88.renderCallByParent = $e476a06be597057a$var$renderCallByParent;








var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $bce4a89e1bec64eb$exports = {};

var $4415e39530ad0572$exports = {};

/** Built-in value references. */ var $4415e39530ad0572$var$getPrototype = $e5cfd6ab9c22776f$exports(Object.getPrototypeOf, Object);
$4415e39530ad0572$exports = $4415e39530ad0572$var$getPrototype;



/** `Object#toString` result references. */ var $bce4a89e1bec64eb$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $bce4a89e1bec64eb$var$funcProto = Function.prototype, $bce4a89e1bec64eb$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $bce4a89e1bec64eb$var$funcToString = $bce4a89e1bec64eb$var$funcProto.toString;
/** Used to check objects for own properties. */ var $bce4a89e1bec64eb$var$hasOwnProperty = $bce4a89e1bec64eb$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $bce4a89e1bec64eb$var$objectCtorString = $bce4a89e1bec64eb$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $bce4a89e1bec64eb$var$isPlainObject(value) {
    if (!$9405d96f7f034703$exports(value) || $22b8ec638f42dca7$exports(value) != $bce4a89e1bec64eb$var$objectTag) return false;
    var proto = $4415e39530ad0572$exports(value);
    if (proto === null) return true;
    var Ctor = $bce4a89e1bec64eb$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $bce4a89e1bec64eb$var$funcToString.call(Ctor) == $bce4a89e1bec64eb$var$objectCtorString;
}
$bce4a89e1bec64eb$exports = $bce4a89e1bec64eb$var$isPlainObject;


var $8e0c6c162d0a6ac4$exports = {};


/** `Object#toString` result references. */ var $8e0c6c162d0a6ac4$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $8e0c6c162d0a6ac4$var$isBoolean(value) {
    return value === true || value === false || $9405d96f7f034703$exports(value) && $22b8ec638f42dca7$exports(value) == $8e0c6c162d0a6ac4$var$boolTag;
}
$8e0c6c162d0a6ac4$exports = $8e0c6c162d0a6ac4$var$isBoolean;




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $2a40e10cde5ed370$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2a40e10cde5ed370$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2a40e10cde5ed370$var$_typeof(o);
}
function $2a40e10cde5ed370$var$_extends() {
    $2a40e10cde5ed370$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a40e10cde5ed370$var$_extends.apply(this, arguments);
}
function $2a40e10cde5ed370$var$_slicedToArray(arr, i) {
    return $2a40e10cde5ed370$var$_arrayWithHoles(arr) || $2a40e10cde5ed370$var$_iterableToArrayLimit(arr, i) || $2a40e10cde5ed370$var$_unsupportedIterableToArray(arr, i) || $2a40e10cde5ed370$var$_nonIterableRest();
}
function $2a40e10cde5ed370$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2a40e10cde5ed370$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a40e10cde5ed370$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a40e10cde5ed370$var$_arrayLikeToArray(o, minLen);
}
function $2a40e10cde5ed370$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2a40e10cde5ed370$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2a40e10cde5ed370$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2a40e10cde5ed370$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a40e10cde5ed370$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a40e10cde5ed370$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2a40e10cde5ed370$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a40e10cde5ed370$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2a40e10cde5ed370$var$_defineProperty(obj, key, value) {
    key = $2a40e10cde5ed370$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2a40e10cde5ed370$var$_toPropertyKey(t) {
    var i = $2a40e10cde5ed370$var$_toPrimitive(t, "string");
    return "symbol" == $2a40e10cde5ed370$var$_typeof(i) ? i : i + "";
}
function $2a40e10cde5ed370$var$_toPrimitive(t, r) {
    if ("object" != $2a40e10cde5ed370$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2a40e10cde5ed370$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2a40e10cde5ed370$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $2a40e10cde5ed370$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $2a40e10cde5ed370$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $2a40e10cde5ed370$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $2a40e10cde5ed370$var$_objectSpread($2a40e10cde5ed370$var$_objectSpread({}, $2a40e10cde5ed370$var$defaultProps), rectangleProps);
    var pathRef = (0, $8nGP5.useRef)();
    var _useState = (0, $8nGP5.useState)(-1), _useState2 = $2a40e10cde5ed370$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8nGP5.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $ajIhI.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $2a40e10cde5ed370$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $2a40e10cde5ed370$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $2a40e10cde5ed370$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $2a40e10cde5ed370$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $ad71aaf4920156c8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ad71aaf4920156c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ad71aaf4920156c8$var$_typeof(o);
}
function $ad71aaf4920156c8$var$_extends() {
    $ad71aaf4920156c8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ad71aaf4920156c8$var$_extends.apply(this, arguments);
}
function $ad71aaf4920156c8$var$_slicedToArray(arr, i) {
    return $ad71aaf4920156c8$var$_arrayWithHoles(arr) || $ad71aaf4920156c8$var$_iterableToArrayLimit(arr, i) || $ad71aaf4920156c8$var$_unsupportedIterableToArray(arr, i) || $ad71aaf4920156c8$var$_nonIterableRest();
}
function $ad71aaf4920156c8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ad71aaf4920156c8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ad71aaf4920156c8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ad71aaf4920156c8$var$_arrayLikeToArray(o, minLen);
}
function $ad71aaf4920156c8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ad71aaf4920156c8$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ad71aaf4920156c8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ad71aaf4920156c8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad71aaf4920156c8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad71aaf4920156c8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ad71aaf4920156c8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad71aaf4920156c8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ad71aaf4920156c8$var$_defineProperty(obj, key, value) {
    key = $ad71aaf4920156c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ad71aaf4920156c8$var$_toPropertyKey(t) {
    var i = $ad71aaf4920156c8$var$_toPrimitive(t, "string");
    return "symbol" == $ad71aaf4920156c8$var$_typeof(i) ? i : i + "";
}
function $ad71aaf4920156c8$var$_toPrimitive(t, r) {
    if ("object" != $ad71aaf4920156c8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ad71aaf4920156c8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ad71aaf4920156c8$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $ad71aaf4920156c8$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $ad71aaf4920156c8$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $ad71aaf4920156c8$var$_objectSpread($ad71aaf4920156c8$var$_objectSpread({}, $ad71aaf4920156c8$var$defaultProps), props);
    var pathRef = (0, $8nGP5.useRef)();
    var _useState = (0, $8nGP5.useState)(-1), _useState2 = $ad71aaf4920156c8$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8nGP5.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $ajIhI.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ad71aaf4920156c8$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $ad71aaf4920156c8$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ad71aaf4920156c8$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $ad71aaf4920156c8$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");



function $ac8f8e6d22dec697$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ac8f8e6d22dec697$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ac8f8e6d22dec697$var$_typeof(o);
}
function $ac8f8e6d22dec697$var$_extends() {
    $ac8f8e6d22dec697$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac8f8e6d22dec697$var$_extends.apply(this, arguments);
}
function $ac8f8e6d22dec697$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac8f8e6d22dec697$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac8f8e6d22dec697$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ac8f8e6d22dec697$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac8f8e6d22dec697$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ac8f8e6d22dec697$var$_defineProperty(obj, key, value) {
    key = $ac8f8e6d22dec697$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ac8f8e6d22dec697$var$_toPropertyKey(t) {
    var i = $ac8f8e6d22dec697$var$_toPrimitive(t, "string");
    return "symbol" == $ac8f8e6d22dec697$var$_typeof(i) ? i : i + "";
}
function $ac8f8e6d22dec697$var$_toPrimitive(t, r) {
    if ("object" != $ac8f8e6d22dec697$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ac8f8e6d22dec697$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ac8f8e6d22dec697$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $ac8f8e6d22dec697$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $e229728826610b73$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $e229728826610b73$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $ac8f8e6d22dec697$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $ac8f8e6d22dec697$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $ac8f8e6d22dec697$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $ac8f8e6d22dec697$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $ac8f8e6d22dec697$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $ac8f8e6d22dec697$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $ac8f8e6d22dec697$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $ac8f8e6d22dec697$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $ac8f8e6d22dec697$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $ac8f8e6d22dec697$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $ac8f8e6d22dec697$var$_objectSpread($ac8f8e6d22dec697$var$_objectSpread({}, $ac8f8e6d22dec697$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $ajIhI.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $ac8f8e6d22dec697$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $ac8f8e6d22dec697$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $ac8f8e6d22dec697$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $2be7c72ce33b6679$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $2be7c72ce33b6679$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be7c72ce33b6679$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be7c72ce33b6679$var$_typeof(o);
}
function $2be7c72ce33b6679$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2be7c72ce33b6679$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2be7c72ce33b6679$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2be7c72ce33b6679$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2be7c72ce33b6679$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2be7c72ce33b6679$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2be7c72ce33b6679$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2be7c72ce33b6679$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2be7c72ce33b6679$var$_defineProperty(obj, key, value) {
    key = $2be7c72ce33b6679$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2be7c72ce33b6679$var$_toPropertyKey(t) {
    var i = $2be7c72ce33b6679$var$_toPrimitive(t, "string");
    return "symbol" == $2be7c72ce33b6679$var$_typeof(i) ? i : i + "";
}
function $2be7c72ce33b6679$var$_toPrimitive(t, r) {
    if ("object" != $2be7c72ce33b6679$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2be7c72ce33b6679$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $2be7c72ce33b6679$var$defaultPropTransformer(option, props) {
    return $2be7c72ce33b6679$var$_objectSpread($2be7c72ce33b6679$var$_objectSpread({}, props), option);
}
function $2be7c72ce33b6679$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $2be7c72ce33b6679$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2a40e10cde5ed370$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ad71aaf4920156c8$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac8f8e6d22dec697$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($2be7c72ce33b6679$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $2be7c72ce33b6679$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) return option.props;
    return option;
}
function $2be7c72ce33b6679$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $2be7c72ce33b6679$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $2be7c72ce33b6679$var$_objectWithoutProperties(_ref2, $2be7c72ce33b6679$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) shape = /*#__PURE__*/ (0, $8nGP5.cloneElement)(option, $2be7c72ce33b6679$var$_objectSpread($2be7c72ce33b6679$var$_objectSpread({}, props), $2be7c72ce33b6679$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($bce4a89e1bec64eb$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($8e0c6c162d0a6ac4$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($2be7c72ce33b6679$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($2be7c72ce33b6679$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $2be7c72ce33b6679$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $2be7c72ce33b6679$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $2be7c72ce33b6679$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $2be7c72ce33b6679$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$7c9a98b3f068686f;
    else if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$b356b51e8337a02f;
    else if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $2be7c72ce33b6679$export$559c3a78b4889350;
    return comparison;
}
function $2be7c72ce33b6679$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $2be7c72ce33b6679$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($2be7c72ce33b6679$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($2be7c72ce33b6679$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($2be7c72ce33b6679$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $2be7c72ce33b6679$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $2be7c72ce33b6679$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $2be7c72ce33b6679$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $2be7c72ce33b6679$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $9ea489eb6e8299b9$var$_excluded = [
    "x",
    "y"
];
function $9ea489eb6e8299b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9ea489eb6e8299b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9ea489eb6e8299b9$var$_typeof(o);
}
function $9ea489eb6e8299b9$var$_extends() {
    $9ea489eb6e8299b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ea489eb6e8299b9$var$_extends.apply(this, arguments);
}
function $9ea489eb6e8299b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ea489eb6e8299b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ea489eb6e8299b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9ea489eb6e8299b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ea489eb6e8299b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9ea489eb6e8299b9$var$_defineProperty(obj, key, value) {
    key = $9ea489eb6e8299b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9ea489eb6e8299b9$var$_toPropertyKey(t) {
    var i = $9ea489eb6e8299b9$var$_toPrimitive(t, "string");
    return "symbol" == $9ea489eb6e8299b9$var$_typeof(i) ? i : i + "";
}
function $9ea489eb6e8299b9$var$_toPrimitive(t, r) {
    if ("object" != $9ea489eb6e8299b9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9ea489eb6e8299b9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $9ea489eb6e8299b9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9ea489eb6e8299b9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9ea489eb6e8299b9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $9ea489eb6e8299b9$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $9ea489eb6e8299b9$var$_objectWithoutProperties(_ref, $9ea489eb6e8299b9$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread($9ea489eb6e8299b9$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $9ea489eb6e8299b9$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $9ea489eb6e8299b9$var$_extends({
        shapeType: "rectangle",
        propTransformer: $9ea489eb6e8299b9$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $9ea489eb6e8299b9$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumber = typeof value === 'number';
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $6f50d8c16ef9d517$var$_excluded = [
    "value",
    "background"
];
var $6f50d8c16ef9d517$var$_Bar;
function $6f50d8c16ef9d517$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6f50d8c16ef9d517$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6f50d8c16ef9d517$var$_typeof(o);
}
function $6f50d8c16ef9d517$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6f50d8c16ef9d517$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6f50d8c16ef9d517$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6f50d8c16ef9d517$var$_extends() {
    $6f50d8c16ef9d517$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f50d8c16ef9d517$var$_extends.apply(this, arguments);
}
function $6f50d8c16ef9d517$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f50d8c16ef9d517$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f50d8c16ef9d517$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6f50d8c16ef9d517$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f50d8c16ef9d517$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f50d8c16ef9d517$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6f50d8c16ef9d517$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6f50d8c16ef9d517$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6f50d8c16ef9d517$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6f50d8c16ef9d517$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6f50d8c16ef9d517$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6f50d8c16ef9d517$var$_callSuper(t, o, e) {
    return o = $6f50d8c16ef9d517$var$_getPrototypeOf(o), $6f50d8c16ef9d517$var$_possibleConstructorReturn(t, $6f50d8c16ef9d517$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6f50d8c16ef9d517$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6f50d8c16ef9d517$var$_possibleConstructorReturn(self, call) {
    if (call && ($6f50d8c16ef9d517$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6f50d8c16ef9d517$var$_assertThisInitialized(self);
}
function $6f50d8c16ef9d517$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6f50d8c16ef9d517$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6f50d8c16ef9d517$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6f50d8c16ef9d517$var$_getPrototypeOf(o) {
    $6f50d8c16ef9d517$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6f50d8c16ef9d517$var$_getPrototypeOf(o);
}
function $6f50d8c16ef9d517$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6f50d8c16ef9d517$var$_setPrototypeOf(subClass, superClass);
}
function $6f50d8c16ef9d517$var$_setPrototypeOf(o, p) {
    $6f50d8c16ef9d517$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6f50d8c16ef9d517$var$_setPrototypeOf(o, p);
}
function $6f50d8c16ef9d517$var$_defineProperty(obj, key, value) {
    key = $6f50d8c16ef9d517$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6f50d8c16ef9d517$var$_toPropertyKey(t) {
    var i = $6f50d8c16ef9d517$var$_toPrimitive(t, "string");
    return "symbol" == $6f50d8c16ef9d517$var$_typeof(i) ? i : i + "";
}
function $6f50d8c16ef9d517$var$_toPrimitive(t, r) {
    if ("object" != $6f50d8c16ef9d517$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6f50d8c16ef9d517$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6f50d8c16ef9d517$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $6f50d8c16ef9d517$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6f50d8c16ef9d517$var$_callSuper(this, Bar, [].concat(args));
        $6f50d8c16ef9d517$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $6f50d8c16ef9d517$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-bar-'));
        $6f50d8c16ef9d517$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $6f50d8c16ef9d517$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $6f50d8c16ef9d517$var$_inherits(Bar, _PureComponent);
    return $6f50d8c16ef9d517$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $6f50d8c16ef9d517$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9ea489eb6e8299b9$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $6f50d8c16ef9d517$var$_objectWithoutProperties(entry, $6f50d8c16ef9d517$var$_excluded);
                    if (!background) return null;
                    var props = $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9ea489eb6e8299b9$export$f19074a6842f9217), $6f50d8c16ef9d517$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ajIhI.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$6f50d8c16ef9d517$var$_Bar = $6f50d8c16ef9d517$export$bbc6c6369b38e3d1;
$6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $6f50d8c16ef9d517$var$_defineProperty($6f50d8c16ef9d517$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $cc31aced37ecb634$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $cc31aced37ecb634$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $cc31aced37ecb634$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $9ea489eb6e8299b9$export$c20d73790de171f0)(minPointSizeProp, $6f50d8c16ef9d517$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $cc31aced37ecb634$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $cc31aced37ecb634$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread($6f50d8c16ef9d517$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $cc31aced37ecb634$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $6f50d8c16ef9d517$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $8nGP5 = parcelRequire("8nGP5");


var $1b98d377f77cff70$exports = {};
var $fccba66310ac2d90$exports = {};
var $609b44c1ee046c31$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $609b44c1ee046c31$var$nativeCeil = Math.ceil, $609b44c1ee046c31$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $609b44c1ee046c31$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $609b44c1ee046c31$var$nativeMax($609b44c1ee046c31$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$609b44c1ee046c31$exports = $609b44c1ee046c31$var$baseRange;



var $72c8651a1f6abbcd$exports = {};
var $47f0826a017aad43$exports = {};
var $94149fd2e115b066$exports = {};
var $3dff5e0e5d51c756$exports = {};
/** Used to match a single whitespace character. */ var $3dff5e0e5d51c756$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3dff5e0e5d51c756$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3dff5e0e5d51c756$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$3dff5e0e5d51c756$exports = $3dff5e0e5d51c756$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $94149fd2e115b066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $94149fd2e115b066$var$baseTrim(string) {
    return string ? string.slice(0, $3dff5e0e5d51c756$exports(string) + 1).replace($94149fd2e115b066$var$reTrimStart, '') : string;
}
$94149fd2e115b066$exports = $94149fd2e115b066$var$baseTrim;




/** Used as references for various `Number` constants. */ var $47f0826a017aad43$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $47f0826a017aad43$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $47f0826a017aad43$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $47f0826a017aad43$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $47f0826a017aad43$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $47f0826a017aad43$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8fab81ce33077160$exports(value)) return $47f0826a017aad43$var$NAN;
    if ($4679825e1cdd07bc$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $4679825e1cdd07bc$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $94149fd2e115b066$exports(value);
    var isBinary = $47f0826a017aad43$var$reIsBinary.test(value);
    return isBinary || $47f0826a017aad43$var$reIsOctal.test(value) ? $47f0826a017aad43$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $47f0826a017aad43$var$reIsBadHex.test(value) ? $47f0826a017aad43$var$NAN : +value;
}
$47f0826a017aad43$exports = $47f0826a017aad43$var$toNumber;


/** Used as references for various `Number` constants. */ var $72c8651a1f6abbcd$var$INFINITY = 1 / 0, $72c8651a1f6abbcd$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $72c8651a1f6abbcd$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $47f0826a017aad43$exports(value);
    if (value === $72c8651a1f6abbcd$var$INFINITY || value === -$72c8651a1f6abbcd$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $72c8651a1f6abbcd$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$72c8651a1f6abbcd$exports = $72c8651a1f6abbcd$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $fccba66310ac2d90$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $b4e75ea659f79f53$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $72c8651a1f6abbcd$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $72c8651a1f6abbcd$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $72c8651a1f6abbcd$exports(step);
        return $609b44c1ee046c31$exports(start, end, step, fromRight);
    };
}
$fccba66310ac2d90$exports = $fccba66310ac2d90$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $1b98d377f77cff70$var$range = $fccba66310ac2d90$exports();
$1b98d377f77cff70$exports = $1b98d377f77cff70$var$range;




var $a090addee6f26581$exports = {};
var $483de91136f09fd5$exports = {};

var $000c4c084007e7b6$exports = {};

var $2jpDk = parcelRequire("2jpDk");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $000c4c084007e7b6$var$now = function() {
    return $2jpDk.Date.now();
};
$000c4c084007e7b6$exports = $000c4c084007e7b6$var$now;



/** Error message constants. */ var $483de91136f09fd5$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $483de91136f09fd5$var$nativeMax = Math.max, $483de91136f09fd5$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $483de91136f09fd5$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($483de91136f09fd5$var$FUNC_ERROR_TEXT);
    wait = $47f0826a017aad43$exports(wait) || 0;
    if ($4679825e1cdd07bc$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $483de91136f09fd5$var$nativeMax($47f0826a017aad43$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $483de91136f09fd5$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $000c4c084007e7b6$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($000c4c084007e7b6$exports());
    }
    function debounced() {
        var time = $000c4c084007e7b6$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$483de91136f09fd5$exports = $483de91136f09fd5$var$debounce;



/** Error message constants. */ var $a090addee6f26581$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a090addee6f26581$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($a090addee6f26581$var$FUNC_ERROR_TEXT);
    if ($4679825e1cdd07bc$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $483de91136f09fd5$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$a090addee6f26581$exports = $a090addee6f26581$var$throttle;



var $ajIhI = parcelRequire("ajIhI");




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");

function $36951101fab10caa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $36951101fab10caa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $36951101fab10caa$var$_typeof(o);
}
function $36951101fab10caa$var$_extends() {
    $36951101fab10caa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36951101fab10caa$var$_extends.apply(this, arguments);
}
function $36951101fab10caa$var$_slicedToArray(arr, i) {
    return $36951101fab10caa$var$_arrayWithHoles(arr) || $36951101fab10caa$var$_iterableToArrayLimit(arr, i) || $36951101fab10caa$var$_unsupportedIterableToArray(arr, i) || $36951101fab10caa$var$_nonIterableRest();
}
function $36951101fab10caa$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $36951101fab10caa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $36951101fab10caa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $36951101fab10caa$var$_arrayLikeToArray(o, minLen);
}
function $36951101fab10caa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $36951101fab10caa$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $36951101fab10caa$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $36951101fab10caa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36951101fab10caa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36951101fab10caa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $36951101fab10caa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36951101fab10caa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $36951101fab10caa$var$_defineProperty(obj, key, value) {
    key = $36951101fab10caa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $36951101fab10caa$var$_toPropertyKey(t) {
    var i = $36951101fab10caa$var$_toPrimitive(t, "string");
    return "symbol" == $36951101fab10caa$var$_typeof(i) ? i : i + "";
}
function $36951101fab10caa$var$_toPrimitive(t, r) {
    if ("object" != $36951101fab10caa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $36951101fab10caa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $36951101fab10caa$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(value[0]) && (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $36951101fab10caa$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $36951101fab10caa$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $36951101fab10caa$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $36951101fab10caa$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $36951101fab10caa$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $36951101fab10caa$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $ajIhI.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $ajIhI.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", $36951101fab10caa$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

function $0e36cf037831a0be$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0e36cf037831a0be$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0e36cf037831a0be$var$_typeof(o);
}
function $0e36cf037831a0be$var$_defineProperty(obj, key, value) {
    key = $0e36cf037831a0be$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0e36cf037831a0be$var$_toPropertyKey(t) {
    var i = $0e36cf037831a0be$var$_toPrimitive(t, "string");
    return "symbol" == $0e36cf037831a0be$var$_typeof(i) ? i : i + "";
}
function $0e36cf037831a0be$var$_toPrimitive(t, r) {
    if ("object" != $0e36cf037831a0be$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0e36cf037831a0be$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0e36cf037831a0be$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $0e36cf037831a0be$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $0e36cf037831a0be$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $ajIhI.default)($0e36cf037831a0be$var$CSS_CLASS_PREFIX, $0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty($0e36cf037831a0be$var$_defineProperty({}, "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-right"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-left"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-bottom"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($0e36cf037831a0be$var$CSS_CLASS_PREFIX, "-top"), (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $0e36cf037831a0be$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $0e36cf037831a0be$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $0e36cf037831a0be$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $0e36cf037831a0be$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $0e36cf037831a0be$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $0e36cf037831a0be$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $0e36cf037831a0be$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $0e36cf037831a0be$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $6380d2f9caef22b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6380d2f9caef22b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6380d2f9caef22b9$var$_typeof(o);
}
function $6380d2f9caef22b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6380d2f9caef22b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6380d2f9caef22b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6380d2f9caef22b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6380d2f9caef22b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6380d2f9caef22b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6380d2f9caef22b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6380d2f9caef22b9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6380d2f9caef22b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6380d2f9caef22b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6380d2f9caef22b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6380d2f9caef22b9$var$_callSuper(t, o, e) {
    return o = $6380d2f9caef22b9$var$_getPrototypeOf(o), $6380d2f9caef22b9$var$_possibleConstructorReturn(t, $6380d2f9caef22b9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6380d2f9caef22b9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6380d2f9caef22b9$var$_possibleConstructorReturn(self, call) {
    if (call && ($6380d2f9caef22b9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6380d2f9caef22b9$var$_assertThisInitialized(self);
}
function $6380d2f9caef22b9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6380d2f9caef22b9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6380d2f9caef22b9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6380d2f9caef22b9$var$_getPrototypeOf(o) {
    $6380d2f9caef22b9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6380d2f9caef22b9$var$_getPrototypeOf(o);
}
function $6380d2f9caef22b9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6380d2f9caef22b9$var$_setPrototypeOf(subClass, superClass);
}
function $6380d2f9caef22b9$var$_setPrototypeOf(o, p) {
    $6380d2f9caef22b9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6380d2f9caef22b9$var$_setPrototypeOf(o, p);
}
function $6380d2f9caef22b9$var$_defineProperty(obj, key, value) {
    key = $6380d2f9caef22b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6380d2f9caef22b9$var$_toPropertyKey(t) {
    var i = $6380d2f9caef22b9$var$_toPrimitive(t, "string");
    return "symbol" == $6380d2f9caef22b9$var$_typeof(i) ? i : i + "";
}
function $6380d2f9caef22b9$var$_toPrimitive(t, r) {
    if ("object" != $6380d2f9caef22b9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6380d2f9caef22b9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6380d2f9caef22b9$var$EPSILON = 1;
var $6380d2f9caef22b9$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $6380d2f9caef22b9$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $6380d2f9caef22b9$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $6380d2f9caef22b9$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $6380d2f9caef22b9$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $6380d2f9caef22b9$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $6380d2f9caef22b9$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $6380d2f9caef22b9$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $6380d2f9caef22b9$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $0e36cf037831a0be$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $6380d2f9caef22b9$var$_objectSpread($6380d2f9caef22b9$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $8nGP5.PureComponent));




function $c1ee5960bb8c7c28$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c1ee5960bb8c7c28$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c1ee5960bb8c7c28$var$_typeof(o);
}
function $c1ee5960bb8c7c28$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c1ee5960bb8c7c28$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c1ee5960bb8c7c28$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c1ee5960bb8c7c28$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c1ee5960bb8c7c28$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c1ee5960bb8c7c28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1ee5960bb8c7c28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c1ee5960bb8c7c28$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c1ee5960bb8c7c28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1ee5960bb8c7c28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1ee5960bb8c7c28$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c1ee5960bb8c7c28$var$_callSuper(t, o, e) {
    return o = $c1ee5960bb8c7c28$var$_getPrototypeOf(o), $c1ee5960bb8c7c28$var$_possibleConstructorReturn(t, $c1ee5960bb8c7c28$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c1ee5960bb8c7c28$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c1ee5960bb8c7c28$var$_possibleConstructorReturn(self, call) {
    if (call && ($c1ee5960bb8c7c28$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c1ee5960bb8c7c28$var$_assertThisInitialized(self);
}
function $c1ee5960bb8c7c28$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c1ee5960bb8c7c28$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c1ee5960bb8c7c28$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c1ee5960bb8c7c28$var$_getPrototypeOf(o) {
    $c1ee5960bb8c7c28$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1ee5960bb8c7c28$var$_getPrototypeOf(o);
}
function $c1ee5960bb8c7c28$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c1ee5960bb8c7c28$var$_setPrototypeOf(subClass, superClass);
}
function $c1ee5960bb8c7c28$var$_setPrototypeOf(o, p) {
    $c1ee5960bb8c7c28$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1ee5960bb8c7c28$var$_setPrototypeOf(o, p);
}
function $c1ee5960bb8c7c28$var$_defineProperty(obj, key, value) {
    key = $c1ee5960bb8c7c28$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c1ee5960bb8c7c28$var$_toPropertyKey(t) {
    var i = $c1ee5960bb8c7c28$var$_toPrimitive(t, "string");
    return "symbol" == $c1ee5960bb8c7c28$var$_typeof(i) ? i : i + "";
}
function $c1ee5960bb8c7c28$var$_toPrimitive(t, r) {
    if ("object" != $c1ee5960bb8c7c28$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c1ee5960bb8c7c28$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c1ee5960bb8c7c28$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $c1ee5960bb8c7c28$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $36951101fab10caa$export$6fe33945eebf9ac8), props);
}
var $c1ee5960bb8c7c28$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $c1ee5960bb8c7c28$var$_classCallCheck(this, Tooltip);
        return $c1ee5960bb8c7c28$var$_callSuper(this, Tooltip, arguments);
    }
    $c1ee5960bb8c7c28$var$_inherits(Tooltip, _PureComponent);
    return $c1ee5960bb8c7c28$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $45b995e155031399$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $c1ee5960bb8c7c28$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $6380d2f9caef22b9$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $c1ee5960bb8c7c28$var$renderContent(content, $c1ee5960bb8c7c28$var$_objectSpread($c1ee5960bb8c7c28$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$c1ee5960bb8c7c28$var$_defineProperty($c1ee5960bb8c7c28$export$28c660c63b792dea, "displayName", 'Tooltip');
$c1ee5960bb8c7c28$var$_defineProperty($c1ee5960bb8c7c28$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $5c4d5cf43eecf2f0$var$_extends() {
    $5c4d5cf43eecf2f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5c4d5cf43eecf2f0$var$_extends.apply(this, arguments);
}
var $5c4d5cf43eecf2f0$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $ajIhI.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("circle", $5c4d5cf43eecf2f0$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, false), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");







function $2de67ced7c3f1e5b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2de67ced7c3f1e5b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2de67ced7c3f1e5b$var$_typeof(o);
}
function $2de67ced7c3f1e5b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2de67ced7c3f1e5b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2de67ced7c3f1e5b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2de67ced7c3f1e5b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2de67ced7c3f1e5b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2de67ced7c3f1e5b$var$_defineProperty(obj, key, value) {
    key = $2de67ced7c3f1e5b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2de67ced7c3f1e5b$var$_toPropertyKey(t) {
    var i = $2de67ced7c3f1e5b$var$_toPrimitive(t, "string");
    return "symbol" == $2de67ced7c3f1e5b$var$_typeof(i) ? i : i + "";
}
function $2de67ced7c3f1e5b$var$_toPrimitive(t, r) {
    if ("object" != $2de67ced7c3f1e5b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2de67ced7c3f1e5b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2de67ced7c3f1e5b$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $2de67ced7c3f1e5b$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $2de67ced7c3f1e5b$var$PREFIX_LIST.reduce(function(res, entry) {
        return $2de67ced7c3f1e5b$var$_objectSpread($2de67ced7c3f1e5b$var$_objectSpread({}, res), {}, $2de67ced7c3f1e5b$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $099f4aa5be8152a1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $099f4aa5be8152a1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $099f4aa5be8152a1$var$_typeof(o);
}
function $099f4aa5be8152a1$var$_extends() {
    $099f4aa5be8152a1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $099f4aa5be8152a1$var$_extends.apply(this, arguments);
}
function $099f4aa5be8152a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $099f4aa5be8152a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $099f4aa5be8152a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $099f4aa5be8152a1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $099f4aa5be8152a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $099f4aa5be8152a1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $099f4aa5be8152a1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $099f4aa5be8152a1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $099f4aa5be8152a1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $099f4aa5be8152a1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $099f4aa5be8152a1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $099f4aa5be8152a1$var$_callSuper(t, o, e) {
    return o = $099f4aa5be8152a1$var$_getPrototypeOf(o), $099f4aa5be8152a1$var$_possibleConstructorReturn(t, $099f4aa5be8152a1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $099f4aa5be8152a1$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $099f4aa5be8152a1$var$_possibleConstructorReturn(self, call) {
    if (call && ($099f4aa5be8152a1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $099f4aa5be8152a1$var$_assertThisInitialized(self);
}
function $099f4aa5be8152a1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $099f4aa5be8152a1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($099f4aa5be8152a1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $099f4aa5be8152a1$var$_getPrototypeOf(o) {
    $099f4aa5be8152a1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $099f4aa5be8152a1$var$_getPrototypeOf(o);
}
function $099f4aa5be8152a1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $099f4aa5be8152a1$var$_setPrototypeOf(subClass, superClass);
}
function $099f4aa5be8152a1$var$_setPrototypeOf(o, p) {
    $099f4aa5be8152a1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $099f4aa5be8152a1$var$_setPrototypeOf(o, p);
}
function $099f4aa5be8152a1$var$_defineProperty(obj, key, value) {
    key = $099f4aa5be8152a1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $099f4aa5be8152a1$var$_toPropertyKey(t) {
    var i = $099f4aa5be8152a1$var$_toPrimitive(t, "string");
    return "symbol" == $099f4aa5be8152a1$var$_typeof(i) ? i : i + "";
}
function $099f4aa5be8152a1$var$_toPrimitive(t, r) {
    if ("object" != $099f4aa5be8152a1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $099f4aa5be8152a1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $099f4aa5be8152a1$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $5389c27663bb3a0e$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $099f4aa5be8152a1$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $099f4aa5be8152a1$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $099f4aa5be8152a1$var$_classCallCheck(this, Brush);
        _this = $099f4aa5be8152a1$var$_callSuper(this, Brush, [
            props
        ]);
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $099f4aa5be8152a1$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $099f4aa5be8152a1$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $099f4aa5be8152a1$var$_inherits(Brush, _PureComponent);
    return $099f4aa5be8152a1$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $099f4aa5be8152a1$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($099f4aa5be8152a1$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $8nGP5.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $099f4aa5be8152a1$var$_objectSpread($099f4aa5be8152a1$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $099f4aa5be8152a1$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $099f4aa5be8152a1$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $ajIhI.default)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.count(children) === 1;
                var style = (0, $2de67ced7c3f1e5b$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $099f4aa5be8152a1$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $099f4aa5be8152a1$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$export$59bc2e3533b384a0, "displayName", 'Brush');
$099f4aa5be8152a1$var$_defineProperty($099f4aa5be8152a1$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");




var $f3c1c1fa4db1e67b$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $55b7e71ec6654a57$exports = {};
var $2d2644df4cbe6c5b$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2d2644df4cbe6c5b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $aa9927229ed34ba4$exports) $aa9927229ed34ba4$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$2d2644df4cbe6c5b$exports = $2d2644df4cbe6c5b$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $55b7e71ec6654a57$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $6aa52744a9ab51b8$exports(iteratee, 3);
    $34c69bd8a346e2bb$exports(object, function(value, key, object) {
        $2d2644df4cbe6c5b$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$55b7e71ec6654a57$exports = $55b7e71ec6654a57$var$mapValues;


var $0a6c56731a98b599$exports = {};
var $59519f3b0613cc71$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $59519f3b0613cc71$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$59519f3b0613cc71$exports = $59519f3b0613cc71$var$arrayEvery;


var $d0ae2edd8b705e48$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $d0ae2edd8b705e48$var$baseEvery(collection, predicate) {
    var result = true;
    $f1008ccff5feed7a$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$d0ae2edd8b705e48$exports = $d0ae2edd8b705e48$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $0a6c56731a98b599$var$every(collection, predicate, guard) {
    var func = $46116793eaa02c32$exports(collection) ? $59519f3b0613cc71$exports : $d0ae2edd8b705e48$exports;
    if (guard && $b4e75ea659f79f53$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6aa52744a9ab51b8$exports(predicate, 3));
}
$0a6c56731a98b599$exports = $0a6c56731a98b599$var$every;






function $b57066fd5661be22$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b57066fd5661be22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b57066fd5661be22$var$_typeof(o);
}
function $b57066fd5661be22$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b57066fd5661be22$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b57066fd5661be22$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b57066fd5661be22$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b57066fd5661be22$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b57066fd5661be22$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b57066fd5661be22$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b57066fd5661be22$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b57066fd5661be22$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b57066fd5661be22$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b57066fd5661be22$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b57066fd5661be22$var$_defineProperty(obj, key, value) {
    key = $b57066fd5661be22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b57066fd5661be22$var$_toPropertyKey(t) {
    var i = $b57066fd5661be22$var$_toPrimitive(t, "string");
    return "symbol" == $b57066fd5661be22$var$_typeof(i) ? i : i + "";
}
function $b57066fd5661be22$var$_toPrimitive(t, r) {
    if ("object" != $b57066fd5661be22$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b57066fd5661be22$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b57066fd5661be22$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $3d08f6c3b4eab1e3$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $3d08f6c3b4eab1e3$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $cc31aced37ecb634$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $cc31aced37ecb634$export$9d80152e23bae434)(scale);
        var ticks = (0, $cc31aced37ecb634$export$ac086aaa4358d590)(scale, $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, result), {}, $b57066fd5661be22$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $b57066fd5661be22$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $b57066fd5661be22$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $b57066fd5661be22$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $b57066fd5661be22$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $b57066fd5661be22$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $b57066fd5661be22$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$b57066fd5661be22$var$_defineProperty($b57066fd5661be22$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $b57066fd5661be22$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, res), {}, $b57066fd5661be22$var$_defineProperty({}, key, $b57066fd5661be22$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $b57066fd5661be22$var$_objectSpread($b57066fd5661be22$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($55b7e71ec6654a57$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($0a6c56731a98b599$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $b57066fd5661be22$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $b57066fd5661be22$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $b57066fd5661be22$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $b32d0da43da8e062$var$_extends() {
    $b32d0da43da8e062$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b32d0da43da8e062$var$_extends.apply(this, arguments);
}
function $b32d0da43da8e062$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b32d0da43da8e062$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b32d0da43da8e062$var$_typeof(o);
}
function $b32d0da43da8e062$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b32d0da43da8e062$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b32d0da43da8e062$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b32d0da43da8e062$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b32d0da43da8e062$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b32d0da43da8e062$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b32d0da43da8e062$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $b32d0da43da8e062$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $b32d0da43da8e062$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b32d0da43da8e062$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b32d0da43da8e062$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b32d0da43da8e062$var$_callSuper(t, o, e) {
    return o = $b32d0da43da8e062$var$_getPrototypeOf(o), $b32d0da43da8e062$var$_possibleConstructorReturn(t, $b32d0da43da8e062$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $b32d0da43da8e062$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $b32d0da43da8e062$var$_possibleConstructorReturn(self, call) {
    if (call && ($b32d0da43da8e062$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b32d0da43da8e062$var$_assertThisInitialized(self);
}
function $b32d0da43da8e062$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b32d0da43da8e062$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b32d0da43da8e062$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $b32d0da43da8e062$var$_getPrototypeOf(o) {
    $b32d0da43da8e062$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b32d0da43da8e062$var$_getPrototypeOf(o);
}
function $b32d0da43da8e062$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b32d0da43da8e062$var$_setPrototypeOf(subClass, superClass);
}
function $b32d0da43da8e062$var$_setPrototypeOf(o, p) {
    $b32d0da43da8e062$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b32d0da43da8e062$var$_setPrototypeOf(o, p);
}
function $b32d0da43da8e062$var$_defineProperty(obj, key, value) {
    key = $b32d0da43da8e062$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b32d0da43da8e062$var$_toPropertyKey(t) {
    var i = $b32d0da43da8e062$var$_toPrimitive(t, "string");
    return "symbol" == $b32d0da43da8e062$var$_typeof(i) ? i : i + "";
}
function $b32d0da43da8e062$var$_toPrimitive(t, r) {
    if ("object" != $b32d0da43da8e062$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b32d0da43da8e062$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b32d0da43da8e062$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $b32d0da43da8e062$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $b32d0da43da8e062$var$_classCallCheck(this, ReferenceDot);
        return $b32d0da43da8e062$var$_callSuper(this, ReferenceDot, arguments);
    }
    $b32d0da43da8e062$var$_inherits(ReferenceDot, _React$Component);
    return $b32d0da43da8e062$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x);
                var isY = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y);
                (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $b32d0da43da8e062$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $b32d0da43da8e062$var$_objectSpread($b32d0da43da8e062$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$b32d0da43da8e062$var$_defineProperty($b32d0da43da8e062$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $b32d0da43da8e062$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $8nGP5 = parcelRequire("8nGP5");

var $1c0fb2bbf2ed516e$exports = {};


var $def60b97c914d75a$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $def60b97c914d75a$var$baseSome(collection, predicate) {
    var result;
    $f1008ccff5feed7a$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$def60b97c914d75a$exports = $def60b97c914d75a$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $1c0fb2bbf2ed516e$var$some(collection, predicate, guard) {
    var func = $46116793eaa02c32$exports(collection) ? $63744a28e8fd4c84$exports : $def60b97c914d75a$exports;
    if (guard && $b4e75ea659f79f53$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $6aa52744a9ab51b8$exports(predicate, 3));
}
$1c0fb2bbf2ed516e$exports = $1c0fb2bbf2ed516e$var$some;



var $ajIhI = parcelRequire("ajIhI");








var $8nGP5 = parcelRequire("8nGP5");

var $5b6ee6816960e591$exports = {};
var $85281606f309b748$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $85281606f309b748$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$70a87f3bd796a6cd$exports(collection)) {
            var iteratee = $6aa52744a9ab51b8$exports(predicate, 3);
            collection = $2e84fcf9f20ac983$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$85281606f309b748$exports = $85281606f309b748$var$createFind;


var $b940e20407e750fe$exports = {};


var $2ce32a6911170559$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $2ce32a6911170559$var$toInteger(value) {
    var result = $72c8651a1f6abbcd$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$2ce32a6911170559$exports = $2ce32a6911170559$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b940e20407e750fe$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b940e20407e750fe$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2ce32a6911170559$exports(fromIndex);
    if (index < 0) index = $b940e20407e750fe$var$nativeMax(length + index, 0);
    return $ecf86b262255e231$exports(array, $6aa52744a9ab51b8$exports(predicate, 3), index);
}
$b940e20407e750fe$exports = $b940e20407e750fe$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $5b6ee6816960e591$var$find = $85281606f309b748$exports($b940e20407e750fe$exports);
$5b6ee6816960e591$exports = $5b6ee6816960e591$var$find;




var $de77b8275d271892$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($c273302ab84aa29a$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $c06c4bb7dffe0deb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06c4bb7dffe0deb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06c4bb7dffe0deb$var$_typeof(o);
}
var $c06c4bb7dffe0deb$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$482c85f2026f212e = /*#__PURE__*/ (0, $8nGP5.createContext)({});
var $c06c4bb7dffe0deb$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $8nGP5.createContext)(undefined);
var $c06c4bb7dffe0deb$export$b18854f928720bc8 = /*#__PURE__*/ (0, $8nGP5.createContext)(0);
var $c06c4bb7dffe0deb$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $8nGP5.createContext)(0);
var $c06c4bb7dffe0deb$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $de77b8275d271892$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($c06c4bb7dffe0deb$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $c06c4bb7dffe0deb$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$e42cfe3f3988c70f);
};
function $c06c4bb7dffe0deb$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $c06c4bb7dffe0deb$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $c06c4bb7dffe0deb$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$92c2a2c8239475bf);
    return (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(xAxisMap);
};
var $c06c4bb7dffe0deb$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    return (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap);
};
var $c06c4bb7dffe0deb$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($5b6ee6816960e591$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0a6c56731a98b599$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap);
};
var $c06c4bb7dffe0deb$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $c06c4bb7dffe0deb$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$29b7735f8b5653b2);
    return viewBox;
};
var $c06c4bb7dffe0deb$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$482c85f2026f212e);
};
var $c06c4bb7dffe0deb$export$8854f7ece606854b = function useChartWidth() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$3c3f0c9338cf7530);
};
var $c06c4bb7dffe0deb$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $8nGP5.useContext)($c06c4bb7dffe0deb$export$b18854f928720bc8);
};


function $17044d3a00ece147$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $17044d3a00ece147$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17044d3a00ece147$var$_typeof(o);
}
function $17044d3a00ece147$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $17044d3a00ece147$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $17044d3a00ece147$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $17044d3a00ece147$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $17044d3a00ece147$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $17044d3a00ece147$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $17044d3a00ece147$var$_callSuper(t, o, e) {
    return o = $17044d3a00ece147$var$_getPrototypeOf(o), $17044d3a00ece147$var$_possibleConstructorReturn(t, $17044d3a00ece147$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $17044d3a00ece147$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $17044d3a00ece147$var$_possibleConstructorReturn(self, call) {
    if (call && ($17044d3a00ece147$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $17044d3a00ece147$var$_assertThisInitialized(self);
}
function $17044d3a00ece147$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $17044d3a00ece147$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($17044d3a00ece147$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $17044d3a00ece147$var$_getPrototypeOf(o) {
    $17044d3a00ece147$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $17044d3a00ece147$var$_getPrototypeOf(o);
}
function $17044d3a00ece147$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $17044d3a00ece147$var$_setPrototypeOf(subClass, superClass);
}
function $17044d3a00ece147$var$_setPrototypeOf(o, p) {
    $17044d3a00ece147$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $17044d3a00ece147$var$_setPrototypeOf(o, p);
}
function $17044d3a00ece147$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $17044d3a00ece147$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $17044d3a00ece147$var$ownKeys(Object(t), !0).forEach(function(r) {
            $17044d3a00ece147$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $17044d3a00ece147$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $17044d3a00ece147$var$_defineProperty(obj, key, value) {
    key = $17044d3a00ece147$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17044d3a00ece147$var$_toPropertyKey(t) {
    var i = $17044d3a00ece147$var$_toPrimitive(t, "string");
    return "symbol" == $17044d3a00ece147$var$_typeof(i) ? i : i + "";
}
function $17044d3a00ece147$var$_toPrimitive(t, r) {
    if ("object" != $17044d3a00ece147$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $17044d3a00ece147$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $17044d3a00ece147$var$_slicedToArray(arr, i) {
    return $17044d3a00ece147$var$_arrayWithHoles(arr) || $17044d3a00ece147$var$_iterableToArrayLimit(arr, i) || $17044d3a00ece147$var$_unsupportedIterableToArray(arr, i) || $17044d3a00ece147$var$_nonIterableRest();
}
function $17044d3a00ece147$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $17044d3a00ece147$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $17044d3a00ece147$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $17044d3a00ece147$var$_arrayLikeToArray(o, minLen);
}
function $17044d3a00ece147$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $17044d3a00ece147$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $17044d3a00ece147$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $17044d3a00ece147$var$_extends() {
    $17044d3a00ece147$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17044d3a00ece147$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $17044d3a00ece147$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $17044d3a00ece147$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $17044d3a00ece147$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($1c0fb2bbf2ed516e$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $17044d3a00ece147$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $c06c4bb7dffe0deb$export$71e825c43eae6ca6)();
    var xAxis = (0, $c06c4bb7dffe0deb$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $c06c4bb7dffe0deb$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $c06c4bb7dffe0deb$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(fixedX);
    var isY = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $17044d3a00ece147$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $17044d3a00ece147$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $17044d3a00ece147$var$_objectSpread($17044d3a00ece147$var$_objectSpread({
        clipPath: clipPath
    }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
        className: (0, $ajIhI.default)('recharts-reference-line', className)
    }, $17044d3a00ece147$var$renderLine(shape, lineProps), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(props, (0, $b57066fd5661be22$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $17044d3a00ece147$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $17044d3a00ece147$var$_classCallCheck(this, ReferenceLine);
        return $17044d3a00ece147$var$_callSuper(this, ReferenceLine, arguments);
    }
    $17044d3a00ece147$var$_inherits(ReferenceLine, _React$Component);
    return $17044d3a00ece147$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($17044d3a00ece147$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$17044d3a00ece147$var$_defineProperty($17044d3a00ece147$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$17044d3a00ece147$var$_defineProperty($17044d3a00ece147$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");








function $fc15d13e0e07ae7f$var$_extends() {
    $fc15d13e0e07ae7f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fc15d13e0e07ae7f$var$_extends.apply(this, arguments);
}
function $fc15d13e0e07ae7f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fc15d13e0e07ae7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fc15d13e0e07ae7f$var$_typeof(o);
}
function $fc15d13e0e07ae7f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc15d13e0e07ae7f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc15d13e0e07ae7f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fc15d13e0e07ae7f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc15d13e0e07ae7f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fc15d13e0e07ae7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fc15d13e0e07ae7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $fc15d13e0e07ae7f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $fc15d13e0e07ae7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fc15d13e0e07ae7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fc15d13e0e07ae7f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fc15d13e0e07ae7f$var$_callSuper(t, o, e) {
    return o = $fc15d13e0e07ae7f$var$_getPrototypeOf(o), $fc15d13e0e07ae7f$var$_possibleConstructorReturn(t, $fc15d13e0e07ae7f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $fc15d13e0e07ae7f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $fc15d13e0e07ae7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($fc15d13e0e07ae7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fc15d13e0e07ae7f$var$_assertThisInitialized(self);
}
function $fc15d13e0e07ae7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fc15d13e0e07ae7f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fc15d13e0e07ae7f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $fc15d13e0e07ae7f$var$_getPrototypeOf(o) {
    $fc15d13e0e07ae7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fc15d13e0e07ae7f$var$_getPrototypeOf(o);
}
function $fc15d13e0e07ae7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fc15d13e0e07ae7f$var$_setPrototypeOf(subClass, superClass);
}
function $fc15d13e0e07ae7f$var$_setPrototypeOf(o, p) {
    $fc15d13e0e07ae7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fc15d13e0e07ae7f$var$_setPrototypeOf(o, p);
}
function $fc15d13e0e07ae7f$var$_defineProperty(obj, key, value) {
    key = $fc15d13e0e07ae7f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fc15d13e0e07ae7f$var$_toPropertyKey(t) {
    var i = $fc15d13e0e07ae7f$var$_toPrimitive(t, "string");
    return "symbol" == $fc15d13e0e07ae7f$var$_typeof(i) ? i : i + "";
}
function $fc15d13e0e07ae7f$var$_toPrimitive(t, r) {
    if ("object" != $fc15d13e0e07ae7f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fc15d13e0e07ae7f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fc15d13e0e07ae7f$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $b57066fd5661be22$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $b57066fd5661be22$export$c7964a5b9439ae62)(p1, p2);
};
var $fc15d13e0e07ae7f$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $fc15d13e0e07ae7f$var$_classCallCheck(this, ReferenceArea);
        return $fc15d13e0e07ae7f$var$_callSuper(this, ReferenceArea, arguments);
    }
    $fc15d13e0e07ae7f$var$_inherits(ReferenceArea, _React$Component);
    return $fc15d13e0e07ae7f$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $3d08f6c3b4eab1e3$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $fc15d13e0e07ae7f$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $fc15d13e0e07ae7f$var$_objectSpread($fc15d13e0e07ae7f$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$fc15d13e0e07ae7f$var$_defineProperty($fc15d13e0e07ae7f$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2a40e10cde5ed370$export$4617fb02663045ef), $fc15d13e0e07ae7f$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $aae848d13cf3ba2c$var$_toConsumableArray(arr) {
    return $aae848d13cf3ba2c$var$_arrayWithoutHoles(arr) || $aae848d13cf3ba2c$var$_iterableToArray(arr) || $aae848d13cf3ba2c$var$_unsupportedIterableToArray(arr) || $aae848d13cf3ba2c$var$_nonIterableSpread();
}
function $aae848d13cf3ba2c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aae848d13cf3ba2c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aae848d13cf3ba2c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aae848d13cf3ba2c$var$_arrayLikeToArray(o, minLen);
}
function $aae848d13cf3ba2c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $aae848d13cf3ba2c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aae848d13cf3ba2c$var$_arrayLikeToArray(arr);
}
function $aae848d13cf3ba2c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aae848d13cf3ba2c$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $17044d3a00ece147$export$b2f28e248e7838eb));
    var dots = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $b32d0da43da8e062$export$aa7f0b0106bff39));
    var elements = [].concat($aae848d13cf3ba2c$var$_toConsumableArray(lines), $aae848d13cf3ba2c$var$_toConsumableArray(dots));
    var areas = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $fc15d13e0e07ae7f$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $f3c1c1fa4db1e67b$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[key1]) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $f52b8f1d950ef826$exports = {};
'use strict';
var $f52b8f1d950ef826$var$has = Object.prototype.hasOwnProperty, $f52b8f1d950ef826$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f52b8f1d950ef826$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f52b8f1d950ef826$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f52b8f1d950ef826$var$Events().__proto__) $f52b8f1d950ef826$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f52b8f1d950ef826$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f52b8f1d950ef826$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $f52b8f1d950ef826$var$EE(fn, context || emitter, once), evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f52b8f1d950ef826$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f52b8f1d950ef826$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f52b8f1d950ef826$var$EventEmitter() {
    this._events = new $f52b8f1d950ef826$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f52b8f1d950ef826$var$has.call(events, name)) names.push($f52b8f1d950ef826$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f52b8f1d950ef826$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f52b8f1d950ef826$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f52b8f1d950ef826$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f52b8f1d950ef826$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f52b8f1d950ef826$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f52b8f1d950ef826$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f52b8f1d950ef826$var$prefix ? $f52b8f1d950ef826$var$prefix + event : event;
        if (this._events[evt]) $f52b8f1d950ef826$var$clearEvent(this, evt);
    } else {
        this._events = new $f52b8f1d950ef826$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f52b8f1d950ef826$var$EventEmitter.prototype.off = $f52b8f1d950ef826$var$EventEmitter.prototype.removeListener;
$f52b8f1d950ef826$var$EventEmitter.prototype.addListener = $f52b8f1d950ef826$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f52b8f1d950ef826$var$EventEmitter.prefixed = $f52b8f1d950ef826$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f52b8f1d950ef826$var$EventEmitter.EventEmitter = $f52b8f1d950ef826$var$EventEmitter;
$f52b8f1d950ef826$exports = $f52b8f1d950ef826$var$EventEmitter;


var $7a03261827aeb66f$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($f52b8f1d950ef826$exports)))();
var $7a03261827aeb66f$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $46f047ba3a8a0f0e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $46f047ba3a8a0f0e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $46f047ba3a8a0f0e$var$_typeof(o);
}
function $46f047ba3a8a0f0e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46f047ba3a8a0f0e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $46f047ba3a8a0f0e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $46f047ba3a8a0f0e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46f047ba3a8a0f0e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46f047ba3a8a0f0e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $46f047ba3a8a0f0e$var$_defineProperty(obj, key, value) {
    key = $46f047ba3a8a0f0e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $46f047ba3a8a0f0e$var$_toPropertyKey(t) {
    var i = $46f047ba3a8a0f0e$var$_toPrimitive(t, "string");
    return "symbol" == $46f047ba3a8a0f0e$var$_typeof(i) ? i : i + "";
}
function $46f047ba3a8a0f0e$var$_toPrimitive(t, r) {
    if ("object" != $46f047ba3a8a0f0e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $46f047ba3a8a0f0e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $46f047ba3a8a0f0e$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $46f047ba3a8a0f0e$var$_classCallCheck(this, AccessibilityManager);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "activeIndex", 0);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "coordinateList", []);
        $46f047ba3a8a0f0e$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $46f047ba3a8a0f0e$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $0ded3ded59a9813b$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domainStart) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");




var $ajIhI = parcelRequire("ajIhI");



function $1371972ac018f8f3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1371972ac018f8f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1371972ac018f8f3$var$_typeof(o);
}
function $1371972ac018f8f3$var$_extends() {
    $1371972ac018f8f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1371972ac018f8f3$var$_extends.apply(this, arguments);
}
function $1371972ac018f8f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1371972ac018f8f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1371972ac018f8f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1371972ac018f8f3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1371972ac018f8f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1371972ac018f8f3$var$_defineProperty(obj, key, value) {
    key = $1371972ac018f8f3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1371972ac018f8f3$var$_toPropertyKey(t) {
    var i = $1371972ac018f8f3$var$_toPrimitive(t, "string");
    return "symbol" == $1371972ac018f8f3$var$_typeof(i) ? i : i + "";
}
function $1371972ac018f8f3$var$_toPrimitive(t, r) {
    if ("object" != $1371972ac018f8f3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1371972ac018f8f3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1371972ac018f8f3$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $4efdaf596664c2fb$exports.curveBasisClosed),
    curveBasisOpen: (0, $4efdaf596664c2fb$exports.curveBasisOpen),
    curveBasis: (0, $4efdaf596664c2fb$exports.curveBasis),
    curveBumpX: (0, $4efdaf596664c2fb$exports.curveBumpX),
    curveBumpY: (0, $4efdaf596664c2fb$exports.curveBumpY),
    curveLinearClosed: (0, $4efdaf596664c2fb$exports.curveLinearClosed),
    curveLinear: (0, $4efdaf596664c2fb$exports.curveLinear),
    curveMonotoneX: (0, $4efdaf596664c2fb$exports.curveMonotoneX),
    curveMonotoneY: (0, $4efdaf596664c2fb$exports.curveMonotoneY),
    curveNatural: (0, $4efdaf596664c2fb$exports.curveNatural),
    curveStep: (0, $4efdaf596664c2fb$exports.curveStep),
    curveStepAfter: (0, $4efdaf596664c2fb$exports.curveStepAfter),
    curveStepBefore: (0, $4efdaf596664c2fb$exports.curveStepBefore)
};
var $1371972ac018f8f3$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $1371972ac018f8f3$var$getX = function getX(p) {
    return p.x;
};
var $1371972ac018f8f3$var$getY = function getY(p) {
    return p.y;
};
var $1371972ac018f8f3$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($dba9b32de817c336$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $1371972ac018f8f3$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $1371972ac018f8f3$var$CURVE_FACTORIES[name] || (0, $4efdaf596664c2fb$exports.curveLinear);
};
var $1371972ac018f8f3$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $1371972ac018f8f3$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $1371972ac018f8f3$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $1371972ac018f8f3$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $1371972ac018f8f3$var$_objectSpread($1371972ac018f8f3$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $4efdaf596664c2fb$exports.area)().y($1371972ac018f8f3$var$getY).x1($1371972ac018f8f3$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $4efdaf596664c2fb$exports.area)().x($1371972ac018f8f3$var$getX).y1($1371972ac018f8f3$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($1371972ac018f8f3$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $4efdaf596664c2fb$exports.area)().y($1371972ac018f8f3$var$getY).x1($1371972ac018f8f3$var$getX).x0(baseLine);
    else if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $4efdaf596664c2fb$exports.area)().x($1371972ac018f8f3$var$getX).y1($1371972ac018f8f3$var$getY).y0(baseLine);
    else lineFunction = (0, $4efdaf596664c2fb$exports.line)().x($1371972ac018f8f3$var$getX).y($1371972ac018f8f3$var$getY);
    lineFunction.defined($1371972ac018f8f3$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $1371972ac018f8f3$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $1371972ac018f8f3$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $1371972ac018f8f3$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, false), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $ajIhI.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


function $d02fe2384966c7b3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d02fe2384966c7b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d02fe2384966c7b3$var$_typeof(o);
}
var $d02fe2384966c7b3$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $d02fe2384966c7b3$var$_extends() {
    $d02fe2384966c7b3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d02fe2384966c7b3$var$_extends.apply(this, arguments);
}
function $d02fe2384966c7b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d02fe2384966c7b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d02fe2384966c7b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d02fe2384966c7b3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d02fe2384966c7b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d02fe2384966c7b3$var$_defineProperty(obj, key, value) {
    key = $d02fe2384966c7b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d02fe2384966c7b3$var$_toPropertyKey(t) {
    var i = $d02fe2384966c7b3$var$_toPrimitive(t, "string");
    return "symbol" == $d02fe2384966c7b3$var$_typeof(i) ? i : i + "";
}
function $d02fe2384966c7b3$var$_toPrimitive(t, r) {
    if ("object" != $d02fe2384966c7b3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d02fe2384966c7b3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d02fe2384966c7b3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d02fe2384966c7b3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d02fe2384966c7b3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d02fe2384966c7b3$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $d02fe2384966c7b3$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $d02fe2384966c7b3$var$_objectWithoutProperties(_ref, $d02fe2384966c7b3$var$_excluded);
    var props = $d02fe2384966c7b3$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(top) || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("path", $d02fe2384966c7b3$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(props, true), {
        className: (0, $ajIhI.default)('recharts-cross', className),
        d: $d02fe2384966c7b3$var$getPath(x, y, width, height, top, left)
    }));
};


function $c18e35bf49155ee1$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $80b0b4a67fb2d33d$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $9823ac6159474f98$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $e229728826610b73$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $80b0b4a67fb2d33d$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $f3674fa56c89941b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f3674fa56c89941b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f3674fa56c89941b$var$_typeof(o);
}
function $f3674fa56c89941b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3674fa56c89941b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3674fa56c89941b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f3674fa56c89941b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3674fa56c89941b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f3674fa56c89941b$var$_defineProperty(obj, key, value) {
    key = $f3674fa56c89941b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f3674fa56c89941b$var$_toPropertyKey(t) {
    var i = $f3674fa56c89941b$var$_toPrimitive(t, "string");
    return "symbol" == $f3674fa56c89941b$var$_typeof(i) ? i : i + "";
}
function $f3674fa56c89941b$var$_toPrimitive(t, r) {
    if ("object" != $f3674fa56c89941b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f3674fa56c89941b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f3674fa56c89941b$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $1371972ac018f8f3$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $d02fe2384966c7b3$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $c18e35bf49155ee1$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $2a40e10cde5ed370$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $80b0b4a67fb2d33d$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $ac8f8e6d22dec697$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $9823ac6159474f98$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $1371972ac018f8f3$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread($f3674fa56c89941b$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $ajIhI.default)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $8nGP5.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $8nGP5.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $8nGP5.createElement)(cursorComp, cursorProps);
}



var $3cb8ecafb87115bc$var$_excluded = [
    "item"
], $3cb8ecafb87115bc$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $3cb8ecafb87115bc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3cb8ecafb87115bc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3cb8ecafb87115bc$var$_typeof(o);
}
function $3cb8ecafb87115bc$var$_extends() {
    $3cb8ecafb87115bc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3cb8ecafb87115bc$var$_extends.apply(this, arguments);
}
function $3cb8ecafb87115bc$var$_slicedToArray(arr, i) {
    return $3cb8ecafb87115bc$var$_arrayWithHoles(arr) || $3cb8ecafb87115bc$var$_iterableToArrayLimit(arr, i) || $3cb8ecafb87115bc$var$_unsupportedIterableToArray(arr, i) || $3cb8ecafb87115bc$var$_nonIterableRest();
}
function $3cb8ecafb87115bc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb8ecafb87115bc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3cb8ecafb87115bc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3cb8ecafb87115bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3cb8ecafb87115bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3cb8ecafb87115bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3cb8ecafb87115bc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3cb8ecafb87115bc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3cb8ecafb87115bc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3cb8ecafb87115bc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3cb8ecafb87115bc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3cb8ecafb87115bc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3cb8ecafb87115bc$var$_callSuper(t, o, e) {
    return o = $3cb8ecafb87115bc$var$_getPrototypeOf(o), $3cb8ecafb87115bc$var$_possibleConstructorReturn(t, $3cb8ecafb87115bc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3cb8ecafb87115bc$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3cb8ecafb87115bc$var$_possibleConstructorReturn(self, call) {
    if (call && ($3cb8ecafb87115bc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3cb8ecafb87115bc$var$_assertThisInitialized(self);
}
function $3cb8ecafb87115bc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3cb8ecafb87115bc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3cb8ecafb87115bc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3cb8ecafb87115bc$var$_getPrototypeOf(o) {
    $3cb8ecafb87115bc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3cb8ecafb87115bc$var$_getPrototypeOf(o);
}
function $3cb8ecafb87115bc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3cb8ecafb87115bc$var$_setPrototypeOf(subClass, superClass);
}
function $3cb8ecafb87115bc$var$_setPrototypeOf(o, p) {
    $3cb8ecafb87115bc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3cb8ecafb87115bc$var$_setPrototypeOf(o, p);
}
function $3cb8ecafb87115bc$var$_toConsumableArray(arr) {
    return $3cb8ecafb87115bc$var$_arrayWithoutHoles(arr) || $3cb8ecafb87115bc$var$_iterableToArray(arr) || $3cb8ecafb87115bc$var$_unsupportedIterableToArray(arr) || $3cb8ecafb87115bc$var$_nonIterableSpread();
}
function $3cb8ecafb87115bc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3cb8ecafb87115bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3cb8ecafb87115bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3cb8ecafb87115bc$var$_arrayLikeToArray(o, minLen);
}
function $3cb8ecafb87115bc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3cb8ecafb87115bc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3cb8ecafb87115bc$var$_arrayLikeToArray(arr);
}
function $3cb8ecafb87115bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3cb8ecafb87115bc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3cb8ecafb87115bc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3cb8ecafb87115bc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3cb8ecafb87115bc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3cb8ecafb87115bc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3cb8ecafb87115bc$var$_defineProperty(obj, key, value) {
    key = $3cb8ecafb87115bc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3cb8ecafb87115bc$var$_toPropertyKey(t) {
    var i = $3cb8ecafb87115bc$var$_toPrimitive(t, "string");
    return "symbol" == $3cb8ecafb87115bc$var$_typeof(i) ? i : i + "";
}
function $3cb8ecafb87115bc$var$_toPrimitive(t, r) {
    if ("object" != $3cb8ecafb87115bc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3cb8ecafb87115bc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3cb8ecafb87115bc$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $3cb8ecafb87115bc$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $3cb8ecafb87115bc$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $3cb8ecafb87115bc$var$renderAsIs(element) {
    return element;
}
var $3cb8ecafb87115bc$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $3cb8ecafb87115bc$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, rangeObj), (0, $e229728826610b73$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, rangeObj), (0, $e229728826610b73$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $3cb8ecafb87115bc$var$originCoordinate;
};
var $3cb8ecafb87115bc$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($3cb8ecafb87115bc$var$_toConsumableArray(result), $3cb8ecafb87115bc$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dataStartIndex) && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $3cb8ecafb87115bc$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $3cb8ecafb87115bc$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($3cb8ecafb87115bc$var$_toConsumableArray(result), [
            (0, $cc31aced37ecb634$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $3cb8ecafb87115bc$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $3cb8ecafb87115bc$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $cc31aced37ecb634$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $3cb8ecafb87115bc$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $3cb8ecafb87115bc$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $cc31aced37ecb634$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $0ded3ded59a9813b$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $3cb8ecafb87115bc$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $3d08f6c3b4eab1e3$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $cc31aced37ecb634$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($3cb8ecafb87115bc$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $cc31aced37ecb634$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry) ? finalDomain : [].concat($3cb8ecafb87115bc$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $cc31aced37ecb634$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $cc31aced37ecb634$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $cc31aced37ecb634$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $cc31aced37ecb634$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $3cb8ecafb87115bc$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $cc31aced37ecb634$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $3cb8ecafb87115bc$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($1b98d377f77cff70$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $cc31aced37ecb634$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $cc31aced37ecb634$export$a0bc8660980558a0)(originalDomain, (0, $cc31aced37ecb634$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $aae848d13cf3ba2c$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))($3cb8ecafb87115bc$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $3cb8ecafb87115bc$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $3cb8ecafb87115bc$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $3cb8ecafb87115bc$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $3cb8ecafb87115bc$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($0082dfda2c4d7cdc$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $3cb8ecafb87115bc$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $3cb8ecafb87115bc$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $3cb8ecafb87115bc$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $3cb8ecafb87115bc$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
    var legendItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $06340f5273236c74$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $099f4aa5be8152a1$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $cc31aced37ecb634$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $3cb8ecafb87115bc$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $3cb8ecafb87115bc$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $3cb8ecafb87115bc$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $3cb8ecafb87115bc$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $3cb8ecafb87115bc$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $0c84d2c5e90079cb$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $cc31aced37ecb634$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $cc31aced37ecb634$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $3cb8ecafb87115bc$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $cc31aced37ecb634$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $cc31aced37ecb634$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, pos), {}, {
                        position: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, composedFn($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty($3cb8ecafb87115bc$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $8b99c43c69c5c37b$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $8b99c43c69c5c37b$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $3cb8ecafb87115bc$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $cc31aced37ecb634$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, result), {}, $3cb8ecafb87115bc$var$_defineProperty({}, name, $3cb8ecafb87115bc$var$getAxisMap(props, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $3cb8ecafb87115bc$var$calculateOffset($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $3cb8ecafb87115bc$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $3cb8ecafb87115bc$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $3cb8ecafb87115bc$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $3cb8ecafb87115bc$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $3cb8ecafb87115bc$var$_defineProperty(_this, "accessibilityManager", new (0, $46f047ba3a8a0f0e$export$a2c2de1efa8671eb)());
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($3cb8ecafb87115bc$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $3cb8ecafb87115bc$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $8b99c43c69c5c37b$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).emit((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($3cb8ecafb87115bc$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $3cb8ecafb87115bc$var$originCoordinate;
                    _this.setState($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $f3674fa56c89941b$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $ajIhI.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $3c595a89abddaa2c$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $3cb8ecafb87115bc$var$_objectWithoutProperties(props, $3cb8ecafb87115bc$var$_excluded);
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(item, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $3cb8ecafb87115bc$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(tooltipItem, {
                    viewBox: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $cc31aced37ecb634$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(activeDot, false)), (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $cc31aced37ecb634$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $3d08f6c3b4eab1e3$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($3cb8ecafb87115bc$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $8nGP5.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $8nGP5.cloneElement)(element, $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $3cb8ecafb87115bc$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                YAxis: {
                    handler: $3cb8ecafb87115bc$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($a090addee6f26581$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $3cb8ecafb87115bc$var$_inherits(CategoricalChartWrapper, _Component);
        return $3cb8ecafb87115bc$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $3cb8ecafb87115bc$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $8b99c43c69c5c37b$export$acdc716e08572f94)([
                        (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(prevProps.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea))
                    ], [
                        (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(this.props.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(this.props.children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $afcbff65789b5460$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $3cb8ecafb87115bc$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $3d08f6c3b4eab1e3$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $e229728826610b73$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $c1ee5960bb8c7c28$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $f1d44a0cc6cff721$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).on((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $7a03261827aeb66f$export$9bcdfe5f29bb33).removeListener((0, $7a03261827aeb66f$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $8b99c43c69c5c37b$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $3cb8ecafb87115bc$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, res), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $3cb8ecafb87115bc$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, res), {}, $3cb8ecafb87115bc$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $8b99c43c69c5c37b$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $2a40e10cde5ed370$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $e229728826610b73$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $2be7c72ce33b6679$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $2be7c72ce33b6679$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $2be7c72ce33b6679$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $2be7c72ce33b6679$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $2be7c72ce33b6679$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $8b99c43c69c5c37b$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $3cb8ecafb87115bc$var$_objectWithoutProperties(_this$props6, $3cb8ecafb87115bc$var$_excluded2);
                    var attrs = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c06c4bb7dffe0deb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), $3cb8ecafb87115bc$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $8b99c43c69c5c37b$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $c06c4bb7dffe0deb$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", $3cb8ecafb87115bc$var$_extends({
                        className: (0, $ajIhI.default)('recharts-wrapper', className),
                        style: $3cb8ecafb87115bc$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ed0c2f2ddc9d58cd$export$7b92b459e668cb21), $3cb8ecafb87115bc$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $3cb8ecafb87115bc$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $8b99c43c69c5c37b$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $8nGP5.Component));
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $3cb8ecafb87115bc$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $3cb8ecafb87115bc$export$e5182fb58612e577(nextProps);
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $3cb8ecafb87115bc$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, $3cb8ecafb87115bc$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $8b99c43c69c5c37b$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $8b99c43c69c5c37b$export$64c61536a2b72e0f)(children, (0, $099f4aa5be8152a1$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($3cb8ecafb87115bc$var$_objectSpread($3cb8ecafb87115bc$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $3cb8ecafb87115bc$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $8nGP5.isValidElement)(option)) dot = /*#__PURE__*/ (0, $8nGP5.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(CategoricalChartWrapper, $3cb8ecafb87115bc$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");


var $8nGP5 = parcelRequire("8nGP5");



var $ajIhI = parcelRequire("ajIhI");












/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $67d4444155ff8f94$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $d8628af70720a1fc$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $b57066fd5661be22$export$3ee78d51cffc2b68)(size, angle);
}
function $d8628af70720a1fc$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $d8628af70720a1fc$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $d8628af70720a1fc$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $67d4444155ff8f94$export$41514b9f058a6886)(ticks, interval + 1);
}




function $a8fa9b9160b1bf17$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $67d4444155ff8f94$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $dfb3031f2e0bc9fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dfb3031f2e0bc9fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dfb3031f2e0bc9fa$var$_typeof(o);
}
function $dfb3031f2e0bc9fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfb3031f2e0bc9fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfb3031f2e0bc9fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dfb3031f2e0bc9fa$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfb3031f2e0bc9fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dfb3031f2e0bc9fa$var$_defineProperty(obj, key, value) {
    key = $dfb3031f2e0bc9fa$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dfb3031f2e0bc9fa$var$_toPropertyKey(t) {
    var i = $dfb3031f2e0bc9fa$var$_toPrimitive(t, "string");
    return "symbol" == $dfb3031f2e0bc9fa$var$_typeof(i) ? i : i + "";
}
function $dfb3031f2e0bc9fa$var$_toPrimitive(t, r) {
    if ("object" != $dfb3031f2e0bc9fa$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dfb3031f2e0bc9fa$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dfb3031f2e0bc9fa$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $dfb3031f2e0bc9fa$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $d8628af70720a1fc$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $dfb3031f2e0bc9fa$var$_objectSpread($dfb3031f2e0bc9fa$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $dfb3031f2e0bc9fa$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(interval) || (0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr) return (0, $d8628af70720a1fc$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $afcbff65789b5460$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $d8628af70720a1fc$export$a1966f4ad955c82b)((0, $afcbff65789b5460$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $afcbff65789b5460$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $3d08f6c3b4eab1e3$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $d8628af70720a1fc$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $a8fa9b9160b1bf17$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $dfb3031f2e0bc9fa$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $dfb3031f2e0bc9fa$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $040ce345c37febc7$var$_excluded = [
    "viewBox"
], $040ce345c37febc7$var$_excluded2 = [
    "viewBox"
], $040ce345c37febc7$var$_excluded3 = [
    "ticks"
];
function $040ce345c37febc7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $040ce345c37febc7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $040ce345c37febc7$var$_typeof(o);
}
function $040ce345c37febc7$var$_extends() {
    $040ce345c37febc7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040ce345c37febc7$var$_extends.apply(this, arguments);
}
function $040ce345c37febc7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $040ce345c37febc7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $040ce345c37febc7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $040ce345c37febc7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $040ce345c37febc7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $040ce345c37febc7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $040ce345c37febc7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $040ce345c37febc7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $040ce345c37febc7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $040ce345c37febc7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $040ce345c37febc7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $040ce345c37febc7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $040ce345c37febc7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $040ce345c37febc7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $040ce345c37febc7$var$_callSuper(t, o, e) {
    return o = $040ce345c37febc7$var$_getPrototypeOf(o), $040ce345c37febc7$var$_possibleConstructorReturn(t, $040ce345c37febc7$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $040ce345c37febc7$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $040ce345c37febc7$var$_possibleConstructorReturn(self, call) {
    if (call && ($040ce345c37febc7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $040ce345c37febc7$var$_assertThisInitialized(self);
}
function $040ce345c37febc7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $040ce345c37febc7$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($040ce345c37febc7$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $040ce345c37febc7$var$_getPrototypeOf(o) {
    $040ce345c37febc7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $040ce345c37febc7$var$_getPrototypeOf(o);
}
function $040ce345c37febc7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $040ce345c37febc7$var$_setPrototypeOf(subClass, superClass);
}
function $040ce345c37febc7$var$_setPrototypeOf(o, p) {
    $040ce345c37febc7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $040ce345c37febc7$var$_setPrototypeOf(o, p);
}
function $040ce345c37febc7$var$_defineProperty(obj, key, value) {
    key = $040ce345c37febc7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $040ce345c37febc7$var$_toPropertyKey(t) {
    var i = $040ce345c37febc7$var$_toPrimitive(t, "string");
    return "symbol" == $040ce345c37febc7$var$_typeof(i) ? i : i + "";
}
function $040ce345c37febc7$var$_toPrimitive(t, r) {
    if ("object" != $040ce345c37febc7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $040ce345c37febc7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $040ce345c37febc7$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $040ce345c37febc7$var$_classCallCheck(this, CartesianAxis);
        _this = $040ce345c37febc7$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $040ce345c37febc7$var$_inherits(CartesianAxis, _Component);
    return $040ce345c37febc7$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $040ce345c37febc7$var$_objectWithoutProperties(_ref, $040ce345c37febc7$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $040ce345c37febc7$var$_objectWithoutProperties(_this$props, $040ce345c37febc7$var$_excluded2);
                return !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $0e7c207b469fdda3$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false)), (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $040ce345c37febc7$var$_extends({}, props, {
                    className: (0, $ajIhI.default)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread($040ce345c37febc7$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $040ce345c37febc7$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $040ce345c37febc7$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $ajIhI.default)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($cb1822b0eadf52f8$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $040ce345c37febc7$var$_objectWithoutProperties(_this$props8, $040ce345c37febc7$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: (0, $ajIhI.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $91b8fcd34b00a8a9$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $844463820b79d851$export$5f1af8db9871e1d6), $040ce345c37febc7$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $8nGP5.Component));
$040ce345c37febc7$var$_defineProperty($040ce345c37febc7$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$040ce345c37febc7$var$_defineProperty($040ce345c37febc7$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $f4dd95f529f72065$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f4dd95f529f72065$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f4dd95f529f72065$var$_typeof(o);
}
function $f4dd95f529f72065$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f4dd95f529f72065$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f4dd95f529f72065$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f4dd95f529f72065$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f4dd95f529f72065$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f4dd95f529f72065$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f4dd95f529f72065$var$_callSuper(t, o, e) {
    return o = $f4dd95f529f72065$var$_getPrototypeOf(o), $f4dd95f529f72065$var$_possibleConstructorReturn(t, $f4dd95f529f72065$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $f4dd95f529f72065$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $f4dd95f529f72065$var$_possibleConstructorReturn(self, call) {
    if (call && ($f4dd95f529f72065$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f4dd95f529f72065$var$_assertThisInitialized(self);
}
function $f4dd95f529f72065$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f4dd95f529f72065$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f4dd95f529f72065$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f4dd95f529f72065$var$_getPrototypeOf(o) {
    $f4dd95f529f72065$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f4dd95f529f72065$var$_getPrototypeOf(o);
}
function $f4dd95f529f72065$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $f4dd95f529f72065$var$_setPrototypeOf(subClass, superClass);
}
function $f4dd95f529f72065$var$_setPrototypeOf(o, p) {
    $f4dd95f529f72065$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f4dd95f529f72065$var$_setPrototypeOf(o, p);
}
function $f4dd95f529f72065$var$_defineProperty(obj, key, value) {
    key = $f4dd95f529f72065$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f4dd95f529f72065$var$_toPropertyKey(t) {
    var i = $f4dd95f529f72065$var$_toPrimitive(t, "string");
    return "symbol" == $f4dd95f529f72065$var$_typeof(i) ? i : i + "";
}
function $f4dd95f529f72065$var$_toPrimitive(t, r) {
    if ("object" != $f4dd95f529f72065$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f4dd95f529f72065$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f4dd95f529f72065$var$_extends() {
    $f4dd95f529f72065$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4dd95f529f72065$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $f4dd95f529f72065$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var height = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var axisOptions = (0, $c06c4bb7dffe0deb$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $040ce345c37febc7$export$bdd99f2cdf352bae), $f4dd95f529f72065$var$_extends({}, axisOptions, {
        className: (0, $ajIhI.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $f4dd95f529f72065$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $f4dd95f529f72065$var$_classCallCheck(this, XAxis);
        return $f4dd95f529f72065$var$_callSuper(this, XAxis, arguments);
    }
    $f4dd95f529f72065$var$_inherits(XAxis, _React$Component);
    return $f4dd95f529f72065$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($f4dd95f529f72065$var$XAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$f4dd95f529f72065$var$_defineProperty($f4dd95f529f72065$export$ea77231de273b52d, "displayName", 'XAxis');
$f4dd95f529f72065$var$_defineProperty($f4dd95f529f72065$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");



function $0a6c1adc00c46590$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0a6c1adc00c46590$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a6c1adc00c46590$var$_typeof(o);
}
function $0a6c1adc00c46590$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a6c1adc00c46590$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0a6c1adc00c46590$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0a6c1adc00c46590$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0a6c1adc00c46590$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0a6c1adc00c46590$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0a6c1adc00c46590$var$_callSuper(t, o, e) {
    return o = $0a6c1adc00c46590$var$_getPrototypeOf(o), $0a6c1adc00c46590$var$_possibleConstructorReturn(t, $0a6c1adc00c46590$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $0a6c1adc00c46590$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $0a6c1adc00c46590$var$_possibleConstructorReturn(self, call) {
    if (call && ($0a6c1adc00c46590$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $0a6c1adc00c46590$var$_assertThisInitialized(self);
}
function $0a6c1adc00c46590$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0a6c1adc00c46590$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a6c1adc00c46590$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $0a6c1adc00c46590$var$_getPrototypeOf(o) {
    $0a6c1adc00c46590$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0a6c1adc00c46590$var$_getPrototypeOf(o);
}
function $0a6c1adc00c46590$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $0a6c1adc00c46590$var$_setPrototypeOf(subClass, superClass);
}
function $0a6c1adc00c46590$var$_setPrototypeOf(o, p) {
    $0a6c1adc00c46590$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0a6c1adc00c46590$var$_setPrototypeOf(o, p);
}
function $0a6c1adc00c46590$var$_defineProperty(obj, key, value) {
    key = $0a6c1adc00c46590$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0a6c1adc00c46590$var$_toPropertyKey(t) {
    var i = $0a6c1adc00c46590$var$_toPrimitive(t, "string");
    return "symbol" == $0a6c1adc00c46590$var$_typeof(i) ? i : i + "";
}
function $0a6c1adc00c46590$var$_toPrimitive(t, r) {
    if ("object" != $0a6c1adc00c46590$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0a6c1adc00c46590$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0a6c1adc00c46590$var$_extends() {
    $0a6c1adc00c46590$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a6c1adc00c46590$var$_extends.apply(this, arguments);
}
var $0a6c1adc00c46590$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var height = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var axisOptions = (0, $c06c4bb7dffe0deb$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $040ce345c37febc7$export$bdd99f2cdf352bae), $0a6c1adc00c46590$var$_extends({}, axisOptions, {
        className: (0, $ajIhI.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $0a6c1adc00c46590$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $0a6c1adc00c46590$var$_classCallCheck(this, YAxis);
        return $0a6c1adc00c46590$var$_callSuper(this, YAxis, arguments);
    }
    $0a6c1adc00c46590$var$_inherits(YAxis, _React$Component);
    return $0a6c1adc00c46590$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0a6c1adc00c46590$var$YAxisImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$0a6c1adc00c46590$var$_defineProperty($0a6c1adc00c46590$export$f96c4024c52de8f4, "displayName", 'YAxis');
$0a6c1adc00c46590$var$_defineProperty($0a6c1adc00c46590$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $22df2ac19736874d$export$94aefc399ef206a9 = (0, $3cb8ecafb87115bc$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f4dd95f529f72065$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0a6c1adc00c46590$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $b57066fd5661be22$export$ece7de1383db5ac)
});


var $8nGP5 = parcelRequire("8nGP5");








var $836f11cfcda8d642$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $836f11cfcda8d642$var$_excluded2 = [
    "offset"
];
function $836f11cfcda8d642$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $836f11cfcda8d642$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $836f11cfcda8d642$var$_typeof(o);
}
function $836f11cfcda8d642$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $836f11cfcda8d642$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $836f11cfcda8d642$var$ownKeys(Object(t), !0).forEach(function(r) {
            $836f11cfcda8d642$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $836f11cfcda8d642$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $836f11cfcda8d642$var$_defineProperty(obj, key, value) {
    key = $836f11cfcda8d642$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $836f11cfcda8d642$var$_toPropertyKey(t) {
    var i = $836f11cfcda8d642$var$_toPrimitive(t, "string");
    return "symbol" == $836f11cfcda8d642$var$_typeof(i) ? i : i + "";
}
function $836f11cfcda8d642$var$_toPrimitive(t, r) {
    if ("object" != $836f11cfcda8d642$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $836f11cfcda8d642$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $836f11cfcda8d642$var$_extends() {
    $836f11cfcda8d642$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $836f11cfcda8d642$var$_extends.apply(this, arguments);
}
function $836f11cfcda8d642$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $836f11cfcda8d642$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $836f11cfcda8d642$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $836f11cfcda8d642$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $836f11cfcda8d642$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $836f11cfcda8d642$var$_objectWithoutProperties(props, $836f11cfcda8d642$var$_excluded);
        var _filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $836f11cfcda8d642$var$_objectWithoutProperties(_filterProps, $836f11cfcda8d642$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("line", $836f11cfcda8d642$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $836f11cfcda8d642$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $836f11cfcda8d642$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $836f11cfcda8d642$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $836f11cfcda8d642$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $836f11cfcda8d642$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $836f11cfcda8d642$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $836f11cfcda8d642$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $cc31aced37ecb634$export$846dc5ac5fecff74)((0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, (0, $040ce345c37febc7$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $836f11cfcda8d642$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $cc31aced37ecb634$export$846dc5ac5fecff74)((0, $dfb3031f2e0bc9fa$export$3d27d42b1034de5c)($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, (0, $040ce345c37febc7$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $cc31aced37ecb634$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $836f11cfcda8d642$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $836f11cfcda8d642$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $c06c4bb7dffe0deb$export$8854f7ece606854b)();
    var chartHeight = (0, $c06c4bb7dffe0deb$export$369ae257969c6f9f)();
    var offset = (0, $c06c4bb7dffe0deb$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $836f11cfcda8d642$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $836f11cfcda8d642$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $836f11cfcda8d642$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $836f11cfcda8d642$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $836f11cfcda8d642$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $836f11cfcda8d642$var$defaultProps.verticalFill,
        x: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $c06c4bb7dffe0deb$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $c06c4bb7dffe0deb$export$631ee617f1052e16)();
    if (!(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(x) || x !== +x || !(0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $836f11cfcda8d642$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $836f11cfcda8d642$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($836f11cfcda8d642$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $836f11cfcda8d642$var$_objectSpread($836f11cfcda8d642$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($836f11cfcda8d642$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$HorizontalGridLines, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$VerticalGridLines, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$HorizontalStripes, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($836f11cfcda8d642$var$VerticalStripes, $836f11cfcda8d642$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$836f11cfcda8d642$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $ajIhI = parcelRequire("ajIhI");

var $8nGP5 = parcelRequire("8nGP5");




function $65a9db7fe004392a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $65a9db7fe004392a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $65a9db7fe004392a$var$_typeof(o);
}
function $65a9db7fe004392a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65a9db7fe004392a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65a9db7fe004392a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $65a9db7fe004392a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65a9db7fe004392a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65a9db7fe004392a$var$_defineProperty(obj, key, value) {
    key = $65a9db7fe004392a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $65a9db7fe004392a$var$_toPropertyKey(t) {
    var i = $65a9db7fe004392a$var$_toPrimitive(t, "string");
    return "symbol" == $65a9db7fe004392a$var$_typeof(i) ? i : i + "";
}
function $65a9db7fe004392a$var$_toPrimitive(t, r) {
    if ("object" != $65a9db7fe004392a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $65a9db7fe004392a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $65a9db7fe004392a$var$_slicedToArray(arr, i) {
    return $65a9db7fe004392a$var$_arrayWithHoles(arr) || $65a9db7fe004392a$var$_iterableToArrayLimit(arr, i) || $65a9db7fe004392a$var$_unsupportedIterableToArray(arr, i) || $65a9db7fe004392a$var$_nonIterableRest();
}
function $65a9db7fe004392a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $65a9db7fe004392a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $65a9db7fe004392a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $65a9db7fe004392a$var$_arrayLikeToArray(o, minLen);
}
function $65a9db7fe004392a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $65a9db7fe004392a$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $65a9db7fe004392a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $65a9db7fe004392a$export$e60a4704009a0009 = /*#__PURE__*/ (0, $8nGP5.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $8nGP5.useRef)(null);
    var onResizeRef = (0, $8nGP5.useRef)();
    onResizeRef.current = onResize;
    (0, $8nGP5.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $8nGP5.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $65a9db7fe004392a$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $8nGP5.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $8nGP5.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($a090addee6f26581$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $8nGP5.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)((0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(width) || (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $3d08f6c3b4eab1e3$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $7371dc891b6c1818$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $8b99c43c69c5c37b$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(child)) return /*#__PURE__*/ (0, $8nGP5.cloneElement)(child, $65a9db7fe004392a$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $65a9db7fe004392a$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $ajIhI.default)('recharts-responsive-container', className),
        style: $65a9db7fe004392a$var$_objectSpread($65a9db7fe004392a$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});


var $4be1ee3c8ca80a36$export$fb184b623420d9be;
var $4be1ee3c8ca80a36$export$d866e82dddc7abe3;
$4be1ee3c8ca80a36$export$fb184b623420d9be = `pcyrpa_title`;
$4be1ee3c8ca80a36$export$d866e82dddc7abe3 = `pcyrpa_titleUnderline`;



var $kSbwP = parcelRequire("kSbwP");


var $fgQ0V = parcelRequire("fgQ0V");
class $36ec24632073ba4a$export$41830d6935700b58 {
    //243a5c  657e96
    static genColorGradientHorizontal(id, colors) {
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsxs)("linearGradient", {
                id: id,
                x1: "0",
                y1: "0",
                x2: "1",
                y2: "1",
                children: [
                    (0, $kSbwP.jsx)("stop", {
                        offset: "0%",
                        stopColor: colors[0],
                        stopOpacity: 1
                    }),
                    (0, $kSbwP.jsx)("stop", {
                        offset: "30%",
                        stopColor: colors[0],
                        stopOpacity: 1
                    }),
                    (0, $kSbwP.jsx)("stop", {
                        offset: "100%",
                        stopColor: colors[1],
                        stopOpacity: 1
                    })
                ]
            })
        });
    }
}
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "SHADOW_FILTER", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'drop-shadow(3px 1px 4px rgba(0, 0, 0, 0.5))'
});
//    static GOLD_COLOR = ['#bfae5a', '#d9c666'];
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "GOLD_COLOR", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        '#bfae5a',
        '#b8a858'
    ]
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "BLUE_COLOR", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [
        '#243a5c',
        '#657e96'
    ]
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "getBarGradient", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ()=>{
        return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
            children: [
                $36ec24632073ba4a$export$41830d6935700b58.genColorGradientHorizontal('barGradientBlue', $36ec24632073ba4a$export$41830d6935700b58.BLUE_COLOR),
                $36ec24632073ba4a$export$41830d6935700b58.genColorGradientHorizontal('barGradientGold', $36ec24632073ba4a$export$41830d6935700b58.GOLD_COLOR)
            ]
        });
    }
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "formatCurrency", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (v)=>{
        if ((0, $fgQ0V.isString)(v)) v = (0, $7fbd760f3c05e83d$export$c0080068ec287465)(v);
        if (v == 0 || isNaN(v)) return 'N/A';
        return '$' + v.toFixed(0);
    }
});
Object.defineProperty($36ec24632073ba4a$export$41830d6935700b58, "formatPercent", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (v)=>{
        if (v == 0 || isNaN(v)) return 'N/A';
        return v.toFixed(0) + '%';
    }
});



const $79f88d7943aea7e8$export$c2e12a891bea2f25 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.createDataAccess(p.reportId);
    const hideUnderline = p.hideUnderline === true;
    if (q == null) return null;
    var scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(q);
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    var groups = scoreStore.SCORE_FIELDS_GROUPS;
    var data = [];
    const GEN_SCORE_ID = 'ALL';
    const scoreTotal = scoreUtils.calcScorePercentile();
    data.push({
        sectionId: GEN_SCORE_ID,
        name: 'Overall Score',
        Score: scoreTotal ? (scoreTotal * 100).toFixed(0) : 'N/A'
    });
    groups.forEach((group)=>{
        if (scoreUtils.is_section_used_for_scoring_by_id(group.sectionId)) data.push({
            sectionId: group.sectionId,
            name: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
            Score: (scoreUtils.calcSectionPercentileById(group.sectionId) * 100).toFixed(0)
        });
    });
    const renderCustomAxisTick = ({ x: x, y: y, payload: payload })=>{
        const sectionId = payload.value == GEN_SCORE_ID ? 'overview' : payload.value;
        const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)(sectionId);
        const sectionName = data.find((section)=>section.sectionId === payload.value).name.split(' ')[0];
        return (0, $kSbwP.jsxs)("g", {
            transform: `translate(${x},${y})`,
            children: [
                (0, $kSbwP.jsx)("image", {
                    href: icon,
                    x: -30,
                    y: -12,
                    width: 20,
                    height: 20
                }),
                (0, $kSbwP.jsx)("text", {
                    fontSize: "12" // ✅ Set readable font size
                    ,
                    fontFamily: "LustTextMedium" // ✅ Keep it clean
                    ,
                    x: -10,
                    y: -25,
                    textAnchor: "end",
                    fill: "#212529",
                    children: sectionName
                })
            ]
        });
    };
    const titleCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($4be1ee3c8ca80a36$export$fb184b623420d9be, {
        [$4be1ee3c8ca80a36$export$d866e82dddc7abe3]: !hideUnderline
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        children: [
            (0, $kSbwP.jsx)("div", {
                className: titleCls,
                children: "Score Summary"
            }),
            (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                width: "100%",
                height: "100%",
                children: (0, $kSbwP.jsxs)((0, $22df2ac19736874d$export$94aefc399ef206a9), {
                    layout: "vertical",
                    width: 500,
                    height: 300,
                    data: data,
                    margin: {
                        top: 20,
                        left: 20,
                        right: 20,
                        bottom: 20
                    },
                    barGap: 5,
                    barCategoryGap: 10,
                    children: [
                        (0, $kSbwP.jsx)("defs", {
                            children: (0, $36ec24632073ba4a$export$41830d6935700b58).getBarGradient()
                        }),
                        (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                            strokeDasharray: "3 3"
                        }),
                        (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                            type: "number",
                            domain: [
                                0,
                                'dataMax'
                            ],
                            allowDataOverflow: true,
                            ticks: [
                                0,
                                25,
                                50,
                                75,
                                100
                            ]
                        }),
                        (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                            dataKey: "sectionId",
                            type: "category",
                            tick: renderCustomAxisTick
                        }),
                        (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {
                            labelFormatter: (value)=>{
                                return data.find((section)=>section.sectionId === value).name;
                            },
                            formatter: (value, name, props)=>`${value}%`
                        }),
                        (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                            dataKey: "Score",
                            radius: [
                                0,
                                10,
                                10,
                                0
                            ],
                            maxBarSize: 100,
                            children: [
                                data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                        fill: entry.sectionId === GEN_SCORE_ID ? 'url(#barGradientGold)' : 'url(#barGradientBlue)',
                                        style: {
                                            filter: (0, $36ec24632073ba4a$export$41830d6935700b58).SHADOW_FILTER
                                        }
                                    }, `cell-${index}`)),
                                (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                    dataKey: "Score",
                                    position: "insideRight",
                                    formatter: (v)=>v + '%',
                                    fill: "white"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");






const $a04e8dca7e1102b6$export$bf43f5ad66c8bc17 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const [ref, bounds] = (0, $3a0100122386f550$export$2e2bcd8739ae039)();
    const [clickedEntry, setClickedEntry] = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useState({
        id: ''
    });
    const scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    var groups = scoreStore.SCORE_FIELDS_GROUPS;
    var data = [];
    var companies = [
        p.reportId,
        ...p.companies
    ];
    companies.forEach((reportId)=>{
        var companyEntry = {};
        var q = store.createDataAccess(reportId);
        if (q == null) return;
        companyEntry['id'] = reportId;
        companyEntry['name'] = q.value('company_name');
        companyEntry['Score'] = q.score();
        companyEntry['logo'] = q.value('logoURL');
        if (companyEntry['Score'] == -1) return;
        data.push(companyEntry);
    });
    const renderCustomAxisTick = ({ x: x, y: y, payload: payload, visibleTicksCount: visibleTicksCount })=>{
        const logoURL = data[payload.index].logo;
        const barWidth = Math.floor(bounds.width / (data.length + 1) * 0.6); // Approximate way if chart width is known
        const alternateHeight = barWidth < 150;
        var textOffset = 0;
        if (alternateHeight) {
            if (payload.index % 2 == 0) textOffset = -7;
            else textOffset = 7;
        }
        const imageWidth = barWidth;
        const imageHeight = barWidth * 0.75;
        var img = (0, $kSbwP.jsx)("image", {
            opacity: 1,
            href: logoURL,
            width: barWidth,
            height: barWidth * 0.75,
            preserveAspectRatio: "xMidYMax meet"
        });
        return (0, $kSbwP.jsxs)("g", {
            transform: `translate(${x},${y})`,
            children: [
                (0, $kSbwP.jsx)("svg", {
                    x: -barWidth / 2,
                    y: -barWidth - 25,
                    width: imageWidth,
                    height: imageHeight,
                    children: img
                }),
                (0, $kSbwP.jsx)("text", {
                    fontSize: "12" // ✅ Set readable font size
                    ,
                    fontFamily: "LustTextMedium" // ✅ Keep it clean
                    ,
                    x: 0,
                    y: 20 - textOffset,
                    textAnchor: "middle",
                    fill: "#212529",
                    children: payload.value
                })
            ]
        });
    };
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                (0, $kSbwP.jsx)("div", {
                    ref: ref,
                    style: {
                        height: '100%',
                        width: '100%',
                        position: 'absolute',
                        opacity: 0
                    }
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $4be1ee3c8ca80a36$export$fb184b623420d9be,
                    children: "Benchmarking"
                }),
                (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                    width: "100%",
                    height: "100%",
                    children: (0, $kSbwP.jsxs)((0, $22df2ac19736874d$export$94aefc399ef206a9), {
                        width: 500,
                        height: 300,
                        data: data,
                        margin: {
                            top: 20,
                            left: 20,
                            right: 20,
                            bottom: 20
                        },
                        children: [
                            (0, $kSbwP.jsx)("defs", {
                                children: (0, $36ec24632073ba4a$export$41830d6935700b58).getBarGradient()
                            }),
                            (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {}),
                            (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {}),
                            (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                                dataKey: 'Score',
                                stackId: "a",
                                radius: [
                                    10,
                                    10,
                                    0,
                                    0
                                ],
                                children: [
                                    data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                            fill: entry.id === p.reportId ? 'url(#barGradientGold)' : 'url(#barGradientBlue)',
                                            stroke: clickedEntry.id === entry.id ? '#212529' : 'none',
                                            strokeWidth: 2,
                                            style: {
                                                filter: (0, $36ec24632073ba4a$export$41830d6935700b58).SHADOW_FILTER
                                            },
                                            onClick: ()=>{
                                                if (entry.id == p.reportId) return;
                                                setClickedEntry({
                                                    id: entry.id
                                                });
                                                setTimeout(()=>{
                                                    setClickedEntry({
                                                        id: ''
                                                    });
                                                    nav.toReport(entry.id);
                                                }, 5);
                                            }
                                        }, `cell-${index}`)),
                                    (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                        dataKey: "Score",
                                        position: "insideBottom",
                                        formatter: (v)=>v + '%',
                                        offset: 20,
                                        fill: "white",
                                        stroke: "transparent"
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                                dataKey: "name",
                                tick: renderCustomAxisTick,
                                interval: 0
                            })
                        ]
                    })
                })
            ]
        })
    });
});



var $ee30843c79a5ac9f$export$4a2bd288272bd4d7;
var $ee30843c79a5ac9f$export$b848b6ed1647f90b;
$ee30843c79a5ac9f$export$4a2bd288272bd4d7 = `BtxznG_panelPaddingLeft`;
$ee30843c79a5ac9f$export$b848b6ed1647f90b = `BtxznG_panelPaddingRight`;



var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");
/**
 * @fileOverview Composed Chart
 */ 

var $8nGP5 = parcelRequire("8nGP5");

var $ajIhI = parcelRequire("ajIhI");














var $1b8fe288515e608e$var$_excluded = [
    "layout",
    "type",
    "stroke",
    "connectNulls",
    "isRange",
    "ref"
], $1b8fe288515e608e$var$_excluded2 = [
    "key"
];
var $1b8fe288515e608e$var$_Area;
function $1b8fe288515e608e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1b8fe288515e608e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1b8fe288515e608e$var$_typeof(o);
}
function $1b8fe288515e608e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1b8fe288515e608e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1b8fe288515e608e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1b8fe288515e608e$var$_extends() {
    $1b8fe288515e608e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b8fe288515e608e$var$_extends.apply(this, arguments);
}
function $1b8fe288515e608e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b8fe288515e608e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b8fe288515e608e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1b8fe288515e608e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b8fe288515e608e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1b8fe288515e608e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1b8fe288515e608e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1b8fe288515e608e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1b8fe288515e608e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1b8fe288515e608e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1b8fe288515e608e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1b8fe288515e608e$var$_callSuper(t, o, e) {
    return o = $1b8fe288515e608e$var$_getPrototypeOf(o), $1b8fe288515e608e$var$_possibleConstructorReturn(t, $1b8fe288515e608e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1b8fe288515e608e$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1b8fe288515e608e$var$_possibleConstructorReturn(self, call) {
    if (call && ($1b8fe288515e608e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1b8fe288515e608e$var$_assertThisInitialized(self);
}
function $1b8fe288515e608e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1b8fe288515e608e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1b8fe288515e608e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1b8fe288515e608e$var$_getPrototypeOf(o) {
    $1b8fe288515e608e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1b8fe288515e608e$var$_getPrototypeOf(o);
}
function $1b8fe288515e608e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1b8fe288515e608e$var$_setPrototypeOf(subClass, superClass);
}
function $1b8fe288515e608e$var$_setPrototypeOf(o, p) {
    $1b8fe288515e608e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1b8fe288515e608e$var$_setPrototypeOf(o, p);
}
function $1b8fe288515e608e$var$_defineProperty(obj, key, value) {
    key = $1b8fe288515e608e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1b8fe288515e608e$var$_toPropertyKey(t) {
    var i = $1b8fe288515e608e$var$_toPrimitive(t, "string");
    return "symbol" == $1b8fe288515e608e$var$_typeof(i) ? i : i + "";
}
function $1b8fe288515e608e$var$_toPrimitive(t, r) {
    if ("object" != $1b8fe288515e608e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1b8fe288515e608e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1b8fe288515e608e$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    function Area() {
        var _this;
        $1b8fe288515e608e$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1b8fe288515e608e$var$_callSuper(this, Area, [].concat(args));
        $1b8fe288515e608e$var$_defineProperty(_this, "state", {
            isAnimationFinished: true
        });
        $1b8fe288515e608e$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-area-'));
        $1b8fe288515e608e$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onAnimationEnd)) onAnimationEnd();
        });
        $1b8fe288515e608e$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(onAnimationStart)) onAnimationStart();
        });
        return _this;
    }
    $1b8fe288515e608e$var$_inherits(Area, _PureComponent);
    return $1b8fe288515e608e$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        dataKey: dataKey,
                        value: entry.value,
                        payload: entry.payload,
                        points: points
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $1b8fe288515e608e$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxY = Math.max(baseLine, maxY);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') maxX = Math.max(baseLine, maxX);
                else if (baseLine && Array.isArray(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($16a263dc7ad650d9$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === 'vertical') return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $1b8fe288515e608e$var$_objectWithoutProperties(_this$props4, $1b8fe288515e608e$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== 'none' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== 'none' && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $1b8fe288515e608e$var$_extends({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine;
                // const clipPathId = isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseLine) && typeof baseLine === 'number') {
                            var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($5fa94942c48bac63$exports)))(baseLine)) {
                            var _interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $1b8fe288515e608e$var$_objectSpread($1b8fe288515e608e$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $ajIhI.default)('recharts-area', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $8b99c43c69c5c37b$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$1b8fe288515e608e$var$_Area = $1b8fe288515e608e$export$ea1a111407f37557;
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "displayName", 'Area');
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "defaultProps", {
    stroke: '#3182bd',
    fill: '#3182bd',
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'line',
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "getBaseValue", function(props, item, xAxis, yAxis) {
    var layout = props.layout, chartBaseValue = props.baseValue;
    var itemBaseValue = item.props.baseValue;
    // The baseValue can be defined both on the AreaChart as well as on the Area.
    // The value for the item takes precedence.
    var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
    if ((0, $3d08f6c3b4eab1e3$export$7e4aa119212bc614)(baseValue) && typeof baseValue === 'number') return baseValue;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var domainMax = Math.max(domain[0], domain[1]);
        var domainMin = Math.min(domain[0], domain[1]);
        if (baseValue === 'dataMin') return domainMin;
        if (baseValue === 'dataMax') return domainMax;
        return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === 'dataMin') return domain[0];
    if (baseValue === 'dataMax') return domain[1];
    return domain[0];
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "getComposedData", function(_ref4) {
    var props = _ref4.props, item = _ref4.item, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, bandSize = _ref4.bandSize, dataKey = _ref4.dataKey, stackedData = _ref4.stackedData, dataStartIndex = _ref4.dataStartIndex, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $1b8fe288515e608e$var$_Area.getBaseValue(props, item, xAxis, yAxis);
    var isHorizontalLayout = layout === 'horizontal';
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = value[1] == null || hasStack && (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey) == null;
        if (isHorizontalLayout) return {
            x: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        var x = Array.isArray(entry.value) ? entry.value[0] : null;
        if (isHorizontalLayout) return {
            x: entry.x,
            y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
        return {
            x: x != null ? xAxis.scale(x) : null,
            y: entry.y
        };
    });
    else baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
    return $1b8fe288515e608e$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
});
$1b8fe288515e608e$var$_defineProperty($1b8fe288515e608e$export$ea1a111407f37557, "renderDotItem", function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dotItem = option(props);
    else {
        var className = (0, $ajIhI.default)('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
        var key = props.key, rest = $1b8fe288515e608e$var$_objectWithoutProperties(props, $1b8fe288515e608e$var$_excluded2);
        dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $1b8fe288515e608e$var$_extends({}, rest, {
            key: key,
            className: className
        }));
    }
    return dotItem;
});




var $8nGP5 = parcelRequire("8nGP5");





var $ajIhI = parcelRequire("ajIhI");









var $a0158cc2cd24124f$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
], $a0158cc2cd24124f$var$_excluded2 = [
    "key"
];
function $a0158cc2cd24124f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a0158cc2cd24124f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a0158cc2cd24124f$var$_typeof(o);
}
function $a0158cc2cd24124f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a0158cc2cd24124f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a0158cc2cd24124f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a0158cc2cd24124f$var$_extends() {
    $a0158cc2cd24124f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0158cc2cd24124f$var$_extends.apply(this, arguments);
}
function $a0158cc2cd24124f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0158cc2cd24124f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0158cc2cd24124f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a0158cc2cd24124f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0158cc2cd24124f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a0158cc2cd24124f$var$_toConsumableArray(arr) {
    return $a0158cc2cd24124f$var$_arrayWithoutHoles(arr) || $a0158cc2cd24124f$var$_iterableToArray(arr) || $a0158cc2cd24124f$var$_unsupportedIterableToArray(arr) || $a0158cc2cd24124f$var$_nonIterableSpread();
}
function $a0158cc2cd24124f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a0158cc2cd24124f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a0158cc2cd24124f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a0158cc2cd24124f$var$_arrayLikeToArray(o, minLen);
}
function $a0158cc2cd24124f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a0158cc2cd24124f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a0158cc2cd24124f$var$_arrayLikeToArray(arr);
}
function $a0158cc2cd24124f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a0158cc2cd24124f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0158cc2cd24124f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a0158cc2cd24124f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a0158cc2cd24124f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a0158cc2cd24124f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a0158cc2cd24124f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a0158cc2cd24124f$var$_callSuper(t, o, e) {
    return o = $a0158cc2cd24124f$var$_getPrototypeOf(o), $a0158cc2cd24124f$var$_possibleConstructorReturn(t, $a0158cc2cd24124f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a0158cc2cd24124f$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a0158cc2cd24124f$var$_possibleConstructorReturn(self, call) {
    if (call && ($a0158cc2cd24124f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a0158cc2cd24124f$var$_assertThisInitialized(self);
}
function $a0158cc2cd24124f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a0158cc2cd24124f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a0158cc2cd24124f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a0158cc2cd24124f$var$_getPrototypeOf(o) {
    $a0158cc2cd24124f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a0158cc2cd24124f$var$_getPrototypeOf(o);
}
function $a0158cc2cd24124f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a0158cc2cd24124f$var$_setPrototypeOf(subClass, superClass);
}
function $a0158cc2cd24124f$var$_setPrototypeOf(o, p) {
    $a0158cc2cd24124f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a0158cc2cd24124f$var$_setPrototypeOf(o, p);
}
function $a0158cc2cd24124f$var$_defineProperty(obj, key, value) {
    key = $a0158cc2cd24124f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0158cc2cd24124f$var$_toPropertyKey(t) {
    var i = $a0158cc2cd24124f$var$_toPrimitive(t, "string");
    return "symbol" == $a0158cc2cd24124f$var$_typeof(i) ? i : i + "";
}
function $a0158cc2cd24124f$var$_toPrimitive(t, r) {
    if ("object" != $a0158cc2cd24124f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a0158cc2cd24124f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a0158cc2cd24124f$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    function Line() {
        var _this;
        $a0158cc2cd24124f$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a0158cc2cd24124f$var$_callSuper(this, Line, [].concat(args));
        $a0158cc2cd24124f$var$_defineProperty(_this, "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($a0158cc2cd24124f$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($a0158cc2cd24124f$var$_toConsumableArray(Line.repeat(lines, count)), $a0158cc2cd24124f$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(', ');
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-line-'));
        $a0158cc2cd24124f$var$_defineProperty(_this, "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $a0158cc2cd24124f$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $a0158cc2cd24124f$var$_inherits(Line, _PureComponent);
    return $a0158cc2cd24124f$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        index: i,
                        cx: entry.x,
                        cy: entry.y,
                        value: entry.value,
                        dataKey: dataKey,
                        payload: entry.payload,
                        points: points
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $a0158cc2cd24124f$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $a0158cc2cd24124f$var$_objectWithoutProperties(_this$props3, $a0158cc2cd24124f$var$_excluded);
                var curveProps = $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: 'none',
                    className: 'recharts-line-curve',
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $a0158cc2cd24124f$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $a0158cc2cd24124f$var$_objectSpread($a0158cc2cd24124f$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $ajIhI.default)('recharts-line', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $8b99c43c69c5c37b$export$392f6c9701718a4e)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($a0158cc2cd24124f$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($a0158cc2cd24124f$var$_toConsumableArray(result), $a0158cc2cd24124f$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(option)) dotItem = option(props);
                else {
                    var key = props.key, dotProps = $a0158cc2cd24124f$var$_objectWithoutProperties(props, $a0158cc2cd24124f$var$_excluded2);
                    var className = (0, $ajIhI.default)('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $5c4d5cf43eecf2f0$export$d046b3c4a416f60d), $a0158cc2cd24124f$var$_extends({
                        key: key
                    }, dotProps, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "displayName", 'Line');
$a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    fill: '#fff',
    points: [],
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $a0158cc2cd24124f$var$_defineProperty($a0158cc2cd24124f$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === 'horizontal') return {
            x: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $a0158cc2cd24124f$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});



var $8nGP5 = parcelRequire("8nGP5");





var $ajIhI = parcelRequire("ajIhI");





var $8nGP5 = parcelRequire("8nGP5");
function $01500a896f6ae02c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $01500a896f6ae02c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $01500a896f6ae02c$var$_typeof(o);
}
function $01500a896f6ae02c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $01500a896f6ae02c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $01500a896f6ae02c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $01500a896f6ae02c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $01500a896f6ae02c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $01500a896f6ae02c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $01500a896f6ae02c$var$_callSuper(t, o, e) {
    return o = $01500a896f6ae02c$var$_getPrototypeOf(o), $01500a896f6ae02c$var$_possibleConstructorReturn(t, $01500a896f6ae02c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $01500a896f6ae02c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $01500a896f6ae02c$var$_possibleConstructorReturn(self, call) {
    if (call && ($01500a896f6ae02c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $01500a896f6ae02c$var$_assertThisInitialized(self);
}
function $01500a896f6ae02c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $01500a896f6ae02c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($01500a896f6ae02c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $01500a896f6ae02c$var$_getPrototypeOf(o) {
    $01500a896f6ae02c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $01500a896f6ae02c$var$_getPrototypeOf(o);
}
function $01500a896f6ae02c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $01500a896f6ae02c$var$_setPrototypeOf(subClass, superClass);
}
function $01500a896f6ae02c$var$_setPrototypeOf(o, p) {
    $01500a896f6ae02c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $01500a896f6ae02c$var$_setPrototypeOf(o, p);
}
function $01500a896f6ae02c$var$_defineProperty(obj, key, value) {
    key = $01500a896f6ae02c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $01500a896f6ae02c$var$_toPropertyKey(t) {
    var i = $01500a896f6ae02c$var$_toPrimitive(t, "string");
    return "symbol" == $01500a896f6ae02c$var$_typeof(i) ? i : i + "";
}
function $01500a896f6ae02c$var$_toPrimitive(t, r) {
    if ("object" != $01500a896f6ae02c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $01500a896f6ae02c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $01500a896f6ae02c$export$2363a7fa7edfe988 = /*#__PURE__*/ function(_React$Component) {
    function ZAxis() {
        $01500a896f6ae02c$var$_classCallCheck(this, ZAxis);
        return $01500a896f6ae02c$var$_callSuper(this, ZAxis, arguments);
    }
    $01500a896f6ae02c$var$_inherits(ZAxis, _React$Component);
    return $01500a896f6ae02c$var$_createClass(ZAxis, [
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
$01500a896f6ae02c$var$_defineProperty($01500a896f6ae02c$export$2363a7fa7edfe988, "displayName", 'ZAxis');
$01500a896f6ae02c$var$_defineProperty($01500a896f6ae02c$export$2363a7fa7edfe988, "defaultProps", {
    zAxisId: 0,
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number'
});









var $8nGP5 = parcelRequire("8nGP5");


var $ae3fae625d10f6ae$var$_excluded = [
    "option",
    "isActive"
];
function $ae3fae625d10f6ae$var$_extends() {
    $ae3fae625d10f6ae$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ae3fae625d10f6ae$var$_extends.apply(this, arguments);
}
function $ae3fae625d10f6ae$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ae3fae625d10f6ae$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ae3fae625d10f6ae$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ae3fae625d10f6ae$export$569fa72fa47640a8(_ref) {
    var option = _ref.option, isActive = _ref.isActive, props = $ae3fae625d10f6ae$var$_objectWithoutProperties(_ref, $ae3fae625d10f6ae$var$_excluded);
    if (typeof option === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $ae3fae625d10f6ae$var$_extends({
        option: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1a06a1b516e783f8$export$fa456266707bf4e4), $ae3fae625d10f6ae$var$_extends({
            type: option
        }, props)),
        isActive: isActive,
        shapeType: "symbols"
    }, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $2be7c72ce33b6679$export$6428a7f2611ef1fa), $ae3fae625d10f6ae$var$_extends({
        option: option,
        isActive: isActive,
        shapeType: "symbols"
    }, props));
}


var $4fc838ae16b87d1b$var$_Scatter;
function $4fc838ae16b87d1b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4fc838ae16b87d1b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4fc838ae16b87d1b$var$_typeof(o);
}
function $4fc838ae16b87d1b$var$_extends() {
    $4fc838ae16b87d1b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fc838ae16b87d1b$var$_extends.apply(this, arguments);
}
function $4fc838ae16b87d1b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4fc838ae16b87d1b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4fc838ae16b87d1b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4fc838ae16b87d1b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4fc838ae16b87d1b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4fc838ae16b87d1b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4fc838ae16b87d1b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4fc838ae16b87d1b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4fc838ae16b87d1b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc838ae16b87d1b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc838ae16b87d1b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4fc838ae16b87d1b$var$_callSuper(t, o, e) {
    return o = $4fc838ae16b87d1b$var$_getPrototypeOf(o), $4fc838ae16b87d1b$var$_possibleConstructorReturn(t, $4fc838ae16b87d1b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $4fc838ae16b87d1b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $4fc838ae16b87d1b$var$_possibleConstructorReturn(self, call) {
    if (call && ($4fc838ae16b87d1b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $4fc838ae16b87d1b$var$_assertThisInitialized(self);
}
function $4fc838ae16b87d1b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $4fc838ae16b87d1b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4fc838ae16b87d1b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4fc838ae16b87d1b$var$_getPrototypeOf(o) {
    $4fc838ae16b87d1b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $4fc838ae16b87d1b$var$_getPrototypeOf(o);
}
function $4fc838ae16b87d1b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $4fc838ae16b87d1b$var$_setPrototypeOf(subClass, superClass);
}
function $4fc838ae16b87d1b$var$_setPrototypeOf(o, p) {
    $4fc838ae16b87d1b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4fc838ae16b87d1b$var$_setPrototypeOf(o, p);
}
function $4fc838ae16b87d1b$var$_defineProperty(obj, key, value) {
    key = $4fc838ae16b87d1b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4fc838ae16b87d1b$var$_toPropertyKey(t) {
    var i = $4fc838ae16b87d1b$var$_toPrimitive(t, "string");
    return "symbol" == $4fc838ae16b87d1b$var$_typeof(i) ? i : i + "";
}
function $4fc838ae16b87d1b$var$_toPrimitive(t, r) {
    if ("object" != $4fc838ae16b87d1b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4fc838ae16b87d1b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4fc838ae16b87d1b$export$1c460fb4285edadc = /*#__PURE__*/ function(_PureComponent) {
    function Scatter() {
        var _this;
        $4fc838ae16b87d1b$var$_classCallCheck(this, Scatter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $4fc838ae16b87d1b$var$_callSuper(this, Scatter, [].concat(args));
        $4fc838ae16b87d1b$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
        });
        $4fc838ae16b87d1b$var$_defineProperty(_this, "id", (0, $3d08f6c3b4eab1e3$export$8b15d37bc3f197d4)('recharts-scatter-'));
        return _this;
    }
    $4fc838ae16b87d1b$var$_inherits(Scatter, _PureComponent);
    return $4fc838ae16b87d1b$var$_createClass(Scatter, [
        {
            key: "renderSymbolsStatically",
            value: function renderSymbolsStatically(points) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, activeShape = _this$props.activeShape, activeIndex = _this$props.activeIndex;
                var baseProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                return points.map(function(entry, i) {
                    var isActive = activeIndex === i;
                    var option = isActive ? activeShape : shape;
                    var props = $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, baseProps), entry);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), $4fc838ae16b87d1b$var$_extends({
                        className: "recharts-scatter-symbol",
                        key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i)
                    }, (0, $f1d44a0cc6cff721$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        role: "img"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ae3fae625d10f6ae$export$569fa72fa47640a8), $4fc838ae16b87d1b$var$_extends({
                        option: option,
                        isActive: isActive,
                        key: "symbol-".concat(i)
                    }, props)));
                });
            }
        },
        {
            key: "renderSymbolsWithAnimation",
            value: function renderSymbolsWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, points = _this$props2.points, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevPoints = this.state.prevPoints;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $ac29565f779d4b91$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "pie-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = points.map(function(entry, index) {
                        var prev = prevPoints && prevPoints[index];
                        if (prev) {
                            var interpolatorCx = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.cx, entry.cx);
                            var interpolatorCy = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.cy, entry.cy);
                            var interpolatorSize = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(prev.size, entry.size);
                            return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
                                cx: interpolatorCx(t),
                                cy: interpolatorCy(t),
                                size: interpolatorSize(t)
                            });
                        }
                        var interpolator = (0, $3d08f6c3b4eab1e3$export$d871d53bd7eeb390)(0, entry.size);
                        return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
                            size: interpolator(t)
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), null, _this3.renderSymbolsStatically(stepData));
                });
            }
        },
        {
            key: "renderSymbols",
            value: function renderSymbols() {
                var _this$props3 = this.props, points = _this$props3.points, isAnimationActive = _this$props3.isAnimationActive;
                var prevPoints = this.state.prevPoints;
                if (isAnimationActive && points && points.length && (!prevPoints || !(0, (/*@__PURE__*/$parcel$interopDefault($5443d49d3d139f56$exports)))(prevPoints, points))) return this.renderSymbolsWithAnimation();
                return this.renderSymbolsStatically(points);
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar() {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props4 = this.props, points = _this$props4.points, xAxis = _this$props4.xAxis, yAxis = _this$props4.yAxis, children = _this$props4.children;
                var errorBarItems = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(children, (0, $d0e02a4abf979d13$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                return errorBarItems.map(function(item, i) {
                    var _item$props = item.props, direction = _item$props.direction, errorDataKey = _item$props.dataKey;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(item, {
                        key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: direction === 'x' ? 'vertical' : 'horizontal',
                        dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
                            return {
                                x: dataPoint.cx,
                                y: dataPoint.cy,
                                value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
                                errorVal: (0, $cc31aced37ecb634$export$f97fc4a450f29a)(dataPoint, dataKey)
                            };
                        }
                    });
                });
            }
        },
        {
            key: "renderLine",
            value: function renderLine() {
                var _this$props5 = this.props, points = _this$props5.points, line = _this$props5.line, lineType = _this$props5.lineType, lineJointType = _this$props5.lineJointType;
                var scatterProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(this.props, false);
                var customLineProps = (0, $8b99c43c69c5c37b$export$d697c39a2985a4c)(line, false);
                var linePoints, lineItem;
                if (lineType === 'joint') linePoints = points.map(function(entry) {
                    return {
                        x: entry.cx,
                        y: entry.cy
                    };
                });
                else if (lineType === 'fitting') {
                    var _getLinearRegression = (0, $3d08f6c3b4eab1e3$export$484982720961754e)(points), xmin = _getLinearRegression.xmin, xmax = _getLinearRegression.xmax, a = _getLinearRegression.a, b = _getLinearRegression.b;
                    var linearExp = function linearExp(x) {
                        return a * x + b;
                    };
                    linePoints = [
                        {
                            x: xmin,
                            y: linearExp(xmin)
                        },
                        {
                            x: xmax,
                            y: linearExp(xmax)
                        }
                    ];
                }
                var lineProps = $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, scatterProps), {}, {
                    fill: 'none',
                    stroke: scatterProps && scatterProps.fill
                }, customLineProps), {}, {
                    points: linePoints
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).isValidElement(line)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(line, lineProps);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($4c7b1825f8a16f64$exports)))(line)) lineItem = line(lineProps);
                else lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $1371972ac018f8f3$export$b0e83c3ef8d2db1), $4fc838ae16b87d1b$var$_extends({}, lineProps, {
                    type: lineJointType
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: "recharts-scatter-line",
                    key: "recharts-scatter-line"
                }, lineItem);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, points = _this$props6.points, line = _this$props6.line, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, id = _this$props6.id, isAnimationActive = _this$props6.isAnimationActive;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ajIhI.default)('recharts-scatter', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    className: layerClass,
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, $9147c7844befd856$export$936d0764594b6eb3), {
                    key: "recharts-scatter-symbols"
                }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && (0, $e476a06be597057a$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        }
    ]);
}((0, $8nGP5.PureComponent));
$4fc838ae16b87d1b$var$_Scatter = $4fc838ae16b87d1b$export$1c460fb4285edadc;
$4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "displayName", 'Scatter');
$4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    zAxisId: 0,
    legendType: 'circle',
    lineType: 'joint',
    lineJointType: 'linear',
    data: [],
    shape: 'circle',
    hide: false,
    isAnimationActive: !(0, $863769adbc4b0799$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $4fc838ae16b87d1b$var$_defineProperty($4fc838ae16b87d1b$export$1c460fb4285edadc, "getComposedData", function(_ref2) {
    var xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, zAxis = _ref2.zAxis, item = _ref2.item, displayedData = _ref2.displayedData, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, offset = _ref2.offset;
    var tooltipType = item.props.tooltipType;
    var cells = (0, $8b99c43c69c5c37b$export$fdd5e64c0e8495bb)(item.props.children, (0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea));
    var xAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
    var yAxisDataKey = (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
    var zAxisDataKey = zAxis && zAxis.dataKey;
    var defaultRangeZ = zAxis ? zAxis.range : (0, $01500a896f6ae02c$export$2363a7fa7edfe988).defaultProps.range;
    var defaultZ = defaultRangeZ && defaultRangeZ[0];
    var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
    var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
    var points = displayedData.map(function(entry, index) {
        var x = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, xAxisDataKey);
        var y = (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, yAxisDataKey);
        var z = !(0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(zAxisDataKey) && (0, $cc31aced37ecb634$export$f97fc4a450f29a)(entry, zAxisDataKey) || '-';
        var tooltipPayload = [
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
                unit: xAxis.unit || '',
                value: x,
                payload: entry,
                dataKey: xAxisDataKey,
                type: tooltipType
            },
            {
                name: (0, (/*@__PURE__*/$parcel$interopDefault($19a6b838e2f2c525$exports)))(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
                unit: yAxis.unit || '',
                value: y,
                payload: entry,
                dataKey: yAxisDataKey,
                type: tooltipType
            }
        ];
        if (z !== '-') tooltipPayload.push({
            name: zAxis.name || zAxis.dataKey,
            unit: zAxis.unit || '',
            value: z,
            payload: entry,
            dataKey: zAxisDataKey,
            type: tooltipType
        });
        var cx = (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
            axis: xAxis,
            ticks: xAxisTicks,
            bandSize: xBandSize,
            entry: entry,
            index: index,
            dataKey: xAxisDataKey
        });
        var cy = (0, $cc31aced37ecb634$export$6e87f3defb83c3f)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize: yBandSize,
            entry: entry,
            index: index,
            dataKey: yAxisDataKey
        });
        var size = z !== '-' ? zAxis.scale(z) : defaultZ;
        var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
        return $4fc838ae16b87d1b$var$_objectSpread($4fc838ae16b87d1b$var$_objectSpread({}, entry), {}, {
            cx: cx,
            cy: cy,
            x: cx - radius,
            y: cy - radius,
            xAxis: xAxis,
            yAxis: yAxis,
            zAxis: zAxis,
            width: 2 * radius,
            height: 2 * radius,
            size: size,
            node: {
                x: x,
                y: y,
                z: z
            },
            tooltipPayload: tooltipPayload,
            tooltipPosition: {
                x: cx,
                y: cy
            },
            payload: entry
        }, cells && cells[index] && cells[index].props);
    });
    return $4fc838ae16b87d1b$var$_objectSpread({
        points: points
    }, offset);
});






var $ccba25d6b178ab5a$export$f881f4f9e4007a57 = (0, $3cb8ecafb87115bc$export$77871aede60e6838)({
    chartName: 'ComposedChart',
    GraphicalChild: [
        (0, $a0158cc2cd24124f$export$17d680238e50603e),
        (0, $1b8fe288515e608e$export$ea1a111407f37557),
        (0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1),
        (0, $4fc838ae16b87d1b$export$1c460fb4285edadc)
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $f4dd95f529f72065$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $0a6c1adc00c46590$export$f96c4024c52de8f4)
        },
        {
            axisType: 'zAxis',
            AxisComp: (0, $01500a896f6ae02c$export$2363a7fa7edfe988)
        }
    ],
    formatAxisMap: (0, $b57066fd5661be22$export$ece7de1383db5ac)
});





var $T5IcR = parcelRequire("T5IcR");


var $99f5eb6d5fa6a0d1$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $99f5eb6d5fa6a0d1$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $99f5eb6d5fa6a0d1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $99f5eb6d5fa6a0d1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $99f5eb6d5fa6a0d1$export$511e1bd5c301e07a = (()=>{
    var _a, _TickInfo_tickSize_accessor_storage;
    let _tickSize_decorators;
    let _tickSize_initializers = [];
    let _tickSize_extraInitializers = [];
    return _a = class TickInfo {
        get tickSize() {
            return $99f5eb6d5fa6a0d1$var$__classPrivateFieldGet(this, _TickInfo_tickSize_accessor_storage, "f");
        }
        set tickSize(value) {
            $99f5eb6d5fa6a0d1$var$__classPrivateFieldSet(this, _TickInfo_tickSize_accessor_storage, value, "f");
        }
        constructor(){
            _TickInfo_tickSize_accessor_storage.set(this, $99f5eb6d5fa6a0d1$var$__runInitializers(this, _tickSize_initializers, 0));
            $99f5eb6d5fa6a0d1$var$__runInitializers(this, _tickSize_extraInitializers);
        }
    }, _TickInfo_tickSize_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tickSize_decorators = [
            (0, $T5IcR.observable)
        ];
        $99f5eb6d5fa6a0d1$var$__esDecorate(_a, null, _tickSize_decorators, {
            kind: "accessor",
            name: "tickSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tickSize" in obj,
                get: (obj)=>obj.tickSize,
                set: (obj, value)=>{
                    obj.tickSize = value;
                }
            },
            metadata: _metadata
        }, _tickSize_initializers, _tickSize_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $99f5eb6d5fa6a0d1$export$8c1b2de0367e9a6e = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    var _a;
    const tickInfo = (0, $8nGP5.useRef)({
        firstTick: 0,
        secondTick: 0
    });
    const [tickStore] = (0, $8nGP5.useState)(new $99f5eb6d5fa6a0d1$export$511e1bd5c301e07a());
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.createDataAccess(p.reportId);
    const prefEbitdaType = q === null || q === void 0 ? void 0 : q.selectedEbitdaType;
    var schemaLookupName = 'Adjusted EBITDA';
    (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[prefEbitdaType]['display']) !== null && _a !== void 0 && _a;
    const NAME_LOOKUP = {
        adj_ebitda_margin: `${schemaLookupName} Margin`,
        EBITDA: schemaLookupName,
        Revenue: 'Revenue'
    };
    if (q == null) return null;
    var data = [];
    var { from: from, to: to } = q.getReportYearRange();
    const maxYears = 11;
    if (to - from > maxYears) from = to - maxYears;
    const ebitdaType = q.selectedEbitdaType;
    for(var year = from; year <= to; year++){
        var yearEntry = {};
        const isActualized = q.getIsYearActualized(year);
        const letter = isActualized ? 'A' : 'P';
        yearEntry['year'] = year + letter;
        yearEntry['Revenue'] = q.valueByYear('net_revenue_per_year', year);
        if (yearEntry['Revenue'] == 'N/A') yearEntry['Revenue'] = 0;
        else yearEntry['Revenue'] = parseFloat(yearEntry['Revenue']);
        yearEntry['EBITDA'] = q.valueByYear(prefEbitdaType, year);
        if (yearEntry['EBITDA'] == 'N/A') {
            var ebitda = q.valueByYear('ebitda_per_year', year);
            if (ebitda != 'N/A') yearEntry['EBITDA'] = ebitda;
            else yearEntry['EBITDA'] = 0;
        } else yearEntry['EBITDA'] = parseFloat(yearEntry['EBITDA']);
        yearEntry['adj_ebitda_margin'] = q.selectedEbitdaMargin(year);
        if (yearEntry['adj_ebitda_margin'] == 'N/A') {
            var ebitdaMargin = q.ebitdaMargin(year);
            if (ebitdaMargin != 'N/A') yearEntry['adj_ebitda_margin'] = ebitdaMargin;
        }
        if (yearEntry['adj_ebitda_margin'] != 'N/A') yearEntry['adj_ebitda_margin'] *= 100;
        data.push(yearEntry);
    }
    const CustomYearLabelsTick = (params)=>{
        if (params.index === 0) tickInfo.current.firstTick = params.x;
        else if (params.index === 1) {
            tickInfo.current.secondTick = params.x;
            const diff = tickInfo.current.secondTick - tickInfo.current.firstTick;
            tickStore.tickSize = diff;
        }
        const { x: x, y: y, payload: payload } = params;
        const bandWidth = tickStore.tickSize;
        return (0, $kSbwP.jsx)("text", {
            x: x + bandWidth / 2,
            y: y + 14,
            fontSize: "14",
            textAnchor: "middle",
            children: payload.value
        });
    };
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        children: [
            (0, $kSbwP.jsx)("div", {
                className: $4be1ee3c8ca80a36$export$fb184b623420d9be,
                children: "Financial Overview"
            }),
            (0, $kSbwP.jsx)((0, $65a9db7fe004392a$export$e60a4704009a0009), {
                width: "100%",
                height: "100%",
                onResize: ()=>{
                    tickInfo.current = {
                        firstTick: 0,
                        secondTick: 0
                    };
                    tickStore.tickSize = 0;
                },
                children: (0, $kSbwP.jsxs)((0, $ccba25d6b178ab5a$export$f881f4f9e4007a57), {
                    data: data,
                    margin: {
                        top: 20,
                        left: 20,
                        right: 20,
                        bottom: 20
                    },
                    children: [
                        (0, $kSbwP.jsx)("defs", {
                            children: (0, $36ec24632073ba4a$export$41830d6935700b58).getBarGradient()
                        }),
                        (0, $kSbwP.jsx)((0, $836f11cfcda8d642$export$6440e27b9f186856), {
                            stroke: "#f5f5f5"
                        }),
                        (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                            domain: [
                                0,
                                'auto'
                            ],
                            yAxisId: "left",
                            tickFormatter: (value)=>`$${value.toFixed()}M`,
                            interval: "preserveStartEnd"
                        }),
                        (0, $kSbwP.jsx)((0, $0a6c1adc00c46590$export$f96c4024c52de8f4), {
                            yAxisId: "right",
                            hide: true
                        }),
                        (0, $kSbwP.jsx)((0, $06340f5273236c74$export$ed247974535929c7), {
                            verticalAlign: "bottom",
                            formatter: (v)=>{
                                return NAME_LOOKUP[v];
                            },
                            wrapperStyle: {
                                fontFamily: 'LustTextMedium',
                                fontSize: 12
                            }
                        }),
                        (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                            dataKey: "Revenue",
                            fill: "url(#barGradientBlue)",
                            yAxisId: "left",
                            radius: [
                                10,
                                10,
                                0,
                                0
                            ],
                            children: [
                                (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                    dataKey: "Revenue",
                                    position: "top",
                                    formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency,
                                    offset: 5,
                                    fill: "black"
                                }),
                                data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                        style: {
                                            filter: (0, $36ec24632073ba4a$export$41830d6935700b58).SHADOW_FILTER
                                        }
                                    }, `cell-${index}`))
                            ]
                        }),
                        (0, $kSbwP.jsxs)((0, $6f50d8c16ef9d517$export$bbc6c6369b38e3d1), {
                            dataKey: "EBITDA",
                            fill: "url(#barGradientGold)",
                            yAxisId: "left",
                            radius: [
                                10,
                                10,
                                0,
                                0
                            ],
                            children: [
                                (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                    dataKey: "EBITDA",
                                    position: "top",
                                    formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency,
                                    offset: 10,
                                    fill: "black"
                                }),
                                data.map((entry, index)=>(0, $kSbwP.jsx)((0, $94307f62a0d95f57$export$f6f0c3fe4ec306ea), {
                                        style: {
                                            filter: (0, $36ec24632073ba4a$export$41830d6935700b58).SHADOW_FILTER
                                        }
                                    }, `cell-${index}`))
                            ]
                        }),
                        (0, $kSbwP.jsx)((0, $a0158cc2cd24124f$export$17d680238e50603e), {
                            type: "monotone",
                            dataKey: "adj_ebitda_margin",
                            stroke: "#d9c666",
                            yAxisId: "right",
                            children: (0, $kSbwP.jsx)((0, $e476a06be597057a$export$835fcf23ab7bf88), {
                                dataKey: "adj_ebitda_margin",
                                position: "top",
                                formatter: (0, $36ec24632073ba4a$export$41830d6935700b58).formatPercent,
                                fill: "black",
                                offset: 10
                            })
                        }),
                        (0, $kSbwP.jsx)((0, $c1ee5960bb8c7c28$export$28c660c63b792dea), {
                            formatter: (v, name, payload)=>{
                                switch(name){
                                    case 'adj_ebitda_margin':
                                        return [
                                            (0, $36ec24632073ba4a$export$41830d6935700b58).formatPercent(v),
                                            NAME_LOOKUP[name]
                                        ];
                                    case 'EBITDA':
                                        return [
                                            (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency(v),
                                            NAME_LOOKUP[name]
                                        ];
                                    default:
                                        return [
                                            (0, $36ec24632073ba4a$export$41830d6935700b58).formatCurrency(v),
                                            NAME_LOOKUP[name]
                                        ];
                                }
                            }
                        }),
                        (0, $kSbwP.jsx)((0, $f4dd95f529f72065$export$ea77231de273b52d), {
                            dataKey: "year",
                            scale: "band",
                            interval: "preserveStartEnd",
                            tick: CustomYearLabelsTick
                        })
                    ]
                })
            })
        ]
    });
});



const $032f62a52fec71db$export$cf41dafb96c88991 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const reportId = store.selectedReportId;
    const compareList = (0, $7403a76d892238e8$export$8b849e0e30783f61).findCompaniesToCompare(reportId, 4);
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        children: [
            (0, $kSbwP.jsx)((0, $f20b217cc7daff5d$export$f20f69a59ceebf9d), {}),
            (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                children: [
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '450px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: (0, $kSbwP.jsx)((0, $908ff996248f52cc$export$d30a5f17ebdee8f), {})
                            }),
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$4a2bd288272bd4d7,
                                children: (0, $kSbwP.jsx)((0, $99f5eb6d5fa6a0d1$export$8c1b2de0367e9a6e), {
                                    reportId: reportId
                                })
                            })
                        ]
                    }),
                    (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "row",
                        style: {
                            width: '100%',
                            minHeight: '450px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$b848b6ed1647f90b,
                                children: (0, $kSbwP.jsx)((0, $79f88d7943aea7e8$export$c2e12a891bea2f25), {
                                    reportId: reportId
                                })
                            }),
                            (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
                                className: $ee30843c79a5ac9f$export$4a2bd288272bd4d7,
                                children: (0, $kSbwP.jsx)((0, $a04e8dca7e1102b6$export$bf43f5ad66c8bc17), {
                                    reportId: reportId,
                                    companies: compareList
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");





var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");


// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $d67fa8c2937648db$var$updateQueue = $d67fa8c2937648db$var$makeQueue();
var $d67fa8c2937648db$export$27f233d61a9e2fa4 = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$updateQueue);
var $d67fa8c2937648db$var$writeQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.write = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$writeQueue);
var $d67fa8c2937648db$var$onStartQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onStart = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onStartQueue);
var $d67fa8c2937648db$var$onFrameQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onFrame = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onFrameQueue);
var $d67fa8c2937648db$var$onFinishQueue = $d67fa8c2937648db$var$makeQueue();
$d67fa8c2937648db$export$27f233d61a9e2fa4.onFinish = (fn)=>$d67fa8c2937648db$var$schedule(fn, $d67fa8c2937648db$var$onFinishQueue);
var $d67fa8c2937648db$var$timeouts = [];
$d67fa8c2937648db$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $d67fa8c2937648db$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $d67fa8c2937648db$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $d67fa8c2937648db$var$timeouts.splice(i, 1);
        $d67fa8c2937648db$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $d67fa8c2937648db$var$timeouts.splice($d67fa8c2937648db$var$findTimeout(time), 0, timeout);
    $d67fa8c2937648db$var$pendingCount += 1;
    $d67fa8c2937648db$var$start();
    return timeout;
};
var $d67fa8c2937648db$var$findTimeout = (time)=>~(~$d67fa8c2937648db$var$timeouts.findIndex((t)=>t.time > time) || ~$d67fa8c2937648db$var$timeouts.length);
$d67fa8c2937648db$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $d67fa8c2937648db$var$onStartQueue.delete(fn);
    $d67fa8c2937648db$var$onFrameQueue.delete(fn);
    $d67fa8c2937648db$var$onFinishQueue.delete(fn);
    $d67fa8c2937648db$var$updateQueue.delete(fn);
    $d67fa8c2937648db$var$writeQueue.delete(fn);
};
$d67fa8c2937648db$export$27f233d61a9e2fa4.sync = (fn)=>{
    $d67fa8c2937648db$var$sync = true;
    $d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $d67fa8c2937648db$var$sync = false;
};
$d67fa8c2937648db$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $d67fa8c2937648db$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $d67fa8c2937648db$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $d67fa8c2937648db$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$d67fa8c2937648db$export$27f233d61a9e2fa4.use = (impl)=>$d67fa8c2937648db$var$nativeRaf = impl;
$d67fa8c2937648db$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$d67fa8c2937648db$export$27f233d61a9e2fa4.catch = console.error;
$d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop = "always";
$d67fa8c2937648db$export$27f233d61a9e2fa4.advance = ()=>{
    if ($d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $d67fa8c2937648db$var$update();
};
var $d67fa8c2937648db$var$ts = -1;
var $d67fa8c2937648db$var$pendingCount = 0;
var $d67fa8c2937648db$var$sync = false;
function $d67fa8c2937648db$var$schedule(fn, queue) {
    if ($d67fa8c2937648db$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $d67fa8c2937648db$var$start();
    }
}
function $d67fa8c2937648db$var$start() {
    if ($d67fa8c2937648db$var$ts < 0) {
        $d67fa8c2937648db$var$ts = 0;
        if ($d67fa8c2937648db$export$27f233d61a9e2fa4.frameLoop !== "demand") $d67fa8c2937648db$var$nativeRaf($d67fa8c2937648db$var$loop);
    }
}
function $d67fa8c2937648db$var$stop() {
    $d67fa8c2937648db$var$ts = -1;
}
function $d67fa8c2937648db$var$loop() {
    if (~$d67fa8c2937648db$var$ts) {
        $d67fa8c2937648db$var$nativeRaf($d67fa8c2937648db$var$loop);
        $d67fa8c2937648db$export$27f233d61a9e2fa4.batchedUpdates($d67fa8c2937648db$var$update);
    }
}
function $d67fa8c2937648db$var$update() {
    const prevTs = $d67fa8c2937648db$var$ts;
    $d67fa8c2937648db$var$ts = $d67fa8c2937648db$export$27f233d61a9e2fa4.now();
    const count = $d67fa8c2937648db$var$findTimeout($d67fa8c2937648db$var$ts);
    if (count) {
        $d67fa8c2937648db$var$eachSafely($d67fa8c2937648db$var$timeouts.splice(0, count), (t)=>t.handler());
        $d67fa8c2937648db$var$pendingCount -= count;
    }
    if (!$d67fa8c2937648db$var$pendingCount) {
        $d67fa8c2937648db$var$stop();
        return;
    }
    $d67fa8c2937648db$var$onStartQueue.flush();
    $d67fa8c2937648db$var$updateQueue.flush(prevTs ? Math.min(64, $d67fa8c2937648db$var$ts - prevTs) : 16.667);
    $d67fa8c2937648db$var$onFrameQueue.flush();
    $d67fa8c2937648db$var$writeQueue.flush();
    $d67fa8c2937648db$var$onFinishQueue.flush();
}
function $d67fa8c2937648db$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $d67fa8c2937648db$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $d67fa8c2937648db$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $d67fa8c2937648db$var$pendingCount -= current.size;
                $d67fa8c2937648db$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $d67fa8c2937648db$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $d67fa8c2937648db$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $d67fa8c2937648db$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $d67fa8c2937648db$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $d67fa8c2937648db$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $d67fa8c2937648db$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $d67fa8c2937648db$var$ts = -1;
        $d67fa8c2937648db$var$timeouts = [];
        $d67fa8c2937648db$var$onStartQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$updateQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$onFrameQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$writeQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$onFinishQueue = $d67fa8c2937648db$var$makeQueue();
        $d67fa8c2937648db$var$pendingCount = 0;
    }
};



var $8nGP5 = parcelRequire("8nGP5");
var $fda335f6a9b8d095$var$__defProp = Object.defineProperty;
var $fda335f6a9b8d095$var$__export = (target, all)=>{
    for(var name in all)$fda335f6a9b8d095$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $fda335f6a9b8d095$export$cceeabf822b64fc0 = {};
$fda335f6a9b8d095$var$__export($fda335f6a9b8d095$export$cceeabf822b64fc0, {
    assign: ()=>$fda335f6a9b8d095$var$assign,
    colors: ()=>$fda335f6a9b8d095$var$colors,
    createStringInterpolator: ()=>$fda335f6a9b8d095$var$createStringInterpolator,
    skipAnimation: ()=>$fda335f6a9b8d095$var$skipAnimation,
    to: ()=>$fda335f6a9b8d095$var$to,
    willAdvance: ()=>$fda335f6a9b8d095$var$willAdvance
});
// src/helpers.ts
function $fda335f6a9b8d095$export$8793edee2d425525() {}
var $fda335f6a9b8d095$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $fda335f6a9b8d095$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $fda335f6a9b8d095$export$248d38f6296296c5(a, b) {
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(a)) {
        if (!$fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $fda335f6a9b8d095$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $fda335f6a9b8d095$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $fda335f6a9b8d095$export$45b10814cc054894 = (a)=>$fda335f6a9b8d095$export$226b3eccf92c9ed9.und(a) ? [] : $fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $fda335f6a9b8d095$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $fda335f6a9b8d095$export$79b2f7037acddd43(items, iterator);
    }
}
var $fda335f6a9b8d095$export$7ba486852759e806 = (queue, ...args)=>$fda335f6a9b8d095$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $fda335f6a9b8d095$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $fda335f6a9b8d095$var$createStringInterpolator;
var $fda335f6a9b8d095$var$to;
var $fda335f6a9b8d095$var$colors = null;
var $fda335f6a9b8d095$var$skipAnimation = false;
var $fda335f6a9b8d095$var$willAdvance = $fda335f6a9b8d095$export$8793edee2d425525;
var $fda335f6a9b8d095$var$assign = (globals)=>{
    if (globals.to) $fda335f6a9b8d095$var$to = globals.to;
    if (globals.now) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $fda335f6a9b8d095$var$colors = globals.colors;
    if (globals.skipAnimation != null) $fda335f6a9b8d095$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $fda335f6a9b8d095$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $fda335f6a9b8d095$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $fda335f6a9b8d095$var$startQueue = /* @__PURE__ */ new Set();
var $fda335f6a9b8d095$var$currentFrame = [];
var $fda335f6a9b8d095$var$prevFrame = [];
var $fda335f6a9b8d095$var$priority = 0;
var $fda335f6a9b8d095$export$a57f5080a3bcc90a = {
    get idle () {
        return !$fda335f6a9b8d095$var$startQueue.size && !$fda335f6a9b8d095$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($fda335f6a9b8d095$var$priority > animation.priority) {
            $fda335f6a9b8d095$var$startQueue.add(animation);
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onStart($fda335f6a9b8d095$var$flushStartQueue);
        } else {
            $fda335f6a9b8d095$var$startSafely(animation);
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)($fda335f6a9b8d095$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $fda335f6a9b8d095$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($fda335f6a9b8d095$var$priority) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onFrame(()=>$fda335f6a9b8d095$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $fda335f6a9b8d095$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $fda335f6a9b8d095$var$currentFrame.splice(prevIndex, 1);
                $fda335f6a9b8d095$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $fda335f6a9b8d095$var$currentFrame = [];
        $fda335f6a9b8d095$var$startQueue.clear();
    }
};
function $fda335f6a9b8d095$var$flushStartQueue() {
    $fda335f6a9b8d095$var$startQueue.forEach($fda335f6a9b8d095$var$startSafely);
    $fda335f6a9b8d095$var$startQueue.clear();
    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)($fda335f6a9b8d095$var$advance);
}
function $fda335f6a9b8d095$var$startSafely(animation) {
    if (!$fda335f6a9b8d095$var$currentFrame.includes(animation)) $fda335f6a9b8d095$var$startUnsafely(animation);
}
function $fda335f6a9b8d095$var$startUnsafely(animation) {
    $fda335f6a9b8d095$var$currentFrame.splice($fda335f6a9b8d095$var$findIndex($fda335f6a9b8d095$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $fda335f6a9b8d095$var$advance(dt) {
    const nextFrame = $fda335f6a9b8d095$var$prevFrame;
    for(let i = 0; i < $fda335f6a9b8d095$var$currentFrame.length; i++){
        const animation = $fda335f6a9b8d095$var$currentFrame[i];
        $fda335f6a9b8d095$var$priority = animation.priority;
        if (!animation.idle) {
            $fda335f6a9b8d095$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $fda335f6a9b8d095$var$priority = 0;
    $fda335f6a9b8d095$var$prevFrame = $fda335f6a9b8d095$var$currentFrame;
    $fda335f6a9b8d095$var$prevFrame.length = 0;
    $fda335f6a9b8d095$var$currentFrame = nextFrame;
    return $fda335f6a9b8d095$var$currentFrame.length > 0;
}
function $fda335f6a9b8d095$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $fda335f6a9b8d095$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $fda335f6a9b8d095$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $fda335f6a9b8d095$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $fda335f6a9b8d095$var$PERCENTAGE = $fda335f6a9b8d095$var$NUMBER + "%";
function $fda335f6a9b8d095$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $fda335f6a9b8d095$export$8972dc0e6ad9238f = new RegExp("rgb" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$4e46ac54fc82cf3b = new RegExp("rgba" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$PERCENTAGE));
var $fda335f6a9b8d095$export$810b04175080204c = new RegExp("hsla" + $fda335f6a9b8d095$var$call($fda335f6a9b8d095$var$NUMBER, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$PERCENTAGE, $fda335f6a9b8d095$var$NUMBER));
var $fda335f6a9b8d095$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fda335f6a9b8d095$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $fda335f6a9b8d095$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $fda335f6a9b8d095$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $fda335f6a9b8d095$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $fda335f6a9b8d095$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($fda335f6a9b8d095$var$colors && $fda335f6a9b8d095$var$colors[color] !== void 0) return $fda335f6a9b8d095$var$colors[color];
    if (match = $fda335f6a9b8d095$export$8972dc0e6ad9238f.exec(color)) return ($fda335f6a9b8d095$var$parse255(match[1]) << 24 | // r
    $fda335f6a9b8d095$var$parse255(match[2]) << 16 | // g
    $fda335f6a9b8d095$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$4e46ac54fc82cf3b.exec(color)) return ($fda335f6a9b8d095$var$parse255(match[1]) << 24 | // r
    $fda335f6a9b8d095$var$parse255(match[2]) << 16 | // g
    $fda335f6a9b8d095$var$parse255(match[3]) << 8 | // b
    $fda335f6a9b8d095$var$parse1(match[4])) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $fda335f6a9b8d095$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $fda335f6a9b8d095$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $fda335f6a9b8d095$export$8f4a7c0bb78e6ea8.exec(color)) return ($fda335f6a9b8d095$var$hslToRgb($fda335f6a9b8d095$var$parse360(match[1]), // h
    $fda335f6a9b8d095$var$parsePercentage(match[2]), // s
    $fda335f6a9b8d095$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $fda335f6a9b8d095$export$810b04175080204c.exec(color)) return ($fda335f6a9b8d095$var$hslToRgb($fda335f6a9b8d095$var$parse360(match[1]), // h
    $fda335f6a9b8d095$var$parsePercentage(match[2]), // s
    $fda335f6a9b8d095$var$parsePercentage(match[3])) | $fda335f6a9b8d095$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $fda335f6a9b8d095$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $fda335f6a9b8d095$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $fda335f6a9b8d095$var$hue2rgb(p, q, h + 1 / 3);
    const g = $fda335f6a9b8d095$var$hue2rgb(p, q, h);
    const b = $fda335f6a9b8d095$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $fda335f6a9b8d095$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $fda335f6a9b8d095$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $fda335f6a9b8d095$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $fda335f6a9b8d095$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $fda335f6a9b8d095$export$61db176b839af1f(input) {
    let int32Color = $fda335f6a9b8d095$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $fda335f6a9b8d095$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.arr(range)) return $fda335f6a9b8d095$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($fda335f6a9b8d095$export$226b3eccf92c9ed9.str(range.output[0])) return $fda335f6a9b8d095$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $fda335f6a9b8d095$var$findRange(input, inputRange);
        return $fda335f6a9b8d095$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $fda335f6a9b8d095$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $fda335f6a9b8d095$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $fda335f6a9b8d095$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $fda335f6a9b8d095$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $fda335f6a9b8d095$var$c1 = 1.70158;
var $fda335f6a9b8d095$var$c2 = $fda335f6a9b8d095$var$c1 * 1.525;
var $fda335f6a9b8d095$var$c3 = $fda335f6a9b8d095$var$c1 + 1;
var $fda335f6a9b8d095$var$c4 = 2 * Math.PI / 3;
var $fda335f6a9b8d095$var$c5 = 2 * Math.PI / 4.5;
var $fda335f6a9b8d095$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $fda335f6a9b8d095$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$fda335f6a9b8d095$var$c3 * x * x * x - $fda335f6a9b8d095$var$c1 * x * x,
    easeOutBack: (x)=>1 + $fda335f6a9b8d095$var$c3 * Math.pow(x - 1, 3) + $fda335f6a9b8d095$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($fda335f6a9b8d095$var$c2 + 1) * 2 * x - $fda335f6a9b8d095$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($fda335f6a9b8d095$var$c2 + 1) * (x * 2 - 2) + $fda335f6a9b8d095$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $fda335f6a9b8d095$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $fda335f6a9b8d095$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $fda335f6a9b8d095$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $fda335f6a9b8d095$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $fda335f6a9b8d095$var$bounceOut(1 - x),
    easeOutBounce: $fda335f6a9b8d095$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $fda335f6a9b8d095$var$bounceOut(1 - 2 * x)) / 2 : (1 + $fda335f6a9b8d095$var$bounceOut(2 * x - 1)) / 2,
    steps: $fda335f6a9b8d095$var$steps
};
// src/fluids.ts
var $fda335f6a9b8d095$var$$get = Symbol.for("FluidValue.get");
var $fda335f6a9b8d095$var$$observers = Symbol.for("FluidValue.observers");
var $fda335f6a9b8d095$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$fda335f6a9b8d095$var$$get]);
var $fda335f6a9b8d095$export$e37b7520edd66839 = (arg)=>arg && arg[$fda335f6a9b8d095$var$$get] ? arg[$fda335f6a9b8d095$var$$get]() : arg;
var $fda335f6a9b8d095$export$133f54e9f7cf1796 = (target)=>target[$fda335f6a9b8d095$var$$observers] || null;
function $fda335f6a9b8d095$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $fda335f6a9b8d095$export$31752c40a5fab62a(target, event) {
    const observers = target[$fda335f6a9b8d095$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $fda335f6a9b8d095$export$8cbca1207adce0c0(observer2, event);
    });
}
var $fda335f6a9b8d095$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $fda335f6a9b8d095$export$a3b4618659637aa3(this, get);
    }
};
$fda335f6a9b8d095$var$$get, $fda335f6a9b8d095$var$$observers;
var $fda335f6a9b8d095$export$a3b4618659637aa3 = (target, get)=>$fda335f6a9b8d095$var$setHidden(target, $fda335f6a9b8d095$var$$get, get);
function $fda335f6a9b8d095$export$72d604e3f8d000a5(target, observer2) {
    if (target[$fda335f6a9b8d095$var$$get]) {
        let observers = target[$fda335f6a9b8d095$var$$observers];
        if (!observers) $fda335f6a9b8d095$var$setHidden(target, $fda335f6a9b8d095$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $fda335f6a9b8d095$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$fda335f6a9b8d095$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$fda335f6a9b8d095$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $fda335f6a9b8d095$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $fda335f6a9b8d095$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $fda335f6a9b8d095$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $fda335f6a9b8d095$var$unitRegex = new RegExp(`(${$fda335f6a9b8d095$var$numberRegex.source})(%|[a-z]+)`, "i");
var $fda335f6a9b8d095$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $fda335f6a9b8d095$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $fda335f6a9b8d095$var$variableToRgba = (input)=>{
    const [token, fallback] = $fda335f6a9b8d095$var$parseCSSVariable(input);
    if (!token || $fda335f6a9b8d095$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $fda335f6a9b8d095$var$cssVariableRegex.test(fallback)) return $fda335f6a9b8d095$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $fda335f6a9b8d095$var$parseCSSVariable = (current)=>{
    const match = $fda335f6a9b8d095$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $fda335f6a9b8d095$var$namedColorRegex;
var $fda335f6a9b8d095$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $fda335f6a9b8d095$export$4759a013d387347a = (config)=>{
    if (!$fda335f6a9b8d095$var$namedColorRegex) $fda335f6a9b8d095$var$namedColorRegex = $fda335f6a9b8d095$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($fda335f6a9b8d095$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $fda335f6a9b8d095$export$e37b7520edd66839(value).replace($fda335f6a9b8d095$var$cssVariableRegex, $fda335f6a9b8d095$var$variableToRgba).replace($fda335f6a9b8d095$var$colorRegex, $fda335f6a9b8d095$export$61db176b839af1f).replace($fda335f6a9b8d095$var$namedColorRegex, $fda335f6a9b8d095$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($fda335f6a9b8d095$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$fda335f6a9b8d095$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$fda335f6a9b8d095$var$unitRegex.test(output[0]) && output.find((value)=>$fda335f6a9b8d095$var$unitRegex.test(value))?.replace($fda335f6a9b8d095$var$numberRegex, "");
        let i = 0;
        return output[0].replace($fda335f6a9b8d095$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($fda335f6a9b8d095$var$rgbaRegex, $fda335f6a9b8d095$var$rgbaRound);
    };
};
// src/deprecations.ts
var $fda335f6a9b8d095$export$82e9f45cca5ba907 = "react-spring: ";
var $fda335f6a9b8d095$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $fda335f6a9b8d095$var$warnInterpolate = $fda335f6a9b8d095$export$d2de3aaeafa91619(console.warn);
function $fda335f6a9b8d095$export$2abfcde8ae218ba8() {
    $fda335f6a9b8d095$var$warnInterpolate(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $fda335f6a9b8d095$var$warnDirectCall = $fda335f6a9b8d095$export$d2de3aaeafa91619(console.warn);
function $fda335f6a9b8d095$export$d99d974913ad3b12() {
    $fda335f6a9b8d095$var$warnDirectCall(`${$fda335f6a9b8d095$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $fda335f6a9b8d095$export$75bed621f62abfa9(value) {
    return $fda335f6a9b8d095$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$fda335f6a9b8d095$export$48d7c418edadb60c() && $fda335f6a9b8d095$var$cssVariableRegex.test(value) || value in ($fda335f6a9b8d095$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $fda335f6a9b8d095$var$observer;
var $fda335f6a9b8d095$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $fda335f6a9b8d095$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $fda335f6a9b8d095$var$resizeElement(handler, target) {
    if (!$fda335f6a9b8d095$var$observer) {
        if (typeof ResizeObserver !== "undefined") $fda335f6a9b8d095$var$observer = new ResizeObserver($fda335f6a9b8d095$var$handleObservation);
    }
    let elementHandlers = $fda335f6a9b8d095$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $fda335f6a9b8d095$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($fda335f6a9b8d095$var$observer) $fda335f6a9b8d095$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $fda335f6a9b8d095$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $fda335f6a9b8d095$var$observer) $fda335f6a9b8d095$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $fda335f6a9b8d095$var$listeners = /* @__PURE__ */ new Set();
var $fda335f6a9b8d095$var$cleanupWindowResizeHandler;
var $fda335f6a9b8d095$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $fda335f6a9b8d095$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $fda335f6a9b8d095$var$resizeWindow = (callback)=>{
    $fda335f6a9b8d095$var$listeners.add(callback);
    if (!$fda335f6a9b8d095$var$cleanupWindowResizeHandler) $fda335f6a9b8d095$var$cleanupWindowResizeHandler = $fda335f6a9b8d095$var$createResizeHandler();
    return ()=>{
        $fda335f6a9b8d095$var$listeners.delete(callback);
        if (!$fda335f6a9b8d095$var$listeners.size && $fda335f6a9b8d095$var$cleanupWindowResizeHandler) {
            $fda335f6a9b8d095$var$cleanupWindowResizeHandler();
            $fda335f6a9b8d095$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $fda335f6a9b8d095$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $fda335f6a9b8d095$var$resizeWindow(callback);
    else return $fda335f6a9b8d095$var$resizeElement(callback, container);
};
// src/progress.ts
var $fda335f6a9b8d095$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $fda335f6a9b8d095$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $fda335f6a9b8d095$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $fda335f6a9b8d095$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $fda335f6a9b8d095$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $fda335f6a9b8d095$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $fda335f6a9b8d095$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $fda335f6a9b8d095$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $fda335f6a9b8d095$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $fda335f6a9b8d095$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $fda335f6a9b8d095$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$fda335f6a9b8d095$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $fda335f6a9b8d095$var$scrollListeners.set(container, listener);
        const target = $fda335f6a9b8d095$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $fda335f6a9b8d095$var$resizeListeners.set(container, $fda335f6a9b8d095$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $fda335f6a9b8d095$var$scrollListeners.get(container);
    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $fda335f6a9b8d095$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $fda335f6a9b8d095$var$scrollListeners.get(container);
        $fda335f6a9b8d095$var$scrollListeners.delete(container);
        if (listener) {
            $fda335f6a9b8d095$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $fda335f6a9b8d095$var$resizeListeners.get(container)?.();
        }
    };
};
function $fda335f6a9b8d095$export$fe4300aa8eebea86(init) {
    const ref = (0, $8nGP5.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $fda335f6a9b8d095$export$700979bc83e7db82 = $fda335f6a9b8d095$export$48d7c418edadb60c() ? (0, $8nGP5.useEffect) : (0, $8nGP5.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $fda335f6a9b8d095$var$useIsMounted = ()=>{
    const isMounted = (0, $8nGP5.useRef)(false);
    $fda335f6a9b8d095$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $fda335f6a9b8d095$export$91db9bc4f8ac944a() {
    const update = (0, $8nGP5.useState)()[1];
    const isMounted = $fda335f6a9b8d095$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $fda335f6a9b8d095$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $8nGP5.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $8nGP5.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $fda335f6a9b8d095$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $8nGP5.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $fda335f6a9b8d095$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $fda335f6a9b8d095$export$392544347a18b6ea = (effect)=>(0, $8nGP5.useEffect)(effect, $fda335f6a9b8d095$var$emptyDeps);
var $fda335f6a9b8d095$var$emptyDeps = [];
function $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $8nGP5.useRef)();
    (0, $8nGP5.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $fda335f6a9b8d095$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $8nGP5.useState)(null);
    $fda335f6a9b8d095$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $fda335f6a9b8d095$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $8nGP5 = parcelRequire("8nGP5");
// src/Animated.ts


var $8nGP5 = parcelRequire("8nGP5");
var $b08e4134053d0fe9$var$$node = Symbol.for("Animated:node");
var $b08e4134053d0fe9$export$3df5e165e801a70f = (value)=>!!value && value[$b08e4134053d0fe9$var$$node] === value;
var $b08e4134053d0fe9$export$6b63995194a3a9e4 = (owner)=>owner && owner[$b08e4134053d0fe9$var$$node];
var $b08e4134053d0fe9$export$b553cb5b22b81b04 = (owner, node)=>(0, $fda335f6a9b8d095$export$5c74248ea0e35446)(owner, $b08e4134053d0fe9$var$$node, node);
var $b08e4134053d0fe9$export$ccab2b64c5d440 = (owner)=>owner && owner[$b08e4134053d0fe9$var$$node] && owner[$b08e4134053d0fe9$var$$node].getPayload();
var $b08e4134053d0fe9$export$31627395a3b18e54 = class {
    constructor(){
        $b08e4134053d0fe9$export$b553cb5b22b81b04(this, this);
    }
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
};
var $b08e4134053d0fe9$export$cb1e8f3c05d37ad5 = class extends $b08e4134053d0fe9$export$31627395a3b18e54 {
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
    /** @internal */ static create(value) {
        return new $b08e4134053d0fe9$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
};
var $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 = class extends $b08e4134053d0fe9$export$cb1e8f3c05d37ad5 {
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
    /** @internal */ static create(value) {
        return new $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
};
// src/context.ts
var $b08e4134053d0fe9$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $b08e4134053d0fe9$export$f1b0b9e366a6e2d4 = class extends $b08e4134053d0fe9$export$31627395a3b18e54 {
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
    getValue(animated) {
        const values = {};
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($b08e4134053d0fe9$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($b08e4134053d0fe9$var$TreeContext.dependencies && (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) $b08e4134053d0fe9$var$TreeContext.dependencies.add(source);
        const payload = $b08e4134053d0fe9$export$ccab2b64c5d440(source);
        if (payload) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
};
// src/AnimatedArray.ts
var $b08e4134053d0fe9$export$ede394683406942d = class extends $b08e4134053d0fe9$export$f1b0b9e366a6e2d4 {
    constructor(source){
        super(source);
    }
    /** @internal */ static create(source) {
        return new $b08e4134053d0fe9$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($b08e4134053d0fe9$var$makeAnimated));
        return true;
    }
};
function $b08e4134053d0fe9$var$makeAnimated(value) {
    const nodeType = (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 : $b08e4134053d0fe9$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $b08e4134053d0fe9$export$e6b77ddbe47b132e(value) {
    const parentNode = $b08e4134053d0fe9$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? $b08e4134053d0fe9$export$ede394683406942d : (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93 : $b08e4134053d0fe9$export$cb1e8f3c05d37ad5;
}
var $b08e4134053d0fe9$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $8nGP5.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $8nGP5.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $8nGP5.useCallback)((value)=>{
            instanceRef.current = $b08e4134053d0fe9$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $b08e4134053d0fe9$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $b08e4134053d0fe9$var$PropsObserver(callback, deps);
        const observerRef = (0, $8nGP5.useRef)();
        (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(deps, (dep)=>(0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $fda335f6a9b8d095$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $8nGP5.useEffect)(callback, []);
        (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $fda335f6a9b8d095$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $8nGP5.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $b08e4134053d0fe9$var$PropsObserver = class {
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
    eventObserved(event) {
        if (event.type == "change") (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).write(this.update);
    }
};
function $b08e4134053d0fe9$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $b08e4134053d0fe9$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $b08e4134053d0fe9$export$f1b0b9e366a6e2d4(props);
    $b08e4134053d0fe9$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $b08e4134053d0fe9$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $b08e4134053d0fe9$var$cacheKey = Symbol.for("AnimatedComponent");
var $b08e4134053d0fe9$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $b08e4134053d0fe9$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $b08e4134053d0fe9$var$getDisplayName(Component) || "Anonymous";
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $b08e4134053d0fe9$var$withAnimated(Component, hostConfig));
        else Component = Component[$b08e4134053d0fe9$var$cacheKey] || (Component[$b08e4134053d0fe9$var$cacheKey] = $b08e4134053d0fe9$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(components)) key = $b08e4134053d0fe9$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $b08e4134053d0fe9$var$getDisplayName = (arg)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $5498e6d7807daeb5$export$b24b633b1364b94b = class {
};


function $21cbb88cff39ec52$var$callProp(value, ...args) {
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $21cbb88cff39ec52$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $fda335f6a9b8d095$export$45b10814cc054894)(value).includes(key)));
var $21cbb88cff39ec52$var$resolveProp = (prop, key)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $21cbb88cff39ec52$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $21cbb88cff39ec52$var$noopTransform = (value)=>value;
var $21cbb88cff39ec52$var$getDefaultProps = (props, transform = $21cbb88cff39ec52$var$noopTransform)=>{
    let keys = $21cbb88cff39ec52$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $21cbb88cff39ec52$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $21cbb88cff39ec52$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $21cbb88cff39ec52$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$21cbb88cff39ec52$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $21cbb88cff39ec52$export$b971039a739bf227(props) {
    const to2 = $21cbb88cff39ec52$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $21cbb88cff39ec52$var$computeGoal(value) {
    value = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(value);
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? value.map($21cbb88cff39ec52$var$computeGoal) : (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(value) ? (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $21cbb88cff39ec52$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $21cbb88cff39ec52$var$isAsyncTo(to2) {
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(to2) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2) && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $21cbb88cff39ec52$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $21cbb88cff39ec52$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $21cbb88cff39ec52$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $21cbb88cff39ec52$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $21cbb88cff39ec52$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $21cbb88cff39ec52$var$defaults = {
    ...$21cbb88cff39ec52$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $fda335f6a9b8d095$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $21cbb88cff39ec52$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $21cbb88cff39ec52$var$defaults);
    }
};
function $21cbb88cff39ec52$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $21cbb88cff39ec52$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $21cbb88cff39ec52$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $21cbb88cff39ec52$var$defaults)if (config2[key] == null) config2[key] = $21cbb88cff39ec52$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $21cbb88cff39ec52$var$sanitizeConfig(config2, props) {
    if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.tension) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.damping) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $21cbb88cff39ec52$var$emptyArray = [];
var $21cbb88cff39ec52$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $21cbb88cff39ec52$var$emptyArray;
        this.toValues = null;
        this.fromValues = $21cbb88cff39ec52$var$emptyArray;
        this.config = new $21cbb88cff39ec52$var$AnimationConfig();
        this.immediate = false;
    }
};
function $21cbb88cff39ec52$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $21cbb88cff39ec52$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $21cbb88cff39ec52$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $21cbb88cff39ec52$var$matchProp(pause, key);
            delay = $21cbb88cff39ec52$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $21cbb88cff39ec52$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $21cbb88cff39ec52$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $21cbb88cff39ec52$var$getNoopResult(target.get()) : $21cbb88cff39ec52$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $21cbb88cff39ec52$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $21cbb88cff39ec52$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $21cbb88cff39ec52$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $21cbb88cff39ec52$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $21cbb88cff39ec52$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $21cbb88cff39ec52$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $21cbb88cff39ec52$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $21cbb88cff39ec52$export$d362d093fa99dc7();
            const skipAnimationSignal = new $21cbb88cff39ec52$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                    $21cbb88cff39ec52$var$stopAsync(state);
                    skipAnimationSignal.result = $21cbb88cff39ec52$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
            $21cbb88cff39ec52$var$stopAsync(state);
            return $21cbb88cff39ec52$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $21cbb88cff39ec52$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $21cbb88cff39ec52$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $21cbb88cff39ec52$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(onRest)) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $21cbb88cff39ec52$var$stopAsync(state, cancelId) {
    (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $21cbb88cff39ec52$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $21cbb88cff39ec52$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $21cbb88cff39ec52$var$isFrameValue = (value)=>value instanceof $21cbb88cff39ec52$export$8229896f80e2495e;
var $21cbb88cff39ec52$var$nextId = 1;
var $21cbb88cff39ec52$export$8229896f80e2495e = class extends (0, $fda335f6a9b8d095$export$aff8e1ac1a016a2) {
    constructor(){
        super(...arguments);
        this.id = $21cbb88cff39ec52$var$nextId++;
        this._priority = 0;
    }
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $fda335f6a9b8d095$export$2abfcde8ae218ba8)();
        return (0, $fda335f6a9b8d095$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).sort(this);
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
};
// src/SpringPhase.ts
var $21cbb88cff39ec52$var$$P = Symbol.for("SpringPhase");
var $21cbb88cff39ec52$var$HAS_ANIMATED = 1;
var $21cbb88cff39ec52$var$IS_ANIMATING = 2;
var $21cbb88cff39ec52$var$IS_PAUSED = 4;
var $21cbb88cff39ec52$var$hasAnimated = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$HAS_ANIMATED) > 0;
var $21cbb88cff39ec52$var$isAnimating = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$IS_ANIMATING) > 0;
var $21cbb88cff39ec52$var$isPaused = (target)=>(target[$21cbb88cff39ec52$var$$P] & $21cbb88cff39ec52$var$IS_PAUSED) > 0;
var $21cbb88cff39ec52$var$setActiveBit = (target, active)=>active ? target[$21cbb88cff39ec52$var$$P] |= $21cbb88cff39ec52$var$IS_ANIMATING | $21cbb88cff39ec52$var$HAS_ANIMATED : target[$21cbb88cff39ec52$var$$P] &= ~$21cbb88cff39ec52$var$IS_ANIMATING;
var $21cbb88cff39ec52$var$setPausedBit = (target, paused)=>paused ? target[$21cbb88cff39ec52$var$$P] |= $21cbb88cff39ec52$var$IS_PAUSED : target[$21cbb88cff39ec52$var$$P] &= ~$21cbb88cff39ec52$var$IS_PAUSED;
// src/SpringValue.ts
var $21cbb88cff39ec52$export$5854d13427d5a954 = class extends $21cbb88cff39ec52$export$8229896f80e2495e {
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $21cbb88cff39ec52$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(arg1) || !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($21cbb88cff39ec52$var$isAnimating(this) || this._state.asyncTo) || $21cbb88cff39ec52$var$isPaused(this);
    }
    get goal() {
        return (0, $fda335f6a9b8d095$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $b08e4134053d0fe9$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $21cbb88cff39ec52$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $21cbb88cff39ec52$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $21cbb88cff39ec52$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $b08e4134053d0fe9$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $fda335f6a9b8d095$export$45b10814cc054894)((0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($21cbb88cff39ec52$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$21cbb88cff39ec52$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $21cbb88cff39ec52$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $21cbb88cff39ec52$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$21cbb88cff39ec52$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(from);
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $21cbb88cff39ec52$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $21cbb88cff39ec52$var$resolveProp(value, key) : value));
        $21cbb88cff39ec52$var$mergeActiveFn(this, props, "onProps");
        $21cbb88cff39ec52$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $21cbb88cff39ec52$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$21cbb88cff39ec52$var$isPaused(this)) {
                        $21cbb88cff39ec52$var$setPausedBit(this, true);
                        (0, $fda335f6a9b8d095$export$7ba486852759e806)(state.pauseQueue);
                        $21cbb88cff39ec52$var$sendEvent(this, "onPause", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($21cbb88cff39ec52$var$isPaused(this)) {
                        $21cbb88cff39ec52$var$setPausedBit(this, false);
                        if ($21cbb88cff39ec52$var$isAnimating(this)) this._resume();
                        (0, $fda335f6a9b8d095$export$7ba486852759e806)(state.resumeQueue);
                        $21cbb88cff39ec52$var$sendEvent(this, "onResume", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $21cbb88cff39ec52$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($21cbb88cff39ec52$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($21cbb88cff39ec52$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $21cbb88cff39ec52$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $21cbb88cff39ec52$var$mergeConfig(config2, $21cbb88cff39ec52$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $21cbb88cff39ec52$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
        if (!node || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(to2)) return resolve($21cbb88cff39ec52$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(from) && $21cbb88cff39ec52$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $21cbb88cff39ec52$var$computeGoal(to2);
        const isAnimatable = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(goal) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(goal) || (0, $fda335f6a9b8d095$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $21cbb88cff39ec52$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$21cbb88cff39ec52$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $fda335f6a9b8d095$export$248d38f6296296c5)($21cbb88cff39ec52$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $fda335f6a9b8d095$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(config2.decay, decay) || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $21cbb88cff39ec52$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $b08e4134053d0fe9$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $fda335f6a9b8d095$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $fda335f6a9b8d095$export$79b2f7037acddd43)($21cbb88cff39ec52$var$ACTIVE_EVENTS, (type)=>$21cbb88cff39ec52$var$mergeActiveFn(this, props, type));
                const result = $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, prevTo));
                (0, $fda335f6a9b8d095$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $21cbb88cff39ec52$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($21cbb88cff39ec52$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($21cbb88cff39ec52$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($21cbb88cff39ec52$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $fda335f6a9b8d095$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $fda335f6a9b8d095$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2)) {
            (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(to2, this);
            if ($21cbb88cff39ec52$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(to2)) (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(arg);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $b08e4134053d0fe9$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $21cbb88cff39ec52$var$sendEvent(this, "onStart", $21cbb88cff39ec52$var$getFinishedResult(this, $21cbb88cff39ec52$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $21cbb88cff39ec52$var$callProp(this.animation.onChange, value, this);
        }
        $21cbb88cff39ec52$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this).reset((0, $fda335f6a9b8d095$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$21cbb88cff39ec52$var$isAnimating(this)) {
            $21cbb88cff39ec52$var$setActiveBit(this, true);
            if (!$21cbb88cff39ec52$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($21cbb88cff39ec52$var$isAnimating(this)) {
            $21cbb88cff39ec52$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $21cbb88cff39ec52$var$getCancelledResult(this.get()) : $21cbb88cff39ec52$var$getFinishedResult(this.get(), $21cbb88cff39ec52$var$checkFinished(this, goal ?? anim.to));
            (0, $fda335f6a9b8d095$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $21cbb88cff39ec52$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
};
function $21cbb88cff39ec52$var$checkFinished(target, to2) {
    const goal = $21cbb88cff39ec52$var$computeGoal(to2);
    const value = $21cbb88cff39ec52$var$computeGoal(target.get());
    return (0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, goal);
}
function $21cbb88cff39ec52$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $21cbb88cff39ec52$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $21cbb88cff39ec52$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $21cbb88cff39ec52$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $21cbb88cff39ec52$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $21cbb88cff39ec52$var$createUpdate(props) {
    const { to: to2, from: from } = props = $21cbb88cff39ec52$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2)) $21cbb88cff39ec52$var$findDefined(to2, keys);
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(from)) $21cbb88cff39ec52$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $21cbb88cff39ec52$var$declareUpdate(props) {
    const update2 = $21cbb88cff39ec52$var$createUpdate(props);
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $21cbb88cff39ec52$var$getDefaultProps(update2);
    return update2;
}
function $21cbb88cff39ec52$var$findDefined(values, keys) {
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $21cbb88cff39ec52$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $21cbb88cff39ec52$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $21cbb88cff39ec52$var$getDefaultProp(props, type) ? $21cbb88cff39ec52$var$resolveProp(props[type], target.key) : void 0;
}
function $21cbb88cff39ec52$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $21cbb88cff39ec52$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $21cbb88cff39ec52$var$nextId2 = 1;
var $21cbb88cff39ec52$export$bd0bf19f25da8474 = class {
    constructor(props, flush3){
        this.id = $21cbb88cff39ec52$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($21cbb88cff39ec52$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $fda335f6a9b8d095$export$45b10814cc054894)(props).map($21cbb88cff39ec52$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $21cbb88cff39ec52$var$prepareKeys(this, queue);
        return $21cbb88cff39ec52$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $21cbb88cff39ec52$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $fda335f6a9b8d095$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
};
function $21cbb88cff39ec52$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$21cbb88cff39ec52$var$flushUpdate(ctrl, props))).then((results)=>$21cbb88cff39ec52$var$getCombinedResult(ctrl, results));
}
async function $21cbb88cff39ec52$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(to2) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $fda335f6a9b8d095$export$79b2f7037acddd43)($21cbb88cff39ec52$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $fda335f6a9b8d095$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $21cbb88cff39ec52$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($21cbb88cff39ec52$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $fda335f6a9b8d095$export$8793edee2d425525),
            resume: (0, $fda335f6a9b8d095$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $21cbb88cff39ec52$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($21cbb88cff39ec52$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($21cbb88cff39ec52$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $21cbb88cff39ec52$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $21cbb88cff39ec52$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $21cbb88cff39ec52$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $21cbb88cff39ec52$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $21cbb88cff39ec52$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $21cbb88cff39ec52$var$createUpdate(props2);
        if (!(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $21cbb88cff39ec52$var$prepareSprings(springs, props2, (key)=>{
            return $21cbb88cff39ec52$var$createSpring(key);
        });
    });
    $21cbb88cff39ec52$var$setSprings(ctrl, springs);
    return springs;
}
function $21cbb88cff39ec52$var$setSprings(ctrl, springs) {
    (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $21cbb88cff39ec52$var$createSpring(key, observer) {
    const spring = new $21cbb88cff39ec52$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $21cbb88cff39ec52$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $21cbb88cff39ec52$var$prepareKeys(ctrl, queue) {
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queue, (props)=>{
        $21cbb88cff39ec52$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $21cbb88cff39ec52$var$createSpring(key, ctrl);
        });
    });
}
var $21cbb88cff39ec52$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $8nGP5.useContext)($21cbb88cff39ec52$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $fda335f6a9b8d095$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $21cbb88cff39ec52$var$ctx;
    return /* @__PURE__ */ $8nGP5.createElement(Provider, {
        value: props
    }, children);
};
var $21cbb88cff39ec52$var$ctx = $21cbb88cff39ec52$var$makeContext($21cbb88cff39ec52$export$f12a216ec50d2cf1, {});
$21cbb88cff39ec52$export$f12a216ec50d2cf1.Provider = $21cbb88cff39ec52$var$ctx.Provider;
$21cbb88cff39ec52$export$f12a216ec50d2cf1.Consumer = $21cbb88cff39ec52$var$ctx.Consumer;
function $21cbb88cff39ec52$var$makeContext(target, init) {
    Object.assign(target, $8nGP5.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $21cbb88cff39ec52$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $fda335f6a9b8d095$export$d99d974913ad3b12)();
        const results = [];
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $21cbb88cff39ec52$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $8nGP5.useMemo)(()=>propsFn || arguments.length == 3 ? $21cbb88cff39ec52$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $8nGP5.useRef)(0);
    const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
    const state = (0, $8nGP5.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $21cbb88cff39ec52$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $21cbb88cff39ec52$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $21cbb88cff39ec52$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($21cbb88cff39ec52$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $8nGP5.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $8nGP5.useMemo)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $21cbb88cff39ec52$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $8nGP5.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $21cbb88cff39ec52$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $21cbb88cff39ec52$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$21cbb88cff39ec52$var$getSprings(ctrl, updates[i]));
    const context = (0, $8nGP5.useContext)($21cbb88cff39ec52$export$f12a216ec50d2cf1);
    const prevContext = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $21cbb88cff39ec52$var$hasProps(context);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $21cbb88cff39ec52$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $21cbb88cff39ec52$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $21cbb88cff39ec52$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $21cbb88cff39ec52$var$initSpringRef = ()=>$21cbb88cff39ec52$export$2471ae76e2946684();
var $21cbb88cff39ec52$export$564bff9c23cad2ca = ()=>(0, $8nGP5.useState)($21cbb88cff39ec52$var$initSpringRef)[0];
var $21cbb88cff39ec52$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $fda335f6a9b8d095$export$fe4300aa8eebea86)(()=>new $21cbb88cff39ec52$export$5854d13427d5a954(initial, props));
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $21cbb88cff39ec52$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $21cbb88cff39ec52$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $21cbb88cff39ec52$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $21cbb88cff39ec52$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $8nGP5.useMemo)(()=>propsFn || arguments.length == 3 ? $21cbb88cff39ec52$export$2471ae76e2946684() : void 0, []);
    const items = (0, $fda335f6a9b8d095$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $8nGP5.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $fda335f6a9b8d095$export$392544347a18b6ea)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $21cbb88cff39ec52$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $21cbb88cff39ec52$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $21cbb88cff39ec52$var$detachRefs(ctrl, ref);
            $21cbb88cff39ec52$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $21cbb88cff39ec52$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $fda335f6a9b8d095$export$91db9bc4f8ac944a)();
    const defaultProps = $21cbb88cff39ec52$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $8nGP5.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $8nGP5.useRef)(false);
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $21cbb88cff39ec52$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $21cbb88cff39ec52$var$callProp(to2, t.item, i);
        to2 = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).obj(to2) ? $21cbb88cff39ec52$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $21cbb88cff39ec52$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $21cbb88cff39ec52$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $21cbb88cff39ec52$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $21cbb88cff39ec52$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $21cbb88cff39ec52$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $8nGP5.useContext)($21cbb88cff39ec52$export$f12a216ec50d2cf1);
    const prevContext = (0, $fda335f6a9b8d095$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $21cbb88cff39ec52$var$hasProps(context);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $21cbb88cff39ec52$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $8nGP5.createElement($8nGP5.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $8nGP5.createElement(elem.type, {
                ...elem.props,
                key: (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).str(t.key) || (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $21cbb88cff39ec52$var$nextKey = 1;
function $21cbb88cff39ec52$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $21cbb88cff39ec52$var$nextKey++;
        });
    }
    return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(keys) ? items : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $fda335f6a9b8d095$export$45b10814cc054894)(keys);
}
var $21cbb88cff39ec52$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fda335f6a9b8d095$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $21cbb88cff39ec52$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $fda335f6a9b8d095$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $21cbb88cff39ec52$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $21cbb88cff39ec52$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $8nGP5.useState)(false);
    const ref = (0, $8nGP5.useRef)();
    const propsFn = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $21cbb88cff39ec52$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $fda335f6a9b8d095$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $21cbb88cff39ec52$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $21cbb88cff39ec52$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($21cbb88cff39ec52$export$c4af9125706c4d30(props));
}
function $21cbb88cff39ec52$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $21cbb88cff39ec52$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $21cbb88cff39ec52$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $21cbb88cff39ec52$export$7b286972b8d8ccbf(items, props)(children);
}
var $21cbb88cff39ec52$export$b0cc4f9860136880 = class extends $21cbb88cff39ec52$export$8229896f80e2495e {
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $fda335f6a9b8d095$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $b08e4134053d0fe9$export$e6b77ddbe47b132e)(value);
        (0, $b08e4134053d0fe9$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $fda335f6a9b8d095$export$248d38f6296296c5)(value, oldValue)) {
            (0, $b08e4134053d0fe9$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $21cbb88cff39ec52$var$checkIdle(this._active)) $21cbb88cff39ec52$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $fda335f6a9b8d095$export$e37b7520edd66839)) : (0, $fda335f6a9b8d095$export$45b10814cc054894)((0, $fda335f6a9b8d095$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$21cbb88cff39ec52$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $b08e4134053d0fe9$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $fda335f6a9b8d095$export$cceeabf822b64fc0).skipAnimation) {
                (0, $d67fa8c2937648db$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $21cbb88cff39ec52$var$becomeIdle(this);
            } else (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(source, this);
            if ($21cbb88cff39ec52$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(source)) (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $21cbb88cff39ec52$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $fda335f6a9b8d095$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($21cbb88cff39ec52$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
};
function $21cbb88cff39ec52$var$isIdle(source) {
    return source.idle !== false;
}
function $21cbb88cff39ec52$var$checkIdle(active) {
    return !active.size || Array.from(active).every($21cbb88cff39ec52$var$isIdle);
}
function $21cbb88cff39ec52$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)((0, $b08e4134053d0fe9$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $21cbb88cff39ec52$export$2c618a4308a30424 = (source, ...args)=>new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args);
var $21cbb88cff39ec52$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $fda335f6a9b8d095$export$2abfcde8ae218ba8)(), new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args));
(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $fda335f6a9b8d095$export$4759a013d387347a,
    to: (source, args)=>new $21cbb88cff39ec52$export$b0cc4f9860136880(source, args)
});
var $21cbb88cff39ec52$export$722fbec263ad908a = (0, $fda335f6a9b8d095$export$a57f5080a3bcc90a).advance;



var $fCKK7 = parcelRequire("fCKK7");


// src/applyAnimatedValues.ts
var $145df61257f4f72c$var$isCustomPropRE = /^--/;
function $145df61257f4f72c$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$145df61257f4f72c$var$isCustomPropRE.test(name) && !($145df61257f4f72c$var$isUnitlessNumber.hasOwnProperty(name) && $145df61257f4f72c$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $145df61257f4f72c$var$attributeCache = {};
function $145df61257f4f72c$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $145df61257f4f72c$var$attributeCache[name] || ($145df61257f4f72c$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $145df61257f4f72c$var$dangerousStyleValue(name, style[name]);
        if ($145df61257f4f72c$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $145df61257f4f72c$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $145df61257f4f72c$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $145df61257f4f72c$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$145df61257f4f72c$var$isUnitlessNumber = Object.keys($145df61257f4f72c$var$isUnitlessNumber).reduce((acc, prop)=>{
    $145df61257f4f72c$var$prefixes.forEach((prefix)=>acc[$145df61257f4f72c$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $145df61257f4f72c$var$isUnitlessNumber);
var $145df61257f4f72c$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $145df61257f4f72c$var$pxTransforms = /^(translate)/;
var $145df61257f4f72c$var$degTransforms = /^(rotate|skew)/;
var $145df61257f4f72c$var$addUnit = (value, unit)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $145df61257f4f72c$var$isValueIdentity = (value, id)=>(0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$145df61257f4f72c$var$isValueIdentity(v, id)) : (0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $145df61257f4f72c$var$AnimatedStyle = class extends (0, $b08e4134053d0fe9$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$145df61257f4f72c$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $145df61257f4f72c$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $fda335f6a9b8d095$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($145df61257f4f72c$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $145df61257f4f72c$var$pxTransforms.test(key) ? "px" : $145df61257f4f72c$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $fda335f6a9b8d095$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$145df61257f4f72c$var$addUnit(deg, unit)})`,
                        $145df61257f4f72c$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$145df61257f4f72c$var$addUnit(v, unit)).join(",")})`,
                        $145df61257f4f72c$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $145df61257f4f72c$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $145df61257f4f72c$var$FluidTransform = class extends (0, $fda335f6a9b8d095$export$aff8e1ac1a016a2) {
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $fda335f6a9b8d095$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $fda335f6a9b8d095$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $fda335f6a9b8d095$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(input, (value)=>(0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(value) && (0, $fda335f6a9b8d095$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $fda335f6a9b8d095$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $fda335f6a9b8d095$export$79b2f7037acddd43)(input, (value)=>(0, $fda335f6a9b8d095$export$57ea7e3a7f6280c7)(value) && (0, $fda335f6a9b8d095$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $fda335f6a9b8d095$export$31752c40a5fab62a)(this, event);
    }
};
// src/primitives.ts
var $145df61257f4f72c$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $fda335f6a9b8d095$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $fCKK7.unstable_batchedUpdates),
    createStringInterpolator: $fda335f6a9b8d095$export$4759a013d387347a,
    colors: $fda335f6a9b8d095$export$8f45430ccf837300
});
var $145df61257f4f72c$var$host = (0, $b08e4134053d0fe9$export$4ee5c78f6dcbcef)($145df61257f4f72c$var$primitives, {
    applyAnimatedValues: $145df61257f4f72c$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $145df61257f4f72c$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $145df61257f4f72c$export$407448d2b89b1813 = $145df61257f4f72c$var$host.animated;



var $gpaur = parcelRequire("gpaur");

var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");
var $815df737c305a096$exports = {};
"use strict";
var $8bd5f31c8fed2208$exports = {};
"use strict";
Object.defineProperty($8bd5f31c8fed2208$exports, "__esModule", {
    value: true
});
Object.defineProperty($8bd5f31c8fed2208$exports, "DraggableCore", {
    enumerable: true,
    get: function() {
        return $8bd5f31c8fed2208$var$_DraggableCore.default;
    }
});
$8bd5f31c8fed2208$exports.default = void 0;

var $8bd5f31c8fed2208$var$React = $8bd5f31c8fed2208$var$_interopRequireWildcard((parcelRequire("8nGP5")));

var $8bd5f31c8fed2208$var$_propTypes = $8bd5f31c8fed2208$var$_interopRequireDefault((parcelRequire("ebCsu")));

var $8bd5f31c8fed2208$var$_reactDom = $8bd5f31c8fed2208$var$_interopRequireDefault((parcelRequire("fCKK7")));

var $8bd5f31c8fed2208$var$_clsx = $8bd5f31c8fed2208$var$_interopRequireDefault((parcelRequire("4kfzs")));

var $jRSXW = parcelRequire("jRSXW");

var $bmHgZ = parcelRequire("bmHgZ");

var $e5aKa = parcelRequire("e5aKa");

var $8bd5f31c8fed2208$var$_DraggableCore = $8bd5f31c8fed2208$var$_interopRequireDefault((parcelRequire("jlTm4")));

var $8bd5f31c8fed2208$var$_log = $8bd5f31c8fed2208$var$_interopRequireDefault((parcelRequire("8iYqY")));
function $8bd5f31c8fed2208$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8bd5f31c8fed2208$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8bd5f31c8fed2208$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8bd5f31c8fed2208$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8bd5f31c8fed2208$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8bd5f31c8fed2208$var$_extends() {
    $8bd5f31c8fed2208$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8bd5f31c8fed2208$var$_extends.apply(this, arguments);
}
function $8bd5f31c8fed2208$var$_defineProperty(obj, key, value) {
    key = $8bd5f31c8fed2208$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8bd5f31c8fed2208$var$_toPropertyKey(arg) {
    var key = $8bd5f31c8fed2208$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8bd5f31c8fed2208$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
} /*:: import type {ControlPosition, PositionOffsetControlPosition, DraggableCoreProps, DraggableCoreDefaultProps} from './DraggableCore';*/ 
/*:: import type {Bounds, DraggableEventHandler} from './utils/types';*/ /*:: import type {Element as ReactElement} from 'react';*/ /*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean,
  prevPropsPosition: ?ControlPosition,
};*/ /*:: export type DraggableDefaultProps = {
  ...DraggableCoreDefaultProps,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: Bounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  scale: number,
};*/ /*:: export type DraggableProps = {
  ...DraggableCoreProps,
  ...DraggableDefaultProps,
  positionOffset: PositionOffsetControlPosition,
  position: ControlPosition,
};*/ //
// Define <Draggable>
//
class $8bd5f31c8fed2208$var$Draggable extends $8bd5f31c8fed2208$var$React.Component /*:: <DraggableProps, DraggableState>*/  {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(_ref /*:: */ , _ref2 /*:: */ ) /*: ?Partial<DraggableState>*/ {
        let { position: position } /*: DraggableProps*/  = _ref /*: DraggableProps*/ ;
        let { prevPropsPosition: prevPropsPosition } /*: DraggableState*/  = _ref2 /*: DraggableState*/ ;
        // Set x/y if a new position is provided in props that is different than the previous.
        if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
            (0, $8bd5f31c8fed2208$var$_log.default)('Draggable: getDerivedStateFromProps %j', {
                position: position,
                prevPropsPosition: prevPropsPosition
            });
            return {
                x: position.x,
                y: position.y,
                prevPropsPosition: {
                    ...position
                }
            };
        }
        return null;
    }
    constructor(props /*: DraggableProps*/ ){
        super(props);
        $8bd5f31c8fed2208$var$_defineProperty(this, "onDragStart", (e, coreData)=>{
            (0, $8bd5f31c8fed2208$var$_log.default)('Draggable: onDragStart: %j', coreData);
            // Short-circuit if user's callback killed it.
            const shouldStart = this.props.onStart(e, (0, $bmHgZ.createDraggableData)(this, coreData));
            // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            this.setState({
                dragging: true,
                dragged: true
            });
        });
        $8bd5f31c8fed2208$var$_defineProperty(this, "onDrag", (e, coreData)=>{
            if (!this.state.dragging) return false;
            (0, $8bd5f31c8fed2208$var$_log.default)('Draggable: onDrag: %j', coreData);
            const uiData = (0, $bmHgZ.createDraggableData)(this, coreData);
            const newState = {
                x: uiData.x,
                y: uiData.y,
                slackX: 0,
                slackY: 0
            };
            // Keep within bounds.
            if (this.props.bounds) {
                // Save original x and y.
                const { x: x, y: y } = newState;
                // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += this.state.slackX;
                newState.y += this.state.slackY;
                // Get bound position. This will ceil/floor the x and y within the boundaries.
                const [newStateX, newStateY] = (0, $bmHgZ.getBoundPosition)(this, newState.x, newState.y);
                newState.x = newStateX;
                newState.y = newStateY;
                // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = this.state.slackX + (x - newState.x);
                newState.slackY = this.state.slackY + (y - newState.y);
                // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - this.state.x;
                uiData.deltaY = newState.y - this.state.y;
            }
            // Short-circuit if user's callback killed it.
            const shouldUpdate = this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            this.setState(newState);
        });
        $8bd5f31c8fed2208$var$_defineProperty(this, "onDragStop", (e, coreData)=>{
            if (!this.state.dragging) return false;
            // Short-circuit if user's callback killed it.
            const shouldContinue = this.props.onStop(e, (0, $bmHgZ.createDraggableData)(this, coreData));
            if (shouldContinue === false) return false;
            (0, $8bd5f31c8fed2208$var$_log.default)('Draggable: onDragStop: %j', coreData);
            const newState /*: Partial<DraggableState>*/  = {
                dragging: false,
                slackX: 0,
                slackY: 0
            };
            // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            const controlled = Boolean(this.props.position);
            if (controlled) {
                const { x: x, y: y } = this.props.position;
                newState.x = x;
                newState.y = y;
            }
            this.setState(newState);
        });
        this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: {
                ...props.position
            },
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
        // Check to see if the element passed is an instanceof SVGElement
        if (typeof window.SVGElement !== 'undefined' && this.findDOMNode() instanceof window.SVGElement) this.setState({
            isElementSVG: true
        });
    }
    componentWillUnmount() {
        this.setState({
            dragging: false
        }); // prevents invariant if unmounted while dragging
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() /*: ?HTMLElement*/ {
        var _this$props$nodeRef$c, _this$props;
        return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.nodeRef) === null || _this$props === void 0 ? void 0 : _this$props.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $8bd5f31c8fed2208$var$_reactDom.default.findDOMNode(this);
    }
    render() /*: ReactElement<any>*/ {
        const { axis: axis, bounds: bounds, children: children, defaultPosition: defaultPosition, defaultClassName: defaultClassName, defaultClassNameDragging: defaultClassNameDragging, defaultClassNameDragged: defaultClassNameDragged, position: position, positionOffset: positionOffset, scale: scale, ...draggableCoreProps } = this.props;
        let style = {};
        let svgTransform = null;
        // If this is controlled, we don't want to move it - unless it's dragging.
        const controlled = Boolean(position);
        const draggable = !controlled || this.state.dragging;
        const validPosition = position || defaultPosition;
        const transformOpts = {
            // Set left if horizontal drag is enabled
            x: (0, $bmHgZ.canDragX)(this) && draggable ? this.state.x : validPosition.x,
            // Set top if vertical drag is enabled
            y: (0, $bmHgZ.canDragY)(this) && draggable ? this.state.y : validPosition.y
        };
        // If this element was SVG, we use the `transform` attribute.
        if (this.state.isElementSVG) svgTransform = (0, $jRSXW.createSVGTransform)(transformOpts, positionOffset);
        else // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, $jRSXW.createCSSTransform)(transformOpts, positionOffset);
        // Mark with class while dragging
        const className = (0, $8bd5f31c8fed2208$var$_clsx.default)(children.props.className || '', defaultClassName, {
            [defaultClassNameDragging]: this.state.dragging,
            [defaultClassNameDragged]: this.state.dragged
        });
        // Reuse the child provided
        // This makes it flexible to use whatever element is wanted (div, ul, etc)
        return /*#__PURE__*/ $8bd5f31c8fed2208$var$React.createElement($8bd5f31c8fed2208$var$_DraggableCore.default, $8bd5f31c8fed2208$var$_extends({}, draggableCoreProps, {
            onStart: this.onDragStart,
            onDrag: this.onDrag,
            onStop: this.onDragStop
        }), /*#__PURE__*/ $8bd5f31c8fed2208$var$React.cloneElement($8bd5f31c8fed2208$var$React.Children.only(children), {
            className: className,
            style: {
                ...children.props.style,
                ...style
            },
            transform: svgTransform
        }));
    }
}
$8bd5f31c8fed2208$exports.default = $8bd5f31c8fed2208$var$Draggable;
$8bd5f31c8fed2208$var$_defineProperty($8bd5f31c8fed2208$var$Draggable, "displayName", 'Draggable');
$8bd5f31c8fed2208$var$_defineProperty($8bd5f31c8fed2208$var$Draggable, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...$8bd5f31c8fed2208$var$_DraggableCore.default.propTypes,
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $8bd5f31c8fed2208$var$_propTypes.default.oneOf([
        'both',
        'x',
        'y',
        'none'
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $8bd5f31c8fed2208$var$_propTypes.default.oneOfType([
        $8bd5f31c8fed2208$var$_propTypes.default.shape({
            left: $8bd5f31c8fed2208$var$_propTypes.default.number,
            right: $8bd5f31c8fed2208$var$_propTypes.default.number,
            top: $8bd5f31c8fed2208$var$_propTypes.default.number,
            bottom: $8bd5f31c8fed2208$var$_propTypes.default.number
        }),
        $8bd5f31c8fed2208$var$_propTypes.default.string,
        $8bd5f31c8fed2208$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $8bd5f31c8fed2208$var$_propTypes.default.string,
    defaultClassNameDragging: $8bd5f31c8fed2208$var$_propTypes.default.string,
    defaultClassNameDragged: $8bd5f31c8fed2208$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $8bd5f31c8fed2208$var$_propTypes.default.shape({
        x: $8bd5f31c8fed2208$var$_propTypes.default.number,
        y: $8bd5f31c8fed2208$var$_propTypes.default.number
    }),
    positionOffset: $8bd5f31c8fed2208$var$_propTypes.default.shape({
        x: $8bd5f31c8fed2208$var$_propTypes.default.oneOfType([
            $8bd5f31c8fed2208$var$_propTypes.default.number,
            $8bd5f31c8fed2208$var$_propTypes.default.string
        ]),
        y: $8bd5f31c8fed2208$var$_propTypes.default.oneOfType([
            $8bd5f31c8fed2208$var$_propTypes.default.number,
            $8bd5f31c8fed2208$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $8bd5f31c8fed2208$var$_propTypes.default.shape({
        x: $8bd5f31c8fed2208$var$_propTypes.default.number,
        y: $8bd5f31c8fed2208$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $e5aKa.dontSetMe,
    style: $e5aKa.dontSetMe,
    transform: $e5aKa.dontSetMe
});
$8bd5f31c8fed2208$var$_defineProperty($8bd5f31c8fed2208$var$Draggable, "defaultProps", {
    ...$8bd5f31c8fed2208$var$_DraggableCore.default.defaultProps,
    axis: 'both',
    bounds: false,
    defaultClassName: 'react-draggable',
    defaultClassNameDragging: 'react-draggable-dragging',
    defaultClassNameDragged: 'react-draggable-dragged',
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
});


var $815df737c305a096$require$Draggable = $8bd5f31c8fed2208$exports.default;
var $815df737c305a096$require$DraggableCore = $8bd5f31c8fed2208$exports.DraggableCore;
// Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
$815df737c305a096$exports = $815df737c305a096$require$Draggable;
$815df737c305a096$exports.default = $815df737c305a096$require$Draggable;
$815df737c305a096$exports.DraggableCore = $815df737c305a096$require$DraggableCore;



var $kSbwP = parcelRequire("kSbwP");

var $gpaur = parcelRequire("gpaur");

var $8nGP5 = parcelRequire("8nGP5");

const $c94930c253f3e81f$export$f836382419f64c98 = (props)=>{
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(children.length === props.layoutPercent.length, 'Children and size must have the same length');
    const cls = props.className || '';
    const style = props.style || {};
    style.position = 'relative';
    const spaceBetween = props.spaceBetween || 0;
    const display = children.map((child, index)=>{
        let size = props.layoutPercent[index];
        const childClass = props.childClass || '';
        return (0, $kSbwP.jsx)("div", {
            className: childClass,
            style: {
                width: `${size}%`,
                height: '100%',
                paddingRight: spaceBetween > 0 && index == 0 ? `${spaceBetween}px` : '0'
            },
            children: child
        }, index);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: cls,
            style: style,
            fillCell: true,
            children: display
        })
    });
};



var $e57608b234d6aa05$export$a67ff6543f6b99a8;
var $e57608b234d6aa05$export$c746a5152d4ba26c;
$e57608b234d6aa05$export$a67ff6543f6b99a8 = `Bk_YHG_dragIconStyle`;
$e57608b234d6aa05$export$c746a5152d4ba26c = `Bk_YHG_draggable`;


var $0a12ebd9c38facea$exports = {};
$0a12ebd9c38facea$exports = new URL("dragIcon.481a3c08.svg", import.meta.url).toString();



const $9583d2c91dbe771f$export$3ccee0cf1acf5f70 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const spaceBetween = props.spaceBetween || 20;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, (/*@__PURE__*/$parcel$interopDefault($gpaur)))(children.length === 2, 'Must be 2 children');
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [highlightDrag, setHighlightDrag] = (0, $8nGP5.useState)(false);
    const [contentSize, setContentSize] = (0, $8nGP5.useState)(uiStore.currentSplitRatioDetailView);
    const setContentSizeThrottle = (0, $8nGP5.useCallback)((0, $fgQ0V.throttle)((size)=>{
        setContentSize(size);
    }, 25), []);
    const [dragPosX, setDragPosX] = (0, $8nGP5.useState)(0);
    const [ref, bounds] = (0, $3a0100122386f550$export$2e2bcd8739ae039)();
    const winWidth = bounds.width;
    const repositionDragable = ()=>{
        setDragPosX(winWidth * (contentSize / 100));
    };
    const resizeRefCallback = (0, $8nGP5.useRef)(()=>{});
    resizeRefCallback.current = repositionDragable;
    const draggableSpring = (0, $21cbb88cff39ec52$export$ab73804b080feffc)(0, {
        onChange: (val)=>{
            const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            setContentSize(val);
        },
        onRest: (val)=>{
            resizeRefCallback.current();
        }
    });
    (0, $8nGP5.useEffect)(()=>{
        uiStore.currentSplitRatioDetailView = contentSize;
    }, [
        contentSize
    ]);
    (0, $8nGP5.useEffect)(()=>{
        repositionDragable();
    }, [
        winWidth
    ]);
    if (!store.query) return null;
    const size = [
        contentSize,
        100 - contentSize
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            winWidth > 0 && (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($815df737c305a096$exports))), {
                axis: "x",
                handle: ".handle",
                bounds: {
                    left: 300,
                    right: winWidth - 300
                },
                positionOffset: {
                    x: -5,
                    y: 50
                },
                // position={{
                //     x: dragPos,
                //     y: 0
                // }}
                //position={{ x: dragPosX, y: 0 }}
                position: {
                    x: dragPosX,
                    y: 0
                },
                onDrag: (e, data)=>{
                    //Maybe add callback later if becomes messy not really draggable responsability
                    var pdfs = document.getElementsByClassName('pdf-viewer');
                    for(var i = 0; i < pdfs.length; i++){
                        const pdf = pdfs[i];
                        pdf.style.pointerEvents = 'none';
                    }
                    var x = data.x;
                    var mouseX = data.lastX;
                    var normalized = data.x / winWidth;
                    // console.log(
                    //     'DRAGGING: ' + x + ' ' + mouseX + ' ' + winWidth
                    // );
                    const viewSize = normalized * 100;
                    setContentSizeThrottle(viewSize);
                },
                onStop: (e, data)=>{
                    //console.log('STOP DRAG: ', data.x);
                    var normalized = data.x / winWidth;
                    const viewSize = normalized * 100;
                    setContentSize(viewSize);
                    repositionDragable();
                    var pdfs = document.getElementsByClassName('pdf-viewer');
                    for(var i = 0; i < pdfs.length; i++){
                        const pdf = pdfs[i];
                        pdf.style.pointerEvents = 'auto';
                    }
                },
                children: (0, $kSbwP.jsx)("div", {
                    className: 'handle ' + $e57608b234d6aa05$export$c746a5152d4ba26c,
                    style: {
                        zIndex: 60000,
                        position: 'absolute',
                        height: 'calc(100vh - 220px)',
                        cursor: 'col-resize !important'
                    },
                    onMouseEnter: ()=>{
                        setHighlightDrag(true);
                    },
                    onMouseLeave: ()=>{
                        setHighlightDrag(false);
                    },
                    onDoubleClick: ()=>{
                        const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                        if (80 - contentSize < 1) draggableSpring.set(contentSize).start(50);
                        else draggableSpring.set(contentSize).start(80);
                    },
                    children: (0, $kSbwP.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a12ebd9c38facea$exports))),
                        style: {
                            pointerEvents: 'none',
                            transform: 'scale(0.9)',
                            opacity: 0
                        }
                    })
                })
            }),
            (0, $kSbwP.jsx)("div", {
                ref: ref,
                style: {
                    width: '100%',
                    height: '100%'
                },
                children: (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    fillCell: true,
                    children: (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
                        layoutPercent: size,
                        spaceBetween: spaceBetween,
                        children: [
                            props.children[0],
                            (0, $kSbwP.jsxs)("div", {
                                style: {
                                    width: '100%',
                                    height: '100%'
                                },
                                children: [
                                    (0, $kSbwP.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($0a12ebd9c38facea$exports))),
                                        className: $e57608b234d6aa05$export$a67ff6543f6b99a8,
                                        style: {
                                            filter: highlightDrag ? 'brightness(95%)' : 'none'
                                        }
                                    }),
                                    props.children[1]
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");

var $5ad47f50ec623be3$export$40a9eeef55665a40;
var $5ad47f50ec623be3$export$93b7586d956c930e;
var $5ad47f50ec623be3$export$f843afa9e9b53052;
var $5ad47f50ec623be3$export$b8bcb06145f9bb8a;
var $5ad47f50ec623be3$export$ae78d338ad66ff90;
var $5ad47f50ec623be3$export$b8972b998723d602;
$5ad47f50ec623be3$export$40a9eeef55665a40 = `oAoGMG_defaultPadding`;
$5ad47f50ec623be3$export$93b7586d956c930e = `oAoGMG_dropShadow`;
$5ad47f50ec623be3$export$f843afa9e9b53052 = `oAoGMG_panelImage`;
$5ad47f50ec623be3$export$b8bcb06145f9bb8a = `oAoGMG_panelRowHeader`;
$5ad47f50ec623be3$export$ae78d338ad66ff90 = `oAoGMG_scaleInOut`;
$5ad47f50ec623be3$export$b8972b998723d602 = `oAoGMG_shadow`;


const $2b38151664cc4c33$export$968713404ca1c9aa = (props)=>{
    var icon = (0, $kSbwP.jsx)("i", {
        className: "bi bi-clipboard"
    });
    if (props.iconUrl) icon = (0, $kSbwP.jsx)("img", {
        src: props.iconUrl,
        alt: "icon"
    });
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        className: $5ad47f50ec623be3$export$b8bcb06145f9bb8a,
        children: [
            icon,
            (0, $kSbwP.jsx)("div", {
                className: "flex-grow-1",
                children: props.title
            }),
            (0, $kSbwP.jsx)("div", {})
        ]
    });
};













const $b8332ea8355e1651$var$convStringToSerializeType = (field, newValue)=>{
    //'$' | '%' | 'year' | 'str' | 'bool'
    if (newValue === null) return null;
    switch(field.t){
        case '$':
        case '%':
            return parseFloat(newValue);
        case 'str':
            return newValue;
        case 'bool':
            return newValue == 1 || newValue == 'true' ? true : false;
        case 'array':
            return newValue.split(',');
        default:
            return newValue;
    }
};
const $b8332ea8355e1651$var$update_override = (tickerId, path, val, originalValue)=>{
    if (val === null || val == originalValue) (0, $b2432f43c421c848$export$7a667d08ed65fa47)().remove_override(tickerId, path);
    else (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_override(tickerId, path, val.toString());
};
const $b8332ea8355e1651$export$ecde49fefbe76021 = (row, column, newValue)=>{
    var _a, _b;
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const rowField = row.field;
    const colField = column.column;
    const schema = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71);
    const data = new (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9)(store.activeReportOriginal, {}, "edit_report_field");
    var f;
    if (rowField.source.indexOf('.') > 0) {
        const { section: section, field: field } = data.getSectionFieldFromSource(rowField.source);
        f = data.schemaBySection({
            section: section,
            field: field
        });
    } else f = schema[rowField.source];
    let val_db = null;
    if ((_a = f.yearly) !== null && _a !== void 0 ? _a : false) val_db = data.valueByYear(rowField.source, parseInt(colField.source));
    else val_db = data.value(rowField.source);
    try {
        if (colField.display === 'Source') {
            //This is source column, Update based on column not row 
            const overidePath = `${rowField.source}_page_source`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, newValue ? newValue.toString() : null, val_db);
            return;
        }
        const convValue = $b8332ea8355e1651$var$convStringToSerializeType(f, newValue);
        if ((_b = f.yearly) !== null && _b !== void 0 ? _b : false) {
            const year = parseInt(colField.source);
            const overidePath = `${rowField.source}/${year.toString()}`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, convValue, val_db);
        } else {
            //value
            const overidePath = `${rowField.source}`;
            $b8332ea8355e1651$var$update_override(store.selectedReportId, overidePath, convValue, val_db);
        }
    } catch (e) {
        console.log('Error onEditReportField', e);
    }
};


const $79da148714874de1$export$58cad4665f64d293 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const data = query.activeReport;
    if (!data) return null;
    const cols = [
        {
            column: {
                source: null,
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const genRow = (fieldName, display, formatter, extra)=>{
        return Object.assign({
            editable: true,
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, column)=>{
                return query.value(fieldName);
            },
            formatter: formatter,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }, extra);
    };
    //    var industry =
    //    query.value('industry') + ', ' + query.value('industrySubType');
    const editableFields = [
        {
            field: 'company_name',
            display: 'Company Name'
        },
        {
            field: 'company_ceo',
            display: 'Company CEO'
        },
        {
            field: 'hq_location',
            display: 'HQ Location'
        },
        {
            field: 'year_founded',
            display: 'Year Founded'
        }
    ];
    const rows = editableFields.map((e)=>{
        return genRow(e.field, e.display, (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox
        });
    });
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Business Overview"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");
var $8eab6c38cd7d6be7$export$40a9eeef55665a40;
var $8eab6c38cd7d6be7$export$93b7586d956c930e;
var $8eab6c38cd7d6be7$export$f843afa9e9b53052;
var $8eab6c38cd7d6be7$export$deba8b5170183922;
var $8eab6c38cd7d6be7$export$ae78d338ad66ff90;
var $8eab6c38cd7d6be7$export$b8972b998723d602;
$8eab6c38cd7d6be7$export$40a9eeef55665a40 = `xMsl9q_defaultPadding`;
$8eab6c38cd7d6be7$export$93b7586d956c930e = `xMsl9q_dropShadow`;
$8eab6c38cd7d6be7$export$f843afa9e9b53052 = `xMsl9q_panelImage`;
$8eab6c38cd7d6be7$export$deba8b5170183922 = `xMsl9q_panelRowDivier`;
$8eab6c38cd7d6be7$export$ae78d338ad66ff90 = `xMsl9q_scaleInOut`;
$8eab6c38cd7d6be7$export$b8972b998723d602 = `xMsl9q_shadow`;


const $fe065f57c6129e2d$export$789f086b167f93b9 = ()=>{
    return (0, $kSbwP.jsx)("div", {
        className: $8eab6c38cd7d6be7$export$deba8b5170183922
    });
};






var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

const $4a29e112f87df826$export$3247f956c2135754 = (props)=>{
    const [ref, bounds] = (0, $3a0100122386f550$export$2e2bcd8739ae039)();
    (0, $8nGP5.useEffect)(()=>{
        props.onResize(bounds);
    }, [
        bounds
    ]);
    return (0, $kSbwP.jsx)("div", {
        ref: ref,
        style: {
            width: '100%',
            height: '1px',
            position: 'absolute'
        }
    });
};






var $fgQ0V = parcelRequire("fgQ0V");


var $8nGP5 = parcelRequire("8nGP5");






var $4d8f71986a24a2e8$export$3dc43a2aec770a90;
$4d8f71986a24a2e8$export$3dc43a2aec770a90 = `Peievq_panelYearly`;



const $bbf930a6e7328633$export$89f5e9b3190f357b = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const yearsShow = (0, $8f024b03d9af7c67$export$d842a17955610ca9)().detailsViewYearsToShow;
    const minPixelsPerEntry = 110;
    //const maxYearsInReport = 8;
    const setYears = (0, $8nGP5.useCallback)((0, $fgQ0V.throttle)((year)=>{
        (0, $8f024b03d9af7c67$export$d842a17955610ca9)().detailsViewYearsToShow = year;
    }, 800, {
        leading: false,
        trailing: true
    }), []);
    const onResize = (size)=>{
        if (size.width == 0) return;
        const calcYears = Math.ceil((size.width - 300) / minPixelsPerEntry);
        if (yearsShow !== calcYears) setYears(calcYears);
    };
    const maxYearsInReport = yearsShow;
    //console.log(maxYearsInReport);
    const query = store.query;
    const reportData = query.activeReport;
    // const findByYearSection = (
    //     req: SectionValueByYearRequest,
    //     yearOffset?: number
    // ) => {
    //     return (field: TableField, column: TableField) => {
    //         const year = parseInt(column.source) + (yearOffset ?? 0);
    //         return query.valueBySection({
    //             section: req.section,
    //             field: req.field,
    //             year
    //         });
    //     };
    // };
    const findByYear = (yearOffset = 0)=>{
        return (field, column)=>{
            const year = parseInt(column.source) + yearOffset;
            return query.valueByYear(field.source, year);
        };
    };
    const findByYearDivideByRevenue = (yearOffset = 0)=>{
        return (field, column)=>{
            const year = parseInt(column.source) + yearOffset;
            const fieldValue = query.valueByYear(field.source, year);
            const revenue = query.valueByYear('net_revenue_per_year', year);
            if (fieldValue === 'N/A' || revenue === 'N/A') return 'N/A';
            return fieldValue / revenue;
        };
    };
    const createColumnsYears = (fromYear, toYear)=>{
        var _a;
        const actualizedYears = (_a = reportData['list_years_actualized_revenue']) !== null && _a !== void 0 ? _a : [];
        const minActualizedYear = Math.min(...actualizedYears);
        const cols = [];
        for(let year = fromYear; year <= toYear; year++){
            const isActualized = actualizedYears.includes(year) || year <= minActualizedYear;
            const letter = isActualized ? 'A' : 'P';
            cols.push({
                column: {
                    source: year.toString(),
                    display: year.toString() + letter
                }
            });
        }
        return cols;
    };
    const getReportYearRange = ()=>{
        if (!reportData) return {
            from: 0,
            to: 0
        };
        var minYear = -1;
        var maxYear = -1;
        const fields = [
            'net_revenue_per_year',
            'ebitda_per_year'
        ];
        fields.forEach((field)=>{
            const list = reportData[field];
            if (!list || Array.isArray(list) === false) return;
            const years = list.map((item)=>parseInt(item.year));
            const min = Math.min(...years);
            const max = Math.max(...years);
            if (minYear == -1 || min < minYear) minYear = min;
            if (maxYear == -1 || max > maxYear) maxYear = max;
        });
        //minYear = 2003;
        if (maxYear - minYear > maxYearsInReport) {
            const trim = maxYear - minYear - maxYearsInReport;
            return {
                from: minYear + trim,
                to: maxYear
            };
        }
        //console.log(minYear, maxYear);
        return {
            from: minYear,
            to: maxYear
        };
    };
    const tableRange = getReportYearRange();
    const columns = [
        ...createColumnsYears(tableRange.from, tableRange.to),
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const defaults = {
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
        formatter: (0, $1ac83566e6b5504b$export$40333d0facc9092d),
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).dollar,
        editable: true
    };
    const defaultsPercent = {
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
        formatter: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6),
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
    };
    const makeRow = (fieldName, hideRowNoData = false)=>{
        var _a;
        const hasData = query.anyValue(fieldName);
        const display = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName]['display']) !== null && _a !== void 0 ? _a : fieldName;
        const row = Object.assign(Object.assign({}, defaults), {
            skipRow: !hasData && hideRowNoData,
            field: {
                source: fieldName,
                display: display
            },
            value: findByYear()
        });
        return row;
    };
    const makeEbitdaRows = (fieldName)=>{
        var _a;
        const hasData = query.anyValue(fieldName);
        const display = (_a = (0, $809f7f123ac5d4fa$export$be4faee424ea3a71)[fieldName]['display']) !== null && _a !== void 0 ? _a : fieldName;
        if (!hasData) return null;
        const ebitdaValuesRow = Object.assign(Object.assign({}, defaults), {
            field: {
                source: fieldName,
                display: display
            },
            value: findByYear()
        });
        const ebitdaMarginRow = Object.assign(Object.assign({}, defaultsPercent), {
            field: {
                source: fieldName,
                display: display + ' Margin'
            },
            value: findByYearDivideByRevenue()
        });
        return [
            ebitdaValuesRow,
            ebitdaMarginRow
        ];
    };
    // const makeSectionRow = (req: SectionFieldRequest) => {
    //     return {
    //         ...defaults,
    //         field: {
    //             source: `${req.section}.${req.field}`,
    //             display: query.labelBySection(req)
    //         },
    //         value: findByYearSection({ ...req })
    //     };
    // };
    const ebitdaKeys = (0, $2934a4a4389d65dc$export$d9b13a70c820f8b9).EBITDA_TYPES;
    const ebitdaRows = (0, (/*@__PURE__*/$parcel$interopDefault($fgQ0V))).flatMap(ebitdaKeys, (key)=>makeEbitdaRows(key) || []);
    const get_capitalized_software = (f, c)=>{
        const year = parseInt(c.source);
        const getValue = (field)=>{
            const value = query.valueByYear(field, year);
            return value === 'N/A' ? 0 : value;
        };
        const override = query.valueByYear('capitalized_software_override', year);
        if (override !== 'N/A') return (0, $7fbd760f3c05e83d$export$c0080068ec287465)(override);
        const capitalizedSoftware = getValue('capitalized_software');
        const capitalized_application_development = getValue('capitalized_application_development');
        const capitalized_rnd = getValue('capitalized_rnd');
        const total = capitalizedSoftware + capitalized_application_development + capitalized_rnd;
        if (total === 0) return null;
        return total;
    };
    const get_capex_plus_software = (f, c)=>{
        var _a;
        const year = parseInt(c.source);
        const capitalized = (_a = get_capitalized_software(f, c)) !== null && _a !== void 0 ? _a : 0;
        const capex = query.valueByYear('capex_per_year', year);
        if (capex === 'N/A') return 'N/A';
        return capex + capitalized;
    };
    const makeFieldRow = (data, type, valFn, extend = {})=>{
        const valueCallback = valFn === 'by_year' ? findByYear(0) : findByYearDivideByRevenue(0);
        const defValues = type === 'dollar' ? defaults : defaultsPercent;
        return Object.assign(Object.assign(Object.assign({}, defValues), {
            field: {
                source: data.source,
                display: data.display
            },
            value: valueCallback
        }), extend);
    };
    const makeDollarRow = (source, display, extra = {})=>{
        return makeFieldRow({
            source: source,
            display: display
        }, 'dollar', 'by_year', Object.assign({
            editable: true
        }, extra));
    };
    const makePercentRowByRevenue = (source, display, extra = {})=>{
        return makeFieldRow({
            source: source,
            display: display
        }, 'percent', 'by_year_divide_by_revenue', Object.assign({
            editable: false
        }, extra));
    };
    const rows = [
        makeDollarRow('net_revenue_per_year', 'Revenue'),
        makePercentRowByRevenue('net_revenue_per_year', 'Revenue Growth', {
            value: (c, f)=>{
                const thisYear = findByYear()(c, f);
                const lastYear = findByYear(-1)(c, f);
                if (thisYear === 'N/A' || lastYear === 'N/A') return 'N/A';
                const growth = (thisYear - lastYear) / lastYear;
                return growth;
            }
        }),
        makeDollarRow('gross_profit_per_year', 'Gross Profit'),
        makePercentRowByRevenue('gross_profit_per_year', 'Gross Margin'),
        makeDollarRow('ebitda_per_year', 'EBITDA'),
        makePercentRowByRevenue('ebitda_per_year', 'EBITDA Margin'),
        makeDollarRow('adjusted_ebitda_per_year', 'Adj. EBITDA'),
        makePercentRowByRevenue('adjusted_ebitda_per_year', 'Adj. EBITDA Margin'),
        // ...ebitdaRows,
        makePercentRowByRevenue('gross_retention_lost_only_per_year', 'Gross Retention (Lost Only)', {
            editable: true,
            value: findByYear(),
            formatter: (0, $1ac83566e6b5504b$export$23be700726d3a499)
        }),
        makePercentRowByRevenue('net_retention_yearly', 'Net Retention', {
            editable: true,
            value: findByYear(),
            formatter: (0, $1ac83566e6b5504b$export$23be700726d3a499)
        }),
        makeDollarRow('total_current_assets_yearly', 'Current Assets'),
        makeDollarRow('total_current_liabilities_yearly', 'Current Liabilities'),
        makePercentRowByRevenue(null, 'NWC Ratio, % of Revenue', {
            value: (f, c)=>{
                const year = parseInt(c.source);
                const assets = query.valueByYear('total_current_assets_yearly', year);
                const Liabilities = query.valueByYear('total_current_liabilities_yearly', year);
                const revenue = query.valueByYear('net_revenue_per_year', year);
                if (assets === 'N/A' || Liabilities === 'N/A' || revenue === 'N/A') return 'N/A';
                return (assets - Liabilities) / revenue;
            }
        }),
        makeDollarRow('capex_per_year', 'Capex'),
        makePercentRowByRevenue('capex_per_year', 'Capex, % of Revenue'),
        makeDollarRow('capitalized_software_override', "\u2060Capitalized Development Costs", {
            //Note we hack this 'field display name' to connect to sources in data access utils
            editable: true,
            value: get_capitalized_software
        }),
        makeDollarRow(null, "\u2060CapEx (incl Capitalized Development Costs)", {
            editable: false,
            value: get_capex_plus_software
        }),
        makePercentRowByRevenue(null, 'CapEx (incl Capitalized Development Costs), as a % of revenue', {
            editable: false,
            value: (f, c)=>{
                //Special case where we edit a field but if not bring a grouped value
                const year = parseInt(c.source);
                const totalCapex = get_capex_plus_software(f, c);
                const revenue = query.valueByYear('net_revenue_per_year', year);
                if (totalCapex === 'N/A' || revenue === 'N/A') return 'N/A';
                return totalCapex / revenue;
            }
        }),
        makeDollarRow('ebitda_cashflow_yearly', 'Free Cash Flow (FCF)'),
        makePercentRowByRevenue(null, 'FCF Conversion, % of EBITDA', {
            value: (f, c)=>{
                const year = parseInt(c.source);
                return query.fcf_conversion_ebitda(year);
            }
        })
    ];
    const ebitda = query.value('ebitda');
    if (ebitda) {
        var keys = Object.keys(ebitda);
        for(var k in keys){
            const key = keys[k];
        }
    }
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $4a29e112f87df826$export$3247f956c2135754), {
                onResize: onResize
            }),
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "General"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                className: $4d8f71986a24a2e8$export$3dc43a2aec770a90,
                topLeftCellText: "($ in Millions)",
                columns: columns,
                rows: rows,
                disable_round_edges: true,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");








const $fc006c6fb6bc2c1f$export$e5d899bd293071b8 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const { query: query } = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const columns = [
        {
            column: {
                source: '',
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const makeRow = (fieldName, display, formatter)=>{
        return {
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, _column)=>{
                return query.value(fieldName);
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            formatter: formatter
        };
    };
    const rows = [
        {
            field: {
                source: 'recurring_revenue_summary',
                display: 'Contractual Revenue'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).boolean,
            value: (field, _column)=>{
                return query.value(field.source);
            },
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            //editor: ValueEditor.boolean,
            editable: true
        },
        makeRow('does_not_exist', 'Payback Period for Growth Capex', (0, $1ac83566e6b5504b$export$40333d0facc9092d))
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "Key Metrics"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: columns,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");






const $c419de567f6a7798$export$4cf3faa507b81a0a = ()=>{
    const data = {};
    const query = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
    const cols = [
        {
            column: {
                source: '2',
                display: '2 Years'
            }
        },
        {
            column: {
                source: '3',
                display: '3 Years'
            }
        },
        {
            column: {
                source: '4',
                display: '4 Years'
            }
        },
        {
            column: {
                source: '5',
                display: '5 Years'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const rowDefaults = {
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
        formatter: (data)=>(0, $7fbd760f3c05e83d$export$e440a706af0c0216)(data.toString())
    };
    const rows = [
        Object.assign(Object.assign({}, rowDefaults), {
            field: {
                source: 'net_revenue_per_year',
                display: 'Historical Organic CAGR'
            },
            value: (field, column)=>{
                const yearCalc = parseInt(column.source);
                return query.organicCagr(yearCalc);
            }
        }),
        Object.assign(Object.assign({}, rowDefaults), {
            field: {
                source: 'net_revenue_per_year',
                display: 'Projected Organic CAGR'
            },
            value: (field, column)=>{
                const yearCalc = parseInt(column.source);
                return query.projectedCagr(yearCalc);
            }
        })
    ];
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                title: "Revenue CAGRs"
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                disable_round_edges: true
            })
        ]
    });
};



const $9f7291a9219114ca$export$8a60f67e01e6fb31 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const data = store.query.activeReport;
    if (!data) return null;
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('revenue_performance');
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Financials",
                iconUrl: icon
            }),
            (0, $kSbwP.jsx)((0, $bbf930a6e7328633$export$89f5e9b3190f357b), {}),
            (0, $kSbwP.jsx)((0, $fe065f57c6129e2d$export$789f086b167f93b9), {}),
            (0, $kSbwP.jsx)((0, $c419de567f6a7798$export$4cf3faa507b81a0a), {}),
            (0, $kSbwP.jsx)((0, $fe065f57c6129e2d$export$789f086b167f93b9), {}),
            (0, $kSbwP.jsx)((0, $fc006c6fb6bc2c1f$export$e5d899bd293071b8), {})
        ]
    });
});



var $kSbwP = parcelRequire("kSbwP");











const $b1fe1211f58e7da7$export$5b854e326c825364 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const data = query.activeReport;
    if (!data) return null;
    const cols = [
        {
            column: {
                source: null,
                display: 'Value'
            }
        },
        {
            column: {
                source: null,
                display: 'Source'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).textbox,
            dontUseRowFormatting: true,
            overrideValue: query.sources.bind(query)
        }
    ];
    const genRow = (fieldName, display, formatter, extra)=>{
        return Object.assign({
            editable: true,
            field: {
                source: fieldName,
                display: display
            },
            value: (_field, column)=>{
                return query.value(fieldName);
            },
            formatter: formatter,
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }, extra);
    };
    //    var industry =
    //    query.value('industry') + ', ' + query.value('industrySubType');
    const rows = [
        genRow('market_share', 'Market Share', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('historical_market_growth', 'Historical Market Growth', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('projected_market_growth', 'Projected Market Growth', (0, $1ac83566e6b5504b$export$23be700726d3a499)),
        genRow('total_addressable_market', 'Total Addressable Market', (0, $1ac83566e6b5504b$export$ce7cfd4f28e6833)(' Bil.'), {
            label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
        }),
        genRow('industry', 'Industry', (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).industry
        }),
        genRow('industrySubType', 'Sub-industry', (0, $1ac83566e6b5504b$export$91991769c57c29a), {
            editor: (0, $68d2907db623a0aa$export$44b5115104b4b812).subIndustry
        })
    ];
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('market_size_and_performance');
    return (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        children: [
            (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                title: "Industry",
                iconUrl: icon
            }),
            (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                columns: cols,
                rows: rows,
                onEditField: (0, $b8332ea8355e1651$export$ecde49fefbe76021)
            })
        ]
    });
});




var $kSbwP = parcelRequire("kSbwP");



var $T5IcR = parcelRequire("T5IcR");


var $8nGP5 = parcelRequire("8nGP5");


var $83348bebf1460cdb$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $83348bebf1460cdb$export$9d5f8324718c22d1 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const pdfRef = (0, $8nGP5.useRef)(null);
    const [pdfViewer, setPdfViewer] = (0, $8nGP5.useState)(null);
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const searchedTerms = (0, $8nGP5.useRef)([]);
    (0, $8nGP5.useEffect)(()=>{
        uiStore.resetViewerRequests();
    }, []);
    (0, $8nGP5.useEffect)(()=>{
        // @ts-ignore
        if (!window.AdobeDC) return;
        if (pdfRef.current == null) return;
        const pdfFile = (0, $T5IcR.toJS)(props.pdfUrl);
        const companyName = (0, $T5IcR.toJS)(props.title_display);
        if (!pdfFile || pdfFile == '') return;
        //LOCALHOST KEY 95c70d4882b846f7899dbcd35e0ce896
        const isLocalhost = window.location.href.indexOf('localhost') > -1;
        var localhost_key = '2042181d883b4bddaabbc5930d48b302';
        var pdf_key = isLocalhost ? localhost_key : (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)().pdfViewerKey;
        // @ts-ignore
        var adobeDCView = new AdobeDC.View({
            clientId: pdf_key,
            divId: 'adobe-dc-view'
        });
        var previewFilePromise = adobeDCView.previewFile({
            content: {
                location: {
                    url: pdfFile
                }
            },
            metaData: {
                fileName: companyName
            }
        }, {
            embedMode: 'FULL_WINDOW',
            enableFormFilling: false,
            showAnnotationTools: false,
            showZoomControl: true,
            defaultViewMode: 'FIT_PAGE',
            focusOnRendering: false
        });
        previewFilePromise.then((adobeViewer)=>{
            setPdfViewer(adobeViewer);
        });
    }, [
        pdfRef,
        props.pdfUrl,
        props.title_display
    ]);
    (0, $8nGP5.useEffect)(function processPdfRequest() {
        const { page: page, highlightTexts: highlightTexts } = uiStore.pdfRequest;
        const clearTerms = ()=>{
            for(const i in searchedTerms.current){
                const term = searchedTerms.current[i];
                term.clear();
            }
        };
        searchedTerms.current = [];
        const doSearch = ()=>$83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                if (highlightTexts.length > 0 && pdfViewer != null) {
                    const api = yield pdfViewer.getAPIs();
                    for(const i in highlightTexts){
                        const term = highlightTexts[i];
                        const highlightRet = yield api.search(term);
                        searchedTerms.current.push(term);
                    }
                }
            });
        const gotoPage = ()=>$83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                if (page != -1 && pdfViewer != null) pdfViewer.getAPIs().then((apis)=>{
                    apis.gotoLocation(page, 0, 0).then((result)=>console.log(result)).catch((error)=>console.log(error));
                });
            });
        function doWork() {
            return $83348bebf1460cdb$var$__awaiter(this, void 0, void 0, function*() {
                gotoPage();
                if (highlightTexts.length > 0) yield doSearch();
                gotoPage();
            });
        }
        doWork();
    }, [
        uiStore.pdfRequest
    ]);
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        fillCell: true,
        children: (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            shadow: true,
            children: (0, $kSbwP.jsx)("div", {
                ref: pdfRef,
                id: "adobe-dc-view",
                className: "pdf-viewer",
                style: {
                    zIndex: 6000,
                    borderRadius: '20px'
                }
            })
        })
    });
});




var $kSbwP = parcelRequire("kSbwP");







var $fgQ0V = parcelRequire("fgQ0V");



var $4bdb7d1d6cbc10d4$export$637f169d296cfe12;
$4bdb7d1d6cbc10d4$export$637f169d296cfe12 = `mE7S0q_panelTableStyle`;


const $3ffe40629fb9765e$export$a470e850d1c2e97c = ()=>{
    const data = {};
    const query = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().query;
    const customers = query.customers;
    if (!customers) return null;
    const colPercent = {
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent,
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
        overrideFormatting: (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)
    };
    const rowDefaults = {
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value,
        label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
        formatter: (data)=>(0, $1ac83566e6b5504b$export$40333d0facc9092d)(data.toString())
    };
    const getYearRange = ()=>{
        var minYear = 0;
        var maxYear = 0;
        const years = [];
        for (const customer of customers)for(const k in customer.revenue){
            const e = customer.revenue[k];
            if (e.year > 0) years.push(e.year);
        }
        return {
            minYear: (0, $fgQ0V.min)(years),
            maxYear: (0, $fgQ0V.max)(years)
        };
    };
    const ALL_YEAR_CUSTOMER_INDEX = -1;
    const { minYear: minYear, maxYear: maxYear } = getYearRange();
    const customerOrder = customers.map((c, index)=>({
            name: c.name,
            index: index
        })).sort((a, b)=>a.name.localeCompare(b.name)).map((c)=>c.index);
    customerOrder.push(ALL_YEAR_CUSTOMER_INDEX);
    const cols = [];
    for(let i = minYear; i <= maxYear; i++){
        cols.push({
            column: {
                source: i.toString(),
                display: i.toString()
            }
        });
        cols.push(Object.assign({
            column: {
                source: i.toString(),
                display: i.toString() + '%'
            },
            overrideValue: (field, column)=>{
                const year = parseInt(column.source);
                const customerIndex = parseInt(field.source);
                var rev = getCustomerRevenue(customerIndex, year);
                var totalRev = query.valueByYear('net_revenue_per_year', year);
                if (totalRev == 'N/A' || rev == 0) return '-';
                return rev / totalRev;
            }
        }, colPercent));
    }
    cols.push({
        header: (col)=>{
            return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                fillCell: true,
                justify: "start",
                children: col.column.display
            });
        },
        column: {
            source: null,
            display: 'Source'
        },
        element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
        dontUseRowFormatting: true,
        overrideValue: (field, column)=>{
            const customerIndex = parseInt(field.source);
            const customer = customers[customerIndex];
            if (!customer) return [];
            return customer.page_sources;
        }
    });
    const getCustomerRevenue = (customerIndex, year)=>{
        var _a, _b;
        if (customerIndex === ALL_YEAR_CUSTOMER_INDEX) return customers.flatMap((c)=>c.revenue).filter((e)=>e.year === year).reduce((acc, e)=>acc + (e.revenue || 0), 0);
        const customer = customers[customerIndex];
        if (!customer) return 0;
        return (_b = (_a = customer.revenue.find((e)=>e.year === year)) === null || _a === void 0 ? void 0 : _a.revenue) !== null && _b !== void 0 ? _b : 0;
    };
    const rows = [];
    for(let i in customerOrder){
        const customerIndex = customerOrder[i];
        const customerName = customerIndex == ALL_YEAR_CUSTOMER_INDEX ? 'Totals' : customers[customerIndex].name;
        const row = Object.assign({
            field: {
                source: customerIndex.toString(),
                display: customerName
            },
            value: (field, column)=>{
                const year = parseInt(column.source);
                const customerIndex = parseInt(field.source);
                var rev = getCustomerRevenue(customerIndex, year);
                if (rev == 0) return '-';
                return rev;
            }
        }, rowDefaults);
        rows.push(row);
    }
    const icon = (0, $3d82e178f5213798$export$ef2b607153f69518)('concentration');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
            children: [
                (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                    title: "Customers",
                    iconUrl: icon
                }),
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    className: $4bdb7d1d6cbc10d4$export$637f169d296cfe12,
                    topLeftCellText: "($ in Millions)",
                    columns: cols,
                    rows: rows
                })
            ]
        })
    });
};


const $cb32edb7d568785b$export$a65eea1eaa5f8fa3 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const q = store.query;
    const nav = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    (0, $8nGP5.useEffect)(function auditReportView() {
        (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('VIEW_PAGE_DEAL', {
            page: 'DealView',
            deal_id: store.selectedReportId,
            url: window.location.href
        });
    }, [
        store.selectedReportId
    ]);
    if (!store.query) return null;
    const pdfUrl = store.query.value('pdf');
    const companyName = store.query.value('company_name');
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $9583d2c91dbe771f$export$3ccee0cf1acf5f70), {
            spaceBetween: 12,
            children: [
                (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                    enableHideScrollUntilMouseOver: true,
                    children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                        direction: "column",
                        style: {
                            gap: '20px'
                        },
                        children: [
                            (0, $kSbwP.jsx)((0, $9f7291a9219114ca$export$8a60f67e01e6fb31), {}),
                            (0, $kSbwP.jsx)((0, $3ffe40629fb9765e$export$a470e850d1c2e97c), {}),
                            (0, $kSbwP.jsx)((0, $b1fe1211f58e7da7$export$5b854e326c825364), {}),
                            (0, $kSbwP.jsx)((0, $79da148714874de1$export$58cad4665f64d293), {})
                        ]
                    })
                }),
                (0, $kSbwP.jsx)((0, $83348bebf1460cdb$export$9d5f8324718c22d1), {
                    pdfUrl: q.pdfViewUrl,
                    title_display: q.companyName
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");













var $kSbwP = parcelRequire("kSbwP");


var $e6db7b46041a73ca$export$2d85d542e52be912;
var $e6db7b46041a73ca$export$2704a0b14f0ac358;
var $e6db7b46041a73ca$export$d2c0f94b95255e43;
var $e6db7b46041a73ca$export$b0da26f11a7d688b;
var $e6db7b46041a73ca$export$134f3e5d09df31a8;
var $e6db7b46041a73ca$export$1237798dc640739a;
var $e6db7b46041a73ca$export$479c4ede0cd2ddba;
var $e6db7b46041a73ca$export$3640fc85e5cb69d6;
var $e6db7b46041a73ca$export$cbaa55241f9795b8;
var $e6db7b46041a73ca$export$51758937339cdf8a;
var $e6db7b46041a73ca$export$d990f29413e4836c;
var $e6db7b46041a73ca$export$bb4532791996264d;
var $e6db7b46041a73ca$export$af5728fd7085c3ad;
var $e6db7b46041a73ca$export$268c0241a24ad0ec;
var $e6db7b46041a73ca$export$a52b030935ae9ca9;
var $e6db7b46041a73ca$export$4e6f96734dfe12f4;
var $e6db7b46041a73ca$export$c4b341013b576107;
var $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
var $e6db7b46041a73ca$export$baf8e363c9bd46ec;
var $e6db7b46041a73ca$export$64c36945836d3acb;
$e6db7b46041a73ca$export$2d85d542e52be912 = `mh-S_q_centerLabel`;
$e6db7b46041a73ca$export$2704a0b14f0ac358 = `mh-S_q_edgeLine`;
$e6db7b46041a73ca$export$d2c0f94b95255e43 = `mh-S_q_edgeLineGreen`;
$e6db7b46041a73ca$export$b0da26f11a7d688b = `mh-S_q_edgeLineRed`;
$e6db7b46041a73ca$export$134f3e5d09df31a8 = `mh-S_q_grayFilter`;
$e6db7b46041a73ca$export$1237798dc640739a = `mh-S_q_label`;
$e6db7b46041a73ca$export$479c4ede0cd2ddba = `mh-S_q_leftLabel`;
$e6db7b46041a73ca$export$3640fc85e5cb69d6 = `mh-S_q_middleLabel`;
$e6db7b46041a73ca$export$cbaa55241f9795b8 = `mh-S_q_rightLabel`;
$e6db7b46041a73ca$export$51758937339cdf8a = `mh-S_q_scoreLine`;
$e6db7b46041a73ca$export$d990f29413e4836c = `mh-S_q_scoreLineContainer`;
$e6db7b46041a73ca$export$bb4532791996264d = `mh-S_q_scoreLineEntry`;
$e6db7b46041a73ca$export$af5728fd7085c3ad = `mh-S_q_scoreLineGreaterThan`;
$e6db7b46041a73ca$export$268c0241a24ad0ec = `mh-S_q_scoreLineRangedGradient`;
$e6db7b46041a73ca$export$a52b030935ae9ca9 = `mh-S_q_textEntry`;
$e6db7b46041a73ca$export$4e6f96734dfe12f4 = `mh-S_q_tooltip`;
$e6db7b46041a73ca$export$c4b341013b576107 = `mh-S_q_tooltipGreen`;
$e6db7b46041a73ca$export$b92f1b4ea687fd3d = `mh-S_q_tooltipRed`;
$e6db7b46041a73ca$export$baf8e363c9bd46ec = `mh-S_q_tooltipYellow`;
$e6db7b46041a73ca$export$64c36945836d3acb = `mh-S_q_tooltip_tip`;


const $21ac4e76fef0eb4d$export$7a5a0d6d8fafcf23 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const disp = p.display;
    //score range is 0 to 1
    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling
    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const noCls = $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
    const yesCls = $e6db7b46041a73ca$export$c4b341013b576107;
    const entries = p.entries.map((entry, i)=>{
        var classTooltip = null;
        var posX = -1;
        const r = p.rule;
        var dist = (entry.rawValue - r.range[0]) / (r.range[1] - r.range[0]);
        if (dist > 1.1) posX = 1 - halfEdge;
        else if (dist < 0.0) posX = halfEdge;
        else posX = edge + dist * (1 - edge * 2);
        if (!entry.didScore) classTooltip = noCls;
        else classTooltip = yesCls;
        //}
        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$bb4532791996264d, classTooltip, $e6db7b46041a73ca$export$64c36945836d3acb);
        return (0, $kSbwP.jsx)("div", {
            className: cls,
            style: {
                left: posXStr
            },
            children: disp.value
        }, i);
    });
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a, $e6db7b46041a73ca$export$af5728fd7085c3ad, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)("div", {
            className: $e6db7b46041a73ca$export$d990f29413e4836c,
            children: (0, $kSbwP.jsxs)("div", {
                className: cls,
                children: [
                    (0, $kSbwP.jsxs)("div", {
                        className: $e6db7b46041a73ca$export$3640fc85e5cb69d6,
                        children: [
                            '>',
                            " ",
                            disp.center
                        ]
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$479c4ede0cd2ddba,
                        children: disp.min
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$cbaa55241f9795b8,
                        children: disp.max
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$d2c0f94b95255e43
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$b0da26f11a7d688b
                    }),
                    entries
                ]
            })
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");



const $fdaccb990ee1a680$export$3422dd3ad07f2311 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const minValue = p.display.min;
    const maxValue = p.display.max;
    const valDisplay = p.display.value;
    //score range is 0 to 1
    //0 - 0.15 IS under - > right in center no scaling
    //0.15 - 0.85 is in range -> scale to 0 - 1
    //0.85 - 1 is over -> right in center no scaling
    const edge = 0.1; //Note CSS also defined this value as --edge-range: 10%;
    const halfEdge = edge / 2;
    var tooltipColor = null;
    const redCls = $e6db7b46041a73ca$export$b92f1b4ea687fd3d;
    const yellowCls = $e6db7b46041a73ca$export$baf8e363c9bd46ec;
    const greenCls = $e6db7b46041a73ca$export$c4b341013b576107;
    const entries = p.entries.map((entry, i)=>{
        var classTooltip = null;
        var posX = -1;
        if (entry.type == 'under') {
            posX = halfEdge;
            classTooltip = redCls;
        } else if (entry.type == 'over') {
            posX = 1 - halfEdge;
            classTooltip = greenCls;
        } else {
            posX = edge + entry.score * (1 - edge * 2);
            classTooltip = null;
            var scoreInt = parseInt((entry.score * 100).toString());
            if (scoreInt > 85) classTooltip = greenCls;
            else if (scoreInt > 55) classTooltip = yellowCls;
            else classTooltip = redCls;
        }
        const posXStr = (posX * 100).toFixed(0).toString() + '%';
        const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$bb4532791996264d, classTooltip, $e6db7b46041a73ca$export$64c36945836d3acb);
        return (0, $kSbwP.jsx)("div", {
            className: cls,
            style: {
                left: posXStr
            },
            children: valDisplay
        }, i);
    });
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a, $e6db7b46041a73ca$export$268c0241a24ad0ec, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)("div", {
            className: $e6db7b46041a73ca$export$d990f29413e4836c,
            children: (0, $kSbwP.jsxs)("div", {
                className: cls,
                children: [
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$479c4ede0cd2ddba,
                        children: minValue
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$cbaa55241f9795b8,
                        children: maxValue
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$2d85d542e52be912,
                        children: p.display.centerText
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$d2c0f94b95255e43
                    }),
                    (0, $kSbwP.jsx)("div", {
                        className: $e6db7b46041a73ca$export$b0da26f11a7d688b
                    }),
                    entries
                ]
            })
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");



const $5c49efab054a1b57$export$82045baefac896dc = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$51758937339cdf8a);
    const noCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$a52b030935ae9ca9, $e6db7b46041a73ca$export$b92f1b4ea687fd3d, {
        [$e6db7b46041a73ca$export$134f3e5d09df31a8]: p.didScore === null || p.didScore === true
    });
    const yesCls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$a52b030935ae9ca9, $e6db7b46041a73ca$export$c4b341013b576107, {
        [$e6db7b46041a73ca$export$134f3e5d09df31a8]: p.didScore === null || p.didScore === false
    });
    const yesTooltip = (0, $kSbwP.jsx)("div", {
        className: yesCls,
        style: {
            left: '60%'
        },
        children: "YES"
    });
    const noTooltip = (0, $kSbwP.jsx)("div", {
        className: noCls,
        style: {
            left: '40%'
        },
        children: "NO"
    });
    const classContainer = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($e6db7b46041a73ca$export$d990f29413e4836c, p.className);
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: classContainer,
            children: [
                yesTooltip,
                noTooltip
            ]
        })
    });
});





var $da302f328e83b849$export$a38dc554151ff661;
var $da302f328e83b849$export$42e4a6ed1eb5a52e;
var $da302f328e83b849$export$5c219a65934d4b9c;
var $da302f328e83b849$export$e730f6987ad4283b;
var $da302f328e83b849$export$41fc6278a3c14d73;
var $da302f328e83b849$export$2f9904c7e241cf9;
var $da302f328e83b849$export$6633e83f4afff9ea;
var $da302f328e83b849$export$637f169d296cfe12;
var $da302f328e83b849$export$daaf31466ad29ead;
var $da302f328e83b849$export$9ba80d992c64273b;
var $da302f328e83b849$export$4087c73cbd989252;
var $da302f328e83b849$export$45f85e82cb24606f;
$da302f328e83b849$export$a38dc554151ff661 = `nyntOq_companyHeaderElement`;
$da302f328e83b849$export$42e4a6ed1eb5a52e = `nyntOq_companyLogo`;
$da302f328e83b849$export$5c219a65934d4b9c = `nyntOq_companyNameLabel`;
$da302f328e83b849$export$e730f6987ad4283b = `nyntOq_dealThumbScore`;
$da302f328e83b849$export$41fc6278a3c14d73 = `nyntOq_noDataAvail`;
$da302f328e83b849$export$2f9904c7e241cf9 = `nyntOq_notScoredGray`;
$da302f328e83b849$export$6633e83f4afff9ea = `nyntOq_panelTableCompanies`;
$da302f328e83b849$export$637f169d296cfe12 = `nyntOq_panelTableStyle`;
$da302f328e83b849$export$daaf31466ad29ead = `nyntOq_panelTitle`;
$da302f328e83b849$export$9ba80d992c64273b = `nyntOq_panelTitleText`;
$da302f328e83b849$export$4087c73cbd989252 = `nyntOq_sectionIcon`;
$da302f328e83b849$export$45f85e82cb24606f = `nyntOq_showNonUsedCheckbox`;



var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");


var $8nGP5 = parcelRequire("8nGP5");
const $d71aa867ac678319$var$Checkbox = (p)=>{
    const cls = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('form-check', p.className);
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useId();
    return (0, $kSbwP.jsxs)("div", {
        className: cls,
        children: [
            (0, $kSbwP.jsx)("input", {
                id: id,
                type: "checkbox",
                className: "form-check-input",
                checked: p.checked,
                onChange: (e)=>p.onChange(e.target.checked)
            }),
            p.label && (0, $kSbwP.jsx)("label", {
                className: "form-check-label",
                htmlFor: id,
                children: p.label
            })
        ]
    });
};
var $d71aa867ac678319$export$2e2bcd8739ae039 = $d71aa867ac678319$var$Checkbox;


const $36c6fce940b0e7aa$export$210595a4b4a710d0 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [showNonUsed, setShowNonUsed] = (0, $8nGP5.useState)(false);
    if (store.selectedReportId == '' || store.query == null) return null;
    const companyId = store.selectedReportId;
    const q = store.query;
    const scoreUtils = new (0, $9b879bbdd76f7296$export$39c49a915ff7ed37)(q);
    const getLabel = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).percent_label;
        else return (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label;
    };
    const getFormatter = (fieldName)=>{
        const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
        if (e.t == '%') {
            if (e.scale == 100) return 0, $1ac83566e6b5504b$export$23be700726d3a499;
            return 0, $1ac83566e6b5504b$export$32e6b1ae352e94d6;
        } else if (e.t == 'bool') return null;
        else return 0, $1ac83566e6b5504b$export$40333d0facc9092d;
    };
    var scoreStore = (0, $9b879bbdd76f7296$export$5bbef306d29b8236)();
    const fieldsGroup = scoreStore.SCORE_FIELDS_GROUPS;
    const getSectionIdAndFieldNameByRow = (row)=>{
        const split = row.source.split('.');
        const sectionId = split[0];
        const fieldName = split[1];
        return {
            sectionId: sectionId,
            fieldName: fieldName
        };
    };
    const getRuleData = (row)=>{
        const { sectionId: sectionId, fieldName: fieldName } = getSectionIdAndFieldNameByRow(row);
        const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(sectionId, fieldName);
        const rawValue = scoreUtils.get_extended_float_for_scoring(rule);
        var ruleScore = 0;
        var isUsed = false;
        if (scoreUtils.is_rule_used_for_scoring(rule)) {
            ruleScore = scoreUtils.do_rule_score(rule);
            isUsed = true;
        }
        const scoreWeight = scoreUtils.get_rule_weight(sectionId, rule);
        return {
            sectionId: sectionId,
            fieldName: fieldName,
            val: rawValue,
            rule: rule,
            ruleScore: ruleScore,
            scoreWeight: scoreWeight,
            isUsed: isUsed
        };
    };
    const getRangedScore = (data)=>{
        var _a;
        const { val: val, rule: rule, ruleScore: ruleScore, fieldName: fieldName } = data;
        const isScored = scoreUtils.is_rule_used_for_scoring(rule);
        var scoreEntries = [];
        var cls = '';
        if (isScored) {
            const score_not_scaled = scoreUtils.do_rule_score(rule, false);
            var scoreType = 'in-range';
            if (score_not_scaled > 1) scoreType = 'over';
            else if (score_not_scaled < 0) scoreType = 'under';
            const scoreEntry = {
                score: ruleScore,
                type: scoreType
            };
            scoreEntries.push(scoreEntry);
        } else cls = $da302f328e83b849$export$2f9904c7e241cf9;
        const formatter = (_a = getFormatter(fieldName)) !== null && _a !== void 0 ? _a : (0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2);
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsx)((0, $fdaccb990ee1a680$export$3422dd3ad07f2311), {
                className: cls,
                entries: scoreEntries,
                display: {
                    min: formatter(rule.range[rule.inverse_score ? 1 : 0]),
                    max: formatter(rule.range[rule.inverse_score ? 0 : 1]),
                    centerText: rule.inverse_score ? '(lower is better)' : '',
                    value: formatter(val)
                }
            })
        });
    };
    const getBooleanScore = (data)=>{
        const { ruleScore: ruleScore } = data;
        var didScore = null;
        if (data.isUsed) didScore = ruleScore > 0;
        return (0, $kSbwP.jsx)((0, $5c49efab054a1b57$export$82045baefac896dc), {
            didScore: didScore
        });
    };
    const getGreaterThanScore = (data)=>{
        var _a;
        const { val: val, rule: rule, ruleScore: ruleScore, fieldName: fieldName } = data;
        const entries = [];
        var cls = '';
        if (data.isUsed) {
            const scoreEntry = {
                didScore: ruleScore > 0,
                rawValue: val
            };
            entries.push(scoreEntry);
        } else cls = $da302f328e83b849$export$2f9904c7e241cf9;
        const formatter = (_a = getFormatter(fieldName)) !== null && _a !== void 0 ? _a : (0, $1ac83566e6b5504b$export$8c8c9051f21dcdc2);
        return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
            children: (0, $kSbwP.jsx)((0, $21ac4e76fef0eb4d$export$7a5a0d6d8fafcf23), {
                className: cls,
                rule: rule,
                entries: entries,
                display: {
                    center: formatter(rule.threshold),
                    min: formatter(rule.range[0]),
                    max: formatter(rule.range[1]),
                    value: formatter(val)
                }
            })
        });
    };
    const columns = [
        {
            column: {
                source: null,
                display: 'Score Visualized'
            },
            overrideValue: (row, col)=>{
                return null;
            },
            element: (row, col, data)=>{
                const ruleData = getRuleData(row.field);
                if (ruleData.val == 'N/A' && !showNonUsed) return null;
                const t = ruleData.rule.check;
                var el = null;
                if (t == 'range') el = getRangedScore(ruleData);
                else if (t == 'greater_than') el = getGreaterThanScore(ruleData);
                else if (t == 'boolean') el = getBooleanScore(ruleData);
                return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    alignItems: "center",
                    fillCell: true,
                    children: el
                });
            }
        },
        {
            column: {
                source: null,
                display: 'Percentile'
            },
            overrideValue: (row, col)=>{
                const { ruleScore: ruleScore, isUsed: isUsed } = getRuleData(row);
                if (!isUsed) return '-';
                return ruleScore != null ? (0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(ruleScore) : '-';
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
        },
        {
            column: {
                source: null,
                display: 'Weight'
            },
            overrideValue: (row, col)=>{
                const { scoreWeight: scoreWeight, ruleScore: ruleScore, isUsed: isUsed } = getRuleData(row);
                if (!isUsed) return '-';
                return `${(0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(ruleScore * scoreWeight).replace('%', '')}/${(0, $1ac83566e6b5504b$export$32e6b1ae352e94d6)(scoreWeight)}`;
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).percent
        }
    ];
    const fieldsToRows = (group)=>{
        var rows = [];
        group.fields.forEach((fieldName)=>{
            var _a;
            const rule = (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_score_rule_by_fieldname(group.sectionId, fieldName);
            if (rule.check == 'none') return;
            if (!scoreUtils.is_rule_used_for_scoring(rule) && !showNonUsed) return;
            const e = (0, $809f7f123ac5d4fa$export$3266a7a951967395)[fieldName];
            (0, $3d71a0e5fc49a3ca$exports.assert)(e != null, `Field ${fieldName} not found in fieldsNameLookup`);
            var display = e.display;
            if (e.dynDisplay) display = q.formatExtendedValueDisplay(e.dynDisplay);
            if (e.dynDisplayPrefix) {
                const dynDisp = e.dynDisplayPrefix.replace('$DATA_PICK_KEY', (_a = scoreUtils.get_datapick_key_for_rule(rule)) !== null && _a !== void 0 ? _a : 'N/A');
                display = dynDisp + display;
            }
            rows.push({
                field: {
                    source: `${group.sectionId}.${fieldName}`,
                    display: display
                },
                label: getLabel(fieldName)
            });
        });
        return rows;
    };
    const groupTables = fieldsGroup.map((group, i)=>{
        const groupRows = fieldsToRows(group);
        if (groupRows.length == 0) return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                    title: (0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId),
                    containerClassName: $da302f328e83b849$export$daaf31466ad29ead,
                    className: $da302f328e83b849$export$9ba80d992c64273b,
                    children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                        section: group.sectionId,
                        className: $da302f328e83b849$export$4087c73cbd989252
                    })
                }),
                (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: (0, $kSbwP.jsx)("div", {
                        className: $da302f328e83b849$export$41fc6278a3c14d73,
                        children: "No Data Available"
                    })
                })
            ]
        }, 'nodata_' + i);
        const sectionWorthIn100 = group.section_worth / scoreUtils.get_max_points_based_on_sections_used() * 100;
        const points = scoreUtils.calcSectionPercentileById(group.sectionId) * sectionWorthIn100;
        return (0, $kSbwP.jsxs)("div", {
            children: [
                (0, $kSbwP.jsx)((0, $308b83e7da0f0dd7$export$86de09faaa70680d), {
                    title: `${(0, $9b879bbdd76f7296$export$39c49a915ff7ed37).get_section_name(group.sectionId)} (${points.toFixed(0)}/${sectionWorthIn100.toFixed(0)}%)`,
                    containerClassName: $da302f328e83b849$export$daaf31466ad29ead,
                    className: $da302f328e83b849$export$9ba80d992c64273b,
                    children: (0, $kSbwP.jsx)((0, $3d82e178f5213798$export$ab8815222a429372), {
                        section: group.sectionId,
                        className: $da302f328e83b849$export$4087c73cbd989252
                    })
                }),
                (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
                    columns: columns,
                    rows: groupRows,
                    disable_round_edges: true,
                    className: $da302f328e83b849$export$637f169d296cfe12
                })
            ]
        }, group.sectionId);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $c94930c253f3e81f$export$f836382419f64c98), {
            layoutPercent: [
                30,
                70
            ],
            children: [
                (0, $kSbwP.jsx)((0, $79f88d7943aea7e8$export$c2e12a891bea2f25), {
                    reportId: companyId,
                    hideUnderline: true
                }),
                (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                    children: [
                        (0, $kSbwP.jsx)((0, $d71aa867ac678319$export$2e2bcd8739ae039), {
                            className: $da302f328e83b849$export$45f85e82cb24606f,
                            checked: showNonUsed,
                            onChange: (newState)=>{
                                setShowNonUsed(newState);
                            },
                            label: "Show Inactive Metrics"
                        }),
                        groupTables
                    ]
                })
            ]
        })
    });
});




var $kSbwP = parcelRequire("kSbwP");
var $d6210966c0731e57$exports = {};
var $9d8320321d7e30ad$exports = {};
$9d8320321d7e30ad$exports = new URL("chatgpt.2e7eab8d.svg", import.meta.url).toString();


var $5a8cc289049c7471$exports = {};
$5a8cc289049c7471$exports = new URL("sparkle.c93894f3.svg", import.meta.url).toString();


$d6210966c0731e57$exports = {
    "chatgpt": $9d8320321d7e30ad$exports,
    "sparkle": $5a8cc289049c7471$exports
};


const $8f0ee97a3ff3e474$export$dedbf5c8cc754a98 = (section)=>{
    if (!$d6210966c0731e57$exports[section]) return null;
    return $d6210966c0731e57$exports[section];
};
const $8f0ee97a3ff3e474$export$f04a61298a47a40f = (p)=>{
    return (0, $kSbwP.jsx)("div", {
        className: p.className,
        children: (0, $kSbwP.jsx)("img", {
            src: $d6210966c0731e57$exports[p.icon]
        })
    });
};







var $8nGP5 = parcelRequire("8nGP5");

var $ebCsu = parcelRequire("ebCsu");
parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $8a9f11900e15f558$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8a9f11900e15f558$var$_toPropertyKey(arg) {
    var key = $8a9f11900e15f558$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $8a9f11900e15f558$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8a9f11900e15f558$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $8a9f11900e15f558$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $8nGP5.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $8nGP5.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $8nGP5.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $8a9f11900e15f558$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $8a9f11900e15f558$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $8a9f11900e15f558$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($8a9f11900e15f558$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $8a9f11900e15f558$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $8nGP5 = parcelRequire("8nGP5");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext($0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext);
const $0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createContext(false);
// This is only used in React < 18.
function $0d357fab303a549b$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(cur === $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $8nGP5.useState)(true);
    let value = (0, $8nGP5.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $8nGP5.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $0d357fab303a549b$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $0d357fab303a549b$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($0d357fab303a549b$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $0d357fab303a549b$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $8nGP5.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $0d357fab303a549b$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $0d357fab303a549b$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).useId();
    let [didSSR] = (0, $8nGP5.useState)($0d357fab303a549b$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$0d357fab303a549b$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $0d357fab303a549b$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useId'] === 'function' ? $0d357fab303a549b$var$$b5e257d569688ac6$var$useModernSSRSafeId : $0d357fab303a549b$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $0d357fab303a549b$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $0d357fab303a549b$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $0d357fab303a549b$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $0d357fab303a549b$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5)))['useSyncExternalStore']($0d357fab303a549b$var$$b5e257d569688ac6$var$subscribe, $0d357fab303a549b$var$$b5e257d569688ac6$var$getSnapshot, $0d357fab303a549b$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $8nGP5.useContext)($0d357fab303a549b$var$$b5e257d569688ac6$var$IsSSRContext);
}



var $8nGP5 = parcelRequire("8nGP5");
const $93c3779b03def7e6$var$TabContext = /*#__PURE__*/ $8nGP5.createContext(null);
var $93c3779b03def7e6$export$2e2bcd8739ae039 = $93c3779b03def7e6$var$TabContext;



var $8nGP5 = parcelRequire("8nGP5");
const $cbaefd650df3ac32$var$SelectableContext = /*#__PURE__*/ $8nGP5.createContext(null);
const $cbaefd650df3ac32$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $cbaefd650df3ac32$export$2e2bcd8739ae039 = $cbaefd650df3ac32$var$SelectableContext;



var $8nGP5 = parcelRequire("8nGP5");




var $8nGP5 = parcelRequire("8nGP5");
const $d4f8bf939aa0eef9$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $d4f8bf939aa0eef9$export$c9058316764c140e(refA, refB) {
    const a = $d4f8bf939aa0eef9$var$toFnRef(refA);
    const b = $d4f8bf939aa0eef9$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $d4f8bf939aa0eef9$var$useMergedRefs(refA, refB) {
    return (0, $8nGP5.useMemo)(()=>$d4f8bf939aa0eef9$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $d4f8bf939aa0eef9$export$2e2bcd8739ae039 = $d4f8bf939aa0eef9$var$useMergedRefs;



var $8nGP5 = parcelRequire("8nGP5");

function $adde1df4331b2c97$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $8nGP5.useRef)(null);
    const hasEnteredRef = (0, $8nGP5.useRef)(inProp);
    const handleExited = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(onExited);
    (0, $8nGP5.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(ref, (0, $0ca6f01aced8e29e$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $8nGP5.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $adde1df4331b2c97$export$2e2bcd8739ae039 = $adde1df4331b2c97$var$NoopTransition;



var $kSbwP = parcelRequire("kSbwP");
const $0ac4314a9cc18c89$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $0ac4314a9cc18c89$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $0ac4314a9cc18c89$var$_excluded3 = [
    "as"
];
function $0ac4314a9cc18c89$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0ac4314a9cc18c89$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $0ac4314a9cc18c89$var$_objectWithoutPropertiesLoose(_ref, $0ac4314a9cc18c89$var$_excluded);
    const context = (0, $8nGP5.useContext)((0, $93c3779b03def7e6$export$2e2bcd8739ae039));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $0ac4314a9cc18c89$var$_objectWithoutPropertiesLoose(context, $0ac4314a9cc18c89$var$_excluded2);
    const key = (0, $cbaefd650df3ac32$export$eef49b42fde998a3)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $cbaefd650df3ac32$export$eef49b42fde998a3)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $0ac4314a9cc18c89$var$TabPanel = /*#__PURE__*/ $8nGP5.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $0ac4314a9cc18c89$var$_objectWithoutPropertiesLoose(_ref2, $0ac4314a9cc18c89$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $adde1df4331b2c97$export$2e2bcd8739ae039) }] = $0ac4314a9cc18c89$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $93c3779b03def7e6$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$0ac4314a9cc18c89$var$TabPanel.displayName = 'TabPanel';
var $0ac4314a9cc18c89$export$2e2bcd8739ae039 = $0ac4314a9cc18c89$var$TabPanel;



var $kSbwP = parcelRequire("kSbwP");
const $ac0f962e18ce3dc9$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $8a9f11900e15f558$export$2ee51287a16ca325)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $0d357fab303a549b$export$619500959fc48b26)(userId);
    const generateChildId = (0, $8nGP5.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $8nGP5.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $93c3779b03def7e6$export$2e2bcd8739ae039).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$ac0f962e18ce3dc9$var$Tabs.Panel = (0, $0ac4314a9cc18c89$export$2e2bcd8739ae039);
var $ac0f962e18ce3dc9$export$2e2bcd8739ae039 = $ac0f962e18ce3dc9$var$Tabs;





var $8nGP5 = parcelRequire("8nGP5");

var $818I0 = parcelRequire("818I0");


function $32111235bb00f3df$export$2e2bcd8739ae039(node) {
    var doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $7f1da6e4e2ccffac$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $32111235bb00f3df$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $93dc448587824ba2$var$rUpper = /([A-Z])/g;
function $93dc448587824ba2$export$2e2bcd8739ae039(string) {
    return string.replace($93dc448587824ba2$var$rUpper, '-$1').toLowerCase();
}


var $fc9e0f35a4611ba5$var$msPattern = /^ms-/;
function $fc9e0f35a4611ba5$export$2e2bcd8739ae039(string) {
    return (0, $93dc448587824ba2$export$2e2bcd8739ae039)(string).replace($fc9e0f35a4611ba5$var$msPattern, '-ms-');
}


var $8daf33ed3a5b05b4$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $8daf33ed3a5b05b4$export$2e2bcd8739ae039(value) {
    return !!(value && $8daf33ed3a5b05b4$var$supportedTransforms.test(value));
}


function $6a01e84b1d47be46$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property)) || (0, $7f1da6e4e2ccffac$export$2e2bcd8739ae039)(node).getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key));
        else if ((0, $8daf33ed3a5b05b4$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $6a01e84b1d47be46$export$2e2bcd8739ae039 = $6a01e84b1d47be46$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $3d98db97c6f46e5c$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $8061db448c42d261$var$parseDuration(node) {
    var str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $3d98db97c6f46e5c$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $8061db448c42d261$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $8061db448c42d261$var$parseDuration(element) || 0;
    var removeEmulate = $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $e3cc240163ce6e78$var$parseDuration(node, property) {
    const str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $e3cc240163ce6e78$export$2e2bcd8739ae039(element, handler) {
    const duration = $e3cc240163ce6e78$var$parseDuration(element, 'transitionDuration');
    const delay = $e3cc240163ce6e78$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $8061db448c42d261$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $72e794bda2b14bcb$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $8nGP5 = parcelRequire("8nGP5");

var $818I0 = parcelRequire("818I0");

var $8nGP5 = parcelRequire("8nGP5");
const $e2bab6b473f544db$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $e2bab6b473f544db$export$c9058316764c140e(refA, refB) {
    const a = $e2bab6b473f544db$var$toFnRef(refA);
    const b = $e2bab6b473f544db$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $e2bab6b473f544db$var$useMergedRefs(refA, refB) {
    return (0, $8nGP5.useMemo)(()=>$e2bab6b473f544db$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $e2bab6b473f544db$export$2e2bcd8739ae039 = $e2bab6b473f544db$var$useMergedRefs;



var $fCKK7 = parcelRequire("fCKK7");
function $9122c8d301795776$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($fCKK7))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



var $kSbwP = parcelRequire("kSbwP");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $1dc2e28d8849ce01$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $8nGP5.useRef)(null);
    const mergedRef = (0, $e2bab6b473f544db$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $9122c8d301795776$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $8nGP5.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $8nGP5.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $8nGP5.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $8nGP5.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $8nGP5.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $8nGP5.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $8nGP5.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $818I0.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).cloneElement(children, {
            ref: attachRef
        })
    });
});
var $1dc2e28d8849ce01$export$2e2bcd8739ae039 = $1dc2e28d8849ce01$var$TransitionWrapper;



var $kSbwP = parcelRequire("kSbwP");
const $2feb2f71257d3959$var$fadeStyles = {
    [(0, $818I0.ENTERING)]: 'show',
    [(0, $818I0.ENTERED)]: 'show'
};
const $2feb2f71257d3959$var$Fade = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $8nGP5.useCallback)((node, isAppearing)=>{
        (0, $72e794bda2b14bcb$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $1dc2e28d8849ce01$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $e3cc240163ce6e78$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $0ca6f01aced8e29e$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $8nGP5.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('fade', className, children.props.className, $2feb2f71257d3959$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$2feb2f71257d3959$var$Fade.displayName = 'Fade';
var $2feb2f71257d3959$export$2e2bcd8739ae039 = $2feb2f71257d3959$var$Fade;


function $b8607d60984ad6be$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $2feb2f71257d3959$export$2e2bcd8739ae039) : (0, $adde1df4331b2c97$export$2e2bcd8739ae039);
    return transition;
}



var $kSbwP = parcelRequire("kSbwP");
const $a59ca1ca26866f85$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $kSbwP.jsx)((0, $ac0f962e18ce3dc9$export$2e2bcd8739ae039), {
        ...props,
        transition: (0, $b8607d60984ad6be$export$2e2bcd8739ae039)(transition)
    });
$a59ca1ca26866f85$var$TabContainer.displayName = 'TabContainer';
var $a59ca1ca26866f85$export$2e2bcd8739ae039 = $a59ca1ca26866f85$var$TabContainer;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $9e7ab869134c26e6$var$TabContent = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$9e7ab869134c26e6$var$TabContent.displayName = 'TabContent';
var $9e7ab869134c26e6$export$2e2bcd8739ae039 = $9e7ab869134c26e6$var$TabContent;




var $8nGP5 = parcelRequire("8nGP5");







var $kSbwP = parcelRequire("kSbwP");
"use client";
const $16b24ee68adceda0$var$TabPane = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $2feb2f71257d3959$export$2e2bcd8739ae039) }] = (0, $0ac4314a9cc18c89$export$fae0121b5afe572d)({
        ...props,
        transition: (0, $b8607d60984ad6be$export$2e2bcd8739ae039)(transition)
    });
    const prefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $93c3779b03def7e6$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$16b24ee68adceda0$var$TabPane.displayName = 'TabPane';
var $16b24ee68adceda0$export$2e2bcd8739ae039 = $16b24ee68adceda0$var$TabPane;


/* eslint-disable react/no-unused-prop-types */ const $4130385b85bf806d$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($ebCsu))).object
};
const $4130385b85bf806d$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$4130385b85bf806d$var$Tab.propTypes = $4130385b85bf806d$var$propTypes;
var $4130385b85bf806d$export$2e2bcd8739ae039 = Object.assign($4130385b85bf806d$var$Tab, {
    Container: (0, $a59ca1ca26866f85$export$2e2bcd8739ae039),
    Content: (0, $9e7ab869134c26e6$export$2e2bcd8739ae039),
    Pane: (0, $16b24ee68adceda0$export$2e2bcd8739ae039)
});

parcelRequire("8nGP5");

var $1TGTA = parcelRequire("1TGTA");

var $8D9Xw = parcelRequire("8D9Xw");

var $8nGP5 = parcelRequire("8nGP5");

var $647ee895478c368b$var$noop = function noop() {};
function $647ee895478c368b$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $647ee895478c368b$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $647ee895478c368b$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$647ee895478c368b$export$26cbf8c37e721e67(prop)] = $647ee895478c368b$var$noop;
        var handler;
    });
    return propTypes;
}
function $647ee895478c368b$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $647ee895478c368b$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $647ee895478c368b$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $73f69c1bcfac1e92$var$_toPropertyKey(arg) {
    var key = $73f69c1bcfac1e92$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $73f69c1bcfac1e92$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73f69c1bcfac1e92$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $8nGP5.useRef)(propValue !== undefined);
    var _useState = (0, $8nGP5.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $8nGP5.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $73f69c1bcfac1e92$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$647ee895478c368b$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $8D9Xw.default)(_ref, [
            $647ee895478c368b$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($73f69c1bcfac1e92$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $73f69c1bcfac1e92$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $1TGTA.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}



var $8D9Xw = parcelRequire("8D9Xw");

var $1TGTA = parcelRequire("1TGTA");

var $79bU5 = parcelRequire("79bU5");

var $8nGP5 = parcelRequire("8nGP5");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e60c074f0cb8bafe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e60c074f0cb8bafe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e60c074f0cb8bafe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e60c074f0cb8bafe$var$componentWillMount.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e60c074f0cb8bafe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $e60c074f0cb8bafe$var$componentWillMount;
        prototype.componentWillReceiveProps = $e60c074f0cb8bafe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $e60c074f0cb8bafe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $7dda9526ac49e80d$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $7dda9526ac49e80d$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $647ee895478c368b$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($647ee895478c368b$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $79bU5.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $1TGTA.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$647ee895478c368b$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $1TGTA.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$647ee895478c368b$export$12ae2baa35bd9b8b(props, key) && $647ee895478c368b$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$647ee895478c368b$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $8D9Xw.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(Component, (0, $1TGTA.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Component);
    (0, $e60c074f0cb8bafe$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $1TGTA.default)({
        innerRef: function innerRef() {}
    }, $647ee895478c368b$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(UncontrolledComponent, (0, $1TGTA.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $7dda9526ac49e80d$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $7dda9526ac49e80d$export$2e2bcd8739ae039(newComponent, (0, $1TGTA.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}







var $8nGP5 = parcelRequire("8nGP5");

var $0a134cba80b47542$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $0a134cba80b47542$export$2e2bcd8739ae039(element, selector) {
    return $0a134cba80b47542$var$toArray(element.querySelectorAll(selector));
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $4c1c7387d84288cf$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $8nGP5.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}




var $8nGP5 = parcelRequire("8nGP5");
const $5d096275a512c93f$var$NavContext = /*#__PURE__*/ $8nGP5.createContext(null);
$5d096275a512c93f$var$NavContext.displayName = 'NavContext';
var $5d096275a512c93f$export$2e2bcd8739ae039 = $5d096275a512c93f$var$NavContext;




const $58dfae96e0f444ef$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $58dfae96e0f444ef$export$635202801f9383a0 = `rrUi`;
function $58dfae96e0f444ef$export$5cc3b7b83e34ade7(property) {
    return `${$58dfae96e0f444ef$export$fd7bcb7e9bef4e8a}${property}`;
}
function $58dfae96e0f444ef$export$7776c0a7cd2eb3e0(property) {
    return `${$58dfae96e0f444ef$export$635202801f9383a0}${property}`;
}



var $8nGP5 = parcelRequire("8nGP5");







var $kSbwP = parcelRequire("kSbwP");
const $3a97e452d7d2ec76$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $3a97e452d7d2ec76$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3a97e452d7d2ec76$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $8nGP5.useContext)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039));
    const navContext = (0, $8nGP5.useContext)((0, $5d096275a512c93f$export$2e2bcd8739ae039));
    const tabContext = (0, $8nGP5.useContext)((0, $93c3779b03def7e6$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $58dfae96e0f444ef$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $3a97e452d7d2ec76$var$NavItem = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $a4ab631a1be079fe$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $3a97e452d7d2ec76$var$_objectWithoutPropertiesLoose(_ref, $3a97e452d7d2ec76$var$_excluded);
    const [props, meta] = $3a97e452d7d2ec76$export$d7a68693710982a(Object.assign({
        key: (0, $cbaefd650df3ac32$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $58dfae96e0f444ef$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$3a97e452d7d2ec76$var$NavItem.displayName = 'NavItem';
var $3a97e452d7d2ec76$export$2e2bcd8739ae039 = $3a97e452d7d2ec76$var$NavItem;



var $kSbwP = parcelRequire("kSbwP");
const $8006606f9503692b$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $8006606f9503692b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8006606f9503692b$var$noop = ()=>{};
const $8006606f9503692b$var$EVENT_KEY_ATTR = (0, $58dfae96e0f444ef$export$5cc3b7b83e34ade7)('event-key');
const $8006606f9503692b$var$Nav = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $8006606f9503692b$var$_objectWithoutPropertiesLoose(_ref, $8006606f9503692b$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $4c1c7387d84288cf$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $8nGP5.useRef)(false);
    const parentOnSelect = (0, $8nGP5.useContext)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039));
    const tabContext = (0, $8nGP5.useContext)((0, $93c3779b03def7e6$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $8nGP5.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(currentListNode, `[${$8006606f9503692b$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $58dfae96e0f444ef$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $8nGP5.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$8006606f9503692b$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $d4f8bf939aa0eef9$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $cbaefd650df3ac32$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $5d096275a512c93f$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $cbaefd650df3ac32$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $8006606f9503692b$var$noop,
                getControllerId: getControllerId || $8006606f9503692b$var$noop
            },
            children: /*#__PURE__*/ (0, $kSbwP.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$8006606f9503692b$var$Nav.displayName = 'Nav';
var $8006606f9503692b$export$2e2bcd8739ae039 = Object.assign($8006606f9503692b$var$Nav, {
    Item: (0, $3a97e452d7d2ec76$export$2e2bcd8739ae039)
});




var $8nGP5 = parcelRequire("8nGP5");
"use client";
// TODO: check
const $5ca0f0a5fc06bd35$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$5ca0f0a5fc06bd35$var$context.displayName = 'NavbarContext';
var $5ca0f0a5fc06bd35$export$2e2bcd8739ae039 = $5ca0f0a5fc06bd35$var$context;



var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $185b5fee6989fec7$var$context = /*#__PURE__*/ $8nGP5.createContext(null);
$185b5fee6989fec7$var$context.displayName = 'CardHeaderContext';
var $185b5fee6989fec7$export$2e2bcd8739ae039 = $185b5fee6989fec7$var$context;



var $8nGP5 = parcelRequire("8nGP5");



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $29942bfbbe8b095e$var$NavItem = /*#__PURE__*/ $8nGP5.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$29942bfbbe8b095e$var$NavItem.displayName = 'NavItem';
var $29942bfbbe8b095e$export$2e2bcd8739ae039 = $29942bfbbe8b095e$var$NavItem;




var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
function $40d7663930fda29e$export$2e2bcd8739ae039() {
    return (0, $8nGP5.useState)(null);
}





var $8nGP5 = parcelRequire("8nGP5");

function $ddb328620523d7d4$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)(listener);
    (0, $8nGP5.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $8nGP5 = parcelRequire("8nGP5");
function $c2311523b6c9392f$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $8nGP5.useCallback)(()=>document, []);
    return (0, $ddb328620523d7d4$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $8nGP5 = parcelRequire("8nGP5");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $1702086ddd03cbf5$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $8nGP5.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $1702086ddd03cbf5$export$2e2bcd8739ae039 = $1702086ddd03cbf5$var$useInterval;



var $8nGP5 = parcelRequire("8nGP5");

function $1cd9a130e8e0cb0f$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $9e2b25d42636a35a$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $8nGP5.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $1cd9a130e8e0cb0f$export$2e2bcd8739ae039 = $1cd9a130e8e0cb0f$var$useRafInterval;



var $8nGP5 = parcelRequire("8nGP5");
function $a0f38e4341df4339$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $8nGP5.useState)(initialState);
    const updater = (0, $8nGP5.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $3a783e1604888c03$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $a0f38e4341df4339$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}



var $8nGP5 = parcelRequire("8nGP5");
function $3c50a1c9e4ee53df$export$2e2bcd8739ae039() {
    const mounted = (0, $8nGP5.useRef)(true);
    const isMounted = (0, $8nGP5.useRef)(()=>mounted.current);
    (0, $8nGP5.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $8nGP5 = parcelRequire("8nGP5");
function $1cfe1a1d2e5bf439$export$2e2bcd8739ae039(value) {
    const ref = (0, $8nGP5.useRef)(null);
    (0, $8nGP5.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $8nGP5 = parcelRequire("8nGP5");
function $73aaedc5fcd628d4$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $8nGP5.useState)({
        image: null,
        error: null
    });
    (0, $8nGP5.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
const $29dbdd8a46c7ba41$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $29dbdd8a46c7ba41$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $29dbdd8a46c7ba41$export$2e2bcd8739ae039 = $29dbdd8a46c7ba41$var$isDOM || $29dbdd8a46c7ba41$var$isReactNative ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);


const $928b453020f54ed5$var$targetMap = new WeakMap();
let $928b453020f54ed5$var$resizeObserver;
function $928b453020f54ed5$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $928b453020f54ed5$var$resizeObserver = $928b453020f54ed5$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $928b453020f54ed5$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $928b453020f54ed5$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $8nGP5.useState)(null);
    (0, $29dbdd8a46c7ba41$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $928b453020f54ed5$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $928b453020f54ed5$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $928b453020f54ed5$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






var $kSbwP = parcelRequire("kSbwP");
const $e983e97d68a5be8f$var$_excluded = [
    "onKeyDown"
];
function $e983e97d68a5be8f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $e983e97d68a5be8f$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $e983e97d68a5be8f$var$Anchor = /*#__PURE__*/ $8nGP5.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $e983e97d68a5be8f$var$_objectWithoutPropertiesLoose(_ref, $e983e97d68a5be8f$var$_excluded);
    const [buttonProps] = (0, $a4ab631a1be079fe$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $000fcb6676031dc3$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($e983e97d68a5be8f$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $kSbwP.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $kSbwP.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$e983e97d68a5be8f$var$Anchor.displayName = 'Anchor';
var $e983e97d68a5be8f$export$2e2bcd8739ae039 = $e983e97d68a5be8f$var$Anchor;






var $kSbwP = parcelRequire("kSbwP");
"use client";
const $4cc20ca706eae48f$var$NavLink = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $e983e97d68a5be8f$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $3a97e452d7d2ec76$export$d7a68693710982a)({
        key: (0, $cbaefd650df3ac32$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$4cc20ca706eae48f$var$NavLink.displayName = 'NavLink';
var $4cc20ca706eae48f$export$2e2bcd8739ae039 = $4cc20ca706eae48f$var$NavLink;



var $kSbwP = parcelRequire("kSbwP");
"use client";
const $6ec05b3671c836b5$var$Nav = /*#__PURE__*/ $8nGP5.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $73f69c1bcfac1e92$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $8nGP5.useContext)((0, $5ca0f0a5fc06bd35$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $8nGP5.useContext)((0, $185b5fee6989fec7$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $8006606f9503692b$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$6ec05b3671c836b5$var$Nav.displayName = 'Nav';
var $6ec05b3671c836b5$export$2e2bcd8739ae039 = Object.assign($6ec05b3671c836b5$var$Nav, {
    Item: (0, $29942bfbbe8b095e$export$2e2bcd8739ae039),
    Link: (0, $4cc20ca706eae48f$export$2e2bcd8739ae039)
});









var $kSbwP = parcelRequire("kSbwP");
function $3f748ec55388f444$var$getDefaultActiveKey(children) {
    let defaultActiveKey;
    (0, $311c500c8155d408$export$4b80e395e36b5a56)(children, (child)=>{
        if (defaultActiveKey == null) defaultActiveKey = child.props.eventKey;
    });
    return defaultActiveKey;
}
function $3f748ec55388f444$var$renderTab(child) {
    const { title: title, eventKey: eventKey, disabled: disabled, tabClassName: tabClassName, tabAttrs: tabAttrs, id: id } = child.props;
    if (title == null) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $29942bfbbe8b095e$export$2e2bcd8739ae039), {
        as: "li",
        role: "presentation",
        children: /*#__PURE__*/ (0, $kSbwP.jsx)((0, $4cc20ca706eae48f$export$2e2bcd8739ae039), {
            as: "button",
            type: "button",
            eventKey: eventKey,
            disabled: disabled,
            id: id,
            className: tabClassName,
            ...tabAttrs,
            children: title
        })
    });
}
const $3f748ec55388f444$var$Tabs = (props)=>{
    const { id: id, onSelect: onSelect, transition: transition, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, variant: variant = 'tabs', children: children, activeKey: activeKey = $3f748ec55388f444$var$getDefaultActiveKey(children), ...controlledProps } = (0, $73f69c1bcfac1e92$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    return /*#__PURE__*/ (0, $kSbwP.jsxs)((0, $ac0f962e18ce3dc9$export$2e2bcd8739ae039), {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        transition: (0, $b8607d60984ad6be$export$2e2bcd8739ae039)(transition),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        children: [
            /*#__PURE__*/ (0, $kSbwP.jsx)((0, $6ec05b3671c836b5$export$2e2bcd8739ae039), {
                id: id,
                ...controlledProps,
                role: "tablist",
                as: "ul",
                variant: variant,
                children: (0, $311c500c8155d408$export$871de8747c9eaa88)(children, $3f748ec55388f444$var$renderTab)
            }),
            /*#__PURE__*/ (0, $kSbwP.jsx)((0, $9e7ab869134c26e6$export$2e2bcd8739ae039), {
                children: (0, $311c500c8155d408$export$871de8747c9eaa88)(children, (child)=>{
                    const childProps = {
                        ...child.props
                    };
                    delete childProps.title;
                    delete childProps.disabled;
                    delete childProps.tabClassName;
                    delete childProps.tabAttrs;
                    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $16b24ee68adceda0$export$2e2bcd8739ae039), {
                        ...childProps
                    });
                })
            })
        ]
    });
};
$3f748ec55388f444$var$Tabs.displayName = 'Tabs';
var $3f748ec55388f444$export$2e2bcd8739ae039 = $3f748ec55388f444$var$Tabs;




var $kSbwP = parcelRequire("kSbwP");


var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");











var $3e24f02855c82492$export$40a9eeef55665a40;
var $3e24f02855c82492$export$93b7586d956c930e;
var $3e24f02855c82492$export$f843afa9e9b53052;
var $3e24f02855c82492$export$637f169d296cfe12;
var $3e24f02855c82492$export$ae78d338ad66ff90;
var $3e24f02855c82492$export$b8972b998723d602;
var $3e24f02855c82492$export$a59643d115b68bf0;
$3e24f02855c82492$export$40a9eeef55665a40 = `aLngCa_defaultPadding`;
$3e24f02855c82492$export$93b7586d956c930e = `aLngCa_dropShadow`;
$3e24f02855c82492$export$f843afa9e9b53052 = `aLngCa_panelImage`;
$3e24f02855c82492$export$637f169d296cfe12 = `aLngCa_panelTableStyle`;
$3e24f02855c82492$export$ae78d338ad66ff90 = `aLngCa_scaleInOut`;
$3e24f02855c82492$export$b8972b998723d602 = `aLngCa_shadow`;
$3e24f02855c82492$export$a59643d115b68bf0 = `aLngCa_uploadButton`;




var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $5fd6bce20ab8481b$export$a3579ca508007a95 = (0, $8nGP5.createContext)({});



var $8nGP5 = parcelRequire("8nGP5");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $173f963c4101a343$export$fe4300aa8eebea86(init) {
    const ref = (0, $8nGP5.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



var $8nGP5 = parcelRequire("8nGP5");
const $1f64697a60450b0a$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $e1fc7471256e233e$export$700979bc83e7db82 = (0, $1f64697a60450b0a$export$4e09c449d6c407f7) ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect);



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * @public
 */ const $116d068e4cc320bc$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $8nGP5.createContext)(null);




var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * @public
 */ const $eee49e6284984f1d$export$22a697fb29aac98d = (0, $8nGP5.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});


"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $7a391a8463dd57d1$var$PopChildMeasure extends $8nGP5.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = parent instanceof HTMLElement ? parent.offsetWidth || 0 : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $7a391a8463dd57d1$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent, anchorX: anchorX }) {
    const id = (0, $8nGP5.useId)();
    const ref = (0, $8nGP5.useRef)(null);
    const size = (0, $8nGP5.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0
    });
    const { nonce: nonce } = (0, $8nGP5.useContext)((0, $eee49e6284984f1d$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $8nGP5.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left, right: right } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $kSbwP.jsx)($7a391a8463dd57d1$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $8nGP5.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $5033dd163dd67488$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, anchorX: anchorX })=>{
    const presenceChildren = (0, $173f963c4101a343$export$fe4300aa8eebea86)($5033dd163dd67488$var$newChildrenMap);
    const id = (0, $8nGP5.useId)();
    let isReusedContext = true;
    let context = (0, $8nGP5.useMemo)(()=>{
        isReusedContext = false;
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, $8nGP5.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $8nGP5.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $kSbwP.jsx)((0, $7a391a8463dd57d1$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        anchorX: anchorX,
        children: children
    });
    return (0, $kSbwP.jsx)((0, $116d068e4cc320bc$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $5033dd163dd67488$var$newChildrenMap() {
    return new Map();
}



var $8nGP5 = parcelRequire("8nGP5");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $dc40494ff9a8b7a9$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $8nGP5.useContext)((0, $116d068e4cc320bc$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $8nGP5.useId)();
    (0, $8nGP5.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $8nGP5.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $dc40494ff9a8b7a9$export$8249053f690ea39a() {
    return $dc40494ff9a8b7a9$export$ee27c052bca048fb((0, $8nGP5.useContext)((0, $116d068e4cc320bc$export$f224e4635b6f8ce2)));
}
function $dc40494ff9a8b7a9$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $8nGP5 = parcelRequire("8nGP5");
const $2b4f9cc0a7c175f2$export$10e61aed958678dd = (child)=>child.key || "";
function $2b4f9cc0a7c175f2$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $8nGP5.Children).forEach(children, (child)=>{
        if ((0, $8nGP5.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}


"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $8c0877f2b5fef61a$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false, anchorX: anchorX = "left" })=>{
    const [isParentPresent, safeToRemove] = (0, $dc40494ff9a8b7a9$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $8nGP5.useMemo)(()=>(0, $2b4f9cc0a7c175f2$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $2b4f9cc0a7c175f2$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $8nGP5.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $8nGP5.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $173f963c4101a343$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $8nGP5.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $8nGP5.useState)(presentChildren);
    (0, $e1fc7471256e233e$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $2b4f9cc0a7c175f2$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $2b4f9cc0a7c175f2$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $2b4f9cc0a7c175f2$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $8nGP5.useContext)((0, $5fd6bce20ab8481b$export$a3579ca508007a95));
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $2b4f9cc0a7c175f2$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $kSbwP.jsx)((0, $5033dd163dd67488$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                children: child
            }, key);
        })
    });
};


function $43e685181e025aa9$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $c78c33232f79d0d9$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


function $c2c6204d0ae4aa0a$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $c2c6204d0ae4aa0a$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $c2c6204d0ae4aa0a$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $c2c6204d0ae4aa0a$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $386a8e57946ac738$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $c2c6204d0ae4aa0a$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $d81090ce8560095d$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};



const $e1f6de081aeddd99$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $ab3abf8b1c748625$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $7d580dc6ed4dd47b$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) (0, $ab3abf8b1c748625$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $205c15274ccbb78b$export$dd826089e3c5e502 = {};


const $557d29fbf3060c74$var$maxElapsed = 40;
function $557d29fbf3060c74$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $e1f6de081aeddd99$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $7d580dc6ed4dd47b$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $205c15274ccbb78b$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!(0, $205c15274ccbb78b$export$dd826089e3c5e502).useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $557d29fbf3060c74$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $e1f6de081aeddd99$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $e1f6de081aeddd99$export$71ecace0a033b35a).length; i++)steps[(0, $e1f6de081aeddd99$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


/*#__NO_SIDE_EFFECTS__*/ const $3db7f0ca4f9c6429$export$8793edee2d425525 = (any)=>any;


const { schedule: $243866cd891e9f65$export$2cef06c20297c17d, cancel: $243866cd891e9f65$export$ec99c0ef4978dccb, state: $243866cd891e9f65$export$fff89137e9e818ce, steps: $243866cd891e9f65$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $557d29fbf3060c74$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $3db7f0ca4f9c6429$export$8793edee2d425525), true);



let $30e8dc9fbee95a32$var$now;
function $30e8dc9fbee95a32$var$clearTime() {
    $30e8dc9fbee95a32$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $30e8dc9fbee95a32$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($30e8dc9fbee95a32$var$now === undefined) $30e8dc9fbee95a32$export$2da9be4cfdb689b1.set((0, $243866cd891e9f65$export$fff89137e9e818ce).isProcessing || (0, $205c15274ccbb78b$export$dd826089e3c5e502).useManualTiming ? (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp : performance.now());
        return $30e8dc9fbee95a32$var$now;
    },
    set: (newTime)=>{
        $30e8dc9fbee95a32$var$now = newTime;
        queueMicrotask($30e8dc9fbee95a32$var$clearTime);
    }
};




function $df60b7a96ed79066$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $df60b7a96ed79066$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $df60b7a96ed79066$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $821f935f0c9e9c61$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $df60b7a96ed79066$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $df60b7a96ed79066$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $e62765a263b9a41a$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $3ddfebdc70564ee7$var$MAX_VELOCITY_DELTA = 30;
const $3ddfebdc70564ee7$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $3ddfebdc70564ee7$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $3ddfebdc70564ee7$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "12.8.0";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $3ddfebdc70564ee7$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $821f935f0c9e9c61$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $243866cd891e9f65$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (v === "none") console.trace();
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($3ddfebdc70564ee7$export$67fcd818a264039d.current) $3ddfebdc70564ee7$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $3ddfebdc70564ee7$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $3ddfebdc70564ee7$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $e62765a263b9a41a$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $3ddfebdc70564ee7$export$ce8bdc721e76545f(init, options) {
    return new $3ddfebdc70564ee7$export$8cea36d14ee64562(init, options);
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $ab70fdf7798ce9cf$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $3ddfebdc70564ee7$export$ce8bdc721e76545f)(value));
}
function $ab70fdf7798ce9cf$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $d81090ce8560095d$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $ab70fdf7798ce9cf$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $386a8e57946ac738$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = $ab70fdf7798ce9cf$var$resolveFinalValueInKeyframes(target[key]);
        $ab70fdf7798ce9cf$var$setMotionValue(visualElement, key, value);
    }
}


const $b5f9d7313c47a627$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $795a3562483d8acb$export$98397f3adbf6259f(value) {
    return Boolean((0, $b5f9d7313c47a627$export$605d60a2578142d3)(value) && value.add);
}



function $fdf49ce736d2cd40$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $795a3562483d8acb$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $205c15274ccbb78b$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $205c15274ccbb78b$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}


/**
 * Convert camelCase to dash-case properties.
 */ const $a94a49baeb171c48$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $6c9374e3d96babcd$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6c9374e3d96babcd$export$8592e1c077c890a6 = "data-" + (0, $a94a49baeb171c48$export$9fd24a634729c672)($6c9374e3d96babcd$export$ed7b8fa9dbf0105d);


function $e607e453dd1538e8$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $6c9374e3d96babcd$export$8592e1c077c890a6];
}


const $69106a7efe290bd4$var$isNotNull = (value)=>value !== null;
function $69106a7efe290bd4$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($69106a7efe290bd4$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


/**
 * Generate a list of every possible transform key.
 */ const $7214a84e3a9c6096$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $7214a84e3a9c6096$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set($7214a84e3a9c6096$export$280dc01950909d86))();


const $7d9dd5cbb990aaec$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $7d9dd5cbb990aaec$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $7d9dd5cbb990aaec$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $7d9dd5cbb990aaec$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $7d9dd5cbb990aaec$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $7d9dd5cbb990aaec$var$keyframesTransition;
    else if ((0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $7d9dd5cbb990aaec$var$criticallyDampedSpring(keyframes[1]) : $7d9dd5cbb990aaec$var$underDampedSpring;
    return $7d9dd5cbb990aaec$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $5d190a348f6f4e3f$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


function $57872364f552b303$export$7c1391340308742e(transition, key) {
    return transition?.[key] ?? transition?.["default"] ?? transition;
}


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $607e4cfbb9883683$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $607e4cfbb9883683$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;






const $d4f1f56e5e1f84a3$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};


const $e825571289930f38$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $e825571289930f38$export$9de1236619d9e756 = /*@__PURE__*/ $e825571289930f38$var$checkStringStartsWith("--");
const $e825571289930f38$var$startsAsVariableToken = /*@__PURE__*/ $e825571289930f38$var$checkStringStartsWith("var(--");
const $e825571289930f38$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $e825571289930f38$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $e825571289930f38$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $e825571289930f38$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


const $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $80084dd05e454f7b$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $80084dd05e454f7b$export$58f0f39f63f3cf42 = {
    ...$80084dd05e454f7b$export$98e628dec113755e,
    transform: (v)=>(0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $80084dd05e454f7b$export$dcdf75081b88279d = {
    ...$80084dd05e454f7b$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $b11366e88f4d772a$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $e356e07a1bd40070$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $32a2b0e07cfb2369$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $b4c042b22c64e3f3$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $f6f3d74f6bb10c44$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $b4c042b22c64e3f3$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $32a2b0e07cfb2369$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $f6f3d74f6bb10c44$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $e356e07a1bd40070$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };



const $370d68247cff6cec$var$clampRgbUnit = (v)=>(0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0, 255, v);
const $370d68247cff6cec$export$7a99c86b5b1f4c9e = {
    ...(0, $80084dd05e454f7b$export$98e628dec113755e),
    transform: (v)=>Math.round($370d68247cff6cec$var$clampRgbUnit(v))
};
const $370d68247cff6cec$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $f6f3d74f6bb10c44$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $f6f3d74f6bb10c44$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $370d68247cff6cec$export$7a99c86b5b1f4c9e.transform(red) + ", " + $370d68247cff6cec$export$7a99c86b5b1f4c9e.transform(green) + ", " + $370d68247cff6cec$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $b11366e88f4d772a$export$83d2e9e3e4ee39ed)((0, $80084dd05e454f7b$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $ff445fc4c28651ee$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $ff445fc4c28651ee$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $f6f3d74f6bb10c44$export$2c8400d58aca05e)("#"),
    parse: $ff445fc4c28651ee$var$parseHex,
    transform: (0, $370d68247cff6cec$export$4e46ac54fc82cf3b).transform
};



/*#__NO_SIDE_EFFECTS__*/ const $5a6c0a76edf006ab$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $5a6c0a76edf006ab$export$41fc368e1a942b97 = /*@__PURE__*/ $5a6c0a76edf006ab$var$createUnitType("deg");
const $5a6c0a76edf006ab$export$626336c2cd4b14de = /*@__PURE__*/ $5a6c0a76edf006ab$var$createUnitType("%");
const $5a6c0a76edf006ab$export$91c0eda1d06bf008 = /*@__PURE__*/ $5a6c0a76edf006ab$var$createUnitType("px");
const $5a6c0a76edf006ab$export$f91e8c45a95a32f2 = /*@__PURE__*/ $5a6c0a76edf006ab$var$createUnitType("vh");
const $5a6c0a76edf006ab$export$aed3d7b7d206c196 = /*@__PURE__*/ $5a6c0a76edf006ab$var$createUnitType("vw");
const $5a6c0a76edf006ab$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>({
        ...$5a6c0a76edf006ab$export$626336c2cd4b14de,
        parse: (v)=>$5a6c0a76edf006ab$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$5a6c0a76edf006ab$export$626336c2cd4b14de.transform(v * 100)
    }))();




const $d50271a4407efb85$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $f6f3d74f6bb10c44$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $f6f3d74f6bb10c44$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $5a6c0a76edf006ab$export$626336c2cd4b14de).transform((0, $b11366e88f4d772a$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $5a6c0a76edf006ab$export$626336c2cd4b14de).transform((0, $b11366e88f4d772a$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $b11366e88f4d772a$export$83d2e9e3e4ee39ed)((0, $80084dd05e454f7b$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $9ec208d2140f13cc$export$35e9368ef982300f = {
    test: (v)=>(0, $370d68247cff6cec$export$4e46ac54fc82cf3b).test(v) || (0, $ff445fc4c28651ee$export$834dfc94dde4b3d8).test(v) || (0, $d50271a4407efb85$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $370d68247cff6cec$export$4e46ac54fc82cf3b).test(v)) return (0, $370d68247cff6cec$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $d50271a4407efb85$export$810b04175080204c).test(v)) return (0, $d50271a4407efb85$export$810b04175080204c).parse(v);
        else return (0, $ff445fc4c28651ee$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $370d68247cff6cec$export$4e46ac54fc82cf3b).transform(v) : (0, $d50271a4407efb85$export$810b04175080204c).transform(v);
    }
};



const $12b83bac28ffbea5$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $977cb6dd165f3ea4$var$test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, $e356e07a1bd40070$export$2444ca58c08448e4))?.length || 0) + (v.match((0, $12b83bac28ffbea5$export$740b69c5fad25dba))?.length || 0) > 0;
}
const $977cb6dd165f3ea4$var$NUMBER_TOKEN = "number";
const $977cb6dd165f3ea4$var$COLOR_TOKEN = "color";
const $977cb6dd165f3ea4$var$VAR_TOKEN = "var";
const $977cb6dd165f3ea4$var$VAR_FUNCTION_TOKEN = "var(";
const $977cb6dd165f3ea4$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $977cb6dd165f3ea4$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $977cb6dd165f3ea4$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($977cb6dd165f3ea4$var$complexRegex, (parsedValue)=>{
        if ((0, $9ec208d2140f13cc$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($977cb6dd165f3ea4$var$COLOR_TOKEN);
            values.push((0, $9ec208d2140f13cc$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($977cb6dd165f3ea4$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($977cb6dd165f3ea4$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($977cb6dd165f3ea4$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $977cb6dd165f3ea4$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($977cb6dd165f3ea4$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $977cb6dd165f3ea4$var$parseComplexValue(v) {
    return $977cb6dd165f3ea4$export$b61fc7c44bf646d5(v).values;
}
function $977cb6dd165f3ea4$var$createTransformer(source) {
    const { split: split, types: types } = $977cb6dd165f3ea4$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $977cb6dd165f3ea4$var$NUMBER_TOKEN) output += (0, $b11366e88f4d772a$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $977cb6dd165f3ea4$var$COLOR_TOKEN) output += (0, $9ec208d2140f13cc$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $977cb6dd165f3ea4$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $977cb6dd165f3ea4$var$getAnimatableNone(v) {
    const parsed = $977cb6dd165f3ea4$var$parseComplexValue(v);
    const transformer = $977cb6dd165f3ea4$var$createTransformer(v);
    return transformer(parsed.map($977cb6dd165f3ea4$var$convertNumbersToZero));
}
const $977cb6dd165f3ea4$export$83a0e34f1302825b = {
    test: $977cb6dd165f3ea4$var$test,
    parse: $977cb6dd165f3ea4$var$parseComplexValue,
    createTransformer: $977cb6dd165f3ea4$var$createTransformer,
    getAnimatableNone: $977cb6dd165f3ea4$var$getAnimatableNone
};




// Adapted from https://gist.github.com/mjackson/5311256
function $495e408f9848f2a9$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $495e408f9848f2a9$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $495e408f9848f2a9$var$hueToRgb(p, q, hue + 1 / 3);
        green = $495e408f9848f2a9$var$hueToRgb(p, q, hue);
        blue = $495e408f9848f2a9$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $5a61e7200cc88d22$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


let $5b4e90778a3057f7$export$491112666e282270 = ()=>{};
let $5b4e90778a3057f7$export$f5708dca728d7177 = ()=>{};
var $5b4e90778a3057f7$var$check, $5b4e90778a3057f7$var$message, $5b4e90778a3057f7$var$check1, $5b4e90778a3057f7$var$message1;


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $5d6ba8cc3db77b06$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $5d6ba8cc3db77b06$var$colorTypes = [
    (0, $ff445fc4c28651ee$export$834dfc94dde4b3d8),
    (0, $370d68247cff6cec$export$4e46ac54fc82cf3b),
    (0, $d50271a4407efb85$export$810b04175080204c)
];
const $5d6ba8cc3db77b06$var$getColorType = (v)=>$5d6ba8cc3db77b06$var$colorTypes.find((type)=>type.test(v));
function $5d6ba8cc3db77b06$var$asRGBA(color) {
    const type = $5d6ba8cc3db77b06$var$getColorType(color);
    (0, $5b4e90778a3057f7$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $d50271a4407efb85$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $495e408f9848f2a9$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $5d6ba8cc3db77b06$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $5d6ba8cc3db77b06$var$asRGBA(from);
    const toRGBA = $5d6ba8cc3db77b06$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $5a61e7200cc88d22$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $5d6ba8cc3db77b06$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $5d6ba8cc3db77b06$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $5d6ba8cc3db77b06$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $370d68247cff6cec$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $b1b7b52f714f8a1b$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $b1b7b52f714f8a1b$export$fed62ccc3fb1a568(origin, target) {
    if ($b1b7b52f714f8a1b$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $539b32b750ab60bb$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $539b32b750ab60bb$export$a4627e546088548d = (...transformers)=>transformers.reduce($539b32b750ab60bb$var$combineFunctions);



function $09bb25ea71bde361$var$mixNumber(a, b) {
    return (p)=>(0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $09bb25ea71bde361$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $09bb25ea71bde361$var$mixNumber;
    else if (typeof a === "string") return (0, $e825571289930f38$export$31f9caa2600b5723)(a) ? (0, $5a61e7200cc88d22$export$a6f92d4bae65c0f1) : (0, $9ec208d2140f13cc$export$35e9368ef982300f).test(a) ? (0, $5d6ba8cc3db77b06$export$51e568cf5c039bac) : $09bb25ea71bde361$export$65516310a87d8205;
    else if (Array.isArray(a)) return $09bb25ea71bde361$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $9ec208d2140f13cc$export$35e9368ef982300f).test(a) ? (0, $5d6ba8cc3db77b06$export$51e568cf5c039bac) : $09bb25ea71bde361$export$ebc23b6840c51ba1;
    return 0, $5a61e7200cc88d22$export$a6f92d4bae65c0f1;
}
function $09bb25ea71bde361$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$09bb25ea71bde361$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $09bb25ea71bde361$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $09bb25ea71bde361$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $09bb25ea71bde361$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $09bb25ea71bde361$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $977cb6dd165f3ea4$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $977cb6dd165f3ea4$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $977cb6dd165f3ea4$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $b1b7b52f714f8a1b$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $b1b7b52f714f8a1b$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $b1b7b52f714f8a1b$export$fed62ccc3fb1a568)(origin, target);
        return (0, $539b32b750ab60bb$export$a4627e546088548d)($09bb25ea71bde361$export$3bbefa2f402845c4($09bb25ea71bde361$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $5b4e90778a3057f7$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $5a61e7200cc88d22$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $81c4cea109d2bbbe$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $09bb25ea71bde361$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $743866394125d059$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $243866cd891e9f65$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $243866cd891e9f65$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $243866cd891e9f65$export$fff89137e9e818ce).isProcessing ? (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp : (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now()
    };
};


const $a630665f53333869$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing(i / (numPoints - 1)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $f9aeb67994bbe7f9$export$f4ff70a5b4808fd8 = 20000;
function $f9aeb67994bbe7f9$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $f9aeb67994bbe7f9$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $f9aeb67994bbe7f9$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $38b87a2943795b76$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $f9aeb67994bbe7f9$export$cbdd6b3d40ea54e2)(generator), (0, $f9aeb67994bbe7f9$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(duration)
    };
}



const $9a8680ab35d60ada$var$velocitySampleDuration = 5; // ms
function $9a8680ab35d60ada$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $9a8680ab35d60ada$var$velocitySampleDuration, 0);
    return (0, $e62765a263b9a41a$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $2e2a278a32c7df48$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};






const $18baa9f144a33c5f$var$safeMin = 0.001;
function $18baa9f144a33c5f$export$b15f158dc6d6f458({ duration: duration = (0, $2e2a278a32c7df48$export$86436497e7b05d16).duration, bounce: bounce = (0, $2e2a278a32c7df48$export$86436497e7b05d16).bounce, velocity: velocity = (0, $2e2a278a32c7df48$export$86436497e7b05d16).velocity, mass: mass = (0, $2e2a278a32c7df48$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $5b4e90778a3057f7$export$491112666e282270)(duration <= (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)((0, $2e2a278a32c7df48$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)((0, $2e2a278a32c7df48$export$86436497e7b05d16).minDamping, (0, $2e2a278a32c7df48$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)((0, $2e2a278a32c7df48$export$86436497e7b05d16).minDuration, (0, $2e2a278a32c7df48$export$86436497e7b05d16).maxDuration, (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $18baa9f144a33c5f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $18baa9f144a33c5f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $18baa9f144a33c5f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $18baa9f144a33c5f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$18baa9f144a33c5f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $18baa9f144a33c5f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $2e2a278a32c7df48$export$86436497e7b05d16).stiffness,
        damping: (0, $2e2a278a32c7df48$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $18baa9f144a33c5f$var$rootIterations = 12;
function $18baa9f144a33c5f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $18baa9f144a33c5f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $18baa9f144a33c5f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}




const $f499a9e0d8a0e4f2$var$durationKeys = [
    "duration",
    "bounce"
];
const $f499a9e0d8a0e4f2$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $f499a9e0d8a0e4f2$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $f499a9e0d8a0e4f2$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $2e2a278a32c7df48$export$86436497e7b05d16).velocity,
        stiffness: (0, $2e2a278a32c7df48$export$86436497e7b05d16).stiffness,
        damping: (0, $2e2a278a32c7df48$export$86436497e7b05d16).damping,
        mass: (0, $2e2a278a32c7df48$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$f499a9e0d8a0e4f2$var$isSpringType(options, $f499a9e0d8a0e4f2$var$physicsKeys) && $f499a9e0d8a0e4f2$var$isSpringType(options, $f499a9e0d8a0e4f2$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $2e2a278a32c7df48$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $18baa9f144a33c5f$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $2e2a278a32c7df48$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $f499a9e0d8a0e4f2$export$b36281d89752ae66(optionsOrVisualDuration = (0, $2e2a278a32c7df48$export$86436497e7b05d16).visualDuration, bounce = (0, $2e2a278a32c7df48$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $f499a9e0d8a0e4f2$var$getSpringOptions({
        ...options,
        velocity: -(0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $2e2a278a32c7df48$export$86436497e7b05d16).restSpeed.granular : (0, $2e2a278a32c7df48$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $2e2a278a32c7df48$export$86436497e7b05d16).restDelta.granular : (0, $2e2a278a32c7df48$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $18baa9f144a33c5f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = t === 0 ? initialVelocity : 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $9a8680ab35d60ada$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $f9aeb67994bbe7f9$export$cbdd6b3d40ea54e2)(generator), (0, $f9aeb67994bbe7f9$export$f4ff70a5b4808fd8));
            const easing = (0, $a630665f53333869$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$f499a9e0d8a0e4f2$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $38b87a2943795b76$export$7f1511d09ee75a99)(options, 100, $f499a9e0d8a0e4f2$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



function $1d1a582201a2bed6$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $f499a9e0d8a0e4f2$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $9a8680ab35d60ada$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}








/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $2f435633a42d941c$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


function $be747c978f3d9923$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $205c15274ccbb78b$export$dd826089e3c5e502).mix || (0, $81c4cea109d2bbbe$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $3db7f0ca4f9c6429$export$8793edee2d425525) : ease;
            mixer = (0, $539b32b750ab60bb$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $be747c978f3d9923$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $5b4e90778a3057f7$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $be747c978f3d9923$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $2f435633a42d941c$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $e60b574325d8481a$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $2f435633a42d941c$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $f2eee1a07738c1ee$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $e60b574325d8481a$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $bcf635245dcdfd58$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $f47b858d165a3763$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $f47b858d165a3763$var$subdivisionPrecision = 0.0000001;
const $f47b858d165a3763$var$subdivisionMaxIterations = 12;
function $f47b858d165a3763$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $f47b858d165a3763$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $f47b858d165a3763$var$subdivisionPrecision && ++i < $f47b858d165a3763$var$subdivisionMaxIterations);
    return currentT;
}
function $f47b858d165a3763$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $3db7f0ca4f9c6429$export$8793edee2d425525;
    const getTForX = (aX)=>$f47b858d165a3763$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $f47b858d165a3763$var$calcBezier(getTForX(t), mY1, mY2);
}


const $2ec239404dddfca7$export$929e5a82286172a6 = /*@__PURE__*/ (0, $f47b858d165a3763$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $2ec239404dddfca7$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $f47b858d165a3763$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $2ec239404dddfca7$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $f47b858d165a3763$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $f67a294157cf8483$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};





// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $d8c6e93346b719ac$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $3932ece6080e7c96$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $461c43baa1cf6cc9$export$77edfce482316a60 = /*@__PURE__*/ (0, $f47b858d165a3763$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $461c43baa1cf6cc9$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $3932ece6080e7c96$export$2c07eeff45156d4d)($461c43baa1cf6cc9$export$77edfce482316a60);
const $461c43baa1cf6cc9$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $d8c6e93346b719ac$export$f946554fb8aeaf0d)($461c43baa1cf6cc9$export$b01116c84cdfe1a2);


const $34280f1dd970722b$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $461c43baa1cf6cc9$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $c72c6700cb8b11f8$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $c72c6700cb8b11f8$export$c8d67a19199d1a50 = (0, $3932ece6080e7c96$export$2c07eeff45156d4d)($c72c6700cb8b11f8$export$e444123e42d03385);
const $c72c6700cb8b11f8$export$30d3455eee55bed5 = (0, $d8c6e93346b719ac$export$f946554fb8aeaf0d)($c72c6700cb8b11f8$export$e444123e42d03385);




const $fac733df141b8130$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


const $a324d089b9f71510$var$easingLookup = {
    linear: (0, $3db7f0ca4f9c6429$export$8793edee2d425525),
    easeIn: $2ec239404dddfca7$export$929e5a82286172a6,
    easeInOut: $2ec239404dddfca7$export$c07234257a03d5e9,
    easeOut: $2ec239404dddfca7$export$57636bb43b1ccbb0,
    circIn: $c72c6700cb8b11f8$export$e444123e42d03385,
    circInOut: $c72c6700cb8b11f8$export$30d3455eee55bed5,
    circOut: $c72c6700cb8b11f8$export$c8d67a19199d1a50,
    backIn: $461c43baa1cf6cc9$export$b01116c84cdfe1a2,
    backInOut: $461c43baa1cf6cc9$export$ddc5fd596f6c71b2,
    backOut: $461c43baa1cf6cc9$export$77edfce482316a60,
    anticipate: $34280f1dd970722b$export$6b0af63b873d419e
};
const $a324d089b9f71510$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $a324d089b9f71510$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $fac733df141b8130$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $5b4e90778a3057f7$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $f47b858d165a3763$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($a324d089b9f71510$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $5b4e90778a3057f7$export$f5708dca728d7177)($a324d089b9f71510$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $a324d089b9f71510$var$easingLookup[definition];
    }
    return definition;
};


function $6eacf1e364d62bee$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2ec239404dddfca7$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $6eacf1e364d62bee$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $f67a294157cf8483$export$216948827bbdc797)(ease) ? ease.map((0, $a324d089b9f71510$export$ef97fe084f156ca4)) : (0, $a324d089b9f71510$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $bcf635245dcdfd58$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $f2eee1a07738c1ee$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $be747c978f3d9923$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $6eacf1e364d62bee$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



const $233833c137e29a60$var$isNotNull = (value)=>value !== null;
function $233833c137e29a60$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($233833c137e29a60$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}





const $5890c99307e4580e$var$transitionTypeMap = {
    decay: (0, $1d1a582201a2bed6$export$ee3ff3a17106998),
    inertia: $1d1a582201a2bed6$export$ee3ff3a17106998,
    tween: (0, $6eacf1e364d62bee$export$d25ddfdf17c3ad3e),
    keyframes: (0, $6eacf1e364d62bee$export$d25ddfdf17c3ad3e),
    spring: $f499a9e0d8a0e4f2$export$b36281d89752ae66
};
function $5890c99307e4580e$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $5890c99307e4580e$var$transitionTypeMap[transition.type];
}


class $9f6f25edeedcc618$export$655db786091c33e0 {
    constructor(){
        this.count = 0;
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this.count++;
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}






const $4dce88953cb82d5f$var$percentToProgress = (percent)=>percent / 100;
class $4dce88953cb82d5f$export$3394f837405475c7 extends (0, $9f6f25edeedcc618$export$655db786091c33e0) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now()) this.tick((0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options: options } = this;
        (0, $5890c99307e4580e$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $6eacf1e364d62bee$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $6eacf1e364d62bee$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $6eacf1e364d62bee$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $539b32b750ab60bb$export$a4627e546088548d)($4dce88953cb82d5f$var$percentToProgress, (0, $81c4cea109d2bbbe$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $f9aeb67994bbe7f9$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mixKeyframes) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $1d1a582201a2bed6$export$ee3ff3a17106998)) state.value = (0, $233833c137e29a60$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get time() {
        return (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        this.updateTime((0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now());
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver: driver = (0, $743866394125d059$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        return timeline.observe(this);
    }
}
// Legacy function support
function $4dce88953cb82d5f$export$ee9b76de7353d815(options) {
    return new $4dce88953cb82d5f$export$3394f837405475c7(options);
}



function $8b9dbb5f425b5d23$export$5a98a90409277f5a(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}


const $d588fe87ae6d0c90$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $d588fe87ae6d0c90$var$rotate = (v)=>{
    const angle = $d588fe87ae6d0c90$var$radToDeg(Math.atan2(v[1], v[0]));
    return $d588fe87ae6d0c90$var$rebaseAngle(angle);
};
const $d588fe87ae6d0c90$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $d588fe87ae6d0c90$var$rotate,
    rotateZ: $d588fe87ae6d0c90$var$rotate,
    skewX: (v)=>$d588fe87ae6d0c90$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$d588fe87ae6d0c90$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $d588fe87ae6d0c90$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $d588fe87ae6d0c90$var$rotateZ = $d588fe87ae6d0c90$var$rotate;
const $d588fe87ae6d0c90$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $d588fe87ae6d0c90$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $d588fe87ae6d0c90$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $d588fe87ae6d0c90$var$scaleX,
    scaleY: $d588fe87ae6d0c90$var$scaleY,
    scale: (v)=>($d588fe87ae6d0c90$var$scaleX(v) + $d588fe87ae6d0c90$var$scaleY(v)) / 2,
    rotateX: (v)=>$d588fe87ae6d0c90$var$rebaseAngle($d588fe87ae6d0c90$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$d588fe87ae6d0c90$var$rebaseAngle($d588fe87ae6d0c90$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $d588fe87ae6d0c90$var$rotateZ,
    rotate: $d588fe87ae6d0c90$var$rotateZ,
    skewX: (v)=>$d588fe87ae6d0c90$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$d588fe87ae6d0c90$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $d588fe87ae6d0c90$var$defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function $d588fe87ae6d0c90$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $d588fe87ae6d0c90$var$defaultTransformValue(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $d588fe87ae6d0c90$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = $d588fe87ae6d0c90$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $d588fe87ae6d0c90$var$defaultTransformValue(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($d588fe87ae6d0c90$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $d588fe87ae6d0c90$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $d588fe87ae6d0c90$export$f9111f9e16b73a26(transform, name);
};
function $d588fe87ae6d0c90$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}





const $568afda14de8ef11$export$8e5250d1aa9bf370 = (v)=>v === (0, $80084dd05e454f7b$export$98e628dec113755e) || v === (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008);
const $568afda14de8ef11$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $568afda14de8ef11$var$nonTranslationalTransformKeys = (0, $7214a84e3a9c6096$export$280dc01950909d86).filter((key)=>!$568afda14de8ef11$var$transformKeys.has(key));
function $568afda14de8ef11$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $568afda14de8ef11$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $568afda14de8ef11$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $d588fe87ae6d0c90$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $d588fe87ae6d0c90$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$568afda14de8ef11$export$781d46a8aa670d52.translateX = $568afda14de8ef11$export$781d46a8aa670d52.x;
$568afda14de8ef11$export$781d46a8aa670d52.translateY = $568afda14de8ef11$export$781d46a8aa670d52.y;



const $ccfd6437c1ea2b0b$var$toResolve = new Set();
let $ccfd6437c1ea2b0b$var$isScheduled = false;
let $ccfd6437c1ea2b0b$var$anyNeedsMeasurement = false;
let $ccfd6437c1ea2b0b$var$isForced = false;
function $ccfd6437c1ea2b0b$var$measureAllKeyframes() {
    if ($ccfd6437c1ea2b0b$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($ccfd6437c1ea2b0b$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $568afda14de8ef11$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $ccfd6437c1ea2b0b$var$anyNeedsMeasurement = false;
    $ccfd6437c1ea2b0b$var$isScheduled = false;
    $ccfd6437c1ea2b0b$var$toResolve.forEach((resolver)=>resolver.complete($ccfd6437c1ea2b0b$var$isForced));
    $ccfd6437c1ea2b0b$var$toResolve.clear();
}
function $ccfd6437c1ea2b0b$var$readAllKeyframes() {
    $ccfd6437c1ea2b0b$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $ccfd6437c1ea2b0b$var$anyNeedsMeasurement = true;
    });
}
function $ccfd6437c1ea2b0b$export$78b96d2a12593b05() {
    $ccfd6437c1ea2b0b$var$isForced = true;
    $ccfd6437c1ea2b0b$var$readAllKeyframes();
    $ccfd6437c1ea2b0b$var$measureAllKeyframes();
    $ccfd6437c1ea2b0b$var$isForced = false;
}
class $ccfd6437c1ea2b0b$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $ccfd6437c1ea2b0b$var$toResolve.add(this);
            if (!$ccfd6437c1ea2b0b$var$isScheduled) {
                $ccfd6437c1ea2b0b$var$isScheduled = true;
                (0, $243866cd891e9f65$export$2cef06c20297c17d).read($ccfd6437c1ea2b0b$var$readAllKeyframes);
                (0, $243866cd891e9f65$export$2cef06c20297c17d).resolveKeyframes($ccfd6437c1ea2b0b$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $8b9dbb5f425b5d23$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForced = false) {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForced);
        $ccfd6437c1ea2b0b$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $ccfd6437c1ea2b0b$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}



const $5b226caf6698f275$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $9d7a28566696001e$export$37a5fde709c1db82(element, name, value) {
    (0, $5b226caf6698f275$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $eaa49755228250c8$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $4d2c580410657193$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $eaa49755228250c8$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);






/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $546c1e926e1d3a44$export$e3ad02c335474dee = {};



function $2f1e8b805050f54a$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $eaa49755228250c8$export$7c73462e0d25e514)(callback);
    return ()=>(0, $546c1e926e1d3a44$export$e3ad02c335474dee)[supportsFlag] ?? memoized();
}


const $076986623cbb9b1c$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $2f1e8b805050f54a$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $f05128e673cb76b6$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $df088174520c01dd$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $f05128e673cb76b6$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $f05128e673cb76b6$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $f05128e673cb76b6$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $f05128e673cb76b6$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};



function $e6ee95c3cea31f7d$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $076986623cbb9b1c$export$866c1d07a1ac2ab)() ? (0, $a630665f53333869$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $fac733df141b8130$export$ff43f99925d7366b)(easing)) return (0, $f05128e673cb76b6$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$e6ee95c3cea31f7d$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $df088174520c01dd$export$2cf569f5e2221176).easeOut);
    else return (0, $df088174520c01dd$export$2cf569f5e2221176)[easing];
}


function $5dd559cd34253842$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $e6ee95c3cea31f7d$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}



function $3acd51d67cfba5f5$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $1faa5ae970531abf$export$a31269144d66b4a({ type: type, ...options }) {
    if ((0, $3acd51d67cfba5f5$export$6ab7812f1bac68be)(type) && (0, $076986623cbb9b1c$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}





/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $a2dc6d5609717cea$export$6c0f9803d8aa7219 extends (0, $9f6f25edeedcc618$export$655db786091c33e0) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $5b4e90778a3057f7$export$f5708dca728d7177)(typeof options.type !== "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
        const transition = (0, $1faa5ae970531abf$export$a31269144d66b4a)(options);
        this.animation = (0, $5dd559cd34253842$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $233833c137e29a60$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                else /**
                     * If we can, we want to commit the final style as set by the user,
                     * rather than the computed keyframe value supplied by the animation.
                     */ (0, $9d7a28566696001e$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        if (!this.isPseudoElement) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get time() {
        return (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        this.finishedTime = null;
        this.animation.currentTime = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(newTime);
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, observe: observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $4d2c580410657193$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            return 0, $3db7f0ca4f9c6429$export$8793edee2d425525;
        } else return observe(this);
    }
}






const $0995e0f4dd2c5cce$var$unsupportedEasingFunctions = {
    anticipate: $34280f1dd970722b$export$6b0af63b873d419e,
    backInOut: $461c43baa1cf6cc9$export$ddc5fd596f6c71b2,
    circInOut: $c72c6700cb8b11f8$export$30d3455eee55bed5
};
function $0995e0f4dd2c5cce$var$isUnsupportedEase(key) {
    return key in $0995e0f4dd2c5cce$var$unsupportedEasingFunctions;
}
function $0995e0f4dd2c5cce$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $0995e0f4dd2c5cce$var$isUnsupportedEase(transition.ease)) transition.ease = $0995e0f4dd2c5cce$var$unsupportedEasingFunctions[transition.ease];
}



/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9c6e9689f246c84d$var$sampleDelta = 10; //ms
class $9c6e9689f246c84d$export$bd2cd6a048093d96 extends (0, $a2dc6d5609717cea$export$6c0f9803d8aa7219) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $0995e0f4dd2c5cce$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $5890c99307e4580e$export$98db6ef1242dfa2)(options);
        super(options);
        if (options.startTime) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read commited styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $4dce88953cb82d5f$export$3394f837405475c7)({
            ...options,
            autoplay: false
        });
        const sampleTime = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(this.finishedTime ?? this.time);
        motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $9c6e9689f246c84d$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $9c6e9689f246c84d$var$sampleDelta);
        sampleAnimation.stop();
    }
}




/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $24e782afe0780b81$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $977cb6dd165f3ea4$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};



function $266365350b2685c0$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $266365350b2685c0$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $24e782afe0780b81$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $24e782afe0780b81$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $5b4e90778a3057f7$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $266365350b2685c0$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $3acd51d67cfba5f5$export$6ab7812f1bac68be)(type)) && velocity;
}




/**
 * A list of values that can be hardware-accelerated.
 */ const $b8c49fbefaaead56$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);
const $b8c49fbefaaead56$var$supportsWaapi = /*@__PURE__*/ (0, $eaa49755228250c8$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $b8c49fbefaaead56$export$ea92bde116fda821(options) {
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
    if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $b8c49fbefaaead56$var$supportsWaapi() && name && $b8c49fbefaaead56$var$acceleratedValues.has(name) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}




/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $ede8efce3f8f49c1$var$MAX_RESOLVE_DELAY = 40;
class $ede8efce3f8f49c1$export$b9855e2a7dee3dd2 extends (0, $9f6f25edeedcc618$export$655db786091c33e0) {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            } else this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, $ccfd6437c1ea2b0b$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate, onComplete: onComplete } = options;
        this.resolvedAt = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!(0, $266365350b2685c0$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            if ((0, $205c15274ccbb78b$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate?.((0, $233833c137e29a60$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            options.duration = 0;
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first commited frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $ede8efce3f8f49c1$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime: startTime,
            finalKeyframe: finalKeyframe,
            ...options,
            keyframes: keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         */ const animation = !isHandoff && (0, $b8c49fbefaaead56$export$ea92bde116fda821)(resolvedOptions) ? new (0, $9c6e9689f246c84d$export$bd2cd6a048093d96)({
            ...resolvedOptions,
            element: resolvedOptions.motionValue.owner.current
        }) : new (0, $4dce88953cb82d5f$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            onComplete?.();
            this.notifyFinished();
        }).catch((0, $3db7f0ca4f9c6429$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) (0, $ccfd6437c1ea2b0b$export$78b96d2a12593b05)();
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        this.animation.cancel();
    }
}


const $a8f938064af523fb$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $57872364f552b303$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $5d190a348f6f4e3f$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $7d9dd5cbb990aaec$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $205c15274ccbb78b$export$dd826089e3c5e502).instantAnimations || (0, $205c15274ccbb78b$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $69106a7efe290bd4$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $243866cd891e9f65$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return new (0, $ede8efce3f8f49c1$export$b9855e2a7dee3dd2)(options);
    };





const $e84ecee72c952f1e$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $7214a84e3a9c6096$export$280dc01950909d86)
]);


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $0b9e4c8588db4974$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $0b9e4c8588db4974$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $0b9e4c8588db4974$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $57872364f552b303$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $e607e453dd1538e8$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $243866cd891e9f65$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $fdf49ce736d2cd40$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $a8f938064af523fb$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $e84ecee72c952f1e$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $243866cd891e9f65$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $ab70fdf7798ce9cf$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $16eb4b801c0c0294$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $386a8e57946ac738$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $0b9e4c8588db4974$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $16eb4b801c0c0294$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $16eb4b801c0c0294$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($16eb4b801c0c0294$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($16eb4b801c0c0294$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $16eb4b801c0c0294$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $80b1750f31d8fd4d$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $16eb4b801c0c0294$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $16eb4b801c0c0294$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $386a8e57946ac738$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $0b9e4c8588db4974$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




function $b0d4790fccce0cb5$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $27b3baa45d57d87a$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $a2a12aa7468acb0b$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $a2a12aa7468acb0b$export$1405a65085f40b9 = [
    "initial",
    ...$a2a12aa7468acb0b$export$16e45afcc206d3a8
];


const $e743ddeccb989164$var$numVariantProps = (0, $a2a12aa7468acb0b$export$1405a65085f40b9).length;
function $e743ddeccb989164$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $e743ddeccb989164$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $e743ddeccb989164$var$numVariantProps; i++){
        const name = (0, $a2a12aa7468acb0b$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $27b3baa45d57d87a$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}





const $4ed6f2f87a788b15$var$reversePriorityOrder = [
    ...(0, $a2a12aa7468acb0b$export$16e45afcc206d3a8)
].reverse();
const $4ed6f2f87a788b15$var$numAnimationTypes = (0, $a2a12aa7468acb0b$export$16e45afcc206d3a8).length;
function $4ed6f2f87a788b15$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $80b1750f31d8fd4d$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $4ed6f2f87a788b15$export$bb53502b7a672aa8(visualElement) {
    let animate = $4ed6f2f87a788b15$var$animateList(visualElement);
    let state = $4ed6f2f87a788b15$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, $386a8e57946ac738$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $e743ddeccb989164$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $4ed6f2f87a788b15$var$numAnimationTypes; i++){
            const type = $4ed6f2f87a788b15$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $27b3baa45d57d87a$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $c78c33232f79d0d9$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $4ed6f2f87a788b15$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $d81090ce8560095d$export$9153ad4c4999f4a0)(next) && (0, $d81090ce8560095d$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b0d4790fccce0cb5$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $386a8e57946ac738$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $4ed6f2f87a788b15$var$createState();
            isInitialRender = true;
        }
    };
}
function $4ed6f2f87a788b15$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b0d4790fccce0cb5$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $4ed6f2f87a788b15$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $4ed6f2f87a788b15$var$createState() {
    return {
        animate: $4ed6f2f87a788b15$var$createTypeState(true),
        whileInView: $4ed6f2f87a788b15$var$createTypeState(),
        whileHover: $4ed6f2f87a788b15$var$createTypeState(),
        whileTap: $4ed6f2f87a788b15$var$createTypeState(),
        whileDrag: $4ed6f2f87a788b15$var$createTypeState(),
        whileFocus: $4ed6f2f87a788b15$var$createTypeState(),
        exit: $4ed6f2f87a788b15$var$createTypeState()
    };
}


class $49634cbad4e01a36$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $b84747866131e563$export$b45b3fe5caabdca extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $4ed6f2f87a788b15$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $c78c33232f79d0d9$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}



let $1518f8d199406e09$var$id = 0;
class $1518f8d199406e09$export$4989d1eb6104cc6c extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $1518f8d199406e09$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $58734ffc5b610f03$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $b84747866131e563$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $1518f8d199406e09$export$4989d1eb6104cc6c)
    }
};




function $91292c358487a948$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



const $ad00d1ceff96a4ee$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $09bdab108fb302ab$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $09bdab108fb302ab$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $ad00d1ceff96a4ee$export$a4cf9c8a4b063a6e)(event) && handler(event, $09bdab108fb302ab$export$12f84bb882d06e1a(event));
};


function $624bd4c7d19a4265$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $91292c358487a948$export$b1d829ddf82884aa)(target, eventName, (0, $09bdab108fb302ab$export$c404e80f92c98d29)(handler), options);
}



/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $9bd549ddcc484297$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $9bd549ddcc484297$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $9bd549ddcc484297$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



const $f9f7177c3b08e6e8$var$SCALE_PRECISION = 0.0001;
const $f9f7177c3b08e6e8$var$SCALE_MIN = 1 - $f9f7177c3b08e6e8$var$SCALE_PRECISION;
const $f9f7177c3b08e6e8$var$SCALE_MAX = 1 + $f9f7177c3b08e6e8$var$SCALE_PRECISION;
const $f9f7177c3b08e6e8$var$TRANSLATE_PRECISION = 0.01;
const $f9f7177c3b08e6e8$var$TRANSLATE_MIN = 0 - $f9f7177c3b08e6e8$var$TRANSLATE_PRECISION;
const $f9f7177c3b08e6e8$var$TRANSLATE_MAX = 0 + $f9f7177c3b08e6e8$var$TRANSLATE_PRECISION;
function $f9f7177c3b08e6e8$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $f9f7177c3b08e6e8$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $f9f7177c3b08e6e8$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $f9f7177c3b08e6e8$export$c1c127004b72a37(target) / $f9f7177c3b08e6e8$export$c1c127004b72a37(source);
    delta.translate = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $f9f7177c3b08e6e8$var$SCALE_MIN && delta.scale <= $f9f7177c3b08e6e8$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $f9f7177c3b08e6e8$var$TRANSLATE_MIN && delta.translate <= $f9f7177c3b08e6e8$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $f9f7177c3b08e6e8$export$c0d25e96fc67d310(delta, source, target, origin) {
    $f9f7177c3b08e6e8$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $f9f7177c3b08e6e8$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $f9f7177c3b08e6e8$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $f9f7177c3b08e6e8$export$c1c127004b72a37(relative);
}
function $f9f7177c3b08e6e8$export$426154f9d100f99(target, relative, parent) {
    $f9f7177c3b08e6e8$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $f9f7177c3b08e6e8$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $f9f7177c3b08e6e8$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $f9f7177c3b08e6e8$export$c1c127004b72a37(layout);
}
function $f9f7177c3b08e6e8$export$2785bfcc929c5650(target, layout, parent) {
    $f9f7177c3b08e6e8$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $f9f7177c3b08e6e8$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}


const $c46d1f0c98e4bf39$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $c46d1f0c98e4bf39$export$3d227df54007d73a = ()=>({
        x: $c46d1f0c98e4bf39$export$ff25708b37f72782(),
        y: $c46d1f0c98e4bf39$export$ff25708b37f72782()
    });
const $c46d1f0c98e4bf39$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $c46d1f0c98e4bf39$export$6459fc9e86be362e = ()=>({
        x: $c46d1f0c98e4bf39$export$6db76765312617ac(),
        y: $c46d1f0c98e4bf39$export$6db76765312617ac()
    });


function $7fa8f479865f19a7$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}



function $fdfd737695829726$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fdfd737695829726$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fdfd737695829726$var$isIdentityScale(scale) || !$fdfd737695829726$var$isIdentityScale(scaleX) || !$fdfd737695829726$var$isIdentityScale(scaleY);
}
function $fdfd737695829726$export$a545127cf1fbb600(values) {
    return $fdfd737695829726$export$bdf30dca883ea463(values) || $fdfd737695829726$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fdfd737695829726$export$bf80f5f8f4dc327f(values) {
    return $fdfd737695829726$var$is2DTranslate(values.x) || $fdfd737695829726$var$is2DTranslate(values.y);
}
function $fdfd737695829726$var$is2DTranslate(value) {
    return value && value !== "0%";
}



/**
 * Scales a point based on a factor and an originPoint
 */ function $90071dca1433d875$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $90071dca1433d875$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $90071dca1433d875$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $90071dca1433d875$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $90071dca1433d875$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $90071dca1433d875$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $90071dca1433d875$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $90071dca1433d875$export$d80074982803af5c(box, { x: x, y: y }) {
    $90071dca1433d875$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $90071dca1433d875$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $90071dca1433d875$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $90071dca1433d875$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $90071dca1433d875$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $90071dca1433d875$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $90071dca1433d875$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fdfd737695829726$export$a545127cf1fbb600)(node.latestValues)) $90071dca1433d875$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $90071dca1433d875$var$TREE_SCALE_SNAP_MAX && treeScale.x > $90071dca1433d875$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $90071dca1433d875$var$TREE_SCALE_SNAP_MAX && treeScale.y > $90071dca1433d875$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $90071dca1433d875$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $90071dca1433d875$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $90071dca1433d875$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $90071dca1433d875$export$58b16271041fbfb(box, transform) {
    $90071dca1433d875$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $90071dca1433d875$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $1b37cd07af156842$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $9bd549ddcc484297$export$d3955c6a8f65a36b)((0, $9bd549ddcc484297$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $1b37cd07af156842$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $1b37cd07af156842$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $90071dca1433d875$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $90071dca1433d875$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


// Fixes https://github.com/motiondivision/motion/issues/2270
const $9186e3f869586d69$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};


function $16e362627ff41e29$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $81a814757877ebbf$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $81a814757877ebbf$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $81a814757877ebbf$export$9f17032d917177de(a.x, b.x);
    const yDelta = $81a814757877ebbf$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}






/**
 * @internal
 */ class $911564de11400ebf$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $911564de11400ebf$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $81a814757877ebbf$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $243866cd891e9f65$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $911564de11400ebf$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $243866cd891e9f65$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $911564de11400ebf$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $911564de11400ebf$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $ad00d1ceff96a4ee$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $09bdab108fb302ab$export$12f84bb882d06e1a)(event);
        const initialInfo = $911564de11400ebf$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $243866cd891e9f65$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $911564de11400ebf$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $539b32b750ab60bb$export$a4627e546088548d)((0, $624bd4c7d19a4265$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $624bd4c7d19a4265$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $624bd4c7d19a4265$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $911564de11400ebf$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $911564de11400ebf$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $911564de11400ebf$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $911564de11400ebf$var$subtractPoint(point, $911564de11400ebf$var$lastDevicePoint(history)),
        offset: $911564de11400ebf$var$subtractPoint(point, $911564de11400ebf$var$startDevicePoint(history)),
        velocity: $911564de11400ebf$var$getVelocity(history, 0.1)
    };
}
function $911564de11400ebf$var$startDevicePoint(history) {
    return history[0];
}
function $911564de11400ebf$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $911564de11400ebf$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $911564de11400ebf$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $607e4cfbb9883683$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}






/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $b8c5ec13a2a6018a$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $b8c5ec13a2a6018a$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $b8c5ec13a2a6018a$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $b8c5ec13a2a6018a$export$690c180aa5775042(layoutBox.x, left, right),
        y: $b8c5ec13a2a6018a$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $b8c5ec13a2a6018a$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $b8c5ec13a2a6018a$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $b8c5ec13a2a6018a$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $b8c5ec13a2a6018a$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $b8c5ec13a2a6018a$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(source);
    const targetLength = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $2f435633a42d941c$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $2f435633a42d941c$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $b8c5ec13a2a6018a$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $b8c5ec13a2a6018a$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $b8c5ec13a2a6018a$export$7c5eaef8f4723d22(dragElastic = $b8c5ec13a2a6018a$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $b8c5ec13a2a6018a$export$a3366d3bac43a742;
    return {
        x: $b8c5ec13a2a6018a$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $b8c5ec13a2a6018a$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $b8c5ec13a2a6018a$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $b8c5ec13a2a6018a$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $b8c5ec13a2a6018a$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $b8c5ec13a2a6018a$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}




const $d907dc6c0c5a87b5$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $d907dc6c0c5a87b5$export$1b3dd616664938e4() {
    return $d907dc6c0c5a87b5$export$9e9bc3c487fccc00.x || $d907dc6c0c5a87b5$export$9e9bc3c487fccc00.y;
}


function $7652aa55063dae0f$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).x || (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).x = (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).x = (0, $d907dc6c0c5a87b5$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $b9f9800b41454371$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $b9f9800b41454371$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $09bdab108fb302ab$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $7652aa55063dae0f$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $5a6c0a76edf006ab$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $fdf49ce736d2cd40$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $b9f9800b41454371$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>this.getAnimationState(axis) === "paused" && this.getAxisMotionValue(axis).animation?.play());
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $911564de11400ebf$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $9186e3f869586d69$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$b9f9800b41454371$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $b8c5ec13a2a6018a$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $16e362627ff41e29$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $b8c5ec13a2a6018a$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $b8c5ec13a2a6018a$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $b8c5ec13a2a6018a$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $16e362627ff41e29$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $5b4e90778a3057f7$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $1b37cd07af156842$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $b8c5ec13a2a6018a$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $9bd549ddcc484297$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $9bd549ddcc484297$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            if (!$b9f9800b41454371$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $fdf49ce736d2cd40$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $a8f938064af523fb$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).animation?.pause());
    }
    getAnimationState(axis) {
        return this.getAxisMotionValue(axis).animation?.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$b9f9800b41454371$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $16e362627ff41e29$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $b8c5ec13a2a6018a$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            if (!$b9f9800b41454371$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $b9f9800b41454371$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $624bd4c7d19a4265$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $16e362627ff41e29$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $243866cd891e9f65$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $91292c358487a948$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $b8c5ec13a2a6018a$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $b9f9800b41454371$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $b9f9800b41454371$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}



class $5c388299bbe76937$export$5d97dc2872682820 extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $3db7f0ca4f9c6429$export$8793edee2d425525);
        this.removeListeners = (0, $3db7f0ca4f9c6429$export$8793edee2d425525);
        this.controls = new (0, $b9f9800b41454371$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $3db7f0ca4f9c6429$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $7875653fcd9a79bd$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $7875653fcd9a79bd$export$b4f8f1ee75ce5859 extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $3db7f0ca4f9c6429$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $911564de11400ebf$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $9186e3f869586d69$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $7875653fcd9a79bd$var$asyncHandler(onPanSessionStart),
            onStart: $7875653fcd9a79bd$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $624bd4c7d19a4265$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");



var $8nGP5 = parcelRequire("8nGP5");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $5b7a97fd90491435$export$da5f7b802957459a = (0, $8nGP5.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $06e8f8500a1f0d6f$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $d24b418b7f1291e7$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $d24b418b7f1291e7$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $d24b418b7f1291e7$export$fafff692be55225d(latest, node.target.x);
        const y = $d24b418b7f1291e7$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $a1f106af044901a8$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $977cb6dd165f3ea4$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $977cb6dd165f3ea4$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



const $362f2d882b198bdd$export$91ddd985b97788d1 = {};
function $362f2d882b198bdd$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $362f2d882b198bdd$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $e825571289930f38$export$9de1236619d9e756)(key)) $362f2d882b198bdd$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}




const { schedule: $e2a86f52a490281a$export$bb76eed83315504c, cancel: $e2a86f52a490281a$export$3252729004b8456e } = /* @__PURE__ */ (0, $557d29fbf3060c74$export$510b0596a933801a)(queueMicrotask, false);


"use client";
class $13a711d143d71da7$var$MeasureLayoutWithContext extends (0, $8nGP5.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $362f2d882b198bdd$export$de9e7791c71225fd)($13a711d143d71da7$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $06e8f8500a1f0d6f$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $e2a86f52a490281a$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $13a711d143d71da7$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $dc40494ff9a8b7a9$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $8nGP5.useContext)((0, $5fd6bce20ab8481b$export$a3579ca508007a95));
    return (0, $kSbwP.jsx)($13a711d143d71da7$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $8nGP5.useContext)((0, $5b7a97fd90491435$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $13a711d143d71da7$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $d24b418b7f1291e7$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $d24b418b7f1291e7$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $d24b418b7f1291e7$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $d24b418b7f1291e7$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $d24b418b7f1291e7$export$5eafb6257a5844c),
    boxShadow: (0, $a1f106af044901a8$export$eb0bc629e74dcf8)
};





function $b724dba9f8cd9123$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $b5f9d7313c47a627$export$605d60a2578142d3)(value) ? value : (0, $3ddfebdc70564ee7$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $a8f938064af523fb$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}



function $e72c8f0c63e96a40$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}


const $2cb1bb8522f7d3e3$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;



class $900fd94ddece1af1$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $df60b7a96ed79066$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $df60b7a96ed79066$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $2cb1bb8522f7d3e3$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $1bd0f57afd95f1e1$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $243866cd891e9f65$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $243866cd891e9f65$export$ec99c0ef4978dccb)(checkElapsed);
}
function $1bd0f57afd95f1e1$export$fcd451ca460f8a2a(callback, timeout) {
    return $1bd0f57afd95f1e1$export$1391212d75b2ee65(callback, (0, $607e4cfbb9883683$export$fc3e7e8557f8c8c7)(timeout));
}



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $10ae3fed497e3a32$export$fcc2206ecb6d74b(value) {
    return (0, $b5f9d7313c47a627$export$605d60a2578142d3)(value) ? value.get() : value;
}







const $c8362be9087d5c3e$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $c8362be9087d5c3e$var$numBorders = $c8362be9087d5c3e$var$borders.length;
const $c8362be9087d5c3e$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $c8362be9087d5c3e$var$isPx = (value)=>typeof value === "number" || (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).test(value);
function $c8362be9087d5c3e$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(0, lead.opacity ?? 1, $c8362be9087d5c3e$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, 0, $c8362be9087d5c3e$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $c8362be9087d5c3e$var$numBorders; i++){
        const borderLabel = `border${$c8362be9087d5c3e$var$borders[i]}Radius`;
        let followRadius = $c8362be9087d5c3e$var$getRadius(follow, borderLabel);
        let leadRadius = $c8362be9087d5c3e$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $c8362be9087d5c3e$var$isPx(followRadius) === $c8362be9087d5c3e$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)($c8362be9087d5c3e$var$asNumber(followRadius), $c8362be9087d5c3e$var$asNumber(leadRadius), progress), 0);
            if ((0, $5a6c0a76edf006ab$export$626336c2cd4b14de).test(leadRadius) || (0, $5a6c0a76edf006ab$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $c8362be9087d5c3e$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $c8362be9087d5c3e$var$easeCrossfadeIn = /*@__PURE__*/ $c8362be9087d5c3e$var$compress(0, 0.5, (0, $c72c6700cb8b11f8$export$c8d67a19199d1a50));
const $c8362be9087d5c3e$var$easeCrossfadeOut = /*@__PURE__*/ $c8362be9087d5c3e$var$compress(0.5, 0.95, (0, $3db7f0ca4f9c6429$export$8793edee2d425525));
function $c8362be9087d5c3e$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $2f435633a42d941c$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $1ef73c442cf028b6$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $1ef73c442cf028b6$export$c53fd88f45d77e4b(box, originBox) {
    $1ef73c442cf028b6$export$a0230ae482601ae8(box.x, originBox.x);
    $1ef73c442cf028b6$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $1ef73c442cf028b6$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $a1226d8269ae0626$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $90071dca1433d875$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $90071dca1433d875$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $a1226d8269ae0626$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $5a6c0a76edf006ab$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $a1226d8269ae0626$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a1226d8269ae0626$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a1226d8269ae0626$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $a1226d8269ae0626$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $a1226d8269ae0626$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $a1226d8269ae0626$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a1226d8269ae0626$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $a1226d8269ae0626$export$42b76f1d0d16d5b(box.x, transforms, $a1226d8269ae0626$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $a1226d8269ae0626$export$42b76f1d0d16d5b(box.y, transforms, $a1226d8269ae0626$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $eb05067f2df0dce4$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $eb05067f2df0dce4$export$a7ec7642fe550fb6(delta) {
    return $eb05067f2df0dce4$var$isAxisDeltaZero(delta.x) && $eb05067f2df0dce4$var$isAxisDeltaZero(delta.y);
}
function $eb05067f2df0dce4$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $eb05067f2df0dce4$export$8d5cf76bb7daff09(a, b) {
    return $eb05067f2df0dce4$export$7a9a6f114ddd0fdb(a.x, b.x) && $eb05067f2df0dce4$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $eb05067f2df0dce4$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $eb05067f2df0dce4$export$ef641b782d85522(a, b) {
    return $eb05067f2df0dce4$export$22adf28bfca1c186(a.x, b.x) && $eb05067f2df0dce4$export$22adf28bfca1c186(a.y, b.y);
}
function $eb05067f2df0dce4$export$c5706146bc63213(box) {
    return (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(box.x) / (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(box.y);
}
function $eb05067f2df0dce4$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $13d53ec340fbf133$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $df60b7a96ed79066$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $df60b7a96ed79066$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $3990b9e2e23eff37$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}















const $67a00e091c44be14$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $67a00e091c44be14$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $67a00e091c44be14$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $67a00e091c44be14$var$animationTarget = 1000;
let $67a00e091c44be14$var$id = 0;
function $67a00e091c44be14$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $67a00e091c44be14$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $e607e453dd1538e8$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $243866cd891e9f65$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $67a00e091c44be14$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $67a00e091c44be14$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $67a00e091c44be14$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) $67a00e091c44be14$var$metrics.nodes = $67a00e091c44be14$var$metrics.calculatedTargetDeltas = $67a00e091c44be14$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($67a00e091c44be14$export$131f2f0cc5fe9609);
                this.nodes.forEach($67a00e091c44be14$var$resolveTargetDelta);
                this.nodes.forEach($67a00e091c44be14$var$calcProjection);
                this.nodes.forEach($67a00e091c44be14$export$c2664f37bc951031);
                if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).addProjectionMetrics) (0, $ab3abf8b1c748625$export$84ce9a476f53d110).addProjectionMetrics($67a00e091c44be14$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $900fd94ddece1af1$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $821f935f0c9e9c61$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $e72c8f0c63e96a40$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $1bd0f57afd95f1e1$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $06e8f8500a1f0d6f$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $06e8f8500a1f0d6f$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($67a00e091c44be14$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $67a00e091c44be14$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $eb05067f2df0dce4$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $57872364f552b303$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $67a00e091c44be14$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($67a00e091c44be14$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $67a00e091c44be14$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($67a00e091c44be14$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($67a00e091c44be14$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($67a00e091c44be14$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($67a00e091c44be14$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($67a00e091c44be14$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
            (0, $243866cd891e9f65$export$fff89137e9e818ce).delta = (0, $b91c3e3a9c8ba92d$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp);
            (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp = now;
            (0, $243866cd891e9f65$export$fff89137e9e818ce).isProcessing = true;
            (0, $243866cd891e9f65$export$1811c3a7e3af92f0).update.process((0, $243866cd891e9f65$export$fff89137e9e818ce));
            (0, $243866cd891e9f65$export$1811c3a7e3af92f0).preRender.process((0, $243866cd891e9f65$export$fff89137e9e818ce));
            (0, $243866cd891e9f65$export$1811c3a7e3af92f0).render.process((0, $243866cd891e9f65$export$fff89137e9e818ce));
            (0, $243866cd891e9f65$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $e2a86f52a490281a$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($67a00e091c44be14$var$clearSnapshot);
            this.sharedNodes.forEach($67a00e091c44be14$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $243866cd891e9f65$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $eb05067f2df0dce4$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fdfd737695829726$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $67a00e091c44be14$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some($67a00e091c44be14$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $90071dca1433d875$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $90071dca1433d875$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $90071dca1433d875$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $90071dca1433d875$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $90071dca1433d875$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fdfd737695829726$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $90071dca1433d875$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fdfd737695829726$export$a545127cf1fbb600)(this.latestValues)) (0, $90071dca1433d875$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fdfd737695829726$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fdfd737695829726$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $a1226d8269ae0626$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fdfd737695829726$export$a545127cf1fbb600)(this.latestValues)) (0, $a1226d8269ae0626$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    (0, $f9f7177c3b08e6e8$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $f9f7177c3b08e6e8$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $90071dca1433d875$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    (0, $f9f7177c3b08e6e8$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) $67a00e091c44be14$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fdfd737695829726$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fdfd737695829726$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $243866cd891e9f65$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $90071dca1433d875$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $1ef73c442cf028b6$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $1ef73c442cf028b6$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $f9f7177c3b08e6e8$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $eb05067f2df0dce4$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $eb05067f2df0dce4$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) $67a00e091c44be14$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
            this.projectionDelta = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($67a00e091c44be14$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $67a00e091c44be14$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $67a00e091c44be14$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $f9f7177c3b08e6e8$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $67a00e091c44be14$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $eb05067f2df0dce4$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $c8362be9087d5c3e$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $243866cd891e9f65$export$2cef06c20297c17d).update(()=>{
                (0, $06e8f8500a1f0d6f$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).layout++;
                this.currentAnimation = (0, $b724dba9f8cd9123$export$335a17c977067b99)(0, $67a00e091c44be14$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $d4f1f56e5e1f84a3$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($67a00e091c44be14$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $67a00e091c44be14$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                const xLength = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $1ef73c442cf028b6$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $90071dca1433d875$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $f9f7177c3b08e6e8$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $13d53ec340fbf133$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId: layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $67a00e091c44be14$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $67a00e091c44be14$var$transformAxes.length; i++){
                $67a00e091c44be14$var$resetDistortingTransform(`rotate${$67a00e091c44be14$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $67a00e091c44be14$var$resetDistortingTransform(`skew${$67a00e091c44be14$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $67a00e091c44be14$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $10ae3fed497e3a32$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $10ae3fed497e3a32$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fdfd737695829726$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $3990b9e2e23eff37$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $362f2d882b198bdd$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $362f2d882b198bdd$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $10ae3fed497e3a32$export$fcc2206ecb6d74b)(styleProp?.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach($67a00e091c44be14$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $67a00e091c44be14$var$updateLayout(node) {
    node.updateLayout();
}
function $67a00e091c44be14$var$notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($67a00e091c44be14$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $7fa8f479865f19a7$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $f9f7177c3b08e6e8$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
        (0, $f9f7177c3b08e6e8$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $c46d1f0c98e4bf39$export$3d227df54007d73a)();
        if (isShared) (0, $f9f7177c3b08e6e8$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $f9f7177c3b08e6e8$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $eb05067f2df0dce4$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    (0, $f9f7177c3b08e6e8$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
                    (0, $f9f7177c3b08e6e8$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $eb05067f2df0dce4$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $67a00e091c44be14$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $ab3abf8b1c748625$export$84ce9a476f53d110).value) $67a00e091c44be14$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $67a00e091c44be14$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $67a00e091c44be14$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $67a00e091c44be14$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $67a00e091c44be14$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $67a00e091c44be14$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $67a00e091c44be14$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $67a00e091c44be14$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $67a00e091c44be14$var$calcProjection(node) {
    node.calcProjection();
}
function $67a00e091c44be14$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $67a00e091c44be14$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $67a00e091c44be14$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $67a00e091c44be14$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $a89acdc8cee7d84f$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $67a00e091c44be14$export$6ffd3e6ae339a132(output, from, to, p) {
    $67a00e091c44be14$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $67a00e091c44be14$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $67a00e091c44be14$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $67a00e091c44be14$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $67a00e091c44be14$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $67a00e091c44be14$var$roundPoint = $67a00e091c44be14$var$userAgentContains("applewebkit/") && !$67a00e091c44be14$var$userAgentContains("chrome/") ? Math.round : (0, $3db7f0ca4f9c6429$export$8793edee2d425525);
function $67a00e091c44be14$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $67a00e091c44be14$var$roundPoint(axis.min);
    axis.max = $67a00e091c44be14$var$roundPoint(axis.max);
}
function $67a00e091c44be14$var$roundBox(box) {
    $67a00e091c44be14$var$roundAxis(box.x);
    $67a00e091c44be14$var$roundAxis(box.y);
}
function $67a00e091c44be14$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $f9f7177c3b08e6e8$export$28d0384c4b79bde2)((0, $eb05067f2df0dce4$export$c5706146bc63213)(snapshot), (0, $eb05067f2df0dce4$export$c5706146bc63213)(layout), 0.2);
}
function $67a00e091c44be14$var$checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}




const $81225ab82b703e90$export$2d029a49a09b6177 = (0, $67a00e091c44be14$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $91292c358487a948$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $0c20a585443a5d4b$export$b91509fcf893b648 = {
    current: undefined
};
const $0c20a585443a5d4b$export$b61a9eb3dbde8858 = (0, $67a00e091c44be14$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$0c20a585443a5d4b$export$b91509fcf893b648.current) {
            const documentNode = new (0, $81225ab82b703e90$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $0c20a585443a5d4b$export$b91509fcf893b648.current = documentNode;
        }
        return $0c20a585443a5d4b$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $8b88ccc73b02d8a3$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $7875653fcd9a79bd$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $5c388299bbe76937$export$5d97dc2872682820),
        ProjectionNode: (0, $0c20a585443a5d4b$export$b61a9eb3dbde8858),
        MeasureLayout: $13a711d143d71da7$export$779f5fb01ad751cd
    }
};





function $629098937c24848f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $0c7f33c50b9380b4$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $629098937c24848f$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $8c8fdb52035f97bd$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $d907dc6c0c5a87b5$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $8c8fdb52035f97bd$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $0c7f33c50b9380b4$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = (enterEvent)=>{
        if (!$8c8fdb52035f97bd$var$isValidHover(enterEvent)) return;
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(target, enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = (leaveEvent)=>{
            if (!$8c8fdb52035f97bd$var$isValidHover(leaveEvent)) return;
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        };
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    };
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



function $02a32fa1ac76ef36$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $09bdab108fb302ab$export$12f84bb882d06e1a)(event)));
}
class $02a32fa1ac76ef36$export$93a81ea037eac456 extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $8c8fdb52035f97bd$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $02a32fa1ac76ef36$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$02a32fa1ac76ef36$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $b0f17f6c5bb409a0$export$d4826db40d47595b extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $539b32b750ab60bb$export$a4627e546088548d)((0, $91292c358487a948$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $91292c358487a948$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}





/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $4abf5ab51ccd3f1d$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $4abf5ab51ccd3f1d$export$e841ada32ff745b(parent, child.parentElement);
};




const $96274de690a2b9d0$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $96274de690a2b9d0$export$5f6976e2f961e8b7(element) {
    return $96274de690a2b9d0$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $78ab420489cb6c4f$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $ae2f9a1fd928ba89$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $ae2f9a1fd928ba89$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $ae2f9a1fd928ba89$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $ae2f9a1fd928ba89$var$filterEvents(()=>{
        if ((0, $78ab420489cb6c4f$export$7987404a4e35b84b).has(element)) return;
        $ae2f9a1fd928ba89$var$firePointerEvent(element, "down");
        const handleKeyup = $ae2f9a1fd928ba89$var$filterEvents(()=>{
            $ae2f9a1fd928ba89$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$ae2f9a1fd928ba89$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $d5abc6c7ec9e945c$var$isValidPressEvent(event) {
    return (0, $ad00d1ceff96a4ee$export$a4cf9c8a4b063a6e)(event) && !(0, $d907dc6c0c5a87b5$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $d5abc6c7ec9e945c$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $0c7f33c50b9380b4$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$d5abc6c7ec9e945c$var$isValidPressEvent(startEvent) || (0, $78ab420489cb6c4f$export$7987404a4e35b84b).has(target)) return;
        (0, $78ab420489cb6c4f$export$7987404a4e35b84b).add(target);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$d5abc6c7ec9e945c$var$isValidPressEvent(endEvent) || !(0, $78ab420489cb6c4f$export$7987404a4e35b84b).has(target)) return;
            (0, $78ab420489cb6c4f$export$7987404a4e35b84b).delete(target);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $4abf5ab51ccd3f1d$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if (target instanceof HTMLElement) {
            target.addEventListener("focus", (event)=>(0, $ae2f9a1fd928ba89$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $96274de690a2b9d0$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $e61d2f9c82feefdc$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $09bdab108fb302ab$export$12f84bb882d06e1a)(event)));
}
class $e61d2f9c82feefdc$export$f026abdbba7f0c9e extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $d5abc6c7ec9e945c$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $e61d2f9c82feefdc$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$e61d2f9c82feefdc$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $dac108990517dd8e$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $dac108990517dd8e$var$observers = new WeakMap();
const $dac108990517dd8e$var$fireObserverCallback = (entry)=>{
    const callback = $dac108990517dd8e$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $dac108990517dd8e$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($dac108990517dd8e$var$fireObserverCallback);
};
function $dac108990517dd8e$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$dac108990517dd8e$var$observers.has(lookupRoot)) $dac108990517dd8e$var$observers.set(lookupRoot, {});
    const rootObservers = $dac108990517dd8e$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($dac108990517dd8e$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $dac108990517dd8e$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $dac108990517dd8e$var$initIntersectionObserver(options);
    $dac108990517dd8e$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $dac108990517dd8e$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $db24210c739d0aa0$var$thresholdNames = {
    some: 0,
    all: 1
};
class $db24210c739d0aa0$export$150851c8cc2f0c72 extends (0, $49634cbad4e01a36$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $db24210c739d0aa0$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $dac108990517dd8e$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($db24210c739d0aa0$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $db24210c739d0aa0$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $63676e4877f6cc1c$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $db24210c739d0aa0$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $e61d2f9c82feefdc$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $b0f17f6c5bb409a0$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $02a32fa1ac76ef36$export$93a81ea037eac456)
    }
};




const $32d24f9401cdee64$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $0c20a585443a5d4b$export$b61a9eb3dbde8858),
        MeasureLayout: $13a711d143d71da7$export$779f5fb01ad751cd
    }
};



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $843d7e09d4fed309$export$40f10139ecf1f171 = (0, $8nGP5.createContext)({
    strict: false
});




var $8nGP5 = parcelRequire("8nGP5");
"use client";
const $47e52599db6d2b52$export$2285bbca2c666415 = /* @__PURE__ */ (0, $8nGP5.createContext)({});



var $8nGP5 = parcelRequire("8nGP5");




function $27e383a56d553de9$export$4b3c3bd8d910d78d(props) {
    return (0, $c78c33232f79d0d9$export$aa71198ceeaf53ce)(props.animate) || (0, $a2a12aa7468acb0b$export$1405a65085f40b9).some((name)=>(0, $27b3baa45d57d87a$export$720b90e312cea233)(props[name]));
}
function $27e383a56d553de9$export$ce46fa4165cdec40(props) {
    return Boolean($27e383a56d553de9$export$4b3c3bd8d910d78d(props) || props.variants);
}



function $b3a419c36b78dd98$export$12fc32fc096a04a3(props, context) {
    if ((0, $27e383a56d553de9$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $27b3baa45d57d87a$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $27b3baa45d57d87a$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $37fecec0e8f032d4$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $b3a419c36b78dd98$export$12fc32fc096a04a3)(props, (0, $8nGP5.useContext)((0, $47e52599db6d2b52$export$2285bbca2c666415)));
    return (0, $8nGP5.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $37fecec0e8f032d4$var$variantLabelsAsDependency(initial),
        $37fecec0e8f032d4$var$variantLabelsAsDependency(animate)
    ]);
}
function $37fecec0e8f032d4$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}



const $36a8bbc18437eadc$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $36a8bbc18437eadc$export$65570e08d843624d = {};
for(const key in $36a8bbc18437eadc$var$featureProps)$36a8bbc18437eadc$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$36a8bbc18437eadc$var$featureProps[key].some((name)=>!!props[name])
};



function $f39433c92e63fcff$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $36a8bbc18437eadc$export$65570e08d843624d)[key] = {
        ...(0, $36a8bbc18437eadc$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $dc1a723203fe0d43$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $8nGP5 = parcelRequire("8nGP5");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $0b3df3e8184e34f1$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $8nGP5.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $16e362627ff41e29$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $8nGP5 = parcelRequire("8nGP5");









function $d7deacf7f95c091f$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    const { visualElement: parent } = (0, $8nGP5.useContext)((0, $47e52599db6d2b52$export$2285bbca2c666415));
    const lazyContext = (0, $8nGP5.useContext)((0, $843d7e09d4fed309$export$40f10139ecf1f171));
    const presenceContext = (0, $8nGP5.useContext)((0, $116d068e4cc320bc$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $8nGP5.useContext)((0, $eee49e6284984f1d$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $8nGP5.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $8nGP5.useContext)((0, $5b7a97fd90491435$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $d7deacf7f95c091f$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $8nGP5.useRef)(false);
    (0, $8nGP5.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $6c9374e3d96babcd$export$8592e1c077c890a6];
    const wantsHandoff = (0, $8nGP5.useRef)(Boolean(optimisedAppearId) && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, $e1fc7471256e233e$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $e2a86f52a490281a$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $8nGP5.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $d7deacf7f95c091f$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $d7deacf7f95c091f$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $16e362627ff41e29$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $d7deacf7f95c091f$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $d7deacf7f95c091f$var$getClosestProjectingNode(visualElement.parent);
}



"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $eaed570bfb4d3a71$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $f39433c92e63fcff$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $8nGP5.useContext)((0, $eee49e6284984f1d$export$22a697fb29aac98d)),
            ...props,
            layoutId: $eaed570bfb4d3a71$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $37fecec0e8f032d4$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $1f64697a60450b0a$export$4e09c449d6c407f7)) {
            $eaed570bfb4d3a71$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $eaed570bfb4d3a71$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $d7deacf7f95c091f$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $kSbwP.jsxs)((0, $47e52599db6d2b52$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $kSbwP.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $0b3df3e8184e34f1$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, $8nGP5.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $dc1a723203fe0d43$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $eaed570bfb4d3a71$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $8nGP5.useContext)((0, $5fd6bce20ab8481b$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $eaed570bfb4d3a71$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $8nGP5.useContext)((0, $843d7e09d4fed309$export$40f10139ecf1f171)).strict;
}
function $eaed570bfb4d3a71$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $36a8bbc18437eadc$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}



var $8nGP5 = parcelRequire("8nGP5");

var $8nGP5 = parcelRequire("8nGP5");


function $1625979bc9d43895$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $362f2d882b198bdd$export$91ddd985b97788d1)[key] || key === "opacity");
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $318b24db2d82be70$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



const $c78b55021f5ae4df$export$7d260a2a5f8bc19e = {
    ...(0, $80084dd05e454f7b$export$98e628dec113755e),
    transform: Math.round
};






const $fa43524a06bbf9bb$export$f2e4285fee37e26 = {
    rotate: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    rotateX: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    rotateY: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    rotateZ: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    scale: $80084dd05e454f7b$export$dcdf75081b88279d,
    scaleX: (0, $80084dd05e454f7b$export$dcdf75081b88279d),
    scaleY: (0, $80084dd05e454f7b$export$dcdf75081b88279d),
    scaleZ: (0, $80084dd05e454f7b$export$dcdf75081b88279d),
    skew: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    skewX: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    skewY: (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    distance: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    translateX: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    translateY: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    translateZ: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    x: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    y: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    z: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    perspective: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    transformPerspective: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    opacity: (0, $80084dd05e454f7b$export$58f0f39f63f3cf42),
    originX: (0, $5a6c0a76edf006ab$export$44e2e1705876d7ed),
    originY: (0, $5a6c0a76edf006ab$export$44e2e1705876d7ed),
    originZ: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008)
};


const $0a436c15509bd355$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderTopWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderRightWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderRadius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    radius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    maxWidth: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    height: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    maxHeight: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    top: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    right: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    bottom: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    left: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    paddingTop: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    paddingRight: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    paddingBottom: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    paddingLeft: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    margin: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    marginTop: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    marginRight: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    marginBottom: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    marginLeft: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    ...(0, $fa43524a06bbf9bb$export$f2e4285fee37e26),
    zIndex: (0, $c78b55021f5ae4df$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $80084dd05e454f7b$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $80084dd05e454f7b$export$58f0f39f63f3cf42),
    numOctaves: (0, $c78b55021f5ae4df$export$7d260a2a5f8bc19e)
};


const $feb4f840e1b01043$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $feb4f840e1b01043$var$numTransforms = (0, $7214a84e3a9c6096$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $feb4f840e1b01043$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $feb4f840e1b01043$var$numTransforms; i++){
        const key = (0, $7214a84e3a9c6096$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $318b24db2d82be70$export$453ef540a9a1bd6b)(value, (0, $0a436c15509bd355$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $feb4f840e1b01043$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}






function $47da4fd8c988bf5f$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $e825571289930f38$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $318b24db2d82be70$export$453ef540a9a1bd6b)(value, (0, $0a436c15509bd355$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $feb4f840e1b01043$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $99f2fece35caab50$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $a2c2490fea924239$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $b5f9d7313c47a627$export$605d60a2578142d3)(source[key]) && !(0, $1625979bc9d43895$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $a2c2490fea924239$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $8nGP5.useMemo)(()=>{
        const state = (0, $99f2fece35caab50$export$8940b483cf52eeda)();
        (0, $47da4fd8c988bf5f$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $a2c2490fea924239$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $a2c2490fea924239$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $a2c2490fea924239$var$useInitialMotionValues(props, visualState));
    return style;
}
function $a2c2490fea924239$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $a2c2490fea924239$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $6aa1f167093949aa$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $6aa1f167093949aa$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $6aa1f167093949aa$var$validMotionProps.has(key);
}


let $4fb5b984b0f83d44$var$shouldForward = (key)=>!(0, $6aa1f167093949aa$export$2f9c46555243bf04)(key);
function $4fb5b984b0f83d44$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $4fb5b984b0f83d44$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $6aa1f167093949aa$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $4fb5b984b0f83d44$export$59d6962c470509a5((parcelRequire("4kwnA")).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $4fb5b984b0f83d44$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($4fb5b984b0f83d44$var$shouldForward(key) || forwardMotionProps === true && (0, $6aa1f167093949aa$export$2f9c46555243bf04)(key) || !isDom && !(0, $6aa1f167093949aa$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $efcbe24ef37396a8$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $b7e49a221af3843f$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $efcbe24ef37396a8$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}



var $8nGP5 = parcelRequire("8nGP5");



const $c1bc4d2b6bf449e7$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $c1bc4d2b6bf449e7$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $c1bc4d2b6bf449e7$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $c1bc4d2b6bf449e7$var$dashKeys : $c1bc4d2b6bf449e7$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



function $3f513404dea0bd77$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $3f513404dea0bd77$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $3f513404dea0bd77$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $3f513404dea0bd77$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $2fd97ff8a837f9a3$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $47da4fd8c988bf5f$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $3f513404dea0bd77$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $c1bc4d2b6bf449e7$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $826a0133f7c71355$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $99f2fece35caab50$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $7d1b1cf2764ed8ce$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $2ac60f04c922bb4d$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $8nGP5.useMemo)(()=>{
        const state = (0, $826a0133f7c71355$export$41be8b43e1c4d4f9)();
        (0, $2fd97ff8a837f9a3$export$5475d24f125d7053)(state, visualState, (0, $7d1b1cf2764ed8ce$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $a2c2490fea924239$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $144692c9d4bc381d$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $b7e49a221af3843f$export$88f3fc2fd3766989)(Component) ? (0, $2ac60f04c922bb4d$export$84309c4f53cb1bd5) : (0, $a2c2490fea924239$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $4fb5b984b0f83d44$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $8nGP5.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $8nGP5.useMemo)(()=>(0, $b5f9d7313c47a627$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $8nGP5.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}




var $8nGP5 = parcelRequire("8nGP5");







function $6c148c0ef80006c7$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $6c148c0ef80006c7$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $6c148c0ef80006c7$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $8nGP5.useContext)((0, $47e52599db6d2b52$export$2285bbca2c666415));
        const presenceContext = (0, $8nGP5.useContext)((0, $116d068e4cc320bc$export$f224e4635b6f8ce2));
        const make = ()=>$6c148c0ef80006c7$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $173f963c4101a343$export$fe4300aa8eebea86)(make);
    };
function $6c148c0ef80006c7$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $10ae3fed497e3a32$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $27e383a56d553de9$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $27e383a56d553de9$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $c78c33232f79d0d9$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $c2c6204d0ae4aa0a$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}




function $b300eea51fd81342$export$16da615486abaa45(props, prevProps, visualElement) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $b5f9d7313c47a627$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $b5f9d7313c47a627$export$605d60a2578142d3)(prevProps.style[key]) || (0, $1625979bc9d43895$export$6d27ce8e3de1c3cf)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}



const $8503655d89eee551$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $6c148c0ef80006c7$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $b300eea51fd81342$export$16da615486abaa45,
        createRenderState: (0, $99f2fece35caab50$export$8940b483cf52eeda)
    })
};






function $18885ec2175a1b2e$export$c01c3c7cdbf4420c(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}



function $6d7feb0adf7f2423$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $4ab82f3aa0eb7ed0$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $872015f2b141fc32$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $6d7feb0adf7f2423$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $4ab82f3aa0eb7ed0$export$28931db5d57958e5).has(key) ? (0, $a94a49baeb171c48$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $e9f3aa8860df3a98$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $b300eea51fd81342$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $b5f9d7313c47a627$export$605d60a2578142d3)(props[key]) || (0, $b5f9d7313c47a627$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $7214a84e3a9c6096$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}




const $c441a45bec4b78cf$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $c441a45bec4b78cf$export$44dabd3fae512e85 = {
    useVisualState: (0, $6c148c0ef80006c7$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $e9f3aa8860df3a98$export$16da615486abaa45),
        createRenderState: (0, $826a0133f7c71355$export$41be8b43e1c4d4f9),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $c441a45bec4b78cf$var$layoutProps.length; i++){
                const key = $c441a45bec4b78cf$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $243866cd891e9f65$export$2cef06c20297c17d).read(()=>{
                (0, $18885ec2175a1b2e$export$c01c3c7cdbf4420c)(current, renderState);
                (0, $243866cd891e9f65$export$2cef06c20297c17d).render(()=>{
                    (0, $2fd97ff8a837f9a3$export$5475d24f125d7053)(renderState, latestValues, (0, $7d1b1cf2764ed8ce$export$6328ce7565ea1049)(current.tagName), props.transformTemplate);
                    (0, $872015f2b141fc32$export$c5f8399d19a7394b)(current, renderState);
                });
            });
        }
    })
};


function $9658972339af1f1f$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $b7e49a221af3843f$export$88f3fc2fd3766989)(Component) ? (0, $c441a45bec4b78cf$export$44dabd3fae512e85) : (0, $8503655d89eee551$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $144692c9d4bc381d$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $eaed570bfb4d3a71$export$c3ad4a902bccc2d8)(config);
    };
}



var $8nGP5 = parcelRequire("8nGP5");





// Does this device prefer reduced motion? Returns `null` server-side.
const $7741e4f778bba3f6$export$ff7706047246b98b = {
    current: null
};
const $7741e4f778bba3f6$export$6476d16e2fd2d0db = {
    current: false
};


function $239507803b76de1f$export$ca9f41fb23dded3d() {
    (0, $7741e4f778bba3f6$export$6476d16e2fd2d0db).current = true;
    if (!(0, $1f64697a60450b0a$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $7741e4f778bba3f6$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $7741e4f778bba3f6$export$ff7706047246b98b).current = false;
}




const $d0bbce8ffb7d8ff5$export$bc2a978a17abfdde = new WeakMap();






function $2653869c7feeeb57$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $b5f9d7313c47a627$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $b5f9d7313c47a627$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $3ddfebdc70564ee7$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $3ddfebdc70564ee7$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}









/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $4dd5575669f568c4$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $19720e90f9cdb509$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);




/**
 * ValueType for "auto"
 */ const $f0ce313ada0d0ce9$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




/**
 * Tests a provided value against a ValueType
 */ const $3218996d5573db88$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $4e2df317a2323a29$export$d176691c1998a1f5 = [
    (0, $80084dd05e454f7b$export$98e628dec113755e),
    (0, $5a6c0a76edf006ab$export$91c0eda1d06bf008),
    (0, $5a6c0a76edf006ab$export$626336c2cd4b14de),
    (0, $5a6c0a76edf006ab$export$41fc368e1a942b97),
    (0, $5a6c0a76edf006ab$export$aed3d7b7d206c196),
    (0, $5a6c0a76edf006ab$export$f91e8c45a95a32f2),
    (0, $f0ce313ada0d0ce9$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $4e2df317a2323a29$export$eefdd52e3ccae428 = (v)=>$4e2df317a2323a29$export$d176691c1998a1f5.find((0, $3218996d5573db88$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $c5d0f3d2da409b4a$var$valueTypes = [
    ...(0, $4e2df317a2323a29$export$d176691c1998a1f5),
    (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    (0, $977cb6dd165f3ea4$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $c5d0f3d2da409b4a$export$950e7e59ea1ffed7 = (v)=>$c5d0f3d2da409b4a$var$valueTypes.find((0, $3218996d5573db88$export$6eae4d0a6a7ca7cd)(v));






/**
 * Properties that should default to 1 or 100%
 */ const $f6717a985328bfd4$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $f6717a985328bfd4$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $e356e07a1bd40070$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $f6717a985328bfd4$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $f6717a985328bfd4$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $f6717a985328bfd4$export$3dea766d36a8935f = {
    ...(0, $977cb6dd165f3ea4$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($f6717a985328bfd4$var$functionRegex);
        return functions ? functions.map($f6717a985328bfd4$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $6c0365315399dd10$export$98cd7c72c5a731fb = {
    ...(0, $0a436c15509bd355$export$eec14432cd1cb67b),
    color: // Color props
    $9ec208d2140f13cc$export$35e9368ef982300f,
    backgroundColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    outlineColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    fill: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    stroke: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    borderTopColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    borderRightColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    borderBottomColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    borderLeftColor: (0, $9ec208d2140f13cc$export$35e9368ef982300f),
    filter: $f6717a985328bfd4$export$3dea766d36a8935f,
    WebkitFilter: (0, $f6717a985328bfd4$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $6c0365315399dd10$export$67d1babe0338d23b = (key)=>$6c0365315399dd10$export$98cd7c72c5a731fb[key];


function $d9aa1718eaa33425$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $6c0365315399dd10$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $f6717a985328bfd4$export$3dea766d36a8935f)) defaultValueType = (0, $977cb6dd165f3ea4$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



const $7c2644a6dbb5dbc6$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $7c2644a6dbb5dbc6$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $ccfd6437c1ea2b0b$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $30e8dc9fbee95a32$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $243866cd891e9f65$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $27e383a56d553de9$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $27e383a56d553de9$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $b5f9d7313c47a627$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $d0bbce8ffb7d8ff5$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $7741e4f778bba3f6$export$6476d16e2fd2d0db).current) (0, $239507803b76de1f$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $7741e4f778bba3f6$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $243866cd891e9f65$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $243866cd891e9f65$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $36a8bbc18437eadc$export$65570e08d843624d){
            const featureDefinition = (0, $36a8bbc18437eadc$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $7c2644a6dbb5dbc6$var$propEventHandlers.length; i++){
            const key = $7c2644a6dbb5dbc6$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $2653869c7feeeb57$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $3ddfebdc70564ee7$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $4dd5575669f568c4$export$65583ed5a868f2d9)(value) || (0, $19720e90f9cdb509$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $c5d0f3d2da409b4a$export$950e7e59ea1ffed7)(value) && (0, $977cb6dd165f3ea4$export$83a0e34f1302825b).test(target)) value = (0, $d9aa1718eaa33425$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $b5f9d7313c47a627$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $b5f9d7313c47a627$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $c2c6204d0ae4aa0a$export$d68f140c4d9b48bc)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $b5f9d7313c47a627$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $821f935f0c9e9c61$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}







/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $530670580bb81492$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $530670580bb81492$export$b9f0c1f373aee2b0(current) {
    const match = $530670580bb81492$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const $530670580bb81492$var$maxDepth = 4;
function $530670580bb81492$export$289398774300c991(current, element, depth = 1) {
    (0, $5b4e90778a3057f7$export$f5708dca728d7177)(depth <= $530670580bb81492$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $530670580bb81492$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $4dd5575669f568c4$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $e825571289930f38$export$31f9caa2600b5723)(fallback) ? $530670580bb81492$export$289398774300c991(fallback, element, depth + 1) : fallback;
}





function $fae5c304adc96145$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $19720e90f9cdb509$export$ade84c85e44a6cb1)(value);
    else return true;
}




/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $1fe837f53cfb3b1d$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $1fe837f53cfb3b1d$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$1fe837f53cfb3b1d$var$invalidTemplates.has(keyframe) && (0, $977cb6dd165f3ea4$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $d9aa1718eaa33425$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $10dbbcc3e3b7f1b4$export$4983792d11b61017 extends (0, $ccfd6437c1ea2b0b$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $e825571289930f38$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $530670580bb81492$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $e84ecee72c952f1e$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $4e2df317a2323a29$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $4e2df317a2323a29$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $568afda14de8ef11$export$8e5250d1aa9bf370)(originType) && (0, $568afda14de8ef11$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $fae5c304adc96145$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $1fe837f53cfb3b1d$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $568afda14de8ef11$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $568afda14de8ef11$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}


class $87a91b280274dec7$export$e49735c2a366bdc7 extends (0, $7c2644a6dbb5dbc6$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $10dbbcc3e3b7f1b4$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $b5f9d7313c47a627$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}








function $c6d4915172d06bb0$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c6d4915172d06bb0$export$23fea75b03ac16b3 extends (0, $87a91b280274dec7$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $6d7feb0adf7f2423$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key)) return (0, $d588fe87ae6d0c90$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $c6d4915172d06bb0$export$3735103072e4a80(instance);
            const value = ((0, $e825571289930f38$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $1b37cd07af156842$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $47da4fd8c988bf5f$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $b300eea51fd81342$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}














class $e99a5d9748cb92b7$export$86bcdffbaf733d84 extends (0, $87a91b280274dec7$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $c46d1f0c98e4bf39$export$6459fc9e86be362e);
        this.updateDimensions = ()=>{
            if (this.current && !this.renderState.dimensions) (0, $18885ec2175a1b2e$export$c01c3c7cdbf4420c)(this.current, this.renderState);
        };
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $7214a84e3a9c6096$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $6c0365315399dd10$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $4ab82f3aa0eb7ed0$export$28931db5d57958e5).has(key) ? (0, $a94a49baeb171c48$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $e9f3aa8860df3a98$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    onBindTransform() {
        if (this.current && !this.renderState.dimensions) (0, $243866cd891e9f65$export$2cef06c20297c17d).postRender(this.updateDimensions);
    }
    build(renderState, latestValues, props) {
        (0, $2fd97ff8a837f9a3$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $872015f2b141fc32$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $7d1b1cf2764ed8ce$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $244cf5e3710a432e$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $b7e49a221af3843f$export$88f3fc2fd3766989)(Component) ? new (0, $e99a5d9748cb92b7$export$86bcdffbaf733d84)(options) : new (0, $c6d4915172d06bb0$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $8nGP5.Fragment)
    });
};


const $a4ead5b38c2be406$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $9658972339af1f1f$export$d86feac869a7f0d5)({
    ...(0, $58734ffc5b610f03$export$7f9953c70dacfd7f),
    ...(0, $63676e4877f6cc1c$export$e5b72898e5a201f1),
    ...(0, $8b88ccc73b02d8a3$export$d7d5d435647ed5a0),
    ...(0, $32d24f9401cdee64$export$b3219800bda33a1f)
}, (0, $244cf5e3710a432e$export$56ba0183203348f5));


const $3330ce8a373a64d5$export$e25e478948902b8b = /*@__PURE__*/ (0, $43e685181e025aa9$export$3af29c0efb268f04)((0, $a4ead5b38c2be406$export$46b7e4b9dc6110c3));



var $kSbwP = parcelRequire("kSbwP");

var $8nGP5 = parcelRequire("8nGP5");

var $2DQiR = parcelRequire("2DQiR");
const $c4a354b5f13f3380$export$3ac10165e82bcbe7 = (props)=>{
    const containerRef = (0, $8nGP5.useRef)(null);
    const lottieInstance = (0, $8nGP5.useRef)(null);
    const animationData = props.data;
    const callbackRef = (0, $8nGP5.useRef)(props.onFrame);
    (0, $8nGP5.useEffect)(()=>{
        callbackRef.current = props.onFrame;
    }, [
        props.onFrame
    ]);
    (0, $8nGP5.useEffect)(()=>{
        var _a;
        if (containerRef.current) {
            console.log('Create LOTTIE');
            lottieInstance.current = (0, (/*@__PURE__*/$parcel$interopDefault($2DQiR))).loadAnimation({
                container: containerRef.current,
                renderer: 'svg',
                autoplay: true,
                animationData: animationData
            });
        }
        const onEnterFrame = ()=>{
            var _a;
            const animation = lottieInstance.current;
            if (callbackRef.current) (_a = callbackRef.current) === null || _a === void 0 || _a.call(callbackRef, animation);
        };
        (_a = lottieInstance.current) === null || _a === void 0 || _a.addEventListener('enterFrame', onEnterFrame);
        return ()=>{
            var _a, _b;
            (_a = lottieInstance.current) === null || _a === void 0 || _a.removeEventListener('enterFrame', onEnterFrame);
            (_b = lottieInstance.current) === null || _b === void 0 || _b.destroy();
        };
    }, [
        containerRef.current,
        animationData
    ]);
    const play = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.play();
    };
    const pause = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.pause();
    };
    const stop = ()=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    const goToFrame = (frame)=>{
        var _a;
        return (_a = lottieInstance.current) === null || _a === void 0 ? void 0 : _a.goToAndStop(frame, true);
    };
    return (0, $kSbwP.jsx)("div", {
        onClick: props.onClick,
        style: {
            width: props.width,
            height: props.height
        },
        children: (0, $kSbwP.jsx)("div", {
            ref: containerRef
        })
    });
};



var $a543ba419c39c04a$exports = {};
$a543ba419c39c04a$exports = JSON.parse('{"v":"5.6.10","fr":60,"ip":0,"op":211,"w":1500,"h":1500,"nm":"Composicao  Cheked SB","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"check contornos","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[732.561,693.224,0],"ix":2},"a":{"a":0,"k":[562.5,1218,0],"ix":1},"s":{"a":0,"k":[46.002,46.002,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[387.664,-266.519],[-145.373,266.519],[-387.664,24.229]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":200,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[624.336,1356.333],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[30,30],"e":[100.956,100.956]},{"t":181}],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Grupo 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":100,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":150,"s":[100],"e":[0]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Aparar caminhos 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Tracos 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":690,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Tracos 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":660,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Tracos 10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":630,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Tracos 9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":600,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Tracos 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":570,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Tracos 7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":540,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Tracos 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":510,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Tracos 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":480,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Tracos 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":450,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Tracos 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":420,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Tracos 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":390,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Tracos","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":360,"ix":10},"p":{"a":0,"k":[747,748.52,0],"ix":2},"a":{"a":0,"k":[-24.727,334.38,0],"ix":1},"s":{"a":0,"k":[100,150,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-17,5],[-17,-124]],"c":false},"ix":2},"nm":"Caminho 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":15,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Shape","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":167,"s":[0],"e":[100]},{"t":187}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":161,"s":[0],"e":[100]},{"t":181}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Patchs","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Ellipse Success","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":25,"s":[400,400],"e":[300,300]},{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":35,"s":[300,300],"e":[400,400]},{"t":53}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588237047,0.878431379795,0.560784339905,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":1,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0],"e":[100]},{"t":25}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Ellipse Expand","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[100,100],"e":[899,899]},{"t":181}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":4},"o":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":150,"s":[0],"e":[100]},{"t":181}],"ix":5},"r":1,"bm":0,"nm":"Preenchimento 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":300,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Ellipse Initial","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":137,"s":[900,900],"e":[700,700]},{"i":{"x":[0,0],"y":[1,1]},"o":{"x":[0.333,0.333],"y":[0,0]},"t":150,"s":[700,700],"e":[900,900]},{"t":181}],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":91,"s":[0.1],"e":[100]},{"t":137}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.470588235294,0.878431372549,0.560784313725,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":91,"op":391,"st":91,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Initial Loading","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[750,750,0],"ix":2},"a":{"a":0,"k":[15,-11,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[900,900],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Caminho da elipse 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.203921568627,0.121568627451,0.592156862745,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Tra\xc3\x83\xc2\xa7ado 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[15,-11],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transformar"}],"nm":"Elipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":22,"s":[0],"e":[99.9]},{"t":90}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0.1],"e":[100]},{"t":86}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.203921568627,0.121568627451,0.592156862745,1],"ix":3},"o":{"a":0,"k":0,"ix":4},"w":{"a":0,"k":50,"ix":5},"lc":2,"lj":1,"ml":4,"bm":10,"nm":"Borda","mn":"ADBE Vector Graphic - Stroke","hd":false}],"ip":0,"op":91,"st":0,"bm":0}],"markers":[]}');


var $d8d03341d2feac10$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d8d03341d2feac10$var$getIsFileReady = (doc)=>{
    if (doc.status == 'completed') {
        if ((doc === null || doc === void 0 ? void 0 : doc.ragStatus) == 'completed') return true;
    }
    return false;
};
const $d8d03341d2feac10$var$ProcessingAnimation = ()=>{
    const [isPresent, safeToRemove] = (0, $dc40494ff9a8b7a9$export$2a8c16d82a0a0e26)();
    const [didFinishAnimation, setDidFinishAnimation] = (0, $8nGP5.useState)(false);
    const isAnimOut = !isPresent;
    const onEnterFrame = (lottie)=>{
        const frame = lottie.currentFrame;
        if (isPresent && frame > 84) lottie.goToAndPlay(0, true);
        else if (frame > 200) {
            lottie.goToAndStop(200, true);
            setTimeout(()=>{
                setDidFinishAnimation(true);
            }, 500);
        }
    };
    (0, $8nGP5.useEffect)(()=>{
        if (!isPresent && didFinishAnimation) safeToRemove();
    }, [
        isPresent,
        didFinishAnimation
    ]);
    return (0, $kSbwP.jsx)((0, $c4a354b5f13f3380$export$3ac10165e82bcbe7), {
        width: 50,
        height: 50,
        data: (0, (/*@__PURE__*/$parcel$interopDefault($a543ba419c39c04a$exports))),
        onFrame: onEnterFrame
    });
};
const $d8d03341d2feac10$var$ProjectFileButtons = (props)=>{
    const viewBtn = (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).button('View', (file)=>{
        props.onView();
    });
    function makeDeleteButton(isEnabled) {
        return (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).button('Delete', (file)=>{
            props.onDelete();
        }, null, isEnabled);
    }
    const deleteBtn = makeDeleteButton(props.deleteEnabled);
    return (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        fillCell: true,
        justify: "around",
        style: {
            gap: '10px',
            marginRight: '5px'
        },
        children: [
            viewBtn,
            deleteBtn
        ]
    });
};
const $d8d03341d2feac10$export$3605042b726118fb = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const [loadedOnMount, setLoadedOnMount] = (0, $8nGP5.useState)(null);
    const projectFilesRaw = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().projectFiles.files;
    const fileKeys = Object.keys(projectFilesRaw);
    if (loadedOnMount == null) {
        var loaded = {};
        fileKeys.forEach((key)=>{
            const file = projectFilesRaw[key];
            loaded[key] = $d8d03341d2feac10$var$getIsFileReady(file);
        });
        setLoadedOnMount(loaded);
    }
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const reportId = store.selectedReportId;
    const companyName = store.query.companyName;
    const targetUploadStorage = {
        type: 'rag',
        reportId: reportId
    };
    function seeFile(fileKey) {
        if (fileKey === store.selectedReportId) props.requestSeeFile(query.value('pdfViewUrl'), fileKey);
        else {
            const fileUrl = projectFilesRaw[fileKey].url;
            props.requestSeeFile(fileUrl, fileKey);
        }
    }
    function deleteFile(fileKey) {
        const areYouSure = window.confirm('Are you sure you want to delete this file? ' + fileKey);
        function deleteFile() {
            return $d8d03341d2feac10$var$__awaiter(this, void 0, void 0, function*() {
                const storage = (0, $fa12c9399a1a76ec$export$39e0a5bed87a3667)();
                const deleteFileName = projectFilesRaw[fileKey].filename;
                storage.deleteFileFromStorage(targetUploadStorage, deleteFileName);
                const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                fb.deleteProjectFile(reportId, fileKey);
                fb.triggerScanRagFiles();
            });
        }
        if (areYouSure) deleteFile();
    }
    const columns = [
        {
            column: {
                source: null,
                display: 'Topics'
            },
            style: {
                justifyContent: 'start',
                alignItems: 'start'
            },
            element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).sources,
            overrideValue: (field, column)=>{
                var _a, _b;
                const doc = projectFilesRaw[field.source];
                return (_b = (_a = doc === null || doc === void 0 ? void 0 : doc.summary) === null || _a === void 0 ? void 0 : _a.topics) !== null && _b !== void 0 ? _b : [];
            }
        },
        {
            column: {
                source: 'saveKey',
                display: 'View'
            },
            element: (row, col, data)=>{
                const doc = projectFilesRaw[row.field.source];
                const isFileReady = $d8d03341d2feac10$var$getIsFileReady(doc);
                var elm = null;
                const baseMotionConfig = {
                    initial: {
                        opacity: 0
                    },
                    animate: {
                        opacity: 1
                    },
                    exit: {
                        opacity: 0
                    }
                };
                if (isFileReady) {
                    const delay = loadedOnMount[row.field.source] ? 0 : 5.0;
                    if (delay > 0) console.log('delay', delay, row.field.source);
                    elm = /*#__PURE__*/ (0, $8nGP5.createElement)((0, $3330ce8a373a64d5$export$e25e478948902b8b).div, Object.assign({}, baseMotionConfig, {
                        key: doc.saveKey,
                        transition: {
                            duration: 0.3,
                            delay: delay
                        }
                    }), (0, $kSbwP.jsx)($d8d03341d2feac10$var$ProjectFileButtons, {
                        onView: ()=>{
                            seeFile(doc.saveKey);
                        },
                        onDelete: ()=>{
                            deleteFile(doc.saveKey);
                            if (loadedOnMount[doc.saveKey]) setLoadedOnMount(Object.assign(Object.assign({}, loadedOnMount), {
                                [doc.saveKey]: false
                            }));
                        },
                        deleteEnabled: doc.saveKey !== reportId
                    }));
                } else {
                    const variants = {
                        initial: {
                            opacity: 0
                        },
                        animate: {
                            opacity: 1
                        },
                        exit: {
                            opacity: 0,
                            transition: {
                                duration: 0.3,
                                delay: 4.5
                            } // delay out
                        }
                    };
                    elm = (0, $kSbwP.jsx)((0, $3330ce8a373a64d5$export$e25e478948902b8b).div, {
                        initial: "initial",
                        animate: "animate",
                        exit: "exit",
                        variants: variants,
                        children: (0, $kSbwP.jsx)($d8d03341d2feac10$var$ProcessingAnimation, {})
                    }, doc.saveKey + '_animation');
                }
                return (0, $kSbwP.jsx)((0, $8c0877f2b5fef61a$export$3ae376d12526dd6f), {
                    mode: "popLayout",
                    children: elm
                });
            }
        }
    ];
    fileKeys.sort((a, b)=>{
        var _a, _b, _c, _d, _e, _f;
        if (a === store.selectedReportId) return -1;
        if (b === store.selectedReportId) return 1;
        var bDate = new Date((_c = (_b = (_a = projectFilesRaw[b]) === null || _a === void 0 ? void 0 : _a.summary) === null || _b === void 0 ? void 0 : _b.created_at) !== null && _c !== void 0 ? _c : 0);
        var aDate = new Date((_f = (_e = (_d = projectFilesRaw[a]) === null || _d === void 0 ? void 0 : _d.summary) === null || _e === void 0 ? void 0 : _e.created_at) !== null && _f !== void 0 ? _f : 0);
        return bDate.getTime() - aDate.getTime();
    });
    const projectFiles = fileKeys.map((fileKey)=>{
        function makeLabelsRow(fileKey) {
            var _a, _b;
            const file = projectFilesRaw[fileKey];
            return {
                field: {
                    source: file.saveKey,
                    display: file.filename.replace('.pdf', ''),
                    description: (_b = (_a = file === null || file === void 0 ? void 0 : file.summary) === null || _a === void 0 ? void 0 : _a.created_at) !== null && _b !== void 0 ? _b : 'N/A'
                },
                value: (_field, column)=>{
                    var _a;
                    try {
                        if (column.source) {
                            if (column.source === 'created_at') {
                                var ret = file.summary[column.source];
                                return ret !== null && ret !== void 0 ? ret : '';
                            } else return (_a = file[column.source]) !== null && _a !== void 0 ? _a : 'N/A';
                        }
                    } catch (_b) {
                        return 'N/A';
                    }
                },
                // onClick: () => {
                //     props.requestSeeFile(file.url, file.filename);
                // },
                label: (0, $d121fd2a7a5df6ff$export$3d23a8262daf519).label,
                element: (0, $7d2817d1c3724d77$export$2fae71e1297dd07b).value
            };
        }
        const clsValues = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($3e24f02855c82492$export$637f169d296cfe12);
        return (0, $kSbwP.jsx)((0, $58be81631dcdd257$export$5dd4673b7f9fa87b), {
            className: clsValues,
            columns: columns,
            rows: [
                makeLabelsRow(fileKey)
            ],
            noHeaderRow: true
        }, fileKey);
    });
    return(// <ScrollPanel
    //     enableHideScrollUntilMouseOver={true}
    //     disableKeyboardScroll={true}
    // >
    (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        fillCell: true,
        shadow: true,
        children: (0, $kSbwP.jsxs)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
            disableKeyboardScroll: true,
            style: {
                paddingRight: '0px'
            },
            children: [
                (0, $kSbwP.jsx)((0, $2b38151664cc4c33$export$968713404ca1c9aa), {
                    title: "Project Files"
                }),
                (0, $kSbwP.jsx)((0, $8c0877f2b5fef61a$export$3ae376d12526dd6f), {
                    children: projectFiles.map((file, index)=>{
                        return (0, $kSbwP.jsx)((0, $3330ce8a373a64d5$export$e25e478948902b8b).div, {
                            initial: {
                                opacity: 0,
                                x: -10
                            },
                            animate: {
                                opacity: 1,
                                x: 0
                            },
                            exit: {
                                opacity: 0,
                                x: -10
                            },
                            transition: {
                                duration: 0.3,
                                delay: index * 0.1
                            },
                            children: file
                        }, file.key);
                    })
                }),
                (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
                    className: $3e24f02855c82492$export$a59643d115b68bf0,
                    display: `+ File`,
                    toasterMessage: `${companyName}: %name%`,
                    storageTarget: targetUploadStorage,
                    onUpload: (fileName)=>{
                        const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                        fb.addDummyProjectFile(reportId, fileName);
                        fb.triggerScanRagFiles();
                    }
                })
            ]
        })
    }));
});



var $kSbwP = parcelRequire("kSbwP");






var $kSbwP = parcelRequire("kSbwP");

var $kSbwP = parcelRequire("kSbwP");

var $de360348d8e02af4$export$d110acd1eb4bf5ee;
var $de360348d8e02af4$export$c945096f7c61efa;
var $de360348d8e02af4$export$d531d37146cc5d63;
var $de360348d8e02af4$export$82e6205b15e6c637;
$de360348d8e02af4$export$d110acd1eb4bf5ee = `LLS8Uq_chatMessage`;
$de360348d8e02af4$export$c945096f7c61efa = `LLS8Uq_chatmessage`;
$de360348d8e02af4$export$d531d37146cc5d63 = `LLS8Uq_citation_class`;
$de360348d8e02af4$export$82e6205b15e6c637 = `LLS8Uq_fadeIn`;
$de360348d8e02af4$export$82e6205b15e6c637;


var $4a6c6cd3ba57d1fc$exports = {};
/*! @license DOMPurify 3.2.5 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.5/LICENSE */ (function(global, factory) {
    $4a6c6cd3ba57d1fc$exports = factory();
})($4a6c6cd3ba57d1fc$exports, function() {
    'use strict';
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== 'undefined' && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const arraySplice = unapply(Array.prototype.splice);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param func - The function to be wrapped and called.
   * @returns A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param func - The constructor function to be wrapped and called.
   * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param set - The set to which elements will be added.
   * @param array - The array containing elements to be added to the set.
   * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === 'string') {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Clean up an array to harden against CSPP
   *
   * @param array - The array to be cleaned.
   * @returns The cleaned version of the array
   */ function cleanArray(array) {
        for(let index = 0; index < array.length; index++){
            const isPropertyExist = objectHasOwnProperty(array, index);
            if (!isPropertyExist) array[index] = null;
        }
        return array;
    }
    /**
   * Shallow clone an object
   *
   * @param object - The object to be cloned.
   * @returns A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object)){
            const isPropertyExist = objectHasOwnProperty(object, property);
            if (isPropertyExist) {
                if (Array.isArray(value)) newObject[property] = cleanArray(value);
                else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = clone(value);
                else newObject[property] = value;
            }
        }
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param object - The object to look up the getter function in its prototype chain.
   * @param prop - The property name for which to find the getter function.
   * @returns The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue() {
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    const svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    const svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feDropShadow',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    const mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover',
        'mprescripts'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    const text = freeze([
        '#text'
    ]);
    const html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'popover',
        'popovertarget',
        'popovertargetaction',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'wrap',
        'xmlns',
        'slot'
    ]);
    const svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'amplitude',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'exponent',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'intercept',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'slope',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'tablevalues',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    const mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    const xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        ARIA_ATTR: ARIA_ATTR,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        CUSTOM_ELEMENT: CUSTOM_ELEMENT,
        DATA_ATTR: DATA_ATTR,
        DOCTYPE_NAME: DOCTYPE_NAME,
        ERB_EXPR: ERB_EXPR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR
    });
    /* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    const NODE_TYPE = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        // Deprecated
        entityNode: 6,
        // Deprecated
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12 // Deprecated
    };
    const getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param trustedTypes The policy factory.
   * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = 'data-tt-policy-suffix';
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    const _createHooksMap = function _createHooksMap() {
        return {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
        };
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        DOMPurify.version = '3.2.5';
        DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== NODE_TYPE.document || !window1.Element) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        const remove = lookupGetter(ElementPrototype, 'remove');
        const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            const template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = '';
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = _createHooksMap();
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ let SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        let HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = objectHasOwnProperty(cfg, 'ALLOWED_TAGS') ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = objectHasOwnProperty(cfg, 'ALLOWED_ATTR') ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = objectHasOwnProperty(cfg, 'FORBID_CONTENTS') ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = objectHasOwnProperty(cfg, 'FORBID_TAGS') ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = objectHasOwnProperty(cfg, 'FORBID_ATTR') ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            MATHML_TEXT_INTEGRATION_POINTS = cfg.MATHML_TEXT_INTEGRATION_POINTS || MATHML_TEXT_INTEGRATION_POINTS;
            HTML_INTEGRATION_POINTS = cfg.HTML_INTEGRATION_POINTS || HTML_INTEGRATION_POINTS;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, text);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
                // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML('');
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, [
            ...svg$1,
            ...svgFilters,
            ...svgDisallowed
        ]);
        const ALL_MATHML_TAGS = addToSet({}, [
            ...mathMl$1,
            ...mathMlDisallowed
        ]);
        /**
     * @param element a DOM element whose namespace is being checked
     * @returns Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                getParentNode(node).removeChild(node);
            } catch (_) {
                remove(node);
            }
        };
        /**
     * _removeAttribute
     *
     * @param name an Attribute name
     * @param element a DOM node
     */ const _removeAttribute = function _removeAttribute(name, element) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: element.getAttributeNode(name),
                    from: element
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: element
                });
            }
            element.removeAttribute(name);
            // We void attribute values for unremovable "is" attributes
            if (name === 'is') {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(element);
                } catch (_) {}
                else try {
                    element.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param dirty - a string of dirty markup
     * @return a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param root The root element or node to start traversing on.
     * @return The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
        };
        /**
     * _isClobbered
     *
     * @param element element to check for clobbering attacks
     * @return true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(element) {
            return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param value object to check whether it's a DOM node
     * @return true is object is a DOM node
     */ const _isNode = function _isNode(value) {
            return typeof Node === 'function' && value instanceof Node;
        };
        function _executeHooks(hooks, currentNode, data) {
            arrayForEach(hooks, (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        }
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     * @param currentNode to check for permission to exist
     * @return true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w!]/g, currentNode.innerHTML) && regExpTest(/<[/\w!]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === NODE_TYPE.progressingInstruction) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i){
                            const childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, ' ');
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param lcTag Lowercase tag name of containing element.
     * @param lcName Lowercase attribute name.
     * @param value Attribute value.
     * @return Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param tagName name of the tag of the node to sanitize
     * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            const hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR,
                forceKeepAttr: undefined
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === 'value' ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, ' ');
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
        };
        // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, ' ');
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            arrayPush(hooks[entryPoint], hookFunction);
        };
        DOMPurify.removeHook = function(entryPoint, hookFunction) {
            if (hookFunction !== undefined) {
                const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
                return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
            }
            return arrayPop(hooks[entryPoint]);
        };
        DOMPurify.removeHooks = function(entryPoint) {
            hooks[entryPoint] = [];
        };
        DOMPurify.removeAllHooks = function() {
            hooks = _createHooksMap();
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});


var $e0f2436fd88d0d31$exports = {};
/**
 * marked v15.0.9 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($e0f2436fd88d0d31$exports);
})($e0f2436fd88d0d31$exports, function(exports1) {
    'use strict';
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    const noopTest = {
        exec: ()=>null
    };
    function edit(regex, opt = '') {
        let source = typeof regex === 'string' ? regex : regex.source;
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === 'string' ? val : val.source;
                valSource = valSource.replace(other.caret, '$1');
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    const other = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceTabs: /^\t+/,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] /,
        listReplaceTask: /^\[[ xX]\] +/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`),
        hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
        htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, 'i')
    };
    /**
     * Block-Level Grammar
     */ const newline = /^(?:[ \t]*(?:\n|$))+/;
    const blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
    const lheading = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/\|table/g, '') // table not in commonmark
    .getRegex();
    const lheadingGfm = edit(lheadingCore).replace(/bull/g, bullet) // lists can interrupt
    .replace(/blockCode/g, /(?: {4}| {0,3}\t)/) // indented code blocks can interrupt
    .replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/) // fenced code blocks can interrupt
    .replace(/blockquote/g, / {0,3}>/) // blockquote can interrupt
    .replace(/heading/g, / {0,3}#{1,6}/) // ATX heading can interrupt
    .replace(/html/g, / {0,3}<[^\n>]+>\n/) // block html can interrupt
    .replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/) // table can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace('label', _blockLabel).replace('title', /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", 'i').replace('comment', _comment).replace('tag', _tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
    .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace('paragraph', paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('blockquote', ' {0,3}>').replace('code', '(?: {4}| {0,3}\t)[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        lheading: lheadingGfm,
        table: gfmTable,
        paragraph: edit(_paragraph).replace('hr', hr).replace('heading', ' {0,3}#{1,6}(?:\\s|$)').replace('|lheading', '') // setext headings don't interrupt commonmark paragraphs
        .replace('table', gfmTable) // interrupt paragraphs with table
        .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
        .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace('hr', hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', lheading).replace('|table', '').replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').replace('|tag', '').getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape$1 = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = /[\p{P}\p{S}]/u;
    const _punctuationOrSpace = /[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
    const punctuation = edit(/^((?![*_])punctSpace)/, 'u').replace(/punctSpace/g, _punctuationOrSpace).getRegex();
    // GFM allows ~ inside strong and em for strikethrough
    const _punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
    const _punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
    const _notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
    const emStrongLDelim = edit(emStrongLDelimCore, 'u').replace(/punct/g, _punctuation).getRegex();
    const emStrongLDelimGfm = edit(emStrongLDelimCore, 'u').replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    const emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)"; // (6) a***a can be either Left or Right Delimiter
    const emStrongRDelimAst = edit(emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAstGfm = edit(emStrongRDelimAstCore, 'gu').replace(/notPunctSpace/g, _notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, _punctuationOrSpaceGfmStrongEm).replace(/punct/g, _punctuationGfmStrongEm).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", 'gu') // (5) #___# can be either Left or Right Delimiter
    .replace(/notPunctSpace/g, _notPunctuationOrSpace).replace(/punctSpace/g, _punctuationOrSpace).replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\(punct)/, 'gu').replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace('scheme', /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace('email', /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace('(?:-->|$)', '-->').getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace('comment', _inlineComment).replace('attribute', /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace('label', _inlineLabel).replace('href', /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace('title', /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace('label', _inlineLabel).replace('ref', _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace('ref', _blockLabel).getRegex();
    const reflinkSearch = edit('reflink|nolink(?!\\()', 'g').replace('reflink', reflink).replace('nolink', nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape$1,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        emStrongRDelimAst: emStrongRDelimAstGfm,
        emStrongLDelim: emStrongLDelimGfm,
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, 'i').replace('email', /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace('{2,}', '*').getRegex(),
        text: edit(inlineGfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Helpers
     */ const escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (other.escapeTest.test(html)) return html.replace(other.escapeReplace, getEscapeReplacement);
        } else {
            if (other.escapeTestNoEncode.test(html)) return html.replace(other.escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(other.percentDecode, '%');
        } catch  {
            return null;
        }
        return href;
    }
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(other.findPipe, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(other.splitPipe);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push('');
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(other.slashPipe, '|');
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return '';
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && true) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        if (level > 0) return -2;
        return -1;
    }
    function outputLink(cap, link, raw, lexer, rules) {
        const href = link.href;
        const title = link.title || null;
        const text = cap[1].replace(rules.other.outputLinkReplace, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            const token = {
                type: 'link',
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: text
        };
    }
    function indentCodeCompensation(raw, text, rules) {
        const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split('\n').map((node)=>{
            const matchIndentInNode = node.match(rules.other.beginningSpace);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: 'space',
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(this.rules.other.codeRemoveIndent, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || '', this.rules);
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, '$1') : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (this.rules.other.endingHash.test(text)) {
                    const trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: rtrim(cap[0], '\n')
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                let lines = rtrim(cap[0], '\n').split('\n');
                let raw = '';
                let text = '';
                const tokens = [];
                while(lines.length > 0){
                    let inBlockquote = false;
                    const currentLines = [];
                    let i;
                    for(i = 0; i < lines.length; i++){
                        // get lines up to a continuation
                        if (this.rules.other.blockquoteStart.test(lines[i])) {
                            currentLines.push(lines[i]);
                            inBlockquote = true;
                        } else if (!inBlockquote) currentLines.push(lines[i]);
                        else break;
                    }
                    lines = lines.slice(i);
                    const currentRaw = currentLines.join('\n');
                    const currentText = currentRaw// precede setext continuation with 4 spaces so it isn't a setext
                    .replace(this.rules.other.blockquoteSetextReplace, '\n    $1').replace(this.rules.other.blockquoteSetextReplace2, '');
                    raw = raw ? `${raw}\n${currentRaw}` : currentRaw;
                    text = text ? `${text}\n${currentText}` : currentText;
                    // parse blockquote lines as top level tokens
                    // merge paragraphs if this is a continuation
                    const top = this.lexer.state.top;
                    this.lexer.state.top = true;
                    this.lexer.blockTokens(currentText, tokens, true);
                    this.lexer.state.top = top;
                    // if there is no continuation then we are done
                    if (lines.length === 0) break;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'code') break;
                    else if (lastToken?.type === 'blockquote') {
                        // include continuation in nested blockquote
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.blockquote(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                        break;
                    } else if (lastToken?.type === 'list') {
                        // include continuation in nested list
                        const oldToken = lastToken;
                        const newText = oldToken.raw + '\n' + lines.join('\n');
                        const newToken = this.list(newText);
                        tokens[tokens.length - 1] = newToken;
                        raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                        text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                        lines = newText.substring(tokens.at(-1).raw.length).split('\n');
                        continue;
                    }
                }
                return {
                    type: 'blockquote',
                    raw: raw,
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
                // Get next list item
                const itemRegex = this.rules.other.listItemRegex(bull);
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    let raw = '';
                    let itemContents = '';
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split('\n', 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>' '.repeat(3 * t.length));
                    let nextLine = src.split('\n', 1)[0];
                    let blankLine = !line.trim();
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else if (blankLine) indent = cap[1].length + 1;
                    else {
                        indent = cap[2].search(this.rules.other.nonSpaceChar); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                        const hrRegex = this.rules.other.hrRegex(indent);
                        const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                        const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                        const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split('\n', 1)[0];
                            let nextLineWithoutTabs;
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) {
                                nextLine = nextLine.replace(this.rules.other.listReplaceNesting, '  ');
                                nextLineWithoutTabs = nextLine;
                            } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, '    ');
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of html block
                            if (htmlBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(nextLine)) break;
                            if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += '\n' + nextLineWithoutTabs.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.replace(this.rules.other.tabCharGlobal, '    ').search(this.rules.other.nonSpaceChar) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLineWithoutTabs.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = this.rules.other.listIsTask.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(this.rules.other.listReplaceTask, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                const lastItem = list.items.at(-1);
                if (lastItem) {
                    lastItem.raw = lastItem.raw.trimEnd();
                    lastItem.text = lastItem.text.trimEnd();
                } else // not a list since there were no items
                return;
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === 'space');
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: 'html',
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style',
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, ' ');
                const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, '$1').replace(this.rules.inline.anyPunctuation, '$1') : '';
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, '$1') : cap[3];
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!this.rules.other.tableDelimiter.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(this.rules.other.tableAlignChars, '').split('|');
            const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, '').split('\n') : [];
            const item = {
                type: 'table',
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (this.rules.other.tableAlignRight.test(align)) item.align.push('right');
                else if (this.rules.other.tableAlignCenter.test(align)) item.align.push('center');
                else if (this.rules.other.tableAlignLeft.test(align)) item.align.push('left');
                else item.align.push(null);
            }
            for(let i = 0; i < headers.length; i++)item.header.push({
                text: headers[i],
                tokens: this.lexer.inline(headers[i]),
                header: true,
                align: item.align[i]
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell, i)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell),
                    header: false,
                    align: item.align[i]
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: cap[1]
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex === -2) // more open parens than closed
                    return;
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                let href = cap[2];
                let title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = this.rules.other.pedanticHrefTitle.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (this.rules.other.startAngleBracket.test(href)) {
                    if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, '$1') : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, '$1') : title
                }, cap[0], this.lexer, this.rules);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, ' ');
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer, this.rules);
            }
        }
        emStrong(src, maskedSrc, prevChar = '') {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
            const nextChar = match[1] || match[2] || '';
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === '*' ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(this.rules.other.newLineCharGlobal, ' ');
                const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
                const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === '@') {
                    text = cap[1];
                    href = 'mailto:' + text;
                } else {
                    text = cap[1];
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === '@') {
                    text = cap[0];
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? '';
                    }while (prevCapZero !== cap[0]);
                    text = cap[0];
                    if (cap[1] === 'www.') href = 'http://' + cap[0];
                    else href = cap[0];
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                const escaped = this.lexer.state.inRawBlock;
                return {
                    type: 'text',
                    raw: cap[0],
                    text: cap[0],
                    escaped: escaped
                };
            }
        }
    }
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                other: other,
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(other.carriageReturn, '\n');
            this.blockTokens(src, this.tokens);
            for(let i = 0; i < this.inlineQueue.length; i++){
                const next = this.inlineQueue[i];
                this.inlineTokens(next.src, next.tokens);
            }
            this.inlineQueue = [];
            return this.tokens;
        }
        blockTokens(src, tokens = [], lastParagraphClipped = false) {
            if (this.options.pedantic) src = src.replace(other.tabCharGlobal, '    ').replace(other.spaceLine, '');
            while(src){
                let token;
                if (this.options.extensions?.block?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.raw.length === 1 && lastToken !== undefined) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    lastToken.raw += '\n';
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'paragraph' || lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    const lastToken = tokens.at(-1);
                    if (lastParagraphClipped && lastToken?.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue.at(-1).src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match = null;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            let keepPrevChar = false;
            let prevChar = '';
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false;
                let token;
                // extensions
                if (this.options.extensions?.inline?.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    const lastToken = tokens.at(-1);
                    if (token.type === 'text' && lastToken?.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                let cutSrc = src;
                if (this.options.extensions?.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    const lastToken = tokens.at(-1);
                    if (lastToken?.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        parser;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(token) {
            return '';
        }
        code({ text: text, lang: lang, escaped: escaped }) {
            const langString = (lang || '').match(other.notSpaceStart)?.[0];
            const code = text.replace(other.endingNewline, '') + '\n';
            if (!langString) return '<pre><code>' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
            return '<pre><code class="language-' + escape(langString) + '">' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
        }
        blockquote({ tokens: tokens }) {
            const body = this.parser.parse(tokens);
            return `<blockquote>\n${body}</blockquote>\n`;
        }
        html({ text: text }) {
            return text;
        }
        heading({ tokens: tokens, depth: depth }) {
            return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>\n`;
        }
        hr(token) {
            return '<hr>\n';
        }
        list(token) {
            const ordered = token.ordered;
            const start = token.start;
            let body = '';
            for(let j = 0; j < token.items.length; j++){
                const item = token.items[j];
                body += this.listitem(item);
            }
            const type = ordered ? 'ol' : 'ul';
            const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startAttr + '>\n' + body + '</' + type + '>\n';
        }
        listitem(item) {
            let itemBody = '';
            if (item.task) {
                const checkbox = this.checkbox({
                    checked: !!item.checked
                });
                if (item.loose) {
                    if (item.tokens[0]?.type === 'paragraph') {
                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                            item.tokens[0].tokens[0].text = checkbox + ' ' + escape(item.tokens[0].tokens[0].text);
                            item.tokens[0].tokens[0].escaped = true;
                        }
                    } else item.tokens.unshift({
                        type: 'text',
                        raw: checkbox + ' ',
                        text: checkbox + ' ',
                        escaped: true
                    });
                } else itemBody += checkbox + ' ';
            }
            itemBody += this.parser.parse(item.tokens, !!item.loose);
            return `<li>${itemBody}</li>\n`;
        }
        checkbox({ checked: checked }) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox">';
        }
        paragraph({ tokens: tokens }) {
            return `<p>${this.parser.parseInline(tokens)}</p>\n`;
        }
        table(token) {
            let header = '';
            // header
            let cell = '';
            for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
            header += this.tablerow({
                text: cell
            });
            let body = '';
            for(let j = 0; j < token.rows.length; j++){
                const row = token.rows[j];
                cell = '';
                for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
                body += this.tablerow({
                    text: cell
                });
            }
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        }
        tablerow({ text: text }) {
            return `<tr>\n${text}</tr>\n`;
        }
        tablecell(token) {
            const content = this.parser.parseInline(token.tokens);
            const type = token.header ? 'th' : 'td';
            const tag = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong({ tokens: tokens }) {
            return `<strong>${this.parser.parseInline(tokens)}</strong>`;
        }
        em({ tokens: tokens }) {
            return `<em>${this.parser.parseInline(tokens)}</em>`;
        }
        codespan({ text: text }) {
            return `<code>${escape(text, true)}</code>`;
        }
        br(token) {
            return '<br>';
        }
        del({ tokens: tokens }) {
            return `<del>${this.parser.parseInline(tokens)}</del>`;
        }
        link({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + escape(title) + '"';
            out += '>' + text + '</a>';
            return out;
        }
        image({ href: href, title: title, text: text }) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return escape(text);
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${escape(title)}"`;
            out += '>';
            return out;
        }
        text(token) {
            return 'tokens' in token && token.tokens ? this.parser.parseInline(token.tokens) : 'escaped' in token && token.escaped ? token.text : escape(token.text);
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong({ text: text }) {
            return text;
        }
        em({ text: text }) {
            return text;
        }
        codespan({ text: text }) {
            return text;
        }
        del({ text: text }) {
            return text;
        }
        html({ text: text }) {
            return text;
        }
        text({ text: text }) {
            return text;
        }
        link({ text: text }) {
            return '' + text;
        }
        image({ text: text }) {
            return '' + text;
        }
        br() {
            return '';
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.renderer.parser = this;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = '';
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const genericToken = anyToken;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(genericToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case 'space':
                        out += this.renderer.space(token);
                        continue;
                    case 'hr':
                        out += this.renderer.hr(token);
                        continue;
                    case 'heading':
                        out += this.renderer.heading(token);
                        continue;
                    case 'code':
                        out += this.renderer.code(token);
                        continue;
                    case 'table':
                        out += this.renderer.table(token);
                        continue;
                    case 'blockquote':
                        out += this.renderer.blockquote(token);
                        continue;
                    case 'list':
                        out += this.renderer.list(token);
                        continue;
                    case 'html':
                        out += this.renderer.html(token);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(token);
                        continue;
                    case 'text':
                        {
                            let textToken = token;
                            let body = this.renderer.text(textToken);
                            while(i + 1 < tokens.length && tokens[i + 1].type === 'text'){
                                textToken = tokens[++i];
                                body += '\n' + this.renderer.text(textToken);
                            }
                            if (top) out += this.renderer.paragraph({
                                type: 'paragraph',
                                raw: body,
                                text: body,
                                tokens: [
                                    {
                                        type: 'text',
                                        raw: body,
                                        text: body,
                                        escaped: true
                                    }
                                ]
                            });
                            else out += body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return '';
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer = this.renderer) {
            let out = '';
            for(let i = 0; i < tokens.length; i++){
                const anyToken = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions?.renderers?.[anyToken.type]) {
                    const ret = this.options.extensions.renderers[anyToken.type].call({
                        parser: this
                    }, anyToken);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(anyToken.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                const token = anyToken;
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token);
                        break;
                    case 'html':
                        out += renderer.html(token);
                        break;
                    case 'link':
                        out += renderer.link(token);
                        break;
                    case 'image':
                        out += renderer.image(token);
                        break;
                    case 'strong':
                        out += renderer.strong(token);
                        break;
                    case 'em':
                        out += renderer.em(token);
                        break;
                    case 'codespan':
                        out += renderer.codespan(token);
                        break;
                    case 'br':
                        out += renderer.br(token);
                        break;
                    case 'del':
                        out += renderer.del(token);
                        break;
                    case 'text':
                        out += renderer.text(token);
                        break;
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return '';
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        block;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            'preprocess',
            'postprocess',
            'processAllTokens'
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
        /**
         * Process all tokens before walk tokens
         */ processAllTokens(tokens) {
            return tokens;
        }
        /**
         * Provide function to tokenize markdown
         */ provideLexer() {
            return this.block ? _Lexer.lex : _Lexer.lexInline;
        }
        /**
         * Provide function to parse tokens
         */ provideParser() {
            return this.block ? _Parser.parse : _Parser.parseInline;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.parseMarkdown(true);
        parseInline = this.parseMarkdown(false);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case 'table':
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case 'list':
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                const tokens = genericToken[childTokens].flat(Infinity);
                                values = values.concat(this.walkTokens(tokens, callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error('extension name required');
                        if ('renderer' in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ('tokenizer' in ext) {
                            if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === 'block') {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === 'inline') {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ('childTokens' in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                        if ([
                            'options',
                            'parser'
                        ].includes(prop)) continue;
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || '';
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                        if ([
                            'options',
                            'rules',
                            'lexer'
                        ].includes(prop)) continue;
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                        if ([
                            'options',
                            'block'
                        ].includes(prop)) continue;
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else // @ts-expect-error cannot type hook function dynamically
                        hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        parseMarkdown(blockType) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const parse = (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                const throwError = this.onError(!!opt.silent, !!opt.async);
                // throw error if an extension set async to true but parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) return throwError(new Error('marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise.'));
                // throw error in case of non string input
                if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
                if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
                if (opt.hooks) {
                    opt.hooks.options = opt;
                    opt.hooks.block = blockType;
                }
                const lexer = opt.hooks ? opt.hooks.provideLexer() : blockType ? _Lexer.lex : _Lexer.lexInline;
                const parser = opt.hooks ? opt.hooks.provideParser() : blockType ? _Parser.parse : _Parser.parseInline;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    let tokens = lexer(src, opt);
                    if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
            return parse;
        }
        onError(silent, async) {
            return (e)=>{
                e.message += '\nPlease report this to https://github.com/markedjs/marked.';
                if (silent) {
                    const msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});







var $8nGP5 = parcelRequire("8nGP5");
/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $8nGP5 = parcelRequire("8nGP5");



var $djlMn = parcelRequire("djlMn");
const $b15f45b1897be4d8$var$h = "react-tooltip-core-styles", $b15f45b1897be4d8$var$w = "react-tooltip-base-styles", $b15f45b1897be4d8$var$b = {
    core: !1,
    base: !1
};
function $b15f45b1897be4d8$var$S({ css: e, id: t = $b15f45b1897be4d8$var$w, type: o = "base", ref: l }) {
    var r, n;
    if (!e || "undefined" == typeof document || $b15f45b1897be4d8$var$b[o]) return;
    if ("core" === o && "undefined" != typeof $djlMn && (null === (r = null === $djlMn || void 0 === $djlMn ? void 0 : $djlMn.env) || void 0 === r ? void 0 : r.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== o && "undefined" != typeof $djlMn && (null === (n = null === $djlMn || void 0 === $djlMn ? void 0 : $djlMn.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === o && (t = $b15f45b1897be4d8$var$h), l || (l = {});
    const { insertAt: i } = l;
    if (document.getElementById(t)) return;
    const c = document.head || document.getElementsByTagName("head")[0], s = document.createElement("style");
    s.id = t, s.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(s, c.firstChild) : c.appendChild(s), s.styleSheet ? s.styleSheet.cssText = e : s.appendChild(document.createTextNode(e)), $b15f45b1897be4d8$var$b[o] = !0;
}
function $b15f45b1897be4d8$export$afe978aceb0adefd({ type: e = "base", id: t = $b15f45b1897be4d8$var$w } = {}) {
    if (!$b15f45b1897be4d8$var$b[e]) return;
    "core" === e && (t = $b15f45b1897be4d8$var$h);
    const o = document.getElementById(t);
    "style" === (null == o ? void 0 : o.tagName) ? null == o || o.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $b15f45b1897be4d8$var$b[e] = !1;
}
const $b15f45b1897be4d8$var$E = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: o = null, place: l = "top", offset: r = 10, strategy: n = "absolute", middlewares: i = [
    (0, $322acf408b6b8401$export$cc800923e997bb8)(Number(r)),
    (0, $322acf408b6b8401$export$8a83211c878a3f1f)({
        fallbackAxisSideDirection: "start"
    }),
    (0, $322acf408b6b8401$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: l
    };
    const s = i;
    return o ? (s.push((0, $322acf408b6b8401$export$f2120bbfa5450bd2)({
        element: o,
        padding: 5
    })), (0, $322acf408b6b8401$export$48a53dcb22e581d0)(e, t, {
        placement: l,
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o, middlewareData: l })=>{
        var r, n;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: s, y: a } = null !== (r = l.arrow) && void 0 !== r ? r : {
            x: 0,
            y: 0
        }, u = null !== (n = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[o.split("-")[0]]) && void 0 !== n ? n : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != s ? `${s}px` : "",
                top: null != a ? `${a}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: o
        };
    })) : (0, $322acf408b6b8401$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: n,
        middleware: s
    }).then(({ x: e, y: t, placement: o })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: o
        }));
}, $b15f45b1897be4d8$var$A = (e, t)=>!("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), $b15f45b1897be4d8$var$_ = (e, t, o)=>{
    let l = null;
    const r = function(...r) {
        const n = ()=>{
            l = null, o || e.apply(this, r);
        };
        o && !l && (e.apply(this, r), l = setTimeout(n, t)), o || (l && clearTimeout(l), l = setTimeout(n, t));
    };
    return r.cancel = ()=>{
        l && (clearTimeout(l), l = null);
    }, r;
}, $b15f45b1897be4d8$var$O = (e)=>null !== e && !Array.isArray(e) && "object" == typeof e, $b15f45b1897be4d8$var$k = (e, t)=>{
    if (e === t) return !0;
    if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every((e, o)=>$b15f45b1897be4d8$var$k(e, t[o]));
    if (Array.isArray(e) !== Array.isArray(t)) return !1;
    if (!$b15f45b1897be4d8$var$O(e) || !$b15f45b1897be4d8$var$O(t)) return e === t;
    const o = Object.keys(e), l = Object.keys(t);
    return o.length === l.length && o.every((o)=>$b15f45b1897be4d8$var$k(e[o], t[o]));
}, $b15f45b1897be4d8$var$T = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const o = t.getPropertyValue(e);
        return "auto" === o || "scroll" === o;
    });
}, $b15f45b1897be4d8$var$L = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($b15f45b1897be4d8$var$T(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $b15f45b1897be4d8$var$C = "undefined" != typeof window ? (0, $8nGP5.useLayoutEffect) : (0, $8nGP5.useEffect), $b15f45b1897be4d8$var$R = (e)=>{
    e.current && (clearTimeout(e.current), e.current = null);
}, $b15f45b1897be4d8$var$x = "DEFAULT_TOOLTIP_ID", $b15f45b1897be4d8$var$N = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $b15f45b1897be4d8$var$$ = (0, $8nGP5.createContext)({
    getTooltipData: ()=>$b15f45b1897be4d8$var$N
}), $b15f45b1897be4d8$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [o, l] = (0, $8nGP5.useState)({
        [$b15f45b1897be4d8$var$x]: new Set
    }), [c, s] = (0, $8nGP5.useState)({
        [$b15f45b1897be4d8$var$x]: {
            current: null
        }
    }), a = (e, ...t)=>{
        l((o)=>{
            var l;
            const r = null !== (l = o[e]) && void 0 !== l ? l : new Set;
            return t.forEach((e)=>r.add(e)), {
                ...o,
                [e]: new Set(r)
            };
        });
    }, u = (e, ...t)=>{
        l((o)=>{
            const l = o[e];
            return l ? (t.forEach((e)=>l.delete(e)), {
                ...o
            }) : o;
        });
    }, d = (0, $8nGP5.useCallback)((e = $b15f45b1897be4d8$var$x)=>{
        var t, l;
        return {
            anchorRefs: null !== (t = o[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (l = c[e]) && void 0 !== l ? l : {
                current: null
            },
            attach: (...t)=>a(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    s((o)=>{
                        var l;
                        return (null === (l = o[e]) || void 0 === l ? void 0 : l.current) === t.current ? o : {
                            ...o,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        o,
        c,
        a,
        u
    ]), p = (0, $8nGP5.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($b15f45b1897be4d8$var$$.Provider, {
        value: p
    }, t);
};
function $b15f45b1897be4d8$var$j(e = $b15f45b1897be4d8$var$x) {
    return (0, $8nGP5.useContext)($b15f45b1897be4d8$var$$).getTooltipData(e);
}
const $b15f45b1897be4d8$export$57a09c4864b20b90 = ({ tooltipId: t, children: l, className: r, place: n, content: i, html: c, variant: a, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $b15f45b1897be4d8$var$j(t), b = (0, $8nGP5.useRef)(null);
    return (0, $8nGP5.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip-wrapper", r),
        "data-tooltip-place": n,
        "data-tooltip-content": i,
        "data-tooltip-html": c,
        "data-tooltip-variant": a,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, l);
};
var $b15f45b1897be4d8$var$z = {
    tooltip: "core-styles-module_tooltip__3vRRp",
    fixed: "core-styles-module_fixed__pcSol",
    arrow: "core-styles-module_arrow__cvMwQ",
    noArrow: "core-styles-module_noArrow__xock6",
    clickable: "core-styles-module_clickable__ZuTTB",
    show: "core-styles-module_show__Nt9eE",
    closing: "core-styles-module_closing__sGnxF"
}, $b15f45b1897be4d8$var$D = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $b15f45b1897be4d8$var$q = ({ forwardRef: t, id: l, className: i, classNameArrow: c, variant: u = "dark", anchorId: d, anchorSelect: p, place: v = "top", offset: m = 10, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, wrapper: g, delayShow: A = 0, delayHide: O = 0, float: T = !1, hidden: x = !1, noArrow: N = !1, clickable: $ = !1, closeOnEsc: I = !1, closeOnScroll: B = !1, closeOnResize: q = !1, openEvents: H, closeEvents: M, globalCloseEvents: W, imperativeModeOnly: P, style: V, position: F, afterShow: K, afterHide: U, disableTooltip: X, content: Y, contentWrapperRef: G, isOpen: Z, defaultIsOpen: J = !1, setIsOpen: Q, activeAnchor: ee, setActiveAnchor: te, border: oe, opacity: le, arrowColor: re, role: ne = "tooltip" })=>{
    var ie;
    const ce = (0, $8nGP5.useRef)(null), se = (0, $8nGP5.useRef)(null), ae = (0, $8nGP5.useRef)(null), ue = (0, $8nGP5.useRef)(null), de = (0, $8nGP5.useRef)(null), [pe, ve] = (0, $8nGP5.useState)({
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: v
    }), [me, fe] = (0, $8nGP5.useState)(!1), [ye, he] = (0, $8nGP5.useState)(!1), [we, be] = (0, $8nGP5.useState)(null), Se = (0, $8nGP5.useRef)(!1), ge = (0, $8nGP5.useRef)(null), { anchorRefs: Ee, setActiveAnchor: Ae } = $b15f45b1897be4d8$var$j(l), _e = (0, $8nGP5.useRef)(!1), [Oe, ke] = (0, $8nGP5.useState)([]), Te = (0, $8nGP5.useRef)(!1), Le = w || h.includes("click"), Ce = Le || (null == H ? void 0 : H.click) || (null == H ? void 0 : H.dblclick) || (null == H ? void 0 : H.mousedown), Re = H ? {
        ...H
    } : {
        mouseover: !0,
        focus: !0,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    };
    !H && Le && Object.assign(Re, {
        mouseenter: !1,
        focus: !1,
        mouseover: !1,
        click: !0
    });
    const xe = M ? {
        ...M
    } : {
        mouseout: !0,
        blur: !0,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    };
    !M && Le && Object.assign(xe, {
        mouseleave: !1,
        blur: !1,
        mouseout: !1
    });
    const Ne = W ? {
        ...W
    } : {
        escape: I || !1,
        scroll: B || !1,
        resize: q || !1,
        clickOutsideAnchor: Ce || !1
    };
    P && (Object.assign(Re, {
        mouseover: !1,
        focus: !1,
        mouseenter: !1,
        click: !1,
        dblclick: !1,
        mousedown: !1
    }), Object.assign(xe, {
        mouseout: !1,
        blur: !1,
        mouseleave: !1,
        click: !1,
        dblclick: !1,
        mouseup: !1
    }), Object.assign(Ne, {
        escape: !1,
        scroll: !1,
        resize: !1,
        clickOutsideAnchor: !1
    })), $b15f45b1897be4d8$var$C(()=>(Te.current = !0, ()=>{
            Te.current = !1;
        }), []);
    const $e = (e)=>{
        Te.current && (e && he(!0), setTimeout(()=>{
            Te.current && (null == Q || Q(e), void 0 === Z && fe(e));
        }, 10));
    };
    (0, $8nGP5.useEffect)(()=>{
        if (void 0 === Z) return ()=>null;
        Z && he(!0);
        const e = setTimeout(()=>{
            fe(Z);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        Z
    ]), (0, $8nGP5.useEffect)(()=>{
        if (me !== Se.current) {
            if ($b15f45b1897be4d8$var$R(de), Se.current = me, me) null == K || K();
            else {
                const e = ((e)=>{
                    const t = e.match(/^([\d.]+)(ms|s)$/);
                    if (!t) return 0;
                    const [, o, l] = t;
                    return Number(o) * ("ms" === l ? 1 : 1e3);
                })(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
                de.current = setTimeout(()=>{
                    he(!1), be(null), null == U || U();
                }, e + 25);
            }
        }
    }, [
        me
    ]);
    const Ie = (e)=>{
        ve((t)=>$b15f45b1897be4d8$var$k(t, e) ? t : e);
    }, je = (e = A)=>{
        $b15f45b1897be4d8$var$R(ae), ye ? $e(!0) : ae.current = setTimeout(()=>{
            $e(!0);
        }, e);
    }, Be = (e = O)=>{
        $b15f45b1897be4d8$var$R(ue), ue.current = setTimeout(()=>{
            _e.current || $e(!1);
        }, e);
    }, ze = (e)=>{
        var t;
        if (!e) return;
        const o = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == o ? void 0 : o.isConnected)) return te(null), void Ae({
            current: null
        });
        A ? je() : $e(!0), te(o), Ae({
            current: o
        }), $b15f45b1897be4d8$var$R(ue);
    }, De = ()=>{
        $ ? Be(O || 100) : O ? Be() : $e(!1), $b15f45b1897be4d8$var$R(ae);
    }, qe = ({ x: e, y: t })=>{
        var o;
        const l = {
            getBoundingClientRect: ()=>({
                    x: e,
                    y: t,
                    width: 0,
                    height: 0,
                    top: t,
                    left: e,
                    right: e,
                    bottom: t
                })
        };
        $b15f45b1897be4d8$var$E({
            place: null !== (o = null == we ? void 0 : we.place) && void 0 !== o ? o : v,
            offset: m,
            elementReference: l,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Ie(e);
        });
    }, He = (e)=>{
        if (!e) return;
        const t = e, o = {
            x: t.clientX,
            y: t.clientY
        };
        qe(o), ge.current = o;
    }, Me = (e)=>{
        var t;
        if (!me) return;
        const o = e.target;
        if (!o.isConnected) return;
        if (null === (t = ce.current) || void 0 === t ? void 0 : t.contains(o)) return;
        [
            document.querySelector(`[id='${d}']`),
            ...Oe
        ].some((e)=>null == e ? void 0 : e.contains(o)) || ($e(!1), $b15f45b1897be4d8$var$R(ae));
    }, We = $b15f45b1897be4d8$var$_(ze, 50, !0), Pe = $b15f45b1897be4d8$var$_(De, 50, !0), Ve = (e)=>{
        Pe.cancel(), We(e);
    }, Fe = ()=>{
        We.cancel(), Pe();
    }, Ke = (0, $8nGP5.useCallback)(()=>{
        var e, t;
        const o = null !== (e = null == we ? void 0 : we.position) && void 0 !== e ? e : F;
        o ? qe(o) : T ? ge.current && qe(ge.current) : (null == ee ? void 0 : ee.isConnected) && $b15f45b1897be4d8$var$E({
            place: null !== (t = null == we ? void 0 : we.place) && void 0 !== t ? t : v,
            offset: m,
            elementReference: ee,
            tooltipReference: ce.current,
            tooltipArrowReference: se.current,
            strategy: b,
            middlewares: S,
            border: oe
        }).then((e)=>{
            Te.current && Ie(e);
        });
    }, [
        me,
        ee,
        Y,
        V,
        v,
        null == we ? void 0 : we.place,
        m,
        b,
        F,
        null == we ? void 0 : we.position,
        T
    ]);
    (0, $8nGP5.useEffect)(()=>{
        var e, t;
        const o = new Set(Ee);
        Oe.forEach((e)=>{
            (null == X ? void 0 : X(e)) || o.add({
                current: e
            });
        });
        const l = document.querySelector(`[id='${d}']`);
        l && !(null == X ? void 0 : X(l)) && o.add({
            current: l
        });
        const r = ()=>{
            $e(!1);
        }, n = $b15f45b1897be4d8$var$L(ee), i = $b15f45b1897be4d8$var$L(ce.current);
        Ne.scroll && (window.addEventListener("scroll", r), null == n || n.addEventListener("scroll", r), null == i || i.addEventListener("scroll", r));
        let c = null;
        Ne.resize ? window.addEventListener("resize", r) : ee && ce.current && (c = (0, $322acf408b6b8401$export$deee3a793edee05f)(ee, ce.current, Ke, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const s = (e)=>{
            "Escape" === e.key && $e(!1);
        };
        Ne.escape && window.addEventListener("keydown", s), Ne.clickOutsideAnchor && window.addEventListener("click", Me);
        const a = [], u = (e)=>Boolean((null == e ? void 0 : e.target) && (null == ee ? void 0 : ee.contains(e.target))), p = (e)=>{
            me && u(e) || ze(e);
        }, v = (e)=>{
            me && u(e) && De();
        }, m = [
            "mouseover",
            "mouseout",
            "mouseenter",
            "mouseleave",
            "focus",
            "blur"
        ], y = [
            "click",
            "dblclick",
            "mousedown",
            "mouseup"
        ];
        Object.entries(Re).forEach(([e, t])=>{
            t && (m.includes(e) ? a.push({
                event: e,
                listener: Ve
            }) : y.includes(e) && a.push({
                event: e,
                listener: p
            }));
        }), Object.entries(xe).forEach(([e, t])=>{
            t && (m.includes(e) ? a.push({
                event: e,
                listener: Fe
            }) : y.includes(e) && a.push({
                event: e,
                listener: v
            }));
        }), T && a.push({
            event: "pointermove",
            listener: He
        });
        const h = ()=>{
            _e.current = !0;
        }, w = ()=>{
            _e.current = !1, De();
        }, b = $ && (xe.mouseout || xe.mouseleave);
        return b && (null === (e = ce.current) || void 0 === e || e.addEventListener("mouseover", h), null === (t = ce.current) || void 0 === t || t.addEventListener("mouseout", w)), a.forEach(({ event: e, listener: t })=>{
            o.forEach((o)=>{
                var l;
                null === (l = o.current) || void 0 === l || l.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            Ne.scroll && (window.removeEventListener("scroll", r), null == n || n.removeEventListener("scroll", r), null == i || i.removeEventListener("scroll", r)), Ne.resize ? window.removeEventListener("resize", r) : null == c || c(), Ne.clickOutsideAnchor && window.removeEventListener("click", Me), Ne.escape && window.removeEventListener("keydown", s), b && (null === (e = ce.current) || void 0 === e || e.removeEventListener("mouseover", h), null === (t = ce.current) || void 0 === t || t.removeEventListener("mouseout", w)), a.forEach(({ event: e, listener: t })=>{
                o.forEach((o)=>{
                    var l;
                    null === (l = o.current) || void 0 === l || l.removeEventListener(e, t);
                });
            });
        };
    }, [
        ee,
        Ke,
        ye,
        Ee,
        Oe,
        H,
        M,
        W,
        Le,
        A,
        O
    ]), (0, $8nGP5.useEffect)(()=>{
        var e, t;
        let o = null !== (t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p) && void 0 !== t ? t : "";
        !o && l && (o = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`);
        const r = new MutationObserver((e)=>{
            const t = [], r = [];
            e.forEach((e)=>{
                if ("attributes" === e.type && "data-tooltip-id" === e.attributeName) e.target.getAttribute("data-tooltip-id") === l ? t.push(e.target) : e.oldValue === l && r.push(e.target);
                if ("childList" === e.type) {
                    if (ee) {
                        const t = [
                            ...e.removedNodes
                        ].filter((e)=>1 === e.nodeType);
                        if (o) try {
                            r.push(...t.filter((e)=>e.matches(o))), r.push(...t.flatMap((e)=>[
                                    ...e.querySelectorAll(o)
                                ]));
                        } catch (e) {}
                        t.some((e)=>{
                            var t;
                            return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, ee)) && (he(!1), $e(!1), te(null), $b15f45b1897be4d8$var$R(ae), $b15f45b1897be4d8$var$R(ue), !0);
                        });
                    }
                    if (o) try {
                        const l = [
                            ...e.addedNodes
                        ].filter((e)=>1 === e.nodeType);
                        t.push(...l.filter((e)=>e.matches(o))), t.push(...l.flatMap((e)=>[
                                ...e.querySelectorAll(o)
                            ]));
                    } catch (e) {}
                }
            }), (t.length || r.length) && ke((e)=>[
                    ...e.filter((e)=>!r.includes(e)),
                    ...t
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ],
            attributeOldValue: !0
        }), ()=>{
            r.disconnect();
        };
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect,
        ee
    ]), (0, $8nGP5.useEffect)(()=>{
        Ke();
    }, [
        Ke
    ]), (0, $8nGP5.useEffect)(()=>{
        if (!(null == G ? void 0 : G.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            setTimeout(()=>Ke());
        });
        return e.observe(G.current), ()=>{
            e.disconnect();
        };
    }, [
        Y,
        null == G ? void 0 : G.current
    ]), (0, $8nGP5.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${d}']`), o = [
            ...Oe,
            t
        ];
        ee && o.includes(ee) || te(null !== (e = Oe[0]) && void 0 !== e ? e : t);
    }, [
        d,
        Oe,
        ee
    ]), (0, $8nGP5.useEffect)(()=>(J && $e(!0), ()=>{
            $b15f45b1897be4d8$var$R(ae), $b15f45b1897be4d8$var$R(ue);
        }), []), (0, $8nGP5.useEffect)(()=>{
        var e;
        let t = null !== (e = null == we ? void 0 : we.anchorSelect) && void 0 !== e ? e : p;
        if (!t && l && (t = `[data-tooltip-id='${l.replace(/'/g, "\\'")}']`), t) try {
            const e = Array.from(document.querySelectorAll(t));
            ke(e);
        } catch (e) {
            ke([]);
        }
    }, [
        l,
        p,
        null == we ? void 0 : we.anchorSelect
    ]), (0, $8nGP5.useEffect)(()=>{
        ae.current && ($b15f45b1897be4d8$var$R(ae), je(A));
    }, [
        A
    ]);
    const Ue = null !== (ie = null == we ? void 0 : we.content) && void 0 !== ie ? ie : Y, Xe = me && Object.keys(pe.tooltipStyles).length > 0;
    return (0, $8nGP5.useImperativeHandle)(t, ()=>({
            open: (e)=>{
                if (null == e ? void 0 : e.anchorSelect) try {
                    document.querySelector(e.anchorSelect);
                } catch (t) {
                    return void console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
                }
                be(null != e ? e : null), (null == e ? void 0 : e.delay) ? je(e.delay) : $e(!0);
            },
            close: (e)=>{
                (null == e ? void 0 : e.delay) ? Be(e.delay) : $e(!1);
            },
            activeAnchor: ee,
            place: pe.place,
            isOpen: Boolean(ye && !x && Ue && Xe)
        })), ye && !x && Ue ? (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(g, {
        id: l,
        role: ne,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip", $b15f45b1897be4d8$var$z.tooltip, $b15f45b1897be4d8$var$D.tooltip, $b15f45b1897be4d8$var$D[u], i, `react-tooltip__place-${pe.place}`, $b15f45b1897be4d8$var$z[Xe ? "show" : "closing"], Xe ? "react-tooltip__show" : "react-tooltip__closing", "fixed" === b && $b15f45b1897be4d8$var$z.fixed, $ && $b15f45b1897be4d8$var$z.clickable),
        onTransitionEnd: (e)=>{
            $b15f45b1897be4d8$var$R(de), me || "opacity" !== e.propertyName || (he(!1), be(null), null == U || U());
        },
        style: {
            ...V,
            ...pe.tooltipStyles,
            opacity: void 0 !== le && Xe ? le : void 0
        },
        ref: ce
    }, Ue, (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement(g, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))("react-tooltip-arrow", $b15f45b1897be4d8$var$z.arrow, $b15f45b1897be4d8$var$D.arrow, c, N && $b15f45b1897be4d8$var$z.noArrow),
        style: {
            ...pe.tooltipArrowStyles,
            background: re ? `linear-gradient(to right bottom, transparent 50%, ${re} 50%)` : void 0
        },
        ref: se
    })) : null;
}, $b15f45b1897be4d8$var$H = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $b15f45b1897be4d8$export$28c660c63b792dea = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).forwardRef(({ id: t, anchorId: l, anchorSelect: n, content: i, html: c, render: a, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: f = "div", children: h = null, events: w = [
    "hover"
], openOnClick: b = !1, positionStrategy: S = "absolute", middlewares: g, delayShow: E = 0, delayHide: _ = 0, float: O = !1, hidden: k = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: C = !1, closeOnScroll: R = !1, closeOnResize: x = !1, openEvents: N, closeEvents: $, globalCloseEvents: I, imperativeModeOnly: B = !1, style: z, position: D, isOpen: M, defaultIsOpen: W = !1, disableStyleInjection: P = !1, border: V, opacity: F, arrowColor: K, setIsOpen: U, afterShow: X, afterHide: Y, disableTooltip: G, role: Z = "tooltip" }, J)=>{
    const [Q, ee] = (0, $8nGP5.useState)(i), [te, oe] = (0, $8nGP5.useState)(c), [le, re] = (0, $8nGP5.useState)(v), [ne, ie] = (0, $8nGP5.useState)(p), [ce, se] = (0, $8nGP5.useState)(m), [ae, ue] = (0, $8nGP5.useState)(E), [de, pe] = (0, $8nGP5.useState)(_), [ve, me] = (0, $8nGP5.useState)(O), [fe, ye] = (0, $8nGP5.useState)(k), [he, we] = (0, $8nGP5.useState)(f), [be, Se] = (0, $8nGP5.useState)(w), [ge, Ee] = (0, $8nGP5.useState)(S), [Ae, _e] = (0, $8nGP5.useState)(null), [Oe, ke] = (0, $8nGP5.useState)(null), Te = (0, $8nGP5.useRef)(P), { anchorRefs: Le, activeAnchor: Ce } = $b15f45b1897be4d8$var$j(t), Re = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, o)=>{
            var l;
            if (o.startsWith("data-tooltip-")) t[o.replace(/^data-tooltip-/, "")] = null !== (l = null == e ? void 0 : e.getAttribute(o)) && void 0 !== l ? l : null;
            return t;
        }, {}), xe = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                re(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                ee(null != e ? e : i);
            },
            html: (e)=>{
                oe(null != e ? e : c);
            },
            variant: (e)=>{
                var t;
                ie(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                se(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                we(null !== (t = e) && void 0 !== t ? t : f);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                Se(null != t ? t : w);
            },
            "position-strategy": (e)=>{
                var t;
                Ee(null !== (t = e) && void 0 !== t ? t : S);
            },
            "delay-show": (e)=>{
                ue(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                pe(null === e ? _ : Number(e));
            },
            float: (e)=>{
                me(null === e ? O : "true" === e);
            },
            hidden: (e)=>{
                ye(null === e ? k : "true" === e);
            },
            "class-name": (e)=>{
                _e(e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, o])=>{
            var l;
            null === (l = t[e]) || void 0 === l || l.call(t, o);
        });
    };
    (0, $8nGP5.useEffect)(()=>{
        ee(i);
    }, [
        i
    ]), (0, $8nGP5.useEffect)(()=>{
        oe(c);
    }, [
        c
    ]), (0, $8nGP5.useEffect)(()=>{
        re(v);
    }, [
        v
    ]), (0, $8nGP5.useEffect)(()=>{
        ie(p);
    }, [
        p
    ]), (0, $8nGP5.useEffect)(()=>{
        se(m);
    }, [
        m
    ]), (0, $8nGP5.useEffect)(()=>{
        ue(E);
    }, [
        E
    ]), (0, $8nGP5.useEffect)(()=>{
        pe(_);
    }, [
        _
    ]), (0, $8nGP5.useEffect)(()=>{
        me(O);
    }, [
        O
    ]), (0, $8nGP5.useEffect)(()=>{
        ye(k);
    }, [
        k
    ]), (0, $8nGP5.useEffect)(()=>{
        Ee(S);
    }, [
        S
    ]), (0, $8nGP5.useEffect)(()=>{
        Te.current !== P && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        P
    ]), (0, $8nGP5.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === P,
                disableBase: P
            }
        }));
    }, []), (0, $8nGP5.useEffect)(()=>{
        var e;
        const o = new Set(Le);
        let r = n;
        if (!r && t && (r = `[data-tooltip-id='${t.replace(/'/g, "\\'")}']`), r) try {
            document.querySelectorAll(r).forEach((e)=>{
                o.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${r}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${l}']`);
        if (i && o.add({
            current: i
        }), !o.size) return ()=>null;
        const c = null !== (e = null != Oe ? Oe : i) && void 0 !== e ? e : Ce.current, s = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const o = Re(c);
                xe(o);
            });
        }), a = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = Re(c);
            xe(e), s.observe(c, a);
        }
        return ()=>{
            s.disconnect();
        };
    }, [
        Le,
        Ce,
        Oe,
        l,
        n
    ]), (0, $8nGP5.useEffect)(()=>{
        (null == z ? void 0 : z.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), V && !$b15f45b1897be4d8$var$A("border", `${V}`) && console.warn(`[react-tooltip] "${V}" is not a valid \`border\`.`), (null == z ? void 0 : z.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), F && !$b15f45b1897be4d8$var$A("opacity", `${F}`) && console.warn(`[react-tooltip] "${F}" is not a valid \`opacity\`.`);
    }, []);
    let Ne = h;
    const $e = (0, $8nGP5.useRef)(null);
    if (a) {
        const t = a({
            content: (null == Oe ? void 0 : Oe.getAttribute("data-tooltip-content")) || Q || null,
            activeAnchor: Oe
        });
        Ne = t ? (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement("div", {
            ref: $e,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else Q && (Ne = Q);
    te && (Ne = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($b15f45b1897be4d8$var$H, {
        content: te
    }));
    const Ie = {
        forwardRef: J,
        id: t,
        anchorId: l,
        anchorSelect: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(u, Ae),
        classNameArrow: d,
        content: Ne,
        contentWrapperRef: $e,
        place: le,
        variant: ne,
        offset: ce,
        wrapper: he,
        events: be,
        openOnClick: b,
        positionStrategy: ge,
        middlewares: g,
        delayShow: ae,
        delayHide: de,
        float: ve,
        hidden: fe,
        noArrow: T,
        clickable: L,
        closeOnEsc: C,
        closeOnScroll: R,
        closeOnResize: x,
        openEvents: N,
        closeEvents: $,
        globalCloseEvents: I,
        imperativeModeOnly: B,
        style: z,
        position: D,
        isOpen: M,
        defaultIsOpen: W,
        border: V,
        opacity: F,
        arrowColor: K,
        setIsOpen: U,
        afterShow: X,
        afterHide: Y,
        disableTooltip: G,
        activeAnchor: Oe,
        setActiveAnchor: (e)=>ke(e),
        role: Z
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).createElement($b15f45b1897be4d8$var$q, {
        ...Ie
    });
});
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $b15f45b1897be4d8$var$S({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}`,
        type: "core"
    }), e.detail.disableBase || $b15f45b1897be4d8$var$S({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});


const $a311b708b00f39ea$export$423c13fd52bec8ad = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    const contentRef = (0, $8nGP5.useRef)(null);
    const [activeContent, setActiveContent] = (0, $8nGP5.useState)(null);
    const msg = p.msg;
    const firmURL = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().firmInfo.logoURL;
    const clssses = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))($de360348d8e02af4$export$c945096f7c61efa, 'fade-in');
    const msgId = p.msgId;
    const companyId = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().selectedReportId;
    const buildTooltipId = (msgId, citationDisplayId)=>{
        return `tooltip_${companyId}_${msgId}_${citationDisplayId}`;
    };
    if (msg.isMe) return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: clssses,
            direction: "column",
            children: [
                (0, $kSbwP.jsx)("div", {
                    style: {
                        height: '50px',
                        alignSelf: 'end',
                        marginBottom: '10px'
                    },
                    children: (0, $kSbwP.jsx)("img", {
                        height: 50,
                        width: 200,
                        src: firmURL,
                        style: {
                            objectFit: 'contain',
                            objectPosition: 'right',
                            height: '100%'
                        }
                    })
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        textAlign: 'right',
                        marginRight: '10px',
                        alignSelf: 'end'
                    },
                    children: msg.message
                })
            ]
        })
    });
    const convertMarkdown = (markdown, messageId)=>{
        const cls = $de360348d8e02af4$export$d531d37146cc5d63;
        const rawHtmlWithDefault = (0, $e0f2436fd88d0d31$exports.marked).parse(markdown);
        var matchCounter = 0;
        const finalOutput = rawHtmlWithDefault.replace(/\[(.*?)\]/g, (match, p1)=>{
            matchCounter++;
            const tooltipId = buildTooltipId(messageId, p1);
            return `<a class='${cls}' data-tooltip-id="${tooltipId}">${matchCounter}</a>`;
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($4a6c6cd3ba57d1fc$exports))).sanitize(finalOutput);
    };
    const formatterHTML = convertMarkdown(msg.message, msgId);
    var tooltips = [];
    if (msg.raw && msg.raw.citations) {
        const citations = msg.raw.citations;
        //data-tooltip-id="my-tooltip
        tooltips = citations.map((citation, index)=>{
            var _a;
            try {
                const toolGenId = msg.raw.citations[index].id;
                const tooltipId = buildTooltipId(msgId, toolGenId);
                var text = (_a = msg.raw.citations[index].payload) === null || _a === void 0 ? void 0 : _a.text;
                if (!text) text = msg.raw.citations[index].text;
                return (0, $kSbwP.jsx)((0, $b15f45b1897be4d8$export$28c660c63b792dea), {
                    id: tooltipId,
                    style: {
                        maxWidth: '400px',
                        zIndex: 9999
                    },
                    children: text
                }, toolGenId + '_' + index);
            } catch (e) {
                console.error('Error in tooltip generation', e);
                console.error('Citation:', citation);
                return null;
            }
        });
    }
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            className: clssses,
            direction: "row",
            children: [
                tooltips,
                (0, $kSbwP.jsx)("div", {
                    className: "p-3",
                    style: {
                        height: '50px'
                    },
                    children: (0, $kSbwP.jsx)((0, $bc783706f3494468$export$7707107edd1bbb83), {})
                }),
                (0, $kSbwP.jsx)("div", {
                    ref: contentRef,
                    className: "flex-grow-1 p-4 align-self-center",
                    style: {
                        marginLeft: '0px'
                    },
                    children: (0, $kSbwP.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: formatterHTML
                        }
                    })
                })
            ]
        })
    });
});






var $kSbwP = parcelRequire("kSbwP");

var $066f6cd7ccd30cf5$exports = {};
$066f6cd7ccd30cf5$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $3d4818c14c5a7ecb$export$cd092c96f205fe24 = (p)=>{
    const w = p.width || 400;
    const h = p.height || 400;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($066f6cd7ccd30cf5$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
        options: defaultOptions,
        height: h,
        width: w
    });
};


const $66ce6f036b68f5b9$export$42499dcdbb97379f = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((p)=>{
    //use id to fetch chat
    const messageData = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().reportChatHistory;
    const keys = Object.keys(messageData).sort();
    const reportId = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)().selectedReportId;
    const messages = [];
    var isLastMessageMe = false;
    keys.forEach((msgId)=>{
        const msg = messageData[msgId];
        if (msg.isMe) {
            isLastMessageMe = true;
            messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                msg: msg,
                msgId: msgId
            }, msgId));
            if (msg.response) {
                isLastMessageMe = false;
                const msgResponse = {
                    isMe: false,
                    message: msg.response,
                    date: new Date(),
                    processed: true,
                    raw: msg.raw
                };
                messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
                    msg: msgResponse,
                    msgId: msgId
                }, msgId + '_response'));
            }
        } else messages.push((0, $kSbwP.jsx)((0, $a311b708b00f39ea$export$423c13fd52bec8ad), {
            msg: msg,
            msgId: msgId
        }, msgId + '_server'));
    });
    if (isLastMessageMe) messages.push((0, $kSbwP.jsx)("div", {
        className: "fade-in",
        children: (0, $kSbwP.jsx)((0, $3d4818c14c5a7ecb$export$cd092c96f205fe24), {
            width: 200,
            height: 100
        })
    }, "animation"));
    return (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
        direction: "column",
        justify: "end",
        children: messages
    });
});



var $97a4632ec479489e$export$b7e3ae3d7c15e42e;
var $97a4632ec479489e$export$2ed7b5e39bba01d1;
var $97a4632ec479489e$export$defe85febe8b728c;
var $97a4632ec479489e$export$e7ab66df97d7c425;
var $97a4632ec479489e$export$981437eb56fae58a;
$97a4632ec479489e$export$b7e3ae3d7c15e42e = `giecvG_input`;
$97a4632ec479489e$export$2ed7b5e39bba01d1 = `giecvG_inputLineOffset`;
$97a4632ec479489e$export$defe85febe8b728c = `giecvG_messages`;
$97a4632ec479489e$export$e7ab66df97d7c425 = `giecvG_scrollFadeContent`;
$97a4632ec479489e$export$981437eb56fae58a = `giecvG_sendButton`;



var $8nGP5 = parcelRequire("8nGP5");

const $70486436adddb424$export$fce4baf3ef34624f = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [inputText, setInputValue] = (0, $8nGP5.useState)('');
    const ui = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const refInput = (0, $8nGP5.useRef)(null);
    const ragAPI = store.ragAPI;
    const history = store.reportChatHistory;
    var totalMessages = 0;
    for(const key in history){
        var msg = history[key];
        totalMessages += 1;
        if (msg.processed) totalMessages += 1;
    }
    (0, $8nGP5.useEffect)(()=>{
        const chatScroll = document.getElementById('chat-scroll');
        if (chatScroll) setTimeout(()=>{
            chatScroll.scrollTop = chatScroll.scrollHeight;
        }, 50);
    }, [
        totalMessages
    ]);
    const onClickSend = ()=>{
        if (ui.chatWaitingForResponse) return;
        const input = refInput.current.value;
        if (input.length == 0) return;
        ragAPI.sendMessage(input);
        setInputValue('');
    };
    const waitingForReply = (0, $kSbwP.jsxs)("i", {
        children: [
            (0, $kSbwP.jsx)("div", {
                className: "spinner-border spinner-border-sm",
                role: "status",
                style: {
                    animationDuration: '1.25s',
                    width: '20px',
                    height: '20px'
                }
            }),
            ' ',
            "Send"
        ]
    });
    const sendButtonContent = (0, $kSbwP.jsxs)("i", {
        className: "bi bi-send",
        onClick: ()=>{
            onClickSend();
        },
        children: [
            ' ',
            "Send"
        ]
    });
    const sendButton = (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
        className: $97a4632ec479489e$export$981437eb56fae58a,
        children: ui.chatWaitingForResponse ? waitingForReply : sendButtonContent
    });
    return (0, $kSbwP.jsx)((0, $a7f903e2fee2d8e0$export$2ddb90ad54e5f587), {
        shadow: true,
        fillCell: true,
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            fillCell: true,
            children: [
                store.isAdmin && (0, $kSbwP.jsx)("input", {
                    type: "button",
                    value: "Clear Chat",
                    style: {
                        position: 'absolute',
                        right: '10px',
                        top: '-150px',
                        zIndex: 100000
                    },
                    onClick: ()=>{
                        var areYouSure = window.confirm("** Clear Chat: Are you sure ?\r\nReport Name:" + store.selectedReportId + '\r\nCompany: ' + store.query.value('company_name'));
                        if (areYouSure) {
                            const fb = (0, $b2432f43c421c848$export$7a667d08ed65fa47)();
                            fb.clear_chat(store.selectedReportId);
                        }
                    }
                }),
                (0, $kSbwP.jsx)("div", {
                    className: $97a4632ec479489e$export$defe85febe8b728c,
                    children: (0, $kSbwP.jsx)((0, $1cd5198602b08238$export$9159ebcaf8f42267), {
                        onLoadScrollToEnd: true,
                        id: "chat-scroll",
                        className: $97a4632ec479489e$export$e7ab66df97d7c425,
                        children: (0, $kSbwP.jsx)((0, $66ce6f036b68f5b9$export$42499dcdbb97379f), {
                            companyId: store.selectedReportId
                        })
                    })
                }),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    className: $97a4632ec479489e$export$2ed7b5e39bba01d1,
                    children: [
                        (0, $kSbwP.jsx)("div", {
                            className: $97a4632ec479489e$export$b7e3ae3d7c15e42e,
                            children: (0, $kSbwP.jsx)("input", {
                                ref: refInput,
                                type: "text",
                                value: inputText,
                                placeholder: "Enter a question",
                                autoFocus: true,
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') onClickSend();
                                },
                                onChange: (e)=>{
                                    setInputValue(e.currentTarget.value);
                                }
                            })
                        }),
                        sendButton
                    ]
                })
            ]
        })
    });
});



var $kSbwP = parcelRequire("kSbwP");



var $8nGP5 = parcelRequire("8nGP5");
var $c7759e75df08ccdb$exports = {};
$c7759e75df08ccdb$exports = new URL("back2.7df4d33c.svg", import.meta.url).toString();


var $484b37a85d2f6285$export$8d6d009d1f06226e;
var $484b37a85d2f6285$export$40a9eeef55665a40;
var $484b37a85d2f6285$export$93b7586d956c930e;
var $484b37a85d2f6285$export$f843afa9e9b53052;
var $484b37a85d2f6285$export$ae78d338ad66ff90;
var $484b37a85d2f6285$export$b8972b998723d602;
var $484b37a85d2f6285$export$adaf8a367aa41030;
$484b37a85d2f6285$export$8d6d009d1f06226e = `Vp5udq_backButton`;
$484b37a85d2f6285$export$40a9eeef55665a40 = `Vp5udq_defaultPadding`;
$484b37a85d2f6285$export$93b7586d956c930e = `Vp5udq_dropShadow`;
$484b37a85d2f6285$export$f843afa9e9b53052 = `Vp5udq_panelImage`;
$484b37a85d2f6285$export$ae78d338ad66ff90 = `Vp5udq_scaleInOut`;
$484b37a85d2f6285$export$b8972b998723d602 = `Vp5udq_shadow`;
$484b37a85d2f6285$export$adaf8a367aa41030 = `Vp5udq_switchView`;





const $16de201126bc302c$export$b5d5cf8927ab7262 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)((props)=>{
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($8nGP5))).Children.toArray(props.children);
    (0, $3d71a0e5fc49a3ca$exports.assert)(children.length > props.activeView, 'Active view is out of range');
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    (0, $8nGP5.useEffect)(()=>{
        if (uiStore.isKeyEscapeDown && props.activeView > 0) props.onBack();
    }, [
        uiStore.isKeyEscapeDown
    ]);
    const childrenView = children.map((child, index)=>{
        return (0, $kSbwP.jsx)("div", {
            className: $484b37a85d2f6285$export$adaf8a367aa41030,
            style: {
                opacity: index === props.activeView ? 1 : 0,
                pointerEvents: index === props.activeView ? 'auto' : 'none',
                zIndex: index === props.activeView ? 10000 : 0
            },
            children: child
        }, index);
    });
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            style: {
                position: 'relative'
            },
            children: [
                (0, $kSbwP.jsx)("div", {
                    className: $484b37a85d2f6285$export$8d6d009d1f06226e,
                    onClick: props.onBack,
                    style: {
                        opacity: props.activeView === 0 ? 0 : 1
                    },
                    children: (0, $kSbwP.jsxs)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                        variant: "light",
                        children: [
                            (0, $kSbwP.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($c7759e75df08ccdb$exports)))
                            }),
                            "Back"
                        ]
                    })
                }),
                childrenView
            ]
        })
    });
});



const $2c12f2027963d4ec$export$bfa9586c766696c1 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const [view, setView] = (0, $8nGP5.useState)(0);
    const [pdfData, setPdfUrl] = (0, $8nGP5.useState)({
        url: null,
        displayName: null
    });
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const query = store.query;
    const requestSeeFile = (pdfUrl, displayName)=>{
        setPdfUrl({
            url: pdfUrl,
            displayName: displayName
        });
        setView(1);
    };
    return (0, $kSbwP.jsxs)((0, $9583d2c91dbe771f$export$3ccee0cf1acf5f70), {
        spaceBetween: 30,
        children: [
            (0, $kSbwP.jsxs)((0, $16de201126bc302c$export$b5d5cf8927ab7262), {
                activeView: view,
                onBack: ()=>setView(0),
                children: [
                    (0, $kSbwP.jsx)((0, $d8d03341d2feac10$export$3605042b726118fb), {
                        requestSeeFile: requestSeeFile
                    }),
                    (0, $kSbwP.jsx)((0, $83348bebf1460cdb$export$9d5f8324718c22d1), {
                        pdfUrl: pdfData.url,
                        title_display: pdfData.displayName
                    })
                ]
            }),
            (0, $kSbwP.jsx)((0, $70486436adddb424$export$fce4baf3ef34624f), {})
        ]
    });
});





const $3ec5e27b9e361204$var$DealChat = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)((0, $2c12f2027963d4ec$export$bfa9586c766696c1), {})
    });
});
var $3ec5e27b9e361204$export$2e2bcd8739ae039 = $3ec5e27b9e361204$var$DealChat;


var $77305530f3e91b71$export$34e0f9847d4c02dd;
var $77305530f3e91b71$export$40a9eeef55665a40;
var $77305530f3e91b71$export$93b7586d956c930e;
var $77305530f3e91b71$export$ace87c730273fd9b;
var $77305530f3e91b71$export$2596e628ba7811d4;
var $77305530f3e91b71$export$f843afa9e9b53052;
var $77305530f3e91b71$export$ae78d338ad66ff90;
var $77305530f3e91b71$export$b8972b998723d602;
var $77305530f3e91b71$export$573c7ff860a6ccf1;
$77305530f3e91b71$export$34e0f9847d4c02dd = `HLHa5a_container`;
$77305530f3e91b71$export$40a9eeef55665a40 = `HLHa5a_defaultPadding`;
$77305530f3e91b71$export$93b7586d956c930e = `HLHa5a_dropShadow`;
$77305530f3e91b71$export$ace87c730273fd9b = `HLHa5a_gptIcon`;
$77305530f3e91b71$export$2596e628ba7811d4 = `HLHa5a_gptTabLabel`;
$77305530f3e91b71$export$f843afa9e9b53052 = `HLHa5a_panelImage`;
$77305530f3e91b71$export$ae78d338ad66ff90 = `HLHa5a_scaleInOut`;
$77305530f3e91b71$export$ae78d338ad66ff90;
$77305530f3e91b71$export$b8972b998723d602 = `HLHa5a_shadow`;
$77305530f3e91b71$export$573c7ff860a6ccf1 = `HLHa5a_tabsShadow`;



const $dd142b8584fa3691$var$DealView = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    var _a, _b;
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const navUtils = (0, $02fdab2e48ca7872$export$726c44d912e0140f)();
    (0, $8nGP5.useEffect)(()=>{
        if (!store.isLoaded) return;
        if (!store.reportDataDB.hasOwnProperty(id)) navUtils.home();
    }, [
        store.isLoaded
    ]);
    (0, $3e7d8e12b3f432b0$export$4ec57c364807b0e9)('DEAL_VIEW', ()=>{
        uiStore.resetDealView();
    });
    (0, $8f024b03d9af7c67$export$d2d3ee67e04f6bd9)((_b = (_a = store.query) === null || _a === void 0 ? void 0 : _a.value('company_name')) !== null && _b !== void 0 ? _b : '');
    (0, $8nGP5.useEffect)(()=>{
        if (id) {
            console.log('Setting report id to', id);
            store.selectedReportId = id;
        }
    }, [
        id
    ]);
    (0, $8nGP5.useEffect)(()=>{
        if (!uiStore.isKeyTabDown) return;
        const values = Object.values((0, $8f024b03d9af7c67$export$74848b9d4d66d1d3));
        const currentIndex = values.indexOf(uiStore.dealViewTab);
        uiStore.dealViewTab = values[(currentIndex + (uiStore.isKeyShiftKeyDown ? -1 : 1) + values.length) % values.length];
    }, [
        uiStore.isKeyTabDown
    ]);
    if (store.query == null) return null;
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsxs)("div", {
            className: 'd-flex justify-content-center',
            style: {
                height: '100%'
            },
            children: [
                (0, $kSbwP.jsx)((0, $c852cf41bf4911ee$export$e7b94983f4222b90), {}),
                (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                    direction: "column",
                    className: 'h-100 w-100',
                    children: [
                        (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                            disableTicker: true,
                            showDealDbLink: true,
                            showScore: true,
                            showShadow: false
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $77305530f3e91b71$export$573c7ff860a6ccf1
                        }),
                        (0, $kSbwP.jsxs)((0, $3f748ec55388f444$export$2e2bcd8739ae039), {
                            activeKey: uiStore.dealViewTab,
                            variant: "underline",
                            className: 'dealViewTabs',
                            onSelect: (k)=>uiStore.dealViewTab = k,
                            mountOnEnter: true,
                            unmountOnExit: true,
                            children: [
                                (0, $kSbwP.jsx)((0, $4130385b85bf806d$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).DASHBOARD,
                                    title: "Dashboard",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $032f62a52fec71db$export$cf41dafb96c88991), {})
                                }),
                                (0, $kSbwP.jsx)((0, $4130385b85bf806d$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).DETAILS,
                                    title: "Deal Details",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $cb32edb7d568785b$export$a65eea1eaa5f8fa3), {})
                                }),
                                (0, $kSbwP.jsx)((0, $4130385b85bf806d$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).COMPARE,
                                    title: "Benchmark & Comps",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $5a1995dee7b5d277$export$a928f7cf0495745d), {})
                                }),
                                (0, $kSbwP.jsx)((0, $4130385b85bf806d$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).SCORE_BREAKDOWN,
                                    title: "Score Details",
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $36c6fce940b0e7aa$export$210595a4b4a710d0), {})
                                }),
                                (0, $kSbwP.jsx)((0, $4130385b85bf806d$export$2e2bcd8739ae039), {
                                    eventKey: (0, $8f024b03d9af7c67$export$74848b9d4d66d1d3).CHAT,
                                    title: (0, $kSbwP.jsxs)("div", {
                                        className: $77305530f3e91b71$export$2596e628ba7811d4 + ' nav-link',
                                        children: [
                                            "AI Chat",
                                            (0, $kSbwP.jsx)((0, $8f0ee97a3ff3e474$export$f04a61298a47a40f), {
                                                icon: "sparkle",
                                                className: $77305530f3e91b71$export$ace87c730273fd9b
                                            })
                                        ]
                                    }),
                                    className: $77305530f3e91b71$export$34e0f9847d4c02dd,
                                    children: (0, $kSbwP.jsx)((0, $3ec5e27b9e361204$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        (0, $kSbwP.jsx)("div", {
                            className: $77305530f3e91b71$export$34e0f9847d4c02dd
                        })
                    ]
                })
            ]
        })
    });
});
var $dd142b8584fa3691$export$2e2bcd8739ae039 = $dd142b8584fa3691$var$DealView;



var $kSbwP = parcelRequire("kSbwP");






var $8nGP5 = parcelRequire("8nGP5");


var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $ab02d596ad38c6d1$var$Container = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$ab02d596ad38c6d1$var$Container.displayName = 'Container';
var $ab02d596ad38c6d1$export$2e2bcd8739ae039 = $ab02d596ad38c6d1$var$Container;



var $8nGP5 = parcelRequire("8nGP5");


var $kSbwP = parcelRequire("kSbwP");
"use client";
const $d3c6ae091da92bfc$var$Row = /*#__PURE__*/ $8nGP5.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $8b96a2995cbd6328$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $8b96a2995cbd6328$export$8970c8db816a5863)();
    const minBreakpoint = (0, $8b96a2995cbd6328$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$d3c6ae091da92bfc$var$Row.displayName = 'Row';
var $d3c6ae091da92bfc$export$2e2bcd8739ae039 = $d3c6ae091da92bfc$var$Row;



var $e5930515877dc472$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e5930515877dc472$var$LoginPage = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const { id: id } = (0, $48e5d1fb97c993cc$export$99eaa27ddbbb95ef)();
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const [loginEmail, setLoginEmail] = (0, $8nGP5.useState)('');
    const [loginPassword, setLoginPassword] = (0, $8nGP5.useState)('');
    const [resetEmail, setResetEmail] = (0, $8nGP5.useState)('');
    const [authState, setAuthState] = (0, $8nGP5.useState)(false);
    (0, $8nGP5.useEffect)(()=>{
        const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
        uiStore.disableLoading = true;
    }, []);
    (0, $8nGP5.useEffect)(()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        auth.onAuthStateChanged((user)=>{
            if (user) setAuthState(true);
            else setAuthState(false);
        });
    });
    const login = ()=>$e5930515877dc472$var$__awaiter(void 0, void 0, void 0, function*() {
            const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
            try {
                const user = yield (0, $402d0a489f4b5d89$export$555508cbc6add439)(auth, loginEmail, loginPassword);
                if (user) {
                    (0, $b2432f43c421c848$export$7a667d08ed65fa47)().store_audit_entry('LOGIN');
                    setTimeout(()=>{
                        location.href = '/';
                    }, 750);
                }
            } catch (e) {
                alert('Invalid user/pass');
            }
        });
    const sendReset = ()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        (0, $402d0a489f4b5d89$export$a8550f7dbe79f93a)(auth, resetEmail);
        alert('Reset email sent');
    };
    const logout = ()=>{
        const auth = (0, $402d0a489f4b5d89$export$ae1af26003f05816)((0, $b2432f43c421c848$export$7a667d08ed65fa47)().app);
        auth.signOut();
    };
    const loggedIn = (0, $kSbwP.jsx)("i", {
        style: {
            color: 'green',
            left: 5,
            top: 3,
            position: 'relative'
        },
        className: "bi bi-check-circle"
    });
    const loggedOut = (0, $kSbwP.jsx)("i", {
        style: {
            color: 'red',
            left: 5,
            top: 3,
            position: 'relative'
        },
        className: "bi bi-x-circle"
    });
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsxs)((0, $ab02d596ad38c6d1$export$2e2bcd8739ae039), {
                className: "w-100 h-100",
                children: [
                    (0, $kSbwP.jsx)((0, $d3c6ae091da92bfc$export$2e2bcd8739ae039), {
                        className: "d-flex justify-content-between",
                        children: (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                            children: (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {})
                        })
                    }),
                    (0, $kSbwP.jsx)((0, $d3c6ae091da92bfc$export$2e2bcd8739ae039), {
                        children: (0, $kSbwP.jsxs)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                            style: {
                                textAlign: 'center',
                                fontSize: 25
                            },
                            children: [
                                "Login Status: ",
                                authState ? loggedIn : loggedOut
                            ]
                        })
                    }),
                    (0, $kSbwP.jsxs)((0, $d3c6ae091da92bfc$export$2e2bcd8739ae039), {
                        className: "pt-5",
                        children: [
                            (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                                xs: 2
                            }),
                            (0, $kSbwP.jsxs)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                                children: [
                                    (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039), {
                                        children: (0, $kSbwP.jsxs)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            controlId: "exampleForm.ControlInput1",
                                            children: [
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Label, {
                                                    children: "Email address"
                                                }),
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Control, {
                                                    type: "email",
                                                    placeholder: "name@example.com",
                                                    onChange: (e)=>setLoginEmail(e.target.value)
                                                }),
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Label, {
                                                    className: "pt-2",
                                                    children: "Password"
                                                }),
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Control, {
                                                    type: "password",
                                                    placeholder: "...",
                                                    onChange: (e)=>setLoginPassword(e.target.value)
                                                })
                                            ]
                                        })
                                    }),
                                    (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                        variant: "primary",
                                        onClick: login,
                                        children: "Login"
                                    })
                                ]
                            }),
                            (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                                xs: 1
                            }),
                            (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                                children: (0, $kSbwP.jsxs)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039), {
                                    children: [
                                        (0, $kSbwP.jsxs)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Group, {
                                            className: "mb-3",
                                            controlId: "exampleForm.ControlInput1",
                                            children: [
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Label, {
                                                    children: "Email address"
                                                }),
                                                (0, $kSbwP.jsx)((0, $5bf7899a63084c1b$export$2e2bcd8739ae039).Control, {
                                                    type: "email",
                                                    placeholder: "name@example.com",
                                                    onChange: (e)=>setResetEmail(e.target.value)
                                                })
                                            ]
                                        }),
                                        (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            onClick: sendReset,
                                            children: "Reset"
                                        })
                                    ]
                                })
                            }),
                            (0, $kSbwP.jsx)((0, $9d386835d571a6a9$export$2e2bcd8739ae039), {
                                xs: 2
                            })
                        ]
                    })
                ]
            }),
            (0, $kSbwP.jsx)((0, $bffaf950c90188d4$export$2e2bcd8739ae039), {
                variant: "primary",
                onClick: logout,
                style: {
                    position: 'absolute',
                    right: 0,
                    bottom: 0
                },
                children: "Logout"
            })
        ]
    });
});
var $e5930515877dc472$export$2e2bcd8739ae039 = $e5930515877dc472$var$LoginPage;



var $kSbwP = parcelRequire("kSbwP");




var $8nGP5 = parcelRequire("8nGP5");



var $1e22e536e4ef8476$exports = {};
$1e22e536e4ef8476$exports = JSON.parse("{\"v\":\"5.7.4\",\"fr\":60,\"ip\":696,\"op\":762,\"w\":600,\"h\":600,\"nm\":\"Final\",\"assets\":[{\"id\":\"comp_0\",\"layers\":[{\"ind\":3,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[200,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":20,\"op\":1520,\"st\":20},{\"ind\":4,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[250,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":30,\"op\":1530,\"st\":30},{\"ind\":5,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":40,\"op\":1540,\"st\":40},{\"ind\":6,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[350,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":50,\"op\":1550,\"st\":50},{\"ind\":7,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[400,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":60,\"op\":1560,\"st\":60},{\"ind\":8,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[450,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":70,\"op\":1570,\"st\":70},{\"ind\":9,\"ty\":0,\"nm\":\"position+scale\",\"refId\":\"comp_1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[500,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[53,53,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":80,\"op\":1580,\"st\":80}]},{\"id\":\"comp_1\",\"layers\":[{\"ind\":1,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":632,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":645,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":657,\"s\":[30]},{\"t\":680,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,415,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1.298]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,0.845]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,-0.057]},\"t\":632,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.645]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0.143]},\"t\":645,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":657,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":699,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":714,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":726,\"s\":[100,100,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0},{\"ind\":2,\"ty\":0,\"nm\":\"asset\",\"refId\":\"comp_2\",\"sr\":1,\"ks\":{\"o\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":615,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.333],\"y\":[0]},\"t\":680,\"s\":[100]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":697,\"s\":[30]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":710,\"s\":[0]},{\"i\":{\"x\":[0.833],\"y\":[0.833]},\"o\":{\"x\":[0.167],\"y\":[0.167]},\"t\":722,\"s\":[30]},{\"t\":745,\"s\":[100]}]},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":615,\"s\":[300,171,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":680,\"s\":[300,415,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":745,\"s\":[300,171,0]}],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":1,\"k\":[{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,8.727]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":615,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":634,\"s\":[90,90,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":647,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":659,\"s\":[100,100,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.333,0.333,0.333],\"y\":[0,0,0]},\"t\":680,\"s\":[75,75,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[1,1,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0]},\"t\":697,\"s\":[55,55,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,1]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0,0,0]},\"t\":710,\"s\":[46,46,100]},{\"i\":{\"x\":[0.833,0.833,0.833],\"y\":[0.833,0.833,0.833]},\"o\":{\"x\":[0.167,0.167,0.167],\"y\":[0.167,0.167,0.167]},\"t\":722,\"s\":[55,55,100]},{\"t\":745,\"s\":[75,75,100]}],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":-65,\"op\":1435,\"st\":-65}]},{\"id\":\"comp_2\",\"layers\":[{\"ind\":1,\"ty\":4,\"nm\":\"Round 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[-74,-14,0],\"l\":2},\"s\":{\"a\":0,\"k\":[129,129,100],\"l\":2}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[60,60]},\"p\":{\"a\":0,\"k\":[0,0]},\"nm\":\"Ellipse Path 1\"},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.831,0.851,0.878,1]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill 1\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-74,-14]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100},\"sk\":{\"a\":0,\"k\":0},\"sa\":{\"a\":0,\"k\":0},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\"}],\"ip\":0,\"op\":1500,\"st\":0}]}],\"layers\":[{\"ind\":2,\"ty\":0,\"nm\":\"sequance\",\"refId\":\"comp_0\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":0,\"k\":0},\"p\":{\"a\":0,\"k\":[248,300,0],\"l\":2},\"a\":{\"a\":0,\"k\":[300,300,0],\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"l\":2}},\"ao\":0,\"w\":600,\"h\":600,\"ip\":0,\"op\":1500,\"st\":0}],\"markers\":[]}");


const $7cf10799ed69235a$export$669f6ea7d267feaf = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    const uiStore = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
    const [showLoading, setShowLoading] = (0, $8nGP5.useState)(true);
    const targetAlpha = store.isLoaded || uiStore.disableLoading ? 0 : 1;
    const props = (0, $21cbb88cff39ec52$export$c4af9125706c4d30)({
        from: {
            opacity: 1
        },
        to: {
            opacity: targetAlpha
        },
        delay: 1000,
        onChange: (val)=>{
            if (val.value['opacity'] == 0) setShowLoading(false);
        }
    });
    if (!showLoading) return null;
    const defaultOptions = {
        loop: true,
        autoplay: true,
        play: true,
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($1e22e536e4ef8476$exports))),
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };
    return (0, $kSbwP.jsx)((0, $145df61257f4f72c$export$407448d2b89b1813).div, {
        style: Object.assign({
            position: 'absolute',
            width: '100%',
            height: '100%',
            zIndex: 80000
        }, props),
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            fillCell: true,
            justify: "start",
            alignItems: "center",
            style: {
                backgroundColor: 'white',
                pointerEvents: 'none'
            },
            direction: "column",
            className: "fade-in",
            children: [
                (0, $kSbwP.jsx)("div", {
                    style: {
                        color: '#243A5C',
                        fontSize: '60px',
                        fontFamily: 'LustTextMedium',
                        marginTop: '200px',
                        zIndex: 100,
                        position: 'relative',
                        top: '50px',
                        animationDelay: '0.2s'
                    },
                    className: "fade-in",
                    children: (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {
                        width: 300
                    })
                }),
                (0, $kSbwP.jsx)("div", {
                    className: "fade-in",
                    style: {
                        animationDelay: '0.45s'
                    },
                    children: (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c21b0df46793000$exports))), {
                        options: defaultOptions,
                        height: 400,
                        width: 400
                    })
                })
            ]
        })
    });
});



var $8nGP5 = parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");





var $4f5f5b50b52104e1$exports = {};
"use strict";
Object.defineProperty($4f5f5b50b52104e1$exports, "__esModule", {
    value: true
});
var $28d59a58c1f5f793$exports = {};
"use strict";
'use client';

var $1yHiF = parcelRequire("1yHiF");
var $28d59a58c1f5f793$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $28d59a58c1f5f793$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($28d59a58c1f5f793$exports, "__esModule", {
    value: true
});
$28d59a58c1f5f793$exports.SimpleTreeViewRoot = $28d59a58c1f5f793$exports.SimpleTreeView = void 0;

var $28d59a58c1f5f793$var$_extends2 = $28d59a58c1f5f793$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $28d59a58c1f5f793$var$_objectWithoutPropertiesLoose2 = $28d59a58c1f5f793$require$_interopRequireDefault((parcelRequire("68UY6")));

var $28d59a58c1f5f793$var$React = $28d59a58c1f5f793$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $28d59a58c1f5f793$var$_propTypes = $28d59a58c1f5f793$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $28d59a58c1f5f793$var$_composeClasses = $28d59a58c1f5f793$require$_interopRequireDefault((parcelRequire("4F19u")));

var $28d59a58c1f5f793$var$_useSlotProps = $28d59a58c1f5f793$require$_interopRequireDefault((parcelRequire("k3QMn")));

var $6b3b06de371680d1$exports = {};
"use strict";
Object.defineProperty($6b3b06de371680d1$exports, "__esModule", {
    value: true
});
$6b3b06de371680d1$exports.createUseThemeProps = $6b3b06de371680d1$var$createUseThemeProps;
Object.defineProperty($6b3b06de371680d1$exports, "styled", {
    enumerable: true,
    get: function() {
        return $6NVMl.styled;
    }
});

var $6NVMl = parcelRequire("6NVMl");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $6b3b06de371680d1$var$createUseThemeProps(name) {
    return $6NVMl.useThemeProps;
}


var $3380f876c6865bf9$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $3380f876c6865bf9$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($3380f876c6865bf9$exports, "__esModule", {
    value: true
});
$3380f876c6865bf9$exports.getSimpleTreeViewUtilityClass = $3380f876c6865bf9$var$getSimpleTreeViewUtilityClass;
$3380f876c6865bf9$exports.simpleTreeViewClasses = void 0;

var $3380f876c6865bf9$var$_generateUtilityClass = $3380f876c6865bf9$require$_interopRequireDefault((parcelRequire("4E9MM")));

var $3380f876c6865bf9$var$_generateUtilityClasses = $3380f876c6865bf9$require$_interopRequireDefault((parcelRequire("4bI4C")));
function $3380f876c6865bf9$var$getSimpleTreeViewUtilityClass(slot) {
    return (0, $3380f876c6865bf9$var$_generateUtilityClass.default)('MuiSimpleTreeView', slot);
}
const $3380f876c6865bf9$var$simpleTreeViewClasses = $3380f876c6865bf9$exports.simpleTreeViewClasses = (0, $3380f876c6865bf9$var$_generateUtilityClasses.default)('MuiSimpleTreeView', [
    'root',
    'item',
    'itemContent',
    'itemGroupTransition',
    'itemIconContainer',
    'itemLabel',
    'itemCheckbox'
]);


var $e46f8cc689dd0177$exports = {};
"use strict";
Object.defineProperty($e46f8cc689dd0177$exports, "__esModule", {
    value: true
});
Object.defineProperty($e46f8cc689dd0177$exports, "useTreeView", {
    enumerable: true,
    get: function() {
        return $383c07d1120ca8df$exports.useTreeView;
    }
});
var $383c07d1120ca8df$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $383c07d1120ca8df$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $383c07d1120ca8df$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($383c07d1120ca8df$exports, "__esModule", {
    value: true
});
$383c07d1120ca8df$exports.useTreeView = void 0;
$383c07d1120ca8df$exports.useTreeViewApiInitialization = $383c07d1120ca8df$var$useTreeViewApiInitialization;

var $383c07d1120ca8df$var$_extends2 = $383c07d1120ca8df$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $383c07d1120ca8df$var$React = $383c07d1120ca8df$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $383c07d1120ca8df$var$_useForkRef = $383c07d1120ca8df$require$_interopRequireDefault((parcelRequire("7uWLa")));
var $c5486d2fc939b2ee$exports = {};
"use strict";
Object.defineProperty($c5486d2fc939b2ee$exports, "__esModule", {
    value: true
});
Object.defineProperty($c5486d2fc939b2ee$exports, "TREE_VIEW_CORE_PLUGINS", {
    enumerable: true,
    get: function() {
        return $4ae690fa46e0bc52$exports.TREE_VIEW_CORE_PLUGINS;
    }
});
var $4ae690fa46e0bc52$exports = {};
"use strict";
Object.defineProperty($4ae690fa46e0bc52$exports, "__esModule", {
    value: true
});
$4ae690fa46e0bc52$exports.TREE_VIEW_CORE_PLUGINS = void 0;
var $ab0c83271d4dd213$exports = {};
"use strict";
Object.defineProperty($ab0c83271d4dd213$exports, "__esModule", {
    value: true
});
Object.defineProperty($ab0c83271d4dd213$exports, "useTreeViewInstanceEvents", {
    enumerable: true,
    get: function() {
        return $29505a7a5898ce69$exports.useTreeViewInstanceEvents;
    }
});
var $29505a7a5898ce69$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $29505a7a5898ce69$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($29505a7a5898ce69$exports, "__esModule", {
    value: true
});
$29505a7a5898ce69$exports.useTreeViewInstanceEvents = void 0;

var $29505a7a5898ce69$var$React = $29505a7a5898ce69$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $bed767915886babb$exports = {};
"use strict";
Object.defineProperty($bed767915886babb$exports, "__esModule", {
    value: true
});
Object.defineProperty($bed767915886babb$exports, "EventManager", {
    enumerable: true,
    get: function() {
        return $c9e8f41ed5873075$exports.EventManager;
    }
});
var $c9e8f41ed5873075$exports = {};
"use strict";
Object.defineProperty($c9e8f41ed5873075$exports, "__esModule", {
    value: true
});
$c9e8f41ed5873075$exports.EventManager = void 0;
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $c9e8f41ed5873075$var$EventManager {
    constructor(){
        this.maxListeners = 20;
        this.warnOnce = false;
        this.events = {};
    }
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}
$c9e8f41ed5873075$exports.EventManager = $c9e8f41ed5873075$var$EventManager;




const $29505a7a5898ce69$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
const $29505a7a5898ce69$var$useTreeViewInstanceEvents = ()=>{
    const [eventManager] = $29505a7a5898ce69$var$React.useState(()=>new $bed767915886babb$exports.EventManager());
    const publishEvent = $29505a7a5898ce69$var$React.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($29505a7a5898ce69$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        eventManager.emit(name, params, event);
    }, [
        eventManager
    ]);
    const subscribeEvent = $29505a7a5898ce69$var$React.useCallback((event, handler)=>{
        eventManager.on(event, handler);
        return ()=>{
            eventManager.removeListener(event, handler);
        };
    }, [
        eventManager
    ]);
    return {
        instance: {
            $$publishEvent: publishEvent,
            $$subscribeEvent: subscribeEvent
        }
    };
};
$29505a7a5898ce69$exports.useTreeViewInstanceEvents = $29505a7a5898ce69$var$useTreeViewInstanceEvents;
$29505a7a5898ce69$var$useTreeViewInstanceEvents.params = {};




var $eb6386a40307cc12$exports = {};
"use strict";
Object.defineProperty($eb6386a40307cc12$exports, "__esModule", {
    value: true
});
Object.defineProperty($eb6386a40307cc12$exports, "useTreeViewOptionalPlugins", {
    enumerable: true,
    get: function() {
        return $7eba4ebb68257589$exports.useTreeViewOptionalPlugins;
    }
});
var $7eba4ebb68257589$exports = {};
"use strict";
Object.defineProperty($7eba4ebb68257589$exports, "__esModule", {
    value: true
});
$7eba4ebb68257589$exports.useTreeViewOptionalPlugins = void 0;
const $7eba4ebb68257589$var$useTreeViewOptionalPlugins = ({ plugins: plugins })=>{
    const pluginSet = new Set(plugins);
    const getAvailablePlugins = ()=>pluginSet;
    return {
        instance: {
            getAvailablePlugins: getAvailablePlugins
        }
    };
};
$7eba4ebb68257589$exports.useTreeViewOptionalPlugins = $7eba4ebb68257589$var$useTreeViewOptionalPlugins;
$7eba4ebb68257589$var$useTreeViewOptionalPlugins.params = {};




var $05b34fc2ee6bddce$exports = {};
"use strict";
Object.defineProperty($05b34fc2ee6bddce$exports, "__esModule", {
    value: true
});
Object.defineProperty($05b34fc2ee6bddce$exports, "useTreeViewId", {
    enumerable: true,
    get: function() {
        return $5b244239498324ab$exports.useTreeViewId;
    }
});
var $5b244239498324ab$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $5b244239498324ab$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $5b244239498324ab$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($5b244239498324ab$exports, "__esModule", {
    value: true
});
$5b244239498324ab$exports.useTreeViewId = void 0;

var $5b244239498324ab$var$_extends2 = $5b244239498324ab$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $5b244239498324ab$var$React = $5b244239498324ab$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $38c0a2e603e59f07$exports = {};
"use strict";
Object.defineProperty($38c0a2e603e59f07$exports, "__esModule", {
    value: true
});
$38c0a2e603e59f07$exports.useSelector = void 0;
var $6b1fc6b5623be35e$exports = {};
'use strict';

$6b1fc6b5623be35e$exports = (parcelRequire("htUof"));


const $38c0a2e603e59f07$var$defaultCompare = Object.is;
const $38c0a2e603e59f07$var$useSelector = (store, selector, args, equals = $38c0a2e603e59f07$var$defaultCompare)=>{
    const selectorWithArgs = (state)=>selector(state, args);
    return (0, $6b1fc6b5623be35e$exports.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs, equals);
};
$38c0a2e603e59f07$exports.useSelector = $38c0a2e603e59f07$var$useSelector;


var $4dfa2e8708449837$exports = {};
"use strict";
Object.defineProperty($4dfa2e8708449837$exports, "__esModule", {
    value: true
});
$4dfa2e8708449837$exports.selectorTreeViewId = void 0;
var $11a1a9bd6141dd56$exports = {};
"use strict";
Object.defineProperty($11a1a9bd6141dd56$exports, "__esModule", {
    value: true
});
$11a1a9bd6141dd56$exports.createSelector = void 0;
var $90730c39e9f007a7$var$__defProp = Object.defineProperty;
var $90730c39e9f007a7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $90730c39e9f007a7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $90730c39e9f007a7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $90730c39e9f007a7$var$__defNormalProp = (obj, key, value)=>key in obj ? $90730c39e9f007a7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $90730c39e9f007a7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($90730c39e9f007a7$var$__hasOwnProp.call(b, prop)) $90730c39e9f007a7$var$__defNormalProp(a, prop, b[prop]);
    if ($90730c39e9f007a7$var$__getOwnPropSymbols) {
        for (var prop of $90730c39e9f007a7$var$__getOwnPropSymbols(b))if ($90730c39e9f007a7$var$__propIsEnum.call(b, prop)) $90730c39e9f007a7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $90730c39e9f007a7$var$__publicField = (obj, key, value)=>{
    $90730c39e9f007a7$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $90730c39e9f007a7$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $90730c39e9f007a7$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $90730c39e9f007a7$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $90730c39e9f007a7$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($90730c39e9f007a7$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $90730c39e9f007a7$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $90730c39e9f007a7$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $90730c39e9f007a7$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $90730c39e9f007a7$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $90730c39e9f007a7$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $90730c39e9f007a7$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $90730c39e9f007a7$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $90730c39e9f007a7$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $90730c39e9f007a7$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $90730c39e9f007a7$var$__spreadValues($90730c39e9f007a7$var$__spreadValues({}, $90730c39e9f007a7$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $90730c39e9f007a7$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $90730c39e9f007a7$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $90730c39e9f007a7$var$$REVISION = 0;
var $90730c39e9f007a7$var$CURRENT_TRACKER = null;
var $90730c39e9f007a7$var$Cell = class {
    constructor(initialValue, isEqual = $90730c39e9f007a7$var$tripleEq){
        $90730c39e9f007a7$var$__publicField(this, "revision", $90730c39e9f007a7$var$$REVISION);
        $90730c39e9f007a7$var$__publicField(this, "_value");
        $90730c39e9f007a7$var$__publicField(this, "_lastValue");
        $90730c39e9f007a7$var$__publicField(this, "_isEqual", $90730c39e9f007a7$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $90730c39e9f007a7$var$CURRENT_TRACKER == null || $90730c39e9f007a7$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$90730c39e9f007a7$var$$REVISION;
    }
};
function $90730c39e9f007a7$var$tripleEq(a, b) {
    return a === b;
}
var $90730c39e9f007a7$var$TrackingCache = class {
    constructor(fn){
        $90730c39e9f007a7$var$__publicField(this, "_cachedValue");
        $90730c39e9f007a7$var$__publicField(this, "_cachedRevision", -1);
        $90730c39e9f007a7$var$__publicField(this, "_deps", []);
        $90730c39e9f007a7$var$__publicField(this, "hits", 0);
        $90730c39e9f007a7$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $90730c39e9f007a7$var$CURRENT_TRACKER;
            $90730c39e9f007a7$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $90730c39e9f007a7$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $90730c39e9f007a7$var$CURRENT_TRACKER == null || $90730c39e9f007a7$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $90730c39e9f007a7$var$getValue(cell) {
    if (!(cell instanceof $90730c39e9f007a7$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $90730c39e9f007a7$var$setValue(storage, value) {
    if (!(storage instanceof $90730c39e9f007a7$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $90730c39e9f007a7$var$createCell(initialValue, isEqual = $90730c39e9f007a7$var$tripleEq) {
    return new $90730c39e9f007a7$var$Cell(initialValue, isEqual);
}
function $90730c39e9f007a7$var$createCache(fn) {
    $90730c39e9f007a7$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $90730c39e9f007a7$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $90730c39e9f007a7$var$neverEq = (a, b)=>false;
function $90730c39e9f007a7$var$createTag() {
    return $90730c39e9f007a7$var$createCell(null, $90730c39e9f007a7$var$neverEq);
}
function $90730c39e9f007a7$var$dirtyTag(tag, value) {
    $90730c39e9f007a7$var$setValue(tag, value);
}
var $90730c39e9f007a7$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $90730c39e9f007a7$var$createTag();
    $90730c39e9f007a7$var$getValue(tag);
};
var $90730c39e9f007a7$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $90730c39e9f007a7$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $90730c39e9f007a7$var$REDUX_PROXY_LABEL = Symbol();
var $90730c39e9f007a7$var$nextId = 0;
var $90730c39e9f007a7$var$proto = Object.getPrototypeOf({});
var $90730c39e9f007a7$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $90730c39e9f007a7$var$__publicField(this, "proxy", new Proxy(this, $90730c39e9f007a7$var$objectProxyHandler));
        $90730c39e9f007a7$var$__publicField(this, "tag", $90730c39e9f007a7$var$createTag());
        $90730c39e9f007a7$var$__publicField(this, "tags", {});
        $90730c39e9f007a7$var$__publicField(this, "children", {});
        $90730c39e9f007a7$var$__publicField(this, "collectionTag", null);
        $90730c39e9f007a7$var$__publicField(this, "id", $90730c39e9f007a7$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $90730c39e9f007a7$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $90730c39e9f007a7$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $90730c39e9f007a7$var$createNode(childValue);
                if (childNode.tag) $90730c39e9f007a7$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $90730c39e9f007a7$var$createTag();
                    tag.value = childValue;
                }
                $90730c39e9f007a7$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $90730c39e9f007a7$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $90730c39e9f007a7$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $90730c39e9f007a7$var$__publicField(this, "proxy", new Proxy([
            this
        ], $90730c39e9f007a7$var$arrayProxyHandler));
        $90730c39e9f007a7$var$__publicField(this, "tag", $90730c39e9f007a7$var$createTag());
        $90730c39e9f007a7$var$__publicField(this, "tags", {});
        $90730c39e9f007a7$var$__publicField(this, "children", {});
        $90730c39e9f007a7$var$__publicField(this, "collectionTag", null);
        $90730c39e9f007a7$var$__publicField(this, "id", $90730c39e9f007a7$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $90730c39e9f007a7$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $90730c39e9f007a7$var$consumeCollection(node);
        return $90730c39e9f007a7$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $90730c39e9f007a7$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $90730c39e9f007a7$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $90730c39e9f007a7$var$objectProxyHandler.has(node, prop);
    }
};
function $90730c39e9f007a7$var$createNode(value) {
    if (Array.isArray(value)) return new $90730c39e9f007a7$var$ArrayTreeNode(value);
    return new $90730c39e9f007a7$var$ObjectTreeNode(value);
}
function $90730c39e9f007a7$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $90730c39e9f007a7$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $90730c39e9f007a7$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $90730c39e9f007a7$var$dirtyCollection(node);
            $90730c39e9f007a7$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $90730c39e9f007a7$var$updateNode(childNode, newChildValue);
        else {
            $90730c39e9f007a7$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $90730c39e9f007a7$var$deleteNode(node) {
    if (node.tag) $90730c39e9f007a7$var$dirtyTag(node.tag, null);
    $90730c39e9f007a7$var$dirtyCollection(node);
    for(const key in node.tags)$90730c39e9f007a7$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$90730c39e9f007a7$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $90730c39e9f007a7$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $90730c39e9f007a7$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $90730c39e9f007a7$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $90730c39e9f007a7$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $90730c39e9f007a7$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $90730c39e9f007a7$export$3f025202a230c6dd = (a, b)=>a === b;
function $90730c39e9f007a7$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $90730c39e9f007a7$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $90730c39e9f007a7$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $90730c39e9f007a7$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $90730c39e9f007a7$var$createSingletonCache(comparator) : $90730c39e9f007a7$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $90730c39e9f007a7$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $90730c39e9f007a7$export$c8f9cf88d9fdee55(func) {
    const node = $90730c39e9f007a7$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $90730c39e9f007a7$var$createCacheKeyComparator($90730c39e9f007a7$export$3f025202a230c6dd);
    const cache = $90730c39e9f007a7$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $90730c39e9f007a7$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $90730c39e9f007a7$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $90730c39e9f007a7$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $90730c39e9f007a7$var$StrongRef;
var $90730c39e9f007a7$var$UNTERMINATED = 0;
var $90730c39e9f007a7$var$TERMINATED = 1;
function $90730c39e9f007a7$var$createCacheNode() {
    return {
        s: $90730c39e9f007a7$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $90730c39e9f007a7$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $90730c39e9f007a7$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $90730c39e9f007a7$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $90730c39e9f007a7$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $90730c39e9f007a7$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $90730c39e9f007a7$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $90730c39e9f007a7$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $90730c39e9f007a7$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $90730c39e9f007a7$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $90730c39e9f007a7$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $90730c39e9f007a7$var$__spreadValues($90730c39e9f007a7$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $90730c39e9f007a7$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $90730c39e9f007a7$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $90730c39e9f007a7$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $90730c39e9f007a7$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $90730c39e9f007a7$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $90730c39e9f007a7$export$595d22ed68ca2841 = /* @__PURE__ */ $90730c39e9f007a7$export$5943f4447f6ef248($90730c39e9f007a7$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $90730c39e9f007a7$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $90730c39e9f007a7$export$595d22ed68ca2841)=>{
    $90730c39e9f007a7$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$90730c39e9f007a7$export$75979cfcd91bf38f
});


const $11a1a9bd6141dd56$var$reselectCreateSelector = (0, $90730c39e9f007a7$export$5943f4447f6ef248)({
    memoize: $90730c39e9f007a7$export$d8ead1d92249919b,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
const $11a1a9bd6141dd56$var$cache = new WeakMap();
/**
 * Type of a selector that take the whole tree view state as input and returns a value based on a required plugin.
 */ /**
 * Type of a selector that take the whole tree view state as input and returns a value based on an optional plugin.
 */ /**
 * Method wrapping reselect's createSelector to provide caching for tree view instances.
 *
 */ const $11a1a9bd6141dd56$var$createSelector = (...createSelectorArgs)=>{
    const selector = (state, selectorArgs)=>{
        const cacheKey = state.cacheKey;
        // If there is no cache for the current tree view instance, create one.
        let cacheForCurrentTreeViewInstance = $11a1a9bd6141dd56$var$cache.get(cacheKey);
        if (!cacheForCurrentTreeViewInstance) {
            cacheForCurrentTreeViewInstance = new Map();
            $11a1a9bd6141dd56$var$cache.set(cacheKey, cacheForCurrentTreeViewInstance);
        }
        // If there is a cached selector, execute it.
        const cachedSelector = cacheForCurrentTreeViewInstance.get(createSelectorArgs);
        if (cachedSelector) return cachedSelector(state, selectorArgs);
        // Otherwise, create a new selector and cache it and execute it.
        const fn = $11a1a9bd6141dd56$var$reselectCreateSelector(...createSelectorArgs);
        cacheForCurrentTreeViewInstance.set(createSelectorArgs, fn);
        return fn(state, selectorArgs);
    };
    return selector;
};
$11a1a9bd6141dd56$exports.createSelector = $11a1a9bd6141dd56$var$createSelector;


const $4dfa2e8708449837$var$selectorTreeViewIdState = (state)=>state.id;
/**
 * Get the id attribute of the tree view.
 * @param {TreeViewState<[UseTreeViewIdSignature]>} state The state of the tree view.
 * @returns {string} The id attribute of the tree view.
 */ const $4dfa2e8708449837$var$selectorTreeViewId = $4dfa2e8708449837$exports.selectorTreeViewId = (0, $11a1a9bd6141dd56$exports.createSelector)($4dfa2e8708449837$var$selectorTreeViewIdState, (idState)=>idState.treeId);


var $fef5881a3f8874a0$exports = {};
"use strict";
Object.defineProperty($fef5881a3f8874a0$exports, "__esModule", {
    value: true
});
$fef5881a3f8874a0$exports.generateTreeItemIdAttribute = $fef5881a3f8874a0$exports.createTreeViewDefaultId = void 0;
let $fef5881a3f8874a0$var$globalTreeViewDefaultId = 0;
const $fef5881a3f8874a0$var$createTreeViewDefaultId = ()=>{
    $fef5881a3f8874a0$var$globalTreeViewDefaultId += 1;
    return `mui-tree-view-${$fef5881a3f8874a0$var$globalTreeViewDefaultId}`;
};
/**
 * Generate the id attribute (i.e.: the `id` attribute passed to the DOM element) of a Tree Item.
 * If the user explicitly defined an id attribute, it will be returned.
 * Otherwise, the method creates a unique id for the item based on the Tree View id attribute and the item `itemId`
 * @param {object} params The parameters to determine the id attribute of the item.
 * @param {TreeViewItemId} params.itemId The id of the item to get the id attribute of.
 * @param {string | undefined} params.idAttribute The id attribute of the item if explicitly defined by the user.
 * @param {string} params.treeId The id attribute of the Tree View.
 * @returns {string} The id attribute of the item.
 */ $fef5881a3f8874a0$exports.createTreeViewDefaultId = $fef5881a3f8874a0$var$createTreeViewDefaultId;
const $fef5881a3f8874a0$var$generateTreeItemIdAttribute = ({ id: id, treeId: treeId = '', itemId: itemId })=>{
    if (id != null) return id;
    return `${treeId}-${itemId}`;
};
$fef5881a3f8874a0$exports.generateTreeItemIdAttribute = $fef5881a3f8874a0$var$generateTreeItemIdAttribute;


const $5b244239498324ab$var$useTreeViewId = ({ params: params, store: store })=>{
    $5b244239498324ab$var$React.useEffect(()=>{
        store.update((prevState)=>{
            if (params.id === prevState.id.providedTreeId && prevState.id.treeId !== undefined) return prevState;
            return (0, $5b244239498324ab$var$_extends2.default)({}, prevState, {
                id: (0, $5b244239498324ab$var$_extends2.default)({}, prevState.id, {
                    treeId: params.id ?? (0, $fef5881a3f8874a0$exports.createTreeViewDefaultId)()
                })
            });
        });
    }, [
        store,
        params.id
    ]);
    const treeId = (0, $38c0a2e603e59f07$exports.useSelector)(store, $4dfa2e8708449837$exports.selectorTreeViewId);
    return {
        getRootProps: ()=>({
                id: treeId
            })
    };
};
$5b244239498324ab$exports.useTreeViewId = $5b244239498324ab$var$useTreeViewId;
$5b244239498324ab$var$useTreeViewId.params = {
    id: true
};
$5b244239498324ab$var$useTreeViewId.getInitialState = ({ id: id })=>({
        id: {
            treeId: undefined,
            providedTreeId: id
        }
    });




/**
 * Internal plugins that create the tools used by the other plugins.
 * These plugins are used by the Tree View components.
 */ const $4ae690fa46e0bc52$var$TREE_VIEW_CORE_PLUGINS = $4ae690fa46e0bc52$exports.TREE_VIEW_CORE_PLUGINS = [
    $ab0c83271d4dd213$exports.useTreeViewInstanceEvents,
    $eb6386a40307cc12$exports.useTreeViewOptionalPlugins,
    $05b34fc2ee6bddce$exports.useTreeViewId
];




var $2b87e6cea7c40a1d$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $2b87e6cea7c40a1d$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($2b87e6cea7c40a1d$exports, "__esModule", {
    value: true
});
$2b87e6cea7c40a1d$exports.extractPluginParamsFromProps = void 0;

var $2b87e6cea7c40a1d$var$_objectWithoutPropertiesLoose2 = $2b87e6cea7c40a1d$require$_interopRequireDefault((parcelRequire("68UY6")));
const $2b87e6cea7c40a1d$var$_excluded = [
    "apiRef",
    "experimentalFeatures"
];
const $2b87e6cea7c40a1d$var$extractPluginParamsFromProps = (_ref)=>{
    let { props: { apiRef: apiRef, experimentalFeatures: inExperimentalFeatures }, plugins: plugins } = _ref, props = (0, $2b87e6cea7c40a1d$var$_objectWithoutPropertiesLoose2.default)(_ref.props, $2b87e6cea7c40a1d$var$_excluded);
    const paramsLookup = {};
    plugins.forEach((plugin)=>{
        Object.assign(paramsLookup, plugin.params);
    });
    const pluginParams = {};
    const forwardedProps = {};
    Object.keys(props).forEach((propName)=>{
        const prop = props[propName];
        if (paramsLookup[propName]) pluginParams[propName] = prop;
        else forwardedProps[propName] = prop;
    });
    const experimentalFeatures = inExperimentalFeatures ?? {};
    const defaultizedPluginParams = plugins.reduce((acc, plugin)=>{
        if (plugin.getDefaultizedParams) return plugin.getDefaultizedParams({
            params: acc,
            experimentalFeatures: experimentalFeatures
        });
        return acc;
    }, pluginParams);
    return {
        apiRef: apiRef,
        forwardedProps: forwardedProps,
        pluginParams: defaultizedPluginParams,
        experimentalFeatures: experimentalFeatures
    };
};
$2b87e6cea7c40a1d$exports.extractPluginParamsFromProps = $2b87e6cea7c40a1d$var$extractPluginParamsFromProps;


var $f2c547a40e907721$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $f2c547a40e907721$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($f2c547a40e907721$exports, "__esModule", {
    value: true
});
$f2c547a40e907721$exports.useTreeViewBuildContext = void 0;

var $f2c547a40e907721$var$React = $f2c547a40e907721$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $f2c547a40e907721$var$useTreeViewBuildContext = ({ plugins: plugins, instance: instance, publicAPI: publicAPI, store: store, rootRef: rootRef })=>{
    const runItemPlugins = $f2c547a40e907721$var$React.useCallback((itemPluginProps)=>{
        let finalRootRef = null;
        let finalContentRef = null;
        const pluginPropEnhancers = [];
        const pluginPropEnhancersNames = {};
        plugins.forEach((plugin)=>{
            if (!plugin.itemPlugin) return;
            const itemPluginResponse = plugin.itemPlugin({
                props: itemPluginProps,
                rootRef: finalRootRef,
                contentRef: finalContentRef
            });
            if (itemPluginResponse?.rootRef) finalRootRef = itemPluginResponse.rootRef;
            if (itemPluginResponse?.contentRef) finalContentRef = itemPluginResponse.contentRef;
            if (itemPluginResponse?.propsEnhancers) {
                pluginPropEnhancers.push(itemPluginResponse.propsEnhancers);
                // Prepare a list of all the slots which are enhanced by at least one plugin
                Object.keys(itemPluginResponse.propsEnhancers).forEach((propsEnhancerName)=>{
                    pluginPropEnhancersNames[propsEnhancerName] = true;
                });
            }
        });
        const resolvePropsEnhancer = (currentSlotName)=>(currentSlotParams)=>{
                const enhancedProps = {};
                pluginPropEnhancers.forEach((propsEnhancersForCurrentPlugin)=>{
                    const propsEnhancerForCurrentPluginAndSlot = propsEnhancersForCurrentPlugin[currentSlotName];
                    if (propsEnhancerForCurrentPluginAndSlot != null) Object.assign(enhancedProps, propsEnhancerForCurrentPluginAndSlot(currentSlotParams));
                });
                return enhancedProps;
            };
        const propsEnhancers = Object.fromEntries(Object.keys(pluginPropEnhancersNames).map((propEnhancerName)=>[
                propEnhancerName,
                resolvePropsEnhancer(propEnhancerName)
            ]));
        return {
            contentRef: finalContentRef,
            rootRef: finalRootRef,
            propsEnhancers: propsEnhancers
        };
    }, [
        plugins
    ]);
    const wrapItem = $f2c547a40e907721$var$React.useCallback(({ itemId: itemId, children: children, idAttribute: idAttribute })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapItem) finalChildren = plugin.wrapItem({
                instance: instance,
                itemId: itemId,
                children: finalChildren,
                idAttribute: idAttribute
            });
        }
        return finalChildren;
    }, [
        plugins,
        instance
    ]);
    const wrapRoot = $f2c547a40e907721$var$React.useCallback(({ children: children })=>{
        let finalChildren = children;
        // The wrappers are reversed to ensure that the first wrapper is the outermost one.
        for(let i = plugins.length - 1; i >= 0; i -= 1){
            const plugin = plugins[i];
            if (plugin.wrapRoot) finalChildren = plugin.wrapRoot({
                children: finalChildren
            });
        }
        return finalChildren;
    }, [
        plugins
    ]);
    return $f2c547a40e907721$var$React.useMemo(()=>({
            runItemPlugins: runItemPlugins,
            wrapItem: wrapItem,
            wrapRoot: wrapRoot,
            instance: instance,
            publicAPI: publicAPI,
            store: store,
            rootRef: rootRef
        }), [
        runItemPlugins,
        wrapItem,
        wrapRoot,
        instance,
        publicAPI,
        store,
        rootRef
    ]);
};
$f2c547a40e907721$exports.useTreeViewBuildContext = $f2c547a40e907721$var$useTreeViewBuildContext;


var $8f230582ae5fdaee$exports = {};
"use strict";
Object.defineProperty($8f230582ae5fdaee$exports, "__esModule", {
    value: true
});
$8f230582ae5fdaee$exports.TreeViewStore = void 0;
class $8f230582ae5fdaee$var$TreeViewStore {
    constructor(value){
        this.value = void 0;
        this.listeners = void 0;
        this.subscribe = (fn)=>{
            this.listeners.add(fn);
            return ()=>{
                this.listeners.delete(fn);
            };
        };
        this.getSnapshot = ()=>{
            return this.value;
        };
        this.update = (updater)=>{
            const newState = updater(this.value);
            if (newState !== this.value) {
                this.value = newState;
                this.listeners.forEach((l)=>l(newState));
            }
        };
        this.value = value;
        this.listeners = new Set();
    }
}
$8f230582ae5fdaee$exports.TreeViewStore = $8f230582ae5fdaee$var$TreeViewStore;


function $383c07d1120ca8df$var$initializeInputApiRef(inputApiRef) {
    if (inputApiRef.current == null) inputApiRef.current = {};
    return inputApiRef;
}
function $383c07d1120ca8df$var$useTreeViewApiInitialization(inputApiRef) {
    const fallbackPublicApiRef = $383c07d1120ca8df$var$React.useRef({});
    if (inputApiRef) return $383c07d1120ca8df$var$initializeInputApiRef(inputApiRef);
    return fallbackPublicApiRef;
}
let $383c07d1120ca8df$var$globalId = 0;
/**
 * This is the main hook that sets the plugin system up for the tree-view.
 *
 * It manages the data used to create the tree-view.
 *
 * @param plugins All the plugins that will be used in the tree-view.
 * @param props The props passed to the tree-view.
 * @param rootRef The ref of the root element.
 */ const $383c07d1120ca8df$var$useTreeView = ({ plugins: inPlugins, rootRef: rootRef, props: props })=>{
    const plugins = $383c07d1120ca8df$var$React.useMemo(()=>[
            ...$c5486d2fc939b2ee$exports.TREE_VIEW_CORE_PLUGINS,
            ...inPlugins
        ], [
        inPlugins
    ]);
    const { pluginParams: pluginParams, forwardedProps: forwardedProps, apiRef: apiRef, experimentalFeatures: experimentalFeatures } = (0, $2b87e6cea7c40a1d$exports.extractPluginParamsFromProps)({
        plugins: plugins,
        props: props
    });
    const instanceRef = $383c07d1120ca8df$var$React.useRef({});
    const instance = instanceRef.current;
    const publicAPI = $383c07d1120ca8df$var$useTreeViewApiInitialization(apiRef);
    const innerRootRef = $383c07d1120ca8df$var$React.useRef(null);
    const handleRootRef = (0, $383c07d1120ca8df$var$_useForkRef.default)(innerRootRef, rootRef);
    const storeRef = $383c07d1120ca8df$var$React.useRef(null);
    if (storeRef.current == null) {
        $383c07d1120ca8df$var$globalId += 1;
        const initialState = {
            cacheKey: {
                id: $383c07d1120ca8df$var$globalId
            }
        };
        plugins.forEach((plugin)=>{
            if (plugin.getInitialState) Object.assign(initialState, plugin.getInitialState(pluginParams));
        });
        storeRef.current = new $8f230582ae5fdaee$exports.TreeViewStore(initialState);
    }
    const contextValue = (0, $f2c547a40e907721$exports.useTreeViewBuildContext)({
        plugins: plugins,
        instance: instance,
        publicAPI: publicAPI.current,
        store: storeRef.current,
        rootRef: innerRootRef
    });
    const rootPropsGetters = [];
    const runPlugin = (plugin)=>{
        const pluginResponse = plugin({
            instance: instance,
            params: pluginParams,
            experimentalFeatures: experimentalFeatures,
            rootRef: innerRootRef,
            plugins: plugins,
            store: storeRef.current
        });
        if (pluginResponse.getRootProps) rootPropsGetters.push(pluginResponse.getRootProps);
        if (pluginResponse.publicAPI) Object.assign(publicAPI.current, pluginResponse.publicAPI);
        if (pluginResponse.instance) Object.assign(instance, pluginResponse.instance);
    };
    plugins.forEach(runPlugin);
    const getRootProps = (otherHandlers = {})=>{
        const rootProps = (0, $383c07d1120ca8df$var$_extends2.default)({
            role: 'tree'
        }, forwardedProps, otherHandlers, {
            ref: handleRootRef
        });
        rootPropsGetters.forEach((rootPropsGetter)=>{
            Object.assign(rootProps, rootPropsGetter(otherHandlers));
        });
        return rootProps;
    };
    return {
        getRootProps: getRootProps,
        rootRef: handleRootRef,
        contextValue: contextValue
    };
};
$383c07d1120ca8df$exports.useTreeView = $383c07d1120ca8df$var$useTreeView;




var $10a40780e7af645f$exports = {};
"use strict";
Object.defineProperty($10a40780e7af645f$exports, "__esModule", {
    value: true
});
Object.defineProperty($10a40780e7af645f$exports, "TreeViewProvider", {
    enumerable: true,
    get: function() {
        return $28bb1fd63f8debf2$exports.TreeViewProvider;
    }
});
Object.defineProperty($10a40780e7af645f$exports, "useTreeViewContext", {
    enumerable: true,
    get: function() {
        return $e00645ca7de9e15d$exports.useTreeViewContext;
    }
});
var $28bb1fd63f8debf2$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $28bb1fd63f8debf2$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($28bb1fd63f8debf2$exports, "__esModule", {
    value: true
});
$28bb1fd63f8debf2$exports.TreeViewProvider = $28bb1fd63f8debf2$var$TreeViewProvider;

var $28bb1fd63f8debf2$var$React = $28bb1fd63f8debf2$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $e00645ca7de9e15d$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $e00645ca7de9e15d$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($e00645ca7de9e15d$exports, "__esModule", {
    value: true
});
$e00645ca7de9e15d$exports.useTreeViewContext = $e00645ca7de9e15d$exports.TreeViewContext = void 0;

var $e00645ca7de9e15d$var$React = $e00645ca7de9e15d$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $e00645ca7de9e15d$var$TreeViewContext = $e00645ca7de9e15d$exports.TreeViewContext = /*#__PURE__*/ $e00645ca7de9e15d$var$React.createContext(null);
const $e00645ca7de9e15d$var$useTreeViewContext = ()=>{
    const context = $e00645ca7de9e15d$var$React.useContext($e00645ca7de9e15d$var$TreeViewContext);
    if (context == null) throw new Error([
        'MUI X: Could not find the Tree View context.',
        'It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    return context;
};
$e00645ca7de9e15d$exports.useTreeViewContext = $e00645ca7de9e15d$var$useTreeViewContext;


var $c5f4c2ae1ee81a8c$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $c5f4c2ae1ee81a8c$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($c5f4c2ae1ee81a8c$exports, "__esModule", {
    value: true
});
$c5f4c2ae1ee81a8c$exports.useTreeViewStyleContext = $c5f4c2ae1ee81a8c$exports.TreeViewStyleContext = void 0;

var $c5f4c2ae1ee81a8c$var$React = $c5f4c2ae1ee81a8c$require$_interopRequireWildcard((parcelRequire("8nGP5")));
/**
 * @ignore - internal component.
 */ const $c5f4c2ae1ee81a8c$var$TreeViewStyleContext = $c5f4c2ae1ee81a8c$exports.TreeViewStyleContext = /*#__PURE__*/ $c5f4c2ae1ee81a8c$var$React.createContext({
    classes: {},
    slots: {},
    slotProps: {}
});
const $c5f4c2ae1ee81a8c$var$useTreeViewStyleContext = ()=>{
    return $c5f4c2ae1ee81a8c$var$React.useContext($c5f4c2ae1ee81a8c$var$TreeViewStyleContext);
};
$c5f4c2ae1ee81a8c$exports.useTreeViewStyleContext = $c5f4c2ae1ee81a8c$var$useTreeViewStyleContext;



var $kSbwP = parcelRequire("kSbwP");
const $28bb1fd63f8debf2$var$EMPTY_OBJECT = {};
/**
 * Sets up the contexts for the underlying Tree Item components.
 *
 * @ignore - do not document.
 */ function $28bb1fd63f8debf2$var$TreeViewProvider(props) {
    const { contextValue: contextValue, classes: classes = $28bb1fd63f8debf2$var$EMPTY_OBJECT, slots: slots = $28bb1fd63f8debf2$var$EMPTY_OBJECT, slotProps: slotProps = $28bb1fd63f8debf2$var$EMPTY_OBJECT, children: children } = props;
    const styleContextValue = $28bb1fd63f8debf2$var$React.useMemo(()=>({
            classes: classes,
            slots: {
                collapseIcon: slots.collapseIcon,
                expandIcon: slots.expandIcon,
                endIcon: slots.endIcon
            },
            slotProps: {
                collapseIcon: slotProps.collapseIcon,
                expandIcon: slotProps.expandIcon,
                endIcon: slotProps.endIcon
            }
        }), [
        classes,
        slots.collapseIcon,
        slots.expandIcon,
        slots.endIcon,
        slotProps.collapseIcon,
        slotProps.expandIcon,
        slotProps.endIcon
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($e00645ca7de9e15d$exports.TreeViewContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($c5f4c2ae1ee81a8c$exports.TreeViewStyleContext.Provider, {
            value: styleContextValue,
            children: contextValue.wrapRoot({
                children: children
            })
        })
    });
}





var $d150c9485f08ca3f$exports = {};
"use strict";
Object.defineProperty($d150c9485f08ca3f$exports, "__esModule", {
    value: true
});
$d150c9485f08ca3f$exports.SIMPLE_TREE_VIEW_PLUGINS = void 0;
var $7fb7e6063f9de6ff$exports = {};
"use strict";
Object.defineProperty($7fb7e6063f9de6ff$exports, "__esModule", {
    value: true
});
Object.defineProperty($7fb7e6063f9de6ff$exports, "TREE_VIEW_ROOT_PARENT_ID", {
    enumerable: true,
    get: function() {
        return $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID;
    }
});
Object.defineProperty($7fb7e6063f9de6ff$exports, "buildSiblingIndexes", {
    enumerable: true,
    get: function() {
        return $6e9d2739eb68decb$exports.buildSiblingIndexes;
    }
});
Object.defineProperty($7fb7e6063f9de6ff$exports, "useTreeViewItems", {
    enumerable: true,
    get: function() {
        return $9572bdd32e0b1c67$exports.useTreeViewItems;
    }
});
var $9572bdd32e0b1c67$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9572bdd32e0b1c67$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $9572bdd32e0b1c67$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($9572bdd32e0b1c67$exports, "__esModule", {
    value: true
});
$9572bdd32e0b1c67$exports.useTreeViewItems = void 0;

var $9572bdd32e0b1c67$var$_extends2 = $9572bdd32e0b1c67$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $9572bdd32e0b1c67$var$React = $9572bdd32e0b1c67$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $9572bdd32e0b1c67$var$_useEventCallback = $9572bdd32e0b1c67$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $39d933053e68e997$exports = {};
"use strict";
Object.defineProperty($39d933053e68e997$exports, "__esModule", {
    value: true
});
$39d933053e68e997$exports.publishTreeViewEvent = void 0;
const $39d933053e68e997$var$publishTreeViewEvent = (instance, eventName, params)=>{
    instance.$$publishEvent(eventName, params);
};
$39d933053e68e997$exports.publishTreeViewEvent = $39d933053e68e997$var$publishTreeViewEvent;


var $6e9d2739eb68decb$exports = {};
"use strict";
Object.defineProperty($6e9d2739eb68decb$exports, "__esModule", {
    value: true
});
$6e9d2739eb68decb$exports.isItemDisabled = $6e9d2739eb68decb$exports.buildSiblingIndexes = $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID = void 0;
const $6e9d2739eb68decb$var$TREE_VIEW_ROOT_PARENT_ID = $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID = '__TREE_VIEW_ROOT_PARENT_ID__';
const $6e9d2739eb68decb$var$buildSiblingIndexes = (siblings)=>{
    const siblingsIndexLookup = {};
    siblings.forEach((childId, index)=>{
        siblingsIndexLookup[childId] = index;
    });
    return siblingsIndexLookup;
};
/**
 * Check if an item is disabled.
 * This method should only be used in selectors that are checking if several items are disabled.
 * Otherwise, use the `selectorIsItemDisabled` selector.
 * @returns
 */ $6e9d2739eb68decb$exports.buildSiblingIndexes = $6e9d2739eb68decb$var$buildSiblingIndexes;
const $6e9d2739eb68decb$var$isItemDisabled = (itemMetaLookup, itemId)=>{
    if (itemId == null) return false;
    let itemMeta = itemMetaLookup[itemId];
    // This can be called before the item has been added to the item map.
    if (!itemMeta) return false;
    if (itemMeta.disabled) return true;
    while(itemMeta.parentId != null){
        itemMeta = itemMetaLookup[itemMeta.parentId];
        if (!itemMeta) return false;
        if (itemMeta.disabled) return true;
    }
    return false;
};
$6e9d2739eb68decb$exports.isItemDisabled = $6e9d2739eb68decb$var$isItemDisabled;


var $25a3ca13bccc784d$exports = {};
"use strict";
Object.defineProperty($25a3ca13bccc784d$exports, "__esModule", {
    value: true
});
Object.defineProperty($25a3ca13bccc784d$exports, "TreeViewItemDepthContext", {
    enumerable: true,
    get: function() {
        return $5f6da498da2019f9$exports.TreeViewItemDepthContext;
    }
});
var $5f6da498da2019f9$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $5f6da498da2019f9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($5f6da498da2019f9$exports, "__esModule", {
    value: true
});
$5f6da498da2019f9$exports.TreeViewItemDepthContext = void 0;

var $5f6da498da2019f9$var$React = $5f6da498da2019f9$require$_interopRequireWildcard((parcelRequire("8nGP5")));
const $5f6da498da2019f9$var$TreeViewItemDepthContext = $5f6da498da2019f9$exports.TreeViewItemDepthContext = /*#__PURE__*/ $5f6da498da2019f9$var$React.createContext(()=>-1);




var $dd8775a0356c16b6$exports = {};
"use strict";
Object.defineProperty($dd8775a0356c16b6$exports, "__esModule", {
    value: true
});
$dd8775a0356c16b6$exports.selectorItemParentId = $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds = $dd8775a0356c16b6$exports.selectorItemModel = $dd8775a0356c16b6$exports.selectorItemMetaLookup = $dd8775a0356c16b6$exports.selectorItemMeta = $dd8775a0356c16b6$exports.selectorItemIndex = $dd8775a0356c16b6$exports.selectorItemDepth = $dd8775a0356c16b6$exports.selectorIsTreeViewLoading = $dd8775a0356c16b6$exports.selectorIsItemDisabled = $dd8775a0356c16b6$exports.selectorGetTreeViewError = $dd8775a0356c16b6$exports.selectorDisabledItemFocusable = $dd8775a0356c16b6$exports.selectorCanItemBeFocused = void 0;


const $dd8775a0356c16b6$var$selectorTreeViewItemsState = (state)=>state.items;
/**
 * Get the loading state for the Tree View.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} The loading state for the Tree View.
 */ const $dd8775a0356c16b6$var$selectorIsTreeViewLoading = $dd8775a0356c16b6$exports.selectorIsTreeViewLoading = (0, $11a1a9bd6141dd56$exports.createSelector)($dd8775a0356c16b6$var$selectorTreeViewItemsState, (items)=>items.loading);
/**
 * Get the error state for the Tree View.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} The error state for the Tree View.
 */ const $dd8775a0356c16b6$var$selectorGetTreeViewError = $dd8775a0356c16b6$exports.selectorGetTreeViewError = (0, $11a1a9bd6141dd56$exports.createSelector)($dd8775a0356c16b6$var$selectorTreeViewItemsState, (items)=>items.error);
/**
 * Get the meta-information of all items.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {TreeViewItemMetaLookup} The meta-information of all items.
 */ const $dd8775a0356c16b6$var$selectorItemMetaLookup = $dd8775a0356c16b6$exports.selectorItemMetaLookup = (0, $11a1a9bd6141dd56$exports.createSelector)($dd8775a0356c16b6$var$selectorTreeViewItemsState, (items)=>items.itemMetaLookup);
const $dd8775a0356c16b6$var$EMPTY_CHILDREN = [];
/**
 * Get the ordered children ids of a given item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the children of.
 * @returns {TreeViewItemId[]} The ordered children ids of the item.
 */ const $dd8775a0356c16b6$var$selectorItemOrderedChildrenIds = $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemOrderedChildrenIdsLookup[itemId ?? $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID] ?? $dd8775a0356c16b6$var$EMPTY_CHILDREN);
/**
 * Get the model of an item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the model of.
 * @returns {R} The model of the item.
 */ const $dd8775a0356c16b6$var$selectorItemModel = $dd8775a0356c16b6$exports.selectorItemModel = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemModelLookup[itemId]);
/**
 * Get the meta-information of an item.
 * Check the `TreeViewItemMeta` type for more information.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>}
 * @param {TreeViewItemId} itemId The id of the item to get the meta-information of.
 * @returns {TreeViewItemMeta | null} The meta-information of the item.
 */ const $dd8775a0356c16b6$var$selectorItemMeta = $dd8775a0356c16b6$exports.selectorItemMeta = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorItemMetaLookup,
    (_, itemId)=>itemId
], (itemMetaLookup, itemId)=>itemMetaLookup[itemId ?? $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID] ?? null);
/**
 * Check if an item is disabled.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is disabled, `false` otherwise.
 */ const $dd8775a0356c16b6$var$selectorIsItemDisabled = $dd8775a0356c16b6$exports.selectorIsItemDisabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorItemMetaLookup,
    (_, itemId)=>itemId
], $6e9d2739eb68decb$exports.isItemDisabled);
/**
 * Get the index of an item in its parent's children.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the index of.
 * @returns {number} The index of the item in its parent's children.
 */ const $dd8775a0356c16b6$var$selectorItemIndex = $dd8775a0356c16b6$exports.selectorItemIndex = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorTreeViewItemsState,
    $dd8775a0356c16b6$var$selectorItemMeta
], (itemsState, itemMeta)=>{
    if (itemMeta == null) return -1;
    const parentIndexes = itemsState.itemChildrenIndexesLookup[itemMeta.parentId ?? $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID];
    return parentIndexes[itemMeta.id];
});
/**
 * Get the id of the parent of an item.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the parent id of.
 * @returns {TreeViewItemId | null} The id of the parent of the item.
 */ const $dd8775a0356c16b6$var$selectorItemParentId = $dd8775a0356c16b6$exports.selectorItemParentId = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorItemMeta
], (itemMeta)=>itemMeta?.parentId ?? null);
/**
 * Get the depth of an item (items at the root level have a depth of 0).
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the depth of.
 * @returns {number} The depth of the item.
 */ const $dd8775a0356c16b6$var$selectorItemDepth = $dd8775a0356c16b6$exports.selectorItemDepth = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorItemMeta
], (itemMeta)=>itemMeta?.depth ?? 0);
/**
 * Check if the disabled items are focusable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} Whether the disabled items are focusable.
 */ const $dd8775a0356c16b6$var$selectorDisabledItemFocusable = $dd8775a0356c16b6$exports.selectorDisabledItemFocusable = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorTreeViewItemsState
], (itemsState)=>itemsState.disabledItemsFocusable);
const $dd8775a0356c16b6$var$selectorCanItemBeFocused = $dd8775a0356c16b6$exports.selectorCanItemBeFocused = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$var$selectorDisabledItemFocusable,
    $dd8775a0356c16b6$var$selectorIsItemDisabled
], (disabledItemsFocusable, isDisabled)=>{
    if (disabledItemsFocusable) return true;
    return !isDisabled;
});





var $kSbwP = parcelRequire("kSbwP");
const $9572bdd32e0b1c67$var$checkId = (id, item, itemMetaLookup)=>{
    if (id == null) throw new Error([
        'MUI X: The Tree View component requires all items to have a unique `id` property.',
        'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
        'An item was provided without id in the `items` prop:',
        JSON.stringify(item)
    ].join('\n'));
    if (itemMetaLookup[id] != null) throw new Error([
        'MUI X: The Tree View component requires all items to have a unique `id` property.',
        'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
        `Two items were provided with the same id in the \`items\` prop: "${id}"`
    ].join('\n'));
};
const $9572bdd32e0b1c67$var$processItemsLookups = ({ disabledItemsFocusable: disabledItemsFocusable, items: items, isItemDisabled: isItemDisabled, getItemLabel: getItemLabel, getItemId: getItemId, initialDepth: initialDepth = 0, initialParentId: initialParentId = null, getChildrenCount: getChildrenCount, ignoreChildren: ignoreChildren = false })=>{
    const itemMetaLookup = {};
    const itemModelLookup = {};
    const itemOrderedChildrenIdsLookup = {
        [$6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID]: []
    };
    const processItem = (item, depth, parentId)=>{
        const id = getItemId ? getItemId(item) : item.id;
        $9572bdd32e0b1c67$var$checkId(id, item, itemMetaLookup);
        const label = getItemLabel ? getItemLabel(item) : item.label;
        if (label == null) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'Alternatively, you can use the `getItemLabel` prop to specify a custom label for each item.',
            'An item was provided without label in the `items` prop:',
            JSON.stringify(item)
        ].join('\n'));
        itemMetaLookup[id] = {
            id: id,
            label: label,
            parentId: parentId,
            idAttribute: undefined,
            expandable: getChildrenCount ? getChildrenCount(item) > 0 : !!item.children?.length,
            disabled: isItemDisabled ? isItemDisabled(item) : false,
            depth: depth
        };
        itemModelLookup[id] = item;
        const parentIdWithDefault = parentId ?? $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID;
        if (!itemOrderedChildrenIdsLookup[parentIdWithDefault]) itemOrderedChildrenIdsLookup[parentIdWithDefault] = [];
        itemOrderedChildrenIdsLookup[parentIdWithDefault].push(id);
        // if lazy loading is enabled, we don't want to process children passed through the `items` prop
        if (!ignoreChildren) item.children?.forEach((child)=>processItem(child, depth + 1, id));
    };
    items?.forEach((item)=>processItem(item, initialDepth, initialParentId));
    const itemChildrenIndexesLookup = {};
    Object.keys(itemOrderedChildrenIdsLookup).forEach((parentId)=>{
        itemChildrenIndexesLookup[parentId] = (0, $6e9d2739eb68decb$exports.buildSiblingIndexes)(itemOrderedChildrenIdsLookup[parentId]);
    });
    return {
        disabledItemsFocusable: disabledItemsFocusable,
        itemMetaLookup: itemMetaLookup,
        itemModelLookup: itemModelLookup,
        itemOrderedChildrenIdsLookup: itemOrderedChildrenIdsLookup,
        itemChildrenIndexesLookup: itemChildrenIndexesLookup
    };
};
const $9572bdd32e0b1c67$var$useTreeViewItems = ({ instance: instance, params: params, store: store })=>{
    const getItem = $9572bdd32e0b1c67$var$React.useCallback((itemId)=>(0, $dd8775a0356c16b6$exports.selectorItemModel)(store.value, itemId), [
        store
    ]);
    const getParentId = $9572bdd32e0b1c67$var$React.useCallback((itemId)=>{
        const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(store.value, itemId);
        return itemMeta?.parentId || null;
    }, [
        store
    ]);
    const setTreeViewLoading = (0, $9572bdd32e0b1c67$var$_useEventCallback.default)((isLoading)=>{
        store.update((prevState)=>(0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, {
                    loading: isLoading
                })
            }));
    });
    const setTreeViewError = (0, $9572bdd32e0b1c67$var$_useEventCallback.default)((error)=>{
        store.update((prevState)=>(0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, {
                    error: error
                })
            }));
    });
    const setIsItemDisabled = (0, $9572bdd32e0b1c67$var$_useEventCallback.default)(({ itemId: itemId, shouldBeDisabled: shouldBeDisabled })=>{
        store.update((prevState)=>{
            if (!prevState.items.itemMetaLookup[itemId]) return prevState;
            const itemMetaLookup = (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items.itemMetaLookup);
            itemMetaLookup[itemId] = (0, $9572bdd32e0b1c67$var$_extends2.default)({}, itemMetaLookup[itemId], {
                disabled: shouldBeDisabled ?? !itemMetaLookup[itemId].disabled
            });
            return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: itemMetaLookup
                })
            });
        });
    });
    const getItemTree = $9572bdd32e0b1c67$var$React.useCallback(()=>{
        const getItemFromItemId = (itemId)=>{
            const item = (0, $dd8775a0356c16b6$exports.selectorItemModel)(store.value, itemId);
            const newChildren = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId);
            if (newChildren.length > 0) item.children = newChildren.map(getItemFromItemId);
            else delete item.children;
            return item;
        };
        return (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, null).map(getItemFromItemId);
    }, [
        store
    ]);
    const getItemOrderedChildrenIds = $9572bdd32e0b1c67$var$React.useCallback((itemId)=>(0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId), [
        store
    ]);
    const getItemDOMElement = (itemId)=>{
        const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(store.value, itemId);
        if (itemMeta == null) return null;
        const idAttribute = (0, $fef5881a3f8874a0$exports.generateTreeItemIdAttribute)({
            treeId: (0, $4dfa2e8708449837$exports.selectorTreeViewId)(store.value),
            itemId: itemId,
            id: itemMeta.idAttribute
        });
        return document.getElementById(idAttribute);
    };
    const areItemUpdatesPreventedRef = $9572bdd32e0b1c67$var$React.useRef(false);
    const preventItemUpdates = $9572bdd32e0b1c67$var$React.useCallback(()=>{
        areItemUpdatesPreventedRef.current = true;
    }, []);
    const areItemUpdatesPrevented = $9572bdd32e0b1c67$var$React.useCallback(()=>areItemUpdatesPreventedRef.current, []);
    const addItems = ({ items: items, parentId: parentId, depth: depth, getChildrenCount: getChildrenCount })=>{
        if (items) {
            const newState = $9572bdd32e0b1c67$var$processItemsLookups({
                disabledItemsFocusable: params.disabledItemsFocusable,
                items: items,
                isItemDisabled: params.isItemDisabled,
                getItemId: params.getItemId,
                getItemLabel: params.getItemLabel,
                getChildrenCount: getChildrenCount,
                initialDepth: depth,
                initialParentId: parentId,
                ignoreChildren: true
            });
            store.update((prevState)=>{
                let newItems;
                if (parentId) newItems = {
                    itemModelLookup: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items.itemModelLookup, newState.itemModelLookup),
                    itemMetaLookup: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items.itemMetaLookup, newState.itemMetaLookup),
                    itemOrderedChildrenIdsLookup: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, newState.itemOrderedChildrenIdsLookup, prevState.items.itemOrderedChildrenIdsLookup),
                    itemChildrenIndexesLookup: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, newState.itemChildrenIndexesLookup, prevState.items.itemChildrenIndexesLookup)
                };
                else newItems = {
                    itemModelLookup: newState.itemModelLookup,
                    itemMetaLookup: newState.itemMetaLookup,
                    itemOrderedChildrenIdsLookup: newState.itemOrderedChildrenIdsLookup,
                    itemChildrenIndexesLookup: newState.itemChildrenIndexesLookup
                };
                Object.values(prevState.items.itemMetaLookup).forEach((item)=>{
                    if (!newState.itemMetaLookup[item.id]) (0, $39d933053e68e997$exports.publishTreeViewEvent)(instance, 'removeItem', {
                        id: item.id
                    });
                });
                return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                    items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, newItems)
                });
            });
        }
    };
    const removeChildren = (parentId)=>{
        store.update((prevState)=>{
            if (!parentId) return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: {},
                    itemOrderedChildrenIdsLookup: {},
                    itemChildrenIndexesLookup: {}
                })
            });
            const newMetaMap = Object.keys(prevState.items.itemMetaLookup).reduce((acc, key)=>{
                const item = prevState.items.itemMetaLookup[key];
                if (item.parentId === parentId) {
                    (0, $39d933053e68e997$exports.publishTreeViewEvent)(instance, 'removeItem', {
                        id: item.id
                    });
                    return acc;
                }
                return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, acc, {
                    [item.id]: item
                });
            }, {});
            const newItemOrderedChildrenIdsLookup = prevState.items.itemOrderedChildrenIdsLookup;
            const newItemChildrenIndexesLookup = prevState.items.itemChildrenIndexesLookup;
            delete newItemChildrenIndexesLookup[parentId];
            delete newItemOrderedChildrenIdsLookup[parentId];
            return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: newMetaMap,
                    itemOrderedChildrenIdsLookup: newItemOrderedChildrenIdsLookup,
                    itemChildrenIndexesLookup: newItemChildrenIndexesLookup
                })
            });
        });
    };
    $9572bdd32e0b1c67$var$React.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        store.update((prevState)=>{
            const newState = $9572bdd32e0b1c67$var$processItemsLookups({
                disabledItemsFocusable: params.disabledItemsFocusable,
                items: params.items,
                isItemDisabled: params.isItemDisabled,
                getItemId: params.getItemId,
                getItemLabel: params.getItemLabel
            });
            Object.values(prevState.items.itemMetaLookup).forEach((item)=>{
                if (!newState.itemMetaLookup[item.id]) (0, $39d933053e68e997$exports.publishTreeViewEvent)(instance, 'removeItem', {
                    id: item.id
                });
            });
            return (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState, {
                items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, prevState.items, newState)
            });
        });
    }, [
        instance,
        store,
        params.items,
        params.disabledItemsFocusable,
        params.isItemDisabled,
        params.getItemId,
        params.getItemLabel
    ]);
    // Wrap `props.onItemClick` with `useEventCallback` to prevent unneeded context updates.
    const handleItemClick = (0, $9572bdd32e0b1c67$var$_useEventCallback.default)((event, itemId)=>{
        if (params.onItemClick) params.onItemClick(event, itemId);
    });
    return {
        getRootProps: ()=>({
                style: {
                    '--TreeView-itemChildrenIndentation': typeof params.itemChildrenIndentation === 'number' ? `${params.itemChildrenIndentation}px` : params.itemChildrenIndentation
                }
            }),
        publicAPI: {
            getItem: getItem,
            getItemDOMElement: getItemDOMElement,
            getItemTree: getItemTree,
            getItemOrderedChildrenIds: getItemOrderedChildrenIds,
            setIsItemDisabled: setIsItemDisabled,
            getParentId: getParentId
        },
        instance: {
            getItemDOMElement: getItemDOMElement,
            preventItemUpdates: preventItemUpdates,
            areItemUpdatesPrevented: areItemUpdatesPrevented,
            addItems: addItems,
            setTreeViewLoading: setTreeViewLoading,
            setTreeViewError: setTreeViewError,
            removeChildren: removeChildren,
            handleItemClick: handleItemClick
        }
    };
};
$9572bdd32e0b1c67$exports.useTreeViewItems = $9572bdd32e0b1c67$var$useTreeViewItems;
$9572bdd32e0b1c67$var$useTreeViewItems.getInitialState = (params)=>({
        items: (0, $9572bdd32e0b1c67$var$_extends2.default)({}, $9572bdd32e0b1c67$var$processItemsLookups({
            disabledItemsFocusable: params.disabledItemsFocusable,
            items: params.items,
            isItemDisabled: params.isItemDisabled,
            getItemId: params.getItemId,
            getItemLabel: params.getItemLabel
        }), {
            loading: false,
            error: null
        })
    });
$9572bdd32e0b1c67$var$useTreeViewItems.getDefaultizedParams = ({ params: params })=>(0, $9572bdd32e0b1c67$var$_extends2.default)({}, params, {
        disabledItemsFocusable: params.disabledItemsFocusable ?? false,
        itemChildrenIndentation: params.itemChildrenIndentation ?? '12px'
    });
$9572bdd32e0b1c67$var$useTreeViewItems.wrapRoot = ({ children: children })=>{
    return /*#__PURE__*/ (0, $kSbwP.jsx)($25a3ca13bccc784d$exports.TreeViewItemDepthContext.Provider, {
        value: $dd8775a0356c16b6$exports.selectorItemDepth,
        children: children
    });
};
$9572bdd32e0b1c67$var$useTreeViewItems.params = {
    disabledItemsFocusable: true,
    items: true,
    isItemDisabled: true,
    getItemLabel: true,
    getItemId: true,
    onItemClick: true,
    itemChildrenIndentation: true
};





var $dab860fc1c8a1d06$exports = {};
"use strict";
Object.defineProperty($dab860fc1c8a1d06$exports, "__esModule", {
    value: true
});
Object.defineProperty($dab860fc1c8a1d06$exports, "useTreeViewExpansion", {
    enumerable: true,
    get: function() {
        return $f730a1bf3d0da12c$exports.useTreeViewExpansion;
    }
});
var $f730a1bf3d0da12c$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $f730a1bf3d0da12c$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($f730a1bf3d0da12c$exports, "__esModule", {
    value: true
});
$f730a1bf3d0da12c$exports.useTreeViewExpansion = void 0;

var $f730a1bf3d0da12c$var$_extends2 = $f730a1bf3d0da12c$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $f730a1bf3d0da12c$var$_useEventCallback = $f730a1bf3d0da12c$require$_interopRequireDefault((parcelRequire("5xdHV")));

var $f730a1bf3d0da12c$var$_useEnhancedEffect = $f730a1bf3d0da12c$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $465b8a23aa196103$exports = {};
"use strict";
Object.defineProperty($465b8a23aa196103$exports, "__esModule", {
    value: true
});
$465b8a23aa196103$exports.selectorItemExpansionTrigger = $465b8a23aa196103$exports.selectorIsItemExpanded = $465b8a23aa196103$exports.selectorIsItemExpandable = $465b8a23aa196103$exports.selectorExpandedItemsMap = $465b8a23aa196103$exports.selectorExpandedItems = void 0;


const $465b8a23aa196103$var$selectorExpansion = (state)=>state.expansion;
/**
 * Get the expanded items.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId[]} The expanded items.
 */ const $465b8a23aa196103$var$selectorExpandedItems = $465b8a23aa196103$exports.selectorExpandedItems = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $465b8a23aa196103$var$selectorExpansion
], (expansionState)=>expansionState.expandedItems);
/**
 * Get the expanded items as a Map.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {TreeViewExpansionValue} The expanded items as a Map.
 */ const $465b8a23aa196103$var$selectorExpandedItemsMap = $465b8a23aa196103$exports.selectorExpandedItemsMap = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $465b8a23aa196103$var$selectorExpandedItems
], (expandedItems)=>{
    const expandedItemsMap = new Map();
    expandedItems.forEach((id)=>{
        expandedItemsMap.set(id, true);
    });
    return expandedItemsMap;
});
/**
 * Check if an item is expanded.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is expanded, `false` otherwise.
 */ const $465b8a23aa196103$var$selectorIsItemExpanded = $465b8a23aa196103$exports.selectorIsItemExpanded = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $465b8a23aa196103$var$selectorExpandedItemsMap,
    (_, itemId)=>itemId
], (expandedItemsMap, itemId)=>expandedItemsMap.has(itemId));
/**
 * Check if an item is expandable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is expandable, `false` otherwise.
 */ const $465b8a23aa196103$var$selectorIsItemExpandable = $465b8a23aa196103$exports.selectorIsItemExpandable = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$exports.selectorItemMeta
], (itemMeta)=>itemMeta?.expandable ?? false);
/**
 * Get the slot that triggers the item's expansion when clicked.
 * @param {TreeViewState<[UseTreeViewExpansionSignature]>} state The state of the tree view.
 * @returns {'content' | 'iconContainer'} The slot that triggers the item's expansion when clicked. Is `null` if the item is not expandable.
 */ const $465b8a23aa196103$var$selectorItemExpansionTrigger = $465b8a23aa196103$exports.selectorItemExpansionTrigger = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $465b8a23aa196103$var$selectorExpansion
], (expansionState)=>expansionState.expansionTrigger);


var $dc348150ffa638e3$exports = {};
"use strict";
Object.defineProperty($dc348150ffa638e3$exports, "__esModule", {
    value: true
});
$dc348150ffa638e3$exports.getExpansionTrigger = void 0;
const $dc348150ffa638e3$var$getExpansionTrigger = ({ isItemEditable: isItemEditable, expansionTrigger: expansionTrigger })=>{
    if (expansionTrigger) return expansionTrigger;
    if (isItemEditable) return 'iconContainer';
    return 'content';
};
$dc348150ffa638e3$exports.getExpansionTrigger = $dc348150ffa638e3$var$getExpansionTrigger;




var $33e5e4da6d4c5b66$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $33e5e4da6d4c5b66$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($33e5e4da6d4c5b66$exports, "__esModule", {
    value: true
});
$33e5e4da6d4c5b66$exports.useAssertModelConsistency = void 0;
var $d73676d7d94c237f$exports = {};
"use strict";
Object.defineProperty($d73676d7d94c237f$exports, "__esModule", {
    value: true
});
Object.defineProperty($d73676d7d94c237f$exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return $5f159749fec4c9a6$exports.clearWarningsCache;
    }
});
Object.defineProperty($d73676d7d94c237f$exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return $5f159749fec4c9a6$exports.warnOnce;
    }
});
var $5f159749fec4c9a6$exports = {};
"use strict";
Object.defineProperty($5f159749fec4c9a6$exports, "__esModule", {
    value: true
});
$5f159749fec4c9a6$exports.clearWarningsCache = $5f159749fec4c9a6$var$clearWarningsCache;
$5f159749fec4c9a6$exports.warnOnce = $5f159749fec4c9a6$var$warnOnce;
const $5f159749fec4c9a6$var$warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function $5f159749fec4c9a6$var$warnOnce(message, gravity = 'warning') {
    return;
}
function $5f159749fec4c9a6$var$clearWarningsCache() {
    $5f159749fec4c9a6$var$warnedOnceCache.clear();
}





var $33e5e4da6d4c5b66$var$React = $33e5e4da6d4c5b66$require$_interopRequireWildcard((parcelRequire("8nGP5")));
function $33e5e4da6d4c5b66$var$useAssertModelConsistencyOutsideOfProduction(parameters) {
    const { state: state, controlled: controlled, defaultValue: defaultValue } = parameters;
    const [{ initialDefaultValue: initialDefaultValue, isControlled: isControlled }] = $33e5e4da6d4c5b66$var$React.useState({
        initialDefaultValue: defaultValue,
        isControlled: controlled !== undefined
    });
    if (isControlled !== (controlled !== undefined)) (0, $d73676d7d94c237f$exports.warnOnce)([
        `MUI X: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of Tree View to be ${isControlled ? 'un' : ''}controlled.`,
        'Elements should not switch from uncontrolled to controlled (or vice versa).',
        `Decide between using a controlled or uncontrolled ${state} ` + 'element for the lifetime of the component.',
        "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
        'More info: https://fb.me/react-controlled-components'
    ], 'error');
    if (JSON.stringify(initialDefaultValue) !== JSON.stringify(defaultValue)) (0, $d73676d7d94c237f$exports.warnOnce)([
        `MUI X: A component is changing the default ${state} state of an uncontrolled Tree View after being initialized. ` + `To suppress this warning opt to use a controlled Tree View.`
    ], 'error');
}
const $33e5e4da6d4c5b66$var$useAssertModelConsistency = $33e5e4da6d4c5b66$exports.useAssertModelConsistency = ()=>{};


const $f730a1bf3d0da12c$var$useTreeViewExpansion = ({ instance: instance, store: store, params: params })=>{
    (0, $33e5e4da6d4c5b66$exports.useAssertModelConsistency)({
        state: 'expandedItems',
        controlled: params.expandedItems,
        defaultValue: params.defaultExpandedItems
    });
    (0, $f730a1bf3d0da12c$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>{
            const newExpansionTrigger = (0, $dc348150ffa638e3$exports.getExpansionTrigger)({
                isItemEditable: params.isItemEditable,
                expansionTrigger: params.expansionTrigger
            });
            if (prevState.expansion.expansionTrigger === newExpansionTrigger) return prevState;
            return (0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState, {
                expansion: (0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState.expansion, {
                    expansionTrigger: newExpansionTrigger
                })
            });
        });
    }, [
        store,
        params.isItemEditable,
        params.expansionTrigger
    ]);
    const setExpandedItems = (event, value)=>{
        if (params.expandedItems === undefined) store.update((prevState)=>(0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState, {
                expansion: (0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState.expansion, {
                    expandedItems: value
                })
            }));
        params.onExpandedItemsChange?.(event, value);
    };
    const applyItemExpansion = (0, $f730a1bf3d0da12c$var$_useEventCallback.default)(({ itemId: itemId, event: event, shouldBeExpanded: shouldBeExpanded })=>{
        const oldExpanded = (0, $465b8a23aa196103$exports.selectorExpandedItems)(store.value);
        let newExpanded;
        if (shouldBeExpanded) newExpanded = [
            itemId
        ].concat(oldExpanded);
        else newExpanded = oldExpanded.filter((id)=>id !== itemId);
        if (params.onItemExpansionToggle) params.onItemExpansionToggle(event, itemId, shouldBeExpanded);
        setExpandedItems(event, newExpanded);
    });
    const setItemExpansion = (0, $f730a1bf3d0da12c$var$_useEventCallback.default)(({ itemId: itemId, event: event = null, shouldBeExpanded: shouldBeExpanded })=>{
        const isExpandedBefore = (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, itemId);
        const cleanShouldBeExpanded = shouldBeExpanded ?? !isExpandedBefore;
        if (isExpandedBefore === cleanShouldBeExpanded) return;
        const eventParameters = {
            isExpansionPrevented: false,
            shouldBeExpanded: cleanShouldBeExpanded,
            event: event,
            itemId: itemId
        };
        (0, $39d933053e68e997$exports.publishTreeViewEvent)(instance, 'beforeItemToggleExpansion', eventParameters);
        if (eventParameters.isExpansionPrevented) return;
        instance.applyItemExpansion({
            itemId: itemId,
            event: event,
            shouldBeExpanded: cleanShouldBeExpanded
        });
    });
    const expandAllSiblings = (event, itemId)=>{
        const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(store.value, itemId);
        if (itemMeta == null) return;
        const siblings = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemMeta.parentId);
        const diff = siblings.filter((child)=>(0, $465b8a23aa196103$exports.selectorIsItemExpandable)(store.value, child) && !(0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, child));
        const newExpanded = (0, $465b8a23aa196103$exports.selectorExpandedItems)(store.value).concat(diff);
        if (diff.length > 0) {
            if (params.onItemExpansionToggle) diff.forEach((newlyExpandedItemId)=>{
                params.onItemExpansionToggle(event, newlyExpandedItemId, true);
            });
            setExpandedItems(event, newExpanded);
        }
    };
    /**
   * Update the controlled model when the `expandedItems` prop changes.
   */ (0, $f730a1bf3d0da12c$var$_useEnhancedEffect.default)(()=>{
        const expandedItems = params.expandedItems;
        if (expandedItems !== undefined) store.update((prevState)=>(0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState, {
                expansion: (0, $f730a1bf3d0da12c$var$_extends2.default)({}, prevState.expansion, {
                    expandedItems: expandedItems
                })
            }));
    }, [
        store,
        params.expandedItems
    ]);
    return {
        publicAPI: {
            setItemExpansion: setItemExpansion
        },
        instance: {
            setItemExpansion: setItemExpansion,
            applyItemExpansion: applyItemExpansion,
            expandAllSiblings: expandAllSiblings
        }
    };
};
$f730a1bf3d0da12c$exports.useTreeViewExpansion = $f730a1bf3d0da12c$var$useTreeViewExpansion;
const $f730a1bf3d0da12c$var$DEFAULT_EXPANDED_ITEMS = [];
$f730a1bf3d0da12c$var$useTreeViewExpansion.getDefaultizedParams = ({ params: params })=>(0, $f730a1bf3d0da12c$var$_extends2.default)({}, params, {
        defaultExpandedItems: params.defaultExpandedItems ?? $f730a1bf3d0da12c$var$DEFAULT_EXPANDED_ITEMS
    });
$f730a1bf3d0da12c$var$useTreeViewExpansion.getInitialState = (params)=>({
        expansion: {
            expandedItems: params.expandedItems === undefined ? params.defaultExpandedItems : params.expandedItems,
            expansionTrigger: (0, $dc348150ffa638e3$exports.getExpansionTrigger)(params)
        }
    });
$f730a1bf3d0da12c$var$useTreeViewExpansion.params = {
    expandedItems: true,
    defaultExpandedItems: true,
    onExpandedItemsChange: true,
    onItemExpansionToggle: true,
    expansionTrigger: true
};




var $569f083d8a710a0f$exports = {};
"use strict";
Object.defineProperty($569f083d8a710a0f$exports, "__esModule", {
    value: true
});
Object.defineProperty($569f083d8a710a0f$exports, "useTreeViewSelection", {
    enumerable: true,
    get: function() {
        return $9e66dcca63418a04$exports.useTreeViewSelection;
    }
});
var $9e66dcca63418a04$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9e66dcca63418a04$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $9e66dcca63418a04$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($9e66dcca63418a04$exports, "__esModule", {
    value: true
});
$9e66dcca63418a04$exports.useTreeViewSelection = void 0;

var $9e66dcca63418a04$var$_extends2 = $9e66dcca63418a04$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $9e66dcca63418a04$var$React = $9e66dcca63418a04$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $9e66dcca63418a04$var$_useEnhancedEffect = $9e66dcca63418a04$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $a95f02974ef5ffc0$exports = {};
"use strict";
Object.defineProperty($a95f02974ef5ffc0$exports, "__esModule", {
    value: true
});
$a95f02974ef5ffc0$exports.isTargetInDescendants = $a95f02974ef5ffc0$exports.getPreviousNavigableItem = $a95f02974ef5ffc0$exports.getNonDisabledItemsInRange = $a95f02974ef5ffc0$exports.getNextNavigableItem = $a95f02974ef5ffc0$exports.getLastNavigableItem = $a95f02974ef5ffc0$exports.getFirstNavigableItem = $a95f02974ef5ffc0$exports.getAllNavigableItems = $a95f02974ef5ffc0$exports.findOrderInTremauxTree = void 0;


const $a95f02974ef5ffc0$var$getLastNavigableItemInArray = (state, items)=>{
    // Equivalent to Array.prototype.findLastIndex
    let itemIndex = items.length - 1;
    while(itemIndex >= 0 && !(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, items[itemIndex]))itemIndex -= 1;
    if (itemIndex === -1) return undefined;
    return items[itemIndex];
};
const $a95f02974ef5ffc0$var$getPreviousNavigableItem = (state, itemId)=>{
    const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemId);
    if (!itemMeta) return null;
    const siblings = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
    const itemIndex = (0, $dd8775a0356c16b6$exports.selectorItemIndex)(state, itemId);
    // TODO: What should we do if the parent is not navigable?
    if (itemIndex === 0) return itemMeta.parentId;
    // Finds the previous navigable sibling.
    let previousNavigableSiblingIndex = itemIndex - 1;
    while(!(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, siblings[previousNavigableSiblingIndex]) && previousNavigableSiblingIndex >= 0)previousNavigableSiblingIndex -= 1;
    if (previousNavigableSiblingIndex === -1) {
        // If we are at depth 0, then it means all the items above the current item are not navigable.
        if (itemMeta.parentId == null) return null;
        // Otherwise, we can try to go up a level and find the previous navigable item.
        return $a95f02974ef5ffc0$var$getPreviousNavigableItem(state, itemMeta.parentId);
    }
    // Finds the last navigable ancestor of the previous navigable sibling.
    let currentItemId = siblings[previousNavigableSiblingIndex];
    let lastNavigableChild = $a95f02974ef5ffc0$var$getLastNavigableItemInArray(state, (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, currentItemId));
    while((0, $465b8a23aa196103$exports.selectorIsItemExpanded)(state, currentItemId) && lastNavigableChild != null){
        currentItemId = lastNavigableChild;
        lastNavigableChild = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, currentItemId).find((childId)=>(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, childId));
    }
    return currentItemId;
};
$a95f02974ef5ffc0$exports.getPreviousNavigableItem = $a95f02974ef5ffc0$var$getPreviousNavigableItem;
const $a95f02974ef5ffc0$var$getNextNavigableItem = (state, itemId)=>{
    // If the item is expanded and has some navigable children, return the first of them.
    if ((0, $465b8a23aa196103$exports.selectorIsItemExpanded)(state, itemId)) {
        const firstNavigableChild = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemId).find((childId)=>(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, childId));
        if (firstNavigableChild != null) return firstNavigableChild;
    }
    let itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemId);
    while(itemMeta != null){
        // Try to find the first navigable sibling after the current item.
        const siblings = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
        const currentItemIndex = (0, $dd8775a0356c16b6$exports.selectorItemIndex)(state, itemMeta.id);
        if (currentItemIndex < siblings.length - 1) {
            let nextItemIndex = currentItemIndex + 1;
            while(!(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, siblings[nextItemIndex]) && nextItemIndex < siblings.length - 1)nextItemIndex += 1;
            if ((0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, siblings[nextItemIndex])) return siblings[nextItemIndex];
        }
        // If the sibling does not exist, go up a level to the parent and try again.
        itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemMeta.parentId);
    }
    return null;
};
$a95f02974ef5ffc0$exports.getNextNavigableItem = $a95f02974ef5ffc0$var$getNextNavigableItem;
const $a95f02974ef5ffc0$var$getLastNavigableItem = (state)=>{
    let itemId = null;
    while(itemId == null || (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(state, itemId)){
        const children = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemId);
        const lastNavigableChild = $a95f02974ef5ffc0$var$getLastNavigableItemInArray(state, children);
        // The item has no navigable children.
        if (lastNavigableChild == null) return itemId;
        itemId = lastNavigableChild;
    }
    return itemId;
};
$a95f02974ef5ffc0$exports.getLastNavigableItem = $a95f02974ef5ffc0$var$getLastNavigableItem;
const $a95f02974ef5ffc0$var$getFirstNavigableItem = (state)=>(0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, null).find((itemId)=>(0, $dd8775a0356c16b6$exports.selectorCanItemBeFocused)(state, itemId));
/**
 * This is used to determine the start and end of a selection range so
 * we can get the items between the two border items.
 *
 * It finds the items' common ancestor using
 * a naive implementation of a lowest common ancestor algorithm
 * (https://en.wikipedia.org/wiki/Lowest_common_ancestor).
 * Then compares the ancestor's 2 children that are ancestors of itemA and ItemB
 * so we can compare their indexes to work out which item comes first in a depth first search.
 * (https://en.wikipedia.org/wiki/Depth-first_search)
 *
 * Another way to put it is which item is shallower in a trémaux tree
 * https://en.wikipedia.org/wiki/Tr%C3%A9maux_tree
 */ $a95f02974ef5ffc0$exports.getFirstNavigableItem = $a95f02974ef5ffc0$var$getFirstNavigableItem;
const $a95f02974ef5ffc0$var$findOrderInTremauxTree = (state, itemAId, itemBId)=>{
    if (itemAId === itemBId) return [
        itemAId,
        itemBId
    ];
    const itemMetaA = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemAId);
    const itemMetaB = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemBId);
    if (!itemMetaA || !itemMetaB) return [
        itemAId,
        itemBId
    ];
    if (itemMetaA.parentId === itemMetaB.id || itemMetaB.parentId === itemMetaA.id) return itemMetaB.parentId === itemMetaA.id ? [
        itemMetaA.id,
        itemMetaB.id
    ] : [
        itemMetaB.id,
        itemMetaA.id
    ];
    const aFamily = [
        itemMetaA.id
    ];
    const bFamily = [
        itemMetaB.id
    ];
    let aAncestor = itemMetaA.parentId;
    let bAncestor = itemMetaB.parentId;
    let aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    let bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    let continueA = true;
    let continueB = true;
    while(!bAncestorIsCommon && !aAncestorIsCommon){
        if (continueA) {
            aFamily.push(aAncestor);
            aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
            continueA = aAncestor !== null;
            if (!aAncestorIsCommon && continueA) aAncestor = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(state, aAncestor);
        }
        if (continueB && !aAncestorIsCommon) {
            bFamily.push(bAncestor);
            bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
            continueB = bAncestor !== null;
            if (!bAncestorIsCommon && continueB) bAncestor = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(state, bAncestor);
        }
    }
    const commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    const ancestorFamily = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, commonAncestor);
    const aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    const bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [
        itemAId,
        itemBId
    ] : [
        itemBId,
        itemAId
    ];
};
$a95f02974ef5ffc0$exports.findOrderInTremauxTree = $a95f02974ef5ffc0$var$findOrderInTremauxTree;
const $a95f02974ef5ffc0$var$getNonDisabledItemsInRange = (state, itemAId, itemBId)=>{
    const getNextItem = (itemId)=>{
        // If the item is expanded and has some children, return the first of them.
        if ((0, $465b8a23aa196103$exports.selectorIsItemExpandable)(state, itemId) && (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(state, itemId)) return (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemId)[0];
        let itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemId);
        while(itemMeta != null){
            // Try to find the first navigable sibling after the current item.
            const siblings = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemMeta.parentId);
            const currentItemIndex = (0, $dd8775a0356c16b6$exports.selectorItemIndex)(state, itemMeta.id);
            if (currentItemIndex < siblings.length - 1) return siblings[currentItemIndex + 1];
            // If the item is the last of its siblings, go up a level to the parent and try again.
            itemMeta = itemMeta.parentId ? (0, $dd8775a0356c16b6$exports.selectorItemMeta)(state, itemMeta.parentId) : null;
        }
        throw new Error('Invalid range');
    };
    const [first, last] = $a95f02974ef5ffc0$var$findOrderInTremauxTree(state, itemAId, itemBId);
    const items = [
        first
    ];
    let current = first;
    while(current !== last){
        current = getNextItem(current);
        if (!(0, $dd8775a0356c16b6$exports.selectorIsItemDisabled)(state, current)) items.push(current);
    }
    return items;
};
$a95f02974ef5ffc0$exports.getNonDisabledItemsInRange = $a95f02974ef5ffc0$var$getNonDisabledItemsInRange;
const $a95f02974ef5ffc0$var$getAllNavigableItems = (state)=>{
    let item = $a95f02974ef5ffc0$var$getFirstNavigableItem(state);
    const navigableItems = [];
    while(item != null){
        navigableItems.push(item);
        item = $a95f02974ef5ffc0$var$getNextNavigableItem(state, item);
    }
    return navigableItems;
};
/**
 * Checks if the target is in a descendant of this item.
 * This can prevent from firing some logic on the ancestors on the interacted item when the event handler is on the root.
 * @param {HTMLElement} target The target to check
 * @param {HTMLElement | null} itemRoot The root of the item to check if the event target is in its descendants
 * @returns {boolean} Whether the target is in a descendant of this item
 */ $a95f02974ef5ffc0$exports.getAllNavigableItems = $a95f02974ef5ffc0$var$getAllNavigableItems;
const $a95f02974ef5ffc0$var$isTargetInDescendants = (target, itemRoot)=>{
    return itemRoot !== target.closest('*[role="treeitem"]');
};
$a95f02974ef5ffc0$exports.isTargetInDescendants = $a95f02974ef5ffc0$var$isTargetInDescendants;


var $9d6211d34b9fc763$exports = {};
"use strict";
Object.defineProperty($9d6211d34b9fc763$exports, "__esModule", {
    value: true
});
$9d6211d34b9fc763$exports.propagateSelection = $9d6211d34b9fc763$exports.getLookupFromArray = $9d6211d34b9fc763$exports.getAddedAndRemovedItems = void 0;
var $2db5ad35ecc09904$exports = {};
"use strict";
Object.defineProperty($2db5ad35ecc09904$exports, "__esModule", {
    value: true
});
$2db5ad35ecc09904$exports.selectorSelectionPropagationRules = $2db5ad35ecc09904$exports.selectorSelectionModelArray = $2db5ad35ecc09904$exports.selectorSelectionModel = $2db5ad35ecc09904$exports.selectorIsSelectionEnabled = $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled = $2db5ad35ecc09904$exports.selectorIsItemSelectionEnabled = $2db5ad35ecc09904$exports.selectorIsItemSelected = $2db5ad35ecc09904$exports.selectorIsCheckboxSelectionEnabled = void 0;


const $2db5ad35ecc09904$var$selectorTreeViewSelectionState = (state)=>state.selection;
/**
 * Get the selected items.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewSelectionValue<boolean>} The selected items.
 */ const $2db5ad35ecc09904$var$selectorSelectionModel = $2db5ad35ecc09904$exports.selectorSelectionModel = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectedItems);
/**
 * Get the selected items as an array.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId[]} The selected items as an array.
 */ const $2db5ad35ecc09904$var$selectorSelectionModelArray = $2db5ad35ecc09904$exports.selectorSelectionModelArray = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorSelectionModel
], (selectedItems)=>{
    if (Array.isArray(selectedItems)) return selectedItems;
    if (selectedItems != null) return [
        selectedItems
    ];
    return [];
});
/**
 * Get the selected items as a map.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {Map<TreeViewItemId, true>} The selected items as a Map.
 */ const $2db5ad35ecc09904$var$selectorSelectionModelMap = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorSelectionModelArray
], (selectedItems)=>{
    const selectedItemsMap = new Map();
    selectedItems.forEach((id)=>{
        selectedItemsMap.set(id, true);
    });
    return selectedItemsMap;
});
/**
 * Check if an item is selected.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if the item is selected, `false` otherwise.
 */ const $2db5ad35ecc09904$var$selectorIsItemSelected = $2db5ad35ecc09904$exports.selectorIsItemSelected = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorSelectionModelMap,
    (_, itemId)=>itemId
], (selectedItemsMap, itemId)=>selectedItemsMap.has(itemId));
/**
 * Check if multi selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if multi selection is enabled, `false` otherwise.
 */ const $2db5ad35ecc09904$var$selectorIsMultiSelectEnabled = $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled && selectionState.isMultiSelectEnabled);
/**
 * Check if selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if selection is enabled, `false` otherwise.
 */ const $2db5ad35ecc09904$var$selectorIsSelectionEnabled = $2db5ad35ecc09904$exports.selectorIsSelectionEnabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled);
/**
 * Check if checkbox selection is enabled.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if checkbox selection is enabled, `false` otherwise.
 */ const $2db5ad35ecc09904$var$selectorIsCheckboxSelectionEnabled = $2db5ad35ecc09904$exports.selectorIsCheckboxSelectionEnabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isCheckboxSelectionEnabled);
/**
 * Check if selection is enabled for an item (if selection is enabled and if the item is not disabled).
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @param {string} itemId The id of the item to check.
 * @returns {boolean} `true` if selection is enabled for the item, `false` otherwise.
 */ const $2db5ad35ecc09904$var$selectorIsItemSelectionEnabled = $2db5ad35ecc09904$exports.selectorIsItemSelectionEnabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $dd8775a0356c16b6$exports.selectorIsItemDisabled,
    $2db5ad35ecc09904$var$selectorIsSelectionEnabled
], (isItemDisabled, isSelectionEnabled)=>isSelectionEnabled && !isItemDisabled);
/**
 * Get the selection propagation rules.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {TreeViewSelectionPropagation} The selection propagation rules.
 */ const $2db5ad35ecc09904$var$selectorSelectionPropagationRules = $2db5ad35ecc09904$exports.selectorSelectionPropagationRules = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectionPropagation);



const $9d6211d34b9fc763$var$getLookupFromArray = (array)=>{
    const lookup = {};
    array.forEach((itemId)=>{
        lookup[itemId] = true;
    });
    return lookup;
};
$9d6211d34b9fc763$exports.getLookupFromArray = $9d6211d34b9fc763$var$getLookupFromArray;
const $9d6211d34b9fc763$var$getAddedAndRemovedItems = ({ store: store, oldModel: oldModel, newModel: newModel })=>{
    const newModelMap = new Map();
    newModel.forEach((id)=>{
        newModelMap.set(id, true);
    });
    return {
        added: newModel.filter((itemId)=>!(0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(store.value, itemId)),
        removed: oldModel.filter((itemId)=>!newModelMap.has(itemId))
    };
};
$9d6211d34b9fc763$exports.getAddedAndRemovedItems = $9d6211d34b9fc763$var$getAddedAndRemovedItems;
const $9d6211d34b9fc763$var$propagateSelection = ({ store: store, selectionPropagation: selectionPropagation, newModel: newModel, oldModel: oldModel, additionalItemsToPropagate: additionalItemsToPropagate })=>{
    if (!selectionPropagation.descendants && !selectionPropagation.parents) return newModel;
    let shouldRegenerateModel = false;
    const newModelLookup = $9d6211d34b9fc763$var$getLookupFromArray(newModel);
    const changes = $9d6211d34b9fc763$var$getAddedAndRemovedItems({
        store: store,
        newModel: newModel,
        oldModel: oldModel
    });
    additionalItemsToPropagate?.forEach((itemId)=>{
        if (newModelLookup[itemId]) {
            if (!changes.added.includes(itemId)) changes.added.push(itemId);
        } else if (!changes.removed.includes(itemId)) changes.removed.push(itemId);
    });
    changes.added.forEach((addedItemId)=>{
        if (selectionPropagation.descendants) {
            const selectDescendants = (itemId)=>{
                if (itemId !== addedItemId) {
                    shouldRegenerateModel = true;
                    newModelLookup[itemId] = true;
                }
                (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId).forEach(selectDescendants);
            };
            selectDescendants(addedItemId);
        }
        if (selectionPropagation.parents) {
            const checkAllDescendantsSelected = (itemId)=>{
                if (!newModelLookup[itemId]) return false;
                const children = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId);
                return children.every(checkAllDescendantsSelected);
            };
            const selectParents = (itemId)=>{
                const parentId = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(store.value, itemId);
                if (parentId == null) return;
                const siblings = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, parentId);
                if (siblings.every(checkAllDescendantsSelected)) {
                    shouldRegenerateModel = true;
                    newModelLookup[parentId] = true;
                    selectParents(parentId);
                }
            };
            selectParents(addedItemId);
        }
    });
    changes.removed.forEach((removedItemId)=>{
        if (selectionPropagation.parents) {
            let parentId = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(store.value, removedItemId);
            while(parentId != null){
                if (newModelLookup[parentId]) {
                    shouldRegenerateModel = true;
                    delete newModelLookup[parentId];
                }
                parentId = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(store.value, parentId);
            }
        }
        if (selectionPropagation.descendants) {
            const deSelectDescendants = (itemId)=>{
                if (itemId !== removedItemId) {
                    shouldRegenerateModel = true;
                    delete newModelLookup[itemId];
                }
                (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId).forEach(deSelectDescendants);
            };
            deSelectDescendants(removedItemId);
        }
    });
    return shouldRegenerateModel ? Object.keys(newModelLookup) : newModel;
};
$9d6211d34b9fc763$exports.propagateSelection = $9d6211d34b9fc763$var$propagateSelection;



var $d4f51b6c199227de$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $d4f51b6c199227de$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($d4f51b6c199227de$exports, "__esModule", {
    value: true
});
$d4f51b6c199227de$exports.useTreeViewSelectionItemPlugin = void 0;

var $d4f51b6c199227de$var$_extends2 = $d4f51b6c199227de$require$_interopRequireDefault((parcelRequire("8tsi7")));
var $f0b064c06f5dfbf7$exports = {};
"use strict";
Object.defineProperty($f0b064c06f5dfbf7$exports, "__esModule", {
    value: true
});
Object.defineProperty($f0b064c06f5dfbf7$exports, "fastObjectShallowCompare", {
    enumerable: true,
    get: function() {
        return $c745bc340c5cfbe3$exports.fastObjectShallowCompare;
    }
});
var $c745bc340c5cfbe3$exports = {};
"use strict";
Object.defineProperty($c745bc340c5cfbe3$exports, "__esModule", {
    value: true
});
$c745bc340c5cfbe3$exports.fastObjectShallowCompare = $c745bc340c5cfbe3$var$fastObjectShallowCompare;
const $c745bc340c5cfbe3$var$is = Object.is;
/**
 * Fast shallow compare for objects.
 * @returns true if objects are equal.
 */ function $c745bc340c5cfbe3$var$fastObjectShallowCompare(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$c745bc340c5cfbe3$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}








function $d4f51b6c199227de$var$selectorItemCheckboxStatus(state, itemId) {
    const isCheckboxSelectionEnabled = (0, $2db5ad35ecc09904$exports.selectorIsCheckboxSelectionEnabled)(state);
    const isSelectionEnabledForItem = (0, $2db5ad35ecc09904$exports.selectorIsItemSelectionEnabled)(state, itemId);
    if ((0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(state, itemId)) return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: false,
        checked: true
    };
    const children = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemId);
    if (children.length === 0) return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: false,
        checked: false
    };
    let hasSelectedDescendant = false;
    let hasUnSelectedDescendant = false;
    const traverseDescendants = (itemToTraverseId)=>{
        if (itemToTraverseId !== itemId) {
            if ((0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(state, itemToTraverseId)) hasSelectedDescendant = true;
            else hasUnSelectedDescendant = true;
        }
        (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, itemToTraverseId).forEach(traverseDescendants);
    };
    traverseDescendants(itemId);
    return {
        disabled: !isSelectionEnabledForItem,
        visible: isCheckboxSelectionEnabled,
        indeterminate: hasSelectedDescendant && hasUnSelectedDescendant,
        checked: (0, $2db5ad35ecc09904$exports.selectorSelectionPropagationRules)(state).parents ? hasSelectedDescendant && !hasUnSelectedDescendant : false
    };
}
const $d4f51b6c199227de$var$useTreeViewSelectionItemPlugin = ({ props: props })=>{
    const { itemId: itemId } = props;
    const { store: store } = (0, $10a40780e7af645f$exports.useTreeViewContext)();
    const checkboxStatus = (0, $38c0a2e603e59f07$exports.useSelector)(store, $d4f51b6c199227de$var$selectorItemCheckboxStatus, itemId, $f0b064c06f5dfbf7$exports.fastObjectShallowCompare);
    return {
        propsEnhancers: {
            checkbox: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                const handleChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (!(0, $2db5ad35ecc09904$exports.selectorIsItemSelectionEnabled)(store.value, itemId)) return;
                    interactions.handleCheckboxSelection(event);
                };
                return (0, $d4f51b6c199227de$var$_extends2.default)({
                    tabIndex: -1,
                    onChange: handleChange
                }, checkboxStatus);
            }
        }
    };
};
$d4f51b6c199227de$exports.useTreeViewSelectionItemPlugin = $d4f51b6c199227de$var$useTreeViewSelectionItemPlugin;



const $9e66dcca63418a04$var$useTreeViewSelection = ({ store: store, params: params })=>{
    (0, $33e5e4da6d4c5b66$exports.useAssertModelConsistency)({
        state: 'selectedItems',
        controlled: params.selectedItems,
        defaultValue: params.defaultSelectedItems
    });
    const lastSelectedItem = $9e66dcca63418a04$var$React.useRef(null);
    const lastSelectedRange = $9e66dcca63418a04$var$React.useRef({});
    const setSelectedItems = (event, newModel, additionalItemsToPropagate)=>{
        const oldModel = (0, $2db5ad35ecc09904$exports.selectorSelectionModel)(store.value);
        let cleanModel;
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        if (isMultiSelectEnabled && (params.selectionPropagation.descendants || params.selectionPropagation.parents)) cleanModel = (0, $9d6211d34b9fc763$exports.propagateSelection)({
            store: store,
            selectionPropagation: params.selectionPropagation,
            newModel: newModel,
            oldModel: oldModel,
            additionalItemsToPropagate: additionalItemsToPropagate
        });
        else cleanModel = newModel;
        if (params.onItemSelectionToggle) {
            if (isMultiSelectEnabled) {
                const changes = (0, $9d6211d34b9fc763$exports.getAddedAndRemovedItems)({
                    store: store,
                    newModel: cleanModel,
                    oldModel: oldModel
                });
                if (params.onItemSelectionToggle) {
                    changes.added.forEach((itemId)=>{
                        params.onItemSelectionToggle(event, itemId, true);
                    });
                    changes.removed.forEach((itemId)=>{
                        params.onItemSelectionToggle(event, itemId, false);
                    });
                }
            } else if (params.onItemSelectionToggle && cleanModel !== oldModel) {
                if (oldModel != null) params.onItemSelectionToggle(event, oldModel, false);
                if (cleanModel != null) params.onItemSelectionToggle(event, cleanModel, true);
            }
        }
        if (params.selectedItems === undefined) store.update((prevState)=>(0, $9e66dcca63418a04$var$_extends2.default)({}, prevState, {
                selection: (0, $9e66dcca63418a04$var$_extends2.default)({}, prevState.selection, {
                    selectedItems: cleanModel
                })
            }));
        params.onSelectedItemsChange?.(event, cleanModel);
    };
    const setItemSelection = ({ itemId: itemId, event: event = null, keepExistingSelection: keepExistingSelection = false, shouldBeSelected: shouldBeSelected })=>{
        if (!(0, $2db5ad35ecc09904$exports.selectorIsSelectionEnabled)(store.value)) return;
        let newSelected;
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        if (keepExistingSelection) {
            const oldSelected = (0, $2db5ad35ecc09904$exports.selectorSelectionModelArray)(store.value);
            const isSelectedBefore = (0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(store.value, itemId);
            if (isSelectedBefore && (shouldBeSelected === false || shouldBeSelected == null)) newSelected = oldSelected.filter((id)=>id !== itemId);
            else if (!isSelectedBefore && (shouldBeSelected === true || shouldBeSelected == null)) newSelected = [
                itemId
            ].concat(oldSelected);
            else newSelected = oldSelected;
        } else // eslint-disable-next-line no-lonely-if
        if (shouldBeSelected === false || shouldBeSelected == null && (0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(store.value, itemId)) newSelected = isMultiSelectEnabled ? [] : null;
        else newSelected = isMultiSelectEnabled ? [
            itemId
        ] : itemId;
        setSelectedItems(event, newSelected, // If shouldBeSelected === selectorIsItemSelected(store, itemId), we still want to propagate the select.
        // This is useful when the element is in an indeterminate state.
        [
            itemId
        ]);
        lastSelectedItem.current = itemId;
        lastSelectedRange.current = {};
    };
    const selectRange = (event, [start, end])=>{
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        let newSelectedItems = (0, $2db5ad35ecc09904$exports.selectorSelectionModelArray)(store.value).slice();
        // If the last selection was a range selection,
        // remove the items that were part of the last range from the model
        if (Object.keys(lastSelectedRange.current).length > 0) newSelectedItems = newSelectedItems.filter((id)=>!lastSelectedRange.current[id]);
        // Add to the model the items that are part of the new range and not already part of the model.
        const selectedItemsLookup = (0, $9d6211d34b9fc763$exports.getLookupFromArray)(newSelectedItems);
        const range = (0, $a95f02974ef5ffc0$exports.getNonDisabledItemsInRange)(store.value, start, end);
        const itemsToAddToModel = range.filter((id)=>!selectedItemsLookup[id]);
        newSelectedItems = newSelectedItems.concat(itemsToAddToModel);
        setSelectedItems(event, newSelectedItems);
        lastSelectedRange.current = (0, $9d6211d34b9fc763$exports.getLookupFromArray)(range);
    };
    const expandSelectionRange = (event, itemId)=>{
        if (lastSelectedItem.current != null) {
            const [start, end] = (0, $a95f02974ef5ffc0$exports.findOrderInTremauxTree)(store.value, itemId, lastSelectedItem.current);
            selectRange(event, [
                start,
                end
            ]);
        }
    };
    const selectRangeFromStartToItem = (event, itemId)=>{
        selectRange(event, [
            (0, $a95f02974ef5ffc0$exports.getFirstNavigableItem)(store.value),
            itemId
        ]);
    };
    const selectRangeFromItemToEnd = (event, itemId)=>{
        selectRange(event, [
            itemId,
            (0, $a95f02974ef5ffc0$exports.getLastNavigableItem)(store.value)
        ]);
    };
    const selectAllNavigableItems = (event)=>{
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        const navigableItems = (0, $a95f02974ef5ffc0$exports.getAllNavigableItems)(store.value);
        setSelectedItems(event, navigableItems);
        lastSelectedRange.current = (0, $9d6211d34b9fc763$exports.getLookupFromArray)(navigableItems);
    };
    const selectItemFromArrowNavigation = (event, currentItem, nextItem)=>{
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        if (!isMultiSelectEnabled) return;
        let newSelectedItems = (0, $2db5ad35ecc09904$exports.selectorSelectionModelArray)(store.value).slice();
        if (Object.keys(lastSelectedRange.current).length === 0) {
            newSelectedItems.push(nextItem);
            lastSelectedRange.current = {
                [currentItem]: true,
                [nextItem]: true
            };
        } else {
            if (!lastSelectedRange.current[currentItem]) lastSelectedRange.current = {};
            if (lastSelectedRange.current[nextItem]) {
                newSelectedItems = newSelectedItems.filter((id)=>id !== currentItem);
                delete lastSelectedRange.current[currentItem];
            } else {
                newSelectedItems.push(nextItem);
                lastSelectedRange.current[nextItem] = true;
            }
        }
        setSelectedItems(event, newSelectedItems);
    };
    (0, $9e66dcca63418a04$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>(0, $9e66dcca63418a04$var$_extends2.default)({}, prevState, {
                selection: {
                    selectedItems: params.selectedItems === undefined ? prevState.selection.selectedItems : params.selectedItems,
                    isEnabled: !params.disableSelection,
                    isMultiSelectEnabled: params.multiSelect,
                    isCheckboxSelectionEnabled: params.checkboxSelection,
                    selectionPropagation: {
                        descendants: params.selectionPropagation.descendants,
                        parents: params.selectionPropagation.parents
                    }
                }
            }));
    }, [
        store,
        params.selectedItems,
        params.multiSelect,
        params.checkboxSelection,
        params.disableSelection,
        params.selectionPropagation.descendants,
        params.selectionPropagation.parents
    ]);
    return {
        getRootProps: ()=>({
                'aria-multiselectable': params.multiSelect
            }),
        publicAPI: {
            setItemSelection: setItemSelection
        },
        instance: {
            setItemSelection: setItemSelection,
            selectAllNavigableItems: selectAllNavigableItems,
            expandSelectionRange: expandSelectionRange,
            selectRangeFromStartToItem: selectRangeFromStartToItem,
            selectRangeFromItemToEnd: selectRangeFromItemToEnd,
            selectItemFromArrowNavigation: selectItemFromArrowNavigation
        }
    };
};
$9e66dcca63418a04$exports.useTreeViewSelection = $9e66dcca63418a04$var$useTreeViewSelection;
$9e66dcca63418a04$var$useTreeViewSelection.itemPlugin = $d4f51b6c199227de$exports.useTreeViewSelectionItemPlugin;
const $9e66dcca63418a04$var$DEFAULT_SELECTED_ITEMS = [];
const $9e66dcca63418a04$var$EMPTY_SELECTION_PROPAGATION = {};
$9e66dcca63418a04$var$useTreeViewSelection.getDefaultizedParams = ({ params: params })=>(0, $9e66dcca63418a04$var$_extends2.default)({}, params, {
        disableSelection: params.disableSelection ?? false,
        multiSelect: params.multiSelect ?? false,
        checkboxSelection: params.checkboxSelection ?? false,
        defaultSelectedItems: params.defaultSelectedItems ?? (params.multiSelect ? $9e66dcca63418a04$var$DEFAULT_SELECTED_ITEMS : null),
        selectionPropagation: params.selectionPropagation ?? $9e66dcca63418a04$var$EMPTY_SELECTION_PROPAGATION
    });
$9e66dcca63418a04$var$useTreeViewSelection.getInitialState = (params)=>({
        selection: {
            selectedItems: params.selectedItems === undefined ? params.defaultSelectedItems : params.selectedItems,
            isEnabled: !params.disableSelection,
            isMultiSelectEnabled: params.multiSelect,
            isCheckboxSelectionEnabled: params.checkboxSelection,
            selectionPropagation: params.selectionPropagation
        }
    });
$9e66dcca63418a04$var$useTreeViewSelection.params = {
    disableSelection: true,
    multiSelect: true,
    checkboxSelection: true,
    defaultSelectedItems: true,
    selectedItems: true,
    onSelectedItemsChange: true,
    onItemSelectionToggle: true,
    selectionPropagation: true
};




var $94f08a12df4fb913$exports = {};
"use strict";
Object.defineProperty($94f08a12df4fb913$exports, "__esModule", {
    value: true
});
Object.defineProperty($94f08a12df4fb913$exports, "useTreeViewFocus", {
    enumerable: true,
    get: function() {
        return $990bcc4c47d9f5cf$exports.useTreeViewFocus;
    }
});
var $990bcc4c47d9f5cf$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $990bcc4c47d9f5cf$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($990bcc4c47d9f5cf$exports, "__esModule", {
    value: true
});
$990bcc4c47d9f5cf$exports.useTreeViewFocus = void 0;

var $990bcc4c47d9f5cf$var$_extends2 = $990bcc4c47d9f5cf$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $990bcc4c47d9f5cf$var$_useEventCallback = $990bcc4c47d9f5cf$require$_interopRequireDefault((parcelRequire("5xdHV")));
var $2ad54a13b55a190b$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $2ad54a13b55a190b$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($2ad54a13b55a190b$exports, "__esModule", {
    value: true
});
$2ad54a13b55a190b$exports.createUseInstanceEventHandler = $2ad54a13b55a190b$var$createUseInstanceEventHandler;
$2ad54a13b55a190b$exports.useInstanceEventHandler = $2ad54a13b55a190b$exports.unstable_resetCleanupTracking = void 0;

var $2ad54a13b55a190b$var$React = $2ad54a13b55a190b$require$_interopRequireWildcard((parcelRequire("8nGP5")));
var $54f56d89ae76c71b$exports = {};
"use strict";
Object.defineProperty($54f56d89ae76c71b$exports, "__esModule", {
    value: true
});
$54f56d89ae76c71b$exports.TimerBasedCleanupTracking = void 0;
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $54f56d89ae76c71b$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $54f56d89ae76c71b$var$TimerBasedCleanupTracking {
    constructor(timeout = $54f56d89ae76c71b$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.timeouts = new Map();
        this.cleanupTimeout = $54f56d89ae76c71b$var$CLEANUP_TIMER_LOOP_MILLIS;
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}
$54f56d89ae76c71b$exports.TimerBasedCleanupTracking = $54f56d89ae76c71b$var$TimerBasedCleanupTracking;


var $80dd403fceceb39f$exports = {};
"use strict";
Object.defineProperty($80dd403fceceb39f$exports, "__esModule", {
    value: true
});
$80dd403fceceb39f$exports.FinalizationRegistryBasedCleanupTracking = void 0;
class $80dd403fceceb39f$var$FinalizationRegistryBasedCleanupTracking {
    constructor(){
        this.registry = new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        });
    }
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    // eslint-disable-next-line class-methods-use-this
    reset() {}
}
$80dd403fceceb39f$exports.FinalizationRegistryBasedCleanupTracking = $80dd403fceceb39f$var$FinalizationRegistryBasedCleanupTracking;


// We use class to make it easier to detect in heap snapshots by name
class $2ad54a13b55a190b$var$ObjectToBeRetainedByReact {
}
// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
function $2ad54a13b55a190b$var$createUseInstanceEventHandler(registryContainer) {
    let cleanupTokensCounter = 0;
    return function useInstanceEventHandler(instance, eventName, handler) {
        if (registryContainer.registry === null) registryContainer.registry = typeof FinalizationRegistry !== 'undefined' ? new $80dd403fceceb39f$exports.FinalizationRegistryBasedCleanupTracking() : new $54f56d89ae76c71b$exports.TimerBasedCleanupTracking();
        const [objectRetainedByReact] = $2ad54a13b55a190b$var$React.useState(new $2ad54a13b55a190b$var$ObjectToBeRetainedByReact());
        const subscription = $2ad54a13b55a190b$var$React.useRef(null);
        const handlerRef = $2ad54a13b55a190b$var$React.useRef(undefined);
        handlerRef.current = handler;
        const cleanupTokenRef = $2ad54a13b55a190b$var$React.useRef(null);
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
            };
            subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            cleanupTokensCounter += 1;
            cleanupTokenRef.current = {
                cleanupToken: cleanupTokensCounter
            };
            registryContainer.registry.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
            ()=>{
                subscription.current?.();
                subscription.current = null;
                cleanupTokenRef.current = null;
            }, cleanupTokenRef.current);
        } else if (!handlerRef.current && subscription.current) {
            subscription.current();
            subscription.current = null;
            if (cleanupTokenRef.current) {
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
        }
        $2ad54a13b55a190b$var$React.useEffect(()=>{
            if (!subscription.current && handlerRef.current) {
                const enhancedHandler = (params, event)=>{
                    if (!event.defaultMuiPrevented) handlerRef.current?.(params, event);
                };
                subscription.current = instance.$$subscribeEvent(eventName, enhancedHandler);
            }
            if (cleanupTokenRef.current && registryContainer.registry) {
                // If the effect was called, it means that this render was committed
                // so we can trust the cleanup function to remove the listener.
                registryContainer.registry.unregister(cleanupTokenRef.current);
                cleanupTokenRef.current = null;
            }
            return ()=>{
                subscription.current?.();
                subscription.current = null;
            };
        }, [
            instance,
            eventName
        ]);
    };
}
const $2ad54a13b55a190b$var$registryContainer = {
    registry: null
};
// eslint-disable-next-line @typescript-eslint/naming-convention
const $2ad54a13b55a190b$var$unstable_resetCleanupTracking = ()=>{
    $2ad54a13b55a190b$var$registryContainer.registry?.reset();
    $2ad54a13b55a190b$var$registryContainer.registry = null;
};
$2ad54a13b55a190b$exports.unstable_resetCleanupTracking = $2ad54a13b55a190b$var$unstable_resetCleanupTracking;
const $2ad54a13b55a190b$var$useInstanceEventHandler = $2ad54a13b55a190b$exports.useInstanceEventHandler = $2ad54a13b55a190b$var$createUseInstanceEventHandler($2ad54a13b55a190b$var$registryContainer);


var $d66f82d897437048$exports = {};
"use strict";
Object.defineProperty($d66f82d897437048$exports, "__esModule", {
    value: true
});
$d66f82d897437048$exports.selectorIsItemTheDefaultFocusableItem = $d66f82d897437048$exports.selectorIsItemFocused = $d66f82d897437048$exports.selectorFocusedItemId = $d66f82d897437048$exports.selectorDefaultFocusableItemId = void 0;





const $d66f82d897437048$var$selectorTreeViewFocusState = (state)=>state.focus;
/**
 * Get the item that should be sequentially focusable (usually with the Tab key).
 * At any point in time, there is a single item that can be sequentially focused in the Tree View.
 * This item is the first selected item (that is both visible and navigable), if any, or the first navigable item if no item is selected.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId | null} The id of the item that should be sequentially focusable.
 */ const $d66f82d897437048$var$selectorDefaultFocusableItemId = $d66f82d897437048$exports.selectorDefaultFocusableItemId = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $2db5ad35ecc09904$exports.selectorSelectionModelArray,
    $465b8a23aa196103$exports.selectorExpandedItemsMap,
    $dd8775a0356c16b6$exports.selectorItemMetaLookup,
    $dd8775a0356c16b6$exports.selectorDisabledItemFocusable,
    (state)=>(0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(state, null)
], (selectedItems, expandedItemsMap, itemMetaLookup, disabledItemsFocusable, orderedRootItemIds)=>{
    const firstSelectedItem = selectedItems.find((itemId)=>{
        if (!disabledItemsFocusable && (0, $6e9d2739eb68decb$exports.isItemDisabled)(itemMetaLookup, itemId)) return false;
        const itemMeta = itemMetaLookup[itemId];
        return itemMeta && (itemMeta.parentId == null || expandedItemsMap.has(itemMeta.parentId));
    });
    if (firstSelectedItem != null) return firstSelectedItem;
    const firstNavigableItem = orderedRootItemIds.find((itemId)=>disabledItemsFocusable || !(0, $6e9d2739eb68decb$exports.isItemDisabled)(itemMetaLookup, itemId));
    if (firstNavigableItem != null) return firstNavigableItem;
    return null;
});
/**
 * Check if an item is the default focusable item.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is the default focusable item, `false` otherwise.
 */ const $d66f82d897437048$var$selectorIsItemTheDefaultFocusableItem = $d66f82d897437048$exports.selectorIsItemTheDefaultFocusableItem = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $d66f82d897437048$var$selectorDefaultFocusableItemId,
    (_, itemId)=>itemId
], (defaultFocusableItemId, itemId)=>defaultFocusableItemId === itemId);
/**
 * Get the id of the item that is currently focused.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @returns {TreeViewItemId | null} The id of the item that is currently focused.
 */ const $d66f82d897437048$var$selectorFocusedItemId = $d66f82d897437048$exports.selectorFocusedItemId = (0, $11a1a9bd6141dd56$exports.createSelector)($d66f82d897437048$var$selectorTreeViewFocusState, (focus)=>focus.focusedItemId);
/**
 * Check if an item is focused.
 * @param {TreeViewState<[UseTreeViewFocusSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is focused, `false` otherwise.
 */ const $d66f82d897437048$var$selectorIsItemFocused = $d66f82d897437048$exports.selectorIsItemFocused = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $d66f82d897437048$var$selectorFocusedItemId,
    (_, itemId)=>itemId
], (focusedItemId, itemId)=>focusedItemId === itemId);




const $990bcc4c47d9f5cf$var$useTreeViewFocus = ({ instance: instance, params: params, store: store })=>{
    const setFocusedItemId = (0, $990bcc4c47d9f5cf$var$_useEventCallback.default)((itemId)=>{
        store.update((prevState)=>{
            const focusedItemId = (0, $d66f82d897437048$exports.selectorFocusedItemId)(prevState);
            if (focusedItemId === itemId) return prevState;
            return (0, $990bcc4c47d9f5cf$var$_extends2.default)({}, prevState, {
                focus: (0, $990bcc4c47d9f5cf$var$_extends2.default)({}, prevState.focus, {
                    focusedItemId: itemId
                })
            });
        });
    });
    const isItemVisible = (itemId)=>{
        const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(store.value, itemId);
        return itemMeta && (itemMeta.parentId == null || (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, itemMeta.parentId));
    };
    const innerFocusItem = (event, itemId)=>{
        const itemElement = instance.getItemDOMElement(itemId);
        if (itemElement) itemElement.focus();
        setFocusedItemId(itemId);
        if (params.onItemFocus) params.onItemFocus(event, itemId);
    };
    const focusItem = (0, $990bcc4c47d9f5cf$var$_useEventCallback.default)((event, itemId)=>{
        // If we receive an itemId, and it is visible, the focus will be set to it
        if (isItemVisible(itemId)) innerFocusItem(event, itemId);
    });
    const removeFocusedItem = (0, $990bcc4c47d9f5cf$var$_useEventCallback.default)(()=>{
        const focusedItemId = (0, $d66f82d897437048$exports.selectorFocusedItemId)(store.value);
        if (focusedItemId == null) return;
        const itemMeta = (0, $dd8775a0356c16b6$exports.selectorItemMeta)(store.value, focusedItemId);
        if (itemMeta) {
            const itemElement = instance.getItemDOMElement(focusedItemId);
            if (itemElement) itemElement.blur();
        }
        setFocusedItemId(null);
    });
    (0, $2ad54a13b55a190b$exports.useInstanceEventHandler)(instance, 'removeItem', ({ id: id })=>{
        const focusedItemId = (0, $d66f82d897437048$exports.selectorFocusedItemId)(store.value);
        const defaultFocusableItemId = (0, $d66f82d897437048$exports.selectorDefaultFocusableItemId)(store.value);
        if (focusedItemId === id && defaultFocusableItemId != null) innerFocusItem(null, defaultFocusableItemId);
    });
    const createRootHandleFocus = (otherHandlers)=>(event)=>{
            otherHandlers.onFocus?.(event);
            if (event.defaultMuiPrevented) return;
            // if the event bubbled (which is React specific) we don't want to steal focus
            const defaultFocusableItemId = (0, $d66f82d897437048$exports.selectorDefaultFocusableItemId)(store.value);
            if (event.target === event.currentTarget && defaultFocusableItemId != null) innerFocusItem(event, defaultFocusableItemId);
        };
    const createRootHandleBlur = (otherHandlers)=>(event)=>{
            otherHandlers.onBlur?.(event);
            if (event.defaultMuiPrevented) return;
            setFocusedItemId(null);
        };
    return {
        getRootProps: (otherHandlers)=>({
                onFocus: createRootHandleFocus(otherHandlers),
                onBlur: createRootHandleBlur(otherHandlers)
            }),
        publicAPI: {
            focusItem: focusItem
        },
        instance: {
            focusItem: focusItem,
            removeFocusedItem: removeFocusedItem
        }
    };
};
$990bcc4c47d9f5cf$exports.useTreeViewFocus = $990bcc4c47d9f5cf$var$useTreeViewFocus;
$990bcc4c47d9f5cf$var$useTreeViewFocus.getInitialState = ()=>({
        focus: {
            focusedItemId: null
        }
    });
$990bcc4c47d9f5cf$var$useTreeViewFocus.params = {
    onItemFocus: true
};




var $aa233e83a0dedbf2$exports = {};
"use strict";
Object.defineProperty($aa233e83a0dedbf2$exports, "__esModule", {
    value: true
});
Object.defineProperty($aa233e83a0dedbf2$exports, "useTreeViewKeyboardNavigation", {
    enumerable: true,
    get: function() {
        return $9c9d05b4992ea2f4$exports.useTreeViewKeyboardNavigation;
    }
});
var $9c9d05b4992ea2f4$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $9c9d05b4992ea2f4$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $9c9d05b4992ea2f4$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($9c9d05b4992ea2f4$exports, "__esModule", {
    value: true
});
$9c9d05b4992ea2f4$exports.useTreeViewKeyboardNavigation = void 0;

var $9c9d05b4992ea2f4$var$React = $9c9d05b4992ea2f4$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $aYQZL = parcelRequire("aYQZL");

var $9c9d05b4992ea2f4$var$_useEventCallback = $9c9d05b4992ea2f4$require$_interopRequireDefault((parcelRequire("5xdHV")));

var $e7fe62e7dc5d6dca$exports = {};
"use strict";
Object.defineProperty($e7fe62e7dc5d6dca$exports, "__esModule", {
    value: true
});
$e7fe62e7dc5d6dca$exports.hasPlugin = void 0;
const $e7fe62e7dc5d6dca$var$hasPlugin = (instance, plugin)=>{
    const plugins = instance.getAvailablePlugins();
    return plugins.has(plugin);
};
$e7fe62e7dc5d6dca$exports.hasPlugin = $e7fe62e7dc5d6dca$var$hasPlugin;


var $508c6e333d1795ae$exports = {};
"use strict";
Object.defineProperty($508c6e333d1795ae$exports, "__esModule", {
    value: true
});
Object.defineProperty($508c6e333d1795ae$exports, "useTreeViewLabel", {
    enumerable: true,
    get: function() {
        return $39e520f5d80e7192$exports.useTreeViewLabel;
    }
});
var $39e520f5d80e7192$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $39e520f5d80e7192$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($39e520f5d80e7192$exports, "__esModule", {
    value: true
});
$39e520f5d80e7192$exports.useTreeViewLabel = void 0;

var $39e520f5d80e7192$var$_extends2 = $39e520f5d80e7192$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $39e520f5d80e7192$var$_useEnhancedEffect = $39e520f5d80e7192$require$_interopRequireDefault((parcelRequire("jMi8t")));
var $5ac6c9be0b81868d$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $5ac6c9be0b81868d$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($5ac6c9be0b81868d$exports, "__esModule", {
    value: true
});
$5ac6c9be0b81868d$exports.useTreeViewLabelItemPlugin = void 0;

var $5ac6c9be0b81868d$var$React = $5ac6c9be0b81868d$require$_interopRequireWildcard((parcelRequire("8nGP5")));


var $ac4d3b7e147f2dd1$exports = {};
"use strict";
Object.defineProperty($ac4d3b7e147f2dd1$exports, "__esModule", {
    value: true
});
$ac4d3b7e147f2dd1$exports.selectorIsItemEditable = $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited = $ac4d3b7e147f2dd1$exports.selectorIsAnyItemBeingEdited = void 0;


const $ac4d3b7e147f2dd1$var$selectorTreeViewLabelState = (state)=>state.label;
/**
 * Check if an item is editable.
 * @param {TreeViewState<[UseTreeViewItemsSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is editable, `false` otherwise.
 */ const $ac4d3b7e147f2dd1$var$selectorIsItemEditable = $ac4d3b7e147f2dd1$exports.selectorIsItemEditable = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $ac4d3b7e147f2dd1$var$selectorTreeViewLabelState,
    (state, itemId)=>(0, $dd8775a0356c16b6$exports.selectorItemModel)(state, itemId)
], (labelState, itemModel)=>{
    if (!itemModel || !labelState) return false;
    if (typeof labelState.isItemEditable === 'boolean') return labelState.isItemEditable;
    return labelState.isItemEditable(itemModel);
});
/**
 * Check if the given item is being edited.
 * @param {TreeViewState<[UseTreeViewLabelSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to check.
 * @returns {boolean} `true` if the item is being edited, `false` otherwise.
 */ const $ac4d3b7e147f2dd1$var$selectorIsItemBeingEdited = $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $ac4d3b7e147f2dd1$var$selectorTreeViewLabelState,
    (_, itemId)=>itemId
], (labelState, itemId)=>itemId ? labelState?.editedItemId === itemId : false);
/**
 * Check if an item is being edited.
 * @param {TreeViewState<[UseTreeViewLabelSignature]>} state The state of the tree view.
 * @returns {boolean} `true` if an item is being edited, `false` otherwise.
 */ const $ac4d3b7e147f2dd1$var$selectorIsAnyItemBeingEdited = $ac4d3b7e147f2dd1$exports.selectorIsAnyItemBeingEdited = (0, $11a1a9bd6141dd56$exports.createSelector)($ac4d3b7e147f2dd1$var$selectorTreeViewLabelState, (labelState)=>!!labelState?.editedItemId);


const $5ac6c9be0b81868d$var$useTreeViewLabelItemPlugin = ({ props: props })=>{
    const { store: store } = (0, $10a40780e7af645f$exports.useTreeViewContext)();
    const { label: label, itemId: itemId } = props;
    const [labelInputValue, setLabelInputValue] = $5ac6c9be0b81868d$var$React.useState(label);
    const isItemEditable = (0, $38c0a2e603e59f07$exports.useSelector)(store, $ac4d3b7e147f2dd1$exports.selectorIsItemEditable, itemId);
    const isItemBeingEdited = (0, $38c0a2e603e59f07$exports.useSelector)(store, $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited, itemId);
    $5ac6c9be0b81868d$var$React.useEffect(()=>{
        if (!isItemBeingEdited) setLabelInputValue(label);
    }, [
        isItemBeingEdited,
        label
    ]);
    return {
        propsEnhancers: {
            label: ()=>({
                    editable: isItemEditable
                }),
            labelInput: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                if (!isItemEditable) return {};
                const handleKeydown = (event)=>{
                    externalEventHandlers.onKeyDown?.(event);
                    if (event.defaultMuiPrevented) return;
                    const target = event.target;
                    if (event.key === 'Enter' && target.value) interactions.handleSaveItemLabel(event, target.value);
                    else if (event.key === 'Escape') interactions.handleCancelItemLabelEditing(event);
                };
                const handleBlur = (event)=>{
                    externalEventHandlers.onBlur?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (event.target.value) interactions.handleSaveItemLabel(event, event.target.value);
                };
                const handleInputChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    setLabelInputValue(event.target.value);
                };
                return {
                    value: labelInputValue ?? '',
                    'data-element': 'labelInput',
                    onChange: handleInputChange,
                    onKeyDown: handleKeydown,
                    onBlur: handleBlur,
                    autoFocus: true,
                    type: 'text'
                };
            }
        }
    };
};
$5ac6c9be0b81868d$exports.useTreeViewLabelItemPlugin = $5ac6c9be0b81868d$var$useTreeViewLabelItemPlugin;


const $39e520f5d80e7192$var$useTreeViewLabel = ({ store: store, params: params })=>{
    const setEditedItemId = (editedItemId)=>{
        store.update((prevState)=>(0, $39e520f5d80e7192$var$_extends2.default)({}, prevState, {
                label: (0, $39e520f5d80e7192$var$_extends2.default)({}, prevState.label, {
                    editedItemId: editedItemId
                })
            }));
    };
    const updateItemLabel = (itemId, label)=>{
        if (!label) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'The label of an item cannot be empty.',
            itemId
        ].join('\n'));
        store.update((prevState)=>{
            const item = prevState.items.itemMetaLookup[itemId];
            if (item.label !== label) return (0, $39e520f5d80e7192$var$_extends2.default)({}, prevState, {
                items: (0, $39e520f5d80e7192$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: (0, $39e520f5d80e7192$var$_extends2.default)({}, prevState.items.itemMetaLookup, {
                        [itemId]: (0, $39e520f5d80e7192$var$_extends2.default)({}, item, {
                            label: label
                        })
                    })
                })
            });
            return prevState;
        });
        if (params.onItemLabelChange) params.onItemLabelChange(itemId, label);
    };
    (0, $39e520f5d80e7192$var$_useEnhancedEffect.default)(()=>{
        store.update((prevState)=>(0, $39e520f5d80e7192$var$_extends2.default)({}, prevState, {
                label: (0, $39e520f5d80e7192$var$_extends2.default)({}, prevState.label, {
                    isItemEditable: params.isItemEditable
                })
            }));
    }, [
        store,
        params.isItemEditable
    ]);
    return {
        instance: {
            setEditedItemId: setEditedItemId,
            updateItemLabel: updateItemLabel
        },
        publicAPI: {
            updateItemLabel: updateItemLabel
        }
    };
};
$39e520f5d80e7192$exports.useTreeViewLabel = $39e520f5d80e7192$var$useTreeViewLabel;
$39e520f5d80e7192$var$useTreeViewLabel.itemPlugin = $5ac6c9be0b81868d$exports.useTreeViewLabelItemPlugin;
$39e520f5d80e7192$var$useTreeViewLabel.getDefaultizedParams = ({ params: params })=>(0, $39e520f5d80e7192$var$_extends2.default)({}, params, {
        isItemEditable: params.isItemEditable ?? false
    });
$39e520f5d80e7192$var$useTreeViewLabel.getInitialState = (params)=>({
        label: {
            isItemEditable: params.isItemEditable,
            editedItemId: null
        }
    });
$39e520f5d80e7192$var$useTreeViewLabel.params = {
    onItemLabelChange: true,
    isItemEditable: true
};









function $9c9d05b4992ea2f4$var$isPrintableKey(string) {
    return !!string && string.length === 1 && !!string.match(/\S/);
}
const $9c9d05b4992ea2f4$var$useTreeViewKeyboardNavigation = ({ instance: instance, store: store, params: params })=>{
    const isRtl = (0, $aYQZL.useRtl)();
    const firstCharMap = $9c9d05b4992ea2f4$var$React.useRef({});
    const updateFirstCharMap = (0, $9c9d05b4992ea2f4$var$_useEventCallback.default)((callback)=>{
        firstCharMap.current = callback(firstCharMap.current);
    });
    const itemMetaLookup = (0, $38c0a2e603e59f07$exports.useSelector)(store, $dd8775a0356c16b6$exports.selectorItemMetaLookup);
    $9c9d05b4992ea2f4$var$React.useEffect(()=>{
        if (instance.areItemUpdatesPrevented()) return;
        const newFirstCharMap = {};
        const processItem = (item)=>{
            newFirstCharMap[item.id] = item.label.substring(0, 1).toLowerCase();
        };
        Object.values(itemMetaLookup).forEach(processItem);
        firstCharMap.current = newFirstCharMap;
    }, [
        itemMetaLookup,
        params.getItemId,
        instance
    ]);
    const getFirstMatchingItem = (itemId, query)=>{
        const cleanQuery = query.toLowerCase();
        const getNextItem = (itemIdToCheck)=>{
            const nextItemId = (0, $a95f02974ef5ffc0$exports.getNextNavigableItem)(store.value, itemIdToCheck);
            // We reached the end of the tree, check from the beginning
            if (nextItemId === null) return (0, $a95f02974ef5ffc0$exports.getFirstNavigableItem)(store.value);
            return nextItemId;
        };
        let matchingItemId = null;
        let currentItemId = getNextItem(itemId);
        const checkedItems = {};
        // The "!checkedItems[currentItemId]" condition avoids an infinite loop when there is no matching item.
        while(matchingItemId == null && !checkedItems[currentItemId])if (firstCharMap.current[currentItemId] === cleanQuery) matchingItemId = currentItemId;
        else {
            checkedItems[currentItemId] = true;
            currentItemId = getNextItem(currentItemId);
        }
        return matchingItemId;
    };
    const canToggleItemSelection = (itemId)=>(0, $2db5ad35ecc09904$exports.selectorIsSelectionEnabled)(store.value) && !(0, $dd8775a0356c16b6$exports.selectorIsItemDisabled)(store.value, itemId);
    const canToggleItemExpansion = (itemId)=>{
        return !(0, $dd8775a0356c16b6$exports.selectorIsItemDisabled)(store.value, itemId) && (0, $465b8a23aa196103$exports.selectorIsItemExpandable)(store.value, itemId);
    };
    // ARIA specification: https://www.w3.org/WAI/ARIA/apg/patterns/treeview/#keyboardinteraction
    const handleItemKeyDown = async (event, itemId)=>{
        if (event.defaultMuiPrevented) return;
        if (event.altKey || (0, $a95f02974ef5ffc0$exports.isTargetInDescendants)(event.target, event.currentTarget)) return;
        const ctrlPressed = event.ctrlKey || event.metaKey;
        const key = event.key;
        const isMultiSelectEnabled = (0, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled)(store.value);
        // eslint-disable-next-line default-case
        switch(true){
            // Select the item when pressing "Space"
            case key === ' ' && canToggleItemSelection(itemId):
                event.preventDefault();
                if (isMultiSelectEnabled && event.shiftKey) instance.expandSelectionRange(event, itemId);
                else instance.setItemSelection({
                    event: event,
                    itemId: itemId,
                    keepExistingSelection: isMultiSelectEnabled,
                    shouldBeSelected: undefined
                });
                break;
            // If the focused item has children, we expand it.
            // If the focused item has no children, we select it.
            case key === 'Enter':
                if ((0, $e7fe62e7dc5d6dca$exports.hasPlugin)(instance, $508c6e333d1795ae$exports.useTreeViewLabel) && (0, $ac4d3b7e147f2dd1$exports.selectorIsItemEditable)(store.value, itemId) && !(0, $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited)(store.value, itemId)) instance.setEditedItemId(itemId);
                else if (canToggleItemExpansion(itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                } else if (canToggleItemSelection(itemId)) {
                    if (isMultiSelectEnabled) {
                        event.preventDefault();
                        instance.setItemSelection({
                            event: event,
                            itemId: itemId,
                            keepExistingSelection: true
                        });
                    } else if (!(0, $2db5ad35ecc09904$exports.selectorIsItemSelected)(store.value, itemId)) {
                        instance.setItemSelection({
                            event: event,
                            itemId: itemId
                        });
                        event.preventDefault();
                    }
                }
                break;
            // Focus the next focusable item
            case key === 'ArrowDown':
                {
                    const nextItem = (0, $a95f02974ef5ffc0$exports.getNextNavigableItem)(store.value, itemId);
                    if (nextItem) {
                        event.preventDefault();
                        instance.focusItem(event, nextItem);
                        // Multi select behavior when pressing Shift + ArrowDown
                        // Toggles the selection state of the next item
                        if (isMultiSelectEnabled && event.shiftKey && canToggleItemSelection(nextItem)) instance.selectItemFromArrowNavigation(event, itemId, nextItem);
                    }
                    break;
                }
            // Focuses the previous focusable item
            case key === 'ArrowUp':
                {
                    const previousItem = (0, $a95f02974ef5ffc0$exports.getPreviousNavigableItem)(store.value, itemId);
                    if (previousItem) {
                        event.preventDefault();
                        instance.focusItem(event, previousItem);
                        // Multi select behavior when pressing Shift + ArrowUp
                        // Toggles the selection state of the previous item
                        if (isMultiSelectEnabled && event.shiftKey && canToggleItemSelection(previousItem)) instance.selectItemFromArrowNavigation(event, itemId, previousItem);
                    }
                    break;
                }
            // If the focused item is expanded, we move the focus to its first child
            // If the focused item is collapsed and has children, we expand it
            case key === 'ArrowRight' && !isRtl || key === 'ArrowLeft' && isRtl:
                if (ctrlPressed) return;
                if ((0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, itemId)) {
                    const nextItemId = (0, $a95f02974ef5ffc0$exports.getNextNavigableItem)(store.value, itemId);
                    if (nextItemId) {
                        instance.focusItem(event, nextItemId);
                        event.preventDefault();
                    }
                } else if (canToggleItemExpansion(itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                }
                break;
            // If the focused item is expanded, we collapse it
            // If the focused item is collapsed and has a parent, we move the focus to this parent
            case key === 'ArrowLeft' && !isRtl || key === 'ArrowRight' && isRtl:
                if (ctrlPressed) return;
                if (canToggleItemExpansion(itemId) && (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, itemId)) {
                    instance.setItemExpansion({
                        event: event,
                        itemId: itemId
                    });
                    event.preventDefault();
                } else {
                    const parent = (0, $dd8775a0356c16b6$exports.selectorItemParentId)(store.value, itemId);
                    if (parent) {
                        instance.focusItem(event, parent);
                        event.preventDefault();
                    }
                }
                break;
            // Focuses the first item in the tree
            case key === 'Home':
                // Multi select behavior when pressing Ctrl + Shift + Home
                // Selects the focused item and all items up to the first item.
                if (canToggleItemSelection(itemId) && isMultiSelectEnabled && ctrlPressed && event.shiftKey) instance.selectRangeFromStartToItem(event, itemId);
                else instance.focusItem(event, (0, $a95f02974ef5ffc0$exports.getFirstNavigableItem)(store.value));
                event.preventDefault();
                break;
            // Focuses the last item in the tree
            case key === 'End':
                // Multi select behavior when pressing Ctrl + Shirt + End
                // Selects the focused item and all the items down to the last item.
                if (canToggleItemSelection(itemId) && isMultiSelectEnabled && ctrlPressed && event.shiftKey) instance.selectRangeFromItemToEnd(event, itemId);
                else instance.focusItem(event, (0, $a95f02974ef5ffc0$exports.getLastNavigableItem)(store.value));
                event.preventDefault();
                break;
            // Expand all siblings that are at the same level as the focused item
            case key === '*':
                instance.expandAllSiblings(event, itemId);
                event.preventDefault();
                break;
            // Multi select behavior when pressing Ctrl + a
            // Selects all the items
            case String.fromCharCode(event.keyCode) === 'A' && ctrlPressed && isMultiSelectEnabled && (0, $2db5ad35ecc09904$exports.selectorIsSelectionEnabled)(store.value):
                instance.selectAllNavigableItems(event);
                event.preventDefault();
                break;
            // Type-ahead
            // TODO: Support typing multiple characters
            case !ctrlPressed && !event.shiftKey && $9c9d05b4992ea2f4$var$isPrintableKey(key):
                {
                    const matchingItem = getFirstMatchingItem(itemId, key);
                    if (matchingItem != null) {
                        instance.focusItem(event, matchingItem);
                        event.preventDefault();
                    }
                    break;
                }
        }
    };
    return {
        instance: {
            updateFirstCharMap: updateFirstCharMap,
            handleItemKeyDown: handleItemKeyDown
        }
    };
};
$9c9d05b4992ea2f4$exports.useTreeViewKeyboardNavigation = $9c9d05b4992ea2f4$var$useTreeViewKeyboardNavigation;
$9c9d05b4992ea2f4$var$useTreeViewKeyboardNavigation.params = {};




var $44cc18230a75c5e0$exports = {};
"use strict";
Object.defineProperty($44cc18230a75c5e0$exports, "__esModule", {
    value: true
});
Object.defineProperty($44cc18230a75c5e0$exports, "useTreeViewJSXItems", {
    enumerable: true,
    get: function() {
        return $7273af7d5238339b$exports.useTreeViewJSXItems;
    }
});
var $7273af7d5238339b$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $7273af7d5238339b$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $7273af7d5238339b$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($7273af7d5238339b$exports, "__esModule", {
    value: true
});
$7273af7d5238339b$exports.useTreeViewJSXItems = void 0;

var $7273af7d5238339b$var$_extends2 = $7273af7d5238339b$require$_interopRequireDefault((parcelRequire("8tsi7")));

var $7273af7d5238339b$var$React = $7273af7d5238339b$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $7273af7d5238339b$var$_useEventCallback = $7273af7d5238339b$require$_interopRequireDefault((parcelRequire("5xdHV")));

var $7273af7d5238339b$var$_useForkRef = $7273af7d5238339b$require$_interopRequireDefault((parcelRequire("7uWLa")));

var $7273af7d5238339b$var$_useEnhancedEffect = $7273af7d5238339b$require$_interopRequireDefault((parcelRequire("jMi8t")));


var $694dba085e0a74a9$exports = {};
"use strict";

var $1yHiF = parcelRequire("1yHiF");
var $694dba085e0a74a9$require$_interopRequireDefault = $1yHiF.default;

var $1RopH = parcelRequire("1RopH");
var $694dba085e0a74a9$require$_interopRequireWildcard = $1RopH.default;
Object.defineProperty($694dba085e0a74a9$exports, "__esModule", {
    value: true
});
$694dba085e0a74a9$exports.TreeViewChildrenItemContext = void 0;
$694dba085e0a74a9$exports.TreeViewChildrenItemProvider = $694dba085e0a74a9$var$TreeViewChildrenItemProvider;

var $694dba085e0a74a9$var$React = $694dba085e0a74a9$require$_interopRequireWildcard((parcelRequire("8nGP5")));

var $694dba085e0a74a9$var$_propTypes = $694dba085e0a74a9$require$_interopRequireDefault((parcelRequire("ebCsu")));

var $8153948822e4985d$exports = {};
"use strict";
Object.defineProperty($8153948822e4985d$exports, "__esModule", {
    value: true
});
$8153948822e4985d$exports.escapeOperandAttributeSelector = $8153948822e4985d$var$escapeOperandAttributeSelector;
$8153948822e4985d$exports.getActiveElement = void 0;
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $8153948822e4985d$var$getActiveElement = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $8153948822e4985d$var$getActiveElement(activeEl.shadowRoot);
    return activeEl;
};
// TODO, eventually replaces this function with CSS.escape, once available in jsdom, either added manually or built in
// https://github.com/jsdom/jsdom/issues/1550#issuecomment-236734471
$8153948822e4985d$exports.getActiveElement = $8153948822e4985d$var$getActiveElement;
function $8153948822e4985d$var$escapeOperandAttributeSelector(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}




var $kSbwP = parcelRequire("kSbwP");
const $694dba085e0a74a9$var$TreeViewChildrenItemContext = $694dba085e0a74a9$exports.TreeViewChildrenItemContext = /*#__PURE__*/ $694dba085e0a74a9$var$React.createContext(null);
function $694dba085e0a74a9$var$TreeViewChildrenItemProvider(props) {
    const { children: children, itemId: itemId = null, idAttribute: idAttribute } = props;
    const { instance: instance, store: store, rootRef: rootRef } = (0, $e00645ca7de9e15d$exports.useTreeViewContext)();
    const childrenIdAttrToIdRef = $694dba085e0a74a9$var$React.useRef(new Map());
    $694dba085e0a74a9$var$React.useEffect(()=>{
        if (!rootRef.current) return;
        const previousChildrenIds = (0, $dd8775a0356c16b6$exports.selectorItemOrderedChildrenIds)(store.value, itemId ?? null) ?? [];
        const escapedIdAttr = (0, $8153948822e4985d$exports.escapeOperandAttributeSelector)(idAttribute ?? rootRef.current.id);
        const childrenElements = rootRef.current.querySelectorAll(`${itemId == null ? '' : `*[id="${escapedIdAttr}"] `}[role="treeitem"]:not(*[id="${escapedIdAttr}"] [role="treeitem"] [role="treeitem"])`);
        const childrenIds = Array.from(childrenElements).map((child)=>childrenIdAttrToIdRef.current.get(child.id));
        const hasChanged = childrenIds.length !== previousChildrenIds.length || childrenIds.some((childId, index)=>childId !== previousChildrenIds[index]);
        if (hasChanged) instance.setJSXItemsOrderedChildrenIds(itemId ?? null, childrenIds);
    });
    const value = $694dba085e0a74a9$var$React.useMemo(()=>({
            registerChild: (childIdAttribute, childItemId)=>childrenIdAttrToIdRef.current.set(childIdAttribute, childItemId),
            unregisterChild: (childIdAttribute)=>childrenIdAttrToIdRef.current.delete(childIdAttribute),
            parentId: itemId
        }), [
        itemId
    ]);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($694dba085e0a74a9$var$TreeViewChildrenItemContext.Provider, {
        value: value,
        children: children
    });
}





var $54f137448559630a$exports = {};
"use strict";
'use client';
Object.defineProperty($54f137448559630a$exports, "__esModule", {
    value: true
});
$54f137448559630a$exports.useTreeItemUtils = $54f137448559630a$exports.itemHasChildren = void 0;








var $bee64f0747ab8cef$exports = {};
"use strict";
Object.defineProperty($bee64f0747ab8cef$exports, "__esModule", {
    value: true
});
$bee64f0747ab8cef$exports.selectorIsLazyLoadingEnabled = $bee64f0747ab8cef$exports.selectorIsItemLoading = $bee64f0747ab8cef$exports.selectorGetTreeItemError = $bee64f0747ab8cef$exports.selectorDataSourceState = void 0;

const $bee64f0747ab8cef$var$selectorLazyLoading = (state)=>state.lazyLoading;
const $bee64f0747ab8cef$var$selectorLazyLoadingOptional = (state)=>state.lazyLoading;
const $bee64f0747ab8cef$var$selectorDataSourceState = $bee64f0747ab8cef$exports.selectorDataSourceState = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $bee64f0747ab8cef$var$selectorLazyLoading
], (lazyLoading)=>lazyLoading.dataSource);
/**
 * Check if lazy loading is enabled.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @returns {boolean} True if lazy loading is enabled, false if it isn't.
 */ const $bee64f0747ab8cef$var$selectorIsLazyLoadingEnabled = $bee64f0747ab8cef$exports.selectorIsLazyLoadingEnabled = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $bee64f0747ab8cef$var$selectorLazyLoadingOptional
], (lazyLoading)=>!!lazyLoading?.enabled);
/**
 * Get the loading state for a tree item.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the loading state of.
 * @returns {boolean} The loading state for the Tree Item.
 */ const $bee64f0747ab8cef$var$selectorIsItemLoading = $bee64f0747ab8cef$exports.selectorIsItemLoading = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $bee64f0747ab8cef$var$selectorDataSourceState,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.loading[itemId] || false);
/**
 * Get the error for a tree item.
 * @param {TreeViewState<[UseTreeViewLazyLoadingSignature]>} state The state of the tree view.
 * @param {TreeViewItemId} itemId The id of the item to get the error for.
 * @returns {boolean} The error for the Tree Item.
 */ const $bee64f0747ab8cef$var$selectorGetTreeItemError = $bee64f0747ab8cef$exports.selectorGetTreeItemError = (0, $11a1a9bd6141dd56$exports.createSelector)([
    $bee64f0747ab8cef$var$selectorDataSourceState,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.errors[itemId] || null);



/**
 * Plugins that need to be present in the Tree View in order for `useTreeItemUtils` to work correctly.
 */ /**
 * Plugins that `useTreeItemUtils` can use if they are present, but are not required.
 */ const $54f137448559630a$var$itemHasChildren = (reactChildren)=>{
    if (Array.isArray(reactChildren)) return reactChildren.length > 0 && reactChildren.some($54f137448559630a$var$itemHasChildren);
    return Boolean(reactChildren);
};
$54f137448559630a$exports.itemHasChildren = $54f137448559630a$var$itemHasChildren;
const $54f137448559630a$var$useTreeItemUtils = ({ itemId: itemId, children: children })=>{
    const { instance: instance, store: store, publicAPI: publicAPI } = (0, $10a40780e7af645f$exports.useTreeViewContext)();
    const isItemExpandable = (0, $38c0a2e603e59f07$exports.useSelector)(store, $465b8a23aa196103$exports.selectorIsItemExpandable, itemId);
    const isLazyLoadingEnabled = (0, $38c0a2e603e59f07$exports.useSelector)(store, $bee64f0747ab8cef$exports.selectorIsLazyLoadingEnabled);
    const isMultiSelectEnabled = (0, $38c0a2e603e59f07$exports.useSelector)(store, $2db5ad35ecc09904$exports.selectorIsMultiSelectEnabled);
    const loading = (0, $38c0a2e603e59f07$exports.useSelector)(store, (state)=>isLazyLoadingEnabled ? (0, $bee64f0747ab8cef$exports.selectorIsItemLoading)(state, itemId) : false);
    const error = (0, $38c0a2e603e59f07$exports.useSelector)(store, (state)=>isLazyLoadingEnabled ? Boolean((0, $bee64f0747ab8cef$exports.selectorGetTreeItemError)(state, itemId)) : false);
    const isExpandable = $54f137448559630a$var$itemHasChildren(children) || isItemExpandable;
    const isExpanded = (0, $38c0a2e603e59f07$exports.useSelector)(store, $465b8a23aa196103$exports.selectorIsItemExpanded, itemId);
    const isFocused = (0, $38c0a2e603e59f07$exports.useSelector)(store, $d66f82d897437048$exports.selectorIsItemFocused, itemId);
    const isSelected = (0, $38c0a2e603e59f07$exports.useSelector)(store, $2db5ad35ecc09904$exports.selectorIsItemSelected, itemId);
    const isDisabled = (0, $38c0a2e603e59f07$exports.useSelector)(store, $dd8775a0356c16b6$exports.selectorIsItemDisabled, itemId);
    const isEditing = (0, $38c0a2e603e59f07$exports.useSelector)(store, $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited, itemId);
    const isEditable = (0, $38c0a2e603e59f07$exports.useSelector)(store, $ac4d3b7e147f2dd1$exports.selectorIsItemEditable, itemId);
    const status = {
        expandable: isExpandable,
        expanded: isExpanded,
        focused: isFocused,
        selected: isSelected,
        disabled: isDisabled,
        editing: isEditing,
        editable: isEditable,
        loading: loading,
        error: error
    };
    const handleExpansion = (event)=>{
        if (status.disabled) return;
        if (!status.focused) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        // If already expanded and trying to toggle selection don't close
        if (status.expandable && !(multiple && (0, $465b8a23aa196103$exports.selectorIsItemExpanded)(store.value, itemId))) // make sure the children selection is propagated again
        instance.setItemExpansion({
            event: event,
            itemId: itemId
        });
    };
    const handleSelection = (event)=>{
        if (status.disabled) return;
        if (!status.focused && !status.editing) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        if (multiple) {
            if (event.shiftKey) instance.expandSelectionRange(event, itemId);
            else instance.setItemSelection({
                event: event,
                itemId: itemId,
                keepExistingSelection: true
            });
        } else instance.setItemSelection({
            event: event,
            itemId: itemId,
            shouldBeSelected: true
        });
    };
    const handleCheckboxSelection = (event)=>{
        const hasShift = event.nativeEvent.shiftKey;
        if (isMultiSelectEnabled && hasShift) instance.expandSelectionRange(event, itemId);
        else instance.setItemSelection({
            event: event,
            itemId: itemId,
            keepExistingSelection: isMultiSelectEnabled,
            shouldBeSelected: event.target.checked
        });
    };
    const toggleItemEditing = ()=>{
        if (!(0, $e7fe62e7dc5d6dca$exports.hasPlugin)(instance, $508c6e333d1795ae$exports.useTreeViewLabel)) return;
        if (isEditable) {
            if (isEditing) instance.setEditedItemId(null);
            else instance.setEditedItemId(itemId);
        }
    };
    const handleSaveItemLabel = (event, newLabel)=>{
        if (!(0, $e7fe62e7dc5d6dca$exports.hasPlugin)(instance, $508c6e333d1795ae$exports.useTreeViewLabel)) return;
        // As a side effect of `instance.focusItem` called here and in `handleCancelItemLabelEditing` the `labelInput` is blurred
        // The `onBlur` event is triggered, which calls `handleSaveItemLabel` again.
        // To avoid creating an unwanted behavior we need to check if the item is being edited before calling `updateItemLabel`
        if ((0, $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited)(store.value, itemId)) {
            instance.updateItemLabel(itemId, newLabel);
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const handleCancelItemLabelEditing = (event)=>{
        if (!(0, $e7fe62e7dc5d6dca$exports.hasPlugin)(instance, $508c6e333d1795ae$exports.useTreeViewLabel)) return;
        if ((0, $ac4d3b7e147f2dd1$exports.selectorIsItemBeingEdited)(store.value, itemId)) {
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const interactions = {
        handleExpansion: handleExpansion,
        handleSelection: handleSelection,
        handleCheckboxSelection: handleCheckboxSelection,
        toggleItemEditing: toggleItemEditing,
        handleSaveItemLabel: handleSaveItemLabel,
        handleCancelItemLabelEditing: handleCancelItemLabelEditing
    };
    return {
        interactions: interactions,
        status: status,
        publicAPI: publicAPI
    };
};
$54f137448559630a$exports.useTreeItemUtils = $54f137448559630a$var$useTreeItemUtils;





var $kSbwP = parcelRequire("kSbwP");
const $7273af7d5238339b$var$useTreeViewJSXItems = ({ instance: instance, store: store })=>{
    instance.preventItemUpdates();
    const insertJSXItem = (0, $7273af7d5238339b$var$_useEventCallback.default)((item)=>{
        store.update((prevState)=>{
            if (prevState.items.itemMetaLookup[item.id] != null) throw new Error([
                'MUI X: The Tree View component requires all items to have a unique `id` property.',
                'Alternatively, you can use the `getItemId` prop to specify a custom id for each item.',
                `Two items were provided with the same id in the \`items\` prop: "${item.id}"`
            ].join('\n'));
            return (0, $7273af7d5238339b$var$_extends2.default)({}, prevState, {
                items: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items, {
                    itemMetaLookup: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemMetaLookup, {
                        [item.id]: item
                    }),
                    // For Simple Tree View, we don't have a proper `item` object, so we create a very basic one.
                    itemModelLookup: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemModelLookup, {
                        [item.id]: {
                            id: item.id,
                            label: item.label ?? ''
                        }
                    })
                })
            });
        });
        return ()=>{
            store.update((prevState)=>{
                const newItemMetaLookup = (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemMetaLookup);
                const newItemModelLookup = (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemModelLookup);
                delete newItemMetaLookup[item.id];
                delete newItemModelLookup[item.id];
                return (0, $7273af7d5238339b$var$_extends2.default)({}, prevState, {
                    items: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items, {
                        itemMetaLookup: newItemMetaLookup,
                        itemModelLookup: newItemModelLookup
                    })
                });
            });
            (0, $39d933053e68e997$exports.publishTreeViewEvent)(instance, 'removeItem', {
                id: item.id
            });
        };
    });
    const setJSXItemsOrderedChildrenIds = (parentId, orderedChildrenIds)=>{
        const parentIdWithDefault = parentId ?? $6e9d2739eb68decb$exports.TREE_VIEW_ROOT_PARENT_ID;
        store.update((prevState)=>(0, $7273af7d5238339b$var$_extends2.default)({}, prevState, {
                items: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items, {
                    itemOrderedChildrenIdsLookup: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemOrderedChildrenIdsLookup, {
                        [parentIdWithDefault]: orderedChildrenIds
                    }),
                    itemChildrenIndexesLookup: (0, $7273af7d5238339b$var$_extends2.default)({}, prevState.items.itemChildrenIndexesLookup, {
                        [parentIdWithDefault]: (0, $6e9d2739eb68decb$exports.buildSiblingIndexes)(orderedChildrenIds)
                    })
                })
            }));
    };
    const mapFirstCharFromJSX = (0, $7273af7d5238339b$var$_useEventCallback.default)((itemId, firstChar)=>{
        instance.updateFirstCharMap((firstCharMap)=>{
            firstCharMap[itemId] = firstChar;
            return firstCharMap;
        });
        return ()=>{
            instance.updateFirstCharMap((firstCharMap)=>{
                const newMap = (0, $7273af7d5238339b$var$_extends2.default)({}, firstCharMap);
                delete newMap[itemId];
                return newMap;
            });
        };
    });
    return {
        instance: {
            insertJSXItem: insertJSXItem,
            setJSXItemsOrderedChildrenIds: setJSXItemsOrderedChildrenIds,
            mapFirstCharFromJSX: mapFirstCharFromJSX
        }
    };
};
$7273af7d5238339b$exports.useTreeViewJSXItems = $7273af7d5238339b$var$useTreeViewJSXItems;
const $7273af7d5238339b$var$useTreeViewJSXItemsItemPlugin = ({ props: props, rootRef: rootRef, contentRef: contentRef })=>{
    const { instance: instance, store: store } = (0, $10a40780e7af645f$exports.useTreeViewContext)();
    const { children: children, disabled: disabled = false, label: label, itemId: itemId, id: id } = props;
    const parentContext = $7273af7d5238339b$var$React.useContext($694dba085e0a74a9$exports.TreeViewChildrenItemContext);
    if (parentContext == null) throw new Error([
        'MUI X: Could not find the Tree View Children Item context.',
        'It looks like you rendered your component outside of a SimpleTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    const { registerChild: registerChild, unregisterChild: unregisterChild, parentId: parentId } = parentContext;
    const expandable = (0, $54f137448559630a$exports.itemHasChildren)(children);
    const pluginContentRef = $7273af7d5238339b$var$React.useRef(null);
    const handleContentRef = (0, $7273af7d5238339b$var$_useForkRef.default)(pluginContentRef, contentRef);
    const treeId = (0, $38c0a2e603e59f07$exports.useSelector)(store, $4dfa2e8708449837$exports.selectorTreeViewId);
    // Prevent any flashing
    (0, $7273af7d5238339b$var$_useEnhancedEffect.default)(()=>{
        const idAttribute = (0, $fef5881a3f8874a0$exports.generateTreeItemIdAttribute)({
            itemId: itemId,
            treeId: treeId,
            id: id
        });
        registerChild(idAttribute, itemId);
        return ()=>{
            unregisterChild(idAttribute);
            unregisterChild(idAttribute);
        };
    }, [
        store,
        instance,
        registerChild,
        unregisterChild,
        itemId,
        id,
        treeId
    ]);
    (0, $7273af7d5238339b$var$_useEnhancedEffect.default)(()=>{
        return instance.insertJSXItem({
            id: itemId,
            idAttribute: id,
            parentId: parentId,
            expandable: expandable,
            disabled: disabled
        });
    }, [
        instance,
        parentId,
        itemId,
        expandable,
        disabled,
        id
    ]);
    $7273af7d5238339b$var$React.useEffect(()=>{
        if (label) return instance.mapFirstCharFromJSX(itemId, (pluginContentRef.current?.textContent ?? '').substring(0, 1).toLowerCase());
        return undefined;
    }, [
        instance,
        itemId,
        label
    ]);
    return {
        contentRef: handleContentRef,
        rootRef: rootRef
    };
};
$7273af7d5238339b$var$useTreeViewJSXItems.itemPlugin = $7273af7d5238339b$var$useTreeViewJSXItemsItemPlugin;
$7273af7d5238339b$var$useTreeViewJSXItems.wrapItem = ({ children: children, itemId: itemId, idAttribute: idAttribute })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const depthContext = $7273af7d5238339b$var$React.useContext($25a3ca13bccc784d$exports.TreeViewItemDepthContext);
    return /*#__PURE__*/ (0, $kSbwP.jsx)($694dba085e0a74a9$exports.TreeViewChildrenItemProvider, {
        itemId: itemId,
        idAttribute: idAttribute,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($25a3ca13bccc784d$exports.TreeViewItemDepthContext.Provider, {
            value: depthContext + 1,
            children: children
        })
    });
};
$7273af7d5238339b$var$useTreeViewJSXItems.wrapRoot = ({ children: children })=>/*#__PURE__*/ (0, $kSbwP.jsx)($694dba085e0a74a9$exports.TreeViewChildrenItemProvider, {
        itemId: null,
        idAttribute: null,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)($25a3ca13bccc784d$exports.TreeViewItemDepthContext.Provider, {
            value: 0,
            children: children
        })
    });
$7273af7d5238339b$var$useTreeViewJSXItems.params = {};




const $d150c9485f08ca3f$var$SIMPLE_TREE_VIEW_PLUGINS = $d150c9485f08ca3f$exports.SIMPLE_TREE_VIEW_PLUGINS = [
    $7fb7e6063f9de6ff$exports.useTreeViewItems,
    $dab860fc1c8a1d06$exports.useTreeViewExpansion,
    $569f083d8a710a0f$exports.useTreeViewSelection,
    $94f08a12df4fb913$exports.useTreeViewFocus,
    $aa233e83a0dedbf2$exports.useTreeViewKeyboardNavigation,
    $44cc18230a75c5e0$exports.useTreeViewJSXItems
]; // We can't infer this type from the plugin, otherwise we would lose the generics.



var $kSbwP = parcelRequire("kSbwP");
const $28d59a58c1f5f793$var$_excluded = [
    "slots",
    "slotProps"
];
const $28d59a58c1f5f793$var$useThemeProps = (0, $6b3b06de371680d1$exports.createUseThemeProps)('MuiSimpleTreeView');
const $28d59a58c1f5f793$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $28d59a58c1f5f793$var$React.useMemo(()=>{
        const slots = {
            root: [
                'root'
            ],
            item: [
                'item'
            ],
            itemContent: [
                'itemContent'
            ],
            itemGroupTransition: [
                'itemGroupTransition'
            ],
            itemIconContainer: [
                'itemIconContainer'
            ],
            itemLabel: [
                'itemLabel'
            ],
            // itemLabelInput: ['itemLabelInput'], => feature not available on this component
            itemCheckbox: [
                'itemCheckbox'
            ]
        };
        return (0, $28d59a58c1f5f793$var$_composeClasses.default)(slots, $3380f876c6865bf9$exports.getSimpleTreeViewUtilityClass, classes);
    }, [
        classes
    ]);
};
const $28d59a58c1f5f793$var$SimpleTreeViewRoot = $28d59a58c1f5f793$exports.SimpleTreeViewRoot = (0, $6b3b06de371680d1$exports.styled)('ul', {
    name: 'MuiSimpleTreeView',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    outline: 0,
    position: 'relative'
});
const $28d59a58c1f5f793$var$EMPTY_ITEMS = [];
/**
 *
 * Demos:
 *
 * - [Tree View](https://mui.com/x/react-tree-view/)
 *
 * API:
 *
 * - [SimpleTreeView API](https://mui.com/x/api/tree-view/simple-tree-view/)
 */ const $28d59a58c1f5f793$var$SimpleTreeView = $28d59a58c1f5f793$exports.SimpleTreeView = /*#__PURE__*/ $28d59a58c1f5f793$var$React.forwardRef(function SimpleTreeView(inProps, ref) {
    const props = $28d59a58c1f5f793$var$useThemeProps({
        props: inProps,
        name: 'MuiSimpleTreeView'
    });
    const { slots: slots, slotProps: slotProps } = props, other = (0, $28d59a58c1f5f793$var$_objectWithoutPropertiesLoose2.default)(props, $28d59a58c1f5f793$var$_excluded);
    const { getRootProps: getRootProps, contextValue: contextValue } = (0, $e46f8cc689dd0177$exports.useTreeView)({
        plugins: $d150c9485f08ca3f$exports.SIMPLE_TREE_VIEW_PLUGINS,
        rootRef: ref,
        props: (0, $28d59a58c1f5f793$var$_extends2.default)({}, other, {
            items: $28d59a58c1f5f793$var$EMPTY_ITEMS
        })
    });
    const classes = $28d59a58c1f5f793$var$useUtilityClasses(props);
    const Root = slots?.root ?? $28d59a58c1f5f793$var$SimpleTreeViewRoot;
    const rootProps = (0, $28d59a58c1f5f793$var$_useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        className: classes.root,
        getSlotProps: getRootProps,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)($10a40780e7af645f$exports.TreeViewProvider, {
        contextValue: contextValue,
        classes: classes,
        slots: slots,
        slotProps: slotProps,
        children: /*#__PURE__*/ (0, $kSbwP.jsx)(Root, (0, $28d59a58c1f5f793$var$_extends2.default)({}, rootProps))
    });
});


Object.keys($28d59a58c1f5f793$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4f5f5b50b52104e1$exports && $4f5f5b50b52104e1$exports[key] === $28d59a58c1f5f793$exports[key]) return;
    Object.defineProperty($4f5f5b50b52104e1$exports, key, {
        enumerable: true,
        get: function() {
            return $28d59a58c1f5f793$exports[key];
        }
    });
});

Object.keys($3380f876c6865bf9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $4f5f5b50b52104e1$exports && $4f5f5b50b52104e1$exports[key] === $3380f876c6865bf9$exports[key]) return;
    Object.defineProperty($4f5f5b50b52104e1$exports, key, {
        enumerable: true,
        get: function() {
            return $3380f876c6865bf9$exports[key];
        }
    });
});



var $8D9Xw = parcelRequire("8D9Xw");

var $1TGTA = parcelRequire("1TGTA");

var $8nGP5 = parcelRequire("8nGP5");


var $ajIhI = parcelRequire("ajIhI");
var $303b495ab50d9d04$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $303b495ab50d9d04$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $303b495ab50d9d04$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($303b495ab50d9d04$exports, "__esModule", {
    value: true
});
var $303b495ab50d9d04$var$_exportNames = {
    circularProgressClasses: true
};
Object.defineProperty($303b495ab50d9d04$exports, "circularProgressClasses", {
    enumerable: true,
    get: function() {
        return $303b495ab50d9d04$var$_circularProgressClasses.default;
    }
});
Object.defineProperty($303b495ab50d9d04$exports, "default", {
    enumerable: true,
    get: function() {
        return $303b495ab50d9d04$var$_CircularProgress.default;
    }
});

var $303b495ab50d9d04$var$_CircularProgress = $303b495ab50d9d04$require$_interopRequireDefault((parcelRequire("bhDm2")));

var $303b495ab50d9d04$var$_circularProgressClasses = $303b495ab50d9d04$require$_interopRequireWildcard((parcelRequire("gq1Gj")));
Object.keys($303b495ab50d9d04$var$_circularProgressClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($303b495ab50d9d04$var$_exportNames, key)) return;
    if (key in $303b495ab50d9d04$exports && $303b495ab50d9d04$exports[key] === $303b495ab50d9d04$var$_circularProgressClasses[key]) return;
    Object.defineProperty($303b495ab50d9d04$exports, key, {
        enumerable: true,
        get: function() {
            return $303b495ab50d9d04$var$_circularProgressClasses[key];
        }
    });
});




var $6NVMl = parcelRequire("6NVMl");
var $124d1943ba55dde5$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $124d1943ba55dde5$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $124d1943ba55dde5$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($124d1943ba55dde5$exports, "__esModule", {
    value: true
});
var $124d1943ba55dde5$var$_exportNames = {
    collapseClasses: true
};
Object.defineProperty($124d1943ba55dde5$exports, "collapseClasses", {
    enumerable: true,
    get: function() {
        return $124d1943ba55dde5$var$_collapseClasses.default;
    }
});
Object.defineProperty($124d1943ba55dde5$exports, "default", {
    enumerable: true,
    get: function() {
        return $124d1943ba55dde5$var$_Collapse.default;
    }
});

var $124d1943ba55dde5$var$_Collapse = $124d1943ba55dde5$require$_interopRequireDefault((parcelRequire("3uKFP")));

var $124d1943ba55dde5$var$_collapseClasses = $124d1943ba55dde5$require$_interopRequireWildcard((parcelRequire("eIMYG")));
Object.keys($124d1943ba55dde5$var$_collapseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($124d1943ba55dde5$var$_exportNames, key)) return;
    if (key in $124d1943ba55dde5$exports && $124d1943ba55dde5$exports[key] === $124d1943ba55dde5$var$_collapseClasses[key]) return;
    Object.defineProperty($124d1943ba55dde5$exports, key, {
        enumerable: true,
        get: function() {
            return $124d1943ba55dde5$var$_collapseClasses[key];
        }
    });
});


var $4dc8eefaf7e838ef$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $4dc8eefaf7e838ef$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $4dc8eefaf7e838ef$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($4dc8eefaf7e838ef$exports, "__esModule", {
    value: true
});
var $4dc8eefaf7e838ef$var$_exportNames = {
    checkboxClasses: true
};
Object.defineProperty($4dc8eefaf7e838ef$exports, "checkboxClasses", {
    enumerable: true,
    get: function() {
        return $4dc8eefaf7e838ef$var$_checkboxClasses.default;
    }
});
Object.defineProperty($4dc8eefaf7e838ef$exports, "default", {
    enumerable: true,
    get: function() {
        return $4dc8eefaf7e838ef$var$_Checkbox.default;
    }
});

var $4dc8eefaf7e838ef$var$_Checkbox = $4dc8eefaf7e838ef$require$_interopRequireDefault((parcelRequire("iFtbQ")));

var $4dc8eefaf7e838ef$var$_checkboxClasses = $4dc8eefaf7e838ef$require$_interopRequireWildcard((parcelRequire("gvoLb")));
Object.keys($4dc8eefaf7e838ef$var$_checkboxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4dc8eefaf7e838ef$var$_exportNames, key)) return;
    if (key in $4dc8eefaf7e838ef$exports && $4dc8eefaf7e838ef$exports[key] === $4dc8eefaf7e838ef$var$_checkboxClasses[key]) return;
    Object.defineProperty($4dc8eefaf7e838ef$exports, key, {
        enumerable: true,
        get: function() {
            return $4dc8eefaf7e838ef$var$_checkboxClasses[key];
        }
    });
});



var $k3QMn = parcelRequire("k3QMn");

var $cx8dF = parcelRequire("cx8dF");

var $4F19u = parcelRequire("4F19u");

var $6NVMl = parcelRequire("6NVMl");
function $a1617ee7cca6f994$export$ff8356348e0cc878(name) {
    return 0, $6NVMl.useThemeProps;
}


var $6NVMl = parcelRequire("6NVMl");

var $1TGTA = parcelRequire("1TGTA");

var $8nGP5 = parcelRequire("8nGP5");

var $9ds9N = parcelRequire("9ds9N");

var $7uWLa = parcelRequire("7uWLa");

var $8nGP5 = parcelRequire("8nGP5");
const $02716139b79a8cfc$export$5e4715462ac10946 = /*#__PURE__*/ $8nGP5.createContext(null);
const $02716139b79a8cfc$export$8a6a3e88e8e060e0 = ()=>{
    const context = $8nGP5.useContext($02716139b79a8cfc$export$5e4715462ac10946);
    if (context == null) throw new Error([
        'MUI X: Could not find the Tree View context.',
        'It looks like you rendered your component outside of a SimpleTreeView or RichTreeView parent component.',
        'This can also happen if you are bundling multiple versions of the Tree View.'
    ].join('\n'));
    return context;
};




var $1TGTA = parcelRequire("1TGTA");

var $jMi8t = parcelRequire("jMi8t");

var $8nGP5 = parcelRequire("8nGP5");


const $23ddd3c612abbb90$var$defaultCompare = Object.is;
const $23ddd3c612abbb90$export$2105062e25df4afe = (store, selector, args, equals = $23ddd3c612abbb90$var$defaultCompare)=>{
    const selectorWithArgs = (state)=>selector(state, args);
    return (0, $6b1fc6b5623be35e$exports.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs, equals);
};



const $15b14787c3112f90$var$reselectCreateSelector = (0, $90730c39e9f007a7$export$5943f4447f6ef248)({
    memoize: (0, $90730c39e9f007a7$export$d8ead1d92249919b),
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
const $15b14787c3112f90$var$cache = new WeakMap();
const $15b14787c3112f90$export$595d22ed68ca2841 = (...createSelectorArgs)=>{
    const selector = (state, selectorArgs)=>{
        const cacheKey = state.cacheKey;
        // If there is no cache for the current tree view instance, create one.
        let cacheForCurrentTreeViewInstance = $15b14787c3112f90$var$cache.get(cacheKey);
        if (!cacheForCurrentTreeViewInstance) {
            cacheForCurrentTreeViewInstance = new Map();
            $15b14787c3112f90$var$cache.set(cacheKey, cacheForCurrentTreeViewInstance);
        }
        // If there is a cached selector, execute it.
        const cachedSelector = cacheForCurrentTreeViewInstance.get(createSelectorArgs);
        if (cachedSelector) return cachedSelector(state, selectorArgs);
        // Otherwise, create a new selector and cache it and execute it.
        const fn = $15b14787c3112f90$var$reselectCreateSelector(...createSelectorArgs);
        cacheForCurrentTreeViewInstance.set(createSelectorArgs, fn);
        return fn(state, selectorArgs);
    };
    return selector;
};



const $05ea814879f5b194$export$e7a9649b6cfa9944 = '__TREE_VIEW_ROOT_PARENT_ID__';
const $05ea814879f5b194$export$1d3868a1fe066660 = (siblings)=>{
    const siblingsIndexLookup = {};
    siblings.forEach((childId, index)=>{
        siblingsIndexLookup[childId] = index;
    });
    return siblingsIndexLookup;
};
const $05ea814879f5b194$export$98e832630d6cf989 = (itemMetaLookup, itemId)=>{
    if (itemId == null) return false;
    let itemMeta = itemMetaLookup[itemId];
    // This can be called before the item has been added to the item map.
    if (!itemMeta) return false;
    if (itemMeta.disabled) return true;
    while(itemMeta.parentId != null){
        itemMeta = itemMetaLookup[itemMeta.parentId];
        if (!itemMeta) return false;
        if (itemMeta.disabled) return true;
    }
    return false;
};


const $edacdbf4783600b4$var$selectorTreeViewItemsState = (state)=>state.items;
const $edacdbf4783600b4$export$4302d87ae7c34b4 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($edacdbf4783600b4$var$selectorTreeViewItemsState, (items)=>items.loading);
const $edacdbf4783600b4$export$e215911469833313 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($edacdbf4783600b4$var$selectorTreeViewItemsState, (items)=>items.error);
const $edacdbf4783600b4$export$e45de148543acce3 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($edacdbf4783600b4$var$selectorTreeViewItemsState, (items)=>items.itemMetaLookup);
const $edacdbf4783600b4$var$EMPTY_CHILDREN = [];
const $edacdbf4783600b4$export$69bc973ba903671f = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemOrderedChildrenIdsLookup[itemId ?? (0, $05ea814879f5b194$export$e7a9649b6cfa9944)] ?? $edacdbf4783600b4$var$EMPTY_CHILDREN);
const $edacdbf4783600b4$export$798d3f35e2df0c38 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$var$selectorTreeViewItemsState,
    (_, itemId)=>itemId
], (itemsState, itemId)=>itemsState.itemModelLookup[itemId]);
const $edacdbf4783600b4$export$f990f915c7ea2f8f = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$export$e45de148543acce3,
    (_, itemId)=>itemId
], (itemMetaLookup, itemId)=>itemMetaLookup[itemId ?? (0, $05ea814879f5b194$export$e7a9649b6cfa9944)] ?? null);
const $edacdbf4783600b4$export$d9423a572d5d897d = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$export$e45de148543acce3,
    (_, itemId)=>itemId
], (0, $05ea814879f5b194$export$98e832630d6cf989));
const $edacdbf4783600b4$export$882fe1a4ba86c1b4 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$var$selectorTreeViewItemsState,
    $edacdbf4783600b4$export$f990f915c7ea2f8f
], (itemsState, itemMeta)=>{
    if (itemMeta == null) return -1;
    const parentIndexes = itemsState.itemChildrenIndexesLookup[itemMeta.parentId ?? (0, $05ea814879f5b194$export$e7a9649b6cfa9944)];
    return parentIndexes[itemMeta.id];
});
const $edacdbf4783600b4$export$c906a77b96e11840 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$export$f990f915c7ea2f8f
], (itemMeta)=>itemMeta?.parentId ?? null);
const $edacdbf4783600b4$export$3b299d518df6e128 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$export$f990f915c7ea2f8f
], (itemMeta)=>itemMeta?.depth ?? 0);
const $edacdbf4783600b4$export$fdde3741e8a8d0d9 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$var$selectorTreeViewItemsState
], (itemsState)=>itemsState.disabledItemsFocusable);
const $edacdbf4783600b4$export$1f5eb544d48e74e6 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $edacdbf4783600b4$export$fdde3741e8a8d0d9,
    $edacdbf4783600b4$export$d9423a572d5d897d
], (disabledItemsFocusable, isDisabled)=>{
    if (disabledItemsFocusable) return true;
    return !isDisabled;
});


const $4ba0d90c93ca7a0e$var$selectorTreeViewLabelState = (state)=>state.label;
const $4ba0d90c93ca7a0e$export$cad5fd68a6e551c8 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $4ba0d90c93ca7a0e$var$selectorTreeViewLabelState,
    (state, itemId)=>(0, $edacdbf4783600b4$export$798d3f35e2df0c38)(state, itemId)
], (labelState, itemModel)=>{
    if (!itemModel || !labelState) return false;
    if (typeof labelState.isItemEditable === 'boolean') return labelState.isItemEditable;
    return labelState.isItemEditable(itemModel);
});
const $4ba0d90c93ca7a0e$export$90735c1de5994ca8 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $4ba0d90c93ca7a0e$var$selectorTreeViewLabelState,
    (_, itemId)=>itemId
], (labelState, itemId)=>itemId ? labelState?.editedItemId === itemId : false);
const $4ba0d90c93ca7a0e$export$48414a4f18571d49 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($4ba0d90c93ca7a0e$var$selectorTreeViewLabelState, (labelState)=>!!labelState?.editedItemId);


const $c2588034e186a728$export$3191224b92f3e03b = ({ props: props })=>{
    const { store: store } = (0, $02716139b79a8cfc$export$8a6a3e88e8e060e0)();
    const { label: label, itemId: itemId } = props;
    const [labelInputValue, setLabelInputValue] = $8nGP5.useState(label);
    const isItemEditable = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $4ba0d90c93ca7a0e$export$cad5fd68a6e551c8), itemId);
    const isItemBeingEdited = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $4ba0d90c93ca7a0e$export$90735c1de5994ca8), itemId);
    $8nGP5.useEffect(()=>{
        if (!isItemBeingEdited) setLabelInputValue(label);
    }, [
        isItemBeingEdited,
        label
    ]);
    return {
        propsEnhancers: {
            label: ()=>({
                    editable: isItemEditable
                }),
            labelInput: ({ externalEventHandlers: externalEventHandlers, interactions: interactions })=>{
                if (!isItemEditable) return {};
                const handleKeydown = (event)=>{
                    externalEventHandlers.onKeyDown?.(event);
                    if (event.defaultMuiPrevented) return;
                    const target = event.target;
                    if (event.key === 'Enter' && target.value) interactions.handleSaveItemLabel(event, target.value);
                    else if (event.key === 'Escape') interactions.handleCancelItemLabelEditing(event);
                };
                const handleBlur = (event)=>{
                    externalEventHandlers.onBlur?.(event);
                    if (event.defaultMuiPrevented) return;
                    if (event.target.value) interactions.handleSaveItemLabel(event, event.target.value);
                };
                const handleInputChange = (event)=>{
                    externalEventHandlers.onChange?.(event);
                    setLabelInputValue(event.target.value);
                };
                return {
                    value: labelInputValue ?? '',
                    'data-element': 'labelInput',
                    onChange: handleInputChange,
                    onKeyDown: handleKeydown,
                    onBlur: handleBlur,
                    autoFocus: true,
                    type: 'text'
                };
            }
        }
    };
};


const $84f75122f2832885$export$c6ca8ef294703a19 = ({ store: store, params: params })=>{
    const setEditedItemId = (editedItemId)=>{
        store.update((prevState)=>(0, $1TGTA.default)({}, prevState, {
                label: (0, $1TGTA.default)({}, prevState.label, {
                    editedItemId: editedItemId
                })
            }));
    };
    const updateItemLabel = (itemId, label)=>{
        if (!label) throw new Error([
            'MUI X: The Tree View component requires all items to have a `label` property.',
            'The label of an item cannot be empty.',
            itemId
        ].join('\n'));
        store.update((prevState)=>{
            const item = prevState.items.itemMetaLookup[itemId];
            if (item.label !== label) return (0, $1TGTA.default)({}, prevState, {
                items: (0, $1TGTA.default)({}, prevState.items, {
                    itemMetaLookup: (0, $1TGTA.default)({}, prevState.items.itemMetaLookup, {
                        [itemId]: (0, $1TGTA.default)({}, item, {
                            label: label
                        })
                    })
                })
            });
            return prevState;
        });
        if (params.onItemLabelChange) params.onItemLabelChange(itemId, label);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($jMi8t)))(()=>{
        store.update((prevState)=>(0, $1TGTA.default)({}, prevState, {
                label: (0, $1TGTA.default)({}, prevState.label, {
                    isItemEditable: params.isItemEditable
                })
            }));
    }, [
        store,
        params.isItemEditable
    ]);
    return {
        instance: {
            setEditedItemId: setEditedItemId,
            updateItemLabel: updateItemLabel
        },
        publicAPI: {
            updateItemLabel: updateItemLabel
        }
    };
};
$84f75122f2832885$export$c6ca8ef294703a19.itemPlugin = (0, $c2588034e186a728$export$3191224b92f3e03b);
$84f75122f2832885$export$c6ca8ef294703a19.getDefaultizedParams = ({ params: params })=>(0, $1TGTA.default)({}, params, {
        isItemEditable: params.isItemEditable ?? false
    });
$84f75122f2832885$export$c6ca8ef294703a19.getInitialState = (params)=>({
        label: {
            isItemEditable: params.isItemEditable,
            editedItemId: null
        }
    });
$84f75122f2832885$export$c6ca8ef294703a19.params = {
    onItemLabelChange: true,
    isItemEditable: true
};


const $de1d8dde310f079b$export$44524f2fb4958e20 = (instance, plugin)=>{
    const plugins = instance.getAvailablePlugins();
    return plugins.has(plugin);
};





const $c6924f3766000541$var$selectorExpansion = (state)=>state.expansion;
const $c6924f3766000541$export$2fc55abf2e30ce50 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $c6924f3766000541$var$selectorExpansion
], (expansionState)=>expansionState.expandedItems);
const $c6924f3766000541$export$596d44e462637830 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $c6924f3766000541$export$2fc55abf2e30ce50
], (expandedItems)=>{
    const expandedItemsMap = new Map();
    expandedItems.forEach((id)=>{
        expandedItemsMap.set(id, true);
    });
    return expandedItemsMap;
});
const $c6924f3766000541$export$a9908e37bd1dfacc = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $c6924f3766000541$export$596d44e462637830,
    (_, itemId)=>itemId
], (expandedItemsMap, itemId)=>expandedItemsMap.has(itemId));
const $c6924f3766000541$export$11d8c9cca6604d36 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)
], (itemMeta)=>itemMeta?.expandable ?? false);
const $c6924f3766000541$export$298875142e252c82 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $c6924f3766000541$var$selectorExpansion
], (expansionState)=>expansionState.expansionTrigger);





const $0857219a79e13429$var$selectorTreeViewSelectionState = (state)=>state.selection;
const $0857219a79e13429$export$c422035927c6c234 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectedItems);
const $0857219a79e13429$export$ce60c82c6907c2e5 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$export$c422035927c6c234
], (selectedItems)=>{
    if (Array.isArray(selectedItems)) return selectedItems;
    if (selectedItems != null) return [
        selectedItems
    ];
    return [];
});
/**
 * Get the selected items as a map.
 * @param {TreeViewState<[UseTreeViewSelectionSignature]>} state The state of the tree view.
 * @returns {Map<TreeViewItemId, true>} The selected items as a Map.
 */ const $0857219a79e13429$var$selectorSelectionModelMap = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$export$ce60c82c6907c2e5
], (selectedItems)=>{
    const selectedItemsMap = new Map();
    selectedItems.forEach((id)=>{
        selectedItemsMap.set(id, true);
    });
    return selectedItemsMap;
});
const $0857219a79e13429$export$38ad7ce4f432e8cc = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorSelectionModelMap,
    (_, itemId)=>itemId
], (selectedItemsMap, itemId)=>selectedItemsMap.has(itemId));
const $0857219a79e13429$export$55aeefee787876c = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled && selectionState.isMultiSelectEnabled);
const $0857219a79e13429$export$d87836403f03cf1c = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isEnabled);
const $0857219a79e13429$export$aaeade982afd98ae = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.isCheckboxSelectionEnabled);
const $0857219a79e13429$export$39d564805393871d = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    (0, $edacdbf4783600b4$export$d9423a572d5d897d),
    $0857219a79e13429$export$d87836403f03cf1c
], (isItemDisabled, isSelectionEnabled)=>isSelectionEnabled && !isItemDisabled);
const $0857219a79e13429$export$5fc1cf0daa0c076a = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $0857219a79e13429$var$selectorTreeViewSelectionState
], (selectionState)=>selectionState.selectionPropagation);





const $2972fccb2c3f7eec$var$selectorTreeViewFocusState = (state)=>state.focus;
const $2972fccb2c3f7eec$export$93dbef097e4c14d8 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    (0, $0857219a79e13429$export$ce60c82c6907c2e5),
    (0, $c6924f3766000541$export$596d44e462637830),
    (0, $edacdbf4783600b4$export$e45de148543acce3),
    (0, $edacdbf4783600b4$export$fdde3741e8a8d0d9),
    (state)=>(0, $edacdbf4783600b4$export$69bc973ba903671f)(state, null)
], (selectedItems, expandedItemsMap, itemMetaLookup, disabledItemsFocusable, orderedRootItemIds)=>{
    const firstSelectedItem = selectedItems.find((itemId)=>{
        if (!disabledItemsFocusable && (0, $05ea814879f5b194$export$98e832630d6cf989)(itemMetaLookup, itemId)) return false;
        const itemMeta = itemMetaLookup[itemId];
        return itemMeta && (itemMeta.parentId == null || expandedItemsMap.has(itemMeta.parentId));
    });
    if (firstSelectedItem != null) return firstSelectedItem;
    const firstNavigableItem = orderedRootItemIds.find((itemId)=>disabledItemsFocusable || !(0, $05ea814879f5b194$export$98e832630d6cf989)(itemMetaLookup, itemId));
    if (firstNavigableItem != null) return firstNavigableItem;
    return null;
});
const $2972fccb2c3f7eec$export$274c59d6acc8848a = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $2972fccb2c3f7eec$export$93dbef097e4c14d8,
    (_, itemId)=>itemId
], (defaultFocusableItemId, itemId)=>defaultFocusableItemId === itemId);
const $2972fccb2c3f7eec$export$6a88adceddd3d738 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($2972fccb2c3f7eec$var$selectorTreeViewFocusState, (focus)=>focus.focusedItemId);
const $2972fccb2c3f7eec$export$c0de0654c618d900 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $2972fccb2c3f7eec$export$6a88adceddd3d738,
    (_, itemId)=>itemId
], (focusedItemId, itemId)=>focusedItemId === itemId);





const $14ffb5f02b65f873$var$selectorLazyLoading = (state)=>state.lazyLoading;
const $14ffb5f02b65f873$var$selectorLazyLoadingOptional = (state)=>state.lazyLoading;
const $14ffb5f02b65f873$export$8aa917e778f5bc9f = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $14ffb5f02b65f873$var$selectorLazyLoading
], (lazyLoading)=>lazyLoading.dataSource);
const $14ffb5f02b65f873$export$d4bb54581531c659 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $14ffb5f02b65f873$var$selectorLazyLoadingOptional
], (lazyLoading)=>!!lazyLoading?.enabled);
const $14ffb5f02b65f873$export$2e5efb865209b49c = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $14ffb5f02b65f873$export$8aa917e778f5bc9f,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.loading[itemId] || false);
const $14ffb5f02b65f873$export$2702f8d0afc4c439 = (0, $15b14787c3112f90$export$595d22ed68ca2841)([
    $14ffb5f02b65f873$export$8aa917e778f5bc9f,
    (_, itemId)=>itemId
], (dataSourceState, itemId)=>dataSourceState.errors[itemId] || null);



'use client';
const $5b91946642b9e96b$export$e5b6155538ff0141 = (reactChildren)=>{
    if (Array.isArray(reactChildren)) return reactChildren.length > 0 && reactChildren.some($5b91946642b9e96b$export$e5b6155538ff0141);
    return Boolean(reactChildren);
};
const $5b91946642b9e96b$export$b02d612b309fafaa = ({ itemId: itemId, children: children })=>{
    const { instance: instance, store: store, publicAPI: publicAPI } = (0, $02716139b79a8cfc$export$8a6a3e88e8e060e0)();
    const isItemExpandable = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $c6924f3766000541$export$11d8c9cca6604d36), itemId);
    const isLazyLoadingEnabled = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $14ffb5f02b65f873$export$d4bb54581531c659));
    const isMultiSelectEnabled = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $0857219a79e13429$export$55aeefee787876c));
    const loading = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (state)=>isLazyLoadingEnabled ? (0, $14ffb5f02b65f873$export$2e5efb865209b49c)(state, itemId) : false);
    const error = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (state)=>isLazyLoadingEnabled ? Boolean((0, $14ffb5f02b65f873$export$2702f8d0afc4c439)(state, itemId)) : false);
    const isExpandable = $5b91946642b9e96b$export$e5b6155538ff0141(children) || isItemExpandable;
    const isExpanded = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $c6924f3766000541$export$a9908e37bd1dfacc), itemId);
    const isFocused = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $2972fccb2c3f7eec$export$c0de0654c618d900), itemId);
    const isSelected = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $0857219a79e13429$export$38ad7ce4f432e8cc), itemId);
    const isDisabled = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $edacdbf4783600b4$export$d9423a572d5d897d), itemId);
    const isEditing = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $4ba0d90c93ca7a0e$export$90735c1de5994ca8), itemId);
    const isEditable = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $4ba0d90c93ca7a0e$export$cad5fd68a6e551c8), itemId);
    const status = {
        expandable: isExpandable,
        expanded: isExpanded,
        focused: isFocused,
        selected: isSelected,
        disabled: isDisabled,
        editing: isEditing,
        editable: isEditable,
        loading: loading,
        error: error
    };
    const handleExpansion = (event)=>{
        if (status.disabled) return;
        if (!status.focused) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        // If already expanded and trying to toggle selection don't close
        if (status.expandable && !(multiple && (0, $c6924f3766000541$export$a9908e37bd1dfacc)(store.value, itemId))) // make sure the children selection is propagated again
        instance.setItemExpansion({
            event: event,
            itemId: itemId
        });
    };
    const handleSelection = (event)=>{
        if (status.disabled) return;
        if (!status.focused && !status.editing) instance.focusItem(event, itemId);
        const multiple = isMultiSelectEnabled && (event.shiftKey || event.ctrlKey || event.metaKey);
        if (multiple) {
            if (event.shiftKey) instance.expandSelectionRange(event, itemId);
            else instance.setItemSelection({
                event: event,
                itemId: itemId,
                keepExistingSelection: true
            });
        } else instance.setItemSelection({
            event: event,
            itemId: itemId,
            shouldBeSelected: true
        });
    };
    const handleCheckboxSelection = (event)=>{
        const hasShift = event.nativeEvent.shiftKey;
        if (isMultiSelectEnabled && hasShift) instance.expandSelectionRange(event, itemId);
        else instance.setItemSelection({
            event: event,
            itemId: itemId,
            keepExistingSelection: isMultiSelectEnabled,
            shouldBeSelected: event.target.checked
        });
    };
    const toggleItemEditing = ()=>{
        if (!(0, $de1d8dde310f079b$export$44524f2fb4958e20)(instance, (0, $84f75122f2832885$export$c6ca8ef294703a19))) return;
        if (isEditable) {
            if (isEditing) instance.setEditedItemId(null);
            else instance.setEditedItemId(itemId);
        }
    };
    const handleSaveItemLabel = (event, newLabel)=>{
        if (!(0, $de1d8dde310f079b$export$44524f2fb4958e20)(instance, (0, $84f75122f2832885$export$c6ca8ef294703a19))) return;
        // As a side effect of `instance.focusItem` called here and in `handleCancelItemLabelEditing` the `labelInput` is blurred
        // The `onBlur` event is triggered, which calls `handleSaveItemLabel` again.
        // To avoid creating an unwanted behavior we need to check if the item is being edited before calling `updateItemLabel`
        if ((0, $4ba0d90c93ca7a0e$export$90735c1de5994ca8)(store.value, itemId)) {
            instance.updateItemLabel(itemId, newLabel);
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const handleCancelItemLabelEditing = (event)=>{
        if (!(0, $de1d8dde310f079b$export$44524f2fb4958e20)(instance, (0, $84f75122f2832885$export$c6ca8ef294703a19))) return;
        if ((0, $4ba0d90c93ca7a0e$export$90735c1de5994ca8)(store.value, itemId)) {
            toggleItemEditing();
            instance.focusItem(event, itemId);
        }
    };
    const interactions = {
        handleExpansion: handleExpansion,
        handleSelection: handleSelection,
        handleCheckboxSelection: handleCheckboxSelection,
        toggleItemEditing: toggleItemEditing,
        handleSaveItemLabel: handleSaveItemLabel,
        handleCancelItemLabelEditing: handleCancelItemLabelEditing
    };
    return {
        interactions: interactions,
        status: status,
        publicAPI: publicAPI
    };
};



var $8nGP5 = parcelRequire("8nGP5");
const $122bfd25b31739e7$export$8634277a87653494 = /*#__PURE__*/ $8nGP5.createContext(()=>-1);




const $42605cb05a479d5b$var$getLastNavigableItemInArray = (state, items)=>{
    // Equivalent to Array.prototype.findLastIndex
    let itemIndex = items.length - 1;
    while(itemIndex >= 0 && !(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, items[itemIndex]))itemIndex -= 1;
    if (itemIndex === -1) return undefined;
    return items[itemIndex];
};
const $42605cb05a479d5b$export$c4f586d7c71ecf8d = (state, itemId)=>{
    const itemMeta = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemId);
    if (!itemMeta) return null;
    const siblings = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemMeta.parentId);
    const itemIndex = (0, $edacdbf4783600b4$export$882fe1a4ba86c1b4)(state, itemId);
    // TODO: What should we do if the parent is not navigable?
    if (itemIndex === 0) return itemMeta.parentId;
    // Finds the previous navigable sibling.
    let previousNavigableSiblingIndex = itemIndex - 1;
    while(!(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, siblings[previousNavigableSiblingIndex]) && previousNavigableSiblingIndex >= 0)previousNavigableSiblingIndex -= 1;
    if (previousNavigableSiblingIndex === -1) {
        // If we are at depth 0, then it means all the items above the current item are not navigable.
        if (itemMeta.parentId == null) return null;
        // Otherwise, we can try to go up a level and find the previous navigable item.
        return $42605cb05a479d5b$export$c4f586d7c71ecf8d(state, itemMeta.parentId);
    }
    // Finds the last navigable ancestor of the previous navigable sibling.
    let currentItemId = siblings[previousNavigableSiblingIndex];
    let lastNavigableChild = $42605cb05a479d5b$var$getLastNavigableItemInArray(state, (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, currentItemId));
    while((0, $c6924f3766000541$export$a9908e37bd1dfacc)(state, currentItemId) && lastNavigableChild != null){
        currentItemId = lastNavigableChild;
        lastNavigableChild = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, currentItemId).find((childId)=>(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, childId));
    }
    return currentItemId;
};
const $42605cb05a479d5b$export$b7da0064a5fd3c3b = (state, itemId)=>{
    // If the item is expanded and has some navigable children, return the first of them.
    if ((0, $c6924f3766000541$export$a9908e37bd1dfacc)(state, itemId)) {
        const firstNavigableChild = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemId).find((childId)=>(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, childId));
        if (firstNavigableChild != null) return firstNavigableChild;
    }
    let itemMeta = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemId);
    while(itemMeta != null){
        // Try to find the first navigable sibling after the current item.
        const siblings = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemMeta.parentId);
        const currentItemIndex = (0, $edacdbf4783600b4$export$882fe1a4ba86c1b4)(state, itemMeta.id);
        if (currentItemIndex < siblings.length - 1) {
            let nextItemIndex = currentItemIndex + 1;
            while(!(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, siblings[nextItemIndex]) && nextItemIndex < siblings.length - 1)nextItemIndex += 1;
            if ((0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, siblings[nextItemIndex])) return siblings[nextItemIndex];
        }
        // If the sibling does not exist, go up a level to the parent and try again.
        itemMeta = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemMeta.parentId);
    }
    return null;
};
const $42605cb05a479d5b$export$337064ce7a54bd6a = (state)=>{
    let itemId = null;
    while(itemId == null || (0, $c6924f3766000541$export$a9908e37bd1dfacc)(state, itemId)){
        const children = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemId);
        const lastNavigableChild = $42605cb05a479d5b$var$getLastNavigableItemInArray(state, children);
        // The item has no navigable children.
        if (lastNavigableChild == null) return itemId;
        itemId = lastNavigableChild;
    }
    return itemId;
};
const $42605cb05a479d5b$export$2ca561ddc1785264 = (state)=>(0, $edacdbf4783600b4$export$69bc973ba903671f)(state, null).find((itemId)=>(0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(state, itemId));
const $42605cb05a479d5b$export$17d19e2e752066c5 = (state, itemAId, itemBId)=>{
    if (itemAId === itemBId) return [
        itemAId,
        itemBId
    ];
    const itemMetaA = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemAId);
    const itemMetaB = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemBId);
    if (!itemMetaA || !itemMetaB) return [
        itemAId,
        itemBId
    ];
    if (itemMetaA.parentId === itemMetaB.id || itemMetaB.parentId === itemMetaA.id) return itemMetaB.parentId === itemMetaA.id ? [
        itemMetaA.id,
        itemMetaB.id
    ] : [
        itemMetaB.id,
        itemMetaA.id
    ];
    const aFamily = [
        itemMetaA.id
    ];
    const bFamily = [
        itemMetaB.id
    ];
    let aAncestor = itemMetaA.parentId;
    let bAncestor = itemMetaB.parentId;
    let aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
    let bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
    let continueA = true;
    let continueB = true;
    while(!bAncestorIsCommon && !aAncestorIsCommon){
        if (continueA) {
            aFamily.push(aAncestor);
            aAncestorIsCommon = bFamily.indexOf(aAncestor) !== -1;
            continueA = aAncestor !== null;
            if (!aAncestorIsCommon && continueA) aAncestor = (0, $edacdbf4783600b4$export$c906a77b96e11840)(state, aAncestor);
        }
        if (continueB && !aAncestorIsCommon) {
            bFamily.push(bAncestor);
            bAncestorIsCommon = aFamily.indexOf(bAncestor) !== -1;
            continueB = bAncestor !== null;
            if (!bAncestorIsCommon && continueB) bAncestor = (0, $edacdbf4783600b4$export$c906a77b96e11840)(state, bAncestor);
        }
    }
    const commonAncestor = aAncestorIsCommon ? aAncestor : bAncestor;
    const ancestorFamily = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, commonAncestor);
    const aSide = aFamily[aFamily.indexOf(commonAncestor) - 1];
    const bSide = bFamily[bFamily.indexOf(commonAncestor) - 1];
    return ancestorFamily.indexOf(aSide) < ancestorFamily.indexOf(bSide) ? [
        itemAId,
        itemBId
    ] : [
        itemBId,
        itemAId
    ];
};
const $42605cb05a479d5b$export$4ce67059a83227bb = (state, itemAId, itemBId)=>{
    const getNextItem = (itemId)=>{
        // If the item is expanded and has some children, return the first of them.
        if ((0, $c6924f3766000541$export$11d8c9cca6604d36)(state, itemId) && (0, $c6924f3766000541$export$a9908e37bd1dfacc)(state, itemId)) return (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemId)[0];
        let itemMeta = (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemId);
        while(itemMeta != null){
            // Try to find the first navigable sibling after the current item.
            const siblings = (0, $edacdbf4783600b4$export$69bc973ba903671f)(state, itemMeta.parentId);
            const currentItemIndex = (0, $edacdbf4783600b4$export$882fe1a4ba86c1b4)(state, itemMeta.id);
            if (currentItemIndex < siblings.length - 1) return siblings[currentItemIndex + 1];
            // If the item is the last of its siblings, go up a level to the parent and try again.
            itemMeta = itemMeta.parentId ? (0, $edacdbf4783600b4$export$f990f915c7ea2f8f)(state, itemMeta.parentId) : null;
        }
        throw new Error('Invalid range');
    };
    const [first, last] = $42605cb05a479d5b$export$17d19e2e752066c5(state, itemAId, itemBId);
    const items = [
        first
    ];
    let current = first;
    while(current !== last){
        current = getNextItem(current);
        if (!(0, $edacdbf4783600b4$export$d9423a572d5d897d)(state, current)) items.push(current);
    }
    return items;
};
const $42605cb05a479d5b$export$136dabd28b10f053 = (state)=>{
    let item = $42605cb05a479d5b$export$2ca561ddc1785264(state);
    const navigableItems = [];
    while(item != null){
        navigableItems.push(item);
        item = $42605cb05a479d5b$export$b7da0064a5fd3c3b(state, item);
    }
    return navigableItems;
};
const $42605cb05a479d5b$export$10ed5614bef54e9f = (target, itemRoot)=>{
    return itemRoot !== target.closest('*[role="treeitem"]');
};




let $28bd5cf04b221f76$var$globalTreeViewDefaultId = 0;
const $28bd5cf04b221f76$export$3a9d81458df729ff = ()=>{
    $28bd5cf04b221f76$var$globalTreeViewDefaultId += 1;
    return `mui-tree-view-${$28bd5cf04b221f76$var$globalTreeViewDefaultId}`;
};
const $28bd5cf04b221f76$export$6ce5f925ac04fad = ({ id: id, treeId: treeId = '', itemId: itemId })=>{
    if (id != null) return id;
    return `${treeId}-${itemId}`;
};




const $95b7543587ba4198$var$selectorTreeViewIdState = (state)=>state.id;
const $95b7543587ba4198$export$bc039a4223921187 = (0, $15b14787c3112f90$export$595d22ed68ca2841)($95b7543587ba4198$var$selectorTreeViewIdState, (idState)=>idState.treeId);




'use client';
const $0f569bc0dd721301$export$e4bcc4675b2b123a = (parameters)=>{
    const { runItemPlugins: runItemPlugins, instance: instance, publicAPI: publicAPI, store: store } = (0, $02716139b79a8cfc$export$8a6a3e88e8e060e0)();
    const depthContext = $8nGP5.useContext((0, $122bfd25b31739e7$export$8634277a87653494));
    const depth = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (...params)=>{
        if (typeof depthContext === 'function') return depthContext(...params);
        return depthContext;
    }, parameters.itemId);
    const { id: id, itemId: itemId, label: label, children: children, rootRef: rootRef } = parameters;
    const { rootRef: pluginRootRef, contentRef: contentRef, propsEnhancers: propsEnhancers } = runItemPlugins(parameters);
    const { interactions: interactions, status: status } = (0, $5b91946642b9e96b$export$b02d612b309fafaa)({
        itemId: itemId,
        children: children
    });
    const rootRefObject = $8nGP5.useRef(null);
    const contentRefObject = $8nGP5.useRef(null);
    const handleRootRef = (0, (/*@__PURE__*/$parcel$interopDefault($7uWLa)))(rootRef, pluginRootRef, rootRefObject);
    const handleContentRef = (0, (/*@__PURE__*/$parcel$interopDefault($7uWLa)))(contentRef, contentRefObject);
    const checkboxRef = $8nGP5.useRef(null);
    const treeId = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $95b7543587ba4198$export$bc039a4223921187));
    const isSelectionEnabledForItem = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $0857219a79e13429$export$39d564805393871d), itemId);
    const isCheckboxSelectionEnabled = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $0857219a79e13429$export$aaeade982afd98ae));
    const idAttribute = (0, $28bd5cf04b221f76$export$6ce5f925ac04fad)({
        itemId: itemId,
        treeId: treeId,
        id: id
    });
    const shouldBeAccessibleWithTab = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $2972fccb2c3f7eec$export$274c59d6acc8848a), itemId);
    const sharedPropsEnhancerParams = {
        rootRefObject: rootRefObject,
        contentRefObject: contentRefObject,
        interactions: interactions
    };
    const createRootHandleFocus = (otherHandlers)=>(event)=>{
            otherHandlers.onFocus?.(event);
            if (event.defaultMuiPrevented) return;
            if (!status.focused && (0, $edacdbf4783600b4$export$1f5eb544d48e74e6)(store.value, itemId) && event.currentTarget === event.target) instance.focusItem(event, itemId);
        };
    const createRootHandleBlur = (otherHandlers)=>(event)=>{
            otherHandlers.onBlur?.(event);
            if (event.defaultMuiPrevented) return;
            const rootElement = instance.getItemDOMElement(itemId);
            // Don't blur the root when switching to editing mode
            // the input that triggers the root blur can be either the relatedTarget (when entering editing state) or the target (when exiting editing state)
            // when we enter the editing state, we focus the input -> we don't want to remove the focused item from the state
            if (status.editing || // we can exit the editing state by clicking outside the input (within the Tree Item) or by pressing Enter or Escape -> we don't want to remove the focused item from the state in these cases
            // we can also exit the editing state by clicking on the root itself -> want to remove the focused item from the state in this case
            event.relatedTarget && (0, $42605cb05a479d5b$export$10ed5614bef54e9f)(event.relatedTarget, rootElement) && (event.target && event.target?.dataset?.element === 'labelInput' && (0, $42605cb05a479d5b$export$10ed5614bef54e9f)(event.target, rootElement) || event.relatedTarget?.dataset?.element === 'labelInput')) return;
            instance.removeFocusedItem();
        };
    const createRootHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            if (event.defaultMuiPrevented || event.target?.dataset?.element === 'labelInput') return;
            instance.handleItemKeyDown(event, itemId);
        };
    const createLabelHandleDoubleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onDoubleClick?.(event);
            if (event.defaultMuiPrevented) return;
            interactions.toggleItemEditing();
        };
    const createContentHandleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            instance.handleItemClick(event, itemId);
            if (event.defaultMuiPrevented || checkboxRef.current?.contains(event.target)) return;
            if ((0, $c6924f3766000541$export$298875142e252c82)(store.value) === 'content') interactions.handleExpansion(event);
            if (!isCheckboxSelectionEnabled) interactions.handleSelection(event);
        };
    const createContentHandleMouseDown = (otherHandlers)=>(event)=>{
            otherHandlers.onMouseDown?.(event);
            if (event.defaultMuiPrevented) return;
            // Prevent text selection
            if (event.shiftKey || event.ctrlKey || event.metaKey || status.disabled) event.preventDefault();
        };
    const createIconContainerHandleClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.defaultMuiPrevented) return;
            if ((0, $c6924f3766000541$export$298875142e252c82)(store.value) === 'iconContainer') interactions.handleExpansion(event);
        };
    const getContextProviderProps = ()=>({
            itemId: itemId,
            id: id
        });
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $1TGTA.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(parameters), (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps));
        // https://www.w3.org/WAI/ARIA/apg/patterns/treeview/
        let ariaSelected;
        if (status.selected) // - each selected node has aria-selected set to true.
        ariaSelected = true;
        else if (!isSelectionEnabledForItem) // - if the tree contains nodes that are not selectable, aria-selected is not present on those nodes.
        ariaSelected = undefined;
        else // - all nodes that are selectable but not selected have aria-selected set to false.
        ariaSelected = false;
        const props = (0, $1TGTA.default)({}, externalEventHandlers, {
            ref: handleRootRef,
            role: 'treeitem',
            tabIndex: shouldBeAccessibleWithTab ? 0 : -1,
            id: idAttribute,
            'aria-expanded': status.expandable ? status.expanded : undefined,
            'aria-selected': ariaSelected,
            'aria-disabled': status.disabled || undefined
        }, externalProps, {
            style: (0, $1TGTA.default)({}, externalProps.style ?? {}, {
                '--TreeView-itemDepth': depth
            }),
            onFocus: createRootHandleFocus(externalEventHandlers),
            onBlur: createRootHandleBlur(externalEventHandlers),
            onKeyDown: createRootHandleKeyDown(externalEventHandlers)
        });
        const enhancedRootProps = propsEnhancers.root?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, props, enhancedRootProps);
    };
    const getContentProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        const props = (0, $1TGTA.default)({}, externalEventHandlers, externalProps, {
            ref: handleContentRef,
            onClick: createContentHandleClick(externalEventHandlers),
            onMouseDown: createContentHandleMouseDown(externalEventHandlers),
            status: status
        });
        [
            'expanded',
            'selected',
            'focused',
            'disabled',
            'editing',
            'editable'
        ].forEach((key)=>{
            if (status[key]) props[`data-${key}`] = '';
        });
        const enhancedContentProps = propsEnhancers.content?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, props, enhancedContentProps);
    };
    const getCheckboxProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        const props = (0, $1TGTA.default)({}, externalEventHandlers, {
            ref: checkboxRef
        }, externalProps);
        const enhancedCheckboxProps = propsEnhancers.checkbox?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, props, enhancedCheckboxProps);
    };
    const getLabelProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $1TGTA.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps));
        const props = (0, $1TGTA.default)({}, externalEventHandlers, {
            children: label
        }, externalProps, {
            onDoubleClick: createLabelHandleDoubleClick(externalEventHandlers)
        });
        const enhancedLabelProps = propsEnhancers.label?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, enhancedLabelProps, props);
    };
    const getLabelInputProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        const enhancedLabelInputProps = propsEnhancers.labelInput?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, externalProps, enhancedLabelInputProps);
    };
    const getIconContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        return (0, $1TGTA.default)({}, externalEventHandlers, externalProps, {
            onClick: createIconContainerHandleClick(externalEventHandlers)
        });
    };
    const getErrorContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        return (0, $1TGTA.default)({}, externalEventHandlers, externalProps);
    };
    const getLoadingContainerProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        return (0, $1TGTA.default)({
            size: '12px',
            thickness: 6
        }, externalEventHandlers, externalProps);
    };
    const getGroupTransitionProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        const response = (0, $1TGTA.default)({}, externalEventHandlers, {
            unmountOnExit: true,
            component: 'ul',
            role: 'group',
            in: status.expanded,
            children: children
        }, externalProps);
        return response;
    };
    const getDragAndDropOverlayProps = (externalProps = {})=>{
        const externalEventHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($9ds9N)))(externalProps);
        const enhancedDragAndDropOverlayProps = propsEnhancers.dragAndDropOverlay?.((0, $1TGTA.default)({}, sharedPropsEnhancerParams, {
            externalEventHandlers: externalEventHandlers
        })) ?? {};
        return (0, $1TGTA.default)({}, externalProps, enhancedDragAndDropOverlayProps);
    };
    return {
        getContextProviderProps: getContextProviderProps,
        getRootProps: getRootProps,
        getContentProps: getContentProps,
        getGroupTransitionProps: getGroupTransitionProps,
        getIconContainerProps: getIconContainerProps,
        getCheckboxProps: getCheckboxProps,
        getLabelProps: getLabelProps,
        getLabelInputProps: getLabelInputProps,
        getDragAndDropOverlayProps: getDragAndDropOverlayProps,
        getErrorContainerProps: getErrorContainerProps,
        getLoadingContainerProps: getLoadingContainerProps,
        rootRef: handleRootRef,
        status: status,
        publicAPI: publicAPI
    };
};



var $4E9MM = parcelRequire("4E9MM");

var $4bI4C = parcelRequire("4bI4C");
function $8f55f1baef7d16e7$export$e06936b9af6d8f5b(slot) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4E9MM)))('MuiTreeItem', slot);
}
const $8f55f1baef7d16e7$export$1970fed62f74ee8d = (0, (/*@__PURE__*/$parcel$interopDefault($4bI4C)))('MuiTreeItem', [
    'root',
    'content',
    'groupTransition',
    'iconContainer',
    'label',
    'checkbox',
    'labelInput',
    'dragAndDropOverlay',
    'errorIcon',
    'loadingIcon',
    // State classes, will be replaced by data-attrs in the next major
    'expanded',
    'selected',
    'focused',
    'disabled',
    'editable',
    'editing'
]);



var $1TGTA = parcelRequire("1TGTA");
parcelRequire("8nGP5");


var $iselN = parcelRequire("iselN");

var $k3QMn = parcelRequire("k3QMn");

var $8nGP5 = parcelRequire("8nGP5");
const $0ba646ecef828252$export$f34f82a67dfb6224 = /*#__PURE__*/ $8nGP5.createContext({
    classes: {},
    slots: {},
    slotProps: {}
});
const $0ba646ecef828252$export$c33a567d15d66283 = ()=>{
    return $8nGP5.useContext($0ba646ecef828252$export$f34f82a67dfb6224);
};



var $ftvpK = parcelRequire("ftvpK");
parcelRequire("8nGP5");

var $kSbwP = parcelRequire("kSbwP");
const $30fa6eeccc6376f4$export$6ea1314a242e98ca = (0, $ftvpK.createSvgIcon)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'TreeViewExpandIcon');
const $30fa6eeccc6376f4$export$679a3c8913aa44c9 = (0, $ftvpK.createSvgIcon)(/*#__PURE__*/ (0, $kSbwP.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'TreeViewCollapseIcon');



var $kSbwP = parcelRequire("kSbwP");
'use client';
function $0198e2daa78daed9$export$9b739c556195473d(props) {
    const { slots: slotsFromTreeItem, slotProps: slotPropsFromTreeItem, status: status } = props;
    const { slots: slotsFromTreeView, slotProps: slotPropsFromTreeView } = (0, $0ba646ecef828252$export$c33a567d15d66283)();
    const slots = {
        collapseIcon: slotsFromTreeItem?.collapseIcon ?? slotsFromTreeView.collapseIcon ?? (0, $30fa6eeccc6376f4$export$679a3c8913aa44c9),
        expandIcon: slotsFromTreeItem?.expandIcon ?? slotsFromTreeView.expandIcon ?? (0, $30fa6eeccc6376f4$export$6ea1314a242e98ca),
        endIcon: slotsFromTreeItem?.endIcon ?? slotsFromTreeView.endIcon,
        icon: slotsFromTreeItem?.icon
    };
    let iconName;
    if (slots?.icon) iconName = 'icon';
    else if (status.expandable) {
        if (status.expanded) iconName = 'collapseIcon';
        else iconName = 'expandIcon';
    } else iconName = 'endIcon';
    const Icon = slots[iconName];
    const iconProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: Icon,
        externalSlotProps: (tempOwnerState)=>(0, $1TGTA.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($iselN)))(slotPropsFromTreeView[iconName], tempOwnerState), (0, (/*@__PURE__*/$parcel$interopDefault($iselN)))(slotPropsFromTreeItem?.[iconName], tempOwnerState)),
        // TODO: Add proper ownerState
        ownerState: {}
    });
    if (!Icon) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)(Icon, (0, $1TGTA.default)({}, iconProps));
}



var $1TGTA = parcelRequire("1TGTA");
parcelRequire("8nGP5");


var $6NVMl = parcelRequire("6NVMl");

var $cx8dF = parcelRequire("cx8dF");

var $6NVMl = parcelRequire("6NVMl");

var $kSbwP = parcelRequire("kSbwP");
'use client';
const $8217255119cc7ea1$var$TreeItemDragAndDropOverlayRoot = (0, $6NVMl.styled)('div', {
    name: 'MuiTreeItemDragAndDropOverlay',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $cx8dF.shouldForwardProp)(prop) && prop !== 'action'
})(({ theme: theme })=>({
        position: 'absolute',
        left: 0,
        display: 'flex',
        top: 0,
        bottom: 0,
        right: 0,
        pointerEvents: 'none',
        variants: [
            {
                props: {
                    action: 'make-child'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderRadius: theme.shape.borderRadius,
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.darkChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $6NVMl.alpha)(theme.palette.primary.dark, theme.palette.action.focusOpacity)
                }
            },
            {
                props: {
                    action: 'reorder-above'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderTop: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'reorder-below'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * var(--TreeView-itemDepth))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            },
            {
                props: {
                    action: 'move-to-parent'
                },
                style: {
                    marginLeft: 'calc(var(--TreeView-indentMultiplier) * calc(var(--TreeView-itemDepth) - 1))',
                    borderBottom: `1px solid ${(theme.vars || theme).palette.action.active}`
                }
            }
        ]
    }));
function $8217255119cc7ea1$export$24c32697a958f8fd(props) {
    if (props.action == null) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)($8217255119cc7ea1$var$TreeItemDragAndDropOverlayRoot, (0, $1TGTA.default)({}, props));
}



var $8nGP5 = parcelRequire("8nGP5");






var $kSbwP = parcelRequire("kSbwP");
'use client';
function $e8b04586ec4942e0$export$b151f5a5928ddbe0(props) {
    const { children: children, itemId: itemId, id: id } = props;
    const { wrapItem: wrapItem, instance: instance, store: store } = (0, $02716139b79a8cfc$export$8a6a3e88e8e060e0)();
    const treeId = (0, $23ddd3c612abbb90$export$2105062e25df4afe)(store, (0, $95b7543587ba4198$export$bc039a4223921187));
    const idAttribute = (0, $28bd5cf04b221f76$export$6ce5f925ac04fad)({
        itemId: itemId,
        treeId: treeId,
        id: id
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)($8nGP5.Fragment, {
        children: wrapItem({
            children: children,
            itemId: itemId,
            instance: instance,
            idAttribute: idAttribute
        })
    });
}



var $1TGTA = parcelRequire("1TGTA");

var $6NVMl = parcelRequire("6NVMl");
/**
 * @ignore - internal component.
 */ const $4a9ef7057429d014$export$94587e9220975c7b = (0, $6NVMl.styled)('input', {
    name: 'MuiTreeItem',
    slot: 'LabelInput',
    overridesResolver: (props, styles)=>styles.labelInput
})(({ theme: theme })=>(0, $1TGTA.default)({}, theme.typography.body1, {
        width: '100%',
        backgroundColor: (theme.vars || theme).palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        border: 'none',
        padding: '0 2px',
        boxSizing: 'border-box',
        '&:focus': {
            outline: `1px solid ${(theme.vars || theme).palette.primary.main}`
        }
    }));




var $kSbwP = parcelRequire("kSbwP");
'use client';
const $225dbc5b8fcc6b42$var$_excluded = [
    "visible"
], $225dbc5b8fcc6b42$var$_excluded2 = [
    "id",
    "itemId",
    "label",
    "disabled",
    "children",
    "slots",
    "slotProps",
    "classes"
];
const $225dbc5b8fcc6b42$var$useThemeProps = (0, $a1617ee7cca6f994$export$ff8356348e0cc878)('MuiTreeItem');
const $225dbc5b8fcc6b42$export$ff0c1ba365ff0d4d = (0, $6NVMl.styled)('li', {
    name: 'MuiTreeItem',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    outline: 0
});
const $225dbc5b8fcc6b42$export$4b687e3f663d618c = (0, $6NVMl.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content,
    shouldForwardProp: (prop)=>(0, $cx8dF.shouldForwardProp)(prop) && prop !== 'status'
})(({ theme: theme })=>({
        padding: theme.spacing(0.5, 1),
        paddingLeft: `calc(${theme.spacing(1)} + var(--TreeView-itemChildrenIndentation) * var(--TreeView-itemDepth))`,
        borderRadius: theme.shape.borderRadius,
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        '&[data-disabled]': {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            backgroundColor: 'transparent'
        },
        '&[data-focused]': {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        '&[data-selected]': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6NVMl.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $6NVMl.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $6NVMl.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
                }
            }
        },
        '&[data-selected][data-focused]': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $6NVMl.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }));
const $225dbc5b8fcc6b42$export$ad138cc8bd84b5f9 = (0, $6NVMl.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label,
    shouldForwardProp: (prop)=>(0, $cx8dF.shouldForwardProp)(prop) && prop !== 'editable'
})(({ theme: theme })=>(0, $1TGTA.default)({
        width: '100%',
        boxSizing: 'border-box',
        // prevent width + padding to overflow
        // fixes overflow - see https://github.com/mui/material-ui/issues/27372
        minWidth: 0,
        position: 'relative',
        overflow: 'hidden'
    }, theme.typography.body1, {
        variants: [
            {
                props: ({ editable: editable })=>editable,
                style: {
                    paddingLeft: '2px'
                }
            }
        ]
    }));
const $225dbc5b8fcc6b42$export$cde71d23f8d44a01 = (0, $6NVMl.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})({
    width: 16,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    position: 'relative',
    '& svg': {
        fontSize: 18
    }
});
const $225dbc5b8fcc6b42$export$5fa90977550fe20d = (0, $6NVMl.styled)((0, (/*@__PURE__*/$parcel$interopDefault($124d1943ba55dde5$exports))), {
    name: 'MuiTreeItem',
    slot: 'GroupTransition',
    overridesResolver: (props, styles)=>styles.groupTransition
})({
    margin: 0,
    padding: 0
});
const $225dbc5b8fcc6b42$export$67e00cbcb2f331e = (0, $6NVMl.styled)('div', {
    name: 'MuiTreeItem',
    slot: 'ErrorIcon',
    overridesResolver: (props, styles)=>styles.errorIcon
})({
    position: 'absolute',
    right: -3,
    width: 7,
    height: 7,
    borderRadius: '50%',
    backgroundColor: 'red'
});
const $225dbc5b8fcc6b42$export$c4148ae2aef8d663 = (0, $6NVMl.styled)((0, (/*@__PURE__*/$parcel$interopDefault($303b495ab50d9d04$exports))), {
    name: 'MuiTreeItem',
    slot: 'LoadingIcon',
    overridesResolver: (props, styles)=>styles.loadingIcon
})({
    color: 'text.primary'
});
const $225dbc5b8fcc6b42$export$32d458b04e8dd681 = (0, $6NVMl.styled)(/*#__PURE__*/ $8nGP5.forwardRef((props, ref)=>{
    const { visible: visible } = props, other = (0, $8D9Xw.default)(props, $225dbc5b8fcc6b42$var$_excluded);
    if (!visible) return null;
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4dc8eefaf7e838ef$exports))), (0, $1TGTA.default)({}, other, {
        ref: ref
    }));
}), {
    name: 'MuiTreeItem',
    slot: 'Checkbox',
    overridesResolver: (props, styles)=>styles.checkbox
})({
    padding: 0
});
const $225dbc5b8fcc6b42$var$useUtilityClasses = (classesProp)=>{
    const { classes: classesFromTreeView } = (0, $0ba646ecef828252$export$c33a567d15d66283)();
    const classes = (0, $1TGTA.default)({}, classesProp, {
        root: (0, $ajIhI.default)(classesProp?.root, classesFromTreeView.root),
        content: (0, $ajIhI.default)(classesProp?.content, classesFromTreeView.itemContent),
        iconContainer: (0, $ajIhI.default)(classesProp?.iconContainer, classesFromTreeView.itemIconContainer),
        checkbox: (0, $ajIhI.default)(classesProp?.checkbox, classesFromTreeView.itemCheckbox),
        label: (0, $ajIhI.default)(classesProp?.label, classesFromTreeView.itemLabel),
        groupTransition: (0, $ajIhI.default)(classesProp?.groupTransition, classesFromTreeView.itemGroupTransition),
        labelInput: (0, $ajIhI.default)(classesProp?.labelInput, classesFromTreeView.itemLabelInput),
        dragAndDropOverlay: (0, $ajIhI.default)(classesProp?.dragAndDropOverlay, classesFromTreeView.itemDragAndDropOverlay),
        errorIcon: (0, $ajIhI.default)(classesProp?.errorIcon, classesFromTreeView.itemErrorIcon),
        loadingIcon: (0, $ajIhI.default)(classesProp?.loadingIcon, classesFromTreeView.itemLoadingIcon)
    });
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        iconContainer: [
            'iconContainer'
        ],
        checkbox: [
            'checkbox'
        ],
        label: [
            'label'
        ],
        groupTransition: [
            'groupTransition'
        ],
        labelInput: [
            'labelInput'
        ],
        dragAndDropOverlay: [
            'dragAndDropOverlay'
        ],
        errorIcon: [
            'errorIcon'
        ],
        loadingIcon: [
            'loadingIcon'
        ],
        expanded: [
            'expanded'
        ],
        editing: [
            'editing'
        ],
        editable: [
            'editable'
        ],
        selected: [
            'selected'
        ],
        focused: [
            'focused'
        ],
        disabled: [
            'disabled'
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($4F19u)))(slots, (0, $8f55f1baef7d16e7$export$e06936b9af6d8f5b), classes);
};
const $225dbc5b8fcc6b42$export$53d36ab85dc89436 = /*#__PURE__*/ $8nGP5.forwardRef(function TreeItem(inProps, forwardedRef) {
    const props = $225dbc5b8fcc6b42$var$useThemeProps({
        props: inProps,
        name: 'MuiTreeItem'
    });
    const { id: id, itemId: itemId, label: label, disabled: disabled, children: children, slots: slots = {}, slotProps: slotProps = {}, classes: classesProp } = props, other = (0, $8D9Xw.default)(props, $225dbc5b8fcc6b42$var$_excluded2);
    const { getContextProviderProps: getContextProviderProps, getRootProps: getRootProps, getContentProps: getContentProps, getIconContainerProps: getIconContainerProps, getCheckboxProps: getCheckboxProps, getLabelProps: getLabelProps, getGroupTransitionProps: getGroupTransitionProps, getLabelInputProps: getLabelInputProps, getDragAndDropOverlayProps: getDragAndDropOverlayProps, getErrorContainerProps: getErrorContainerProps, getLoadingContainerProps: getLoadingContainerProps, status: status } = (0, $0f569bc0dd721301$export$e4bcc4675b2b123a)({
        id: id,
        itemId: itemId,
        children: children,
        label: label,
        disabled: disabled
    });
    const classes = $225dbc5b8fcc6b42$var$useUtilityClasses(classesProp);
    const Root = slots.root ?? $225dbc5b8fcc6b42$export$ff0c1ba365ff0d4d;
    const rootProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: Root,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        externalSlotProps: slotProps.root,
        additionalProps: {
            ref: forwardedRef
        },
        ownerState: {},
        className: classes.root
    });
    const Content = slots.content ?? $225dbc5b8fcc6b42$export$4b687e3f663d618c;
    const contentProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: Content,
        getSlotProps: getContentProps,
        externalSlotProps: slotProps.content,
        ownerState: {},
        className: (0, $ajIhI.default)(classes.content, status.expanded && classes.expanded, status.selected && classes.selected, status.focused && classes.focused, status.disabled && classes.disabled, status.editing && classes.editing, status.editable && classes.editable)
    });
    const IconContainer = slots.iconContainer ?? $225dbc5b8fcc6b42$export$cde71d23f8d44a01;
    const iconContainerProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: IconContainer,
        getSlotProps: getIconContainerProps,
        externalSlotProps: slotProps.iconContainer,
        ownerState: {},
        className: classes.iconContainer
    });
    const Label = slots.label ?? $225dbc5b8fcc6b42$export$ad138cc8bd84b5f9;
    const labelProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: Label,
        getSlotProps: getLabelProps,
        externalSlotProps: slotProps.label,
        ownerState: {},
        className: classes.label
    });
    const Checkbox = slots.checkbox ?? $225dbc5b8fcc6b42$export$32d458b04e8dd681;
    const checkboxProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: Checkbox,
        getSlotProps: getCheckboxProps,
        externalSlotProps: slotProps.checkbox,
        ownerState: {},
        className: classes.checkbox
    });
    const GroupTransition = slots.groupTransition ?? undefined;
    const groupTransitionProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: GroupTransition,
        getSlotProps: getGroupTransitionProps,
        externalSlotProps: slotProps.groupTransition,
        ownerState: {},
        className: classes.groupTransition
    });
    const LabelInput = slots.labelInput ?? (0, $4a9ef7057429d014$export$94587e9220975c7b);
    const labelInputProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: LabelInput,
        getSlotProps: getLabelInputProps,
        externalSlotProps: slotProps.labelInput,
        ownerState: {},
        className: classes.labelInput
    });
    const DragAndDropOverlay = slots.dragAndDropOverlay ?? (0, $8217255119cc7ea1$export$24c32697a958f8fd);
    const dragAndDropOverlayProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: DragAndDropOverlay,
        getSlotProps: getDragAndDropOverlayProps,
        externalSlotProps: slotProps.dragAndDropOverlay,
        ownerState: {},
        className: classes.dragAndDropOverlay
    });
    const ErrorIcon = slots.errorIcon ?? $225dbc5b8fcc6b42$export$67e00cbcb2f331e;
    const errorContainerProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: ErrorIcon,
        getSlotProps: getErrorContainerProps,
        externalSlotProps: slotProps.errorIcon,
        ownerState: {},
        className: classes.errorIcon
    });
    const LoadingIcon = slots.loadingIcon ?? $225dbc5b8fcc6b42$export$c4148ae2aef8d663;
    const loadingContainerProps = (0, (/*@__PURE__*/$parcel$interopDefault($k3QMn)))({
        elementType: LoadingIcon,
        getSlotProps: getLoadingContainerProps,
        externalSlotProps: slotProps.loadingIcon,
        ownerState: {},
        className: classes.loadingIcon
    });
    return /*#__PURE__*/ (0, $kSbwP.jsx)((0, $e8b04586ec4942e0$export$b151f5a5928ddbe0), (0, $1TGTA.default)({}, getContextProviderProps(), {
        children: /*#__PURE__*/ (0, $kSbwP.jsxs)(Root, (0, $1TGTA.default)({}, rootProps, {
            children: [
                /*#__PURE__*/ (0, $kSbwP.jsxs)(Content, (0, $1TGTA.default)({}, contentProps, {
                    children: [
                        /*#__PURE__*/ (0, $kSbwP.jsxs)(IconContainer, (0, $1TGTA.default)({}, iconContainerProps, {
                            children: [
                                status.error && /*#__PURE__*/ (0, $kSbwP.jsx)(ErrorIcon, (0, $1TGTA.default)({}, errorContainerProps)),
                                status.loading ? /*#__PURE__*/ (0, $kSbwP.jsx)(LoadingIcon, (0, $1TGTA.default)({}, loadingContainerProps)) : /*#__PURE__*/ (0, $kSbwP.jsx)((0, $0198e2daa78daed9$export$9b739c556195473d), {
                                    status: status,
                                    slots: slots,
                                    slotProps: slotProps
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0, $kSbwP.jsx)(Checkbox, (0, $1TGTA.default)({}, checkboxProps)),
                        status.editing ? /*#__PURE__*/ (0, $kSbwP.jsx)(LabelInput, (0, $1TGTA.default)({}, labelInputProps)) : /*#__PURE__*/ (0, $kSbwP.jsx)(Label, (0, $1TGTA.default)({}, labelProps)),
                        /*#__PURE__*/ (0, $kSbwP.jsx)(DragAndDropOverlay, (0, $1TGTA.default)({}, dragAndDropOverlayProps))
                    ]
                })),
                children && /*#__PURE__*/ (0, $kSbwP.jsx)($225dbc5b8fcc6b42$export$5fa90977550fe20d, (0, $1TGTA.default)({
                    as: GroupTransition
                }, groupTransitionProps))
            ]
        }))
    }));
});


var $9fef8b6c6e12ae2f$exports = {};
"use strict";

var $1RopH = parcelRequire("1RopH");
var $9fef8b6c6e12ae2f$require$_interopRequireWildcard = $1RopH.default;

var $1yHiF = parcelRequire("1yHiF");
var $9fef8b6c6e12ae2f$require$_interopRequireDefault = $1yHiF.default;
Object.defineProperty($9fef8b6c6e12ae2f$exports, "__esModule", {
    value: true
});
var $9fef8b6c6e12ae2f$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty($9fef8b6c6e12ae2f$exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $9fef8b6c6e12ae2f$var$_boxClasses.default;
    }
});
Object.defineProperty($9fef8b6c6e12ae2f$exports, "default", {
    enumerable: true,
    get: function() {
        return $9fef8b6c6e12ae2f$var$_Box.default;
    }
});

var $9fef8b6c6e12ae2f$var$_Box = $9fef8b6c6e12ae2f$require$_interopRequireDefault((parcelRequire("akQDf")));

var $9fef8b6c6e12ae2f$var$_boxClasses = $9fef8b6c6e12ae2f$require$_interopRequireWildcard((parcelRequire("6RvMV")));
Object.keys($9fef8b6c6e12ae2f$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9fef8b6c6e12ae2f$var$_exportNames, key)) return;
    if (key in $9fef8b6c6e12ae2f$exports && $9fef8b6c6e12ae2f$exports[key] === $9fef8b6c6e12ae2f$var$_boxClasses[key]) return;
    Object.defineProperty($9fef8b6c6e12ae2f$exports, key, {
        enumerable: true,
        get: function() {
            return $9fef8b6c6e12ae2f$var$_boxClasses[key];
        }
    });
});


const $98c5ba02ccfb6ac5$var$KnowledgeBase = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    return (0, $kSbwP.jsx)((0, $kSbwP.Fragment), {
        children: (0, $kSbwP.jsx)("div", {
            className: "d-flex justify-content-center",
            style: {
                height: '100%'
            },
            children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
                direction: "column",
                className: "h-100 w-100",
                children: [
                    (0, $kSbwP.jsx)((0, $77d5878715146af4$export$8b251419efc915eb), {
                        disableTicker: true,
                        showNewDeal: true
                    }),
                    (0, $kSbwP.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9fef8b6c6e12ae2f$exports))), {
                        sx: {
                            minHeight: 352,
                            minWidth: 250
                        },
                        children: (0, $kSbwP.jsxs)((0, $4f5f5b50b52104e1$exports.SimpleTreeView), {
                            children: [
                                (0, $kSbwP.jsxs)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                    itemId: "grid",
                                    label: "Data Grid",
                                    children: [
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "grid-community",
                                            label: "@mui/x-data-grid"
                                        }),
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "grid-pro",
                                            label: "@mui/x-data-grid-pro"
                                        }),
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "grid-premium",
                                            label: "@mui/x-data-grid-premium"
                                        })
                                    ]
                                }),
                                (0, $kSbwP.jsxs)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                    itemId: "pickers",
                                    label: "Date and Time Pickers",
                                    children: [
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "pickers-community",
                                            label: "@mui/x-date-pickers"
                                        }),
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "pickers-pro",
                                            label: "@mui/x-date-pickers-pro"
                                        })
                                    ]
                                }),
                                (0, $kSbwP.jsxs)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                    itemId: "charts",
                                    label: "Charts",
                                    children: [
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "charts-community",
                                            label: "@mui/x-charts"
                                        }),
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "charts-pro",
                                            label: "@mui/x-charts-pro"
                                        })
                                    ]
                                }),
                                (0, $kSbwP.jsxs)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                    itemId: "tree-view",
                                    label: "Tree View",
                                    children: [
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "tree-view-community",
                                            label: "@mui/x-tree-view"
                                        }),
                                        (0, $kSbwP.jsx)((0, $225dbc5b8fcc6b42$export$53d36ab85dc89436), {
                                            itemId: "tree-view-pro",
                                            label: "@mui/x-tree-view-pro"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    (0, $kSbwP.jsx)((0, $d39d5626a2a26fe7$export$6b45509f74bc6382), {
                        display: "Upload File",
                        storageTarget: {
                            type: 'knowledge_base',
                            folder: 'test'
                        },
                        toasterMessage: "Uploading Knowledge: %name%"
                    })
                ]
            })
        })
    });
});
var $98c5ba02ccfb6ac5$export$2e2bcd8739ae039 = $98c5ba02ccfb6ac5$var$KnowledgeBase;


const $325af5f10b3faac7$export$953c2efc134d7f79 = (0, $d8a76c81a2e66478$export$b6ae1bc530f4c149)(()=>{
    const store = (0, $8f024b03d9af7c67$export$6ccbb43953eebf8)();
    (0, $8nGP5.useEffect)(()=>{
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
                storeUI.onKeyUpReset();
            }
        });
        document.addEventListener('keydown', (e)=>{
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            //key for back?
            if (e.key === 'Backspace') {
                if (e.currentTarget.activeElement.localName == 'input') return;
                window.history.back();
            }
            if (e.ctrlKey) storeUI.isKeyControlKeyDown = true;
            if (e.key === 'PageUp') storeUI.scrolling = 'UP';
            else if (e.key === 'PageDown') storeUI.scrolling = 'DOWN';
            else storeUI.scrolling = 'NONE';
            if (e.key == 'Tab') {
                if (e.currentTarget.activeElement.localName == 'input') return;
                e.preventDefault();
                storeUI.isKeyShiftKeyDown = e.shiftKey;
                storeUI.isKeyTabDown = true;
            }
            if (e.key == 'Escape') {
                e.preventDefault();
                storeUI.isKeyEscapeDown = true;
            }
        });
        document.addEventListener('keyup', (e)=>{
            const storeUI = (0, $8f024b03d9af7c67$export$d842a17955610ca9)();
            storeUI.onKeyUpReset();
        });
    }, []);
    const hrefContainsLogin = window.location.href.includes('/login');
    return (0, $kSbwP.jsxs)((0, $kSbwP.Fragment), {
        children: [
            (0, $kSbwP.jsx)((0, $c1e5789890d2fb2f$export$f2815235e76a62b9), {
                position: "bottom-right",
                style: {
                    zIndex: 100000000,
                    textAlign: 'right'
                }
            }),
            (0, $kSbwP.jsx)((0, $96c137ca70850e28$export$7a45779be0c29756), {}),
            (0, $kSbwP.jsx)((0, $7cf10799ed69235a$export$669f6ea7d267feaf), {}),
            (0, $kSbwP.jsx)((0, $0f551f4a4f916cc1$export$9ba4e89fdfa1fc54), {
                children: (0, $kSbwP.jsxs)((0, $48e5d1fb97c993cc$export$3565eb3d00ca5a74), {
                    children: [
                        (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: store.isLoaded ? (0, $kSbwP.jsx)((0, $e640bef1966ab6d6$export$2e2bcd8739ae039), {}) : null
                        }),
                        (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: (0, $kSbwP.jsx)((0, $e5930515877dc472$export$2e2bcd8739ae039), {})
                        }),
                        (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                            path: "/:id",
                            element: store.isLoaded ? (0, $kSbwP.jsx)((0, $dd142b8584fa3691$export$2e2bcd8739ae039), {}) : null
                        }),
                        (0, $kSbwP.jsx)((0, $48e5d1fb97c993cc$export$e7b0ac011bb776c6), {
                            path: "/knowledge",
                            element: store.isLoaded ? (0, $kSbwP.jsx)((0, $98c5ba02ccfb6ac5$export$2e2bcd8739ae039), {}) : null
                        })
                    ]
                })
            })
        ]
    });
});


// This is a magic string replaced by rollup
const $ef9854b1b1bbf4cf$export$31499a9cd224b78c = "9.14.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $4546c9f85d024500$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $69b66c77e999bb3b$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $69b66c77e999bb3b$export$c8bfa33e4e8ae492((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return 0, $4546c9f85d024500$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $69b66c77e999bb3b$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $69b66c77e999bb3b$export$7e223ec222791509(name, creator, obj = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] = __SENTRY__[0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



// eslint-disable-next-line @typescript-eslint/unbound-method
const $04327917d6f3444a$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$e6127cc7fe7395c3(wat) {
    switch($04327917d6f3444a$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $04327917d6f3444a$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$var$isBuiltin(wat, className) {
    return $04327917d6f3444a$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$9f9636d330b71954(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$ef9e2056653f0c8e(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$12e869b2a583f783(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$844ec244b1367d54(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$c3825b437cbdea5c(wat) {
    return wat === null || $04327917d6f3444a$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$53b83ca8eaab0383(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$49841c62b9eff15(wat) {
    return $04327917d6f3444a$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $04327917d6f3444a$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$bc2894c7158efbac(wat) {
    return $04327917d6f3444a$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $04327917d6f3444a$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $04327917d6f3444a$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $04327917d6f3444a$export$49034edbe6b62415(request, Request);
}



const $d2c922fb99362c48$var$WINDOW = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
const $d2c922fb99362c48$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d2c922fb99362c48$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $d2c922fb99362c48$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $d2c922fb99362c48$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $d2c922fb99362c48$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($d2c922fb99362c48$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $04327917d6f3444a$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $d2c922fb99362c48$export$1cfafeee2987818b() {
    try {
        return $d2c922fb99362c48$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $d2c922fb99362c48$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$d2c922fb99362c48$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $32dbb9c779accb6e$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






/** Prefix for logging strings */ const $50107229405f0b55$var$PREFIX = 'Sentry Logger ';
const $50107229405f0b55$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $50107229405f0b55$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $50107229405f0b55$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($50107229405f0b55$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $50107229405f0b55$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $50107229405f0b55$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $32dbb9c779accb6e$export$16a28057038b10ef) $50107229405f0b55$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $50107229405f0b55$export$cda52e2a8927a2ca(()=>{
                (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console[name](`${$50107229405f0b55$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $50107229405f0b55$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $50107229405f0b55$export$af88d00dbe7f521 = (0, $69b66c77e999bb3b$export$7e223ec222791509)('logger', $50107229405f0b55$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $404b08ff2be9997a$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $404b08ff2be9997a$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $404b08ff2be9997a$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $04327917d6f3444a$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $404b08ff2be9997a$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $04327917d6f3444a$export$844ec244b1367d54)(value)) return false;
    if ((0, $04327917d6f3444a$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $04327917d6f3444a$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $404b08ff2be9997a$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$404b08ff2be9997a$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $331e7a423c1d6bab$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $331e7a423c1d6bab$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $331e7a423c1d6bab$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $331e7a423c1d6bab$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $331e7a423c1d6bab$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $331e7a423c1d6bab$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $331e7a423c1d6bab$export$62ff257738bf57f5(value) {
    if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$331e7a423c1d6bab$var$getOwnProperties(value)
    };
    else if ((0, $04327917d6f3444a$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $331e7a423c1d6bab$var$serializeEventTarget(value.target),
            currentTarget: $331e7a423c1d6bab$var$serializeEventTarget(value.currentTarget),
            ...$331e7a423c1d6bab$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $04327917d6f3444a$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $331e7a423c1d6bab$var$serializeEventTarget(target) {
    try {
        return (0, $04327917d6f3444a$export$45a5e7f76e0caa8d)(target) ? (0, $d2c922fb99362c48$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $331e7a423c1d6bab$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $331e7a423c1d6bab$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($331e7a423c1d6bab$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $404b08ff2be9997a$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $404b08ff2be9997a$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $331e7a423c1d6bab$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $331e7a423c1d6bab$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $331e7a423c1d6bab$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($331e7a423c1d6bab$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($331e7a423c1d6bab$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $331e7a423c1d6bab$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $331e7a423c1d6bab$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $331e7a423c1d6bab$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $04327917d6f3444a$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $832931c5253c6f61$var$getCrypto() {
    const gbl = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $832931c5253c6f61$export$19f53698e68b2496(crypto = $832931c5253c6f61$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $832931c5253c6f61$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $832931c5253c6f61$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $832931c5253c6f61$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $832931c5253c6f61$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $832931c5253c6f61$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $832931c5253c6f61$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $832931c5253c6f61$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $832931c5253c6f61$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $832931c5253c6f61$export$d364f2020ab30578(input) {
    const match = input.match($832931c5253c6f61$var$SEMVER_REGEXP) || [];
    const major = $832931c5253c6f61$var$_parseInt(match[1]);
    const minor = $832931c5253c6f61$var$_parseInt(match[2]);
    const patch = $832931c5253c6f61$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $832931c5253c6f61$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $404b08ff2be9997a$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $404b08ff2be9997a$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $404b08ff2be9997a$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $832931c5253c6f61$export$6de4ffac6a2f1098(exception) {
    if ($832931c5253c6f61$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $832931c5253c6f61$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $b99b0aced21a41e0$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $b99b0aced21a41e0$export$7740643b9eeaf0c4() {
    return Date.now() / $b99b0aced21a41e0$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $b99b0aced21a41e0$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $b99b0aced21a41e0$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $b99b0aced21a41e0$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $b99b0aced21a41e0$export$ee52dced521e3e18 = $b99b0aced21a41e0$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $b99b0aced21a41e0$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $b99b0aced21a41e0$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $b99b0aced21a41e0$export$baf075a948ffc0bf() {
    if (!$b99b0aced21a41e0$var$cachedTimeOrigin) $b99b0aced21a41e0$var$cachedTimeOrigin = $b99b0aced21a41e0$var$getBrowserTimeOrigin();
    return $b99b0aced21a41e0$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $933b7638f999d30c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $832931c5253c6f61$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$933b7638f999d30c$var$sessionToJSON(session)
    };
    if (context) $933b7638f999d30c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $933b7638f999d30c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $832931c5253c6f61$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $933b7638f999d30c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $933b7638f999d30c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $933b7638f999d30c$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}






/**
 * Generate a random, valid trace ID.
 */ function $a4fae29ec8bb25f7$export$dc6d7ea554bcce10() {
    return (0, $832931c5253c6f61$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $a4fae29ec8bb25f7$export$295213bc4d0c54ad() {
    return (0, $832931c5253c6f61$export$19f53698e68b2496)().substring(16);
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $e0d3e5565e99f13e$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $e0d3e5565e99f13e$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $3384f12a46e56483$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3384f12a46e56483$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(scope, $3384f12a46e56483$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$3384f12a46e56483$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $3384f12a46e56483$export$91f063ebb8eff307(scope) {
    return scope[$3384f12a46e56483$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $2043822b84732d98$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $2043822b84732d98$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $2043822b84732d98$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $3384f12a46e56483$export$3f25fa50c18e20ca)(newScope, (0, $3384f12a46e56483$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $933b7638f999d30c$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $2043822b84732d98$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $04327917d6f3444a$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $3384f12a46e56483$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $2043822b84732d98$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $404b08ff2be9997a$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $3384f12a46e56483$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $4913dbcbce765e31$export$6f1b9191db9c4d5() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $4913dbcbce765e31$export$de9862929b76bf57() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $8efce4d24d3cc76f$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $2043822b84732d98$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $2043822b84732d98$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $8efce4d24d3cc76f$var$getAsyncContextStack() {
    const registry = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $8efce4d24d3cc76f$export$d36ec451f120cfba((0, $4913dbcbce765e31$export$6f1b9191db9c4d5)(), (0, $4913dbcbce765e31$export$de9862929b76bf57)());
}
function $8efce4d24d3cc76f$var$withScope(callback) {
    return $8efce4d24d3cc76f$var$getAsyncContextStack().withScope(callback);
}
function $8efce4d24d3cc76f$var$withSetScope(scope, callback) {
    const stack = $8efce4d24d3cc76f$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $8efce4d24d3cc76f$var$withIsolationScope(callback) {
    return $8efce4d24d3cc76f$var$getAsyncContextStack().withScope(()=>{
        return callback($8efce4d24d3cc76f$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $8efce4d24d3cc76f$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $8efce4d24d3cc76f$var$withIsolationScope,
        withScope: $8efce4d24d3cc76f$var$withScope,
        withSetScope: $8efce4d24d3cc76f$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $8efce4d24d3cc76f$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$8efce4d24d3cc76f$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$8efce4d24d3cc76f$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4df7c5181b9904cb$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $4df7c5181b9904cb$export$f639b0c2752203be(carrier) {
    const sentry = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $8efce4d24d3cc76f$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $7579005d8c799ca0$export$c7be4b0125a10cba() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $7579005d8c799ca0$export$68f3af03034c9e90() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $7579005d8c799ca0$export$aa55d5ab8e05984f() {
    return (0, $69b66c77e999bb3b$export$7e223ec222791509)('globalScope', ()=>new (0, $2043822b84732d98$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $7579005d8c799ca0$export$ec58d9285c204497(...rest) {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $7579005d8c799ca0$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $7579005d8c799ca0$export$6bb76d6eba7e258c() {
    return $7579005d8c799ca0$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $7579005d8c799ca0$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f24718adf40977d4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $861e84080756a67e$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $861e84080756a67e$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $861e84080756a67e$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $861e84080756a67e$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $861e84080756a67e$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $861e84080756a67e$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $861e84080756a67e$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $861e84080756a67e$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($861e84080756a67e$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $861e84080756a67e$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $861e84080756a67e$export$2d8f5188773bcddd(integration) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $861e84080756a67e$export$2323046b9414659f(fn) {
    return fn;
}




const $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT = 50;
const $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $6eb7fa2c12e5f94a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($6eb7fa2c12e5f94a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $6eb7fa2c12e5f94a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $6eb7fa2c12e5f94a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $6eb7fa2c12e5f94a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $6eb7fa2c12e5f94a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($6eb7fa2c12e5f94a$var$STRIP_FRAME_REGEXP.test($6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $6eb7fa2c12e5f94a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $6eb7fa2c12e5f94a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac
        }));
}
function $6eb7fa2c12e5f94a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $6eb7fa2c12e5f94a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $6eb7fa2c12e5f94a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $6eb7fa2c12e5f94a$var$defaultFunctionName;
        return fn.name || $6eb7fa2c12e5f94a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $6eb7fa2c12e5f94a$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


const $879ff71665c6eecc$var$INTEGRATION_NAME = 'Dedupe';
const $879ff71665c6eecc$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $879ff71665c6eecc$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($879ff71665c6eecc$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $879ff71665c6eecc$export$6d39aa44cd0c7567 = (0, $861e84080756a67e$export$2323046b9414659f)($879ff71665c6eecc$var$_dedupeIntegration);
/** only exported for tests. */ function $879ff71665c6eecc$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($879ff71665c6eecc$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($879ff71665c6eecc$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $879ff71665c6eecc$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $879ff71665c6eecc$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $879ff71665c6eecc$var$_getExceptionFromEvent(previousEvent);
    const currentException = $879ff71665c6eecc$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $879ff71665c6eecc$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $6eb7fa2c12e5f94a$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $879ff71665c6eecc$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $879ff71665c6eecc$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $8c14f7174ada528d$var$originalFunctionToString;
const $8c14f7174ada528d$var$INTEGRATION_NAME = 'FunctionToString';
const $8c14f7174ada528d$var$SETUP_CLIENTS = new WeakMap();
const $8c14f7174ada528d$var$_functionToStringIntegration = ()=>{
    return {
        name: $8c14f7174ada528d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $8c14f7174ada528d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(this);
                    const context = $8c14f7174ada528d$var$SETUP_CLIENTS.has((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $8c14f7174ada528d$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $8c14f7174ada528d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $8c14f7174ada528d$export$7918117e9202e4fb = (0, $861e84080756a67e$export$2323046b9414659f)($8c14f7174ada528d$var$_functionToStringIntegration);



/** Regular expression used to parse a Dsn. */ const $843b0da08619aa63$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $843b0da08619aa63$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $843b0da08619aa63$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $843b0da08619aa63$export$b892860177f70a30(str) {
    const match = $843b0da08619aa63$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $843b0da08619aa63$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $843b0da08619aa63$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $843b0da08619aa63$var$validateDsn(dsn) {
    if (!(0, $32dbb9c779accb6e$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$843b0da08619aa63$var$isValidProtocol(protocol)) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $843b0da08619aa63$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $843b0da08619aa63$export$b892860177f70a30(from) : $843b0da08619aa63$var$dsnFromComponents(from);
    if (!components || !$843b0da08619aa63$var$validateDsn(components)) return undefined;
    return components;
}


const $1b878ff624a14448$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $1b878ff624a14448$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $1b878ff624a14448$var$_getIngestEndpoint(dsn) {
    return `${$1b878ff624a14448$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $1b878ff624a14448$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $1b878ff624a14448$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $1b878ff624a14448$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$1b878ff624a14448$var$_getIngestEndpoint(dsn)}?${$1b878ff624a14448$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $1b878ff624a14448$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $843b0da08619aa63$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$1b878ff624a14448$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}






/**
 * Get a list of possible event messages from a Sentry event.
 */ function $0074d0f077bfa8f4$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $9230543946cecc48$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $9230543946cecc48$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $9230543946cecc48$export$9a84f518c163c552 = (0, $861e84080756a67e$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $9230543946cecc48$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $9230543946cecc48$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $9230543946cecc48$var$_mergeOptions(options, clientOptions);
            }
            return $9230543946cecc48$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $9230543946cecc48$export$cb3c5c2ceb9818ba = (0, $861e84080756a67e$export$2323046b9414659f)((options = {})=>{
    return {
        ...$9230543946cecc48$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $9230543946cecc48$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $9230543946cecc48$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $9230543946cecc48$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($9230543946cecc48$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($9230543946cecc48$var$_isUselessError(event)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($9230543946cecc48$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}.\nUrl: ${$9230543946cecc48$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$9230543946cecc48$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}.\nUrl: ${$9230543946cecc48$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($9230543946cecc48$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $9230543946cecc48$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $0074d0f077bfa8f4$export$d55a97c329cacfcc)(event).some((message)=>(0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $9230543946cecc48$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $9230543946cecc48$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $9230543946cecc48$var$_getEventFilterUrl(event);
    return !url ? false : (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $9230543946cecc48$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $9230543946cecc48$var$_getEventFilterUrl(event);
    return !url ? true : (0, $404b08ff2be9997a$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $9230543946cecc48$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $9230543946cecc48$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $9230543946cecc48$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $832931c5253c6f61$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $9230543946cecc48$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $62a36d7bdb68e8f6$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $f24718adf40977d4$export$16a28057038b10ef) (0, $50107229405f0b55$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $62a36d7bdb68e8f6$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $62a36d7bdb68e8f6$export$ecb76f41d43c0e43(client) {
    (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().setClient(client);
}









const $09c0eeb1390de562$export$849dbeeeda01ae98 = 'production';







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $88d6af982193bd0a$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($88d6af982193bd0a$var$States || ($88d6af982193bd0a$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $88d6af982193bd0a$export$1fda8aa4d135f8aa(value) {
    return new $88d6af982193bd0a$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $88d6af982193bd0a$export$78e43115b553f358(reason) {
    return new $88d6af982193bd0a$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $88d6af982193bd0a$export$6f292d4960313241 {
    constructor(executor){
        this._state = $88d6af982193bd0a$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $88d6af982193bd0a$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $88d6af982193bd0a$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $88d6af982193bd0a$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $88d6af982193bd0a$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $88d6af982193bd0a$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $88d6af982193bd0a$var$States.PENDING) return;
            if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($88d6af982193bd0a$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($88d6af982193bd0a$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $2b9febab9489909b$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $f24718adf40977d4$export$16a28057038b10ef) && processor.id && result === null && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(result)) result.then((final)=>$2b9febab9489909b$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $2b9febab9489909b$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $91867b645e9a946a$var$parsedStackResults;
let $91867b645e9a946a$var$lastKeysCount;
let $91867b645e9a946a$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $91867b645e9a946a$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($91867b645e9a946a$var$cachedFilenameDebugIds && debugIdKeys.length === $91867b645e9a946a$var$lastKeysCount) return $91867b645e9a946a$var$cachedFilenameDebugIds;
    $91867b645e9a946a$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $91867b645e9a946a$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$91867b645e9a946a$var$parsedStackResults) $91867b645e9a946a$var$parsedStackResults = {};
        const result = $91867b645e9a946a$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $91867b645e9a946a$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $91867b645e9a946a$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $91867b645e9a946a$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $91867b645e9a946a$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}






/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81e4dea968b0d498$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $81e4dea968b0d498$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $81e4dea968b0d498$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $81e4dea968b0d498$export$a3295358bff77e(object, depth);
    if ($81e4dea968b0d498$var$jsonSize(normalized) > maxSize) return $81e4dea968b0d498$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $81e4dea968b0d498$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $81e4dea968b0d498$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $81e4dea968b0d498$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $81e4dea968b0d498$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $331e7a423c1d6bab$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $81e4dea968b0d498$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $81e4dea968b0d498$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $04327917d6f3444a$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $04327917d6f3444a$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $81e4dea968b0d498$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $81e4dea968b0d498$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $81e4dea968b0d498$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81e4dea968b0d498$var$jsonSize(value) {
    return $81e4dea968b0d498$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $81e4dea968b0d498$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $81e4dea968b0d498$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $a0fd9313f4cb718b$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $a0fd9313f4cb718b$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $a0fd9313f4cb718b$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $a0fd9313f4cb718b$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $a0fd9313f4cb718b$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $a0fd9313f4cb718b$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $a0fd9313f4cb718b$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $a0fd9313f4cb718b$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $a0fd9313f4cb718b$export$1efec95406bbe327 = 'sentry.profile_id';
const $a0fd9313f4cb718b$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $a0fd9313f4cb718b$export$b016f89ac1066ec = 'cache.hit';
const $a0fd9313f4cb718b$export$3110e4c3f4386399 = 'cache.key';
const $a0fd9313f4cb718b$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $a0fd9313f4cb718b$export$be7a251980e7e946 = 'http.request.method';
const $a0fd9313f4cb718b$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $a0fd9313f4cb718b$export$ff77b5fd5b2d627b = 'sentry.link.type';





const $8d4d84fb2953dc92$export$6e69537d67fa20f = 'sentry-';
const $8d4d84fb2953dc92$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $8d4d84fb2953dc92$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $8d4d84fb2953dc92$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $8d4d84fb2953dc92$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($8d4d84fb2953dc92$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($8d4d84fb2953dc92$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $8d4d84fb2953dc92$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$8d4d84fb2953dc92$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $8d4d84fb2953dc92$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $8d4d84fb2953dc92$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $04327917d6f3444a$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $8d4d84fb2953dc92$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $8d4d84fb2953dc92$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $8d4d84fb2953dc92$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $8d4d84fb2953dc92$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $8d4d84fb2953dc92$export$bdd844ddb2def819) {
            (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $3ce0cc58f6f6cba3$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $3ce0cc58f6f6cba3$export$5008da00b1b6dee6 = $3ce0cc58f6f6cba3$export$1f70765132c3c225;






const $c739fbebe9c4fc83$export$136e25984ba4a383 = 0;
const $c739fbebe9c4fc83$export$58f7963109c806fc = 1;
const $c739fbebe9c4fc83$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $c739fbebe9c4fc83$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $c739fbebe9c4fc83$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $c739fbebe9c4fc83$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $c739fbebe9c4fc83$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $c739fbebe9c4fc83$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $c739fbebe9c4fc83$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



const $c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $c41596970e41417f$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $c41596970e41417f$export$c08fbc656a245d03(span) {
    return {
        scope: span[$c41596970e41417f$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$c41596970e41417f$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $cc2433bfd1c42bff$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $805e225f1c20308d$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $805e225f1c20308d$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($805e225f1c20308d$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $805e225f1c20308d$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $805e225f1c20308d$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $8d4d84fb2953dc92$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $805e225f1c20308d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $805e225f1c20308d$export$f35d907436da45cf(traceId = (0, $a4fae29ec8bb25f7$export$dc6d7ea554bcce10)(), spanId = (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $805e225f1c20308d$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $8001bfb4d6603905$export$208d5b368507fb8b = 0x0;
const $8001bfb4d6603905$export$eb571cd9b5d98de8 = 0x1;
let $8001bfb4d6603905$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $8001bfb4d6603905$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $8001bfb4d6603905$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $8001bfb4d6603905$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $8001bfb4d6603905$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $c41596970e41417f$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $a4fae29ec8bb25f7$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $8001bfb4d6603905$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $8001bfb4d6603905$export$5caecac1caaf3a71(span);
    return (0, $805e225f1c20308d$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $8001bfb4d6603905$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $8001bfb4d6603905$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $8001bfb4d6603905$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $8001bfb4d6603905$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $8001bfb4d6603905$var$ensureTimestampInSeconds(input.getTime());
    return (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $8001bfb4d6603905$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $8001bfb4d6603905$export$92d8c23565496537(span) {
    if ($8001bfb4d6603905$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($8001bfb4d6603905$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $8001bfb4d6603905$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $8001bfb4d6603905$export$3f7581298f56c6d7(endTime) || undefined,
            status: $8001bfb4d6603905$export$e238a77ea3a8cd66(status),
            op: attributes[0, $a0fd9313f4cb718b$export$1a413bd9a88fdb09],
            origin: attributes[0, $a0fd9313f4cb718b$export$cca8dd30f57f805e],
            links: $8001bfb4d6603905$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $8001bfb4d6603905$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $8001bfb4d6603905$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $8001bfb4d6603905$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $8001bfb4d6603905$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $8001bfb4d6603905$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $c739fbebe9c4fc83$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $c739fbebe9c4fc83$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $8001bfb4d6603905$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $8001bfb4d6603905$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $8001bfb4d6603905$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$8001bfb4d6603905$var$ROOT_SPAN_FIELD] || span;
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(childSpan, $8001bfb4d6603905$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(span, $8001bfb4d6603905$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $8001bfb4d6603905$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $8001bfb4d6603905$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($8001bfb4d6603905$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD] ? Array.from(span[$8001bfb4d6603905$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $8001bfb4d6603905$export$c4c6a79b1260ca1b(span) {
    return span[$8001bfb4d6603905$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $8001bfb4d6603905$export$1be426a8e585c83e() {
    const carrier = (0, $69b66c77e999bb3b$export$19eade501500c6c1)();
    const acs = (0, $4df7c5181b9904cb$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $3384f12a46e56483$export$91f063ebb8eff307)((0, $7579005d8c799ca0$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $8001bfb4d6603905$export$d11691ff45a3e535() {
    if (!$8001bfb4d6603905$var$hasShownSpanDropWarning) {
        (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $8001bfb4d6603905$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $8001bfb4d6603905$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $a0fd9313f4cb718b$export$d7a7d984b0791405)]: 'custom',
        [(0, $a0fd9313f4cb718b$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $e872f90a02880534$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $e872f90a02880534$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(spanWithMaybeDsc, $e872f90a02880534$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $e872f90a02880534$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $09c0eeb1390de562$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $e872f90a02880534$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $e872f90a02880534$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $e872f90a02880534$export$a117f995597e25df(span) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $8001bfb4d6603905$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $8001bfb4d6603905$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $a0fd9313f4cb718b$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$e872f90a02880534$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $8d4d84fb2953dc92$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $e872f90a02880534$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $a0fd9313f4cb718b$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $3ce0cc58f6f6cba3$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $8001bfb4d6603905$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $c41596970e41417f$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $e872f90a02880534$export$95cf936fdacaff7b(span) {
    const dsc = $e872f90a02880534$export$a117f995597e25df(span);
    return (0, $8d4d84fb2953dc92$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $8bb3e72af3599b65$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $8bb3e72af3599b65$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $8bb3e72af3599b65$var$applySpanToEvent(event, span);
    $8bb3e72af3599b65$var$applyFingerprintToEvent(event, fingerprint);
    $8bb3e72af3599b65$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $8bb3e72af3599b65$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $8bb3e72af3599b65$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'extra', extra);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'tags', tags);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'user', user);
    $8bb3e72af3599b65$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $8bb3e72af3599b65$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $8bb3e72af3599b65$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $8bb3e72af3599b65$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $8bb3e72af3599b65$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $8bb3e72af3599b65$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $8001bfb4d6603905$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $e872f90a02880534$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $8001bfb4d6603905$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $8001bfb4d6603905$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $8bb3e72af3599b65$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $84bc2afffc49348f$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $832931c5253c6f61$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $84bc2afffc49348f$export$d7e04067a6fbc882(prepared, options);
    $84bc2afffc49348f$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $84bc2afffc49348f$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $84bc2afffc49348f$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $7579005d8c799ca0$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $8bb3e72af3599b65$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $8bb3e72af3599b65$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $8bb3e72af3599b65$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $2b9febab9489909b$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $84bc2afffc49348f$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $84bc2afffc49348f$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $84bc2afffc49348f$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $09c0eeb1390de562$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $404b08ff2be9997a$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $84bc2afffc49348f$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $91867b645e9a946a$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $84bc2afffc49348f$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $84bc2afffc49348f$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $84bc2afffc49348f$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $81e4dea968b0d498$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $81e4dea968b0d498$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $81e4dea968b0d498$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $81e4dea968b0d498$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $84bc2afffc49348f$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $2043822b84732d98$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $84bc2afffc49348f$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($84bc2afffc49348f$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($84bc2afffc49348f$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $84bc2afffc49348f$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $2043822b84732d98$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $84bc2afffc49348f$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $84bc2afffc49348f$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$84bc2afffc49348f$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $d0ea6cfcc1ddd989$export$f5282963edea4a68(exception, hint) {
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureException(exception, (0, $84bc2afffc49348f$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $d0ea6cfcc1ddd989$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2(event, hint) {
    return (0, $7579005d8c799ca0$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $d0ea6cfcc1ddd989$export$2f04de43fe27971a(name, context) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $d0ea6cfcc1ddd989$export$bb4922da0dd51b92(extras) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $d0ea6cfcc1ddd989$export$8e8e7789d42ed61d(key, extra) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $d0ea6cfcc1ddd989$export$74a8fb34822092e6(tags) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $d0ea6cfcc1ddd989$export$a37d07ee78eb4569(key, value) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $d0ea6cfcc1ddd989$export$8b6bb3dd62a01be2(user) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $d0ea6cfcc1ddd989$export$5d4e9fd7fac8e617() {
    return (0, $7579005d8c799ca0$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d0ea6cfcc1ddd989$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (!client) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $832931c5253c6f61$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $d0ea6cfcc1ddd989$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $d0ea6cfcc1ddd989$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $d0ea6cfcc1ddd989$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $7579005d8c799ca0$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d0ea6cfcc1ddd989$export$4909b86c8034bf73(timeout) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $d0ea6cfcc1ddd989$export$8360e631d277ea4d(timeout) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $d0ea6cfcc1ddd989$export$3f95c6f800b78024() {
    return !!(0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $d0ea6cfcc1ddd989$export$3b029eb57ac4d562() {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $d0ea6cfcc1ddd989$export$9aac0b9f77928fbf(callback) {
    (0, $7579005d8c799ca0$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $d0ea6cfcc1ddd989$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $933b7638f999d30c$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $933b7638f999d30c$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $d0ea6cfcc1ddd989$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $d0ea6cfcc1ddd989$export$17a5be43989a0bc1() {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $933b7638f999d30c$export$56521d9ba90f62ee)(session);
    $d0ea6cfcc1ddd989$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $d0ea6cfcc1ddd989$var$_sendSessionUpdate() {
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $d0ea6cfcc1ddd989$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $d0ea6cfcc1ddd989$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $d0ea6cfcc1ddd989$var$_sendSessionUpdate();
}




const $454364c661d00d30$var$WINDOW = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$67fc34576016d6ec() {
    return 'history' in $454364c661d00d30$var$WINDOW && !!$454364c661d00d30$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $454364c661d00d30$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $454364c661d00d30$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $454364c661d00d30$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$454364c661d00d30$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($454364c661d00d30$export$d5f608b368e73f38($454364c661d00d30$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $454364c661d00d30$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $454364c661d00d30$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$531055a6c684a70a() {
    return 'ReportingObserver' in $454364c661d00d30$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $454364c661d00d30$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$454364c661d00d30$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}












/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b04b40088fe5ea6b$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $b04b40088fe5ea6b$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $b04b40088fe5ea6b$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $b04b40088fe5ea6b$export$604a45d95a155e2b(envelope, types) {
    return $b04b40088fe5ea6b$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $b04b40088fe5ea6b$var$encodeUTF8(input) {
    const carrier = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $b04b40088fe5ea6b$var$decodeUTF8(input) {
    const carrier = (0, $69b66c77e999bb3b$export$c8bfa33e4e8ae492)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $b04b40088fe5ea6b$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $b04b40088fe5ea6b$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $81e4dea968b0d498$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $b04b40088fe5ea6b$var$concatBuffers(parts);
}
function $b04b40088fe5ea6b$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $b04b40088fe5ea6b$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($b04b40088fe5ea6b$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $b04b40088fe5ea6b$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $b04b40088fe5ea6b$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $b04b40088fe5ea6b$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $b04b40088fe5ea6b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    otel_log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $b04b40088fe5ea6b$export$b11169581eeaf237(type) {
    return $b04b40088fe5ea6b$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $b04b40088fe5ea6b$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $b04b40088fe5ea6b$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $a0a857ad29b67515$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $a0a857ad29b67515$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b04b40088fe5ea6b$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $a0a857ad29b67515$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $b04b40088fe5ea6b$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $a0a857ad29b67515$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $b04b40088fe5ea6b$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $a0a857ad29b67515$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $e872f90a02880534$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $8001bfb4d6603905$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $8001bfb4d6603905$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $b04b40088fe5ea6b$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(headers, items);
}







/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $b6a910e07cb72210$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}














/**
 * Converts a transaction event to a span JSON object.
 */ function $854fb525ddc2ad53$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $a0fd9313f4cb718b$export$1efec95406bbe327],
        exclusive_time: data?.[0, $a0fd9313f4cb718b$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $854fb525ddc2ad53$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $a0fd9313f4cb718b$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $a0fd9313f4cb718b$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}



const $1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $1b3e1f4ebe4b3dca$var$_makeInternalError(message) {
    return {
        message: message,
        [$1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $1b3e1f4ebe4b3dca$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $1b3e1f4ebe4b3dca$var$INTERNAL_ERROR_SYMBOL in error;
}
function $1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $1b3e1f4ebe4b3dca$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $843b0da08619aa63$export$128827c3562ec0cb)(options.dsn);
        else (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $1b878ff624a14448$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $832931c5253c6f61$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $832931c5253c6f61$export$6de4ffac6a2f1098)(exception)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log($1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $832931c5253c6f61$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $04327917d6f3444a$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $04327917d6f3444a$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $832931c5253c6f61$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $832931c5253c6f61$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log($1b3e1f4ebe4b3dca$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $933b7638f999d30c$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $861e84080756a67e$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $861e84080756a67e$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $a0a857ad29b67515$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $b04b40088fe5ea6b$export$d650323442802f6f)(env, (0, $b04b40088fe5ea6b$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $09c0eeb1390de562$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn($1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn($1b3e1f4ebe4b3dca$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $a0a857ad29b67515$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $861e84080756a67e$export$51abed9797baa598)(this, integrations);
        (0, $861e84080756a67e$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $933b7638f999d30c$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $84bc2afffc49348f$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $7579005d8c799ca0$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $e872f90a02880534$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)(), isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)()) {
        if ((0, $f24718adf40977d4$export$16a28057038b10ef) && $1b3e1f4ebe4b3dca$var$isErrorEvent(event)) (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Captured error event \`${(0, $0074d0f077bfa8f4$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $f24718adf40977d4$export$16a28057038b10ef) {
                if ($1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(reason)) (0, $50107229405f0b55$export$af88d00dbe7f521).log(reason.message);
                else if ($1b3e1f4ebe4b3dca$var$_isInternalError(reason)) (0, $50107229405f0b55$export$af88d00dbe7f521).warn(reason.message);
                else (0, $50107229405f0b55$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $1b3e1f4ebe4b3dca$var$isTransactionEvent(event);
        const isError = $1b3e1f4ebe4b3dca$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $cc2433bfd1c42bff$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $88d6af982193bd0a$export$78e43115b553f358)($1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $1b3e1f4ebe4b3dca$var$processBeforeSend(this, options, prepared, hint);
            return $1b3e1f4ebe4b3dca$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $1b3e1f4ebe4b3dca$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($1b3e1f4ebe4b3dca$var$_isDoNotSendEventError(reason) || $1b3e1f4ebe4b3dca$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $1b3e1f4ebe4b3dca$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $b6a910e07cb72210$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $843b0da08619aa63$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $1b3e1f4ebe4b3dca$export$4f22f74eddb7716a = $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $1b3e1f4ebe4b3dca$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $04327917d6f3444a$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $04327917d6f3444a$export$53b83ca8eaab0383)(event) && event !== null) throw $1b3e1f4ebe4b3dca$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $1b3e1f4ebe4b3dca$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $04327917d6f3444a$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $1b3e1f4ebe4b3dca$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $1b3e1f4ebe4b3dca$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($1b3e1f4ebe4b3dca$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($1b3e1f4ebe4b3dca$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $854fb525ddc2ad53$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $e0d3e5565e99f13e$export$4950aa0f605343fb)(event, (0, $854fb525ddc2ad53$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $8001bfb4d6603905$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $1b3e1f4ebe4b3dca$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $1b3e1f4ebe4b3dca$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $1b3e1f4ebe4b3dca$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $3384f12a46e56483$export$91f063ebb8eff307)(scope);
    const traceContext = span ? (0, $8001bfb4d6603905$export$46c6fbd1d265ebf0)(span) : (0, $7579005d8c799ca0$export$1e83db7ee4876dc4)(scope);
    const dynamicSamplingContext = span ? (0, $e872f90a02880534$export$a117f995597e25df)(span) : (0, $e872f90a02880534$export$89ef1736f08c6b2b)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}




/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $dbda0c7ef1789297$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};





/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $0b84bbf39fcc01a6$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: 'otel_log'
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $0b84bbf39fcc01a6$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $843b0da08619aa63$export$44d472fbb931a776)(dsn);
    return (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(headers, logs.map($0b84bbf39fcc01a6$export$3fb4f8e4a128d620));
}




const $9cd0f6413ac3097d$var$MAX_LOG_BUFFER_SIZE = 100;
const $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $9cd0f6413ac3097d$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case 'number':
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case 'boolean':
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case 'string':
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = '';
                try {
                    stringValue = JSON.stringify(value) ?? '';
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $9cd0f6413ac3097d$export$3ab3d16b9eebd986(beforeLog, client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)(), scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)()) {
    if (!client) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $1b3e1f4ebe4b3dca$export$fb7d833b3fdedf5f)(client, scope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    if (release) processedLogAttributes['sentry.release'] = release;
    if (environment) processedLogAttributes['sentry.environment'] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        processedLogAttributes['sentry.sdk.name'] = sdk.name;
        processedLogAttributes['sentry.sdk.version'] = sdk.version;
    }
    const beforeLogMessage = beforeLog.message;
    if ((0, $04327917d6f3444a$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $3384f12a46e56483$export$91f063ebb8eff307)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    processedLogAttributes['sentry.trace.parent_span_id'] = span.spanContext().spanId;
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(attributes).map(([key, value])=>$9cd0f6413ac3097d$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $dbda0c7ef1789297$export$4fb50c0840d636d1)[level]
    };
    const logBuffer = $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $9cd0f6413ac3097d$var$MAX_LOG_BUFFER_SIZE) $9cd0f6413ac3097d$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $9cd0f6413ac3097d$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $9cd0f6413ac3097d$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $0b84bbf39fcc01a6$export$4324f1d0c59fd57b)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $662601301922d548$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $662601301922d548$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $97e636466ee42774$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c)
            })),
        version: (0, $ef9854b1b1bbf4cf$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $0003c7546bee8a58$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $0003c7546bee8a58$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $49f9172a05aa7804$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $49f9172a05aa7804$export$2e9ae379995d99e3(ex),
        value: $49f9172a05aa7804$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $49f9172a05aa7804$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $49f9172a05aa7804$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $81e4dea968b0d498$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $49f9172a05aa7804$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $04327917d6f3444a$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $49f9172a05aa7804$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $49f9172a05aa7804$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $49f9172a05aa7804$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $49f9172a05aa7804$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $49f9172a05aa7804$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $49f9172a05aa7804$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $49f9172a05aa7804$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $49f9172a05aa7804$var$getSkipFirstStackStringLines(ex) {
    if (ex && $49f9172a05aa7804$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $49f9172a05aa7804$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $49f9172a05aa7804$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $49f9172a05aa7804$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $49f9172a05aa7804$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $49f9172a05aa7804$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($49f9172a05aa7804$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $49f9172a05aa7804$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $49f9172a05aa7804$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $49f9172a05aa7804$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $49f9172a05aa7804$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $04327917d6f3444a$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $49f9172a05aa7804$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $04327917d6f3444a$export$ef9e2056653f0c8e)(exception) || (0, $04327917d6f3444a$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $49f9172a05aa7804$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $04327917d6f3444a$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $49f9172a05aa7804$var$eventFromError(stackParser, exception);
    if ((0, $04327917d6f3444a$export$53b83ca8eaab0383)(exception) || (0, $04327917d6f3444a$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $49f9172a05aa7804$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $49f9172a05aa7804$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $49f9172a05aa7804$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $49f9172a05aa7804$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $04327917d6f3444a$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $49f9172a05aa7804$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $331e7a423c1d6bab$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $04327917d6f3444a$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $04327917d6f3444a$export$9671ea99bd126ace)(exception)) {
        const className = $49f9172a05aa7804$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $49f9172a05aa7804$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $49f9172a05aa7804$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $4344c5993a935327$export$56d8a8a25bd48b81 = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);
let $4344c5993a935327$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $4344c5993a935327$export$b79738ab10c590b2() {
    return $4344c5993a935327$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $4344c5993a935327$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $4344c5993a935327$var$ignoreOnError++;
    setTimeout(()=>{
        $4344c5993a935327$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $4344c5993a935327$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$4344c5993a935327$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $4344c5993a935327$export$1265a142ff5ba165();
            (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $832931c5253c6f61$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $832931c5253c6f61$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $d0ea6cfcc1ddd989$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $331e7a423c1d6bab$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}


const $ee9a22ecd1aa84b2$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $ee9a22ecd1aa84b2$export$1df9218a526d318d extends (0, $1b3e1f4ebe4b3dca$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $4344c5993a935327$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $0003c7546bee8a58$export$8ad33f488b1ab046)();
        (0, $97e636466ee42774$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $4344c5993a935327$export$56d8a8a25bd48b81).document) (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $4344c5993a935327$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                this._flushOutcomes();
                if (enableLogs) (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
            }
        });
        if (enableLogs) {
            client.on('flush', ()=>{
                (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
            });
            client.on('afterCaptureLog', ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $9cd0f6413ac3097d$export$f8ed83d3b6a0b504)(client);
                }, $ee9a22ecd1aa84b2$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on('postprocessEvent', (0, $662601301922d548$export$3e12ad68afa434ac));
            client.on('beforeSendSession', (0, $662601301922d548$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $49f9172a05aa7804$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $49f9172a05aa7804$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2d9d70da08177dd3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






// We keep the handlers globally
const $be735159016cae74$var$handlers = {};
const $be735159016cae74$var$instrumented = {};
/** Add a handler function. */ function $be735159016cae74$export$a4e09611e30da72e(type, handler) {
    $be735159016cae74$var$handlers[type] = $be735159016cae74$var$handlers[type] || [];
    $be735159016cae74$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $be735159016cae74$export$b17eab759a1cb5fe() {
    Object.keys($be735159016cae74$var$handlers).forEach((key)=>{
        $be735159016cae74$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $be735159016cae74$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$be735159016cae74$var$instrumented[type]) {
        $be735159016cae74$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $be735159016cae74$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $be735159016cae74$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $32dbb9c779accb6e$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}



const $5f3c0b8987a9c625$export$56d8a8a25bd48b81 = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1);


const $021562726ff72538$var$DEBOUNCE_DURATION = 1000;
let $021562726ff72538$var$debounceTimerID;
let $021562726ff72538$var$lastCapturedEventType;
let $021562726ff72538$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $021562726ff72538$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $021562726ff72538$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $021562726ff72538$export$3014bbf0af0e1d4a() {
    if (!(0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $be735159016cae74$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $021562726ff72538$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $021562726ff72538$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $021562726ff72538$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $021562726ff72538$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $021562726ff72538$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $021562726ff72538$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $021562726ff72538$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $021562726ff72538$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($021562726ff72538$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(target, '_sentryId', (0, $832931c5253c6f61$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$021562726ff72538$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $021562726ff72538$var$lastCapturedEventType = event.type;
            $021562726ff72538$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($021562726ff72538$var$debounceTimerID);
        $021562726ff72538$var$debounceTimerID = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).setTimeout(()=>{
            $021562726ff72538$var$lastCapturedEventTargetId = undefined;
            $021562726ff72538$var$lastCapturedEventType = undefined;
        }, $021562726ff72538$var$DEBOUNCE_DURATION);
    };
}
function $021562726ff72538$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $aa321501103bea56$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $aa321501103bea56$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $aa321501103bea56$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $aa321501103bea56$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $aa321501103bea56$var$lastHref;
        $aa321501103bea56$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $be735159016cae74$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $454364c661d00d30$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $aa321501103bea56$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $aa321501103bea56$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $be735159016cae74$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}



const $0a61ddeb01dceb07$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0a61ddeb01dceb07$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $0a61ddeb01dceb07$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0a61ddeb01dceb07$export$c67d533bf77cbf54() {
    if (!(0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $04327917d6f3444a$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0a61ddeb01dceb07$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $be735159016cae74$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $04327917d6f3444a$export$844ec244b1367d54)(header) && (0, $04327917d6f3444a$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $be735159016cae74$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $0a61ddeb01dceb07$var$parseXhrUrlArg(url) {
    if ((0, $04327917d6f3444a$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $e56315d488d5f830$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $e56315d488d5f830$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $7579005d8c799ca0$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $e56315d488d5f830$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $b99b0aced21a41e0$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $204766ed52e0ca74$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $204766ed52e0ca74$var$instrumentConsole);
}
function $204766ed52e0ca74$var$instrumentConsole() {
    if (!('console' in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1))) return;
    (0, $50107229405f0b55$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console)) return;
        (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $50107229405f0b55$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $be735159016cae74$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $50107229405f0b55$export$77c4ce905194557b)[level];
                log?.apply((0, $4546c9f85d024500$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4793d2ef5a24aa18$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, ()=>$4793d2ef5a24aa18$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $4793d2ef5a24aa18$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, ()=>$4793d2ef5a24aa18$var$instrumentFetch($4793d2ef5a24aa18$var$streamHandler));
}
function $4793d2ef5a24aa18$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $454364c661d00d30$export$c82d238e23c40b21)()) return;
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4546c9f85d024500$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $4793d2ef5a24aa18$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $4793d2ef5a24aa18$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $4546c9f85d024500$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $be735159016cae74$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $04327917d6f3444a$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $331e7a423c1d6bab$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $4793d2ef5a24aa18$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $4793d2ef5a24aa18$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $4793d2ef5a24aa18$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $be735159016cae74$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $b99b0aced21a41e0$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $4793d2ef5a24aa18$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $4793d2ef5a24aa18$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($4793d2ef5a24aa18$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $4793d2ef5a24aa18$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $4793d2ef5a24aa18$var$getUrlFromResource(url),
            method: $4793d2ef5a24aa18$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $4793d2ef5a24aa18$var$getUrlFromResource(arg),
        method: $4793d2ef5a24aa18$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $4793d2ef5a24aa18$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $04327917d6f3444a$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $e82b0b6d57f59f62$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $be7435a8b8909e7b$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $be7435a8b8909e7b$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $be7435a8b8909e7b$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith('/');
    const base = urlBase ?? (isRelative ? $be7435a8b8909e7b$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $be7435a8b8909e7b$export$5339fcdc8e2a427c(url) {
    if ($be7435a8b8909e7b$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $be7435a8b8909e7b$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $be7435a8b8909e7b$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $be7435a8b8909e7b$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $c107bbb6bc21618d$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $d447c48b9e08cd77$var$INTEGRATION_NAME = 'Breadcrumbs';
const $d447c48b9e08cd77$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $d447c48b9e08cd77$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $204766ed52e0ca74$export$1d6e0d073f9e6723)($d447c48b9e08cd77$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $021562726ff72538$export$5aeffd3db2cf9df7)($d447c48b9e08cd77$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0a61ddeb01dceb07$export$26ace48dd54c9aea)($d447c48b9e08cd77$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $4793d2ef5a24aa18$export$f75d3c772c923df0)($d447c48b9e08cd77$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $aa321501103bea56$export$3f18c56c58114e75)($d447c48b9e08cd77$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $d447c48b9e08cd77$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $d447c48b9e08cd77$export$c079d904b326663a = (0, $861e84080756a67e$export$2323046b9414659f)($d447c48b9e08cd77$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $d447c48b9e08cd77$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        (0, $e56315d488d5f830$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $832931c5253c6f61$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $d447c48b9e08cd77$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $d447c48b9e08cd77$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $d447c48b9e08cd77$var$_isEvent(event) ? event.target : event;
            target = (0, $d2c922fb99362c48$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $d2c922fb99362c48$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $d447c48b9e08cd77$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $c107bbb6bc21618d$export$d771ef054122c30a)(handlerData.level),
            message: (0, $404b08ff2be9997a$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $404b08ff2be9997a$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $d447c48b9e08cd77$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0a61ddeb01dceb07$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $e82b0b6d57f59f62$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $d447c48b9e08cd77$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $e82b0b6d57f59f62$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $e56315d488d5f830$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $d447c48b9e08cd77$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)((0, $4344c5993a935327$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $be7435a8b8909e7b$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $e56315d488d5f830$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $d447c48b9e08cd77$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $9a68cce3ce0bb193$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $9a68cce3ce0bb193$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $9a68cce3ce0bb193$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $9a68cce3ce0bb193$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'setTimeout', $9a68cce3ce0bb193$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'setInterval', $9a68cce3ce0bb193$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)((0, $4344c5993a935327$export$56d8a8a25bd48b81), 'requestAnimationFrame', $9a68cce3ce0bb193$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $4344c5993a935327$export$56d8a8a25bd48b81)) (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $9a68cce3ce0bb193$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $9a68cce3ce0bb193$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($9a68cce3ce0bb193$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $9a68cce3ce0bb193$export$59bfe9f1c76150e = (0, $861e84080756a67e$export$2323046b9414659f)($9a68cce3ce0bb193$var$_browserApiErrorsIntegration);
function $9a68cce3ce0bb193$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4344c5993a935327$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $9a68cce3ce0bb193$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $4344c5993a935327$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $9a68cce3ce0bb193$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $331e7a423c1d6bab$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $4344c5993a935327$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $9a68cce3ce0bb193$var$_wrapEventTarget(target) {
    const globalObject = (0, $4344c5993a935327$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($9a68cce3ce0bb193$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4344c5993a935327$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $4344c5993a935327$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $6eb7fa2c12e5f94a$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $331e7a423c1d6bab$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $9a68cce3ce0bb193$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $731b2b8bc77077dd$export$1baa7880e357371c = (0, $861e84080756a67e$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $4344c5993a935327$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $d0ea6cfcc1ddd989$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $d0ea6cfcc1ddd989$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $aa321501103bea56$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $d0ea6cfcc1ddd989$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $d0ea6cfcc1ddd989$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $19d5d29938440538$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $19d5d29938440538$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $19d5d29938440538$var$instrumentError);
}
function $19d5d29938440538$var$instrumentError() {
    $19d5d29938440538$var$_oldOnErrorHandler = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $be735159016cae74$export$b18c893e424d3127)('error', handlerData);
        if ($19d5d29938440538$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $19d5d29938440538$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $35f9e1cc8c25e8dd$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $be735159016cae74$export$a4e09611e30da72e)(type, handler);
    (0, $be735159016cae74$export$e18d6c5462c01368)(type, $35f9e1cc8c25e8dd$var$instrumentUnhandledRejection);
}
function $35f9e1cc8c25e8dd$var$instrumentUnhandledRejection() {
    $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler = (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $be735159016cae74$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $35f9e1cc8c25e8dd$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $4546c9f85d024500$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $c25e540eb2723260$var$INTEGRATION_NAME = 'GlobalHandlers';
const $c25e540eb2723260$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $c25e540eb2723260$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $c25e540eb2723260$var$_installGlobalOnErrorHandler(client);
                $c25e540eb2723260$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $c25e540eb2723260$var$_installGlobalOnUnhandledRejectionHandler(client);
                $c25e540eb2723260$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $c25e540eb2723260$export$66acc70e8cf2b71a = (0, $861e84080756a67e$export$2323046b9414659f)($c25e540eb2723260$var$_globalHandlersIntegration);
function $c25e540eb2723260$var$_installGlobalOnErrorHandler(client) {
    (0, $19d5d29938440538$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c25e540eb2723260$var$getOptions();
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client || (0, $4344c5993a935327$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $c25e540eb2723260$var$_enhanceEventWithInitialFrame((0, $49f9172a05aa7804$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $c25e540eb2723260$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $35f9e1cc8c25e8dd$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $c25e540eb2723260$var$getOptions();
        if ((0, $7579005d8c799ca0$export$6bb76d6eba7e258c)() !== client || (0, $4344c5993a935327$export$b79738ab10c590b2)()) return;
        const error = $c25e540eb2723260$var$_getUnhandledRejectionError(e);
        const event = (0, $04327917d6f3444a$export$c3825b437cbdea5c)(error) ? $c25e540eb2723260$var$_eventFromRejectionWithPrimitive(error) : (0, $49f9172a05aa7804$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $d0ea6cfcc1ddd989$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $c25e540eb2723260$var$_getUnhandledRejectionError(error) {
    if ((0, $04327917d6f3444a$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $c25e540eb2723260$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $c25e540eb2723260$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $04327917d6f3444a$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $d2c922fb99362c48$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $c25e540eb2723260$var$globalHandlerLog(type) {
    (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $c25e540eb2723260$var$getOptions() {
    const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $6abaf570de9c35b7$export$1378794447170364 = (0, $861e84080756a67e$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4344c5993a935327$export$56d8a8a25bd48b81).navigator && !(0, $4344c5993a935327$export$56d8a8a25bd48b81).location && !(0, $4344c5993a935327$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $d2c922fb99362c48$export$1cfafeee2987818b)();
            const { referrer: referrer } = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $4344c5993a935327$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $7e1a774b3ad20a6a$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $04327917d6f3444a$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $04327917d6f3444a$export$49034edbe6b62415)(error[key], Error)) {
        $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $04327917d6f3444a$export$49034edbe6b62415)(childError, Error)) {
            $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $7e1a774b3ad20a6a$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $7e1a774b3ad20a6a$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $e27823d35f485e68$var$DEFAULT_KEY = 'cause';
const $e27823d35f485e68$var$DEFAULT_LIMIT = 5;
const $e27823d35f485e68$var$INTEGRATION_NAME = 'LinkedErrors';
const $e27823d35f485e68$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $e27823d35f485e68$var$DEFAULT_LIMIT;
    const key = options.key || $e27823d35f485e68$var$DEFAULT_KEY;
    return {
        name: $e27823d35f485e68$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $7e1a774b3ad20a6a$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $49f9172a05aa7804$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $e27823d35f485e68$export$ebabb00eb7f3a395 = (0, $861e84080756a67e$export$2323046b9414659f)($e27823d35f485e68$var$_linkedErrorsIntegration);



// This was originally forked from https://github.com/csnover/TraceKit, and was largely
// re - written as part of raven - js.
//
// This code was later copied to the JavaScript mono - repo and further modified and
// refactored over the years.
const $7acfd98b18348ab8$var$OPERA10_PRIORITY = 10;
const $7acfd98b18348ab8$var$OPERA11_PRIORITY = 20;
const $7acfd98b18348ab8$var$CHROME_PRIORITY = 30;
const $7acfd98b18348ab8$var$WINJS_PRIORITY = 40;
const $7acfd98b18348ab8$var$GECKO_PRIORITY = 50;
function $7acfd98b18348ab8$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $7acfd98b18348ab8$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $7acfd98b18348ab8$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $7acfd98b18348ab8$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $7acfd98b18348ab8$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $7acfd98b18348ab8$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $7acfd98b18348ab8$var$createFrame(filename, (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $7acfd98b18348ab8$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $7acfd98b18348ab8$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $7acfd98b18348ab8$var$extractSafariExtensionDetails(parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), parts[2]);
        return $7acfd98b18348ab8$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $7acfd98b18348ab8$export$263a749fff749872 = [
    $7acfd98b18348ab8$var$CHROME_PRIORITY,
    $7acfd98b18348ab8$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $7acfd98b18348ab8$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $7acfd98b18348ab8$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $7acfd98b18348ab8$var$gecko = (line)=>{
    const parts = $7acfd98b18348ab8$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $7acfd98b18348ab8$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac);
        [func, filename] = $7acfd98b18348ab8$var$extractSafariExtensionDetails(func, filename);
        return $7acfd98b18348ab8$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $7acfd98b18348ab8$export$cdba47a5dd2804d = [
    $7acfd98b18348ab8$var$GECKO_PRIORITY,
    $7acfd98b18348ab8$var$gecko
];
const $7acfd98b18348ab8$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $7acfd98b18348ab8$var$winjs = (line)=>{
    const parts = $7acfd98b18348ab8$var$winjsRegex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[2], parts[1] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $7acfd98b18348ab8$export$179460296da408e8 = [
    $7acfd98b18348ab8$var$WINJS_PRIORITY,
    $7acfd98b18348ab8$var$winjs
];
const $7acfd98b18348ab8$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $7acfd98b18348ab8$var$opera10 = (line)=>{
    const parts = $7acfd98b18348ab8$var$opera10Regex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[2], parts[3] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $7acfd98b18348ab8$export$f892b52c880ffc7a = [
    $7acfd98b18348ab8$var$OPERA10_PRIORITY,
    $7acfd98b18348ab8$var$opera10
];
const $7acfd98b18348ab8$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $7acfd98b18348ab8$var$opera11 = (line)=>{
    const parts = $7acfd98b18348ab8$var$opera11Regex.exec(line);
    return parts ? $7acfd98b18348ab8$var$createFrame(parts[5], parts[3] || parts[4] || (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $7acfd98b18348ab8$export$af11af13f09fb0dc = [
    $7acfd98b18348ab8$var$OPERA11_PRIORITY,
    $7acfd98b18348ab8$var$opera11
];
const $7acfd98b18348ab8$export$7197c0fe6554c079 = [
    $7acfd98b18348ab8$export$263a749fff749872,
    $7acfd98b18348ab8$export$cdba47a5dd2804d
];
const $7acfd98b18348ab8$export$2b2b997d81bf3907 = (0, $6eb7fa2c12e5f94a$export$a5739666fb2d03d4)(...$7acfd98b18348ab8$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $7acfd98b18348ab8$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $6eb7fa2c12e5f94a$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a1647adb6599c170$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $270d12994bf1f4ec$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $270d12994bf1f4ec$export$e464f4a514ac28a8(name) {
    const cached = $270d12994bf1f4ec$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $454364c661d00d30$export$d5f608b368e73f38)(impl)) return $270d12994bf1f4ec$var$cachedImplementations[name] = impl.bind((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81));
    const document = (0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $a1647adb6599c170$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $270d12994bf1f4ec$var$cachedImplementations[name] = impl.bind((0, $5f3c0b8987a9c625$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $270d12994bf1f4ec$export$8aa36702e8c8978(name) {
    $270d12994bf1f4ec$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $270d12994bf1f4ec$export$e7aa7bc5c1b3cfb3(...rest) {
    return $270d12994bf1f4ec$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $270d12994bf1f4ec$export$831dc9f2ab0a617b(...rest) {
    return $270d12994bf1f4ec$export$e464f4a514ac28a8('setTimeout')(...rest);
}






const $d9d42f3ee1635225$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $d9d42f3ee1635225$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $88d6af982193bd0a$export$78e43115b553f358)($d9d42f3ee1635225$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $88d6af982193bd0a$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $9473eeeb360c214f$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $9473eeeb360c214f$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $9473eeeb360c214f$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $9473eeeb360c214f$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $9473eeeb360c214f$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $9473eeeb360c214f$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $9473eeeb360c214f$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $9473eeeb360c214f$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $3757232aff96d110$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $3757232aff96d110$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $d9d42f3ee1635225$export$85a4f67f852183e6)(options.bufferSize || $3757232aff96d110$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $b04b40088fe5ea6b$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $b04b40088fe5ea6b$export$b11169581eeaf237)(type);
            if ((0, $9473eeeb360c214f$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $b04b40088fe5ea6b$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $b04b40088fe5ea6b$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $b04b40088fe5ea6b$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $b04b40088fe5ea6b$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $9473eeeb360c214f$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $d9d42f3ee1635225$export$c8667f1887a128dc)) {
                (0, $f24718adf40977d4$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $88d6af982193bd0a$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $925c7eb596cc6482$export$b2311068c46d7cc8(options, nativeFetch = (0, $270d12994bf1f4ec$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $270d12994bf1f4ec$export$8aa36702e8c8978)('fetch');
            return (0, $88d6af982193bd0a$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $270d12994bf1f4ec$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $88d6af982193bd0a$export$78e43115b553f358)(e);
        }
    }
    return (0, $3757232aff96d110$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $ce7e9b0fffbfaf16$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $9230543946cecc48$export$cb3c5c2ceb9818ba)(),
        (0, $8c14f7174ada528d$export$7918117e9202e4fb)(),
        (0, $9a68cce3ce0bb193$export$59bfe9f1c76150e)(),
        (0, $d447c48b9e08cd77$export$c079d904b326663a)(),
        (0, $c25e540eb2723260$export$66acc70e8cf2b71a)(),
        (0, $e27823d35f485e68$export$ebabb00eb7f3a395)(),
        (0, $879ff71665c6eecc$export$6d39aa44cd0c7567)(),
        (0, $6abaf570de9c35b7$export$1378794447170364)(),
        (0, $731b2b8bc77077dd$export$1baa7880e357371c)()
    ];
}
/** Exported only for tests. */ function $ce7e9b0fffbfaf16$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $ce7e9b0fffbfaf16$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $4344c5993a935327$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$ce7e9b0fffbfaf16$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $ce7e9b0fffbfaf16$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $ce7e9b0fffbfaf16$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $4344c5993a935327$export$56d8a8a25bd48b81).window !== 'undefined' && (0, $4344c5993a935327$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? 'chrome' : 'browser';
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $d2c922fb99362c48$export$1cfafeee2987818b)() || '';
    const extensionProtocols = [
        'chrome-extension:',
        'moz-extension:',
        'ms-browser-extension:',
        'safari-web-extension:'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $4344c5993a935327$export$56d8a8a25bd48b81) === (0, $4344c5993a935327$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== 'undefined';
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $ce7e9b0fffbfaf16$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $ce7e9b0fffbfaf16$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $ce7e9b0fffbfaf16$var$shouldShowBrowserExtensionError()) {
        if (0, $2d9d70da08177dd3$export$16a28057038b10ef) (0, $50107229405f0b55$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if ((0, $2d9d70da08177dd3$export$16a28057038b10ef) && !(0, $454364c661d00d30$export$edf3cb81fd7d2a3e)()) (0, $50107229405f0b55$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    const clientOptions = {
        ...options,
        stackParser: (0, $6eb7fa2c12e5f94a$export$1d5cf88b347146d4)(options.stackParser || (0, $7acfd98b18348ab8$export$2b2b997d81bf3907)),
        integrations: (0, $861e84080756a67e$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $925c7eb596cc6482$export$b2311068c46d7cc8)
    };
    return (0, $62a36d7bdb68e8f6$export$5333c3f1c58d9bc1)((0, $ee9a22ecd1aa84b2$export$1df9218a526d318d), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $ce7e9b0fffbfaf16$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $4344c5993a935327$export$56d8a8a25bd48b81).document) {
        (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $7579005d8c799ca0$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $d0ea6cfcc1ddd989$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $1b878ff624a14448$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $4344c5993a935327$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $4344c5993a935327$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.head || (0, $4344c5993a935327$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $2d9d70da08177dd3$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ce7e9b0fffbfaf16$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $ce7e9b0fffbfaf16$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $8nGP5 = parcelRequire("8nGP5");

var $cSUBB = parcelRequire("cSUBB");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $5ad43317f9410006$export$6c1f0397687d8b2 = $cSUBB.default || $cSUBB;


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $dde552c79915ef63$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





var $8nGP5 = parcelRequire("8nGP5");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $238dbbfae37bcc04$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $238dbbfae37bcc04$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $238dbbfae37bcc04$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($238dbbfae37bcc04$export$a87138b73900f5b((0, $8nGP5.version)) && (0, $04327917d6f3444a$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $238dbbfae37bcc04$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $d0ea6cfcc1ddd989$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $238dbbfae37bcc04$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $238dbbfae37bcc04$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}


const $36d6126caa675dd8$export$6ef4c0367e27f2d5 = 'unknown';
const $36d6126caa675dd8$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $36d6126caa675dd8$export$e926676385687eaf extends $8nGP5.Component {
    constructor(props){
        super(props);
        this.state = $36d6126caa675dd8$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $7579005d8c799ca0$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on('afterSendEvent', (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $ce7e9b0fffbfaf16$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $7579005d8c799ca0$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $238dbbfae37bcc04$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $ce7e9b0fffbfaf16$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $36d6126caa675dd8$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($36d6126caa675dd8$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === 'function' ? children() : children;
        const element = typeof fallback === 'function' ? $8nGP5.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($8nGP5.isValidElement(element)) return element;
        if (fallback) (0, $dde552c79915ef63$export$16a28057038b10ef) && (0, $50107229405f0b55$export$af88d00dbe7f521).warn('fallback did not produce a valid ReactElement');
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $36d6126caa675dd8$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $36d6126caa675dd8$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$8nGP5.createElement($36d6126caa675dd8$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $8nGP5.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $5ad43317f9410006$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}




var $8nGP5 = parcelRequire("8nGP5");
/**
 * Inits the React SDK
 */ function $dd2a0d6c025e4d96$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $97e636466ee42774$export$b9f95b027256052c)(opts, 'react');
    (0, $d0ea6cfcc1ddd989$export$2f04de43fe27971a)('react', {
        version: $8nGP5.version
    });
    return (0, $ce7e9b0fffbfaf16$export$2cd8252107eb640b)(opts);
}





const $b1b793d8911e6aa6$var$config = (0, $3d79bba9fc178656$export$b3611e87cd5ba6ce)();
const $b1b793d8911e6aa6$var$isProd = true;
if ($b1b793d8911e6aa6$var$isProd) {
    console.log('**** Sentry enabled ****');
    $dd2a0d6c025e4d96$export$2cd8252107eb640b({
        dsn: 'https://da20019de005c0cb1ea1e1f5fe326fb7@o4509184942407680.ingest.us.sentry.io/4509184943390720',
        environment: $b1b793d8911e6aa6$var$config.clientName
    });
}
(0, $b2432f43c421c848$export$7a667d08ed65fa47)().init();
(0, $de9addb89ca41b61$export$dfb5619354ba860)();
(0, $T5IcR.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', ({ reason: reason })=>{
//const { message } = reason as Error;
//if (message) self.alert(message);
});
// const { serviceWorker } = window.navigator,
//     NODE_ENV = process.env.NODE_ENV || 'development';
// if (NODE_ENV !== 'development')
//     serviceWorker
//         ?.register('sw.js')
//         .then(serviceWorkerUpdate)
//         .then(worker => {
//             if (
//                 window.confirm(
//                     'New version of this Web App detected, update now?'
//                 )
//             )
//                 worker.postMessage({ type: 'SKIP_WAITING' });
//         });
// serviceWorker?.addEventListener('controllerchange', () =>
//     window.location.reload()
// );
const $b1b793d8911e6aa6$var$root = (0, $d87212bfbb9d55bf$export$882461b6382ed46c)(document.querySelector('#app'));
const $b1b793d8911e6aa6$var$errorPage = (0, $kSbwP.jsx)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
    style: {
        backgroundColor: 'white'
    },
    fillCell: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    children: (0, $kSbwP.jsx)("div", {
        style: {
            transform: 'scale(2)'
        },
        children: (0, $kSbwP.jsxs)((0, $a5cfab634e3a04d6$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "center",
            alignItems: "center",
            children: [
                (0, $kSbwP.jsx)((0, $bc783706f3494468$export$e6ff31bff12b7ff4), {}),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        fontSize: '20px',
                        marginTop: '15px'
                    },
                    children: "An error has occurred."
                }),
                (0, $kSbwP.jsx)("div", {
                    style: {
                        fontSize: '8px'
                    },
                    children: "An automatic error report has been sent to Flightline."
                })
            ]
        })
    })
});
if ($b1b793d8911e6aa6$var$isProd) {
    const page = (0, $kSbwP.jsx)($36d6126caa675dd8$export$e926676385687eaf, {
        fallback: $b1b793d8911e6aa6$var$errorPage,
        children: (0, $kSbwP.jsx)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {})
    });
    $b1b793d8911e6aa6$var$root.render(page);
} else $b1b793d8911e6aa6$var$root.render((0, $kSbwP.jsx)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {}));


//# sourceMappingURL=index.389692c3.js.map
